/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * XConvert API
 * description intentionally left blank for internal docs
 *
 * OpenAPI spec version: 0.1.DEV
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:9000/api".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AIAgentTask
 */
export interface AIAgentTask {
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    aiModelEnum?: AIAgentTask.AiModelEnumEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AIAgentTask
     */
    cancelledByUser?: boolean;
    /**
     * 
     * @type {ChecklistGenerationData}
     * @memberof AIAgentTask
     */
    checklistData?: ChecklistGenerationData;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof AIAgentTask
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    eventCategory?: AIAgentTask.EventCategoryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AIAgentTask
     */
    exampleQueuedEventIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AIAgentTask
     */
    exampleTransportOrderIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    inputScript?: string;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    inputScriptPath?: string;
    /**
     * 
     * @type {Array<AiScriptChangeIteration>}
     * @memberof AIAgentTask
     */
    iterations?: Array<AiScriptChangeIteration>;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    latestUpdatedScript?: string;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    rawConversation?: string;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    requirements?: string;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    systemPrompt?: string;
    /**
     * 
     * @type {Date}
     * @memberof AIAgentTask
     */
    taskCompletionTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    taskCreator?: string;
    /**
     * 
     * @type {string}
     * @memberof AIAgentTask
     */
    xrequestId?: string;
}

/**
 * @export
 * @namespace AIAgentTask
 */
export namespace AIAgentTask {
    /**
     * @export
     * @enum {string}
     */
    export enum AiModelEnumEnum {
        LEGACY = 'LEGACY',
        GPT35 = 'GPT35',
        GPT4 = 'GPT4',
        GPT4TURBO = 'GPT4_TURBO',
        GPT4O = 'GPT4_O',
        GPT4OMini = 'GPT4_O_Mini',
        MISTRALTINY = 'MISTRAL_TINY',
        MISTRALSMALL = 'MISTRAL_SMALL',
        Claude35Sonnet = 'Claude35_Sonnet',
        DeepSeekV3 = 'DeepSeek_V3',
        Claude37Sonnet = 'Claude37_Sonnet',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        Claude4Sonnet = 'Claude4_Sonnet',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        Claude45Sonnet = 'Claude45_Sonnet',
        Claude45Haiku = 'Claude45_Haiku',
        GPT5NANO = 'GPT5_NANO',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE46SONNETTHINKING = 'CLAUDE46_SONNET_THINKING',
        CLAUDE46OPUSTHINKING = 'CLAUDE46_OPUS_THINKING',
        CLAUDE45SONNETTHINKING = 'CLAUDE45_SONNET_THINKING',
        CLAUDE45OPUSTHINKING = 'CLAUDE45_OPUS_THINKING',
        QWEN3635B = 'QWEN36_35B',
        GEMMA426B = 'GEMMA4_26B',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38 = 'QWEN38',
        QWEN38THINKING = 'QWEN38_THINKING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum EventCategoryEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORTORDERSTATUSEVENT = 'TRANSPORT_ORDER_STATUS_EVENT',
        ETAEVENT = 'ETA_EVENT',
        ATTACHMENTEVENT = 'ATTACHMENT_EVENT',
        GENERICAIPOSTIMPORTSCRIPT = 'GENERIC_AI_POST_IMPORT_SCRIPT'
    }
}

/**
 * 
 * @export
 * @interface AccessTokenResponse
 */
export interface AccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResponse
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResponse
     */
    trackingPageUrl?: string;
}

/**
 * 
 * @export
 * @interface AccessTransportOrderViaExternalAssignedDeviceUrlRequest
 */
export interface AccessTransportOrderViaExternalAssignedDeviceUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessTransportOrderViaExternalAssignedDeviceUrlRequest
     */
    companyTag?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessTransportOrderViaExternalAssignedDeviceUrlRequest
     */
    externalTransportOrderRef?: string;
}

/**
 * 
 * @export
 * @interface AccountActivateRequest
 */
export interface AccountActivateRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountActivateRequest
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountActivateRequest
     */
    verificationToken?: string;
}

/**
 * 
 * @export
 * @interface AccountConfirmResult
 */
export interface AccountConfirmResult {
    /**
     * 
     * @type {string}
     * @memberof AccountConfirmResult
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface AcknowledgeCompaniesFromCustomerReportResponse
 */
export interface AcknowledgeCompaniesFromCustomerReportResponse {
    /**
     * 
     * @type {Array<UpdateCompanyCustomerReportResponseForSingleCompany>}
     * @memberof AcknowledgeCompaniesFromCustomerReportResponse
     */
    customerReportSettingsForAllCompanies?: Array<UpdateCompanyCustomerReportResponseForSingleCompany>;
}

/**
 * 
 * @export
 * @interface ActiveConverterOverride
 */
export interface ActiveConverterOverride {
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    applyWhenScript?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    changeType?: ActiveConverterOverride.ChangeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    conversionType?: ActiveConverterOverride.ConversionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    converter?: ActiveConverterOverride.ConverterEnum;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    eventSourceCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    eventType?: ActiveConverterOverride.EventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    fileExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    fileNameRegex?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    inputTextContains?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    inputTextMatches?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveConverterOverride
     */
    receiverMailAddressIs?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActiveConverterOverride
     */
    sourceCompanyTag?: Array<string>;
}

/**
 * @export
 * @namespace ActiveConverterOverride
 */
export namespace ActiveConverterOverride {
    /**
     * @export
     * @enum {string}
     */
    export enum ChangeTypeEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ConversionTypeEnum {
        QUEUEDEVENTTOEXTERNALFORMAT = 'QUEUED_EVENT_TO_EXTERNAL_FORMAT',
        EXTERNALFORMATTOTRANSPORTORDER = 'EXTERNAL_FORMAT_TO_TRANSPORT_ORDER',
        MERGEFILES = 'MERGE_FILES'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ConverterEnum {
        SOLOPLAN = 'SOLOPLAN',
        LISINLISOUT = 'LIS_IN_LIS_OUT',
        ELEMICA = 'ELEMICA',
        SAP = 'SAP',
        EDI = 'EDI',
        SIMPLECSV = 'SIMPLE_CSV',
        GENERICXLS = 'GENERIC_XLS',
        FORTRAS = 'FORTRAS',
        DHLIMPORTER = 'DHL_IMPORTER',
        DESCARTESIMPORTER = 'DESCARTES_IMPORTER',
        METAMODEL = 'META_MODEL',
        GEHR = 'GEHR',
        GENERICGROOVY = 'GENERIC_GROOVY',
        BNSTELEMATIK = 'BNS_TELEMATIK',
        TRANSPOREONXML = 'TRANSPOREON_XML',
        NOOP = 'NO_OP',
        TRANSLOGICA = 'TRANSLOGICA',
        TRANSDATA = 'TRANSDATA',
        CISTELEMATIK = 'CIS_TELEMATIK',
        FRMEYERUNDSOHN = 'FR_MEYER_UND_SOHN',
        ATTACHMENTPROCESSOR = 'ATTACHMENT_PROCESSOR',
        PDFGENERATOR = 'PDF_GENERATOR',
        SHIPPEO = 'SHIPPEO',
        CONIZI = 'CONIZI',
        GENERICZIP = 'GENERIC_ZIP',
        EDIV2 = 'EDI_v2',
        GENERICAI = 'GENERIC_AI'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
}

/**
 * 
 * @export
 * @interface AddAcknowledgementForCompaniesCustomerReportRequest
 */
export interface AddAcknowledgementForCompaniesCustomerReportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddAcknowledgementForCompaniesCustomerReportRequest
     */
    companyIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AddAcknowledgementForCompaniesCustomerReportRequest
     */
    isAcknowledged?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddAcknowledgementForCompaniesCustomerReportRequest
     */
    personWhoAcknowledged?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAcknowledgementForCompaniesCustomerReportRequest
     */
    serviceType?: AddAcknowledgementForCompaniesCustomerReportRequest.ServiceTypeEnum;
}

/**
 * @export
 * @namespace AddAcknowledgementForCompaniesCustomerReportRequest
 */
export namespace AddAcknowledgementForCompaniesCustomerReportRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceTypeEnum {
        APIGATEWAYREPORT = 'API_GATEWAY_REPORT',
        SFTPREPORT = 'SFTP_REPORT',
        CUSTOMERFILEHEALTHREPORT = 'CUSTOMER_FILE_HEALTH_REPORT',
        LOGENIOSFILEHEALTHREPORT = 'LOGENIOS_FILE_HEALTH_REPORT',
        ATTACHMENTFILEHEALTHREPORT = 'ATTACHMENT_FILE_HEALTH_REPORT',
        QUEUEREPORT = 'QUEUE_REPORT',
        STATUSJSONREPORT = 'STATUS_JSON_REPORT',
        NEEDSVERIFICATIONREPORT = 'NEEDS_VERIFICATION_REPORT',
        ERRORFILESREPORT = 'ERROR_FILES_REPORT',
        ETACALCULATORREPORT = 'ETA_CALCULATOR_REPORT',
        MESSAGELOGREPORT = 'MESSAGE_LOG_REPORT',
        SCHEDULERREPORTTASKSTATUS = 'SCHEDULER_REPORT_TASK_STATUS'
    }
}

/**
 * 
 * @export
 * @interface AddDefaultsToConfigRequest
 */
export interface AddDefaultsToConfigRequest {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof AddDefaultsToConfigRequest
     */
    config?: CompanyConfiguration;
}

/**
 * 
 * @export
 * @interface AddDefaultsToConfigResponse
 */
export interface AddDefaultsToConfigResponse {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof AddDefaultsToConfigResponse
     */
    config?: CompanyConfiguration;
}

/**
 * 
 * @export
 * @interface AddFiltersRequest
 */
export interface AddFiltersRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AddFiltersRequest
     */
    isCompanyFilter?: boolean;
    /**
     * 
     * @type {UserFilter}
     * @memberof AddFiltersRequest
     */
    userFilter?: UserFilter;
}

/**
 * 
 * @export
 * @interface AddGlobalGeofencesResponse
 */
export interface AddGlobalGeofencesResponse {
    /**
     * 
     * @type {string}
     * @memberof AddGlobalGeofencesResponse
     */
    reason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddGlobalGeofencesResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface AddObserverRule
 */
export interface AddObserverRule {
    /**
     * Value expected at the given path. If <null> any value
     * @type {string}
     * @memberof AddObserverRule
     */
    expectedValue?: string;
    /**
     * Value expected at the given path as regex. If <null> any value
     * @type {string}
     * @memberof AddObserverRule
     */
    expectedValueRegex?: string;
    /**
     * Level to which the observer shall be added
     * @type {string}
     * @memberof AddObserverRule
     */
    level?: AddObserverRule.LevelEnum;
    /**
     * 
     * @type {Observer}
     * @memberof AddObserverRule
     */
    observerToAdd?: Observer;
    /**
     * Path denoted in immediate format
     * @type {string}
     * @memberof AddObserverRule
     */
    path?: string;
}

/**
 * @export
 * @namespace AddObserverRule
 */
export namespace AddObserverRule {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORT = 'TRANSPORT'
    }
}

/**
 * 
 * @export
 * @interface AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
 */
export interface AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    companyIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    disableOptions?: AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest.DisableOptionsEnum;
    /**
     * 
     * @type {Any}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    disableUntilObject?: Any;
    /**
     * 
     * @type {boolean}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    enable?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    fromDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    personWhoIgnored?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    reasonToIgnore?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    serviceType?: AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest.ServiceTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     */
    toDate?: Date;
}

/**
 * @export
 * @namespace AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
 */
export namespace AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum DisableOptionsEnum {
        UNTILCHANGE = 'UNTIL_CHANGE',
        UNTILTOMORROW = 'UNTIL_TOMORROW',
        FORAMONTH = 'FOR_A_MONTH',
        FORAWEEK = 'FOR_A_WEEK',
        CUSTOMDATE = 'CUSTOM_DATE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceTypeEnum {
        APIGATEWAYREPORT = 'API_GATEWAY_REPORT',
        SFTPREPORT = 'SFTP_REPORT',
        CUSTOMERFILEHEALTHREPORT = 'CUSTOMER_FILE_HEALTH_REPORT',
        LOGENIOSFILEHEALTHREPORT = 'LOGENIOS_FILE_HEALTH_REPORT',
        ATTACHMENTFILEHEALTHREPORT = 'ATTACHMENT_FILE_HEALTH_REPORT',
        QUEUEREPORT = 'QUEUE_REPORT',
        STATUSJSONREPORT = 'STATUS_JSON_REPORT',
        NEEDSVERIFICATIONREPORT = 'NEEDS_VERIFICATION_REPORT',
        ERRORFILESREPORT = 'ERROR_FILES_REPORT',
        ETACALCULATORREPORT = 'ETA_CALCULATOR_REPORT',
        MESSAGELOGREPORT = 'MESSAGE_LOG_REPORT',
        SCHEDULERREPORTTASKSTATUS = 'SCHEDULER_REPORT_TASK_STATUS'
    }
}

/**
 * 
 * @export
 * @interface AddOrRemoveCompaniesFromIgnoreListForCustomerReportResponse
 */
export interface AddOrRemoveCompaniesFromIgnoreListForCustomerReportResponse {
    /**
     * 
     * @type {Array<UpdateCompanyCustomerReportResponseForSingleCompany>}
     * @memberof AddOrRemoveCompaniesFromIgnoreListForCustomerReportResponse
     */
    customerReportSettingsForAllCompanies?: Array<UpdateCompanyCustomerReportResponseForSingleCompany>;
}

/**
 * 
 * @export
 * @interface AdditionalColumnConfiguration
 */
export interface AdditionalColumnConfiguration {
    /**
     * 
     * @type {string}
     * @memberof AdditionalColumnConfiguration
     */
    additionalDataKey?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalColumnConfiguration
     */
    iconName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalColumnConfiguration
     */
    labelText?: string;
    /**
     * 
     * @type {Array<LocalizedLabel>}
     * @memberof AdditionalColumnConfiguration
     */
    localizedLabels?: Array<LocalizedLabel>;
}

/**
 * 
 * @export
 * @interface AdditionalDataDisplayColumn
 */
export interface AdditionalDataDisplayColumn {
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataDisplayColumn
     */
    id?: string;
    /**
     * 
     * @type {AdditionalTableColumn}
     * @memberof AdditionalDataDisplayColumn
     */
    value?: AdditionalTableColumn;
}

/**
 * 
 * @export
 * @interface AdditionalDataEntry
 */
export interface AdditionalDataEntry {
    /**
     * Key used to identify this piece of information
     * @type {string}
     * @memberof AdditionalDataEntry
     */
    key?: string;
    /**
     * Indicates that this key-value pair should be only visible to the company who added the key-value-pair. (relevant if this field is used to store id mappings)
     * @type {boolean}
     * @memberof AdditionalDataEntry
     */
    markedAsPrivate?: boolean;
    /**
     * indicates that this key-value pair should not be removed on a replace operation when there is no new value available
     * @type {boolean}
     * @memberof AdditionalDataEntry
     */
    sticky?: boolean;
    /**
     * value to be stored
     * @type {string}
     * @memberof AdditionalDataEntry
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface AdditionalDataFieldConfiguration
 */
export interface AdditionalDataFieldConfiguration {
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataFieldConfiguration
     */
    defaultValue?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataFieldConfiguration
     */
    displayName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdditionalDataFieldConfiguration
     */
    dropDownOptions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataFieldConfiguration
     */
    fieldType?: AdditionalDataFieldConfiguration.FieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdditionalDataFieldConfiguration
     */
    isReadOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdditionalDataFieldConfiguration
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdditionalDataFieldConfiguration
     */
    isVisible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataFieldConfiguration
     */
    keyName?: string;
    /**
     * 
     * @type {number}
     * @memberof AdditionalDataFieldConfiguration
     */
    sortIndex?: number;
}

/**
 * @export
 * @namespace AdditionalDataFieldConfiguration
 */
export namespace AdditionalDataFieldConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum FieldTypeEnum {
        TEXT = 'TEXT',
        DROPDOWN = 'DROPDOWN',
        CHECKBOX = 'CHECKBOX'
    }
}

/**
 * 
 * @export
 * @interface AdditionalDataMapping
 */
export interface AdditionalDataMapping {
    /**
     * 
     * @type {boolean}
     * @memberof AdditionalDataMapping
     */
    _export?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataMapping
     */
    externalKeyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdditionalDataMapping
     */
    _import?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataMapping
     */
    logeniosKeyName?: string;
}

/**
 * 
 * @export
 * @interface AdditionalDataWithLevel
 */
export interface AdditionalDataWithLevel {
    /**
     * 
     * @type {AdditionalDataEntry}
     * @memberof AdditionalDataWithLevel
     */
    entry?: AdditionalDataEntry;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataWithLevel
     */
    level?: AdditionalDataWithLevel.LevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdditionalDataWithLevel
     */
    options?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDataWithLevel
     */
    type?: AdditionalDataWithLevel.TypeEnum;
}

/**
 * @export
 * @namespace AdditionalDataWithLevel
 */
export namespace AdditionalDataWithLevel {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        FREIGHT = 'FREIGHT',
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORT = 'TRANSPORT',
        LOADINGLOCATION = 'LOADING_LOCATION',
        UNLOADINGLOCATION = 'UNLOADING_LOCATION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        TEXT = 'TEXT',
        BOOLEAN = 'BOOLEAN',
        OPTION = 'OPTION',
        DATE = 'DATE',
        TIME = 'TIME'
    }
}

/**
 * 
 * @export
 * @interface AdditionalDetails
 */
export interface AdditionalDetails {
    /**
     * 
     * @type {string}
     * @memberof AdditionalDetails
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDetails
     */
    prompt?: string;
}

/**
 * 
 * @export
 * @interface AdditionalTableColumn
 */
export interface AdditionalTableColumn {
    /**
     * 
     * @type {string}
     * @memberof AdditionalTableColumn
     */
    additionalDataKey?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdditionalTableColumn
     */
    allowedValues?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdditionalTableColumn
     */
    dataType?: AdditionalTableColumn.DataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdditionalTableColumn
     */
    defaultLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalTableColumn
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalTableColumn
     */
    level?: AdditionalTableColumn.LevelEnum;
    /**
     * 
     * @type {Array<LocalizedLabel>}
     * @memberof AdditionalTableColumn
     */
    localizedLabels?: Array<LocalizedLabel>;
    /**
     * 
     * @type {number}
     * @memberof AdditionalTableColumn
     */
    sortIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof AdditionalTableColumn
     */
    valueExpression?: string;
}

/**
 * @export
 * @namespace AdditionalTableColumn
 */
export namespace AdditionalTableColumn {
    /**
     * @export
     * @enum {string}
     */
    export enum DataTypeEnum {
        String = 'String',
        Numeric = 'Numeric',
        Time = 'Time'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORTORDERSTATUS = 'TRANSPORT_ORDER_STATUS',
        TRANSPORT = 'TRANSPORT',
        STOPLOCATION = 'STOP_LOCATION',
        FREIGHT = 'FREIGHT',
        STOPLOCATIONSTATUS = 'STOP_LOCATION_STATUS',
        FREIGHTSTATUS = 'FREIGHT_STATUS'
    }
}

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    additionalInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    gs1GlobalLocationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    houseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    verified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface AddressBook
 */
export interface AddressBook {
    /**
     * 
     * @type {Array<AddressDetails>}
     * @memberof AddressBook
     */
    addressDetails?: Array<AddressDetails>;
    /**
     * 
     * @type {string}
     * @memberof AddressBook
     */
    companyId?: string;
}

/**
 * 
 * @export
 * @interface AddressDetails
 */
export interface AddressDetails {
    /**
     * 
     * @type {string}
     * @memberof AddressDetails
     */
    ccEmailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDetails
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDetails
     */
    phoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDetails
     */
    preferredLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDetails
     */
    timocomId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDetails
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface AddressExportOptions
 */
export interface AddressExportOptions {
    /**
     * 
     * @type {boolean}
     * @memberof AddressExportOptions
     */
    exportLoadingLocationsAsTemporaryAddresses?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressExportOptions
     */
    exportUnloadingLocationsAsTemporaryAddresses?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressExportOptions
     */
    preferExportOfCustomerNumberInsteadOfAddress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressExportOptions
     */
    shouldExportFullAddressForLoadingLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressExportOptions
     */
    shouldExportFullAddressForUnloadingLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressExportOptions
     */
    shouldExportOnlyCustomerAdressNumbers?: boolean;
}

/**
 * 
 * @export
 * @interface AddressImportResult
 */
export interface AddressImportResult {
    /**
     * 
     * @type {number}
     * @memberof AddressImportResult
     */
    importedCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddressImportResult
     */
    result?: boolean;
}

/**
 * 
 * @export
 * @interface AddressKindMapping
 */
export interface AddressKindMapping {
    /**
     * 
     * @type {string}
     * @memberof AddressKindMapping
     */
    actionKind?: AddressKindMapping.ActionKindEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AddressKindMapping
     */
    applyForExport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressKindMapping
     */
    applyForImport?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddressKindMapping
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressKindMapping
     */
    importPriority?: number;
    /**
     * 
     * @type {number}
     * @memberof AddressKindMapping
     */
    lisCustomerKind?: number;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof AddressKindMapping
     */
    script?: GroovyBasedMappingScript;
}

/**
 * @export
 * @namespace AddressKindMapping
 */
export namespace AddressKindMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionKindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
}

/**
 * 
 * @export
 * @interface AddressSelectConfiguration
 */
export interface AddressSelectConfiguration {
    /**
     * 
     * @type {Array<AdditionalDataFieldConfiguration>}
     * @memberof AddressSelectConfiguration
     */
    additionalData?: Array<AdditionalDataFieldConfiguration>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddressSelectConfiguration
     */
    allowedCountryCodes?: Array<string>;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    attachments?: TextFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    city?: TextFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    countryCode?: TextFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    date?: TextFieldConfiguration;
    /**
     * 
     * @type {string}
     * @memberof AddressSelectConfiguration
     */
    earliestPossibleDate?: AddressSelectConfiguration.EarliestPossibleDateEnum;
    /**
     * 
     * @type {CompanyAddressMappingGroup}
     * @memberof AddressSelectConfiguration
     */
    group?: CompanyAddressMappingGroup;
    /**
     * 
     * @type {Address}
     * @memberof AddressSelectConfiguration
     */
    location?: Address;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    name?: TextFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    name2?: TextFieldConfiguration;
    /**
     * 
     * @type {DateTimeFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    planArrival?: DateTimeFieldConfiguration;
    /**
     * 
     * @type {DateTimeFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    planDepart?: DateTimeFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    street?: TextFieldConfiguration;
    /**
     * 
     * @type {string}
     * @memberof AddressSelectConfiguration
     */
    type?: AddressSelectConfiguration.TypeEnum;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof AddressSelectConfiguration
     */
    zipCode?: TextFieldConfiguration;
}

/**
 * @export
 * @namespace AddressSelectConfiguration
 */
export namespace AddressSelectConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum EarliestPossibleDateEnum {
        NOTRESTRICTED = 'NOT_RESTRICTED',
        YESTERDAY = 'YESTERDAY',
        TODAY = 'TODAY',
        TOMORROW = 'TOMORROW'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        FREEADDRESSINPUT = 'FREE_ADDRESS_INPUT',
        SELECTFROMADDRESSGROUP = 'SELECT_FROM_ADDRESS_GROUP',
        FIXEDADDRESS = 'FIXED_ADDRESS'
    }
}

/**
 * 
 * @export
 * @interface AddressWithCoordinates
 */
export interface AddressWithCoordinates {
    /**
     * 
     * @type {Address}
     * @memberof AddressWithCoordinates
     */
    address?: Address;
    /**
     * 
     * @type {Coordinates}
     * @memberof AddressWithCoordinates
     */
    coordinates?: Coordinates;
}

/**
 * 
 * @export
 * @interface AdjacentTourOnVehicleInfo
 */
export interface AdjacentTourOnVehicleInfo {
    /**
     * Toll in EUR for the empty kilometers driven between this tour and the adjacent tour
     * @type {number}
     * @memberof AdjacentTourOnVehicleInfo
     */
    emptyTollAmount?: number;
    /**
     * Toll relevant kilometers driven empty between this tour and the adjacent tour
     * @type {number}
     * @memberof AdjacentTourOnVehicleInfo
     */
    emptyTollKilometer?: number;
    /**
     * The first or last stop's Odometer reading (depending on if its next or prev Tour) is stored.
     * @type {number}
     * @memberof AdjacentTourOnVehicleInfo
     */
    odometerReading?: number;
    /**
     * The id of the next tour for the assigned vehicle
     * @type {string}
     * @memberof AdjacentTourOnVehicleInfo
     */
    tourId?: string;
}

/**
 * 
 * @export
 * @interface AdrDescription
 */
export interface AdrDescription {
    /**
     * List of key value pairs for storing additonal information
     * @type {Array<AdditionalDataEntry>}
     * @memberof AdrDescription
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * Chemical Abstracts Service register number of the transported good
     * @type {string}
     * @memberof AdrDescription
     */
    casNumber?: string;
    /**
     * Class code of the dangerous good (e.g. C1, M7, FC, D)
     * @type {string}
     * @memberof AdrDescription
     */
    classCode?: string;
    /**
     * Class name of the dangerous good (e.g. 1, 2, 3, 6.1 , 9)
     * @type {string}
     * @memberof AdrDescription
     */
    className?: string;
    /**
     * Additional information text
     * @type {string}
     * @memberof AdrDescription
     */
    infoText?: string;
    /**
     * Info if dangerous for the enviroment
     * @type {boolean}
     * @memberof AdrDescription
     */
    isDangerousForTheEnvironment?: boolean;
    /**
     * Info if the transported dangerous good is of limited quantity
     * @type {boolean}
     * @memberof AdrDescription
     */
    limitedQuantity?: boolean;
    /**
     * Multiplier of the dangerous good
     * @type {number}
     * @memberof AdrDescription
     */
    multiplier?: number;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof AdrDescription
     */
    netVolume?: DoubleWithUnit;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof AdrDescription
     */
    netWeight?: DoubleWithUnit;
    /**
     * Official name of the transported dangerous good. E.g. Natriumcarbonat
     * @type {string}
     * @memberof AdrDescription
     */
    officialName?: string;
    /**
     * Packing group
     * @type {string}
     * @memberof AdrDescription
     */
    packingGroup?: AdrDescription.PackingGroupEnum;
    /**
     * Category of the transport
     * @type {string}
     * @memberof AdrDescription
     */
    transportCategory?: string;
    /**
     * Tunnel restriction code of the specified dangerous goods.
     * @type {string}
     * @memberof AdrDescription
     */
    tunnelRestrictionCode?: string;
    /**
     * UN Number of the dangerous good
     * @type {string}
     * @memberof AdrDescription
     */
    unNumber?: string;
    /**
     * Verbose name of the transported dangerous good. E.G. Soda
     * @type {string}
     * @memberof AdrDescription
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace AdrDescription
 */
export namespace AdrDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum PackingGroupEnum {
        ClassOne = 'classOne',
        ClassTwo = 'classTwo',
        ClassThree = 'classThree'
    }
}

/**
 * 
 * @export
 * @interface AdrPackingGroupKindMapping
 */
export interface AdrPackingGroupKindMapping {
    /**
     * 
     * @type {string}
     * @memberof AdrPackingGroupKindMapping
     */
    externalName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdrPackingGroupKindMapping
     */
    group?: AdrPackingGroupKindMapping.GroupEnum;
}

/**
 * @export
 * @namespace AdrPackingGroupKindMapping
 */
export namespace AdrPackingGroupKindMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum GroupEnum {
        ClassOne = 'classOne',
        ClassTwo = 'classTwo',
        ClassThree = 'classThree'
    }
}

/**
 * 
 * @export
 * @interface AdvancedFtpsOptions
 */
export interface AdvancedFtpsOptions {
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedFtpsOptions
     */
    disableStrictReplyParsing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedFtpsOptions
     */
    enableDebugMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedFtpsOptions
     */
    isWindowsFtpServer?: boolean;
}

/**
 * 
 * @export
 * @interface AiExtractionRule
 */
export interface AiExtractionRule {
    /**
     * 
     * @type {string}
     * @memberof AiExtractionRule
     */
    prompt?: string;
}

/**
 * 
 * @export
 * @interface AiModelResponseScripting
 */
export interface AiModelResponseScripting {
    /**
     * 
     * @type {ExecuteFunctionResponse}
     * @memberof AiModelResponseScripting
     */
    aiModelResponse?: ExecuteFunctionResponse;
    /**
     * 
     * @type {string}
     * @memberof AiModelResponseScripting
     */
    rawAiModelResponse?: string;
    /**
     * 
     * @type {number}
     * @memberof AiModelResponseScripting
     */
    totalCompletionTokensNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof AiModelResponseScripting
     */
    totalPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof AiModelResponseScripting
     */
    totalUsageTokensNumber?: number;
}

/**
 * 
 * @export
 * @interface AiParseResult
 */
export interface AiParseResult {
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    actuallyUsedModel?: string;
    /**
     * 
     * @type {number}
     * @memberof AiParseResult
     */
    completionTokens?: number;
    /**
     * 
     * @type {number}
     * @memberof AiParseResult
     */
    counter?: number;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    flag?: AiParseResult.FlagEnum;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    input?: string;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    output?: string;
    /**
     * 
     * @type {number}
     * @memberof AiParseResult
     */
    promptTokens?: number;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    rawInput?: string;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    rawOutput?: string;
    /**
     * 
     * @type {Array<AiReviewResult>}
     * @memberof AiParseResult
     */
    review?: Array<AiReviewResult>;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    thinkingMessage?: string;
    /**
     * 
     * @type {Date}
     * @memberof AiParseResult
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof AiParseResult
     */
    tokensConsumed?: number;
    /**
     * 
     * @type {number}
     * @memberof AiParseResult
     */
    totalPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof AiParseResult
     */
    type?: string;
}

/**
 * @export
 * @namespace AiParseResult
 */
export namespace AiParseResult {
    /**
     * @export
     * @enum {string}
     */
    export enum FlagEnum {
        WRONG = 'WRONG',
        FIXED = 'FIXED',
        INTERESTING = 'INTERESTING'
    }
}

/**
 * 
 * @export
 * @interface AiProcessingSettings
 */
export interface AiProcessingSettings {
    /**
     * 
     * @type {boolean}
     * @memberof AiProcessingSettings
     */
    disableAiRequestsCache?: boolean;
}

/**
 * 
 * @export
 * @interface AiReviewResult
 */
export interface AiReviewResult {
    /**
     * 
     * @type {string}
     * @memberof AiReviewResult
     */
    correctedOutput?: string;
    /**
     * 
     * @type {string}
     * @memberof AiReviewResult
     */
    correctedPromt?: string;
    /**
     * 
     * @type {number}
     * @memberof AiReviewResult
     */
    qualityRating?: number;
    /**
     * 
     * @type {string}
     * @memberof AiReviewResult
     */
    reviewer?: string;
}

/**
 * 
 * @export
 * @interface AiScriptChangeIteration
 */
export interface AiScriptChangeIteration {
    /**
     * 
     * @type {AiModelResponseScripting}
     * @memberof AiScriptChangeIteration
     */
    aiModelResponseScripting?: AiModelResponseScripting;
    /**
     * 
     * @type {number}
     * @memberof AiScriptChangeIteration
     */
    durationMs?: number;
    /**
     * 
     * @type {ExecuteFunctionResponse}
     * @memberof AiScriptChangeIteration
     */
    functionCallOutput?: ExecuteFunctionResponse;
    /**
     * 
     * @type {string}
     * @memberof AiScriptChangeIteration
     */
    inputPrompt?: string;
    /**
     * 
     * @type {QueuedEventConversionResponse}
     * @memberof AiScriptChangeIteration
     */
    queuedEventConversionResponse?: QueuedEventConversionResponse;
    /**
     * 
     * @type {string}
     * @memberof AiScriptChangeIteration
     */
    scriptExecutionLogs?: string;
    /**
     * 
     * @type {string}
     * @memberof AiScriptChangeIteration
     */
    status?: AiScriptChangeIteration.StatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof AiScriptChangeIteration
     */
    timestamp?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AiScriptChangeIteration
     */
    userApprovedScript?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AiScriptChangeIteration
     */
    userInputPrompt?: string;
    /**
     * 
     * @type {string}
     * @memberof AiScriptChangeIteration
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace AiScriptChangeIteration
 */
export namespace AiScriptChangeIteration {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        RUNNING = 'RUNNING',
        DONE = 'DONE',
        USERINPUTREQUIRED = 'USER_INPUT_REQUIRED',
        ABORTED = 'ABORTED'
    }
}

/**
 * 
 * @export
 * @interface AlgoResult
 */
export interface AlgoResult {
    /**
     * 
     * @type {string}
     * @memberof AlgoResult
     */
    correctionStatus?: AlgoResult.CorrectionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AlgoResult
     */
    cost?: number;
    /**
     * 
     * @type {number}
     * @memberof AlgoResult
     */
    durationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof AlgoResult
     */
    finalOutput?: string;
    /**
     * 
     * @type {string}
     * @memberof AlgoResult
     */
    modelUsed?: string;
    /**
     * 
     * @type {number}
     * @memberof AlgoResult
     */
    numOfChanges?: number;
    /**
     * 
     * @type {number}
     * @memberof AlgoResult
     */
    numOfIterations?: number;
    /**
     * 
     * @type {Array<RequestResponseLog>}
     * @memberof AlgoResult
     */
    requestResponseLogs?: Array<RequestResponseLog>;
    /**
     * 
     * @type {Array<ScriptChange>}
     * @memberof AlgoResult
     */
    scriptDifferences?: Array<ScriptChange>;
    /**
     * 
     * @type {number}
     * @memberof AlgoResult
     */
    totalCompletionTokensNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof AlgoResult
     */
    totalUsageTokensNumber?: number;
}

/**
 * @export
 * @namespace AlgoResult
 */
export namespace AlgoResult {
    /**
     * @export
     * @enum {string}
     */
    export enum CorrectionStatusEnum {
        UNFIXED = 'UNFIXED',
        QUICKFIX = 'QUICK_FIX',
        COMPLEXFIX = 'COMPLEX_FIX',
        UNFIXEDFAILUREEXECUTINGTRANSFORMATION = 'UNFIXED_FAILURE_EXECUTING_TRANSFORMATION',
        UNFIXEDFAILURENULLRESPONSE = 'UNFIXED_FAILURE_NULL_RESPONSE',
        EXCEPTIONTHROWN = 'EXCEPTION_THROWN',
        FAILUREDUETOCONTINUOUSERROR = 'FAILURE_DUE_TO_CONTINUOUS_ERROR'
    }
}

/**
 * 
 * @export
 * @interface AliveCheckResponse
 */
export interface AliveCheckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AliveCheckResponse
     */
    alive?: boolean;
}

/**
 * 
 * @export
 * @interface AllPartnersUsersResponse
 */
export interface AllPartnersUsersResponse {
    /**
     * 
     * @type {Array<PartnerUsersResponse>}
     * @memberof AllPartnersUsersResponse
     */
    partnersWithUsers?: Array<PartnerUsersResponse>;
}

/**
 * 
 * @export
 * @interface AllPartnersValidationRuleNamesResponse
 */
export interface AllPartnersValidationRuleNamesResponse {
    /**
     * 
     * @type {any}
     * @memberof AllPartnersValidationRuleNamesResponse
     */
    partnersWithRules?: any;
}

/**
 * 
 * @export
 * @interface AllowedAttachmentTypesToShow
 */
export interface AllowedAttachmentTypesToShow {
    /**
     * 
     * @type {boolean}
     * @memberof AllowedAttachmentTypesToShow
     */
    freightAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedAttachmentTypesToShow
     */
    stopAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedAttachmentTypesToShow
     */
    transportAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedAttachmentTypesToShow
     */
    transportOrderAttachments?: boolean;
}

/**
 * 
 * @export
 * @interface AnalyzeTicketForPickupRequest
 */
export interface AnalyzeTicketForPickupRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AnalyzeTicketForPickupRequest
     */
    labels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnalyzeTicketForPickupRequest
     */
    recentComments?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AnalyzeTicketForPickupRequest
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyzeTicketForPickupRequest
     */
    ticketId?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeTicketForPickupRequest
     */
    ticketName?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeTicketForPickupRequest
     */
    ticketText?: string;
}

/**
 * 
 * @export
 * @interface AnalyzeTicketForPickupResponse
 */
export interface AnalyzeTicketForPickupResponse {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeTicketForPickupResponse
     */
    difficultyAssessment?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeTicketForPickupResponse
     */
    reasoning?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeTicketForPickupResponse
     */
    recommendedOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeTicketForPickupResponse
     */
    suggestion?: string;
}

/**
 * 
 * @export
 * @interface AnnotateWithKey
 */
export interface AnnotateWithKey {
    /**
     * 
     * @type {string}
     * @memberof AnnotateWithKey
     */
    keyName?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnotateWithKey
     */
    level?: AnnotateWithKey.LevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnnotateWithKey
     */
    options?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AnnotateWithKey
     */
    type?: AnnotateWithKey.TypeEnum;
}

/**
 * @export
 * @namespace AnnotateWithKey
 */
export namespace AnnotateWithKey {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        FREIGHT = 'FREIGHT',
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORT = 'TRANSPORT',
        LOADINGLOCATION = 'LOADING_LOCATION',
        UNLOADINGLOCATION = 'UNLOADING_LOCATION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        TEXT = 'TEXT',
        BOOLEAN = 'BOOLEAN',
        OPTION = 'OPTION',
        DATE = 'DATE',
        TIME = 'TIME'
    }
}

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
}

/**
 * 
 * @export
 * @interface ApiAdditional
 */
export interface ApiAdditional {
    /**
     * 
     * @type {string}
     * @memberof ApiAdditional
     */
    key?: ApiAdditional.KeyEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiAdditional
     */
    value?: string;
}

/**
 * @export
 * @namespace ApiAdditional
 */
export namespace ApiAdditional {
    /**
     * @export
     * @enum {string}
     */
    export enum KeyEnum {
        SPEDIONPLACEWORKFLOW = 'SPEDION_PLACE_WORKFLOW',
        SPEDIONORDERWORKFLOW = 'SPEDION_ORDER_WORKFLOW',
        SYNCVEHICLECHANGESTOTELEMATIC = 'SYNC_VEHICLE_CHANGES_TO_TELEMATIC',
        SYNCDRIVERCHANGESTOTELEMATIC = 'SYNC_DRIVER_CHANGES_TO_TELEMATIC',
        CUSTOMXMLCLASS = 'CUSTOM_XML_CLASS',
        POSTINGURL = 'POSTING_URL',
        STATUSPOSTINGURL = 'STATUS_POSTING_URL',
        POLLINGURL = 'POLLING_URL',
        CUSTOMAUTHHEADER = 'CUSTOM_AUTH_HEADER',
        SIXFOLDCOMPANYID = 'SIXFOLD_COMPANY_ID',
        SIXFOLDPOLLLASTXDAYS = 'SIXFOLD_POLL_LAST_X_DAYS',
        USE1330INSTEADOF1332 = 'USE_1330_INSTEAD_OF_1332',
        CUSTOMXMLENCODING = 'CUSTOM_XML_ENCODING',
        USEETAFORM = 'USE_ETA_FORM',
        LOGENIOSFTPUSERNAME = 'LOGENIOS_FTP_USER_NAME',
        LOGENIOSFTPUSERPASSWORD = 'LOGENIOS_FTP_USER_PASSWORD',
        FTPUPLOADPATH = 'FTP_UPLOAD_PATH',
        YELLOWFOXVEHICLEGROUPKEY = 'YELLOWFOX_VEHICLEGROUP_KEY',
        YELLOWFOXVEHICLEKEY = 'YELLOWFOX_VEHICLE_KEY',
        YELLOWFOXIMPORTKEY = 'YELLOWFOX_IMPORT_KEY',
        TOMTOMUSEOBJECTNAMEANDOBJECTNR = 'TOMTOM_USE_OBJECTNAME_AND_OBJECTNR',
        TRANSPOREONCLIENTID = 'TRANSPOREON_CLIENT_ID',
        SIXFOLDSHIPPERINTERFACEASSIGNVEHICLEINSTEADOFTARGETCOMPANY = 'SIXFOLD_SHIPPER_INTERFACE_ASSIGN_VEHICLE_INSTEAD_OF_TARGET_COMPANY',
        TRANSPOREONSENDPOSITIONS = 'TRANSPOREON_SEND_POSITIONS',
        SHIPPEOTELEMATICCONFIGURATION = 'SHIPPEO_TELEMATIC_CONFIGURATION',
        SHIPPEODISABLEETATRANSMISSION = 'SHIPPEO_DISABLE_ETA_TRANSMISSION',
        TRANSPOREONSTATUSEXPORTVIACONVERTER = 'TRANSPOREON_STATUS_EXPORT_VIA_CONVERTER',
        FLEETMASTERGPSAPITOKEN = 'FLEETMASTER_GPS_API_TOKEN',
        FLEETMASTERORDERAPITOKEN = 'FLEETMASTER_ORDER_API_TOKEN',
        TRANSPOREONVISIBILITYINTERFACEUSER = 'TRANSPOREON_VISIBILITY_INTERFACE_USER',
        TRANSPOREONUSECUSTOMERSHIPMENTNUMBERNOTTRANSPOREONORDERREF = 'TRANSPOREON_USE_CUSTOMER_SHIPMENT_NUMBER_NOT_TRANSPOREON_ORDER_REF',
        TRANSPOREONWORKFLOWID = 'TRANSPOREON_WORKFLOW_ID',
        TRANSPOREONENABLELOADINGCOMISSIONPRINTOUTINTERFACE = 'TRANSPOREON_ENABLE_LOADING_COMISSION_PRINTOUT_INTERFACE',
        TIMOCOMOAUTHCLIENT = 'TIMOCOM_OAUTH_CLIENT',
        TIMOCOMOAUTHSECRET = 'TIMOCOM_OAUTH_SECRET',
        SCANMEDIAPOSITIONSOURCE = 'SCANMEDIA_POSITION_SOURCE',
        SIMPEXDISABLEDOWNGRADEOFSTATUSVALUES = 'SIMPEX_DISABLE_DOWNGRADE_OF_STATUS_VALUES',
        RIOOAUTHCLIENTID = 'RIO_OAUTH_CLIENT_ID',
        RIOOAUTHCLIENTSECRET = 'RIO_OAUTH_CLIENT_SECRET',
        RIOFVLDISABLEFV25BMESSAGE = 'RIO_FVL_DISABLE_FV25B_MESSAGE',
        SHIPPEOASSIGNTRAILER = 'SHIPPEO_ASSIGN_TRAILER',
        SIMPEXSENDPOSITIONBEFORETRANSPORTORDER = 'SIMPEX_SEND_POSITION_BEFORE_TRANSPORT_ORDER',
        SHIPPEOUSEONLYNUMBERPLATE = 'SHIPPEO_USE_ONLY_NUMBERPLATE',
        FOURKITESSHIPPERID = 'FOURKITES_SHIPPER_ID',
        SPEDIONATTACHMENTCATEGORIESTOBESENDTOTABLET = 'SPEDION_ATTACHMENT_CATEGORIES_TO_BE_SEND_TO_TABLET',
        SPEDIONFORMSTOIGNORE = 'SPEDION_FORMS_TO_IGNORE',
        SPEDIONSENDBOUNCETOURSONLYTOLOGENIOS = 'SPEDION_SEND_BOUNCE_TOURS_ONLY_TO_LOGENIOS',
        TIMOCOMDISABLEPOLLING = 'TIMOCOM_DISABLE_POLLING',
        TIMOCOMFORCEFULLFETCH = 'TIMOCOM_FORCE_FULL_FETCH',
        SPEDIONPROCESSONLYMESSAGESWITHCUSTOMERID = 'SPEDION_PROCESS_ONLY_MESSAGES_WITH_CUSTOMER_ID',
        ZEKJUPOLLINGGEOSTATUSKEY = 'ZEKJU_POLLING_GEO_STATUS_KEY',
        TOMTOMUSEPOLLINGINSTEADOFMESSAGEQUEUE = 'TOMTOM_USE_POLLING_INSTEAD_OF_MESSAGE_QUEUE',
        ZEKJUREGISTRATIONSCRIPT = 'ZEKJU_REGISTRATION_SCRIPT',
        SPEDIONPULLDRIVEANDRESTTIMES = 'SPEDION_PULL_DRIVE_AND_REST_TIMES',
        SPEDIONEXTRACTSHIPPEREXPRESSION = 'SPEDION_EXTRACT_SHIPPER_EXPRESSION'
    }
}

/**
 * 
 * @export
 * @interface ApiGatewayConfig
 */
export interface ApiGatewayConfig {
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    accountName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    allowModifyTransportOrdersOfSourceCompany?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    api?: ApiGatewayConfig.ApiEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    backupIncomingMessages?: boolean;
    /**
     * 
     * @type {Array<ApiAdditional>}
     * @memberof ApiGatewayConfig
     */
    customApiAdditionals?: Array<ApiAdditional>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    disableAttachmentImport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    disableExportToExternalApi?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    environmentFilterString?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    exchangeOptions?: ApiGatewayConfig.ExchangeOptionsEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    exportTransportOrderEventsToExternalApi?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    externalTransporOrderIdRegexPatternTakeGroupOne?: string;
    /**
     * 
     * @type {ImportOptions}
     * @memberof ApiGatewayConfig
     */
    importOptions?: ImportOptions;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    monitoringEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    password?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiGatewayConfig
     */
    pollingTimeInSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    postTransportOrderToExternalFormatConversionScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    sourceCompanyHasToMatchForTourExport?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayConfig
     */
    useStopMetaDataIdentifierForStatusUpdates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayConfig
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace ApiGatewayConfig
 */
export namespace ApiGatewayConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum ApiEnum {
        SIMPEX = 'SIMPEX',
        TOMTOM = 'TOMTOM',
        SAP = 'SAP',
        AIS = 'AIS',
        TRANSICS = 'TRANSICS',
        FLEETMASTER = 'FLEETMASTER',
        FRAMELOGIC = 'FRAMELOGIC',
        YELLOWFOX = 'YELLOWFOX',
        CUSTOMHTTPPOST = 'CUSTOM_HTTP_POST',
        CUSTOMXML = 'CUSTOM_XML',
        FOURKITES = 'FOURKITES',
        SPEDIONTOM = 'SPEDION_TOM',
        NAVISOFT = 'NAVISOFT',
        NAVISOFTSELENIUM = 'NAVISOFT_SELENIUM',
        DHLSELENIUM = 'DHL_SELENIUM',
        FLEETTECH = 'FLEETTECH',
        TRACCAR = 'TRACCAR',
        SCANMEDIA = 'SCANMEDIA',
        SIXFOLD = 'SIXFOLD',
        SIXFOLDPLATFORMSHIPMENTS = 'SIXFOLD_PLATFORM_SHIPMENTS',
        FLEETBOARD = 'FLEETBOARD',
        FLEETBOARDCONIZI = 'FLEETBOARD_CONIZI',
        TRANSPOREON = 'TRANSPOREON',
        SHIPPEO = 'SHIPPEO',
        ALIORGPS = 'ALIOR_GPS',
        LOCTRACKER = 'LOC_TRACKER',
        WEBEYE = 'WEBEYE',
        TIMOCOM = 'TIMOCOM',
        RIO = 'RIO',
        ASTRATAFLEETVISOR = 'ASTRATA_FLEETVISOR',
        EASYTRACKMAP = 'EASYTRACKMAP',
        FLEETHAND = 'FLEETHAND',
        RIOTELEMATICS = 'RIO_TELEMATICS',
        FOURKITESV2 = 'FOURKITES_v2',
        FOURKITESV3 = 'FOURKITES_v3',
        PROJECT44 = 'PROJECT44',
        ZEKJUCARRIER = 'ZEKJU_CARRIER',
        ZEKJUSHIPPER = 'ZEKJU_SHIPPER',
        TIS = 'TIS',
        LOGISAT = 'LOGISAT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExchangeOptionsEnum {
        TRANSPORTORDERFROMTELEMATICTOUR = 'TRANSPORT_ORDER_FROM_TELEMATIC_TOUR',
        TELEMATICTOURFROMTRANSPORTORDER = 'TELEMATIC_TOUR_FROM_TRANSPORT_ORDER',
        MAPTELEMATICTOURTOTRANSPORTORDER = 'MAP_TELEMATIC_TOUR_TO_TRANSPORT_ORDER',
        MAPORCREATETRANSPORTORDERFROMTELEMATICTOUR = 'MAP_OR_CREATE_TRANSPORT_ORDER_FROM_TELEMATIC_TOUR',
        ONLYIMPORTVEHICLEPOSITIONS = 'ONLY_IMPORT_VEHICLE_POSITIONS'
    }
}

/**
 * 
 * @export
 * @interface ApiGatewayMonitoringConfiguration
 */
export interface ApiGatewayMonitoringConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    externalMessagesWaitingThreshold?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    level?: ApiGatewayMonitoringConfiguration.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    message?: string;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayMonitoringConfiguration
     */
    title?: string;
}

/**
 * @export
 * @namespace ApiGatewayMonitoringConfiguration
 */
export namespace ApiGatewayMonitoringConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface ApiGatewayState
 */
export interface ApiGatewayState {
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayState
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayState
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayState
     */
    configId?: string;
    /**
     * 
     * @type {any}
     * @memberof ApiGatewayState
     */
    state?: any;
}

/**
 * 
 * @export
 * @interface ApiGatewayStateUpdate
 */
export interface ApiGatewayStateUpdate {
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayStateUpdate
     */
    command?: ApiGatewayStateUpdate.CommandEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayStateUpdate
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiGatewayStateUpdate
     */
    value?: string;
}

/**
 * @export
 * @namespace ApiGatewayStateUpdate
 */
export namespace ApiGatewayStateUpdate {
    /**
     * @export
     * @enum {string}
     */
    export enum CommandEnum {
        CREATEORUPDATE = 'CREATE_OR_UPDATE',
        DELETE = 'DELETE'
    }
}

/**
 * 
 * @export
 * @interface ApiGatewayStateUpdateRequest
 */
export interface ApiGatewayStateUpdateRequest {
    /**
     * 
     * @type {Array<ApiGatewayStateUpdate>}
     * @memberof ApiGatewayStateUpdateRequest
     */
    commands?: Array<ApiGatewayStateUpdate>;
}

/**
 * 
 * @export
 * @interface ApiSyncQueueMonitoringConfiguration
 */
export interface ApiSyncQueueMonitoringConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    level?: ApiSyncQueueMonitoringConfiguration.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    message?: string;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof ApiSyncQueueMonitoringConfiguration
     */
    title?: string;
}

/**
 * @export
 * @namespace ApiSyncQueueMonitoringConfiguration
 */
export namespace ApiSyncQueueMonitoringConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface AppDeviceId
 */
export interface AppDeviceId {
    /**
     * 
     * @type {string}
     * @memberof AppDeviceId
     */
    installationId?: string;
    /**
     * 
     * @type {string}
     * @memberof AppDeviceId
     */
    secureId?: string;
}

/**
 * 
 * @export
 * @interface ApplyCustomerAddressMappingResult
 */
export interface ApplyCustomerAddressMappingResult {
    /**
     * 
     * @type {TransportOrder}
     * @memberof ApplyCustomerAddressMappingResult
     */
    newOrder?: TransportOrder;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyCustomerAddressMappingResult
     */
    result?: boolean;
}

/**
 * 
 * @export
 * @interface ArchiveTransportOrdersRequest
 */
export interface ArchiveTransportOrdersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ArchiveTransportOrdersRequest
     */
    transportOrderIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface ArchiveTransportOrdersResponse
 */
export interface ArchiveTransportOrdersResponse {
    /**
     * 
     * @type {string}
     * @memberof ArchiveTransportOrdersResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArchiveTransportOrdersResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface ArchivingInfo
 */
export interface ArchivingInfo {
    /**
     * 
     * @type {string}
     * @memberof ArchivingInfo
     */
    archivedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof ArchivingInfo
     */
    since?: Date;
}

/**
 * 
 * @export
 * @interface ArrivalNotificationConfiguration
 */
export interface ArrivalNotificationConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof ArrivalNotificationConfiguration
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ArrivalNotificationConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArrivalNotificationConfiguration
     */
    id?: string;
    /**
     * 
     * @type {Array<OnlyForPartnerCompaniesEntry>}
     * @memberof ArrivalNotificationConfiguration
     */
    onlyForPartnerCompanies?: Array<OnlyForPartnerCompaniesEntry>;
    /**
     * 
     * @type {string}
     * @memberof ArrivalNotificationConfiguration
     */
    timeToNotify?: ArrivalNotificationConfiguration.TimeToNotifyEnum;
}

/**
 * @export
 * @namespace ArrivalNotificationConfiguration
 */
export namespace ArrivalNotificationConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum TimeToNotifyEnum {
        FifteenMinutes = 'FifteenMinutes',
        ThirtyMinutes = 'ThirtyMinutes',
        OneHour = 'OneHour',
        TwoHours = 'TwoHours'
    }
}

/**
 * 
 * @export
 * @interface As2ServerConfiguration
 */
export interface As2ServerConfiguration {
    /**
     * 
     * @type {string}
     * @memberof As2ServerConfiguration
     */
    receiverPrivateKeyPem?: string;
    /**
     * 
     * @type {string}
     * @memberof As2ServerConfiguration
     */
    receiverPublicKeyPem?: string;
}

/**
 * 
 * @export
 * @interface As2SyncConfiguration
 */
export interface As2SyncConfiguration {
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    encryptAlgo?: As2SyncConfiguration.EncryptAlgoEnum;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    receiverPublicKeyPem?: string;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    receiverSystemName?: string;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    remoteUploadUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    senderSystemName?: string;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    signAlgo?: As2SyncConfiguration.SignAlgoEnum;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    signingPfxKeyAlias?: string;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    signingPfxKeyFile?: string;
    /**
     * 
     * @type {string}
     * @memberof As2SyncConfiguration
     */
    signingPfxKeyPassword?: string;
}

/**
 * @export
 * @namespace As2SyncConfiguration
 */
export namespace As2SyncConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum EncryptAlgoEnum {
        AES128CBC = 'CRYPT_AES128_CBC',
        _3DES = 'CRYPT_3DES'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SignAlgoEnum {
        DIGESTSHA256 = 'DIGEST_SHA_256'
    }
}

/**
 * 
 * @export
 * @interface AssignResponse
 */
export interface AssignResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssignResponse
     */
    ok?: boolean;
}

/**
 * 
 * @export
 * @interface AssignToCurrentCompanyRequestData
 */
export interface AssignToCurrentCompanyRequestData {
    /**
     * 
     * @type {string}
     * @memberof AssignToCurrentCompanyRequestData
     */
    accessToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssignToCurrentCompanyRequestData
     */
    createPartnership?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssignToCurrentCompanyRequestData
     */
    orderId?: string;
}

/**
 * 
 * @export
 * @interface AssignedDevice
 */
export interface AssignedDevice {
    /**
     * Email address of someone from the company who should receive a the notifications in case of attachment rejection and invoice reminders as well.
     * @type {string}
     * @memberof AssignedDevice
     */
    attachmentStatusUpdateReceiverMailAddress?: string;
    /**
     * BCc Email address of someone from the company who should receive a installation instruction for the mobile or single tour app
     * @type {string}
     * @memberof AssignedDevice
     */
    bccAddress?: string;
    /**
     * Cc Email address of someone from the company who should receive a installation instruction for the mobile or single tour app
     * @type {string}
     * @memberof AssignedDevice
     */
    ccAddress?: string;
    /**
     * Email address of the driver who should receive a installation instruction for the mobile or single tour app
     * @type {string}
     * @memberof AssignedDevice
     */
    emailAddress?: string;
    /**
     * The URL under which that order shall be reachable via external system. Must start with https://m.logenios.com/te/<your_company_tag>/<sldfll>
     * @type {string}
     * @memberof AssignedDevice
     */
    externalAccesUrl?: string;
    /**
     * Accepted languages of the driver who should use the LOGENIOS mobile or single tour app
     * @type {string}
     * @memberof AssignedDevice
     */
    language?: string;
    /**
     * Phone number of the driver who should receive a installation instruction for the mobile or single tour app
     * @type {string}
     * @memberof AssignedDevice
     */
    phoneNr?: string;
    /**
     * Timocom ID of the company that shall receive the transport order
     * @type {string}
     * @memberof AssignedDevice
     */
    timocomId?: string;
    /**
     * Verbose name of the driver used to personalize the installation instructions
     * @type {string}
     * @memberof AssignedDevice
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface AssignedDeviceNotificationConfiguration
 */
export interface AssignedDeviceNotificationConfiguration {
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    detectLanguage?: AssignedDeviceNotificationConfiguration.DetectLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    displayStopListInAssignedDeviceMail?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    doNotDisturbFromHour?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    doNotDisturbTillHour?: number;
    /**
     * 
     * @type {MailConfiguration}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    onAssignMail?: MailConfiguration;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    onAssignSmsText?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    onCancelSmsText?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    onUpdateSmsText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    sendCcMailToExternalUser?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignedDeviceNotificationConfiguration
     */
    sendCcMailToFixedUserList?: Array<string>;
}

/**
 * @export
 * @namespace AssignedDeviceNotificationConfiguration
 */
export namespace AssignedDeviceNotificationConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum DetectLanguageEnum {
        OFF = 'OFF',
        USEASSIGNEDDEVICELANGUAGE = 'USE_ASSIGNED_DEVICE_LANGUAGE',
        USEDRIVERLANGUAGE = 'USE_DRIVER_LANGUAGE',
        USEPHONENUMBER = 'USE_PHONE_NUMBER'
    }
}

/**
 * 
 * @export
 * @interface AssignedGroup
 */
export interface AssignedGroup {
    /**
     * 
     * @type {string}
     * @memberof AssignedGroup
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedGroup
     */
    groupName?: string;
}

/**
 * 
 * @export
 * @interface AssignedOrderBox
 */
export interface AssignedOrderBox {
    /**
     * 
     * @type {string}
     * @memberof AssignedOrderBox
     */
    imei?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedOrderBox
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface AsyncJobResponse
 */
export interface AsyncJobResponse {
    /**
     * 
     * @type {string}
     * @memberof AsyncJobResponse
     */
    jobStatusUrl?: string;
}

/**
 * 
 * @export
 * @interface AtlasCoordinate
 */
export interface AtlasCoordinate {
    /**
     * 
     * @type {ModelFloat}
     * @memberof AtlasCoordinate
     */
    latitude?: ModelFloat;
    /**
     * 
     * @type {ModelFloat}
     * @memberof AtlasCoordinate
     */
    longitude?: ModelFloat;
}

/**
 * 
 * @export
 * @interface AtlasDateTime
 */
export interface AtlasDateTime {
    /**
     * 
     * @type {Number}
     * @memberof AtlasDateTime
     */
    day?: Number;
    /**
     * 
     * @type {Number}
     * @memberof AtlasDateTime
     */
    hour?: Number;
    /**
     * 
     * @type {Number}
     * @memberof AtlasDateTime
     */
    minute?: Number;
    /**
     * 
     * @type {Number}
     * @memberof AtlasDateTime
     */
    month?: Number;
    /**
     * 
     * @type {Number}
     * @memberof AtlasDateTime
     */
    second?: Number;
    /**
     * 
     * @type {string}
     * @memberof AtlasDateTime
     */
    timezone?: string;
    /**
     * 
     * @type {Number}
     * @memberof AtlasDateTime
     */
    year?: Number;
}

/**
 * 
 * @export
 * @interface AtlasDevice
 */
export interface AtlasDevice {
    /**
     * 
     * @type {string}
     * @memberof AtlasDevice
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AtlasDevice
     */
    deviceName?: string;
}

/**
 * 
 * @export
 * @interface AtlasDevicesResponse
 */
export interface AtlasDevicesResponse {
    /**
     * 
     * @type {Array<AtlasDevice>}
     * @memberof AtlasDevicesResponse
     */
    deviceList?: Array<AtlasDevice>;
}

/**
 * 
 * @export
 * @interface AtlasPosition
 */
export interface AtlasPosition {
    /**
     * 
     * @type {AtlasCoordinate}
     * @memberof AtlasPosition
     */
    coordinate?: AtlasCoordinate;
    /**
     * 
     * @type {AtlasDateTime}
     * @memberof AtlasPosition
     */
    dateTime?: AtlasDateTime;
    /**
     * 
     * @type {string}
     * @memberof AtlasPosition
     */
    deviceId?: string;
    /**
     * 
     * @type {number}
     * @memberof AtlasPosition
     */
    heading?: number;
    /**
     * 
     * @type {string}
     * @memberof AtlasPosition
     */
    ignitionState?: string;
    /**
     * 
     * @type {Number}
     * @memberof AtlasPosition
     */
    speed?: Number;
}

/**
 * 
 * @export
 * @interface AtlasPositionsResponse
 */
export interface AtlasPositionsResponse {
    /**
     * 
     * @type {Array<AtlasPosition>}
     * @memberof AtlasPositionsResponse
     */
    positionList?: Array<AtlasPosition>;
}

/**
 * 
 * @export
 * @interface AtlasVersionResponse
 */
export interface AtlasVersionResponse {
    /**
     * 
     * @type {string}
     * @memberof AtlasVersionResponse
     */
    version?: string;
}

/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * Additional key-value-pairs associated with this attachment
     * @type {Array<AdditionalDataEntry>}
     * @memberof Attachment
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * ID of the attachment
     * @type {string}
     * @memberof Attachment
     */
    attachmentId?: string;
    /**
     * Classification of the attached document
     * @type {string}
     * @memberof Attachment
     */
    category?: Attachment.CategoryEnum;
    /**
     * Creation timestamp of the attachment
     * @type {Date}
     * @memberof Attachment
     */
    creation?: Date;
    /**
     * MD5 Hash of the attachment payload
     * @type {string}
     * @memberof Attachment
     */
    fileHash?: string;
    /**
     * Internal text note for attachment added by attachment reviewer
     * @type {string}
     * @memberof Attachment
     */
    internalTextNote?: string;
    /**
     * Name of the attached file
     * @type {string}
     * @memberof Attachment
     */
    name?: string;
    /**
     * 
     * @type {Origin}
     * @memberof Attachment
     */
    origin?: Origin;
    /**
     * 
     * @type {AttachmentStatus}
     * @memberof Attachment
     */
    status?: AttachmentStatus;
    /**
     * Content of the attachment encoded as base64 data. This field can be used to add the attachment to a transport order. The api server creates a standard attachment from the content of this field and then clears this field.
     * @type {string}
     * @memberof Attachment
     */
    uploadOnlyBase64AttachmentContent?: string;
}

/**
 * @export
 * @namespace Attachment
 */
export namespace Attachment {
    /**
     * @export
     * @enum {string}
     */
    export enum CategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
}

/**
 * 
 * @export
 * @interface AttachmentAddRequest
 */
export interface AttachmentAddRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentAddRequest
     */
    attachmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAddRequest
     */
    category?: AttachmentAddRequest.CategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAddRequest
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAddRequest
     */
    internalTextNote?: string;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof AttachmentAddRequest
     */
    pathSelector?: TransportOrderPathSelector;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAddRequest
     */
    uploadOnlyBase64AttachmentContent?: string;
}

/**
 * @export
 * @namespace AttachmentAddRequest
 */
export namespace AttachmentAddRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum CategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
}

/**
 * 
 * @export
 * @interface AttachmentAreaConfiguration
 */
export interface AttachmentAreaConfiguration {
    /**
     * 
     * @type {Array<AttachmentClassConfiguration>}
     * @memberof AttachmentAreaConfiguration
     */
    availableClasses?: Array<AttachmentClassConfiguration>;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    canClassifyStopLocationAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    canClassifyTourAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    canClassifyTransportAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    canUploadInvoices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    canUploadStopLocationAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    canUploadTourAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    canUploadTransportAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    convertImageAttachmentsToPdf?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    displayAttachmentUploadWizard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    displayStopLocationAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    displayTourAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    displayTransportAttachments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAreaConfiguration
     */
    excludeFilePattern?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAreaConfiguration
     */
    includeFilePattern?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAreaConfiguration
     */
    infoText?: string;
    /**
     * 
     * @type {Array<Translation>}
     * @memberof AttachmentAreaConfiguration
     */
    infoTextTranslation?: Array<Translation>;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAreaConfiguration
     */
    invoiceExcludeFilePattern?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentAreaConfiguration
     */
    invoiceIncludeFilePattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    transportAttachmentsArePods?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentAreaConfiguration
     */
    userMustClassifyAttachments?: boolean;
}

/**
 * 
 * @export
 * @interface AttachmentCategoriesToBeProcessed
 */
export interface AttachmentCategoriesToBeProcessed {
    /**
     * 
     * @type {string}
     * @memberof AttachmentCategoriesToBeProcessed
     */
    category?: AttachmentCategoriesToBeProcessed.CategoryEnum;
    /**
     * 
     * @type {TransportOrderLevelSelector}
     * @memberof AttachmentCategoriesToBeProcessed
     */
    level?: TransportOrderLevelSelector;
}

/**
 * @export
 * @namespace AttachmentCategoriesToBeProcessed
 */
export namespace AttachmentCategoriesToBeProcessed {
    /**
     * @export
     * @enum {string}
     */
    export enum CategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
}

/**
 * 
 * @export
 * @interface AttachmentCategoryAndStatusInLevel
 */
export interface AttachmentCategoryAndStatusInLevel {
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachmentCategoryAndStatusInLevel
     */
    category?: Array<AttachmentCategoryAndStatusInLevel.CategoryEnum>;
    /**
     * 
     * @type {TransportOrderLevelSelector}
     * @memberof AttachmentCategoryAndStatusInLevel
     */
    levelSelector?: TransportOrderLevelSelector;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachmentCategoryAndStatusInLevel
     */
    statusCodes?: Array<AttachmentCategoryAndStatusInLevel.StatusCodesEnum>;
}

/**
 * @export
 * @namespace AttachmentCategoryAndStatusInLevel
 */
export namespace AttachmentCategoryAndStatusInLevel {
    /**
     * @export
     * @enum {string}
     */
    export enum CategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodesEnum {
        CREATED = 'CREATED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
}

/**
 * 
 * @export
 * @interface AttachmentCategoryFilterBasedOnKeyWords
 */
export interface AttachmentCategoryFilterBasedOnKeyWords {
    /**
     * 
     * @type {string}
     * @memberof AttachmentCategoryFilterBasedOnKeyWords
     */
    attachmentCategory?: AttachmentCategoryFilterBasedOnKeyWords.AttachmentCategoryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachmentCategoryFilterBasedOnKeyWords
     */
    keywords?: Array<string>;
}

/**
 * @export
 * @namespace AttachmentCategoryFilterBasedOnKeyWords
 */
export namespace AttachmentCategoryFilterBasedOnKeyWords {
    /**
     * @export
     * @enum {string}
     */
    export enum AttachmentCategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
}

/**
 * 
 * @export
 * @interface AttachmentClassConfiguration
 */
export interface AttachmentClassConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachmentClassConfiguration
     */
    availableAttachmentClasses?: Array<AttachmentClassConfiguration.AvailableAttachmentClassesEnum>;
    /**
     * 
     * @type {string}
     * @memberof AttachmentClassConfiguration
     */
    levelSelector?: AttachmentClassConfiguration.LevelSelectorEnum;
}

/**
 * @export
 * @namespace AttachmentClassConfiguration
 */
export namespace AttachmentClassConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableAttachmentClassesEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LevelSelectorEnum {
        TransportOrder = 'TransportOrder',
        Transport = 'Transport',
        StopLocation = 'StopLocation',
        LoadingLocation = 'LoadingLocation',
        UnloadingLocation = 'UnloadingLocation'
    }
}

/**
 * 
 * @export
 * @interface AttachmentModifyRequest
 */
export interface AttachmentModifyRequest {
    /**
     * New additionalData replacing old additional data of the attachment
     * @type {Array<AdditionalDataEntry>}
     * @memberof AttachmentModifyRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * New category for the attachment
     * @type {string}
     * @memberof AttachmentModifyRequest
     */
    attachmentCategory?: AttachmentModifyRequest.AttachmentCategoryEnum;
    /**
     * New file name for the attachment
     * @type {string}
     * @memberof AttachmentModifyRequest
     */
    fileName?: string;
    /**
     * Text note for this attachment added by the reviewer
     * @type {string}
     * @memberof AttachmentModifyRequest
     */
    internalTextNote?: string;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof AttachmentModifyRequest
     */
    newPath?: TransportOrderPathSelector;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof AttachmentModifyRequest
     */
    pathSelector?: TransportOrderPathSelector;
    /**
     * 
     * @type {AttachmentStatus}
     * @memberof AttachmentModifyRequest
     */
    status?: AttachmentStatus;
}

/**
 * @export
 * @namespace AttachmentModifyRequest
 */
export namespace AttachmentModifyRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum AttachmentCategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
}

/**
 * 
 * @export
 * @interface AttachmentModifyResponse
 */
export interface AttachmentModifyResponse {
    /**
     * 
     * @type {Attachment}
     * @memberof AttachmentModifyResponse
     */
    attachment?: Attachment;
    /**
     * 
     * @type {TransportOrder}
     * @memberof AttachmentModifyResponse
     */
    transportOrder?: TransportOrder;
}

/**
 * 
 * @export
 * @interface AttachmentOverviewModalConfiguration
 */
export interface AttachmentOverviewModalConfiguration {
    /**
     * 
     * @type {string}
     * @memberof AttachmentOverviewModalConfiguration
     */
    modalSize?: AttachmentOverviewModalConfiguration.ModalSizeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showAttachmentStatusColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showDeliveryNumberColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showFreightIdColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showSStopCityColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showShipmentNumberColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showStopIdColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showStopNameColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentOverviewModalConfiguration
     */
    showTransportIdColumn?: boolean;
}

/**
 * @export
 * @namespace AttachmentOverviewModalConfiguration
 */
export namespace AttachmentOverviewModalConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModalSizeEnum {
        Mini = 'mini',
        Tiny = 'tiny',
        Small = 'small',
        Large = 'large',
        Fullscreen = 'fullscreen'
    }
}

/**
 * 
 * @export
 * @interface AttachmentPresignedUrlResponse
 */
export interface AttachmentPresignedUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof AttachmentPresignedUrlResponse
     */
    preSignedUrl?: string;
}

/**
 * 
 * @export
 * @interface AttachmentProcessorConfiguration
 */
export interface AttachmentProcessorConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentProcessorConfiguration
     */
    discardAttachments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AttachmentProcessorConfiguration
     */
    postImportScript?: string;
    /**
     * 
     * @type {SplitOnOptions}
     * @memberof AttachmentProcessorConfiguration
     */
    splitOn?: SplitOnOptions;
    /**
     * 
     * @type {SplitOnWithAI}
     * @memberof AttachmentProcessorConfiguration
     */
    splitOnWithAI?: SplitOnWithAI;
}

/**
 * 
 * @export
 * @interface AttachmentProcessorPromptBuilder
 */
export interface AttachmentProcessorPromptBuilder {
    /**
     * 
     * @type {Array<AdditionalDetails>}
     * @memberof AttachmentProcessorPromptBuilder
     */
    additionalDetails?: Array<AdditionalDetails>;
    /**
     * 
     * @type {BackendSearchOptions}
     * @memberof AttachmentProcessorPromptBuilder
     */
    backendSearchOptions?: BackendSearchOptions;
    /**
     * 
     * @type {string}
     * @memberof AttachmentProcessorPromptBuilder
     */
    extractionMode?: AttachmentProcessorPromptBuilder.ExtractionModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AttachmentProcessorPromptBuilder
     */
    matchingLevel?: AttachmentProcessorPromptBuilder.MatchingLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof AttachmentProcessorPromptBuilder
     */
    model?: AttachmentProcessorPromptBuilder.ModelEnum;
    /**
     * 
     * @type {string}
     * @memberof AttachmentProcessorPromptBuilder
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentProcessorPromptBuilder
     */
    prompt?: string;
}

/**
 * @export
 * @namespace AttachmentProcessorPromptBuilder
 */
export namespace AttachmentProcessorPromptBuilder {
    /**
     * @export
     * @enum {string}
     */
    export enum ExtractionModeEnum {
        SINGLE = 'SINGLE',
        LIST = 'LIST'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MatchingLevelEnum {
        EXTERNALTRANSPORTORDERID = 'EXTERNAL_TRANSPORT_ORDER_ID',
        TRANSPORTID = 'TRANSPORT_ID',
        BACKENDSEARCH = 'BACKEND_SEARCH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ModelEnum {
        GPT4O = 'GPT4_O',
        CLAUDE45SONNET = 'CLAUDE45_SONNET',
        CLAUDE45HAIKU = 'CLAUDE45_HAIKU',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING'
    }
}

/**
 * 
 * @export
 * @interface AttachmentStatus
 */
export interface AttachmentStatus {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof AttachmentStatus
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {Origin}
     * @memberof AttachmentStatus
     */
    origin?: Origin;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatus
     */
    rejectedCode?: AttachmentStatus.RejectedCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatus
     */
    rejectedReason?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatus
     */
    statusCode?: AttachmentStatus.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof AttachmentStatus
     */
    timestamp?: Date;
}

/**
 * @export
 * @namespace AttachmentStatus
 */
export namespace AttachmentStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum RejectedCodeEnum {
        WRONGTRANSPORT = 'WRONG_TRANSPORT',
        MISSINGSIGNATURE = 'MISSING_SIGNATURE',
        NOTREADABLE = 'NOT_READABLE',
        MISSINGWEIGHT = 'MISSING_WEIGHT',
        ASSIGNEACHINDIVIDUALLYTOSHIPMENT = 'ASSIGN_EACH_INDIVIDUALLY_TO_SHIPMENT',
        INCOMPLETE = 'INCOMPLETE',
        OTHER = 'OTHER',
        TOURNRMISSINGONINVOICE = 'TOUR_NR_MISSING_ON_INVOICE',
        INVOICEAMOUNTWRONG = 'INVOICE_AMOUNT_WRONG',
        INCORRECTCOMPANYNAME = 'INCORRECT_COMPANY_NAME'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        CREATED = 'CREATED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
}

/**
 * 
 * @export
 * @interface AttachmentStatusAndLevel
 */
export interface AttachmentStatusAndLevel {
    /**
     * 
     * @type {TransportOrderLevelSelector}
     * @memberof AttachmentStatusAndLevel
     */
    levelSelector?: TransportOrderLevelSelector;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentStatusAndLevel
     */
    missingAttachment?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachmentStatusAndLevel
     */
    statusCodes?: Array<AttachmentStatusAndLevel.StatusCodesEnum>;
}

/**
 * @export
 * @namespace AttachmentStatusAndLevel
 */
export namespace AttachmentStatusAndLevel {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodesEnum {
        CREATED = 'CREATED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
}

/**
 * 
 * @export
 * @interface AttachmentStatusRequest
 */
export interface AttachmentStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    actionId?: string;
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof AttachmentStatusRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    attachmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentStatusRequest
     */
    forceOverrideDependentStates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    freightId?: string;
    /**
     * 
     * @type {Origin}
     * @memberof AttachmentStatusRequest
     */
    origin?: Origin;
    /**
     * The status which should be submitted
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    statusCode?: AttachmentStatusRequest.StatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    stopId?: string;
    /**
     * 
     * @type {Date}
     * @memberof AttachmentStatusRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentStatusRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace AttachmentStatusRequest
 */
export namespace AttachmentStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        CREATED = 'CREATED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
}

/**
 * 
 * @export
 * @interface AuthTestResponse
 */
export interface AuthTestResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthTestResponse
     */
    auth?: string;
}

/**
 * 
 * @export
 * @interface AuthToken
 */
export interface AuthToken {
    /**
     * 
     * @type {Date}
     * @memberof AuthToken
     */
    creationTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AuthToken
     */
    expiryDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AuthToken
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthToken
     */
    token?: string;
}

/**
 * 
 * @export
 * @interface AuthTokenRequest
 */
export interface AuthTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    expires?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface AutoDetectTruckTrailerMismatchConfig
 */
export interface AutoDetectTruckTrailerMismatchConfig {
    /**
     * 
     * @type {Array<string>}
     * @memberof AutoDetectTruckTrailerMismatchConfig
     */
    emailAddressForNotification?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AutoDetectTruckTrailerMismatchConfig
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AutoDetectTruckTrailerMismatchConfig
     */
    onlyCheckMessagesNotOlderThenSeconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AutoDetectTruckTrailerMismatchConfig
     */
    onlyEnableInLoadingLocationRadius?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AutoDetectTruckTrailerMismatchConfig
     */
    radiusAroundLoadingLocationToCheckMismatchInM?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutoDetectTruckTrailerMismatchConfig
     */
    specificStopIdsList?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AutoDetectTruckTrailerMismatchConfig
     */
    thresholdInM?: number;
}

/**
 * 
 * @export
 * @interface AvailableCompany
 */
export interface AvailableCompany {
    /**
     * 
     * @type {boolean}
     * @memberof AvailableCompany
     */
    companyAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AvailableCompany
     */
    companyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableCompany
     */
    permissions?: Array<AvailableCompany.PermissionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableCompany
     */
    roles?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableCompany
     */
    secretPermissions?: Array<AvailableCompany.SecretPermissionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableCompany
     */
    secretRoles?: Array<string>;
}

/**
 * @export
 * @namespace AvailableCompany
 */
export namespace AvailableCompany {
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionsEnum {
        USERSCREATE = 'USERS_CREATE',
        USERSDELETE = 'USERS_DELETE',
        USERSMODIFY = 'USERS_MODIFY',
        USERSVIEW = 'USERS_VIEW',
        USERSMODIFYPERMISSIONS = 'USERS_MODIFY_PERMISSIONS',
        FTPACCESS = 'FTP_ACCESS',
        TOCREATE = 'TO_CREATE',
        TOLINK = 'TO_LINK',
        TOASSIGNCOMPANY = 'TO_ASSIGN_COMPANY',
        TOASSIGNVEHICLE = 'TO_ASSIGN_VEHICLE',
        TOPATCH = 'TO_PATCH',
        TOPOSTSTATUS = 'TO_POST_STATUS',
        TOPUT = 'TO_PUT',
        TOSTORNO = 'TO_STORNO',
        TOADDOBSERVER = 'TO_ADD_OBSERVER',
        TOREMOVEOBSERVER = 'TO_REMOVE_OBSERVER',
        QUEUELIST = 'QUEUE_LIST',
        QUEUEMODIFY = 'QUEUE_MODIFY',
        EVENTS = 'EVENTS',
        COMPANYMODIFY = 'COMPANY_MODIFY',
        COMPANYFULLVIEW = 'COMPANY_FULL_VIEW',
        COMPANYPARTIALVIEW = 'COMPANY_PARTIAL_VIEW',
        COMPANYVIEWPARTNERS = 'COMPANY_VIEW_PARTNERS',
        COMPANYMODIFYPARTNERS = 'COMPANY_MODIFY_PARTNERS',
        USEDEPOT = 'USE_DEPOT',
        USEDEPOTSTOCK = 'USE_DEPOT_STOCK',
        ETAGET = 'ETA_GET',
        ETAPOST = 'ETA_POST',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDOWNLOAD = 'ATTACHMENT_DOWNLOAD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTUPLOAD = 'ATTACHMENT_UPLOAD',
        TELEMATICPOST = 'TELEMATIC_POST',
        TELEMATICGET = 'TELEMATIC_GET',
        USERROLESVIEW = 'USER_ROLES_VIEW',
        USERROLESCREATEMODIFYDELETE = 'USER_ROLES_CREATE_MODIFY_DELETE',
        USERROLESASSIGN = 'USER_ROLES_ASSIGN',
        VEHICLEVIEW = 'VEHICLE_VIEW',
        VEHICLECREATEMODIFYDELETE = 'VEHICLE_CREATE_MODIFY_DELETE',
        SCHEDULERCONFIG = 'SCHEDULER_CONFIG',
        VIEWREPORT = 'VIEW_REPORT',
        VIEWMANAGEMENTREPORT = 'VIEW_MANAGEMENT_REPORT',
        VIEWGENERICREPORTS = 'VIEW_GENERIC_REPORTS',
        DRIVERVIEW = 'DRIVER_VIEW',
        DRIVERCREATEMODIFYDELETE = 'DRIVER_CREATE_MODIFY_DELETE',
        USEMAILGATEWAY = 'USE_MAIL_GATEWAY',
        CMUSE = 'CM_USE',
        ATTACHMENTREVIEW = 'ATTACHMENT_REVIEW',
        SELFATTACHMENTREVIEW = 'SELF_ATTACHMENT_REVIEW',
        BILL = 'BILL',
        ADDRESSMAPPINGVIEW = 'ADDRESS_MAPPING_VIEW',
        ADDRESSMAPPINGCREATEMODIFYDELETE = 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE',
        COMPANYMESSAGELOGVIEW = 'COMPANY_MESSAGE_LOGVIEW',
        RESENDFAILEDREQUESTS = 'RESEND_FAILED_REQUESTS',
        COMPANYTAGVIEW = 'COMPANY_TAG_VIEW',
        INTERNALMONITORING = 'INTERNAL_MONITORING',
        VIEWSTANDINGTIMES = 'VIEW_STANDING_TIMES',
        TOASSIGNTRAILER = 'TO_ASSIGN_TRAILER',
        TOASSIGNDEVICE = 'TO_ASSIGN_DEVICE',
        VIEWEMPTYKMREPORT = 'VIEW_EMPTY_KM_REPORT',
        VIEWFLEET = 'VIEW_FLEET',
        TOLIST = 'TO_LIST',
        VIEWTOURCOSTREPORT = 'VIEW_TOUR_COST_REPORT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SecretPermissionsEnum {
        USERSCREATE = 'USERS_CREATE',
        USERSDELETE = 'USERS_DELETE',
        USERSMODIFY = 'USERS_MODIFY',
        USERSVIEW = 'USERS_VIEW',
        USERSMODIFYPERMISSIONS = 'USERS_MODIFY_PERMISSIONS',
        FTPACCESS = 'FTP_ACCESS',
        TOCREATE = 'TO_CREATE',
        TOLINK = 'TO_LINK',
        TOASSIGNCOMPANY = 'TO_ASSIGN_COMPANY',
        TOASSIGNVEHICLE = 'TO_ASSIGN_VEHICLE',
        TOPATCH = 'TO_PATCH',
        TOPOSTSTATUS = 'TO_POST_STATUS',
        TOPUT = 'TO_PUT',
        TOSTORNO = 'TO_STORNO',
        TOADDOBSERVER = 'TO_ADD_OBSERVER',
        TOREMOVEOBSERVER = 'TO_REMOVE_OBSERVER',
        QUEUELIST = 'QUEUE_LIST',
        QUEUEMODIFY = 'QUEUE_MODIFY',
        EVENTS = 'EVENTS',
        COMPANYMODIFY = 'COMPANY_MODIFY',
        COMPANYFULLVIEW = 'COMPANY_FULL_VIEW',
        COMPANYPARTIALVIEW = 'COMPANY_PARTIAL_VIEW',
        COMPANYVIEWPARTNERS = 'COMPANY_VIEW_PARTNERS',
        COMPANYMODIFYPARTNERS = 'COMPANY_MODIFY_PARTNERS',
        USEDEPOT = 'USE_DEPOT',
        USEDEPOTSTOCK = 'USE_DEPOT_STOCK',
        ETAGET = 'ETA_GET',
        ETAPOST = 'ETA_POST',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDOWNLOAD = 'ATTACHMENT_DOWNLOAD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTUPLOAD = 'ATTACHMENT_UPLOAD',
        TELEMATICPOST = 'TELEMATIC_POST',
        TELEMATICGET = 'TELEMATIC_GET',
        USERROLESVIEW = 'USER_ROLES_VIEW',
        USERROLESCREATEMODIFYDELETE = 'USER_ROLES_CREATE_MODIFY_DELETE',
        USERROLESASSIGN = 'USER_ROLES_ASSIGN',
        VEHICLEVIEW = 'VEHICLE_VIEW',
        VEHICLECREATEMODIFYDELETE = 'VEHICLE_CREATE_MODIFY_DELETE',
        SCHEDULERCONFIG = 'SCHEDULER_CONFIG',
        VIEWREPORT = 'VIEW_REPORT',
        VIEWMANAGEMENTREPORT = 'VIEW_MANAGEMENT_REPORT',
        VIEWGENERICREPORTS = 'VIEW_GENERIC_REPORTS',
        DRIVERVIEW = 'DRIVER_VIEW',
        DRIVERCREATEMODIFYDELETE = 'DRIVER_CREATE_MODIFY_DELETE',
        USEMAILGATEWAY = 'USE_MAIL_GATEWAY',
        CMUSE = 'CM_USE',
        ATTACHMENTREVIEW = 'ATTACHMENT_REVIEW',
        SELFATTACHMENTREVIEW = 'SELF_ATTACHMENT_REVIEW',
        BILL = 'BILL',
        ADDRESSMAPPINGVIEW = 'ADDRESS_MAPPING_VIEW',
        ADDRESSMAPPINGCREATEMODIFYDELETE = 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE',
        COMPANYMESSAGELOGVIEW = 'COMPANY_MESSAGE_LOGVIEW',
        RESENDFAILEDREQUESTS = 'RESEND_FAILED_REQUESTS',
        COMPANYTAGVIEW = 'COMPANY_TAG_VIEW',
        INTERNALMONITORING = 'INTERNAL_MONITORING',
        VIEWSTANDINGTIMES = 'VIEW_STANDING_TIMES',
        TOASSIGNTRAILER = 'TO_ASSIGN_TRAILER',
        TOASSIGNDEVICE = 'TO_ASSIGN_DEVICE',
        VIEWEMPTYKMREPORT = 'VIEW_EMPTY_KM_REPORT',
        VIEWFLEET = 'VIEW_FLEET',
        TOLIST = 'TO_LIST',
        VIEWTOURCOSTREPORT = 'VIEW_TOUR_COST_REPORT'
    }
}

/**
 * 
 * @export
 * @interface BackendSearchOptions
 */
export interface BackendSearchOptions {
    /**
     * 
     * @type {string}
     * @memberof BackendSearchOptions
     */
    level?: BackendSearchOptions.LevelEnum;
}

/**
 * @export
 * @namespace BackendSearchOptions
 */
export namespace BackendSearchOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        TRANSPORTORDERMATCH = 'TRANSPORT_ORDER_MATCH',
        SHIPMENTMATCH = 'SHIPMENT_MATCH'
    }
}

/**
 * 
 * @export
 * @interface BackendToEtaCalculatorEvent
 */
export interface BackendToEtaCalculatorEvent {
    /**
     * 
     * @type {string}
     * @memberof BackendToEtaCalculatorEvent
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof BackendToEtaCalculatorEvent
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof BackendToEtaCalculatorEvent
     */
    errorString?: string;
    /**
     * 
     * @type {EtaConfig}
     * @memberof BackendToEtaCalculatorEvent
     */
    etaConfig?: EtaConfig;
    /**
     * 
     * @type {PositionRequest}
     * @memberof BackendToEtaCalculatorEvent
     */
    positionRequest?: PositionRequest;
    /**
     * 
     * @type {LastVehiclePositions}
     * @memberof BackendToEtaCalculatorEvent
     */
    previousVehiclePosition?: LastVehiclePositions;
    /**
     * 
     * @type {boolean}
     * @memberof BackendToEtaCalculatorEvent
     */
    processed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BackendToEtaCalculatorEvent
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof BackendToEtaCalculatorEvent
     */
    transportId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BackendToEtaCalculatorEvent
     */
    transportIds?: Array<string>;
    /**
     * 
     * @type {TransportOrder}
     * @memberof BackendToEtaCalculatorEvent
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {TransportOrderChangeEventRef}
     * @memberof BackendToEtaCalculatorEvent
     */
    transportOrderChangeEventRef?: TransportOrderChangeEventRef;
    /**
     * 
     * @type {string}
     * @memberof BackendToEtaCalculatorEvent
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface Base64Image
 */
export interface Base64Image {
    /**
     * 
     * @type {string}
     * @memberof Base64Image
     */
    base64PngImage?: string;
    /**
     * 
     * @type {string}
     * @memberof Base64Image
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface BatchAttachmentModifyFailedItem
 */
export interface BatchAttachmentModifyFailedItem {
    /**
     * Error message describing why it failed
     * @type {string}
     * @memberof BatchAttachmentModifyFailedItem
     */
    error?: string;
    /**
     * 
     * @type {BatchAttachmentModifyItem}
     * @memberof BatchAttachmentModifyFailedItem
     */
    item?: BatchAttachmentModifyItem;
}

/**
 * 
 * @export
 * @interface BatchAttachmentModifyItem
 */
export interface BatchAttachmentModifyItem {
    /**
     * ID of the attachment to modify
     * @type {string}
     * @memberof BatchAttachmentModifyItem
     */
    attachmentId?: string;
    /**
     * 
     * @type {AttachmentModifyRequest}
     * @memberof BatchAttachmentModifyItem
     */
    modifyRequest?: AttachmentModifyRequest;
    /**
     * ID of the transport order containing the attachment
     * @type {string}
     * @memberof BatchAttachmentModifyItem
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface BatchAttachmentModifyRequest
 */
export interface BatchAttachmentModifyRequest {
    /**
     * List of attachment modifications to process
     * @type {Array<BatchAttachmentModifyItem>}
     * @memberof BatchAttachmentModifyRequest
     */
    modifications?: Array<BatchAttachmentModifyItem>;
}

/**
 * 
 * @export
 * @interface BatchAttachmentModifyResponse
 */
export interface BatchAttachmentModifyResponse {
    /**
     * List of failed modifications with error messages
     * @type {Array<BatchAttachmentModifyFailedItem>}
     * @memberof BatchAttachmentModifyResponse
     */
    failed?: Array<BatchAttachmentModifyFailedItem>;
    /**
     * List of successful modifications
     * @type {Array<AttachmentModifyResponse>}
     * @memberof BatchAttachmentModifyResponse
     */
    successful?: Array<AttachmentModifyResponse>;
}

/**
 * 
 * @export
 * @interface BillWorkLogBookEntriesRequest
 */
export interface BillWorkLogBookEntriesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BillWorkLogBookEntriesRequest
     */
    logEntryIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BillWorkLogBookEntriesRequest
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof BillWorkLogBookEntriesRequest
     */
    year?: number;
}

/**
 * 
 * @export
 * @interface BillWorkLogBookEntriesResponse
 */
export interface BillWorkLogBookEntriesResponse {
    /**
     * 
     * @type {any}
     * @memberof BillWorkLogBookEntriesResponse
     */
    errors?: any;
}

/**
 * 
 * @export
 * @interface BillingRequest
 */
export interface BillingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BillingRequest
     */
    companyIdFilter?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BillingRequest
     */
    debugMode?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BillingRequest
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof BillingRequest
     */
    year?: number;
}

/**
 * 
 * @export
 * @interface BnsTelematikConverterConfiguration
 */
export interface BnsTelematikConverterConfiguration {
    /**
     * 
     * @type {string}
     * @memberof BnsTelematikConverterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BnsTelematikConverterConfiguration
     */
    importAvisInfoAsObserver?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BnsTelematikConverterConfiguration
     */
    modifyMode?: BnsTelematikConverterConfiguration.ModifyModeEnum;
    /**
     * 
     * @type {string}
     * @memberof BnsTelematikConverterConfiguration
     */
    postImportScript?: string;
}

/**
 * @export
 * @namespace BnsTelematikConverterConfiguration
 */
export namespace BnsTelematikConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface Byte
 */
export interface Byte {
}

/**
 * 
 * @export
 * @interface CacheUpdateTiming
 */
export interface CacheUpdateTiming {
    /**
     * 
     * @type {string}
     * @memberof CacheUpdateTiming
     */
    cacheName?: string;
    /**
     * 
     * @type {Date}
     * @memberof CacheUpdateTiming
     */
    lastCacheUpdateMessage?: Date;
}

/**
 * 
 * @export
 * @interface ChangeEvent
 */
export interface ChangeEvent {
    /**
     * 
     * @type {string}
     * @memberof ChangeEvent
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEvent
     */
    affectedTransportOrderId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeEvent
     */
    affectedTransportOrderIds?: Array<string>;
    /**
     * 
     * @type {CompanyEvent}
     * @memberof ChangeEvent
     */
    companyEvent?: CompanyEvent;
    /**
     * 
     * @type {string}
     * @memberof ChangeEvent
     */
    companyId?: string;
    /**
     * 
     * @type {EtaChangeEvent}
     * @memberof ChangeEvent
     */
    etaEvent?: EtaChangeEvent;
    /**
     * 
     * @type {string}
     * @memberof ChangeEvent
     */
    eventSourceCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEvent
     */
    eventSourceRequestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEvent
     */
    eventType?: ChangeEvent.EventTypeEnum;
    /**
     * 
     * @type {MessageLogEvent}
     * @memberof ChangeEvent
     */
    messageLogEvent?: MessageLogEvent;
    /**
     * 
     * @type {PositionEvent}
     * @memberof ChangeEvent
     */
    positionEvent?: PositionEvent;
    /**
     * 
     * @type {SystemStatusMessage}
     * @memberof ChangeEvent
     */
    systemNotificationEvent?: SystemStatusMessage;
    /**
     * 
     * @type {Date}
     * @memberof ChangeEvent
     */
    timestamp?: Date;
    /**
     * 
     * @type {TransportOrderChangeEvent}
     * @memberof ChangeEvent
     */
    transportOrderEvent?: TransportOrderChangeEvent;
    /**
     * 
     * @type {Date}
     * @memberof ChangeEvent
     */
    creationTimestamp?: Date;
}

/**
 * @export
 * @namespace ChangeEvent
 */
export namespace ChangeEvent {
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
}

/**
 * 
 * @export
 * @interface ChangeEventsFilterRequest
 */
export interface ChangeEventsFilterRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeEventsFilterRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEventsFilterRequest
     */
    eventSourceCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEventsFilterRequest
     */
    eventSourceRequestId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeEventsFilterRequest
     */
    eventType?: Array<ChangeEventsFilterRequest.EventTypeEnum>;
    /**
     * 
     * @type {Date}
     * @memberof ChangeEventsFilterRequest
     */
    from?: Date;
    /**
     * 
     * @type {number}
     * @memberof ChangeEventsFilterRequest
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeEventsFilterRequest
     */
    page?: number;
    /**
     * 
     * @type {Date}
     * @memberof ChangeEventsFilterRequest
     */
    to?: Date;
    /**
     * 
     * @type {string}
     * @memberof ChangeEventsFilterRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace ChangeEventsFilterRequest
 */
export namespace ChangeEventsFilterRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
}

/**
 * 
 * @export
 * @interface ChangeEventsResult
 */
export interface ChangeEventsResult {
    /**
     * 
     * @type {Array<ChangeEvent>}
     * @memberof ChangeEventsResult
     */
    changeEvents?: Array<ChangeEvent>;
}

/**
 * 
 * @export
 * @interface ChargeInformation
 */
export interface ChargeInformation {
    /**
     * 
     * @type {string}
     * @memberof ChargeInformation
     */
    currency?: ChargeInformation.CurrencyEnum;
    /**
     * 
     * @type {Array<ChargedFee>}
     * @memberof ChargeInformation
     */
    feesAndTaxes?: Array<ChargedFee>;
    /**
     * 
     * @type {number}
     * @memberof ChargeInformation
     */
    totalAmount?: number;
}

/**
 * @export
 * @namespace ChargeInformation
 */
export namespace ChargeInformation {
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        EUR = 'EUR',
        PLZ = 'PLZ',
        HUF = 'HUF',
        CZK = 'CZK',
        DKK = 'DKK',
        CHF = 'CHF',
        SEK = 'SEK',
        NOK = 'NOK',
        GBP = 'GBP',
        UAH = 'UAH'
    }
}

/**
 * 
 * @export
 * @interface ChargedFee
 */
export interface ChargedFee {
    /**
     * 
     * @type {string}
     * @memberof ChargedFee
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargedFee
     */
    kind?: ChargedFee.KindEnum;
    /**
     * 
     * @type {number}
     * @memberof ChargedFee
     */
    pricePerUnit?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargedFee
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargedFee
     */
    totalPrice?: number;
}

/**
 * @export
 * @namespace ChargedFee
 */
export namespace ChargedFee {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        FuelDiscount = 'FuelDiscount',
        FuelPremium = 'FuelPremium',
        LoadingSupport = 'LoadingSupport',
        UnloadingSupport = 'UnloadingSupport',
        StallFee = 'StallFee'
    }
}

/**
 * 
 * @export
 * @interface CheckAndUpdateDisableUntilStatusRequest
 */
export interface CheckAndUpdateDisableUntilStatusRequest {
    /**
     * 
     * @type {Array<CompanyReportData>}
     * @memberof CheckAndUpdateDisableUntilStatusRequest
     */
    companyReports?: Array<CompanyReportData>;
}

/**
 * 
 * @export
 * @interface ChecklistGenerationData
 */
export interface ChecklistGenerationData {
    /**
     * 
     * @type {Date}
     * @memberof ChecklistGenerationData
     */
    checklistAppliedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChecklistGenerationData
     */
    checklistGeneratedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ChecklistGenerationData
     */
    databaseEntryId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistGenerationData
     */
    finalRequirement?: string;
    /**
     * 
     * @type {Array<ChecklistTask>}
     * @memberof ChecklistGenerationData
     */
    generatedChecklist?: Array<ChecklistTask>;
    /**
     * 
     * @type {string}
     * @memberof ChecklistGenerationData
     */
    originalRequirement?: string;
    /**
     * 
     * @type {Array<ChecklistTask>}
     * @memberof ChecklistGenerationData
     */
    selectedChecklist?: Array<ChecklistTask>;
    /**
     * 
     * @type {Array<ChecklistTaskModification>}
     * @memberof ChecklistGenerationData
     */
    taskModifications?: Array<ChecklistTaskModification>;
}

/**
 * 
 * @export
 * @interface ChecklistTask
 */
export interface ChecklistTask {
    /**
     * 
     * @type {string}
     * @memberof ChecklistTask
     */
    llmTaskDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTask
     */
    originalRequest?: string;
}

/**
 * 
 * @export
 * @interface ChecklistTaskModification
 */
export interface ChecklistTaskModification {
    /**
     * 
     * @type {string}
     * @memberof ChecklistTaskModification
     */
    llmTaskDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistTaskModification
     */
    userModifiedTaskDescription?: string;
}

/**
 * 
 * @export
 * @interface CisTelematikConverterConfiguration
 */
export interface CisTelematikConverterConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof CisTelematikConverterConfiguration
     */
    autoExportBeginAction?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CisTelematikConverterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof CisTelematikConverterConfiguration
     */
    modifyMode?: CisTelematikConverterConfiguration.ModifyModeEnum;
    /**
     * 
     * @type {string}
     * @memberof CisTelematikConverterConfiguration
     */
    postImportScript?: string;
}

/**
 * @export
 * @namespace CisTelematikConverterConfiguration
 */
export namespace CisTelematikConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface ClientMailCredentials
 */
export interface ClientMailCredentials {
    /**
     * 
     * @type {boolean}
     * @memberof ClientMailCredentials
     */
    enable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientMailCredentials
     */
    fromAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientMailCredentials
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientMailCredentials
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientMailCredentials
     */
    serverAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientMailCredentials
     */
    userName?: string;
}

/**
 * 
 * @export
 * @interface ClientMetadata
 */
export interface ClientMetadata {
    /**
     * 
     * @type {MongoDriver}
     * @memberof ClientMetadata
     */
    driver?: MongoDriver;
    /**
     * 
     * @type {Os}
     * @memberof ClientMetadata
     */
    os?: Os;
    /**
     * 
     * @type {string}
     * @memberof ClientMetadata
     */
    platform?: string;
}

/**
 * 
 * @export
 * @interface CmNavTreeTextModalListRequest
 */
export interface CmNavTreeTextModalListRequest {
    /**
     * 
     * @type {string}
     * @memberof CmNavTreeTextModalListRequest
     */
    newPath?: string;
}

/**
 * 
 * @export
 * @interface Collection
 */
export interface Collection {
    /**
     * 
     * @type {number}
     * @memberof Collection
     */
    size?: number;
}

/**
 * 
 * @export
 * @interface CompaniesToInvoiceResponse
 */
export interface CompaniesToInvoiceResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CompaniesToInvoiceResponse
     */
    companyIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CompaniesToInvoiceResponse
     */
    count?: number;
}

/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    _id?: string;
    /**
     * 
     * @type {Address}
     * @memberof Company
     */
    address?: Address;
    /**
     * 
     * @type {Array<ContactInfo>}
     * @memberof Company
     */
    contacts?: Array<ContactInfo>;
    /**
     * 
     * @type {CompanyCustomerReportConfig}
     * @memberof Company
     */
    customerReportSettings?: CompanyCustomerReportConfig;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    isShipmentCreateFormCompany?: boolean;
    /**
     * Indicates the current lifecycle status of the company (PRODUCTION, SETUP, or TESTING). This is different from companyTags which are used for transport order mapping.
     * @type {string}
     * @memberof Company
     */
    lifecycleStatus?: Company.LifecycleStatusEnum;
    /**
     * Description of the planned company project layout. Required when lifecycleStatus is SETUP. Example: 'Company is importing PDF and sending to TOM'.
     * @type {string}
     * @memberof Company
     */
    lifecycleStatusDescription?: string;
    /**
     * Due date for automatic transition from SETUP to PRODUCTION status. Only relevant when lifecycleStatus is SETUP.
     * @type {Date}
     * @memberof Company
     */
    lifecycleStatusProductionDueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    tag?: string;
}

/**
 * @export
 * @namespace Company
 */
export namespace Company {
    /**
     * @export
     * @enum {string}
     */
    export enum LifecycleStatusEnum {
        PRODUCTION = 'PRODUCTION',
        SETUP = 'SETUP',
        TESTING = 'TESTING'
    }
}

/**
 * 
 * @export
 * @interface CompanyAddressBookRequestResponse
 */
export interface CompanyAddressBookRequestResponse {
    /**
     * 
     * @type {AddressBook}
     * @memberof CompanyAddressBookRequestResponse
     */
    addressBook?: AddressBook;
    /**
     * 
     * @type {Array<Driver>}
     * @memberof CompanyAddressBookRequestResponse
     */
    drivers?: Array<Driver>;
}

/**
 * 
 * @export
 * @interface CompanyAddressMapping
 */
export interface CompanyAddressMapping {
    /**
     * Identifier of this address entry
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    _id?: string;
    /**
     * List of observers that should be added to the transport order when the company address mapping is resolved.
     * @type {Array<Observer>}
     * @memberof CompanyAddressMapping
     */
    addObservers?: Array<Observer>;
    /**
     * Specifies wether this company address mapping shall be applied for the source company or the target company. Default: TARGET_COMPANY
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    applyFor?: CompanyAddressMapping.ApplyForEnum;
    /**
     * City name
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    city?: string;
    /**
     * Company where this address entry belongs to
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    companyId?: string;
    /**
     * Country code where this address belongs to
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    countryCode?: string;
    /**
     * External Address number of the external system
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    externalAddressNumber?: string;
    /**
     * External Address number 2 of the external system
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    externalAddressNumber2?: string;
    /**
     * CompanyAddressMappingGroup where this address entry belongs to. If this value is null, the mapping entry does not belong to any group
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    groupId?: string;
    /**
     * Group name of the corresponding group or null. This value is set by the backend
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    groupName?: string;
    /**
     * CompanyAddressMappingGroup where this address entry belongs to. If this value is null, the mapping entry does not belong to any group
     * @type {Array<AssignedGroup>}
     * @memberof CompanyAddressMapping
     */
    groups?: Array<AssignedGroup>;
    /**
     * If available this field contains the global location number assigned by the GS1 association
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    gs1GlobalLocationNumber?: string;
    /**
     * House number
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    houseNr?: string;
    /**
     * True if the customer address mapping was imported
     * @type {boolean}
     * @memberof CompanyAddressMapping
     */
    imported?: boolean;
    /**
     * If this entry is a duplicate, it won't be used to resolve an address
     * @type {boolean}
     * @memberof CompanyAddressMapping
     */
    isDuplicate?: boolean;
    /**
     * Kind of address. May be used to differentiate between contractor, freight payer, loading location etc.
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    kind?: CompanyAddressMapping.KindEnum;
    /**
     * Mulipolygon geofence for this location
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    multiPolygonGeofence?: string;
    /**
     * Name of the company/receiver/etc
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    name1?: string;
    /**
     * Second name
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    name2?: string;
    /**
     * Groovy script which is executed when this mapping matches to a particular stop location
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    onResolveScript?: string;
    /**
     * 
     * @type {ReplacementAddress}
     * @memberof CompanyAddressMapping
     */
    replaceWith?: ReplacementAddress;
    /**
     * Specifies to which Additonal Data entries the address should be resolved
     * @type {Array<AdditionalDataEntry>}
     * @memberof CompanyAddressMapping
     */
    resolveTo?: Array<AdditionalDataEntry>;
    /**
     * Opening Hours of this address
     * @type {Array<OpeningHour>}
     * @memberof CompanyAddressMapping
     */
    setOpeningHours?: Array<OpeningHour>;
    /**
     * Street name
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    street?: string;
    /**
     * Zip Code of the address location
     * @type {string}
     * @memberof CompanyAddressMapping
     */
    zipCode?: string;
}

/**
 * @export
 * @namespace CompanyAddressMapping
 */
export namespace CompanyAddressMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum ApplyForEnum {
        SOURCECOMPANY = 'SOURCE_COMPANY',
        TARGETCOMPANY = 'TARGET_COMPANY',
        BOTH = 'BOTH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        Any = 'Any',
        StopLocation = 'StopLocation',
        FreightPayer = 'FreightPayer',
        Shipper = 'Shipper',
        Carrier = 'Carrier',
        LoadingLocation = 'LoadingLocation',
        UnloadingLocation = 'UnloadingLocation'
    }
}

/**
 * 
 * @export
 * @interface CompanyAddressMappingConfiguration
 */
export interface CompanyAddressMappingConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAddressMappingConfiguration
     */
    allowResolveWithoutAddress?: boolean;
    /**
     * 
     * @type {IncompleteAddressHandling}
     * @memberof CompanyAddressMappingConfiguration
     */
    incompleteAddresses?: IncompleteAddressHandling;
    /**
     * 
     * @type {string}
     * @memberof CompanyAddressMappingConfiguration
     */
    matchOn?: CompanyAddressMappingConfiguration.MatchOnEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAddressMappingConfiguration
     */
    optionallyRequestMappingFor?: Array<CompanyAddressMappingConfiguration.OptionallyRequestMappingForEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAddressMappingConfiguration
     */
    requireCompanyAddressMappingForFreightPayer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAddressMappingConfiguration
     */
    requireCompanyAddressMappingForShipper?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyAddressMappingConfiguration
     */
    requiredUserInput?: CompanyAddressMappingConfiguration.RequiredUserInputEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAddressMappingConfiguration
     */
    shouldHaltIfCompanyAddressMappingIsIncomplete?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAddressMappingConfiguration
     */
    shouldHaltModeActiveForCompanyIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAddressMappingConfiguration
     */
    shouldHaltModeActiveForCountryCodes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAddressMappingConfiguration
     */
    shouldHaltModeActiveForLoadingLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAddressMappingConfiguration
     */
    shouldHaltModeActiveForUnloadingLocations?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAddressMappingConfiguration
     */
    shouldHaltModeDisabledForCompanyIds?: Array<string>;
    /**
     * 
     * @type {Array<CompanyAddressMappingOverride>}
     * @memberof CompanyAddressMappingConfiguration
     */
    specificConfig?: Array<CompanyAddressMappingOverride>;
}

/**
 * @export
 * @namespace CompanyAddressMappingConfiguration
 */
export namespace CompanyAddressMappingConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum MatchOnEnum {
        ADDRESS = 'MATCH_ADDRESS',
        STOPID = 'MATCH_STOP_ID',
        EXTERNALSTOPID = 'MATCH_EXTERNAL_STOP_ID'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OptionallyRequestMappingForEnum {
        FREIGHTPAYER = 'FREIGHT_PAYER',
        SHIPPER = 'SHIPPER',
        LOADINGLOCATION = 'LOADING_LOCATION',
        UNLOADINGLOCATION = 'UNLOADING_LOCATION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RequiredUserInputEnum {
        INPUTEXTERNALCUSTOMERNUMBER = 'INPUT_EXTERNAL_CUSTOMER_NUMBER',
        CHECKADDRESS = 'CHECK_ADDRESS',
        INPUTEXTERNALCUSTOMERNUMBERANDCHECKADDRESS = 'INPUT_EXTERNAL_CUSTOMER_NUMBER_AND_CHECK_ADDRESS',
        PROVIDEGEOCOORDINATES = 'PROVIDE_GEO_COORDINATES',
        PROVIDEFREIGHTMAPPING = 'PROVIDE_FREIGHT_MAPPING',
        PROVIDESHIPMENTMAPPING = 'PROVIDE_SHIPMENT_MAPPING',
        CONFIRM = 'CONFIRM',
        NOTIFY = 'NOTIFY',
        PROVIDESTATUSMESSAGES = 'PROVIDE_STATUS_MESSAGES'
    }
}

/**
 * 
 * @export
 * @interface CompanyAddressMappingGroup
 */
export interface CompanyAddressMappingGroup {
    /**
     * Identifier of this company address mapping group
     * @type {string}
     * @memberof CompanyAddressMappingGroup
     */
    _id?: string;
    /**
     * Company to which this Address Mapping Group belongs to
     * @type {string}
     * @memberof CompanyAddressMappingGroup
     */
    companyId?: string;
    /**
     * Name of this Company Address Mapping Group
     * @type {string}
     * @memberof CompanyAddressMappingGroup
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface CompanyAddressMappingOverride
 */
export interface CompanyAddressMappingOverride {
    /**
     * 
     * @type {Array<ImmediateFormatPathMatchRule>}
     * @memberof CompanyAddressMappingOverride
     */
    applyWhenAllRulesMatch?: Array<ImmediateFormatPathMatchRule>;
    /**
     * 
     * @type {CompanyAddressMappingConfiguration}
     * @memberof CompanyAddressMappingOverride
     */
    override?: CompanyAddressMappingConfiguration;
    /**
     * 
     * @type {string}
     * @memberof CompanyAddressMappingOverride
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface CompanyAddressMappingWithPathSelector
 */
export interface CompanyAddressMappingWithPathSelector {
    /**
     * 
     * @type {CompanyAddressMapping}
     * @memberof CompanyAddressMappingWithPathSelector
     */
    companyAddressMapping?: CompanyAddressMapping;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof CompanyAddressMappingWithPathSelector
     */
    transportOrderPathSelector?: TransportOrderPathSelector;
}

/**
 * 
 * @export
 * @interface CompanyConfigChanges
 */
export interface CompanyConfigChanges {
    /**
     * 
     * @type {Array<ConfigChangeEntry>}
     * @memberof CompanyConfigChanges
     */
    changes?: Array<ConfigChangeEntry>;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigChanges
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigChanges
     */
    companyName?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyConfigChanges
     */
    totalChanges?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyConfigChanges
     */
    totalConfigChanges?: number;
}

/**
 * 
 * @export
 * @interface CompanyConfigHistory
 */
export interface CompanyConfigHistory {
    /**
     * 
     * @type {number}
     * @memberof CompanyConfigHistory
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyHistory>}
     * @memberof CompanyConfigHistory
     */
    results?: Array<CompanyHistory>;
}

/**
 * 
 * @export
 * @interface CompanyConfiguration
 */
export interface CompanyConfiguration {
    /**
     * 
     * @type {string}
     * @memberof CompanyConfiguration
     */
    activeConverter?: CompanyConfiguration.ActiveConverterEnum;
    /**
     * 
     * @type {Array<ActiveConverterOverride>}
     * @memberof CompanyConfiguration
     */
    activeConverterOverride?: Array<ActiveConverterOverride>;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfiguration
     */
    activeConverterSelectionStrategy?: CompanyConfiguration.ActiveConverterSelectionStrategyEnum;
    /**
     * 
     * @type {Array<ApiGatewayConfig>}
     * @memberof CompanyConfiguration
     */
    apiGatewayConfigs?: Array<ApiGatewayConfig>;
    /**
     * 
     * @type {AttachmentProcessorConfiguration}
     * @memberof CompanyConfiguration
     */
    attachmentProcessor?: AttachmentProcessorConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    autoAcceptTransportOrdersOnAssignDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    autoArriveAtLoadingLocationOnAssignOrderBox?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    autoArriveAtLoadingLocationOnAssignVehicle?: boolean;
    /**
     * 
     * @type {AutoDetectTruckTrailerMismatchConfig}
     * @memberof CompanyConfiguration
     */
    autoDetectTruckTrailerMismatchConfig?: AutoDetectTruckTrailerMismatchConfig;
    /**
     * 
     * @type {BnsTelematikConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    bnsConverterConfiguration?: BnsTelematikConverterConfiguration;
    /**
     * 
     * @type {CisTelematikConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    cisTelematikConverter?: CisTelematikConverterConfiguration;
    /**
     * 
     * @type {CompanyAddressMappingConfiguration}
     * @memberof CompanyConfiguration
     */
    companyAddressMappingConfiguration?: CompanyAddressMappingConfiguration;
    /**
     * 
     * @type {CompanyLevelMonitoringConfiguration}
     * @memberof CompanyConfiguration
     */
    companyLevelMonitoringConfiguration?: CompanyLevelMonitoringConfiguration;
    /**
     * 
     * @type {CompanySpecificViewConfiguration}
     * @memberof CompanyConfiguration
     */
    companySpecificView?: CompanySpecificViewConfiguration;
    /**
     * 
     * @type {ContactingInfo}
     * @memberof CompanyConfiguration
     */
    contactingInfo?: ContactingInfo;
    /**
     * 
     * @type {ConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    converterConfiguration?: ConverterConfiguration;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfiguration
     */
    converterVersion?: string;
    /**
     * 
     * @type {Array<CreatePdfOnEventConfiguration>}
     * @memberof CompanyConfiguration
     */
    createPdfOnEvent?: Array<CreatePdfOnEventConfiguration>;
    /**
     * 
     * @type {CustomWorkflowDefinition}
     * @memberof CompanyConfiguration
     */
    customWorkflowDefinitions?: CustomWorkflowDefinition;
    /**
     * 
     * @type {DescartesImporterConfiguration}
     * @memberof CompanyConfiguration
     */
    descartesImporterConfiguration?: DescartesImporterConfiguration;
    /**
     * 
     * @type {DhlImporterConfiguration}
     * @memberof CompanyConfiguration
     */
    dhlImporterConfiguration?: DhlImporterConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    disableOldHistory?: boolean;
    /**
     * 
     * @type {EdiConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    ediConverterConfiguration?: EdiConverterConfiguration;
    /**
     * 
     * @type {EdiConverterV2Configuration}
     * @memberof CompanyConfiguration
     */
    ediConverterV2Configuration?: EdiConverterV2Configuration;
    /**
     * 
     * @type {ElemicaConfiguration}
     * @memberof CompanyConfiguration
     */
    elemicaConfiguration?: ElemicaConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    enableRawRequestLogging?: boolean;
    /**
     * 
     * @type {Array<EtaConfig>}
     * @memberof CompanyConfiguration
     */
    etaConfigs?: Array<EtaConfig>;
    /**
     * 
     * @type {ExcludedFromUnbilledOrdersCalculationInfo}
     * @memberof CompanyConfiguration
     */
    excludedFromUnbilledOrdersCalculation?: ExcludedFromUnbilledOrdersCalculationInfo;
    /**
     * 
     * @type {FileGatewayConfiguration}
     * @memberof CompanyConfiguration
     */
    fileGatewayConfig?: FileGatewayConfiguration;
    /**
     * 
     * @type {FileSystemWorkerConfiguration}
     * @memberof CompanyConfiguration
     */
    fileSystemWorkerConfiguration?: FileSystemWorkerConfiguration;
    /**
     * 
     * @type {FixerTaskConfiguration}
     * @memberof CompanyConfiguration
     */
    fixerTaskConfiguration?: FixerTaskConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    forceAllowMultipleMatchingIndexOperators?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    forceOverrideDependedStatesOnModifyTransportOrder?: boolean;
    /**
     * 
     * @type {FortrasConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    fortrasConverterConfiguration?: FortrasConverterConfiguration;
    /**
     * 
     * @type {GehrConfiguration}
     * @memberof CompanyConfiguration
     */
    gehrConfiguration?: GehrConfiguration;
    /**
     * 
     * @type {GenericAiConfiguration}
     * @memberof CompanyConfiguration
     */
    genericAiConfig?: GenericAiConfiguration;
    /**
     * 
     * @type {GenericImporterConfiguration}
     * @memberof CompanyConfiguration
     */
    genericImporterConfiguration?: GenericImporterConfiguration;
    /**
     * 
     * @type {GenericXlsConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    genericXlsConfiguration?: GenericXlsConverterConfiguration;
    /**
     * 
     * @type {GenericZipConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    genericZipConverterConfiguration?: GenericZipConverterConfiguration;
    /**
     * Use this field to place Comments regarding the current company.
     * @type {string}
     * @memberof CompanyConfiguration
     */
    internalNotes?: string;
    /**
     * 
     * @type {LanguageConfiguration}
     * @memberof CompanyConfiguration
     */
    languageConfiguration?: LanguageConfiguration;
    /**
     * 
     * @type {LisConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    lisConverterConfiguration?: LisConverterConfiguration;
    /**
     * 
     * @type {MetaModelConfiguration}
     * @memberof CompanyConfiguration
     */
    metaModelConfiguration?: MetaModelConfiguration;
    /**
     * 
     * @type {Array<MonitorConfig>}
     * @memberof CompanyConfiguration
     */
    monitorConfigs?: Array<MonitorConfig>;
    /**
     * 
     * @type {NotificationConfiguration}
     * @memberof CompanyConfiguration
     */
    notificationConfiguration?: NotificationConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    overrideCoordinatesFromCompany?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfiguration
     */
    preCreateTransportOrderScript?: string;
    /**
     * 
     * @type {PrivacyConfiguration}
     * @memberof CompanyConfiguration
     */
    privacyConfiguration?: PrivacyConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    resetTransportOrderOnUpdateAfterStorno?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfiguration
     */
    responsibleLogeniosManager?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    runFixerTaskAfterVehicleOrTrailerReassign?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    runFixerTaskIfVehicleIsAtLoadingLocationAtCreation?: boolean;
    /**
     * 
     * @type {SapConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    sapConverterConfiguration?: SapConverterConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    saveRawRequests?: boolean;
    /**
     * 
     * @type {ScriptRunnerConfiguration}
     * @memberof CompanyConfiguration
     */
    scriptRunner?: ScriptRunnerConfiguration;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfiguration
     */
    sendTransportOrderToDriverVia?: CompanyConfiguration.SendTransportOrderToDriverViaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    setNextTourToExecutingWhenCurrentTourIsDone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    shouldCreateNewDriverIfAssignedDriverIsUnknown?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    shouldCreateNewVehicleIfAssignedVehicleIsUnknown?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    shouldMirrorEvents?: boolean;
    /**
     * 
     * @type {SimpleCsvConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    simpleCsvConverterConfiguration?: SimpleCsvConverterConfiguration;
    /**
     * 
     * @type {SoloplanConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    soloplanConverterConfiguration?: SoloplanConverterConfiguration;
    /**
     * 
     * @type {SpedionIntegration}
     * @memberof CompanyConfiguration
     */
    spedionIntegration?: SpedionIntegration;
    /**
     * 
     * @type {StatusByVehiclePositionsConfiguration}
     * @memberof CompanyConfiguration
     */
    statusByVehiclePositionsConfig?: StatusByVehiclePositionsConfiguration;
    /**
     * 
     * @type {StopMergeAndOrderConfiguration}
     * @memberof CompanyConfiguration
     */
    stopMergeAndOrderConfiguration?: StopMergeAndOrderConfiguration;
    /**
     * 
     * @type {TaskConfigurations}
     * @memberof CompanyConfiguration
     */
    taskConfigurations?: TaskConfigurations;
    /**
     * 
     * @type {TrackingConfiguration}
     * @memberof CompanyConfiguration
     */
    telematicConfiguration?: TrackingConfiguration;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfiguration
     */
    telematicTourMappingScript?: string;
    /**
     * 
     * @type {TransdataConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    transdataConverter?: TransdataConverterConfiguration;
    /**
     * 
     * @type {TranslogicaConverterConfiguration}
     * @memberof CompanyConfiguration
     */
    translogicaConverter?: TranslogicaConverterConfiguration;
    /**
     * 
     * @type {TransporeonImporterConfiguration}
     * @memberof CompanyConfiguration
     */
    transporeonImporterConfiguration?: TransporeonImporterConfiguration;
    /**
     * 
     * @type {TransportOrderLinkConfiguration}
     * @memberof CompanyConfiguration
     */
    transportOrderLinkConfiguration?: TransportOrderLinkConfiguration;
    /**
     * 
     * @type {TransportOrderRewriteConfiguration}
     * @memberof CompanyConfiguration
     */
    transportOrderRewriteConfiguration?: TransportOrderRewriteConfiguration;
    /**
     * 
     * @type {TransportOrderScripts}
     * @memberof CompanyConfiguration
     */
    transportOrderScripts?: TransportOrderScripts;
    /**
     * 
     * @type {ValidationConfiguration}
     * @memberof CompanyConfiguration
     */
    transportOrderValidationRules?: ValidationConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    transportOrdersAlwaysChangeable?: boolean;
    /**
     * 
     * @type {CompanyUiViewConfiguration}
     * @memberof CompanyConfiguration
     */
    uiUiViewConfiguration?: CompanyUiViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfiguration
     */
    useSpedionSingleTourApp?: boolean;
    /**
     * 
     * @type {VehicleSyncConfiguration}
     * @memberof CompanyConfiguration
     */
    vehicleSyncConfiguration?: VehicleSyncConfiguration;
}

/**
 * @export
 * @namespace CompanyConfiguration
 */
export namespace CompanyConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ActiveConverterEnum {
        SOLOPLAN = 'SOLOPLAN',
        LISINLISOUT = 'LIS_IN_LIS_OUT',
        ELEMICA = 'ELEMICA',
        SAP = 'SAP',
        EDI = 'EDI',
        SIMPLECSV = 'SIMPLE_CSV',
        GENERICXLS = 'GENERIC_XLS',
        FORTRAS = 'FORTRAS',
        DHLIMPORTER = 'DHL_IMPORTER',
        DESCARTESIMPORTER = 'DESCARTES_IMPORTER',
        METAMODEL = 'META_MODEL',
        GEHR = 'GEHR',
        GENERICGROOVY = 'GENERIC_GROOVY',
        BNSTELEMATIK = 'BNS_TELEMATIK',
        TRANSPOREONXML = 'TRANSPOREON_XML',
        NOOP = 'NO_OP',
        TRANSLOGICA = 'TRANSLOGICA',
        TRANSDATA = 'TRANSDATA',
        CISTELEMATIK = 'CIS_TELEMATIK',
        FRMEYERUNDSOHN = 'FR_MEYER_UND_SOHN',
        ATTACHMENTPROCESSOR = 'ATTACHMENT_PROCESSOR',
        PDFGENERATOR = 'PDF_GENERATOR',
        SHIPPEO = 'SHIPPEO',
        CONIZI = 'CONIZI',
        GENERICZIP = 'GENERIC_ZIP',
        EDIV2 = 'EDI_v2',
        GENERICAI = 'GENERIC_AI'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ActiveConverterSelectionStrategyEnum {
        OVERRIDEDEFAULTCONVERTER = 'OVERRIDE_DEFAULT_CONVERTER',
        RUNALLCONVERTERS = 'RUN_ALL_CONVERTERS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SendTransportOrderToDriverViaEnum {
        TELEMATIC = 'TELEMATIC',
        SINGLETOURAPP = 'SINGLE_TOUR_APP',
        WEBAPP = 'WEB_APP'
    }
}

/**
 * 
 * @export
 * @interface CompanyConfigurationChange
 */
export interface CompanyConfigurationChange {
    /**
     * 
     * @type {ObjectId}
     * @memberof CompanyConfigurationChange
     */
    _id?: ObjectId;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    historyId?: string;
    /**
     * 
     * @type {Any}
     * @memberof CompanyConfigurationChange
     */
    oldValue?: Any;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    operation?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    path?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyConfigurationChange
     */
    ticketNrs?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof CompanyConfigurationChange
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationChange
     */
    userName?: string;
    /**
     * 
     * @type {Any}
     * @memberof CompanyConfigurationChange
     */
    value?: Any;
}

/**
 * 
 * @export
 * @interface CompanyConfigurationChanges
 */
export interface CompanyConfigurationChanges {
    /**
     * 
     * @type {Array<CompanyConfigurationChange>}
     * @memberof CompanyConfigurationChanges
     */
    changes?: Array<CompanyConfigurationChange>;
}

/**
 * 
 * @export
 * @interface CompanyConfigurationDraft
 */
export interface CompanyConfigurationDraft {
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationDraft
     */
    _id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfigurationDraft
     */
    autoSaved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationDraft
     */
    companyId?: string;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof CompanyConfigurationDraft
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {Date}
     * @memberof CompanyConfigurationDraft
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationDraft
     */
    name?: string;
    /**
     * 
     * @type {Array<PatchEntry>}
     * @memberof CompanyConfigurationDraft
     */
    patchSet?: Array<PatchEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyConfigurationDraft
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyConfigurationDraft
     */
    userId?: string;
}

/**
 * 
 * @export
 * @interface CompanyConfigurationListResult
 */
export interface CompanyConfigurationListResult {
    /**
     * 
     * @type {Array<CompanyWithConfig>}
     * @memberof CompanyConfigurationListResult
     */
    companiesWithConfig?: Array<CompanyWithConfig>;
}

/**
 * 
 * @export
 * @interface CompanyCreateRequest
 */
export interface CompanyCreateRequest {
    /**
     * 
     * @type {Address}
     * @memberof CompanyCreateRequest
     */
    address?: Address;
    /**
     * 
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface CompanyCustomerReportConfig
 */
export interface CompanyCustomerReportConfig {
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    apiGatewayReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    attachmentFileHealthReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    customerFileHealthReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    errorFilesReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    etaCalculatorReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    logeniosFileHealthReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    messageLogReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    needsVerificationReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    queueReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    schedulerReportTaskStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    sftpReportReportStatus?: IndividualReportSetting;
    /**
     * 
     * @type {IndividualReportSetting}
     * @memberof CompanyCustomerReportConfig
     */
    statusJsonReportStatus?: IndividualReportSetting;
}

/**
 * 
 * @export
 * @interface CompanyEvent
 */
export interface CompanyEvent {
    /**
     * 
     * @type {Driver}
     * @memberof CompanyEvent
     */
    driver?: Driver;
    /**
     * 
     * @type {string}
     * @memberof CompanyEvent
     */
    type?: CompanyEvent.TypeEnum;
    /**
     * 
     * @type {User}
     * @memberof CompanyEvent
     */
    user?: User;
    /**
     * 
     * @type {Vehicle}
     * @memberof CompanyEvent
     */
    vehicle?: Vehicle;
}

/**
 * @export
 * @namespace CompanyEvent
 */
export namespace CompanyEvent {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        VEHICLECREATE = 'VEHICLE_CREATE',
        VEHICLEMODIFY = 'VEHICLE_MODIFY',
        VEHICLEDELETE = 'VEHICLE_DELETE',
        DRIVERCREATE = 'DRIVER_CREATE',
        DRIVERMODIFY = 'DRIVER_MODIFY',
        DRIVERDELETE = 'DRIVER_DELETE',
        USERCREATE = 'USER_CREATE',
        USERMODIFY = 'USER_MODIFY',
        USERDELETE = 'USER_DELETE'
    }
}

/**
 * 
 * @export
 * @interface CompanyFreightMapping
 */
export interface CompanyFreightMapping {
    /**
     * Id of the freight mapping rule
     * @type {string}
     * @memberof CompanyFreightMapping
     */
    _id?: string;
    /**
     * Specifies to which additional Data entries the address should be resolved
     * @type {Array<AdditionalDataEntry>}
     * @memberof CompanyFreightMapping
     */
    annotateWith?: Array<AdditionalDataEntry>;
    /**
     * Company to which this freightMapping belongs to
     * @type {string}
     * @memberof CompanyFreightMapping
     */
    companyId?: string;
    /**
     * The Freight Mapping group to which this mapping rule belongs to
     * @type {string}
     * @memberof CompanyFreightMapping
     */
    freightMappingGroup?: string;
    /**
     * The name of the freight mapping group which this group belongs to
     * @type {string}
     * @memberof CompanyFreightMapping
     */
    freightMappingGroupName?: string;
    /**
     * 
     * @type {FreightMappingFieldValues}
     * @memberof CompanyFreightMapping
     */
    matchOn?: FreightMappingFieldValues;
    /**
     * 
     * @type {FreightMappingFieldValues}
     * @memberof CompanyFreightMapping
     */
    replaceWith?: FreightMappingFieldValues;
}

/**
 * 
 * @export
 * @interface CompanyFreightMappingGroup
 */
export interface CompanyFreightMappingGroup {
    /**
     * Id of the freight mapping group
     * @type {string}
     * @memberof CompanyFreightMappingGroup
     */
    _id?: string;
    /**
     * Specifies a set of keys which must be provided by a freight mapping entry. This field is merely a hint for the web ui.
     * @type {Array<string>}
     * @memberof CompanyFreightMappingGroup
     */
    annotateWithKeys?: Array<string>;
    /**
     * Id of the company to which this group belongs
     * @type {string}
     * @memberof CompanyFreightMappingGroup
     */
    companyId?: string;
    /**
     * Definition of the set of fields which should be compared with all freight mapping entries of this group in order to find a matching entry.
     * @type {Array<string>}
     * @memberof CompanyFreightMappingGroup
     */
    fieldsToCompare?: Array<CompanyFreightMappingGroup.FieldsToCompareEnum>;
    /**
     * Provides a set of fields which shall be replaced during the mapping procedure
     * @type {Array<string>}
     * @memberof CompanyFreightMappingGroup
     */
    fieldsToReplace?: Array<CompanyFreightMappingGroup.FieldsToReplaceEnum>;
    /**
     * Name of the freight mapping group
     * @type {string}
     * @memberof CompanyFreightMappingGroup
     */
    name?: string;
    /**
     * Groovy script which is executed when this mapping matches to a particular freight
     * @type {string}
     * @memberof CompanyFreightMappingGroup
     */
    onResolveScript?: string;
    /**
     * If specified this field limits the application to transport orders that are sent to / received from the given partner companies.
     * @type {Array<string>}
     * @memberof CompanyFreightMappingGroup
     */
    onlyForPartnerCompanies?: Array<string>;
    /**
     * Specifies if this mapping shall be applied even if this company is source company
     * @type {boolean}
     * @memberof CompanyFreightMappingGroup
     */
    shouldApplyIfCcmpanyIsSourceCompany?: boolean;
    /**
     * Specifies whether or not the freight mapping process should put a transport order to the state INPUT_MISSING if no matching freight mapping rule was found
     * @type {boolean}
     * @memberof CompanyFreightMappingGroup
     */
    shouldHaltIfFreightMappingIsIncomplete?: boolean;
}

/**
 * @export
 * @namespace CompanyFreightMappingGroup
 */
export namespace CompanyFreightMappingGroup {
    /**
     * @export
     * @enum {string}
     */
    export enum FieldsToCompareEnum {
        FreightId = 'FreightId',
        ExternalFreightId = 'ExternalFreightId',
        DeliveryNumber = 'DeliveryNumber',
        VerboseName = 'VerboseName',
        ContainmentName = 'ContainmentName',
        ContainmentNameExt = 'ContainmentNameExt',
        ContainmentType = 'ContainmentType',
        ContainmentQuantity = 'ContainmentQuantity',
        Height = 'Height',
        Length = 'Length',
        Width = 'Width',
        TotalLots = 'TotalLots',
        TotalQuantity = 'TotalQuantity',
        TotalVolume = 'TotalVolume',
        TotalWeight = 'TotalWeight',
        TotalLoadingMeter = 'TotalLoadingMeter'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FieldsToReplaceEnum {
        FreightId = 'FreightId',
        ExternalFreightId = 'ExternalFreightId',
        DeliveryNumber = 'DeliveryNumber',
        VerboseName = 'VerboseName',
        ContainmentName = 'ContainmentName',
        ContainmentNameExt = 'ContainmentNameExt',
        ContainmentType = 'ContainmentType',
        ContainmentQuantity = 'ContainmentQuantity',
        Height = 'Height',
        Length = 'Length',
        Width = 'Width',
        TotalLots = 'TotalLots',
        TotalQuantity = 'TotalQuantity',
        TotalVolume = 'TotalVolume',
        TotalWeight = 'TotalWeight',
        TotalLoadingMeter = 'TotalLoadingMeter'
    }
}

/**
 * 
 * @export
 * @interface CompanyHistory
 */
export interface CompanyHistory {
    /**
     * 
     * @type {string}
     * @memberof CompanyHistory
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyHistory
     */
    changeComment?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyHistory
     */
    changeMethod?: CompanyHistory.ChangeMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyHistory
     */
    changedBy?: string;
    /**
     * 
     * @type {Company}
     * @memberof CompanyHistory
     */
    company?: Company;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof CompanyHistory
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {Contract}
     * @memberof CompanyHistory
     */
    contract?: Contract;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyHistory
     */
    ticketNrs?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof CompanyHistory
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof CompanyHistory
     */
    workTimeInMinutes?: number;
}

/**
 * @export
 * @namespace CompanyHistory
 */
export namespace CompanyHistory {
    /**
     * @export
     * @enum {string}
     */
    export enum ChangeMethodEnum {
        CREATE = 'CREATE',
        MODIFY = 'MODIFY',
        DELETE = 'DELETE'
    }
}

/**
 * 
 * @export
 * @interface CompanyLevelMonitoringConfiguration
 */
export interface CompanyLevelMonitoringConfiguration {
    /**
     * 
     * @type {ApiGatewayMonitoringConfiguration}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    apiGatewayMonitoring?: ApiGatewayMonitoringConfiguration;
    /**
     * 
     * @type {ApiSyncQueueMonitoringConfiguration}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    apiSyncQueueMonitoring?: ApiSyncQueueMonitoringConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {ErrorFilesMonitoring}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    errorFilesMonitoring?: ErrorFilesMonitoring;
    /**
     * 
     * @type {InfrastructureQueueMonitoringConfiguration}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    infrastructureQueueMonitoring?: InfrastructureQueueMonitoringConfiguration;
    /**
     * 
     * @type {KundenNrMonitoring}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    kundenNrMonitoring?: KundenNrMonitoring;
    /**
     * 
     * @type {Logenios2CustomerMonitoring}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    logenios2CustomerMonitoring?: Logenios2CustomerMonitoring;
    /**
     * 
     * @type {QueuedEventsErrorMonitoring}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    queuedEventsErrorMonitoring?: QueuedEventsErrorMonitoring;
    /**
     * 
     * @type {SftpSyncMonitoring}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    sftpSyncMonitoring?: SftpSyncMonitoring;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    shouldSilenceScriptErrors?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    slackNotificationEnabledForCompany?: boolean;
    /**
     * 
     * @type {StatusJsonMonitoring}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    statusJsonMonitoring?: StatusJsonMonitoring;
    /**
     * 
     * @type {VehicleAssignmentMonitoringConfiguration}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    vehicleAssignmentMonitoring?: VehicleAssignmentMonitoringConfiguration;
    /**
     * 
     * @type {VehiclePositionsMonitoringConfiguration}
     * @memberof CompanyLevelMonitoringConfiguration
     */
    vehiclePositionsMonitoring?: VehiclePositionsMonitoringConfiguration;
}

/**
 * 
 * @export
 * @interface CompanyListResponse
 */
export interface CompanyListResponse {
    /**
     * 
     * @type {Array<Company>}
     * @memberof CompanyListResponse
     */
    results?: Array<Company>;
}

/**
 * 
 * @export
 * @interface CompanyMessageLogReport
 */
export interface CompanyMessageLogReport {
    /**
     * 
     * @type {string}
     * @memberof CompanyMessageLogReport
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyMessageLogReport
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyMessageLogReport
     */
    errorMessages?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyMessageLogReport
     */
    totalSendErrors?: number;
}

/**
 * 
 * @export
 * @interface CompanyMonitorConfigs
 */
export interface CompanyMonitorConfigs {
    /**
     * 
     * @type {Array<MonitorConfig>}
     * @memberof CompanyMonitorConfigs
     */
    monitorConfigs?: Array<MonitorConfig>;
}

/**
 * 
 * @export
 * @interface CompanyNameAndId
 */
export interface CompanyNameAndId {
    /**
     * 
     * @type {string}
     * @memberof CompanyNameAndId
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNameAndId
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyNameAndId
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface CompanyQueueInfo
 */
export interface CompanyQueueInfo {
    /**
     * 
     * @type {string}
     * @memberof CompanyQueueInfo
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyQueueInfo
     */
    companyName?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyQueueInfo
     */
    minTimestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof CompanyQueueInfo
     */
    oldestEventAgeSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyQueueInfo
     */
    oldestEventTimestampBerlin?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyQueueInfo
     */
    unprocessedEvents?: number;
}

/**
 * 
 * @export
 * @interface CompanyQueuedEventsErrorReport
 */
export interface CompanyQueuedEventsErrorReport {
    /**
     * 
     * @type {string}
     * @memberof CompanyQueuedEventsErrorReport
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyQueuedEventsErrorReport
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyQueuedEventsErrorReport
     */
    errorSummary?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyQueuedEventsErrorReport
     */
    oldestErrorEventFrom?: Date;
    /**
     * 
     * @type {number}
     * @memberof CompanyQueuedEventsErrorReport
     */
    processedEventsWithErrorCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyQueuedEventsErrorReport
     */
    recentErrorEventIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface CompanyQueuedEventsHealthReport
 */
export interface CompanyQueuedEventsHealthReport {
    /**
     * 
     * @type {string}
     * @memberof CompanyQueuedEventsHealthReport
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyQueuedEventsHealthReport
     */
    companyName?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyQueuedEventsHealthReport
     */
    oldestUnprocessedEventFrom?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyQueuedEventsHealthReport
     */
    oldestUnprocessedEventIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CompanyQueuedEventsHealthReport
     */
    unprocessedEventsOlderThanFiveMinutes?: number;
}

/**
 * 
 * @export
 * @interface CompanyReportData
 */
export interface CompanyReportData {
    /**
     * 
     * @type {string}
     * @memberof CompanyReportData
     */
    companyId?: string;
    /**
     * 
     * @type {Any}
     * @memberof CompanyReportData
     */
    reportStatus?: Any;
    /**
     * 
     * @type {string}
     * @memberof CompanyReportData
     */
    serviceType?: CompanyReportData.ServiceTypeEnum;
}

/**
 * @export
 * @namespace CompanyReportData
 */
export namespace CompanyReportData {
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceTypeEnum {
        APIGATEWAYREPORT = 'API_GATEWAY_REPORT',
        SFTPREPORT = 'SFTP_REPORT',
        CUSTOMERFILEHEALTHREPORT = 'CUSTOMER_FILE_HEALTH_REPORT',
        LOGENIOSFILEHEALTHREPORT = 'LOGENIOS_FILE_HEALTH_REPORT',
        ATTACHMENTFILEHEALTHREPORT = 'ATTACHMENT_FILE_HEALTH_REPORT',
        QUEUEREPORT = 'QUEUE_REPORT',
        STATUSJSONREPORT = 'STATUS_JSON_REPORT',
        NEEDSVERIFICATIONREPORT = 'NEEDS_VERIFICATION_REPORT',
        ERRORFILESREPORT = 'ERROR_FILES_REPORT',
        ETACALCULATORREPORT = 'ETA_CALCULATOR_REPORT',
        MESSAGELOGREPORT = 'MESSAGE_LOG_REPORT',
        SCHEDULERREPORTTASKSTATUS = 'SCHEDULER_REPORT_TASK_STATUS'
    }
}

/**
 * 
 * @export
 * @interface CompanyResponsibleManagerResponse
 */
export interface CompanyResponsibleManagerResponse {
    /**
     * 
     * @type {Array<CompanyWithResponsibleManager>}
     * @memberof CompanyResponsibleManagerResponse
     */
    companyWithResponsibleManager?: Array<CompanyWithResponsibleManager>;
}

/**
 * 
 * @export
 * @interface CompanyShort
 */
export interface CompanyShort {
    /**
     * 
     * @type {string}
     * @memberof CompanyShort
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyShort
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyShort
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface CompanyShortInfo
 */
export interface CompanyShortInfo {
    /**
     * 
     * @type {string}
     * @memberof CompanyShortInfo
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyShortInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyShortInfo
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface CompanyShortInfoResponse
 */
export interface CompanyShortInfoResponse {
    /**
     * 
     * @type {Array<CompanyShortInfo>}
     * @memberof CompanyShortInfoResponse
     */
    companies?: Array<CompanyShortInfo>;
}

/**
 * 
 * @export
 * @interface CompanyShortListResponse
 */
export interface CompanyShortListResponse {
    /**
     * 
     * @type {Array<CompanyShort>}
     * @memberof CompanyShortListResponse
     */
    companies?: Array<CompanyShort>;
}

/**
 * 
 * @export
 * @interface CompanySpecificViewConfiguration
 */
export interface CompanySpecificViewConfiguration {
    /**
     * 
     * @type {number}
     * @memberof CompanySpecificViewConfiguration
     */
    clientSupportedApiVersion?: number;
    /**
     * 
     * @type {CompanySpecificViewMergingConfiguration}
     * @memberof CompanySpecificViewConfiguration
     */
    merging?: CompanySpecificViewMergingConfiguration;
    /**
     * 
     * @type {ViewConfigurationScripts}
     * @memberof CompanySpecificViewConfiguration
     */
    scripts?: ViewConfigurationScripts;
    /**
     * 
     * @type {string}
     * @memberof CompanySpecificViewConfiguration
     */
    traveledDistanceDataSource?: CompanySpecificViewConfiguration.TraveledDistanceDataSourceEnum;
}

/**
 * @export
 * @namespace CompanySpecificViewConfiguration
 */
export namespace CompanySpecificViewConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum TraveledDistanceDataSourceEnum {
        ODOMETER = 'ODOMETER',
        VIRTUALODOMETER = 'VIRTUAL_ODOMETER'
    }
}

/**
 * 
 * @export
 * @interface CompanySpecificViewMergingConfiguration
 */
export interface CompanySpecificViewMergingConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpecificViewMergingConfiguration
     */
    mergeFreights?: boolean;
}

/**
 * 
 * @export
 * @interface CompanyTag
 */
export interface CompanyTag {
    /**
     * 
     * @type {string}
     * @memberof CompanyTag
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTag
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTag
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyTag
     */
    creationTimeStamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyTag
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTag
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTag
     */
    textColor?: string;
}

/**
 * 
 * @export
 * @interface CompanyTagsFetchResponse
 */
export interface CompanyTagsFetchResponse {
    /**
     * 
     * @type {Array<CompanyTag>}
     * @memberof CompanyTagsFetchResponse
     */
    entries?: Array<CompanyTag>;
    /**
     * 
     * @type {number}
     * @memberof CompanyTagsFetchResponse
     */
    totalFound?: number;
}

/**
 * 
 * @export
 * @interface CompanyTransportOrderMapping
 */
export interface CompanyTransportOrderMapping {
    /**
     * 
     * @type {string}
     * @memberof CompanyTransportOrderMapping
     */
    _id?: string;
    /**
     * 
     * @type {Array<AdditionalDataWithLevel>}
     * @memberof CompanyTransportOrderMapping
     */
    annotateWith?: Array<AdditionalDataWithLevel>;
    /**
     * 
     * @type {string}
     * @memberof CompanyTransportOrderMapping
     */
    companyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyTransportOrderMapping
     */
    companyTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyTransportOrderMapping
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTransportOrderMapping
     */
    groupName?: string;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof CompanyTransportOrderMapping
     */
    location?: TransportOrderPathSelector;
    /**
     * Optional additional match rules evaluated against the immediate format of the freight (e.g. path 'shp.freight.articleNumber'). If set, the mapping only matches when the regular matchOn fields AND all these rules match. Null/empty entries are ignored.
     * @type {Array<ImmediateFormatPathMatchRule>}
     * @memberof CompanyTransportOrderMapping
     */
    matchExpressions?: Array<ImmediateFormatPathMatchRule>;
    /**
     * 
     * @type {Array<MatchingCriteria>}
     * @memberof CompanyTransportOrderMapping
     */
    matchOn?: Array<MatchingCriteria>;
    /**
     * 
     * @type {FreightMappingFieldValues}
     * @memberof CompanyTransportOrderMapping
     */
    replaceWith?: FreightMappingFieldValues;
}

/**
 * 
 * @export
 * @interface CompanyTransportOrderMappingGroup
 */
export interface CompanyTransportOrderMappingGroup {
    /**
     * Id of the transportOrders mapping group
     * @type {string}
     * @memberof CompanyTransportOrderMappingGroup
     */
    _id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyTransportOrderMappingGroup
     */
    allowSkipping?: boolean;
    /**
     * Id of the company to which this group belongs
     * @type {string}
     * @memberof CompanyTransportOrderMappingGroup
     */
    companyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyTransportOrderMappingGroup
     */
    companyTags?: Array<string>;
    /**
     * Date reference for validity period check. One of CREATION_DATE, PLAN_ARRIVE, PLAN_DEPARTURE
     * @type {string}
     * @memberof CompanyTransportOrderMappingGroup
     */
    dateReference?: CompanyTransportOrderMappingGroup.DateReferenceEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyTransportOrderMappingGroup
     */
    fieldsToCompare?: Array<CompanyTransportOrderMappingGroup.FieldsToCompareEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyTransportOrderMappingGroup
     */
    fieldsToReplace?: Array<CompanyTransportOrderMappingGroup.FieldsToReplaceEnum>;
    /**
     * Name of the transportOrders mapping group
     * @type {string}
     * @memberof CompanyTransportOrderMappingGroup
     */
    groupName?: string;
    /**
     * Immediate format paths (e.g. 'shp.freight.articleNumber') the mappings of this group match on. Analogous to fieldsToCompare, but for entries that are not part of the fixed field list. The concrete value and operator per path are configured on the individual mapping.
     * @type {Array<string>}
     * @memberof CompanyTransportOrderMappingGroup
     */
    immediateFormatPathsToCompare?: Array<string>;
    /**
     * 
     * @type {Array<AnnotateWithKey>}
     * @memberof CompanyTransportOrderMappingGroup
     */
    keysToAnnotate?: Array<AnnotateWithKey>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyTransportOrderMappingGroup
     */
    onlyForPartnerCompanies?: Array<string>;
    /**
     * Priority of the rules. Rules with higher prioritiy values are applied after the rules with the lower priority
     * @type {number}
     * @memberof CompanyTransportOrderMappingGroup
     */
    priority?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyTransportOrderMappingGroup
     */
    shouldAddCompanyTagsToShipmentMappingGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyTransportOrderMappingGroup
     */
    shouldApplyIfCompanyIsSourceCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyTransportOrderMappingGroup
     */
    shouldHaltIfMappingIsMissing?: boolean;
    /**
     * Optional valid-from date (inclusive). If null, no lower bound.
     * @type {Date}
     * @memberof CompanyTransportOrderMappingGroup
     */
    validFrom?: Date;
    /**
     * Optional valid-till date (inclusive). If null, no upper bound.
     * @type {Date}
     * @memberof CompanyTransportOrderMappingGroup
     */
    validTill?: Date;
}

/**
 * @export
 * @namespace CompanyTransportOrderMappingGroup
 */
export namespace CompanyTransportOrderMappingGroup {
    /**
     * @export
     * @enum {string}
     */
    export enum DateReferenceEnum {
        CREATIONDATE = 'CREATION_DATE',
        PLANARRIVE = 'PLAN_ARRIVE',
        PLANDEPARTURE = 'PLAN_DEPARTURE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FieldsToCompareEnum {
        TARGETCOMPANYNAME = 'TARGET_COMPANY_NAME',
        EXTERNALTARGETCOMPANYID = 'EXTERNAL_TARGET_COMPANY_ID',
        LOADINGLOCATIONNAME1 = 'LOADING_LOCATION_NAME1',
        LOADINGLOCATIONNAME2 = 'LOADING_LOCATION_NAME2',
        LOADINGLOCATIONCITY = 'LOADING_LOCATION_CITY',
        LOADINGLOCATIONSTREET = 'LOADING_LOCATION_STREET',
        LOADINGLOCATIONCOUNTRYCODE = 'LOADING_LOCATION_COUNTRY_CODE',
        LOADINGLOCATIONZIPCODE = 'LOADING_LOCATION_ZIP_CODE',
        LOADINGLOCATIONEXTERNALSTOPID = 'LOADING_LOCATION_EXTERNAL_STOP_ID',
        UNLOADINGLOCATIONNAME1 = 'UNLOADING_LOCATION_NAME1',
        UNLOADINGLOCATIONNAME2 = 'UNLOADING_LOCATION_NAME2',
        UNLOADINGLOCATIONCITY = 'UNLOADING_LOCATION_CITY',
        UNLOADINGLOCATIONSTREET = 'UNLOADING_LOCATION_STREET',
        UNLOADINGLOCATIONCOUNTRYCODE = 'UNLOADING_LOCATION_COUNTRY_CODE',
        UNLOADINGLOCATIONZIPCODE = 'UNLOADING_LOCATION_ZIP_CODE',
        UNLOADINGLOCATIONEXTERNALSTOPID = 'UNLOADING_LOCATION_EXTERNAL_STOP_ID',
        FREIGHTID = 'FREIGHT_ID',
        FREIGHTEXTERNALFREIGHTID = 'FREIGHT_EXTERNAL_FREIGHT_ID',
        FREIGHTDELIVERYNUMBER = 'FREIGHT_DELIVERY_NUMBER',
        FREIGHTVERBOSENAME = 'FREIGHT_VERBOSE_NAME',
        FREIGHTCONTAINMENTNAME = 'FREIGHT_CONTAINMENT_NAME',
        FREIGHTCONTAINMENTNAMEEXT = 'FREIGHT_CONTAINMENT_NAME_EXT',
        FREIGHTCONTAINMENTTYPE = 'FREIGHT_CONTAINMENT_TYPE',
        FREIGHTCONTAINMENTQUANTITY = 'FREIGHT_CONTAINMENT_QUANTITY',
        FREIGHTHEIGHT = 'FREIGHT_HEIGHT',
        FREIGHTWIDTH = 'FREIGHT_WIDTH',
        FREIGHTLENGTH = 'FREIGHT_LENGTH',
        FREIGHTTOTALLOTS = 'FREIGHT_TOTAL_LOTS',
        FREIGHTTOTALLOADINGMETER = 'FREIGHT_TOTAL_LOADING_METER',
        FREIGHTTOTALQUANTITY = 'FREIGHT_TOTAL_QUANTITY',
        FREIGHTTOTALVOLUME = 'FREIGHT_TOTAL_VOLUME',
        FREIGHTTOTALWEIGHT = 'FREIGHT_TOTAL_WEIGHT',
        TRANSPORTCOMMENT = 'TRANSPORT_COMMENT',
        SHIPPERNAME = 'SHIPPER_NAME',
        SHIPPERCITY = 'SHIPPER_CITY',
        SHIPPERZIPCODE = 'SHIPPER_ZIPCODE',
        SHIPPERCOUNTRYCODE = 'SHIPPER_COUNTRY_CODE',
        SHIPPERSTREET = 'SHIPPER_STREET',
        FREIGHTPAYERNAME = 'FREIGHT_PAYER_NAME',
        FREIGHTPAYERCITY = 'FREIGHT_PAYER_CITY',
        FREIGHTPAYERZIPCODE = 'FREIGHT_PAYER_ZIPCODE',
        FREIGHTPAYERCOUNTRYCODE = 'FREIGHT_PAYER_COUNTRY_CODE',
        FREIGHTPAYERSTREET = 'FREIGHT_PAYER_STREET',
        FREIGHTPAYEREXTERNALPARTNERID = 'FREIGHT_PAYER_EXTERNAL_PARTNER_ID',
        FREIGHTPAYEREXTERNALID = 'FREIGHT_PAYER_EXTERNAL_ID'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FieldsToReplaceEnum {
        FreightId = 'FreightId',
        ExternalFreightId = 'ExternalFreightId',
        DeliveryNumber = 'DeliveryNumber',
        VerboseName = 'VerboseName',
        ContainmentName = 'ContainmentName',
        ContainmentNameExt = 'ContainmentNameExt',
        ContainmentType = 'ContainmentType',
        ContainmentQuantity = 'ContainmentQuantity',
        Height = 'Height',
        Length = 'Length',
        Width = 'Width',
        TotalLots = 'TotalLots',
        TotalQuantity = 'TotalQuantity',
        TotalVolume = 'TotalVolume',
        TotalWeight = 'TotalWeight',
        TotalLoadingMeter = 'TotalLoadingMeter'
    }
}

/**
 * 
 * @export
 * @interface CompanyUiViewConfiguration
 */
export interface CompanyUiViewConfiguration {
    /**
     * 
     * @type {AttachmentOverviewModalConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    attachmentOverviewModal?: AttachmentOverviewModalConfiguration;
    /**
     * 
     * @type {ReviewPageConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    attachmentReviewPage?: ReviewPageConfiguration;
    /**
     * 
     * @type {TransportOrderCreatePageViewConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    createPage?: TransportOrderCreatePageViewConfiguration;
    /**
     * 
     * @type {DepotMonitorViewConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    depotMonitor?: DepotMonitorViewConfiguration;
    /**
     * 
     * @type {MobileWebAppConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    mobileWebApp?: MobileWebAppConfiguration;
    /**
     * 
     * @type {ReviewPageConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    ownFleetAttachmentReviewPage?: ReviewPageConfiguration;
    /**
     * 
     * @type {StatusMonitoringConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    statusMonitoring?: StatusMonitoringConfiguration;
    /**
     * 
     * @type {StopDelayThresholdsConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    stopDelayThresholds?: StopDelayThresholdsConfiguration;
    /**
     * 
     * @type {TrackingPageViewConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    trackingPage?: TrackingPageViewConfiguration;
    /**
     * 
     * @type {TransportOrderDetailPageViewConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    transportOrderDetailPage?: TransportOrderDetailPageViewConfiguration;
    /**
     * 
     * @type {TransportOrderListViewConfiguration}
     * @memberof CompanyUiViewConfiguration
     */
    transportOrderListPage?: TransportOrderListViewConfiguration;
    /**
     * 
     * @type {TransportOrderPdfView}
     * @memberof CompanyUiViewConfiguration
     */
    transportOrderPdf?: TransportOrderPdfView;
}

/**
 * 
 * @export
 * @interface CompanyUserRolesByIdsResponse
 */
export interface CompanyUserRolesByIdsResponse {
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof CompanyUserRolesByIdsResponse
     */
    roles?: Array<UserRole>;
}

/**
 * 
 * @export
 * @interface CompanyWithConfig
 */
export interface CompanyWithConfig {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof CompanyWithConfig
     */
    companyConfig?: CompanyConfiguration;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithConfig
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithConfig
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithConfig
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface CompanyWithExcludeInfo
 */
export interface CompanyWithExcludeInfo {
    /**
     * 
     * @type {ExcludedFromUnbilledOrdersCalculationInfo}
     * @memberof CompanyWithExcludeInfo
     */
    excludeInfo?: ExcludedFromUnbilledOrdersCalculationInfo;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithExcludeInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithExcludeInfo
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface CompanyWithExternalCompanyId
 */
export interface CompanyWithExternalCompanyId {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithExternalCompanyId
     */
    autoAcceptOrders?: boolean;
    /**
     * 
     * @type {Company}
     * @memberof CompanyWithExternalCompanyId
     */
    company?: Company;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithExternalCompanyId
     */
    companyAddressMappingMatchOn?: CompanyWithExternalCompanyId.CompanyAddressMappingMatchOnEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyWithExternalCompanyId
     */
    externalCompanyIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithExternalCompanyId
     */
    mergeFreights?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithExternalCompanyId
     */
    requireManualReviewOfReceivedShipments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithExternalCompanyId
     */
    shouldInheritVehiclePresetByPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithExternalCompanyId
     */
    shouldShowOriginalFreightPayer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithExternalCompanyId
     */
    shouldShowOriginalShipper?: boolean;
}

/**
 * @export
 * @namespace CompanyWithExternalCompanyId
 */
export namespace CompanyWithExternalCompanyId {
    /**
     * @export
     * @enum {string}
     */
    export enum CompanyAddressMappingMatchOnEnum {
        ADDRESS = 'MATCH_ADDRESS',
        STOPID = 'MATCH_STOP_ID',
        EXTERNALSTOPID = 'MATCH_EXTERNAL_STOP_ID'
    }
}

/**
 * 
 * @export
 * @interface CompanyWithResponsibleManager
 */
export interface CompanyWithResponsibleManager {
    /**
     * 
     * @type {string}
     * @memberof CompanyWithResponsibleManager
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithResponsibleManager
     */
    companyName?: string;
    /**
     * 
     * @type {CompanyCustomerReportConfig}
     * @memberof CompanyWithResponsibleManager
     */
    customerReportSetting?: CompanyCustomerReportConfig;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithResponsibleManager
     */
    lifecycleStatus?: CompanyWithResponsibleManager.LifecycleStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithResponsibleManager
     */
    lifecycleStatusDescription?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyWithResponsibleManager
     */
    lifecycleStatusProductionDueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithResponsibleManager
     */
    responsibleManager?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyWithResponsibleManager
     */
    slackNotificationEnabledForCompany?: boolean;
}

/**
 * @export
 * @namespace CompanyWithResponsibleManager
 */
export namespace CompanyWithResponsibleManager {
    /**
     * @export
     * @enum {string}
     */
    export enum LifecycleStatusEnum {
        PRODUCTION = 'PRODUCTION',
        SETUP = 'SETUP',
        TESTING = 'TESTING'
    }
}

/**
 * 
 * @export
 * @interface CompanyWithUnbilledOrders
 */
export interface CompanyWithUnbilledOrders {
    /**
     * 
     * @type {string}
     * @memberof CompanyWithUnbilledOrders
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyWithUnbilledOrders
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyWithUnbilledOrders
     */
    total?: number;
    /**
     * 
     * @type {Array<TransportOrderIdProjection>}
     * @memberof CompanyWithUnbilledOrders
     */
    unbilledOrders?: Array<TransportOrderIdProjection>;
}

/**
 * 
 * @export
 * @interface ComparePricesResponse
 */
export interface ComparePricesResponse {
    /**
     * 
     * @type {Invoice}
     * @memberof ComparePricesResponse
     */
    invoice?: Invoice;
    /**
     * 
     * @type {boolean}
     * @memberof ComparePricesResponse
     */
    isSame?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ComparePricesResponse
     */
    xlsPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ComparePricesResponse
     */
    zohoPrice?: number;
}

/**
 * 
 * @export
 * @interface CompletionReportComponent
 */
export interface CompletionReportComponent {
    /**
     * 
     * @type {boolean}
     * @memberof CompletionReportComponent
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {Array<MissingInfo>}
     * @memberof CompletionReportComponent
     */
    missingInfos?: Array<MissingInfo>;
    /**
     * 
     * @type {string}
     * @memberof CompletionReportComponent
     */
    sourceCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof CompletionReportComponent
     */
    targetCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof CompletionReportComponent
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Array<ValidationWarning>}
     * @memberof CompletionReportComponent
     */
    validationWarnings?: Array<ValidationWarning>;
}

/**
 * 
 * @export
 * @interface CompletionReportResponse
 */
export interface CompletionReportResponse {
    /**
     * 
     * @type {Array<CompletionReportComponent>}
     * @memberof CompletionReportResponse
     */
    reportData?: Array<CompletionReportComponent>;
}

/**
 * 
 * @export
 * @interface ComputeSegmentsFromPositionsRequest
 */
export interface ComputeSegmentsFromPositionsRequest {
    /**
     * 
     * @type {Array<Position>}
     * @memberof ComputeSegmentsFromPositionsRequest
     */
    positions?: Array<Position>;
}

/**
 * 
 * @export
 * @interface ConfigChangeEntry
 */
export interface ConfigChangeEntry {
    /**
     * 
     * @type {string}
     * @memberof ConfigChangeEntry
     */
    changedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigChangeEntry
     */
    comment?: string;
    /**
     * 
     * @type {Array<CompanyConfigurationChange>}
     * @memberof ConfigChangeEntry
     */
    configurationChanges?: Array<CompanyConfigurationChange>;
    /**
     * 
     * @type {Date}
     * @memberof ConfigChangeEntry
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof ConfigChangeEntry
     */
    workTimeInMinutes?: number;
}

/**
 * 
 * @export
 * @interface ConfigDbVerificationResponse
 */
export interface ConfigDbVerificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ConfigDbVerificationResponse
     */
    isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigDbVerificationResponse
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface ConfigFieldDescription
 */
export interface ConfigFieldDescription {
    /**
     * 
     * @type {string}
     * @memberof ConfigFieldDescription
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigFieldDescription
     */
    fieldPath?: string;
    /**
     * 
     * @type {Date}
     * @memberof ConfigFieldDescription
     */
    lastModifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ConfigFieldDescription
     */
    lastModifiedBy?: string;
    /**
     * 
     * @type {Array<PreviousConfigFieldDescription>}
     * @memberof ConfigFieldDescription
     */
    previousStates?: Array<PreviousConfigFieldDescription>;
}

/**
 * 
 * @export
 * @interface ConfigMatch
 */
export interface ConfigMatch {
    /**
     * 
     * @type {string}
     * @memberof ConfigMatch
     */
    config?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatch
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatch
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface ConfigTestBadRequest
 */
export interface ConfigTestBadRequest {
    /**
     * 
     * @type {ConverterInternalErrorResult}
     * @memberof ConfigTestBadRequest
     */
    error?: ConverterInternalErrorResult;
}

/**
 * 
 * @export
 * @interface ConfigValidationResponse
 */
export interface ConfigValidationResponse {
    /**
     * 
     * @type {ConfigDbVerificationResponse}
     * @memberof ConfigValidationResponse
     */
    verifyResponse?: ConfigDbVerificationResponse;
    /**
     * 
     * @type {Array<ConfigValidationWarning>}
     * @memberof ConfigValidationResponse
     */
    warnings?: Array<ConfigValidationWarning>;
}

/**
 * 
 * @export
 * @interface ConfigValidationWarning
 */
export interface ConfigValidationWarning {
    /**
     * 
     * @type {string}
     * @memberof ConfigValidationWarning
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigValidationWarning
     */
    ruleName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigValidationWarning
     */
    warning?: string;
}

/**
 * 
 * @export
 * @interface ConfirmLoadedConfirmDeliveredWorkflowConfiguration
 */
export interface ConfirmLoadedConfirmDeliveredWorkflowConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmLoadedConfirmDeliveredWorkflowConfiguration
     */
    allowPartialFreightLoading?: boolean;
    /**
     * 
     * @type {ReportDeviationModalConfiguration}
     * @memberof ConfirmLoadedConfirmDeliveredWorkflowConfiguration
     */
    reportDeviationModal?: ReportDeviationModalConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmLoadedConfirmDeliveredWorkflowConfiguration
     */
    showAcceptRejectButtons?: boolean;
}

/**
 * 
 * @export
 * @interface ConfirmLoadedSelectDeliveredWorkflowConfiguration
 */
export interface ConfirmLoadedSelectDeliveredWorkflowConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmLoadedSelectDeliveredWorkflowConfiguration
     */
    allowPartialFreightLoading?: boolean;
    /**
     * 
     * @type {ReportDeviationModalConfiguration}
     * @memberof ConfirmLoadedSelectDeliveredWorkflowConfiguration
     */
    reportDeviationModal?: ReportDeviationModalConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmLoadedSelectDeliveredWorkflowConfiguration
     */
    showAcceptRejectButtons?: boolean;
}

/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    phoneNumber?: string;
}

/**
 * 
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    phoneNr?: string;
}

/**
 * 
 * @export
 * @interface ContactingInfo
 */
export interface ContactingInfo {
    /**
     * 
     * @type {Array<Contact>}
     * @memberof ContactingInfo
     */
    contacts?: Array<Contact>;
    /**
     * 
     * @type {string}
     * @memberof ContactingInfo
     */
    serviceLevel?: ContactingInfo.ServiceLevelEnum;
}

/**
 * @export
 * @namespace ContactingInfo
 */
export namespace ContactingInfo {
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceLevelEnum {
        INSTANT = 'INSTANT',
        OPENINGHOURS = 'OPENING_HOURS',
        NEXTDAY = 'NEXT_DAY'
    }
}

/**
 * 
 * @export
 * @interface ContainmentTypeMapping
 */
export interface ContainmentTypeMapping {
    /**
     * 
     * @type {string}
     * @memberof ContainmentTypeMapping
     */
    externalName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainmentTypeMapping
     */
    type?: ContainmentTypeMapping.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContainmentTypeMapping
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace ContainmentTypeMapping
 */
export namespace ContainmentTypeMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        EpalEurPallet = 'epalEurPallet',
        Epal2Pallet = 'epal2Pallet',
        Epal3Pallet = 'epal3Pallet',
        Epal6HalfPallet = 'epal6HalfPallet',
        Epal7HalfPallet = 'epal7HalfPallet',
        EpalBoxPallet = 'epalBoxPallet',
        ChepEuroPallet = 'chepEuroPallet',
        ChepHalfPallet = 'chepHalfPallet',
        ChepIndustrialPallet = 'chepIndustrialPallet',
        ChepPlasticEurPallet = 'chepPlasticEurPallet',
        ChepPlasticQuarterPallet = 'chepPlasticQuarterPallet',
        Pallet = 'pallet',
        PalletCollar = 'palletCollar',
        EurH1PlasticPallet = 'eurH1PlasticPallet',
        PaperSack = 'paperSack',
        InflatableBag = 'inflatableBag',
        Container20ft = 'container20ft',
        Container40ft = 'container40ft',
        Container45ft = 'container45ft',
        Container48ft = 'container48ft',
        Container53ft = 'container53ft',
        IbcContainer = 'ibcContainer',
        IntermediateBulkContainer = 'intermediateBulkContainer',
        IfcoTray = 'ifcoTray',
        SlipSheet = 'slipSheet',
        CagePallet = 'cagePallet',
        RollContainer = 'rollContainer',
        Bag = 'bag',
        Box = 'box',
        Piece = 'piece',
        Other = 'other'
    }
}

/**
 * 
 * @export
 * @interface ContentType
 */
export interface ContentType {
    /**
     * 
     * @type {string}
     * @memberof ContentType
     */
    contentSubtype?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentType
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentType
     */
    content?: string;
    /**
     * 
     * @type {Array<HeaderValueParam>}
     * @memberof ContentType
     */
    parameters?: Array<HeaderValueParam>;
}

/**
 * 
 * @export
 * @interface Contract
 */
export interface Contract {
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    _id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contract
     */
    applyDiscount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Contract
     */
    billingActive?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof Contract
     */
    billingAddress?: Address;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    exportTo?: Contract.ExportToEnum;
    /**
     * 
     * @type {number}
     * @memberof Contract
     */
    fixedBasePrice?: number;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    groupingTagScript?: string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    importFrom?: Contract.ImportFromEnum;
    /**
     * 
     * @type {number}
     * @memberof Contract
     */
    minimumBillableAmount?: number;
    /**
     * 
     * @type {Array<MonthlyCost>}
     * @memberof Contract
     */
    monthlyCosts?: Array<MonthlyCost>;
    /**
     * 
     * @type {number}
     * @memberof Contract
     */
    pricePerOrder?: number;
    /**
     * 
     * @type {Array<ContractSpecificConfiguration>}
     * @memberof Contract
     */
    specific?: Array<ContractSpecificConfiguration>;
    /**
     * 
     * @type {Array<DiscountRange>}
     * @memberof Contract
     */
    specificDiscountRanges?: Array<DiscountRange>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Contract
     */
    subcompaniesToIncludeInInvoice?: Array<string>;
    /**
     * 
     * @type {UsageBasedCostMatrix}
     * @memberof Contract
     */
    usageBasedCostMatrix?: UsageBasedCostMatrix;
    /**
     * 
     * @type {Date}
     * @memberof Contract
     */
    validFrom?: Date;
    /**
     * 
     * @type {VehiclePolylineBilling}
     * @memberof Contract
     */
    vehiclePolylineBilling?: VehiclePolylineBilling;
    /**
     * 
     * @type {ObserverCompanyContractDetails}
     * @memberof Contract
     */
    whenCurrentCompanyHasObservers?: ObserverCompanyContractDetails;
    /**
     * 
     * @type {SourceCompanyContractDetails}
     * @memberof Contract
     */
    whenCurrentCompanyIsSource?: SourceCompanyContractDetails;
    /**
     * 
     * @type {TargetCompanyContractDetails}
     * @memberof Contract
     */
    whenCurrentCompanyIsTarget?: TargetCompanyContractDetails;
    /**
     * 
     * @type {ZohoConfig}
     * @memberof Contract
     */
    zohoConfig?: ZohoConfig;
}

/**
 * @export
 * @namespace Contract
 */
export namespace Contract {
    /**
     * @export
     * @enum {string}
     */
    export enum ExportToEnum {
        LIS = 'LIS',
        BNS = 'BNS',
        CLOGISTIK = 'CLOGISTIK',
        LOGENIOS = 'LOGENIOS',
        DRMALEK = 'DRMALEK',
        GEHR = 'GEHR',
        COMTRIX = 'COMTRIX',
        COMLOGIS = 'COMLOGIS',
        A4L = 'A4L',
        ECOVIUM = 'ECOVIUM'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ImportFromEnum {
        LIS = 'LIS',
        BNS = 'BNS',
        CLOGISTIK = 'CLOGISTIK',
        LOGENIOS = 'LOGENIOS',
        DRMALEK = 'DRMALEK',
        GEHR = 'GEHR',
        COMTRIX = 'COMTRIX',
        COMLOGIS = 'COMLOGIS',
        A4L = 'A4L',
        ECOVIUM = 'ECOVIUM'
    }
}

/**
 * 
 * @export
 * @interface ContractOverride
 */
export interface ContractOverride {
    /**
     * 
     * @type {number}
     * @memberof ContractOverride
     */
    pricePerOrder?: number;
    /**
     * 
     * @type {UsageBasedCostMatrix}
     * @memberof ContractOverride
     */
    usageBasedCostMatrix?: UsageBasedCostMatrix;
}

/**
 * 
 * @export
 * @interface ContractOverrideApplyRule
 */
export interface ContractOverrideApplyRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractOverrideApplyRule
     */
    sourceCompanyIn?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractOverrideApplyRule
     */
    targetCompanyIn?: Array<string>;
}

/**
 * 
 * @export
 * @interface ContractSpecificConfiguration
 */
export interface ContractSpecificConfiguration {
    /**
     * 
     * @type {ContractOverrideApplyRule}
     * @memberof ContractSpecificConfiguration
     */
    applyWhen?: ContractOverrideApplyRule;
    /**
     * 
     * @type {ContractOverride}
     * @memberof ContractSpecificConfiguration
     */
    override?: ContractOverride;
}

/**
 * 
 * @export
 * @interface ContractingParty
 */
export interface ContractingParty {
    /**
     * List of key value pairs for storing additional information
     * @type {Array<AdditionalDataEntry>}
     * @memberof ContractingParty
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * City where the party is located
     * @type {string}
     * @memberof ContractingParty
     */
    city?: string;
    /**
     * The LOGENIOS CompanyId if the involved party has an logenios account
     * @type {string}
     * @memberof ContractingParty
     */
    companyId?: string;
    /**
     * 
     * @type {Contact}
     * @memberof ContractingParty
     */
    contact?: Contact;
    /**
     * An id for adressing this element. Must be unique for all ContractingParties within that TransportOrder. Will be auto filled if null.
     * @type {string}
     * @memberof ContractingParty
     */
    contractingPartyId?: string;
    /**
     * Country code, preferably use ISO 3166 two letter language code
     * @type {string}
     * @memberof ContractingParty
     */
    countryCode?: string;
    /**
     * The user defined external company id
     * @type {string}
     * @memberof ContractingParty
     */
    externalPartnerId?: string;
    /**
     * The global location number issued by the GS1
     * @type {string}
     * @memberof ContractingParty
     */
    gs1GlobalLocationNumber?: string;
    /**
     * House number
     * @type {string}
     * @memberof ContractingParty
     */
    houseNr?: string;
    /**
     * Name of the party
     * @type {string}
     * @memberof ContractingParty
     */
    name?: string;
    /**
     * Second name
     * @type {string}
     * @memberof ContractingParty
     */
    name2?: string;
    /**
     * Describes how this party is involved in the shipment process.
     * @type {string}
     * @memberof ContractingParty
     */
    role?: ContractingParty.RoleEnum;
    /**
     * Street name
     * @type {string}
     * @memberof ContractingParty
     */
    street?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof ContractingParty
     */
    zipCode?: string;
}

/**
 * @export
 * @namespace ContractingParty
 */
export namespace ContractingParty {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        FREIGHTPAYER = 'FREIGHT_PAYER',
        SHIPPER = 'SHIPPER',
        RECEIVER = 'RECEIVER',
        CUSTOMER = 'CUSTOMER',
        CARRIER = 'CARRIER',
        LOGENIOSSOURCECOMPANY = 'LOGENIOS_SOURCE_COMPANY',
        LOGENIOSVIACOMPANY = 'LOGENIOS_VIA_COMPANY',
        LOGENIOSTARGETCOMPANY = 'LOGENIOS_TARGET_COMPANY'
    }
}

/**
 * 
 * @export
 * @interface ContractingPartyMapping
 */
export interface ContractingPartyMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof ContractingPartyMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    externalPartnerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    houseNr?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    role?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof ContractingPartyMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyMapping
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface ContractingPartyToAddressKindMapping
 */
export interface ContractingPartyToAddressKindMapping {
    /**
     * 
     * @type {boolean}
     * @memberof ContractingPartyToAddressKindMapping
     */
    applyForExport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractingPartyToAddressKindMapping
     */
    applyForImport?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyToAddressKindMapping
     */
    contractingPartyRole?: ContractingPartyToAddressKindMapping.ContractingPartyRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyToAddressKindMapping
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractingPartyToAddressKindMapping
     */
    lisCustomerKind?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractingPartyToAddressKindMapping
     */
    postExportScript?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractingPartyToAddressKindMapping
     */
    priority?: number;
}

/**
 * @export
 * @namespace ContractingPartyToAddressKindMapping
 */
export namespace ContractingPartyToAddressKindMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum ContractingPartyRoleEnum {
        FREIGHTPAYER = 'FREIGHT_PAYER',
        SHIPPER = 'SHIPPER',
        RECEIVER = 'RECEIVER',
        CUSTOMER = 'CUSTOMER',
        CARRIER = 'CARRIER',
        LOGENIOSSOURCECOMPANY = 'LOGENIOS_SOURCE_COMPANY',
        LOGENIOSVIACOMPANY = 'LOGENIOS_VIA_COMPANY',
        LOGENIOSTARGETCOMPANY = 'LOGENIOS_TARGET_COMPANY'
    }
}

/**
 * 
 * @export
 * @interface ContractsResponse
 */
export interface ContractsResponse {
    /**
     * 
     * @type {Array<Contract>}
     * @memberof ContractsResponse
     */
    contracts?: Array<Contract>;
    /**
     * 
     * @type {number}
     * @memberof ContractsResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface ConversionInfo
 */
export interface ConversionInfo {
    /**
     * 
     * @type {string}
     * @memberof ConversionInfo
     */
    by?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversionInfo
     */
    fileName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ConversionInfo
     */
    timestamp?: Date;
}

/**
 * 
 * @export
 * @interface ConversionJobLog
 */
export interface ConversionJobLog {
    /**
     * 
     * @type {string}
     * @memberof ConversionJobLog
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversionJobLog
     */
    archiveFileName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversionJobLog
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ConversionJobLog
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof ConversionJobLog
     */
    inputFileName?: string;
    /**
     * 
     * @type {Array<ConversionLogOutput>}
     * @memberof ConversionJobLog
     */
    outputs?: Array<ConversionLogOutput>;
    /**
     * 
     * @type {string}
     * @memberof ConversionJobLog
     */
    result?: ConversionJobLog.ResultEnum;
    /**
     * 
     * @type {Array<ConversionTaskLog>}
     * @memberof ConversionJobLog
     */
    taskLog?: Array<ConversionTaskLog>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversionJobLog
     */
    transportOrderIds?: Array<string>;
}

/**
 * @export
 * @namespace ConversionJobLog
 */
export namespace ConversionJobLog {
    /**
     * @export
     * @enum {string}
     */
    export enum ResultEnum {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE'
    }
}

/**
 * 
 * @export
 * @interface ConversionJobLogResponse
 */
export interface ConversionJobLogResponse {
    /**
     * 
     * @type {Array<ConversionJobLog>}
     * @memberof ConversionJobLogResponse
     */
    entries?: Array<ConversionJobLog>;
    /**
     * 
     * @type {number}
     * @memberof ConversionJobLogResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface ConversionLogOutput
 */
export interface ConversionLogOutput {
    /**
     * 
     * @type {string}
     * @memberof ConversionLogOutput
     */
    archiveFileName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversionLogOutput
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversionLogOutput
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface ConversionTaskLog
 */
export interface ConversionTaskLog {
    /**
     * 
     * @type {Date}
     * @memberof ConversionTaskLog
     */
    endTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof ConversionTaskLog
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversionTaskLog
     */
    result?: ConversionTaskLog.ResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversionTaskLog
     */
    stage?: ConversionTaskLog.StageEnum;
    /**
     * 
     * @type {Date}
     * @memberof ConversionTaskLog
     */
    startTimestamp?: Date;
}

/**
 * @export
 * @namespace ConversionTaskLog
 */
export namespace ConversionTaskLog {
    /**
     * @export
     * @enum {string}
     */
    export enum ResultEnum {
        OK = 'OK',
        FAILURE = 'FAILURE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StageEnum {
        RECEIVED = 'RECEIVED',
        CONVERTINGTOTRANSPORTORDER = 'CONVERTING_TO_TRANSPORT_ORDER',
        SENDTOBACKEND = 'SEND_TO_BACKEND',
        ERROR = 'ERROR',
        CONVERTINGTOEXTERNALFORMAT = 'CONVERTING_TO_EXTERNAL_FORMAT',
        PREOCR = 'PRE_OCR',
        UPLOADATTACHMENT = 'UPLOAD_ATTACHMENT',
        SENDTOAPIGATEWAY = 'SEND_TO_API_GATEWAY'
    }
}

/**
 * 
 * @export
 * @interface ConverterConfiguration
 */
export interface ConverterConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ConverterConfiguration
     */
    allowExportOfTransportOrdersForNonTargetCompany?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConverterConfiguration
     */
    attachmentFileName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConverterConfiguration
     */
    fileNameOverrideScript?: string;
    /**
     * 
     * @type {string}
     * @memberof ConverterConfiguration
     */
    ftpAttachmentFolder?: string;
    /**
     * 
     * @type {Array<FtpSpecificFolderConfiguration>}
     * @memberof ConverterConfiguration
     */
    ftpSpecificFolders?: Array<FtpSpecificFolderConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof ConverterConfiguration
     */
    ftpStatusEventFolder?: string;
    /**
     * 
     * @type {string}
     * @memberof ConverterConfiguration
     */
    ftpTransportOrderEventFolder?: string;
    /**
     * 
     * @type {OnErrorConfiguration}
     * @memberof ConverterConfiguration
     */
    onError?: OnErrorConfiguration;
    /**
     * 
     * @type {string}
     * @memberof ConverterConfiguration
     */
    postConvertScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConverterConfiguration
     */
    sendErrorMailOnConverterFailure?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConverterConfiguration
     */
    shouldExportAttachmentsToFtp?: boolean;
}

/**
 * 
 * @export
 * @interface ConverterCostMatrix
 */
export interface ConverterCostMatrix {
    /**
     * 
     * @type {string}
     * @memberof ConverterCostMatrix
     */
    converter?: ConverterCostMatrix.ConverterEnum;
    /**
     * 
     * @type {number}
     * @memberof ConverterCostMatrix
     */
    fixPricePerCompany?: number;
}

/**
 * @export
 * @namespace ConverterCostMatrix
 */
export namespace ConverterCostMatrix {
    /**
     * @export
     * @enum {string}
     */
    export enum ConverterEnum {
        SOLOPLAN = 'SOLOPLAN',
        LISINLISOUT = 'LIS_IN_LIS_OUT',
        ELEMICA = 'ELEMICA',
        SAP = 'SAP',
        EDI = 'EDI',
        SIMPLECSV = 'SIMPLE_CSV',
        GENERICXLS = 'GENERIC_XLS',
        FORTRAS = 'FORTRAS',
        DHLIMPORTER = 'DHL_IMPORTER',
        DESCARTESIMPORTER = 'DESCARTES_IMPORTER',
        METAMODEL = 'META_MODEL',
        GEHR = 'GEHR',
        GENERICGROOVY = 'GENERIC_GROOVY',
        BNSTELEMATIK = 'BNS_TELEMATIK',
        TRANSPOREONXML = 'TRANSPOREON_XML',
        NOOP = 'NO_OP',
        TRANSLOGICA = 'TRANSLOGICA',
        TRANSDATA = 'TRANSDATA',
        CISTELEMATIK = 'CIS_TELEMATIK',
        FRMEYERUNDSOHN = 'FR_MEYER_UND_SOHN',
        ATTACHMENTPROCESSOR = 'ATTACHMENT_PROCESSOR',
        PDFGENERATOR = 'PDF_GENERATOR',
        SHIPPEO = 'SHIPPEO',
        CONIZI = 'CONIZI',
        GENERICZIP = 'GENERIC_ZIP',
        EDIV2 = 'EDI_v2',
        GENERICAI = 'GENERIC_AI'
    }
}

/**
 * 
 * @export
 * @interface ConverterInfo
 */
export interface ConverterInfo {
    /**
     * 
     * @type {Array<ConversionInfo>}
     * @memberof ConverterInfo
     */
    input?: Array<ConversionInfo>;
}

/**
 * 
 * @export
 * @interface ConverterInternalErrorResult
 */
export interface ConverterInternalErrorResult {
    /**
     * 
     * @type {string}
     * @memberof ConverterInternalErrorResult
     */
    endpoint?: string;
    /**
     * 
     * @type {string}
     * @memberof ConverterInternalErrorResult
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ConverterInternalErrorResult
     */
    statusCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ConverterInternalErrorResult
     */
    xRequestId?: string;
}

/**
 * 
 * @export
 * @interface Coordinate
 */
export interface Coordinate {
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    longitude?: number;
}

/**
 * 
 * @export
 * @interface Coordinates
 */
export interface Coordinates {
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof Coordinates
     */
    source?: Coordinates.SourceEnum;
}

/**
 * @export
 * @namespace Coordinates
 */
export namespace Coordinates {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        COMPANY = 'COMPANY',
        SPEDIONGEONAMES = 'SPEDION_GEO_NAMES',
        NOMINATIM = 'NOMINATIM',
        HERE = 'HERE',
        GEOCODIO = 'GEOCODIO',
        MANUAL = 'MANUAL',
        GM = 'GM'
    }
}

/**
 * 
 * @export
 * @interface CopyAsNewTransportOrderRequest
 */
export interface CopyAsNewTransportOrderRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CopyAsNewTransportOrderRequest
     */
    removeAttachments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CopyAsNewTransportOrderRequest
     */
    targetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyAsNewTransportOrderRequest
     */
    transpordOrderId?: string;
}

/**
 * 
 * @export
 * @interface CountEventsResult
 */
export interface CountEventsResult {
    /**
     * 
     * @type {number}
     * @memberof CountEventsResult
     */
    count?: number;
}

/**
 * 
 * @export
 * @interface CreateOrModifyTransportOrderDryRunRequest
 */
export interface CreateOrModifyTransportOrderDryRunRequest {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof CreateOrModifyTransportOrderDryRunRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof CreateOrModifyTransportOrderDryRunRequest
     */
    orders?: Array<TransportOrder>;
}

/**
 * 
 * @export
 * @interface CreateOrModifyTransportOrderDryRunResponse
 */
export interface CreateOrModifyTransportOrderDryRunResponse {
    /**
     * 
     * @type {Array<TransportOrderResponse>}
     * @memberof CreateOrModifyTransportOrderDryRunResponse
     */
    transportOrderResponses?: Array<TransportOrderResponse>;
}

/**
 * 
 * @export
 * @interface CreatePdfOnEventConfiguration
 */
export interface CreatePdfOnEventConfiguration {
    /**
     * 
     * @type {Array<Base64Image>}
     * @memberof CreatePdfOnEventConfiguration
     */
    base64Images?: Array<Base64Image>;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    category?: CreatePdfOnEventConfiguration.CategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    creationScript?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    mode?: CreatePdfOnEventConfiguration.ModeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    outputAction?: CreatePdfOnEventConfiguration.OutputActionEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    pdfTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    scriptLanguage?: CreatePdfOnEventConfiguration.ScriptLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    shipmentMode?: CreatePdfOnEventConfiguration.ShipmentModeEnum;
    /**
     * 
     * @type {Array<TriggerOnEvent>}
     * @memberof CreatePdfOnEventConfiguration
     */
    triggeringEvent?: Array<TriggerOnEvent>;
    /**
     * 
     * @type {string}
     * @memberof CreatePdfOnEventConfiguration
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace CreatePdfOnEventConfiguration
 */
export namespace CreatePdfOnEventConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum CategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        FILLPDF = 'FILL_PDF',
        PDFFROMHTML = 'PDF_FROM_HTML',
        PDFFROMHTMLUSINGCHROME = 'PDF_FROM_HTML_USING_CHROME',
        DEBUGOUTPUTRAWHTML = 'DEBUG_OUTPUT_RAW_HTML'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OutputActionEnum {
        ATTACHTOTRANSPORTORDER = 'ATTACH_TO_TRANSPORT_ORDER',
        WRITETOFILE = 'WRITE_TO_FILE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ScriptLanguageEnum {
        GROOVY = 'GROOVY',
        KOTLIN = 'KOTLIN'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ShipmentModeEnum {
        SHIPMENT = 'SHIPMENT',
        FREIGHTWITHSTOPS = 'FREIGHT_WITH_STOPS',
        FREIGHTWITHSTOPSFORCEMERGE = 'FREIGHT_WITH_STOPS_FORCE_MERGE',
        FREIGHTWITHSTOPSNOMERGE = 'FREIGHT_WITH_STOPS_NO_MERGE',
        SHIPMENTNOMERGE = 'SHIPMENT_NO_MERGE',
        SHIPMENTFORCEMERGE = 'SHIPMENT_FORCE_MERGE'
    }
}

/**
 * 
 * @export
 * @interface CreateScriptRunnerUserRequest
 */
export interface CreateScriptRunnerUserRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateScriptRunnerUserRequest
     */
    companyAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateScriptRunnerUserRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScriptRunnerUserRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScriptRunnerUserRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScriptRunnerUserRequest
     */
    preferredLanguage?: CreateScriptRunnerUserRequest.PreferredLanguageEnum;
}

/**
 * @export
 * @namespace CreateScriptRunnerUserRequest
 */
export namespace CreateScriptRunnerUserRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredLanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
}

/**
 * 
 * @export
 * @interface CreateScriptRunnerUserResponse
 */
export interface CreateScriptRunnerUserResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateScriptRunnerUserResponse
     */
    reason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateScriptRunnerUserResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface CsvAdditionalDataMapping
 */
export interface CsvAdditionalDataMapping {
    /**
     * 
     * @type {boolean}
     * @memberof CsvAdditionalDataMapping
     */
    _export?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CsvAdditionalDataMapping
     */
    _import?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CsvAdditionalDataMapping
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof CsvAdditionalDataMapping
     */
    logeniosKeyName?: string;
}

/**
 * 
 * @export
 * @interface CsvAddressColumnMapping
 */
export interface CsvAddressColumnMapping {
    /**
     * 
     * @type {Array<CsvAdditionalDataMapping>}
     * @memberof CsvAddressColumnMapping
     */
    additionals?: Array<CsvAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    houseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    mergeAndOrderKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    planBegin?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    planEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    stopId?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvAddressColumnMapping
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface CsvFreightColumnMapping
 */
export interface CsvFreightColumnMapping {
    /**
     * 
     * @type {Array<CsvAdditionalDataMapping>}
     * @memberof CsvFreightColumnMapping
     */
    additionals?: Array<CsvAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    articleNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    containmentQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    containmentQuantityUnit?: CsvFreightColumnMapping.ContainmentQuantityUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    containmentType?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    deliveryNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    externalFreightId?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    freightId?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    height?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    lengthUnit?: CsvFreightColumnMapping.LengthUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalLoadingMeter?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalLoadingMeterUnit?: CsvFreightColumnMapping.TotalLoadingMeterUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalLots?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalQuantityUnit?: CsvFreightColumnMapping.TotalQuantityUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalVolume?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalVolumeUnit?: CsvFreightColumnMapping.TotalVolumeUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    totalWeightUnit?: CsvFreightColumnMapping.TotalWeightUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvFreightColumnMapping
     */
    width?: string;
}

/**
 * @export
 * @namespace CsvFreightColumnMapping
 */
export namespace CsvFreightColumnMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum ContainmentQuantityUnitEnum {
        Km = 'km',
        M = 'm',
        Mm = 'mm',
        Cm = 'cm',
        G = 'g',
        Kg = 'kg',
        MetricTon = 'metric_ton',
        S = 's',
        Sqm = 'sqm',
        Cbm = 'cbm',
        L = 'l',
        Ml = 'ml',
        ImpGal = 'imp_gal',
        UsLiqGal = 'us_liq_gal',
        UsDryGal = 'us_dry_gal',
        MetricGal = 'metric_gal',
        Foot = 'foot',
        Inch = 'inch',
        Yard = 'yard',
        ImpTon = 'imp_ton',
        Pound = 'pound',
        Quarter = 'quarter',
        Piece = 'piece',
        Bag = 'bag'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LengthUnitEnum {
        Km = 'km',
        M = 'm',
        Mm = 'mm',
        Cm = 'cm',
        G = 'g',
        Kg = 'kg',
        MetricTon = 'metric_ton',
        S = 's',
        Sqm = 'sqm',
        Cbm = 'cbm',
        L = 'l',
        Ml = 'ml',
        ImpGal = 'imp_gal',
        UsLiqGal = 'us_liq_gal',
        UsDryGal = 'us_dry_gal',
        MetricGal = 'metric_gal',
        Foot = 'foot',
        Inch = 'inch',
        Yard = 'yard',
        ImpTon = 'imp_ton',
        Pound = 'pound',
        Quarter = 'quarter',
        Piece = 'piece',
        Bag = 'bag'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TotalLoadingMeterUnitEnum {
        Km = 'km',
        M = 'm',
        Mm = 'mm',
        Cm = 'cm',
        G = 'g',
        Kg = 'kg',
        MetricTon = 'metric_ton',
        S = 's',
        Sqm = 'sqm',
        Cbm = 'cbm',
        L = 'l',
        Ml = 'ml',
        ImpGal = 'imp_gal',
        UsLiqGal = 'us_liq_gal',
        UsDryGal = 'us_dry_gal',
        MetricGal = 'metric_gal',
        Foot = 'foot',
        Inch = 'inch',
        Yard = 'yard',
        ImpTon = 'imp_ton',
        Pound = 'pound',
        Quarter = 'quarter',
        Piece = 'piece',
        Bag = 'bag'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TotalQuantityUnitEnum {
        Km = 'km',
        M = 'm',
        Mm = 'mm',
        Cm = 'cm',
        G = 'g',
        Kg = 'kg',
        MetricTon = 'metric_ton',
        S = 's',
        Sqm = 'sqm',
        Cbm = 'cbm',
        L = 'l',
        Ml = 'ml',
        ImpGal = 'imp_gal',
        UsLiqGal = 'us_liq_gal',
        UsDryGal = 'us_dry_gal',
        MetricGal = 'metric_gal',
        Foot = 'foot',
        Inch = 'inch',
        Yard = 'yard',
        ImpTon = 'imp_ton',
        Pound = 'pound',
        Quarter = 'quarter',
        Piece = 'piece',
        Bag = 'bag'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TotalVolumeUnitEnum {
        Km = 'km',
        M = 'm',
        Mm = 'mm',
        Cm = 'cm',
        G = 'g',
        Kg = 'kg',
        MetricTon = 'metric_ton',
        S = 's',
        Sqm = 'sqm',
        Cbm = 'cbm',
        L = 'l',
        Ml = 'ml',
        ImpGal = 'imp_gal',
        UsLiqGal = 'us_liq_gal',
        UsDryGal = 'us_dry_gal',
        MetricGal = 'metric_gal',
        Foot = 'foot',
        Inch = 'inch',
        Yard = 'yard',
        ImpTon = 'imp_ton',
        Pound = 'pound',
        Quarter = 'quarter',
        Piece = 'piece',
        Bag = 'bag'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TotalWeightUnitEnum {
        Km = 'km',
        M = 'm',
        Mm = 'mm',
        Cm = 'cm',
        G = 'g',
        Kg = 'kg',
        MetricTon = 'metric_ton',
        S = 's',
        Sqm = 'sqm',
        Cbm = 'cbm',
        L = 'l',
        Ml = 'ml',
        ImpGal = 'imp_gal',
        UsLiqGal = 'us_liq_gal',
        UsDryGal = 'us_dry_gal',
        MetricGal = 'metric_gal',
        Foot = 'foot',
        Inch = 'inch',
        Yard = 'yard',
        ImpTon = 'imp_ton',
        Pound = 'pound',
        Quarter = 'quarter',
        Piece = 'piece',
        Bag = 'bag'
    }
}

/**
 * 
 * @export
 * @interface CsvInputFormatOptions
 */
export interface CsvInputFormatOptions {
    /**
     * 
     * @type {string}
     * @memberof CsvInputFormatOptions
     */
    fieldSeparator?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvInputFormatOptions
     */
    fileEncoding?: string;
}

/**
 * 
 * @export
 * @interface CsvTransportColumnMapping
 */
export interface CsvTransportColumnMapping {
    /**
     * 
     * @type {Array<CsvAdditionalDataMapping>}
     * @memberof CsvTransportColumnMapping
     */
    additionals?: Array<CsvAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportColumnMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportColumnMapping
     */
    shipmentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportColumnMapping
     */
    transportId?: string;
}

/**
 * 
 * @export
 * @interface CsvTransportOrderColumnMapping
 */
export interface CsvTransportOrderColumnMapping {
    /**
     * 
     * @type {Array<CsvAdditionalDataMapping>}
     * @memberof CsvTransportOrderColumnMapping
     */
    additionals?: Array<CsvAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportOrderColumnMapping
     */
    assignedVehicleNumberplate?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportOrderColumnMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportOrderColumnMapping
     */
    externalTargetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportOrderColumnMapping
     */
    targetCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CsvTransportOrderColumnMapping
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface CustomWorkflowDefinition
 */
export interface CustomWorkflowDefinition {
    /**
     * List of additional status fields.
     * @type {Array<StatusField>}
     * @memberof CustomWorkflowDefinition
     */
    statusFields?: Array<StatusField>;
}

/**
 * 
 * @export
 * @interface CustomerAddressMappingGroupResponse
 */
export interface CustomerAddressMappingGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerAddressMappingGroupResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyAddressMappingGroup>}
     * @memberof CustomerAddressMappingGroupResponse
     */
    results?: Array<CompanyAddressMappingGroup>;
}

/**
 * 
 * @export
 * @interface CustomerAddressMappingOfOrderResponse
 */
export interface CustomerAddressMappingOfOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerAddressMappingOfOrderResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyAddressMappingWithPathSelector>}
     * @memberof CustomerAddressMappingOfOrderResponse
     */
    results?: Array<CompanyAddressMappingWithPathSelector>;
}

/**
 * 
 * @export
 * @interface CustomerAddressMappingResponse
 */
export interface CustomerAddressMappingResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerAddressMappingResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyAddressMapping>}
     * @memberof CustomerAddressMappingResponse
     */
    results?: Array<CompanyAddressMapping>;
}

/**
 * 
 * @export
 * @interface CustomerFreightMappingGroupsResponse
 */
export interface CustomerFreightMappingGroupsResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerFreightMappingGroupsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyFreightMappingGroup>}
     * @memberof CustomerFreightMappingGroupsResponse
     */
    results?: Array<CompanyFreightMappingGroup>;
}

/**
 * 
 * @export
 * @interface CustomerFreightMappingResponse
 */
export interface CustomerFreightMappingResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerFreightMappingResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyFreightMapping>}
     * @memberof CustomerFreightMappingResponse
     */
    results?: Array<CompanyFreightMapping>;
}

/**
 * 
 * @export
 * @interface CustomerTransportOrderMappingGroupsResponse
 */
export interface CustomerTransportOrderMappingGroupsResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerTransportOrderMappingGroupsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyTransportOrderMappingGroup>}
     * @memberof CustomerTransportOrderMappingGroupsResponse
     */
    results?: Array<CompanyTransportOrderMappingGroup>;
}

/**
 * 
 * @export
 * @interface CustomerTransportOrderMappingResponse
 */
export interface CustomerTransportOrderMappingResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerTransportOrderMappingResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyTransportOrderMapping>}
     * @memberof CustomerTransportOrderMappingResponse
     */
    results?: Array<CompanyTransportOrderMapping>;
}

/**
 * 
 * @export
 * @interface DailyStatistics
 */
export interface DailyStatistics {
    /**
     * 
     * @type {number}
     * @memberof DailyStatistics
     */
    incomingPositions?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyStatistics
     */
    operatingHours?: number;
    /**
     * 
     * @type {Date}
     * @memberof DailyStatistics
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof DailyStatistics
     */
    travelledDistanceKm?: number;
}

/**
 * 
 * @export
 * @interface DangerousGoodsMapping
 */
export interface DangerousGoodsMapping {
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    casNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    classCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    className?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DangerousGoodsMapping
     */
    exportGGUTRecord?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DangerousGoodsMapping
     */
    exportGGUTRecordFromPackets?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    infoText?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    isDangerousForTheEnvironment?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    limitedQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    netWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    officialName?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    packingGroup?: string;
    /**
     * 
     * @type {Array<AdrPackingGroupKindMapping>}
     * @memberof DangerousGoodsMapping
     */
    packingGroupMapping?: Array<AdrPackingGroupKindMapping>;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof DangerousGoodsMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    tunnelRestrictionCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    unNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DangerousGoodsMapping
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface DartConfig
 */
export interface DartConfig {
    /**
     * 
     * @type {boolean}
     * @memberof DartConfig
     */
    active?: boolean;
}

/**
 * 
 * @export
 * @interface DartDelayEntry
 */
export interface DartDelayEntry {
    /**
     * 
     * @type {string}
     * @memberof DartDelayEntry
     */
    algoName?: string;
    /**
     * 
     * @type {string}
     * @memberof DartDelayEntry
     */
    delay?: string;
    /**
     * 
     * @type {number}
     * @memberof DartDelayEntry
     */
    delaySeconds?: number;
    /**
     * 
     * @type {Date}
     * @memberof DartDelayEntry
     */
    plannedTime?: Date;
}

/**
 * 
 * @export
 * @interface DartDelayResult
 */
export interface DartDelayResult {
    /**
     * 
     * @type {Array<DartDelayEntry>}
     * @memberof DartDelayResult
     */
    delays?: Array<DartDelayEntry>;
    /**
     * 
     * @type {string}
     * @memberof DartDelayResult
     */
    errorDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DartDelayResult
     */
    hasValidDelay?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DartDelayResult
     */
    isForecastLimitReached?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DartDelayResult
     */
    timeStamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DartDelayResult
     */
    timeStampOfLastInputActivity?: Date;
    /**
     * 
     * @type {string}
     * @memberof DartDelayResult
     */
    totalDelay?: string;
    /**
     * 
     * @type {number}
     * @memberof DartDelayResult
     */
    totalDelayInSeconds?: number;
}

/**
 * 
 * @export
 * @interface DatabaseVersion
 */
export interface DatabaseVersion {
    /**
     * 
     * @type {string}
     * @memberof DatabaseVersion
     */
    _id?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseVersion
     */
    currentVersion?: number;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseVersion
     */
    migrationDate?: Date;
}

/**
 * 
 * @export
 * @interface DateTimeFieldConfiguration
 */
export interface DateTimeFieldConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeFieldConfiguration
     */
    allowDateValuesFromThePast?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeFieldConfiguration
     */
    defaultValue?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeFieldConfiguration
     */
    isReadOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeFieldConfiguration
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeFieldConfiguration
     */
    isVisible?: boolean;
}

/**
 * 
 * @export
 * @interface DateTimeMapping
 */
export interface DateTimeMapping {
    /**
     * 
     * @type {string}
     * @memberof DateTimeMapping
     */
    selector?: DateTimeMapping.SelectorEnum;
    /**
     * 
     * @type {string}
     * @memberof DateTimeMapping
     */
    sourceField?: string;
}

/**
 * @export
 * @namespace DateTimeMapping
 */
export namespace DateTimeMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum SelectorEnum {
        Date = 'Date',
        Time = 'Time',
        DateTime = 'DateTime',
        WindowBegin = 'WindowBegin',
        WindowEnd = 'WindowEnd'
    }
}

/**
 * 
 * @export
 * @interface DeferredNotification
 */
export interface DeferredNotification {
    /**
     * 
     * @type {string}
     * @memberof DeferredNotification
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeferredNotification
     */
    collapseKey?: string;
    /**
     * 
     * @type {string}
     * @memberof DeferredNotification
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof DeferredNotification
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DeferredNotification
     */
    deferredUntil?: Date;
    /**
     * 
     * @type {EmailNotification}
     * @memberof DeferredNotification
     */
    emailNotification?: EmailNotification;
    /**
     * 
     * @type {number}
     * @memberof DeferredNotification
     */
    errorCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DeferredNotification
     */
    observerId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeferredNotification
     */
    orderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeferredNotification
     */
    processed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DeferredNotification
     */
    sent?: Date;
    /**
     * 
     * @type {SmsNotification}
     * @memberof DeferredNotification
     */
    smsNotification?: SmsNotification;
}

/**
 * 
 * @export
 * @interface DeferredNotificationResponse
 */
export interface DeferredNotificationResponse {
    /**
     * 
     * @type {Array<DeferredNotification>}
     * @memberof DeferredNotificationResponse
     */
    deferredNotifications?: Array<DeferredNotification>;
}

/**
 * 
 * @export
 * @interface DelayedArrivalNotificationConfiguration
 */
export interface DelayedArrivalNotificationConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof DelayedArrivalNotificationConfiguration
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DelayedArrivalNotificationConfiguration
     */
    delayTimespan?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DelayedArrivalNotificationConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DelayedArrivalNotificationConfiguration
     */
    id?: string;
    /**
     * 
     * @type {Array<OnlyForPartnerCompaniesEntry>}
     * @memberof DelayedArrivalNotificationConfiguration
     */
    onlyForPartnerCompanies?: Array<OnlyForPartnerCompaniesEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof DelayedArrivalNotificationConfiguration
     */
    perStop?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DelayedArrivalNotificationConfiguration
     */
    timeToNotify?: DelayedArrivalNotificationConfiguration.TimeToNotifyEnum;
}

/**
 * @export
 * @namespace DelayedArrivalNotificationConfiguration
 */
export namespace DelayedArrivalNotificationConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum TimeToNotifyEnum {
        FifteenMinutes = 'FifteenMinutes',
        ThirtyMinutes = 'ThirtyMinutes',
        OneHour = 'OneHour',
        TwoHours = 'TwoHours'
    }
}

/**
 * 
 * @export
 * @interface DeleteFailedRequestsResponse
 */
export interface DeleteFailedRequestsResponse {
    /**
     * 
     * @type {string}
     * @memberof DeleteFailedRequestsResponse
     */
    error?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteFailedRequestsResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface DeleteTransportOrderConfigTestsResponse
 */
export interface DeleteTransportOrderConfigTestsResponse {
    /**
     * 
     * @type {string}
     * @memberof DeleteTransportOrderConfigTestsResponse
     */
    deletedTestId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteTransportOrderConfigTestsResponse
     */
    successful?: boolean;
}

/**
 * 
 * @export
 * @interface Delivery
 */
export interface Delivery {
    /**
     * Additional key value pairs related to the delivery
     * @type {Array<AdditionalDataEntry>}
     * @memberof Delivery
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * List of files attached to this delivery
     * @type {Array<Attachment>}
     * @memberof Delivery
     */
    attachments?: Array<Attachment>;
    /**
     * Additional information related to this delivery
     * @type {string}
     * @memberof Delivery
     */
    comment?: string;
    /**
     * List of contracting parties for this delivery
     * @type {Array<ContractingParty>}
     * @memberof Delivery
     */
    contractingParties?: Array<ContractingParty>;
    /**
     * List of cargo for this delivery
     * @type {Array<Freight>}
     * @memberof Delivery
     */
    freight?: Array<Freight>;
    /**
     * 
     * @type {StopLocation}
     * @memberof Delivery
     */
    loadingLocation?: StopLocation;
    /**
     * 
     * @type {Array<Transport>}
     * @memberof Delivery
     */
    mergedTransports?: Array<Transport>;
    /**
     * Planned stop date of this delivery
     * @type {Date}
     * @memberof Delivery
     */
    planEnd?: Date;
    /**
     * Planned start date of this delivery
     * @type {Date}
     * @memberof Delivery
     */
    planStart?: Date;
    /**
     * Shipment number related to this delivery
     * @type {string}
     * @memberof Delivery
     */
    shipmentNumber?: string;
    /**
     * 
     * @type {StopLocation}
     * @memberof Delivery
     */
    unloadingLocation?: StopLocation;
    /**
     * Via Locations, e.g. depots
     * @type {Array<StopLocation>}
     * @memberof Delivery
     */
    viaLocations?: Array<StopLocation>;
}

/**
 * 
 * @export
 * @interface DeliveryAreaViewConfiguration
 */
export interface DeliveryAreaViewConfiguration {
    /**
     * 
     * @type {DeliveryHeaderViewConfiguration}
     * @memberof DeliveryAreaViewConfiguration
     */
    deliveryHeader?: DeliveryHeaderViewConfiguration;
    /**
     * 
     * @type {FreightTableViewConfiguration}
     * @memberof DeliveryAreaViewConfiguration
     */
    freightTable?: FreightTableViewConfiguration;
    /**
     * 
     * @type {DeliveryStatusViewConfiguration}
     * @memberof DeliveryAreaViewConfiguration
     */
    statusView?: DeliveryStatusViewConfiguration;
}

/**
 * 
 * @export
 * @interface DeliveryHeaderViewConfiguration
 */
export interface DeliveryHeaderViewConfiguration {
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    driver?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    externalTransportOrderId?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    loadingLocation?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    shipper?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    timeWindow?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    trailer?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    transportOrderId?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    unloadingLocation?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof DeliveryHeaderViewConfiguration
     */
    vehicle?: FieldViewConfiguration;
}

/**
 * 
 * @export
 * @interface DeliveryStatus
 */
export interface DeliveryStatus {
    /**
     * 
     * @type {number}
     * @memberof DeliveryStatus
     */
    attempt_no?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryStatus
     */
    certificate_verified?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DeliveryStatus
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryStatus
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryStatus
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryStatus
     */
    mx_host?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryStatus
     */
    session_seconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryStatus
     */
    tls?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryStatus
     */
    utf8?: boolean;
}

/**
 * 
 * @export
 * @interface DeliveryStatusViewConfiguration
 */
export interface DeliveryStatusViewConfiguration {
    /**
     * 
     * @type {string}
     * @memberof DeliveryStatusViewConfiguration
     */
    displayMode?: DeliveryStatusViewConfiguration.DisplayModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryStatusViewConfiguration
     */
    hideStatusView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryStatusViewConfiguration
     */
    showEta?: boolean;
}

/**
 * @export
 * @namespace DeliveryStatusViewConfiguration
 */
export namespace DeliveryStatusViewConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum DisplayModeEnum {
        CENTRALIZED = 'CENTRALIZED',
        EMBEDINDELIVERY = 'EMBED_IN_DELIVERY'
    }
}

/**
 * 
 * @export
 * @interface DepotFreight
 */
export interface DepotFreight {
    /**
     * 
     * @type {string}
     * @memberof DepotFreight
     */
    customFreightId?: string;
    /**
     * 
     * @type {Array<FreightWithTO>}
     * @memberof DepotFreight
     */
    incomingFreight?: Array<FreightWithTO>;
    /**
     * 
     * @type {Array<FreightWithTO>}
     * @memberof DepotFreight
     */
    outgoingFreight?: Array<FreightWithTO>;
    /**
     * 
     * @type {string}
     * @memberof DepotFreight
     */
    state?: DepotFreight.StateEnum;
}

/**
 * @export
 * @namespace DepotFreight
 */
export namespace DepotFreight {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        INCOMING = 'INCOMING',
        STORED = 'STORED',
        OUTGOING = 'OUTGOING',
        FETCHED = 'FETCHED',
        DELIVERED = 'DELIVERED'
    }
}

/**
 * 
 * @export
 * @interface DepotFreightResponse
 */
export interface DepotFreightResponse {
    /**
     * 
     * @type {Array<DepotFreight>}
     * @memberof DepotFreightResponse
     */
    freightInDepot?: Array<DepotFreight>;
}

/**
 * 
 * @export
 * @interface DepotMonitorViewConfiguration
 */
export interface DepotMonitorViewConfiguration {
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof DepotMonitorViewConfiguration
     */
    additionalColumns?: Array<AdditionalTableColumn>;
}

/**
 * 
 * @export
 * @interface DescartesExport
 */
export interface DescartesExport {
    /**
     * 
     * @type {string}
     * @memberof DescartesExport
     */
    exportFreightStatusScript?: string;
    /**
     * 
     * @type {string}
     * @memberof DescartesExport
     */
    exportStopLocationStatusScript?: string;
    /**
     * 
     * @type {string}
     * @memberof DescartesExport
     */
    exportTransportOrderStatusScript?: string;
}

/**
 * 
 * @export
 * @interface DescartesImporterConfiguration
 */
export interface DescartesImporterConfiguration {
    /**
     * 
     * @type {string}
     * @memberof DescartesImporterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {DescartesExport}
     * @memberof DescartesImporterConfiguration
     */
    _export?: DescartesExport;
    /**
     * 
     * @type {string}
     * @memberof DescartesImporterConfiguration
     */
    timezone?: string;
}

/**
 * 
 * @export
 * @interface DescribePatchsetRequest
 */
export interface DescribePatchsetRequest {
    /**
     * 
     * @type {string}
     * @memberof DescribePatchsetRequest
     */
    languageCode?: string;
    /**
     * 
     * @type {Array<PatchEntry>}
     * @memberof DescribePatchsetRequest
     */
    patchSet?: Array<PatchEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof DescribePatchsetRequest
     */
    shouldHighlightAsHtml?: boolean;
}

/**
 * 
 * @export
 * @interface DetermineResidenceTimesResult
 */
export interface DetermineResidenceTimesResult {
    /**
     * 
     * @type {Array<ResidenceTime>}
     * @memberof DetermineResidenceTimesResult
     */
    residenceTimes?: Array<ResidenceTime>;
    /**
     * 
     * @type {VehicleGeoFilterRequest}
     * @memberof DetermineResidenceTimesResult
     */
    vehicleGeoFilterRequest?: VehicleGeoFilterRequest;
}

/**
 * 
 * @export
 * @interface DetermineVehicleConfiguration
 */
export interface DetermineVehicleConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof DetermineVehicleConfiguration
     */
    emailReceiverOverride?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DetermineVehicleConfiguration
     */
    notifyIfMultipleVehiclesWereFound?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetermineVehicleConfiguration
     */
    notifyIfVehicleWasNotFound?: boolean;
}

/**
 * 
 * @export
 * @interface DhlImporterConfiguration
 */
export interface DhlImporterConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof DhlImporterConfiguration
     */
    combineFreightsOverStages?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DhlImporterConfiguration
     */
    dropPlaceholderStops?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DhlImporterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof DhlImporterConfiguration
     */
    postImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof DhlImporterConfiguration
     */
    timezone?: string;
}

/**
 * 
 * @export
 * @interface DisabledStaticRules
 */
export interface DisabledStaticRules {
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    addressMappingMissingDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    coordinateDivergingCheckDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    freightMappingMissingDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    freightToStopStatusInconsistentDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    manualReviewDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    missingKundenAuftraegeDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    shipmentMappingMissingDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    uniqueFreightIdDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    uniqueTransportIdDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledStaticRules
     */
    uniqueTransportIdStopIdDisabled?: boolean;
}

/**
 * 
 * @export
 * @interface DiscountRange
 */
export interface DiscountRange {
    /**
     * 
     * @type {number}
     * @memberof DiscountRange
     */
    applyWhenMoreThan?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountRange
     */
    discount?: number;
}

/**
 * 
 * @export
 * @interface DiscoveryServiceRequest
 */
export interface DiscoveryServiceRequest {
    /**
     * DiscoveryService Request
     * @type {string}
     * @memberof DiscoveryServiceRequest
     */
    collection?: string;
}

/**
 * 
 * @export
 * @interface DiscoveryServiceResponse
 */
export interface DiscoveryServiceResponse {
    /**
     * DiscoveryService Response
     * @type {Array<string>}
     * @memberof DiscoveryServiceResponse
     */
    filtrableProperties?: Array<string>;
}

/**
 * 
 * @export
 * @interface DisplayOptions
 */
export interface DisplayOptions {
    /**
     * 
     * @type {number}
     * @memberof DisplayOptions
     */
    column?: number;
    /**
     * 
     * @type {string}
     * @memberof DisplayOptions
     */
    group?: string;
}

/**
 * 
 * @export
 * @interface DoubleWithUnit
 */
export interface DoubleWithUnit {
    /**
     * 
     * @type {string}
     * @memberof DoubleWithUnit
     */
    unit?: DoubleWithUnit.UnitEnum;
    /**
     * 
     * @type {number}
     * @memberof DoubleWithUnit
     */
    value?: number;
}

/**
 * @export
 * @namespace DoubleWithUnit
 */
export namespace DoubleWithUnit {
    /**
     * @export
     * @enum {string}
     */
    export enum UnitEnum {
        Km = 'km',
        M = 'm',
        Mm = 'mm',
        Cm = 'cm',
        G = 'g',
        Kg = 'kg',
        MetricTon = 'metric_ton',
        S = 's',
        Sqm = 'sqm',
        Cbm = 'cbm',
        L = 'l',
        Ml = 'ml',
        ImpGal = 'imp_gal',
        UsLiqGal = 'us_liq_gal',
        UsDryGal = 'us_dry_gal',
        MetricGal = 'metric_gal',
        Foot = 'foot',
        Inch = 'inch',
        Yard = 'yard',
        ImpTon = 'imp_ton',
        Pound = 'pound',
        Quarter = 'quarter',
        Piece = 'piece',
        Bag = 'bag'
    }
}

/**
 * 
 * @export
 * @interface DoubleWithUnitFieldConfiguration
 */
export interface DoubleWithUnitFieldConfiguration {
    /**
     * 
     * @type {string}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    defaultValue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    isReadOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    isVisible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    maxValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    minValue?: string;
    /**
     * 
     * @type {number}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    sortIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof DoubleWithUnitFieldConfiguration
     */
    unitValue?: string;
}

/**
 * 
 * @export
 * @interface Driver
 */
export interface Driver {
    /**
     * ID of the driver
     * @type {string}
     * @memberof Driver
     */
    _id?: string;
    /**
     * Company which employs this driver.
     * @type {string}
     * @memberof Driver
     */
    companyId?: string;
    /**
     * Phone number of the driver
     * @type {string}
     * @memberof Driver
     */
    contactPhoneNr?: string;
    /**
     * Email address of the driver
     * @type {string}
     * @memberof Driver
     */
    emailAddress?: string;
    /**
     * User defined id field
     * @type {string}
     * @memberof Driver
     */
    externalDriverId?: string;
    /**
     * First name of the driver
     * @type {string}
     * @memberof Driver
     */
    firstName?: string;
    /**
     * Preferred communication language
     * @type {string}
     * @memberof Driver
     */
    language?: string;
    /**
     * Last name of the driver
     * @type {string}
     * @memberof Driver
     */
    lastName?: string;
}

/**
 * 
 * @export
 * @interface DriverListResponse
 */
export interface DriverListResponse {
    /**
     * 
     * @type {number}
     * @memberof DriverListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<Driver>}
     * @memberof DriverListResponse
     */
    drivers?: Array<Driver>;
}

/**
 * 
 * @export
 * @interface DriverPolyline
 */
export interface DriverPolyline {
    /**
     * 
     * @type {Driver}
     * @memberof DriverPolyline
     */
    driver?: Driver;
    /**
     * 
     * @type {string}
     * @memberof DriverPolyline
     */
    polyline?: string;
    /**
     * 
     * @type {Array<VehicleTrackSegment>}
     * @memberof DriverPolyline
     */
    vehicleTrackSegments?: Array<VehicleTrackSegment>;
}

/**
 * 
 * @export
 * @interface DriverRequest
 */
export interface DriverRequest {
    /**
     * Phone number of the driver
     * @type {string}
     * @memberof DriverRequest
     */
    contactPhoneNr?: string;
    /**
     * Email address of the driver
     * @type {string}
     * @memberof DriverRequest
     */
    emailAddress?: string;
    /**
     * User defined id field
     * @type {string}
     * @memberof DriverRequest
     */
    externalDriverId?: string;
    /**
     * First name of the driver
     * @type {string}
     * @memberof DriverRequest
     */
    firstName?: string;
    /**
     * Preferred communication language
     * @type {string}
     * @memberof DriverRequest
     */
    language?: string;
    /**
     * Last name of the driver
     * @type {string}
     * @memberof DriverRequest
     */
    lastName?: string;
}

/**
 * 
 * @export
 * @interface DriverWorkAndRestTimes
 */
export interface DriverWorkAndRestTimes {
    /**
     * 
     * @type {string}
     * @memberof DriverWorkAndRestTimes
     */
    _id?: string;
    /**
     * 
     * @type {Array<DtcoActivity>}
     * @memberof DriverWorkAndRestTimes
     */
    activities?: Array<DtcoActivity>;
    /**
     * 
     * @type {string}
     * @memberof DriverWorkAndRestTimes
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverWorkAndRestTimes
     */
    driverId?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverWorkAndRestTimes
     */
    externalDriverId?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverWorkAndRestTimes
     */
    spedionDriverId?: number;
    /**
     * 
     * @type {Date}
     * @memberof DriverWorkAndRestTimes
     */
    updatedAt?: Date;
}

/**
 * 
 * @export
 * @interface DriverWorkAndRestTimesUpsertRequest
 */
export interface DriverWorkAndRestTimesUpsertRequest {
    /**
     * 
     * @type {Array<DtcoActivity>}
     * @memberof DriverWorkAndRestTimesUpsertRequest
     */
    activities?: Array<DtcoActivity>;
    /**
     * 
     * @type {string}
     * @memberof DriverWorkAndRestTimesUpsertRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverWorkAndRestTimesUpsertRequest
     */
    externalDriverId?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverWorkAndRestTimesUpsertRequest
     */
    spedionDriverId?: number;
}

/**
 * 
 * @export
 * @interface DropCacheEntryRequest
 */
export interface DropCacheEntryRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DropCacheEntryRequest
     */
    cacheKeys?: Array<string>;
}

/**
 * 
 * @export
 * @interface DropCacheResponse
 */
export interface DropCacheResponse {
    /**
     * 
     * @type {number}
     * @memberof DropCacheResponse
     */
    numKeysDropped?: number;
}

/**
 * 
 * @export
 * @interface DtcoActivity
 */
export interface DtcoActivity {
    /**
     * 
     * @type {string}
     * @memberof DtcoActivity
     */
    activityType?: DtcoActivity.ActivityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DtcoActivity
     */
    cardState?: string;
    /**
     * 
     * @type {Date}
     * @memberof DtcoActivity
     */
    end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DtcoActivity
     */
    start?: Date;
}

/**
 * @export
 * @namespace DtcoActivity
 */
export namespace DtcoActivity {
    /**
     * @export
     * @enum {string}
     */
    export enum ActivityTypeEnum {
        WORK = 'WORK',
        BREAKREST = 'BREAK_REST',
        DRIVING = 'DRIVING',
        UNDEFINED = 'UNDEFINED'
    }
}

/**
 * 
 * @export
 * @interface DumpV2ActionFilter
 */
export interface DumpV2ActionFilter {
    /**
     * 
     * @type {Array<string>}
     * @memberof DumpV2ActionFilter
     */
    excludeTransportOrderChangeTypes?: Array<DumpV2ActionFilter.ExcludeTransportOrderChangeTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof DumpV2ActionFilter
     */
    includePositionEvents?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DumpV2ActionFilter
     */
    includeTransportOrderChangeTypes?: Array<DumpV2ActionFilter.IncludeTransportOrderChangeTypesEnum>;
}

/**
 * @export
 * @namespace DumpV2ActionFilter
 */
export namespace DumpV2ActionFilter {
    /**
     * @export
     * @enum {string}
     */
    export enum ExcludeTransportOrderChangeTypesEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IncludeTransportOrderChangeTypesEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface DuplicateImportNotificationConfiguration
 */
export interface DuplicateImportNotificationConfiguration {
    /**
     * If set, the notification is sent to these addresses instead of the sender (userEmail) of the imported document
     * @type {Array<string>}
     * @memberof DuplicateImportNotificationConfiguration
     */
    emailReceiverOverride?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateImportNotificationConfiguration
     */
    enabled?: boolean;
    /**
     * Only notify when the existing transport order was created more than this many hours ago. If not set, every duplicate import triggers the notification.
     * @type {number}
     * @memberof DuplicateImportNotificationConfiguration
     */
    minAgeOfExistingOrderInHours?: number;
}

/**
 * 
 * @export
 * @interface EdiAdditionalDataMapping
 */
export interface EdiAdditionalDataMapping {
    /**
     * 
     * @type {boolean}
     * @memberof EdiAdditionalDataMapping
     */
    _export?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EdiAdditionalDataMapping
     */
    externalKeyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EdiAdditionalDataMapping
     */
    _import?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EdiAdditionalDataMapping
     */
    logeniosKeyName?: string;
}

/**
 * 
 * @export
 * @interface EdiContainmentTypeMapping
 */
export interface EdiContainmentTypeMapping {
    /**
     * 
     * @type {string}
     * @memberof EdiContainmentTypeMapping
     */
    ediType?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiContainmentTypeMapping
     */
    logeniosType?: EdiContainmentTypeMapping.LogeniosTypeEnum;
}

/**
 * @export
 * @namespace EdiContainmentTypeMapping
 */
export namespace EdiContainmentTypeMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum LogeniosTypeEnum {
        EpalEurPallet = 'epalEurPallet',
        Epal2Pallet = 'epal2Pallet',
        Epal3Pallet = 'epal3Pallet',
        Epal6HalfPallet = 'epal6HalfPallet',
        Epal7HalfPallet = 'epal7HalfPallet',
        EpalBoxPallet = 'epalBoxPallet',
        ChepEuroPallet = 'chepEuroPallet',
        ChepHalfPallet = 'chepHalfPallet',
        ChepIndustrialPallet = 'chepIndustrialPallet',
        ChepPlasticEurPallet = 'chepPlasticEurPallet',
        ChepPlasticQuarterPallet = 'chepPlasticQuarterPallet',
        Pallet = 'pallet',
        PalletCollar = 'palletCollar',
        EurH1PlasticPallet = 'eurH1PlasticPallet',
        PaperSack = 'paperSack',
        InflatableBag = 'inflatableBag',
        Container20ft = 'container20ft',
        Container40ft = 'container40ft',
        Container45ft = 'container45ft',
        Container48ft = 'container48ft',
        Container53ft = 'container53ft',
        IbcContainer = 'ibcContainer',
        IntermediateBulkContainer = 'intermediateBulkContainer',
        IfcoTray = 'ifcoTray',
        SlipSheet = 'slipSheet',
        CagePallet = 'cagePallet',
        RollContainer = 'rollContainer',
        Bag = 'bag',
        Box = 'box',
        Piece = 'piece',
        Other = 'other'
    }
}

/**
 * 
 * @export
 * @interface EdiConverterConfiguration
 */
export interface EdiConverterConfiguration {
    /**
     * 
     * @type {string}
     * @memberof EdiConverterConfiguration
     */
    determineEncodingScript?: string;
    /**
     * 
     * @type {EdiDocumentDefinition}
     * @memberof EdiConverterConfiguration
     */
    documentDefinition?: EdiDocumentDefinition;
    /**
     * 
     * @type {Array<EdiExportConfiguration>}
     * @memberof EdiConverterConfiguration
     */
    exportConfigurations?: Array<EdiExportConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof EdiConverterConfiguration
     */
    fileEncoding?: string;
    /**
     * 
     * @type {Array<EdiMappingConfiguration>}
     * @memberof EdiConverterConfiguration
     */
    mappings?: Array<EdiMappingConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof EdiConverterConfiguration
     */
    preParseDocumentScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EdiConverterConfiguration
     */
    splitEdiMessageOnUNH?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EdiConverterConfiguration
     */
    timezone?: string;
}

/**
 * 
 * @export
 * @interface EdiConverterV2Configuration
 */
export interface EdiConverterV2Configuration {
    /**
     * 
     * @type {Array<EdiToImmediateFormatMapping>}
     * @memberof EdiConverterV2Configuration
     */
    ediToImmediateFormatMapping?: Array<EdiToImmediateFormatMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiConverterV2Configuration
     */
    fileEncoding?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiConverterV2Configuration
     */
    modifyMode?: EdiConverterV2Configuration.ModifyModeEnum;
}

/**
 * @export
 * @namespace EdiConverterV2Configuration
 */
export namespace EdiConverterV2Configuration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface EdiDocumentDefinition
 */
export interface EdiDocumentDefinition {
    /**
     * 
     * @type {Array<EdiNode>}
     * @memberof EdiDocumentDefinition
     */
    nodes?: Array<EdiNode>;
}

/**
 * 
 * @export
 * @interface EdiExportApplyWhenAll
 */
export interface EdiExportApplyWhenAll {
    /**
     * 
     * @type {string}
     * @memberof EdiExportApplyWhenAll
     */
    changeType?: EdiExportApplyWhenAll.ChangeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EdiExportApplyWhenAll
     */
    eventType?: EdiExportApplyWhenAll.EventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EdiExportApplyWhenAll
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiExportApplyWhenAll
     */
    sourceCompanyId?: string;
}

/**
 * @export
 * @namespace EdiExportApplyWhenAll
 */
export namespace EdiExportApplyWhenAll {
    /**
     * @export
     * @enum {string}
     */
    export enum ChangeTypeEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
}

/**
 * 
 * @export
 * @interface EdiExportConfiguration
 */
export interface EdiExportConfiguration {
    /**
     * 
     * @type {EdiExportApplyWhenAll}
     * @memberof EdiExportConfiguration
     */
    applyWhenAll?: EdiExportApplyWhenAll;
    /**
     * 
     * @type {string}
     * @memberof EdiExportConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiExportConfiguration
     */
    exportEtaKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiExportConfiguration
     */
    exportLinkEventKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiExportConfiguration
     */
    exportPositionKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiExportConfiguration
     */
    exportStatusKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiExportConfiguration
     */
    exportTransportOrderKotlinScript?: string;
}

/**
 * 
 * @export
 * @interface EdiFreightMapping
 */
export interface EdiFreightMapping {
    /**
     * 
     * @type {Array<EdiAdditionalDataMapping>}
     * @memberof EdiFreightMapping
     */
    additionals?: Array<EdiAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    containmentQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    containmentType?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    deliveryNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    externalFreightId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    freightId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    freightIdPrefix?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    height?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    heightUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    lengthUnit?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof EdiFreightMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalLoadingMeter?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalLoadingMeterUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalLots?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalQuantityUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalVolume?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalVolumeUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    totalWeightUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    width?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiFreightMapping
     */
    widthUnit?: string;
}

/**
 * 
 * @export
 * @interface EdiMappingConfiguration
 */
export interface EdiMappingConfiguration {
    /**
     * 
     * @type {Array<EdiContainmentTypeMapping>}
     * @memberof EdiMappingConfiguration
     */
    containmentTypeMapping?: Array<EdiContainmentTypeMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    externalTransportOrderIdSource?: string;
    /**
     * 
     * @type {EdiFreightMapping}
     * @memberof EdiMappingConfiguration
     */
    freightMapping?: EdiFreightMapping;
    /**
     * 
     * @type {Array<EdiSegmentScriptConfiguration>}
     * @memberof EdiMappingConfiguration
     */
    handleSegmentScript?: Array<EdiSegmentScriptConfiguration>;
    /**
     * 
     * @type {boolean}
     * @memberof EdiMappingConfiguration
     */
    importAllKeysAsAdditional?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    loadingLocationQualifier?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    mergeDuplicateSegmentsScript?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    modifyMode?: EdiMappingConfiguration.ModifyModeEnum;
    /**
     * 
     * @type {EdiPacketItemMapping}
     * @memberof EdiMappingConfiguration
     */
    packetItemMapping?: EdiPacketItemMapping;
    /**
     * 
     * @type {EdiPacketMapping}
     * @memberof EdiMappingConfiguration
     */
    packetMapping?: EdiPacketMapping;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    preImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    selector?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    selectorScript?: string;
    /**
     * 
     * @type {EdiStopActionMapping}
     * @memberof EdiMappingConfiguration
     */
    stopActionMapping?: EdiStopActionMapping;
    /**
     * 
     * @type {EdiStopLocationMapping}
     * @memberof EdiMappingConfiguration
     */
    stopLocationMapping?: EdiStopLocationMapping;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    targetCompanyQualifier?: string;
    /**
     * 
     * @type {EdiTransportMapping}
     * @memberof EdiMappingConfiguration
     */
    transportMapping?: EdiTransportMapping;
    /**
     * 
     * @type {EdiTransportOrderMapping}
     * @memberof EdiMappingConfiguration
     */
    transportOrderMapping?: EdiTransportOrderMapping;
    /**
     * 
     * @type {string}
     * @memberof EdiMappingConfiguration
     */
    unloadingLocationQualifier?: string;
}

/**
 * @export
 * @namespace EdiMappingConfiguration
 */
export namespace EdiMappingConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface EdiNode
 */
export interface EdiNode {
    /**
     * 
     * @type {Array<EdiNode>}
     * @memberof EdiNode
     */
    entries?: Array<EdiNode>;
    /**
     * 
     * @type {number}
     * @memberof EdiNode
     */
    maxOccurs?: number;
    /**
     * 
     * @type {string}
     * @memberof EdiNode
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EdiNode
     */
    required?: boolean;
}

/**
 * 
 * @export
 * @interface EdiPacketItemMapping
 */
export interface EdiPacketItemMapping {
    /**
     * 
     * @type {Array<EdiAdditionalDataMapping>}
     * @memberof EdiPacketItemMapping
     */
    additionals?: Array<EdiAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketItemMapping
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketItemMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketItemMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketItemMapping
     */
    packetItemId?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof EdiPacketItemMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketItemMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketItemMapping
     */
    weight?: string;
}

/**
 * 
 * @export
 * @interface EdiPacketMapping
 */
export interface EdiPacketMapping {
    /**
     * 
     * @type {Array<EdiAdditionalDataMapping>}
     * @memberof EdiPacketMapping
     */
    additionals?: Array<EdiAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketMapping
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketMapping
     */
    packetId?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof EdiPacketMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiPacketMapping
     */
    weight?: string;
}

/**
 * 
 * @export
 * @interface EdiSegmentScriptConfiguration
 */
export interface EdiSegmentScriptConfiguration {
    /**
     * 
     * @type {string}
     * @memberof EdiSegmentScriptConfiguration
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiSegmentScriptConfiguration
     */
    segment?: string;
}

/**
 * 
 * @export
 * @interface EdiStopActionMapping
 */
export interface EdiStopActionMapping {
    /**
     * 
     * @type {string}
     * @memberof EdiStopActionMapping
     */
    actionDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopActionMapping
     */
    actionId?: string;
    /**
     * 
     * @type {Array<EdiAdditionalDataMapping>}
     * @memberof EdiStopActionMapping
     */
    additionals?: Array<EdiAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiStopActionMapping
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopActionMapping
     */
    planStart?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopActionMapping
     */
    planStop?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof EdiStopActionMapping
     */
    script?: GroovyBasedMappingScript;
}

/**
 * 
 * @export
 * @interface EdiStopLocationMapping
 */
export interface EdiStopLocationMapping {
    /**
     * 
     * @type {Array<EdiAdditionalDataMapping>}
     * @memberof EdiStopLocationMapping
     */
    additionals?: Array<EdiAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    gs1GlobalLocationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    houseNr?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    longitude?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    openingHoursFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    openingHoursTo?: string;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiStopLocationMapping
     */
    planArriveAtLoadingLocation?: DateTimeMapping;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiStopLocationMapping
     */
    planArriveAtUnloadingLocation?: DateTimeMapping;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiStopLocationMapping
     */
    planDepartAtLoadingLocation?: DateTimeMapping;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiStopLocationMapping
     */
    planDepartAtUnloadingLocation?: DateTimeMapping;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof EdiStopLocationMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {boolean}
     * @memberof EdiStopLocationMapping
     */
    shouldAutoAssignStopId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    stopId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiStopLocationMapping
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface EdiToImmediateFormatMapping
 */
export interface EdiToImmediateFormatMapping {
    /**
     * 
     * @type {string}
     * @memberof EdiToImmediateFormatMapping
     */
    ediPath?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiToImmediateFormatMapping
     */
    immediateFormatKey?: string;
}

/**
 * 
 * @export
 * @interface EdiTransportMapping
 */
export interface EdiTransportMapping {
    /**
     * 
     * @type {Array<EdiAdditionalDataMapping>}
     * @memberof EdiTransportMapping
     */
    additionals?: Array<EdiAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportMapping
     */
    comment?: string;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiTransportMapping
     */
    planStart?: DateTimeMapping;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiTransportMapping
     */
    planStop?: DateTimeMapping;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportMapping
     */
    plannedDistance?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof EdiTransportMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportMapping
     */
    shipmentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportMapping
     */
    transportId?: string;
}

/**
 * 
 * @export
 * @interface EdiTransportOrderMapping
 */
export interface EdiTransportOrderMapping {
    /**
     * 
     * @type {Array<EdiAdditionalDataMapping>}
     * @memberof EdiTransportOrderMapping
     */
    additionals?: Array<EdiAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedDeviceLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedDevicePhoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedDeviceVerboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedDriverExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedDriverFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedDriverLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedDriverPhoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedTrailerExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedTrailerNumberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedVehicleExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    assignedVehicleNumberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    comment?: string;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiTransportOrderMapping
     */
    created?: DateTimeMapping;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    createdSelector?: EdiTransportOrderMapping.CreatedSelectorEnum;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    externalTargetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiTransportOrderMapping
     */
    planStart?: DateTimeMapping;
    /**
     * 
     * @type {DateTimeMapping}
     * @memberof EdiTransportOrderMapping
     */
    planStop?: DateTimeMapping;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof EdiTransportOrderMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    targetCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    targetCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    transportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof EdiTransportOrderMapping
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace EdiTransportOrderMapping
 */
export namespace EdiTransportOrderMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum CreatedSelectorEnum {
        Date = 'Date',
        Time = 'Time',
        DateTime = 'DateTime',
        WindowBegin = 'WindowBegin',
        WindowEnd = 'WindowEnd'
    }
}

/**
 * 
 * @export
 * @interface EditIterationRequest
 */
export interface EditIterationRequest {
    /**
     * 
     * @type {number}
     * @memberof EditIterationRequest
     */
    iterationIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof EditIterationRequest
     */
    newFunctionCallResult?: string;
    /**
     * 
     * @type {string}
     * @memberof EditIterationRequest
     */
    taskId?: string;
}

/**
 * 
 * @export
 * @interface Edl12ToAdditionalDataMapping
 */
export interface Edl12ToAdditionalDataMapping {
    /**
     * 
     * @type {string}
     * @memberof Edl12ToAdditionalDataMapping
     */
    edl12AttributeName?: string;
    /**
     * 
     * @type {string}
     * @memberof Edl12ToAdditionalDataMapping
     */
    logeniosAdditionalDataKey?: string;
}

/**
 * 
 * @export
 * @interface EffectiveUser
 */
export interface EffectiveUser {
    /**
     * 
     * @type {string}
     * @memberof EffectiveUser
     */
    db?: string;
    /**
     * 
     * @type {string}
     * @memberof EffectiveUser
     */
    user?: string;
}

/**
 * 
 * @export
 * @interface ElemicaConfiguration
 */
export interface ElemicaConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ElemicaConfiguration
     */
    encoding?: string;
}

/**
 * 
 * @export
 * @interface EmailNotification
 */
export interface EmailNotification {
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailNotification
     */
    receivers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmailNotification
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailNotification
     */
    title?: string;
}

/**
 * 
 * @export
 * @interface EmailRequest
 */
export interface EmailRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailRequest
     */
    email?: string;
}

/**
 * 
 * @export
 * @interface EmptyKilometersReportRequest
 */
export interface EmptyKilometersReportRequest {
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRequest
     */
    sinceTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRequest
     */
    toTimestamp?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmptyKilometersReportRequest
     */
    vehicles?: Array<string>;
}

/**
 * 
 * @export
 * @interface EmptyKilometersReportResponse
 */
export interface EmptyKilometersReportResponse {
    /**
     * 
     * @type {Array<EmptyKilometersReportRow>}
     * @memberof EmptyKilometersReportResponse
     */
    rows?: Array<EmptyKilometersReportRow>;
}

/**
 * 
 * @export
 * @interface EmptyKilometersReportRow
 */
export interface EmptyKilometersReportRow {
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportRow
     */
    actualTourDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    calculationReason?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    customer?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    emptyKm?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    emptyKmSource?: EmptyKilometersReportRow.EmptyKmSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    firstStopCity?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    firstStopLatitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    firstStopLongitude?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    groupLabel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmptyKilometersReportRow
     */
    hints?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    lastStopCity?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    lastStopLatitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    lastStopLongitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportRow
     */
    mapWindowFrom?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    mapWindowSource?: EmptyKilometersReportRow.MapWindowSourceEnum;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportRow
     */
    mapWindowTo?: Date;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    odometerEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    odometerSource?: EmptyKilometersReportRow.OdometerSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    odometerStart?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    plausibility?: EmptyKilometersReportRow.PlausibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    previousLastStopCity?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    previousLastStopLatitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    previousLastStopLongitude?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    previousTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmptyKilometersReportRow
     */
    properlyExecuted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmptyKilometersReportRow
     */
    provisional?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    statusCode?: EmptyKilometersReportRow.StatusCodeEnum;
    /**
     * 
     * @type {Array<EmptyKilometersReportStop>}
     * @memberof EmptyKilometersReportRow
     */
    stops?: Array<EmptyKilometersReportStop>;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportRow
     */
    tourDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportRow
     */
    tourKm?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    tourKmSource?: EmptyKilometersReportRow.TourKmSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportRow
     */
    usedFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportRow
     */
    usedTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportRow
     */
    vehicleNumberPlate?: string;
}

/**
 * @export
 * @namespace EmptyKilometersReportRow
 */
export namespace EmptyKilometersReportRow {
    /**
     * @export
     * @enum {string}
     */
    export enum EmptyKmSourceEnum {
        FMSBOUNDARY = 'FMS_BOUNDARY',
        GPSTRACKFALLBACK = 'GPS_TRACK_FALLBACK',
        NONE = 'NONE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MapWindowSourceEnum {
        ACTUAL = 'ACTUAL',
        PLAN = 'PLAN',
        INFERREDFROMNEIGHBOURS = 'INFERRED_FROM_NEIGHBOURS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OdometerSourceEnum {
        FMS = 'FMS',
        VIRTUAL = 'VIRTUAL',
        VIRTUALPARTIAL = 'VIRTUAL_PARTIAL',
        NONE = 'NONE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PlausibilityEnum {
        OK = 'OK',
        NEGATIVE = 'NEGATIVE',
        IMPLAUSIBLEHIGH = 'IMPLAUSIBLE_HIGH',
        MISSINGDATA = 'MISSING_DATA',
        INGROUP = 'IN_GROUP'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TourKmSourceEnum {
        FMSBOUNDARY = 'FMS_BOUNDARY',
        GPSTRACKFALLBACK = 'GPS_TRACK_FALLBACK',
        NONE = 'NONE'
    }
}

/**
 * 
 * @export
 * @interface EmptyKilometersReportStop
 */
export interface EmptyKilometersReportStop {
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportStop
     */
    actualArrive?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportStop
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersReportStop
     */
    kind?: EmptyKilometersReportStop.KindEnum;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportStop
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportStop
     */
    longitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersReportStop
     */
    planArrive?: Date;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersReportStop
     */
    sequence?: number;
}

/**
 * @export
 * @namespace EmptyKilometersReportStop
 */
export namespace EmptyKilometersReportStop {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        LOADANDUNLOAD = 'LOAD_AND_UNLOAD',
        OTHER = 'OTHER'
    }
}

/**
 * 
 * @export
 * @interface EmptyKilometersRunDetailsRequest
 */
export interface EmptyKilometersRunDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsRequest
     */
    previousTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsRequest
     */
    sinceTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsRequest
     */
    toTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsRequest
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface EmptyKilometersRunDetailsResponse
 */
export interface EmptyKilometersRunDetailsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    driverNames?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    dtcoAvailable?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    from?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    fromCity?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    gpsDistanceKm?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    gpsDrivingSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    gpsStandingSeconds?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    hints?: Array<string>;
    /**
     * 
     * @type {Array<EmptyRunSegment>}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    segments?: Array<EmptyRunSegment>;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    to?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    toCity?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    transportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersRunDetailsResponse
     */
    vehicleNumberPlate?: string;
}

/**
 * 
 * @export
 * @interface EmptyKilometersSegment
 */
export interface EmptyKilometersSegment {
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    currentExternalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    currentTransportOrderId?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    emptyKm?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    fromCity?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    fromLatitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    fromLongitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersSegment
     */
    fromTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    groupLabel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmptyKilometersSegment
     */
    hints?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    odometerEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    odometerSource?: EmptyKilometersSegment.OdometerSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    odometerStart?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    plausibility?: EmptyKilometersSegment.PlausibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    previousExternalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    previousTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmptyKilometersSegment
     */
    provisional?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    toCity?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    toLatitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    toLongitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof EmptyKilometersSegment
     */
    toTimestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof EmptyKilometersSegment
     */
    tourKm?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyKilometersSegment
     */
    vehicleNumberPlate?: string;
}

/**
 * @export
 * @namespace EmptyKilometersSegment
 */
export namespace EmptyKilometersSegment {
    /**
     * @export
     * @enum {string}
     */
    export enum OdometerSourceEnum {
        FMS = 'FMS',
        VIRTUAL = 'VIRTUAL',
        VIRTUALPARTIAL = 'VIRTUAL_PARTIAL',
        NONE = 'NONE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PlausibilityEnum {
        OK = 'OK',
        NEGATIVE = 'NEGATIVE',
        IMPLAUSIBLEHIGH = 'IMPLAUSIBLE_HIGH',
        MISSINGDATA = 'MISSING_DATA',
        INGROUP = 'IN_GROUP'
    }
}

/**
 * 
 * @export
 * @interface EmptyRunDtcoActivity
 */
export interface EmptyRunDtcoActivity {
    /**
     * 
     * @type {string}
     * @memberof EmptyRunDtcoActivity
     */
    activityType?: EmptyRunDtcoActivity.ActivityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmptyRunDtcoActivity
     */
    driverName?: string;
    /**
     * 
     * @type {Date}
     * @memberof EmptyRunDtcoActivity
     */
    end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmptyRunDtcoActivity
     */
    start?: Date;
}

/**
 * @export
 * @namespace EmptyRunDtcoActivity
 */
export namespace EmptyRunDtcoActivity {
    /**
     * @export
     * @enum {string}
     */
    export enum ActivityTypeEnum {
        WORK = 'WORK',
        BREAKREST = 'BREAK_REST',
        DRIVING = 'DRIVING',
        UNDEFINED = 'UNDEFINED'
    }
}

/**
 * 
 * @export
 * @interface EmptyRunSegment
 */
export interface EmptyRunSegment {
    /**
     * 
     * @type {string}
     * @memberof EmptyRunSegment
     */
    addressName?: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyRunSegment
     */
    city?: string;
    /**
     * 
     * @type {number}
     * @memberof EmptyRunSegment
     */
    distanceKm?: number;
    /**
     * 
     * @type {Array<EmptyRunDtcoActivity>}
     * @memberof EmptyRunSegment
     */
    dtcoActivities?: Array<EmptyRunDtcoActivity>;
    /**
     * 
     * @type {number}
     * @memberof EmptyRunSegment
     */
    durationSeconds?: number;
    /**
     * 
     * @type {Date}
     * @memberof EmptyRunSegment
     */
    from?: Date;
    /**
     * 
     * @type {number}
     * @memberof EmptyRunSegment
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EmptyRunSegment
     */
    longitude?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmptyRunSegment
     */
    nextTourFirstStop?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmptyRunSegment
     */
    previousTourLastStop?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EmptyRunSegment
     */
    sequence?: number;
    /**
     * 
     * @type {string}
     * @memberof EmptyRunSegment
     */
    state?: EmptyRunSegment.StateEnum;
    /**
     * 
     * @type {Date}
     * @memberof EmptyRunSegment
     */
    to?: Date;
}

/**
 * @export
 * @namespace EmptyRunSegment
 */
export namespace EmptyRunSegment {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        DRIVING = 'DRIVING',
        STANDING = 'STANDING',
        ARRIVED = 'ARRIVED'
    }
}

/**
 * 
 * @export
 * @interface Envelope
 */
export interface Envelope {
    /**
     * 
     * @type {string}
     * @memberof Envelope
     */
    sender?: string;
    /**
     * 
     * @type {string}
     * @memberof Envelope
     */
    sending_ip?: string;
    /**
     * 
     * @type {string}
     * @memberof Envelope
     */
    targets?: string;
    /**
     * 
     * @type {string}
     * @memberof Envelope
     */
    transport?: string;
}

/**
 * 
 * @export
 * @interface ErrorFilesMonitoring
 */
export interface ErrorFilesMonitoring {
    /**
     * 
     * @type {boolean}
     * @memberof ErrorFilesMonitoring
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ErrorFilesMonitoring
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorFilesMonitoring
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorFilesMonitoring
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorFilesMonitoring
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorFilesMonitoring
     */
    level?: ErrorFilesMonitoring.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof ErrorFilesMonitoring
     */
    message?: string;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof ErrorFilesMonitoring
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof ErrorFilesMonitoring
     */
    title?: string;
}

/**
 * @export
 * @namespace ErrorFilesMonitoring
 */
export namespace ErrorFilesMonitoring {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface Eta
 */
export interface Eta {
    /**
     * 
     * @type {number}
     * @memberof Eta
     */
    addedStaticErrorInMinutes?: number;
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof Eta
     */
    additionalDataEntries?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof Eta
     */
    algo?: string;
    /**
     * 
     * @type {number}
     * @memberof Eta
     */
    averageDrivingSpeed?: number;
    /**
     * 
     * @type {GpsPosition}
     * @memberof Eta
     */
    calculationPosition?: GpsPosition;
    /**
     * 
     * @type {Date}
     * @memberof Eta
     */
    calculationTimestamp?: Date;
    /**
     * 
     * @type {DartDelayResult}
     * @memberof Eta
     */
    dartDelayResult?: DartDelayResult;
    /**
     * 
     * @type {number}
     * @memberof Eta
     */
    distanceToPreviousPosition?: number;
    /**
     * 
     * @type {Date}
     * @memberof Eta
     */
    eta?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Eta
     */
    isDriving?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Eta
     */
    liveLink?: string;
    /**
     * 
     * @type {number}
     * @memberof Eta
     */
    remainingAdditionalPauseTime?: number;
    /**
     * 
     * @type {number}
     * @memberof Eta
     */
    remainingDistanceInM?: number;
    /**
     * 
     * @type {number}
     * @memberof Eta
     */
    remainingDriveTime?: number;
    /**
     * 
     * @type {number}
     * @memberof Eta
     */
    remainingWorkingTime?: number;
}

/**
 * 
 * @export
 * @interface EtaCalculation
 */
export interface EtaCalculation {
    /**
     * 
     * @type {Date}
     * @memberof EtaCalculation
     */
    calculationTimestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof EtaCalculation
     */
    diffBetweenCalculatedEtaAndRealArrivalInMinutes?: number;
    /**
     * 
     * @type {Eta}
     * @memberof EtaCalculation
     */
    eta?: Eta;
    /**
     * 
     * @type {Date}
     * @memberof EtaCalculation
     */
    realArrivalTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof EtaCalculation
     */
    remainingDistanceInKm?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCalculation
     */
    remainingTimeBetweenArrivalTimeAndEtaCreationInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCalculation
     */
    speed?: number;
    /**
     * 
     * @type {string}
     * @memberof EtaCalculation
     */
    vehicleId?: string;
    /**
     * 
     * @type {string}
     * @memberof EtaCalculation
     */
    vehicleType?: EtaCalculation.VehicleTypeEnum;
}

/**
 * @export
 * @namespace EtaCalculation
 */
export namespace EtaCalculation {
    /**
     * @export
     * @enum {string}
     */
    export enum VehicleTypeEnum {
        TRAILER = 'TRAILER',
        CAR = 'CAR',
        TRANSPORTER = 'TRANSPORTER',
        TRUCK75T = 'TRUCK_7_5T',
        TRUCK1199T = 'TRUCK_11_99T',
        TRUCK18T = 'TRUCK_18T',
        TRUCK40T = 'TRUCK_40T',
        TRUCKTRAILER = 'TRUCK_TRAILER',
        TANKERTRUCK = 'TANKER_TRUCK'
    }
}

/**
 * 
 * @export
 * @interface EtaCalculatorCompanys
 */
export interface EtaCalculatorCompanys {
    /**
     * 
     * @type {Array<Company>}
     * @memberof EtaCalculatorCompanys
     */
    companiesWithConfig?: Array<Company>;
}

/**
 * 
 * @export
 * @interface EtaCalculatorEventsResponse
 */
export interface EtaCalculatorEventsResponse {
    /**
     * 
     * @type {number}
     * @memberof EtaCalculatorEventsResponse
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCalculatorEventsResponse
     */
    countTimeInMs?: number;
    /**
     * 
     * @type {Array<BackendToEtaCalculatorEvent>}
     * @memberof EtaCalculatorEventsResponse
     */
    events?: Array<BackendToEtaCalculatorEvent>;
    /**
     * 
     * @type {number}
     * @memberof EtaCalculatorEventsResponse
     */
    fetchTimeInMs?: number;
}

/**
 * 
 * @export
 * @interface EtaChangeEvent
 */
export interface EtaChangeEvent {
    /**
     * 
     * @type {string}
     * @memberof EtaChangeEvent
     */
    backendToEtaEventId?: string;
    /**
     * 
     * @type {GpsPosition}
     * @memberof EtaChangeEvent
     */
    currentPosition?: GpsPosition;
    /**
     * 
     * @type {Driver}
     * @memberof EtaChangeEvent
     */
    driver?: Driver;
    /**
     * 
     * @type {Array<string>}
     * @memberof EtaChangeEvent
     */
    nextStopIds?: Array<string>;
    /**
     * 
     * @type {TransportOrder}
     * @memberof EtaChangeEvent
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {Vehicle}
     * @memberof EtaChangeEvent
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface EtaConfig
 */
export interface EtaConfig {
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    acceptEtasFromTargetLinkedTransportOrders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    calculateActualTollAmountOnTourFinish?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    calculateAdditionalPauseTimeBasedOnRemainingSlackTime?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    calculateEtaForSplittedLinkedTours?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    calculateRouteInfoOnTourCreateOrUpdate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    calculateTollAmountOnTourCreateOrUpdate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EtaConfig
     */
    calculationMode?: EtaConfig.CalculationModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    cancelOldUnprocessedEtaEventsForTransportOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    compensateStaticCalculationErrors?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EtaConfig
     */
    custom?: EtaConfig.CustomEnum;
    /**
     * 
     * @type {DartConfig}
     * @memberof EtaConfig
     */
    dartConfig?: DartConfig;
    /**
     * 
     * @type {number}
     * @memberof EtaConfig
     */
    drivingSpeedCorrectionFactor?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaConfig
     */
    estimatedDurationAtStopLocationInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof EtaConfig
     */
    etaSource?: EtaConfig.EtaSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    setNextStopToApproaching?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    useShallowEtaEvents?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtaConfig
     */
    useTabuSearch?: boolean;
}

/**
 * @export
 * @namespace EtaConfig
 */
export namespace EtaConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum CalculationModeEnum {
        ONLYAPPROACHINGSTOP = 'ONLY_APPROACHING_STOP',
        TOURBASED = 'TOUR_BASED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CustomEnum {
        PTVPORSCHE = 'PTV_PORSCHE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum EtaSourceEnum {
        PTV = 'PTV',
        GRAPHHOPPER = 'GRAPHHOPPER',
        OSRM = 'OSRM',
        COMPANY = 'COMPANY',
        NONE = 'NONE',
        ORS = 'ORS',
        CUSTOM = 'CUSTOM'
    }
}

/**
 * 
 * @export
 * @interface EtaCorrectionAverageResult
 */
export interface EtaCorrectionAverageResult {
    /**
     * 
     * @type {number}
     * @memberof EtaCorrectionAverageResult
     */
    averageAddedStaticOffsetInMin?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCorrectionAverageResult
     */
    averageCalculationErrorInMin?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCorrectionAverageResult
     */
    averageDifferenceBetweenPlanArriveAndActualArriveInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCorrectionAverageResult
     */
    averageDifferenceBetweenPlanDepartAndActualArriveInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCorrectionAverageResult
     */
    numSamples?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaCorrectionAverageResult
     */
    numTransportOrders?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EtaCorrectionAverageResult
     */
    orderIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface EtaCorrectionSampleRequest
 */
export interface EtaCorrectionSampleRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof EtaCorrectionSampleRequest
     */
    algos?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EtaCorrectionSampleRequest
     */
    destinationCity?: string;
    /**
     * 
     * @type {string}
     * @memberof EtaCorrectionSampleRequest
     */
    orderIdPrefix?: string;
    /**
     * 
     * @type {string}
     * @memberof EtaCorrectionSampleRequest
     */
    planArriveTime?: string;
}

/**
 * 
 * @export
 * @interface EtaEvent
 */
export interface EtaEvent {
    /**
     * 
     * @type {string}
     * @memberof EtaEvent
     */
    backendToEtaEventId?: string;
    /**
     * 
     * @type {GpsPosition}
     * @memberof EtaEvent
     */
    currentPosition?: GpsPosition;
    /**
     * 
     * @type {Driver}
     * @memberof EtaEvent
     */
    driver?: Driver;
    /**
     * 
     * @type {Array<StopLocation>}
     * @memberof EtaEvent
     */
    nextStops?: Array<StopLocation>;
    /**
     * 
     * @type {Date}
     * @memberof EtaEvent
     */
    timestamp?: Date;
    /**
     * 
     * @type {TransportOrder}
     * @memberof EtaEvent
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {Vehicle}
     * @memberof EtaEvent
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface EtaFieldViewConfiguration
 */
export interface EtaFieldViewConfiguration {
    /**
     * 
     * @type {string}
     * @memberof EtaFieldViewConfiguration
     */
    defaultLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof EtaFieldViewConfiguration
     */
    etaFormat?: EtaFieldViewConfiguration.EtaFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EtaFieldViewConfiguration
     */
    isVisible?: boolean;
    /**
     * 
     * @type {Array<LocalizedLabel>}
     * @memberof EtaFieldViewConfiguration
     */
    localizedLabels?: Array<LocalizedLabel>;
    /**
     * 
     * @type {number}
     * @memberof EtaFieldViewConfiguration
     */
    sortIndex?: number;
}

/**
 * @export
 * @namespace EtaFieldViewConfiguration
 */
export namespace EtaFieldViewConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum EtaFormatEnum {
        REMAININGTIME = 'REMAINING_TIME',
        DATETIMEOFARRIVAL = 'DATETIME_OF_ARRIVAL'
    }
}

/**
 * 
 * @export
 * @interface EtaPatchRequest
 */
export interface EtaPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof EtaPatchRequest
     */
    backendToEtaEventId?: string;
    /**
     * 
     * @type {GpsPosition}
     * @memberof EtaPatchRequest
     */
    currentPosition?: GpsPosition;
    /**
     * 
     * @type {Driver}
     * @memberof EtaPatchRequest
     */
    driver?: Driver;
    /**
     * 
     * @type {TourEtaInfo}
     * @memberof EtaPatchRequest
     */
    etaInfo?: TourEtaInfo;
    /**
     * 
     * @type {Array<EtaTransportStopEvent>}
     * @memberof EtaPatchRequest
     */
    etaToStops?: Array<EtaTransportStopEvent>;
    /**
     * 
     * @type {Vehicle}
     * @memberof EtaPatchRequest
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface EtaProcessedRequest
 */
export interface EtaProcessedRequest {
    /**
     * 
     * @type {string}
     * @memberof EtaProcessedRequest
     */
    errorString?: string;
    /**
     * 
     * @type {string}
     * @memberof EtaProcessedRequest
     */
    id?: string;
}

/**
 * 
 * @export
 * @interface EtaQualityReportDay
 */
export interface EtaQualityReportDay {
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    averageAddedStaticOffsetInMin?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    averageCalculationErrorInMin?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    averageDifferenceBetweenPlanArriveAndActualArriveInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    averageDifferenceBetweenPlanDepartAndActualArriveInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    averageMaxSlackTimeInMin?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    averageMinSlackTimeInMin?: number;
    /**
     * 
     * @type {string}
     * @memberof EtaQualityReportDay
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    numSamples?: number;
    /**
     * 
     * @type {number}
     * @memberof EtaQualityReportDay
     */
    numTransportOrders?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EtaQualityReportDay
     */
    orderIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface EtaQualityReportRequest
 */
export interface EtaQualityReportRequest {
    /**
     * 
     * @type {string}
     * @memberof EtaQualityReportRequest
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof EtaQualityReportRequest
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EtaQualityReportRequest
     */
    to?: Date;
}

/**
 * 
 * @export
 * @interface EtaQualityReportResponse
 */
export interface EtaQualityReportResponse {
    /**
     * 
     * @type {Array<EtaQualityReportDay>}
     * @memberof EtaQualityReportResponse
     */
    days?: Array<EtaQualityReportDay>;
}

/**
 * 
 * @export
 * @interface EtaTestEventRequest
 */
export interface EtaTestEventRequest {
    /**
     * 
     * @type {string}
     * @memberof EtaTestEventRequest
     */
    backendToEtaEventId?: string;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof EtaTestEventRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {string}
     * @memberof EtaTestEventRequest
     */
    configCompanyId?: string;
    /**
     * 
     * @type {Driver}
     * @memberof EtaTestEventRequest
     */
    driver?: Driver;
    /**
     * 
     * @type {Eta}
     * @memberof EtaTestEventRequest
     */
    eta?: Eta;
    /**
     * 
     * @type {GpsPosition}
     * @memberof EtaTestEventRequest
     */
    position?: GpsPosition;
    /**
     * 
     * @type {TransportOrder}
     * @memberof EtaTestEventRequest
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof EtaTestEventRequest
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof EtaTestEventRequest
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface EtaTransportStopEvent
 */
export interface EtaTransportStopEvent {
    /**
     * 
     * @type {string}
     * @memberof EtaTransportStopEvent
     */
    errorString?: string;
    /**
     * 
     * @type {Eta}
     * @memberof EtaTransportStopEvent
     */
    eta?: Eta;
    /**
     * 
     * @type {string}
     * @memberof EtaTransportStopEvent
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof EtaTransportStopEvent
     */
    uniqueLocationId?: string;
}

/**
 * 
 * @export
 * @interface EventAdditionalInformation
 */
export interface EventAdditionalInformation {
    /**
     * 
     * @type {string}
     * @memberof EventAdditionalInformation
     */
    info?: string;
    /**
     * 
     * @type {string}
     * @memberof EventAdditionalInformation
     */
    recipientAddress?: string;
}

/**
 * 
 * @export
 * @interface EventData
 */
export interface EventData {
    /**
     * 
     * @type {Array<Any>}
     * @memberof EventData
     */
    campaigns?: Array<Any>;
    /**
     * 
     * @type {DeliveryStatus}
     * @memberof EventData
     */
    delivery_status?: DeliveryStatus;
    /**
     * 
     * @type {Envelope}
     * @memberof EventData
     */
    envelope?: Envelope;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    event?: string;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    log_level?: string;
    /**
     * 
     * @type {Message}
     * @memberof EventData
     */
    message?: Message;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    recipient?: string;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    recipient_domain?: string;
    /**
     * 
     * @type {Storage}
     * @memberof EventData
     */
    storage?: Storage;
    /**
     * 
     * @type {Array<Any>}
     * @memberof EventData
     */
    tags?: Array<Any>;
    /**
     * 
     * @type {string}
     * @memberof EventData
     */
    timestamp?: string;
}

/**
 * 
 * @export
 * @interface EventMirroringRules
 */
export interface EventMirroringRules {
    /**
     * 
     * @type {boolean}
     * @memberof EventMirroringRules
     */
    mirrorTextMessageEvents?: boolean;
    /**
     * 
     * @type {TransportOrderEventMirroringRules}
     * @memberof EventMirroringRules
     */
    transportOrderEvents?: TransportOrderEventMirroringRules;
}

/**
 * 
 * @export
 * @interface EventSuppressionRules
 */
export interface EventSuppressionRules {
    /**
     * 
     * @type {boolean}
     * @memberof EventSuppressionRules
     */
    suppressDeliveredEvents?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventSuppressionRules
     */
    suppressEventTypes?: Array<EventSuppressionRules.SuppressEventTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventSuppressionRules
     */
    suppressEventsFromCompaniesWithIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EventSuppressionRules
     */
    suppressInputMissingEvents?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventSuppressionRules
     */
    suppressLinkEvents?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventSuppressionRules
     */
    suppressStatusUpdateObserverEvents?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventSuppressionRules
     */
    suppressSystemStatusNotificationEvents?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventSuppressionRules
     */
    suppressTransportOrderEvents?: Array<EventSuppressionRules.SuppressTransportOrderEventsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof EventSuppressionRules
     */
    suppressUpdateEventsThatAreCoocurringWithAssignEvents?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventSuppressionRules
     */
    suppressUpdateEventsWithIrrelevantChangesForHumans?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventSuppressionRules
     */
    suppressionScript?: string;
}

/**
 * @export
 * @namespace EventSuppressionRules
 */
export namespace EventSuppressionRules {
    /**
     * @export
     * @enum {string}
     */
    export enum SuppressEventTypesEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SuppressTransportOrderEventsEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface ExcelExportField
 */
export interface ExcelExportField {
    /**
     * 
     * @type {boolean}
     * @memberof ExcelExportField
     */
    isVisible?: boolean;
}

/**
 * 
 * @export
 * @interface ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
 */
export interface ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest {
    /**
     * 
     * @type {string}
     * @memberof ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
     */
    action?: ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest.ActionEnum;
    /**
     * 
     * @type {string}
     * @memberof ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
     */
    ticketNrs?: string;
}

/**
 * @export
 * @namespace ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
 */
export namespace ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionEnum {
        EXCLUDE = 'EXCLUDE',
        INCLUDE = 'INCLUDE'
    }
}

/**
 * 
 * @export
 * @interface ExcludeCompanyFromUnbilledTransportOrdersCalculationResponse
 */
export interface ExcludeCompanyFromUnbilledTransportOrdersCalculationResponse {
    /**
     * 
     * @type {string}
     * @memberof ExcludeCompanyFromUnbilledTransportOrdersCalculationResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExcludeCompanyFromUnbilledTransportOrdersCalculationResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface ExcludedFromUnbilledOrdersCalculationInfo
 */
export interface ExcludedFromUnbilledOrdersCalculationInfo {
    /**
     * 
     * @type {string}
     * @memberof ExcludedFromUnbilledOrdersCalculationInfo
     */
    by?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcludedFromUnbilledOrdersCalculationInfo
     */
    reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExcludedFromUnbilledOrdersCalculationInfo
     */
    since?: Date;
}

/**
 * 
 * @export
 * @interface ExecuteFunctionResponse
 */
export interface ExecuteFunctionResponse {
    /**
     * 
     * @type {string}
     * @memberof ExecuteFunctionResponse
     */
    documentationType?: ExecuteFunctionResponse.DocumentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExecuteFunctionResponse
     */
    executeFunc?: ExecuteFunctionResponse.ExecuteFuncEnum;
    /**
     * 
     * @type {string}
     * @memberof ExecuteFunctionResponse
     */
    functionCallResult?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecuteFunctionResponse
     */
    query?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecuteFunctionResponse
     */
    script?: string;
}

/**
 * @export
 * @namespace ExecuteFunctionResponse
 */
export namespace ExecuteFunctionResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum DocumentationTypeEnum {
        LISDOCUMENTATION = 'GET_LIS_DOCUMENTATION',
        TRANSLOGICADOCUMENTATION = 'GET_TRANSLOGICA_DOCUMENTATION',
        LOGENIOSENVIRONMENTDOCUMENTATION = 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION',
        AIENVDOCUMENTATION = 'GET_AIENV_DOCUMENTATION',
        TRANSDATADOCUMENTATION = 'GET_TRANSDATA_DOCUMENTATION',
        SOLOPLANDOCUMENTATION = 'GET_SOLOPLAN_DOCUMENTATION',
        EDIDOCUMENTATION = 'GET_EDI_DOCUMENTATION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExecuteFuncEnum {
        GETDOCUMENTATION = 'GET_DOCUMENTATION',
        EXECUTESCRIPTANDRETURNLOGS = 'EXECUTE_SCRIPT_AND_RETURN_LOGS',
        GETJSON = 'GET_JSON',
        GETUSERADDITIONALINFO = 'GET_USER_ADDITIONAL_INFO',
        GETINITIALSCRIPTANDINITIALLOGS = 'GET_INITIAL_SCRIPT_AND_INITIAL_LOGS',
        REQUESTUSERTOMANUALLYVERIFYOUTPUT = 'REQUEST_USER_TO_MANUALLY_VERIFY_OUTPUT'
    }
}

/**
 * 
 * @export
 * @interface ExpectedResult
 */
export interface ExpectedResult {
    /**
     * 
     * @type {string}
     * @memberof ExpectedResult
     */
    expectedModifyMode?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpectedResult
     */
    exportData?: string;
    /**
     * 
     * @type {Array<QueuedEventConversionFileResult>}
     * @memberof ExpectedResult
     */
    exportDataList?: Array<QueuedEventConversionFileResult>;
    /**
     * 
     * @type {any}
     * @memberof ExpectedResult
     */
    fieldsToFuzzyMatch?: any;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExpectedResult
     */
    fieldsToIgnore?: Array<string>;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof ExpectedResult
     */
    importData?: Array<TransportOrder>;
    /**
     * 
     * @type {string}
     * @memberof ExpectedResult
     */
    type?: ExpectedResult.TypeEnum;
}

/**
 * @export
 * @namespace ExpectedResult
 */
export namespace ExpectedResult {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        TO = 'TO',
        LIS = 'LIS',
        LISITC = 'LIS_ITC',
        EDI = 'EDI',
        XML = 'XML',
        OTHER = 'OTHER',
        ACTIVEMWARE = 'ACTIVE_MWARE',
        FORTRAS = 'FORTRAS'
    }
}

/**
 * 
 * @export
 * @interface ExternalStopIdentifier
 */
export interface ExternalStopIdentifier {
    /**
     * 
     * @type {string}
     * @memberof ExternalStopIdentifier
     */
    externalStopId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalStopIdentifier
     */
    externalTransportId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalStopIdentifier
     */
    externalTransportOrderId?: string;
}

/**
 * 
 * @export
 * @interface ExtractToSpecificConfigRequest
 */
export interface ExtractToSpecificConfigRequest {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof ExtractToSpecificConfigRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {string}
     * @memberof ExtractToSpecificConfigRequest
     */
    specifificConfig?: ExtractToSpecificConfigRequest.SpecifificConfigEnum;
}

/**
 * @export
 * @namespace ExtractToSpecificConfigRequest
 */
export namespace ExtractToSpecificConfigRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SpecifificConfigEnum {
        SOLOPLAN = 'SOLOPLAN',
        LISINLISOUT = 'LIS_IN_LIS_OUT',
        ELEMICA = 'ELEMICA',
        SAP = 'SAP',
        EDI = 'EDI',
        SIMPLECSV = 'SIMPLE_CSV',
        GENERICXLS = 'GENERIC_XLS',
        FORTRAS = 'FORTRAS',
        DHLIMPORTER = 'DHL_IMPORTER',
        DESCARTESIMPORTER = 'DESCARTES_IMPORTER',
        METAMODEL = 'META_MODEL',
        GEHR = 'GEHR',
        GENERICGROOVY = 'GENERIC_GROOVY',
        BNSTELEMATIK = 'BNS_TELEMATIK',
        TRANSPOREONXML = 'TRANSPOREON_XML',
        NOOP = 'NO_OP',
        TRANSLOGICA = 'TRANSLOGICA',
        TRANSDATA = 'TRANSDATA',
        CISTELEMATIK = 'CIS_TELEMATIK',
        FRMEYERUNDSOHN = 'FR_MEYER_UND_SOHN',
        ATTACHMENTPROCESSOR = 'ATTACHMENT_PROCESSOR',
        PDFGENERATOR = 'PDF_GENERATOR',
        SHIPPEO = 'SHIPPEO',
        CONIZI = 'CONIZI',
        GENERICZIP = 'GENERIC_ZIP',
        EDIV2 = 'EDI_v2',
        GENERICAI = 'GENERIC_AI'
    }
}

/**
 * 
 * @export
 * @interface ExtractToSpecificConfigResponse
 */
export interface ExtractToSpecificConfigResponse {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof ExtractToSpecificConfigResponse
     */
    newConfig?: CompanyConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof ExtractToSpecificConfigResponse
     */
    successful?: boolean;
}

/**
 * 
 * @export
 * @interface FailedAssignmentsResponse
 */
export interface FailedAssignmentsResponse {
    /**
     * 
     * @type {string}
     * @memberof FailedAssignmentsResponse
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedAssignmentsResponse
     */
    reason?: string;
}

/**
 * 
 * @export
 * @interface FailedEmailSms
 */
export interface FailedEmailSms {
    /**
     * 
     * @type {string}
     * @memberof FailedEmailSms
     */
    additionalInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedEmailSms
     */
    messageLogId?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedEmailSms
     */
    messageType?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedEmailSms
     */
    receiver?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedEmailSms
     */
    sendTime?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedEmailSms
     */
    status?: string;
}

/**
 * 
 * @export
 * @interface FailedEmailSmsMonitoringResponse
 */
export interface FailedEmailSmsMonitoringResponse {
    /**
     * 
     * @type {Array<FailedEmailSms>}
     * @memberof FailedEmailSmsMonitoringResponse
     */
    failedEmailSmsList?: Array<FailedEmailSms>;
}

/**
 * 
 * @export
 * @interface FailedRequest
 */
export interface FailedRequest {
    /**
     * 
     * @type {string}
     * @memberof FailedRequest
     */
    _id?: string;
    /**
     * 
     * @type {HarRequest}
     * @memberof FailedRequest
     */
    harRequest?: HarRequest;
    /**
     * 
     * @type {boolean}
     * @memberof FailedRequest
     */
    retriedSuccessfully?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FailedRequest
     */
    retriedSuccessfullyAt?: Date;
    /**
     * 
     * @type {User}
     * @memberof FailedRequest
     */
    retriedSuccessfullyBy?: User;
    /**
     * 
     * @type {Date}
     * @memberof FailedRequest
     */
    timeOfAttempt?: Date;
    /**
     * 
     * @type {User}
     * @memberof FailedRequest
     */
    user?: User;
    /**
     * 
     * @type {string}
     * @memberof FailedRequest
     */
    xRequestId?: string;
}

/**
 * 
 * @export
 * @interface FailedRequestsMonitoringResponse
 */
export interface FailedRequestsMonitoringResponse {
    /**
     * 
     * @type {Array<FailedRequestsPerCompany>}
     * @memberof FailedRequestsMonitoringResponse
     */
    numberOfFailedRequestsPerCompany?: Array<FailedRequestsPerCompany>;
}

/**
 * 
 * @export
 * @interface FailedRequestsPerCompany
 */
export interface FailedRequestsPerCompany {
    /**
     * 
     * @type {string}
     * @memberof FailedRequestsPerCompany
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedRequestsPerCompany
     */
    companyName?: string;
    /**
     * 
     * @type {number}
     * @memberof FailedRequestsPerCompany
     */
    numberOfFailedRequests?: number;
}

/**
 * 
 * @export
 * @interface FailedRequestsResponse
 */
export interface FailedRequestsResponse {
    /**
     * 
     * @type {number}
     * @memberof FailedRequestsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<FailedRequest>}
     * @memberof FailedRequestsResponse
     */
    requests?: Array<FailedRequest>;
}

/**
 * 
 * @export
 * @interface FetchAIAgentTasksResponse
 */
export interface FetchAIAgentTasksResponse {
    /**
     * 
     * @type {Array<AIAgentTask>}
     * @memberof FetchAIAgentTasksResponse
     */
    fetchAiAgentTasksResponse?: Array<AIAgentTask>;
}

/**
 * 
 * @export
 * @interface FetchAiParseResultsRequest
 */
export interface FetchAiParseResultsRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchAiParseResultsRequest
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchAiParseResultsRequest
     */
    inputContains?: string;
    /**
     * 
     * @type {number}
     * @memberof FetchAiParseResultsRequest
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchAiParseResultsRequest
     */
    outputContains?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchAiParseResultsRequest
     */
    type?: string;
}

/**
 * 
 * @export
 * @interface FetchAiParseResultsResponse
 */
export interface FetchAiParseResultsResponse {
    /**
     * 
     * @type {Array<AiParseResult>}
     * @memberof FetchAiParseResultsResponse
     */
    results?: Array<AiParseResult>;
}

/**
 * 
 * @export
 * @interface FetchAllConfigDraftsResponse
 */
export interface FetchAllConfigDraftsResponse {
    /**
     * 
     * @type {Array<CompanyConfigurationDraft>}
     * @memberof FetchAllConfigDraftsResponse
     */
    drafts?: Array<CompanyConfigurationDraft>;
}

/**
 * 
 * @export
 * @interface FetchCmNavTreeTextModalListResponse
 */
export interface FetchCmNavTreeTextModalListResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchCmNavTreeTextModalListResponse
     */
    pathList?: Array<string>;
}

/**
 * 
 * @export
 * @interface FetchCompanyConfigChangesResponse
 */
export interface FetchCompanyConfigChangesResponse {
    /**
     * 
     * @type {Array<CompanyConfigChanges>}
     * @memberof FetchCompanyConfigChangesResponse
     */
    companies?: Array<CompanyConfigChanges>;
    /**
     * 
     * @type {Date}
     * @memberof FetchCompanyConfigChangesResponse
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FetchCompanyConfigChangesResponse
     */
    to?: Date;
    /**
     * 
     * @type {number}
     * @memberof FetchCompanyConfigChangesResponse
     */
    totalChanges?: number;
    /**
     * 
     * @type {number}
     * @memberof FetchCompanyConfigChangesResponse
     */
    totalCompanies?: number;
    /**
     * 
     * @type {number}
     * @memberof FetchCompanyConfigChangesResponse
     */
    totalConfigChanges?: number;
}

/**
 * 
 * @export
 * @interface FetchCompanyConfigurationChangesForFieldResponse
 */
export interface FetchCompanyConfigurationChangesForFieldResponse {
    /**
     * 
     * @type {Array<CompanyConfigurationChange>}
     * @memberof FetchCompanyConfigurationChangesForFieldResponse
     */
    changes?: Array<CompanyConfigurationChange>;
    /**
     * 
     * @type {number}
     * @memberof FetchCompanyConfigurationChangesForFieldResponse
     */
    count?: number;
}

/**
 * 
 * @export
 * @interface FetchCompanyTagsRequest
 */
export interface FetchCompanyTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchCompanyTagsRequest
     */
    companyId?: string;
    /**
     * 
     * @type {number}
     * @memberof FetchCompanyTagsRequest
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof FetchCompanyTagsRequest
     */
    skip?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchCompanyTagsRequest
     */
    sortBy?: FetchCompanyTagsRequest.SortByEnum;
    /**
     * 
     * @type {string}
     * @memberof FetchCompanyTagsRequest
     */
    sortDirection?: FetchCompanyTagsRequest.SortDirectionEnum;
}

/**
 * @export
 * @namespace FetchCompanyTagsRequest
 */
export namespace FetchCompanyTagsRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SortByEnum {
        CREATIONTIMESTAMP = 'CREATION_TIMESTAMP'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SortDirectionEnum {
        ASC = 'ASC',
        DESC = 'DESC'
    }
}

/**
 * 
 * @export
 * @interface FetchDraftOfConfigResponse
 */
export interface FetchDraftOfConfigResponse {
    /**
     * 
     * @type {CompanyConfigurationDraft}
     * @memberof FetchDraftOfConfigResponse
     */
    draft?: CompanyConfigurationDraft;
}

/**
 * 
 * @export
 * @interface FetchFollowingCompanyConfigurationHistoryResponse
 */
export interface FetchFollowingCompanyConfigurationHistoryResponse {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof FetchFollowingCompanyConfigurationHistoryResponse
     */
    followingConfig?: CompanyConfiguration;
    /**
     * 
     * @type {CompanyHistory}
     * @memberof FetchFollowingCompanyConfigurationHistoryResponse
     */
    historyEntry?: CompanyHistory;
}

/**
 * 
 * @export
 * @interface FetchFollowingCompanyContractHistoryResponse
 */
export interface FetchFollowingCompanyContractHistoryResponse {
    /**
     * 
     * @type {Contract}
     * @memberof FetchFollowingCompanyContractHistoryResponse
     */
    followingContract?: Contract;
    /**
     * 
     * @type {CompanyHistory}
     * @memberof FetchFollowingCompanyContractHistoryResponse
     */
    historyEntry?: CompanyHistory;
}

/**
 * 
 * @export
 * @interface FetchHistoryRequest
 */
export interface FetchHistoryRequest {
    /**
     * 
     * @type {number}
     * @memberof FetchHistoryRequest
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchHistoryRequest
     */
    objectId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchHistoryRequest
     */
    objectTypes?: Array<FetchHistoryRequest.ObjectTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof FetchHistoryRequest
     */
    query?: string;
    /**
     * 
     * @type {number}
     * @memberof FetchHistoryRequest
     */
    skip?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchHistoryRequest
     */
    sortBy?: FetchHistoryRequest.SortByEnum;
    /**
     * 
     * @type {string}
     * @memberof FetchHistoryRequest
     */
    sortDirection?: FetchHistoryRequest.SortDirectionEnum;
}

/**
 * @export
 * @namespace FetchHistoryRequest
 */
export namespace FetchHistoryRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ObjectTypesEnum {
        USER = 'USER',
        USERROLE = 'USERROLE',
        PARTNER = 'PARTNER',
        VEHICLE = 'VEHICLE',
        DRIVER = 'DRIVER',
        COMPANYADDRESSMAPPING = 'COMPANY_ADDRESS_MAPPING',
        COMPANYADDRESSMAPPINGGROUP = 'COMPANY_ADDRESS_MAPPING_GROUP',
        FREIGHTMAPPING = 'FREIGHT_MAPPING',
        FREIGHTMAPPINGGROUP = 'FREIGHT_MAPPING_GROUP',
        TRANSPORTORDERMAPPING = 'TRANSPORT_ORDER_MAPPING',
        TRANSPORTORDERMAPPINGGROUP = 'TRANSPORT_ORDER_MAPPING_GROUP',
        QUEUE = 'QUEUE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SortByEnum {
        TIMESTAMP = 'TIMESTAMP',
        CHANGEDBY = 'CHANGED_BY',
        CHANGEMETHOD = 'CHANGE_METHOD',
        OBJECTTYPE = 'OBJECT_TYPE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SortDirectionEnum {
        ASC = 'ASC',
        DESC = 'DESC'
    }
}

/**
 * 
 * @export
 * @interface FetchHistoryResponse
 */
export interface FetchHistoryResponse {
    /**
     * 
     * @type {Array<History>}
     * @memberof FetchHistoryResponse
     */
    entries?: Array<History>;
    /**
     * 
     * @type {number}
     * @memberof FetchHistoryResponse
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchHistoryResponse
     */
    objectId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchHistoryResponse
     */
    objectType?: Array<FetchHistoryResponse.ObjectTypeEnum>;
    /**
     * 
     * @type {number}
     * @memberof FetchHistoryResponse
     */
    totalFound?: number;
}

/**
 * @export
 * @namespace FetchHistoryResponse
 */
export namespace FetchHistoryResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ObjectTypeEnum {
        USER = 'USER',
        USERROLE = 'USERROLE',
        PARTNER = 'PARTNER',
        VEHICLE = 'VEHICLE',
        DRIVER = 'DRIVER',
        COMPANYADDRESSMAPPING = 'COMPANY_ADDRESS_MAPPING',
        COMPANYADDRESSMAPPINGGROUP = 'COMPANY_ADDRESS_MAPPING_GROUP',
        FREIGHTMAPPING = 'FREIGHT_MAPPING',
        FREIGHTMAPPINGGROUP = 'FREIGHT_MAPPING_GROUP',
        TRANSPORTORDERMAPPING = 'TRANSPORT_ORDER_MAPPING',
        TRANSPORTORDERMAPPINGGROUP = 'TRANSPORT_ORDER_MAPPING_GROUP',
        QUEUE = 'QUEUE'
    }
}

/**
 * 
 * @export
 * @interface FetchInvoicesRequest
 */
export interface FetchInvoicesRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchInvoicesRequest
     */
    invoiceId?: string;
}

/**
 * 
 * @export
 * @interface FetchMailLogRequest
 */
export interface FetchMailLogRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchMailLogRequest
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FetchMailLogRequest
     */
    companySpecific?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FetchMailLogRequest
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchMailLogRequest
     */
    objectId?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchMailLogRequest
     */
    query?: string;
    /**
     * 
     * @type {number}
     * @memberof FetchMailLogRequest
     */
    skip?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchMailLogRequest
     */
    sortBy?: FetchMailLogRequest.SortByEnum;
    /**
     * 
     * @type {string}
     * @memberof FetchMailLogRequest
     */
    sortDirection?: FetchMailLogRequest.SortDirectionEnum;
}

/**
 * @export
 * @namespace FetchMailLogRequest
 */
export namespace FetchMailLogRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SortByEnum {
        MESSAGETYPE = 'MESSAGE_TYPE',
        SENDTIME = 'SEND_TIME'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SortDirectionEnum {
        ASC = 'ASC',
        DESC = 'DESC'
    }
}

/**
 * 
 * @export
 * @interface FetchMailLogResponse
 */
export interface FetchMailLogResponse {
    /**
     * 
     * @type {Array<MessageLog>}
     * @memberof FetchMailLogResponse
     */
    entries?: Array<MessageLog>;
    /**
     * 
     * @type {number}
     * @memberof FetchMailLogResponse
     */
    totalFound?: number;
}

/**
 * 
 * @export
 * @interface FetchMigrationsResponse
 */
export interface FetchMigrationsResponse {
    /**
     * 
     * @type {number}
     * @memberof FetchMigrationsResponse
     */
    currentDbVersion?: number;
    /**
     * 
     * @type {Array<DatabaseVersion>}
     * @memberof FetchMigrationsResponse
     */
    dbVersions?: Array<DatabaseVersion>;
    /**
     * 
     * @type {Array<MigrationTask>}
     * @memberof FetchMigrationsResponse
     */
    migrations?: Array<MigrationTask>;
    /**
     * 
     * @type {string}
     * @memberof FetchMigrationsResponse
     */
    responseMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FetchMigrationsResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface FetchPartnersWithConfigAndExportAndImportResponse
 */
export interface FetchPartnersWithConfigAndExportAndImportResponse {
    /**
     * 
     * @type {Array<PartnerCompanyWithPartnerObjects>}
     * @memberof FetchPartnersWithConfigAndExportAndImportResponse
     */
    partners?: Array<PartnerCompanyWithPartnerObjects>;
}

/**
 * 
 * @export
 * @interface FetchScheduledOrderCreationRulesRequest
 */
export interface FetchScheduledOrderCreationRulesRequest {
}

/**
 * 
 * @export
 * @interface FetchScheduledOrderCreationRulesResponse
 */
export interface FetchScheduledOrderCreationRulesResponse {
    /**
     * 
     * @type {number}
     * @memberof FetchScheduledOrderCreationRulesResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ScheduledOrderCreationRule>}
     * @memberof FetchScheduledOrderCreationRulesResponse
     */
    rules?: Array<ScheduledOrderCreationRule>;
}

/**
 * 
 * @export
 * @interface FetchScriptsDocumentationsResponse
 */
export interface FetchScriptsDocumentationsResponse {
    /**
     * 
     * @type {Array<ScriptsDocumentationEntry>}
     * @memberof FetchScriptsDocumentationsResponse
     */
    fetchScriptsDocumentationsResponse?: Array<ScriptsDocumentationEntry>;
}

/**
 * 
 * @export
 * @interface FetchSpecificMessageLogsForTransportOrdersRequest
 */
export interface FetchSpecificMessageLogsForTransportOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchSpecificMessageLogsForTransportOrdersRequest
     */
    messageType?: FetchSpecificMessageLogsForTransportOrdersRequest.MessageTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchSpecificMessageLogsForTransportOrdersRequest
     */
    transportOrderIds?: Array<string>;
}

/**
 * @export
 * @namespace FetchSpecificMessageLogsForTransportOrdersRequest
 */
export namespace FetchSpecificMessageLogsForTransportOrdersRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum MessageTypeEnum {
        REMINDER = 'REMINDER',
        INFO = 'INFO',
        WARNING = 'WARNING'
    }
}

/**
 * 
 * @export
 * @interface FetchTestFailuresResponse
 */
export interface FetchTestFailuresResponse {
    /**
     * 
     * @type {Array<TestFailureLogEntry>}
     * @memberof FetchTestFailuresResponse
     */
    testFailures?: Array<TestFailureLogEntry>;
    /**
     * 
     * @type {number}
     * @memberof FetchTestFailuresResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface FetchTransportOrderListFilterRequest
 */
export interface FetchTransportOrderListFilterRequest {
    /**
     * 
     * @type {Array<SearchTermObject>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    additionalDataFilters?: Array<SearchTermObject>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    attachmentCategories?: Array<FetchTransportOrderListFilterRequest.AttachmentCategoriesEnum>;
    /**
     * 
     * @type {Array<AttachmentCategoryAndStatusInLevel>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    attachmentCategoryAndStatusInLevel?: Array<AttachmentCategoryAndStatusInLevel>;
    /**
     * 
     * @type {Array<AttachmentStatusAndLevel>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    attachmentStatusInLevel?: Array<AttachmentStatusAndLevel>;
    /**
     * Only works with attachmentStatusInLevel. Shows only attachments if for all levels a attachment in status created is there
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    attachmentToBeApproved?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FetchTransportOrderListFilterRequest
     */
    begin?: Date;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    countTransportOrders?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    dateTimeField?: FetchTransportOrderListFilterRequest.DateTimeFieldEnum;
    /**
     * 
     * @type {Date}
     * @memberof FetchTransportOrderListFilterRequest
     */
    end?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    exactSearchTermMatch?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    excludeFreightStatus?: Array<FetchTransportOrderListFilterRequest.ExcludeFreightStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    excludeStatus?: Array<FetchTransportOrderListFilterRequest.ExcludeStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    excludeStopLocationStatus?: Array<FetchTransportOrderListFilterRequest.ExcludeStopLocationStatusEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    hasAssignedDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    hasAttachment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    hasObserver?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    hasVehicle?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    inSourceCompany?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    inTargetCompany?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    includeFreightStatus?: Array<FetchTransportOrderListFilterRequest.IncludeFreightStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    includeStatus?: Array<FetchTransportOrderListFilterRequest.IncludeStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    includeStopLocationStatus?: Array<FetchTransportOrderListFilterRequest.IncludeStopLocationStatusEnum>;
    /**
     * 
     * @type {Date}
     * @memberof FetchTransportOrderListFilterRequest
     */
    modifiedSince?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    notInSourceCompany?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    notInTargetCompany?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    partnerIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    partnerNameRegex?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    searchInAllCompanies?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    searchTerm?: string;
    /**
     * 
     * @type {Array<SearchTermObject>}
     * @memberof FetchTransportOrderListFilterRequest
     */
    searchTermFilter?: Array<SearchTermObject>;
    /**
     * 
     * @type {number}
     * @memberof FetchTransportOrderListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    sortBy?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    sortOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    status?: FetchTransportOrderListFilterRequest.StatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FetchTransportOrderListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FetchTransportOrderListFilterRequest
     */
    useFastBasicFilter?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    validationStatus?: FetchTransportOrderListFilterRequest.ValidationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    vehicle?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchTransportOrderListFilterRequest
     */
    withLinkingState?: FetchTransportOrderListFilterRequest.WithLinkingStateEnum;
}

/**
 * @export
 * @namespace FetchTransportOrderListFilterRequest
 */
export namespace FetchTransportOrderListFilterRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum AttachmentCategoriesEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DateTimeFieldEnum {
        CREATED = 'CREATED',
        PLANBEGIN = 'PLAN_BEGIN',
        PLANEND = 'PLAN_END',
        WITHIN = 'WITHIN',
        PLANSTARTORADVISEDFROM = 'PLANSTART_OR_ADVISEDFROM',
        ACTUALBEGIN = 'ACTUAL_BEGIN',
        ACTUALEND = 'ACTUAL_END',
        ACTUALWITHIN = 'ACTUAL_WITHIN'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExcludeFreightStatusEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExcludeStatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExcludeStopLocationStatusEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IncludeFreightStatusEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IncludeStatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IncludeStopLocationStatusEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ValidationStatusEnum {
        VALID = 'ONLY_VALID',
        INVALID = 'ONLY_INVALID'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WithLinkingStateEnum {
        LINKED = 'LINKED',
        NOTLINKED = 'NOT_LINKED'
    }
}

/**
 * 
 * @export
 * @interface FetchUnbilledResponse
 */
export interface FetchUnbilledResponse {
    /**
     * 
     * @type {number}
     * @memberof FetchUnbilledResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ProjectWorkLogBookEntry>}
     * @memberof FetchUnbilledResponse
     */
    workLogEntries?: Array<ProjectWorkLogBookEntry>;
}

/**
 * 
 * @export
 * @interface FetchValidationRulesResponse
 */
export interface FetchValidationRulesResponse {
    /**
     * 
     * @type {any}
     * @memberof FetchValidationRulesResponse
     */
    results?: any;
}

/**
 * 
 * @export
 * @interface FetchedAuthToken
 */
export interface FetchedAuthToken {
    /**
     * 
     * @type {boolean}
     * @memberof FetchedAuthToken
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FetchedAuthToken
     */
    creationTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FetchedAuthToken
     */
    expiryDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof FetchedAuthToken
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface FetchedAuthTokenList
 */
export interface FetchedAuthTokenList {
    /**
     * 
     * @type {Array<FetchedAuthToken>}
     * @memberof FetchedAuthTokenList
     */
    fetchedAuthTokenList?: Array<FetchedAuthToken>;
}

/**
 * 
 * @export
 * @interface FieldViewConfiguration
 */
export interface FieldViewConfiguration {
    /**
     * 
     * @type {string}
     * @memberof FieldViewConfiguration
     */
    defaultLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FieldViewConfiguration
     */
    isVisible?: boolean;
    /**
     * 
     * @type {Array<LocalizedLabel>}
     * @memberof FieldViewConfiguration
     */
    localizedLabels?: Array<LocalizedLabel>;
    /**
     * 
     * @type {number}
     * @memberof FieldViewConfiguration
     */
    sortIndex?: number;
}

/**
 * 
 * @export
 * @interface FileGatewayConfiguration
 */
export interface FileGatewayConfiguration {
    /**
     * 
     * @type {As2ServerConfiguration}
     * @memberof FileGatewayConfiguration
     */
    as2?: As2ServerConfiguration;
    /**
     * 
     * @type {GenericPushConfiguration}
     * @memberof FileGatewayConfiguration
     */
    genericPush?: GenericPushConfiguration;
    /**
     * 
     * @type {MailGatewayConfiguration}
     * @memberof FileGatewayConfiguration
     */
    mailGatewayConfig?: MailGatewayConfiguration;
}

/**
 * 
 * @export
 * @interface FileSystemWorkerConfiguration
 */
export interface FileSystemWorkerConfiguration {
    /**
     * 
     * @type {As2SyncConfiguration}
     * @memberof FileSystemWorkerConfiguration
     */
    as2SyncConfiguration?: As2SyncConfiguration;
    /**
     * 
     * @type {number}
     * @memberof FileSystemWorkerConfiguration
     */
    batchIntervalInSec?: number;
    /**
     * 
     * @type {string}
     * @memberof FileSystemWorkerConfiguration
     */
    copyExportedFilesToCompanyWithId?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSystemWorkerConfiguration
     */
    copyProcessedFilesToCompanyWithId?: string;
    /**
     * 
     * @type {FileSystemWorkerMailConfiguration}
     * @memberof FileSystemWorkerConfiguration
     */
    emailConfiguration?: FileSystemWorkerMailConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FileSystemWorkerConfiguration
     */
    extractTourNrFromAttachmentFileNameScript?: string;
    /**
     * 
     * @type {GoogleSheetDownloadConfiguration}
     * @memberof FileSystemWorkerConfiguration
     */
    googleSheetDownloadConfiguration?: GoogleSheetDownloadConfiguration;
    /**
     * 
     * @type {HttpSyncConfiguration}
     * @memberof FileSystemWorkerConfiguration
     */
    httpSyncConfiguration?: HttpSyncConfiguration;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileSystemWorkerConfiguration
     */
    mailOnErrorReceivers?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FileSystemWorkerConfiguration
     */
    maxFileAgeBeforeWarningInSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof FileSystemWorkerConfiguration
     */
    maxNumberOfRetriesOnTemporalError?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerConfiguration
     */
    mergeOutputFiles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerConfiguration
     */
    moveAttachmentsToCustomer2LogeniosFolder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerConfiguration
     */
    moveErrorFilesToNeedsVerificationFolder?: boolean;
    /**
     * 
     * @type {Array<ProcessingDelay>}
     * @memberof FileSystemWorkerConfiguration
     */
    processingDelay?: Array<ProcessingDelay>;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerConfiguration
     */
    runOcrBeforeConvertingPdf?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerConfiguration
     */
    sendMailOnError?: boolean;
    /**
     * 
     * @type {SFTPSyncConfiguration}
     * @memberof FileSystemWorkerConfiguration
     */
    sftpSync?: SFTPSyncConfiguration;
    /**
     * 
     * @type {Array<SFTPSyncConfiguration>}
     * @memberof FileSystemWorkerConfiguration
     */
    sftpSyncList?: Array<SFTPSyncConfiguration>;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerConfiguration
     */
    treadFilesInRootAsIfTheyWereInCustomerToLogeniosFolder?: boolean;
}

/**
 * 
 * @export
 * @interface FileSystemWorkerMailConfiguration
 */
export interface FileSystemWorkerMailConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerMailConfiguration
     */
    deleteFilesAfterSending?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileSystemWorkerMailConfiguration
     */
    mailReceivers?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemWorkerMailConfiguration
     */
    sendExportedFilesViaEMail?: boolean;
}

/**
 * 
 * @export
 * @interface FinishToursTaskConfiguration
 */
export interface FinishToursTaskConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof FinishToursTaskConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FinishToursTaskConfiguration
     */
    daysToFix?: number;
    /**
     * 
     * @type {number}
     * @memberof FinishToursTaskConfiguration
     */
    hardFinishTransportOrderAfterHours?: number;
}

/**
 * 
 * @export
 * @interface FixTransportOrderTimesRequest
 */
export interface FixTransportOrderTimesRequest {
    /**
     * 
     * @type {string}
     * @memberof FixTransportOrderTimesRequest
     */
    algo?: FixTransportOrderTimesRequest.AlgoEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FixTransportOrderTimesRequest
     */
    fixStopsOfLinkedTransports?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FixTransportOrderTimesRequest
     */
    mergeAndOrderKeyToStartFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof FixTransportOrderTimesRequest
     */
    offsetAfterInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof FixTransportOrderTimesRequest
     */
    offsetBeforeInMinutes?: number;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof FixTransportOrderTimesRequest
     */
    overrideCompanyConfig?: CompanyConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof FixTransportOrderTimesRequest
     */
    partialFixAllowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixTransportOrderTimesRequest
     */
    replaceOriginalTransportOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixTransportOrderTimesRequest
     */
    shouldCreateHistoryEntry?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FixTransportOrderTimesRequest
     */
    stopIdToStartFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof FixTransportOrderTimesRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace FixTransportOrderTimesRequest
 */
export namespace FixTransportOrderTimesRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum AlgoEnum {
        REVERSE = 'REVERSE',
        FORWARD = 'FORWARD',
        STANDINGCLUSTERS = 'STANDING_CLUSTERS'
    }
}

/**
 * 
 * @export
 * @interface FixerTaskConfiguration
 */
export interface FixerTaskConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof FixerTaskConfiguration
     */
    doNotRemoveSubSolutionsForClusterAlgo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixerTaskConfiguration
     */
    fixStopsOfLinkedTransports?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FixerTaskConfiguration
     */
    fixerAlgo?: FixerTaskConfiguration.FixerAlgoEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FixerTaskConfiguration
     */
    fixerShallRespectArrivalTimeWindow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixerTaskConfiguration
     */
    reverse?: boolean;
}

/**
 * @export
 * @namespace FixerTaskConfiguration
 */
export namespace FixerTaskConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum FixerAlgoEnum {
        REVERSE = 'REVERSE',
        FORWARD = 'FORWARD',
        STANDINGCLUSTERS = 'STANDING_CLUSTERS'
    }
}

/**
 * 
 * @export
 * @interface FlowControlStats
 */
export interface FlowControlStats {
}

/**
 * 
 * @export
 * @interface FormatConfigResponse
 */
export interface FormatConfigResponse {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof FormatConfigResponse
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FormatConfigResponse
     */
    errorMessage?: string;
}

/**
 * 
 * @export
 * @interface FormatContractResponse
 */
export interface FormatContractResponse {
    /**
     * 
     * @type {Contract}
     * @memberof FormatContractResponse
     */
    contract?: Contract;
    /**
     * 
     * @type {string}
     * @memberof FormatContractResponse
     */
    errorMessage?: string;
}

/**
 * 
 * @export
 * @interface FortrasConverterConfiguration
 */
export interface FortrasConverterConfiguration {
    /**
     * 
     * @type {string}
     * @memberof FortrasConverterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {FotrasExportMapping}
     * @memberof FortrasConverterConfiguration
     */
    exportMapping?: FotrasExportMapping;
    /**
     * 
     * @type {FortrasImportMapping}
     * @memberof FortrasConverterConfiguration
     */
    importMapping?: FortrasImportMapping;
    /**
     * 
     * @type {string}
     * @memberof FortrasConverterConfiguration
     */
    version?: FortrasConverterConfiguration.VersionEnum;
}

/**
 * @export
 * @namespace FortrasConverterConfiguration
 */
export namespace FortrasConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum VersionEnum {
        Bord512 = 'Bord512',
        Bord128 = 'Bord128'
    }
}

/**
 * 
 * @export
 * @interface FortrasExportBarcodesUndReferenzen
 */
export interface FortrasExportBarcodesUndReferenzen {
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refKind1?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refKind2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refKind3?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refKind4?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refKind5?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refNr1?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refNr2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refNr3?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refNr4?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportBarcodesUndReferenzen
     */
    refNr5?: string;
}

/**
 * 
 * @export
 * @interface FortrasExportFreieTexte
 */
export interface FortrasExportFreieTexte {
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    borderoIdx?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    record?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    text2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    text3?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    textKind1?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    textKind2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportFreieTexte
     */
    textKind3?: string;
}

/**
 * 
 * @export
 * @interface FortrasExportGefahrgutsatz
 */
export interface FortrasExportGefahrgutsatz {
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    borderoIdx?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    calculatedPoints?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    className?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    dangerLabelPattern1?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    dangerLabelPattern2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    dangerLabelPattern3?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    dangerLabelPattern4?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    dgRef?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    exceptedQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    explosiveMass?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    grossWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    isLimitedAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    multiplier?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    netVolume?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    netVolumeClassifier?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    numPackets?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    packingGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    packingGroup2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    packingType?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    record?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    release?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    shipmentIdx?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    tunnelCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    unNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    uniqueDgKey?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportGefahrgutsatz
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface FortrasExportHeadersatz
 */
export interface FortrasExportHeadersatz {
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    MailboxLength?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    emtpy?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    emtpy2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    emtpy3?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    emtpy4?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    emtpy5?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    intRef?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    messageType?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    recordLength?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    rest?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    senderMailboxID?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportHeadersatz
     */
    startAdress?: string;
}

/**
 * 
 * @export
 * @interface FortrasExportSendungsnummern
 */
export interface FortrasExportSendungsnummern {
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    borderoNrReceiver?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    borderoNrShipper?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    cubicMeters?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    directDelivery?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    directPickup?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    franking?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    grossWeigth?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    loadingMeters?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    numLoadingAids?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    numLoadingAids2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    numLots?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    pickupDate?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    pickupTimeFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    pickupTimeTo?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    productGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    shipmentFreightWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    shipmentNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    shipmentNr1?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    typeOfLoadingAids?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    typeOfLoadingAids2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    valoeOfGoodsCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungsnummern
     */
    valueOfGoods?: string;
}

/**
 * 
 * @export
 * @interface FortrasExportSendungspositionenMapping
 */
export interface FortrasExportSendungspositionenMapping {
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    chargableWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    cubicMeter?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    grossWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    height?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    loadingMeter?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    numLots?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    numPackets?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    numPacketsOnPallets?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    packingKind?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    packingTypeInPallets?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    refNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportSendungspositionenMapping
     */
    width?: string;
}

/**
 * 
 * @export
 * @interface FortrasExportTextschluessel
 */
export interface FortrasExportTextschluessel {
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    borderoIdx?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    record?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    text1?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    text2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    text3?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    text4?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    text5?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    text6?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    textKind1?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    textKind2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    textKind3?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    textKind4?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    textKind5?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasExportTextschluessel
     */
    textKind6?: string;
}

/**
 * 
 * @export
 * @interface FortrasImportAdditionalDataMapping
 */
export interface FortrasImportAdditionalDataMapping {
    /**
     * 
     * @type {boolean}
     * @memberof FortrasImportAdditionalDataMapping
     */
    _export?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FortrasImportAdditionalDataMapping
     */
    _import?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportAdditionalDataMapping
     */
    logeniosKeyName?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportAdditionalDataMapping
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface FortrasImportFreightMapping
 */
export interface FortrasImportFreightMapping {
    /**
     * 
     * @type {Array<FortrasImportAdditionalDataMapping>}
     * @memberof FortrasImportFreightMapping
     */
    additionals?: Array<FortrasImportAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    containmentQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    containmentType?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    deliveryNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    externalFreightId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    freightId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    height?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    totalLoadingMeter?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    totalLots?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    totalQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    totalVolume?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    totalWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportFreightMapping
     */
    width?: string;
}

/**
 * 
 * @export
 * @interface FortrasImportMapping
 */
export interface FortrasImportMapping {
    /**
     * 
     * @type {FortrasImportFreightMapping}
     * @memberof FortrasImportMapping
     */
    freightMapping?: FortrasImportFreightMapping;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportMapping
     */
    h00TextDestination?: FortrasImportMapping.H00TextDestinationEnum;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportMapping
     */
    h10TextDestination?: FortrasImportMapping.H10TextDestinationEnum;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportMapping
     */
    importMode?: FortrasImportMapping.ImportModeEnum;
    /**
     * 
     * @type {FortrasImportStatusMapping}
     * @memberof FortrasImportMapping
     */
    importStatusMapping?: FortrasImportStatusMapping;
    /**
     * 
     * @type {FortrasImportPacketMapping}
     * @memberof FortrasImportMapping
     */
    packetMapping?: FortrasImportPacketMapping;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportMapping
     */
    postImportScript?: string;
    /**
     * 
     * @type {FortrasImportStopLocationMapping}
     * @memberof FortrasImportMapping
     */
    stopLocationMapping?: FortrasImportStopLocationMapping;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportMapping
     */
    timeZone?: string;
    /**
     * 
     * @type {FortrasImportTransportMapping}
     * @memberof FortrasImportMapping
     */
    transportMapping?: FortrasImportTransportMapping;
    /**
     * 
     * @type {FortrasImportTransportOrderMapping}
     * @memberof FortrasImportMapping
     */
    transportOrderMapping?: FortrasImportTransportOrderMapping;
}

/**
 * @export
 * @namespace FortrasImportMapping
 */
export namespace FortrasImportMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum H00TextDestinationEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORT = 'TRANSPORT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum H10TextDestinationEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORT = 'TRANSPORT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ImportModeEnum {
        BORDEROTOTRANSPORTORDER = 'BORDERO_TO_TRANSPORTORDER',
        SHIPMENTTOTRANSPORTORDER = 'SHIPMENT_TO_TRANSPORTORDER'
    }
}

/**
 * 
 * @export
 * @interface FortrasImportPacketMapping
 */
export interface FortrasImportPacketMapping {
    /**
     * 
     * @type {string}
     * @memberof FortrasImportPacketMapping
     */
    externalPacketId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportPacketMapping
     */
    packetId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportPacketMapping
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface FortrasImportStatusMapping
 */
export interface FortrasImportStatusMapping {
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStatusMapping
     */
    preImportScript?: string;
}

/**
 * 
 * @export
 * @interface FortrasImportStopLocationMapping
 */
export interface FortrasImportStopLocationMapping {
    /**
     * 
     * @type {Array<FortrasImportAdditionalDataMapping>}
     * @memberof FortrasImportStopLocationMapping
     */
    additionals?: Array<FortrasImportAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    houseNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    openingHoursFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    openingHoursTo?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    planArrive?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    planArriveTime?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    planDepart?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    planDepartTime?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    stopId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportStopLocationMapping
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface FortrasImportTransportMapping
 */
export interface FortrasImportTransportMapping {
    /**
     * 
     * @type {Array<FortrasImportAdditionalDataMapping>}
     * @memberof FortrasImportTransportMapping
     */
    additionals?: Array<FortrasImportAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportMapping
     */
    plannedDistance?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportMapping
     */
    shipmentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportMapping
     */
    transportId?: string;
}

/**
 * 
 * @export
 * @interface FortrasImportTransportOrderMapping
 */
export interface FortrasImportTransportOrderMapping {
    /**
     * 
     * @type {Array<FortrasImportAdditionalDataMapping>}
     * @memberof FortrasImportTransportOrderMapping
     */
    additionals?: Array<FortrasImportAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedDeviceLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedDeviceMail?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedDevicePhoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedDeviceVerboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedDriverExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedTrailerExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedTrailerNumberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedVehicleExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    assignedVehicleNumberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    externalTargetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    targetCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof FortrasImportTransportOrderMapping
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface FotrasExportAdressMapping
 */
export interface FotrasExportAdressMapping {
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    addressKind?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    addressNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    cityDistrict?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    customsNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    iln?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    name3?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportAdressMapping
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface FotrasExportMapping
 */
export interface FotrasExportMapping {
    /**
     * 
     * @type {FotrasExportSendungsdatenKopfsatzMapping}
     * @memberof FotrasExportMapping
     */
    a00?: FotrasExportSendungsdatenKopfsatzMapping;
    /**
     * 
     * @type {Array<FotrasExportAdressMapping>}
     * @memberof FotrasExportMapping
     */
    b00?: Array<FotrasExportAdressMapping>;
    /**
     * 
     * @type {FortrasExportSendungspositionenMapping}
     * @memberof FotrasExportMapping
     */
    d00?: FortrasExportSendungspositionenMapping;
    /**
     * 
     * @type {FortrasExportGefahrgutsatz}
     * @memberof FotrasExportMapping
     */
    e00?: FortrasExportGefahrgutsatz;
    /**
     * 
     * @type {FortrasExportBarcodesUndReferenzen}
     * @memberof FotrasExportMapping
     */
    f00?: FortrasExportBarcodesUndReferenzen;
    /**
     * 
     * @type {FortrasExportSendungsnummern}
     * @memberof FotrasExportMapping
     */
    g00?: FortrasExportSendungsnummern;
    /**
     * 
     * @type {Array<FortrasExportTextschluessel>}
     * @memberof FotrasExportMapping
     */
    h00?: Array<FortrasExportTextschluessel>;
    /**
     * 
     * @type {Array<FortrasExportFreieTexte>}
     * @memberof FotrasExportMapping
     */
    h10?: Array<FortrasExportFreieTexte>;
    /**
     * 
     * @type {FortrasExportHeadersatz}
     * @memberof FotrasExportMapping
     */
    ph?: FortrasExportHeadersatz;
}

/**
 * 
 * @export
 * @interface FotrasExportSendungsdatenKopfsatzMapping
 */
export interface FotrasExportSendungsdatenKopfsatzMapping {
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    borderoNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    carrier?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    carrierCity?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    carrierCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    carrierZip?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    codeList?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    dataType?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    forwarderNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    forwarderNr2?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    numberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    numberPlate2?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    product?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    receiverPartnerNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    release?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    senderPartnerNr?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    test?: string;
    /**
     * 
     * @type {string}
     * @memberof FotrasExportSendungsdatenKopfsatzMapping
     */
    transportType?: string;
}

/**
 * 
 * @export
 * @interface Freight
 */
export interface Freight {
    /**
     * List of key value pairs for storing additonal information
     * @type {Array<AdditionalDataEntry>}
     * @memberof Freight
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {AdrDescription}
     * @memberof Freight
     */
    adr?: AdrDescription;
    /**
     * Article number of this freight
     * @type {string}
     * @memberof Freight
     */
    articleNumber?: string;
    /**
     * Documents attached to this freight item
     * @type {Array<Attachment>}
     * @memberof Freight
     */
    attachments?: Array<Attachment>;
    /**
     * Textual comment for free text information
     * @type {string}
     * @memberof Freight
     */
    comment?: string;
    /**
     * Verbose name of the containment, e.g. EUR Pallets
     * @type {string}
     * @memberof Freight
     */
    containmentName?: string;
    /**
     * External Verbose name of the containment, e.g. EUR Pallets
     * @type {string}
     * @memberof Freight
     */
    containmentNameExt?: string;
    /**
     * Number of containment items used for packaging the freight
     * @type {number}
     * @memberof Freight
     */
    containmentQuantity?: number;
    /**
     * DEPRECATED! Type of containmnent used to encapsulate the freight. Please use ContainmentName instead and fill in the symbolic name.
     * @type {string}
     * @memberof Freight
     */
    containmentType?: Freight.ContainmentTypeEnum;
    /**
     * List of contracting parties/companies/legal entities involved in the transport process
     * @type {Array<ContractingParty>}
     * @memberof Freight
     */
    contractingParties?: Array<ContractingParty>;
    /**
     * Delivery number of the relevant shipping document
     * @type {string}
     * @memberof Freight
     */
    deliveryNumber?: string;
    /**
     * External identifier of this freight 
     * @type {string}
     * @memberof Freight
     */
    externalFreightId?: string;
    /**
     * Id of this freight item. Must be unique within this transport order
     * @type {string}
     * @memberof Freight
     */
    freightId?: string;
    /**
     * This field contains a list of freight identification numbers. On updates this key is used to update freights in linked transports.
     * @type {Array<string>}
     * @memberof Freight
     */
    freightLinkKeys?: Array<string>;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Freight
     */
    height?: DoubleWithUnit;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Freight
     */
    length?: DoubleWithUnit;
    /**
     * List of sub-packets describing this freight
     * @type {Array<Packet>}
     * @memberof Freight
     */
    packets?: Array<Packet>;
    /**
     * 
     * @type {FreightStatus}
     * @memberof Freight
     */
    status?: FreightStatus;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Freight
     */
    totalLoadingMeter?: DoubleWithUnit;
    /**
     * Number of lots of the freight consists of pallets
     * @type {number}
     * @memberof Freight
     */
    totalLots?: number;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Freight
     */
    totalQuantity?: DoubleWithUnit;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Freight
     */
    totalVolume?: DoubleWithUnit;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Freight
     */
    totalWeight?: DoubleWithUnit;
    /**
     * Verbose name describing this freight item
     * @type {string}
     * @memberof Freight
     */
    verboseName?: string;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Freight
     */
    width?: DoubleWithUnit;
}

/**
 * @export
 * @namespace Freight
 */
export namespace Freight {
    /**
     * @export
     * @enum {string}
     */
    export enum ContainmentTypeEnum {
        EpalEurPallet = 'epalEurPallet',
        Epal2Pallet = 'epal2Pallet',
        Epal3Pallet = 'epal3Pallet',
        Epal6HalfPallet = 'epal6HalfPallet',
        Epal7HalfPallet = 'epal7HalfPallet',
        EpalBoxPallet = 'epalBoxPallet',
        ChepEuroPallet = 'chepEuroPallet',
        ChepHalfPallet = 'chepHalfPallet',
        ChepIndustrialPallet = 'chepIndustrialPallet',
        ChepPlasticEurPallet = 'chepPlasticEurPallet',
        ChepPlasticQuarterPallet = 'chepPlasticQuarterPallet',
        Pallet = 'pallet',
        PalletCollar = 'palletCollar',
        EurH1PlasticPallet = 'eurH1PlasticPallet',
        PaperSack = 'paperSack',
        InflatableBag = 'inflatableBag',
        Container20ft = 'container20ft',
        Container40ft = 'container40ft',
        Container45ft = 'container45ft',
        Container48ft = 'container48ft',
        Container53ft = 'container53ft',
        IbcContainer = 'ibcContainer',
        IntermediateBulkContainer = 'intermediateBulkContainer',
        IfcoTray = 'ifcoTray',
        SlipSheet = 'slipSheet',
        CagePallet = 'cagePallet',
        RollContainer = 'rollContainer',
        Bag = 'bag',
        Box = 'box',
        Piece = 'piece',
        Other = 'other'
    }
}

/**
 * 
 * @export
 * @interface FreightCreateViewConfiguration
 */
export interface FreightCreateViewConfiguration {
    /**
     * 
     * @type {Array<AdditionalDataFieldConfiguration>}
     * @memberof FreightCreateViewConfiguration
     */
    additionalData?: Array<AdditionalDataFieldConfiguration>;
    /**
     * 
     * @type {number}
     * @memberof FreightCreateViewConfiguration
     */
    allowedFreights?: number;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    attachments?: TextFieldConfiguration;
    /**
     * 
     * @type {OptionFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    containmentName?: OptionFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    containmentQuantity?: TextFieldConfiguration;
    /**
     * 
     * @type {OptionFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    containmentType?: OptionFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    deliveryNumber?: TextFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    freightId?: TextFieldConfiguration;
    /**
     * 
     * @type {DoubleWithUnitFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    height?: DoubleWithUnitFieldConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof FreightCreateViewConfiguration
     */
    isFreightRequired?: boolean;
    /**
     * 
     * @type {DoubleWithUnitFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    length?: DoubleWithUnitFieldConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof FreightCreateViewConfiguration
     */
    limitFreights?: boolean;
    /**
     * 
     * @type {DoubleWithUnitFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    totalLoadingMeter?: DoubleWithUnitFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    totalLots?: TextFieldConfiguration;
    /**
     * 
     * @type {DoubleWithUnitFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    totalQuantity?: DoubleWithUnitFieldConfiguration;
    /**
     * 
     * @type {DoubleWithUnitFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    totalVolume?: DoubleWithUnitFieldConfiguration;
    /**
     * 
     * @type {DoubleWithUnitFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    totalWeight?: DoubleWithUnitFieldConfiguration;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    verboseName?: TextFieldConfiguration;
    /**
     * 
     * @type {DoubleWithUnitFieldConfiguration}
     * @memberof FreightCreateViewConfiguration
     */
    width?: DoubleWithUnitFieldConfiguration;
}

/**
 * 
 * @export
 * @interface FreightDisplayOptions
 */
export interface FreightDisplayOptions {
    /**
     * 
     * @type {Array<ImmediateFormatCustomField>}
     * @memberof FreightDisplayOptions
     */
    customFields?: Array<ImmediateFormatCustomField>;
    /**
     * 
     * @type {boolean}
     * @memberof FreightDisplayOptions
     */
    showContainmentQuantity?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreightDisplayOptions
     */
    showFreightId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreightDisplayOptions
     */
    showStatus?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreightDisplayOptions
     */
    showTotalVolume?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreightDisplayOptions
     */
    showTotalWeight?: boolean;
}

/**
 * 
 * @export
 * @interface FreightInformation
 */
export interface FreightInformation {
    /**
     * 
     * @type {any}
     * @memberof FreightInformation
     */
    freightDetails?: any;
    /**
     * 
     * @type {string}
     * @memberof FreightInformation
     */
    verboseFreightInformation?: string;
}

/**
 * 
 * @export
 * @interface FreightMapping
 */
export interface FreightMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof FreightMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    containmentQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    containmentType?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    defaultLisLmArt?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    deliveryNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    externalFreightId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    freightId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    freightIdPrefix?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    height?: string;
    /**
     * 
     * @type {Array<LademiMapping>}
     * @memberof FreightMapping
     */
    lademiMapping?: Array<LademiMapping>;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    length?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof FreightMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    totalLoadingMeter?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    totalLots?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    totalQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    totalVolume?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    totalWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMapping
     */
    width?: string;
}

/**
 * 
 * @export
 * @interface FreightMappingFieldValues
 */
export interface FreightMappingFieldValues {
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    containmentNameExt?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    containmentQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    containmentType?: FreightMappingFieldValues.ContainmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    deliveryNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    externalFreightId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    freightId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    height?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    totalLoadingMeter?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    totalLots?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    totalQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    totalVolume?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    totalWeight?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMappingFieldValues
     */
    width?: string;
}

/**
 * @export
 * @namespace FreightMappingFieldValues
 */
export namespace FreightMappingFieldValues {
    /**
     * @export
     * @enum {string}
     */
    export enum ContainmentTypeEnum {
        EpalEurPallet = 'epalEurPallet',
        Epal2Pallet = 'epal2Pallet',
        Epal3Pallet = 'epal3Pallet',
        Epal6HalfPallet = 'epal6HalfPallet',
        Epal7HalfPallet = 'epal7HalfPallet',
        EpalBoxPallet = 'epalBoxPallet',
        ChepEuroPallet = 'chepEuroPallet',
        ChepHalfPallet = 'chepHalfPallet',
        ChepIndustrialPallet = 'chepIndustrialPallet',
        ChepPlasticEurPallet = 'chepPlasticEurPallet',
        ChepPlasticQuarterPallet = 'chepPlasticQuarterPallet',
        Pallet = 'pallet',
        PalletCollar = 'palletCollar',
        EurH1PlasticPallet = 'eurH1PlasticPallet',
        PaperSack = 'paperSack',
        InflatableBag = 'inflatableBag',
        Container20ft = 'container20ft',
        Container40ft = 'container40ft',
        Container45ft = 'container45ft',
        Container48ft = 'container48ft',
        Container53ft = 'container53ft',
        IbcContainer = 'ibcContainer',
        IntermediateBulkContainer = 'intermediateBulkContainer',
        IfcoTray = 'ifcoTray',
        SlipSheet = 'slipSheet',
        CagePallet = 'cagePallet',
        RollContainer = 'rollContainer',
        Bag = 'bag',
        Box = 'box',
        Piece = 'piece',
        Other = 'other'
    }
}

/**
 * 
 * @export
 * @interface FreightMergingOptions
 */
export interface FreightMergingOptions {
    /**
     * 
     * @type {string}
     * @memberof FreightMergingOptions
     */
    displayName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FreightMergingOptions
     */
    enable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FreightMergingOptions
     */
    excludeScript?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightMergingOptions
     */
    groupingKey?: FreightMergingOptions.GroupingKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof FreightMergingOptions
     */
    includeScript?: string;
}

/**
 * @export
 * @namespace FreightMergingOptions
 */
export namespace FreightMergingOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum GroupingKeyEnum {
        None = 'None',
        ContainmentType = 'ContainmentType',
        ContainmentName = 'ContainmentName'
    }
}

/**
 * 
 * @export
 * @interface FreightStatus
 */
export interface FreightStatus {
    /**
     * Additional key-value-pairs associated with this status
     * @type {Array<AdditionalDataEntry>}
     * @memberof FreightStatus
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    deliveredTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    loadedTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    loadingTimestamp?: Date;
    /**
     * 
     * @type {GpsPosition}
     * @memberof FreightStatus
     */
    location?: GpsPosition;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    notLoadedTimestamp?: Date;
    /**
     * 
     * @type {Origin}
     * @memberof FreightStatus
     */
    origin?: Origin;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    pickedTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    rejectedTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof FreightStatus
     */
    sender?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightStatus
     */
    statusCode?: FreightStatus.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    timestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatus
     */
    unloadingTimestamp?: Date;
}

/**
 * @export
 * @namespace FreightStatus
 */
export namespace FreightStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface FreightStatusMapping
 */
export interface FreightStatusMapping {
    /**
     * 
     * @type {string}
     * @memberof FreightStatusMapping
     */
    applyWhen?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightStatusMapping
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightStatusMapping
     */
    statusCode?: FreightStatusMapping.StatusCodeEnum;
    /**
     * 
     * @type {LisStatusFields}
     * @memberof FreightStatusMapping
     */
    statusFields?: LisStatusFields;
    /**
     * 
     * @type {string}
     * @memberof FreightStatusMapping
     */
    targetStatus?: string;
}

/**
 * @export
 * @namespace FreightStatusMapping
 */
export namespace FreightStatusMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface FreightStatusRequest
 */
export interface FreightStatusRequest {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof FreightStatusRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof FreightStatusRequest
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FreightStatusRequest
     */
    forceOverrideDependentStates?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreightStatusRequest
     */
    forceOverrideTimestamp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FreightStatusRequest
     */
    freightId?: string;
    /**
     * 
     * @type {Origin}
     * @memberof FreightStatusRequest
     */
    origin?: Origin;
    /**
     * The status which should be submitted
     * @type {string}
     * @memberof FreightStatusRequest
     */
    statusCode?: FreightStatusRequest.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof FreightStatusRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof FreightStatusRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace FreightStatusRequest
 */
export namespace FreightStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface FreightTableViewConfiguration
 */
export interface FreightTableViewConfiguration {
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof FreightTableViewConfiguration
     */
    additionalColums?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof FreightTableViewConfiguration
     */
    amountColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof FreightTableViewConfiguration
     */
    externalFreightIdColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof FreightTableViewConfiguration
     */
    nrColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof FreightTableViewConfiguration
     */
    shipmentNrColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof FreightTableViewConfiguration
     */
    verboseNameColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof FreightTableViewConfiguration
     */
    weightColumn?: FieldViewConfiguration;
}

/**
 * 
 * @export
 * @interface FreightWithTO
 */
export interface FreightWithTO {
    /**
     * 
     * @type {Freight}
     * @memberof FreightWithTO
     */
    freight?: Freight;
    /**
     * 
     * @type {TransportOrder}
     * @memberof FreightWithTO
     */
    transportOrder?: TransportOrder;
}

/**
 * 
 * @export
 * @interface FtpSpecificFolderConfiguration
 */
export interface FtpSpecificFolderConfiguration {
    /**
     * 
     * @type {string}
     * @memberof FtpSpecificFolderConfiguration
     */
    folderName?: string;
    /**
     * 
     * @type {FtpSpecificFolderSelectConfiguration}
     * @memberof FtpSpecificFolderConfiguration
     */
    whenAll?: FtpSpecificFolderSelectConfiguration;
}

/**
 * 
 * @export
 * @interface FtpSpecificFolderSelectConfiguration
 */
export interface FtpSpecificFolderSelectConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof FtpSpecificFolderSelectConfiguration
     */
    isAttachment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FtpSpecificFolderSelectConfiguration
     */
    isStatusEvent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FtpSpecificFolderSelectConfiguration
     */
    sourceCompanyIdMatches?: string;
    /**
     * 
     * @type {string}
     * @memberof FtpSpecificFolderSelectConfiguration
     */
    targetCompanyIdMatches?: string;
    /**
     * 
     * @type {string}
     * @memberof FtpSpecificFolderSelectConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface GehrAuftragMapping
 */
export interface GehrAuftragMapping {
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    adressstammExtBezGehr?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    ansprechpartner?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    dispoBemerkung?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    dokumente?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    entladeDatum?: string;
    /**
     * 
     * @type {GehrHaltestelleMapping}
     * @memberof GehrAuftragMapping
     */
    entladestelle?: GehrHaltestelleMapping;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    entladezeit?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    extBezRel_Gehr?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    frachtbetrag?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    frachtzahlerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    frankatur?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    imAuftrag?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    infoEins?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    kundennummer?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    ladeDatum?: string;
    /**
     * 
     * @type {GehrHaltestelleMapping}
     * @memberof GehrAuftragMapping
     */
    ladestelle?: GehrHaltestelleMapping;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    ladezeit?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    quelle?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    referenznummer?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrAuftragMapping
     */
    vorschriften?: string;
}

/**
 * 
 * @export
 * @interface GehrConfiguration
 */
export interface GehrConfiguration {
    /**
     * 
     * @type {string}
     * @memberof GehrConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {GehrExportConfiguration}
     * @memberof GehrConfiguration
     */
    _export?: GehrExportConfiguration;
}

/**
 * 
 * @export
 * @interface GehrExportConfiguration
 */
export interface GehrExportConfiguration {
    /**
     * 
     * @type {GehrAuftragMapping}
     * @memberof GehrExportConfiguration
     */
    gehrAuftragMapping?: GehrAuftragMapping;
    /**
     * 
     * @type {boolean}
     * @memberof GehrExportConfiguration
     */
    shouldMergeTransportFreightPairs?: boolean;
}

/**
 * 
 * @export
 * @interface GehrHaltestelleMapping
 */
export interface GehrHaltestelleMapping {
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    abfahrtPlan?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    addressId?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    ankunftPlan?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    bemerkung?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    entladebeginnPlan?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    entladeendePlan?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    firma?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    fixtermin?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    ladebeginnPlan?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    ladeendePlan?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    land?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    lieferscheinNr?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    ort?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    plz?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    strasse?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    tarifkilometer?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrHaltestelleMapping
     */
    termin?: string;
    /**
     * 
     * @type {GehrWareMapping}
     * @memberof GehrHaltestelleMapping
     */
    ware?: GehrWareMapping;
}

/**
 * 
 * @export
 * @interface GehrWareMapping
 */
export interface GehrWareMapping {
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    bemerkung?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    bezeichnung?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    breiteWare_cm?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    bruttoGewicht?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    hoeheWare_cm?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    lademeter?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    laengeWare_cm?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    menge?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    nettoGewicht?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    verpackung?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    volumen?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    volumenGewicht_kg?: string;
    /**
     * 
     * @type {string}
     * @memberof GehrWareMapping
     */
    volumen_m3?: string;
}

/**
 * 
 * @export
 * @interface GenericAiAdditionalField
 */
export interface GenericAiAdditionalField {
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiAdditionalField
     */
    extractInSeparatePrompt?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericAiAdditionalField
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiAdditionalField
     */
    level?: GenericAiAdditionalField.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericAiAdditionalField
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiAdditionalField
     */
    prompt?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiAdditionalField
     */
    separatePromptModel?: GenericAiAdditionalField.SeparatePromptModelEnum;
}

/**
 * @export
 * @namespace GenericAiAdditionalField
 */
export namespace GenericAiAdditionalField {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        SHIPMENT = 'SHIPMENT',
        FREIGHT = 'FREIGHT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SeparatePromptModelEnum {
        ANTHROPIC = 'ANTHROPIC',
        OPENAI = 'OPEN_AI',
        DEEPSEEK = 'DEEPSEEK',
        ANTHROPIC37SONNET = 'ANTHROPIC37_SONNET',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        CLAUDE4SONNET = 'CLAUDE4_SONNET',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        CLAUDE45SONNET = 'CLAUDE45_SONNET',
        CLAUDE45HAIKU = 'CLAUDE45_HAIKU',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE45SONNETTHINKING = 'CLAUDE45_SONNET_THINKING',
        CLAUDE45OPUSTHINKING = 'CLAUDE45_OPUS_THINKING',
        CLAUDE46SONNETTHINKING = 'CLAUDE46_SONNET_THINKING',
        CLAUDE46OPUSTHINKING = 'CLAUDE46_OPUS_THINKING',
        QWEN3635B = 'QWEN36_35B',
        GEMMA426B = 'GEMMA4_26B',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38THINKING = 'QWEN38_THINKING',
        QWEN38 = 'QWEN38'
    }
}

/**
 * 
 * @export
 * @interface GenericAiConfiguration
 */
export interface GenericAiConfiguration {
    /**
     * 
     * @type {number}
     * @memberof GenericAiConfiguration
     */
    acceptanceScoreThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    addMergeAndOrderKey?: boolean;
    /**
     * 
     * @type {Array<GenericAiAdditionalField>}
     * @memberof GenericAiConfiguration
     */
    additionalFields?: Array<GenericAiAdditionalField>;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    additionalParseFreightInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    aiParseModel?: GenericAiConfiguration.AiParseModelEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    aiParseModelParseFreight?: GenericAiConfiguration.AiParseModelParseFreightEnum;
    /**
     * 
     * @type {AiProcessingSettings}
     * @memberof GenericAiConfiguration
     */
    aiProcessingSettings?: AiProcessingSettings;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    allowEqualLoadAndUnloadAddress?: boolean;
    /**
     * 
     * @type {Array<AttachmentCategoryFilterBasedOnKeyWords>}
     * @memberof GenericAiConfiguration
     */
    attachmentCategoryFilterKeyWords?: Array<AttachmentCategoryFilterBasedOnKeyWords>;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    companyNameThatCanNotBeUsedAsConsignor?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    externalTargetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    externalTransportOrderIdHandling?: GenericAiConfiguration.ExternalTransportOrderIdHandlingEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    extractFreightPayer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    extractFreightPayerInstructions?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    extractHorizontalLinesFromPDFOrImage?: boolean;
    /**
     * 
     * @type {Array<AiExtractionRule>}
     * @memberof GenericAiConfiguration
     */
    extractionRules?: Array<AiExtractionRule>;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    fuseOcrResultWithExtractedText?: boolean;
    /**
     * 
     * @type {Array<GenericAiTourExample>}
     * @memberof GenericAiConfiguration
     */
    genericAiTourExamples?: Array<GenericAiTourExample>;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    html2PdfUsingSeleniumAndChrome?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    includeOriginalAttachmentsInImport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    includeRelevantAttachmentsOnly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    modifyMode?: GenericAiConfiguration.ModifyModeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    observerCcAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    observerHandling?: GenericAiConfiguration.ObserverHandlingEnum;
    /**
     * 
     * @type {PagesContainingKeywordsFilter}
     * @memberof GenericAiConfiguration
     */
    pagesContainingKeywordsFilter?: PagesContainingKeywordsFilter;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    parseAddressStyle?: GenericAiConfiguration.ParseAddressStyleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    parseFreightV2?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    pdfStripperEngine?: GenericAiConfiguration.PdfStripperEngineEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    postImportKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    postImportPrompt?: string;
    /**
     * 
     * @type {PreSplitPDFOptions}
     * @memberof GenericAiConfiguration
     */
    preSplitPDFOptions?: PreSplitPDFOptions;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    preSplitPDFs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    processFirstPageOnlyExcelFiles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericAiConfiguration
     */
    processPDFasImgOCR?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GenericAiConfiguration
     */
    processPDFasImgOCRCustomDpi?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    prompt1?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    prompt1AdditionalInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    prompt2?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    prompt2AdditionalInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    promptVersion?: GenericAiConfiguration.PromptVersionEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericAiConfiguration
     */
    removePagesContainingKeywords?: Array<string>;
    /**
     * 
     * @type {Array<GenericAiSpecificConfiguration>}
     * @memberof GenericAiConfiguration
     */
    specificConfigurations?: Array<GenericAiSpecificConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof GenericAiConfiguration
     */
    xlsxSheetFilterPrompt?: string;
}

/**
 * @export
 * @namespace GenericAiConfiguration
 */
export namespace GenericAiConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum AiParseModelEnum {
        ANTHROPIC = 'ANTHROPIC',
        OPENAI = 'OPEN_AI',
        DEEPSEEK = 'DEEPSEEK',
        ANTHROPIC37SONNET = 'ANTHROPIC37_SONNET',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        CLAUDE4SONNET = 'CLAUDE4_SONNET',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        CLAUDE45SONNET = 'CLAUDE45_SONNET',
        CLAUDE45HAIKU = 'CLAUDE45_HAIKU',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE45SONNETTHINKING = 'CLAUDE45_SONNET_THINKING',
        CLAUDE45OPUSTHINKING = 'CLAUDE45_OPUS_THINKING',
        CLAUDE46SONNETTHINKING = 'CLAUDE46_SONNET_THINKING',
        CLAUDE46OPUSTHINKING = 'CLAUDE46_OPUS_THINKING',
        QWEN3635B = 'QWEN36_35B',
        GEMMA426B = 'GEMMA4_26B',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38THINKING = 'QWEN38_THINKING',
        QWEN38 = 'QWEN38'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AiParseModelParseFreightEnum {
        ANTHROPIC35SONNET = 'ANTHROPIC35_SONNET',
        OPENAI4O = 'OPEN_AI_4O',
        DEEPSEEKV3 = 'DEEPSEEK_V3',
        ANTHROPIC37SONNET = 'ANTHROPIC37_SONNET',
        CLAUDE45HAIKU = 'CLAUDE45_HAIKU',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE45SONNET = 'CLAUDE45_SONNET',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38THINKING = 'QWEN38_THINKING',
        QWEN38 = 'QWEN38'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExternalTransportOrderIdHandlingEnum {
        LEAVEEMPTY = 'LEAVE_EMPTY',
        DEDUPLICATEBESTGUESS = 'DEDUPLICATE_BEST_GUESS',
        USEEXTRACTEDIDONLY = 'USE_EXTRACTED_ID_ONLY'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH',
        PATCHNOFREIGHTNOTRANSPORTS = 'PATCH_NO_FREIGHT_NO_TRANSPORTS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ObserverHandlingEnum {
        LEAVEEMPTY = 'LEAVE_EMPTY',
        EXTRACTMAIL = 'EXTRACT_MAIL',
        EXTRACTMAILANDNOTIFYIMMEDIATELY = 'EXTRACT_MAIL_AND_NOTIFY_IMMEDIATELY',
        EXTRACTMAILANDNOTIFYONSTATUSEXECUTING = 'EXTRACT_MAIL_AND_NOTIFY_ON_STATUS_EXECUTING',
        EXTRACTMAILSHIPMENTBASEDANDNOTIFYIMMEDIATELY = 'EXTRACT_MAIL_SHIPMENT_BASED_AND_NOTIFY_IMMEDIATELY',
        EXTRACTMAILSHIPMENTBASEDANDNOTIFYONSTATUSEXECUTING = 'EXTRACT_MAIL_SHIPMENT_BASED_AND_NOTIFY_ON_STATUS_EXECUTING',
        EXTRACTMAILSHIPMENTBASED = 'EXTRACT_MAIL_SHIPMENT_BASED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ParseAddressStyleEnum {
        ALLADDRESSES = 'PARSE_ALL_ADDRESSES',
        ADDRESS = 'PARSE_ADDRESS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PdfStripperEngineEnum {
        GOOGLECLOUDVISION = 'GOOGLE_CLOUD_VISION',
        PDFV2 = 'PDF_V2'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PromptVersionEnum {
        V1 = 'V1',
        V2 = 'V2'
    }
}

/**
 * 
 * @export
 * @interface GenericAiShipment
 */
export interface GenericAiShipment {
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    comment?: string;
    /**
     * 
     * @type {any}
     * @memberof GenericAiShipment
     */
    details?: any;
    /**
     * 
     * @type {number}
     * @memberof GenericAiShipment
     */
    freightLoadingMeter?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericAiShipment
     */
    freightQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericAiShipment
     */
    freightWeight?: number;
    /**
     * 
     * @type {Array<FreightInformation>}
     * @memberof GenericAiShipment
     */
    freights?: Array<FreightInformation>;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    freightsPayer?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    loadingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    loadingDateTimeRange?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericAiShipment
     */
    loadingMergeAndOrderKey?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    loadingOpeningHours?: string;
    /**
     * 
     * @type {Array<PropertyNameAndValue>}
     * @memberof GenericAiShipment
     */
    otherReferenceNumbers?: Array<PropertyNameAndValue>;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    shipmentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    unloadingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    unloadingDateTimeRange?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericAiShipment
     */
    unloadingMergeAndOrderKey?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    unloadingOpeningHours?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiShipment
     */
    verboseFreightName?: string;
}

/**
 * 
 * @export
 * @interface GenericAiSpecificConfiguration
 */
export interface GenericAiSpecificConfiguration {
    /**
     * 
     * @type {GenericAiSpecificConfigurationApplyRules}
     * @memberof GenericAiSpecificConfiguration
     */
    applyWhenAny?: GenericAiSpecificConfigurationApplyRules;
    /**
     * 
     * @type {GenericAiConfiguration}
     * @memberof GenericAiSpecificConfiguration
     */
    override?: GenericAiConfiguration;
    /**
     * 
     * @type {string}
     * @memberof GenericAiSpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface GenericAiSpecificConfigurationApplyRules
 */
export interface GenericAiSpecificConfigurationApplyRules {
    /**
     * 
     * @type {string}
     * @memberof GenericAiSpecificConfigurationApplyRules
     */
    fileNameMatches?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiSpecificConfigurationApplyRules
     */
    inputTextContains?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiSpecificConfigurationApplyRules
     */
    inputTextMatches?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiSpecificConfigurationApplyRules
     */
    receiverMailAddressIs?: string;
}

/**
 * 
 * @export
 * @interface GenericAiTour
 */
export interface GenericAiTour {
    /**
     * 
     * @type {string}
     * @memberof GenericAiTour
     */
    consignor?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTour
     */
    creator?: string;
    /**
     * 
     * @type {any}
     * @memberof GenericAiTour
     */
    details?: any;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTour
     */
    emailAddressNotifiedOfProgress?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTour
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericAiTour
     */
    responsibleAttachmentIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTour
     */
    responsibleAttachmentName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GenericAiTour
     */
    responsiblePageNumbers?: Array<number>;
    /**
     * 
     * @type {Array<GenericAiShipment>}
     * @memberof GenericAiTour
     */
    shipments?: Array<GenericAiShipment>;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTour
     */
    verboseChargeInformation?: string;
}

/**
 * 
 * @export
 * @interface GenericAiTourExample
 */
export interface GenericAiTourExample {
    /**
     * 
     * @type {string}
     * @memberof GenericAiTourExample
     */
    additionalInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTourExample
     */
    emailText?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTourExample
     */
    exampleId?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericAiTourExample
     */
    exampleName?: string;
    /**
     * 
     * @type {Array<GenericAiTour>}
     * @memberof GenericAiTourExample
     */
    extractedTransportOrders?: Array<GenericAiTour>;
}

/**
 * 
 * @export
 * @interface GenericGroovyExport
 */
export interface GenericGroovyExport {
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportAssignVehicleEventScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportAttachmentEventScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportEtaEventScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportFreightStatusScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportLinkEventScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportObserverStatusScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportPositionEventScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportStopLocationStatusScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportTextMessageEventScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportTransportOrderScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    exportTransportOrderStatusScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyExport
     */
    language?: GenericGroovyExport.LanguageEnum;
}

/**
 * @export
 * @namespace GenericGroovyExport
 */
export namespace GenericGroovyExport {
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        KOTLIN = 'KOTLIN',
        GROOVY = 'GROOVY'
    }
}

/**
 * 
 * @export
 * @interface GenericGroovyImport
 */
export interface GenericGroovyImport {
    /**
     * 
     * @type {boolean}
     * @memberof GenericGroovyImport
     */
    abortOnScriptError?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyImport
     */
    importTransportOrderScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovyImport
     */
    language?: GenericGroovyImport.LanguageEnum;
}

/**
 * @export
 * @namespace GenericGroovyImport
 */
export namespace GenericGroovyImport {
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        KOTLIN = 'KOTLIN',
        GROOVY = 'GROOVY'
    }
}

/**
 * 
 * @export
 * @interface GenericGroovySpecificConfigurationApplyRules
 */
export interface GenericGroovySpecificConfigurationApplyRules {
    /**
     * 
     * @type {string}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    inputFilenameMatches?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    onConversionToExternalFormat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    onConversionToTransportOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    sourceCompanyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    sourceCompanyTag?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    specificConfigAdditionalIs?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    whenScript?: string;
    /**
     * 
     * @type {GenericGroovySpecificConfigurationApplyWhenOrderHasAdditionalData}
     * @memberof GenericGroovySpecificConfigurationApplyRules
     */
    whenTransportOrderHasAdditionalData?: GenericGroovySpecificConfigurationApplyWhenOrderHasAdditionalData;
}

/**
 * 
 * @export
 * @interface GenericGroovySpecificConfigurationApplyWhenOrderHasAdditionalData
 */
export interface GenericGroovySpecificConfigurationApplyWhenOrderHasAdditionalData {
    /**
     * 
     * @type {string}
     * @memberof GenericGroovySpecificConfigurationApplyWhenOrderHasAdditionalData
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericGroovySpecificConfigurationApplyWhenOrderHasAdditionalData
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface GenericImporterConfiguration
 */
export interface GenericImporterConfiguration {
    /**
     * 
     * @type {string}
     * @memberof GenericImporterConfiguration
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {GenericGroovyExport}
     * @memberof GenericImporterConfiguration
     */
    _export?: GenericGroovyExport;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterConfiguration
     */
    fileExtension?: string;
    /**
     * 
     * @type {GenericGroovyImport}
     * @memberof GenericImporterConfiguration
     */
    _import?: GenericGroovyImport;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterConfiguration
     */
    modifyMode?: GenericImporterConfiguration.ModifyModeEnum;
    /**
     * 
     * @type {Array<GenericImporterSpecificConfiguration>}
     * @memberof GenericImporterConfiguration
     */
    specificConfigurations?: Array<GenericImporterSpecificConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterConfiguration
     */
    timezone?: string;
}

/**
 * @export
 * @namespace GenericImporterConfiguration
 */
export namespace GenericImporterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface GenericImporterOverride
 */
export interface GenericImporterOverride {
    /**
     * 
     * @type {string}
     * @memberof GenericImporterOverride
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterOverride
     */
    encoding?: string;
    /**
     * 
     * @type {GenericGroovyExport}
     * @memberof GenericImporterOverride
     */
    _export?: GenericGroovyExport;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterOverride
     */
    fileExtension?: string;
    /**
     * 
     * @type {GenericGroovyImport}
     * @memberof GenericImporterOverride
     */
    _import?: GenericGroovyImport;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterOverride
     */
    modifyMode?: GenericImporterOverride.ModifyModeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterOverride
     */
    timezone?: string;
}

/**
 * @export
 * @namespace GenericImporterOverride
 */
export namespace GenericImporterOverride {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface GenericImporterSpecificConfiguration
 */
export interface GenericImporterSpecificConfiguration {
    /**
     * 
     * @type {GenericGroovySpecificConfigurationApplyRules}
     * @memberof GenericImporterSpecificConfiguration
     */
    applyWhenAll?: GenericGroovySpecificConfigurationApplyRules;
    /**
     * 
     * @type {GenericImporterOverride}
     * @memberof GenericImporterSpecificConfiguration
     */
    override?: GenericImporterOverride;
    /**
     * 
     * @type {string}
     * @memberof GenericImporterSpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface GenericPushConfiguration
 */
export interface GenericPushConfiguration {
    /**
     * 
     * @type {string}
     * @memberof GenericPushConfiguration
     */
    destinationDirectory?: GenericPushConfiguration.DestinationDirectoryEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericPushConfiguration
     */
    fileExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericPushConfiguration
     */
    responseContentType?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericPushConfiguration
     */
    responseStatusCode?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericPushConfiguration
     */
    responseText?: string;
}

/**
 * @export
 * @namespace GenericPushConfiguration
 */
export namespace GenericPushConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum DestinationDirectoryEnum {
        Customer2Logenios = 'Customer2Logenios',
        Attachment2Logenios = 'Attachment2Logenios',
        Telematic2Logenios = 'Telematic2Logenios'
    }
}

/**
 * 
 * @export
 * @interface GenericXlsConfigurationOverride
 */
export interface GenericXlsConfigurationOverride {
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    abortOnScriptError?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    attachExtractedExcelFile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    attachOriginalInput?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    disableSplittingOfAttachmentsBasedOnSplitMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    evaluateExcelFormulas?: boolean;
    /**
     * 
     * @type {Array<GenericXlsExtractionRule>}
     * @memberof GenericXlsConfigurationOverride
     */
    extractionRules?: Array<GenericXlsExtractionRule>;
    /**
     * 
     * @type {GenericXlsImmediateFormatParserOptions}
     * @memberof GenericXlsConfigurationOverride
     */
    immediateFormatParserOptions?: GenericXlsImmediateFormatParserOptions;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConfigurationOverride
     */
    importScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConfigurationOverride
     */
    inputFormat?: GenericXlsConfigurationOverride.InputFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConfigurationOverride
     */
    originalInputAttachmentCategory?: GenericXlsConfigurationOverride.OriginalInputAttachmentCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConfigurationOverride
     */
    originalInputAttachmentStatus?: GenericXlsConfigurationOverride.OriginalInputAttachmentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsConfigurationOverride
     */
    originalInputPageCopies?: number;
    /**
     * 
     * @type {PagesContainingKeywordsFilter}
     * @memberof GenericXlsConfigurationOverride
     */
    pagesContainingKeywordsFilter?: PagesContainingKeywordsFilter;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    sanitizeAttachmentNames?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConfigurationOverride
     */
    scriptingLanguage?: GenericXlsConfigurationOverride.ScriptingLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    shouldModifyTransportOrderByPatch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConfigurationOverride
     */
    skipHiddenRows?: boolean;
    /**
     * 
     * @type {SplitterOptions}
     * @memberof GenericXlsConfigurationOverride
     */
    splitterOptions?: SplitterOptions;
}

/**
 * @export
 * @namespace GenericXlsConfigurationOverride
 */
export namespace GenericXlsConfigurationOverride {
    /**
     * @export
     * @enum {string}
     */
    export enum InputFormatEnum {
        XLS = 'XLS',
        CSV = 'CSV',
        PDF = 'PDF',
        PDFV2 = 'PDF_v2',
        OCRPDFV2 = 'OCR_PDF_v2',
        GOOGLEOCRPDFV2 = 'GOOGLE_OCR_PDF_v2',
        PDFFORM = 'PDF_FORM',
        HTML = 'HTML',
        HTMLV2 = 'HTML_v2',
        RAW = 'RAW',
        DOCX = 'DOCX',
        PDFV2NoSegmentation = 'PDF_v2_noSegmentation',
        PDFV2ElasticPlacement = 'PDF_v2_elasticPlacement',
        PDFV2ElasticPlacementNoSegmentation = 'PDF_v2_elasticPlacement_noSegmentation',
        EDI = 'EDI',
        XML = 'XML',
        FORTRAS = 'FORTRAS',
        EML = 'EML',
        JSONMAIL = 'JSON_MAIL',
        JSON = 'JSON',
        GOOGLEOCRPDFV2FUSIONWITHTESSERACT = 'GOOGLE_OCR_PDF_v2_FUSION_WITH_TESSERACT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OriginalInputAttachmentCategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OriginalInputAttachmentStatusEnum {
        CREATED = 'CREATED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ScriptingLanguageEnum {
        KOTLIN = 'KOTLIN',
        GROOVY = 'GROOVY',
        RULEBASED = 'RULE_BASED'
    }
}

/**
 * 
 * @export
 * @interface GenericXlsConverterConfiguration
 */
export interface GenericXlsConverterConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    abortOnScriptError?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConverterConfiguration
     */
    aiParseModelParseADRDescription?: GenericXlsConverterConfiguration.AiParseModelParseADRDescriptionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    attachExtractedExcelFile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    attachExtractedTextAsPdf?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    attachOriginalInput?: boolean;
    /**
     * 
     * @type {CsvInputFormatOptions}
     * @memberof GenericXlsConverterConfiguration
     */
    csvInputFormatOptions?: CsvInputFormatOptions;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    disableSplittingOfAttachmentsBasedOnSplitMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    evaluateExcelFormulas?: boolean;
    /**
     * 
     * @type {Array<GenericXlsExtractionRule>}
     * @memberof GenericXlsConverterConfiguration
     */
    extractionRules?: Array<GenericXlsExtractionRule>;
    /**
     * 
     * @type {GenericXlsImmediateFormatParserOptions}
     * @memberof GenericXlsConverterConfiguration
     */
    immediateFormatParserOptions?: GenericXlsImmediateFormatParserOptions;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConverterConfiguration
     */
    importScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConverterConfiguration
     */
    inputFormat?: GenericXlsConverterConfiguration.InputFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConverterConfiguration
     */
    originalInputAttachmentCategory?: GenericXlsConverterConfiguration.OriginalInputAttachmentCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConverterConfiguration
     */
    originalInputAttachmentStatus?: GenericXlsConverterConfiguration.OriginalInputAttachmentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsConverterConfiguration
     */
    originalInputPageCopies?: number;
    /**
     * 
     * @type {PagesContainingKeywordsFilter}
     * @memberof GenericXlsConverterConfiguration
     */
    pagesContainingKeywordsFilter?: PagesContainingKeywordsFilter;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    sanitizeAttachmentNames?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsConverterConfiguration
     */
    scriptingLanguage?: GenericXlsConverterConfiguration.ScriptingLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    shouldModifyTransportOrderByPatch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsConverterConfiguration
     */
    skipHiddenRows?: boolean;
    /**
     * 
     * @type {Array<GenericXlsSpecificConfiguration>}
     * @memberof GenericXlsConverterConfiguration
     */
    specificConfiguration?: Array<GenericXlsSpecificConfiguration>;
    /**
     * 
     * @type {SplitterOptions}
     * @memberof GenericXlsConverterConfiguration
     */
    splitterOptions?: SplitterOptions;
    /**
     * 
     * @type {Array<GenericXlsExtractionRule>}
     * @memberof GenericXlsConverterConfiguration
     */
    splittingRules?: Array<GenericXlsExtractionRule>;
}

/**
 * @export
 * @namespace GenericXlsConverterConfiguration
 */
export namespace GenericXlsConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum AiParseModelParseADRDescriptionEnum {
        ANTHROPIC35SONNET = 'ANTHROPIC35_SONNET',
        OPENAI4O = 'OPEN_AI_4O',
        DEEPSEEKV3 = 'DEEPSEEK_V3',
        ANTHROPIC37SONNET = 'ANTHROPIC37_SONNET',
        CLAUDE45HAIKU = 'CLAUDE45_HAIKU',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum InputFormatEnum {
        XLS = 'XLS',
        CSV = 'CSV',
        PDF = 'PDF',
        PDFV2 = 'PDF_v2',
        OCRPDFV2 = 'OCR_PDF_v2',
        GOOGLEOCRPDFV2 = 'GOOGLE_OCR_PDF_v2',
        PDFFORM = 'PDF_FORM',
        HTML = 'HTML',
        HTMLV2 = 'HTML_v2',
        RAW = 'RAW',
        DOCX = 'DOCX',
        PDFV2NoSegmentation = 'PDF_v2_noSegmentation',
        PDFV2ElasticPlacement = 'PDF_v2_elasticPlacement',
        PDFV2ElasticPlacementNoSegmentation = 'PDF_v2_elasticPlacement_noSegmentation',
        EDI = 'EDI',
        XML = 'XML',
        FORTRAS = 'FORTRAS',
        EML = 'EML',
        JSONMAIL = 'JSON_MAIL',
        JSON = 'JSON',
        GOOGLEOCRPDFV2FUSIONWITHTESSERACT = 'GOOGLE_OCR_PDF_v2_FUSION_WITH_TESSERACT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OriginalInputAttachmentCategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OriginalInputAttachmentStatusEnum {
        CREATED = 'CREATED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ScriptingLanguageEnum {
        KOTLIN = 'KOTLIN',
        GROOVY = 'GROOVY',
        RULEBASED = 'RULE_BASED'
    }
}

/**
 * 
 * @export
 * @interface GenericXlsExtractionRule
 */
export interface GenericXlsExtractionRule {
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    action?: GenericXlsExtractionRule.ActionEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    extractionRegex?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    ifNotAvailableTrigger?: GenericXlsExtractionRule.IfNotAvailableTriggerEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    matchOnColumns?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    matchText?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    matchWhen?: GenericXlsExtractionRule.MatchWhenEnum;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    offsetColumns?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    offsetLines?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    parentRuleId?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    ruleId?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    selectNumColumns?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    selectNumLines?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    selectionLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    selector?: GenericXlsExtractionRule.SelectorEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    selectorMatchText?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    selectorMatchWhen?: GenericXlsExtractionRule.SelectorMatchWhenEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsExtractionRule
     */
    skipEmptyCells?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    skipNumColumns?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    skipNumEntriesAtEnd?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    skipNumEntriesAtStart?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    splitEvery?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsExtractionRule
     */
    splitLineOffset?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsExtractionRule
     */
    splitOnlyOnChange?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    splitPointSelection?: GenericXlsExtractionRule.SplitPointSelectionEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsExtractionRule
     */
    tagName?: string;
}

/**
 * @export
 * @namespace GenericXlsExtractionRule
 */
export namespace GenericXlsExtractionRule {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionEnum {
        TAG = 'TAG',
        LABEL = 'LABEL',
        SQUASH = 'SQUASH',
        REMOVEEMPTYROWSANDCOLUMNS = 'REMOVE_EMPTY_ROWS_AND_COLUMNS',
        REMOVEEMPTYROWSONLY = 'REMOVE_EMPTY_ROWS_ONLY',
        REMOVEEMPTYCOLUMNSONLY = 'REMOVE_EMPTY_COLUMNS_ONLY'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IfNotAvailableTriggerEnum {
        DONOTHING = 'DO_NOTHING',
        SHOWSTATUSVALIDATIONWARNING = 'SHOW_STATUS_VALIDATION_WARNING',
        GOTOINPUTMISSING = 'GO_TO_INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MatchWhenEnum {
        EXACTMATCH = 'EXACT_MATCH',
        PARTIALMATCH = 'PARTIAL_MATCH',
        REGEXMATCH = 'REGEX_MATCH',
        MATCHONLINE = 'MATCH_ON_LINE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SelectorEnum {
        THISCELL = 'THIS_CELL',
        RIGHTCELL = 'RIGHT_CELL',
        LEFTCELL = 'LEFT_CELL',
        RECTANGLETILL = 'RECTANGLE_TILL',
        ROWSTILL = 'ROWS_TILL',
        THISCOLUMN = 'THIS_COLUMN',
        NEXTROW = 'NEXT_ROW',
        THISROW = 'THIS_ROW',
        PREVROW = 'PREV_ROW',
        NEXTCELLDOWN = 'NEXT_CELL_DOWN',
        NEXTCELLUP = 'NEXT_CELL_UP',
        AREATILLCELL = 'AREA_TILL_CELL',
        ROWSTILLCELL = 'ROWS_TILL_CELL',
        EXCLUDEROWSTILLCELL = 'EXCLUDE_ROWS_TILL_CELL',
        ROWSTILLNEXTMATCH = 'ROWS_TILL_NEXT_MATCH',
        SPLITALONGLINEBEFORE = 'SPLIT_ALONG_LINE_BEFORE',
        SPLITALONGLINEAFTER = 'SPLIT_ALONG_LINE_AFTER',
        RANGEWITHSIZE = 'RANGE_WITH_SIZE',
        REMAININGBUFFER = 'REMAINING_BUFFER',
        REMAININGBUFFERSPLITEVERY = 'REMAINING_BUFFER_SPLIT_EVERY'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SelectorMatchWhenEnum {
        EXACTMATCH = 'EXACT_MATCH',
        PARTIALMATCH = 'PARTIAL_MATCH',
        REGEXMATCH = 'REGEX_MATCH',
        MATCHONLINE = 'MATCH_ON_LINE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SplitPointSelectionEnum {
        OFFSETBASED = 'OFFSET_BASED',
        MATCHINGCELLBASED = 'MATCHING_CELL_BASED'
    }
}

/**
 * 
 * @export
 * @interface GenericXlsImmediateFormatParserOptions
 */
export interface GenericXlsImmediateFormatParserOptions {
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    aiModel?: GenericXlsImmediateFormatParserOptions.AiModelEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    aiModelForParsePlanTimes?: GenericXlsImmediateFormatParserOptions.AiModelForParsePlanTimesEnum;
    /**
     * 
     * @type {Array<ImmediateFormatAiPomt>}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    aiPompts?: Array<ImmediateFormatAiPomt>;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    dateFormat?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    defaultArriveHour?: number;
    /**
     * 
     * @type {number}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    defaultDepartHour?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    disableMergingInStopListMode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    genericAiPromptAdditionalInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    lengthUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    numberFormat?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    stopListMode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    timeFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsImmediateFormatParserOptions
     */
    weightUnit?: string;
}

/**
 * @export
 * @namespace GenericXlsImmediateFormatParserOptions
 */
export namespace GenericXlsImmediateFormatParserOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum AiModelEnum {
        LEGACY = 'LEGACY',
        GPT35 = 'GPT35',
        GPT4 = 'GPT4',
        GPT4TURBO = 'GPT4_TURBO',
        GPT4O = 'GPT4_O',
        GPT4OMini = 'GPT4_O_Mini',
        MISTRALTINY = 'MISTRAL_TINY',
        MISTRALSMALL = 'MISTRAL_SMALL',
        Claude35Sonnet = 'Claude35_Sonnet',
        DeepSeekV3 = 'DeepSeek_V3',
        Claude37Sonnet = 'Claude37_Sonnet',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        Claude4Sonnet = 'Claude4_Sonnet',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        Claude45Sonnet = 'Claude45_Sonnet',
        Claude45Haiku = 'Claude45_Haiku',
        GPT5NANO = 'GPT5_NANO',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE46SONNETTHINKING = 'CLAUDE46_SONNET_THINKING',
        CLAUDE46OPUSTHINKING = 'CLAUDE46_OPUS_THINKING',
        CLAUDE45SONNETTHINKING = 'CLAUDE45_SONNET_THINKING',
        CLAUDE45OPUSTHINKING = 'CLAUDE45_OPUS_THINKING',
        QWEN3635B = 'QWEN36_35B',
        GEMMA426B = 'GEMMA4_26B',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38 = 'QWEN38',
        QWEN38THINKING = 'QWEN38_THINKING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AiModelForParsePlanTimesEnum {
        LEGACY = 'LEGACY',
        GPT35 = 'GPT35',
        GPT4 = 'GPT4',
        GPT4TURBO = 'GPT4_TURBO',
        GPT4O = 'GPT4_O',
        GPT4OMini = 'GPT4_O_Mini',
        MISTRALTINY = 'MISTRAL_TINY',
        MISTRALSMALL = 'MISTRAL_SMALL',
        Claude35Sonnet = 'Claude35_Sonnet',
        DeepSeekV3 = 'DeepSeek_V3',
        Claude37Sonnet = 'Claude37_Sonnet',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        Claude4Sonnet = 'Claude4_Sonnet',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        Claude45Sonnet = 'Claude45_Sonnet',
        Claude45Haiku = 'Claude45_Haiku',
        GPT5NANO = 'GPT5_NANO',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE46SONNETTHINKING = 'CLAUDE46_SONNET_THINKING',
        CLAUDE46OPUSTHINKING = 'CLAUDE46_OPUS_THINKING',
        CLAUDE45SONNETTHINKING = 'CLAUDE45_SONNET_THINKING',
        CLAUDE45OPUSTHINKING = 'CLAUDE45_OPUS_THINKING',
        QWEN3635B = 'QWEN36_35B',
        GEMMA426B = 'GEMMA4_26B',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38 = 'QWEN38',
        QWEN38THINKING = 'QWEN38_THINKING'
    }
}

/**
 * 
 * @export
 * @interface GenericXlsSpecificConfiguration
 */
export interface GenericXlsSpecificConfiguration {
    /**
     * 
     * @type {GenericXlsSpecificConfigurationApplyRules}
     * @memberof GenericXlsSpecificConfiguration
     */
    applyWhen?: GenericXlsSpecificConfigurationApplyRules;
    /**
     * 
     * @type {GenericXlsConfigurationOverride}
     * @memberof GenericXlsSpecificConfiguration
     */
    override?: GenericXlsConfigurationOverride;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsSpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface GenericXlsSpecificConfigurationApplyRules
 */
export interface GenericXlsSpecificConfigurationApplyRules {
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsSpecificConfigurationApplyRules
     */
    onConversionToExternalFormat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenericXlsSpecificConfigurationApplyRules
     */
    onConversionToTransportOrder?: boolean;
    /**
     * 
     * @type {Array<GenericXlsExtractionRule>}
     * @memberof GenericXlsSpecificConfigurationApplyRules
     */
    onRuleMatch?: Array<GenericXlsExtractionRule>;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsSpecificConfigurationApplyRules
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericXlsSpecificConfigurationApplyRules
     */
    sourceCompanyId?: string;
}

/**
 * 
 * @export
 * @interface GenericZipConverterConfiguration
 */
export interface GenericZipConverterConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof GenericZipConverterConfiguration
     */
    abortOnScriptError?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenericZipConverterConfiguration
     */
    postImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericZipConverterConfiguration
     */
    preImportScript?: string;
}

/**
 * 
 * @export
 * @interface GeoStatusDataV2CompanyChange
 */
export interface GeoStatusDataV2CompanyChange {
    /**
     * 
     * @type {Company}
     * @memberof GeoStatusDataV2CompanyChange
     */
    company?: Company;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof GeoStatusDataV2CompanyChange
     */
    configuration?: CompanyConfiguration;
}

/**
 * 
 * @export
 * @interface GeoStatusDataV2Partnership
 */
export interface GeoStatusDataV2Partnership {
    /**
     * 
     * @type {string}
     * @memberof GeoStatusDataV2Partnership
     */
    company1?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoStatusDataV2Partnership
     */
    company2?: string;
}

/**
 * 
 * @export
 * @interface GeoStatusDumpTransportOrderListFilterRequest
 */
export interface GeoStatusDumpTransportOrderListFilterRequest {
    /**
     * 
     * @type {FetchTransportOrderListFilterRequest}
     * @memberof GeoStatusDumpTransportOrderListFilterRequest
     */
    filter?: FetchTransportOrderListFilterRequest;
    /**
     * 
     * @type {boolean}
     * @memberof GeoStatusDumpTransportOrderListFilterRequest
     */
    includeLinked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeoStatusDumpTransportOrderListFilterRequest
     */
    zipped?: boolean;
}

/**
 * 
 * @export
 * @interface GeoStatusDumpTransportOrderVersionRangeRequest
 */
export interface GeoStatusDumpTransportOrderVersionRangeRequest {
    /**
     * 
     * @type {DumpV2ActionFilter}
     * @memberof GeoStatusDumpTransportOrderVersionRangeRequest
     */
    actionFilter?: DumpV2ActionFilter;
    /**
     * 
     * @type {FetchTransportOrderListFilterRequest}
     * @memberof GeoStatusDumpTransportOrderVersionRangeRequest
     */
    filter?: FetchTransportOrderListFilterRequest;
    /**
     * 
     * @type {boolean}
     * @memberof GeoStatusDumpTransportOrderVersionRangeRequest
     */
    includeLinked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GeoStatusDumpTransportOrderVersionRangeRequest
     */
    sourceVersion?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoStatusDumpTransportOrderVersionRangeRequest
     */
    targetVersion?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeoStatusDumpTransportOrderVersionRangeRequest
     */
    zipped?: boolean;
}

/**
 * 
 * @export
 * @interface GeoStatusInfoResponse
 */
export interface GeoStatusInfoResponse {
    /**
     * 
     * @type {TimeInterval}
     * @memberof GeoStatusInfoResponse
     */
    arrivalTimeWindowForFirstStop?: TimeInterval;
    /**
     * 
     * @type {Vehicle}
     * @memberof GeoStatusInfoResponse
     */
    determinedVehicle?: Vehicle;
    /**
     * 
     * @type {string}
     * @memberof GeoStatusInfoResponse
     */
    sortMethod?: GeoStatusInfoResponse.SortMethodEnum;
    /**
     * 
     * @type {Array<StopWithResidenceTimes>}
     * @memberof GeoStatusInfoResponse
     */
    sortedStopsWithResidenceTimes?: Array<StopWithResidenceTimes>;
    /**
     * 
     * @type {StatusByVehiclePositionsConfiguration}
     * @memberof GeoStatusInfoResponse
     */
    statusByVehiclePositionsConfig?: StatusByVehiclePositionsConfiguration;
    /**
     * 
     * @type {TimeWindow}
     * @memberof GeoStatusInfoResponse
     */
    stopPlannedArrivalTimeWindow?: TimeWindow;
    /**
     * 
     * @type {boolean}
     * @memberof GeoStatusInfoResponse
     */
    transportOrderInTimeWindowToReceivePositions?: boolean;
    /**
     * 
     * @type {TimeInterval}
     * @memberof GeoStatusInfoResponse
     */
    transportOrderTimeWindowToReceivePositions?: TimeInterval;
}

/**
 * @export
 * @namespace GeoStatusInfoResponse
 */
export namespace GeoStatusInfoResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum SortMethodEnum {
        PLANNEDARRIVE = 'PLANNED_ARRIVE',
        PLANNEDDEPART = 'PLANNED_DEPART',
        BESTGUESS = 'BEST_GUESS',
        BYSTOPINDEX = 'BY_STOP_INDEX'
    }
}

/**
 * 
 * @export
 * @interface GeoStatusTestDataV2
 */
export interface GeoStatusTestDataV2 {
    /**
     * 
     * @type {Array<GeoStatusTestDataV2Action>}
     * @memberof GeoStatusTestDataV2
     */
    actions?: Array<GeoStatusTestDataV2Action>;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof GeoStatusTestDataV2
     */
    originalTransportOrders?: Array<TransportOrder>;
}

/**
 * 
 * @export
 * @interface GeoStatusTestDataV2Action
 */
export interface GeoStatusTestDataV2Action {
    /**
     * 
     * @type {GeoStatusDataV2CompanyChange}
     * @memberof GeoStatusTestDataV2Action
     */
    changeCompanyConfig?: GeoStatusDataV2CompanyChange;
    /**
     * 
     * @type {ChangeEvent}
     * @memberof GeoStatusTestDataV2Action
     */
    changeEvent?: ChangeEvent;
    /**
     * 
     * @type {GeoStatusDataV2CompanyChange}
     * @memberof GeoStatusTestDataV2Action
     */
    createCompany?: GeoStatusDataV2CompanyChange;
    /**
     * 
     * @type {ChangeEvent}
     * @memberof GeoStatusTestDataV2Action
     */
    createEvent?: ChangeEvent;
    /**
     * 
     * @type {GeoStatusDataV2Partnership}
     * @memberof GeoStatusTestDataV2Action
     */
    createPartner?: GeoStatusDataV2Partnership;
    /**
     * 
     * @type {Vehicle}
     * @memberof GeoStatusTestDataV2Action
     */
    createVehicle?: Vehicle;
    /**
     * 
     * @type {Position}
     * @memberof GeoStatusTestDataV2Action
     */
    position?: Position;
    /**
     * 
     * @type {Date}
     * @memberof GeoStatusTestDataV2Action
     */
    timestamp?: Date;
}

/**
 * 
 * @export
 * @interface GeoStatusTestDataV2WithVersionRange
 */
export interface GeoStatusTestDataV2WithVersionRange {
    /**
     * 
     * @type {Array<GeoStatusTestDataV2Action>}
     * @memberof GeoStatusTestDataV2WithVersionRange
     */
    actions?: Array<GeoStatusTestDataV2Action>;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof GeoStatusTestDataV2WithVersionRange
     */
    originalTransportOrders?: Array<TransportOrder>;
    /**
     * 
     * @type {Array<GeoStatusTransportOrderVersionBoundary>}
     * @memberof GeoStatusTestDataV2WithVersionRange
     */
    transportOrderVersionBoundaries?: Array<GeoStatusTransportOrderVersionBoundary>;
}

/**
 * 
 * @export
 * @interface GeoStatusTransportOrderVersionBoundary
 */
export interface GeoStatusTransportOrderVersionBoundary {
    /**
     * 
     * @type {string}
     * @memberof GeoStatusTransportOrderVersionBoundary
     */
    sourceChangeEventId?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof GeoStatusTransportOrderVersionBoundary
     */
    sourceTransportOrder?: TransportOrder;
    /**
     * 
     * @type {number}
     * @memberof GeoStatusTransportOrderVersionBoundary
     */
    sourceVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoStatusTransportOrderVersionBoundary
     */
    targetChangeEventId?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof GeoStatusTransportOrderVersionBoundary
     */
    targetTransportOrder?: TransportOrder;
    /**
     * 
     * @type {number}
     * @memberof GeoStatusTransportOrderVersionBoundary
     */
    targetVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoStatusTransportOrderVersionBoundary
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface Geocoding
 */
export interface Geocoding {
    /**
     * 
     * @type {string}
     * @memberof Geocoding
     */
    _id?: string;
    /**
     * 
     * @type {Address}
     * @memberof Geocoding
     */
    address?: Address;
    /**
     * 
     * @type {Coordinates}
     * @memberof Geocoding
     */
    coordinates?: Coordinates;
    /**
     * 
     * @type {string}
     * @memberof Geocoding
     */
    geocodingApiResponse?: string;
    /**
     * 
     * @type {string}
     * @memberof Geocoding
     */
    locationType?: string;
    /**
     * 
     * @type {string}
     * @memberof Geocoding
     */
    plusCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Geocoding
     */
    resultType?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof Geocoding
     */
    timestamp?: Date;
}

/**
 * 
 * @export
 * @interface Geofence
 */
export interface Geofence {
    /**
     * 
     * @type {string}
     * @memberof Geofence
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Geofence
     */
    geofence?: string;
    /**
     * 
     * @type {string}
     * @memberof Geofence
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface GerolsteinerResponse
 */
export interface GerolsteinerResponse {
    /**
     * 
     * @type {string}
     * @memberof GerolsteinerResponse
     */
    str?: string;
}

/**
 * 
 * @export
 * @interface GetAllCompaniesAndBilledOrdersResponse
 */
export interface GetAllCompaniesAndBilledOrdersResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAllCompaniesAndBilledOrdersResponse
     */
    allBilledOrders?: Array<string>;
    /**
     * 
     * @type {Array<CompanyShort>}
     * @memberof GetAllCompaniesAndBilledOrdersResponse
     */
    companies?: Array<CompanyShort>;
}

/**
 * 
 * @export
 * @interface GetAllConfigurationsThatChangedResponse
 */
export interface GetAllConfigurationsThatChangedResponse {
    /**
     * 
     * @type {Array<CompanyWithConfig>}
     * @memberof GetAllConfigurationsThatChangedResponse
     */
    companiesWithConfig?: Array<CompanyWithConfig>;
    /**
     * 
     * @type {string}
     * @memberof GetAllConfigurationsThatChangedResponse
     */
    fetchTime?: string;
}

/**
 * 
 * @export
 * @interface GetAllUnbilledOrdersForCompanyRequest
 */
export interface GetAllUnbilledOrdersForCompanyRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAllUnbilledOrdersForCompanyRequest
     */
    billedOrder?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetAllUnbilledOrdersForCompanyRequest
     */
    companyId?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllUnbilledOrdersForCompanyRequest
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllUnbilledOrdersForCompanyRequest
     */
    year?: number;
}

/**
 * 
 * @export
 * @interface GetAllUnbilledOrdersForCompanyResponse
 */
export interface GetAllUnbilledOrdersForCompanyResponse {
    /**
     * 
     * @type {CompanyShort}
     * @memberof GetAllUnbilledOrdersForCompanyResponse
     */
    company?: CompanyShort;
    /**
     * 
     * @type {Array<TransportOrderIdProjection>}
     * @memberof GetAllUnbilledOrdersForCompanyResponse
     */
    unbilledOrders?: Array<TransportOrderIdProjection>;
}

/**
 * 
 * @export
 * @interface GetCompaniesExcludedFromUnbilledTransportOrdersCalculationResponse
 */
export interface GetCompaniesExcludedFromUnbilledTransportOrdersCalculationResponse {
    /**
     * 
     * @type {Array<CompanyWithExcludeInfo>}
     * @memberof GetCompaniesExcludedFromUnbilledTransportOrdersCalculationResponse
     */
    companies?: Array<CompanyWithExcludeInfo>;
}

/**
 * 
 * @export
 * @interface GetCompanyNamesResponse
 */
export interface GetCompanyNamesResponse {
    /**
     * 
     * @type {Array<CompanyNameAndId>}
     * @memberof GetCompanyNamesResponse
     */
    companyNames?: Array<CompanyNameAndId>;
}

/**
 * 
 * @export
 * @interface GetConfigFieldDescriptionResponse
 */
export interface GetConfigFieldDescriptionResponse {
    /**
     * 
     * @type {Array<ConfigFieldDescription>}
     * @memberof GetConfigFieldDescriptionResponse
     */
    fieldDescriptionMap?: Array<ConfigFieldDescription>;
}

/**
 * 
 * @export
 * @interface GetGlobalGeofencesResponse
 */
export interface GetGlobalGeofencesResponse {
    /**
     * 
     * @type {Array<GlobalGeofence>}
     * @memberof GetGlobalGeofencesResponse
     */
    globalGeofences?: Array<GlobalGeofence>;
}

/**
 * 
 * @export
 * @interface GetScriptInfoResponse
 */
export interface GetScriptInfoResponse {
    /**
     * 
     * @type {any}
     * @memberof GetScriptInfoResponse
     */
    scripts?: any;
}

/**
 * 
 * @export
 * @interface GetTestFailuresRequest
 */
export interface GetTestFailuresRequest {
    /**
     * 
     * @type {string}
     * @memberof GetTestFailuresRequest
     */
    errorContains?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTestFailuresRequest
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTestFailuresRequest
     */
    testName?: string;
}

/**
 * 
 * @export
 * @interface GetTypeRequest
 */
export interface GetTypeRequest {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof GetTypeRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {Contract}
     * @memberof GetTypeRequest
     */
    contract?: Contract;
    /**
     * 
     * @type {string}
     * @memberof GetTypeRequest
     */
    path?: string;
}

/**
 * 
 * @export
 * @interface GetTypeResponse
 */
export interface GetTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTypeResponse
     */
    defaultDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypeResponse
     */
    defaultObject?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypeResponse
     */
    deprecatedMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTypeResponse
     */
    isCompanyId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTypeResponse
     */
    isDeprecated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTypeResponse
     */
    isEnum?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTypeResponse
     */
    isGroovyScript?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTypeResponse
     */
    isKotlinScript?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTypeResponse
     */
    isValueList?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTypeResponse
     */
    listType?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypeResponse
     */
    path?: string;
    /**
     * 
     * @type {any}
     * @memberof GetTypeResponse
     */
    scriptParameters?: any;
    /**
     * 
     * @type {string}
     * @memberof GetTypeResponse
     */
    type?: string;
}

/**
 * 
 * @export
 * @interface GetTypesRequest
 */
export interface GetTypesRequest {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof GetTypesRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {Contract}
     * @memberof GetTypesRequest
     */
    contract?: Contract;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTypesRequest
     */
    paths?: Array<string>;
}

/**
 * 
 * @export
 * @interface GetTypesResponse
 */
export interface GetTypesResponse {
    /**
     * 
     * @type {Array<GetTypeResponse>}
     * @memberof GetTypesResponse
     */
    responses?: Array<GetTypeResponse>;
}

/**
 * 
 * @export
 * @interface GetUserNameResponse
 */
export interface GetUserNameResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserNameResponse
     */
    userName?: string;
}

/**
 * 
 * @export
 * @interface GetUsersCompanyResponse
 */
export interface GetUsersCompanyResponse {
    /**
     * 
     * @type {Company}
     * @memberof GetUsersCompanyResponse
     */
    company?: Company;
}

/**
 * 
 * @export
 * @interface GlobalGeofence
 */
export interface GlobalGeofence {
    /**
     * Identifier of this global geofence
     * @type {string}
     * @memberof GlobalGeofence
     */
    _id?: string;
    /**
     * regext to match addresses against like 'stop.name name2 street city zip'
     * @type {string}
     * @memberof GlobalGeofence
     */
    addressRegex?: string;
    /**
     * geofences to match addresses
     * @type {Array<Geofence>}
     * @memberof GlobalGeofence
     */
    matchingAreaGeofences?: Array<Geofence>;
    /**
     * Name of the global geofence
     * @type {string}
     * @memberof GlobalGeofence
     */
    name?: string;
    /**
     * observers
     * @type {Array<Observer>}
     * @memberof GlobalGeofence
     */
    observers?: Array<Observer>;
    /**
     * 
     * @type {Geofence}
     * @memberof GlobalGeofence
     */
    resolvingGeofence?: Geofence;
}

/**
 * 
 * @export
 * @interface GoogleSheetDownloadConfiguration
 */
export interface GoogleSheetDownloadConfiguration {
    /**
     * 
     * @type {string}
     * @memberof GoogleSheetDownloadConfiguration
     */
    customFileName?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleSheetDownloadConfiguration
     */
    downloadIntervalInMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSheetDownloadConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleSheetDownloadConfiguration
     */
    googleSheetUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleSheetDownloadConfiguration
     */
    numberOfSheetsToImport?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSheetDownloadConfiguration
     */
    overwriteExisting?: boolean;
}

/**
 * 
 * @export
 * @interface GpsPosition
 */
export interface GpsPosition {
    /**
     * 
     * @type {number}
     * @memberof GpsPosition
     */
    accuracyInM?: number;
    /**
     * 
     * @type {number}
     * @memberof GpsPosition
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof GpsPosition
     */
    longitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof GpsPosition
     */
    timestamp?: Date;
}

/**
 * 
 * @export
 * @interface GpxTrackForVehicleRequest
 */
export interface GpxTrackForVehicleRequest {
    /**
     * 
     * @type {Date}
     * @memberof GpxTrackForVehicleRequest
     */
    startTime?: Date;
    /**
     * 
     * @type {Vehicle}
     * @memberof GpxTrackForVehicleRequest
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface GraylogRequest
 */
export interface GraylogRequest {
    /**
     * 
     * @type {string}
     * @memberof GraylogRequest
     */
    query?: string;
    /**
     * 
     * @type {number}
     * @memberof GraylogRequest
     */
    range?: number;
}

/**
 * 
 * @export
 * @interface GroovyBasedMappingScript
 */
export interface GroovyBasedMappingScript {
    /**
     * 
     * @type {string}
     * @memberof GroovyBasedMappingScript
     */
    postExportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GroovyBasedMappingScript
     */
    postImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof GroovyBasedMappingScript
     */
    preExportScript?: string;
}

/**
 * 
 * @export
 * @interface GroovyScript
 */
export interface GroovyScript {
    /**
     * 
     * @type {boolean}
     * @memberof GroovyScript
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroovyScript
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GroovyScript
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof GroovyScript
     */
    scriptIfActive?: string;
}

/**
 * 
 * @export
 * @interface HarHeader
 */
export interface HarHeader {
    /**
     * 
     * @type {string}
     * @memberof HarHeader
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HarHeader
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface HarPostData
 */
export interface HarPostData {
    /**
     * 
     * @type {string}
     * @memberof HarPostData
     */
    mimeType?: string;
    /**
     * 
     * @type {string}
     * @memberof HarPostData
     */
    text?: string;
}

/**
 * 
 * @export
 * @interface HarQueryString
 */
export interface HarQueryString {
    /**
     * 
     * @type {string}
     * @memberof HarQueryString
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HarQueryString
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface HarRequest
 */
export interface HarRequest {
    /**
     * 
     * @type {number}
     * @memberof HarRequest
     */
    bodySize?: number;
    /**
     * 
     * @type {Array<Any>}
     * @memberof HarRequest
     */
    cookies?: Array<Any>;
    /**
     * 
     * @type {Array<HarHeader>}
     * @memberof HarRequest
     */
    headers?: Array<HarHeader>;
    /**
     * 
     * @type {number}
     * @memberof HarRequest
     */
    headersSize?: number;
    /**
     * 
     * @type {string}
     * @memberof HarRequest
     */
    httpVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof HarRequest
     */
    method?: string;
    /**
     * 
     * @type {HarPostData}
     * @memberof HarRequest
     */
    postData?: HarPostData;
    /**
     * 
     * @type {Array<HarQueryString>}
     * @memberof HarRequest
     */
    queryString?: Array<HarQueryString>;
    /**
     * 
     * @type {string}
     * @memberof HarRequest
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface HasTemperatureDataResponse
 */
export interface HasTemperatureDataResponse {
    /**
     * 
     * @type {boolean}
     * @memberof HasTemperatureDataResponse
     */
    hasTemperatureData?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HasTemperatureDataResponse
     */
    transportOrderId?: string;
}

/**
 * Arbitrary key value pairs
 * @export
 * @interface HashMap
 */
export interface HashMap {
}

/**
 * 
 * @export
 * @interface HeaderAreaViewConfiguration
 */
export interface HeaderAreaViewConfiguration {
    /**
     * 
     * @type {string}
     * @memberof HeaderAreaViewConfiguration
     */
    activeItemColor?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderAreaViewConfiguration
     */
    activeItemTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderAreaViewConfiguration
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderAreaViewConfiguration
     */
    browserTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderAreaViewConfiguration
     */
    faviconIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderAreaViewConfiguration
     */
    logo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HeaderAreaViewConfiguration
     */
    showMapLink?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HeaderAreaViewConfiguration
     */
    textColor?: string;
}

/**
 * 
 * @export
 * @interface HeaderValueParam
 */
export interface HeaderValueParam {
    /**
     * 
     * @type {string}
     * @memberof HeaderValueParam
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderValueParam
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface Headers
 */
export interface Headers {
    /**
     * 
     * @type {string}
     * @memberof Headers
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof Headers
     */
    message_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Headers
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof Headers
     */
    to?: string;
}

/**
 * 
 * @export
 * @interface HealthResponseBackend
 */
export interface HealthResponseBackend {
    /**
     * 
     * @type {ThreadPoolHealth}
     * @memberof HealthResponseBackend
     */
    dispatchersIoHealth?: ThreadPoolHealth;
    /**
     * 
     * @type {Array<CacheUpdateTiming>}
     * @memberof HealthResponseBackend
     */
    lastCacheUpdateMessages?: Array<CacheUpdateTiming>;
    /**
     * 
     * @type {Array<MinioHealthState>}
     * @memberof HealthResponseBackend
     */
    minioHealthState?: Array<MinioHealthState>;
    /**
     * 
     * @type {boolean}
     * @memberof HealthResponseBackend
     */
    minioHealthy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HealthResponseBackend
     */
    mongoHealthy?: boolean;
    /**
     * 
     * @type {NomadInfo}
     * @memberof HealthResponseBackend
     */
    nomadInfo?: NomadInfo;
    /**
     * 
     * @type {string}
     * @memberof HealthResponseBackend
     */
    commitTimestamp?: string;
    /**
     * 
     * @type {number}
     * @memberof HealthResponseBackend
     */
    cpus?: number;
    /**
     * 
     * @type {string}
     * @memberof HealthResponseBackend
     */
    javaVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof HealthResponseBackend
     */
    maxMemInMb?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthResponseBackend
     */
    numOpenFiles?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthResponseBackend
     */
    openFileLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof HealthResponseBackend
     */
    pipelineCreationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof HealthResponseBackend
     */
    usedMemInMb?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthResponseBackend
     */
    usedMemInPercent?: number;
    /**
     * 
     * @type {string}
     * @memberof HealthResponseBackend
     */
    version?: string;
}

/**
 * 
 * @export
 * @interface History
 */
export interface History {
    /**
     * 
     * @type {string}
     * @memberof History
     */
    _id?: string;
    /**
     * 
     * @type {Any}
     * @memberof History
     */
    _object?: Any;
    /**
     * 
     * @type {string}
     * @memberof History
     */
    changeComment?: string;
    /**
     * 
     * @type {string}
     * @memberof History
     */
    changeMethod?: History.ChangeMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof History
     */
    changedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof History
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof History
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof History
     */
    type?: History.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof History
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace History
 */
export namespace History {
    /**
     * @export
     * @enum {string}
     */
    export enum ChangeMethodEnum {
        CREATE = 'CREATE',
        MODIFY = 'MODIFY',
        DELETE = 'DELETE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        USER = 'USER',
        USERROLE = 'USERROLE',
        PARTNER = 'PARTNER',
        VEHICLE = 'VEHICLE',
        DRIVER = 'DRIVER',
        COMPANYADDRESSMAPPING = 'COMPANY_ADDRESS_MAPPING',
        COMPANYADDRESSMAPPINGGROUP = 'COMPANY_ADDRESS_MAPPING_GROUP',
        FREIGHTMAPPING = 'FREIGHT_MAPPING',
        FREIGHTMAPPINGGROUP = 'FREIGHT_MAPPING_GROUP',
        TRANSPORTORDERMAPPING = 'TRANSPORT_ORDER_MAPPING',
        TRANSPORTORDERMAPPINGGROUP = 'TRANSPORT_ORDER_MAPPING_GROUP',
        QUEUE = 'QUEUE'
    }
}

/**
 * 
 * @export
 * @interface HttpStatusCode
 */
export interface HttpStatusCode {
    /**
     * 
     * @type {string}
     * @memberof HttpStatusCode
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof HttpStatusCode
     */
    value?: number;
}

/**
 * 
 * @export
 * @interface HttpSyncBasicAuthConfiguration
 */
export interface HttpSyncBasicAuthConfiguration {
    /**
     * 
     * @type {string}
     * @memberof HttpSyncBasicAuthConfiguration
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpSyncBasicAuthConfiguration
     */
    username?: string;
}

/**
 * 
 * @export
 * @interface HttpSyncConfiguration
 */
export interface HttpSyncConfiguration {
    /**
     * 
     * @type {HttpSyncBasicAuthConfiguration}
     * @memberof HttpSyncConfiguration
     */
    authBasic?: HttpSyncBasicAuthConfiguration;
    /**
     * 
     * @type {string}
     * @memberof HttpSyncConfiguration
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpSyncConfiguration
     */
    method?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HttpSyncConfiguration
     */
    processRespondHttpFiles?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HttpSyncConfiguration
     */
    remoteUploadUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpSyncConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface ImageInput
 */
export interface ImageInput {
    /**
     * 
     * @type {string}
     * @memberof ImageInput
     */
    base64Data?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageInput
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageInput
     */
    mediaType?: string;
}

/**
 * 
 * @export
 * @interface ImmediateFormatAiPomt
 */
export interface ImmediateFormatAiPomt {
    /**
     * 
     * @type {Array<ImmediateFormatAiPomtExample>}
     * @memberof ImmediateFormatAiPomt
     */
    examples?: Array<ImmediateFormatAiPomtExample>;
    /**
     * 
     * @type {number}
     * @memberof ImmediateFormatAiPomt
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatAiPomt
     */
    instructionText?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatAiPomt
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface ImmediateFormatAiPomtExample
 */
export interface ImmediateFormatAiPomtExample {
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatAiPomtExample
     */
    input?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatAiPomtExample
     */
    output?: string;
}

/**
 * 
 * @export
 * @interface ImmediateFormatCustomField
 */
export interface ImmediateFormatCustomField {
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatCustomField
     */
    defaultLabelString?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatCustomField
     */
    immediateFormatPathExpression?: string;
}

/**
 * 
 * @export
 * @interface ImmediateFormatEntry
 */
export interface ImmediateFormatEntry {
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatEntry
     */
    data?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatEntry
     */
    key?: string;
}

/**
 * 
 * @export
 * @interface ImmediateFormatPathMatchRule
 */
export interface ImmediateFormatPathMatchRule {
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatPathMatchRule
     */
    operator?: ImmediateFormatPathMatchRule.OperatorEnum;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatPathMatchRule
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatPathMatchRule
     */
    value?: string;
}

/**
 * @export
 * @namespace ImmediateFormatPathMatchRule
 */
export namespace ImmediateFormatPathMatchRule {
    /**
     * @export
     * @enum {string}
     */
    export enum OperatorEnum {
        EQUALS = 'EQUALS',
        CONTAINS = 'CONTAINS',
        REGEXMATCH = 'REGEX_MATCH',
        EXISTS = 'EXISTS'
    }
}

/**
 * 
 * @export
 * @interface ImmediateFormatResponse
 */
export interface ImmediateFormatResponse {
    /**
     * 
     * @type {Array<ImmediateFormatEntry>}
     * @memberof ImmediateFormatResponse
     */
    entries?: Array<ImmediateFormatEntry>;
    /**
     * 
     * @type {string}
     * @memberof ImmediateFormatResponse
     */
    orderId?: string;
}

/**
 * 
 * @export
 * @interface ImportOptions
 */
export interface ImportOptions {
    /**
     * 
     * @type {boolean}
     * @memberof ImportOptions
     */
    etaImportEnabled?: boolean;
}

/**
 * 
 * @export
 * @interface IncompleteAddressHandling
 */
export interface IncompleteAddressHandling {
    /**
     * 
     * @type {Array<string>}
     * @memberof IncompleteAddressHandling
     */
    fieldsRequiredForCompleteAddress?: Array<IncompleteAddressHandling.FieldsRequiredForCompleteAddressEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof IncompleteAddressHandling
     */
    shouldHaltIfLoadingAddressIsIncomplete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IncompleteAddressHandling
     */
    shouldHaltIfUnloadingAddressIsIncomplete?: boolean;
}

/**
 * @export
 * @namespace IncompleteAddressHandling
 */
export namespace IncompleteAddressHandling {
    /**
     * @export
     * @enum {string}
     */
    export enum FieldsRequiredForCompleteAddressEnum {
        NAME = 'NAME',
        CITY = 'CITY',
        ZIPCODE = 'ZIP_CODE',
        STREET = 'STREET',
        COUNTRYCODE = 'COUNTRY_CODE'
    }
}

/**
 * 
 * @export
 * @interface IndividualReportSetting
 */
export interface IndividualReportSetting {
    /**
     * 
     * @type {Date}
     * @memberof IndividualReportSetting
     */
    acknowledgedFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IndividualReportSetting
     */
    acknowledgedUntil?: Date;
    /**
     * 
     * @type {Any}
     * @memberof IndividualReportSetting
     */
    acknowledgedUntilChangeValue?: Any;
    /**
     * 
     * @type {string}
     * @memberof IndividualReportSetting
     */
    acknowledgingPm?: string;
    /**
     * 
     * @type {Date}
     * @memberof IndividualReportSetting
     */
    acknowledgingTimeStamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof IndividualReportSetting
     */
    acknowledgmentReason?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualReportSetting
     */
    acknowledgmentType?: IndividualReportSetting.AcknowledgmentTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IndividualReportSetting
     */
    disableTimeStamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof IndividualReportSetting
     */
    disableType?: IndividualReportSetting.DisableTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IndividualReportSetting
     */
    disabledUntil?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IndividualReportSetting
     */
    fromDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IndividualReportSetting
     */
    isAcknowledgedByPm?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IndividualReportSetting
     */
    personWhoIgnored?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualReportSetting
     */
    reasonToIgnore?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IndividualReportSetting
     */
    shouldBeIgnored?: boolean;
    /**
     * 
     * @type {Any}
     * @memberof IndividualReportSetting
     */
    untilChangeValue?: Any;
}

/**
 * @export
 * @namespace IndividualReportSetting
 */
export namespace IndividualReportSetting {
    /**
     * @export
     * @enum {string}
     */
    export enum AcknowledgmentTypeEnum {
        UNTILCHANGE = 'UNTIL_CHANGE',
        UNTILTOMORROW = 'UNTIL_TOMORROW',
        FORAMONTH = 'FOR_A_MONTH',
        FORAWEEK = 'FOR_A_WEEK',
        CUSTOMDATE = 'CUSTOM_DATE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DisableTypeEnum {
        UNTILCHANGE = 'UNTIL_CHANGE',
        UNTILTOMORROW = 'UNTIL_TOMORROW',
        FORAMONTH = 'FOR_A_MONTH',
        FORAWEEK = 'FOR_A_WEEK',
        CUSTOMDATE = 'CUSTOM_DATE'
    }
}

/**
 * 
 * @export
 * @interface InfSymOnExport
 */
export interface InfSymOnExport {
    /**
     * 
     * @type {string}
     * @memberof InfSymOnExport
     */
    exportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof InfSymOnExport
     */
    symbolWert?: string;
}

/**
 * 
 * @export
 * @interface InfSymOnImport
 */
export interface InfSymOnImport {
    /**
     * 
     * @type {string}
     * @memberof InfSymOnImport
     */
    importScript?: string;
    /**
     * 
     * @type {string}
     * @memberof InfSymOnImport
     */
    putAdditionalDataWithKey?: string;
}

/**
 * 
 * @export
 * @interface InfSymRecordConfiguration
 */
export interface InfSymRecordConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof InfSymRecordConfiguration
     */
    _export?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InfSymRecordConfiguration
     */
    _import?: boolean;
    /**
     * 
     * @type {InfSymOnExport}
     * @memberof InfSymRecordConfiguration
     */
    onExport?: InfSymOnExport;
    /**
     * 
     * @type {InfSymOnImport}
     * @memberof InfSymRecordConfiguration
     */
    onImport?: InfSymOnImport;
    /**
     * 
     * @type {number}
     * @memberof InfSymRecordConfiguration
     */
    symbolNo?: number;
    /**
     * 
     * @type {string}
     * @memberof InfSymRecordConfiguration
     */
    symbolType?: InfSymRecordConfiguration.SymbolTypeEnum;
}

/**
 * @export
 * @namespace InfSymRecordConfiguration
 */
export namespace InfSymRecordConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum SymbolTypeEnum {
        AUFTRAG = 'AUFTRAG',
        TOUR = 'TOUR'
    }
}

/**
 * 
 * @export
 * @interface InfrastructureQueueMonitoringConfiguration
 */
export interface InfrastructureQueueMonitoringConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof InfrastructureQueueMonitoringConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfrastructureQueueMonitoringConfiguration
     */
    ignoredQueueTypes?: Array<InfrastructureQueueMonitoringConfiguration.IgnoredQueueTypesEnum>;
}

/**
 * @export
 * @namespace InfrastructureQueueMonitoringConfiguration
 */
export namespace InfrastructureQueueMonitoringConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum IgnoredQueueTypesEnum {
        FTPSYNC = 'FTP_SYNC',
        APIGATEWAYSYNC = 'API_GATEWAY_SYNC',
        APISYNC = 'API_SYNC',
        NOTIFICATIONS = 'NOTIFICATIONS',
        ETACALCULATOR = 'ETA_CALCULATOR',
        SCRIPTRUNNER = 'SCRIPT_RUNNER'
    }
}

/**
 * 
 * @export
 * @interface InvitationListResponse
 */
export interface InvitationListResponse {
    /**
     * 
     * @type {number}
     * @memberof InvitationListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<PartnerInvitation>}
     * @memberof InvitationListResponse
     */
    invitations?: Array<PartnerInvitation>;
}

/**
 * 
 * @export
 * @interface InvitationRespone
 */
export interface InvitationRespone {
    /**
     * 
     * @type {PartnerInvitation}
     * @memberof InvitationRespone
     */
    invitation?: PartnerInvitation;
    /**
     * 
     * @type {Company}
     * @memberof InvitationRespone
     */
    invitingCompany?: Company;
    /**
     * 
     * @type {User}
     * @memberof InvitationRespone
     */
    invitingUser?: User;
}

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    _id?: string;
    /**
     * 
     * @type {Company}
     * @memberof Invoice
     */
    company?: Company;
    /**
     * 
     * @type {Contract}
     * @memberof Invoice
     */
    contract?: Contract;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    lastModifiedAt?: Date;
    /**
     * 
     * @type {Array<InvoiceDataLine>}
     * @memberof Invoice
     */
    lines?: Array<InvoiceDataLine>;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    to?: Date;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    totalExcelPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    totalZohoPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    transportOrderDiscount?: number;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    uploadedToZoho?: Date;
    /**
     * 
     * @type {Array<ProjectWorkLogBookEntry>}
     * @memberof Invoice
     */
    workLogEntries?: Array<ProjectWorkLogBookEntry>;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    zohoReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    zohoResultBody?: string;
}

/**
 * 
 * @export
 * @interface InvoiceAssignmentFilter
 */
export interface InvoiceAssignmentFilter {
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceAssignmentFilter
     */
    hasAssigedTrailer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceAssignmentFilter
     */
    hasAssignedDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceAssignmentFilter
     */
    hasAssignedDeviceWithMail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceAssignmentFilter
     */
    hasAssignedVehicle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceAssignmentFilter
     */
    hasTargetCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceAssignmentFilter
     */
    isBounceOrder?: boolean;
}

/**
 * 
 * @export
 * @interface InvoiceDataLine
 */
export interface InvoiceDataLine {
    /**
     * 
     * @type {string}
     * @memberof InvoiceDataLine
     */
    _id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceDataLine
     */
    billedTransportOrders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDataLine
     */
    groupingTag?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDataLine
     */
    invoiceId?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDataLine
     */
    numTransportOrders?: number;
    /**
     * 
     * @type {Array<Company>}
     * @memberof InvoiceDataLine
     */
    observer?: Array<Company>;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDataLine
     */
    pricePerTransportOrder?: number;
    /**
     * 
     * @type {Company}
     * @memberof InvoiceDataLine
     */
    sourceCompany?: Company;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDataLine
     */
    sourceTms?: InvoiceDataLine.SourceTmsEnum;
    /**
     * 
     * @type {Company}
     * @memberof InvoiceDataLine
     */
    targetCompany?: Company;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDataLine
     */
    targetTms?: InvoiceDataLine.TargetTmsEnum;
    /**
     * 
     * @type {Array<TransportOrderBilledItem>}
     * @memberof InvoiceDataLine
     */
    usedFeatures?: Array<TransportOrderBilledItem>;
    /**
     * 
     * @type {Array<VehiclePolylineBilledItem>}
     * @memberof InvoiceDataLine
     */
    usedVehicleFeatures?: Array<VehiclePolylineBilledItem>;
}

/**
 * @export
 * @namespace InvoiceDataLine
 */
export namespace InvoiceDataLine {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceTmsEnum {
        LIS = 'LIS',
        BNS = 'BNS',
        CLOGISTIK = 'CLOGISTIK',
        LOGENIOS = 'LOGENIOS',
        DRMALEK = 'DRMALEK',
        GEHR = 'GEHR',
        COMTRIX = 'COMTRIX',
        COMLOGIS = 'COMLOGIS',
        A4L = 'A4L',
        ECOVIUM = 'ECOVIUM'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TargetTmsEnum {
        LIS = 'LIS',
        BNS = 'BNS',
        CLOGISTIK = 'CLOGISTIK',
        LOGENIOS = 'LOGENIOS',
        DRMALEK = 'DRMALEK',
        GEHR = 'GEHR',
        COMTRIX = 'COMTRIX',
        COMLOGIS = 'COMLOGIS',
        A4L = 'A4L',
        ECOVIUM = 'ECOVIUM'
    }
}

/**
 * 
 * @export
 * @interface InvoiceFilterOptions
 */
export interface InvoiceFilterOptions {
    /**
     * 
     * @type {InvoiceAssignmentFilter}
     * @memberof InvoiceFilterOptions
     */
    excludeIfAny?: InvoiceAssignmentFilter;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceFilterOptions
     */
    excludeTransportOrdersInStatus?: Array<InvoiceFilterOptions.ExcludeTransportOrdersInStatusEnum>;
    /**
     * 
     * @type {GroovyScript}
     * @memberof InvoiceFilterOptions
     */
    filterScript?: GroovyScript;
    /**
     * 
     * @type {InvoiceAssignmentFilter}
     * @memberof InvoiceFilterOptions
     */
    includeIfAny?: InvoiceAssignmentFilter;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceFilterOptions
     */
    includeTransportOrdersInStatus?: Array<InvoiceFilterOptions.IncludeTransportOrdersInStatusEnum>;
}

/**
 * @export
 * @namespace InvoiceFilterOptions
 */
export namespace InvoiceFilterOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum ExcludeTransportOrdersInStatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IncludeTransportOrdersInStatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
}

/**
 * 
 * @export
 * @interface InvoiceResponse
 */
export interface InvoiceResponse {
    /**
     * 
     * @type {Array<SingleInvoiceResponse>}
     * @memberof InvoiceResponse
     */
    invoiceResponses?: Array<SingleInvoiceResponse>;
}

/**
 * 
 * @export
 * @interface InvoicingReportResponse
 */
export interface InvoicingReportResponse {
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof InvoicingReportResponse
     */
    invoices?: Array<Invoice>;
}

/**
 * 
 * @export
 * @interface IsSuperuserResponse
 */
export interface IsSuperuserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IsSuperuserResponse
     */
    isSuperuser?: boolean;
}

/**
 * 
 * @export
 * @interface JsonNode
 */
export interface JsonNode {
}

/**
 * 
 * @export
 * @interface KundenNrMonitoring
 */
export interface KundenNrMonitoring {
    /**
     * 
     * @type {boolean}
     * @memberof KundenNrMonitoring
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof KundenNrMonitoring
     */
    daysToCheck?: number;
    /**
     * 
     * @type {Date}
     * @memberof KundenNrMonitoring
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof KundenNrMonitoring
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof KundenNrMonitoring
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof KundenNrMonitoring
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof KundenNrMonitoring
     */
    level?: KundenNrMonitoring.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof KundenNrMonitoring
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof KundenNrMonitoring
     */
    showToAllParties?: boolean;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof KundenNrMonitoring
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof KundenNrMonitoring
     */
    title?: string;
}

/**
 * @export
 * @namespace KundenNrMonitoring
 */
export namespace KundenNrMonitoring {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface LademiMapping
 */
export interface LademiMapping {
    /**
     * 
     * @type {string}
     * @memberof LademiMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof LademiMapping
     */
    containmentQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof LademiMapping
     */
    containmentType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LademiMapping
     */
    _export?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LademiMapping
     */
    _import?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LademiMapping
     */
    lmArt?: string;
    /**
     * 
     * @type {string}
     * @memberof LademiMapping
     */
    totalQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof LademiMapping
     */
    totalWeight?: string;
}

/**
 * 
 * @export
 * @interface LanguageConfiguration
 */
export interface LanguageConfiguration {
    /**
     * 
     * @type {string}
     * @memberof LanguageConfiguration
     */
    companyLanguage?: LanguageConfiguration.CompanyLanguageEnum;
    /**
     * 
     * @type {any}
     * @memberof LanguageConfiguration
     */
    globalOverride?: any;
    /**
     * 
     * @type {Array<LanguageOverride>}
     * @memberof LanguageConfiguration
     */
    languageOverrides?: Array<LanguageOverride>;
    /**
     * 
     * @type {Array<TranslationEntry>}
     * @memberof LanguageConfiguration
     */
    translations?: Array<TranslationEntry>;
}

/**
 * @export
 * @namespace LanguageConfiguration
 */
export namespace LanguageConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum CompanyLanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
}

/**
 * 
 * @export
 * @interface LanguageOverride
 */
export interface LanguageOverride {
    /**
     * 
     * @type {string}
     * @memberof LanguageOverride
     */
    language?: LanguageOverride.LanguageEnum;
    /**
     * 
     * @type {any}
     * @memberof LanguageOverride
     */
    overrides?: any;
}

/**
 * @export
 * @namespace LanguageOverride
 */
export namespace LanguageOverride {
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
}

/**
 * 
 * @export
 * @interface LastPosition
 */
export interface LastPosition {
    /**
     * 
     * @type {number}
     * @memberof LastPosition
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof LastPosition
     */
    longitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof LastPosition
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof LastPosition
     */
    vehicleId?: string;
}

/**
 * 
 * @export
 * @interface LastValidOdometerData
 */
export interface LastValidOdometerData {
    /**
     * 
     * @type {number}
     * @memberof LastValidOdometerData
     */
    odometer?: number;
    /**
     * 
     * @type {Date}
     * @memberof LastValidOdometerData
     */
    timestamp?: Date;
}

/**
 * 
 * @export
 * @interface LastVehiclePositions
 */
export interface LastVehiclePositions {
    /**
     * 
     * @type {Position}
     * @memberof LastVehiclePositions
     */
    lastPosition?: Position;
    /**
     * 
     * @type {Array<string>}
     * @memberof LastVehiclePositions
     */
    lastTransportOrdersValidPositionWasSent?: Array<string>;
    /**
     * 
     * @type {LastValidOdometerData}
     * @memberof LastVehiclePositions
     */
    lastValidOdometer?: LastValidOdometerData;
    /**
     * 
     * @type {Position}
     * @memberof LastVehiclePositions
     */
    lastValidPosition?: Position;
    /**
     * 
     * @type {Date}
     * @memberof LastVehiclePositions
     */
    modifiedTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof LastVehiclePositions
     */
    vehicleState?: LastVehiclePositions.VehicleStateEnum;
}

/**
 * @export
 * @namespace LastVehiclePositions
 */
export namespace LastVehiclePositions {
    /**
     * @export
     * @enum {string}
     */
    export enum VehicleStateEnum {
        DRIVING = 'DRIVING',
        STANDING = 'STANDING',
        ARRIVED = 'ARRIVED'
    }
}

/**
 * 
 * @export
 * @interface LimitedAccessUserInfo
 */
export interface LimitedAccessUserInfo {
    /**
     * 
     * @type {string}
     * @memberof LimitedAccessUserInfo
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * company id of the linked transport order
     * @type {string}
     * @memberof Link
     */
    companyId?: string;
    /**
     * company name of the links transport order
     * @type {string}
     * @memberof Link
     */
    companyName?: string;
    /**
     * id of the transport in the linked transport order
     * @type {string}
     * @memberof Link
     */
    transportId?: string;
    /**
     * id of the transport order which was linked to this order
     * @type {string}
     * @memberof Link
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface LinkInfo
 */
export interface LinkInfo {
    /**
     * This field contains a list of transport order identification numbers. On creation of a transport order the Logenios backend searches for other transport orders which contains at lease one externalLinkKey and links this transport order to the matched order
     * @type {Array<string>}
     * @memberof LinkInfo
     */
    externalLinkKeys?: Array<string>;
    /**
     * company id of the contractor
     * @type {string}
     * @memberof LinkInfo
     */
    sourceCompanyId?: string;
    /**
     * company name of the contractor
     * @type {string}
     * @memberof LinkInfo
     */
    sourceCompanyName?: string;
    /**
     * Information on related source orders
     * @type {Array<Link>}
     * @memberof LinkInfo
     */
    sourceLinks?: Array<Link>;
    /**
     * id of the original transport order which is assigned to the contractor
     * @type {string}
     * @memberof LinkInfo
     */
    sourceTransportOrderId?: string;
    /**
     * id of the transport in the original transport order which is assigned to the contractor
     * @type {string}
     * @memberof LinkInfo
     */
    sourceTransportOrderTransportId?: string;
    /**
     * company id of the sub-contractor
     * @type {string}
     * @memberof LinkInfo
     */
    targetCompanyId?: string;
    /**
     * company name of the sub-contractor
     * @type {string}
     * @memberof LinkInfo
     */
    targetCompanyName?: string;
    /**
     * external parter id of the sub-contractor
     * @type {string}
     * @memberof LinkInfo
     */
    targetExternalPartnerId?: string;
    /**
     * Information on related target orders
     * @type {Array<Link>}
     * @memberof LinkInfo
     */
    targetLinks?: Array<Link>;
    /**
     * id of the transport order which was created as a executionResult of the subcontracting process and assigned to a sub-contractor
     * @type {string}
     * @memberof LinkInfo
     */
    targetTransportOrderId?: string;
}

/**
 * 
 * @export
 * @interface LinkKeyExtractionRule
 */
export interface LinkKeyExtractionRule {
    /**
     * The link key is only extracted when those rules find a match in the given immediate format. If this list is <null> the link key is always extracted
     * @type {Array<ImmediateFormatPathMatchRule>}
     * @memberof LinkKeyExtractionRule
     */
    applyWhenAllRulesMatch?: Array<ImmediateFormatPathMatchRule>;
    /**
     * Regex that shall be used to extract the external Link key
     * @type {string}
     * @memberof LinkKeyExtractionRule
     */
    extractionRegex?: string;
    /**
     * Path denoted in immediate format
     * @type {string}
     * @memberof LinkKeyExtractionRule
     */
    path?: string;
}

/**
 * 
 * @export
 * @interface LinkTableEntry
 */
export interface LinkTableEntry {
    /**
     * 
     * @type {string}
     * @memberof LinkTableEntry
     */
    direction?: LinkTableEntry.DirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof LinkTableEntry
     */
    externalSourceTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkTableEntry
     */
    externalTargetTransportOrderId?: string;
    /**
     * 
     * @type {Array<Link>}
     * @memberof LinkTableEntry
     */
    link?: Array<Link>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkTableEntry
     */
    linkKeys?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LinkTableEntry
     */
    sourceOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkTableEntry
     */
    sourceTransportId?: string;
    /**
     * 
     * @type {Array<StopLocation>}
     * @memberof LinkTableEntry
     */
    stops?: Array<StopLocation>;
    /**
     * 
     * @type {string}
     * @memberof LinkTableEntry
     */
    targetOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkTableEntry
     */
    targetTransportId?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof LinkTableEntry
     */
    vehicle?: Vehicle;
}

/**
 * @export
 * @namespace LinkTableEntry
 */
export namespace LinkTableEntry {
    /**
     * @export
     * @enum {string}
     */
    export enum DirectionEnum {
        SOURCETOTARGET = 'SOURCE_TO_TARGET',
        TARGETTOSOURCE = 'TARGET_TO_SOURCE'
    }
}

/**
 * 
 * @export
 * @interface LinkTransportOrderRequest
 */
export interface LinkTransportOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof LinkTransportOrderRequest
     */
    targetCompanyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkTransportOrderRequest
     */
    transportIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LinkTransportOrderRequest
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface LinkedCompany
 */
export interface LinkedCompany {
    /**
     * 
     * @type {boolean}
     * @memberof LinkedCompany
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkedCompany
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedCompany
     */
    description?: string;
}

/**
 * 
 * @export
 * @interface LinkedVehicleInfo
 */
export interface LinkedVehicleInfo {
    /**
     * 
     * @type {string}
     * @memberof LinkedVehicleInfo
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Array<Vehicle>}
     * @memberof LinkedVehicleInfo
     */
    vehicles?: Array<Vehicle>;
}

/**
 * 
 * @export
 * @interface LinkingPartnersResponse
 */
export interface LinkingPartnersResponse {
    /**
     * 
     * @type {Array<CompanyNameAndId>}
     * @memberof LinkingPartnersResponse
     */
    linkingPartners?: Array<CompanyNameAndId>;
}

/**
 * 
 * @export
 * @interface LisCompanySpecificConfiguration
 */
export interface LisCompanySpecificConfiguration {
    /**
     * 
     * @type {LisCompanySpecificConfigurationApplyRules}
     * @memberof LisCompanySpecificConfiguration
     */
    applyWhenAll?: LisCompanySpecificConfigurationApplyRules;
    /**
     * 
     * @type {LisConverterConfigurationOverride}
     * @memberof LisCompanySpecificConfiguration
     */
    override?: LisConverterConfigurationOverride;
    /**
     * 
     * @type {string}
     * @memberof LisCompanySpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface LisCompanySpecificConfigurationApplyRules
 */
export interface LisCompanySpecificConfigurationApplyRules {
    /**
     * 
     * @type {boolean}
     * @memberof LisCompanySpecificConfigurationApplyRules
     */
    onConversionToExternalFormat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LisCompanySpecificConfigurationApplyRules
     */
    onConversionToTransportOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LisCompanySpecificConfigurationApplyRules
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof LisCompanySpecificConfigurationApplyRules
     */
    sourceCompanyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LisCompanySpecificConfigurationApplyRules
     */
    sourceCompanyTag?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LisCompanySpecificConfigurationApplyRules
     */
    specificConfigAdditionalIs?: string;
}

/**
 * 
 * @export
 * @interface LisConverterConfiguration
 */
export interface LisConverterConfiguration {
    /**
     * 
     * @type {AddressExportOptions}
     * @memberof LisConverterConfiguration
     */
    addressExportOptions?: AddressExportOptions;
    /**
     * 
     * @type {Array<AddressKindMapping>}
     * @memberof LisConverterConfiguration
     */
    addressKindMapping?: Array<AddressKindMapping>;
    /**
     * 
     * @type {Array<ContainmentTypeMapping>}
     * @memberof LisConverterConfiguration
     */
    containmentTypeMapping?: Array<ContainmentTypeMapping>;
    /**
     * 
     * @type {ContractingPartyMapping}
     * @memberof LisConverterConfiguration
     */
    contractingPartyMapping?: ContractingPartyMapping;
    /**
     * 
     * @type {Array<ContractingPartyToAddressKindMapping>}
     * @memberof LisConverterConfiguration
     */
    contractingPartyToAddressKindMapping?: Array<ContractingPartyToAddressKindMapping>;
    /**
     * 
     * @type {DangerousGoodsMapping}
     * @memberof LisConverterConfiguration
     */
    dangerousGoodsMapping?: DangerousGoodsMapping;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfiguration
     */
    defaultLisTxtArtNr?: string;
    /**
     * 
     * @type {LisDmsConfig}
     * @memberof LisConverterConfiguration
     */
    dms?: LisDmsConfig;
    /**
     * 
     * @type {LisDmsImportMapping}
     * @memberof LisConverterConfiguration
     */
    dmsImport?: LisDmsImportMapping;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfiguration
     */
    fileEncoding?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfiguration
     */
    forceDisableExport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfiguration
     */
    forceLinkAllTransports?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfiguration
     */
    forceSplitInputFilesOnLadeLi?: boolean;
    /**
     * 
     * @type {FreightMapping}
     * @memberof LisConverterConfiguration
     */
    freightMapping?: FreightMapping;
    /**
     * 
     * @type {FreightMergingOptions}
     * @memberof LisConverterConfiguration
     */
    freightMerging?: FreightMergingOptions;
    /**
     * 
     * @type {Array<FreightStatusMapping>}
     * @memberof LisConverterConfiguration
     */
    freightStatusMapping?: Array<FreightStatusMapping>;
    /**
     * 
     * @type {Array<LisInitRecordConfiguration>}
     * @memberof LisConverterConfiguration
     */
    initRecords?: Array<LisInitRecordConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfiguration
     */
    logeniosLisName?: string;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfiguration
     */
    modifyMode?: LisConverterConfiguration.ModifyModeEnum;
    /**
     * 
     * @type {PacketItemMapping}
     * @memberof LisConverterConfiguration
     */
    packetItemMapping?: PacketItemMapping;
    /**
     * 
     * @type {PacketMapping}
     * @memberof LisConverterConfiguration
     */
    packetMapping?: PacketMapping;
    /**
     * 
     * @type {Array<LisPureStatusImporter>}
     * @memberof LisConverterConfiguration
     */
    pureStatusImporter?: Array<LisPureStatusImporter>;
    /**
     * 
     * @type {LisScriptBasedExportConfig}
     * @memberof LisConverterConfiguration
     */
    scriptBasedExport?: LisScriptBasedExportConfig;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfiguration
     */
    shouldAddEmptyPositRecordIfPositRecordIsMissing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfiguration
     */
    shouldExportOnlyCustomerAdressNumbers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfiguration
     */
    shouldLimitTextLengthTo255Chars?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfiguration
     */
    sortLisRecordsBeforeImport?: boolean;
    /**
     * 
     * @type {Array<LisCompanySpecificConfiguration>}
     * @memberof LisConverterConfiguration
     */
    specificConfiguration?: Array<LisCompanySpecificConfiguration>;
    /**
     * 
     * @type {LisSpecificConfigurationOptions}
     * @memberof LisConverterConfiguration
     */
    specificConfigurationOptions?: LisSpecificConfigurationOptions;
    /**
     * 
     * @type {StatusMapping}
     * @memberof LisConverterConfiguration
     */
    statusMapping?: StatusMapping;
    /**
     * 
     * @type {StopActionMapping}
     * @memberof LisConverterConfiguration
     */
    stopActionMapping?: StopActionMapping;
    /**
     * 
     * @type {Array<StopActionStatusMapping>}
     * @memberof LisConverterConfiguration
     */
    stopActionStatusMapping?: Array<StopActionStatusMapping>;
    /**
     * 
     * @type {StopLocationMapping}
     * @memberof LisConverterConfiguration
     */
    stopLocationMapping?: StopLocationMapping;
    /**
     * 
     * @type {Array<StopStatusMapping>}
     * @memberof LisConverterConfiguration
     */
    stopStatusMapping?: Array<StopStatusMapping>;
    /**
     * 
     * @type {SubCompanyMapping}
     * @memberof LisConverterConfiguration
     */
    subCompanyMapping?: SubCompanyMapping;
    /**
     * 
     * @type {TargetCompanyMapping}
     * @memberof LisConverterConfiguration
     */
    targetCompanyMapping?: TargetCompanyMapping;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfiguration
     */
    targetSystemLisName?: string;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfiguration
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfiguration
     */
    tourHandlingOptions?: LisConverterConfiguration.TourHandlingOptionsEnum;
    /**
     * 
     * @type {TransportMapping}
     * @memberof LisConverterConfiguration
     */
    transportMapping?: TransportMapping;
    /**
     * 
     * @type {TransportMergingOptions}
     * @memberof LisConverterConfiguration
     */
    transportMergingOptions?: TransportMergingOptions;
    /**
     * 
     * @type {TransportOrderMapping}
     * @memberof LisConverterConfiguration
     */
    transportOrderMapping?: TransportOrderMapping;
    /**
     * 
     * @type {Array<TransportOrderStatusMapping>}
     * @memberof LisConverterConfiguration
     */
    transportOrderStatusMapping?: Array<TransportOrderStatusMapping>;
}

/**
 * @export
 * @namespace LisConverterConfiguration
 */
export namespace LisConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TourHandlingOptionsEnum {
        LADELITOTRANSPORTORDER = 'MAP_LADELI_TO_TRANSPORT_ORDER',
        AUFTRTOTRANSPORTORDER = 'MAP_AUFTR_TO_TRANSPORT_ORDER'
    }
}

/**
 * 
 * @export
 * @interface LisConverterConfigurationOverride
 */
export interface LisConverterConfigurationOverride {
    /**
     * 
     * @type {Array<AddressKindMapping>}
     * @memberof LisConverterConfigurationOverride
     */
    addressKindMapping?: Array<AddressKindMapping>;
    /**
     * 
     * @type {ContractingPartyMapping}
     * @memberof LisConverterConfigurationOverride
     */
    contractingPartyMapping?: ContractingPartyMapping;
    /**
     * 
     * @type {Array<ContractingPartyToAddressKindMapping>}
     * @memberof LisConverterConfigurationOverride
     */
    contractingPartyToAddressKindMapping?: Array<ContractingPartyToAddressKindMapping>;
    /**
     * 
     * @type {DangerousGoodsMapping}
     * @memberof LisConverterConfigurationOverride
     */
    dangerousGoodsMapping?: DangerousGoodsMapping;
    /**
     * 
     * @type {LisDmsConfig}
     * @memberof LisConverterConfigurationOverride
     */
    dms?: LisDmsConfig;
    /**
     * 
     * @type {LisDmsImportMapping}
     * @memberof LisConverterConfigurationOverride
     */
    dmsImport?: LisDmsImportMapping;
    /**
     * 
     * @type {boolean}
     * @memberof LisConverterConfigurationOverride
     */
    forceDisableExport?: boolean;
    /**
     * 
     * @type {FreightMapping}
     * @memberof LisConverterConfigurationOverride
     */
    freightMapping?: FreightMapping;
    /**
     * 
     * @type {FreightMergingOptions}
     * @memberof LisConverterConfigurationOverride
     */
    freightMerging?: FreightMergingOptions;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfigurationOverride
     */
    modifyMode?: LisConverterConfigurationOverride.ModifyModeEnum;
    /**
     * 
     * @type {PacketItemMapping}
     * @memberof LisConverterConfigurationOverride
     */
    packetItemMapping?: PacketItemMapping;
    /**
     * 
     * @type {PacketMapping}
     * @memberof LisConverterConfigurationOverride
     */
    packetMapping?: PacketMapping;
    /**
     * 
     * @type {Array<LisPureStatusImporter>}
     * @memberof LisConverterConfigurationOverride
     */
    pureStatusImporter?: Array<LisPureStatusImporter>;
    /**
     * 
     * @type {LisScriptBasedExportConfig}
     * @memberof LisConverterConfigurationOverride
     */
    scriptBasedExport?: LisScriptBasedExportConfig;
    /**
     * 
     * @type {StatusMapping}
     * @memberof LisConverterConfigurationOverride
     */
    statusMapping?: StatusMapping;
    /**
     * 
     * @type {StopActionMapping}
     * @memberof LisConverterConfigurationOverride
     */
    stopActionMapping?: StopActionMapping;
    /**
     * 
     * @type {StopLocationMapping}
     * @memberof LisConverterConfigurationOverride
     */
    stopLocationMapping?: StopLocationMapping;
    /**
     * 
     * @type {SubCompanyMapping}
     * @memberof LisConverterConfigurationOverride
     */
    subCompanyMapping?: SubCompanyMapping;
    /**
     * 
     * @type {TargetCompanyMapping}
     * @memberof LisConverterConfigurationOverride
     */
    targetCompanyMapping?: TargetCompanyMapping;
    /**
     * 
     * @type {string}
     * @memberof LisConverterConfigurationOverride
     */
    tourHandlingOptions?: LisConverterConfigurationOverride.TourHandlingOptionsEnum;
    /**
     * 
     * @type {TransportMapping}
     * @memberof LisConverterConfigurationOverride
     */
    transportMapping?: TransportMapping;
    /**
     * 
     * @type {TransportMergingOptions}
     * @memberof LisConverterConfigurationOverride
     */
    transportMergingOptions?: TransportMergingOptions;
    /**
     * 
     * @type {TransportOrderMapping}
     * @memberof LisConverterConfigurationOverride
     */
    transportOrderMapping?: TransportOrderMapping;
    /**
     * 
     * @type {Array<TransportOrderStatusMapping>}
     * @memberof LisConverterConfigurationOverride
     */
    transportOrderStatusMapping?: Array<TransportOrderStatusMapping>;
}

/**
 * @export
 * @namespace LisConverterConfigurationOverride
 */
export namespace LisConverterConfigurationOverride {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TourHandlingOptionsEnum {
        LADELITOTRANSPORTORDER = 'MAP_LADELI_TO_TRANSPORT_ORDER',
        AUFTRTOTRANSPORTORDER = 'MAP_AUFTR_TO_TRANSPORT_ORDER'
    }
}

/**
 * 
 * @export
 * @interface LisDmsConfig
 */
export interface LisDmsConfig {
    /**
     * 
     * @type {boolean}
     * @memberof LisDmsConfig
     */
    makeUniqueDmsFileName?: boolean;
}

/**
 * 
 * @export
 * @interface LisDmsImportMapping
 */
export interface LisDmsImportMapping {
    /**
     * 
     * @type {string}
     * @memberof LisDmsImportMapping
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof LisDmsImportMapping
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof LisDmsImportMapping
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface LisInitRecordConfiguration
 */
export interface LisInitRecordConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof LisInitRecordConfiguration
     */
    fieldsToInclude?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LisInitRecordConfiguration
     */
    fieldsToSuppress?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LisInitRecordConfiguration
     */
    satzart?: string;
}

/**
 * 
 * @export
 * @interface LisLinkKeyMapping
 */
export interface LisLinkKeyMapping {
    /**
     * 
     * @type {string}
     * @memberof LisLinkKeyMapping
     */
    field?: string;
}

/**
 * 
 * @export
 * @interface LisPureFreightStatusImportConfig
 */
export interface LisPureFreightStatusImportConfig {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureFreightStatusImportConfig
     */
    additionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof LisPureFreightStatusImportConfig
     */
    freightId?: string;
    /**
     * 
     * @type {string}
     * @memberof LisPureFreightStatusImportConfig
     */
    shipmentId?: string;
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureFreightStatusImportConfig
     */
    statusAdditionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof LisPureFreightStatusImportConfig
     */
    statusCode?: LisPureFreightStatusImportConfig.StatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LisPureFreightStatusImportConfig
     */
    statusTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof LisPureFreightStatusImportConfig
     */
    transportId?: string;
}

/**
 * @export
 * @namespace LisPureFreightStatusImportConfig
 */
export namespace LisPureFreightStatusImportConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface LisPureStatusImporter
 */
export interface LisPureStatusImporter {
    /**
     * 
     * @type {string}
     * @memberof LisPureStatusImporter
     */
    lisStatusCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LisPureStatusImporter
     */
    postImportScript?: string;
    /**
     * 
     * @type {LisPureTransportOrderStatusImportConfig}
     * @memberof LisPureStatusImporter
     */
    transportOrder?: LisPureTransportOrderStatusImportConfig;
}

/**
 * 
 * @export
 * @interface LisPureStopStatusImportConfig
 */
export interface LisPureStopStatusImportConfig {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureStopStatusImportConfig
     */
    additionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureStopStatusImportConfig
     */
    statusAdditionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof LisPureStopStatusImportConfig
     */
    statusCode?: LisPureStopStatusImportConfig.StatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LisPureStopStatusImportConfig
     */
    statusTimestamp?: string;
}

/**
 * @export
 * @namespace LisPureStopStatusImportConfig
 */
export namespace LisPureStopStatusImportConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface LisPureTransportOrderStatusImportConfig
 */
export interface LisPureTransportOrderStatusImportConfig {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    additionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {LisPureFreightStatusImportConfig}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    freight?: LisPureFreightStatusImportConfig;
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    statusAdditionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    statusCode?: LisPureTransportOrderStatusImportConfig.StatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    statusTimestamp?: string;
    /**
     * 
     * @type {LisPureTransportStatusImportConfig}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    transport?: LisPureTransportStatusImportConfig;
    /**
     * 
     * @type {string}
     * @memberof LisPureTransportOrderStatusImportConfig
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace LisPureTransportOrderStatusImportConfig
 */
export namespace LisPureTransportOrderStatusImportConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
}

/**
 * 
 * @export
 * @interface LisPureTransportStatusImportConfig
 */
export interface LisPureTransportStatusImportConfig {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureTransportStatusImportConfig
     */
    additionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {LisPureStopStatusImportConfig}
     * @memberof LisPureTransportStatusImportConfig
     */
    loadingLoc?: LisPureStopStatusImportConfig;
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof LisPureTransportStatusImportConfig
     */
    statusAdditionalData?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof LisPureTransportStatusImportConfig
     */
    transportId?: string;
    /**
     * 
     * @type {LisPureStopStatusImportConfig}
     * @memberof LisPureTransportStatusImportConfig
     */
    unloadingLoc?: LisPureStopStatusImportConfig;
}

/**
 * 
 * @export
 * @interface LisScriptBasedExportConfig
 */
export interface LisScriptBasedExportConfig {
    /**
     * 'changeType' is of type 'AttachmentEventType' and 'env' is of type 'FormatterEnv'. Both only known to the converter, since this script is triggered in the converter.
     * @type {string}
     * @memberof LisScriptBasedExportConfig
     */
    exportAttachmentEventKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof LisScriptBasedExportConfig
     */
    exportEtaEventKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof LisScriptBasedExportConfig
     */
    exportLinkEventKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof LisScriptBasedExportConfig
     */
    exportStatusKotlinScript?: string;
    /**
     * 
     * @type {string}
     * @memberof LisScriptBasedExportConfig
     */
    exportTransportOrderKotlinScript?: string;
}

/**
 * 
 * @export
 * @interface LisSpecificConfigurationOptions
 */
export interface LisSpecificConfigurationOptions {
    /**
     * 
     * @type {string}
     * @memberof LisSpecificConfigurationOptions
     */
    applyModeOnConversionToExternalFormat?: LisSpecificConfigurationOptions.ApplyModeOnConversionToExternalFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof LisSpecificConfigurationOptions
     */
    applyModeOnConversionToTransportOrder?: LisSpecificConfigurationOptions.ApplyModeOnConversionToTransportOrderEnum;
}

/**
 * @export
 * @namespace LisSpecificConfigurationOptions
 */
export namespace LisSpecificConfigurationOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum ApplyModeOnConversionToExternalFormatEnum {
        USEFIRSTMATCHINGSPECIFICCONFIGURATION = 'USE_FIRST_MATCHING_SPECIFIC_CONFIGURATION',
        RUNONECONVERSIONJOBFOREACHMATCHINGSPECIFICCONFIGURATION = 'RUN_ONE_CONVERSION_JOB_FOR_EACH_MATCHING_SPECIFIC_CONFIGURATION',
        RUNONECONVERSIONJOBFOREACHMATCHINGSPECIFICCONFIGURATIONORABORT = 'RUN_ONE_CONVERSION_JOB_FOR_EACH_MATCHING_SPECIFIC_CONFIGURATION_OR_ABORT',
        USEFIRSTMATCHINGSPECIFICCONFIGURATIONORABORT = 'USE_FIRST_MATCHING_SPECIFIC_CONFIGURATION_OR_ABORT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ApplyModeOnConversionToTransportOrderEnum {
        USEFIRSTMATCHINGSPECIFICCONFIGURATION = 'USE_FIRST_MATCHING_SPECIFIC_CONFIGURATION',
        RUNONECONVERSIONJOBFOREACHMATCHINGSPECIFICCONFIGURATION = 'RUN_ONE_CONVERSION_JOB_FOR_EACH_MATCHING_SPECIFIC_CONFIGURATION',
        RUNONECONVERSIONJOBFOREACHMATCHINGSPECIFICCONFIGURATIONORABORT = 'RUN_ONE_CONVERSION_JOB_FOR_EACH_MATCHING_SPECIFIC_CONFIGURATION_OR_ABORT',
        USEFIRSTMATCHINGSPECIFICCONFIGURATIONORABORT = 'USE_FIRST_MATCHING_SPECIFIC_CONFIGURATION_OR_ABORT'
    }
}

/**
 * 
 * @export
 * @interface LisStatusFields
 */
export interface LisStatusFields {
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    aufArt?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    aufIntNr?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    aufNr?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    diffEinh?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    diffMenge?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    ean?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    ffpausch?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    hinweis?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    kommNr?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    liefNr?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    quitGeber?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    refNr?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    statusArt?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    tatsGew?: string;
    /**
     * 
     * @type {string}
     * @memberof LisStatusFields
     */
    tourNr?: string;
}

/**
 * 
 * @export
 * @interface LisTransportOrderStatusImportConfig
 */
export interface LisTransportOrderStatusImportConfig {
    /**
     * 
     * @type {string}
     * @memberof LisTransportOrderStatusImportConfig
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof LisTransportOrderStatusImportConfig
     */
    postImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof LisTransportOrderStatusImportConfig
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface LisTransportStatusHandling
 */
export interface LisTransportStatusHandling {
    /**
     * 
     * @type {boolean}
     * @memberof LisTransportStatusHandling
     */
    copyStatusAufIntNrToAdditionalData?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LisTransportStatusHandling
     */
    copyStatusRecordsToAdditionalData?: boolean;
}

/**
 * 
 * @export
 * @interface ListTransportOrderConfigTestsResponse
 */
export interface ListTransportOrderConfigTestsResponse {
    /**
     * 
     * @type {number}
     * @memberof ListTransportOrderConfigTestsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<TransportOrderConfigTest>}
     * @memberof ListTransportOrderConfigTestsResponse
     */
    tests?: Array<TransportOrderConfigTest>;
}

/**
 * 
 * @export
 * @interface LocalizedLabel
 */
export interface LocalizedLabel {
    /**
     * 
     * @type {string}
     * @memberof LocalizedLabel
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizedLabel
     */
    language?: string;
}

/**
 * 
 * @export
 * @interface Locks
 */
export interface Locks {
}

/**
 * 
 * @export
 * @interface LogEntry
 */
export interface LogEntry {
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    level?: LogEntry.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    message?: string;
}

/**
 * @export
 * @namespace LogEntry
 */
export namespace LogEntry {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        TRACE = 'TRACE',
        DEBUG = 'DEBUG',
        INFO = 'INFO',
        WARN = 'WARN',
        ERROR = 'ERROR'
    }
}

/**
 * 
 * @export
 * @interface LogScraperResponse
 */
export interface LogScraperResponse {
    /**
     * 
     * @type {number}
     * @memberof LogScraperResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogScraperResponse
     */
    cutMessages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LogScraperResponse
     */
    elapsedMs?: number;
    /**
     * 
     * @type {string}
     * @memberof LogScraperResponse
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof LogScraperResponse
     */
    errorDetails?: string;
    /**
     * 
     * @type {number}
     * @memberof LogScraperResponse
     */
    errorsPerHour?: number;
    /**
     * 
     * @type {Date}
     * @memberof LogScraperResponse
     */
    from?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogScraperResponse
     */
    messages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LogScraperResponse
     */
    statusCode?: number;
    /**
     * 
     * @type {Date}
     * @memberof LogScraperResponse
     */
    to?: Date;
    /**
     * 
     * @type {string}
     * @memberof LogScraperResponse
     */
    xrid?: string;
}

/**
 * 
 * @export
 * @interface LogTrackGeofence
 */
export interface LogTrackGeofence {
    /**
     * 
     * @type {number}
     * @memberof LogTrackGeofence
     */
    expirationDurationInMs?: number;
    /**
     * 
     * @type {number}
     * @memberof LogTrackGeofence
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof LogTrackGeofence
     */
    longitude?: number;
    /**
     * 
     * @type {ModelFloat}
     * @memberof LogTrackGeofence
     */
    radiusInM?: ModelFloat;
}

/**
 * 
 * @export
 * @interface LogTrackInitRequest
 */
export interface LogTrackInitRequest {
    /**
     * 
     * @type {AppDeviceId}
     * @memberof LogTrackInitRequest
     */
    appDeviceId?: AppDeviceId;
    /**
     * 
     * @type {string}
     * @memberof LogTrackInitRequest
     */
    authToken?: string;
    /**
     * 
     * @type {string}
     * @memberof LogTrackInitRequest
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface LogTrackInitResponse
 */
export interface LogTrackInitResponse {
    /**
     * 
     * @type {Array<LogTrackGeofence>}
     * @memberof LogTrackInitResponse
     */
    geofences?: Array<LogTrackGeofence>;
    /**
     * 
     * @type {boolean}
     * @memberof LogTrackInitResponse
     */
    trackingEnabled?: boolean;
}

/**
 * 
 * @export
 * @interface LogTrackPosition
 */
export interface LogTrackPosition {
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    accuracy?: number;
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    altitude?: number;
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    battery?: number;
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    course?: number;
    /**
     * 
     * @type {AppDeviceId}
     * @memberof LogTrackPosition
     */
    deviceId?: AppDeviceId;
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    longitude?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LogTrackPosition
     */
    mock?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LogTrackPosition
     */
    speed?: number;
    /**
     * 
     * @type {Date}
     * @memberof LogTrackPosition
     */
    time?: Date;
}

/**
 * 
 * @export
 * @interface LogTrackPositionRequest
 */
export interface LogTrackPositionRequest {
    /**
     * 
     * @type {string}
     * @memberof LogTrackPositionRequest
     */
    authToken?: string;
    /**
     * 
     * @type {LogTrackPosition}
     * @memberof LogTrackPositionRequest
     */
    position?: LogTrackPosition;
    /**
     * 
     * @type {string}
     * @memberof LogTrackPositionRequest
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface LogTrackPositionResponse
 */
export interface LogTrackPositionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LogTrackPositionResponse
     */
    trackingEnabled?: boolean;
}

/**
 * 
 * @export
 * @interface Logenios2CustomerMonitoring
 */
export interface Logenios2CustomerMonitoring {
    /**
     * 
     * @type {boolean}
     * @memberof Logenios2CustomerMonitoring
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Logenios2CustomerMonitoring
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Logenios2CustomerMonitoring
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Logenios2CustomerMonitoring
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Logenios2CustomerMonitoring
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Logenios2CustomerMonitoring
     */
    level?: Logenios2CustomerMonitoring.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof Logenios2CustomerMonitoring
     */
    message?: string;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof Logenios2CustomerMonitoring
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof Logenios2CustomerMonitoring
     */
    title?: string;
}

/**
 * @export
 * @namespace Logenios2CustomerMonitoring
 */
export namespace Logenios2CustomerMonitoring {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface LogeniosApiCustomReceiver
 */
export interface LogeniosApiCustomReceiver {
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiCustomReceiver
     */
    receiverAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiCustomReceiver
     */
    receiverType?: LogeniosApiCustomReceiver.ReceiverTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiCustomReceiver
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace LogeniosApiCustomReceiver
 */
export namespace LogeniosApiCustomReceiver {
    /**
     * @export
     * @enum {string}
     */
    export enum ReceiverTypeEnum {
        WHATSAPP = 'WHATSAPP',
        SPEDIONVEHICLE = 'SPEDION_VEHICLE',
        SPEDIONDRIVER = 'SPEDION_DRIVER',
        ZEKJU = 'ZEKJU'
    }
}

/**
 * 
 * @export
 * @interface LogeniosApiMail
 */
export interface LogeniosApiMail {
    /**
     * 
     * @type {Array<LogeniosApiMailAttachment>}
     * @memberof LogeniosApiMail
     */
    attachmentFiles?: Array<LogeniosApiMailAttachment>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogeniosApiMail
     */
    bccAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogeniosApiMail
     */
    ccAddresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMail
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMail
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof LogeniosApiMail
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMail
     */
    externalMessageId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMail
     */
    logeniosMessageId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMail
     */
    notificationReference?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogeniosApiMail
     */
    receiverAddresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMail
     */
    replyTo?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMail
     */
    subject?: string;
}

/**
 * 
 * @export
 * @interface LogeniosApiMailAttachment
 */
export interface LogeniosApiMailAttachment {
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMailAttachment
     */
    base64?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiMailAttachment
     */
    fileName?: string;
}

/**
 * 
 * @export
 * @interface LogeniosApiSms
 */
export interface LogeniosApiSms {
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiSms
     */
    phoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiSms
     */
    smsId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiSms
     */
    smsPort?: LogeniosApiSms.SmsPortEnum;
    /**
     * 
     * @type {string}
     * @memberof LogeniosApiSms
     */
    text?: string;
}

/**
 * @export
 * @namespace LogeniosApiSms
 */
export namespace LogeniosApiSms {
    /**
     * @export
     * @enum {string}
     */
    export enum SmsPortEnum {
        Twilio = 'Twilio',
        Spedion = 'Spedion',
        TwilioRcs = 'TwilioRcs'
    }
}

/**
 * 
 * @export
 * @interface LongRunningQueriesResponse
 */
export interface LongRunningQueriesResponse {
    /**
     * 
     * @type {string}
     * @memberof LongRunningQueriesResponse
     */
    from?: string;
    /**
     * 
     * @type {Array<LongRunningQueryByNs>}
     * @memberof LongRunningQueriesResponse
     */
    queries?: Array<LongRunningQueryByNs>;
    /**
     * 
     * @type {number}
     * @memberof LongRunningQueriesResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface LongRunningQueryByNs
 */
export interface LongRunningQueryByNs {
    /**
     * 
     * @type {string}
     * @memberof LongRunningQueryByNs
     */
    ns?: string;
    /**
     * 
     * @type {Array<Operation>}
     * @memberof LongRunningQueryByNs
     */
    queries?: Array<Operation>;
}

/**
 * 
 * @export
 * @interface MWAExpiryConfig
 */
export interface MWAExpiryConfig {
    /**
     * 
     * @type {boolean}
     * @memberof MWAExpiryConfig
     */
    accessShallExpire?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MWAExpiryConfig
     */
    revokeAccessAfterDays?: number;
    /**
     * 
     * @type {number}
     * @memberof MWAExpiryConfig
     */
    revokeAccessWhenTransportOrderIsDoneAfterDays?: number;
}

/**
 * 
 * @export
 * @interface MailAttachment
 */
export interface MailAttachment {
    /**
     * 
     * @type {string}
     * @memberof MailAttachment
     */
    base64Body?: string;
    /**
     * 
     * @type {string}
     * @memberof MailAttachment
     */
    fileName?: string;
}

/**
 * 
 * @export
 * @interface MailConfiguration
 */
export interface MailConfiguration {
    /**
     * 
     * @type {Array<MailAttachment>}
     * @memberof MailConfiguration
     */
    attachments?: Array<MailAttachment>;
    /**
     * 
     * @type {string}
     * @memberof MailConfiguration
     */
    bodyText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailConfiguration
     */
    centerAligned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MailConfiguration
     */
    footerHtml?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailConfiguration
     */
    hideLogeniosFooter?: boolean;
}

/**
 * 
 * @export
 * @interface MailContent
 */
export interface MailContent {
    /**
     * 
     * @type {string}
     * @memberof MailContent
     */
    byeText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailContent
     */
    centerAligned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MailContent
     */
    footerHtml?: string;
    /**
     * 
     * @type {string}
     * @memberof MailContent
     */
    greeting?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailContent
     */
    hideLogeniosFooter?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MailContent
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof MailContent
     */
    text?: string;
}

/**
 * 
 * @export
 * @interface MailGatewayConfiguration
 */
export interface MailGatewayConfiguration {
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfiguration
     */
    allowAllMailsFromDomain?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    checkDKIM?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    checkDMARC?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    checkSPF?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    enable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfiguration
     */
    excludeFilePattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    excludeMainJsonFromZipFile?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfiguration
     */
    fileNameOverrideScript?: string;
    /**
     * 
     * @type {Array<SFTPDownloadDirectoryMapping>}
     * @memberof MailGatewayConfiguration
     */
    fileToDirectoryMapping?: Array<SFTPDownloadDirectoryMapping>;
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfiguration
     */
    includeFilePattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    shouldZipAttachments?: boolean;
    /**
     * 
     * @type {Array<MailGatewayConfigurationOverride>}
     * @memberof MailGatewayConfiguration
     */
    specificConfigurations?: Array<MailGatewayConfigurationOverride>;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    storeHtmlMailBody?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    storeMailAsJson?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MailGatewayConfiguration
     */
    storeMailBody?: boolean;
}

/**
 * 
 * @export
 * @interface MailGatewayConfigurationOverride
 */
export interface MailGatewayConfigurationOverride {
    /**
     * 
     * @type {MailGatewayConfigurationOverrideApplyWhen}
     * @memberof MailGatewayConfigurationOverride
     */
    applyWhen?: MailGatewayConfigurationOverrideApplyWhen;
    /**
     * 
     * @type {MailGatewayConfiguration}
     * @memberof MailGatewayConfigurationOverride
     */
    override?: MailGatewayConfiguration;
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfigurationOverride
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface MailGatewayConfigurationOverrideApplyWhen
 */
export interface MailGatewayConfigurationOverrideApplyWhen {
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfigurationOverrideApplyWhen
     */
    whenAttachmentFilePatternIs?: string;
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfigurationOverrideApplyWhen
     */
    whenMailTextContains?: string;
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfigurationOverrideApplyWhen
     */
    whenReceiverMailIs?: string;
    /**
     * 
     * @type {string}
     * @memberof MailGatewayConfigurationOverrideApplyWhen
     */
    whenSubjectContains?: string;
}

/**
 * 
 * @export
 * @interface MailGatewayConfigurationResponse
 */
export interface MailGatewayConfigurationResponse {
    /**
     * 
     * @type {Company}
     * @memberof MailGatewayConfigurationResponse
     */
    company?: Company;
    /**
     * 
     * @type {MailGatewayConfiguration}
     * @memberof MailGatewayConfigurationResponse
     */
    mailGatewayConfiguration?: MailGatewayConfiguration;
    /**
     * 
     * @type {User}
     * @memberof MailGatewayConfigurationResponse
     */
    user?: User;
}

/**
 * 
 * @export
 * @interface MailgunWebhookInputRequest
 */
export interface MailgunWebhookInputRequest {
    /**
     * 
     * @type {EventData}
     * @memberof MailgunWebhookInputRequest
     */
    event_data?: EventData;
    /**
     * 
     * @type {Signature}
     * @memberof MailgunWebhookInputRequest
     */
    signature?: Signature;
    /**
     * 
     * @type {UserVariables}
     * @memberof MailgunWebhookInputRequest
     */
    user_variables?: UserVariables;
}

/**
 * 
 * @export
 * @interface MapVehicleToAssignedDeviceRequest
 */
export interface MapVehicleToAssignedDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof MapVehicleToAssignedDeviceRequest
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof MapVehicleToAssignedDeviceRequest
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface MatchingCriteria
 */
export interface MatchingCriteria {
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    fieldName?: MatchingCriteria.FieldNameEnum;
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    fieldValue?: string;
}

/**
 * @export
 * @namespace MatchingCriteria
 */
export namespace MatchingCriteria {
    /**
     * @export
     * @enum {string}
     */
    export enum FieldNameEnum {
        TARGETCOMPANYNAME = 'TARGET_COMPANY_NAME',
        EXTERNALTARGETCOMPANYID = 'EXTERNAL_TARGET_COMPANY_ID',
        LOADINGLOCATIONNAME1 = 'LOADING_LOCATION_NAME1',
        LOADINGLOCATIONNAME2 = 'LOADING_LOCATION_NAME2',
        LOADINGLOCATIONCITY = 'LOADING_LOCATION_CITY',
        LOADINGLOCATIONSTREET = 'LOADING_LOCATION_STREET',
        LOADINGLOCATIONCOUNTRYCODE = 'LOADING_LOCATION_COUNTRY_CODE',
        LOADINGLOCATIONZIPCODE = 'LOADING_LOCATION_ZIP_CODE',
        LOADINGLOCATIONEXTERNALSTOPID = 'LOADING_LOCATION_EXTERNAL_STOP_ID',
        UNLOADINGLOCATIONNAME1 = 'UNLOADING_LOCATION_NAME1',
        UNLOADINGLOCATIONNAME2 = 'UNLOADING_LOCATION_NAME2',
        UNLOADINGLOCATIONCITY = 'UNLOADING_LOCATION_CITY',
        UNLOADINGLOCATIONSTREET = 'UNLOADING_LOCATION_STREET',
        UNLOADINGLOCATIONCOUNTRYCODE = 'UNLOADING_LOCATION_COUNTRY_CODE',
        UNLOADINGLOCATIONZIPCODE = 'UNLOADING_LOCATION_ZIP_CODE',
        UNLOADINGLOCATIONEXTERNALSTOPID = 'UNLOADING_LOCATION_EXTERNAL_STOP_ID',
        FREIGHTID = 'FREIGHT_ID',
        FREIGHTEXTERNALFREIGHTID = 'FREIGHT_EXTERNAL_FREIGHT_ID',
        FREIGHTDELIVERYNUMBER = 'FREIGHT_DELIVERY_NUMBER',
        FREIGHTVERBOSENAME = 'FREIGHT_VERBOSE_NAME',
        FREIGHTCONTAINMENTNAME = 'FREIGHT_CONTAINMENT_NAME',
        FREIGHTCONTAINMENTNAMEEXT = 'FREIGHT_CONTAINMENT_NAME_EXT',
        FREIGHTCONTAINMENTTYPE = 'FREIGHT_CONTAINMENT_TYPE',
        FREIGHTCONTAINMENTQUANTITY = 'FREIGHT_CONTAINMENT_QUANTITY',
        FREIGHTHEIGHT = 'FREIGHT_HEIGHT',
        FREIGHTWIDTH = 'FREIGHT_WIDTH',
        FREIGHTLENGTH = 'FREIGHT_LENGTH',
        FREIGHTTOTALLOTS = 'FREIGHT_TOTAL_LOTS',
        FREIGHTTOTALLOADINGMETER = 'FREIGHT_TOTAL_LOADING_METER',
        FREIGHTTOTALQUANTITY = 'FREIGHT_TOTAL_QUANTITY',
        FREIGHTTOTALVOLUME = 'FREIGHT_TOTAL_VOLUME',
        FREIGHTTOTALWEIGHT = 'FREIGHT_TOTAL_WEIGHT',
        TRANSPORTCOMMENT = 'TRANSPORT_COMMENT',
        SHIPPERNAME = 'SHIPPER_NAME',
        SHIPPERCITY = 'SHIPPER_CITY',
        SHIPPERZIPCODE = 'SHIPPER_ZIPCODE',
        SHIPPERCOUNTRYCODE = 'SHIPPER_COUNTRY_CODE',
        SHIPPERSTREET = 'SHIPPER_STREET',
        FREIGHTPAYERNAME = 'FREIGHT_PAYER_NAME',
        FREIGHTPAYERCITY = 'FREIGHT_PAYER_CITY',
        FREIGHTPAYERZIPCODE = 'FREIGHT_PAYER_ZIPCODE',
        FREIGHTPAYERCOUNTRYCODE = 'FREIGHT_PAYER_COUNTRY_CODE',
        FREIGHTPAYERSTREET = 'FREIGHT_PAYER_STREET',
        FREIGHTPAYEREXTERNALPARTNERID = 'FREIGHT_PAYER_EXTERNAL_PARTNER_ID',
        FREIGHTPAYEREXTERNALID = 'FREIGHT_PAYER_EXTERNAL_ID'
    }
}

/**
 * 
 * @export
 * @interface MergedStop
 */
export interface MergedStop {
    /**
     * 
     * @type {Array<TransportStopPair>}
     * @memberof MergedStop
     */
    mergedStops?: Array<TransportStopPair>;
}

/**
 * 
 * @export
 * @interface MergedStopListResponse
 */
export interface MergedStopListResponse {
    /**
     * 
     * @type {Array<MergedStop>}
     * @memberof MergedStopListResponse
     */
    stops?: Array<MergedStop>;
}

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {Array<Any>}
     * @memberof Message
     */
    attachments?: Array<Any>;
    /**
     * 
     * @type {Headers}
     * @memberof Message
     */
    headers?: Headers;
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    size?: number;
}

/**
 * 
 * @export
 * @interface MessageLog
 */
export interface MessageLog {
    /**
     * 
     * @type {string}
     * @memberof MessageLog
     */
    _id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MessageLog
     */
    acknowledged?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof MessageLog
     */
    createdAt?: Date;
    /**
     * 
     * @type {LogeniosApiCustomReceiver}
     * @memberof MessageLog
     */
    customReceiver?: LogeniosApiCustomReceiver;
    /**
     * 
     * @type {string}
     * @memberof MessageLog
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageLog
     */
    eventAdditionalInformation?: string;
    /**
     * 
     * @type {Array<EventAdditionalInformation>}
     * @memberof MessageLog
     */
    eventAdditionalInformationList?: Array<EventAdditionalInformation>;
    /**
     * 
     * @type {boolean}
     * @memberof MessageLog
     */
    hasFinalState?: boolean;
    /**
     * 
     * @type {LogeniosApiMail}
     * @memberof MessageLog
     */
    mail?: LogeniosApiMail;
    /**
     * 
     * @type {string}
     * @memberof MessageLog
     */
    messageHash?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageLog
     */
    messageType?: MessageLog.MessageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MessageLog
     */
    retries?: number;
    /**
     * 
     * @type {SendCause}
     * @memberof MessageLog
     */
    sendCause?: SendCause;
    /**
     * 
     * @type {boolean}
     * @memberof MessageLog
     */
    sendSuccessfully?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof MessageLog
     */
    sendTime?: Date;
    /**
     * 
     * @type {LogeniosApiSms}
     * @memberof MessageLog
     */
    sms?: LogeniosApiSms;
    /**
     * 
     * @type {string}
     * @memberof MessageLog
     */
    statusText?: string;
    /**
     * 
     * @type {Array<StatusText>}
     * @memberof MessageLog
     */
    statusTextList?: Array<StatusText>;
}

/**
 * @export
 * @namespace MessageLog
 */
export namespace MessageLog {
    /**
     * @export
     * @enum {string}
     */
    export enum MessageTypeEnum {
        REMINDER = 'REMINDER',
        INFO = 'INFO',
        WARNING = 'WARNING'
    }
}

/**
 * 
 * @export
 * @interface MessageLogAcknowledgeRequest
 */
export interface MessageLogAcknowledgeRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageLogAcknowledgeRequest
     */
    companyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageLogAcknowledgeRequest
     */
    messageLogId?: Array<string>;
}

/**
 * 
 * @export
 * @interface MessageLogEvent
 */
export interface MessageLogEvent {
    /**
     * 
     * @type {MessageLog}
     * @memberof MessageLogEvent
     */
    message?: MessageLog;
}

/**
 * 
 * @export
 * @interface MessageLogReport
 */
export interface MessageLogReport {
    /**
     * 
     * @type {Array<CompanyMessageLogReport>}
     * @memberof MessageLogReport
     */
    companies?: Array<CompanyMessageLogReport>;
    /**
     * 
     * @type {number}
     * @memberof MessageLogReport
     */
    totalSendErrors?: number;
}

/**
 * 
 * @export
 * @interface MessageLogResponse
 */
export interface MessageLogResponse {
    /**
     * 
     * @type {Array<MessageLog>}
     * @memberof MessageLogResponse
     */
    logs?: Array<MessageLog>;
}

/**
 * 
 * @export
 * @interface MetaModel
 */
export interface MetaModel {
    /**
     * 
     * @type {string}
     * @memberof MetaModel
     */
    name?: string;
    /**
     * 
     * @type {MetaModelNode}
     * @memberof MetaModel
     */
    root?: MetaModelNode;
}

/**
 * 
 * @export
 * @interface MetaModelConfiguration
 */
export interface MetaModelConfiguration {
    /**
     * 
     * @type {MetaModelMappingConfigration}
     * @memberof MetaModelConfiguration
     */
    exportMapping?: MetaModelMappingConfigration;
    /**
     * 
     * @type {MetaModelMappingConfigration}
     * @memberof MetaModelConfiguration
     */
    importMapping?: MetaModelMappingConfigration;
}

/**
 * 
 * @export
 * @interface MetaModelMappingConfigration
 */
export interface MetaModelMappingConfigration {
    /**
     * 
     * @type {Array<ModelConnection>}
     * @memberof MetaModelMappingConfigration
     */
    connections?: Array<ModelConnection>;
    /**
     * 
     * @type {string}
     * @memberof MetaModelMappingConfigration
     */
    graphData?: string;
    /**
     * 
     * @type {MetaModel}
     * @memberof MetaModelMappingConfigration
     */
    sourceModel?: MetaModel;
    /**
     * 
     * @type {MetaModel}
     * @memberof MetaModelMappingConfigration
     */
    targetModel?: MetaModel;
}

/**
 * 
 * @export
 * @interface MetaModelNode
 */
export interface MetaModelNode {
    /**
     * 
     * @type {Array<MetaModelNode>}
     * @memberof MetaModelNode
     */
    children?: Array<MetaModelNode>;
    /**
     * 
     * @type {string}
     * @memberof MetaModelNode
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaModelNode
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaModelNode
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface MigrateDbResponse
 */
export interface MigrateDbResponse {
    /**
     * 
     * @type {number}
     * @memberof MigrateDbResponse
     */
    currentDbVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof MigrateDbResponse
     */
    responseMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MigrateDbResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface MigrationTask
 */
export interface MigrationTask {
    /**
     * 
     * @type {string}
     * @memberof MigrationTask
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MigrationTask
     */
    preMigrationDbVersion?: number;
}

/**
 * 
 * @export
 * @interface MinioHealthState
 */
export interface MinioHealthState {
    /**
     * 
     * @type {boolean}
     * @memberof MinioHealthState
     */
    isHealth?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MinioHealthState
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface MissingAttribute
 */
export interface MissingAttribute {
    /**
     * Key is the tag name coming from the script which decided where to put the value in the transport order. e.g shp.loadingLoc.name1, shp.loadingLoc.city. Whole list of available tags : c.f. src/components/util/table-splitter-ui/src/misc/tag_model.ts
     * @type {string}
     * @memberof MissingAttribute
     */
    key?: string;
    /**
     * 
     * @type {MissingAttributePath}
     * @memberof MissingAttribute
     */
    path?: MissingAttributePath;
    /**
     * 
     * @type {string}
     * @memberof MissingAttribute
     */
    requiredAction?: MissingAttribute.RequiredActionEnum;
    /**
     * Everytime this object will get updated in DB, updatedTime attribute will filled with current time.
     * @type {Date}
     * @memberof MissingAttribute
     */
    updatedTime?: Date;
    /**
     * In pre resolving phase of transport order all values will be null. When the resolving of all fields is finished and user provide all values from the webapp ui, then values attribute will have a non null value.
     * @type {string}
     * @memberof MissingAttribute
     */
    value?: string;
}

/**
 * @export
 * @namespace MissingAttribute
 */
export namespace MissingAttribute {
    /**
     * @export
     * @enum {string}
     */
    export enum RequiredActionEnum {
        DONOTHING = 'DO_NOTHING',
        USERSHALLPROVIDEVALUES = 'USER_SHALL_PROVIDE_VALUES',
        WARNUSER = 'WARN_USER'
    }
}

/**
 * 
 * @export
 * @interface MissingAttributePath
 */
export interface MissingAttributePath {
    /**
     * 
     * @type {string}
     * @memberof MissingAttributePath
     */
    freightIndex?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingAttributePath
     */
    transportIndex?: string;
}

/**
 * 
 * @export
 * @interface MissingAttributeValuesUpdateRequest
 */
export interface MissingAttributeValuesUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof MissingAttributeValuesUpdateRequest
     */
    orderId?: string;
    /**
     * 
     * @type {Array<MissingAttribute>}
     * @memberof MissingAttributeValuesUpdateRequest
     */
    updatedMissingAttributeList?: Array<MissingAttribute>;
}

/**
 * 
 * @export
 * @interface MissingAttributeValuesUpdateResponse
 */
export interface MissingAttributeValuesUpdateResponse {
    /**
     * 
     * @type {TransportOrder}
     * @memberof MissingAttributeValuesUpdateResponse
     */
    newOrder?: TransportOrder;
    /**
     * 
     * @type {boolean}
     * @memberof MissingAttributeValuesUpdateResponse
     */
    result?: boolean;
}

/**
 * 
 * @export
 * @interface MissingInfo
 */
export interface MissingInfo {
    /**
     * 
     * @type {string}
     * @memberof MissingInfo
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingInfo
     */
    tag?: MissingInfo.TagEnum;
}

/**
 * @export
 * @namespace MissingInfo
 */
export namespace MissingInfo {
    /**
     * @export
     * @enum {string}
     */
    export enum TagEnum {
        GPSDATA = 'GPSDATA',
        STOPSLEFT = 'STOPSLEFT',
        UNLOADEDINTIME = 'UNLOADED_IN_TIME'
    }
}

/**
 * 
 * @export
 * @interface MobileWebAppConfiguration
 */
export interface MobileWebAppConfiguration {
    /**
     * 
     * @type {MWAExpiryConfig}
     * @memberof MobileWebAppConfiguration
     */
    accessExpiryConfig?: MWAExpiryConfig;
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppConfiguration
     */
    accessGpsPosition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppConfiguration
     */
    activeVersion?: MobileWebAppConfiguration.ActiveVersionEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof MobileWebAppConfiguration
     */
    availableStatusWorkflows?: Array<MobileWebAppConfiguration.AvailableStatusWorkflowsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppConfiguration
     */
    leftMenuDefaultOpen?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppConfiguration
     */
    sendAssignedDeviceNotificationCondition?: MobileWebAppConfiguration.SendAssignedDeviceNotificationConditionEnum;
    /**
     * 
     * @type {Array<MobileWebAppSpecificConfiguration>}
     * @memberof MobileWebAppConfiguration
     */
    specificConfigs?: Array<MobileWebAppSpecificConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppConfiguration
     */
    statusWorkflow?: MobileWebAppConfiguration.StatusWorkflowEnum;
    /**
     * 
     * @type {StopListConfiguration}
     * @memberof MobileWebAppConfiguration
     */
    stopListConfiguration?: StopListConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppConfiguration
     */
    useConfigFromTargetCompany?: boolean;
    /**
     * 
     * @type {MobileWebAppV2Config}
     * @memberof MobileWebAppConfiguration
     */
    v2?: MobileWebAppV2Config;
    /**
     * 
     * @type {WorkflowConfiguration}
     * @memberof MobileWebAppConfiguration
     */
    workflowConfiguration?: WorkflowConfiguration;
}

/**
 * @export
 * @namespace MobileWebAppConfiguration
 */
export namespace MobileWebAppConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ActiveVersionEnum {
        V2 = 'V2'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableStatusWorkflowsEnum {
        StopStatus = 'StopStatus',
        StopLocationAndActionStatus = 'StopLocationAndActionStatus',
        ConfirmLoadedConfirmDelivered = 'ConfirmLoadedConfirmDelivered',
        SelectLoadedSelectDelivered = 'SelectLoadedSelectDelivered',
        ConfirmLoadedSelectDelivered = 'ConfirmLoadedSelectDelivered',
        ShipmentBasedSchenkerDesign = 'ShipmentBasedSchenkerDesign',
        None = 'None'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SendAssignedDeviceNotificationConditionEnum {
        DIRECTLYONASSIGN = 'DIRECTLY_ON_ASSIGN',
        WHENDEVICEANDATTACHMENTPRESENT = 'WHEN_DEVICE_AND_ATTACHMENT_PRESENT',
        DONTSENDNOTIFICATION = 'DONT_SEND_NOTIFICATION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusWorkflowEnum {
        StopStatus = 'StopStatus',
        StopLocationAndActionStatus = 'StopLocationAndActionStatus',
        ConfirmLoadedConfirmDelivered = 'ConfirmLoadedConfirmDelivered',
        SelectLoadedSelectDelivered = 'SelectLoadedSelectDelivered',
        ConfirmLoadedSelectDelivered = 'ConfirmLoadedSelectDelivered',
        ShipmentBasedSchenkerDesign = 'ShipmentBasedSchenkerDesign',
        None = 'None'
    }
}

/**
 * 
 * @export
 * @interface MobileWebAppContactDetailsConfig
 */
export interface MobileWebAppContactDetailsConfig {
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppContactDetailsConfig
     */
    showContactEmailEditAtBottom?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppContactDetailsConfig
     */
    showContactEmailEditModal?: boolean;
}

/**
 * 
 * @export
 * @interface MobileWebAppPodConfiguration
 */
export interface MobileWebAppPodConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppPodConfiguration
     */
    generatePod?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MobileWebAppPodConfiguration
     */
    includeWorkflowFields?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppPodConfiguration
     */
    podFormat?: MobileWebAppPodConfiguration.PodFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppPodConfiguration
     */
    requireSignaturesFrom?: MobileWebAppPodConfiguration.RequireSignaturesFromEnum;
    /**
     * 
     * @type {SignDocumentConfig}
     * @memberof MobileWebAppPodConfiguration
     */
    stampConfig?: SignDocumentConfig;
}

/**
 * @export
 * @namespace MobileWebAppPodConfiguration
 */
export namespace MobileWebAppPodConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum PodFormatEnum {
        MergeSignatureWithPODTemplate = 'Merge_Signature_With_POD_Template',
        PODGraphic = 'POD_Graphic'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RequireSignaturesFromEnum {
        SHIPPER = 'SHIPPER',
        RECEIVER = 'RECEIVER',
        SHIPPERANDRECEIVER = 'SHIPPER_AND_RECEIVER'
    }
}

/**
 * 
 * @export
 * @interface MobileWebAppSpecificConfiguration
 */
export interface MobileWebAppSpecificConfiguration {
    /**
     * 
     * @type {Array<ImmediateFormatPathMatchRule>}
     * @memberof MobileWebAppSpecificConfiguration
     */
    applyWhenAllPathsMatches?: Array<ImmediateFormatPathMatchRule>;
    /**
     * 
     * @type {MobileWebAppConfiguration}
     * @memberof MobileWebAppSpecificConfiguration
     */
    override?: MobileWebAppConfiguration;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppSpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface MobileWebAppV2Config
 */
export interface MobileWebAppV2Config {
    /**
     * 
     * @type {AttachmentAreaConfiguration}
     * @memberof MobileWebAppV2Config
     */
    attachmentArea?: AttachmentAreaConfiguration;
    /**
     * 
     * @type {MobileWebAppContactDetailsConfig}
     * @memberof MobileWebAppV2Config
     */
    contactDetails?: MobileWebAppContactDetailsConfig;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppV2Config
     */
    determineShipmentNrScript?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileWebAppV2Config
     */
    determineTourNrScript?: string;
    /**
     * 
     * @type {ShipmentListSideMenuMobileWebAppConfig}
     * @memberof MobileWebAppV2Config
     */
    shipmentListSideMenu?: ShipmentListSideMenuMobileWebAppConfig;
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppV2Config
     */
    showComment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MobileWebAppV2Config
     */
    showDateTimeSectionInSchenkerBasedDesign?: boolean;
    /**
     * 
     * @type {SignDocumentConfig}
     * @memberof MobileWebAppV2Config
     */
    signDocumentConfig?: SignDocumentConfig;
    /**
     * 
     * @type {StopLocationViewConfiguration}
     * @memberof MobileWebAppV2Config
     */
    stopLocationView?: StopLocationViewConfiguration;
    /**
     * 
     * @type {TourViewHeaderConfiguration}
     * @memberof MobileWebAppV2Config
     */
    tourViewHeader?: TourViewHeaderConfiguration;
    /**
     * 
     * @type {TransportOrderWorkflowAreaConfig}
     * @memberof MobileWebAppV2Config
     */
    transportOrderWorkflowArea?: TransportOrderWorkflowAreaConfig;
    /**
     * 
     * @type {UploadPageViewConfiguration}
     * @memberof MobileWebAppV2Config
     */
    uploadPageStyling?: UploadPageViewConfiguration;
}

/**
 * 
 * @export
 * @interface ModelBoolean
 */
export interface ModelBoolean {
}

/**
 * 
 * @export
 * @interface ModelConnection
 */
export interface ModelConnection {
    /**
     * 
     * @type {string}
     * @memberof ModelConnection
     */
    fromId?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConnection
     */
    kind?: ModelConnection.KindEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelConnection
     */
    toId?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConnection
     */
    transformation?: string;
}

/**
 * @export
 * @namespace ModelConnection
 */
export namespace ModelConnection {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        OneToOne = 'OneToOne',
        NToM = 'NToM'
    }
}

/**
 * 
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    status?: ModelFile.StatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    prefixLength?: number;
    /**
     * 
     * @type {Path}
     * @memberof ModelFile
     */
    filePath?: Path;
}

/**
 * @export
 * @namespace ModelFile
 */
export namespace ModelFile {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        INVALID = 'INVALID',
        CHECKED = 'CHECKED'
    }
}

/**
 * 
 * @export
 * @interface ModelFloat
 */
export interface ModelFloat {
}

/**
 * 
 * @export
 * @interface ModelMap
 */
export interface ModelMap {
    /**
     * 
     * @type {Set}
     * @memberof ModelMap
     */
    entries?: Set;
    /**
     * 
     * @type {Set}
     * @memberof ModelMap
     */
    keys?: Set;
    /**
     * 
     * @type {number}
     * @memberof ModelMap
     */
    size?: number;
    /**
     * 
     * @type {Collection}
     * @memberof ModelMap
     */
    values?: Collection;
}

/**
 * 
 * @export
 * @interface ModifyFilterName
 */
export interface ModifyFilterName {
    /**
     * 
     * @type {string}
     * @memberof ModifyFilterName
     */
    filterId?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyFilterName
     */
    filterName?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyFilterName
     */
    userId?: string;
}

/**
 * 
 * @export
 * @interface MongoCurrentOp
 */
export interface MongoCurrentOp {
    /**
     * 
     * @type {Array<Operation>}
     * @memberof MongoCurrentOp
     */
    inprog?: Array<Operation>;
    /**
     * 
     * @type {number}
     * @memberof MongoCurrentOp
     */
    ok?: number;
    /**
     * 
     * @type {OperationTime}
     * @memberof MongoCurrentOp
     */
    operationTime?: OperationTime;
}

/**
 * 
 * @export
 * @interface MongoDriver
 */
export interface MongoDriver {
    /**
     * 
     * @type {string}
     * @memberof MongoDriver
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MongoDriver
     */
    version?: string;
}

/**
 * 
 * @export
 * @interface MonitorConfig
 */
export interface MonitorConfig {
    /**
     * 
     * @type {Array<AdditionalDataDisplayColumn>}
     * @memberof MonitorConfig
     */
    additionalDataDisplayColumns?: Array<AdditionalDataDisplayColumn>;
    /**
     * 
     * @type {boolean}
     * @memberof MonitorConfig
     */
    delayedOnly?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitorConfig
     */
    displayColumns?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitorConfig
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitorConfig
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitorConfig
     */
    isArrivalMonitor?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitorConfig
     */
    isDepotFreightMonitor?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MonitorConfig
     */
    searchTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitorConfig
     */
    shouldDisplayCounters?: boolean;
}

/**
 * 
 * @export
 * @interface MonitoringOperationsResponse
 */
export interface MonitoringOperationsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitoringOperationsResponse
     */
    indexMsgs?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MonitoringOperationsResponse
     */
    indexingOps?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringOperationsResponse
     */
    longRunningOps?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringOperationsResponse
     */
    longRunningOpsByUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringOperationsResponse
     */
    longRunningOpsByUsersTimeInS?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringOperationsResponse
     */
    longRunningOpsTimeInS?: number;
    /**
     * 
     * @type {MongoCurrentOp}
     * @memberof MonitoringOperationsResponse
     */
    ops?: MongoCurrentOp;
}

/**
 * 
 * @export
 * @interface MonitoringQueueResponse
 */
export interface MonitoringQueueResponse {
    /**
     * 
     * @type {Array<CompanyQueueInfo>}
     * @memberof MonitoringQueueResponse
     */
    companyQueueInfos?: Array<CompanyQueueInfo>;
    /**
     * 
     * @type {Array<CompanyQueueInfo>}
     * @memberof MonitoringQueueResponse
     */
    emptyCompanyQueueInfos?: Array<CompanyQueueInfo>;
}

/**
 * 
 * @export
 * @interface MonthlyCost
 */
export interface MonthlyCost {
    /**
     * 
     * @type {string}
     * @memberof MonthlyCost
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyCost
     */
    price?: number;
}

/**
 * 
 * @export
 * @interface MultiOrderScriptingRequest
 */
export interface MultiOrderScriptingRequest {
    /**
     * 
     * @type {string}
     * @memberof MultiOrderScriptingRequest
     */
    groovyScript?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiOrderScriptingRequest
     */
    transportOrderIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface MultiOrderScriptingResponse
 */
export interface MultiOrderScriptingResponse {
    /**
     * 
     * @type {any}
     * @memberof MultiOrderScriptingResponse
     */
    results?: any;
}

/**
 * 
 * @export
 * @interface MultiScriptExecutionRequest
 */
export interface MultiScriptExecutionRequest {
    /**
     * 
     * @type {string}
     * @memberof MultiScriptExecutionRequest
     */
    companyId?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof MultiScriptExecutionRequest
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof MultiScriptExecutionRequest
     */
    transportOrderId?: string;
    /**
     * 
     * @type {ViewConfigurationScripts}
     * @memberof MultiScriptExecutionRequest
     */
    viewConfigurationScripts?: ViewConfigurationScripts;
}

/**
 * 
 * @export
 * @interface MultipleEtaProcessedRequest
 */
export interface MultipleEtaProcessedRequest {
    /**
     * 
     * @type {Array<EtaProcessedRequest>}
     * @memberof MultipleEtaProcessedRequest
     */
    processedEvents?: Array<EtaProcessedRequest>;
}

/**
 * 
 * @export
 * @interface MultipleTransportOrderStatusUpdateRequests
 */
export interface MultipleTransportOrderStatusUpdateRequests {
    /**
     * 
     * @type {Array<TransportOrderStatusUpdateRequest>}
     * @memberof MultipleTransportOrderStatusUpdateRequests
     */
    requests?: Array<TransportOrderStatusUpdateRequest>;
}

/**
 * 
 * @export
 * @interface NoContent
 */
export interface NoContent {
    /**
     * 
     * @type {number}
     * @memberof NoContent
     */
    contentLength?: number;
    /**
     * 
     * @type {ContentType}
     * @memberof NoContent
     */
    contentType?: ContentType;
    /**
     * 
     * @type {Headers}
     * @memberof NoContent
     */
    headers?: Headers;
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof NoContent
     */
    status?: HttpStatusCode;
}

/**
 * 
 * @export
 * @interface NomadInfo
 */
export interface NomadInfo {
    /**
     * 
     * @type {string}
     * @memberof NomadInfo
     */
    allocationId?: string;
    /**
     * 
     * @type {string}
     * @memberof NomadInfo
     */
    ipAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof NomadInfo
     */
    jobName?: string;
    /**
     * 
     * @type {string}
     * @memberof NomadInfo
     */
    nomadDC?: string;
}

/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * Use this to configure the min delay for late arrival notificaitons. Default 15min
     * @type {number}
     * @memberof Notification
     */
    minDelayForLateArrivalNotificationInMinutes?: number;
    /**
     * Timestamp when the notification was sent
     * @type {Date}
     * @memberof Notification
     */
    sentTimestamp?: Date;
    /**
     * Status of this notification
     * @type {string}
     * @memberof Notification
     */
    status?: Notification.StatusEnum;
    /**
     * If any of the listed events occurs, a notification is sent to the users observing this transport order
     * @type {Array<string>}
     * @memberof Notification
     */
    trigger?: Array<Notification.TriggerEnum>;
}

/**
 * @export
 * @namespace Notification
 */
export namespace Notification {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        PLANNED = 'PLANNED',
        SENT = 'SENT',
        RECEIVED = 'RECEIVED',
        VIEWEDBYRECEIVER = 'VIEWED_BY_RECEIVER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TriggerEnum {
        OnObserverAdd = 'OnObserverAdd',
        OnTransportOrderCreate = 'OnTransportOrderCreate',
        OnTransportOrderAccept = 'OnTransportOrderAccept',
        OnTransportOrderReject = 'OnTransportOrderReject',
        OnTransportOrderDone = 'OnTransportOrderDone',
        OnTransportOrderExecuting = 'OnTransportOrderExecuting',
        OnBeginLoading = 'OnBeginLoading',
        OnFinishLoading = 'OnFinishLoading',
        OnFreightNotLoaded = 'OnFreightNotLoaded',
        OnBeginUnloading = 'OnBeginUnloading',
        OnFinishUnloading = 'OnFinishUnloading',
        OnArrive = 'OnArrive',
        WillArriveIn15min = 'WillArriveIn15min',
        WillArriveIn30min = 'WillArriveIn30min',
        OnExpectedLateArrival = 'OnExpectedLateArrival',
        OnLateArrival = 'OnLateArrival',
        RemainingDistance15km = 'RemainingDistance15km',
        RemainingDistance30km = 'RemainingDistance30km',
        RemainingDistance45km = 'RemainingDistance45km',
        OneHourBeforePlanArriveAtUnloadingLocation = 'OneHourBeforePlanArriveAtUnloadingLocation',
        OneDayBeforePlanArriveAtUnloadingLocation = 'OneDayBeforePlanArriveAtUnloadingLocation',
        RemainingDistance15kmToUnloadingLocation = 'RemainingDistance15kmToUnloadingLocation',
        RemainingDistance30kmToUnloadingLocation = 'RemainingDistance30kmToUnloadingLocation',
        RemainingDistance45kmToUnloadingLocation = 'RemainingDistance45kmToUnloadingLocation',
        WillArriveIn15minAtUnloadingLocation = 'WillArriveIn15minAtUnloadingLocation',
        WillArriveIn30minAtUnloadingLocation = 'WillArriveIn30minAtUnloadingLocation',
        OnLinkDeliveryTour = 'OnLinkDeliveryTour'
    }
}

/**
 * 
 * @export
 * @interface NotificationConfiguration
 */
export interface NotificationConfiguration {
    /**
     * 
     * @type {string}
     * @memberof NotificationConfiguration
     */
    activeSmsPort?: NotificationConfiguration.ActiveSmsPortEnum;
    /**
     * 
     * @type {Array<ArrivalNotificationConfiguration>}
     * @memberof NotificationConfiguration
     */
    arrivalNotificationConfigurations?: Array<ArrivalNotificationConfiguration>;
    /**
     * 
     * @type {number}
     * @memberof NotificationConfiguration
     */
    arrivalNotificationTimeWindowInH?: number;
    /**
     * 
     * @type {AssignedDeviceNotificationConfiguration}
     * @memberof NotificationConfiguration
     */
    assignedDevice?: AssignedDeviceNotificationConfiguration;
    /**
     * 
     * @type {Array<DelayedArrivalNotificationConfiguration>}
     * @memberof NotificationConfiguration
     */
    delayedArrivalNotificationConfigurations?: Array<DelayedArrivalNotificationConfiguration>;
    /**
     * 
     * @type {DetermineVehicleConfiguration}
     * @memberof NotificationConfiguration
     */
    determineVehicleConfiguration?: DetermineVehicleConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationConfiguration
     */
    disableDeferringUpdateNotificationsForAssignedDevices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationConfiguration
     */
    disableSourceCompanyCheck?: boolean;
    /**
     * 
     * @type {DuplicateImportNotificationConfiguration}
     * @memberof NotificationConfiguration
     */
    duplicateImportNotificationConfiguration?: DuplicateImportNotificationConfiguration;
    /**
     * 
     * @type {ObserverArrivalNotificationConfiguration}
     * @memberof NotificationConfiguration
     */
    observerArrivalNotificationConfiguration?: ObserverArrivalNotificationConfiguration;
    /**
     * 
     * @type {ObserverModalSetting}
     * @memberof NotificationConfiguration
     */
    observerModalSetting?: ObserverModalSetting;
    /**
     * 
     * @type {PlannedArrivalNotificationConfiguration}
     * @memberof NotificationConfiguration
     */
    plannedArrivalNotificationConfiguration?: PlannedArrivalNotificationConfiguration;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfiguration
     */
    senderOfArrivalNotifications?: NotificationConfiguration.SenderOfArrivalNotificationsEnum;
    /**
     * 
     * @type {Array<SmsFailureNotificationConfiguration>}
     * @memberof NotificationConfiguration
     */
    smsFailureNotificationConfigurations?: Array<SmsFailureNotificationConfiguration>;
    /**
     * 
     * @type {MailConfiguration}
     * @memberof NotificationConfiguration
     */
    statusChangedMailConfiguration?: MailConfiguration;
    /**
     * 
     * @type {StatusValidationConfiguration}
     * @memberof NotificationConfiguration
     */
    statusValidationConfiguration?: StatusValidationConfiguration;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationConfiguration
     */
    statusValidationReceiverMails?: Array<string>;
    /**
     * 
     * @type {Array<SystemStatusMonitoringNotificationConfiguration>}
     * @memberof NotificationConfiguration
     */
    systemStatusMonitoringConfiguration?: Array<SystemStatusMonitoringNotificationConfiguration>;
    /**
     * 
     * @type {Array<TourStatusChangeNotificationConfiguration>}
     * @memberof NotificationConfiguration
     */
    tourStatusChangeNotificationConfiguration?: Array<TourStatusChangeNotificationConfiguration>;
    /**
     * 
     * @type {ClientMailCredentials}
     * @memberof NotificationConfiguration
     */
    useClientMailCredentials?: ClientMailCredentials;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfiguration
     */
    useCustomMailBodyTemplate?: string;
}

/**
 * @export
 * @namespace NotificationConfiguration
 */
export namespace NotificationConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ActiveSmsPortEnum {
        Twilio = 'Twilio',
        Spedion = 'Spedion',
        TwilioRcs = 'TwilioRcs'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SenderOfArrivalNotificationsEnum {
        BACKENDDEPRECATED = 'BACKEND_DEPRECATED',
        NOTIFICATIONWORKER = 'NOTIFICATION_WORKER'
    }
}

/**
 * 
 * @export
 * @interface Number
 */
export interface Number {
}

/**
 * 
 * @export
 * @interface Numberplate
 */
export interface Numberplate {
    /**
     * 
     * @type {string}
     * @memberof Numberplate
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Numberplate
     */
    numberplate?: string;
}

/**
 * 
 * @export
 * @interface OaiPromptListRequest
 */
export interface OaiPromptListRequest {
    /**
     * 
     * @type {string}
     * @memberof OaiPromptListRequest
     */
    flag?: OaiPromptListRequest.FlagEnum;
    /**
     * 
     * @type {Date}
     * @memberof OaiPromptListRequest
     */
    from?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof OaiPromptListRequest
     */
    hasReviews?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OaiPromptListRequest
     */
    inputContains?: string;
    /**
     * 
     * @type {string}
     * @memberof OaiPromptListRequest
     */
    model?: string;
    /**
     * 
     * @type {number}
     * @memberof OaiPromptListRequest
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof OaiPromptListRequest
     */
    take?: number;
    /**
     * 
     * @type {Date}
     * @memberof OaiPromptListRequest
     */
    till?: Date;
    /**
     * 
     * @type {string}
     * @memberof OaiPromptListRequest
     */
    type?: string;
}

/**
 * @export
 * @namespace OaiPromptListRequest
 */
export namespace OaiPromptListRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum FlagEnum {
        WRONG = 'WRONG',
        FIXED = 'FIXED',
        INTERESTING = 'INTERESTING'
    }
}

/**
 * 
 * @export
 * @interface OaiPromptListResponse
 */
export interface OaiPromptListResponse {
    /**
     * 
     * @type {Array<AiParseResult>}
     * @memberof OaiPromptListResponse
     */
    results?: Array<AiParseResult>;
}

/**
 * 
 * @export
 * @interface ObjectId
 */
export interface ObjectId {
    /**
     * 
     * @type {number}
     * @memberof ObjectId
     */
    timestamp?: number;
    /**
     * 
     * @type {number}
     * @memberof ObjectId
     */
    counter?: number;
    /**
     * 
     * @type {number}
     * @memberof ObjectId
     */
    randomValue1?: number;
    /**
     * 
     * @type {Short}
     * @memberof ObjectId
     */
    randomValue2?: Short;
}

/**
 * 
 * @export
 * @interface Observer
 */
export interface Observer {
    /**
     * Additional Information stored with this observer
     * @type {Array<AdditionalDataEntry>}
     * @memberof Observer
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * If present, allows all users of the referenced company to view this transport order.
     * @type {string}
     * @memberof Observer
     */
    companyId?: string;
    /**
     * If present, allows the user with this e-mail to view the transport order. In order to get access, an email with an private access url may be sent to this address.
     * @type {string}
     * @memberof Observer
     */
    email?: string;
    /**
     * If present, allows all users of the referenced company to view this transport order.
     * @type {string}
     * @memberof Observer
     */
    externalCompanyId?: string;
    /**
     * External Id of this observer object
     * @type {string}
     * @memberof Observer
     */
    externalObserverId?: string;
    /**
     * Enables forwarding of transport order events
     * @type {boolean}
     * @memberof Observer
     */
    forwardEventsToObservingCompany?: boolean;
    /**
     * Hides the driving lane for the observer. Last Vehicle Position is still visible
     * @type {boolean}
     * @memberof Observer
     */
    hideDrivingLane?: boolean;
    /**
     * 
     * @type {Notification}
     * @memberof Observer
     */
    notification?: Notification;
    /**
     * Notification Reference that shall be displayed to the observer
     * @type {string}
     * @memberof Observer
     */
    notificationReference?: string;
    /**
     * Id of this observer object
     * @type {string}
     * @memberof Observer
     */
    observerId?: string;
    /**
     * Limits the visibility of this transport order for the observer to the specified freight
     * @type {Array<string>}
     * @memberof Observer
     */
    onlyAtFreightIds?: Array<string>;
    /**
     * Limits the visibility of this transport order for the observer to the specified stop locations
     * @type {Array<string>}
     * @memberof Observer
     */
    onlyAtStopIds?: Array<string>;
    /**
     * If present, allows the user with this phone number to view the transport order. In order to access the transport order, an SMS message containing an access url may be sent to this phone number.
     * @type {string}
     * @memberof Observer
     */
    phoneNr?: string;
    /**
     * Language in which the observer prefers to receive notifications
     * @type {string}
     * @memberof Observer
     */
    preferredLanguage?: Observer.PreferredLanguageEnum;
    /**
     * Description if the tracking page shall show the tour view or an per shipment view. Default: per shipment view
     * @type {string}
     * @memberof Observer
     */
    trackingPageView?: Observer.TrackingPageViewEnum;
    /**
     * If present, the related user is allowed to view the transport order where this observer object is present 
     * @type {string}
     * @memberof Observer
     */
    userId?: string;
    /**
     * Verbose name, e.g. the name of the person allowed to view a transport order
     * @type {string}
     * @memberof Observer
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace Observer
 */
export namespace Observer {
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredLanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TrackingPageViewEnum {
        TOURVIEW = 'TOUR_VIEW',
        SHIPMENTVIEW = 'SHIPMENT_VIEW'
    }
}

/**
 * 
 * @export
 * @interface ObserverArrivalNotificationConfiguration
 */
export interface ObserverArrivalNotificationConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    byeTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    datetimeFormat?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    greetingTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    mailTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    smsTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    subjectTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof ObserverArrivalNotificationConfiguration
     */
    timezone?: string;
}

/**
 * 
 * @export
 * @interface ObserverCompanyContractDetails
 */
export interface ObserverCompanyContractDetails {
    /**
     * 
     * @type {boolean}
     * @memberof ObserverCompanyContractDetails
     */
    currentCompanyIsSource?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ObserverCompanyContractDetails
     */
    currentCompanyIsTarget?: boolean;
    /**
     * 
     * @type {InvoiceFilterOptions}
     * @memberof ObserverCompanyContractDetails
     */
    filter?: InvoiceFilterOptions;
    /**
     * 
     * @type {boolean}
     * @memberof ObserverCompanyContractDetails
     */
    includeAnonymousObservers?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ObserverCompanyContractDetails
     */
    includeObserverCompanyIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ObserverCompanyContractDetails
     */
    shouldCountOrders?: boolean;
}

/**
 * 
 * @export
 * @interface ObserverModalSetting
 */
export interface ObserverModalSetting {
    /**
     * 
     * @type {Array<string>}
     * @memberof ObserverModalSetting
     */
    customNotificationTriggerOptions?: Array<ObserverModalSetting.CustomNotificationTriggerOptionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ObserverModalSetting
     */
    languageOptions?: Array<ObserverModalSetting.LanguageOptionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ObserverModalSetting
     */
    triggerTypes?: Array<ObserverModalSetting.TriggerTypesEnum>;
}

/**
 * @export
 * @namespace ObserverModalSetting
 */
export namespace ObserverModalSetting {
    /**
     * @export
     * @enum {string}
     */
    export enum CustomNotificationTriggerOptionsEnum {
        OnObserverAdd = 'OnObserverAdd',
        OnTransportOrderCreate = 'OnTransportOrderCreate',
        OnTransportOrderAccept = 'OnTransportOrderAccept',
        OnTransportOrderReject = 'OnTransportOrderReject',
        OnTransportOrderDone = 'OnTransportOrderDone',
        OnTransportOrderExecuting = 'OnTransportOrderExecuting',
        OnBeginLoading = 'OnBeginLoading',
        OnFinishLoading = 'OnFinishLoading',
        OnFreightNotLoaded = 'OnFreightNotLoaded',
        OnBeginUnloading = 'OnBeginUnloading',
        OnFinishUnloading = 'OnFinishUnloading',
        OnArrive = 'OnArrive',
        WillArriveIn15min = 'WillArriveIn15min',
        WillArriveIn30min = 'WillArriveIn30min',
        OnExpectedLateArrival = 'OnExpectedLateArrival',
        OnLateArrival = 'OnLateArrival',
        RemainingDistance15km = 'RemainingDistance15km',
        RemainingDistance30km = 'RemainingDistance30km',
        RemainingDistance45km = 'RemainingDistance45km',
        OneHourBeforePlanArriveAtUnloadingLocation = 'OneHourBeforePlanArriveAtUnloadingLocation',
        OneDayBeforePlanArriveAtUnloadingLocation = 'OneDayBeforePlanArriveAtUnloadingLocation',
        RemainingDistance15kmToUnloadingLocation = 'RemainingDistance15kmToUnloadingLocation',
        RemainingDistance30kmToUnloadingLocation = 'RemainingDistance30kmToUnloadingLocation',
        RemainingDistance45kmToUnloadingLocation = 'RemainingDistance45kmToUnloadingLocation',
        WillArriveIn15minAtUnloadingLocation = 'WillArriveIn15minAtUnloadingLocation',
        WillArriveIn30minAtUnloadingLocation = 'WillArriveIn30minAtUnloadingLocation',
        OnLinkDeliveryTour = 'OnLinkDeliveryTour'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageOptionsEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TriggerTypesEnum {
        TOURVIEW = 'TOUR_VIEW',
        SHIPMENTVIEW = 'SHIPMENT_VIEW'
    }
}

/**
 * 
 * @export
 * @interface OnErrorConfiguration
 */
export interface OnErrorConfiguration {
    /**
     * 
     * @type {string}
     * @memberof OnErrorConfiguration
     */
    receiverAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OnErrorConfiguration
     */
    sendEmail?: boolean;
}

/**
 * 
 * @export
 * @interface OnlyForPartnerCompaniesEntry
 */
export interface OnlyForPartnerCompaniesEntry {
    /**
     * 
     * @type {string}
     * @memberof OnlyForPartnerCompaniesEntry
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof OnlyForPartnerCompaniesEntry
     */
    companyName?: string;
}

/**
 * 
 * @export
 * @interface OpeningHour
 */
export interface OpeningHour {
    /**
     * 
     * @type {boolean}
     * @memberof OpeningHour
     */
    closed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    day?: OpeningHour.DayEnum;
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    to?: string;
}

/**
 * @export
 * @namespace OpeningHour
 */
export namespace OpeningHour {
    /**
     * @export
     * @enum {string}
     */
    export enum DayEnum {
        MONDAY = 'MONDAY',
        TUESDAY = 'TUESDAY',
        WEDNESDAY = 'WEDNESDAY',
        THURSDAY = 'THURSDAY',
        FRIDAY = 'FRIDAY',
        SATURDAY = 'SATURDAY',
        SUNDAY = 'SUNDAY'
    }
}

/**
 * 
 * @export
 * @interface Operation
 */
export interface Operation {
    /**
     * 
     * @type {ObjectId}
     * @memberof Operation
     */
    _id?: ObjectId;
    /**
     * 
     * @type {boolean}
     * @memberof Operation
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    client?: string;
    /**
     * 
     * @type {ClientMetadata}
     * @memberof Operation
     */
    clientMetadata?: ClientMetadata;
    /**
     * 
     * @type {Any}
     * @memberof Operation
     */
    command?: Any;
    /**
     * 
     * @type {number}
     * @memberof Operation
     */
    connectionId?: number;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    currentOpTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    desc?: string;
    /**
     * 
     * @type {Array<EffectiveUser>}
     * @memberof Operation
     */
    effectiveUsers?: Array<EffectiveUser>;
    /**
     * 
     * @type {FlowControlStats}
     * @memberof Operation
     */
    flowControlStats?: FlowControlStats;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    host?: string;
    /**
     * 
     * @type {Locks}
     * @memberof Operation
     */
    locks?: Locks;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    msg?: string;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    ns?: string;
    /**
     * 
     * @type {number}
     * @memberof Operation
     */
    numYields?: number;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    op?: string;
    /**
     * 
     * @type {number}
     * @memberof Operation
     */
    opid?: number;
    /**
     * 
     * @type {number}
     * @memberof Operation
     */
    secs_running?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Operation
     */
    threaded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Operation
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Operation
     */
    waitingForFlowControl?: boolean;
    /**
     * 
     * @type {WaitingForLatch}
     * @memberof Operation
     */
    waitingForLatch?: WaitingForLatch;
    /**
     * 
     * @type {boolean}
     * @memberof Operation
     */
    waitingForLock?: boolean;
}

/**
 * 
 * @export
 * @interface OperationTime
 */
export interface OperationTime {
    /**
     * 
     * @type {Timestamp}
     * @memberof OperationTime
     */
    $timestamp?: Timestamp;
}

/**
 * 
 * @export
 * @interface OptionFieldConfiguration
 */
export interface OptionFieldConfiguration {
    /**
     * 
     * @type {string}
     * @memberof OptionFieldConfiguration
     */
    defaultValue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OptionFieldConfiguration
     */
    isReadOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OptionFieldConfiguration
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OptionFieldConfiguration
     */
    isVisible?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OptionFieldConfiguration
     */
    options?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OptionFieldConfiguration
     */
    sortIndex?: number;
}

/**
 * 
 * @export
 * @interface OrderBoxTagResponse
 */
export interface OrderBoxTagResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderBoxTagResponse
     */
    imei?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBoxTagResponse
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface OrderBoxValidationResponse
 */
export interface OrderBoxValidationResponse {
    /**
     * 
     * @type {Vehicle}
     * @memberof OrderBoxValidationResponse
     */
    assignedVehicle?: Vehicle;
    /**
     * 
     * @type {boolean}
     * @memberof OrderBoxValidationResponse
     */
    isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderBoxValidationResponse
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface OrderReference
 */
export interface OrderReference {
    /**
     * 
     * @type {string}
     * @memberof OrderReference
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReference
     */
    id?: string;
    /**
     * 
     * @type {Array<StopLocation>}
     * @memberof OrderReference
     */
    stops?: Array<StopLocation>;
}

/**
 * 
 * @export
 * @interface Origin
 */
export interface Origin {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof Origin
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    externalUserId?: string;
    /**
     * 
     * @type {LimitedAccessUserInfo}
     * @memberof Origin
     */
    limitedAccessUserInfo?: LimitedAccessUserInfo;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    source?: Origin.SourceEnum;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    systemName?: string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    systemVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace Origin
 */
export namespace Origin {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        LOGENIOSFTP = 'LOGENIOS_FTP',
        LOGENIOSWEBSITE = 'LOGENIOS_WEBSITE',
        LOGENIOSCM = 'LOGENIOS_CM',
        LOGENIOSAPPLICATION = 'LOGENIOS_APPLICATION',
        LOGENIOSBACKEND = 'LOGENIOS_BACKEND',
        LOGENIOSAPIGATEWAY = 'LOGENIOS_API_GATEWAY',
        API = 'API',
        UNSET = 'UNSET'
    }
}

/**
 * 
 * @export
 * @interface Os
 */
export interface Os {
    /**
     * 
     * @type {string}
     * @memberof Os
     */
    architecture?: string;
    /**
     * 
     * @type {string}
     * @memberof Os
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Os
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Os
     */
    version?: string;
}

/**
 * 
 * @export
 * @interface OutputAction
 */
export interface OutputAction {
    /**
     * 
     * @type {WriteFileCommand}
     * @memberof OutputAction
     */
    writeAsFile?: WriteFileCommand;
    /**
     * 
     * @type {WriteToAttachmentCommand}
     * @memberof OutputAction
     */
    writeToAttachment?: WriteToAttachmentCommand;
}

/**
 * 
 * @export
 * @interface OutputFileConfig
 */
export interface OutputFileConfig {
    /**
     * 
     * @type {string}
     * @memberof OutputFileConfig
     */
    csvSeparator?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputFileConfig
     */
    fileType?: OutputFileConfig.FileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OutputFileConfig
     */
    quoteChar?: string;
}

/**
 * @export
 * @namespace OutputFileConfig
 */
export namespace OutputFileConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum FileTypeEnum {
        XLSX = 'XLSX',
        CSV = 'CSV'
    }
}

/**
 * 
 * @export
 * @interface OutputReport
 */
export interface OutputReport {
    /**
     * 
     * @type {Array<ReportPage>}
     * @memberof OutputReport
     */
    pages?: Array<ReportPage>;
}

/**
 * 
 * @export
 * @interface OverrideTranslation
 */
export interface OverrideTranslation {
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    bg?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    cs?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    de?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    en?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    es?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    fr?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    hu?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    it?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    lt?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    nl?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    pl?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    ro?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    ru?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideTranslation
     */
    tr?: string;
}

/**
 * 
 * @export
 * @interface Packet
 */
export interface Packet {
    /**
     * List of key value pairs for storing additonal information
     * @type {Array<AdditionalDataEntry>}
     * @memberof Packet
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {AdrDescription}
     * @memberof Packet
     */
    adr?: AdrDescription;
    /**
     * Amount
     * @type {number}
     * @memberof Packet
     */
    amount?: number;
    /**
     * Additional free text comment
     * @type {string}
     * @memberof Packet
     */
    comment?: string;
    /**
     * Verbose name of the packaging
     * @type {string}
     * @memberof Packet
     */
    containmentName?: string;
    /**
     * External Verbose name of the packaging
     * @type {string}
     * @memberof Packet
     */
    containmentNameExt?: string;
    /**
     * DEPRECATED! Containment type of this package. Please use ContainmentName instead.
     * @type {string}
     * @memberof Packet
     */
    containmentType?: Packet.ContainmentTypeEnum;
    /**
     * External Packet Id.
     * @type {string}
     * @memberof Packet
     */
    externalPacketId?: string;
    /**
     * Height of the packet
     * @type {number}
     * @memberof Packet
     */
    height?: number;
    /**
     * Optional: List of item of which this package is composed
     * @type {Array<PacketItem>}
     * @memberof Packet
     */
    items?: Array<PacketItem>;
    /**
     * Length of the packet
     * @type {number}
     * @memberof Packet
     */
    length?: number;
    /**
     * Identification of the packet. Must be unique within that freight
     * @type {string}
     * @memberof Packet
     */
    packetId?: string;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Packet
     */
    totalWeight?: DoubleWithUnit;
    /**
     * Verbose name of the packet
     * @type {string}
     * @memberof Packet
     */
    verboseName?: string;
    /**
     * Weight of the packet
     * @type {number}
     * @memberof Packet
     */
    weight?: number;
    /**
     * Width of the packet
     * @type {number}
     * @memberof Packet
     */
    width?: number;
}

/**
 * @export
 * @namespace Packet
 */
export namespace Packet {
    /**
     * @export
     * @enum {string}
     */
    export enum ContainmentTypeEnum {
        EpalEurPallet = 'epalEurPallet',
        Epal2Pallet = 'epal2Pallet',
        Epal3Pallet = 'epal3Pallet',
        Epal6HalfPallet = 'epal6HalfPallet',
        Epal7HalfPallet = 'epal7HalfPallet',
        EpalBoxPallet = 'epalBoxPallet',
        ChepEuroPallet = 'chepEuroPallet',
        ChepHalfPallet = 'chepHalfPallet',
        ChepIndustrialPallet = 'chepIndustrialPallet',
        ChepPlasticEurPallet = 'chepPlasticEurPallet',
        ChepPlasticQuarterPallet = 'chepPlasticQuarterPallet',
        Pallet = 'pallet',
        PalletCollar = 'palletCollar',
        EurH1PlasticPallet = 'eurH1PlasticPallet',
        PaperSack = 'paperSack',
        InflatableBag = 'inflatableBag',
        Container20ft = 'container20ft',
        Container40ft = 'container40ft',
        Container45ft = 'container45ft',
        Container48ft = 'container48ft',
        Container53ft = 'container53ft',
        IbcContainer = 'ibcContainer',
        IntermediateBulkContainer = 'intermediateBulkContainer',
        IfcoTray = 'ifcoTray',
        SlipSheet = 'slipSheet',
        CagePallet = 'cagePallet',
        RollContainer = 'rollContainer',
        Bag = 'bag',
        Box = 'box',
        Piece = 'piece',
        Other = 'other'
    }
}

/**
 * 
 * @export
 * @interface PacketItem
 */
export interface PacketItem {
    /**
     * 
     * @type {AdrDescription}
     * @memberof PacketItem
     */
    adr?: AdrDescription;
    /**
     * 
     * @type {number}
     * @memberof PacketItem
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PacketItem
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketItem
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketItem
     */
    containmentType?: PacketItem.ContainmentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PacketItem
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof PacketItem
     */
    packetItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketItem
     */
    verboseName?: string;
    /**
     * 
     * @type {number}
     * @memberof PacketItem
     */
    weight?: number;
}

/**
 * @export
 * @namespace PacketItem
 */
export namespace PacketItem {
    /**
     * @export
     * @enum {string}
     */
    export enum ContainmentTypeEnum {
        EpalEurPallet = 'epalEurPallet',
        Epal2Pallet = 'epal2Pallet',
        Epal3Pallet = 'epal3Pallet',
        Epal6HalfPallet = 'epal6HalfPallet',
        Epal7HalfPallet = 'epal7HalfPallet',
        EpalBoxPallet = 'epalBoxPallet',
        ChepEuroPallet = 'chepEuroPallet',
        ChepHalfPallet = 'chepHalfPallet',
        ChepIndustrialPallet = 'chepIndustrialPallet',
        ChepPlasticEurPallet = 'chepPlasticEurPallet',
        ChepPlasticQuarterPallet = 'chepPlasticQuarterPallet',
        Pallet = 'pallet',
        PalletCollar = 'palletCollar',
        EurH1PlasticPallet = 'eurH1PlasticPallet',
        PaperSack = 'paperSack',
        InflatableBag = 'inflatableBag',
        Container20ft = 'container20ft',
        Container40ft = 'container40ft',
        Container45ft = 'container45ft',
        Container48ft = 'container48ft',
        Container53ft = 'container53ft',
        IbcContainer = 'ibcContainer',
        IntermediateBulkContainer = 'intermediateBulkContainer',
        IfcoTray = 'ifcoTray',
        SlipSheet = 'slipSheet',
        CagePallet = 'cagePallet',
        RollContainer = 'rollContainer',
        Bag = 'bag',
        Box = 'box',
        Piece = 'piece',
        Other = 'other'
    }
}

/**
 * 
 * @export
 * @interface PacketItemMapping
 */
export interface PacketItemMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof PacketItemMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof PacketItemMapping
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketItemMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketItemMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketItemMapping
     */
    packetItemId?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof PacketItemMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof PacketItemMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketItemMapping
     */
    weight?: string;
}

/**
 * 
 * @export
 * @interface PacketMapping
 */
export interface PacketMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof PacketMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    containmentName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PacketMapping
     */
    exportEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PacketMapping
     */
    exportLademi?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PacketMapping
     */
    exportLademiRecord?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    externalPacketId?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    lmArt?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    packetId?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof PacketMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    verboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof PacketMapping
     */
    weight?: string;
}

/**
 * 
 * @export
 * @interface PagesContainingKeywordsFilter
 */
export interface PagesContainingKeywordsFilter {
    /**
     * 
     * @type {string}
     * @memberof PagesContainingKeywordsFilter
     */
    keywordFilterMode?: PagesContainingKeywordsFilter.KeywordFilterModeEnum;
    /**
     * 
     * @type {string}
     * @memberof PagesContainingKeywordsFilter
     */
    keywordFilterStyle?: PagesContainingKeywordsFilter.KeywordFilterStyleEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PagesContainingKeywordsFilter
     */
    keywords?: Array<string>;
}

/**
 * @export
 * @namespace PagesContainingKeywordsFilter
 */
export namespace PagesContainingKeywordsFilter {
    /**
     * @export
     * @enum {string}
     */
    export enum KeywordFilterModeEnum {
        ANY = 'MATCH_ANY',
        ALL = 'MATCH_ALL'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum KeywordFilterStyleEnum {
        RETAIN = 'RETAIN',
        REMOVE = 'REMOVE'
    }
}

/**
 * 
 * @export
 * @interface Paginate
 */
export interface Paginate {
    /**
     * Query Pagination
     * @type {number}
     * @memberof Paginate
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof Paginate
     */
    skip?: number;
    /**
     * 
     * @type {string}
     * @memberof Paginate
     */
    sortBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Paginate
     */
    sortDirection?: Paginate.SortDirectionEnum;
}

/**
 * @export
 * @namespace Paginate
 */
export namespace Paginate {
    /**
     * @export
     * @enum {string}
     */
    export enum SortDirectionEnum {
        ASC = 'ASC',
        DESC = 'DESC'
    }
}

/**
 * 
 * @export
 * @interface ParseNextScheduledExecutionRequest
 */
export interface ParseNextScheduledExecutionRequest {
    /**
     * 
     * @type {Date}
     * @memberof ParseNextScheduledExecutionRequest
     */
    lastExecution?: Date;
    /**
     * 
     * @type {string}
     * @memberof ParseNextScheduledExecutionRequest
     */
    nextExecutionPrompt?: string;
}

/**
 * 
 * @export
 * @interface ParseNextScheduledExecutionResponse
 */
export interface ParseNextScheduledExecutionResponse {
    /**
     * 
     * @type {Date}
     * @memberof ParseNextScheduledExecutionResponse
     */
    nextExecution?: Date;
}

/**
 * 
 * @export
 * @interface ParseTextPublicRequest
 */
export interface ParseTextPublicRequest {
    /**
     * 
     * @type {AiProcessingSettings}
     * @memberof ParseTextPublicRequest
     */
    aiProcessingSettings?: AiProcessingSettings;
    /**
     * 
     * @type {number}
     * @memberof ParseTextPublicRequest
     */
    callTimeout?: number;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    expectedOutputFormat?: ParseTextPublicRequest.ExpectedOutputFormatEnum;
    /**
     * 
     * @type {Array<ImageInput>}
     * @memberof ParseTextPublicRequest
     */
    images?: Array<ImageInput>;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    input?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    model?: ParseTextPublicRequest.ModelEnum;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    modelSpecificResponseFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    pin?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    rawInput?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    stopSequence?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParseTextPublicRequest
     */
    stopSequenceList?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ParseTextPublicRequest
     */
    temperature?: number;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    thinkingMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextPublicRequest
     */
    type?: string;
}

/**
 * @export
 * @namespace ParseTextPublicRequest
 */
export namespace ParseTextPublicRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ExpectedOutputFormatEnum {
        ANY = 'ANY',
        JSON = 'JSON'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ModelEnum {
        LEGACY = 'LEGACY',
        GPT35 = 'GPT35',
        GPT4 = 'GPT4',
        GPT4TURBO = 'GPT4_TURBO',
        GPT4O = 'GPT4_O',
        GPT4OMini = 'GPT4_O_Mini',
        MISTRALTINY = 'MISTRAL_TINY',
        MISTRALSMALL = 'MISTRAL_SMALL',
        Claude35Sonnet = 'Claude35_Sonnet',
        DeepSeekV3 = 'DeepSeek_V3',
        Claude37Sonnet = 'Claude37_Sonnet',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        Claude4Sonnet = 'Claude4_Sonnet',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        Claude45Sonnet = 'Claude45_Sonnet',
        Claude45Haiku = 'Claude45_Haiku',
        GPT5NANO = 'GPT5_NANO',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE46SONNETTHINKING = 'CLAUDE46_SONNET_THINKING',
        CLAUDE46OPUSTHINKING = 'CLAUDE46_OPUS_THINKING',
        CLAUDE45SONNETTHINKING = 'CLAUDE45_SONNET_THINKING',
        CLAUDE45OPUSTHINKING = 'CLAUDE45_OPUS_THINKING',
        QWEN3635B = 'QWEN36_35B',
        GEMMA426B = 'GEMMA4_26B',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38 = 'QWEN38',
        QWEN38THINKING = 'QWEN38_THINKING'
    }
}

/**
 * 
 * @export
 * @interface ParseTextRequest
 */
export interface ParseTextRequest {
    /**
     * 
     * @type {AiProcessingSettings}
     * @memberof ParseTextRequest
     */
    aiProcessingSettings?: AiProcessingSettings;
    /**
     * 
     * @type {number}
     * @memberof ParseTextRequest
     */
    callTimeout?: number;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    expectedOutputFormat?: ParseTextRequest.ExpectedOutputFormatEnum;
    /**
     * 
     * @type {Array<ImageInput>}
     * @memberof ParseTextRequest
     */
    images?: Array<ImageInput>;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    input?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    model?: ParseTextRequest.ModelEnum;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    modelSpecificResponseFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    rawInput?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    stopSequence?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParseTextRequest
     */
    stopSequenceList?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ParseTextRequest
     */
    temperature?: number;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    thinkingMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextRequest
     */
    type?: string;
}

/**
 * @export
 * @namespace ParseTextRequest
 */
export namespace ParseTextRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ExpectedOutputFormatEnum {
        ANY = 'ANY',
        JSON = 'JSON'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ModelEnum {
        LEGACY = 'LEGACY',
        GPT35 = 'GPT35',
        GPT4 = 'GPT4',
        GPT4TURBO = 'GPT4_TURBO',
        GPT4O = 'GPT4_O',
        GPT4OMini = 'GPT4_O_Mini',
        MISTRALTINY = 'MISTRAL_TINY',
        MISTRALSMALL = 'MISTRAL_SMALL',
        Claude35Sonnet = 'Claude35_Sonnet',
        DeepSeekV3 = 'DeepSeek_V3',
        Claude37Sonnet = 'Claude37_Sonnet',
        GEMINI25PRO = 'GEMINI25_PRO',
        GEMINI31PRO = 'GEMINI31_PRO',
        GEMINI25FLASH = 'GEMINI25_FLASH',
        Claude4Sonnet = 'Claude4_Sonnet',
        GPT5 = 'GPT5',
        GPT5MINI = 'GPT5_MINI',
        Claude45Sonnet = 'Claude45_Sonnet',
        Claude45Haiku = 'Claude45_Haiku',
        GPT5NANO = 'GPT5_NANO',
        CLAUDE45OPUS = 'CLAUDE45_OPUS',
        CLAUDE46OPUS = 'CLAUDE46_OPUS',
        CLAUDE46SONNET = 'CLAUDE46_SONNET',
        CLAUDE46SONNETTHINKING = 'CLAUDE46_SONNET_THINKING',
        CLAUDE46OPUSTHINKING = 'CLAUDE46_OPUS_THINKING',
        CLAUDE45SONNETTHINKING = 'CLAUDE45_SONNET_THINKING',
        CLAUDE45OPUSTHINKING = 'CLAUDE45_OPUS_THINKING',
        QWEN3635B = 'QWEN36_35B',
        GEMMA426B = 'GEMMA4_26B',
        CLAUDE48OPUS = 'CLAUDE48_OPUS',
        CLAUDE48OPUSTHINKING = 'CLAUDE48_OPUS_THINKING',
        DEEPSEEKV4FLASH = 'DEEPSEEK_V4_FLASH',
        GPT56SOL = 'GPT56_SOL',
        GPT56TERRA = 'GPT56_TERRA',
        GPT56LUNA = 'GPT56_LUNA',
        QWEN38 = 'QWEN38',
        QWEN38THINKING = 'QWEN38_THINKING'
    }
}

/**
 * 
 * @export
 * @interface ParseTextResponse
 */
export interface ParseTextResponse {
    /**
     * 
     * @type {number}
     * @memberof ParseTextResponse
     */
    completionTokensNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ParseTextResponse
     */
    dataBaseEntryId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParseTextResponse
     */
    fromCache?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParseTextResponse
     */
    output?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTextResponse
     */
    thinkingMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof ParseTextResponse
     */
    totalPromptPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ParseTextResponse
     */
    usageTokensNumber?: number;
}

/**
 * 
 * @export
 * @interface ParseTransportOrderRequest
 */
export interface ParseTransportOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof ParseTransportOrderRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ParseTransportOrderRequest
     */
    prompt?: string;
    /**
     * 
     * @type {Date}
     * @memberof ParseTransportOrderRequest
     */
    scheduledTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ParseTransportOrderRequest
     */
    targetCompanyId?: string;
}

/**
 * 
 * @export
 * @interface ParseTransportOrderResponse
 */
export interface ParseTransportOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof ParseTransportOrderResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof ParseTransportOrderResponse
     */
    transportOrders?: Array<TransportOrder>;
}

/**
 * 
 * @export
 * @interface Partner
 */
export interface Partner {
    /**
     * ID of this partnership
     * @type {string}
     * @memberof Partner
     */
    _id?: string;
    /**
     * Specify whether received shipments should be automatically accepted
     * @type {boolean}
     * @memberof Partner
     */
    autoAcceptOrders?: boolean;
    /**
     *          | Specifies how to match addresses for this partnership. This setting overrides the company based setting.     
     * @type {string}
     * @memberof Partner
     */
    companyAddressMappingMatchOn?: Partner.CompanyAddressMappingMatchOnEnum;
    /**
     * Company for which the partnership is established.
     * @type {string}
     * @memberof Partner
     */
    companyId?: string;
    /**
     * Timestamp when the partnership was established
     * @type {Date}
     * @memberof Partner
     */
    creationTime?: Date;
    /**
     * List of external ids which are used to identify the partner
     * @type {Array<string>}
     * @memberof Partner
     */
    externalPartnerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Partner
     */
    freightMergeByKeys?: Array<Partner.FreightMergeByKeysEnum>;
    /**
     * Specify whether for received transport orders freights shall be merged
     * @type {boolean}
     * @memberof Partner
     */
    mergeFreights?: boolean;
    /**
     * Company to which the partnership is established
     * @type {string}
     * @memberof Partner
     */
    partnerCompanyId?: string;
    /**
     * Specify whether received shipments must be manually reviewed and accepted in order to cause side effects
     * @type {boolean}
     * @memberof Partner
     */
    requireManualReviewOfReceivedShipments?: boolean;
    /**
     * Specify whether it is allowed for the source company to preset a vehicle which will be used to execute the transport order
     * @type {boolean}
     * @memberof Partner
     */
    shouldInheritVehiclePresetByPartner?: boolean;
    /**
     * Specify wether the partner can see the real freight payer of shared transport orders
     * @type {boolean}
     * @memberof Partner
     */
    shouldShowOriginalFreightPayer?: boolean;
    /**
     * Specify wether the partner can see the real shipper of shared transport orders
     * @type {boolean}
     * @memberof Partner
     */
    shouldShowOriginalShipper?: boolean;
}

/**
 * @export
 * @namespace Partner
 */
export namespace Partner {
    /**
     * @export
     * @enum {string}
     */
    export enum CompanyAddressMappingMatchOnEnum {
        ADDRESS = 'MATCH_ADDRESS',
        STOPID = 'MATCH_STOP_ID',
        EXTERNALSTOPID = 'MATCH_EXTERNAL_STOP_ID'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FreightMergeByKeysEnum {
        CONTAINMENTTYPE = 'CONTAINMENT_TYPE',
        CONTAINMENTNAME = 'CONTAINMENT_NAME',
        VERBOSENAME = 'VERBOSE_NAME',
        LENGTH = 'LENGTH',
        WIDTH = 'WIDTH',
        HEIGHT = 'HEIGHT',
        ARTICLENUMBER = 'ARTICLE_NUMBER'
    }
}

/**
 * 
 * @export
 * @interface PartnerAccess
 */
export interface PartnerAccess {
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnerAccess
     */
    accessibleSourceCompanies?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnerAccess
     */
    accessibleTargetCompanies?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerAccess
     */
    viewUnassignedOrders?: boolean;
}

/**
 * 
 * @export
 * @interface PartnerAddRequest
 */
export interface PartnerAddRequest {
    /**
     * 
     * @type {string}
     * @memberof PartnerAddRequest
     */
    companyId?: string;
}

/**
 * 
 * @export
 * @interface PartnerCompanyWithPartnerObjects
 */
export interface PartnerCompanyWithPartnerObjects {
    /**
     * 
     * @type {Company}
     * @memberof PartnerCompanyWithPartnerObjects
     */
    company?: Company;
    /**
     * 
     * @type {Partner}
     * @memberof PartnerCompanyWithPartnerObjects
     */
    exportPartner?: Partner;
    /**
     * 
     * @type {Partner}
     * @memberof PartnerCompanyWithPartnerObjects
     */
    importPartner?: Partner;
}

/**
 * 
 * @export
 * @interface PartnerInvitation
 */
export interface PartnerInvitation {
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitedCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitedCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitedContactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitedContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitingCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitingCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitingContactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitingContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    invitingUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    randomIdToken?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitation
     */
    status?: PartnerInvitation.StatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof PartnerInvitation
     */
    timestamp?: Date;
}

/**
 * @export
 * @namespace PartnerInvitation
 */
export namespace PartnerInvitation {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        PENDING = 'PENDING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
}

/**
 * 
 * @export
 * @interface PartnerInvitationStatusUpdate
 */
export interface PartnerInvitationStatusUpdate {
    /**
     * 
     * @type {string}
     * @memberof PartnerInvitationStatusUpdate
     */
    status?: PartnerInvitationStatusUpdate.StatusEnum;
}

/**
 * @export
 * @namespace PartnerInvitationStatusUpdate
 */
export namespace PartnerInvitationStatusUpdate {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        PENDING = 'PENDING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
}

/**
 * 
 * @export
 * @interface PartnerListResponse
 */
export interface PartnerListResponse {
    /**
     * 
     * @type {number}
     * @memberof PartnerListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyWithExternalCompanyId>}
     * @memberof PartnerListResponse
     */
    partners?: Array<CompanyWithExternalCompanyId>;
}

/**
 * 
 * @export
 * @interface PartnerQueryObject
 */
export interface PartnerQueryObject {
    /**
     * 
     * @type {string}
     * @memberof PartnerQueryObject
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerQueryObject
     */
    externalPartnerId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerQueryObject
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface PartnerQueryResponse
 */
export interface PartnerQueryResponse {
    /**
     * 
     * @type {Array<PartnerQueryObject>}
     * @memberof PartnerQueryResponse
     */
    partners?: Array<PartnerQueryObject>;
}

/**
 * 
 * @export
 * @interface PartnerUsersResponse
 */
export interface PartnerUsersResponse {
    /**
     * 
     * @type {string}
     * @memberof PartnerUsersResponse
     */
    partnerId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUsersResponse
     */
    partnerName?: string;
    /**
     * 
     * @type {Array<User>}
     * @memberof PartnerUsersResponse
     */
    users?: Array<User>;
}

/**
 * 
 * @export
 * @interface PasswordChangeRequest
 */
export interface PasswordChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeRequest
     */
    currentPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeRequest
     */
    newPassword?: string;
}

/**
 * 
 * @export
 * @interface PasswordResetRequest
 */
export interface PasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    authToken?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    newPassword?: string;
}

/**
 * 
 * @export
 * @interface PasswordResetResult
 */
export interface PasswordResetResult {
    /**
     * 
     * @type {boolean}
     * @memberof PasswordResetResult
     */
    successful?: boolean;
}

/**
 * 
 * @export
 * @interface PatchEntry
 */
export interface PatchEntry {
    /**
     * 
     * @type {string}
     * @memberof PatchEntry
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchEntry
     */
    oldValue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchEntry
     */
    op?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchEntry
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchEntry
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface PatchEntryDescription
 */
export interface PatchEntryDescription {
    /**
     * 
     * @type {string}
     * @memberof PatchEntryDescription
     */
    newValue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchEntryDescription
     */
    oldValue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchEntryDescription
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchEntryDescription
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface PatchsetDescription
 */
export interface PatchsetDescription {
    /**
     * 
     * @type {Array<PatchEntryDescription>}
     * @memberof PatchsetDescription
     */
    patchEntryDescription?: Array<PatchEntryDescription>;
}

/**
 * 
 * @export
 * @interface Path
 */
export interface Path {
}

/**
 * 
 * @export
 * @interface PerformanceMetric
 */
export interface PerformanceMetric {
    /**
     * 
     * @type {number}
     * @memberof PerformanceMetric
     */
    latencyInMs?: number;
    /**
     * 
     * @type {string}
     * @memberof PerformanceMetric
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PerformanceMetric
     */
    nomadAllocationId?: string;
}

/**
 * 
 * @export
 * @interface PerformanceResponse
 */
export interface PerformanceResponse {
    /**
     * 
     * @type {Array<PerformanceMetric>}
     * @memberof PerformanceResponse
     */
    performanceMeasurements?: Array<PerformanceMetric>;
}

/**
 * 
 * @export
 * @interface PlannedArrivalNotificationConfiguration
 */
export interface PlannedArrivalNotificationConfiguration {
    /**
     * 
     * @type {string}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    byeTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    datetimeFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    greetingTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    mailTextScript?: string;
    /**
     * 
     * @type {number}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    oneDayAheadPreferredSendTime?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    oneDayAheadSkipWeekends?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    smsTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    subjectTextScript?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedArrivalNotificationConfiguration
     */
    timezone?: string;
}

/**
 * 
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {Array<number>}
     * @memberof Point
     */
    coordinates?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Point
     */
    type?: string;
}

/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    _id?: string;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    accuracy?: number;
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof Position
     */
    additionalDataEntries?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    driverId?: string;
    /**
     * 
     * @type {Date}
     * @memberof Position
     */
    externalMessageTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    externalPositionId?: string;
    /**
     * 
     * @type {Point}
     * @memberof Position
     */
    geoJsonPoint?: Point;
    /**
     * 
     * @type {boolean}
     * @memberof Position
     */
    gpsFix?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    heading?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    odometer?: number;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    orderBoxImei?: string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    orderBoxTag?: string;
    /**
     * 
     * @type {Array<ReferencedTransportOrder>}
     * @memberof Position
     */
    referencedTransportOrders?: Array<ReferencedTransportOrder>;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    source?: Position.SourceEnum;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    sourceTransportOrderId?: string;
    /**
     * Speed calculated in km/h
     * @type {number}
     * @memberof Position
     */
    speed?: number;
    /**
     * 
     * @type {Date}
     * @memberof Position
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    totalFuel?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Position
     */
    transportIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    transportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    vehicleId?: string;
    /**
     * 
     * @type {VirtualOdometer}
     * @memberof Position
     */
    virtualOdometer?: VirtualOdometer;
    /**
     * Virtual speed calculated in km/h
     * @type {number}
     * @memberof Position
     */
    virtualSpeed?: number;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Position
     */
    weight?: DoubleWithUnit;
}

/**
 * @export
 * @namespace Position
 */
export namespace Position {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        SPEDION = 'SPEDION',
        TOMTOM = 'TOMTOM',
        GPX = 'GPX',
        AIS = 'AIS',
        TRANSICS = 'TRANSICS',
        FLEETMASTER = 'FLEETMASTER',
        CUSTOMXML = 'CUSTOM_XML',
        EasyTrackMap = 'EasyTrackMap',
        FleetTech = 'FleetTech',
        ScanMedia = 'ScanMedia',
        Fleethand = 'Fleethand',
        RioTelematics = 'RioTelematics',
        TIS = 'TIS'
    }
}

/**
 * 
 * @export
 * @interface PositionEvent
 */
export interface PositionEvent {
    /**
     * 
     * @type {number}
     * @memberof PositionEvent
     */
    odometer?: number;
    /**
     * 
     * @type {AssignedOrderBox}
     * @memberof PositionEvent
     */
    orderBox?: AssignedOrderBox;
    /**
     * 
     * @type {GpsPosition}
     * @memberof PositionEvent
     */
    position?: GpsPosition;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionEvent
     */
    transportIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionEvent
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof PositionEvent
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface PositionRequest
 */
export interface PositionRequest {
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    accuracy?: number;
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof PositionRequest
     */
    additionalDataEntries?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof PositionRequest
     */
    companyId?: string;
    /**
     * 
     * @type {Driver}
     * @memberof PositionRequest
     */
    driver?: Driver;
    /**
     * 
     * @type {Date}
     * @memberof PositionRequest
     */
    externalMessageTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof PositionRequest
     */
    externalPositionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PositionRequest
     */
    gpsFix?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    heading?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    odometer?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionRequest
     */
    orderBoxImei?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionRequest
     */
    source?: PositionRequest.SourceEnum;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    speed?: number;
    /**
     * 
     * @type {Date}
     * @memberof PositionRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof PositionRequest
     */
    totalFuel?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionRequest
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof PositionRequest
     */
    vehicle?: Vehicle;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof PositionRequest
     */
    weight?: DoubleWithUnit;
}

/**
 * @export
 * @namespace PositionRequest
 */
export namespace PositionRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        SPEDION = 'SPEDION',
        TOMTOM = 'TOMTOM',
        GPX = 'GPX',
        AIS = 'AIS',
        TRANSICS = 'TRANSICS',
        FLEETMASTER = 'FLEETMASTER',
        CUSTOMXML = 'CUSTOM_XML',
        EasyTrackMap = 'EasyTrackMap',
        FleetTech = 'FleetTech',
        ScanMedia = 'ScanMedia',
        Fleethand = 'Fleethand',
        RioTelematics = 'RioTelematics',
        TIS = 'TIS'
    }
}

/**
 * 
 * @export
 * @interface PositionResponse
 */
export interface PositionResponse {
    /**
     * 
     * @type {Position}
     * @memberof PositionResponse
     */
    position?: Position;
}

/**
 * 
 * @export
 * @interface PositionTestEventRequest
 */
export interface PositionTestEventRequest {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof PositionTestEventRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {string}
     * @memberof PositionTestEventRequest
     */
    configCompanyId?: string;
    /**
     * 
     * @type {GpsPosition}
     * @memberof PositionTestEventRequest
     */
    position?: GpsPosition;
    /**
     * 
     * @type {TransportOrder}
     * @memberof PositionTestEventRequest
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof PositionTestEventRequest
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface PostAssignTargetCompanyScript
 */
export interface PostAssignTargetCompanyScript {
    /**
     * 
     * @type {boolean}
     * @memberof PostAssignTargetCompanyScript
     */
    active?: boolean;
    /**
     * If true, this script is also executed when the current company of the transport order is the source company (i.e. the script is stored in the company configuration of transportOrder.companyId).
     * @type {boolean}
     * @memberof PostAssignTargetCompanyScript
     */
    alsoRunWhenCurrentCompanyIsSourceCompany?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostAssignTargetCompanyScript
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAssignTargetCompanyScript
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAssignTargetCompanyScript
     */
    scriptIfActive?: string;
}

/**
 * 
 * @export
 * @interface PostStopEtasRequest
 */
export interface PostStopEtasRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PostStopEtasRequest
     */
    identifyByStopOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostStopEtasRequest
     */
    liveLink?: string;
    /**
     * 
     * @type {PositionRequest}
     * @memberof PostStopEtasRequest
     */
    relatedPosition?: PositionRequest;
    /**
     * 
     * @type {Date}
     * @memberof PostStopEtasRequest
     */
    relatedTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof PostStopEtasRequest
     */
    source?: PostStopEtasRequest.SourceEnum;
    /**
     * 
     * @type {Array<StopEta>}
     * @memberof PostStopEtasRequest
     */
    stopEtas?: Array<StopEta>;
}

/**
 * @export
 * @namespace PostStopEtasRequest
 */
export namespace PostStopEtasRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        PTV = 'PTV',
        GRAPHHOPPER = 'GRAPHHOPPER',
        OSRM = 'OSRM',
        COMPANY = 'COMPANY',
        NONE = 'NONE',
        ORS = 'ORS',
        CUSTOM = 'CUSTOM'
    }
}

/**
 * 
 * @export
 * @interface PreSplitPDFOptions
 */
export interface PreSplitPDFOptions {
    /**
     * 
     * @type {number}
     * @memberof PreSplitPDFOptions
     */
    creatorNameWeightExactMatch?: number;
    /**
     * 
     * @type {number}
     * @memberof PreSplitPDFOptions
     */
    creatorNameWeightSimilar?: number;
    /**
     * 
     * @type {string}
     * @memberof PreSplitPDFOptions
     */
    orderNumberNameReplacement?: string;
    /**
     * 
     * @type {number}
     * @memberof PreSplitPDFOptions
     */
    orderNumberWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof PreSplitPDFOptions
     */
    pageNumberWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof PreSplitPDFOptions
     */
    promptAdditionalInstructions?: string;
    /**
     * 
     * @type {number}
     * @memberof PreSplitPDFOptions
     */
    scoreThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof PreSplitPDFOptions
     */
    totalPagesNumberWeight?: number;
}

/**
 * 
 * @export
 * @interface PreviewReportTimeReferenceResponse
 */
export interface PreviewReportTimeReferenceResponse {
    /**
     * 
     * @type {Date}
     * @memberof PreviewReportTimeReferenceResponse
     */
    from?: Date;
    /**
     * 
     * @type {string}
     * @memberof PreviewReportTimeReferenceResponse
     */
    preview?: string;
    /**
     * 
     * @type {Date}
     * @memberof PreviewReportTimeReferenceResponse
     */
    to?: Date;
}

/**
 * 
 * @export
 * @interface PreviousConfigFieldDescription
 */
export interface PreviousConfigFieldDescription {
    /**
     * 
     * @type {string}
     * @memberof PreviousConfigFieldDescription
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviousConfigFieldDescription
     */
    fieldPath?: string;
    /**
     * 
     * @type {Date}
     * @memberof PreviousConfigFieldDescription
     */
    lastModifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PreviousConfigFieldDescription
     */
    lastModifiedBy?: string;
}

/**
 * 
 * @export
 * @interface PrivacyConfiguration
 */
export interface PrivacyConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof PrivacyConfiguration
     */
    dontFilterDriverNamesForPartners?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacyConfiguration
     */
    hidePolyineForOtherCompanies?: boolean;
}

/**
 * 
 * @export
 * @interface ProcessingDelay
 */
export interface ProcessingDelay {
    /**
     * 
     * @type {number}
     * @memberof ProcessingDelay
     */
    delayInSec?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcessingDelay
     */
    fileExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessingDelay
     */
    fileNameRegex?: string;
}

/**
 * 
 * @export
 * @interface ProcessingInfo
 */
export interface ProcessingInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProcessingInfo
     */
    exportedFiles?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProcessingInfo
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessingInfo
     */
    requestId?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcessingInfo
     */
    retryCounter?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcessingInfo
     */
    state?: ProcessingInfo.StateEnum;
    /**
     * 
     * @type {Date}
     * @memberof ProcessingInfo
     */
    timestamp?: Date;
}

/**
 * @export
 * @namespace ProcessingInfo
 */
export namespace ProcessingInfo {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        OK = 'OK',
        WARN = 'WARN',
        ERROR = 'ERROR',
        RETRY = 'RETRY'
    }
}

/**
 * 
 * @export
 * @interface ProjectWorkLogBookEntry
 */
export interface ProjectWorkLogBookEntry {
    /**
     * Identifier of this OneTimeEffort
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    _id?: string;
    /**
     * 
     * @type {ArchivingInfo}
     * @memberof ProjectWorkLogBookEntry
     */
    archived?: ArchivingInfo;
    /**
     * Timestamp when the bill was delivered to the customer
     * @type {Date}
     * @memberof ProjectWorkLogBookEntry
     */
    billedAtTime?: Date;
    /**
     * Cost of the Effort
     * @type {number}
     * @memberof ProjectWorkLogBookEntry
     */
    billingCost?: number;
    /**
     * Fixed Price or hourly rate
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    billingMode?: ProjectWorkLogBookEntry.BillingModeEnum;
    /**
     * Describes what gets billed for internal use
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    comment?: string;
    /**
     * Identifier of the billed company
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    companyId?: string;
    /**
     * Name of the billed company
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    companyName?: string;
    /**
     * Timestamp when the OneTimeEffort was created
     * @type {Date}
     * @memberof ProjectWorkLogBookEntry
     */
    createdDate?: Date;
    /**
     * Name which is shown in the billing
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    shortDescription?: string;
    /**
     * Time which was spent on this task
     * @type {number}
     * @memberof ProjectWorkLogBookEntry
     */
    timeSpentOnTask?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    userFirstName?: string;
    /**
     * Identifier of the user which created this OneTimeEffort
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectWorkLogBookEntry
     */
    userLastName?: string;
}

/**
 * @export
 * @namespace ProjectWorkLogBookEntry
 */
export namespace ProjectWorkLogBookEntry {
    /**
     * @export
     * @enum {string}
     */
    export enum BillingModeEnum {
        FixPrice = 'fixPrice',
        Hourly = 'hourly',
        Daily = 'daily'
    }
}

/**
 * 
 * @export
 * @interface ProjectWorkLogBookResponse
 */
export interface ProjectWorkLogBookResponse {
    /**
     * 
     * @type {Array<ProjectWorkLogBookEntry>}
     * @memberof ProjectWorkLogBookResponse
     */
    projectWorkLogBookEntries?: Array<ProjectWorkLogBookEntry>;
    /**
     * 
     * @type {number}
     * @memberof ProjectWorkLogBookResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface PropertyNameAndValue
 */
export interface PropertyNameAndValue {
    /**
     * 
     * @type {string}
     * @memberof PropertyNameAndValue
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyNameAndValue
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface QueryParams
 */
export interface QueryParams {
    /**
     * 
     * @type {boolean}
     * @memberof QueryParams
     */
    bypassID?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueryParams
     */
    showhidden?: boolean;
    /**
     * Query Params
     * @type {number}
     * @memberof QueryParams
     */
    timeLimit?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueryParams
     */
    wantedFields?: Array<string>;
}

/**
 * 
 * @export
 * @interface QueryRequest
 */
export interface QueryRequest {
    /**
     * 
     * @type {Paginate}
     * @memberof QueryRequest
     */
    paginate?: Paginate;
    /**
     * 
     * @type {QueryParams}
     * @memberof QueryRequest
     */
    params?: QueryParams;
    /**
     * Query Request
     * @type {string}
     * @memberof QueryRequest
     */
    query?: string;
}

/**
 * 
 * @export
 * @interface QueryResponse
 */
export interface QueryResponse {
    /**
     * 
     * @type {Array<ChangeEvent>}
     * @memberof QueryResponse
     */
    changeEvents?: Array<ChangeEvent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueryResponse
     */
    collectionWithPrivateFields?: Array<string>;
    /**
     * 
     * @type {Array<Company>}
     * @memberof QueryResponse
     */
    companies?: Array<Company>;
    /**
     * 
     * @type {Array<CompanyAddressMappingGroup>}
     * @memberof QueryResponse
     */
    companyAddressMappingGroups?: Array<CompanyAddressMappingGroup>;
    /**
     * 
     * @type {Array<CompanyAddressMapping>}
     * @memberof QueryResponse
     */
    companyAddressMappings?: Array<CompanyAddressMapping>;
    /**
     * 
     * @type {Array<CompanyConfigurationDraft>}
     * @memberof QueryResponse
     */
    companyConfigurationDraft?: Array<CompanyConfigurationDraft>;
    /**
     * 
     * @type {Array<CompanyFreightMapping>}
     * @memberof QueryResponse
     */
    companyFreightMapping?: Array<CompanyFreightMapping>;
    /**
     * 
     * @type {Array<CompanyFreightMappingGroup>}
     * @memberof QueryResponse
     */
    companyFreightMappingGroups?: Array<CompanyFreightMappingGroup>;
    /**
     * 
     * @type {Array<CompanyHistory>}
     * @memberof QueryResponse
     */
    companyHistory?: Array<CompanyHistory>;
    /**
     * 
     * @type {number}
     * @memberof QueryResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<Driver>}
     * @memberof QueryResponse
     */
    drivers?: Array<Driver>;
    /**
     * 
     * @type {Array<History>}
     * @memberof QueryResponse
     */
    history?: Array<History>;
    /**
     * 
     * @type {Array<MessageLog>}
     * @memberof QueryResponse
     */
    messageLog?: Array<MessageLog>;
    /**
     * 
     * @type {Array<Partner>}
     * @memberof QueryResponse
     */
    partners?: Array<Partner>;
    /**
     * 
     * @type {Array<Position>}
     * @memberof QueryResponse
     */
    positions?: Array<Position>;
    /**
     * 
     * @type {Array<ProjectWorkLogBookEntry>}
     * @memberof QueryResponse
     */
    projectWorkLogBookEntries?: Array<ProjectWorkLogBookEntry>;
    /**
     * 
     * @type {Array<QueuedEvent>}
     * @memberof QueryResponse
     */
    queuedEvents?: Array<QueuedEvent>;
    /**
     * 
     * @type {Array<Queue>}
     * @memberof QueryResponse
     */
    queues?: Array<Queue>;
    /**
     * 
     * @type {Array<SchedulerTaskConfig>}
     * @memberof QueryResponse
     */
    schedulerTaskConfigs?: Array<SchedulerTaskConfig>;
    /**
     * 
     * @type {Array<SystemStatusMessage>}
     * @memberof QueryResponse
     */
    systemStatusMessage?: Array<SystemStatusMessage>;
    /**
     * Query Response
     * @type {Array<TransportOrder>}
     * @memberof QueryResponse
     */
    transportOrders?: Array<TransportOrder>;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof QueryResponse
     */
    userRoles?: Array<UserRole>;
    /**
     * 
     * @type {Array<User>}
     * @memberof QueryResponse
     */
    users?: Array<User>;
    /**
     * 
     * @type {Array<Vehicle>}
     * @memberof QueryResponse
     */
    vehicles?: Array<Vehicle>;
}

/**
 * 
 * @export
 * @interface Queue
 */
export interface Queue {
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Queue
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Queue
     */
    enqueuePositionEvents?: boolean;
    /**
     * 
     * @type {EventMirroringRules}
     * @memberof Queue
     */
    mirroring?: EventMirroringRules;
    /**
     * 
     * @type {boolean}
     * @memberof Queue
     */
    mirroringEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    name?: string;
    /**
     * 
     * @type {QueueOptions}
     * @memberof Queue
     */
    options?: QueueOptions;
    /**
     * 
     * @type {Array<RateLimit>}
     * @memberof Queue
     */
    rateLimits?: Array<RateLimit>;
    /**
     * 
     * @type {EventSuppressionRules}
     * @memberof Queue
     */
    suppressionRules?: EventSuppressionRules;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    type?: Queue.TypeEnum;
}

/**
 * @export
 * @namespace Queue
 */
export namespace Queue {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        FTPSYNC = 'FTP_SYNC',
        APIGATEWAYSYNC = 'API_GATEWAY_SYNC',
        APISYNC = 'API_SYNC',
        NOTIFICATIONS = 'NOTIFICATIONS',
        ETACALCULATOR = 'ETA_CALCULATOR',
        SCRIPTRUNNER = 'SCRIPT_RUNNER'
    }
}

/**
 * 
 * @export
 * @interface QueueListResponse
 */
export interface QueueListResponse {
    /**
     * 
     * @type {Array<Queue>}
     * @memberof QueueListResponse
     */
    queues?: Array<Queue>;
}

/**
 * 
 * @export
 * @interface QueueOptions
 */
export interface QueueOptions {
    /**
     * 
     * @type {boolean}
     * @memberof QueueOptions
     */
    includeForwardDiff?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QueueOptions
     */
    redeliverUnprocessedEventsAfterSeconds?: number;
}

/**
 * 
 * @export
 * @interface QueueWithEvent
 */
export interface QueueWithEvent {
    /**
     * 
     * @type {Array<QueuedEvent>}
     * @memberof QueueWithEvent
     */
    events?: Array<QueuedEvent>;
    /**
     * 
     * @type {Queue}
     * @memberof QueueWithEvent
     */
    queue?: Queue;
}

/**
 * 
 * @export
 * @interface QueuedEvent
 */
export interface QueuedEvent {
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    _id?: string;
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof QueuedEvent
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    changeEventId?: string;
    /**
     * 
     * @type {CompanyEvent}
     * @memberof QueuedEvent
     */
    companyEvent?: CompanyEvent;
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof QueuedEvent
     */
    createdAt?: Date;
    /**
     * 
     * @type {EtaEvent}
     * @memberof QueuedEvent
     */
    etaEvent?: EtaEvent;
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    eventSourceCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    eventSourceRequestId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    eventType?: QueuedEvent.EventTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof QueuedEvent
     */
    fetchCounter?: number;
    /**
     * 
     * @type {Date}
     * @memberof QueuedEvent
     */
    lastFetchTimestamp?: Date;
    /**
     * 
     * @type {MessageLogEvent}
     * @memberof QueuedEvent
     */
    messageLogEvent?: MessageLogEvent;
    /**
     * 
     * @type {PositionEvent}
     * @memberof QueuedEvent
     */
    positionEvent?: PositionEvent;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEvent
     */
    processed?: boolean;
    /**
     * 
     * @type {ProcessingInfo}
     * @memberof QueuedEvent
     */
    processingInfo?: ProcessingInfo;
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    queueId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueuedEvent
     */
    queueType?: QueuedEvent.QueueTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEvent
     */
    rateLimited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEvent
     */
    shouldMirrorThisEvent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEvent
     */
    suppressed?: boolean;
    /**
     * 
     * @type {SystemStatusMessage}
     * @memberof QueuedEvent
     */
    systemNotificationEvent?: SystemStatusMessage;
    /**
     * 
     * @type {Date}
     * @memberof QueuedEvent
     */
    timestamp?: Date;
    /**
     * 
     * @type {TransportOrderEvent}
     * @memberof QueuedEvent
     */
    transportOrderEvent?: TransportOrderEvent;
}

/**
 * @export
 * @namespace QueuedEvent
 */
export namespace QueuedEvent {
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum QueueTypeEnum {
        FTPSYNC = 'FTP_SYNC',
        APIGATEWAYSYNC = 'API_GATEWAY_SYNC',
        APISYNC = 'API_SYNC',
        NOTIFICATIONS = 'NOTIFICATIONS',
        ETACALCULATOR = 'ETA_CALCULATOR',
        SCRIPTRUNNER = 'SCRIPT_RUNNER'
    }
}

/**
 * 
 * @export
 * @interface QueuedEventAndConfig
 */
export interface QueuedEventAndConfig {
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof QueuedEventAndConfig
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {QueuedEvent}
     * @memberof QueuedEventAndConfig
     */
    event?: QueuedEvent;
}

/**
 * 
 * @export
 * @interface QueuedEventConversionFileResult
 */
export interface QueuedEventConversionFileResult {
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionFileResult
     */
    base64Content?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventConversionFileResult
     */
    disableDeduplicator?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionFileResult
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionFileResult
     */
    fileName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventConversionFileResult
     */
    keepExactFileName?: boolean;
    /**
     * 
     * @type {OutputAction}
     * @memberof QueuedEventConversionFileResult
     */
    outputActions?: OutputAction;
}

/**
 * 
 * @export
 * @interface QueuedEventConversionResponse
 */
export interface QueuedEventConversionResponse {
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionResponse
     */
    activeConverter?: string;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionResponse
     */
    activeSpecificConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionResponse
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionResponse
     */
    logs?: string;
    /**
     * 
     * @type {Array<QueuedEventConversionFileResult>}
     * @memberof QueuedEventConversionResponse
     */
    resultFiles?: Array<QueuedEventConversionFileResult>;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionResponse
     */
    status?: QueuedEventConversionResponse.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventConversionResponse
     */
    statusMessage?: string;
}

/**
 * @export
 * @namespace QueuedEventConversionResponse
 */
export namespace QueuedEventConversionResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        OK = 'OK',
        TEMPORALFAILURE = 'TEMPORAL_FAILURE',
        PERMANENTFAILURE = 'PERMANENT_FAILURE'
    }
}

/**
 * 
 * @export
 * @interface QueuedEventResponse
 */
export interface QueuedEventResponse {
    /**
     * 
     * @type {Array<QueuedEvent>}
     * @memberof QueuedEventResponse
     */
    events?: Array<QueuedEvent>;
}

/**
 * 
 * @export
 * @interface QueuedEventStatusRequest
 */
export interface QueuedEventStatusRequest {
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventStatusRequest
     */
    processed?: boolean;
    /**
     * 
     * @type {ProcessingInfo}
     * @memberof QueuedEventStatusRequest
     */
    processingInfo?: ProcessingInfo;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventStatusRequest
     */
    rateLimited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventStatusRequest
     */
    suppressed?: boolean;
}

/**
 * 
 * @export
 * @interface QueuedEventsErrorMonitoring
 */
export interface QueuedEventsErrorMonitoring {
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventsErrorMonitoring
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof QueuedEventsErrorMonitoring
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventsErrorMonitoring
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventsErrorMonitoring
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QueuedEventsErrorMonitoring
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventsErrorMonitoring
     */
    level?: QueuedEventsErrorMonitoring.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventsErrorMonitoring
     */
    message?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueuedEventsErrorMonitoring
     */
    monitoredQueues?: Array<QueuedEventsErrorMonitoring.MonitoredQueuesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueuedEventsErrorMonitoring
     */
    monitoredStates?: Array<QueuedEventsErrorMonitoring.MonitoredStatesEnum>;
    /**
     * 
     * @type {number}
     * @memberof QueuedEventsErrorMonitoring
     */
    resetTimeInMinutes?: number;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof QueuedEventsErrorMonitoring
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof QueuedEventsErrorMonitoring
     */
    title?: string;
}

/**
 * @export
 * @namespace QueuedEventsErrorMonitoring
 */
export namespace QueuedEventsErrorMonitoring {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MonitoredQueuesEnum {
        FTPSYNC = 'FTP_SYNC',
        APIGATEWAYSYNC = 'API_GATEWAY_SYNC',
        APISYNC = 'API_SYNC',
        NOTIFICATIONS = 'NOTIFICATIONS',
        ETACALCULATOR = 'ETA_CALCULATOR',
        SCRIPTRUNNER = 'SCRIPT_RUNNER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MonitoredStatesEnum {
        OK = 'OK',
        WARN = 'WARN',
        ERROR = 'ERROR',
        RETRY = 'RETRY'
    }
}

/**
 * 
 * @export
 * @interface QueuedEventsErrorReports
 */
export interface QueuedEventsErrorReports {
    /**
     * 
     * @type {Array<CompanyQueuedEventsErrorReport>}
     * @memberof QueuedEventsErrorReports
     */
    reports?: Array<CompanyQueuedEventsErrorReport>;
}

/**
 * 
 * @export
 * @interface QueuedEventsHealthReports
 */
export interface QueuedEventsHealthReports {
    /**
     * 
     * @type {Array<CompanyQueuedEventsHealthReport>}
     * @memberof QueuedEventsHealthReports
     */
    reports?: Array<CompanyQueuedEventsHealthReport>;
}

/**
 * 
 * @export
 * @interface QueuedEventsResponse
 */
export interface QueuedEventsResponse {
    /**
     * 
     * @type {number}
     * @memberof QueuedEventsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<QueuedEvent>}
     * @memberof QueuedEventsResponse
     */
    events?: Array<QueuedEvent>;
}

/**
 * 
 * @export
 * @interface RateLimit
 */
export interface RateLimit {
    /**
     * 
     * @type {boolean}
     * @memberof RateLimit
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RateLimit
     */
    eventType?: RateLimit.EventTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RateLimit
     */
    limitInSeconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RateLimit
     */
    setProcessed?: boolean;
}

/**
 * @export
 * @namespace RateLimit
 */
export namespace RateLimit {
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
}

/**
 * 
 * @export
 * @interface RawRequest
 */
export interface RawRequest {
    /**
     * 
     * @type {string}
     * @memberof RawRequest
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof RawRequest
     */
    companyId?: string;
    /**
     * 
     * @type {HarRequest}
     * @memberof RawRequest
     */
    harRequest?: HarRequest;
    /**
     * 
     * @type {Date}
     * @memberof RawRequest
     */
    timeOfAttempt?: Date;
    /**
     * 
     * @type {User}
     * @memberof RawRequest
     */
    user?: User;
    /**
     * 
     * @type {string}
     * @memberof RawRequest
     */
    xRequestId?: string;
}

/**
 * 
 * @export
 * @interface RawRequestsResponse
 */
export interface RawRequestsResponse {
    /**
     * 
     * @type {number}
     * @memberof RawRequestsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<RawRequest>}
     * @memberof RawRequestsResponse
     */
    requests?: Array<RawRequest>;
}

/**
 * 
 * @export
 * @interface RecommendTopTicketsRequest
 */
export interface RecommendTopTicketsRequest {
    /**
     * 
     * @type {Array<ScoredTicket>}
     * @memberof RecommendTopTicketsRequest
     */
    tickets?: Array<ScoredTicket>;
}

/**
 * 
 * @export
 * @interface RecommendTopTicketsResponse
 */
export interface RecommendTopTicketsResponse {
    /**
     * 
     * @type {Array<TopTicketRecommendation>}
     * @memberof RecommendTopTicketsResponse
     */
    recommendations?: Array<TopTicketRecommendation>;
}

/**
 * 
 * @export
 * @interface RecoverHistoryEntryRequest
 */
export interface RecoverHistoryEntryRequest {
    /**
     * 
     * @type {History}
     * @memberof RecoverHistoryEntryRequest
     */
    entry?: History;
}

/**
 * 
 * @export
 * @interface RecoverHistoryEntryResponse
 */
export interface RecoverHistoryEntryResponse {
    /**
     * 
     * @type {Any}
     * @memberof RecoverHistoryEntryResponse
     */
    recoveredObject?: Any;
    /**
     * 
     * @type {boolean}
     * @memberof RecoverHistoryEntryResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface ReferencedTransportOrder
 */
export interface ReferencedTransportOrder {
    /**
     * 
     * @type {string}
     * @memberof ReferencedTransportOrder
     */
    transporOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedTransportOrder
     */
    transportId?: string;
}

/**
 * 
 * @export
 * @interface RegisterUserData
 */
export interface RegisterUserData {
    /**
     * 
     * @type {string}
     * @memberof RegisterUserData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserData
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserData
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserData
     */
    password?: string;
}

/**
 * 
 * @export
 * @interface Registration
 */
export interface Registration {
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    _id?: string;
    /**
     * 
     * @type {RegisterUserData}
     * @memberof Registration
     */
    adminUser?: RegisterUserData;
    /**
     * 
     * @type {Company}
     * @memberof Registration
     */
    company?: Company;
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    invitationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    ip4AddressString?: string;
    /**
     * 
     * @type {Date}
     * @memberof Registration
     */
    registrationTime?: Date;
}

/**
 * 
 * @export
 * @interface RelationStats
 */
export interface RelationStats {
    /**
     * 
     * @type {TimeStats}
     * @memberof RelationStats
     */
    arrivalDelay?: TimeStats;
    /**
     * 
     * @type {TimeStats}
     * @memberof RelationStats
     */
    departureDelay?: TimeStats;
    /**
     * 
     * @type {TimeStats}
     * @memberof RelationStats
     */
    loadingTime?: TimeStats;
    /**
     * 
     * @type {TimeStats}
     * @memberof RelationStats
     */
    plannedTimeAtLocation?: TimeStats;
    /**
     * 
     * @type {TimeStats}
     * @memberof RelationStats
     */
    timeAtLocation?: TimeStats;
    /**
     * 
     * @type {TimeStats}
     * @memberof RelationStats
     */
    unloadingTime?: TimeStats;
}

/**
 * 
 * @export
 * @interface RelativeDateRangeSpec
 */
export interface RelativeDateRangeSpec {
    /**
     * 
     * @type {string}
     * @memberof RelativeDateRangeSpec
     */
    anchor?: RelativeDateRangeSpec.AnchorEnum;
    /**
     * 
     * @type {string}
     * @memberof RelativeDateRangeSpec
     */
    endBoundary?: RelativeDateRangeSpec.EndBoundaryEnum;
    /**
     * 
     * @type {string}
     * @memberof RelativeDateRangeSpec
     */
    endLocalTime?: string;
    /**
     * 
     * @type {number}
     * @memberof RelativeDateRangeSpec
     */
    endOffsetDays?: number;
    /**
     * 
     * @type {string}
     * @memberof RelativeDateRangeSpec
     */
    startBoundary?: RelativeDateRangeSpec.StartBoundaryEnum;
    /**
     * 
     * @type {string}
     * @memberof RelativeDateRangeSpec
     */
    startLocalTime?: string;
    /**
     * 
     * @type {number}
     * @memberof RelativeDateRangeSpec
     */
    startOffsetDays?: number;
}

/**
 * @export
 * @namespace RelativeDateRangeSpec
 */
export namespace RelativeDateRangeSpec {
    /**
     * @export
     * @enum {string}
     */
    export enum AnchorEnum {
        TODAY = 'TODAY'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum EndBoundaryEnum {
        STARTOFDAY = 'START_OF_DAY',
        ENDOFDAY = 'END_OF_DAY'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StartBoundaryEnum {
        STARTOFDAY = 'START_OF_DAY',
        ENDOFDAY = 'END_OF_DAY'
    }
}

/**
 * 
 * @export
 * @interface RelativeTimeReference
 */
export interface RelativeTimeReference {
    /**
     * 
     * @type {string}
     * @memberof RelativeTimeReference
     */
    base?: RelativeTimeReference.BaseEnum;
    /**
     * 
     * @type {Array<TimeOffset>}
     * @memberof RelativeTimeReference
     */
    offsets?: Array<TimeOffset>;
}

/**
 * @export
 * @namespace RelativeTimeReference
 */
export namespace RelativeTimeReference {
    /**
     * @export
     * @enum {string}
     */
    export enum BaseEnum {
        NOW = 'NOW',
        STARTOFDAY = 'START_OF_DAY',
        STARTOFWEEK = 'START_OF_WEEK',
        STARTOFMONTH = 'START_OF_MONTH',
        ENDOFDAY = 'END_OF_DAY',
        ENDOFWEEK = 'END_OF_WEEK',
        ENDOFMONTH = 'END_OF_MONTH'
    }
}

/**
 * 
 * @export
 * @interface ReplaceCompanyAddressMappingRequest
 */
export interface ReplaceCompanyAddressMappingRequest {
    /**
     * 
     * @type {Array<CompanyAddressMapping>}
     * @memberof ReplaceCompanyAddressMappingRequest
     */
    entries?: Array<CompanyAddressMapping>;
    /**
     * 
     * @type {string}
     * @memberof ReplaceCompanyAddressMappingRequest
     */
    groupId?: string;
}

/**
 * 
 * @export
 * @interface ReplaceCompanyFreightMappingRequest
 */
export interface ReplaceCompanyFreightMappingRequest {
    /**
     * 
     * @type {Array<CompanyFreightMapping>}
     * @memberof ReplaceCompanyFreightMappingRequest
     */
    entries?: Array<CompanyFreightMapping>;
    /**
     * 
     * @type {string}
     * @memberof ReplaceCompanyFreightMappingRequest
     */
    groupId?: string;
}

/**
 * 
 * @export
 * @interface ReplaceCompanyTransportOrderMappingRequest
 */
export interface ReplaceCompanyTransportOrderMappingRequest {
    /**
     * 
     * @type {Array<CompanyTransportOrderMapping>}
     * @memberof ReplaceCompanyTransportOrderMappingRequest
     */
    entries?: Array<CompanyTransportOrderMapping>;
    /**
     * 
     * @type {string}
     * @memberof ReplaceCompanyTransportOrderMappingRequest
     */
    groupId?: string;
}

/**
 * 
 * @export
 * @interface ReplacementAddress
 */
export interface ReplacementAddress {
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    externalStopId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    houseNr?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    name1?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementAddress
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface ReplayGeoStatusTestDataRequest
 */
export interface ReplayGeoStatusTestDataRequest {
    /**
     * 
     * @type {string}
     * @memberof ReplayGeoStatusTestDataRequest
     */
    dump?: string;
}

/**
 * 
 * @export
 * @interface ReplayGeoStatusTestDataResponse
 */
export interface ReplayGeoStatusTestDataResponse {
    /**
     * 
     * @type {Array<TransportOrderWithPolyline>}
     * @memberof ReplayGeoStatusTestDataResponse
     */
    ordersWithPolyline?: Array<TransportOrderWithPolyline>;
}

/**
 * 
 * @export
 * @interface ReportCell
 */
export interface ReportCell {
    /**
     * 
     * @type {string}
     * @memberof ReportCell
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportCell
     */
    stringContent?: string;
}

/**
 * 
 * @export
 * @interface ReportDeviationModalConfiguration
 */
export interface ReportDeviationModalConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ReportDeviationModalConfiguration
     */
    allowPartialFreightDelivery?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportDeviationModalConfiguration
     */
    defaultTimeForEndActionInput?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportDeviationModalConfiguration
     */
    defaultTimeForStartActionInput?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportDeviationModalConfiguration
     */
    freightAccordionTitleFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDeviationModalConfiguration
     */
    modalLayout?: ReportDeviationModalConfiguration.ModalLayoutEnum;
    /**
     * 
     * @type {MobileWebAppPodConfiguration}
     * @memberof ReportDeviationModalConfiguration
     */
    pod?: MobileWebAppPodConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDeviationModalConfiguration
     */
    showFinishActionTimestampInput?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDeviationModalConfiguration
     */
    showFreightStatusEditTable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDeviationModalConfiguration
     */
    showReciprocalLocation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDeviationModalConfiguration
     */
    showStartActionTimestampInput?: boolean;
}

/**
 * @export
 * @namespace ReportDeviationModalConfiguration
 */
export namespace ReportDeviationModalConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModalLayoutEnum {
        TABLE = 'FREIGHT_TABLE',
        ACCORDEON = 'FREIGHT_ACCORDEON'
    }
}

/**
 * 
 * @export
 * @interface ReportGenerationStats
 */
export interface ReportGenerationStats {
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    companyName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportGenerationStats
     */
    emailReceivers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    generatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    generatedByUserEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    generatedByUserId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReportGenerationStats
     */
    generationTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    generationType?: ReportGenerationStats.GenerationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    reportName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    reportType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReportGenerationStats
     */
    sentByEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportGenerationStats
     */
    uploadedToFtp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportGenerationStats
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace ReportGenerationStats
 */
export namespace ReportGenerationStats {
    /**
     * @export
     * @enum {string}
     */
    export enum GenerationTypeEnum {
        MANUAL = 'MANUAL',
        AUTO = 'AUTO'
    }
}

/**
 * 
 * @export
 * @interface ReportGenerationStatsResponse
 */
export interface ReportGenerationStatsResponse {
    /**
     * 
     * @type {Array<ReportGenerationStats>}
     * @memberof ReportGenerationStatsResponse
     */
    stats?: Array<ReportGenerationStats>;
    /**
     * 
     * @type {number}
     * @memberof ReportGenerationStatsResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface ReportPage
 */
export interface ReportPage {
    /**
     * 
     * @type {Array<ReportRow>}
     * @memberof ReportPage
     */
    dataLines?: Array<ReportRow>;
    /**
     * 
     * @type {Array<ReportCell>}
     * @memberof ReportPage
     */
    header?: Array<ReportCell>;
    /**
     * 
     * @type {string}
     * @memberof ReportPage
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface ReportRow
 */
export interface ReportRow {
    /**
     * 
     * @type {Array<ReportCell>}
     * @memberof ReportRow
     */
    cells?: Array<ReportCell>;
    /**
     * 
     * @type {string}
     * @memberof ReportRow
     */
    color?: string;
}

/**
 * 
 * @export
 * @interface ReportTimeReference
 */
export interface ReportTimeReference {
    /**
     * 
     * @type {RelativeTimeReference}
     * @memberof ReportTimeReference
     */
    from?: RelativeTimeReference;
    /**
     * 
     * @type {RelativeTimeReference}
     * @memberof ReportTimeReference
     */
    to?: RelativeTimeReference;
}

/**
 * 
 * @export
 * @interface RequestResponseLog
 */
export interface RequestResponseLog {
    /**
     * 
     * @type {string}
     * @memberof RequestResponseLog
     */
    inputHash?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestResponseLog
     */
    inputPayload?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestResponseLog
     */
    iteration?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestResponseLog
     */
    outputPayload?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestResponseLog
     */
    promptType?: RequestResponseLog.PromptTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RequestResponseLog
     */
    promptVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof RequestResponseLog
     */
    timestamp?: Date;
}

/**
 * @export
 * @namespace RequestResponseLog
 */
export namespace RequestResponseLog {
    /**
     * @export
     * @enum {string}
     */
    export enum PromptTypeEnum {
        GETDOCUMENTATION = 'GET_DOCUMENTATION',
        EXECUTESCRIPTANDRETURNLOGS = 'EXECUTE_SCRIPT_AND_RETURN_LOGS',
        GETJSON = 'GET_JSON',
        GETUSERADDITIONALINFO = 'GET_USER_ADDITIONAL_INFO',
        GETINITIALSCRIPTANDINITIALLOGS = 'GET_INITIAL_SCRIPT_AND_INITIAL_LOGS',
        REQUESTUSERTOMANUALLYVERIFYOUTPUT = 'REQUEST_USER_TO_MANUALLY_VERIFY_OUTPUT'
    }
}

/**
 * 
 * @export
 * @interface RequiredUserInputData
 */
export interface RequiredUserInputData {
    /**
     * 
     * @type {string}
     * @memberof RequiredUserInputData
     */
    addressMappingMatchMode?: RequiredUserInputData.AddressMappingMatchModeEnum;
    /**
     * 
     * @type {CompanyFreightMappingGroup}
     * @memberof RequiredUserInputData
     */
    missingFreightMappingGroup?: CompanyFreightMappingGroup;
    /**
     * 
     * @type {CompanyTransportOrderMappingGroup}
     * @memberof RequiredUserInputData
     */
    missingShipmentMappingGroup?: CompanyTransportOrderMappingGroup;
    /**
     * 
     * @type {Array<CompanyTransportOrderMapping>}
     * @memberof RequiredUserInputData
     */
    missingShipmentMappings?: Array<CompanyTransportOrderMapping>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequiredUserInputData
     */
    requiredStatusInput?: Array<RequiredUserInputData.RequiredStatusInputEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof RequiredUserInputData
     */
    userDidConfirm?: boolean;
}

/**
 * @export
 * @namespace RequiredUserInputData
 */
export namespace RequiredUserInputData {
    /**
     * @export
     * @enum {string}
     */
    export enum AddressMappingMatchModeEnum {
        ADDRESS = 'MATCH_ADDRESS',
        STOPID = 'MATCH_STOP_ID',
        EXTERNALSTOPID = 'MATCH_EXTERNAL_STOP_ID'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RequiredStatusInputEnum {
        TIMESTAMPARRIVED = 'TIMESTAMP_ARRIVED',
        TIMESTAMPDEPARTED = 'TIMESTAMP_DEPARTED',
        TIMESTAMPLOADED = 'TIMESTAMP_LOADED',
        TIMESTAMPUNLOADING = 'TIMESTAMP_UNLOADING',
        TIMESTAMPNOTLOADED = 'TIMESTAMP_NOT_LOADED',
        TIMESTAMPREJECTED = 'TIMESTAMP_REJECTED',
        TIMESTAMPDELIVERED = 'TIMESTAMP_DELIVERED',
        TIMESTAMPADVISED = 'TIMESTAMP_ADVISED',
        TIMESTAMPCANCELED = 'TIMESTAMP_CANCELED',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        VEHICLESHOULDPROVIDEGPSDATA = 'VEHICLE_SHOULD_PROVIDE_GPS_DATA',
        REQUIRELINKEDTRANSPORTORDER = 'REQUIRE_LINKED_TRANSPORT_ORDER',
        REQUIREATTACHMENT = 'REQUIRE_ATTACHMENT',
        REQUIREWORKFLOWFIELD = 'REQUIRE_WORKFLOW_FIELD',
        REQUIRESTATUS = 'REQUIRE_STATUS'
    }
}

/**
 * 
 * @export
 * @interface ResidenceTime
 */
export interface ResidenceTime {
    /**
     * 
     * @type {Date}
     * @memberof ResidenceTime
     */
    arrivedTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ResidenceTime
     */
    departedTimestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof ResidenceTime
     */
    diffBetweenMeanTimeAndSearchMeanTimeInMinutes?: number;
    /**
     * 
     * @type {Date}
     * @memberof ResidenceTime
     */
    meanTime?: Date;
    /**
     * 
     * @type {Position}
     * @memberof ResidenceTime
     */
    positionArrival?: Position;
    /**
     * 
     * @type {Position}
     * @memberof ResidenceTime
     */
    positionDeparture?: Position;
    /**
     * 
     * @type {number}
     * @memberof ResidenceTime
     */
    residenceTimeInSeconds?: number;
    /**
     * 
     * @type {Date}
     * @memberof ResidenceTime
     */
    searchWindowMeanTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ResidenceTime
     */
    vehicleNotDepartedYet?: boolean;
}

/**
 * 
 * @export
 * @interface ResidenceTimesResult
 */
export interface ResidenceTimesResult {
    /**
     * 
     * @type {Array<VehicleResidenceTime>}
     * @memberof ResidenceTimesResult
     */
    vehicleResidenceTimes?: Array<VehicleResidenceTime>;
}

/**
 * 
 * @export
 * @interface ResolveCustomerAddressMappingBatchRequest
 */
export interface ResolveCustomerAddressMappingBatchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolveCustomerAddressMappingBatchRequest
     */
    transportOrderIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface ResolveCustomerAddressMappingBatchResponse
 */
export interface ResolveCustomerAddressMappingBatchResponse {
    /**
     * 
     * @type {Array<ResolveCustomerAddressMappingResult>}
     * @memberof ResolveCustomerAddressMappingBatchResponse
     */
    results?: Array<ResolveCustomerAddressMappingResult>;
}

/**
 * 
 * @export
 * @interface ResolveCustomerAddressMappingResult
 */
export interface ResolveCustomerAddressMappingResult {
    /**
     * 
     * @type {string}
     * @memberof ResolveCustomerAddressMappingResult
     */
    errorMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResolveCustomerAddressMappingResult
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResolveCustomerAddressMappingResult
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface Result
 */
export interface Result {
    /**
     * 
     * @type {boolean}
     * @memberof Result
     */
    result?: boolean;
}

/**
 * 
 * @export
 * @interface ReviewPageConfiguration
 */
export interface ReviewPageConfiguration {
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof ReviewPageConfiguration
     */
    additionalColums?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {Array<AttachmentCategoriesToBeProcessed>}
     * @memberof ReviewPageConfiguration
     */
    attachmentCategoriesToBeProcessed?: Array<AttachmentCategoriesToBeProcessed>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    attachmentCategoryColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    attachmentLevelColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {TransportOrderLevelSelector}
     * @memberof ReviewPageConfiguration
     */
    attachmentLevels?: TransportOrderLevelSelector;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    canBeTargetCompany?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReviewPageConfiguration
     */
    canSetTourToDone?: ReviewPageConfiguration.CanSetTourToDoneEnum;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    externalTransportOrderIdColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    externalUserIdColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    invoiceColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    loadingLocationCityColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    loadingLocationColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    planStartColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    rejectionReasonColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {string}
     * @memberof ReviewPageConfiguration
     */
    reminderEmailFooterText?: ReviewPageConfiguration.ReminderEmailFooterTextEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    removeTourFromListOnAccept?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    removeTourFromListOnDone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    removeTourFromListOnReject?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    retainExpandedRowsState?: boolean;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    shipmentNumberColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    showInvoiceReminderButtonWhenInvoiceMissing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    showOnlyToursWithAssignedDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    showRejectedAttachmentsTab?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReviewPageConfiguration
     */
    startDate?: Date;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    targetCompanyColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {string}
     * @memberof ReviewPageConfiguration
     */
    toBeProcessedColumnMode?: ReviewPageConfiguration.ToBeProcessedColumnModeEnum;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    totalWeightColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    trailerNumberplateColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    transferStatusColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    unloadingLocationCityColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    unloadingLocationColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewPageConfiguration
     */
    useNotificationReferenceAsTourNr?: boolean;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof ReviewPageConfiguration
     */
    vehicleNumberplateColumn?: FieldViewConfiguration;
}

/**
 * @export
 * @namespace ReviewPageConfiguration
 */
export namespace ReviewPageConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum CanSetTourToDoneEnum {
        ANYTIME = 'ANYTIME',
        ATLEASTONEATTACHMENTPERLEVEL = 'AT_LEAST_ONE_ATTACHMENT_PER_LEVEL'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReminderEmailFooterTextEnum {
        NONE = 'NONE',
        DEFAULT = 'DEFAULT',
        StatusChangeMailFooter = 'StatusChangeMailFooter'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ToBeProcessedColumnModeEnum {
        HASATTACHMENT = 'HAS_ATTACHMENT',
        NOMISSINGATTACHMENT = 'NO_MISSING_ATTACHMENT',
        ONLYATTACHMENTSWITHCREATEDSTATUS = 'ONLY_ATTACHMENTS_WITH_CREATED_STATUS'
    }
}

/**
 * 
 * @export
 * @interface RolesOfUserRequest
 */
export interface RolesOfUserRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RolesOfUserRequest
     */
    roles?: Array<string>;
}

/**
 * 
 * @export
 * @interface RollbackTransportOrderRequest
 */
export interface RollbackTransportOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof RollbackTransportOrderRequest
     */
    changeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RollbackTransportOrderRequest
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface RollbackTransportOrderResponse
 */
export interface RollbackTransportOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof RollbackTransportOrderResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RollbackTransportOrderResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface RouteInformation
 */
export interface RouteInformation {
    /**
     * Actual total toll amount in EUR, calculated from the truck's real waypoints when the tour is done
     * @type {number}
     * @memberof RouteInformation
     */
    actualTollAmount?: number;
    /**
     * Actual toll relevant kilometers, calculated from the truck's real waypoints
     * @type {number}
     * @memberof RouteInformation
     */
    actualTollKilometer?: number;
    /**
     * Actual TOTAL driven kilometers (toll + non-toll) from the toll engine; used as a fallback for Tour-KM when odometer data is missing
     * @type {number}
     * @memberof RouteInformation
     */
    actualTotalKilometer?: number;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof RouteInformation
     */
    consumedFuel?: DoubleWithUnit;
    /**
     * Toll in EUR for the deadhead run (Leerfahrt) driven from the previous tour's last stop to this tour's first stop
     * @type {number}
     * @memberof RouteInformation
     */
    deadheadTollAmount?: number;
    /**
     * Toll relevant kilometers driven deadhead (Leerfahrt) from the previous tour's last stop to this tour's first stop
     * @type {number}
     * @memberof RouteInformation
     */
    deadheadTollKilometer?: number;
    /**
     * Expected total toll amount in EUR, calculated from the planned stops
     * @type {number}
     * @memberof RouteInformation
     */
    expectedTollAmount?: number;
    /**
     * Expected toll relevant kilometers, calculated from the planned stops
     * @type {number}
     * @memberof RouteInformation
     */
    expectedTollKilometer?: number;
    /**
     * List of all the distances between stops in the order as they were driven
     * @type {Array<StopDistanceInfo>}
     * @memberof RouteInformation
     */
    stopDistanceInfo?: Array<StopDistanceInfo>;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof RouteInformation
     */
    traveledDistance?: DoubleWithUnit;
    /**
     * Maximum odometer reading, taken from the last stop visited by the truck
     * @type {number}
     * @memberof RouteInformation
     */
    traveledDistanceMaxOdometer?: number;
    /**
     * Minimum odometer reading, taken from the first stop visited by the truck
     * @type {number}
     * @memberof RouteInformation
     */
    traveledDistanceMinOdometer?: number;
    /**
     * 
     * @type {AdjacentTourOnVehicleInfo}
     * @memberof RouteInformation
     */
    vehicleLastTourInfo?: AdjacentTourOnVehicleInfo;
    /**
     * 
     * @type {AdjacentTourOnVehicleInfo}
     * @memberof RouteInformation
     */
    vehicleNextTourInfo?: AdjacentTourOnVehicleInfo;
}

/**
 * 
 * @export
 * @interface RouteOptimizerRequest
 */
export interface RouteOptimizerRequest {
    /**
     * 
     * @type {string}
     * @memberof RouteOptimizerRequest
     */
    mode?: RouteOptimizerRequest.ModeEnum;
    /**
     * 
     * @type {number}
     * @memberof RouteOptimizerRequest
     */
    mustDeliverPercentage?: number;
    /**
     * 
     * @type {Array<Shipment>}
     * @memberof RouteOptimizerRequest
     */
    shipments?: Array<Shipment>;
}

/**
 * @export
 * @namespace RouteOptimizerRequest
 */
export namespace RouteOptimizerRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        OrToolsVRP = 'OrToolsVRP',
        LogeniosVRP = 'LogeniosVRP'
    }
}

/**
 * 
 * @export
 * @interface RunTransportOrderStatusValidationsRequest
 */
export interface RunTransportOrderStatusValidationsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RunTransportOrderStatusValidationsRequest
     */
    toIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RunTransportOrderStatusValidationsRequest
     */
    writeToDb?: boolean;
}

/**
 * 
 * @export
 * @interface SFTPDownloadDirectoryMapping
 */
export interface SFTPDownloadDirectoryMapping {
    /**
     * 
     * @type {string}
     * @memberof SFTPDownloadDirectoryMapping
     */
    destination?: SFTPDownloadDirectoryMapping.DestinationEnum;
    /**
     * 
     * @type {string}
     * @memberof SFTPDownloadDirectoryMapping
     */
    fileExtension?: string;
}

/**
 * @export
 * @namespace SFTPDownloadDirectoryMapping
 */
export namespace SFTPDownloadDirectoryMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum DestinationEnum {
        Customer2Logenios = 'Customer2Logenios',
        Attachment2Logenios = 'Attachment2Logenios',
        Telematic2Logenios = 'Telematic2Logenios'
    }
}

/**
 * 
 * @export
 * @interface SFTPSyncConfiguration
 */
export interface SFTPSyncConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SFTPSyncConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    configName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SFTPSyncConfiguration
     */
    deleteDownloadedFiles?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    downloadFileFilter?: string;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    downloadFileNameTag?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SFTPSyncConfiguration
     */
    downloadFilesFromFtp?: boolean;
    /**
     * 
     * @type {Array<SFTPDownloadDirectoryMapping>}
     * @memberof SFTPSyncConfiguration
     */
    fileDownloadDirectoryMapping?: Array<SFTPDownloadDirectoryMapping>;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    fileFilter?: string;
    /**
     * 
     * @type {AdvancedFtpsOptions}
     * @memberof SFTPSyncConfiguration
     */
    ftpsOptions?: AdvancedFtpsOptions;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    privateKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    protocol?: SFTPSyncConfiguration.ProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    publicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    remoteMachine?: string;
    /**
     * 
     * @type {number}
     * @memberof SFTPSyncConfiguration
     */
    remotePort?: number;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    remoteSourceDir?: string;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    remoteTargetDir?: string;
    /**
     * 
     * @type {number}
     * @memberof SFTPSyncConfiguration
     */
    syncIntervalInSec?: number;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    uploadFileFilter?: string;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    uploadFilesToFtp?: SFTPSyncConfiguration.UploadFilesToFtpEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SFTPSyncConfiguration
     */
    uploadSubdirectories?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SFTPSyncConfiguration
     */
    username?: string;
}

/**
 * @export
 * @namespace SFTPSyncConfiguration
 */
export namespace SFTPSyncConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ProtocolEnum {
        SSH = 'SSH',
        FTPS = 'FTPS',
        INSECUREFTP = 'INSECURE_FTP'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum UploadFilesToFtpEnum {
        Off = 'Off',
        TraceOnly = 'TraceOnly',
        NoTrace = 'NoTrace',
        On = 'On'
    }
}

/**
 * 
 * @export
 * @interface SapAdditionalDataMapping
 */
export interface SapAdditionalDataMapping {
    /**
     * 
     * @type {string}
     * @memberof SapAdditionalDataMapping
     */
    logeniosKeyName?: string;
    /**
     * 
     * @type {string}
     * @memberof SapAdditionalDataMapping
     */
    sapKeyName?: string;
}

/**
 * 
 * @export
 * @interface SapAddressImportConfiguration
 */
export interface SapAddressImportConfiguration {
    /**
     * 
     * @type {SapContractingPartyImportConfiguration}
     * @memberof SapAddressImportConfiguration
     */
    contractingParty?: SapContractingPartyImportConfiguration;
    /**
     * 
     * @type {SapDispatcherUserImportConfiguration}
     * @memberof SapAddressImportConfiguration
     */
    dispatcherUser?: SapDispatcherUserImportConfiguration;
    /**
     * 
     * @type {SapObserverImportConfiguration}
     * @memberof SapAddressImportConfiguration
     */
    observer?: SapObserverImportConfiguration;
    /**
     * 
     * @type {SapStopLocationImportConfiguration}
     * @memberof SapAddressImportConfiguration
     */
    stopLocation?: SapStopLocationImportConfiguration;
    /**
     * 
     * @type {SapTargetCompanyImportConfiguration}
     * @memberof SapAddressImportConfiguration
     */
    targetCompany?: SapTargetCompanyImportConfiguration;
}

/**
 * 
 * @export
 * @interface SapCompanySpecificConfiguration
 */
export interface SapCompanySpecificConfiguration {
    /**
     * 
     * @type {SapCompanySpecificConfigurationApplyRules}
     * @memberof SapCompanySpecificConfiguration
     */
    applyWhenAll?: SapCompanySpecificConfigurationApplyRules;
    /**
     * 
     * @type {SapConverterConfigurationOverride}
     * @memberof SapCompanySpecificConfiguration
     */
    override?: SapConverterConfigurationOverride;
    /**
     * 
     * @type {string}
     * @memberof SapCompanySpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface SapCompanySpecificConfigurationApplyRules
 */
export interface SapCompanySpecificConfigurationApplyRules {
    /**
     * 
     * @type {boolean}
     * @memberof SapCompanySpecificConfigurationApplyRules
     */
    onConversionToExternalFormat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SapCompanySpecificConfigurationApplyRules
     */
    onConversionToTransportOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SapCompanySpecificConfigurationApplyRules
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof SapCompanySpecificConfigurationApplyRules
     */
    sourceCompanyId?: string;
}

/**
 * 
 * @export
 * @interface SapContractingPartyImportConfiguration
 */
export interface SapContractingPartyImportConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SapContractingPartyImportConfiguration
     */
    role?: SapContractingPartyImportConfiguration.RoleEnum;
}

/**
 * @export
 * @namespace SapContractingPartyImportConfiguration
 */
export namespace SapContractingPartyImportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        FREIGHTPAYER = 'FREIGHT_PAYER',
        SHIPPER = 'SHIPPER',
        RECEIVER = 'RECEIVER',
        CUSTOMER = 'CUSTOMER',
        CARRIER = 'CARRIER',
        LOGENIOSSOURCECOMPANY = 'LOGENIOS_SOURCE_COMPANY',
        LOGENIOSVIACOMPANY = 'LOGENIOS_VIA_COMPANY',
        LOGENIOSTARGETCOMPANY = 'LOGENIOS_TARGET_COMPANY'
    }
}

/**
 * 
 * @export
 * @interface SapConverterConfiguration
 */
export interface SapConverterConfiguration {
    /**
     * 
     * @type {Array<Edl12ToAdditionalDataMapping>}
     * @memberof SapConverterConfiguration
     */
    edl12ToAdditionalDataMapping?: Array<Edl12ToAdditionalDataMapping>;
    /**
     * 
     * @type {SapConverterExportOptions}
     * @memberof SapConverterConfiguration
     */
    _export?: SapConverterExportOptions;
    /**
     * 
     * @type {string}
     * @memberof SapConverterConfiguration
     */
    fileEncoding?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterConfiguration
     */
    format?: SapConverterConfiguration.FormatEnum;
    /**
     * 
     * @type {SapFreightMapping}
     * @memberof SapConverterConfiguration
     */
    freightMapping?: SapFreightMapping;
    /**
     * 
     * @type {string}
     * @memberof SapConverterConfiguration
     */
    importMode?: SapConverterConfiguration.ImportModeEnum;
    /**
     * 
     * @type {SapPacketMapping}
     * @memberof SapConverterConfiguration
     */
    packetMapping?: SapPacketMapping;
    /**
     * 
     * @type {Array<SapPartnerQualifierMapping>}
     * @memberof SapConverterConfiguration
     */
    partnerQualifierMapping?: Array<SapPartnerQualifierMapping>;
    /**
     * 
     * @type {SapConverterScripts}
     * @memberof SapConverterConfiguration
     */
    script?: SapConverterScripts;
    /**
     * 
     * @type {Array<SapCompanySpecificConfiguration>}
     * @memberof SapConverterConfiguration
     */
    specificConfiguration?: Array<SapCompanySpecificConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof SapConverterConfiguration
     */
    stopIdHandling?: SapConverterConfiguration.StopIdHandlingEnum;
    /**
     * 
     * @type {Array<SapTextRecordMapping>}
     * @memberof SapConverterConfiguration
     */
    textRecordMapping?: Array<SapTextRecordMapping>;
}

/**
 * @export
 * @namespace SapConverterConfiguration
 */
export namespace SapConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum FormatEnum {
        SHIPMENT = 'SHIPMENT',
        DELIVERY = 'DELIVERY'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ImportModeEnum {
        EDL = 'EDL',
        EDK = 'EDK',
        EDLWITHEDKFALLBACK = 'EDL_WITH_EDK_FALLBACK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StopIdHandlingEnum {
        ADDRESSHASH = 'ADDRESS_HASH',
        SAPPARTNERNR = 'SAP_PARTNER_NR',
        TRANSPORTIDPLUSCOUNTER = 'TRANSPORT_ID_PLUS_COUNTER'
    }
}

/**
 * 
 * @export
 * @interface SapConverterConfigurationOverride
 */
export interface SapConverterConfigurationOverride {
    /**
     * 
     * @type {Array<Edl12ToAdditionalDataMapping>}
     * @memberof SapConverterConfigurationOverride
     */
    edl12ToAdditionalDataMapping?: Array<Edl12ToAdditionalDataMapping>;
    /**
     * 
     * @type {SapConverterExportOptions}
     * @memberof SapConverterConfigurationOverride
     */
    _export?: SapConverterExportOptions;
    /**
     * 
     * @type {SapFreightMapping}
     * @memberof SapConverterConfigurationOverride
     */
    freightMapping?: SapFreightMapping;
    /**
     * 
     * @type {Array<SapPartnerQualifierMapping>}
     * @memberof SapConverterConfigurationOverride
     */
    partnerQualifierMapping?: Array<SapPartnerQualifierMapping>;
    /**
     * 
     * @type {SapConverterScripts}
     * @memberof SapConverterConfigurationOverride
     */
    script?: SapConverterScripts;
    /**
     * 
     * @type {string}
     * @memberof SapConverterConfigurationOverride
     */
    stopIdHandling?: SapConverterConfigurationOverride.StopIdHandlingEnum;
    /**
     * 
     * @type {Array<SapTextRecordMapping>}
     * @memberof SapConverterConfigurationOverride
     */
    textRecordMapping?: Array<SapTextRecordMapping>;
}

/**
 * @export
 * @namespace SapConverterConfigurationOverride
 */
export namespace SapConverterConfigurationOverride {
    /**
     * @export
     * @enum {string}
     */
    export enum StopIdHandlingEnum {
        ADDRESSHASH = 'ADDRESS_HASH',
        SAPPARTNERNR = 'SAP_PARTNER_NR',
        TRANSPORTIDPLUSCOUNTER = 'TRANSPORT_ID_PLUS_COUNTER'
    }
}

/**
 * 
 * @export
 * @interface SapConverterExportOptions
 */
export interface SapConverterExportOptions {
    /**
     * 
     * @type {SapConverterTransportOrderEventExportOptions}
     * @memberof SapConverterExportOptions
     */
    transportOrderEvent?: SapConverterTransportOrderEventExportOptions;
}

/**
 * 
 * @export
 * @interface SapConverterScripts
 */
export interface SapConverterScripts {
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    edl20RetoureDetectionScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    edl24ExtensionHandlerScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    postImportEDL20Script?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    postImportEDT20Script?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    postImportFreightScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    postImportStopLocationScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    postImportTransportOrderScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    postImportTransportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    preExportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    preImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    preImportTransportOrderScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SapConverterScripts
     */
    preImportTransportScript?: string;
}

/**
 * 
 * @export
 * @interface SapConverterTransportOrderEventExportOptions
 */
export interface SapConverterTransportOrderEventExportOptions {
    /**
     * 
     * @type {SapIdocHeader}
     * @memberof SapConverterTransportOrderEventExportOptions
     */
    idocHeader?: SapIdocHeader;
    /**
     * 
     * @type {string}
     * @memberof SapConverterTransportOrderEventExportOptions
     */
    postExportScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SapConverterTransportOrderEventExportOptions
     */
    shouldExportAsSoap?: boolean;
}

/**
 * 
 * @export
 * @interface SapDateTimeQualifier
 */
export interface SapDateTimeQualifier {
    /**
     * 
     * @type {string}
     * @memberof SapDateTimeQualifier
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof SapDateTimeQualifier
     */
    qualifier?: string;
}

/**
 * 
 * @export
 * @interface SapDispatcherUserImportConfiguration
 */
export interface SapDispatcherUserImportConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SapDispatcherUserImportConfiguration
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface SapFreightMapping
 */
export interface SapFreightMapping {
    /**
     * 
     * @type {string}
     * @memberof SapFreightMapping
     */
    freightImportSource?: SapFreightMapping.FreightImportSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof SapFreightMapping
     */
    postImportScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SapFreightMapping
     */
    restoreFreightPacketHierarchy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SapFreightMapping
     */
    weightSource?: SapFreightMapping.WeightSourceEnum;
}

/**
 * @export
 * @namespace SapFreightMapping
 */
export namespace SapFreightMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum FreightImportSourceEnum {
        EDL24 = 'EDL24',
        EDL37 = 'EDL37',
        EDL37WithEDL24Fallback = 'EDL37_With_EDL24_Fallback',
        EDL37WithEDL24Merge = 'EDL37_With_EDL24_Merge'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WeightSourceEnum {
        BRUTTOWEIGHT = 'BRUTTO_WEIGHT',
        NETTOWEIGHT = 'NETTO_WEIGHT'
    }
}

/**
 * 
 * @export
 * @interface SapIdocHeader
 */
export interface SapIdocHeader {
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    direct?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    docrel?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    mandant?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    outmod?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    receiverPfc?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    receiverPor?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    receiverPrn?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    receiverPrt?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    senderPor?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    senderPrn?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    senderPrt?: string;
    /**
     * 
     * @type {string}
     * @memberof SapIdocHeader
     */
    status?: string;
}

/**
 * 
 * @export
 * @interface SapObserverImportConfiguration
 */
export interface SapObserverImportConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SapObserverImportConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SapObserverImportConfiguration
     */
    enabledIfReture?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SapObserverImportConfiguration
     */
    notificationReference?: SapObserverImportConfiguration.NotificationReferenceEnum;
    /**
     * 
     * @type {Array<SapObserverTriggerValue>}
     * @memberof SapObserverImportConfiguration
     */
    notificationTrigger?: Array<SapObserverTriggerValue>;
}

/**
 * @export
 * @namespace SapObserverImportConfiguration
 */
export namespace SapObserverImportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum NotificationReferenceEnum {
        TRANSPORTNR = 'TRANSPORT_NR',
        SHIPMENTNR = 'SHIPMENT_NR',
        TRANSPORTANDSHIPMENTNR = 'TRANSPORT_AND_SHIPMENT_NR',
        CUSTOMERPURCHASEORDERNR = 'CUSTOMER_PURCHASE_ORDER_NR'
    }
}

/**
 * 
 * @export
 * @interface SapObserverTriggerValue
 */
export interface SapObserverTriggerValue {
    /**
     * 
     * @type {string}
     * @memberof SapObserverTriggerValue
     */
    trigger?: SapObserverTriggerValue.TriggerEnum;
}

/**
 * @export
 * @namespace SapObserverTriggerValue
 */
export namespace SapObserverTriggerValue {
    /**
     * @export
     * @enum {string}
     */
    export enum TriggerEnum {
        OnObserverAdd = 'OnObserverAdd',
        OnTransportOrderCreate = 'OnTransportOrderCreate',
        OnTransportOrderAccept = 'OnTransportOrderAccept',
        OnTransportOrderReject = 'OnTransportOrderReject',
        OnTransportOrderDone = 'OnTransportOrderDone',
        OnTransportOrderExecuting = 'OnTransportOrderExecuting',
        OnBeginLoading = 'OnBeginLoading',
        OnFinishLoading = 'OnFinishLoading',
        OnFreightNotLoaded = 'OnFreightNotLoaded',
        OnBeginUnloading = 'OnBeginUnloading',
        OnFinishUnloading = 'OnFinishUnloading',
        OnArrive = 'OnArrive',
        WillArriveIn15min = 'WillArriveIn15min',
        WillArriveIn30min = 'WillArriveIn30min',
        OnExpectedLateArrival = 'OnExpectedLateArrival',
        OnLateArrival = 'OnLateArrival',
        RemainingDistance15km = 'RemainingDistance15km',
        RemainingDistance30km = 'RemainingDistance30km',
        RemainingDistance45km = 'RemainingDistance45km',
        OneHourBeforePlanArriveAtUnloadingLocation = 'OneHourBeforePlanArriveAtUnloadingLocation',
        OneDayBeforePlanArriveAtUnloadingLocation = 'OneDayBeforePlanArriveAtUnloadingLocation',
        RemainingDistance15kmToUnloadingLocation = 'RemainingDistance15kmToUnloadingLocation',
        RemainingDistance30kmToUnloadingLocation = 'RemainingDistance30kmToUnloadingLocation',
        RemainingDistance45kmToUnloadingLocation = 'RemainingDistance45kmToUnloadingLocation',
        WillArriveIn15minAtUnloadingLocation = 'WillArriveIn15minAtUnloadingLocation',
        WillArriveIn30minAtUnloadingLocation = 'WillArriveIn30minAtUnloadingLocation',
        OnLinkDeliveryTour = 'OnLinkDeliveryTour'
    }
}

/**
 * 
 * @export
 * @interface SapPacketMapping
 */
export interface SapPacketMapping {
    /**
     * 
     * @type {string}
     * @memberof SapPacketMapping
     */
    postImportScript?: string;
}

/**
 * 
 * @export
 * @interface SapPartnerQualifierMapping
 */
export interface SapPartnerQualifierMapping {
    /**
     * 
     * @type {string}
     * @memberof SapPartnerQualifierMapping
     */
    addressKind?: string;
    /**
     * 
     * @type {string}
     * @memberof SapPartnerQualifierMapping
     */
    fallbackQualifier?: string;
    /**
     * 
     * @type {SapAddressImportConfiguration}
     * @memberof SapPartnerQualifierMapping
     */
    importAs?: SapAddressImportConfiguration;
    /**
     * 
     * @type {string}
     * @memberof SapPartnerQualifierMapping
     */
    laufK?: string;
    /**
     * 
     * @type {string}
     * @memberof SapPartnerQualifierMapping
     */
    qualifier?: string;
    /**
     * 
     * @type {string}
     * @memberof SapPartnerQualifierMapping
     */
    qualifierSourceField?: string;
}

/**
 * 
 * @export
 * @interface SapStopLocationImportConfiguration
 */
export interface SapStopLocationImportConfiguration {
    /**
     * 
     * @type {Array<SapAdditionalDataMapping>}
     * @memberof SapStopLocationImportConfiguration
     */
    additionalDataMapping?: Array<SapAdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof SapStopLocationImportConfiguration
     */
    kind?: SapStopLocationImportConfiguration.KindEnum;
    /**
     * 
     * @type {number}
     * @memberof SapStopLocationImportConfiguration
     */
    mergeAndOrderKeyWithinTransport?: number;
    /**
     * 
     * @type {string}
     * @memberof SapStopLocationImportConfiguration
     */
    retureKind?: SapStopLocationImportConfiguration.RetureKindEnum;
    /**
     * 
     * @type {string}
     * @memberof SapStopLocationImportConfiguration
     */
    retureVerboseName?: string;
    /**
     * 
     * @type {Array<SapDateTimeQualifier>}
     * @memberof SapStopLocationImportConfiguration
     */
    timeWindow?: Array<SapDateTimeQualifier>;
    /**
     * 
     * @type {string}
     * @memberof SapStopLocationImportConfiguration
     */
    transportSubKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SapStopLocationImportConfiguration
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace SapStopLocationImportConfiguration
 */
export namespace SapStopLocationImportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RetureKindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
}

/**
 * 
 * @export
 * @interface SapTargetCompanyImportConfiguration
 */
export interface SapTargetCompanyImportConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SapTargetCompanyImportConfiguration
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface SapTextRecordMapping
 */
export interface SapTextRecordMapping {
    /**
     * 
     * @type {string}
     * @memberof SapTextRecordMapping
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof SapTextRecordMapping
     */
    languageIso?: string;
    /**
     * 
     * @type {string}
     * @memberof SapTextRecordMapping
     */
    tdId?: string;
    /**
     * 
     * @type {string}
     * @memberof SapTextRecordMapping
     */
    tdObject?: string;
}

/**
 * 
 * @export
 * @interface SaveConfigAsDraftRequest
 */
export interface SaveConfigAsDraftRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveConfigAsDraftRequest
     */
    autoSaved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveConfigAsDraftRequest
     */
    companyId?: string;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof SaveConfigAsDraftRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {string}
     * @memberof SaveConfigAsDraftRequest
     */
    draftName?: string;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof SaveConfigAsDraftRequest
     */
    oldConfig?: CompanyConfiguration;
}

/**
 * 
 * @export
 * @interface SaveConfigAsDraftResponse
 */
export interface SaveConfigAsDraftResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SaveConfigAsDraftResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface SaveConfigFieldDescriptionRequest
 */
export interface SaveConfigFieldDescriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveConfigFieldDescriptionRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveConfigFieldDescriptionRequest
     */
    fieldPath?: string;
}

/**
 * 
 * @export
 * @interface SaveConfigFieldDescriptionResponse
 */
export interface SaveConfigFieldDescriptionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SaveConfigFieldDescriptionResponse
     */
    successful?: boolean;
}

/**
 * 
 * @export
 * @interface SaveContractRequest
 */
export interface SaveContractRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveContractRequest
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveContractRequest
     */
    companyId?: string;
    /**
     * 
     * @type {Contract}
     * @memberof SaveContractRequest
     */
    newContract?: Contract;
    /**
     * 
     * @type {Contract}
     * @memberof SaveContractRequest
     */
    oldContract?: Contract;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveContractRequest
     */
    ticketNrs?: Array<string>;
}

/**
 * 
 * @export
 * @interface SaveContractResponse
 */
export interface SaveContractResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SaveContractResponse
     */
    successful?: boolean;
}

/**
 * 
 * @export
 * @interface SaveSystemStatusMessagesResponse
 */
export interface SaveSystemStatusMessagesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveSystemStatusMessagesResponse
     */
    createdSystemStatusMessages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SaveSystemStatusMessagesResponse
     */
    error?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveSystemStatusMessagesResponse
     */
    finishedSystemStatusMessages?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSystemStatusMessagesResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface SaveTransportOrderConfigTestRequest
 */
export interface SaveTransportOrderConfigTestRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveTransportOrderConfigTestRequest
     */
    companyId?: string;
    /**
     * 
     * @type {ExpectedResult}
     * @memberof SaveTransportOrderConfigTestRequest
     */
    expectedResult?: ExpectedResult;
    /**
     * 
     * @type {TransportOrderConfigTestInput}
     * @memberof SaveTransportOrderConfigTestRequest
     */
    input?: TransportOrderConfigTestInput;
    /**
     * 
     * @type {TransportOrderConfigTestOptions}
     * @memberof SaveTransportOrderConfigTestRequest
     */
    options?: TransportOrderConfigTestOptions;
    /**
     * 
     * @type {string}
     * @memberof SaveTransportOrderConfigTestRequest
     */
    testName?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveTransportOrderConfigTestRequest
     */
    type?: SaveTransportOrderConfigTestRequest.TypeEnum;
}

/**
 * @export
 * @namespace SaveTransportOrderConfigTestRequest
 */
export namespace SaveTransportOrderConfigTestRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        IMPORT = 'IMPORT',
        EXPORT = 'EXPORT'
    }
}

/**
 * 
 * @export
 * @interface ScheduledOrderCreationRule
 */
export interface ScheduledOrderCreationRule {
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderCreationRule
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderCreationRule
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderCreationRule
     */
    creationRulePrompt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledOrderCreationRule
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderCreationRule
     */
    genericAiPrompt?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledOrderCreationRule
     */
    lastExecution?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledOrderCreationRule
     */
    lastSuccessfulExecution?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledOrderCreationRule
     */
    nextExecution?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderCreationRule
     */
    ruleName?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderCreationRule
     */
    state?: ScheduledOrderCreationRule.StateEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduledOrderCreationRule
     */
    targetCompanyId?: string;
    /**
     * 
     * @type {Throwable}
     * @memberof ScheduledOrderCreationRule
     */
    throwable?: Throwable;
}

/**
 * @export
 * @namespace ScheduledOrderCreationRule
 */
export namespace ScheduledOrderCreationRule {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        SUCCESS = 'SUCCESS',
        RUNNING = 'RUNNING',
        FAILED = 'FAILED'
    }
}

/**
 * 
 * @export
 * @interface SchedulerConfig
 */
export interface SchedulerConfig {
    /**
     * 
     * @type {string}
     * @memberof SchedulerConfig
     */
    _id?: string;
    /**
     * 
     * @type {number}
     * @memberof SchedulerConfig
     */
    checkIntervalInSeconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerConfig
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface SchedulerConfigs
 */
export interface SchedulerConfigs {
    /**
     * 
     * @type {Array<SchedulerConfig>}
     * @memberof SchedulerConfigs
     */
    configs?: Array<SchedulerConfig>;
}

/**
 * 
 * @export
 * @interface SchedulerFinishTaskConfiguration
 */
export interface SchedulerFinishTaskConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerFinishTaskConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerFinishTaskConfiguration
     */
    checkAllVehicles?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SchedulerFinishTaskConfiguration
     */
    daysToFix?: number;
    /**
     * 
     * @type {number}
     * @memberof SchedulerFinishTaskConfiguration
     */
    finishTransportOrdersBySchedulerAfterHours?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerFinishTaskConfiguration
     */
    fixMissingTimesInDoneTransportOrders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerFinishTaskConfiguration
     */
    fixOriginalTransportOrder?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SchedulerFinishTaskConfiguration
     */
    hardFinishTransportOrderAfterHours?: number;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerFinishTaskConfiguration
     */
    onlyTransportOrdersWithPlannedArrivalAfter?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerFinishTaskConfiguration
     */
    skipFixedTransportOrders?: boolean;
}

/**
 * 
 * @export
 * @interface SchedulerReportingConfiguration
 */
export interface SchedulerReportingConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    errorMessage?: string;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerReportingConfiguration
     */
    lastExecution?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerReportingConfiguration
     */
    nextExecution?: Date;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    reportName?: SchedulerReportingConfiguration.ReportNameEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace SchedulerReportingConfiguration
 */
export namespace SchedulerReportingConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportNameEnum {
        ELFLEINVDLREPORT = 'ELFLEIN_VDL_REPORT',
        ELFLEINVDLERRORREPORT = 'ELFLEIN_VDL_ERROR_REPORT',
        REPORTV2 = 'REPORT_V2',
        STANDINGTIMESREPORT = 'STANDING_TIMES_REPORT',
        DELIVERYREPORT = 'DELIVERY_REPORT'
    }
}

/**
 * 
 * @export
 * @interface SchedulerReportingConfigurationsResponse
 */
export interface SchedulerReportingConfigurationsResponse {
    /**
     * 
     * @type {Array<SchedulerReportingConfiguration>}
     * @memberof SchedulerReportingConfigurationsResponse
     */
    configurations?: Array<SchedulerReportingConfiguration>;
    /**
     * 
     * @type {number}
     * @memberof SchedulerReportingConfigurationsResponse
     */
    count?: number;
}

/**
 * 
 * @export
 * @interface SchedulerReportingPeriodicity
 */
export interface SchedulerReportingPeriodicity {
    /**
     * 
     * @type {number}
     * @memberof SchedulerReportingPeriodicity
     */
    days?: number;
    /**
     * 
     * @type {number}
     * @memberof SchedulerReportingPeriodicity
     */
    hours?: number;
    /**
     * 
     * @type {number}
     * @memberof SchedulerReportingPeriodicity
     */
    minutes?: number;
    /**
     * 
     * @type {number}
     * @memberof SchedulerReportingPeriodicity
     */
    months?: number;
    /**
     * 
     * @type {number}
     * @memberof SchedulerReportingPeriodicity
     */
    seconds?: number;
}

/**
 * 
 * @export
 * @interface SchedulerReportingTaskStateResponse
 */
export interface SchedulerReportingTaskStateResponse {
    /**
     * 
     * @type {Array<SchedulerReportingConfiguration>}
     * @memberof SchedulerReportingTaskStateResponse
     */
    schedulerReportingTaskState?: Array<SchedulerReportingConfiguration>;
}

/**
 * 
 * @export
 * @interface SchedulerTaskConfig
 */
export interface SchedulerTaskConfig {
    /**
     * 
     * @type {string}
     * @memberof SchedulerTaskConfig
     */
    _id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerTaskConfig
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SchedulerTaskConfig
     */
    intervalInSeconds?: number;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerTaskConfig
     */
    lastAliveSignal?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerTaskConfig
     */
    lastRun?: Date;
    /**
     * 
     * @type {string}
     * @memberof SchedulerTaskConfig
     */
    lastXRequestId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerTaskConfig
     */
    nextRun?: Date;
    /**
     * 
     * @type {string}
     * @memberof SchedulerTaskConfig
     */
    nodeName?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerTaskConfig
     */
    state?: SchedulerTaskConfig.StateEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulerTaskConfig
     */
    taskName?: SchedulerTaskConfig.TaskNameEnum;
    /**
     * 
     * @type {Throwable}
     * @memberof SchedulerTaskConfig
     */
    throwable?: Throwable;
}

/**
 * @export
 * @namespace SchedulerTaskConfig
 */
export namespace SchedulerTaskConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        STARTED = 'STARTED',
        SUCCESS = 'SUCCESS',
        DEAD = 'DEAD',
        FAILED = 'FAILED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TaskNameEnum {
        CleanOldSharesOfSingleTour = 'CleanOldSharesOfSingleTour',
        CheckDbConsistency = 'CheckDbConsistency',
        FinishUncompletedGeoStatusTours = 'FinishUncompletedGeoStatusTours',
        MissingStatusMessageEmail = 'MissingStatusMessageEmail',
        ObserverArrivalNotificationTask = 'ObserverArrivalNotificationTask',
        DelayedArrivalNotificationTask = 'DelayedArrivalNotificationTask',
        ArrivalNotificationTask = 'ArrivalNotificationTask',
        CleanOldDataSetsTask = 'CleanOldDataSetsTask',
        SchedulerHealtCheck = 'SchedulerHealtCheck',
        SchedulerReportingTask = 'SchedulerReportingTask',
        FinishToursTask = 'FinishToursTask',
        CompanyLevelMonitoringTask = 'CompanyLevelMonitoringTask',
        MailgunFailMonitorTask = 'MailgunFailMonitorTask',
        SendStatusValidationMails = 'SendStatusValidationMails',
        SmsMonitoringTask = 'SmsMonitoringTask',
        DailyPartnerCollabReportTask = 'DailyPartnerCollabReportTask',
        ResendFailedMessagesTask = 'ResendFailedMessagesTask',
        EtaQualityReportTask = 'EtaQualityReportTask',
        OrderCreationTask = 'OrderCreationTask',
        SmsTimeoutNotificationTask = 'SmsTimeoutNotificationTask'
    }
}

/**
 * 
 * @export
 * @interface SchedulerTaskConfigs
 */
export interface SchedulerTaskConfigs {
    /**
     * 
     * @type {Array<SchedulerTaskConfig>}
     * @memberof SchedulerTaskConfigs
     */
    configs?: Array<SchedulerTaskConfig>;
}

/**
 * 
 * @export
 * @interface ScoredTicket
 */
export interface ScoredTicket {
    /**
     * 
     * @type {number}
     * @memberof ScoredTicket
     */
    iid?: number;
    /**
     * 
     * @type {Array<ScoredTicketLabel>}
     * @memberof ScoredTicket
     */
    labelDetails?: Array<ScoredTicketLabel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScoredTicket
     */
    labels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScoredTicket
     */
    recentComments?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ScoredTicket
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof ScoredTicket
     */
    state?: string;
    /**
     * 
     * @type {number}
     * @memberof ScoredTicket
     */
    ticketId?: number;
    /**
     * 
     * @type {string}
     * @memberof ScoredTicket
     */
    ticketName?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoredTicket
     */
    ticketText?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoredTicket
     */
    webUrl?: string;
}

/**
 * 
 * @export
 * @interface ScoredTicketLabel
 */
export interface ScoredTicketLabel {
    /**
     * 
     * @type {string}
     * @memberof ScoredTicketLabel
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoredTicketLabel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoredTicketLabel
     */
    textColor?: string;
}

/**
 * 
 * @export
 * @interface ScoredUnassignedTicketsResponse
 */
export interface ScoredUnassignedTicketsResponse {
    /**
     * 
     * @type {Array<ScoredTicket>}
     * @memberof ScoredUnassignedTicketsResponse
     */
    tickets?: Array<ScoredTicket>;
}

/**
 * 
 * @export
 * @interface ScriptChange
 */
export interface ScriptChange {
    /**
     * 
     * @type {string}
     * @memberof ScriptChange
     */
    newLine?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptChange
     */
    originalLine?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptChange
     */
    type?: ScriptChange.TypeEnum;
}

/**
 * @export
 * @namespace ScriptChange
 */
export namespace ScriptChange {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        ADDED = 'ADDED',
        REMOVED = 'REMOVED',
        MODIFIED = 'MODIFIED'
    }
}

/**
 * 
 * @export
 * @interface ScriptErrorLogAddedResponse
 */
export interface ScriptErrorLogAddedResponse {
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogAddedResponse
     */
    errorLogId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScriptErrorLogAddedResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface ScriptErrorLogEntry
 */
export interface ScriptErrorLogEntry {
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogEntry
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogEntry
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogEntry
     */
    config?: string;
    /**
     * 
     * @type {ScriptErrorLoggerDecodedConverterResponse}
     * @memberof ScriptErrorLogEntry
     */
    converterResponseObjectDecoded?: ScriptErrorLoggerDecodedConverterResponse;
    /**
     * 
     * @type {number}
     * @memberof ScriptErrorLogEntry
     */
    converterResponseStatus?: number;
    /**
     * 
     * @type {Date}
     * @memberof ScriptErrorLogEntry
     */
    createdAt?: Date;
    /**
     * 
     * @type {AlgoResult}
     * @memberof ScriptErrorLogEntry
     */
    dummyAlgoResults?: AlgoResult;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScriptErrorLogEntry
     */
    logs?: Array<string>;
    /**
     * 
     * @type {QueuedEvent}
     * @memberof ScriptErrorLogEntry
     */
    queuedEvent?: QueuedEvent;
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogEntry
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogEntry
     */
    scriptPath?: string;
    /**
     * 
     * @type {AlgoResult}
     * @memberof ScriptErrorLogEntry
     */
    slimAlgoResults?: AlgoResult;
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogEntry
     */
    testType?: ScriptErrorLogEntry.TestTypeEnum;
    /**
     * 
     * @type {User}
     * @memberof ScriptErrorLogEntry
     */
    user?: User;
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLogEntry
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace ScriptErrorLogEntry
 */
export namespace ScriptErrorLogEntry {
    /**
     * @export
     * @enum {string}
     */
    export enum TestTypeEnum {
        IMPORT = 'IMPORT',
        EXPORT = 'EXPORT'
    }
}

/**
 * 
 * @export
 * @interface ScriptErrorLogResponse
 */
export interface ScriptErrorLogResponse {
    /**
     * 
     * @type {Array<ScriptErrorLogEntry>}
     * @memberof ScriptErrorLogResponse
     */
    errorLogs?: Array<ScriptErrorLogEntry>;
    /**
     * 
     * @type {number}
     * @memberof ScriptErrorLogResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface ScriptErrorLoggerDecodedConverterResponse
 */
export interface ScriptErrorLoggerDecodedConverterResponse {
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLoggerDecodedConverterResponse
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptErrorLoggerDecodedConverterResponse
     */
    text?: string;
}

/**
 * 
 * @export
 * @interface ScriptErrorLoggerRequest
 */
export interface ScriptErrorLoggerRequest {
    /**
     * 
     * @type {ScriptErrorLogEntry}
     * @memberof ScriptErrorLoggerRequest
     */
    entry?: ScriptErrorLogEntry;
}

/**
 * 
 * @export
 * @interface ScriptRunnerConfiguration
 */
export interface ScriptRunnerConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ScriptRunnerConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {Array<ScriptRunnerCronJob>}
     * @memberof ScriptRunnerConfiguration
     */
    cronJobs?: Array<ScriptRunnerCronJob>;
    /**
     * 
     * @type {string}
     * @memberof ScriptRunnerConfiguration
     */
    onQueuedEventScript?: string;
}

/**
 * 
 * @export
 * @interface ScriptRunnerCronJob
 */
export interface ScriptRunnerCronJob {
    /**
     * 
     * @type {boolean}
     * @memberof ScriptRunnerCronJob
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScriptRunnerCronJob
     */
    cronScript?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScriptRunnerCronJob
     */
    runDailyAt?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ScriptRunnerCronJob
     */
    runEvery?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptRunnerCronJob
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface ScriptRunnerUserExistsResponse
 */
export interface ScriptRunnerUserExistsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ScriptRunnerUserExistsResponse
     */
    exists?: boolean;
}

/**
 * 
 * @export
 * @interface ScriptingRequest
 */
export interface ScriptingRequest {
    /**
     * 
     * @type {string}
     * @memberof ScriptingRequest
     */
    groovyScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScriptingRequest
     */
    sentryLogging?: boolean;
    /**
     * 
     * @type {TransportOrder}
     * @memberof ScriptingRequest
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof ScriptingRequest
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface ScriptsDocumentationEntry
 */
export interface ScriptsDocumentationEntry {
    /**
     * 
     * @type {string}
     * @memberof ScriptsDocumentationEntry
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptsDocumentationEntry
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptsDocumentationEntry
     */
    documentationType?: ScriptsDocumentationEntry.DocumentationTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ScriptsDocumentationEntry
     */
    latestUpdateDate?: Date;
}

/**
 * @export
 * @namespace ScriptsDocumentationEntry
 */
export namespace ScriptsDocumentationEntry {
    /**
     * @export
     * @enum {string}
     */
    export enum DocumentationTypeEnum {
        LISDOCUMENTATION = 'GET_LIS_DOCUMENTATION',
        TRANSLOGICADOCUMENTATION = 'GET_TRANSLOGICA_DOCUMENTATION',
        LOGENIOSENVIRONMENTDOCUMENTATION = 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION',
        AIENVDOCUMENTATION = 'GET_AIENV_DOCUMENTATION',
        TRANSDATADOCUMENTATION = 'GET_TRANSDATA_DOCUMENTATION',
        SOLOPLANDOCUMENTATION = 'GET_SOLOPLAN_DOCUMENTATION',
        EDIDOCUMENTATION = 'GET_EDI_DOCUMENTATION'
    }
}

/**
 * 
 * @export
 * @interface SearchConfigsRequest
 */
export interface SearchConfigsRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchConfigsRequest
     */
    searchTerm?: string;
}

/**
 * 
 * @export
 * @interface SearchConfigsResponse
 */
export interface SearchConfigsResponse {
    /**
     * 
     * @type {Array<ConfigMatch>}
     * @memberof SearchConfigsResponse
     */
    matches?: Array<ConfigMatch>;
}

/**
 * 
 * @export
 * @interface SearchData
 */
export interface SearchData {
    /**
     * 
     * @type {string}
     * @memberof SearchData
     */
    additionalDataKeyName?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchData
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface SearchTermObject
 */
export interface SearchTermObject {
    /**
     * 
     * @type {SearchData}
     * @memberof SearchTermObject
     */
    searchData?: SearchData;
    /**
     * 
     * @type {string}
     * @memberof SearchTermObject
     */
    searchForTransportOrderPart?: SearchTermObject.SearchForTransportOrderPartEnum;
}

/**
 * @export
 * @namespace SearchTermObject
 */
export namespace SearchTermObject {
    /**
     * @export
     * @enum {string}
     */
    export enum SearchForTransportOrderPartEnum {
        AdditionalData = 'AdditionalData',
        TransportOrderId = 'TransportOrderId',
        AssignedTrailerExternalVehicleId = 'AssignedTrailerExternalVehicleId',
        AssignedTrailerNumberPlate = 'AssignedTrailerNumberPlate',
        AssignedVehicleExternalVehicleId = 'AssignedVehicleExternalVehicleId',
        AssignedVehicleNumberPlate = 'AssignedVehicleNumberPlate',
        AssignedDeviceVerboseName = 'AssignedDeviceVerboseName',
        Comment = 'Comment',
        SourceCompanyName = 'SourceCompanyName',
        ExternalTargetCompanyId = 'ExternalTargetCompanyId',
        ExternalTargetTransportOrderId = 'ExternalTargetTransportOrderId',
        ExternalUserId = 'ExternalUserId',
        FreightAdditionalData = 'FreightAdditionalData',
        FreightComment = 'FreightComment',
        FreightDeliveryNumber = 'FreightDeliveryNumber',
        FreightExternalFreightId = 'FreightExternalFreightId',
        FreightId = 'FreightId',
        FreightVerboseName = 'FreightVerboseName',
        LinkInfoExternalLinkKeys = 'LinkInfoExternalLinkKeys',
        StatusAdditionalData = 'StatusAdditionalData',
        TargetCompanyName = 'TargetCompanyName',
        TransportsAdditionalData = 'TransportsAdditionalData',
        TransportsComment = 'TransportsComment',
        TransportsLinkInfoExternalLinkKeys = 'TransportsLinkInfoExternalLinkKeys',
        TransportsShipmentNumber = 'TransportsShipmentNumber',
        TransportId = 'TransportId',
        StopsAdditionalData = 'StopsAdditionalData',
        StopsCity = 'StopsCity',
        LoadingLocationCity = 'LoadingLocationCity',
        UnloadingLocationCity = 'UnloadingLocationCity',
        StopsComment = 'StopsComment',
        StopsName = 'StopsName',
        LoadingLocationName = 'LoadingLocationName',
        UnloadingLocationName = 'UnloadingLocationName',
        LoadingLocationNameOrCity = 'LoadingLocationNameOrCity',
        UnloadingLocationNameOrCity = 'UnloadingLocationNameOrCity',
        StopsName2 = 'StopsName2',
        StopsStreet = 'StopsStreet',
        StopsUniqueLocationId = 'StopsUniqueLocationId',
        StopsZipCode = 'StopsZipCode',
        VerboseName = 'VerboseName',
        UserEmail = 'UserEmail'
    }
}

/**
 * 
 * @export
 * @interface SelectLoadedSelectDeliveredWorkflowConfiguration
 */
export interface SelectLoadedSelectDeliveredWorkflowConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SelectLoadedSelectDeliveredWorkflowConfiguration
     */
    allowPartialFreightLoading?: boolean;
    /**
     * 
     * @type {ReportDeviationModalConfiguration}
     * @memberof SelectLoadedSelectDeliveredWorkflowConfiguration
     */
    reportDeviationModal?: ReportDeviationModalConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof SelectLoadedSelectDeliveredWorkflowConfiguration
     */
    showAcceptRejectButtons?: boolean;
}

/**
 * 
 * @export
 * @interface SendCause
 */
export interface SendCause {
    /**
     * 
     * @type {string}
     * @memberof SendCause
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendCause
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SendCause
     */
    queuedEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendCause
     */
    senderName?: string;
    /**
     * 
     * @type {string}
     * @memberof SendCause
     */
    transportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendCause
     */
    xRequestId?: string;
}

/**
 * 
 * @export
 * @interface SendMailResponse
 */
export interface SendMailResponse {
    /**
     * 
     * @type {string}
     * @memberof SendMailResponse
     */
    externalMailId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendMailResponse
     */
    logeniosMailId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendMailResponse
     */
    smsId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SendMailResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface SendTransportOrderStatusValidationsMailsNowRequest
 */
export interface SendTransportOrderStatusValidationsMailsNowRequest {
    /**
     * 
     * @type {string}
     * @memberof SendTransportOrderStatusValidationsMailsNowRequest
     */
    senderMail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendTransportOrderStatusValidationsMailsNowRequest
     */
    toIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface SendTransportOrderStatusValidationsMailsNowResponse
 */
export interface SendTransportOrderStatusValidationsMailsNowResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof SendTransportOrderStatusValidationsMailsNowResponse
     */
    receiverMails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendTransportOrderStatusValidationsMailsNowResponse
     */
    sendTos?: Array<string>;
}

/**
 * 
 * @export
 * @interface Set
 */
export interface Set {
    /**
     * 
     * @type {number}
     * @memberof Set
     */
    size?: number;
}

/**
 * 
 * @export
 * @interface SetCmNavTreeTextModalListResponse
 */
export interface SetCmNavTreeTextModalListResponse {
    /**
     * 
     * @type {string}
     * @memberof SetCmNavTreeTextModalListResponse
     */
    errorText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetCmNavTreeTextModalListResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface SftpSyncMonitoring
 */
export interface SftpSyncMonitoring {
    /**
     * 
     * @type {boolean}
     * @memberof SftpSyncMonitoring
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SftpSyncMonitoring
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SftpSyncMonitoring
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SftpSyncMonitoring
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SftpSyncMonitoring
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SftpSyncMonitoring
     */
    level?: SftpSyncMonitoring.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof SftpSyncMonitoring
     */
    message?: string;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof SftpSyncMonitoring
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof SftpSyncMonitoring
     */
    title?: string;
}

/**
 * @export
 * @namespace SftpSyncMonitoring
 */
export namespace SftpSyncMonitoring {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface ShareUserAccessViaEmailRequest
 */
export interface ShareUserAccessViaEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareUserAccessViaEmailRequest
     */
    userAccessToken?: string;
}

/**
 * 
 * @export
 * @interface ShareUserAccessViaEmailResponse
 */
export interface ShareUserAccessViaEmailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ShareUserAccessViaEmailResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface Shipment
 */
export interface Shipment {
    /**
     * Additional key-value-pairs associated with this transport order
     * @type {Array<AdditionalDataEntry>}
     * @memberof Shipment
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {AssignedDevice}
     * @memberof Shipment
     */
    assignedDevice?: AssignedDevice;
    /**
     * 
     * @type {Driver}
     * @memberof Shipment
     */
    assignedDriver?: Driver;
    /**
     * 
     * @type {AssignedOrderBox}
     * @memberof Shipment
     */
    assignedOrderBox?: AssignedOrderBox;
    /**
     * 
     * @type {Vehicle}
     * @memberof Shipment
     */
    assignedTrailer?: Vehicle;
    /**
     * 
     * @type {Vehicle}
     * @memberof Shipment
     */
    assignedVehicle?: Vehicle;
    /**
     * File attachments associated with this shipment
     * @type {Array<Attachment>}
     * @memberof Shipment
     */
    attachments?: Array<Attachment>;
    /**
     * additional comments
     * @type {string}
     * @memberof Shipment
     */
    comment?: string;
    /**
     * originating company id
     * @type {string}
     * @memberof Shipment
     */
    companyId?: string;
    /**
     * originating company name
     * @type {string}
     * @memberof Shipment
     */
    companyName?: string;
    /**
     * Constraints regarding to the executing vehicle which must be satisfied
     * @type {Array<string>}
     * @memberof Shipment
     */
    constraints?: Array<Shipment.ConstraintsEnum>;
    /**
     * date time when this shipment was created
     * @type {Date}
     * @memberof Shipment
     */
    created?: Date;
    /**
     * 
     * @type {CustomWorkflowDefinition}
     * @memberof Shipment
     */
    customWorkflow?: CustomWorkflowDefinition;
    /**
     * Deliveries to be made in this shipment
     * @type {Array<Delivery>}
     * @memberof Shipment
     */
    deliveries?: Array<Delivery>;
    /**
     * exernal id of company which is responsible for order execution
     * @type {string}
     * @memberof Shipment
     */
    externalTargetCompanyId?: string;
    /**
     * External Transport order id of the order from which that shipment was derived
     * @type {string}
     * @memberof Shipment
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {LinkInfo}
     * @memberof Shipment
     */
    linkInfo?: LinkInfo;
    /**
     * date time when this shipment was modified
     * @type {Date}
     * @memberof Shipment
     */
    modified?: Date;
    /**
     * List of Observers which have read only access to this shipment
     * @type {Array<Observer>}
     * @memberof Shipment
     */
    observer?: Array<Observer>;
    /**
     * planned date time when the order execution should be finished
     * @type {Date}
     * @memberof Shipment
     */
    planEnd?: Date;
    /**
     * planned date time when the order execution should start
     * @type {Date}
     * @memberof Shipment
     */
    planStart?: Date;
    /**
     * 
     * @type {RouteInformation}
     * @memberof Shipment
     */
    route?: RouteInformation;
    /**
     * 
     * @type {TransportOrderStatus}
     * @memberof Shipment
     */
    status?: TransportOrderStatus;
    /**
     * 
     * @type {TransportOrderValidationResult}
     * @memberof Shipment
     */
    statusValidationResult?: TransportOrderValidationResult;
    /**
     * id of company which is responsible for order execution
     * @type {string}
     * @memberof Shipment
     */
    targetCompanyId?: string;
    /**
     * name of company which is responsible for order execution
     * @type {string}
     * @memberof Shipment
     */
    targetCompanyName?: string;
    /**
     * external order identifier used by the telematic system
     * @type {string}
     * @memberof Shipment
     */
    telematicTransportOrderId?: string;
    /**
     * 
     * @type {TourEtaInfo}
     * @memberof Shipment
     */
    tourEta?: TourEtaInfo;
    /**
     * Transport order id of the order from which that shipment was derived
     * @type {string}
     * @memberof Shipment
     */
    transportOrderId?: string;
    /**
     * short description of this transport order
     * @type {string}
     * @memberof Shipment
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace Shipment
 */
export namespace Shipment {
    /**
     * @export
     * @enum {string}
     */
    export enum ConstraintsEnum {
        CAR = 'CAR',
        TRANSPORTER = 'TRANSPORTER',
        TRUCK75T = 'TRUCK_7_5T',
        TRUCK1199T = 'TRUCK_11_99T',
        TRUCK40T = 'TRUCK_40T',
        CRANE = 'CRANE',
        MOFFETT = 'MOFFETT',
        PALLETJACK = 'PALLET_JACK',
        CONTAINER = 'CONTAINER',
        DOUBLECONTAINER = 'DOUBLE_CONTAINER',
        COOLINGUNIT = 'COOLING_UNIT',
        SILOTRUCK = 'SILO_TRUCK',
        TAUTLINER = 'TAUTLINER',
        FLATBED = 'FLATBED',
        SIXWHEELER = 'SIX_WHEELER',
        EIGHTWHEELER = 'EIGHT_WHEELER',
        MEGATRAILER = 'MEGA_TRAILER',
        SWAPBODY = 'SWAP_BODY'
    }
}

/**
 * 
 * @export
 * @interface ShipmentBasedSchenkerDesignWonflow
 */
export interface ShipmentBasedSchenkerDesignWonflow {
    /**
     * 
     * @type {FreightDisplayOptions}
     * @memberof ShipmentBasedSchenkerDesignWonflow
     */
    freightDisplayOptions?: FreightDisplayOptions;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentBasedSchenkerDesignWonflow
     */
    hideInvoiceUploadForm?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentBasedSchenkerDesignWonflow
     */
    hidePodUploadForm?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentBasedSchenkerDesignWonflow
     */
    selectOrEnterVehicleOnActivate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentBasedSchenkerDesignWonflow
     */
    showCustomWorkflowFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentBasedSchenkerDesignWonflow
     */
    showDateTimeSection?: boolean;
}

/**
 * 
 * @export
 * @interface ShipmentFormConfig
 */
export interface ShipmentFormConfig {
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfig
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfig
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfig
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfig
     */
    companyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentFormConfig
     */
    createTransportOrderWithGpt4Prompt?: boolean;
    /**
     * 
     * @type {ShipmentFormDesign}
     * @memberof ShipmentFormConfig
     */
    design?: ShipmentFormDesign;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShipmentFormConfig
     */
    emailTo?: Array<string>;
    /**
     * 
     * @type {Array<GenericAiTourExample>}
     * @memberof ShipmentFormConfig
     */
    genericAiTourExamples?: Array<GenericAiTourExample>;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentFormConfig
     */
    hasMultipleTransports?: boolean;
    /**
     * 
     * @type {Array<Observer>}
     * @memberof ShipmentFormConfig
     */
    observers?: Array<Observer>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfig
     */
    pin?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfig
     */
    sourceCompanyIdForCreation?: string;
    /**
     * 
     * @type {TransportOrderCreatePageViewConfiguration}
     * @memberof ShipmentFormConfig
     */
    uiConfig?: TransportOrderCreatePageViewConfiguration;
    /**
     * 
     * @type {Array<ShipmentFormConfigUser>}
     * @memberof ShipmentFormConfig
     */
    users?: Array<ShipmentFormConfigUser>;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentFormConfig
     */
    validUntil?: Date;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfig
     */
    verbose?: string;
}

/**
 * 
 * @export
 * @interface ShipmentFormConfigListResponse
 */
export interface ShipmentFormConfigListResponse {
    /**
     * 
     * @type {Array<ShipmentFormConfig>}
     * @memberof ShipmentFormConfigListResponse
     */
    configs?: Array<ShipmentFormConfig>;
    /**
     * 
     * @type {number}
     * @memberof ShipmentFormConfigListResponse
     */
    count?: number;
}

/**
 * 
 * @export
 * @interface ShipmentFormConfigRequest
 */
export interface ShipmentFormConfigRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentFormConfigRequest
     */
    createTransportOrderWithGpt4Prompt?: boolean;
    /**
     * 
     * @type {ShipmentFormDesign}
     * @memberof ShipmentFormConfigRequest
     */
    design?: ShipmentFormDesign;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShipmentFormConfigRequest
     */
    emailTo?: Array<string>;
    /**
     * 
     * @type {Array<GenericAiTourExample>}
     * @memberof ShipmentFormConfigRequest
     */
    genericAiTourExamples?: Array<GenericAiTourExample>;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentFormConfigRequest
     */
    hasMultipleTransports?: boolean;
    /**
     * 
     * @type {AddressSelectConfiguration}
     * @memberof ShipmentFormConfigRequest
     */
    loadingLocation?: AddressSelectConfiguration;
    /**
     * 
     * @type {Array<Observer>}
     * @memberof ShipmentFormConfigRequest
     */
    observers?: Array<Observer>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfigRequest
     */
    pin?: string;
    /**
     * 
     * @type {ShipperConfiguration}
     * @memberof ShipmentFormConfigRequest
     */
    shipper?: ShipperConfiguration;
    /**
     * 
     * @type {TransportOrderCreatePageViewConfiguration}
     * @memberof ShipmentFormConfigRequest
     */
    uiConfig?: TransportOrderCreatePageViewConfiguration;
    /**
     * 
     * @type {AddressSelectConfiguration}
     * @memberof ShipmentFormConfigRequest
     */
    unloadingLocation?: AddressSelectConfiguration;
    /**
     * 
     * @type {Array<ShipmentFormConfigUser>}
     * @memberof ShipmentFormConfigRequest
     */
    users?: Array<ShipmentFormConfigUser>;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentFormConfigRequest
     */
    validUntil?: Date;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfigRequest
     */
    verbose?: string;
}

/**
 * 
 * @export
 * @interface ShipmentFormConfigUser
 */
export interface ShipmentFormConfigUser {
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfigUser
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfigUser
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentFormConfigUser
     */
    lastAccessed?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentFormConfigUser
     */
    latestInvitationSentDate?: Date;
    /**
     * 
     * @type {Array<Observer>}
     * @memberof ShipmentFormConfigUser
     */
    observers?: Array<Observer>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfigUser
     */
    pin?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormConfigUser
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface ShipmentFormDesign
 */
export interface ShipmentFormDesign {
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormDesign
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormDesign
     */
    carrierLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormDesign
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormDesign
     */
    shipperLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentFormDesign
     */
    textColor?: string;
}

/**
 * 
 * @export
 * @interface ShipmentListSideMenuMobileWebAppConfig
 */
export interface ShipmentListSideMenuMobileWebAppConfig {
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentListSideMenuMobileWebAppConfig
     */
    showOnlyTransportOrdersWithAttachment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentListSideMenuMobileWebAppConfig
     */
    showSideMenu?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentListSideMenuMobileWebAppConfig
     */
    statusTextDisplay?: ShipmentListSideMenuMobileWebAppConfig.StatusTextDisplayEnum;
}

/**
 * @export
 * @namespace ShipmentListSideMenuMobileWebAppConfig
 */
export namespace ShipmentListSideMenuMobileWebAppConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusTextDisplayEnum {
        ORDERSTATUS = 'TRANSPORT_ORDER_STATUS',
        ATTACHMENTSTATUS = 'TRANSPORT_ATTACHMENT_STATUS'
    }
}

/**
 * 
 * @export
 * @interface ShipmentMappingCandidatesResponse
 */
export interface ShipmentMappingCandidatesResponse {
    /**
     * 
     * @type {Array<CompanyTransportOrderMapping>}
     * @memberof ShipmentMappingCandidatesResponse
     */
    mappings?: Array<CompanyTransportOrderMapping>;
}

/**
 * 
 * @export
 * @interface ShipmentResponse
 */
export interface ShipmentResponse {
    /**
     * 
     * @type {Array<Shipment>}
     * @memberof ShipmentResponse
     */
    shipments?: Array<Shipment>;
}

/**
 * 
 * @export
 * @interface ShipperAddress
 */
export interface ShipperAddress {
    /**
     * 
     * @type {string}
     * @memberof ShipperAddress
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface ShipperConfiguration
 */
export interface ShipperConfiguration {
    /**
     * 
     * @type {ShipperAddress}
     * @memberof ShipperConfiguration
     */
    shipper?: ShipperAddress;
    /**
     * 
     * @type {string}
     * @memberof ShipperConfiguration
     */
    type?: ShipperConfiguration.TypeEnum;
}

/**
 * @export
 * @namespace ShipperConfiguration
 */
export namespace ShipperConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        FREESHIPPERINPUT = 'FREE_SHIPPER_INPUT',
        FIXEDSHIPPER = 'FIXED_SHIPPER'
    }
}

/**
 * 
 * @export
 * @interface Short
 */
export interface Short {
}

/**
 * 
 * @export
 * @interface ShortestFoundDistanceToStop
 */
export interface ShortestFoundDistanceToStop {
    /**
     * 
     * @type {number}
     * @memberof ShortestFoundDistanceToStop
     */
    distanceInMeter?: number;
    /**
     * 
     * @type {GpsPosition}
     * @memberof ShortestFoundDistanceToStop
     */
    position?: GpsPosition;
    /**
     * 
     * @type {string}
     * @memberof ShortestFoundDistanceToStop
     */
    vehicleId?: string;
}

/**
 * 
 * @export
 * @interface SignDocumentConfig
 */
export interface SignDocumentConfig {
    /**
     * 
     * @type {string}
     * @memberof SignDocumentConfig
     */
    pageToStamp?: SignDocumentConfig.PageToStampEnum;
    /**
     * 
     * @type {number}
     * @memberof SignDocumentConfig
     */
    stampPositionX?: number;
    /**
     * 
     * @type {number}
     * @memberof SignDocumentConfig
     */
    stampPositionY?: number;
    /**
     * 
     * @type {string}
     * @memberof SignDocumentConfig
     */
    stampTitle?: string;
}

/**
 * @export
 * @namespace SignDocumentConfig
 */
export namespace SignDocumentConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum PageToStampEnum {
        FIRSTPAGE = 'FIRST_PAGE',
        LASTPAGE = 'LAST_PAGE'
    }
}

/**
 * 
 * @export
 * @interface Signature
 */
export interface Signature {
    /**
     * 
     * @type {string}
     * @memberof Signature
     */
    signature?: string;
    /**
     * 
     * @type {string}
     * @memberof Signature
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof Signature
     */
    token?: string;
}

/**
 * 
 * @export
 * @interface SimpleCSVContainmentTypeMapping
 */
export interface SimpleCSVContainmentTypeMapping {
    /**
     * 
     * @type {string}
     * @memberof SimpleCSVContainmentTypeMapping
     */
    csvType?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCSVContainmentTypeMapping
     */
    logeniosType?: SimpleCSVContainmentTypeMapping.LogeniosTypeEnum;
}

/**
 * @export
 * @namespace SimpleCSVContainmentTypeMapping
 */
export namespace SimpleCSVContainmentTypeMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum LogeniosTypeEnum {
        EpalEurPallet = 'epalEurPallet',
        Epal2Pallet = 'epal2Pallet',
        Epal3Pallet = 'epal3Pallet',
        Epal6HalfPallet = 'epal6HalfPallet',
        Epal7HalfPallet = 'epal7HalfPallet',
        EpalBoxPallet = 'epalBoxPallet',
        ChepEuroPallet = 'chepEuroPallet',
        ChepHalfPallet = 'chepHalfPallet',
        ChepIndustrialPallet = 'chepIndustrialPallet',
        ChepPlasticEurPallet = 'chepPlasticEurPallet',
        ChepPlasticQuarterPallet = 'chepPlasticQuarterPallet',
        Pallet = 'pallet',
        PalletCollar = 'palletCollar',
        EurH1PlasticPallet = 'eurH1PlasticPallet',
        PaperSack = 'paperSack',
        InflatableBag = 'inflatableBag',
        Container20ft = 'container20ft',
        Container40ft = 'container40ft',
        Container45ft = 'container45ft',
        Container48ft = 'container48ft',
        Container53ft = 'container53ft',
        IbcContainer = 'ibcContainer',
        IntermediateBulkContainer = 'intermediateBulkContainer',
        IfcoTray = 'ifcoTray',
        SlipSheet = 'slipSheet',
        CagePallet = 'cagePallet',
        RollContainer = 'rollContainer',
        Bag = 'bag',
        Box = 'box',
        Piece = 'piece',
        Other = 'other'
    }
}

/**
 * 
 * @export
 * @interface SimpleCronTimes
 */
export interface SimpleCronTimes {
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleCronTimes
     */
    dayOfWeek?: Array<SimpleCronTimes.DayOfWeekEnum>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimpleCronTimes
     */
    hours?: Array<number>;
}

/**
 * @export
 * @namespace SimpleCronTimes
 */
export namespace SimpleCronTimes {
    /**
     * @export
     * @enum {string}
     */
    export enum DayOfWeekEnum {
        MONDAY = 'MONDAY',
        TUESDAY = 'TUESDAY',
        WEDNESDAY = 'WEDNESDAY',
        THURSDAY = 'THURSDAY',
        FRIDAY = 'FRIDAY',
        SATURDAY = 'SATURDAY',
        SUNDAY = 'SUNDAY'
    }
}

/**
 * 
 * @export
 * @interface SimpleCsvCompanySpecificConfiguration
 */
export interface SimpleCsvCompanySpecificConfiguration {
    /**
     * 
     * @type {SimpleCsvCompanySpecificConfigurationApplyRules}
     * @memberof SimpleCsvCompanySpecificConfiguration
     */
    applyWhenAll?: SimpleCsvCompanySpecificConfigurationApplyRules;
    /**
     * 
     * @type {SimpleCsvConverterConfiguration}
     * @memberof SimpleCsvCompanySpecificConfiguration
     */
    override?: SimpleCsvConverterConfiguration;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvCompanySpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface SimpleCsvCompanySpecificConfigurationApplyRules
 */
export interface SimpleCsvCompanySpecificConfigurationApplyRules {
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvCompanySpecificConfigurationApplyRules
     */
    onConversionToExternalFormat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvCompanySpecificConfigurationApplyRules
     */
    onConversionToTransportOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvCompanySpecificConfigurationApplyRules
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvCompanySpecificConfigurationApplyRules
     */
    sourceCompanyId?: string;
}

/**
 * 
 * @export
 * @interface SimpleCsvConverterConfiguration
 */
export interface SimpleCsvConverterConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvConverterConfiguration
     */
    abortOnScriptError?: boolean;
    /**
     * 
     * @type {Array<SimpleCSVContainmentTypeMapping>}
     * @memberof SimpleCsvConverterConfiguration
     */
    containmentTypeMapping?: Array<SimpleCSVContainmentTypeMapping>;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    dateTimeFormatString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvConverterConfiguration
     */
    evaluateExcelFormulas?: boolean;
    /**
     * 
     * @type {SimpleCsvExportConfiguration}
     * @memberof SimpleCsvConverterConfiguration
     */
    _export?: SimpleCsvExportConfiguration;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    fileEncoding?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    fileFormat?: SimpleCsvConverterConfiguration.FileFormatEnum;
    /**
     * 
     * @type {CsvFreightColumnMapping}
     * @memberof SimpleCsvConverterConfiguration
     */
    freightMapping?: CsvFreightColumnMapping;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvConverterConfiguration
     */
    ignoreErrorsInExcelFormulas?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    importCsvDataLineScript?: string;
    /**
     * 
     * @type {CsvAddressColumnMapping}
     * @memberof SimpleCsvConverterConfiguration
     */
    loadingStopMapping?: CsvAddressColumnMapping;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    modifyMode?: SimpleCsvConverterConfiguration.ModifyModeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimpleCsvConverterConfiguration
     */
    numHeaderLinesToSkip?: number;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    numberFormatDecimalSeparator?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    numberFormatThousandsSeparator?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    postImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    preImportLineFilterScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    preImportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    quoteChar?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleCsvConverterConfiguration
     */
    reorderColumnsTo?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    separator?: string;
    /**
     * 
     * @type {SimpleCsvSheetConfiguration}
     * @memberof SimpleCsvConverterConfiguration
     */
    sheets?: SimpleCsvSheetConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvConverterConfiguration
     */
    skipHiddenRows?: boolean;
    /**
     * 
     * @type {Array<SimpleCsvCompanySpecificConfiguration>}
     * @memberof SimpleCsvConverterConfiguration
     */
    specificConfiguration?: Array<SimpleCsvCompanySpecificConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvConverterConfiguration
     */
    timezone?: string;
    /**
     * 
     * @type {CsvTransportColumnMapping}
     * @memberof SimpleCsvConverterConfiguration
     */
    transportMapping?: CsvTransportColumnMapping;
    /**
     * 
     * @type {CsvTransportOrderColumnMapping}
     * @memberof SimpleCsvConverterConfiguration
     */
    transportOrderMapping?: CsvTransportOrderColumnMapping;
    /**
     * 
     * @type {CsvAddressColumnMapping}
     * @memberof SimpleCsvConverterConfiguration
     */
    unloadingStopMapping?: CsvAddressColumnMapping;
}

/**
 * @export
 * @namespace SimpleCsvConverterConfiguration
 */
export namespace SimpleCsvConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum FileFormatEnum {
        EXCEL = 'EXCEL',
        EXCEL97 = 'EXCEL_97',
        FLATFILE = 'FLAT_FILE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface SimpleCsvExportColumnDefinition
 */
export interface SimpleCsvExportColumnDefinition {
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportColumnDefinition
     */
    columnName?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportColumnDefinition
     */
    valueExpr?: string;
}

/**
 * 
 * @export
 * @interface SimpleCsvExportConfiguration
 */
export interface SimpleCsvExportConfiguration {
    /**
     * 
     * @type {Array<SimpleCsvExportColumnDefinition>}
     * @memberof SimpleCsvExportConfiguration
     */
    etaEvent?: Array<SimpleCsvExportColumnDefinition>;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportConfiguration
     */
    excelSheetName?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportConfiguration
     */
    fileExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportConfiguration
     */
    outputFormat?: SimpleCsvExportConfiguration.OutputFormatEnum;
    /**
     * 
     * @type {Array<SimpleCsvExportColumnDefinition>}
     * @memberof SimpleCsvExportConfiguration
     */
    positionEvent?: Array<SimpleCsvExportColumnDefinition>;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportConfiguration
     */
    postExportLineScript?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportConfiguration
     */
    quoteChar?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleCsvExportConfiguration
     */
    relevantStatusCodesToExport?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleCsvExportConfiguration
     */
    relevantStatusEventsToExport?: Array<SimpleCsvExportConfiguration.RelevantStatusEventsToExportEnum>;
    /**
     * 
     * @type {string}
     * @memberof SimpleCsvExportConfiguration
     */
    separator?: string;
    /**
     * 
     * @type {Array<SimpleCsvExportColumnDefinition>}
     * @memberof SimpleCsvExportConfiguration
     */
    statusEvent?: Array<SimpleCsvExportColumnDefinition>;
    /**
     * 
     * @type {Array<SimpleCsvExportColumnDefinition>}
     * @memberof SimpleCsvExportConfiguration
     */
    transportOrderEvent?: Array<SimpleCsvExportColumnDefinition>;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvExportConfiguration
     */
    writeHeader?: boolean;
}

/**
 * @export
 * @namespace SimpleCsvExportConfiguration
 */
export namespace SimpleCsvExportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum OutputFormatEnum {
        EXCEL = 'EXCEL',
        EXCEL97 = 'EXCEL_97',
        FLATFILE = 'FLAT_FILE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RelevantStatusEventsToExportEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface SimpleCsvSheetConfiguration
 */
export interface SimpleCsvSheetConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleCsvSheetConfiguration
     */
    exclude?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimpleCsvSheetConfiguration
     */
    excludeIndexes?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleCsvSheetConfiguration
     */
    include?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimpleCsvSheetConfiguration
     */
    includeIndexes?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleCsvSheetConfiguration
     */
    shouldMergeAllSheets?: boolean;
}

/**
 * 
 * @export
 * @interface SimpleResponse
 */
export interface SimpleResponse {
    /**
     * 
     * @type {string}
     * @memberof SimpleResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface SingleInvoiceResponse
 */
export interface SingleInvoiceResponse {
    /**
     * 
     * @type {string}
     * @memberof SingleInvoiceResponse
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleInvoiceResponse
     */
    invoiceId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SingleInvoiceResponse
     */
    lastModifiedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SingleInvoiceResponse
     */
    uploadedToZoho?: Date;
    /**
     * 
     * @type {string}
     * @memberof SingleInvoiceResponse
     */
    zohoId?: string;
}

/**
 * 
 * @export
 * @interface SmsFailureNotificationConfiguration
 */
export interface SmsFailureNotificationConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SmsFailureNotificationConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SmsFailureNotificationConfiguration
     */
    failureResponseEmailBody?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsFailureNotificationConfiguration
     */
    failureResponseEmailSubject?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsFailureNotificationConfiguration
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsFailureNotificationConfiguration
     */
    noResponseEmailBody?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsFailureNotificationConfiguration
     */
    noResponseEmailSubject?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SmsFailureNotificationConfiguration
     */
    recipientEmails?: Array<string>;
}

/**
 * 
 * @export
 * @interface SmsNotification
 */
export interface SmsNotification {
    /**
     * 
     * @type {string}
     * @memberof SmsNotification
     */
    receiver?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsNotification
     */
    text?: string;
}

/**
 * 
 * @export
 * @interface SoloplanAdditionalDataImportConfiguration
 */
export interface SoloplanAdditionalDataImportConfiguration {
    /**
     * 
     * @type {Array<SoloplanAdditionalDataItemImportConfiguration>}
     * @memberof SoloplanAdditionalDataImportConfiguration
     */
    freight?: Array<SoloplanAdditionalDataItemImportConfiguration>;
    /**
     * 
     * @type {Array<SoloplanAdditionalDataItemImportConfiguration>}
     * @memberof SoloplanAdditionalDataImportConfiguration
     */
    stopLocation?: Array<SoloplanAdditionalDataItemImportConfiguration>;
    /**
     * 
     * @type {Array<SoloplanAdditionalDataItemImportConfiguration>}
     * @memberof SoloplanAdditionalDataImportConfiguration
     */
    transport?: Array<SoloplanAdditionalDataItemImportConfiguration>;
    /**
     * 
     * @type {Array<SoloplanAdditionalDataItemImportConfiguration>}
     * @memberof SoloplanAdditionalDataImportConfiguration
     */
    transportOrder?: Array<SoloplanAdditionalDataItemImportConfiguration>;
}

/**
 * 
 * @export
 * @interface SoloplanAdditionalDataItemImportConfiguration
 */
export interface SoloplanAdditionalDataItemImportConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SoloplanAdditionalDataItemImportConfiguration
     */
    logeniosKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAdditionalDataItemImportConfiguration
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface SoloplanAddress
 */
export interface SoloplanAddress {
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    extnr?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    land?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    name1?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    nr?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    ort1?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    plz?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    strasse?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAddress
     */
    telzentrale?: string;
}

/**
 * 
 * @export
 * @interface SoloplanAdrAg
 */
export interface SoloplanAdrAg {
    /**
     * 
     * @type {string}
     * @memberof SoloplanAdrAg
     */
    extnr?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAdrAg
     */
    nr?: string;
}

/**
 * 
 * @export
 * @interface SoloplanAk
 */
export interface SoloplanAk {
    /**
     * 
     * @type {SoloplanAdrAg}
     * @memberof SoloplanAk
     */
    adr_ag?: SoloplanAdrAg;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAk
     */
    auftrdatum?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAk
     */
    auftrzeit?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAk
     */
    extnr?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAk
     */
    mandant?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanAk
     */
    organisation?: string;
    /**
     * 
     * @type {SoloplanSd}
     * @memberof SoloplanAk
     */
    sd?: SoloplanSd;
}

/**
 * 
 * @export
 * @interface SoloplanCompanySpecificConfiguration
 */
export interface SoloplanCompanySpecificConfiguration {
    /**
     * 
     * @type {SoloplanCompanySpecificConfigurationApplyRules}
     * @memberof SoloplanCompanySpecificConfiguration
     */
    applyWhenAll?: SoloplanCompanySpecificConfigurationApplyRules;
    /**
     * 
     * @type {SoloplanConverterConfigurationOverride}
     * @memberof SoloplanCompanySpecificConfiguration
     */
    override?: SoloplanConverterConfigurationOverride;
    /**
     * 
     * @type {string}
     * @memberof SoloplanCompanySpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface SoloplanCompanySpecificConfigurationApplyRules
 */
export interface SoloplanCompanySpecificConfigurationApplyRules {
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanCompanySpecificConfigurationApplyRules
     */
    onConversionToExternalFormat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanCompanySpecificConfigurationApplyRules
     */
    onConversionToTransportOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SoloplanCompanySpecificConfigurationApplyRules
     */
    script?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanCompanySpecificConfigurationApplyRules
     */
    sourceCompanyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SoloplanCompanySpecificConfigurationApplyRules
     */
    sourceCompanyTag?: Array<string>;
}

/**
 * 
 * @export
 * @interface SoloplanConverterConfiguration
 */
export interface SoloplanConverterConfiguration {
    /**
     * 
     * @type {SoloplanExportConfiguration}
     * @memberof SoloplanConverterConfiguration
     */
    _export?: SoloplanExportConfiguration;
    /**
     * 
     * @type {SoloplanImportConfiguration}
     * @memberof SoloplanConverterConfiguration
     */
    _import?: SoloplanImportConfiguration;
    /**
     * 
     * @type {Array<SoloplanCompanySpecificConfiguration>}
     * @memberof SoloplanConverterConfiguration
     */
    specificConfiguration?: Array<SoloplanCompanySpecificConfiguration>;
    /**
     * 
     * @type {SoloplanStatusExportConfiguration}
     * @memberof SoloplanConverterConfiguration
     */
    statusExport?: SoloplanStatusExportConfiguration;
}

/**
 * 
 * @export
 * @interface SoloplanConverterConfigurationOverride
 */
export interface SoloplanConverterConfigurationOverride {
    /**
     * 
     * @type {SoloplanExportConfiguration}
     * @memberof SoloplanConverterConfigurationOverride
     */
    _export?: SoloplanExportConfiguration;
    /**
     * 
     * @type {SoloplanImportConfiguration}
     * @memberof SoloplanConverterConfigurationOverride
     */
    _import?: SoloplanImportConfiguration;
}

/**
 * 
 * @export
 * @interface SoloplanExportConfiguration
 */
export interface SoloplanExportConfiguration {
    /**
     * 
     * @type {SoloplanAk}
     * @memberof SoloplanExportConfiguration
     */
    ak?: SoloplanAk;
    /**
     * 
     * @type {string}
     * @memberof SoloplanExportConfiguration
     */
    exportMode?: SoloplanExportConfiguration.ExportModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanExportConfiguration
     */
    exportTransportOrderOnAssignVehicle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanExportConfiguration
     */
    shouldMergeTransportFreighPairs?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SoloplanExportConfiguration
     */
    statusExportTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanExportConfiguration
     */
    timezone?: string;
}

/**
 * @export
 * @namespace SoloplanExportConfiguration
 */
export namespace SoloplanExportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ExportModeEnum {
        TRANSPORT = 'ONE_AK_PER_TRANSPORT',
        TRANSPORTORDER = 'ONE_AK_PER_TRANSPORT_ORDER'
    }
}

/**
 * 
 * @export
 * @interface SoloplanGgvs
 */
export interface SoloplanGgvs {
    /**
     * 
     * @type {string}
     * @memberof SoloplanGgvs
     */
    ggvscname?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanGgvs
     */
    ggvsunnr?: string;
}

/**
 * 
 * @export
 * @interface SoloplanImportConfiguration
 */
export interface SoloplanImportConfiguration {
    /**
     * 
     * @type {SoloplanAdditionalDataImportConfiguration}
     * @memberof SoloplanImportConfiguration
     */
    additionalData?: SoloplanAdditionalDataImportConfiguration;
    /**
     * 
     * @type {string}
     * @memberof SoloplanImportConfiguration
     */
    format?: SoloplanImportConfiguration.FormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanImportConfiguration
     */
    importPositionsAsFreight?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SoloplanImportConfiguration
     */
    postImportScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanImportConfiguration
     */
    shouldImportStopActionTimeWindow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanImportConfiguration
     */
    shouldPrefixFreightIdWithTaNr?: boolean;
    /**
     * 
     * @type {StopLocationImportConfiguration}
     * @memberof SoloplanImportConfiguration
     */
    stopLocationImportConfiguration?: StopLocationImportConfiguration;
}

/**
 * @export
 * @namespace SoloplanImportConfiguration
 */
export namespace SoloplanImportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum FormatEnum {
        TOUROUT = 'TOUR_OUT',
        TELEMATIK = 'TELEMATIK',
        TOURINOUTV1JSON = 'TOUR_INOUT_V1_JSON'
    }
}

/**
 * 
 * @export
 * @interface SoloplanInfo
 */
export interface SoloplanInfo {
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    absinfo1?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    absinfo2?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    empinfo1?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info1?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info10?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info11?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info12?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info13?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info14?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info15?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info16?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info17?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info2?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info3?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info4?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info5?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info6?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info7?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info8?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanInfo
     */
    info9?: string;
}

/**
 * 
 * @export
 * @interface SoloplanPo
 */
export interface SoloplanPo {
    /**
     * 
     * @type {SoloplanGgvs}
     * @memberof SoloplanPo
     */
    ggvs?: SoloplanGgvs;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPo
     */
    info10?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPo
     */
    info3?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPo
     */
    info4?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPo
     */
    info9?: string;
    /**
     * 
     * @type {SoloplanPoFd}
     * @memberof SoloplanPo
     */
    pofd?: SoloplanPoFd;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPo
     */
    posnr?: string;
}

/**
 * 
 * @export
 * @interface SoloplanPoFd
 */
export interface SoloplanPoFd {
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    anzahl?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    artikelNr?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    breite?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    container?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    eancode?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    fgewicht?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    hoehe?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    inhalt?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    inhalt2?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    laenge?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    meter1?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    stellplatzCnt?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    tgewicht?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    verpackung?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanPoFd
     */
    zeichen?: string;
}

/**
 * 
 * @export
 * @interface SoloplanRstk
 */
export interface SoloplanRstk {
    /**
     * 
     * @type {string}
     * @memberof SoloplanRstk
     */
    ladedatum?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanRstk
     */
    ladezeitbis?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanRstk
     */
    ladezeitvon?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanRstk
     */
    lieferdatum?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanRstk
     */
    lieferzeitbis?: string;
    /**
     * 
     * @type {string}
     * @memberof SoloplanRstk
     */
    lieferzeitvon?: string;
}

/**
 * 
 * @export
 * @interface SoloplanSd
 */
export interface SoloplanSd {
    /**
     * 
     * @type {SoloplanAddress}
     * @memberof SoloplanSd
     */
    adr_abs?: SoloplanAddress;
    /**
     * 
     * @type {SoloplanAddress}
     * @memberof SoloplanSd
     */
    adr_emp?: SoloplanAddress;
    /**
     * 
     * @type {string}
     * @memberof SoloplanSd
     */
    extnr?: string;
    /**
     * 
     * @type {SoloplanInfo}
     * @memberof SoloplanSd
     */
    info?: SoloplanInfo;
    /**
     * 
     * @type {SoloplanPo}
     * @memberof SoloplanSd
     */
    po?: SoloplanPo;
    /**
     * 
     * @type {SoloplanRstk}
     * @memberof SoloplanSd
     */
    rstk?: SoloplanRstk;
    /**
     * 
     * @type {SoloplanSendungstypen}
     * @memberof SoloplanSd
     */
    sendungstypen?: SoloplanSendungstypen;
}

/**
 * 
 * @export
 * @interface SoloplanSendungstypen
 */
export interface SoloplanSendungstypen {
    /**
     * 
     * @type {string}
     * @memberof SoloplanSendungstypen
     */
    sdgtyp1matchcode?: string;
}

/**
 * 
 * @export
 * @interface SoloplanStatusExportConfiguration
 */
export interface SoloplanStatusExportConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanStatusExportConfiguration
     */
    exportEta?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SoloplanStatusExportConfiguration
     */
    exportFreightStatus?: boolean;
}

/**
 * 
 * @export
 * @interface SourceCompanyContractDetails
 */
export interface SourceCompanyContractDetails {
    /**
     * 
     * @type {Array<string>}
     * @memberof SourceCompanyContractDetails
     */
    excludeTargetCompanyIds?: Array<string>;
    /**
     * 
     * @type {InvoiceFilterOptions}
     * @memberof SourceCompanyContractDetails
     */
    filter?: InvoiceFilterOptions;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourceCompanyContractDetails
     */
    includeTargetCompanyIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SourceCompanyContractDetails
     */
    shouldCountOrders?: boolean;
}

/**
 * 
 * @export
 * @interface SpedionIntegration
 */
export interface SpedionIntegration {
    /**
     * 
     * @type {Array<string>}
     * @memberof SpedionIntegration
     */
    allowedSpedionCompanyIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SpedionIntegration
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface SplitOnBarCode
 */
export interface SplitOnBarCode {
    /**
     * 
     * @type {string}
     * @memberof SplitOnBarCode
     */
    codeShouldMatchRegex?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitOnBarCode
     */
    onBarCodeScript?: string;
}

/**
 * 
 * @export
 * @interface SplitOnOptions
 */
export interface SplitOnOptions {
    /**
     * 
     * @type {Array<GenericXlsExtractionRule>}
     * @memberof SplitOnOptions
     */
    anyRule?: Array<GenericXlsExtractionRule>;
    /**
     * 
     * @type {string}
     * @memberof SplitOnOptions
     */
    attachmentCategory?: SplitOnOptions.AttachmentCategoryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SplitOnOptions
     */
    disableOcr?: boolean;
    /**
     * 
     * @type {Array<SplitOnBarCode>}
     * @memberof SplitOnOptions
     */
    splitOnBarCode?: Array<SplitOnBarCode>;
}

/**
 * @export
 * @namespace SplitOnOptions
 */
export namespace SplitOnOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum AttachmentCategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
}

/**
 * 
 * @export
 * @interface SplitOnWithAI
 */
export interface SplitOnWithAI {
    /**
     * 
     * @type {PreSplitPDFOptions}
     * @memberof SplitOnWithAI
     */
    preSplitPDFOptions?: PreSplitPDFOptions;
    /**
     * 
     * @type {boolean}
     * @memberof SplitOnWithAI
     */
    preSplitPDFs?: boolean;
    /**
     * 
     * @type {AttachmentProcessorPromptBuilder}
     * @memberof SplitOnWithAI
     */
    promptBuilder?: AttachmentProcessorPromptBuilder;
}

/**
 * 
 * @export
 * @interface SplitterOptions
 */
export interface SplitterOptions {
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    aggressiveLineMerging?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SplitterOptions
     */
    changeRotationBeforeExtraction?: SplitterOptions.ChangeRotationBeforeExtractionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    disableHeaderRemoval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    extractHorizontalLines?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    insertEmptyLines?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SplitterOptions
     */
    ocrEngine?: SplitterOptions.OcrEngineEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    segmentDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    shallConvertPdfToImagesBeforeExtraction?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    splitOnOversizedWhitespaces?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    squashBuffer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    useAggressivePageDeduplication?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    useCorrectCalculationOfYCoordinate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SplitterOptions
     */
    useElasticCellPlacement?: boolean;
}

/**
 * @export
 * @namespace SplitterOptions
 */
export namespace SplitterOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum ChangeRotationBeforeExtractionEnum {
        PLUS90DEG = 'PLUS_90_DEG',
        MINUS90DEG = 'MINUS_90_DEG',
        PLUS180DEG = 'PLUS_180_DEG'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OcrEngineEnum {
        Tesseract = 'Tesseract',
        GoogleCloudVision = 'GoogleCloudVision'
    }
}

/**
 * 
 * @export
 * @interface StandingTimesUiDataResponse
 */
export interface StandingTimesUiDataResponse {
    /**
     * 
     * @type {Array<StandingTimesUiDriver>}
     * @memberof StandingTimesUiDataResponse
     */
    drivers?: Array<StandingTimesUiDriver>;
    /**
     * 
     * @type {Array<StandingTimesUiShipper>}
     * @memberof StandingTimesUiDataResponse
     */
    shipper?: Array<StandingTimesUiShipper>;
    /**
     * 
     * @type {Array<StandingTimesUiStopLocation>}
     * @memberof StandingTimesUiDataResponse
     */
    stopLocations?: Array<StandingTimesUiStopLocation>;
    /**
     * 
     * @type {Array<StandingTimesUiVehicle>}
     * @memberof StandingTimesUiDataResponse
     */
    vehicles?: Array<StandingTimesUiVehicle>;
}

/**
 * 
 * @export
 * @interface StandingTimesUiDisplayColumn
 */
export interface StandingTimesUiDisplayColumn {
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiDisplayColumn
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiDisplayColumn
     */
    name?: StandingTimesUiDisplayColumn.NameEnum;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiDisplayColumn
     */
    type?: StandingTimesUiDisplayColumn.TypeEnum;
}

/**
 * @export
 * @namespace StandingTimesUiDisplayColumn
 */
export namespace StandingTimesUiDisplayColumn {
    /**
     * @export
     * @enum {string}
     */
    export enum NameEnum {
        LOADING = 'LOADING',
        UNLOADING = 'UNLOADING',
        TIMEATLOCATION = 'TIME_AT_LOCATION',
        DELAYARRIVAL = 'DELAY_ARRIVAL',
        DELAYDEPARTURE = 'DELAY_DEPARTURE',
        PLANNEDTIMEATLOCATION = 'PLANNED_TIME_AT_LOCATION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        AVERAGE = 'AVERAGE',
        MEDIAN = 'MEDIAN',
        TOTAL = 'TOTAL',
        TIMES = 'TIMES',
        MIN = 'MIN',
        MAX = 'MAX'
    }
}

/**
 * 
 * @export
 * @interface StandingTimesUiDriver
 */
export interface StandingTimesUiDriver {
    /**
     * 
     * @type {Driver}
     * @memberof StandingTimesUiDriver
     */
    driver?: Driver;
    /**
     * 
     * @type {Array<StandingTimesUiRelation>}
     * @memberof StandingTimesUiDriver
     */
    relations?: Array<StandingTimesUiRelation>;
    /**
     * 
     * @type {RelationStats}
     * @memberof StandingTimesUiDriver
     */
    stats?: RelationStats;
}

/**
 * 
 * @export
 * @interface StandingTimesUiLocation
 */
export interface StandingTimesUiLocation {
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocation
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocation
     */
    kind?: StandingTimesUiLocation.KindEnum;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocation
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocation
     */
    uniqueLocationId?: string;
}

/**
 * @export
 * @namespace StandingTimesUiLocation
 */
export namespace StandingTimesUiLocation {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
}

/**
 * 
 * @export
 * @interface StandingTimesUiLocationStats
 */
export interface StandingTimesUiLocationStats {
    /**
     * 
     * @type {Address}
     * @memberof StandingTimesUiLocationStats
     */
    address?: Address;
    /**
     * 
     * @type {Date}
     * @memberof StandingTimesUiLocationStats
     */
    arrivedTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocationStats
     */
    city?: string;
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiLocationStats
     */
    delayArrivalInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiLocationStats
     */
    delayDepartureInMinutes?: number;
    /**
     * 
     * @type {Date}
     * @memberof StandingTimesUiLocationStats
     */
    departedTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocationStats
     */
    kind?: StandingTimesUiLocationStats.KindEnum;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocationStats
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof StandingTimesUiLocationStats
     */
    plannedArrivedTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StandingTimesUiLocationStats
     */
    plannedDepartedTimestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiLocationStats
     */
    plannedTimeAtLocationInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiLocationStats
     */
    timeAtLocationInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiLocationStats
     */
    uniqueLocationId?: string;
}

/**
 * @export
 * @namespace StandingTimesUiLocationStats
 */
export namespace StandingTimesUiLocationStats {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
}

/**
 * 
 * @export
 * @interface StandingTimesUiRelation
 */
export interface StandingTimesUiRelation {
    /**
     * 
     * @type {Array<StandingTimesUiLocation>}
     * @memberof StandingTimesUiRelation
     */
    locations?: Array<StandingTimesUiLocation>;
    /**
     * 
     * @type {Array<StandingTimesUiShipmentEntry>}
     * @memberof StandingTimesUiRelation
     */
    shipmentEntries?: Array<StandingTimesUiShipmentEntry>;
    /**
     * 
     * @type {RelationStats}
     * @memberof StandingTimesUiRelation
     */
    stats?: RelationStats;
}

/**
 * 
 * @export
 * @interface StandingTimesUiShipmentEntry
 */
export interface StandingTimesUiShipmentEntry {
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiShipmentEntry
     */
    emptyKmAfterwards?: number;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiShipmentEntry
     */
    externalOrderId?: string;
    /**
     * 
     * @type {Array<StandingTimesUiLocationStats>}
     * @memberof StandingTimesUiShipmentEntry
     */
    locationStats?: Array<StandingTimesUiLocationStats>;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiShipmentEntry
     */
    numberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiShipmentEntry
     */
    orderId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandingTimesUiShipmentEntry
     */
    transportIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiShipmentEntry
     */
    travelDurationInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingTimesUiShipmentEntry
     */
    traveledKm?: number;
}

/**
 * 
 * @export
 * @interface StandingTimesUiShipper
 */
export interface StandingTimesUiShipper {
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiShipper
     */
    name?: string;
    /**
     * 
     * @type {Array<StandingTimesUiRelation>}
     * @memberof StandingTimesUiShipper
     */
    relations?: Array<StandingTimesUiRelation>;
    /**
     * 
     * @type {RelationStats}
     * @memberof StandingTimesUiShipper
     */
    stats?: RelationStats;
}

/**
 * 
 * @export
 * @interface StandingTimesUiSpecificReportXlsxRequest
 */
export interface StandingTimesUiSpecificReportXlsxRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof StandingTimesUiSpecificReportXlsxRequest
     */
    orderIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiSpecificReportXlsxRequest
     */
    shipperName?: string;
}

/**
 * 
 * @export
 * @interface StandingTimesUiStopLocation
 */
export interface StandingTimesUiStopLocation {
    /**
     * 
     * @type {StandingTimesUiLocation}
     * @memberof StandingTimesUiStopLocation
     */
    location?: StandingTimesUiLocation;
    /**
     * 
     * @type {Array<StandingTimesUiRelation>}
     * @memberof StandingTimesUiStopLocation
     */
    relations?: Array<StandingTimesUiRelation>;
    /**
     * 
     * @type {RelationStats}
     * @memberof StandingTimesUiStopLocation
     */
    stats?: RelationStats;
}

/**
 * 
 * @export
 * @interface StandingTimesUiTableAsXlsxRequest
 */
export interface StandingTimesUiTableAsXlsxRequest {
    /**
     * 
     * @type {StandingTimesUiTableFormattingInfo}
     * @memberof StandingTimesUiTableAsXlsxRequest
     */
    formattingInfo?: StandingTimesUiTableFormattingInfo;
}

/**
 * 
 * @export
 * @interface StandingTimesUiTableFormattingInfo
 */
export interface StandingTimesUiTableFormattingInfo {
    /**
     * 
     * @type {Array<StandingTimesUiDisplayColumn>}
     * @memberof StandingTimesUiTableFormattingInfo
     */
    displayedColumns?: Array<StandingTimesUiDisplayColumn>;
    /**
     * 
     * @type {string}
     * @memberof StandingTimesUiTableFormattingInfo
     */
    language?: StandingTimesUiTableFormattingInfo.LanguageEnum;
}

/**
 * @export
 * @namespace StandingTimesUiTableFormattingInfo
 */
export namespace StandingTimesUiTableFormattingInfo {
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
}

/**
 * 
 * @export
 * @interface StandingTimesUiVehicle
 */
export interface StandingTimesUiVehicle {
    /**
     * 
     * @type {Array<StandingTimesUiRelation>}
     * @memberof StandingTimesUiVehicle
     */
    relations?: Array<StandingTimesUiRelation>;
    /**
     * 
     * @type {RelationStats}
     * @memberof StandingTimesUiVehicle
     */
    stats?: RelationStats;
    /**
     * 
     * @type {Vehicle}
     * @memberof StandingTimesUiVehicle
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    actionStatus?: Status.ActionStatusEnum;
    /**
     * 
     * @type {AttachmentStatus}
     * @memberof Status
     */
    attachmentStatus?: AttachmentStatus;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    freightStatus?: Status.FreightStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    stopLocationStatus?: Status.StopLocationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    transportOrderStatus?: Status.TransportOrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    transportStatus?: Status.TransportStatusEnum;
}

/**
 * @export
 * @namespace Status
 */
export namespace Status {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionStatusEnum {
        PLANNED = 'PLANNED',
        INPROGRESS = 'IN_PROGRESS',
        DONE = 'DONE',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FreightStatusEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StopLocationStatusEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TransportOrderStatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TransportStatusEnum {
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DONE = 'DONE',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StatusByVehiclePositionsConfiguration
 */
export interface StatusByVehiclePositionsConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    adjustTimeWindowByTransportOrdersOnVehicle?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    arrivalRadiusInMeter?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    arriveOnAllPossibleLoadingLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    autoExecuteTransportOrderArrivingFirstStop?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    departureRadiusInMeter?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    filterTelematicStatusMessages?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    finishTransportOrderOnArrivalAtLastStopLocation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    forceMergeAndOrderKeyForStopOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    ignoreFreightStatusForArrivalBecauseWeMaltreatTheTransportOrder?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    minimalDurationForArrivalInSeconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    recalculateApproachingStop?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    relevantDrivingLanes?: Array<StatusByVehiclePositionsConfiguration.RelevantDrivingLanesEnum>;
    /**
     * 
     * @type {number}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    relevantDrivingLanesFailOverrideTimeThresholdInMinutes?: number;
    /**
     * 
     * @type {SchedulerFinishTaskConfiguration}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    schedulerFinishTaskConfiguration?: SchedulerFinishTaskConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    setTransportOrderAsDeliveredInsteadOfDone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    skipFirstPositionForProcessing?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    stopLocationStatusCodesToArriveAtStop?: Array<StatusByVehiclePositionsConfiguration.StopLocationStatusCodesToArriveAtStopEnum>;
    /**
     * 
     * @type {TimeWindow}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    stopPlannedArrivalTimeWindow?: TimeWindow;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    stopsEarlyApproaching?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    stopsEarlyApproachingRadiusInMeter?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatusByVehiclePositionsConfiguration
     */
    useMergeAndOrderKeyForStopOrder?: boolean;
}

/**
 * @export
 * @namespace StatusByVehiclePositionsConfiguration
 */
export namespace StatusByVehiclePositionsConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum RelevantDrivingLanesEnum {
        TRUCK = 'TRUCK',
        TRAILER = 'TRAILER',
        DEVICE = 'DEVICE',
        USETRUCKIFMISSINGTRAILER = 'USE_TRUCK_IF_MISSING_TRAILER',
        USETRAILERIFMISSINGTRUCK = 'USE_TRAILER_IF_MISSING_TRUCK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StopLocationStatusCodesToArriveAtStopEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StatusField
 */
export interface StatusField {
    /**
     * 
     * @type {StatusFieldApplyWhen}
     * @memberof StatusField
     */
    applyWhen?: StatusFieldApplyWhen;
    /**
     * Textual description what the user should enter in this field
     * @type {string}
     * @memberof StatusField
     */
    description?: string;
    /**
     * Translation of the description text
     * @type {Array<Translation>}
     * @memberof StatusField
     */
    descriptionLocalization?: Array<Translation>;
    /**
     * 
     * @type {DisplayOptions}
     * @memberof StatusField
     */
    displayOptions?: DisplayOptions;
    /**
     * Internal name of the status field
     * @type {string}
     * @memberof StatusField
     */
    keyName?: string;
    /**
     * Level at which the status field is placed
     * @type {string}
     * @memberof StatusField
     */
    level?: StatusField.LevelEnum;
    /**
     * Specifies that this field shall only be shown when the state to be submitted of the specified object matches the state configured in this field. If this field has the value null, the field shall be shown always
     * @type {string}
     * @memberof StatusField
     */
    onlyForTargetState?: string;
    /**
     * If the type of the status field is 'CHOICE' or 'MULTIPLE_CHOICE' this list contains all valid choices
     * @type {Array<StatusFieldOption>}
     * @memberof StatusField
     */
    options?: Array<StatusFieldOption>;
    /**
     * Specifies the input required by the user. E.g. Date, String, Number ...
     * @type {string}
     * @memberof StatusField
     */
    type?: StatusField.TypeEnum;
    /**
     * Display name of the status field
     * @type {string}
     * @memberof StatusField
     */
    verboseName?: string;
    /**
     * Translation of the verboseName field label
     * @type {Array<Translation>}
     * @memberof StatusField
     */
    verboseNameLocalization?: Array<Translation>;
}

/**
 * @export
 * @namespace StatusField
 */
export namespace StatusField {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORT = 'TRANSPORT',
        STOPLOCATION = 'STOP_LOCATION',
        LOADINGLOCATION = 'LOADING_LOCATION',
        UNLOADINGLOCATION = 'UNLOADING_LOCATION',
        STOPACTION = 'STOP_ACTION',
        FREIGHT = 'FREIGHT',
        TRANSPORTORDERATTACHMENT = 'TRANSPORT_ORDER_ATTACHMENT',
        TRANSPORTATTACHMENT = 'TRANSPORT_ATTACHMENT',
        STOPLOCATIONATTACHMENT = 'STOP_LOCATION_ATTACHMENT',
        LOADINGLOCATIONATTACHMENT = 'LOADING_LOCATION_ATTACHMENT',
        UNLOADINGLOCATIONATTACHMENT = 'UNLOADING_LOCATION_ATTACHMENT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        INT = 'INT',
        DATE = 'DATE',
        DATETIME = 'DATETIME',
        TIME = 'TIME',
        CHOICE = 'CHOICE',
        MULTIPLECHOICE = 'MULTIPLE_CHOICE',
        TEXT = 'TEXT',
        FILE = 'FILE',
        CHECKBOX = 'CHECKBOX',
        SIGNATUREPAD = 'SIGNATURE_PAD'
    }
}

/**
 * 
 * @export
 * @interface StatusFieldApplyWhen
 */
export interface StatusFieldApplyWhen {
    /**
     * If true, this field is loaded from the target company's customWorkflowDefinitions instead of the source company's
     * @type {boolean}
     * @memberof StatusFieldApplyWhen
     */
    isTargetCompany?: boolean;
    /**
     * All rules in this list must match the transport order's immediate format data. If null the field is always copied (backwards compatible)
     * @type {Array<ImmediateFormatPathMatchRule>}
     * @memberof StatusFieldApplyWhen
     */
    rulesMatch?: Array<ImmediateFormatPathMatchRule>;
}

/**
 * 
 * @export
 * @interface StatusFieldOption
 */
export interface StatusFieldOption {
    /**
     * Display keyName of the choice item. Should be unique.
     * @type {string}
     * @memberof StatusFieldOption
     */
    name?: string;
    /**
     * Translation of the workflow options
     * @type {Array<Translation>}
     * @memberof StatusFieldOption
     */
    nameLocalization?: Array<Translation>;
    /**
     * Internal representation of this choice item. Must be unique
     * @type {string}
     * @memberof StatusFieldOption
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface StatusForwardRule
 */
export interface StatusForwardRule {
    /**
     * 
     * @type {boolean}
     * @memberof StatusForwardRule
     */
    active?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatusForwardRule
     */
    changeTypes?: Array<StatusForwardRule.ChangeTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof StatusForwardRule
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusForwardRule
     */
    direction?: StatusForwardRule.DirectionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StatusForwardRule
     */
    forward?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusForwardRule
     */
    generateVirtualAssignEventOnArrivalAtLoadingLocation?: boolean;
    /**
     * 
     * @type {Status}
     * @memberof StatusForwardRule
     */
    newStatus?: Status;
    /**
     * 
     * @type {string}
     * @memberof StatusForwardRule
     */
    stopMatcher?: StatusForwardRule.StopMatcherEnum;
}

/**
 * @export
 * @namespace StatusForwardRule
 */
export namespace StatusForwardRule {
    /**
     * @export
     * @enum {string}
     */
    export enum ChangeTypesEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DirectionEnum {
        UPWARDS = 'UPWARDS',
        DOWNWARDS = 'DOWNWARDS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StopMatcherEnum {
        LOCATION = 'LOCATION',
        STOPID = 'STOP_ID'
    }
}

/**
 * 
 * @export
 * @interface StatusJsonMonitoring
 */
export interface StatusJsonMonitoring {
    /**
     * 
     * @type {string}
     * @memberof StatusJsonMonitoring
     */
    checkMode?: StatusJsonMonitoring.CheckModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonMonitoring
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof StatusJsonMonitoring
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonMonitoring
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonMonitoring
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StatusJsonMonitoring
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonMonitoring
     */
    level?: StatusJsonMonitoring.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonMonitoring
     */
    message?: string;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof StatusJsonMonitoring
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof StatusJsonMonitoring
     */
    title?: string;
}

/**
 * @export
 * @namespace StatusJsonMonitoring
 */
export namespace StatusJsonMonitoring {
    /**
     * @export
     * @enum {string}
     */
    export enum CheckModeEnum {
        CHECKIFEXISTS = 'CHECK_IF_EXISTS',
        ALWAYSCHECK = 'ALWAYS_CHECK',
        NEVERCHECK = 'NEVER_CHECK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface StatusMapping
 */
export interface StatusMapping {
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof StatusMapping
     */
    script?: GroovyBasedMappingScript;
}

/**
 * 
 * @export
 * @interface StatusMessage
 */
export interface StatusMessage {
    /**
     * 
     * @type {string}
     * @memberof StatusMessage
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusMessage
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusMessage
     */
    title?: string;
}

/**
 * 
 * @export
 * @interface StatusMonitoringConfiguration
 */
export interface StatusMonitoringConfiguration {
    /**
     * 
     * @type {Array<StatusReportConfiguration>}
     * @memberof StatusMonitoringConfiguration
     */
    reports?: Array<StatusReportConfiguration>;
}

/**
 * 
 * @export
 * @interface StatusReportColumn
 */
export interface StatusReportColumn {
    /**
     * 
     * @type {string}
     * @memberof StatusReportColumn
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusReportColumn
     */
    viewScript?: string;
}

/**
 * 
 * @export
 * @interface StatusReportConfiguration
 */
export interface StatusReportConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof StatusReportConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusReportConfiguration
     */
    baseTime?: StatusReportConfiguration.BaseTimeEnum;
    /**
     * 
     * @type {string}
     * @memberof StatusReportConfiguration
     */
    dateTimeField?: StatusReportConfiguration.DateTimeFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof StatusReportConfiguration
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof StatusReportConfiguration
     */
    endTimeOffsetInHours?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatusReportConfiguration
     */
    mailReceivers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StatusReportConfiguration
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatusReportConfiguration
     */
    onlyPartnerIds?: Array<string>;
    /**
     * 
     * @type {Array<StatusReportColumn>}
     * @memberof StatusReportConfiguration
     */
    outputColumns?: Array<StatusReportColumn>;
    /**
     * 
     * @type {OutputFileConfig}
     * @memberof StatusReportConfiguration
     */
    outputFileConfig?: OutputFileConfig;
    /**
     * 
     * @type {SchedulerReportingPeriodicity}
     * @memberof StatusReportConfiguration
     */
    periodicity?: SchedulerReportingPeriodicity;
    /**
     * 
     * @type {string}
     * @memberof StatusReportConfiguration
     */
    reportQuery?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusReportConfiguration
     */
    reportScript?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusReportConfiguration
     */
    reportType?: StatusReportConfiguration.ReportTypeEnum;
    /**
     * sendTimes replaces periodicity. If sendTimes is null, periodicity counts.
     * @type {Array<SimpleCronTimes>}
     * @memberof StatusReportConfiguration
     */
    sendTimes?: Array<SimpleCronTimes>;
    /**
     * 
     * @type {StandingTimesUiTableFormattingInfo}
     * @memberof StatusReportConfiguration
     */
    standingTimesReportFormattingInfo?: StandingTimesUiTableFormattingInfo;
    /**
     * 
     * @type {number}
     * @memberof StatusReportConfiguration
     */
    startTimeOffsetInHours?: number;
    /**
     * 
     * @type {ReportTimeReference}
     * @memberof StatusReportConfiguration
     */
    timeReference?: ReportTimeReference;
    /**
     * 
     * @type {boolean}
     * @memberof StatusReportConfiguration
     */
    uploadReportToFtp?: boolean;
}

/**
 * @export
 * @namespace StatusReportConfiguration
 */
export namespace StatusReportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum BaseTimeEnum {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        LAST30DAYS = 'LAST30DAYS',
        LAST7DAYS = 'LAST7DAYS',
        LASTWEEK = 'LAST_WEEK',
        LASTMONTH = 'LAST_MONTH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DateTimeFieldEnum {
        CREATED = 'CREATED',
        PLANBEGIN = 'PLAN_BEGIN',
        PLANEND = 'PLAN_END',
        WITHIN = 'WITHIN',
        PLANSTARTORADVISEDFROM = 'PLANSTART_OR_ADVISEDFROM',
        ACTUALBEGIN = 'ACTUAL_BEGIN',
        ACTUALEND = 'ACTUAL_END',
        ACTUALWITHIN = 'ACTUAL_WITHIN'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ELFLEINVDLREPORT = 'ELFLEIN_VDL_REPORT',
        ELFLEINVDLERRORREPORT = 'ELFLEIN_VDL_ERROR_REPORT',
        REPORTV2 = 'REPORT_V2',
        STANDINGTIMESREPORT = 'STANDING_TIMES_REPORT',
        DELIVERYREPORT = 'DELIVERY_REPORT'
    }
}

/**
 * 
 * @export
 * @interface StatusText
 */
export interface StatusText {
    /**
     * 
     * @type {string}
     * @memberof StatusText
     */
    recipientAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusText
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof StatusText
     */
    timestamp?: Date;
}

/**
 * 
 * @export
 * @interface StatusValidationConfiguration
 */
export interface StatusValidationConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof StatusValidationConfiguration
     */
    disableNotificationForInputMissing?: boolean;
    /**
     * 
     * @type {MailContent}
     * @memberof StatusValidationConfiguration
     */
    mailContent?: MailContent;
    /**
     * sets how old the TransportOrders in the mail can be, calculated: TO.planEnd AFTER (now() - planEndDaysAgo) 
     * @type {number}
     * @memberof StatusValidationConfiguration
     */
    planEndDaysAgo?: number;
    /**
     * 
     * @type {Array<SimpleCronTimes>}
     * @memberof StatusValidationConfiguration
     */
    sendReminderMailTimes?: Array<SimpleCronTimes>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatusValidationConfiguration
     */
    statusValidationReceiverMails?: Array<string>;
}

/**
 * 
 * @export
 * @interface StatusValidationWarningIdentification
 */
export interface StatusValidationWarningIdentification {
    /**
     * 
     * @type {string}
     * @memberof StatusValidationWarningIdentification
     */
    toId?: string;
    /**
     * 
     * @type {Array<WarningIdentifier>}
     * @memberof StatusValidationWarningIdentification
     */
    warningIdentifiers?: Array<WarningIdentifier>;
}

/**
 * 
 * @export
 * @interface StopAction
 */
export interface StopAction {
    /**
     * Textual description of the action which should be performed
     * @type {string}
     * @memberof StopAction
     */
    actionDescription?: string;
    /**
     * Unique id within the stop location
     * @type {string}
     * @memberof StopAction
     */
    actionId?: string;
    /**
     * List of key value pairs containing additional information
     * @type {Array<AdditionalDataEntry>}
     * @memberof StopAction
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * Documents attached to this stop action
     * @type {Array<Attachment>}
     * @memberof StopAction
     */
    attachments?: Array<Attachment>;
    /**
     * Additional textual comments
     * @type {string}
     * @memberof StopAction
     */
    comment?: string;
    /**
     * Reference  of fright items if freight is affected by this action
     * @type {Array<string>}
     * @memberof StopAction
     */
    freightIds?: Array<string>;
    /**
     * Kind of action to be executed
     * @type {string}
     * @memberof StopAction
     */
    kind?: StopAction.KindEnum;
    /**
     * Planned start time of this action
     * @type {Date}
     * @memberof StopAction
     */
    planStart?: Date;
    /**
     * Planned end time of this action
     * @type {Date}
     * @memberof StopAction
     */
    planStop?: Date;
    /**
     * 
     * @type {StopActionStatus}
     * @memberof StopAction
     */
    status?: StopActionStatus;
}

/**
 * @export
 * @namespace StopAction
 */
export namespace StopAction {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
}

/**
 * 
 * @export
 * @interface StopActionMapping
 */
export interface StopActionMapping {
    /**
     * 
     * @type {string}
     * @memberof StopActionMapping
     */
    actionDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof StopActionMapping
     */
    actionId?: string;
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof StopActionMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof StopActionMapping
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof StopActionMapping
     */
    planStart?: string;
    /**
     * 
     * @type {string}
     * @memberof StopActionMapping
     */
    planStop?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof StopActionMapping
     */
    script?: GroovyBasedMappingScript;
}

/**
 * 
 * @export
 * @interface StopActionStatus
 */
export interface StopActionStatus {
    /**
     * Additional key-value-pairs associated with this status
     * @type {Array<AdditionalDataEntry>}
     * @memberof StopActionStatus
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {Date}
     * @memberof StopActionStatus
     */
    canceledTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopActionStatus
     */
    doneTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopActionStatus
     */
    inProgressTimestamp?: Date;
    /**
     * 
     * @type {GpsPosition}
     * @memberof StopActionStatus
     */
    location?: GpsPosition;
    /**
     * 
     * @type {Origin}
     * @memberof StopActionStatus
     */
    origin?: Origin;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatus
     */
    sender?: string;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatus
     */
    statusCode?: StopActionStatus.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof StopActionStatus
     */
    timestamp?: Date;
}

/**
 * @export
 * @namespace StopActionStatus
 */
export namespace StopActionStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        INPROGRESS = 'IN_PROGRESS',
        DONE = 'DONE',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StopActionStatusMapping
 */
export interface StopActionStatusMapping {
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusMapping
     */
    actionKind?: StopActionStatusMapping.ActionKindEnum;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusMapping
     */
    applyWhen?: string;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusMapping
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusMapping
     */
    statusCode?: StopActionStatusMapping.StatusCodeEnum;
    /**
     * 
     * @type {LisStatusFields}
     * @memberof StopActionStatusMapping
     */
    statusFields?: LisStatusFields;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusMapping
     */
    targetStatus?: string;
}

/**
 * @export
 * @namespace StopActionStatusMapping
 */
export namespace StopActionStatusMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionKindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        INPROGRESS = 'IN_PROGRESS',
        DONE = 'DONE',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StopActionStatusRequest
 */
export interface StopActionStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusRequest
     */
    actionId?: string;
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof StopActionStatusRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusRequest
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StopActionStatusRequest
     */
    forceOverrideDependentStates?: boolean;
    /**
     * 
     * @type {Origin}
     * @memberof StopActionStatusRequest
     */
    origin?: Origin;
    /**
     * The status which should be submitted
     * @type {string}
     * @memberof StopActionStatusRequest
     */
    statusCode?: StopActionStatusRequest.StatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusRequest
     */
    stopId?: string;
    /**
     * 
     * @type {Date}
     * @memberof StopActionStatusRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusRequest
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof StopActionStatusRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace StopActionStatusRequest
 */
export namespace StopActionStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        INPROGRESS = 'IN_PROGRESS',
        DONE = 'DONE',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StopDelayThresholdsConfiguration
 */
export interface StopDelayThresholdsConfiguration {
    /**
     * Maximum delay in minutes that is still considered on time (inclusive). Default: 5.
     * @type {number}
     * @memberof StopDelayThresholdsConfiguration
     */
    onTimeToleranceMin?: number;
    /**
     * Delay in minutes at which the warning level starts (inclusive). Default: 6. Critical starts above warningThresholdMaxMin.
     * @type {number}
     * @memberof StopDelayThresholdsConfiguration
     */
    warningThresholdMaxMin?: number;
}

/**
 * 
 * @export
 * @interface StopDistanceInfo
 */
export interface StopDistanceInfo {
    /**
     * 
     * @type {number}
     * @memberof StopDistanceInfo
     */
    distanceInMeters?: number;
    /**
     * 
     * @type {string}
     * @memberof StopDistanceInfo
     */
    fromStop?: string;
    /**
     * 
     * @type {string}
     * @memberof StopDistanceInfo
     */
    toStop?: string;
}

/**
 * 
 * @export
 * @interface StopEta
 */
export interface StopEta {
    /**
     * 
     * @type {Date}
     * @memberof StopEta
     */
    eta?: Date;
    /**
     * 
     * @type {string}
     * @memberof StopEta
     */
    liveLink?: string;
    /**
     * 
     * @type {number}
     * @memberof StopEta
     */
    stopNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof StopEta
     */
    transportNumber?: number;
}

/**
 * 
 * @export
 * @interface StopEtaPatchRequest
 */
export interface StopEtaPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof StopEtaPatchRequest
     */
    backendToEtaEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof StopEtaPatchRequest
     */
    companyId?: string;
    /**
     * 
     * @type {Driver}
     * @memberof StopEtaPatchRequest
     */
    driver?: Driver;
    /**
     * 
     * @type {string}
     * @memberof StopEtaPatchRequest
     */
    errorString?: string;
    /**
     * 
     * @type {Eta}
     * @memberof StopEtaPatchRequest
     */
    eta?: Eta;
    /**
     * 
     * @type {ExternalStopIdentifier}
     * @memberof StopEtaPatchRequest
     */
    externalStopIdentifier?: ExternalStopIdentifier;
    /**
     * 
     * @type {StopIdentifier}
     * @memberof StopEtaPatchRequest
     */
    stopIdentifier?: StopIdentifier;
    /**
     * 
     * @type {Vehicle}
     * @memberof StopEtaPatchRequest
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface StopEtaReport
 */
export interface StopEtaReport {
    /**
     * 
     * @type {Date}
     * @memberof StopEtaReport
     */
    arrivedStatusTimestamp?: Date;
    /**
     * 
     * @type {Array<EtaCalculation>}
     * @memberof StopEtaReport
     */
    etaCalculations?: Array<EtaCalculation>;
    /**
     * 
     * @type {Date}
     * @memberof StopEtaReport
     */
    lastEta?: Date;
    /**
     * 
     * @type {Number}
     * @memberof StopEtaReport
     */
    mergeAndOrderKey?: Number;
    /**
     * 
     * @type {Date}
     * @memberof StopEtaReport
     */
    planArrive?: Date;
    /**
     * 
     * @type {number}
     * @memberof StopEtaReport
     */
    previousStopMergeAndOrderKey?: number;
    /**
     * 
     * @type {string}
     * @memberof StopEtaReport
     */
    previousStopUniqueLocationId?: string;
    /**
     * 
     * @type {string}
     * @memberof StopEtaReport
     */
    uniqueLocationId?: string;
}

/**
 * 
 * @export
 * @interface StopEtaResult
 */
export interface StopEtaResult {
    /**
     * 
     * @type {Date}
     * @memberof StopEtaResult
     */
    eta?: Date;
    /**
     * 
     * @type {string}
     * @memberof StopEtaResult
     */
    liveLink?: string;
    /**
     * 
     * @type {PositionRequest}
     * @memberof StopEtaResult
     */
    relatedPosition?: PositionRequest;
    /**
     * 
     * @type {Date}
     * @memberof StopEtaResult
     */
    relatedTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof StopEtaResult
     */
    source?: StopEtaResult.SourceEnum;
}

/**
 * @export
 * @namespace StopEtaResult
 */
export namespace StopEtaResult {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        PTV = 'PTV',
        GRAPHHOPPER = 'GRAPHHOPPER',
        OSRM = 'OSRM',
        COMPANY = 'COMPANY',
        NONE = 'NONE',
        ORS = 'ORS',
        CUSTOM = 'CUSTOM'
    }
}

/**
 * 
 * @export
 * @interface StopGeoStatus
 */
export interface StopGeoStatus {
    /**
     * 
     * @type {Array<ShortestFoundDistanceToStop>}
     * @memberof StopGeoStatus
     */
    shortestFoundDistanceToStops?: Array<ShortestFoundDistanceToStop>;
    /**
     * 
     * @type {string}
     * @memberof StopGeoStatus
     */
    status?: StopGeoStatus.StatusEnum;
}

/**
 * @export
 * @namespace StopGeoStatus
 */
export namespace StopGeoStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        PLANNED = 'PLANNED',
        APPROACHING = 'APPROACHING',
        APPROACHINGCANCELED = 'APPROACHING_CANCELED',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StopIdentifier
 */
export interface StopIdentifier {
    /**
     * 
     * @type {string}
     * @memberof StopIdentifier
     */
    stopId?: string;
    /**
     * 
     * @type {string}
     * @memberof StopIdentifier
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof StopIdentifier
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface StopListConfiguration
 */
export interface StopListConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof StopListConfiguration
     */
    showContainmentName?: boolean;
}

/**
 * 
 * @export
 * @interface StopLocation
 */
export interface StopLocation {
    /**
     * List of actions to execute at this stop location
     * @type {Array<StopAction>}
     * @memberof StopLocation
     */
    actions?: Array<StopAction>;
    /**
     * Additional key-value pairs regarding this stop location
     * @type {Array<AdditionalDataEntry>}
     * @memberof StopLocation
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * Documents attached to this stop location.
     * @type {Array<Attachment>}
     * @memberof StopLocation
     */
    attachments?: Array<Attachment>;
    /**
     * City where to stop
     * @type {string}
     * @memberof StopLocation
     */
    city?: string;
    /**
     * Comment regarding this stop location
     * @type {string}
     * @memberof StopLocation
     */
    comment?: string;
    /**
     * 
     * @type {Contact}
     * @memberof StopLocation
     */
    contact?: Contact;
    /**
     * 
     * @type {Coordinates}
     * @memberof StopLocation
     */
    coordinates?: Coordinates;
    /**
     * country code of this stop location. Preferably two letter ISO 3166
     * @type {string}
     * @memberof StopLocation
     */
    countryCode?: string;
    /**
     * 
     * @type {Eta}
     * @memberof StopLocation
     */
    eta?: Eta;
    /**
     * external identifier of this stop location
     * @type {string}
     * @memberof StopLocation
     */
    externalStopId?: string;
    /**
     * 
     * @type {StopGeoStatus}
     * @memberof StopLocation
     */
    geoStatus?: StopGeoStatus;
    /**
     * The global location number issued by the GS1 if available
     * @type {string}
     * @memberof StopLocation
     */
    gs1GlobalLocationNumber?: string;
    /**
     * House number
     * @type {string}
     * @memberof StopLocation
     */
    houseNr?: string;
    /**
     * Flag that indicates that stop location address is complete or not
     * @type {boolean}
     * @memberof StopLocation
     */
    incompleteAddress?: boolean;
    /**
     * Key to describe stop order and possible collapse of stops
     * @type {number}
     * @memberof StopLocation
     */
    mergeAndOrderKey?: number;
    /**
     * Mulipolygon geofence for this stop location
     * @type {string}
     * @memberof StopLocation
     */
    multiPolygonGeofence?: string;
    /**
     * Name 1, e.g. Company name
     * @type {string}
     * @memberof StopLocation
     */
    name?: string;
    /**
     * Name 2, e.g. Department name
     * @type {string}
     * @memberof StopLocation
     */
    name2?: string;
    /**
     * Opening Hours of this stop location
     * @type {Array<OpeningHour>}
     * @memberof StopLocation
     */
    openingHours?: Array<OpeningHour>;
    /**
     * Planned earliest arrival time
     * @type {Date}
     * @memberof StopLocation
     */
    planArrive?: Date;
    /**
     * Planned latest departure time
     * @type {Date}
     * @memberof StopLocation
     */
    planDepart?: Date;
    /**
     * Raw string of stop location address
     * @type {string}
     * @memberof StopLocation
     */
    rawAddressString?: string;
    /**
     * 
     * @type {StopLocationStatus}
     * @memberof StopLocation
     */
    status?: StopLocationStatus;
    /**
     * identifier of this stop location. Must be unique per transport
     * @type {string}
     * @memberof StopLocation
     */
    stopId?: string;
    /**
     * Street name of the stop location
     * @type {string}
     * @memberof StopLocation
     */
    street?: string;
    /**
     * Holds the calculated hash of the location identified by country, city, street and  zipcode
     * @type {string}
     * @memberof StopLocation
     */
    uniqueLocationId?: string;
    /**
     * Zip Code of the city
     * @type {string}
     * @memberof StopLocation
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface StopLocationImportConfiguration
 */
export interface StopLocationImportConfiguration {
    /**
     * 
     * @type {string}
     * @memberof StopLocationImportConfiguration
     */
    planBeginSource?: StopLocationImportConfiguration.PlanBeginSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof StopLocationImportConfiguration
     */
    planEndSource?: StopLocationImportConfiguration.PlanEndSourceEnum;
}

/**
 * @export
 * @namespace StopLocationImportConfiguration
 */
export namespace StopLocationImportConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum PlanBeginSourceEnum {
        RSTK = 'RSTK',
        TO = 'TO'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PlanEndSourceEnum {
        RSTK = 'RSTK',
        TO = 'TO'
    }
}

/**
 * 
 * @export
 * @interface StopLocationMapping
 */
export interface StopLocationMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof StopLocationMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    houseNr?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    longitude?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    name2?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    openingHoursExportMode?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    openingHoursFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    openingHoursTo?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    planArrive?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    planDepart?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof StopLocationMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationMapping
     */
    shouldAssignStopIdFromAddressHash?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationMapping
     */
    shouldAssignStopIdFromAddressHashAndAction?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationMapping
     */
    shouldAutoAssignStopId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationMapping
     */
    shouldExportOpeningHours?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationMapping
     */
    shouldImportOpeningHours?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationMapping
     */
    shouldSuppressAddressInPresenceOfGLN?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    stopId?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationMapping
     */
    zipCode?: string;
}

/**
 * 
 * @export
 * @interface StopLocationStatus
 */
export interface StopLocationStatus {
    /**
     * Additional key-value-pairs associated with this status
     * @type {Array<AdditionalDataEntry>}
     * @memberof StopLocationStatus
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * The earliest time the carrier and the sender/receiver of the goods agreed on
     * @type {Date}
     * @memberof StopLocationStatus
     */
    advisedFromTimestamp?: Date;
    /**
     * The latest time the carrier and the sender/receiver of the goods agreed on
     * @type {Date}
     * @memberof StopLocationStatus
     */
    advisedTillTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatus
     */
    approachingTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof StopLocationStatus
     */
    arrivalGeoFence?: string;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatus
     */
    arrivedTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatus
     */
    canceledTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatus
     */
    departedTimestamp?: Date;
    /**
     * 
     * @type {GpsPosition}
     * @memberof StopLocationStatus
     */
    location?: GpsPosition;
    /**
     * 
     * @type {Origin}
     * @memberof StopLocationStatus
     */
    origin?: Origin;
    /**
     * 
     * @type {string}
     * @memberof StopLocationStatus
     */
    sender?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationStatus
     */
    statusCode?: StopLocationStatus.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatus
     */
    timestamp?: Date;
}

/**
 * @export
 * @namespace StopLocationStatus
 */
export namespace StopLocationStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StopLocationStatusRequest
 */
export interface StopLocationStatusRequest {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof StopLocationStatusRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof StopLocationStatusRequest
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationStatusRequest
     */
    forceOverrideDependentStates?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationStatusRequest
     */
    forceOverrideTimestamp?: boolean;
    /**
     * 
     * @type {Origin}
     * @memberof StopLocationStatusRequest
     */
    origin?: Origin;
    /**
     * The status which should be submitted
     * @type {string}
     * @memberof StopLocationStatusRequest
     */
    statusCode?: StopLocationStatusRequest.StatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof StopLocationStatusRequest
     */
    stopId?: string;
    /**
     * 
     * @type {StopMetaDataIdentifier}
     * @memberof StopLocationStatusRequest
     */
    stopMetaDataIdentifier?: StopMetaDataIdentifier;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatusRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatusRequest
     */
    timestampFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopLocationStatusRequest
     */
    timestampTill?: Date;
    /**
     * 
     * @type {string}
     * @memberof StopLocationStatusRequest
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof StopLocationStatusRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace StopLocationStatusRequest
 */
export namespace StopLocationStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StopLocationViewConfiguration
 */
export interface StopLocationViewConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationViewConfiguration
     */
    canUploadAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationViewConfiguration
     */
    displayStopLocationAttachments?: boolean;
    /**
     * 
     * @type {StopLocationViewFreightTableConfig}
     * @memberof StopLocationViewConfiguration
     */
    freightTable?: StopLocationViewFreightTableConfig;
    /**
     * 
     * @type {Array<StopLocationViewWorkflowFreightTableOverride>}
     * @memberof StopLocationViewConfiguration
     */
    workflowFreightTableOverrides?: Array<StopLocationViewWorkflowFreightTableOverride>;
}

/**
 * 
 * @export
 * @interface StopLocationViewFreightTableConfig
 */
export interface StopLocationViewFreightTableConfig {
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationViewFreightTableConfig
     */
    customWorkflowFieldsShowName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationViewFreightTableConfig
     */
    showContainmentColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopLocationViewFreightTableConfig
     */
    showDeliveryNumberColumn?: boolean;
}

/**
 * 
 * @export
 * @interface StopLocationViewWorkflowFreightTableOverride
 */
export interface StopLocationViewWorkflowFreightTableOverride {
    /**
     * 
     * @type {StopLocationViewFreightTableConfig}
     * @memberof StopLocationViewWorkflowFreightTableOverride
     */
    freightTable?: StopLocationViewFreightTableConfig;
    /**
     * 
     * @type {string}
     * @memberof StopLocationViewWorkflowFreightTableOverride
     */
    workflow?: string;
}

/**
 * 
 * @export
 * @interface StopMergeAndOrderConfiguration
 */
export interface StopMergeAndOrderConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof StopMergeAndOrderConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StopMergeAndOrderConfiguration
     */
    maximumAllowedNonOverlapInMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StopMergeAndOrderConfiguration
     */
    mergeEvenWithNonMatchingActions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopMergeAndOrderConfiguration
     */
    mergeOnlyConsecutiveStops?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopMergeAndOrderConfiguration
     */
    mergeOverlappingStops?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopMergeAndOrderConfiguration
     */
    overrideIncompleteMergeAndOrderKeys?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopMergeAndOrderConfiguration
     */
    residenceTimesHaveToOverlap?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopMergeAndOrderConfiguration
     */
    shouldMergeStops?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StopMergeAndOrderConfiguration
     */
    sortStopsBy?: StopMergeAndOrderConfiguration.SortStopsByEnum;
}

/**
 * @export
 * @namespace StopMergeAndOrderConfiguration
 */
export namespace StopMergeAndOrderConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum SortStopsByEnum {
        PLANNEDARRIVE = 'PLANNED_ARRIVE',
        PLANNEDDEPART = 'PLANNED_DEPART',
        BESTGUESS = 'BEST_GUESS',
        BYSTOPINDEX = 'BY_STOP_INDEX'
    }
}

/**
 * 
 * @export
 * @interface StopMetaDataIdentifier
 */
export interface StopMetaDataIdentifier {
    /**
     * 
     * @type {boolean}
     * @memberof StopMetaDataIdentifier
     */
    ignoreArrivalTimes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopMetaDataIdentifier
     */
    ignoreStopActionKind?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StopMetaDataIdentifier
     */
    kind?: Array<StopMetaDataIdentifier.KindEnum>;
    /**
     * 
     * @type {number}
     * @memberof StopMetaDataIdentifier
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof StopMetaDataIdentifier
     */
    longitude?: number;
    /**
     * Geofence (multipolygon) of the referenced stop. When the target stop also carries a geofence, both polygons are matched by overlap instead of relying on the (possibly outside-of-geofence) coordinate point alone.
     * @type {string}
     * @memberof StopMetaDataIdentifier
     */
    multiPolygonGeofence?: string;
    /**
     * 
     * @type {Date}
     * @memberof StopMetaDataIdentifier
     */
    planArrive?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StopMetaDataIdentifier
     */
    planDepart?: Date;
}

/**
 * @export
 * @namespace StopMetaDataIdentifier
 */
export namespace StopMetaDataIdentifier {
    /**
     * @export
     * @enum {string}
     */
    export enum KindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
}

/**
 * 
 * @export
 * @interface StopStatusMapping
 */
export interface StopStatusMapping {
    /**
     * 
     * @type {string}
     * @memberof StopStatusMapping
     */
    actionKind?: StopStatusMapping.ActionKindEnum;
    /**
     * 
     * @type {string}
     * @memberof StopStatusMapping
     */
    applyWhen?: string;
    /**
     * 
     * @type {string}
     * @memberof StopStatusMapping
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StopStatusMapping
     */
    statusCode?: StopStatusMapping.StatusCodeEnum;
    /**
     * 
     * @type {LisStatusFields}
     * @memberof StopStatusMapping
     */
    statusFields?: LisStatusFields;
    /**
     * 
     * @type {string}
     * @memberof StopStatusMapping
     */
    targetStatus?: string;
}

/**
 * @export
 * @namespace StopStatusMapping
 */
export namespace StopStatusMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionKindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
}

/**
 * 
 * @export
 * @interface StopStatusWorkflowConfiguration
 */
export interface StopStatusWorkflowConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    askForEtaWhenTruckIsApproaching?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    openReportDeviationModalOnDeparture?: boolean;
    /**
     * 
     * @type {ReportDeviationModalConfiguration}
     * @memberof StopStatusWorkflowConfiguration
     */
    reportDeviationModal?: ReportDeviationModalConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    selectOrEnterVehicleOnActivate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    showArrivedDepartedButtonsInStopView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    showCancelStopLocationButton?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    showFinishTourButton?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    showReportDeviationButton?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StopStatusWorkflowConfiguration
     */
    showSendToTruckButtonOnActivate?: boolean;
}

/**
 * 
 * @export
 * @interface StopWithResidenceTimes
 */
export interface StopWithResidenceTimes {
    /**
     * 
     * @type {Array<ResidenceTime>}
     * @memberof StopWithResidenceTimes
     */
    residenceTimes?: Array<ResidenceTime>;
    /**
     * 
     * @type {DetermineResidenceTimesResult}
     * @memberof StopWithResidenceTimes
     */
    residenceTimesResult?: DetermineResidenceTimesResult;
    /**
     * 
     * @type {DetermineResidenceTimesResult}
     * @memberof StopWithResidenceTimes
     */
    residenceTimesResultWholeTrackingTime?: DetermineResidenceTimesResult;
    /**
     * 
     * @type {StopLocation}
     * @memberof StopWithResidenceTimes
     */
    stopLocation?: StopLocation;
}

/**
 * 
 * @export
 * @interface Storage
 */
export interface Storage {
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface SubCompanyMapping
 */
export interface SubCompanyMapping {
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    addressKind?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    assignedDeviceLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    assignedDeviceMailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    assignedDevicePhoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    assignedDeviceVerboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    externalPartnerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubCompanyMapping
     */
    mergeShipmentsWithinBorderoInMainTransportOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    planLoadAtDepotDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    planLoadAtDepotTimeFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    planLoadAtDepotTimeTill?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    planUnloadAtDepotDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    planUnloadAtDepotTimeFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    planUnloadAtDepotTimeTill?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubCompanyMapping
     */
    shouldImportAssignedDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubCompanyMapping
     */
    shouldInsertDepot?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubCompanyMapping
     */
    splitBorderoInDifferentTransportOrders?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubCompanyMapping
     */
    subCompanyName?: string;
}

/**
 * 
 * @export
 * @interface SuperUserTwoFactorAuthenticationStatusResponse
 */
export interface SuperUserTwoFactorAuthenticationStatusResponse {
    /**
     * 
     * @type {Array<SuperUsersTwoFactorAuthenticationStatus>}
     * @memberof SuperUserTwoFactorAuthenticationStatusResponse
     */
    superUsersList?: Array<SuperUsersTwoFactorAuthenticationStatus>;
}

/**
 * 
 * @export
 * @interface SuperUsersTwoFactorAuthenticationStatus
 */
export interface SuperUsersTwoFactorAuthenticationStatus {
    /**
     * 
     * @type {boolean}
     * @memberof SuperUsersTwoFactorAuthenticationStatus
     */
    twoFactorActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuperUsersTwoFactorAuthenticationStatus
     */
    userEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperUsersTwoFactorAuthenticationStatus
     */
    userFirstName?: string;
}

/**
 * 
 * @export
 * @interface SwitchActiveTransportOrderConfigTestsRequest
 */
export interface SwitchActiveTransportOrderConfigTestsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SwitchActiveTransportOrderConfigTestsRequest
     */
    newActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SwitchActiveTransportOrderConfigTestsRequest
     */
    testId?: string;
}

/**
 * 
 * @export
 * @interface SwitchActiveTransportOrderConfigTestsResponse
 */
export interface SwitchActiveTransportOrderConfigTestsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SwitchActiveTransportOrderConfigTestsResponse
     */
    successful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SwitchActiveTransportOrderConfigTestsResponse
     */
    testId?: string;
}

/**
 * 
 * @export
 * @interface SystemStatusMessage
 */
export interface SystemStatusMessage {
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessage
     */
    _id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemStatusMessage
     */
    affectedTransportOrders?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemStatusMessage
     */
    companyIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof SystemStatusMessage
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessage
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof SystemStatusMessage
     */
    endTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SystemStatusMessage
     */
    forCustomerToSee?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessage
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SystemStatusMessage
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SystemStatusMessage
     */
    lastOccurrence?: Date;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessage
     */
    level?: SystemStatusMessage.LevelEnum;
    /**
     * 
     * @type {StatusMessage}
     * @memberof SystemStatusMessage
     */
    message?: StatusMessage;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof SystemStatusMessage
     */
    options?: SystemStatusOptions;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemStatusMessage
     */
    queuedEventIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof SystemStatusMessage
     */
    startTime?: Date;
}

/**
 * @export
 * @namespace SystemStatusMessage
 */
export namespace SystemStatusMessage {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface SystemStatusMessagesResponse
 */
export interface SystemStatusMessagesResponse {
    /**
     * 
     * @type {number}
     * @memberof SystemStatusMessagesResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<SystemStatusMessage>}
     * @memberof SystemStatusMessagesResponse
     */
    messages?: Array<SystemStatusMessage>;
}

/**
 * 
 * @export
 * @interface SystemStatusMonitoringNotificationConfiguration
 */
export interface SystemStatusMonitoringNotificationConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemStatusMonitoringNotificationConfiguration
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SystemStatusMonitoringNotificationConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMonitoringNotificationConfiguration
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemStatusMonitoringNotificationConfiguration
     */
    logLevels?: Array<SystemStatusMonitoringNotificationConfiguration.LogLevelsEnum>;
}

/**
 * @export
 * @namespace SystemStatusMonitoringNotificationConfiguration
 */
export namespace SystemStatusMonitoringNotificationConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum LogLevelsEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
}

/**
 * 
 * @export
 * @interface SystemStatusOptions
 */
export interface SystemStatusOptions {
    /**
     * 
     * @type {boolean}
     * @memberof SystemStatusOptions
     */
    endStatusMessageWhenAllAffectedTransportOrdersAreDone?: boolean;
}

/**
 * 
 * @export
 * @interface TargetCompanyContractDetails
 */
export interface TargetCompanyContractDetails {
    /**
     * 
     * @type {Array<string>}
     * @memberof TargetCompanyContractDetails
     */
    excludeSourceCompanyIds?: Array<string>;
    /**
     * 
     * @type {InvoiceFilterOptions}
     * @memberof TargetCompanyContractDetails
     */
    filter?: InvoiceFilterOptions;
    /**
     * 
     * @type {Array<string>}
     * @memberof TargetCompanyContractDetails
     */
    includeSourceCompanyIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TargetCompanyContractDetails
     */
    shouldCountOrders?: boolean;
}

/**
 * 
 * @export
 * @interface TargetCompanyMapping
 */
export interface TargetCompanyMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof TargetCompanyMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    addressKind?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    assignedDeviceLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    assignedDeviceMailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    assignedDevicePhoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    assignedDeviceVerboseName?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    externalTargetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    onTargetCompanyMappingScript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TargetCompanyMapping
     */
    shouldImportCompanyNameAsComment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TargetCompanyMapping
     */
    targetCompanyName?: string;
}

/**
 * 
 * @export
 * @interface TargetUserRequest
 */
export interface TargetUserRequest {
    /**
     * 
     * @type {string}
     * @memberof TargetUserRequest
     */
    userId?: string;
}

/**
 * 
 * @export
 * @interface TaskConfigurations
 */
export interface TaskConfigurations {
    /**
     * 
     * @type {FinishToursTaskConfiguration}
     * @memberof TaskConfigurations
     */
    finishToursTaskConfiguration?: FinishToursTaskConfiguration;
}

/**
 * 
 * @export
 * @interface TaskOptions
 */
export interface TaskOptions {
    /**
     * 
     * @type {boolean}
     * @memberof TaskOptions
     */
    forceInstantRun?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskOptions
     */
    taskName?: TaskOptions.TaskNameEnum;
}

/**
 * @export
 * @namespace TaskOptions
 */
export namespace TaskOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum TaskNameEnum {
        CleanOldSharesOfSingleTour = 'CleanOldSharesOfSingleTour',
        CheckDbConsistency = 'CheckDbConsistency',
        FinishUncompletedGeoStatusTours = 'FinishUncompletedGeoStatusTours',
        MissingStatusMessageEmail = 'MissingStatusMessageEmail',
        ObserverArrivalNotificationTask = 'ObserverArrivalNotificationTask',
        DelayedArrivalNotificationTask = 'DelayedArrivalNotificationTask',
        ArrivalNotificationTask = 'ArrivalNotificationTask',
        CleanOldDataSetsTask = 'CleanOldDataSetsTask',
        SchedulerHealtCheck = 'SchedulerHealtCheck',
        SchedulerReportingTask = 'SchedulerReportingTask',
        FinishToursTask = 'FinishToursTask',
        CompanyLevelMonitoringTask = 'CompanyLevelMonitoringTask',
        MailgunFailMonitorTask = 'MailgunFailMonitorTask',
        SendStatusValidationMails = 'SendStatusValidationMails',
        SmsMonitoringTask = 'SmsMonitoringTask',
        DailyPartnerCollabReportTask = 'DailyPartnerCollabReportTask',
        ResendFailedMessagesTask = 'ResendFailedMessagesTask',
        EtaQualityReportTask = 'EtaQualityReportTask',
        OrderCreationTask = 'OrderCreationTask',
        SmsTimeoutNotificationTask = 'SmsTimeoutNotificationTask'
    }
}

/**
 * 
 * @export
 * @interface TelematicData
 */
export interface TelematicData {
    /**
     * 
     * @type {string}
     * @memberof TelematicData
     */
    companyId?: string;
    /**
     * 
     * @type {Array<PositionRequest>}
     * @memberof TelematicData
     */
    positionRequests?: Array<PositionRequest>;
}

/**
 * 
 * @export
 * @interface TelematicDataResponse
 */
export interface TelematicDataResponse {
    /**
     * 
     * @type {number}
     * @memberof TelematicDataResponse
     */
    addedPositions?: number;
}

/**
 * 
 * @export
 * @interface TelematicState
 */
export interface TelematicState {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof TelematicState
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {Date}
     * @memberof TelematicState
     */
    arrivedOnDeviceTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TelematicState
     */
    canceledTimestamp?: Date;
    /**
     * 
     * @type {GpsPosition}
     * @memberof TelematicState
     */
    location?: GpsPosition;
    /**
     * 
     * @type {Date}
     * @memberof TelematicState
     */
    modifiedTimestamp?: Date;
    /**
     * 
     * @type {Origin}
     * @memberof TelematicState
     */
    origin?: Origin;
    /**
     * 
     * @type {Date}
     * @memberof TelematicState
     */
    readByDriverTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TelematicState
     */
    sentTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof TelematicState
     */
    statusCode?: TelematicState.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof TelematicState
     */
    timestamp?: Date;
    /**
     * 
     * @type {Vehicle}
     * @memberof TelematicState
     */
    vehicle?: Vehicle;
}

/**
 * @export
 * @namespace TelematicState
 */
export namespace TelematicState {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        SENT = 'SENT',
        ARRIVEDONDEVICE = 'ARRIVED_ON_DEVICE',
        READBYDRIVER = 'READ_BY_DRIVER',
        CANCELED = 'CANCELED',
        MODIFIED = 'MODIFIED'
    }
}

/**
 * 
 * @export
 * @interface TelematicTourMapRequest
 */
export interface TelematicTourMapRequest {
    /**
     * 
     * @type {boolean}
     * @memberof TelematicTourMapRequest
     */
    allowMappingOfMultipleTransportOrdersToSingleTelematicTour?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TelematicTourMapRequest
     */
    assignTrailer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TelematicTourMapRequest
     */
    assignVehicle?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TelematicTourMapRequest
     */
    daysToMap?: number;
    /**
     * 
     * @type {string}
     * @memberof TelematicTourMapRequest
     */
    mappingScript?: string;
    /**
     * 
     * @type {Origin}
     * @memberof TelematicTourMapRequest
     */
    origin?: Origin;
    /**
     * 
     * @type {boolean}
     * @memberof TelematicTourMapRequest
     */
    setTelematicId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TelematicTourMapRequest
     */
    targetCompanyId?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TelematicTourMapRequest
     */
    transportOrderToMap?: TransportOrder;
    /**
     * 
     * @type {boolean}
     * @memberof TelematicTourMapRequest
     */
    tryMappedTransportOrdersAndIgnoreState?: boolean;
}

/**
 * 
 * @export
 * @interface TelematicTourMapResponse
 */
export interface TelematicTourMapResponse {
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof TelematicTourMapResponse
     */
    mappedTransportOrders?: Array<TransportOrder>;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TelematicTourMapResponse
     */
    telematicTour?: TransportOrder;
}

/**
 * 
 * @export
 * @interface TelematicTransportOrderStatusRequest
 */
export interface TelematicTransportOrderStatusRequest {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof TelematicTransportOrderStatusRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof TelematicTransportOrderStatusRequest
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TelematicTransportOrderStatusRequest
     */
    forceOverrideDependentStates?: boolean;
    /**
     * 
     * @type {Origin}
     * @memberof TelematicTransportOrderStatusRequest
     */
    origin?: Origin;
    /**
     * The status which should be submitted
     * @type {string}
     * @memberof TelematicTransportOrderStatusRequest
     */
    statusCode?: TelematicTransportOrderStatusRequest.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof TelematicTransportOrderStatusRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof TelematicTransportOrderStatusRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace TelematicTransportOrderStatusRequest
 */
export namespace TelematicTransportOrderStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        SENT = 'SENT',
        ARRIVEDONDEVICE = 'ARRIVED_ON_DEVICE',
        READBYDRIVER = 'READ_BY_DRIVER',
        CANCELED = 'CANCELED',
        MODIFIED = 'MODIFIED'
    }
}

/**
 * 
 * @export
 * @interface TempTargetUser
 */
export interface TempTargetUser {
    /**
     * 
     * @type {Company}
     * @memberof TempTargetUser
     */
    company?: Company;
    /**
     * 
     * @type {AuthToken}
     * @memberof TempTargetUser
     */
    token?: AuthToken;
    /**
     * 
     * @type {User}
     * @memberof TempTargetUser
     */
    user?: User;
}

/**
 * 
 * @export
 * @interface TemperatureDataPoint
 */
export interface TemperatureDataPoint {
    /**
     * 
     * @type {Date}
     * @memberof TemperatureDataPoint
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof TemperatureDataPoint
     */
    value?: number;
}

/**
 * 
 * @export
 * @interface TemperatureHistoryResponse
 */
export interface TemperatureHistoryResponse {
    /**
     * 
     * @type {Array<TemperatureSensorSeries>}
     * @memberof TemperatureHistoryResponse
     */
    sensorSeries?: Array<TemperatureSensorSeries>;
    /**
     * 
     * @type {string}
     * @memberof TemperatureHistoryResponse
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TemperatureSensorSeries
 */
export interface TemperatureSensorSeries {
    /**
     * 
     * @type {Array<TemperatureDataPoint>}
     * @memberof TemperatureSensorSeries
     */
    dataPoints?: Array<TemperatureDataPoint>;
    /**
     * 
     * @type {string}
     * @memberof TemperatureSensorSeries
     */
    displayLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TemperatureSensorSeries
     */
    sensorKey?: string;
}

/**
 * 
 * @export
 * @interface TestFailureLogEntry
 */
export interface TestFailureLogEntry {
    /**
     * 
     * @type {string}
     * @memberof TestFailureLogEntry
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof TestFailureLogEntry
     */
    actual?: string;
    /**
     * 
     * @type {Array<AiParseResult>}
     * @memberof TestFailureLogEntry
     */
    actualAiProcessingData?: Array<AiParseResult>;
    /**
     * 
     * @type {string}
     * @memberof TestFailureLogEntry
     */
    detailedDiffSummary?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TestFailureLogEntry
     */
    diffs?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TestFailureLogEntry
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof TestFailureLogEntry
     */
    expected?: string;
    /**
     * 
     * @type {Array<AiParseResult>}
     * @memberof TestFailureLogEntry
     */
    expectedAiProcessingData?: Array<AiParseResult>;
    /**
     * 
     * @type {string}
     * @memberof TestFailureLogEntry
     */
    testName?: string;
    /**
     * 
     * @type {TestSettings}
     * @memberof TestFailureLogEntry
     */
    testSettings?: TestSettings;
    /**
     * 
     * @type {Date}
     * @memberof TestFailureLogEntry
     */
    timestamp?: Date;
}

/**
 * 
 * @export
 * @interface TestSettings
 */
export interface TestSettings {
    /**
     * 
     * @type {any}
     * @memberof TestSettings
     */
    fieldsToFuzzyMatch?: any;
    /**
     * 
     * @type {Array<string>}
     * @memberof TestSettings
     */
    fieldsToIgnore?: Array<string>;
}

/**
 * 
 * @export
 * @interface TestSuppressionScriptResponse
 */
export interface TestSuppressionScriptResponse {
    /**
     * 
     * @type {Array<QueuedEvent>}
     * @memberof TestSuppressionScriptResponse
     */
    events?: Array<QueuedEvent>;
}

/**
 * 
 * @export
 * @interface TextFieldConfiguration
 */
export interface TextFieldConfiguration {
    /**
     * 
     * @type {string}
     * @memberof TextFieldConfiguration
     */
    defaultValue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TextFieldConfiguration
     */
    isReadOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextFieldConfiguration
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextFieldConfiguration
     */
    isVisible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TextFieldConfiguration
     */
    sortIndex?: number;
}

/**
 * 
 * @export
 * @interface TextRecord
 */
export interface TextRecord {
    /**
     * 
     * @type {boolean}
     * @memberof TextRecord
     */
    _export?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TextRecord
     */
    getTextExpression?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TextRecord
     */
    _import?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TextRecord
     */
    setTextExpression?: string;
    /**
     * 
     * @type {number}
     * @memberof TextRecord
     */
    txtArtNr?: number;
}

/**
 * 
 * @export
 * @interface ThreadPoolHealth
 */
export interface ThreadPoolHealth {
    /**
     * 
     * @type {number}
     * @memberof ThreadPoolHealth
     */
    activeThreadCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ThreadPoolHealth
     */
    maxPoolSize?: number;
    /**
     * 
     * @type {number}
     * @memberof ThreadPoolHealth
     */
    poolSize?: number;
}

/**
 * 
 * @export
 * @interface Throwable
 */
export interface Throwable {
    /**
     * 
     * @type {Throwable}
     * @memberof Throwable
     */
    cause?: Throwable;
    /**
     * 
     * @type {string}
     * @memberof Throwable
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface TimeInterval
 */
export interface TimeInterval {
    /**
     * 
     * @type {Date}
     * @memberof TimeInterval
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimeInterval
     */
    to?: Date;
}

/**
 * 
 * @export
 * @interface TimeOffset
 */
export interface TimeOffset {
    /**
     * 
     * @type {string}
     * @memberof TimeOffset
     */
    offsetDirection?: TimeOffset.OffsetDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeOffset
     */
    unit?: TimeOffset.UnitEnum;
    /**
     * 
     * @type {number}
     * @memberof TimeOffset
     */
    value?: number;
}

/**
 * @export
 * @namespace TimeOffset
 */
export namespace TimeOffset {
    /**
     * @export
     * @enum {string}
     */
    export enum OffsetDirectionEnum {
        ADD = 'ADD',
        SUBTRACT = 'SUBTRACT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum UnitEnum {
        HOURS = 'HOURS',
        DAYS = 'DAYS',
        WEEKS = 'WEEKS',
        MONTHS = 'MONTHS'
    }
}

/**
 * 
 * @export
 * @interface TimeStats
 */
export interface TimeStats {
    /**
     * 
     * @type {number}
     * @memberof TimeStats
     */
    average?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeStats
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeStats
     */
    median?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeStats
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeStats
     */
    times?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeStats
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface TimeWindow
 */
export interface TimeWindow {
    /**
     * 
     * @type {number}
     * @memberof TimeWindow
     */
    afterInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeWindow
     */
    beforeInMinutes?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TimeWindow
     */
    daysOfWeekToSkip?: Array<TimeWindow.DaysOfWeekToSkipEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TimeWindow
     */
    holidaysToSkip?: Array<string>;
}

/**
 * @export
 * @namespace TimeWindow
 */
export namespace TimeWindow {
    /**
     * @export
     * @enum {string}
     */
    export enum DaysOfWeekToSkipEnum {
        MONDAY = 'MONDAY',
        TUESDAY = 'TUESDAY',
        WEDNESDAY = 'WEDNESDAY',
        THURSDAY = 'THURSDAY',
        FRIDAY = 'FRIDAY',
        SATURDAY = 'SATURDAY',
        SUNDAY = 'SUNDAY'
    }
}

/**
 * 
 * @export
 * @interface Timestamp
 */
export interface Timestamp {
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    i?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    t?: number;
}

/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    token?: string;
}

/**
 * 
 * @export
 * @interface TopTicketRecommendation
 */
export interface TopTicketRecommendation {
    /**
     * 
     * @type {string}
     * @memberof TopTicketRecommendation
     */
    difficultyAssessment?: string;
    /**
     * 
     * @type {number}
     * @memberof TopTicketRecommendation
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof TopTicketRecommendation
     */
    reasoning?: string;
    /**
     * 
     * @type {string}
     * @memberof TopTicketRecommendation
     */
    suggestion?: string;
    /**
     * 
     * @type {number}
     * @memberof TopTicketRecommendation
     */
    ticketId?: number;
}

/**
 * 
 * @export
 * @interface TotpEnrollmentResponse
 */
export interface TotpEnrollmentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TotpEnrollmentResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TotpEnrollmentResponse
     */
    uri?: string;
}

/**
 * 
 * @export
 * @interface TourCostReportDriverRow
 */
export interface TourCostReportDriverRow {
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    deadHeadDurationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportDriverRow
     */
    driverId?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportDriverRow
     */
    driverName?: string;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    drivingTimeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    emptyDrivingTimeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    emptyTollAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    emptyTollKilometer?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    emptyWorkingTimeSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportDriverRow
     */
    externalDriverId?: string;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    fuelConsumedEmptyLiters?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    fuelConsumedTourLiters?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TourCostReportDriverRow
     */
    hasDtcoData?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    leerKm?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    longestWorkBlockSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    numberOfStops?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    numberOfTours?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    restTimeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    standTimeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    tollAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    tollKilometer?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    tourDurationSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    tourKm?: number;
    /**
     * 
     * @type {Array<TourCostReportTourDetail>}
     * @memberof TourCostReportDriverRow
     */
    tours?: Array<TourCostReportTourDetail>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TourCostReportDriverRow
     */
    warnings?: Array<TourCostReportDriverRow.WarningsEnum>;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    workingDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportDriverRow
     */
    workingTimeSeconds?: number;
}

/**
 * @export
 * @namespace TourCostReportDriverRow
 */
export namespace TourCostReportDriverRow {
    /**
     * @export
     * @enum {string}
     */
    export enum WarningsEnum {
        MISSINGDTCODATA = 'MISSING_DTCO_DATA',
        NODTCOINTOURWINDOW = 'NO_DTCO_IN_TOUR_WINDOW',
        MISSINGACTUALSTOPTIMES = 'MISSING_ACTUAL_STOP_TIMES',
        EXCESSIVECONTINUOUSWORK = 'EXCESSIVE_CONTINUOUS_WORK',
        OVERLAPPINGPREVIOUSTOUR = 'OVERLAPPING_PREVIOUS_TOUR',
        MISSINGTOURKILOMETER = 'MISSING_TOUR_KILOMETER'
    }
}

/**
 * 
 * @export
 * @interface TourCostReportRequest
 */
export interface TourCostReportRequest {
    /**
     * 
     * @type {string}
     * @memberof TourCostReportRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportRequest
     */
    sinceTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportRequest
     */
    toTimestamp?: string;
}

/**
 * 
 * @export
 * @interface TourCostReportResponse
 */
export interface TourCostReportResponse {
    /**
     * 
     * @type {string}
     * @memberof TourCostReportResponse
     */
    companyId?: string;
    /**
     * 
     * @type {Array<TourCostReportDriverRow>}
     * @memberof TourCostReportResponse
     */
    rows?: Array<TourCostReportDriverRow>;
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportResponse
     */
    since?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportResponse
     */
    to?: Date;
}

/**
 * 
 * @export
 * @interface TourCostReportShipmentLeg
 */
export interface TourCostReportShipmentLeg {
    /**
     * 
     * @type {string}
     * @memberof TourCostReportShipmentLeg
     */
    loadingLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportShipmentLeg
     */
    loadingStandTimeSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportShipmentLeg
     */
    unloadingLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportShipmentLeg
     */
    unloadingStandTimeSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportShipmentLeg
     */
    verladerName?: string;
}

/**
 * 
 * @export
 * @interface TourCostReportStandTimeStop
 */
export interface TourCostReportStandTimeStop {
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportStandTimeStop
     */
    arrivedTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportStandTimeStop
     */
    departedTimestamp?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TourCostReportStandTimeStop
     */
    isLoading?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportStandTimeStop
     */
    standTimeSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportStandTimeStop
     */
    stopLabel?: string;
}

/**
 * 
 * @export
 * @interface TourCostReportTourDetail
 */
export interface TourCostReportTourDetail {
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    deadHeadDurationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    driverId?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    driverName?: string;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    drivingTimeSeconds?: number;
    /**
     * 
     * @type {Array<DtcoActivity>}
     * @memberof TourCostReportTourDetail
     */
    dtcoActivities?: Array<DtcoActivity>;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    emptyDrivingTimeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    emptyTollAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    emptyTollKilometer?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    emptyWorkingTimeSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    externalDriverId?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    fuelConsumedEmptyLiters?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    fuelConsumedTourLiters?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    leerKm?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    longestWorkBlockSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    numberOfStops?: number;
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportTourDetail
     */
    planEnd?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportTourDetail
     */
    planStart?: Date;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    restTimeSeconds?: number;
    /**
     * 
     * @type {Array<TourCostReportShipmentLeg>}
     * @memberof TourCostReportTourDetail
     */
    shipmentLegs?: Array<TourCostReportShipmentLeg>;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    standTimeSeconds?: number;
    /**
     * 
     * @type {Array<TourCostReportStandTimeStop>}
     * @memberof TourCostReportTourDetail
     */
    standTimeStops?: Array<TourCostReportStandTimeStop>;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    statusCode?: string;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    tollAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    tollKilometer?: number;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    tollSource?: TourCostReportTourDetail.TollSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    tourDurationSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    tourKm?: number;
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportTourDetail
     */
    tourWindowEnd?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TourCostReportTourDetail
     */
    tourWindowStart?: Date;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    transportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    vehicleId?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    vehicleNumberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof TourCostReportTourDetail
     */
    verladerName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TourCostReportTourDetail
     */
    warnings?: Array<TourCostReportTourDetail.WarningsEnum>;
    /**
     * 
     * @type {number}
     * @memberof TourCostReportTourDetail
     */
    workingTimeSeconds?: number;
}

/**
 * @export
 * @namespace TourCostReportTourDetail
 */
export namespace TourCostReportTourDetail {
    /**
     * @export
     * @enum {string}
     */
    export enum TollSourceEnum {
        ACTUAL = 'ACTUAL',
        EXPECTED = 'EXPECTED',
        NONE = 'NONE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WarningsEnum {
        MISSINGDTCODATA = 'MISSING_DTCO_DATA',
        NODTCOINTOURWINDOW = 'NO_DTCO_IN_TOUR_WINDOW',
        MISSINGACTUALSTOPTIMES = 'MISSING_ACTUAL_STOP_TIMES',
        EXCESSIVECONTINUOUSWORK = 'EXCESSIVE_CONTINUOUS_WORK',
        OVERLAPPINGPREVIOUSTOUR = 'OVERLAPPING_PREVIOUS_TOUR',
        MISSINGTOURKILOMETER = 'MISSING_TOUR_KILOMETER'
    }
}

/**
 * 
 * @export
 * @interface TourEtaInfo
 */
export interface TourEtaInfo {
    /**
     * 
     * @type {string}
     * @memberof TourEtaInfo
     */
    completeRoutingGraph?: string;
    /**
     * 
     * @type {string}
     * @memberof TourEtaInfo
     */
    currentRoutingGraph?: string;
    /**
     * 
     * @type {number}
     * @memberof TourEtaInfo
     */
    estimatedTourDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof TourEtaInfo
     */
    estimatedTourDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof TourEtaInfo
     */
    liveLink?: string;
    /**
     * 
     * @type {PositionRequest}
     * @memberof TourEtaInfo
     */
    relatedPosition?: PositionRequest;
    /**
     * 
     * @type {Date}
     * @memberof TourEtaInfo
     */
    relatedTimestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof TourEtaInfo
     */
    remainingKilometersTillCompletion?: number;
    /**
     * 
     * @type {number}
     * @memberof TourEtaInfo
     */
    remainingTimeTillCompletion?: number;
    /**
     * 
     * @type {string}
     * @memberof TourEtaInfo
     */
    source?: TourEtaInfo.SourceEnum;
}

/**
 * @export
 * @namespace TourEtaInfo
 */
export namespace TourEtaInfo {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        PTV = 'PTV',
        GRAPHHOPPER = 'GRAPHHOPPER',
        OSRM = 'OSRM',
        COMPANY = 'COMPANY',
        NONE = 'NONE',
        ORS = 'ORS',
        CUSTOM = 'CUSTOM'
    }
}

/**
 * 
 * @export
 * @interface TourPolylineResponse
 */
export interface TourPolylineResponse {
    /**
     * 
     * @type {number}
     * @memberof TourPolylineResponse
     */
    epsilon?: number;
    /**
     * 
     * @type {string}
     * @memberof TourPolylineResponse
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TourPolylineResponse
     */
    polyline?: string;
    /**
     * 
     * @type {string}
     * @memberof TourPolylineResponse
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Array<VehiclePolyline>}
     * @memberof TourPolylineResponse
     */
    vehiclePolylines?: Array<VehiclePolyline>;
}

/**
 * 
 * @export
 * @interface TourPolylinesForVehicle
 */
export interface TourPolylinesForVehicle {
    /**
     * 
     * @type {Array<TourPolylineResponse>}
     * @memberof TourPolylinesForVehicle
     */
    tourPolylineResponses?: Array<TourPolylineResponse>;
}

/**
 * 
 * @export
 * @interface TourStatusChangeNotificationConfiguration
 */
export interface TourStatusChangeNotificationConfiguration {
    /**
     * If this is specified, sending of the messages only happens, when all of those rules match
     * @type {Array<ImmediateFormatPathMatchRule>}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    applyWhenAllRulesMatch?: Array<ImmediateFormatPathMatchRule>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    id?: string;
    /**
     * 
     * @type {Array<OnlyForPartnerCompaniesEntry>}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    onlyForPartnerCompanies?: Array<OnlyForPartnerCompaniesEntry>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    onlyForSpecificInputMissingType?: Array<TourStatusChangeNotificationConfiguration.OnlyForSpecificInputMissingTypeEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    relevantEvents?: Array<TourStatusChangeNotificationConfiguration.RelevantEventsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    relevantTransportOrderStatusChanges?: Array<TourStatusChangeNotificationConfiguration.RelevantTransportOrderStatusChangesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof TourStatusChangeNotificationConfiguration
     */
    sendToOrderCreatorOnly?: boolean;
}

/**
 * @export
 * @namespace TourStatusChangeNotificationConfiguration
 */
export namespace TourStatusChangeNotificationConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum OnlyForSpecificInputMissingTypeEnum {
        ADDRESSMAPPINGMISSING = 'ADDRESS_MAPPING_MISSING',
        SHIPMENTMAPPINGMISSING = 'SHIPMENT_MAPPING_MISSING',
        FREIGHTMAPPINGMISSING = 'FREIGHT_MAPPING_MISSING',
        MANUALREVIEWREQUIRED = 'MANUAL_REVIEW_REQUIRED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RelevantEventsEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RelevantTransportOrderStatusChangesEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
}

/**
 * 
 * @export
 * @interface TourViewHeaderConfiguration
 */
export interface TourViewHeaderConfiguration {
    /**
     * 
     * @type {Array<AdditionalColumnConfiguration>}
     * @memberof TourViewHeaderConfiguration
     */
    additionalColumns?: Array<AdditionalColumnConfiguration>;
    /**
     * 
     * @type {boolean}
     * @memberof TourViewHeaderConfiguration
     */
    showCarrier?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TourViewHeaderConfiguration
     */
    showDriver?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TourViewHeaderConfiguration
     */
    showExtneralOrderId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TourViewHeaderConfiguration
     */
    showShipper?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TourViewHeaderConfiguration
     */
    showTrailer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TourViewHeaderConfiguration
     */
    showVehicle?: boolean;
}

/**
 * 
 * @export
 * @interface TrackSegment
 */
export interface TrackSegment {
    /**
     * 
     * @type {number}
     * @memberof TrackSegment
     */
    distanceInM?: number;
    /**
     * 
     * @type {Position}
     * @memberof TrackSegment
     */
    p1?: Position;
    /**
     * 
     * @type {Position}
     * @memberof TrackSegment
     */
    p2?: Position;
    /**
     * 
     * @type {number}
     * @memberof TrackSegment
     */
    timeBetweenInS?: number;
}

/**
 * 
 * @export
 * @interface TrackingConfiguration
 */
export interface TrackingConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof TrackingConfiguration
     */
    allowMappingOfMultipleTransportOrdersToSingleTelematicTour?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrackingConfiguration
     */
    numDaysToMap?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingConfiguration
     */
    replaceExistingPositionsByExternalPositionId?: boolean;
    /**
     * 
     * @type {TimeWindow}
     * @memberof TrackingConfiguration
     */
    timeWindowToReceivePositionsForTransportOrder?: TimeWindow;
}

/**
 * 
 * @export
 * @interface TrackingPageViewConfiguration
 */
export interface TrackingPageViewConfiguration {
    /**
     * 
     * @type {AllowedAttachmentTypesToShow}
     * @memberof TrackingPageViewConfiguration
     */
    allowedAttachmentTypes?: AllowedAttachmentTypesToShow;
    /**
     * 
     * @type {AttachmentOverviewModalConfiguration}
     * @memberof TrackingPageViewConfiguration
     */
    attachmentOverviewModal?: AttachmentOverviewModalConfiguration;
    /**
     * 
     * @type {string}
     * @memberof TrackingPageViewConfiguration
     */
    customUserDns?: string;
    /**
     * 
     * @type {DeliveryAreaViewConfiguration}
     * @memberof TrackingPageViewConfiguration
     */
    deliveryArea?: DeliveryAreaViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPageViewConfiguration
     */
    enableZipCodeValidation?: boolean;
    /**
     * 
     * @type {HeaderAreaViewConfiguration}
     * @memberof TrackingPageViewConfiguration
     */
    headerArea?: HeaderAreaViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPageViewConfiguration
     */
    hideAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPageViewConfiguration
     */
    hideFooter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPageViewConfiguration
     */
    hideLoadingLocation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPageViewConfiguration
     */
    includeDepotsFromLinkedOrders?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrackingPageViewConfiguration
     */
    planTimeOptions?: TrackingPageViewConfiguration.PlanTimeOptionsEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPageViewConfiguration
     */
    showLoadingUnloadingTimes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPageViewConfiguration
     */
    showOpeningHoursIfAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrackingPageViewConfiguration
     */
    style?: TrackingPageViewConfiguration.StyleEnum;
}

/**
 * @export
 * @namespace TrackingPageViewConfiguration
 */
export namespace TrackingPageViewConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum PlanTimeOptionsEnum {
        PLANTIME = 'SHOW_PLAN_TIME',
        AVISTIME = 'SHOW_AVIS_TIME',
        PLANANDAVISTIME = 'SHOW_PLAN_AND_AVIS_TIME'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StyleEnum {
        TOURVIEW = 'TOUR_VIEW',
        SHIPMENTVIEW = 'SHIPMENT_VIEW'
    }
}

/**
 * 
 * @export
 * @interface TransdataConverterConfiguration
 */
export interface TransdataConverterConfiguration {
    /**
     * 
     * @type {string}
     * @memberof TransdataConverterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof TransdataConverterConfiguration
     */
    exportTransportOrderScript?: string;
    /**
     * 
     * @type {string}
     * @memberof TransdataConverterConfiguration
     */
    modifyMode?: TransdataConverterConfiguration.ModifyModeEnum;
}

/**
 * @export
 * @namespace TransdataConverterConfiguration
 */
export namespace TransdataConverterConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ModifyModeEnum {
        FULLREPLACE = 'FULL_REPLACE',
        REPLACE = 'REPLACE',
        PATCH = 'PATCH'
    }
}

/**
 * 
 * @export
 * @interface Translation
 */
export interface Translation {
    /**
     * 
     * @type {string}
     * @memberof Translation
     */
    language?: Translation.LanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof Translation
     */
    localizedText?: string;
}

/**
 * @export
 * @namespace Translation
 */
export namespace Translation {
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
}

/**
 * 
 * @export
 * @interface TranslationEntry
 */
export interface TranslationEntry {
    /**
     * 
     * @type {string}
     * @memberof TranslationEntry
     */
    key?: string;
    /**
     * 
     * @type {OverrideTranslation}
     * @memberof TranslationEntry
     */
    translations?: OverrideTranslation;
}

/**
 * 
 * @export
 * @interface TranslogicaConverterConfiguration
 */
export interface TranslogicaConverterConfiguration {
    /**
     * 
     * @type {TranslogicaExportConfiguration}
     * @memberof TranslogicaConverterConfiguration
     */
    _export?: TranslogicaExportConfiguration;
    /**
     * 
     * @type {Array<TranslogicaSpecificConfiguration>}
     * @memberof TranslogicaConverterConfiguration
     */
    specificConfigurations?: Array<TranslogicaSpecificConfiguration>;
}

/**
 * 
 * @export
 * @interface TranslogicaConverterConfigurationOverride
 */
export interface TranslogicaConverterConfigurationOverride {
    /**
     * 
     * @type {TranslogicaExportConfiguration}
     * @memberof TranslogicaConverterConfigurationOverride
     */
    _export?: TranslogicaExportConfiguration;
}

/**
 * 
 * @export
 * @interface TranslogicaExportConfiguration
 */
export interface TranslogicaExportConfiguration {
    /**
     * 
     * @type {string}
     * @memberof TranslogicaExportConfiguration
     */
    exportTransportOrderKotlinScript?: string;
}

/**
 * 
 * @export
 * @interface TranslogicaSpecificConfiguration
 */
export interface TranslogicaSpecificConfiguration {
    /**
     * 
     * @type {TranslogicaSpecificConfigurationApplyRules}
     * @memberof TranslogicaSpecificConfiguration
     */
    applyWhenAll?: TranslogicaSpecificConfigurationApplyRules;
    /**
     * 
     * @type {TranslogicaConverterConfigurationOverride}
     * @memberof TranslogicaSpecificConfiguration
     */
    override?: TranslogicaConverterConfigurationOverride;
    /**
     * 
     * @type {string}
     * @memberof TranslogicaSpecificConfiguration
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface TranslogicaSpecificConfigurationApplyRules
 */
export interface TranslogicaSpecificConfigurationApplyRules {
    /**
     * 
     * @type {boolean}
     * @memberof TranslogicaSpecificConfigurationApplyRules
     */
    onConversionToExternalFormat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TranslogicaSpecificConfigurationApplyRules
     */
    onConversionToTransportOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TranslogicaSpecificConfigurationApplyRules
     */
    sourceCompanyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TranslogicaSpecificConfigurationApplyRules
     */
    sourceCompanyTag?: Array<string>;
}

/**
 * 
 * @export
 * @interface TransporeonImporterConfiguration
 */
export interface TransporeonImporterConfiguration {
    /**
     * 
     * @type {string}
     * @memberof TransporeonImporterConfiguration
     */
    encoding?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransporeonImporterConfiguration
     */
    singleFreightTransports?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransporeonImporterConfiguration
     */
    timezone?: string;
}

/**
 * 
 * @export
 * @interface Transport
 */
export interface Transport {
    /**
     * Additional key value pairs related to the transport
     * @type {Array<AdditionalDataEntry>}
     * @memberof Transport
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * List of files attached to this transport
     * @type {Array<Attachment>}
     * @memberof Transport
     */
    attachments?: Array<Attachment>;
    /**
     * Reference to the resolved shipment mapping
     * @type {number}
     * @memberof Transport
     */
    co2Emissions?: number;
    /**
     * Additional information related to this transport
     * @type {string}
     * @memberof Transport
     */
    comment?: string;
    /**
     * 
     * @type {LinkInfo}
     * @memberof Transport
     */
    linkInfo?: LinkInfo;
    /**
     * Planned stop date of this transport
     * @type {Date}
     * @memberof Transport
     */
    planEnd?: Date;
    /**
     * Planned start date of this transport
     * @type {Date}
     * @memberof Transport
     */
    planStart?: Date;
    /**
     * 
     * @type {DoubleWithUnit}
     * @memberof Transport
     */
    plannedDistance?: DoubleWithUnit;
    /**
     * Shipment number related to this transport 
     * @type {string}
     * @memberof Transport
     */
    shipmentNumber?: string;
    /**
     * stop locations of this transport segment
     * @type {Array<StopLocation>}
     * @memberof Transport
     */
    stops?: Array<StopLocation>;
    /**
     * id of this transport segment. This id must be unique per transport order
     * @type {string}
     * @memberof Transport
     */
    transportId?: string;
}

/**
 * 
 * @export
 * @interface TransportAllOrderToExcelConversionRequest
 */
export interface TransportAllOrderToExcelConversionRequest {
    /**
     * 
     * @type {FetchTransportOrderListFilterRequest}
     * @memberof TransportAllOrderToExcelConversionRequest
     */
    filters?: FetchTransportOrderListFilterRequest;
    /**
     * 
     * @type {string}
     * @memberof TransportAllOrderToExcelConversionRequest
     */
    mode?: TransportAllOrderToExcelConversionRequest.ModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TransportAllOrderToExcelConversionRequest
     */
    sendReportByEmail?: boolean;
}

/**
 * @export
 * @namespace TransportAllOrderToExcelConversionRequest
 */
export namespace TransportAllOrderToExcelConversionRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        OneLinePerFreight = 'OneLinePerFreight',
        OneLinePerTransport = 'OneLinePerTransport'
    }
}

/**
 * 
 * @export
 * @interface TransportCreateViewConfiguration
 */
export interface TransportCreateViewConfiguration {
    /**
     * 
     * @type {Array<AdditionalDataFieldConfiguration>}
     * @memberof TransportCreateViewConfiguration
     */
    additionalData?: Array<AdditionalDataFieldConfiguration>;
    /**
     * 
     * @type {TextFieldConfiguration}
     * @memberof TransportCreateViewConfiguration
     */
    attachments?: TextFieldConfiguration;
}

/**
 * 
 * @export
 * @interface TransportLinkingRequest
 */
export interface TransportLinkingRequest {
    /**
     * 
     * @type {boolean}
     * @memberof TransportLinkingRequest
     */
    copyObserversFromSourceTransport?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportLinkingRequest
     */
    sourceTransportId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportLinkingRequest
     */
    sourceTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportLinkingRequest
     */
    targetTransportId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportLinkingRequest
     */
    targetTransportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportLinkingResponse
 */
export interface TransportLinkingResponse {
    /**
     * 
     * @type {string}
     * @memberof TransportLinkingResponse
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportLinkingResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface TransportMapping
 */
export interface TransportMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof TransportMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    earliestLoadingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    earliestLoadingTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    earliestUnloadingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    earliestUnloadingTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    externalLinkKey?: string;
    /**
     * 
     * @type {Array<LisLinkKeyMapping>}
     * @memberof TransportMapping
     */
    externalLinkKeys?: Array<LisLinkKeyMapping>;
    /**
     * 
     * @type {Array<InfSymRecordConfiguration>}
     * @memberof TransportMapping
     */
    infSymRecords?: Array<InfSymRecordConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    latestLoadingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    latestLoadingTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    latestUnloadingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    latestUnloadingTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    plannedDistance?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof TransportMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    shipmentNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportMapping
     */
    shouldExportCommentAsDefaultText?: boolean;
    /**
     * 
     * @type {LisTransportStatusHandling}
     * @memberof TransportMapping
     */
    statusHandling?: LisTransportStatusHandling;
    /**
     * 
     * @type {Array<TextRecord>}
     * @memberof TransportMapping
     */
    textRecords?: Array<TextRecord>;
    /**
     * 
     * @type {string}
     * @memberof TransportMapping
     */
    transportId?: string;
}

/**
 * 
 * @export
 * @interface TransportMergingOptions
 */
export interface TransportMergingOptions {
    /**
     * 
     * @type {boolean}
     * @memberof TransportMergingOptions
     */
    enable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportMergingOptions
     */
    mergeScript?: string;
}

/**
 * 
 * @export
 * @interface TransportOrder
 */
export interface TransportOrder {
    /**
     * Unique identifier for the transport order. This field is automatically assigned when a transport order is created
     * @type {string}
     * @memberof TransportOrder
     */
    _id?: string;
    /**
     * Additional key-value-pairs associated with this transport order
     * @type {Array<AdditionalDataEntry>}
     * @memberof TransportOrder
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {AssignedDevice}
     * @memberof TransportOrder
     */
    assignedDevice?: AssignedDevice;
    /**
     * 
     * @type {Driver}
     * @memberof TransportOrder
     */
    assignedDriver?: Driver;
    /**
     * 
     * @type {AssignedOrderBox}
     * @memberof TransportOrder
     */
    assignedOrderBox?: AssignedOrderBox;
    /**
     * 
     * @type {Vehicle}
     * @memberof TransportOrder
     */
    assignedTrailer?: Vehicle;
    /**
     * 
     * @type {Vehicle}
     * @memberof TransportOrder
     */
    assignedVehicle?: Vehicle;
    /**
     * File attachments associated with this transport order
     * @type {Array<Attachment>}
     * @memberof TransportOrder
     */
    attachments?: Array<Attachment>;
    /**
     * 
     * @type {ChargeInformation}
     * @memberof TransportOrder
     */
    charge?: ChargeInformation;
    /**
     * Reference to the resolved shipment mapping
     * @type {number}
     * @memberof TransportOrder
     */
    co2Emissions?: number;
    /**
     * additional comments
     * @type {string}
     * @memberof TransportOrder
     */
    comment?: string;
    /**
     * originating company id
     * @type {string}
     * @memberof TransportOrder
     */
    companyId?: string;
    /**
     * originating company name
     * @type {string}
     * @memberof TransportOrder
     */
    companyName?: string;
    /**
     * Company Tags
     * @type {Array<CompanyTag>}
     * @memberof TransportOrder
     */
    companyTags?: Array<CompanyTag>;
    /**
     * Constraints regarding to the executing vehicle which must be satisfied
     * @type {Array<string>}
     * @memberof TransportOrder
     */
    constraints?: Array<TransportOrder.ConstraintsEnum>;
    /**
     * date time when this shipment was created
     * @type {Date}
     * @memberof TransportOrder
     */
    created?: Date;
    /**
     * 
     * @type {CustomWorkflowDefinition}
     * @memberof TransportOrder
     */
    customWorkflow?: CustomWorkflowDefinition;
    /**
     * external id of company which is responsible for order execution
     * @type {string}
     * @memberof TransportOrder
     */
    externalTargetCompanyId?: string;
    /**
     * User defined identifier for the transport order
     * @type {string}
     * @memberof TransportOrder
     */
    externalTransportOrderId?: string;
    /**
     * Contains information who issued or changed this transport order
     * @type {string}
     * @memberof TransportOrder
     */
    externalUserId?: string;
    /**
     * List of freight to be transported
     * @type {Array<Freight>}
     * @memberof TransportOrder
     */
    freight?: Array<Freight>;
    /**
     * 
     * @type {LinkInfo}
     * @memberof TransportOrder
     */
    linkInfo?: LinkInfo;
    /**
     * missing attributes list
     * @type {Array<MissingAttribute>}
     * @memberof TransportOrder
     */
    missingAttributeList?: Array<MissingAttribute>;
    /**
     * date time when this shipment was modified
     * @type {Date}
     * @memberof TransportOrder
     */
    modified?: Date;
    /**
     * List of Observers which have read only access to this transport order
     * @type {Array<Observer>}
     * @memberof TransportOrder
     */
    observer?: Array<Observer>;
    /**
     * planned date time when the order execution should be finished
     * @type {Date}
     * @memberof TransportOrder
     */
    planEnd?: Date;
    /**
     * planned date time when the order execution should start
     * @type {Date}
     * @memberof TransportOrder
     */
    planStart?: Date;
    /**
     * 
     * @type {RouteInformation}
     * @memberof TransportOrder
     */
    route?: RouteInformation;
    /**
     * 
     * @type {TransportOrderStatus}
     * @memberof TransportOrder
     */
    status?: TransportOrderStatus;
    /**
     * 
     * @type {TransportOrderValidationResult}
     * @memberof TransportOrder
     */
    statusValidationResult?: TransportOrderValidationResult;
    /**
     * id of company which is responsible for order execution
     * @type {string}
     * @memberof TransportOrder
     */
    targetCompanyId?: string;
    /**
     * name of company which is responsible for order execution
     * @type {string}
     * @memberof TransportOrder
     */
    targetCompanyName?: string;
    /**
     * external order identifier used by the telematic system
     * @type {string}
     * @memberof TransportOrder
     */
    telematicTransportOrderId?: string;
    /**
     * 
     * @type {TourEtaInfo}
     * @memberof TransportOrder
     */
    tourEta?: TourEtaInfo;
    /**
     * List of transport segments. Each segment may contain one or more stops
     * @type {Array<Transport>}
     * @memberof TransportOrder
     */
    transports?: Array<Transport>;
    /**
     * the sender of the email to be processed mailAddress
     * @type {string}
     * @memberof TransportOrder
     */
    userEmail?: string;
    /**
     * short description of this transport order
     * @type {string}
     * @memberof TransportOrder
     */
    verboseName?: string;
}

/**
 * @export
 * @namespace TransportOrder
 */
export namespace TransportOrder {
    /**
     * @export
     * @enum {string}
     */
    export enum ConstraintsEnum {
        CAR = 'CAR',
        TRANSPORTER = 'TRANSPORTER',
        TRUCK75T = 'TRUCK_7_5T',
        TRUCK1199T = 'TRUCK_11_99T',
        TRUCK40T = 'TRUCK_40T',
        CRANE = 'CRANE',
        MOFFETT = 'MOFFETT',
        PALLETJACK = 'PALLET_JACK',
        CONTAINER = 'CONTAINER',
        DOUBLECONTAINER = 'DOUBLE_CONTAINER',
        COOLINGUNIT = 'COOLING_UNIT',
        SILOTRUCK = 'SILO_TRUCK',
        TAUTLINER = 'TAUTLINER',
        FLATBED = 'FLATBED',
        SIXWHEELER = 'SIX_WHEELER',
        EIGHTWHEELER = 'EIGHT_WHEELER',
        MEGATRAILER = 'MEGA_TRAILER',
        SWAPBODY = 'SWAP_BODY'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderAdditionalDataModifyRequest
 */
export interface TransportOrderAdditionalDataModifyRequest {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof TransportOrderAdditionalDataModifyRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof TransportOrderAdditionalDataModifyRequest
     */
    pathSelector?: TransportOrderPathSelector;
}

/**
 * 
 * @export
 * @interface TransportOrderAssignRequest
 */
export interface TransportOrderAssignRequest {
    /**
     * 
     * @type {AssignedDevice}
     * @memberof TransportOrderAssignRequest
     */
    assignedDevice?: AssignedDevice;
    /**
     * 
     * @type {AssignedOrderBox}
     * @memberof TransportOrderAssignRequest
     */
    assignedOrderBox?: AssignedOrderBox;
    /**
     * Customer defined external partner id of the target company to which the transport order should be assigned.
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    externalPartnerId?: string;
    /**
     * External id of the target trailer
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    externalTrailerId?: string;
    /**
     * External vehicle id of the target vehicle.
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    externalVehicleId?: string;
    /**
     * Number plate of the target vehicle
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    numberPlate?: string;
    /**
     * Number plate of the target trailer
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    numberPlateOfTrailer?: string;
    /**
     * Event source which caused the assign request
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    source?: TransportOrderAssignRequest.SourceEnum;
    /**
     * LOGENIOS customer ID of the target company to which the transport order should be assigned
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    targetCompanyId?: string;
    /**
     * Display name of the target company to which the transport order shall be assigned. This value is used if the target company is not yet known by LOGENIOS.
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    targetCompanyName?: string;
    /**
     * LOGENIOS trailer id of the attached trailer
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    trailerId?: string;
    /**
     * LOGENIOS vehicle id of the target vehicle
     * @type {string}
     * @memberof TransportOrderAssignRequest
     */
    vehicleId?: string;
}

/**
 * @export
 * @namespace TransportOrderAssignRequest
 */
export namespace TransportOrderAssignRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceEnum {
        LOGENIOSFTP = 'LOGENIOS_FTP',
        LOGENIOSWEBSITE = 'LOGENIOS_WEBSITE',
        LOGENIOSCM = 'LOGENIOS_CM',
        LOGENIOSAPPLICATION = 'LOGENIOS_APPLICATION',
        LOGENIOSBACKEND = 'LOGENIOS_BACKEND',
        LOGENIOSAPIGATEWAY = 'LOGENIOS_API_GATEWAY',
        API = 'API',
        UNSET = 'UNSET'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderAssignedDeviceInfo
 */
export interface TransportOrderAssignedDeviceInfo {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderAssignedDeviceInfo
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderAssignedDeviceInfo
     */
    accessUrl?: string;
    /**
     * 
     * @type {AssignedDevice}
     * @memberof TransportOrderAssignedDeviceInfo
     */
    assignedTo?: AssignedDevice;
    /**
     * 
     * @type {Array<TransportOrderRetractedDeviceInfo>}
     * @memberof TransportOrderAssignedDeviceInfo
     */
    retractedDevices?: Array<TransportOrderRetractedDeviceInfo>;
}

/**
 * 
 * @export
 * @interface TransportOrderBilledItem
 */
export interface TransportOrderBilledItem {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    creationDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderBilledItem
     */
    deliveryNumber?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderBilledItem
     */
    hasAssignedDevice?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderBilledItem
     */
    inputConverters?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderBilledItem
     */
    isAssignedToSubcarrier?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderBilledItem
     */
    isBounceOrder?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderBilledItem
     */
    linkedCarrierOrders?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderBilledItem
     */
    linkedShipperOrders?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderBilledItem
     */
    numAttachments?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderBilledItem
     */
    numAttachmentsOfTypeCmr?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderBilledItem
     */
    numObservers?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderBilledItem
     */
    numTrackingPoints?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderBilledItem
     */
    numTransports?: number;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    planStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    shipmentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    sourceCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    targetCompany?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderBilledItem
     */
    trackingViaOrderbox?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderBilledItem
     */
    transportOrderStatus?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderByIdSourceAndTargetViewResponse
 */
export interface TransportOrderByIdSourceAndTargetViewResponse {
    /**
     * 
     * @type {JsonNode}
     * @memberof TransportOrderByIdSourceAndTargetViewResponse
     */
    diff?: JsonNode;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderByIdSourceAndTargetViewResponse
     */
    sourceCompanyName?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderByIdSourceAndTargetViewResponse
     */
    sourceTo?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderByIdSourceAndTargetViewResponse
     */
    targetCompanyName?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderByIdSourceAndTargetViewResponse
     */
    targetTo?: TransportOrder;
}

/**
 * 
 * @export
 * @interface TransportOrderChange
 */
export interface TransportOrderChange {
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderChange
     */
    forwardDiff?: TransportOrder;
    /**
     * 
     * @type {TransportOrderObject}
     * @memberof TransportOrderChange
     */
    modifiedObject?: TransportOrderObject;
    /**
     * 
     * @type {Origin}
     * @memberof TransportOrderChange
     */
    origin?: Origin;
    /**
     * 
     * @type {Array<PatchEntry>}
     * @memberof TransportOrderChange
     */
    patchSet?: Array<PatchEntry>;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderChange
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderChange
     */
    type?: TransportOrderChange.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderChange
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace TransportOrderChange
 */
export namespace TransportOrderChange {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderChangeEvent
 */
export interface TransportOrderChangeEvent {
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof TransportOrderChangeEvent
     */
    linkedTransportOrders?: Array<TransportOrder>;
    /**
     * 
     * @type {Origin}
     * @memberof TransportOrderChangeEvent
     */
    origin?: Origin;
    /**
     * 
     * @type {Array<PatchEntry>}
     * @memberof TransportOrderChangeEvent
     */
    patchSet?: Array<PatchEntry>;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof TransportOrderChangeEvent
     */
    path?: TransportOrderPathSelector;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderChangeEvent
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderChangeEvent
     */
    type?: TransportOrderChangeEvent.TypeEnum;
}

/**
 * @export
 * @namespace TransportOrderChangeEvent
 */
export namespace TransportOrderChangeEvent {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderChangeEventRef
 */
export interface TransportOrderChangeEventRef {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderChangeEventRef
     */
    changeEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderChangeEventRef
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderConfigTest
 */
export interface TransportOrderConfigTest {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTest
     */
    _id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderConfigTest
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTest
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderConfigTest
     */
    created?: Date;
    /**
     * 
     * @type {ExpectedResult}
     * @memberof TransportOrderConfigTest
     */
    expectedResult?: ExpectedResult;
    /**
     * 
     * @type {TransportOrderConfigTestInput}
     * @memberof TransportOrderConfigTest
     */
    input?: TransportOrderConfigTestInput;
    /**
     * 
     * @type {ExpectedResult}
     * @memberof TransportOrderConfigTest
     */
    lastResult?: ExpectedResult;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderConfigTest
     */
    lastRun?: Date;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof TransportOrderConfigTest
     */
    lastSuccessfulConfig?: CompanyConfiguration;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderConfigTest
     */
    lastSuccessfulRun?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderConfigTest
     */
    modified?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTest
     */
    name?: string;
    /**
     * 
     * @type {TransportOrderConfigTestOptions}
     * @memberof TransportOrderConfigTest
     */
    options?: TransportOrderConfigTestOptions;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderConfigTest
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTest
     */
    type?: TransportOrderConfigTest.TypeEnum;
}

/**
 * @export
 * @namespace TransportOrderConfigTest
 */
export namespace TransportOrderConfigTest {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        IMPORT = 'IMPORT',
        EXPORT = 'EXPORT'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderConfigTestInput
 */
export interface TransportOrderConfigTestInput {
    /**
     * 
     * @type {TransportOrderConfigTestInputExport}
     * @memberof TransportOrderConfigTestInput
     */
    exportData?: TransportOrderConfigTestInputExport;
    /**
     * 
     * @type {TransportOrderConfigTestInputImport}
     * @memberof TransportOrderConfigTestInput
     */
    importData?: TransportOrderConfigTestInputImport;
}

/**
 * 
 * @export
 * @interface TransportOrderConfigTestInputExport
 */
export interface TransportOrderConfigTestInputExport {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestInputExport
     */
    eventType?: TransportOrderConfigTestInputExport.EventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestInputExport
     */
    newStatus?: string;
    /**
     * 
     * @type {QueuedEvent}
     * @memberof TransportOrderConfigTestInputExport
     */
    queuedEvent?: QueuedEvent;
    /**
     * 
     * @type {TelematicState}
     * @memberof TransportOrderConfigTestInputExport
     */
    telematicState?: TelematicState;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderConfigTestInputExport
     */
    transportOrder?: TransportOrder;
}

/**
 * @export
 * @namespace TransportOrderConfigTestInputExport
 */
export namespace TransportOrderConfigTestInputExport {
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderConfigTestInputImport
 */
export interface TransportOrderConfigTestInputImport {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestInputImport
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestInputImport
     */
    importDoc?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestInputImport
     */
    type?: TransportOrderConfigTestInputImport.TypeEnum;
}

/**
 * @export
 * @namespace TransportOrderConfigTestInputImport
 */
export namespace TransportOrderConfigTestInputImport {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        TEXT = 'TEXT',
        FILE = 'FILE'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderConfigTestOptions
 */
export interface TransportOrderConfigTestOptions {
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderConfigTestOptions
     */
    checkSortOrderOfTransports?: boolean;
}

/**
 * 
 * @export
 * @interface TransportOrderConfigTestResult
 */
export interface TransportOrderConfigTestResult {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestResult
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestResult
     */
    expected?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderConfigTestResult
     */
    foundDifferences?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestResult
     */
    fullResult?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderConfigTestResult
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestResult
     */
    transportOrderConfigTestId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderConfigTestUpdate
 */
export interface TransportOrderConfigTestUpdate {
    /**
     * 
     * @type {ExpectedResult}
     * @memberof TransportOrderConfigTestUpdate
     */
    expectedResult?: ExpectedResult;
    /**
     * 
     * @type {TransportOrderConfigTestInput}
     * @memberof TransportOrderConfigTestUpdate
     */
    input?: TransportOrderConfigTestInput;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestUpdate
     */
    testId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderConfigTestUpdate
     */
    testName?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderCountResponse
 */
export interface TransportOrderCountResponse {
    /**
     * 
     * @type {number}
     * @memberof TransportOrderCountResponse
     */
    count?: number;
}

/**
 * 
 * @export
 * @interface TransportOrderCreatePageViewConfiguration
 */
export interface TransportOrderCreatePageViewConfiguration {
    /**
     * 
     * @type {FreightCreateViewConfiguration}
     * @memberof TransportOrderCreatePageViewConfiguration
     */
    freightCreateView?: FreightCreateViewConfiguration;
    /**
     * 
     * @type {AddressSelectConfiguration}
     * @memberof TransportOrderCreatePageViewConfiguration
     */
    loadingLocation?: AddressSelectConfiguration;
    /**
     * 
     * @type {ShipperConfiguration}
     * @memberof TransportOrderCreatePageViewConfiguration
     */
    shipper?: ShipperConfiguration;
    /**
     * 
     * @type {Array<TransportOrderTemplate>}
     * @memberof TransportOrderCreatePageViewConfiguration
     */
    templates?: Array<TransportOrderTemplate>;
    /**
     * 
     * @type {TransportCreateViewConfiguration}
     * @memberof TransportOrderCreatePageViewConfiguration
     */
    transportCreateView?: TransportCreateViewConfiguration;
    /**
     * 
     * @type {TransportOrderCreateViewConfiguration}
     * @memberof TransportOrderCreatePageViewConfiguration
     */
    transportOrderCreateView?: TransportOrderCreateViewConfiguration;
    /**
     * 
     * @type {AddressSelectConfiguration}
     * @memberof TransportOrderCreatePageViewConfiguration
     */
    unloadingLocation?: AddressSelectConfiguration;
}

/**
 * 
 * @export
 * @interface TransportOrderCreateViewConfiguration
 */
export interface TransportOrderCreateViewConfiguration {
    /**
     * 
     * @type {Array<AdditionalDataFieldConfiguration>}
     * @memberof TransportOrderCreateViewConfiguration
     */
    additionalData?: Array<AdditionalDataFieldConfiguration>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderCreateViewConfiguration
     */
    externalTransportOrderId?: FieldViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderCreateViewConfiguration
     */
    showAddressBookOnPublicPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderCreateViewConfiguration
     */
    showOrderListOnPublicPage?: boolean;
}

/**
 * 
 * @export
 * @interface TransportOrderDetailPageContractingPartyColumConfig
 */
export interface TransportOrderDetailPageContractingPartyColumConfig {
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    additionalColumns?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showDriver?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showFreightPayer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showOrderBox?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showPrice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showSendToDriverLink?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showSource?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showTarget?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showTrailer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageContractingPartyColumConfig
     */
    showVehicle?: boolean;
}

/**
 * 
 * @export
 * @interface TransportOrderDetailPageViewConfiguration
 */
export interface TransportOrderDetailPageViewConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    allowAssignToTimoCom?: boolean;
    /**
     * 
     * @type {TransportOrderDetailPageContractingPartyColumConfig}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    contractingPartyColumn?: TransportOrderDetailPageContractingPartyColumConfig;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    etaFormat?: TransportOrderDetailPageViewConfiguration.EtaFormatEnum;
    /**
     * 
     * @type {TransportOrderFreightListViewConfiguration}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    freightListViewConfig?: TransportOrderFreightListViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    showFreightLoadingUnloadingTimes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    showFreightStatusColumn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    showTransportOrderStatusChangeConfirmation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    timeDisplayMode?: TransportOrderDetailPageViewConfiguration.TimeDisplayModeEnum;
    /**
     * 
     * @type {TransportOrderDetailViewTransportListViewConfiguration}
     * @memberof TransportOrderDetailPageViewConfiguration
     */
    transportListViewConfig?: TransportOrderDetailViewTransportListViewConfiguration;
}

/**
 * @export
 * @namespace TransportOrderDetailPageViewConfiguration
 */
export namespace TransportOrderDetailPageViewConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum EtaFormatEnum {
        REMAININGTIME = 'REMAINING_TIME',
        DATETIMEOFARRIVAL = 'DATETIME_OF_ARRIVAL'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TimeDisplayModeEnum {
        ADVISED = 'ADVISED',
        PLANNED = 'PLANNED'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderDetailViewTransportListViewConfiguration
 */
export interface TransportOrderDetailViewTransportListViewConfiguration {
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    action?: FieldViewConfiguration;
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    additionalFields?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    city?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    countryCode?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    eta?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    latitude?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    longitude?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    mergeAndOrderKey?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    name?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    name2?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    planArrive?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    planDepart?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    remainingDistance?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    shipmentNr?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    status?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    stopId?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    street?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    transportId?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderDetailViewTransportListViewConfiguration
     */
    zipCode?: FieldViewConfiguration;
}

/**
 * 
 * @export
 * @interface TransportOrderEtaPutResult
 */
export interface TransportOrderEtaPutResult {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderEtaPutResult
     */
    id?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderEtaReport
 */
export interface TransportOrderEtaReport {
    /**
     * 
     * @type {Array<StopEtaReport>}
     * @memberof TransportOrderEtaReport
     */
    stopEtaReports?: Array<StopEtaReport>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderEtaReport
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderEtaReportList
 */
export interface TransportOrderEtaReportList {
    /**
     * 
     * @type {Array<TransportOrderEtaReport>}
     * @memberof TransportOrderEtaReportList
     */
    etaReports?: Array<TransportOrderEtaReport>;
}

/**
 * 
 * @export
 * @interface TransportOrderEvent
 */
export interface TransportOrderEvent {
    /**
     * 
     * @type {TransportOrderChange}
     * @memberof TransportOrderEvent
     */
    change?: TransportOrderChange;
    /**
     * Linked transport orders
     * @type {Array<TransportOrder>}
     * @memberof TransportOrderEvent
     */
    linkedTransportOrders?: Array<TransportOrder>;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderEvent
     */
    transportOrder?: TransportOrder;
}

/**
 * 
 * @export
 * @interface TransportOrderEventMirroringRules
 */
export interface TransportOrderEventMirroringRules {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderEventMirroringRules
     */
    mirrorChangeTypes?: Array<TransportOrderEventMirroringRules.MirrorChangeTypesEnum>;
}

/**
 * @export
 * @namespace TransportOrderEventMirroringRules
 */
export namespace TransportOrderEventMirroringRules {
    /**
     * @export
     * @enum {string}
     */
    export enum MirrorChangeTypesEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderExcelReportColumnList
 */
export interface TransportOrderExcelReportColumnList {
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    artikelNr?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    auftragnehmer?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    auftragsstatus?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    co2Kg?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    dieselL?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    entladestelleLand?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    entladestelleName?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    entladestelleOrt?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    entladestellePlz?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    entladestelleStrasse?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    extTourNr?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    fahrer?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    fahrzeugKennzeichen?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    fahrzeugName?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    frachtNrExt?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    geplanteEntladezeitBis?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    geplanteEntladezeitVon?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    geplanteLadezeitBis?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    geplanteLadezeitVon?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    gewicht?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    gewichtEinheit?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    inhalt?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    kommentar?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    ladestelleLand?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    ladestelleName?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    ladestelleOrt?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    ladestellePlz?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    ladestelleStrasse?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    leerKmNachTour?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    leerKmVorTour?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    lieferscheinNr?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    logeniosId?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    packmittel?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    palettenanzahl?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    planungVon?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    planungVonEntlade?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    sendungsNr?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    stellplaetze?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    streckePlanKm?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    streckeTatsKm?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    tatsaechlicheEntladezeitBis?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    tatsaechlicheEntladezeitVon?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    tatsaechlicheLadezeitBis?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    tatsaechlicheLadezeitVon?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    transportId?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    zeitpunktGeladen?: ExcelExportField;
    /**
     * 
     * @type {ExcelExportField}
     * @memberof TransportOrderExcelReportColumnList
     */
    zeitpunktGeliefert?: ExcelExportField;
}

/**
 * 
 * @export
 * @interface TransportOrderFreightListViewConfiguration
 */
export interface TransportOrderFreightListViewConfiguration {
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    additionalFields?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    containmentType?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    deliveryNr?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    externalFreightId?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    freightId?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    height?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    length?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    loadingMeter?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    status?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    totalLoadingMeter?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    totalLots?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    totalQuantity?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    totalWeight?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    verboseName?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    volume?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderFreightListViewConfiguration
     */
    width?: FieldViewConfiguration;
}

/**
 * 
 * @export
 * @interface TransportOrderHistory
 */
export interface TransportOrderHistory {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderHistory
     */
    _id?: string;
    /**
     * 
     * @type {Array<TransportOrderChange>}
     * @memberof TransportOrderHistory
     */
    changes?: Array<TransportOrderChange>;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderHistory
     */
    creationTimestamp?: Date;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderHistory
     */
    original?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderHistory
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderIdProjection
 */
export interface TransportOrderIdProjection {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderIdProjection
     */
    _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderIdProjection
     */
    billingDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderIdProjection
     */
    observers?: Array<string>;
}

/**
 * 
 * @export
 * @interface TransportOrderInfo
 */
export interface TransportOrderInfo {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderInfo
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderInfo
     */
    targetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderInfo
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderLevelSelector
 */
export interface TransportOrderLevelSelector {
    /**
     * ActionId or null if the level is not a stop action
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    actionLevel?: boolean;
    /**
     * AttachmentId or null if the level is not an attachment
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    attachmentLevel?: boolean;
    /**
     * contractingPartyId or null if the level is not a contractingParty
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    contractingPartyLevel?: boolean;
    /**
     * freightId or null if the level is not located below a freight
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    freightLevel?: boolean;
    /**
     * StopId or null if the level is not located below a loading location
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    loadingLocationLevel?: boolean;
    /**
     * StopId or null if the level is not located below a stop location
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    stopLevel?: boolean;
    /**
     * TransportID or null if the level is not located below a transport
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    transportLevel?: boolean;
    /**
     * TransportOrderID or null if the level is not located below a transport
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    transportOrderLevel?: boolean;
    /**
     * uniqueLocationId or null if the level has no unique Location id
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    uniqueLocationLevel?: boolean;
    /**
     * StopId or null if the level is not located below a unloading location
     * @type {boolean}
     * @memberof TransportOrderLevelSelector
     */
    unloadingLocationLevel?: boolean;
}

/**
 * 
 * @export
 * @interface TransportOrderLinkConfiguration
 */
export interface TransportOrderLinkConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderLinkConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {Array<LinkedCompany>}
     * @memberof TransportOrderLinkConfiguration
     */
    companiesToLinkByKey?: Array<LinkedCompany>;
    /**
     * Copies the assigned trailer of the target transport order to the source transport order when a link is established
     * @type {boolean}
     * @memberof TransportOrderLinkConfiguration
     */
    copyTrailerToSourceTransportOrderOnLink?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderLinkConfiguration
     */
    fixStopsOfLinkedTransports?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderLinkConfiguration
     */
    forceExecutionOfSourceTransportOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderLinkConfiguration
     */
    forwardAttachments?: boolean;
    /**
     * Forwards positions to linked transport orders
     * @type {boolean}
     * @memberof TransportOrderLinkConfiguration
     */
    forwardPositions?: boolean;
    /**
     * Control what positions shall be forwarded to the source company
     * @type {string}
     * @memberof TransportOrderLinkConfiguration
     */
    forwardPositionsMode?: TransportOrderLinkConfiguration.ForwardPositionsModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderLinkConfiguration
     */
    pullObserversFromSourceTransportOrder?: boolean;
    /**
     * 
     * @type {Array<StatusForwardRule>}
     * @memberof TransportOrderLinkConfiguration
     */
    statusForwardRules?: Array<StatusForwardRule>;
}

/**
 * @export
 * @namespace TransportOrderLinkConfiguration
 */
export namespace TransportOrderLinkConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ForwardPositionsModeEnum {
        ALL = 'ALL',
        ONLYTRUCK = 'ONLY_TRUCK',
        ONLYTRAILER = 'ONLY_TRAILER',
        RELEVANTDRIVINGLANE = 'RELEVANT_DRIVING_LANE'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderLinkDescriptionResponse
 */
export interface TransportOrderLinkDescriptionResponse {
    /**
     * 
     * @type {Array<LinkTableEntry>}
     * @memberof TransportOrderLinkDescriptionResponse
     */
    links?: Array<LinkTableEntry>;
}

/**
 * 
 * @export
 * @interface TransportOrderListRequest
 */
export interface TransportOrderListRequest {
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof TransportOrderListRequest
     */
    orders?: Array<TransportOrder>;
}

/**
 * 
 * @export
 * @interface TransportOrderListResponse
 */
export interface TransportOrderListResponse {
    /**
     * 
     * @type {number}
     * @memberof TransportOrderListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<LinkedVehicleInfo>}
     * @memberof TransportOrderListResponse
     */
    linkedVehicles?: Array<LinkedVehicleInfo>;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof TransportOrderListResponse
     */
    transportOrders?: Array<TransportOrder>;
}

/**
 * 
 * @export
 * @interface TransportOrderListViewConfiguration
 */
export interface TransportOrderListViewConfiguration {
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof TransportOrderListViewConfiguration
     */
    additionalColums?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    assignedDeviceColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    assignedDeviceMailColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    assignedDevicePhoneColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    attachmentsColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    companyNameColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    consumedFuel?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    createdColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof TransportOrderListViewConfiguration
     */
    customFilters?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    driverColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    emptyDriveAfter?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    emptyDriveBefore?: FieldViewConfiguration;
    /**
     * 
     * @type {EtaFieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    etaColumn?: EtaFieldViewConfiguration;
    /**
     * 
     * @type {TransportOrderExcelReportColumnList}
     * @memberof TransportOrderListViewConfiguration
     */
    excelReportColumn?: TransportOrderExcelReportColumnList;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    externalTransportOrderIdColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    freightColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    fromColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    idColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    isSubCharteredColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    linkedTours?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    nextStopColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    observerColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderListViewConfiguration
     */
    onlyShowOrdersIfUserHasToListPermission?: boolean;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    originalSourceCompanyColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    planEndColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    planStartColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    plannedTourDistance?: FieldViewConfiguration;
    /**
     * 
     * @type {Array<UserFilter>}
     * @memberof TransportOrderListViewConfiguration
     */
    savedFilters?: Array<UserFilter>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    shipmentNumber?: FieldViewConfiguration;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderListViewConfiguration
     */
    sourceOfPlanDates?: TransportOrderListViewConfiguration.SourceOfPlanDatesEnum;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    statusColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderListViewConfiguration
     */
    stopIndicatorsLimit?: number;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    stopListColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    targetCompanyNameColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    telematicStateColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    totalContainmentQuantity?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    totalLots?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    trailerColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {Array<AdditionalTableColumn>}
     * @memberof TransportOrderListViewConfiguration
     */
    transportOrderStatusFieldColumns?: Array<AdditionalTableColumn>;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    traveledTourDistance?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    userEmailColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    vehicleColumn?: FieldViewConfiguration;
    /**
     * 
     * @type {FieldViewConfiguration}
     * @memberof TransportOrderListViewConfiguration
     */
    vehicleNameColumn?: FieldViewConfiguration;
}

/**
 * @export
 * @namespace TransportOrderListViewConfiguration
 */
export namespace TransportOrderListViewConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceOfPlanDatesEnum {
        PLANTIMEONLY = 'PLAN_TIME_ONLY',
        ADVISEDTIMEWITHPLANTIMEFALLBACK = 'ADVISED_TIME_WITH_PLANTIME_FALLBACK',
        ADVISEDTIMEONLY = 'ADVISED_TIME_ONLY'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderLog
 */
export interface TransportOrderLog {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderLog
     */
    _id?: string;
    /**
     * 
     * @type {TransportOrderMetaInfo}
     * @memberof TransportOrderLog
     */
    meta?: TransportOrderMetaInfo;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderLog
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderLog
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderMapping
 */
export interface TransportOrderMapping {
    /**
     * 
     * @type {Array<AdditionalDataMapping>}
     * @memberof TransportOrderMapping
     */
    additionals?: Array<AdditionalDataMapping>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedDriverExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedDriverFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedDriverLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedDriverPhoneNr?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedTrailerExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedTrailerNumberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedVehicleExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    assignedVehicleNumberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    created?: string;
    /**
     * 
     * @type {Array<LisLinkKeyMapping>}
     * @memberof TransportOrderMapping
     */
    externalLinkKeys?: Array<LisLinkKeyMapping>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    externalTargetCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    externalUserId?: string;
    /**
     * 
     * @type {Array<InfSymRecordConfiguration>}
     * @memberof TransportOrderMapping
     */
    infSymRecords?: Array<InfSymRecordConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    plan_start?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    plan_stop?: string;
    /**
     * 
     * @type {GroovyBasedMappingScript}
     * @memberof TransportOrderMapping
     */
    script?: GroovyBasedMappingScript;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderMapping
     */
    shouldExportCommentAsDefaultText?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    targetCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    targetCustomerName?: string;
    /**
     * 
     * @type {Array<TextRecord>}
     * @memberof TransportOrderMapping
     */
    textRecords?: Array<TextRecord>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    transportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderMapping
     */
    useSingleTourApp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    useSingleTourAppScript?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMapping
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderMessageLog
 */
export interface TransportOrderMessageLog {
    /**
     * 
     * @type {Array<MessageLog>}
     * @memberof TransportOrderMessageLog
     */
    logs?: Array<MessageLog>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMessageLog
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderMessageLogsResponse
 */
export interface TransportOrderMessageLogsResponse {
    /**
     * 
     * @type {Array<TransportOrderMessageLog>}
     * @memberof TransportOrderMessageLogsResponse
     */
    transportOrderLogs?: Array<TransportOrderMessageLog>;
}

/**
 * 
 * @export
 * @interface TransportOrderMetaInfo
 */
export interface TransportOrderMetaInfo {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMetaInfo
     */
    _id?: string;
    /**
     * 
     * @type {Array<LogEntry>}
     * @memberof TransportOrderMetaInfo
     */
    logs?: Array<LogEntry>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMetaInfo
     */
    originalData?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderMetaInfo
     */
    source?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderObject
 */
export interface TransportOrderObject {
    /**
     * 
     * @type {StopAction}
     * @memberof TransportOrderObject
     */
    action?: StopAction;
    /**
     * 
     * @type {AssignedDevice}
     * @memberof TransportOrderObject
     */
    assignedDevice?: AssignedDevice;
    /**
     * 
     * @type {AssignedOrderBox}
     * @memberof TransportOrderObject
     */
    assignedOrderBox?: AssignedOrderBox;
    /**
     * 
     * @type {Vehicle}
     * @memberof TransportOrderObject
     */
    assignedTrailer?: Vehicle;
    /**
     * 
     * @type {Vehicle}
     * @memberof TransportOrderObject
     */
    assignedVehicle?: Vehicle;
    /**
     * 
     * @type {Attachment}
     * @memberof TransportOrderObject
     */
    attachment?: Attachment;
    /**
     * 
     * @type {Freight}
     * @memberof TransportOrderObject
     */
    freight?: Freight;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderObject
     */
    linkedTransportOrder?: TransportOrder;
    /**
     * 
     * @type {Observer}
     * @memberof TransportOrderObject
     */
    observer?: Observer;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof TransportOrderObject
     */
    path?: TransportOrderPathSelector;
    /**
     * 
     * @type {StopLocation}
     * @memberof TransportOrderObject
     */
    stop?: StopLocation;
    /**
     * 
     * @type {Transport}
     * @memberof TransportOrderObject
     */
    transport?: Transport;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderObject
     */
    transportOrder?: TransportOrder;
}

/**
 * 
 * @export
 * @interface TransportOrderObserverInfo
 */
export interface TransportOrderObserverInfo {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderObserverInfo
     */
    accessToken?: string;
    /**
     * 
     * @type {Observer}
     * @memberof TransportOrderObserverInfo
     */
    observer?: Observer;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderObserverInfo
     */
    trackingUrl?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderPathSelector
 */
export interface TransportOrderPathSelector {
    /**
     * ActionId or null if the referenced element is not a stop action
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    actionId?: string;
    /**
     * AttachmentId or null if the referenced element is not an attachment
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    attachmentId?: string;
    /**
     * contractingPartyId or null if the referenced element is not a contractingParty
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    contractingPartyId?: string;
    /**
     * The externalTransportOrder id of the referenced transport order
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    externalTransportOrderId?: string;
    /**
     * The file hash of an attachment
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    fileHash?: string;
    /**
     * The name of an attachment
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    fileName?: string;
    /**
     * freightId or null if the referenced element is not located below a freight
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    freightId?: string;
    /**
     * The Id of the selected observer
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    observerId?: string;
    /**
     * If a transportOrder is represented as shipment, this value describes the shipment index within the transport order
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    shipmentIndex?: string;
    /**
     * StopId or null if the referenced element is not located below a stop location
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    stopId?: string;
    /**
     * TransportID or null if the referenced element is not located below a transport
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    transportId?: string;
    /**
     * ID of the referenced transport order
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    transportOrderId?: string;
    /**
     * uniqueLocationId or null if the referenced element has no unique Location id
     * @type {string}
     * @memberof TransportOrderPathSelector
     */
    uniqueLocationId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderPdfResponse
 */
export interface TransportOrderPdfResponse {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderPdfResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderPdfResponse
     */
    pdfAsBase64?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderPdfView
 */
export interface TransportOrderPdfView {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderPdfView
     */
    template?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderResponse
 */
export interface TransportOrderResponse {
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderResponse
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof TransportOrderResponse
     */
    validationErrors?: Array<ValidationError>;
}

/**
 * 
 * @export
 * @interface TransportOrderRetractedDeviceInfo
 */
export interface TransportOrderRetractedDeviceInfo {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderRetractedDeviceInfo
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderRetractedDeviceInfo
     */
    accessUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderRetractedDeviceInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderRetractedDeviceInfo
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderRetractedDeviceInfo
     */
    verboseName?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderRewriteConfiguration
 */
export interface TransportOrderRewriteConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderRewriteConfiguration
     */
    addGeoHashToExternalLinkKey?: boolean;
    /**
     * 
     * @type {Array<AddObserverRule>}
     * @memberof TransportOrderRewriteConfiguration
     */
    addObservers?: Array<AddObserverRule>;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderRewriteConfiguration
     */
    addTransportOrderIdAndTransportIdToTransportExternalLinkKey?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderRewriteConfiguration
     */
    addTransportOrderIdToExternalLinkKey?: boolean;
    /**
     * Default is 25
     * @type {number}
     * @memberof TransportOrderRewriteConfiguration
     */
    barcodeHeight?: number;
    /**
     * Default is 25
     * @type {number}
     * @memberof TransportOrderRewriteConfiguration
     */
    barcodePositionX?: number;
    /**
     * Default is 15
     * @type {number}
     * @memberof TransportOrderRewriteConfiguration
     */
    barcodePositionY?: number;
    /**
     * Default is 133.33
     * @type {number}
     * @memberof TransportOrderRewriteConfiguration
     */
    barcodeWidth?: number;
    /**
     * 
     * @type {Array<LinkKeyExtractionRule>}
     * @memberof TransportOrderRewriteConfiguration
     */
    deriveLinkKeys?: Array<LinkKeyExtractionRule>;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderRewriteConfiguration
     */
    expandNullOClockToNullOClockTimeWindow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderRewriteConfiguration
     */
    extractTextOfPdfAttachments?: boolean;
    /**
     * Applies to Source Company
     * @type {boolean}
     * @memberof TransportOrderRewriteConfiguration
     */
    fillPlanArrivePlanDepartTimesFromOpeningHours?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderRewriteConfiguration
     */
    insertExternalTransportOrderIdBarcodeOnPdfAttachments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderRewriteConfiguration
     */
    transportOrderBarcodeScript?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderScripts
 */
export interface TransportOrderScripts {
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    addAttachmentScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    deriveExternalLinkKeyOfTransportScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    postAssignDeviceScript?: GroovyScript;
    /**
     * 
     * @type {PostAssignTargetCompanyScript}
     * @memberof TransportOrderScripts
     */
    postAssignTargetCompanyScript?: PostAssignTargetCompanyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    postAssignVehicleScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    postModifyTransportOrderScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    postSubmitStatusScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    preCreateTransportOrderScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    preModifyOrCreateTransportOrderScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    preResolveIndexOperatorScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    preSubmitStatusScript?: GroovyScript;
    /**
     * 
     * @type {GroovyScript}
     * @memberof TransportOrderScripts
     */
    telematicTourMappingScript?: GroovyScript;
}

/**
 * 
 * @export
 * @interface TransportOrderSplitRequest
 */
export interface TransportOrderSplitRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderSplitRequest
     */
    addressMappingIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderSplitRequest
     */
    forceSplit?: boolean;
}

/**
 * 
 * @export
 * @interface TransportOrderSplitResponse
 */
export interface TransportOrderSplitResponse {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderSplitResponse
     */
    loadingReplacedTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderSplitResponse
     */
    originTransportOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderSplitResponse
     */
    unloadingReplacedTransportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderStatus
 */
export interface TransportOrderStatus {
    /**
     * Additional key-value-pairs associated with this status
     * @type {Array<AdditionalDataEntry>}
     * @memberof TransportOrderStatus
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderStatus
     */
    executingTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderStatus
     */
    insertedIntoTargetSystemTimestamp?: Date;
    /**
     * This field states wether the order was already billed to the freight payer
     * @type {boolean}
     * @memberof TransportOrderStatus
     */
    isBilled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatus
     */
    isLocked?: boolean;
    /**
     * 
     * @type {GpsPosition}
     * @memberof TransportOrderStatus
     */
    location?: GpsPosition;
    /**
     * 
     * @type {Origin}
     * @memberof TransportOrderStatus
     */
    origin?: Origin;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatus
     */
    statusCode?: TransportOrderStatus.StatusCodeEnum;
    /**
     * 
     * @type {TelematicState}
     * @memberof TransportOrderStatus
     */
    telematicState?: TelematicState;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderStatus
     */
    timestamp?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportOrderStatus
     */
    tmsOrderIds?: Array<string>;
}

/**
 * @export
 * @namespace TransportOrderStatus
 */
export namespace TransportOrderStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderStatusChangeResult
 */
export interface TransportOrderStatusChangeResult {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusChangeResult
     */
    result?: string;
}

/**
 * 
 * @export
 * @interface TransportOrderStatusMapping
 */
export interface TransportOrderStatusMapping {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusMapping
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusMapping
     */
    _export?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusMapping
     */
    _import?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusMapping
     */
    includeWhenExportTransport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusMapping
     */
    includeWhenExportTransportOrder?: boolean;
    /**
     * 
     * @type {LisTransportOrderStatusImportConfig}
     * @memberof TransportOrderStatusMapping
     */
    onImport?: LisTransportOrderStatusImportConfig;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusMapping
     */
    statusCode?: TransportOrderStatusMapping.StatusCodeEnum;
    /**
     * 
     * @type {LisStatusFields}
     * @memberof TransportOrderStatusMapping
     */
    statusFields?: LisStatusFields;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusMapping
     */
    targetStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusMapping
     */
    telematicStatusCode?: TransportOrderStatusMapping.TelematicStatusCodeEnum;
}

/**
 * @export
 * @namespace TransportOrderStatusMapping
 */
export namespace TransportOrderStatusMapping {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TelematicStatusCodeEnum {
        SENT = 'SENT',
        ARRIVEDONDEVICE = 'ARRIVED_ON_DEVICE',
        READBYDRIVER = 'READ_BY_DRIVER',
        CANCELED = 'CANCELED',
        MODIFIED = 'MODIFIED'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderStatusRequest
 */
export interface TransportOrderStatusRequest {
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof TransportOrderStatusRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusRequest
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusRequest
     */
    forceOverrideDependentStates?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusRequest
     */
    forceOverrideTimestamp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusRequest
     */
    isBilled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusRequest
     */
    isLocked?: boolean;
    /**
     * 
     * @type {Origin}
     * @memberof TransportOrderStatusRequest
     */
    origin?: Origin;
    /**
     * The status which should be submitted
     * @type {string}
     * @memberof TransportOrderStatusRequest
     */
    statusCode?: TransportOrderStatusRequest.StatusCodeEnum;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderStatusRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace TransportOrderStatusRequest
 */
export namespace TransportOrderStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusCodeEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderStatusUpdateRequest
 */
export interface TransportOrderStatusUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    actionId?: string;
    /**
     * 
     * @type {Array<AdditionalDataEntry>}
     * @memberof TransportOrderStatusUpdateRequest
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderStatusUpdateRequest
     */
    advisedFromTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderStatusUpdateRequest
     */
    advisedTillTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    attachmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusUpdateRequest
     */
    disableStatusDowngrade?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    externalTransportOrderId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusUpdateRequest
     */
    forceOverrideDependentStates?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusUpdateRequest
     */
    forceOverrideTimestamp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    freightId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusUpdateRequest
     */
    isBilled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderStatusUpdateRequest
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    observerId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderStatusUpdateRequest
     */
    odometer?: number;
    /**
     * 
     * @type {Origin}
     * @memberof TransportOrderStatusUpdateRequest
     */
    origin?: Origin;
    /**
     * 
     * @type {GpsPosition}
     * @memberof TransportOrderStatusUpdateRequest
     */
    position?: GpsPosition;
    /**
     * The status which should be submitted
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    statusCode?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    stopId?: string;
    /**
     * 
     * @type {StopMetaDataIdentifier}
     * @memberof TransportOrderStatusUpdateRequest
     */
    stopMetaDataIdentifier?: StopMetaDataIdentifier;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    telematicStatusCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderStatusUpdateRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof TransportOrderStatusUpdateRequest
     */
    totalFuel?: number;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderStatusUpdateRequest
     */
    transportOrderId?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof TransportOrderStatusUpdateRequest
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface TransportOrderTemplate
 */
export interface TransportOrderTemplate {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTemplate
     */
    name?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderTemplate
     */
    order?: TransportOrder;
}

/**
 * 
 * @export
 * @interface TransportOrderTestEventRequest
 */
export interface TransportOrderTestEventRequest {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    attachmentId?: string;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof TransportOrderTestEventRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    configCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    eventType?: TransportOrderTestEventRequest.EventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    freightId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    newStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    orderCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    stopId?: string;
    /**
     * 
     * @type {TelematicState}
     * @memberof TransportOrderTestEventRequest
     */
    telematicState?: TelematicState;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    transportId?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderTestEventRequest
     */
    transportOrder?: TransportOrder;
    /**
     * 
     * @type {string}
     * @memberof TransportOrderTestEventRequest
     */
    transportOrderId?: string;
}

/**
 * @export
 * @namespace TransportOrderTestEventRequest
 */
export namespace TransportOrderTestEventRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderToExcelConversionRequest
 */
export interface TransportOrderToExcelConversionRequest {
    /**
     * 
     * @type {string}
     * @memberof TransportOrderToExcelConversionRequest
     */
    mode?: TransportOrderToExcelConversionRequest.ModeEnum;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof TransportOrderToExcelConversionRequest
     */
    orders?: Array<TransportOrder>;
}

/**
 * @export
 * @namespace TransportOrderToExcelConversionRequest
 */
export namespace TransportOrderToExcelConversionRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        OneLinePerFreight = 'OneLinePerFreight',
        OneLinePerTransport = 'OneLinePerTransport'
    }
}

/**
 * 
 * @export
 * @interface TransportOrderValidationResult
 */
export interface TransportOrderValidationResult {
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderValidationResult
     */
    valid?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TransportOrderValidationResult
     */
    validationTimestamp?: Date;
    /**
     * 
     * @type {Array<ValidationWarning>}
     * @memberof TransportOrderValidationResult
     */
    warnings?: Array<ValidationWarning>;
}

/**
 * 
 * @export
 * @interface TransportOrderWithPolyline
 */
export interface TransportOrderWithPolyline {
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderWithPolyline
     */
    order?: TransportOrder;
    /**
     * 
     * @type {TourPolylineResponse}
     * @memberof TransportOrderWithPolyline
     */
    polyline?: TourPolylineResponse;
}

/**
 * 
 * @export
 * @interface TransportOrderWithTokenPin
 */
export interface TransportOrderWithTokenPin {
    /**
     * Pin of the Shipment Form Config
     * @type {string}
     * @memberof TransportOrderWithTokenPin
     */
    pin?: string;
    /**
     * Access Token of the Shipment Form Config
     * @type {string}
     * @memberof TransportOrderWithTokenPin
     */
    token?: string;
    /**
     * 
     * @type {TransportOrder}
     * @memberof TransportOrderWithTokenPin
     */
    transportOrder?: TransportOrder;
}

/**
 * 
 * @export
 * @interface TransportOrderWorkflowAreaConfig
 */
export interface TransportOrderWorkflowAreaConfig {
    /**
     * 
     * @type {boolean}
     * @memberof TransportOrderWorkflowAreaConfig
     */
    isVisible?: boolean;
}

/**
 * 
 * @export
 * @interface TransportSelectedOrderToExcelConversionRequest
 */
export interface TransportSelectedOrderToExcelConversionRequest {
    /**
     * 
     * @type {string}
     * @memberof TransportSelectedOrderToExcelConversionRequest
     */
    mode?: TransportSelectedOrderToExcelConversionRequest.ModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TransportSelectedOrderToExcelConversionRequest
     */
    sendReportByEmail?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportSelectedOrderToExcelConversionRequest
     */
    transportOrderIds?: Array<string>;
}

/**
 * @export
 * @namespace TransportSelectedOrderToExcelConversionRequest
 */
export namespace TransportSelectedOrderToExcelConversionRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        OneLinePerFreight = 'OneLinePerFreight',
        OneLinePerTransport = 'OneLinePerTransport'
    }
}

/**
 * 
 * @export
 * @interface TransportStopPair
 */
export interface TransportStopPair {
    /**
     * 
     * @type {StopLocation}
     * @memberof TransportStopPair
     */
    sl?: StopLocation;
    /**
     * 
     * @type {Transport}
     * @memberof TransportStopPair
     */
    t?: Transport;
    /**
     * 
     * @type {string}
     * @memberof TransportStopPair
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface TriggerAssignCompanyRequest
 */
export interface TriggerAssignCompanyRequest {
    /**
     * 
     * @type {boolean}
     * @memberof TriggerAssignCompanyRequest
     */
    shouldForceMirrorThisEvent?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TriggerAssignCompanyRequest
     */
    transportOrderIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface TriggerAssignCompanyResponse
 */
export interface TriggerAssignCompanyResponse {
    /**
     * 
     * @type {Array<FailedAssignmentsResponse>}
     * @memberof TriggerAssignCompanyResponse
     */
    failedAssignments?: Array<FailedAssignmentsResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TriggerAssignCompanyResponse
     */
    successfulAssignments?: Array<string>;
}

/**
 * 
 * @export
 * @interface TriggerFailedRequestResponse
 */
export interface TriggerFailedRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof TriggerFailedRequestResponse
     */
    error?: string;
    /**
     * 
     * @type {Array<Byte>}
     * @memberof TriggerFailedRequestResponse
     */
    response?: Array<Byte>;
    /**
     * 
     * @type {number}
     * @memberof TriggerFailedRequestResponse
     */
    statusCode?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TriggerFailedRequestResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TriggerFailedRequestResponse
     */
    xRequestId?: string;
}

/**
 * 
 * @export
 * @interface TriggerOnEvent
 */
export interface TriggerOnEvent {
    /**
     * 
     * @type {string}
     * @memberof TriggerOnEvent
     */
    actionKind?: TriggerOnEvent.ActionKindEnum;
    /**
     * 
     * @type {string}
     * @memberof TriggerOnEvent
     */
    applyWhenScript?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerOnEvent
     */
    eventType?: TriggerOnEvent.EventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TriggerOnEvent
     */
    statusCode?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerOnEvent
     */
    transportOrderEventType?: TriggerOnEvent.TransportOrderEventTypeEnum;
}

/**
 * @export
 * @namespace TriggerOnEvent
 */
export namespace TriggerOnEvent {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionKindEnum {
        LOAD = 'LOAD',
        UNLOAD = 'UNLOAD',
        ENTERFERRY = 'ENTER_FERRY',
        ENTERTRAIN = 'ENTER_TRAIN',
        LEAVEFERRY = 'LEAVE_FERRY',
        LEAVETRAIN = 'LEAVE_TRAIN',
        OTHER = 'OTHER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum EventTypeEnum {
        TRANSPORTORDEREVENT = 'TRANSPORT_ORDER_EVENT',
        POSITIONEVENT = 'POSITION_EVENT',
        ETAEVENT = 'ETA_EVENT',
        COMPANYEVENT = 'COMPANY_EVENT',
        SYSTEMNOTIFICATION = 'SYSTEM_NOTIFICATION',
        TEXTMESSAGEEVENT = 'TEXT_MESSAGE_EVENT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TransportOrderEventTypeEnum {
        CREATE = 'CREATE',
        UPDATE = 'UPDATE',
        STORNO = 'STORNO',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTMODIFY = 'ATTACHMENT_MODIFY',
        ASSIGNCOMPANY = 'ASSIGN_COMPANY',
        ASSIGNVEHICLE = 'ASSIGN_VEHICLE',
        ASSIGNDEVICE = 'ASSIGN_DEVICE',
        ASSIGNTRAILER = 'ASSIGN_TRAILER',
        ASSIGNORDERBOX = 'ASSIGN_ORDERBOX',
        STATUSUPDATETRANSPORTORDER = 'STATUS_UPDATE_TRANSPORT_ORDER',
        STATUSUPDATESTOPLOCATION = 'STATUS_UPDATE_STOP_LOCATION',
        STATUSUPDATESTOPACTION = 'STATUS_UPDATE_STOP_ACTION',
        STATUSUPDATEFREIGHT = 'STATUS_UPDATE_FREIGHT',
        STATUSUPDATEATTACHMENT = 'STATUS_UPDATE_ATTACHMENT',
        LINKEVENT = 'LINK_EVENT',
        STATUSUPDATEOBSERVER = 'STATUS_UPDATE_OBSERVER'
    }
}

/**
 * 
 * @export
 * @interface TriggerTransportOrderConfigTestsRequest
 */
export interface TriggerTransportOrderConfigTestsRequest {
    /**
     * 
     * @type {string}
     * @memberof TriggerTransportOrderConfigTestsRequest
     */
    companyId?: string;
    /**
     * 
     * @type {CompanyConfiguration}
     * @memberof TriggerTransportOrderConfigTestsRequest
     */
    config?: CompanyConfiguration;
    /**
     * 
     * @type {Array<string>}
     * @memberof TriggerTransportOrderConfigTestsRequest
     */
    testIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface TriggerTransportOrderConfigTestsResponse
 */
export interface TriggerTransportOrderConfigTestsResponse {
    /**
     * 
     * @type {Array<TransportOrderConfigTestResult>}
     * @memberof TriggerTransportOrderConfigTestsResponse
     */
    results?: Array<TransportOrderConfigTestResult>;
}

/**
 * 
 * @export
 * @interface UnbilledTransportOrderResponse
 */
export interface UnbilledTransportOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof UnbilledTransportOrderResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<CompanyWithUnbilledOrders>}
     * @memberof UnbilledTransportOrderResponse
     */
    orderIdsByCompany?: Array<CompanyWithUnbilledOrders>;
}

/**
 * 
 * @export
 * @interface UnsubscribeEmailRequest
 */
export interface UnsubscribeEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof UnsubscribeEmailRequest
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof UnsubscribeEmailRequest
     */
    subject?: string;
}

/**
 * 
 * @export
 * @interface UpdateAcknowledgedOnStatusValidationRequest
 */
export interface UpdateAcknowledgedOnStatusValidationRequest {
    /**
     * 
     * @type {Array<StatusValidationWarningIdentification>}
     * @memberof UpdateAcknowledgedOnStatusValidationRequest
     */
    identifications?: Array<StatusValidationWarningIdentification>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAcknowledgedOnStatusValidationRequest
     */
    newAcknowledgedState?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateAcknowledgedOnStatusValidationResponse
 */
export interface UpdateAcknowledgedOnStatusValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateAcknowledgedOnStatusValidationResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {Array<ValidationWarning>}
     * @memberof UpdateAcknowledgedOnStatusValidationResponse
     */
    newFutureWarnings?: Array<ValidationWarning>;
    /**
     * 
     * @type {Array<ValidationWarning>}
     * @memberof UpdateAcknowledgedOnStatusValidationResponse
     */
    newWarnings?: Array<ValidationWarning>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAcknowledgedOnStatusValidationResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateAvailableCompanyToUserRequest
 */
export interface UpdateAvailableCompanyToUserRequest {
    /**
     * 
     * @type {Array<AvailableCompany>}
     * @memberof UpdateAvailableCompanyToUserRequest
     */
    newAvailableCompanies?: Array<AvailableCompany>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCompanyToUserRequest
     */
    userId?: string;
}

/**
 * 
 * @export
 * @interface UpdateAvailableCompanyToUserResponse
 */
export interface UpdateAvailableCompanyToUserResponse {
    /**
     * 
     * @type {Array<AvailableCompany>}
     * @memberof UpdateAvailableCompanyToUserResponse
     */
    newAvailableCompaniesOfUser?: Array<AvailableCompany>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCompanyToUserResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateCompanyConfigHistoryCommentRequest
 */
export interface UpdateCompanyConfigHistoryCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyConfigHistoryCommentRequest
     */
    newComment?: string;
}

/**
 * 
 * @export
 * @interface UpdateCompanyConfigHistoryCommentResponse
 */
export interface UpdateCompanyConfigHistoryCommentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyConfigHistoryCommentResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateCompanyConfigRequestWrapper
 */
export interface UpdateCompanyConfigRequestWrapper {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyConfigRequestWrapper
     */
    configAsJson?: string;
}

/**
 * 
 * @export
 * @interface UpdateCompanyCustomerReportResponseForSingleCompany
 */
export interface UpdateCompanyCustomerReportResponseForSingleCompany {
    /**
     * 
     * @type {CompanyCustomerReportConfig}
     * @memberof UpdateCompanyCustomerReportResponseForSingleCompany
     */
    companyCustomerReportSettings?: CompanyCustomerReportConfig;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyCustomerReportResponseForSingleCompany
     */
    companyId?: string;
}

/**
 * 
 * @export
 * @interface UpdateConfigDraftsResponse
 */
export interface UpdateConfigDraftsResponse {
    /**
     * 
     * @type {CompanyConfigurationDraft}
     * @memberof UpdateConfigDraftsResponse
     */
    newDraft?: CompanyConfigurationDraft;
}

/**
 * 
 * @export
 * @interface UpdateIgnoreListForCustomerReportForAllCompaniesRequest
 */
export interface UpdateIgnoreListForCustomerReportForAllCompaniesRequest {
    /**
     * 
     * @type {Array<CompanyWithResponsibleManager>}
     * @memberof UpdateIgnoreListForCustomerReportForAllCompaniesRequest
     */
    companyList?: Array<CompanyWithResponsibleManager>;
}

/**
 * 
 * @export
 * @interface UpdateIgnoreListForCustomerReportForAllCompaniesResponse
 */
export interface UpdateIgnoreListForCustomerReportForAllCompaniesResponse {
    /**
     * 
     * @type {Array<CompanyWithResponsibleManager>}
     * @memberof UpdateIgnoreListForCustomerReportForAllCompaniesResponse
     */
    companyList?: Array<CompanyWithResponsibleManager>;
}

/**
 * 
 * @export
 * @interface UpdateQueuedEventsRequest
 */
export interface UpdateQueuedEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateQueuedEventsRequest
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateQueuedEventsRequest
     */
    newProcessed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateQueuedEventsRequest
     */
    newProcessingState?: UpdateQueuedEventsRequest.NewProcessingStateEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateQueuedEventsRequest
     */
    queuedEventIds?: Array<string>;
}

/**
 * @export
 * @namespace UpdateQueuedEventsRequest
 */
export namespace UpdateQueuedEventsRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum NewProcessingStateEnum {
        OK = 'OK',
        WARN = 'WARN',
        ERROR = 'ERROR',
        RETRY = 'RETRY'
    }
}

/**
 * 
 * @export
 * @interface UpdateSchedulerReportingConfigurationResponse
 */
export interface UpdateSchedulerReportingConfigurationResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateSchedulerReportingConfigurationResponse
     */
    error?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSchedulerReportingConfigurationResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateSystemStatusMessagesResponse
 */
export interface UpdateSystemStatusMessagesResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateSystemStatusMessagesResponse
     */
    error?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSystemStatusMessagesResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateTransportOrderConfigTestsRequest
 */
export interface UpdateTransportOrderConfigTestsRequest {
    /**
     * 
     * @type {Array<TransportOrderConfigTestUpdate>}
     * @memberof UpdateTransportOrderConfigTestsRequest
     */
    updates?: Array<TransportOrderConfigTestUpdate>;
}

/**
 * 
 * @export
 * @interface UpdateTransportOrderConfigTestsResponse
 */
export interface UpdateTransportOrderConfigTestsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTransportOrderConfigTestsResponse
     */
    failedUpdateTestIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTransportOrderConfigTestsResponse
     */
    successfulUpdateTestIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface UploadInvoiceToZohoRequest
 */
export interface UploadInvoiceToZohoRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadInvoiceToZohoRequest
     */
    invoiceId?: string;
}

/**
 * 
 * @export
 * @interface UploadPageViewConfiguration
 */
export interface UploadPageViewConfiguration {
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    accentBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    accentTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    accordionDividerColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    attachmentsTableHeaderBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    attachmentsTableHeaderTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    cardBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    checkboxColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    dropZoneBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    dropZoneBorderColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    dropZoneHoverBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    dropZoneHoverBorderColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    dropZoneHoverTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    dropZoneTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    errorColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    linkColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    pageBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    pendingColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    primaryButtonBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    primaryButtonColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    primaryButtonHoverBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    primaryButtonHoverTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    primaryTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    secondaryTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    sectionHeaderTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    selectionHighlightColor?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPageViewConfiguration
     */
    successColor?: string;
}

/**
 * 
 * @export
 * @interface UsageBasedCostMatrix
 */
export interface UsageBasedCostMatrix {
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    assignOrderBoxPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    assignTargetCompanyPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    assignedDevicePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    attachmentCmrUsagePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    attachmentUsagePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    bounceOrderPrice?: number;
    /**
     * 
     * @type {Array<ConverterCostMatrix>}
     * @memberof UsageBasedCostMatrix
     */
    converterUsageCostMatrix?: Array<ConverterCostMatrix>;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    mobileWebAppUsagePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    orderLinkedToCarrierOrderPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    orderLinkedToShipperOrderPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    perObserverPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    pricePerTransport?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageBasedCostMatrix
     */
    trackingPrice?: number;
}

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    _id?: string;
    /**
     * 
     * @type {PartnerAccess}
     * @memberof User
     */
    access?: PartnerAccess;
    /**
     * 
     * @type {Array<AvailableCompany>}
     * @memberof User
     */
    availableCompanies?: Array<AvailableCompany>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    emailVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    externalUserId?: string;
    /**
     * 
     * @type {Array<UserFilter>}
     * @memberof User
     */
    filters?: Array<UserFilter>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    phoneVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    preferredLanguage?: User.PreferredLanguageEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    roles?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    sendMailsToAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    showObservedOrdersFromForeignCompanies?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    spedionUser?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    state?: User.StateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    totpActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    companyAdmin?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    permissions?: Array<User.PermissionsEnum>;
}

/**
 * @export
 * @namespace User
 */
export namespace User {
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredLanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
        DELETED = 'DELETED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionsEnum {
        USERSCREATE = 'USERS_CREATE',
        USERSDELETE = 'USERS_DELETE',
        USERSMODIFY = 'USERS_MODIFY',
        USERSVIEW = 'USERS_VIEW',
        USERSMODIFYPERMISSIONS = 'USERS_MODIFY_PERMISSIONS',
        FTPACCESS = 'FTP_ACCESS',
        TOCREATE = 'TO_CREATE',
        TOLINK = 'TO_LINK',
        TOASSIGNCOMPANY = 'TO_ASSIGN_COMPANY',
        TOASSIGNVEHICLE = 'TO_ASSIGN_VEHICLE',
        TOPATCH = 'TO_PATCH',
        TOPOSTSTATUS = 'TO_POST_STATUS',
        TOPUT = 'TO_PUT',
        TOSTORNO = 'TO_STORNO',
        TOADDOBSERVER = 'TO_ADD_OBSERVER',
        TOREMOVEOBSERVER = 'TO_REMOVE_OBSERVER',
        QUEUELIST = 'QUEUE_LIST',
        QUEUEMODIFY = 'QUEUE_MODIFY',
        EVENTS = 'EVENTS',
        COMPANYMODIFY = 'COMPANY_MODIFY',
        COMPANYFULLVIEW = 'COMPANY_FULL_VIEW',
        COMPANYPARTIALVIEW = 'COMPANY_PARTIAL_VIEW',
        COMPANYVIEWPARTNERS = 'COMPANY_VIEW_PARTNERS',
        COMPANYMODIFYPARTNERS = 'COMPANY_MODIFY_PARTNERS',
        USEDEPOT = 'USE_DEPOT',
        USEDEPOTSTOCK = 'USE_DEPOT_STOCK',
        ETAGET = 'ETA_GET',
        ETAPOST = 'ETA_POST',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDOWNLOAD = 'ATTACHMENT_DOWNLOAD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTUPLOAD = 'ATTACHMENT_UPLOAD',
        TELEMATICPOST = 'TELEMATIC_POST',
        TELEMATICGET = 'TELEMATIC_GET',
        USERROLESVIEW = 'USER_ROLES_VIEW',
        USERROLESCREATEMODIFYDELETE = 'USER_ROLES_CREATE_MODIFY_DELETE',
        USERROLESASSIGN = 'USER_ROLES_ASSIGN',
        VEHICLEVIEW = 'VEHICLE_VIEW',
        VEHICLECREATEMODIFYDELETE = 'VEHICLE_CREATE_MODIFY_DELETE',
        SCHEDULERCONFIG = 'SCHEDULER_CONFIG',
        VIEWREPORT = 'VIEW_REPORT',
        VIEWMANAGEMENTREPORT = 'VIEW_MANAGEMENT_REPORT',
        VIEWGENERICREPORTS = 'VIEW_GENERIC_REPORTS',
        DRIVERVIEW = 'DRIVER_VIEW',
        DRIVERCREATEMODIFYDELETE = 'DRIVER_CREATE_MODIFY_DELETE',
        USEMAILGATEWAY = 'USE_MAIL_GATEWAY',
        CMUSE = 'CM_USE',
        ATTACHMENTREVIEW = 'ATTACHMENT_REVIEW',
        SELFATTACHMENTREVIEW = 'SELF_ATTACHMENT_REVIEW',
        BILL = 'BILL',
        ADDRESSMAPPINGVIEW = 'ADDRESS_MAPPING_VIEW',
        ADDRESSMAPPINGCREATEMODIFYDELETE = 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE',
        COMPANYMESSAGELOGVIEW = 'COMPANY_MESSAGE_LOGVIEW',
        RESENDFAILEDREQUESTS = 'RESEND_FAILED_REQUESTS',
        COMPANYTAGVIEW = 'COMPANY_TAG_VIEW',
        INTERNALMONITORING = 'INTERNAL_MONITORING',
        VIEWSTANDINGTIMES = 'VIEW_STANDING_TIMES',
        TOASSIGNTRAILER = 'TO_ASSIGN_TRAILER',
        TOASSIGNDEVICE = 'TO_ASSIGN_DEVICE',
        VIEWEMPTYKMREPORT = 'VIEW_EMPTY_KM_REPORT',
        VIEWFLEET = 'VIEW_FLEET',
        TOLIST = 'TO_LIST',
        VIEWTOURCOSTREPORT = 'VIEW_TOUR_COST_REPORT'
    }
}

/**
 * 
 * @export
 * @interface UserCreateRequest
 */
export interface UserCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    externalUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    preferredLanguage?: UserCreateRequest.PreferredLanguageEnum;
}

/**
 * @export
 * @namespace UserCreateRequest
 */
export namespace UserCreateRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredLanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
}

/**
 * 
 * @export
 * @interface UserDetails
 */
export interface UserDetails {
    /**
     * 
     * @type {string}
     * @memberof UserDetails
     */
    deviceInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetails
     */
    ipAddress?: string;
}

/**
 * 
 * @export
 * @interface UserFilter
 */
export interface UserFilter {
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserFilter
     */
    dateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserFilter
     */
    dateTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    dateType?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    filterId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    genericDateRange?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserFilter
     */
    includeFreightStatus?: Array<UserFilter.IncludeFreightStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserFilter
     */
    includeStopLocationStatus?: Array<UserFilter.IncludeStopLocationStatusEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserFilter
     */
    partnerIds?: Array<string>;
    /**
     * 
     * @type {RelativeDateRangeSpec}
     * @memberof UserFilter
     */
    relativeDateRangeSpec?: RelativeDateRangeSpec;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    searchText?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    searchTextType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserFilter
     */
    transportOrderStatus?: Array<UserFilter.TransportOrderStatusEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserFilter
     */
    userId?: string;
}

/**
 * @export
 * @namespace UserFilter
 */
export namespace UserFilter {
    /**
     * @export
     * @enum {string}
     */
    export enum IncludeFreightStatusEnum {
        PLANNED = 'PLANNED',
        PICKED = 'PICKED',
        LOADING = 'LOADING',
        NOTLOADED = 'NOT_LOADED',
        LOADED = 'LOADED',
        UNLOADING = 'UNLOADING',
        DELIVERED = 'DELIVERED',
        REJECTED = 'REJECTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IncludeStopLocationStatusEnum {
        PLANNED = 'PLANNED',
        ADVISED = 'ADVISED',
        APPROACHING = 'APPROACHING',
        ARRIVED = 'ARRIVED',
        DEPARTED = 'DEPARTED',
        CANCELED = 'CANCELED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TransportOrderStatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
}

/**
 * 
 * @export
 * @interface UserFilterList
 */
export interface UserFilterList {
    /**
     * 
     * @type {Array<UserFilter>}
     * @memberof UserFilterList
     */
    userFilterList?: Array<UserFilter>;
}

/**
 * 
 * @export
 * @interface UserListResponse
 */
export interface UserListResponse {
    /**
     * 
     * @type {number}
     * @memberof UserListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<User>}
     * @memberof UserListResponse
     */
    users?: Array<User>;
}

/**
 * 
 * @export
 * @interface UserRequest
 */
export interface UserRequest {
    /**
     * 
     * @type {PartnerAccess}
     * @memberof UserRequest
     */
    access?: PartnerAccess;
    /**
     * 
     * @type {Array<AvailableCompany>}
     * @memberof UserRequest
     */
    availableCompanies?: Array<AvailableCompany>;
    /**
     * 
     * @type {boolean}
     * @memberof UserRequest
     */
    companyAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    externalUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    password?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRequest
     */
    permissions?: Array<UserRequest.PermissionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    preferredLanguage?: UserRequest.PreferredLanguageEnum;
    /**
     * 
     * @type {UserDetails}
     * @memberof UserRequest
     */
    userDetails?: UserDetails;
}

/**
 * @export
 * @namespace UserRequest
 */
export namespace UserRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionsEnum {
        USERSCREATE = 'USERS_CREATE',
        USERSDELETE = 'USERS_DELETE',
        USERSMODIFY = 'USERS_MODIFY',
        USERSVIEW = 'USERS_VIEW',
        USERSMODIFYPERMISSIONS = 'USERS_MODIFY_PERMISSIONS',
        FTPACCESS = 'FTP_ACCESS',
        TOCREATE = 'TO_CREATE',
        TOLINK = 'TO_LINK',
        TOASSIGNCOMPANY = 'TO_ASSIGN_COMPANY',
        TOASSIGNVEHICLE = 'TO_ASSIGN_VEHICLE',
        TOPATCH = 'TO_PATCH',
        TOPOSTSTATUS = 'TO_POST_STATUS',
        TOPUT = 'TO_PUT',
        TOSTORNO = 'TO_STORNO',
        TOADDOBSERVER = 'TO_ADD_OBSERVER',
        TOREMOVEOBSERVER = 'TO_REMOVE_OBSERVER',
        QUEUELIST = 'QUEUE_LIST',
        QUEUEMODIFY = 'QUEUE_MODIFY',
        EVENTS = 'EVENTS',
        COMPANYMODIFY = 'COMPANY_MODIFY',
        COMPANYFULLVIEW = 'COMPANY_FULL_VIEW',
        COMPANYPARTIALVIEW = 'COMPANY_PARTIAL_VIEW',
        COMPANYVIEWPARTNERS = 'COMPANY_VIEW_PARTNERS',
        COMPANYMODIFYPARTNERS = 'COMPANY_MODIFY_PARTNERS',
        USEDEPOT = 'USE_DEPOT',
        USEDEPOTSTOCK = 'USE_DEPOT_STOCK',
        ETAGET = 'ETA_GET',
        ETAPOST = 'ETA_POST',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDOWNLOAD = 'ATTACHMENT_DOWNLOAD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTUPLOAD = 'ATTACHMENT_UPLOAD',
        TELEMATICPOST = 'TELEMATIC_POST',
        TELEMATICGET = 'TELEMATIC_GET',
        USERROLESVIEW = 'USER_ROLES_VIEW',
        USERROLESCREATEMODIFYDELETE = 'USER_ROLES_CREATE_MODIFY_DELETE',
        USERROLESASSIGN = 'USER_ROLES_ASSIGN',
        VEHICLEVIEW = 'VEHICLE_VIEW',
        VEHICLECREATEMODIFYDELETE = 'VEHICLE_CREATE_MODIFY_DELETE',
        SCHEDULERCONFIG = 'SCHEDULER_CONFIG',
        VIEWREPORT = 'VIEW_REPORT',
        VIEWMANAGEMENTREPORT = 'VIEW_MANAGEMENT_REPORT',
        VIEWGENERICREPORTS = 'VIEW_GENERIC_REPORTS',
        DRIVERVIEW = 'DRIVER_VIEW',
        DRIVERCREATEMODIFYDELETE = 'DRIVER_CREATE_MODIFY_DELETE',
        USEMAILGATEWAY = 'USE_MAIL_GATEWAY',
        CMUSE = 'CM_USE',
        ATTACHMENTREVIEW = 'ATTACHMENT_REVIEW',
        SELFATTACHMENTREVIEW = 'SELF_ATTACHMENT_REVIEW',
        BILL = 'BILL',
        ADDRESSMAPPINGVIEW = 'ADDRESS_MAPPING_VIEW',
        ADDRESSMAPPINGCREATEMODIFYDELETE = 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE',
        COMPANYMESSAGELOGVIEW = 'COMPANY_MESSAGE_LOGVIEW',
        RESENDFAILEDREQUESTS = 'RESEND_FAILED_REQUESTS',
        COMPANYTAGVIEW = 'COMPANY_TAG_VIEW',
        INTERNALMONITORING = 'INTERNAL_MONITORING',
        VIEWSTANDINGTIMES = 'VIEW_STANDING_TIMES',
        TOASSIGNTRAILER = 'TO_ASSIGN_TRAILER',
        TOASSIGNDEVICE = 'TO_ASSIGN_DEVICE',
        VIEWEMPTYKMREPORT = 'VIEW_EMPTY_KM_REPORT',
        VIEWFLEET = 'VIEW_FLEET',
        TOLIST = 'TO_LIST',
        VIEWTOURCOSTREPORT = 'VIEW_TOUR_COST_REPORT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredLanguageEnum {
        GERMAN = 'GERMAN',
        ENGLISH = 'ENGLISH',
        POLISH = 'POLISH',
        RUSSIAN = 'RUSSIAN',
        LITHUANIAN = 'LITHUANIAN',
        SPANISH = 'SPANISH',
        FRENCH = 'FRENCH',
        DUTCH = 'DUTCH',
        TURKISH = 'TURKISH',
        ITALIAN = 'ITALIAN',
        BULGARIAN = 'BULGARIAN',
        HUNGARIAN = 'HUNGARIAN',
        ROMANIAN = 'ROMANIAN',
        CZECH = 'CZECH'
    }
}

/**
 * 
 * @export
 * @interface UserRole
 */
export interface UserRole {
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRole
     */
    permissions?: Array<UserRole.PermissionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRole
     */
    users?: Array<string>;
}

/**
 * @export
 * @namespace UserRole
 */
export namespace UserRole {
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionsEnum {
        USERSCREATE = 'USERS_CREATE',
        USERSDELETE = 'USERS_DELETE',
        USERSMODIFY = 'USERS_MODIFY',
        USERSVIEW = 'USERS_VIEW',
        USERSMODIFYPERMISSIONS = 'USERS_MODIFY_PERMISSIONS',
        FTPACCESS = 'FTP_ACCESS',
        TOCREATE = 'TO_CREATE',
        TOLINK = 'TO_LINK',
        TOASSIGNCOMPANY = 'TO_ASSIGN_COMPANY',
        TOASSIGNVEHICLE = 'TO_ASSIGN_VEHICLE',
        TOPATCH = 'TO_PATCH',
        TOPOSTSTATUS = 'TO_POST_STATUS',
        TOPUT = 'TO_PUT',
        TOSTORNO = 'TO_STORNO',
        TOADDOBSERVER = 'TO_ADD_OBSERVER',
        TOREMOVEOBSERVER = 'TO_REMOVE_OBSERVER',
        QUEUELIST = 'QUEUE_LIST',
        QUEUEMODIFY = 'QUEUE_MODIFY',
        EVENTS = 'EVENTS',
        COMPANYMODIFY = 'COMPANY_MODIFY',
        COMPANYFULLVIEW = 'COMPANY_FULL_VIEW',
        COMPANYPARTIALVIEW = 'COMPANY_PARTIAL_VIEW',
        COMPANYVIEWPARTNERS = 'COMPANY_VIEW_PARTNERS',
        COMPANYMODIFYPARTNERS = 'COMPANY_MODIFY_PARTNERS',
        USEDEPOT = 'USE_DEPOT',
        USEDEPOTSTOCK = 'USE_DEPOT_STOCK',
        ETAGET = 'ETA_GET',
        ETAPOST = 'ETA_POST',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDOWNLOAD = 'ATTACHMENT_DOWNLOAD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTUPLOAD = 'ATTACHMENT_UPLOAD',
        TELEMATICPOST = 'TELEMATIC_POST',
        TELEMATICGET = 'TELEMATIC_GET',
        USERROLESVIEW = 'USER_ROLES_VIEW',
        USERROLESCREATEMODIFYDELETE = 'USER_ROLES_CREATE_MODIFY_DELETE',
        USERROLESASSIGN = 'USER_ROLES_ASSIGN',
        VEHICLEVIEW = 'VEHICLE_VIEW',
        VEHICLECREATEMODIFYDELETE = 'VEHICLE_CREATE_MODIFY_DELETE',
        SCHEDULERCONFIG = 'SCHEDULER_CONFIG',
        VIEWREPORT = 'VIEW_REPORT',
        VIEWMANAGEMENTREPORT = 'VIEW_MANAGEMENT_REPORT',
        VIEWGENERICREPORTS = 'VIEW_GENERIC_REPORTS',
        DRIVERVIEW = 'DRIVER_VIEW',
        DRIVERCREATEMODIFYDELETE = 'DRIVER_CREATE_MODIFY_DELETE',
        USEMAILGATEWAY = 'USE_MAIL_GATEWAY',
        CMUSE = 'CM_USE',
        ATTACHMENTREVIEW = 'ATTACHMENT_REVIEW',
        SELFATTACHMENTREVIEW = 'SELF_ATTACHMENT_REVIEW',
        BILL = 'BILL',
        ADDRESSMAPPINGVIEW = 'ADDRESS_MAPPING_VIEW',
        ADDRESSMAPPINGCREATEMODIFYDELETE = 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE',
        COMPANYMESSAGELOGVIEW = 'COMPANY_MESSAGE_LOGVIEW',
        RESENDFAILEDREQUESTS = 'RESEND_FAILED_REQUESTS',
        COMPANYTAGVIEW = 'COMPANY_TAG_VIEW',
        INTERNALMONITORING = 'INTERNAL_MONITORING',
        VIEWSTANDINGTIMES = 'VIEW_STANDING_TIMES',
        TOASSIGNTRAILER = 'TO_ASSIGN_TRAILER',
        TOASSIGNDEVICE = 'TO_ASSIGN_DEVICE',
        VIEWEMPTYKMREPORT = 'VIEW_EMPTY_KM_REPORT',
        VIEWFLEET = 'VIEW_FLEET',
        TOLIST = 'TO_LIST',
        VIEWTOURCOSTREPORT = 'VIEW_TOUR_COST_REPORT'
    }
}

/**
 * 
 * @export
 * @interface UserRoleAddRequest
 */
export interface UserRoleAddRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRoleAddRequest
     */
    userId?: string;
}

/**
 * 
 * @export
 * @interface UserRoleRequest
 */
export interface UserRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRoleRequest
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRoleRequest
     */
    permissions?: Array<UserRoleRequest.PermissionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRoleRequest
     */
    users?: Array<string>;
}

/**
 * @export
 * @namespace UserRoleRequest
 */
export namespace UserRoleRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionsEnum {
        USERSCREATE = 'USERS_CREATE',
        USERSDELETE = 'USERS_DELETE',
        USERSMODIFY = 'USERS_MODIFY',
        USERSVIEW = 'USERS_VIEW',
        USERSMODIFYPERMISSIONS = 'USERS_MODIFY_PERMISSIONS',
        FTPACCESS = 'FTP_ACCESS',
        TOCREATE = 'TO_CREATE',
        TOLINK = 'TO_LINK',
        TOASSIGNCOMPANY = 'TO_ASSIGN_COMPANY',
        TOASSIGNVEHICLE = 'TO_ASSIGN_VEHICLE',
        TOPATCH = 'TO_PATCH',
        TOPOSTSTATUS = 'TO_POST_STATUS',
        TOPUT = 'TO_PUT',
        TOSTORNO = 'TO_STORNO',
        TOADDOBSERVER = 'TO_ADD_OBSERVER',
        TOREMOVEOBSERVER = 'TO_REMOVE_OBSERVER',
        QUEUELIST = 'QUEUE_LIST',
        QUEUEMODIFY = 'QUEUE_MODIFY',
        EVENTS = 'EVENTS',
        COMPANYMODIFY = 'COMPANY_MODIFY',
        COMPANYFULLVIEW = 'COMPANY_FULL_VIEW',
        COMPANYPARTIALVIEW = 'COMPANY_PARTIAL_VIEW',
        COMPANYVIEWPARTNERS = 'COMPANY_VIEW_PARTNERS',
        COMPANYMODIFYPARTNERS = 'COMPANY_MODIFY_PARTNERS',
        USEDEPOT = 'USE_DEPOT',
        USEDEPOTSTOCK = 'USE_DEPOT_STOCK',
        ETAGET = 'ETA_GET',
        ETAPOST = 'ETA_POST',
        ATTACHMENTADD = 'ATTACHMENT_ADD',
        ATTACHMENTDOWNLOAD = 'ATTACHMENT_DOWNLOAD',
        ATTACHMENTDELETE = 'ATTACHMENT_DELETE',
        ATTACHMENTUPLOAD = 'ATTACHMENT_UPLOAD',
        TELEMATICPOST = 'TELEMATIC_POST',
        TELEMATICGET = 'TELEMATIC_GET',
        USERROLESVIEW = 'USER_ROLES_VIEW',
        USERROLESCREATEMODIFYDELETE = 'USER_ROLES_CREATE_MODIFY_DELETE',
        USERROLESASSIGN = 'USER_ROLES_ASSIGN',
        VEHICLEVIEW = 'VEHICLE_VIEW',
        VEHICLECREATEMODIFYDELETE = 'VEHICLE_CREATE_MODIFY_DELETE',
        SCHEDULERCONFIG = 'SCHEDULER_CONFIG',
        VIEWREPORT = 'VIEW_REPORT',
        VIEWMANAGEMENTREPORT = 'VIEW_MANAGEMENT_REPORT',
        VIEWGENERICREPORTS = 'VIEW_GENERIC_REPORTS',
        DRIVERVIEW = 'DRIVER_VIEW',
        DRIVERCREATEMODIFYDELETE = 'DRIVER_CREATE_MODIFY_DELETE',
        USEMAILGATEWAY = 'USE_MAIL_GATEWAY',
        CMUSE = 'CM_USE',
        ATTACHMENTREVIEW = 'ATTACHMENT_REVIEW',
        SELFATTACHMENTREVIEW = 'SELF_ATTACHMENT_REVIEW',
        BILL = 'BILL',
        ADDRESSMAPPINGVIEW = 'ADDRESS_MAPPING_VIEW',
        ADDRESSMAPPINGCREATEMODIFYDELETE = 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE',
        COMPANYMESSAGELOGVIEW = 'COMPANY_MESSAGE_LOGVIEW',
        RESENDFAILEDREQUESTS = 'RESEND_FAILED_REQUESTS',
        COMPANYTAGVIEW = 'COMPANY_TAG_VIEW',
        INTERNALMONITORING = 'INTERNAL_MONITORING',
        VIEWSTANDINGTIMES = 'VIEW_STANDING_TIMES',
        TOASSIGNTRAILER = 'TO_ASSIGN_TRAILER',
        TOASSIGNDEVICE = 'TO_ASSIGN_DEVICE',
        VIEWEMPTYKMREPORT = 'VIEW_EMPTY_KM_REPORT',
        VIEWFLEET = 'VIEW_FLEET',
        TOLIST = 'TO_LIST',
        VIEWTOURCOSTREPORT = 'VIEW_TOUR_COST_REPORT'
    }
}

/**
 * 
 * @export
 * @interface UserRoleResponse
 */
export interface UserRoleResponse {
    /**
     * 
     * @type {number}
     * @memberof UserRoleResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof UserRoleResponse
     */
    roles?: Array<UserRole>;
}

/**
 * 
 * @export
 * @interface UserVariables
 */
export interface UserVariables {
    /**
     * 
     * @type {string}
     * @memberof UserVariables
     */
    logeniosMessageId?: string;
}

/**
 * 
 * @export
 * @interface ValidateTotpResponse
 */
export interface ValidateTotpResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateTotpResponse
     */
    totpValid?: boolean;
}

/**
 * 
 * @export
 * @interface ValidationCheck
 */
export interface ValidationCheck {
    /**
     * 
     * @type {ValidationCheckActiveAfter}
     * @memberof ValidationCheck
     */
    checkActiveAfter?: ValidationCheckActiveAfter;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationCheck
     */
    disableThisRuleForTargetCompanies?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationCheck
     */
    disableThisRuleWhenInState?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationCheck
     */
    enableThisRuleForTargetCompanies?: Array<string>;
    /**
     * 
     * @type {GroovyScript}
     * @memberof ValidationCheck
     */
    enableWhenScript?: GroovyScript;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheck
     */
    requireAssignedDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheck
     */
    requireAssignedVehicle?: boolean;
    /**
     * 
     * @type {ValidationCheckRequireAttachments}
     * @memberof ValidationCheck
     */
    requireAttachments?: ValidationCheckRequireAttachments;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheck
     */
    requireLinkedOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheck
     */
    requireTracking?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationCheck
     */
    requiredStates?: Array<string>;
    /**
     * 
     * @type {ValidationCheckRequiredTimestamps}
     * @memberof ValidationCheck
     */
    requiredTimestamps?: ValidationCheckRequiredTimestamps;
    /**
     * 
     * @type {string}
     * @memberof ValidationCheck
     */
    requiredTimestampsMode?: ValidationCheck.RequiredTimestampsModeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationCheck
     */
    requiredWorkflowFields?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ValidationCheck
     */
    validationScript?: string;
}

/**
 * @export
 * @namespace ValidationCheck
 */
export namespace ValidationCheck {
    /**
     * @export
     * @enum {string}
     */
    export enum RequiredTimestampsModeEnum {
        AND = 'AND',
        OR = 'OR'
    }
}

/**
 * 
 * @export
 * @interface ValidationCheckActiveAfter
 */
export interface ValidationCheckActiveAfter {
    /**
     * 
     * @type {number}
     * @memberof ValidationCheckActiveAfter
     */
    offsetInHours?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationCheckActiveAfter
     */
    time?: ValidationCheckActiveAfter.TimeEnum;
}

/**
 * @export
 * @namespace ValidationCheckActiveAfter
 */
export namespace ValidationCheckActiveAfter {
    /**
     * @export
     * @enum {string}
     */
    export enum TimeEnum {
        Created = 'Created',
        TransportOrderPlanStart = 'TransportOrderPlanStart',
        TransportOrderPlanEnd = 'TransportOrderPlanEnd',
        StopLocationPlanArrive = 'StopLocationPlanArrive',
        StopLocationPlanDepart = 'StopLocationPlanDepart'
    }
}

/**
 * 
 * @export
 * @interface ValidationCheckRequireAttachments
 */
export interface ValidationCheckRequireAttachments {
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationCheckRequireAttachments
     */
    allowedStates?: Array<ValidationCheckRequireAttachments.AllowedStatesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ValidationCheckRequireAttachments
     */
    ofCategory?: ValidationCheckRequireAttachments.OfCategoryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequireAttachments
     */
    requireAcceptedState?: boolean;
}

/**
 * @export
 * @namespace ValidationCheckRequireAttachments
 */
export namespace ValidationCheckRequireAttachments {
    /**
     * @export
     * @enum {string}
     */
    export enum AllowedStatesEnum {
        CREATED = 'CREATED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OfCategoryEnum {
        DeliveryNote = 'DeliveryNote',
        CartageNote = 'CartageNote',
        ProofOfDelivery = 'ProofOfDelivery',
        ProofOfDeliveryTemplate = 'ProofOfDeliveryTemplate',
        Bordereau = 'Bordereau',
        CmrDocument = 'CmrDocument',
        PhotoOfDamage = 'PhotoOfDamage',
        PhotoOfDeliveryLocation = 'PhotoOfDeliveryLocation',
        ReturnNote = 'ReturnNote',
        WeightNote = 'WeightNote',
        CustomsDocuments = 'CustomsDocuments',
        Signature = 'Signature',
        Other = 'Other',
        Bill = 'Bill',
        PhotoOfLoadSecuring = 'PhotoOfLoadSecuring',
        RejectedAttachment = 'RejectedAttachment',
        FreightOrder = 'FreightOrder',
        PickupNote = 'PickupNote',
        PalletNote = 'PalletNote',
        ShipmentNote = 'ShipmentNote'
    }
}

/**
 * 
 * @export
 * @interface ValidationCheckRequiredTimestamps
 */
export interface ValidationCheckRequiredTimestamps {
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    advised?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    arrived?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    canceled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    delivered?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    departed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    loaded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    notLoaded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    rejected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationCheckRequiredTimestamps
     */
    unloading?: boolean;
}

/**
 * 
 * @export
 * @interface ValidationConfiguration
 */
export interface ValidationConfiguration {
    /**
     * 
     * @type {DisabledStaticRules}
     * @memberof ValidationConfiguration
     */
    disabledStaticRules?: DisabledStaticRules;
    /**
     * 
     * @type {Array<ValidationRule>}
     * @memberof ValidationConfiguration
     */
    rules?: Array<ValidationRule>;
    /**
     * 
     * @type {Array<SimpleCronTimes>}
     * @memberof ValidationConfiguration
     */
    sendReminderMailTimes?: Array<SimpleCronTimes>;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationConfiguration
     */
    sendWeeklyReminderEmail?: boolean;
}

/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    field?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface ValidationResult
 */
export interface ValidationResult {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof ValidationResult
     */
    errors?: Array<ValidationError>;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationResult
     */
    successful?: boolean;
}

/**
 * 
 * @export
 * @interface ValidationRule
 */
export interface ValidationRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationRule
     */
    autoAcknowledgeOnTransportOrderStatus?: Array<ValidationRule.AutoAcknowledgeOnTransportOrderStatusEnum>;
    /**
     * 
     * @type {ValidationCheck}
     * @memberof ValidationRule
     */
    check?: ValidationCheck;
    /**
     * 
     * @type {string}
     * @memberof ValidationRule
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationRule
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationRule
     */
    informAssignedDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationRule
     */
    informImmediately?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationRule
     */
    informSourceCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationRule
     */
    informTargetCompany?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidationRule
     */
    level?: ValidationRule.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof ValidationRule
     */
    ruleName?: string;
}

/**
 * @export
 * @namespace ValidationRule
 */
export namespace ValidationRule {
    /**
     * @export
     * @enum {string}
     */
    export enum AutoAcknowledgeOnTransportOrderStatusEnum {
        CREATED = 'CREATED',
        DISPATCHING = 'DISPATCHING',
        ACKNOWLEDGING = 'ACKNOWLEDGING',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        EXECUTING = 'EXECUTING',
        DELIVERED = 'DELIVERED',
        DONE = 'DONE',
        CANCELED = 'CANCELED',
        INPUTMISSING = 'INPUT_MISSING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        TRANSPORTORDER = 'TRANSPORT_ORDER',
        TRANSPORT = 'TRANSPORT',
        STOPLOCATION = 'STOP_LOCATION',
        LOADINGLOCATION = 'LOADING_LOCATION',
        UNLOADINGLOCATION = 'UNLOADING_LOCATION',
        STOPACTION = 'STOP_ACTION',
        FREIGHT = 'FREIGHT'
    }
}

/**
 * 
 * @export
 * @interface ValidationWarning
 */
export interface ValidationWarning {
    /**
     * 
     * @type {boolean}
     * @memberof ValidationWarning
     */
    acknowledged?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidationWarning
     */
    checkType?: ValidationWarning.CheckTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ValidationWarning
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationWarning
     */
    informAssignedDevice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationWarning
     */
    informImmediately?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationWarning
     */
    informSourceCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationWarning
     */
    informTargetCompany?: boolean;
    /**
     * 
     * @type {TransportOrderPathSelector}
     * @memberof ValidationWarning
     */
    location?: TransportOrderPathSelector;
    /**
     * 
     * @type {string}
     * @memberof ValidationWarning
     */
    requiredAction?: ValidationWarning.RequiredActionEnum;
    /**
     * 
     * @type {RequiredUserInputData}
     * @memberof ValidationWarning
     */
    requiredActionData?: RequiredUserInputData;
    /**
     * 
     * @type {string}
     * @memberof ValidationWarning
     */
    ruleName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ValidationWarning
     */
    warningActiveAfter?: Date;
}

/**
 * @export
 * @namespace ValidationWarning
 */
export namespace ValidationWarning {
    /**
     * @export
     * @enum {string}
     */
    export enum CheckTypeEnum {
        SCRIPTCHECK = 'SCRIPT_CHECK',
        STATUSCHECK = 'STATUS_CHECK',
        TIMESTAMPCHECK = 'TIMESTAMP_CHECK',
        ASSIGNEDVEHICLECHECK = 'ASSIGNED_VEHICLE_CHECK',
        TRACKINGCHECK = 'TRACKING_CHECK',
        LINKEDCHECK = 'LINKED_CHECK',
        ATTACHMENTCHECK = 'ATTACHMENT_CHECK',
        WORKFLOWFIELDSCHECK = 'WORKFLOW_FIELDS_CHECK',
        STATICCHECK = 'STATIC_CHECK',
        ASSIGNEDDEVICECHECK = 'ASSIGNED_DEVICE_CHECK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RequiredActionEnum {
        INPUTEXTERNALCUSTOMERNUMBER = 'INPUT_EXTERNAL_CUSTOMER_NUMBER',
        CHECKADDRESS = 'CHECK_ADDRESS',
        INPUTEXTERNALCUSTOMERNUMBERANDCHECKADDRESS = 'INPUT_EXTERNAL_CUSTOMER_NUMBER_AND_CHECK_ADDRESS',
        PROVIDEGEOCOORDINATES = 'PROVIDE_GEO_COORDINATES',
        PROVIDEFREIGHTMAPPING = 'PROVIDE_FREIGHT_MAPPING',
        PROVIDESHIPMENTMAPPING = 'PROVIDE_SHIPMENT_MAPPING',
        CONFIRM = 'CONFIRM',
        NOTIFY = 'NOTIFY',
        PROVIDESTATUSMESSAGES = 'PROVIDE_STATUS_MESSAGES'
    }
}

/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * Identifier of this vehicle
     * @type {string}
     * @memberof Vehicle
     */
    _id?: string;
    /**
     * 
     * @type {Numberplate}
     * @memberof Vehicle
     */
    cleanedNumberPlate?: Numberplate;
    /**
     * Company id of the company which own the vehicle
     * @type {string}
     * @memberof Vehicle
     */
    companyId?: string;
    /**
     * 
     * @type {DailyStatistics}
     * @memberof Vehicle
     */
    dailyStats?: DailyStatistics;
    /**
     * User defined identifier of this vehicle
     * @type {string}
     * @memberof Vehicle
     */
    externalVehicleId?: string;
    /**
     * The vehicle fuel type
     * @type {string}
     * @memberof Vehicle
     */
    fuelType?: Vehicle.FuelTypeEnum;
    /**
     * Vehicle registration of the vehicle
     * @type {string}
     * @memberof Vehicle
     */
    numberPlate?: string;
    /**
     * Archived past daily stats
     * @type {Array<DailyStatistics>}
     * @memberof Vehicle
     */
    pastDailyStats?: Array<DailyStatistics>;
    /**
     * 
     * @type {VehicleProperties}
     * @memberof Vehicle
     */
    properties?: VehicleProperties;
    /**
     * 
     * @type {VehicleShare}
     * @memberof Vehicle
     */
    share?: VehicleShare;
    /**
     * The vehicle category
     * @type {string}
     * @memberof Vehicle
     */
    vehicleType?: Vehicle.VehicleTypeEnum;
}

/**
 * @export
 * @namespace Vehicle
 */
export namespace Vehicle {
    /**
     * @export
     * @enum {string}
     */
    export enum FuelTypeEnum {
        DIESEL = 'DIESEL',
        LNG = 'LNG',
        CNG = 'CNG',
        HYDRO = 'HYDRO',
        BEV = 'BEV',
        HVO100 = 'HVO100'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum VehicleTypeEnum {
        TRAILER = 'TRAILER',
        CAR = 'CAR',
        TRANSPORTER = 'TRANSPORTER',
        TRUCK75T = 'TRUCK_7_5T',
        TRUCK1199T = 'TRUCK_11_99T',
        TRUCK18T = 'TRUCK_18T',
        TRUCK40T = 'TRUCK_40T',
        TRUCKTRAILER = 'TRUCK_TRAILER',
        TANKERTRUCK = 'TANKER_TRUCK'
    }
}

/**
 * 
 * @export
 * @interface VehicleApiGatewaySourcesResponse
 */
export interface VehicleApiGatewaySourcesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleApiGatewaySourcesResponse
     */
    sources?: Array<string>;
}

/**
 * 
 * @export
 * @interface VehicleAssignmentMonitoringConfiguration
 */
export interface VehicleAssignmentMonitoringConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    daysToCheck?: number;
    /**
     * 
     * @type {Date}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    level?: VehicleAssignmentMonitoringConfiguration.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    monitoredVehicles?: VehicleAssignmentMonitoringConfiguration.MonitoredVehiclesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    showToAllParties?: boolean;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {string}
     * @memberof VehicleAssignmentMonitoringConfiguration
     */
    title?: string;
}

/**
 * @export
 * @namespace VehicleAssignmentMonitoringConfiguration
 */
export namespace VehicleAssignmentMonitoringConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MonitoredVehiclesEnum {
        TRUCK = 'TRUCK',
        TRAILER = 'TRAILER',
        BOTH = 'BOTH'
    }
}

/**
 * 
 * @export
 * @interface VehicleEmptyKilometersRequest
 */
export interface VehicleEmptyKilometersRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyKilometersRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyKilometersRequest
     */
    sinceTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyKilometersRequest
     */
    toTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyKilometersRequest
     */
    vehicle?: string;
}

/**
 * 
 * @export
 * @interface VehicleEmptyKilometersResponse
 */
export interface VehicleEmptyKilometersResponse {
    /**
     * 
     * @type {Array<EmptyKilometersSegment>}
     * @memberof VehicleEmptyKilometersResponse
     */
    segments?: Array<EmptyKilometersSegment>;
}

/**
 * 
 * @export
 * @interface VehicleEmptyTourDetailsSegment
 */
export interface VehicleEmptyTourDetailsSegment {
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    beelineDistanceInKm?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    distance?: number;
    /**
     * 
     * @type {Address}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    fromAddress?: Address;
    /**
     * 
     * @type {Position}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    fromPosition?: Position;
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    odometerDistanceInKm?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    smallBeelineAlert?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    toAddress?: Address;
    /**
     * 
     * @type {Position}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    toPosition?: Position;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleEmptyTourDetailsSegment
     */
    transportOrderId?: Array<string>;
}

/**
 * 
 * @export
 * @interface VehicleEmptyTourRequest
 */
export interface VehicleEmptyTourRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyTourRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyTourRequest
     */
    sinceTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyTourRequest
     */
    toTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyTourRequest
     */
    vehicleId?: string;
}

/**
 * 
 * @export
 * @interface VehicleEmptyTourResponse
 */
export interface VehicleEmptyTourResponse {
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourResponse
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourResponse
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourResponse
     */
    percentageByOdometer?: number;
    /**
     * 
     * @type {Array<VehicleEmptyTourDetailsSegment>}
     * @memberof VehicleEmptyTourResponse
     */
    segments?: Array<VehicleEmptyTourDetailsSegment>;
    /**
     * 
     * @type {Date}
     * @memberof VehicleEmptyTourResponse
     */
    sinceTimestamp?: Date;
    /**
     * 
     * @type {Array<VehicleEmptyTourDetailsSegment>}
     * @memberof VehicleEmptyTourResponse
     */
    slicedSegments?: Array<VehicleEmptyTourDetailsSegment>;
    /**
     * 
     * @type {Date}
     * @memberof VehicleEmptyTourResponse
     */
    toTimestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourResponse
     */
    totalDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleEmptyTourResponse
     */
    totalDistanceByOdometerInKm?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleEmptyTourResponse
     */
    vehicleId?: string;
}

/**
 * 
 * @export
 * @interface VehicleGeoFilterRequest
 */
export interface VehicleGeoFilterRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleGeoFilterRequest
     */
    companyId?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleGeoFilterRequest
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleGeoFilterRequest
     */
    longitude?: number;
    /**
     * 
     * @type {Date}
     * @memberof VehicleGeoFilterRequest
     */
    meanTimeOverride?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleGeoFilterRequest
     */
    numberPlate?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleGeoFilterRequest
     */
    polygon?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleGeoFilterRequest
     */
    radiusInMeter?: number;
    /**
     * 
     * @type {Date}
     * @memberof VehicleGeoFilterRequest
     */
    sinceTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehicleGeoFilterRequest
     */
    toTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleGeoFilterRequest
     */
    vehicleId?: string;
}

/**
 * 
 * @export
 * @interface VehicleListResponse
 */
export interface VehicleListResponse {
    /**
     * 
     * @type {number}
     * @memberof VehicleListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<LastPosition>}
     * @memberof VehicleListResponse
     */
    lastPositions?: Array<LastPosition>;
    /**
     * 
     * @type {Array<Vehicle>}
     * @memberof VehicleListResponse
     */
    vehicles?: Array<Vehicle>;
}

/**
 * 
 * @export
 * @interface VehiclePolyline
 */
export interface VehiclePolyline {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehiclePolyline
     */
    appDeviceIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof VehiclePolyline
     */
    from?: Date;
    /**
     * 
     * @type {Position}
     * @memberof VehiclePolyline
     */
    lastVehiclePosition?: Position;
    /**
     * 
     * @type {string}
     * @memberof VehiclePolyline
     */
    polyline?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehiclePolyline
     */
    to?: Date;
    /**
     * 
     * @type {Vehicle}
     * @memberof VehiclePolyline
     */
    vehicle?: Vehicle;
    /**
     * 
     * @type {Array<VehicleTrackSegment>}
     * @memberof VehiclePolyline
     */
    vehicleTrackSegments?: Array<VehicleTrackSegment>;
}

/**
 * 
 * @export
 * @interface VehiclePolylineBilledItem
 */
export interface VehiclePolylineBilledItem {
    /**
     * 
     * @type {string}
     * @memberof VehiclePolylineBilledItem
     */
    vehicleId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehiclePolylineBilledItem
     */
    vehicleNumberPlate?: string;
}

/**
 * 
 * @export
 * @interface VehiclePolylineBilling
 */
export interface VehiclePolylineBilling {
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePolylineBilling
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehiclePolylineBilling
     */
    pricePerVehicle?: number;
}

/**
 * 
 * @export
 * @interface VehiclePolylineWithPositions
 */
export interface VehiclePolylineWithPositions {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehiclePolylineWithPositions
     */
    appDeviceIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof VehiclePolylineWithPositions
     */
    from?: Date;
    /**
     * 
     * @type {Position}
     * @memberof VehiclePolylineWithPositions
     */
    lastVehiclePosition?: Position;
    /**
     * 
     * @type {string}
     * @memberof VehiclePolylineWithPositions
     */
    polyline?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehiclePolylineWithPositions
     */
    to?: Date;
    /**
     * 
     * @type {Vehicle}
     * @memberof VehiclePolylineWithPositions
     */
    vehicle?: Vehicle;
    /**
     * 
     * @type {Array<Position>}
     * @memberof VehiclePolylineWithPositions
     */
    vehiclePositions?: Array<Position>;
    /**
     * 
     * @type {Array<VehicleTrackSegment>}
     * @memberof VehiclePolylineWithPositions
     */
    vehicleTrackSegments?: Array<VehicleTrackSegment>;
}

/**
 * 
 * @export
 * @interface VehiclePositionsCheckResult
 */
export interface VehiclePositionsCheckResult {
    /**
     * 
     * @type {Array<TrackSegment>}
     * @memberof VehiclePositionsCheckResult
     */
    jumps?: Array<TrackSegment>;
}

/**
 * 
 * @export
 * @interface VehiclePositionsMonitoringConfiguration
 */
export interface VehiclePositionsMonitoringConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    customerVisible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    daysToCheck?: number;
    /**
     * 
     * @type {Date}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    disableUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    groupKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    isRelevantForLogeniosInfrastructureMonitoring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    level?: VehiclePositionsMonitoringConfiguration.LevelEnum;
    /**
     * 
     * @type {string}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    monitoredVehicles?: VehiclePositionsMonitoringConfiguration.MonitoredVehiclesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    showToAllParties?: boolean;
    /**
     * 
     * @type {SystemStatusOptions}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    systemStatusOptions?: SystemStatusOptions;
    /**
     * 
     * @type {number}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    timespanInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof VehiclePositionsMonitoringConfiguration
     */
    title?: string;
}

/**
 * @export
 * @namespace VehiclePositionsMonitoringConfiguration
 */
export namespace VehiclePositionsMonitoringConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        AINFO = 'A_INFO',
        BWARNING = 'B_WARNING',
        CERROR = 'C_ERROR'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MonitoredVehiclesEnum {
        TRUCK = 'TRUCK',
        TRAILER = 'TRAILER',
        BOTH = 'BOTH'
    }
}

/**
 * 
 * @export
 * @interface VehiclePositionsResponse
 */
export interface VehiclePositionsResponse {
    /**
     * 
     * @type {Array<Position>}
     * @memberof VehiclePositionsResponse
     */
    positions?: Array<Position>;
}

/**
 * 
 * @export
 * @interface VehicleProperties
 */
export interface VehicleProperties {
    /**
     * Additional Attributes for the vehicle object
     * @type {Array<AdditionalDataEntry>}
     * @memberof VehicleProperties
     */
    additionalData?: Array<AdditionalDataEntry>;
    /**
     * E-Mail address of the driver
     * @type {string}
     * @memberof VehicleProperties
     */
    emailAddress?: string;
    /**
     * Mobile phone number of the driver
     * @type {string}
     * @memberof VehicleProperties
     */
    mobilePhoneNumber?: string;
    /**
     * Alternative name to match this vehicle
     * @type {string}
     * @memberof VehicleProperties
     */
    numberPlateAlias?: string;
    /**
     * If a Logenios OrderBox is installed at the vehicle, this field may contain the TAG of the OrderBox, Then the Tag is automatically assigned to a transport order when the vehicle is assigned
     * @type {string}
     * @memberof VehicleProperties
     */
    orderBoxTag?: string;
    /**
     * Spedion customer id of this truck
     * @type {number}
     * @memberof VehicleProperties
     */
    spedionCustomerId?: number;
    /**
     * Indicate if the LOGENIOS Single Tour App shall be used to to send orders to this vehicle
     * @type {boolean}
     * @memberof VehicleProperties
     */
    useSingleTourApp?: boolean;
}

/**
 * 
 * @export
 * @interface VehicleRequest
 */
export interface VehicleRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleRequest
     */
    externalVehicleId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRequest
     */
    fuelType?: VehicleRequest.FuelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VehicleRequest
     */
    numberPlate?: string;
    /**
     * 
     * @type {VehicleProperties}
     * @memberof VehicleRequest
     */
    properties?: VehicleProperties;
    /**
     * 
     * @type {VehicleShare}
     * @memberof VehicleRequest
     */
    share?: VehicleShare;
    /**
     * 
     * @type {string}
     * @memberof VehicleRequest
     */
    vehicleType?: VehicleRequest.VehicleTypeEnum;
}

/**
 * @export
 * @namespace VehicleRequest
 */
export namespace VehicleRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum FuelTypeEnum {
        DIESEL = 'DIESEL',
        LNG = 'LNG',
        CNG = 'CNG',
        HYDRO = 'HYDRO',
        BEV = 'BEV',
        HVO100 = 'HVO100'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum VehicleTypeEnum {
        TRAILER = 'TRAILER',
        CAR = 'CAR',
        TRANSPORTER = 'TRANSPORTER',
        TRUCK75T = 'TRUCK_7_5T',
        TRUCK1199T = 'TRUCK_11_99T',
        TRUCK18T = 'TRUCK_18T',
        TRUCK40T = 'TRUCK_40T',
        TRUCKTRAILER = 'TRUCK_TRAILER',
        TANKERTRUCK = 'TANKER_TRUCK'
    }
}

/**
 * 
 * @export
 * @interface VehicleResidenceTime
 */
export interface VehicleResidenceTime {
    /**
     * 
     * @type {Array<ResidenceTime>}
     * @memberof VehicleResidenceTime
     */
    residenceTimes?: Array<ResidenceTime>;
    /**
     * 
     * @type {Vehicle}
     * @memberof VehicleResidenceTime
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface VehicleShare
 */
export interface VehicleShare {
    /**
     * Alias name which is used as vehicle name in the company which received the share
     * @type {string}
     * @memberof VehicleShare
     */
    alias?: string;
    /**
     * Automatically revoke this share when a transport order assigned to the shared vehicle is finished
     * @type {boolean}
     * @memberof VehicleShare
     */
    cancelWhenTourFinished?: boolean;
    /**
     * Due date of this share. The vehicle is no longer available for the target company after this date
     * @type {Date}
     * @memberof VehicleShare
     */
    endDate?: Date;
    /**
     * Point in time when the vehicle starts to become visible to the company receiving this share
     * @type {Date}
     * @memberof VehicleShare
     */
    startDate?: Date;
    /**
     * The company id which should see the vehicle annotated with this share
     * @type {string}
     * @memberof VehicleShare
     */
    targetCompanyId?: string;
    /**
     * The name of the company which received the vehicle share
     * @type {string}
     * @memberof VehicleShare
     */
    targetCompanyName?: string;
}

/**
 * 
 * @export
 * @interface VehicleSyncConfiguration
 */
export interface VehicleSyncConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSyncConfiguration
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncConfiguration
     */
    syncKey?: VehicleSyncConfiguration.SyncKeyEnum;
}

/**
 * @export
 * @namespace VehicleSyncConfiguration
 */
export namespace VehicleSyncConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum SyncKeyEnum {
        NUMBERPLATE = 'NUMBERPLATE',
        EXTERNALVEHICLEID = 'EXTERNAL_VEHICLE_ID'
    }
}

/**
 * 
 * @export
 * @interface VehicleTrackSegment
 */
export interface VehicleTrackSegment {
    /**
     * 
     * @type {Coordinate}
     * @memberof VehicleTrackSegment
     */
    centerCoordinate?: Coordinate;
    /**
     * 
     * @type {number}
     * @memberof VehicleTrackSegment
     */
    distanceInM?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleTrackSegment
     */
    durationInSeconds?: number;
    /**
     * 
     * @type {Position}
     * @memberof VehicleTrackSegment
     */
    endPosition?: Position;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrackSegment
     */
    estimatedState?: VehicleTrackSegment.EstimatedStateEnum;
    /**
     * 
     * @type {Date}
     * @memberof VehicleTrackSegment
     */
    from?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrackSegment
     */
    polyline?: string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof VehicleTrackSegment
     */
    reverseResolvedAddresses?: Array<Address>;
    /**
     * 
     * @type {Position}
     * @memberof VehicleTrackSegment
     */
    startPosition?: Position;
    /**
     * 
     * @type {Date}
     * @memberof VehicleTrackSegment
     */
    to?: Date;
    /**
     * 
     * @type {Array<TransportOrderInfo>}
     * @memberof VehicleTrackSegment
     */
    transportOrderInfo?: Array<TransportOrderInfo>;
}

/**
 * @export
 * @namespace VehicleTrackSegment
 */
export namespace VehicleTrackSegment {
    /**
     * @export
     * @enum {string}
     */
    export enum EstimatedStateEnum {
        DRIVING = 'DRIVING',
        STANDING = 'STANDING',
        ARRIVED = 'ARRIVED'
    }
}

/**
 * 
 * @export
 * @interface VehicleWithPosition
 */
export interface VehicleWithPosition {
    /**
     * 
     * @type {Position}
     * @memberof VehicleWithPosition
     */
    position?: Position;
    /**
     * 
     * @type {Array<OrderReference>}
     * @memberof VehicleWithPosition
     */
    tours?: Array<OrderReference>;
    /**
     * 
     * @type {Vehicle}
     * @memberof VehicleWithPosition
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface VehiclesReportRequest
 */
export interface VehiclesReportRequest {
    /**
     * 
     * @type {Date}
     * @memberof VehiclesReportRequest
     */
    sinceTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehiclesReportRequest
     */
    toTimestamp?: Date;
}

/**
 * 
 * @export
 * @interface VehiclesReportResponse
 */
export interface VehiclesReportResponse {
    /**
     * 
     * @type {string}
     * @memberof VehiclesReportResponse
     */
    response?: string;
}

/**
 * 
 * @export
 * @interface VehiclesWithPositionResponse
 */
export interface VehiclesWithPositionResponse {
    /**
     * 
     * @type {Array<VehicleWithPosition>}
     * @memberof VehiclesWithPositionResponse
     */
    vehiclesWithPositions?: Array<VehicleWithPosition>;
}

/**
 * 
 * @export
 * @interface ViewConfigurationScripts
 */
export interface ViewConfigurationScripts {
    /**
     * 
     * @type {string}
     * @memberof ViewConfigurationScripts
     */
    onViewFreight?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewConfigurationScripts
     */
    onViewQueuedEvent?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewConfigurationScripts
     */
    onViewStopLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewConfigurationScripts
     */
    onViewTransport?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewConfigurationScripts
     */
    onViewTransportOrder?: string;
}

/**
 * 
 * @export
 * @interface VirtualOdometer
 */
export interface VirtualOdometer {
    /**
     * 
     * @type {Date}
     * @memberof VirtualOdometer
     */
    created?: Date;
    /**
     * 
     * @type {number}
     * @memberof VirtualOdometer
     */
    distanceToLastPositionInMeter?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualOdometer
     */
    odometer?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualOdometer
     */
    operatingHours?: number;
}

/**
 * 
 * @export
 * @interface Void
 */
export interface Void {
}

/**
 * 
 * @export
 * @interface VrpResult
 */
export interface VrpResult {
    /**
     * 
     * @type {number}
     * @memberof VrpResult
     */
    memory?: number;
    /**
     * 
     * @type {string}
     * @memberof VrpResult
     */
    mode?: VrpResult.ModeEnum;
    /**
     * 
     * @type {Array<VrpRoute>}
     * @memberof VrpResult
     */
    routes?: Array<VrpRoute>;
    /**
     * 
     * @type {number}
     * @memberof VrpResult
     */
    runtime?: number;
    /**
     * 
     * @type {Array<Shipment>}
     * @memberof VrpResult
     */
    skippedShipments?: Array<Shipment>;
    /**
     * 
     * @type {number}
     * @memberof VrpResult
     */
    totalAssignedLocations?: number;
    /**
     * 
     * @type {number}
     * @memberof VrpResult
     */
    totalDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof VrpResult
     */
    totalDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof VrpResult
     */
    totalLoad?: number;
}

/**
 * @export
 * @namespace VrpResult
 */
export namespace VrpResult {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        OrToolsVRP = 'OrToolsVRP',
        LogeniosVRP = 'LogeniosVRP'
    }
}

/**
 * 
 * @export
 * @interface VrpRoute
 */
export interface VrpRoute {
    /**
     * 
     * @type {number}
     * @memberof VrpRoute
     */
    distance?: number;
    /**
     * 
     * @type {number}
     * @memberof VrpRoute
     */
    duration?: number;
    /**
     * 
     * @type {Array<VrpStop>}
     * @memberof VrpRoute
     */
    route?: Array<VrpStop>;
    /**
     * 
     * @type {string}
     * @memberof VrpRoute
     */
    routeName?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof VrpRoute
     */
    vehicle?: Vehicle;
}

/**
 * 
 * @export
 * @interface VrpStop
 */
export interface VrpStop {
    /**
     * 
     * @type {Array<Freight>}
     * @memberof VrpStop
     */
    freights?: Array<Freight>;
    /**
     * 
     * @type {number}
     * @memberof VrpStop
     */
    load?: number;
    /**
     * 
     * @type {number}
     * @memberof VrpStop
     */
    matrixIndex?: number;
    /**
     * 
     * @type {StopLocation}
     * @memberof VrpStop
     */
    stop?: StopLocation;
}

/**
 * 
 * @export
 * @interface WaitingForLatch
 */
export interface WaitingForLatch {
    /**
     * 
     * @type {string}
     * @memberof WaitingForLatch
     */
    captureName?: string;
    /**
     * 
     * @type {Timestamp}
     * @memberof WaitingForLatch
     */
    timestamp?: Timestamp;
}

/**
 * 
 * @export
 * @interface WarningIdentifier
 */
export interface WarningIdentifier {
    /**
     * 
     * @type {string}
     * @memberof WarningIdentifier
     */
    checkType?: WarningIdentifier.CheckTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WarningIdentifier
     */
    ruleName?: string;
}

/**
 * @export
 * @namespace WarningIdentifier
 */
export namespace WarningIdentifier {
    /**
     * @export
     * @enum {string}
     */
    export enum CheckTypeEnum {
        SCRIPTCHECK = 'SCRIPT_CHECK',
        STATUSCHECK = 'STATUS_CHECK',
        TIMESTAMPCHECK = 'TIMESTAMP_CHECK',
        ASSIGNEDVEHICLECHECK = 'ASSIGNED_VEHICLE_CHECK',
        TRACKINGCHECK = 'TRACKING_CHECK',
        LINKEDCHECK = 'LINKED_CHECK',
        ATTACHMENTCHECK = 'ATTACHMENT_CHECK',
        WORKFLOWFIELDSCHECK = 'WORKFLOW_FIELDS_CHECK',
        STATICCHECK = 'STATIC_CHECK',
        ASSIGNEDDEVICECHECK = 'ASSIGNED_DEVICE_CHECK'
    }
}

/**
 * 
 * @export
 * @interface WikiPage
 */
export interface WikiPage {
    /**
     * 
     * @type {string}
     * @memberof WikiPage
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof WikiPage
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof WikiPage
     */
    format?: string;
    /**
     * 
     * @type {string}
     * @memberof WikiPage
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof WikiPage
     */
    title?: string;
}

/**
 * 
 * @export
 * @interface WorkflowConfiguration
 */
export interface WorkflowConfiguration {
    /**
     * 
     * @type {ConfirmLoadedConfirmDeliveredWorkflowConfiguration}
     * @memberof WorkflowConfiguration
     */
    confirmLoadedConfirmDeliveredWorkflow?: ConfirmLoadedConfirmDeliveredWorkflowConfiguration;
    /**
     * 
     * @type {ConfirmLoadedSelectDeliveredWorkflowConfiguration}
     * @memberof WorkflowConfiguration
     */
    confirmLoadedSelectDeliveredWorkflow?: ConfirmLoadedSelectDeliveredWorkflowConfiguration;
    /**
     * 
     * @type {SelectLoadedSelectDeliveredWorkflowConfiguration}
     * @memberof WorkflowConfiguration
     */
    selectLoadedSelectDeliveredWorkflow?: SelectLoadedSelectDeliveredWorkflowConfiguration;
    /**
     * 
     * @type {ShipmentBasedSchenkerDesignWonflow}
     * @memberof WorkflowConfiguration
     */
    shipmentBasedSchenkerDesignWorkflow?: ShipmentBasedSchenkerDesignWonflow;
    /**
     * 
     * @type {StopStatusWorkflowConfiguration}
     * @memberof WorkflowConfiguration
     */
    stopStatusAndActionWorkflow?: StopStatusWorkflowConfiguration;
    /**
     * 
     * @type {StopStatusWorkflowConfiguration}
     * @memberof WorkflowConfiguration
     */
    stopStatusWorkflow?: StopStatusWorkflowConfiguration;
}

/**
 * 
 * @export
 * @interface WrappedTransportOrdersRequest
 */
export interface WrappedTransportOrdersRequest {
    /**
     * 
     * @type {TransportOrderMetaInfo}
     * @memberof WrappedTransportOrdersRequest
     */
    metaInfos?: TransportOrderMetaInfo;
    /**
     * 
     * @type {Array<TransportOrder>}
     * @memberof WrappedTransportOrdersRequest
     */
    transportOrders?: Array<TransportOrder>;
}

/**
 * 
 * @export
 * @interface WrappedTransportOrdersResponse
 */
export interface WrappedTransportOrdersResponse {
    /**
     * 
     * @type {string}
     * @memberof WrappedTransportOrdersResponse
     */
    resultCode?: WrappedTransportOrdersResponse.ResultCodeEnum;
    /**
     * 
     * @type {Array<TransportOrderResponse>}
     * @memberof WrappedTransportOrdersResponse
     */
    transportOrdersResponses?: Array<TransportOrderResponse>;
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof WrappedTransportOrdersResponse
     */
    validationErrors?: Array<ValidationError>;
}

/**
 * @export
 * @namespace WrappedTransportOrdersResponse
 */
export namespace WrappedTransportOrdersResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ResultCodeEnum {
        OK = 'OK',
        Failed = 'Failed',
        Forbidden = 'Forbidden',
        Created = 'Created',
        BadRequest = 'BadRequest'
    }
}

/**
 * 
 * @export
 * @interface WriteFileCommand
 */
export interface WriteFileCommand {
    /**
     * 
     * @type {boolean}
     * @memberof WriteFileCommand
     */
    disableDeduplicator?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WriteFileCommand
     */
    keepExactFileName?: boolean;
}

/**
 * 
 * @export
 * @interface WriteToAttachmentCommand
 */
export interface WriteToAttachmentCommand {
    /**
     * 
     * @type {string}
     * @memberof WriteToAttachmentCommand
     */
    attachmentCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteToAttachmentCommand
     */
    transportId?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteToAttachmentCommand
     */
    transportOrderId?: string;
}

/**
 * 
 * @export
 * @interface XlsLine
 */
export interface XlsLine {
    /**
     * 
     * @type {Array<string>}
     * @memberof XlsLine
     */
    cells?: Array<string>;
}

/**
 * 
 * @export
 * @interface XlsToJsonResult
 */
export interface XlsToJsonResult {
    /**
     * 
     * @type {Array<XlsLine>}
     * @memberof XlsToJsonResult
     */
    lines?: Array<XlsLine>;
}

/**
 * 
 * @export
 * @interface ZohoConfig
 */
export interface ZohoConfig {
    /**
     * 
     * @type {string}
     * @memberof ZohoConfig
     */
    additionalInfoField?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ZohoConfig
     */
    isUsageReportNeeded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ZohoConfig
     */
    orderMergingType?: ZohoConfig.OrderMergingTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ZohoConfig
     */
    separateInvoiceForProjectWorkLog?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ZohoConfig
     */
    zohoId?: string;
}

/**
 * @export
 * @namespace ZohoConfig
 */
export namespace ZohoConfig {
    /**
     * @export
     * @enum {string}
     */
    export enum OrderMergingTypeEnum {
        SOURCE = 'SOURCE',
        TARGET = 'TARGET',
        SOURCEANDTARGET = 'SOURCE_AND_TARGET',
        ALL = 'ALL',
        NONE = 'NONE',
        GROUPINGTAG = 'GROUPING_TAG'
    }
}

/**
 * 
 * @export
 * @interface ZohoInvoicingResponse
 */
export interface ZohoInvoicingResponse {
    /**
     * 
     * @type {Array<ZohoResponse>}
     * @memberof ZohoInvoicingResponse
     */
    zohoResponses?: Array<ZohoResponse>;
}

/**
 * 
 * @export
 * @interface ZohoResponse
 */
export interface ZohoResponse {
    /**
     * 
     * @type {string}
     * @memberof ZohoResponse
     */
    invoiceJson?: string;
    /**
     * 
     * @type {string}
     * @memberof ZohoResponse
     */
    resultBody?: string;
    /**
     * 
     * @type {number}
     * @memberof ZohoResponse
     */
    statusCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ZohoResponse
     */
    zohoInvoiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ZohoResponse
     */
    zohoReferenceNumber?: string;
}


/**
 * AccountApi - fetch parameter creator
 * @export
 */
export const AccountApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * If an account was newly created, it must be activated. In order to activate the account, the activation token which was sent to the user via email must be set as a request parameter. As a executionResult the account is activated.
         * @summary Activate an account given a verification token and a new password
         * @param {AccountActivateRequest} AccountActivateRequest AccountActivateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount(AccountActivateRequest: AccountActivateRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AccountActivateRequest' is not null or undefined
            if (AccountActivateRequest === null || AccountActivateRequest === undefined) {
                throw new RequiredError('AccountActivateRequest','Required parameter AccountActivateRequest was null or undefined when calling activateAccount.');
            }
            const localVarPath = `/account/activate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountActivateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AccountActivateRequest || {}) : (AccountActivateRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to check the given credentials. If the authentication credentials are valid, this endpoint returns the string \"ok\". Otherwise it returns the status code 403 - forbidden.
         * @summary check auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAuthentication(options: any = {}): FetchArgs {
            const localVarPath = `/account/authenticate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check whether the user has the permission to perform the specified action.
         * @summary has permission
         * @param {'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT'} action action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPermission(action: 'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT', options: any = {}): FetchArgs {
            // verify required parameter 'action' is not null or undefined
            if (action === null || action === undefined) {
                throw new RequiredError('action','Required parameter action was null or undefined when calling checkPermission.');
            }
            const localVarPath = `/account/action/{action}`
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to submit the email validation token to our backend server. As a executionResult, the email address assigned to the validation token is marked as valid.
         * @summary Confirm email address
         * @param {string} token token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailAddress(token: string, options: any = {}): FetchArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling confirmEmailAddress.');
            }
            const localVarPath = `/account/confirm/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authtoken name and user id and delete the relevant authToken. Updated list of auth token will return in response.
         * @summary delete authToken from a user collection
         * @param {string} authTokenName authTokenName
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthToken(authTokenName: string, userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'authTokenName' is not null or undefined
            if (authTokenName === null || authTokenName === undefined) {
                throw new RequiredError('authTokenName','Required parameter authTokenName was null or undefined when calling deleteAuthToken.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling deleteAuthToken.');
            }
            const localVarPath = `/account/deleteAuthTokens`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (authTokenName !== undefined) {
                localVarQueryParameter['authTokenName'] = authTokenName;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch details of auth tokens exist in a user.
         * @summary contains auth tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAuthTokens(options: any = {}): FetchArgs {
            const localVarPath = `/account/fetchAuthTokens`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns the currently authenticated user object. It also contains the whole set of permissions assigned to the currently authenticated user. The set of permissions contains all permissions on user level as well as on role level.
         * @summary current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCurrentUser(options: any = {}): FetchArgs {
            const localVarPath = `/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to generate an auth token. The auth token can be used to authenticate an api-client without storing the actual password of the user in plain text. If this authentication method is used, please set the Authentication Type to Bearer instead of Basic.  Per default the authentication token has a validity period of 24h. If the auth token is used by server processes, most probably the expiry date should be increased. This field value can be specified in the following format:  | expires | Description                                                 | |---------|-------------------------------------------------------------| | 1y      | The auth token has a validity of 1 year                     | | 1y6m    | The auth token has a validity of 1 year and 6 month         | | 12h     | The auth token expires in 12 hours.                         | | 3d      | The auth token expires in 3 days                            | | 30s     | The auth token expires in 30 seconds                        | | 6h3m30s | The auth token expires in 6 hours, 3 minutes and 30 seconds |   
         * @summary generate
         * @param {AuthTokenRequest} AuthTokenRequest AuthTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthToken(AuthTokenRequest: AuthTokenRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AuthTokenRequest' is not null or undefined
            if (AuthTokenRequest === null || AuthTokenRequest === undefined) {
                throw new RequiredError('AuthTokenRequest','Required parameter AuthTokenRequest was null or undefined when calling generateAuthToken.');
            }
            const localVarPath = `/account/token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthTokenRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AuthTokenRequest || {}) : (AuthTokenRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the password of the currently authenticated user. The new password must be at least 8 characters long. This request must also contain the current password of the user to prevent accidental or malicious changes. If the user forgot his or her own password, please use the password recovery feature.
         * @summary change password
         * @param {PasswordChangeRequest} PasswordChangeRequest PasswordChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyPassword(PasswordChangeRequest: PasswordChangeRequest, options: any = {}): FetchArgs {
            // verify required parameter 'PasswordChangeRequest' is not null or undefined
            if (PasswordChangeRequest === null || PasswordChangeRequest === undefined) {
                throw new RequiredError('PasswordChangeRequest','Required parameter PasswordChangeRequest was null or undefined when calling modifyPassword.');
            }
            const localVarPath = `/account/password/change`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PasswordChangeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(PasswordChangeRequest || {}) : (PasswordChangeRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to request a new password for the given user. This endpoint always returns 200 and true as PasswordResetResult in order to prevent the api-caller from gaining knowledge about existing users.  If the user really exists, an email is sent to the user. This email includes instructions how to reset the password.
         * @summary Request password reset for email address
         * @param {EmailRequest} EmailRequest EmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(EmailRequest: EmailRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EmailRequest' is not null or undefined
            if (EmailRequest === null || EmailRequest === undefined) {
                throw new RequiredError('EmailRequest','Required parameter EmailRequest was null or undefined when calling requestPasswordReset.');
            }
            const localVarPath = `/account/password/resetrequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EmailRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EmailRequest || {}) : (EmailRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the password of the user we find by the authToken. The new password must be at least 8 characters long.
         * @summary change password by authToken from a reset request
         * @param {PasswordResetRequest} PasswordResetRequest PasswordResetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(PasswordResetRequest: PasswordResetRequest, options: any = {}): FetchArgs {
            // verify required parameter 'PasswordResetRequest' is not null or undefined
            if (PasswordResetRequest === null || PasswordResetRequest === undefined) {
                throw new RequiredError('PasswordResetRequest','Required parameter PasswordResetRequest was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/account/password/reset`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PasswordResetRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(PasswordResetRequest || {}) : (PasswordResetRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the user profile of the currently authenticated user. It is not possible to manipulate the permissions using this endpoint. If the phone number or e-mail address is changed, the new phone number or email-address is marked as not verified.
         * @summary update account data
         * @param {UserRequest} UserRequest UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountData(UserRequest: UserRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UserRequest' is not null or undefined
            if (UserRequest === null || UserRequest === undefined) {
                throw new RequiredError('UserRequest','Required parameter UserRequest was null or undefined when calling updateAccountData.');
            }
            const localVarPath = `/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UserRequest || {}) : (UserRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    return {
        /**
         * If an account was newly created, it must be activated. In order to activate the account, the activation token which was sent to the user via email must be set as a request parameter. As a executionResult the account is activated.
         * @summary Activate an account given a verification token and a new password
         * @param {AccountActivateRequest} AccountActivateRequest AccountActivateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount(AccountActivateRequest: AccountActivateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).activateAccount(AccountActivateRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Use this endpoint to check the given credentials. If the authentication credentials are valid, this endpoint returns the string \"ok\". Otherwise it returns the status code 403 - forbidden.
         * @summary check auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAuthentication(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthTestResponse> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).checkAuthentication(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check whether the user has the permission to perform the specified action.
         * @summary has permission
         * @param {'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT'} action action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPermission(action: 'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).checkPermission(action, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Use this endpoint to submit the email validation token to our backend server. As a executionResult, the email address assigned to the validation token is marked as valid.
         * @summary Confirm email address
         * @param {string} token token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailAddress(token: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccountConfirmResult> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).confirmEmailAddress(token, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get the authtoken name and user id and delete the relevant authToken. Updated list of auth token will return in response.
         * @summary delete authToken from a user collection
         * @param {string} authTokenName authTokenName
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthToken(authTokenName: string, userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthToken> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).deleteAuthToken(authTokenName, userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch details of auth tokens exist in a user.
         * @summary contains auth tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAuthTokens(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchedAuthTokenList> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).fetchAuthTokens(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns the currently authenticated user object. It also contains the whole set of permissions assigned to the currently authenticated user. The set of permissions contains all permissions on user level as well as on role level.
         * @summary current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCurrentUser(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).fetchCurrentUser(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Use this endpoint to generate an auth token. The auth token can be used to authenticate an api-client without storing the actual password of the user in plain text. If this authentication method is used, please set the Authentication Type to Bearer instead of Basic.  Per default the authentication token has a validity period of 24h. If the auth token is used by server processes, most probably the expiry date should be increased. This field value can be specified in the following format:  | expires | Description                                                 | |---------|-------------------------------------------------------------| | 1y      | The auth token has a validity of 1 year                     | | 1y6m    | The auth token has a validity of 1 year and 6 month         | | 12h     | The auth token expires in 12 hours.                         | | 3d      | The auth token expires in 3 days                            | | 30s     | The auth token expires in 30 seconds                        | | 6h3m30s | The auth token expires in 6 hours, 3 minutes and 30 seconds |   
         * @summary generate
         * @param {AuthTokenRequest} AuthTokenRequest AuthTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthToken(AuthTokenRequest: AuthTokenRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthToken> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).generateAuthToken(AuthTokenRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify the password of the currently authenticated user. The new password must be at least 8 characters long. This request must also contain the current password of the user to prevent accidental or malicious changes. If the user forgot his or her own password, please use the password recovery feature.
         * @summary change password
         * @param {PasswordChangeRequest} PasswordChangeRequest PasswordChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyPassword(PasswordChangeRequest: PasswordChangeRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).modifyPassword(PasswordChangeRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Use this endpoint to request a new password for the given user. This endpoint always returns 200 and true as PasswordResetResult in order to prevent the api-caller from gaining knowledge about existing users.  If the user really exists, an email is sent to the user. This email includes instructions how to reset the password.
         * @summary Request password reset for email address
         * @param {EmailRequest} EmailRequest EmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(EmailRequest: EmailRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PasswordResetResult> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).requestPasswordReset(EmailRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify the password of the user we find by the authToken. The new password must be at least 8 characters long.
         * @summary change password by authToken from a reset request
         * @param {PasswordResetRequest} PasswordResetRequest PasswordResetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(PasswordResetRequest: PasswordResetRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).resetPassword(PasswordResetRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update the user profile of the currently authenticated user. It is not possible to manipulate the permissions using this endpoint. If the phone number or e-mail address is changed, the new phone number or email-address is marked as not verified.
         * @summary update account data
         * @param {UserRequest} UserRequest UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountData(UserRequest: UserRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).updateAccountData(UserRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * If an account was newly created, it must be activated. In order to activate the account, the activation token which was sent to the user via email must be set as a request parameter. As a executionResult the account is activated.
         * @summary Activate an account given a verification token and a new password
         * @param {AccountActivateRequest} AccountActivateRequest AccountActivateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount(AccountActivateRequest: AccountActivateRequest, options?: any) {
            return AccountApiFp(configuration).activateAccount(AccountActivateRequest, options)(fetch, basePath);
        },
        /**
         * Use this endpoint to check the given credentials. If the authentication credentials are valid, this endpoint returns the string \"ok\". Otherwise it returns the status code 403 - forbidden.
         * @summary check auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAuthentication(options?: any) {
            return AccountApiFp(configuration).checkAuthentication(options)(fetch, basePath);
        },
        /**
         * Check whether the user has the permission to perform the specified action.
         * @summary has permission
         * @param {'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT'} action action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPermission(action: 'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT', options?: any) {
            return AccountApiFp(configuration).checkPermission(action, options)(fetch, basePath);
        },
        /**
         * Use this endpoint to submit the email validation token to our backend server. As a executionResult, the email address assigned to the validation token is marked as valid.
         * @summary Confirm email address
         * @param {string} token token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailAddress(token: string, options?: any) {
            return AccountApiFp(configuration).confirmEmailAddress(token, options)(fetch, basePath);
        },
        /**
         * Get the authtoken name and user id and delete the relevant authToken. Updated list of auth token will return in response.
         * @summary delete authToken from a user collection
         * @param {string} authTokenName authTokenName
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthToken(authTokenName: string, userId: string, options?: any) {
            return AccountApiFp(configuration).deleteAuthToken(authTokenName, userId, options)(fetch, basePath);
        },
        /**
         * Fetch details of auth tokens exist in a user.
         * @summary contains auth tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAuthTokens(options?: any) {
            return AccountApiFp(configuration).fetchAuthTokens(options)(fetch, basePath);
        },
        /**
         * This endpoint returns the currently authenticated user object. It also contains the whole set of permissions assigned to the currently authenticated user. The set of permissions contains all permissions on user level as well as on role level.
         * @summary current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCurrentUser(options?: any) {
            return AccountApiFp(configuration).fetchCurrentUser(options)(fetch, basePath);
        },
        /**
         * Use this endpoint to generate an auth token. The auth token can be used to authenticate an api-client without storing the actual password of the user in plain text. If this authentication method is used, please set the Authentication Type to Bearer instead of Basic.  Per default the authentication token has a validity period of 24h. If the auth token is used by server processes, most probably the expiry date should be increased. This field value can be specified in the following format:  | expires | Description                                                 | |---------|-------------------------------------------------------------| | 1y      | The auth token has a validity of 1 year                     | | 1y6m    | The auth token has a validity of 1 year and 6 month         | | 12h     | The auth token expires in 12 hours.                         | | 3d      | The auth token expires in 3 days                            | | 30s     | The auth token expires in 30 seconds                        | | 6h3m30s | The auth token expires in 6 hours, 3 minutes and 30 seconds |   
         * @summary generate
         * @param {AuthTokenRequest} AuthTokenRequest AuthTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthToken(AuthTokenRequest: AuthTokenRequest, options?: any) {
            return AccountApiFp(configuration).generateAuthToken(AuthTokenRequest, options)(fetch, basePath);
        },
        /**
         * Modify the password of the currently authenticated user. The new password must be at least 8 characters long. This request must also contain the current password of the user to prevent accidental or malicious changes. If the user forgot his or her own password, please use the password recovery feature.
         * @summary change password
         * @param {PasswordChangeRequest} PasswordChangeRequest PasswordChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyPassword(PasswordChangeRequest: PasswordChangeRequest, options?: any) {
            return AccountApiFp(configuration).modifyPassword(PasswordChangeRequest, options)(fetch, basePath);
        },
        /**
         * Use this endpoint to request a new password for the given user. This endpoint always returns 200 and true as PasswordResetResult in order to prevent the api-caller from gaining knowledge about existing users.  If the user really exists, an email is sent to the user. This email includes instructions how to reset the password.
         * @summary Request password reset for email address
         * @param {EmailRequest} EmailRequest EmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(EmailRequest: EmailRequest, options?: any) {
            return AccountApiFp(configuration).requestPasswordReset(EmailRequest, options)(fetch, basePath);
        },
        /**
         * Modify the password of the user we find by the authToken. The new password must be at least 8 characters long.
         * @summary change password by authToken from a reset request
         * @param {PasswordResetRequest} PasswordResetRequest PasswordResetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(PasswordResetRequest: PasswordResetRequest, options?: any) {
            return AccountApiFp(configuration).resetPassword(PasswordResetRequest, options)(fetch, basePath);
        },
        /**
         * Update the user profile of the currently authenticated user. It is not possible to manipulate the permissions using this endpoint. If the phone number or e-mail address is changed, the new phone number or email-address is marked as not verified.
         * @summary update account data
         * @param {UserRequest} UserRequest UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountData(UserRequest: UserRequest, options?: any) {
            return AccountApiFp(configuration).updateAccountData(UserRequest, options)(fetch, basePath);
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * If an account was newly created, it must be activated. In order to activate the account, the activation token which was sent to the user via email must be set as a request parameter. As a executionResult the account is activated.
     * @summary Activate an account given a verification token and a new password
     * @param {AccountActivateRequest} AccountActivateRequest AccountActivateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public activateAccount(AccountActivateRequest: AccountActivateRequest, options?: any) {
        return AccountApiFp(this.configuration).activateAccount(AccountActivateRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Use this endpoint to check the given credentials. If the authentication credentials are valid, this endpoint returns the string \"ok\". Otherwise it returns the status code 403 - forbidden.
     * @summary check auth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public checkAuthentication(options?: any) {
        return AccountApiFp(this.configuration).checkAuthentication(options)(this.fetch, this.basePath);
    }

    /**
     * Check whether the user has the permission to perform the specified action.
     * @summary has permission
     * @param {'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT'} action action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public checkPermission(action: 'USERS_CREATE' | 'USERS_DELETE' | 'USERS_MODIFY' | 'USERS_VIEW' | 'USERS_MODIFY_PERMISSIONS' | 'FTP_ACCESS' | 'TO_CREATE' | 'TO_LINK' | 'TO_ASSIGN_COMPANY' | 'TO_ASSIGN_VEHICLE' | 'TO_PATCH' | 'TO_POST_STATUS' | 'TO_PUT' | 'TO_STORNO' | 'TO_ADD_OBSERVER' | 'TO_REMOVE_OBSERVER' | 'QUEUE_LIST' | 'QUEUE_MODIFY' | 'EVENTS' | 'COMPANY_MODIFY' | 'COMPANY_FULL_VIEW' | 'COMPANY_PARTIAL_VIEW' | 'COMPANY_VIEW_PARTNERS' | 'COMPANY_MODIFY_PARTNERS' | 'USE_DEPOT' | 'USE_DEPOT_STOCK' | 'ETA_GET' | 'ETA_POST' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DOWNLOAD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_UPLOAD' | 'TELEMATIC_POST' | 'TELEMATIC_GET' | 'USER_ROLES_VIEW' | 'USER_ROLES_CREATE_MODIFY_DELETE' | 'USER_ROLES_ASSIGN' | 'VEHICLE_VIEW' | 'VEHICLE_CREATE_MODIFY_DELETE' | 'SCHEDULER_CONFIG' | 'VIEW_REPORT' | 'VIEW_MANAGEMENT_REPORT' | 'VIEW_GENERIC_REPORTS' | 'DRIVER_VIEW' | 'DRIVER_CREATE_MODIFY_DELETE' | 'USE_MAIL_GATEWAY' | 'CM_USE' | 'ATTACHMENT_REVIEW' | 'SELF_ATTACHMENT_REVIEW' | 'BILL' | 'ADDRESS_MAPPING_VIEW' | 'ADDRESS_MAPPING_CREATE_MODIFY_DELETE' | 'COMPANY_MESSAGE_LOGVIEW' | 'RESEND_FAILED_REQUESTS' | 'COMPANY_TAG_VIEW' | 'INTERNAL_MONITORING' | 'VIEW_STANDING_TIMES' | 'TO_ASSIGN_TRAILER' | 'TO_ASSIGN_DEVICE' | 'VIEW_EMPTY_KM_REPORT' | 'VIEW_FLEET' | 'TO_LIST' | 'VIEW_TOUR_COST_REPORT', options?: any) {
        return AccountApiFp(this.configuration).checkPermission(action, options)(this.fetch, this.basePath);
    }

    /**
     * Use this endpoint to submit the email validation token to our backend server. As a executionResult, the email address assigned to the validation token is marked as valid.
     * @summary Confirm email address
     * @param {string} token token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public confirmEmailAddress(token: string, options?: any) {
        return AccountApiFp(this.configuration).confirmEmailAddress(token, options)(this.fetch, this.basePath);
    }

    /**
     * Get the authtoken name and user id and delete the relevant authToken. Updated list of auth token will return in response.
     * @summary delete authToken from a user collection
     * @param {string} authTokenName authTokenName
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public deleteAuthToken(authTokenName: string, userId: string, options?: any) {
        return AccountApiFp(this.configuration).deleteAuthToken(authTokenName, userId, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch details of auth tokens exist in a user.
     * @summary contains auth tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public fetchAuthTokens(options?: any) {
        return AccountApiFp(this.configuration).fetchAuthTokens(options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns the currently authenticated user object. It also contains the whole set of permissions assigned to the currently authenticated user. The set of permissions contains all permissions on user level as well as on role level.
     * @summary current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public fetchCurrentUser(options?: any) {
        return AccountApiFp(this.configuration).fetchCurrentUser(options)(this.fetch, this.basePath);
    }

    /**
     * Use this endpoint to generate an auth token. The auth token can be used to authenticate an api-client without storing the actual password of the user in plain text. If this authentication method is used, please set the Authentication Type to Bearer instead of Basic.  Per default the authentication token has a validity period of 24h. If the auth token is used by server processes, most probably the expiry date should be increased. This field value can be specified in the following format:  | expires | Description                                                 | |---------|-------------------------------------------------------------| | 1y      | The auth token has a validity of 1 year                     | | 1y6m    | The auth token has a validity of 1 year and 6 month         | | 12h     | The auth token expires in 12 hours.                         | | 3d      | The auth token expires in 3 days                            | | 30s     | The auth token expires in 30 seconds                        | | 6h3m30s | The auth token expires in 6 hours, 3 minutes and 30 seconds |   
     * @summary generate
     * @param {AuthTokenRequest} AuthTokenRequest AuthTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public generateAuthToken(AuthTokenRequest: AuthTokenRequest, options?: any) {
        return AccountApiFp(this.configuration).generateAuthToken(AuthTokenRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Modify the password of the currently authenticated user. The new password must be at least 8 characters long. This request must also contain the current password of the user to prevent accidental or malicious changes. If the user forgot his or her own password, please use the password recovery feature.
     * @summary change password
     * @param {PasswordChangeRequest} PasswordChangeRequest PasswordChangeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public modifyPassword(PasswordChangeRequest: PasswordChangeRequest, options?: any) {
        return AccountApiFp(this.configuration).modifyPassword(PasswordChangeRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Use this endpoint to request a new password for the given user. This endpoint always returns 200 and true as PasswordResetResult in order to prevent the api-caller from gaining knowledge about existing users.  If the user really exists, an email is sent to the user. This email includes instructions how to reset the password.
     * @summary Request password reset for email address
     * @param {EmailRequest} EmailRequest EmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public requestPasswordReset(EmailRequest: EmailRequest, options?: any) {
        return AccountApiFp(this.configuration).requestPasswordReset(EmailRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Modify the password of the user we find by the authToken. The new password must be at least 8 characters long.
     * @summary change password by authToken from a reset request
     * @param {PasswordResetRequest} PasswordResetRequest PasswordResetRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public resetPassword(PasswordResetRequest: PasswordResetRequest, options?: any) {
        return AccountApiFp(this.configuration).resetPassword(PasswordResetRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Update the user profile of the currently authenticated user. It is not possible to manipulate the permissions using this endpoint. If the phone number or e-mail address is changed, the new phone number or email-address is marked as not verified.
     * @summary update account data
     * @param {UserRequest} UserRequest UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateAccountData(UserRequest: UserRequest, options?: any) {
        return AccountApiFp(this.configuration).updateAccountData(UserRequest, options)(this.fetch, this.basePath);
    }

}

/**
 * AttachmentsApi - fetch parameter creator
 * @export
 */
export const AttachmentsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use this method to add a file attachment to a selected transport order element.  As described in section \"Management of Attachments\" the transport order itself does not contain  actual attachments. Instead, it contains an URL reference to each attached file.   As executionResult, this endpoint returns an upload url which can be used to upload the actual file.   Use the addAttachment operation to attach an arbitrary file reference to a transport order element  (e.g. the TransportOrder, a Transport , a StopLocation, a StopAction or the Freight). The actual  content of the attachment must be uploaded directly to the object storage server. For small files  the presignedUploadUrl returned by this operation can be used. In case of larger file uploads, the  operation prepareAttachment should be used to retrieve an upload url. Once the upload is completed,  the addAttachment operation must be called to  actually reference the added attachment.     Please note that the added attachment points to an empty location until the attachment is really uploaded by the client.
         * @summary Create attachment
         * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment(AttachmentAddRequest: AttachmentAddRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AttachmentAddRequest' is not null or undefined
            if (AttachmentAddRequest === null || AttachmentAddRequest === undefined) {
                throw new RequiredError('AttachmentAddRequest','Required parameter AttachmentAddRequest was null or undefined when calling addAttachment.');
            }
            const localVarPath = `/attachments/add`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AttachmentAddRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AttachmentAddRequest || {}) : (AttachmentAddRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method modifies multiple attachments in a single request. It processes all modifications and returns successful and failed results. 
         * @summary Batch modify attachments
         * @param {BatchAttachmentModifyRequest} BatchAttachmentModifyRequest BatchAttachmentModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchModifyAttachments(BatchAttachmentModifyRequest: BatchAttachmentModifyRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BatchAttachmentModifyRequest' is not null or undefined
            if (BatchAttachmentModifyRequest === null || BatchAttachmentModifyRequest === undefined) {
                throw new RequiredError('BatchAttachmentModifyRequest','Required parameter BatchAttachmentModifyRequest was null or undefined when calling batchModifyAttachments.');
            }
            const localVarPath = `/attachments/batch-modify`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BatchAttachmentModifyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BatchAttachmentModifyRequest || {}) : (BatchAttachmentModifyRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes an attachment with the specified attachment id from the transport order with the specified transportOrderId. The ATTACHMENT_DELETE permission is required to access this operation.
         * @summary Deletes an attachment.
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [actionId] actionId
         * @param {string} [contractingPartyId] contractingPartyId
         * @param {string} [fileName] fileName
         * @param {string} [freightId] freightId
         * @param {string} [stopId] stopId
         * @param {string} [transportId] transportId
         * @param {string} [uniqueLocationId] uniqueLocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'attachmentId' is not null or undefined
            if (attachmentId === null || attachmentId === undefined) {
                throw new RequiredError('attachmentId','Required parameter attachmentId was null or undefined when calling deleteAttachment.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling deleteAttachment.');
            }
            const localVarPath = `/attachments/delete/{transportOrderId}/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }

            if (contractingPartyId !== undefined) {
                localVarQueryParameter['contractingPartyId'] = contractingPartyId;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (freightId !== undefined) {
                localVarQueryParameter['freightId'] = freightId;
            }

            if (stopId !== undefined) {
                localVarQueryParameter['stopId'] = stopId;
            }

            if (transportId !== undefined) {
                localVarQueryParameter['transportId'] = transportId;
            }

            if (uniqueLocationId !== undefined) {
                localVarQueryParameter['uniqueLocationId'] = uniqueLocationId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation returns the actual location of the file attachment. The resulting url can be used to download an attachment without further authentication. However, the returned URL expires after 30 min.
         * @summary Get Download URL for Attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [fileName] fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentDownloadUrl(attachmentId: string, transportOrderId: string, fileName?: string, options: any = {}): FetchArgs {
            // verify required parameter 'attachmentId' is not null or undefined
            if (attachmentId === null || attachmentId === undefined) {
                throw new RequiredError('attachmentId','Required parameter attachmentId was null or undefined when calling getAttachmentDownloadUrl.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling getAttachmentDownloadUrl.');
            }
            const localVarPath = `/attachments/downloadUrl/{transportOrderId}/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation returns the actual location of the file attachment. The resulting url can be used to show an attachment inline without further authentication.  The corresponding filetype is determined by the filename extension.  However, the returned URL expires after 30 min.
         * @summary Get inline URL for Attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [fileName] fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentInlineUrl(attachmentId: string, transportOrderId: string, fileName?: string, options: any = {}): FetchArgs {
            // verify required parameter 'attachmentId' is not null or undefined
            if (attachmentId === null || attachmentId === undefined) {
                throw new RequiredError('attachmentId','Required parameter attachmentId was null or undefined when calling getAttachmentInlineUrl.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling getAttachmentInlineUrl.');
            }
            const localVarPath = `/attachments/inlineUrl/{transportOrderId}/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * As executionResult, this endpoint returns an upload url which can be used to upload the actual file. The resulting upload url allows to replace the file content if the attachment was uploaded previously. Use this method to upload attachments which are specified during transport order creation.
         * @summary Get upload url for an existing attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [actionId] actionId
         * @param {string} [contractingPartyId] contractingPartyId
         * @param {string} [fileName] fileName
         * @param {string} [freightId] freightId
         * @param {string} [stopId] stopId
         * @param {string} [transportId] transportId
         * @param {string} [uniqueLocationId] uniqueLocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentUploadUrl(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'attachmentId' is not null or undefined
            if (attachmentId === null || attachmentId === undefined) {
                throw new RequiredError('attachmentId','Required parameter attachmentId was null or undefined when calling getAttachmentUploadUrl.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling getAttachmentUploadUrl.');
            }
            const localVarPath = `/attachments/uploadUrl/{transportOrderId}/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }

            if (contractingPartyId !== undefined) {
                localVarQueryParameter['contractingPartyId'] = contractingPartyId;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (freightId !== undefined) {
                localVarQueryParameter['freightId'] = freightId;
            }

            if (stopId !== undefined) {
                localVarQueryParameter['stopId'] = stopId;
            }

            if (transportId !== undefined) {
                localVarQueryParameter['transportId'] = transportId;
            }

            if (uniqueLocationId !== undefined) {
                localVarQueryParameter['uniqueLocationId'] = uniqueLocationId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation redirects the calling client to the actual location of an attachment to immediately start downloading the attachment file content.
         * @summary Download attachment by redirect
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentUrl(attachmentId: string, transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'attachmentId' is not null or undefined
            if (attachmentId === null || attachmentId === undefined) {
                throw new RequiredError('attachmentId','Required parameter attachmentId was null or undefined when calling getAttachmentUrl.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling getAttachmentUrl.');
            }
            const localVarPath = `/attachments/download/{transportOrderId}/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method modifies the name, status,category and additional data from an existing attachment and moves it corresponding to the pathSelector. It returns the modified TransportOrder and Attachment 
         * @summary Modify attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {AttachmentModifyRequest} AttachmentModifyRequest AttachmentModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyAttachment(attachmentId: string, transportOrderId: string, AttachmentModifyRequest: AttachmentModifyRequest, options: any = {}): FetchArgs {
            // verify required parameter 'attachmentId' is not null or undefined
            if (attachmentId === null || attachmentId === undefined) {
                throw new RequiredError('attachmentId','Required parameter attachmentId was null or undefined when calling modifyAttachment.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling modifyAttachment.');
            }
            // verify required parameter 'AttachmentModifyRequest' is not null or undefined
            if (AttachmentModifyRequest === null || AttachmentModifyRequest === undefined) {
                throw new RequiredError('AttachmentModifyRequest','Required parameter AttachmentModifyRequest was null or undefined when calling modifyAttachment.');
            }
            const localVarPath = `/attachments/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (transportOrderId !== undefined) {
                localVarQueryParameter['transportOrderId'] = transportOrderId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AttachmentModifyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AttachmentModifyRequest || {}) : (AttachmentModifyRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this method to prepare a file attachment which should be attached to the specified transport order element.  This method returns a upload url which can be used to upload an attachment file to the object storage.  The workflow for adding an attachment is as follows:  1. `prepareAttachment()` which returns an upload url  2. HTTP + PUT to the given upload url  3. call `addAttachment()` to make the attachment visible to others   
         * @summary Prepare attachment
         * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareAttachment(AttachmentAddRequest: AttachmentAddRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AttachmentAddRequest' is not null or undefined
            if (AttachmentAddRequest === null || AttachmentAddRequest === undefined) {
                throw new RequiredError('AttachmentAddRequest','Required parameter AttachmentAddRequest was null or undefined when calling prepareAttachment.');
            }
            const localVarPath = `/attachments/prepare`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AttachmentAddRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AttachmentAddRequest || {}) : (AttachmentAddRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentsApi - functional programming interface
 * @export
 */
export const AttachmentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Use this method to add a file attachment to a selected transport order element.  As described in section \"Management of Attachments\" the transport order itself does not contain  actual attachments. Instead, it contains an URL reference to each attached file.   As executionResult, this endpoint returns an upload url which can be used to upload the actual file.   Use the addAttachment operation to attach an arbitrary file reference to a transport order element  (e.g. the TransportOrder, a Transport , a StopLocation, a StopAction or the Freight). The actual  content of the attachment must be uploaded directly to the object storage server. For small files  the presignedUploadUrl returned by this operation can be used. In case of larger file uploads, the  operation prepareAttachment should be used to retrieve an upload url. Once the upload is completed,  the addAttachment operation must be called to  actually reference the added attachment.     Please note that the added attachment points to an empty location until the attachment is really uploaded by the client.
         * @summary Create attachment
         * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment(AttachmentAddRequest: AttachmentAddRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AttachmentPresignedUrlResponse> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).addAttachment(AttachmentAddRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This method modifies multiple attachments in a single request. It processes all modifications and returns successful and failed results. 
         * @summary Batch modify attachments
         * @param {BatchAttachmentModifyRequest} BatchAttachmentModifyRequest BatchAttachmentModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchModifyAttachments(BatchAttachmentModifyRequest: BatchAttachmentModifyRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BatchAttachmentModifyResponse> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).batchModifyAttachments(BatchAttachmentModifyRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes an attachment with the specified attachment id from the transport order with the specified transportOrderId. The ATTACHMENT_DELETE permission is required to access this operation.
         * @summary Deletes an attachment.
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [actionId] actionId
         * @param {string} [contractingPartyId] contractingPartyId
         * @param {string} [fileName] fileName
         * @param {string} [freightId] freightId
         * @param {string} [stopId] stopId
         * @param {string} [transportId] transportId
         * @param {string} [uniqueLocationId] uniqueLocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Attachment> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).deleteAttachment(attachmentId, transportOrderId, actionId, contractingPartyId, fileName, freightId, stopId, transportId, uniqueLocationId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation returns the actual location of the file attachment. The resulting url can be used to download an attachment without further authentication. However, the returned URL expires after 30 min.
         * @summary Get Download URL for Attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [fileName] fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentDownloadUrl(attachmentId: string, transportOrderId: string, fileName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AttachmentPresignedUrlResponse> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).getAttachmentDownloadUrl(attachmentId, transportOrderId, fileName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation returns the actual location of the file attachment. The resulting url can be used to show an attachment inline without further authentication.  The corresponding filetype is determined by the filename extension.  However, the returned URL expires after 30 min.
         * @summary Get inline URL for Attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [fileName] fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentInlineUrl(attachmentId: string, transportOrderId: string, fileName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AttachmentPresignedUrlResponse> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).getAttachmentInlineUrl(attachmentId, transportOrderId, fileName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * As executionResult, this endpoint returns an upload url which can be used to upload the actual file. The resulting upload url allows to replace the file content if the attachment was uploaded previously. Use this method to upload attachments which are specified during transport order creation.
         * @summary Get upload url for an existing attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [actionId] actionId
         * @param {string} [contractingPartyId] contractingPartyId
         * @param {string} [fileName] fileName
         * @param {string} [freightId] freightId
         * @param {string} [stopId] stopId
         * @param {string} [transportId] transportId
         * @param {string} [uniqueLocationId] uniqueLocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentUploadUrl(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AttachmentPresignedUrlResponse> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).getAttachmentUploadUrl(attachmentId, transportOrderId, actionId, contractingPartyId, fileName, freightId, stopId, transportId, uniqueLocationId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation redirects the calling client to the actual location of an attachment to immediately start downloading the attachment file content.
         * @summary Download attachment by redirect
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentUrl(attachmentId: string, transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).getAttachmentUrl(attachmentId, transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This method modifies the name, status,category and additional data from an existing attachment and moves it corresponding to the pathSelector. It returns the modified TransportOrder and Attachment 
         * @summary Modify attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {AttachmentModifyRequest} AttachmentModifyRequest AttachmentModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyAttachment(attachmentId: string, transportOrderId: string, AttachmentModifyRequest: AttachmentModifyRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AttachmentModifyResponse> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).modifyAttachment(attachmentId, transportOrderId, AttachmentModifyRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Use this method to prepare a file attachment which should be attached to the specified transport order element.  This method returns a upload url which can be used to upload an attachment file to the object storage.  The workflow for adding an attachment is as follows:  1. `prepareAttachment()` which returns an upload url  2. HTTP + PUT to the given upload url  3. call `addAttachment()` to make the attachment visible to others   
         * @summary Prepare attachment
         * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareAttachment(AttachmentAddRequest: AttachmentAddRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AttachmentPresignedUrlResponse> {
            const localVarFetchArgs = AttachmentsApiFetchParamCreator(configuration).prepareAttachment(AttachmentAddRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AttachmentsApi - factory interface
 * @export
 */
export const AttachmentsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Use this method to add a file attachment to a selected transport order element.  As described in section \"Management of Attachments\" the transport order itself does not contain  actual attachments. Instead, it contains an URL reference to each attached file.   As executionResult, this endpoint returns an upload url which can be used to upload the actual file.   Use the addAttachment operation to attach an arbitrary file reference to a transport order element  (e.g. the TransportOrder, a Transport , a StopLocation, a StopAction or the Freight). The actual  content of the attachment must be uploaded directly to the object storage server. For small files  the presignedUploadUrl returned by this operation can be used. In case of larger file uploads, the  operation prepareAttachment should be used to retrieve an upload url. Once the upload is completed,  the addAttachment operation must be called to  actually reference the added attachment.     Please note that the added attachment points to an empty location until the attachment is really uploaded by the client.
         * @summary Create attachment
         * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment(AttachmentAddRequest: AttachmentAddRequest, options?: any) {
            return AttachmentsApiFp(configuration).addAttachment(AttachmentAddRequest, options)(fetch, basePath);
        },
        /**
         * This method modifies multiple attachments in a single request. It processes all modifications and returns successful and failed results. 
         * @summary Batch modify attachments
         * @param {BatchAttachmentModifyRequest} BatchAttachmentModifyRequest BatchAttachmentModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchModifyAttachments(BatchAttachmentModifyRequest: BatchAttachmentModifyRequest, options?: any) {
            return AttachmentsApiFp(configuration).batchModifyAttachments(BatchAttachmentModifyRequest, options)(fetch, basePath);
        },
        /**
         * Removes an attachment with the specified attachment id from the transport order with the specified transportOrderId. The ATTACHMENT_DELETE permission is required to access this operation.
         * @summary Deletes an attachment.
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [actionId] actionId
         * @param {string} [contractingPartyId] contractingPartyId
         * @param {string} [fileName] fileName
         * @param {string} [freightId] freightId
         * @param {string} [stopId] stopId
         * @param {string} [transportId] transportId
         * @param {string} [uniqueLocationId] uniqueLocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options?: any) {
            return AttachmentsApiFp(configuration).deleteAttachment(attachmentId, transportOrderId, actionId, contractingPartyId, fileName, freightId, stopId, transportId, uniqueLocationId, options)(fetch, basePath);
        },
        /**
         * This operation returns the actual location of the file attachment. The resulting url can be used to download an attachment without further authentication. However, the returned URL expires after 30 min.
         * @summary Get Download URL for Attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [fileName] fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentDownloadUrl(attachmentId: string, transportOrderId: string, fileName?: string, options?: any) {
            return AttachmentsApiFp(configuration).getAttachmentDownloadUrl(attachmentId, transportOrderId, fileName, options)(fetch, basePath);
        },
        /**
         * This operation returns the actual location of the file attachment. The resulting url can be used to show an attachment inline without further authentication.  The corresponding filetype is determined by the filename extension.  However, the returned URL expires after 30 min.
         * @summary Get inline URL for Attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [fileName] fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentInlineUrl(attachmentId: string, transportOrderId: string, fileName?: string, options?: any) {
            return AttachmentsApiFp(configuration).getAttachmentInlineUrl(attachmentId, transportOrderId, fileName, options)(fetch, basePath);
        },
        /**
         * As executionResult, this endpoint returns an upload url which can be used to upload the actual file. The resulting upload url allows to replace the file content if the attachment was uploaded previously. Use this method to upload attachments which are specified during transport order creation.
         * @summary Get upload url for an existing attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {string} [actionId] actionId
         * @param {string} [contractingPartyId] contractingPartyId
         * @param {string} [fileName] fileName
         * @param {string} [freightId] freightId
         * @param {string} [stopId] stopId
         * @param {string} [transportId] transportId
         * @param {string} [uniqueLocationId] uniqueLocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentUploadUrl(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options?: any) {
            return AttachmentsApiFp(configuration).getAttachmentUploadUrl(attachmentId, transportOrderId, actionId, contractingPartyId, fileName, freightId, stopId, transportId, uniqueLocationId, options)(fetch, basePath);
        },
        /**
         * This operation redirects the calling client to the actual location of an attachment to immediately start downloading the attachment file content.
         * @summary Download attachment by redirect
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentUrl(attachmentId: string, transportOrderId: string, options?: any) {
            return AttachmentsApiFp(configuration).getAttachmentUrl(attachmentId, transportOrderId, options)(fetch, basePath);
        },
        /**
         * This method modifies the name, status,category and additional data from an existing attachment and moves it corresponding to the pathSelector. It returns the modified TransportOrder and Attachment 
         * @summary Modify attachment
         * @param {string} attachmentId attachmentId
         * @param {string} transportOrderId transportOrderId
         * @param {AttachmentModifyRequest} AttachmentModifyRequest AttachmentModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyAttachment(attachmentId: string, transportOrderId: string, AttachmentModifyRequest: AttachmentModifyRequest, options?: any) {
            return AttachmentsApiFp(configuration).modifyAttachment(attachmentId, transportOrderId, AttachmentModifyRequest, options)(fetch, basePath);
        },
        /**
         * Use this method to prepare a file attachment which should be attached to the specified transport order element.  This method returns a upload url which can be used to upload an attachment file to the object storage.  The workflow for adding an attachment is as follows:  1. `prepareAttachment()` which returns an upload url  2. HTTP + PUT to the given upload url  3. call `addAttachment()` to make the attachment visible to others   
         * @summary Prepare attachment
         * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareAttachment(AttachmentAddRequest: AttachmentAddRequest, options?: any) {
            return AttachmentsApiFp(configuration).prepareAttachment(AttachmentAddRequest, options)(fetch, basePath);
        },
    };
};

/**
 * AttachmentsApi - object-oriented interface
 * @export
 * @class AttachmentsApi
 * @extends {BaseAPI}
 */
export class AttachmentsApi extends BaseAPI {
    /**
     * Use this method to add a file attachment to a selected transport order element.  As described in section \"Management of Attachments\" the transport order itself does not contain  actual attachments. Instead, it contains an URL reference to each attached file.   As executionResult, this endpoint returns an upload url which can be used to upload the actual file.   Use the addAttachment operation to attach an arbitrary file reference to a transport order element  (e.g. the TransportOrder, a Transport , a StopLocation, a StopAction or the Freight). The actual  content of the attachment must be uploaded directly to the object storage server. For small files  the presignedUploadUrl returned by this operation can be used. In case of larger file uploads, the  operation prepareAttachment should be used to retrieve an upload url. Once the upload is completed,  the addAttachment operation must be called to  actually reference the added attachment.     Please note that the added attachment points to an empty location until the attachment is really uploaded by the client.
     * @summary Create attachment
     * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public addAttachment(AttachmentAddRequest: AttachmentAddRequest, options?: any) {
        return AttachmentsApiFp(this.configuration).addAttachment(AttachmentAddRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This method modifies multiple attachments in a single request. It processes all modifications and returns successful and failed results. 
     * @summary Batch modify attachments
     * @param {BatchAttachmentModifyRequest} BatchAttachmentModifyRequest BatchAttachmentModifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public batchModifyAttachments(BatchAttachmentModifyRequest: BatchAttachmentModifyRequest, options?: any) {
        return AttachmentsApiFp(this.configuration).batchModifyAttachments(BatchAttachmentModifyRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Removes an attachment with the specified attachment id from the transport order with the specified transportOrderId. The ATTACHMENT_DELETE permission is required to access this operation.
     * @summary Deletes an attachment.
     * @param {string} attachmentId attachmentId
     * @param {string} transportOrderId transportOrderId
     * @param {string} [actionId] actionId
     * @param {string} [contractingPartyId] contractingPartyId
     * @param {string} [fileName] fileName
     * @param {string} [freightId] freightId
     * @param {string} [stopId] stopId
     * @param {string} [transportId] transportId
     * @param {string} [uniqueLocationId] uniqueLocationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public deleteAttachment(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options?: any) {
        return AttachmentsApiFp(this.configuration).deleteAttachment(attachmentId, transportOrderId, actionId, contractingPartyId, fileName, freightId, stopId, transportId, uniqueLocationId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation returns the actual location of the file attachment. The resulting url can be used to download an attachment without further authentication. However, the returned URL expires after 30 min.
     * @summary Get Download URL for Attachment
     * @param {string} attachmentId attachmentId
     * @param {string} transportOrderId transportOrderId
     * @param {string} [fileName] fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getAttachmentDownloadUrl(attachmentId: string, transportOrderId: string, fileName?: string, options?: any) {
        return AttachmentsApiFp(this.configuration).getAttachmentDownloadUrl(attachmentId, transportOrderId, fileName, options)(this.fetch, this.basePath);
    }

    /**
     * This operation returns the actual location of the file attachment. The resulting url can be used to show an attachment inline without further authentication.  The corresponding filetype is determined by the filename extension.  However, the returned URL expires after 30 min.
     * @summary Get inline URL for Attachment
     * @param {string} attachmentId attachmentId
     * @param {string} transportOrderId transportOrderId
     * @param {string} [fileName] fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getAttachmentInlineUrl(attachmentId: string, transportOrderId: string, fileName?: string, options?: any) {
        return AttachmentsApiFp(this.configuration).getAttachmentInlineUrl(attachmentId, transportOrderId, fileName, options)(this.fetch, this.basePath);
    }

    /**
     * As executionResult, this endpoint returns an upload url which can be used to upload the actual file. The resulting upload url allows to replace the file content if the attachment was uploaded previously. Use this method to upload attachments which are specified during transport order creation.
     * @summary Get upload url for an existing attachment
     * @param {string} attachmentId attachmentId
     * @param {string} transportOrderId transportOrderId
     * @param {string} [actionId] actionId
     * @param {string} [contractingPartyId] contractingPartyId
     * @param {string} [fileName] fileName
     * @param {string} [freightId] freightId
     * @param {string} [stopId] stopId
     * @param {string} [transportId] transportId
     * @param {string} [uniqueLocationId] uniqueLocationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getAttachmentUploadUrl(attachmentId: string, transportOrderId: string, actionId?: string, contractingPartyId?: string, fileName?: string, freightId?: string, stopId?: string, transportId?: string, uniqueLocationId?: string, options?: any) {
        return AttachmentsApiFp(this.configuration).getAttachmentUploadUrl(attachmentId, transportOrderId, actionId, contractingPartyId, fileName, freightId, stopId, transportId, uniqueLocationId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation redirects the calling client to the actual location of an attachment to immediately start downloading the attachment file content.
     * @summary Download attachment by redirect
     * @param {string} attachmentId attachmentId
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getAttachmentUrl(attachmentId: string, transportOrderId: string, options?: any) {
        return AttachmentsApiFp(this.configuration).getAttachmentUrl(attachmentId, transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This method modifies the name, status,category and additional data from an existing attachment and moves it corresponding to the pathSelector. It returns the modified TransportOrder and Attachment 
     * @summary Modify attachment
     * @param {string} attachmentId attachmentId
     * @param {string} transportOrderId transportOrderId
     * @param {AttachmentModifyRequest} AttachmentModifyRequest AttachmentModifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public modifyAttachment(attachmentId: string, transportOrderId: string, AttachmentModifyRequest: AttachmentModifyRequest, options?: any) {
        return AttachmentsApiFp(this.configuration).modifyAttachment(attachmentId, transportOrderId, AttachmentModifyRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Use this method to prepare a file attachment which should be attached to the specified transport order element.  This method returns a upload url which can be used to upload an attachment file to the object storage.  The workflow for adding an attachment is as follows:  1. `prepareAttachment()` which returns an upload url  2. HTTP + PUT to the given upload url  3. call `addAttachment()` to make the attachment visible to others   
     * @summary Prepare attachment
     * @param {AttachmentAddRequest} AttachmentAddRequest AttachmentAddRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public prepareAttachment(AttachmentAddRequest: AttachmentAddRequest, options?: any) {
        return AttachmentsApiFp(this.configuration).prepareAttachment(AttachmentAddRequest, options)(this.fetch, this.basePath);
    }

}

/**
 * ChangeEventsApi - fetch parameter creator
 * @export
 */
export const ChangeEventsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the count of change events by the given filter.
         * @summary Get count of change events by filter
         * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ChangeEventsFilterRequest' is not null or undefined
            if (ChangeEventsFilterRequest === null || ChangeEventsFilterRequest === undefined) {
                throw new RequiredError('ChangeEventsFilterRequest','Required parameter ChangeEventsFilterRequest was null or undefined when calling countEventsByFilter.');
            }
            const localVarPath = `/events/countEventsByFilter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChangeEventsFilterRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ChangeEventsFilterRequest || {}) : (ChangeEventsFilterRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns a diff of 2 change events identified by the change event ids. 
         * @summary gets diff between 2 change events by ids
         * @param {string} changeEventId1 changeEventId1
         * @param {string} changeEventId2 changeEventId2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDiffOfChangeEventsByIds(changeEventId1: string, changeEventId2: string, options: any = {}): FetchArgs {
            // verify required parameter 'changeEventId1' is not null or undefined
            if (changeEventId1 === null || changeEventId1 === undefined) {
                throw new RequiredError('changeEventId1','Required parameter changeEventId1 was null or undefined when calling fetchDiffOfChangeEventsByIds.');
            }
            // verify required parameter 'changeEventId2' is not null or undefined
            if (changeEventId2 === null || changeEventId2 === undefined) {
                throw new RequiredError('changeEventId2','Required parameter changeEventId2 was null or undefined when calling fetchDiffOfChangeEventsByIds.');
            }
            const localVarPath = `/events/diffEventsById/{changeEventId1}/{changeEventId2}`
                .replace(`{${"changeEventId1"}}`, encodeURIComponent(String(changeEventId1)))
                .replace(`{${"changeEventId2"}}`, encodeURIComponent(String(changeEventId2)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all change events by the given filter.
         * @summary Find change events by filter
         * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ChangeEventsFilterRequest' is not null or undefined
            if (ChangeEventsFilterRequest === null || ChangeEventsFilterRequest === undefined) {
                throw new RequiredError('ChangeEventsFilterRequest','Required parameter ChangeEventsFilterRequest was null or undefined when calling fetchEventsByFilter.');
            }
            const localVarPath = `/events/fetchEventsByFilter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChangeEventsFilterRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ChangeEventsFilterRequest || {}) : (ChangeEventsFilterRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns a change event identified by the change event id. It must belong to the current company of the user. 
         * @summary gets a change event by id
         * @param {string} changeEventId changeEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSingleChangeEventById(changeEventId: string, options: any = {}): FetchArgs {
            // verify required parameter 'changeEventId' is not null or undefined
            if (changeEventId === null || changeEventId === undefined) {
                throw new RequiredError('changeEventId','Required parameter changeEventId was null or undefined when calling fetchSingleChangeEventById.');
            }
            const localVarPath = `/events/fetchSingleChangeEventById/{changeEventId}`
                .replace(`{${"changeEventId"}}`, encodeURIComponent(String(changeEventId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangeEventsApi - functional programming interface
 * @export
 */
export const ChangeEventsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get the count of change events by the given filter.
         * @summary Get count of change events by filter
         * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CountEventsResult> {
            const localVarFetchArgs = ChangeEventsApiFetchParamCreator(configuration).countEventsByFilter(ChangeEventsFilterRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns a diff of 2 change events identified by the change event ids. 
         * @summary gets diff between 2 change events by ids
         * @param {string} changeEventId1 changeEventId1
         * @param {string} changeEventId2 changeEventId2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDiffOfChangeEventsByIds(changeEventId1: string, changeEventId2: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ChangeEvent> {
            const localVarFetchArgs = ChangeEventsApiFetchParamCreator(configuration).fetchDiffOfChangeEventsByIds(changeEventId1, changeEventId2, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch all change events by the given filter.
         * @summary Find change events by filter
         * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ChangeEventsResult> {
            const localVarFetchArgs = ChangeEventsApiFetchParamCreator(configuration).fetchEventsByFilter(ChangeEventsFilterRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns a change event identified by the change event id. It must belong to the current company of the user. 
         * @summary gets a change event by id
         * @param {string} changeEventId changeEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSingleChangeEventById(changeEventId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ChangeEvent> {
            const localVarFetchArgs = ChangeEventsApiFetchParamCreator(configuration).fetchSingleChangeEventById(changeEventId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ChangeEventsApi - factory interface
 * @export
 */
export const ChangeEventsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get the count of change events by the given filter.
         * @summary Get count of change events by filter
         * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options?: any) {
            return ChangeEventsApiFp(configuration).countEventsByFilter(ChangeEventsFilterRequest, options)(fetch, basePath);
        },
        /**
         * This endpoint returns a diff of 2 change events identified by the change event ids. 
         * @summary gets diff between 2 change events by ids
         * @param {string} changeEventId1 changeEventId1
         * @param {string} changeEventId2 changeEventId2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDiffOfChangeEventsByIds(changeEventId1: string, changeEventId2: string, options?: any) {
            return ChangeEventsApiFp(configuration).fetchDiffOfChangeEventsByIds(changeEventId1, changeEventId2, options)(fetch, basePath);
        },
        /**
         * Fetch all change events by the given filter.
         * @summary Find change events by filter
         * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options?: any) {
            return ChangeEventsApiFp(configuration).fetchEventsByFilter(ChangeEventsFilterRequest, options)(fetch, basePath);
        },
        /**
         * This endpoint returns a change event identified by the change event id. It must belong to the current company of the user. 
         * @summary gets a change event by id
         * @param {string} changeEventId changeEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSingleChangeEventById(changeEventId: string, options?: any) {
            return ChangeEventsApiFp(configuration).fetchSingleChangeEventById(changeEventId, options)(fetch, basePath);
        },
    };
};

/**
 * ChangeEventsApi - object-oriented interface
 * @export
 * @class ChangeEventsApi
 * @extends {BaseAPI}
 */
export class ChangeEventsApi extends BaseAPI {
    /**
     * Get the count of change events by the given filter.
     * @summary Get count of change events by filter
     * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeEventsApi
     */
    public countEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options?: any) {
        return ChangeEventsApiFp(this.configuration).countEventsByFilter(ChangeEventsFilterRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns a diff of 2 change events identified by the change event ids. 
     * @summary gets diff between 2 change events by ids
     * @param {string} changeEventId1 changeEventId1
     * @param {string} changeEventId2 changeEventId2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeEventsApi
     */
    public fetchDiffOfChangeEventsByIds(changeEventId1: string, changeEventId2: string, options?: any) {
        return ChangeEventsApiFp(this.configuration).fetchDiffOfChangeEventsByIds(changeEventId1, changeEventId2, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch all change events by the given filter.
     * @summary Find change events by filter
     * @param {ChangeEventsFilterRequest} ChangeEventsFilterRequest ChangeEventsFilterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeEventsApi
     */
    public fetchEventsByFilter(ChangeEventsFilterRequest: ChangeEventsFilterRequest, options?: any) {
        return ChangeEventsApiFp(this.configuration).fetchEventsByFilter(ChangeEventsFilterRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns a change event identified by the change event id. It must belong to the current company of the user. 
     * @summary gets a change event by id
     * @param {string} changeEventId changeEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeEventsApi
     */
    public fetchSingleChangeEventById(changeEventId: string, options?: any) {
        return ChangeEventsApiFp(this.configuration).fetchSingleChangeEventById(changeEventId, options)(this.fetch, this.basePath);
    }

}

/**
 * CompanyApi - fetch parameter creator
 * @export
 */
export const CompanyApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * update company's customer report setting to acknowledged based on the enable flag.
         * @summary update company's customer report setting to acknowledged.
         * @param {AddAcknowledgementForCompaniesCustomerReportRequest} AddAcknowledgementForCompaniesCustomerReportRequest AddAcknowledgementForCompaniesCustomerReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeCompaniesFromCustomerReport(AddAcknowledgementForCompaniesCustomerReportRequest: AddAcknowledgementForCompaniesCustomerReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AddAcknowledgementForCompaniesCustomerReportRequest' is not null or undefined
            if (AddAcknowledgementForCompaniesCustomerReportRequest === null || AddAcknowledgementForCompaniesCustomerReportRequest === undefined) {
                throw new RequiredError('AddAcknowledgementForCompaniesCustomerReportRequest','Required parameter AddAcknowledgementForCompaniesCustomerReportRequest was null or undefined when calling acknowledgeCompaniesFromCustomerReport.');
            }
            const localVarPath = `/company/acknowledgeCompaniesFromCustomerReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddAcknowledgementForCompaniesCustomerReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AddAcknowledgementForCompaniesCustomerReportRequest || {}) : (AddAcknowledgementForCompaniesCustomerReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new customer address mapping
         * @summary Add new customerAddressMapping
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyAddressMapping(CompanyAddressMapping: CompanyAddressMapping, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyAddressMapping' is not null or undefined
            if (CompanyAddressMapping === null || CompanyAddressMapping === undefined) {
                throw new RequiredError('CompanyAddressMapping','Required parameter CompanyAddressMapping was null or undefined when calling addCompanyAddressMapping.');
            }
            const localVarPath = `/company/addressMapping/add`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyAddressMapping" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyAddressMapping || {}) : (CompanyAddressMapping || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new customer address mapping group
         * @summary Add new customerAddressMappingGroup
         * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyAddressMappingGroup(CompanyAddressMappingGroup: CompanyAddressMappingGroup, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyAddressMappingGroup' is not null or undefined
            if (CompanyAddressMappingGroup === null || CompanyAddressMappingGroup === undefined) {
                throw new RequiredError('CompanyAddressMappingGroup','Required parameter CompanyAddressMappingGroup was null or undefined when calling addCompanyAddressMappingGroup.');
            }
            const localVarPath = `/company/addressMappingGroup`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyAddressMappingGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyAddressMappingGroup || {}) : (CompanyAddressMappingGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new customer freight mapping
         * @summary Add new customerFreightMapping
         * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyFreightMapping(CompanyFreightMapping: CompanyFreightMapping, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyFreightMapping' is not null or undefined
            if (CompanyFreightMapping === null || CompanyFreightMapping === undefined) {
                throw new RequiredError('CompanyFreightMapping','Required parameter CompanyFreightMapping was null or undefined when calling addCompanyFreightMapping.');
            }
            const localVarPath = `/company/freightMapping/add`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyFreightMapping" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyFreightMapping || {}) : (CompanyFreightMapping || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new customer freight mapping group
         * @summary Add new customerFreightMappingGroup
         * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyFreightMappingGroup(CompanyFreightMappingGroup: CompanyFreightMappingGroup, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyFreightMappingGroup' is not null or undefined
            if (CompanyFreightMappingGroup === null || CompanyFreightMappingGroup === undefined) {
                throw new RequiredError('CompanyFreightMappingGroup','Required parameter CompanyFreightMappingGroup was null or undefined when calling addCompanyFreightMappingGroup.');
            }
            const localVarPath = `/company/freightMappingGroups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyFreightMappingGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyFreightMappingGroup || {}) : (CompanyFreightMappingGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new company tag
         * @summary Add new company tag
         * @param {CompanyTag} CompanyTag CompanyTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTag(CompanyTag: CompanyTag, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyTag' is not null or undefined
            if (CompanyTag === null || CompanyTag === undefined) {
                throw new RequiredError('CompanyTag','Required parameter CompanyTag was null or undefined when calling addCompanyTag.');
            }
            const localVarPath = `/company/addCompanyTag`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyTag" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyTag || {}) : (CompanyTag || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new customer TransportOrder Mapping
         * @summary Add new customerTransportOrderMapping
         * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTransportOrderMapping(CompanyTransportOrderMapping: CompanyTransportOrderMapping, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyTransportOrderMapping' is not null or undefined
            if (CompanyTransportOrderMapping === null || CompanyTransportOrderMapping === undefined) {
                throw new RequiredError('CompanyTransportOrderMapping','Required parameter CompanyTransportOrderMapping was null or undefined when calling addCompanyTransportOrderMapping.');
            }
            const localVarPath = `/company/transportOrderMapping/add`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyTransportOrderMapping" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyTransportOrderMapping || {}) : (CompanyTransportOrderMapping || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new customer TransportOrder mapping group
         * @summary Add new customerCompanyTransportOrderMappingGroup
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTransportOrderMappingGroup(CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyTransportOrderMappingGroup' is not null or undefined
            if (CompanyTransportOrderMappingGroup === null || CompanyTransportOrderMappingGroup === undefined) {
                throw new RequiredError('CompanyTransportOrderMappingGroup','Required parameter CompanyTransportOrderMappingGroup was null or undefined when calling addCompanyTransportOrderMappingGroup.');
            }
            const localVarPath = `/company/transportOrderMappingGroups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyTransportOrderMappingGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyTransportOrderMappingGroup || {}) : (CompanyTransportOrderMappingGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the add filter request and save it in database as per user id and company specific
         * @summary Add new filter for a user as per his company signed in
         * @param {AddFiltersRequest} AddFiltersRequest AddFiltersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFilters(AddFiltersRequest: AddFiltersRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AddFiltersRequest' is not null or undefined
            if (AddFiltersRequest === null || AddFiltersRequest === undefined) {
                throw new RequiredError('AddFiltersRequest','Required parameter AddFiltersRequest was null or undefined when calling addFilters.');
            }
            const localVarPath = `/company/addFilter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddFiltersRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AddFiltersRequest || {}) : (AddFiltersRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update company's customer report setting to ignore or unIgnore based on the enable flag.
         * @summary update company's customer report setting to ignore or unignore.
         * @param {AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest} AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemoveCompaniesFromIgnoreListForCustomerReport(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest: AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest' is not null or undefined
            if (AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest === null || AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest === undefined) {
                throw new RequiredError('AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest','Required parameter AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest was null or undefined when calling addOrRemoveCompaniesFromIgnoreListForCustomerReport.');
            }
            const localVarPath = `/company/addOrRemoveCompaniesFromIgnoreListForCustomerReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest || {}) : (AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a user with the given userId to the role with the given userRoleId. The Permission USER_ROLES_ASSIGN is required to execute this operation.
         * @summary Add user role membership for the given role and the given user
         * @param {string} roleId roleId
         * @param {UserRoleAddRequest} UserRoleAddRequest UserRoleAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleToUser(roleId: string, UserRoleAddRequest: UserRoleAddRequest, options: any = {}): FetchArgs {
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId','Required parameter roleId was null or undefined when calling addRoleToUser.');
            }
            // verify required parameter 'UserRoleAddRequest' is not null or undefined
            if (UserRoleAddRequest === null || UserRoleAddRequest === undefined) {
                throw new RequiredError('UserRoleAddRequest','Required parameter UserRoleAddRequest was null or undefined when calling addRoleToUser.');
            }
            const localVarPath = `/company/roles/{roleId}/users`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserRoleAddRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UserRoleAddRequest || {}) : (UserRoleAddRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archives Company
         * @summary archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompany(options: any = {}): FetchArgs {
            const localVarPath = `/company/archive`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate spedion user as per php session id
         * @summary Authenticate spedion user as per php session id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateSpedionUser(options: any = {}): FetchArgs {
            const localVarPath = `/company/authenticateSpedionUser`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes multiple company address mappings
         * @summary Delete companyAddressMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyAddressMappings(ids: string, options: any = {}): FetchArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling bulkDeleteCompanyAddressMappings.');
            }
            const localVarPath = `/company/addressMapping/bulk-delete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes multiple company freight mappings
         * @summary Delete companyFreightMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyFreightMappings(ids: string, options: any = {}): FetchArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling bulkDeleteCompanyFreightMappings.');
            }
            const localVarPath = `/company/freightMapping/bulk-delete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes multiple company TransportOrder mappings
         * @summary Delete CompanyTransportOrderMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyTransportOrderMappings(ids: string, options: any = {}): FetchArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling bulkDeleteCompanyTransportOrderMappings.');
            }
            const localVarPath = `/company/transportOrderMapping/bulk-delete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check and update disable until status for customer reports based on the new report values.
         * @summary Check and update disable until status based on current customer reports.
         * @param {CheckAndUpdateDisableUntilStatusRequest} CheckAndUpdateDisableUntilStatusRequest CheckAndUpdateDisableUntilStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndUpdateDisableUntilStatus(CheckAndUpdateDisableUntilStatusRequest: CheckAndUpdateDisableUntilStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'CheckAndUpdateDisableUntilStatusRequest' is not null or undefined
            if (CheckAndUpdateDisableUntilStatusRequest === null || CheckAndUpdateDisableUntilStatusRequest === undefined) {
                throw new RequiredError('CheckAndUpdateDisableUntilStatusRequest','Required parameter CheckAndUpdateDisableUntilStatusRequest was null or undefined when calling checkAndUpdateDisableUntilStatus.');
            }
            const localVarPath = `/company/checkAndUpdateDisableUntilStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CheckAndUpdateDisableUntilStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CheckAndUpdateDisableUntilStatusRequest || {}) : (CheckAndUpdateDisableUntilStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clones an existing company TransportOrder mapping group, creating a new group with the same settings. Optionally override fields via the request body (e.g. validFrom, validTill, groupName).
         * @summary Clone a companyTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling cloneCompanyTransportOrderMappingGroup.');
            }
            // verify required parameter 'CompanyTransportOrderMappingGroup' is not null or undefined
            if (CompanyTransportOrderMappingGroup === null || CompanyTransportOrderMappingGroup === undefined) {
                throw new RequiredError('CompanyTransportOrderMappingGroup','Required parameter CompanyTransportOrderMappingGroup was null or undefined when calling cloneCompanyTransportOrderMappingGroup.');
            }
            const localVarPath = `/company/transportOrderMappingGroups/{id}/clone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyTransportOrderMappingGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyTransportOrderMappingGroup || {}) : (CompanyTransportOrderMappingGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new driver for the current company of the user. If a driver with the specified pin already exists, a BadRequest is returned to the calling user. The DRIVER_CREATE_MODIFY_DELETE permission is required to call this endpoint
         * @summary Create new driver
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriver(DriverRequest: DriverRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DriverRequest' is not null or undefined
            if (DriverRequest === null || DriverRequest === undefined) {
                throw new RequiredError('DriverRequest','Required parameter DriverRequest was null or undefined when calling createDriver.');
            }
            const localVarPath = `/company/drivers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DriverRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DriverRequest || {}) : (DriverRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an new invitation and send an invitation email to the invited party. If the invited party accepts the invitation, both companies become partner and can exchange transports.
         * @summary send invitation
         * @param {PartnerInvitation} PartnerInvitation PartnerInvitation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(PartnerInvitation: PartnerInvitation, options: any = {}): FetchArgs {
            // verify required parameter 'PartnerInvitation' is not null or undefined
            if (PartnerInvitation === null || PartnerInvitation === undefined) {
                throw new RequiredError('PartnerInvitation','Required parameter PartnerInvitation was null or undefined when calling createInvitation.');
            }
            const localVarPath = `/company/partners/outgoinginvitations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PartnerInvitation" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(PartnerInvitation || {}) : (PartnerInvitation || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user for the specified company. The permission USERS_CREATE is required to create a new user account. The newly created user is member of the same company as the currently authenticated user.
         * @summary create user
         * @param {UserCreateRequest} UserCreateRequest UserCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(UserCreateRequest: UserCreateRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UserCreateRequest' is not null or undefined
            if (UserCreateRequest === null || UserCreateRequest === undefined) {
                throw new RequiredError('UserCreateRequest','Required parameter UserCreateRequest was null or undefined when calling createUser.');
            }
            const localVarPath = `/company/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserCreateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UserCreateRequest || {}) : (UserCreateRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user role. The permission USER_ROLES_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Create new user role
         * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserRole(UserRoleRequest: UserRoleRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UserRoleRequest' is not null or undefined
            if (UserRoleRequest === null || UserRoleRequest === undefined) {
                throw new RequiredError('UserRoleRequest','Required parameter UserRoleRequest was null or undefined when calling createUserRole.');
            }
            const localVarPath = `/company/roles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserRoleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UserRoleRequest || {}) : (UserRoleRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new vehicles for the current company of the user. If a vehicles with the specified numberPlate or externalVehicleId already exists, a BadRequest is returned to the calling user. The VEHICLE_CREATE_MODIFY_DELETE permission is required to call this endpoint
         * @summary Create new vehicles
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle(VehicleRequest: VehicleRequest, options: any = {}): FetchArgs {
            // verify required parameter 'VehicleRequest' is not null or undefined
            if (VehicleRequest === null || VehicleRequest === undefined) {
                throw new RequiredError('VehicleRequest','Required parameter VehicleRequest was null or undefined when calling createVehicle.');
            }
            const localVarPath = `/company/vehicles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehicleRequest || {}) : (VehicleRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a customer address mapping
         * @summary Delete customerAddressMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyAddressMapping(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCompanyAddressMapping.');
            }
            const localVarPath = `/company/addressMapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a customer address mapping group
         * @summary Delete customerAddressMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyAddressMappingGroup(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCompanyAddressMappingGroup.');
            }
            const localVarPath = `/company/addressMappingGroup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a company freight mapping
         * @summary Delete companyFreightMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyFreightMapping(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCompanyFreightMapping.');
            }
            const localVarPath = `/company/freightMapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a company freight mapping group
         * @summary Delete companyFreightMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyFreightMappingGroup(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCompanyFreightMappingGroup.');
            }
            const localVarPath = `/company/freightMappingGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a company tag
         * @summary Delete companyTag with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTag(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCompanyTag.');
            }
            const localVarPath = `/company/deleteCompanyTag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a company transportOrder mapping
         * @summary Delete companyTransportOrderMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTransportOrderMapping(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCompanyTransportOrderMapping.');
            }
            const localVarPath = `/company/transportOrderMapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a company TransportOrder mapping group
         * @summary Delete companyTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTransportOrderMappingGroup(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCompanyTransportOrderMappingGroup.');
            }
            const localVarPath = `/company/transportOrderMappingGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the filter with the given filterId and userId. The permission COMPANY_MODIFY is required to execute this operation.
         * @summary Delete filter by id
         * @param {string} [filterId] filterId
         * @param {string} [userId] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilter(filterId?: string, userId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/deleteFilter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (filterId !== undefined) {
                localVarQueryParameter['filterId'] = filterId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a partner and cancels the partnership between two companies.
         * @summary delete
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartner(partnerCompanyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'partnerCompanyId' is not null or undefined
            if (partnerCompanyId === null || partnerCompanyId === undefined) {
                throw new RequiredError('partnerCompanyId','Required parameter partnerCompanyId was null or undefined when calling deletePartner.');
            }
            const localVarPath = `/company/partners/{partnerCompanyId}`
                .replace(`{${"partnerCompanyId"}}`, encodeURIComponent(String(partnerCompanyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to remove a user from the companies users list. The permission USER_DELETE is required to execute this operation
         * @summary Delete user by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteUserById.');
            }
            const localVarPath = `/company/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the user role with the specified role id.
         * @summary Delete user role by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRoleById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteUserRoleById.');
            }
            const localVarPath = `/company/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the filter name depending upon the filter id and return the updated filter list
         * @summary Modify filter name as per the id
         * @param {ModifyFilterName} ModifyFilterName ModifyFilterName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFilterName(ModifyFilterName: ModifyFilterName, options: any = {}): FetchArgs {
            // verify required parameter 'ModifyFilterName' is not null or undefined
            if (ModifyFilterName === null || ModifyFilterName === undefined) {
                throw new RequiredError('ModifyFilterName','Required parameter ModifyFilterName was null or undefined when calling editFilterName.');
            }
            const localVarPath = `/company/editFilterName`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ModifyFilterName" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ModifyFilterName || {}) : (ModifyFilterName || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all users of all partners for the current company. In order to call this operation the permission USERS_VIEW is required
         * @summary Get List of users for all partner companies
         * @param {string} query query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPartnersUsers(query: string, options: any = {}): FetchArgs {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query','Required parameter query was null or undefined when calling fetchAllPartnersUsers.');
            }
            const localVarPath = `/company/partners/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of all partner companies with list of validationRules    
         * @summary Get List of all partner companies with list of validationRules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPartnersValidationRuleNames(options: any = {}): FetchArgs {
            const localVarPath = `/company/partners/validationRuleNames`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch address book and drivers of the user's company.
         * @summary fetch company's address book and drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressBookAndDrivers(options: any = {}): FetchArgs {
            const localVarPath = `/company/fetchCompanyAddressBookAndDrivers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all company address mapping groups of this company
         * @summary Get a list of all customer address mapping groups
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingGroups(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/addressMappingGroup`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all user defined address mappings defined for this company.
         * @summary Get a list of all customer address mappings
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/addressMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (onlyGroupIds) {
                localVarQueryParameter['onlyGroupIds'] = onlyGroupIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all user defined address mappings defined for this company without authentication.
         * @summary Get a list of all customer address mappings
         * @param {string} token token
         * @param {string} [pin] pin
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingListPublic(token: string, pin?: string, onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling fetchCompanyAddressMappingListPublic.');
            }
            const localVarPath = `/company/addressMappingPublic`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pin !== undefined) {
                localVarQueryParameter['pin'] = pin;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (onlyGroupIds) {
                localVarQueryParameter['onlyGroupIds'] = onlyGroupIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the company with the specified companyId, if the currently authenticated user has the permission to view that company.
         * @summary get company by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchCompanyById.');
            }
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all user definied freight mapping groups defined for this company.
         * @summary Get a list of all freight mapping groups
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyFreightMappingGroupList(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/freightMappingGroups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all user defined freight mappings for this company.
         * @summary Get a list of all freight mapping
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyFreightMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/freightMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (onlyGroupIds) {
                localVarQueryParameter['onlyGroupIds'] = onlyGroupIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the company of the currently authenticated user.
         * @summary get current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyOfUser(options: any = {}): FetchArgs {
            const localVarPath = `/company/current`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch Company tags as per company id
         * @summary Fetch Company tags as per company id
         * @param {FetchCompanyTagsRequest} FetchCompanyTagsRequest FetchCompanyTagsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTags(FetchCompanyTagsRequest: FetchCompanyTagsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchCompanyTagsRequest' is not null or undefined
            if (FetchCompanyTagsRequest === null || FetchCompanyTagsRequest === undefined) {
                throw new RequiredError('FetchCompanyTagsRequest','Required parameter FetchCompanyTagsRequest was null or undefined when calling fetchCompanyTags.');
            }
            const localVarPath = `/company/fetchCompanyTags`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchCompanyTagsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchCompanyTagsRequest || {}) : (FetchCompanyTagsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all user definied transportOrder mapping groups defined for this company.
         * @summary Get a list of all transportOrder mapping groups
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingGroupList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/transportOrderMappingGroups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all user defined transportOrder mappings for this company.
         * @summary Get a list of all transportOrder mapping
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/transportOrderMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all user defined transportOrder mappings based the specific group id for this company.
         * @summary Get a list of all transportOrder mapping by group id
         * @param {string} groupId groupId
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingListByGroupId(groupId: string, skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError('groupId','Required parameter groupId was null or undefined when calling fetchCompanyTransportOrderMappingListByGroupId.');
            }
            const localVarPath = `/company/transportOrderMappingByGroupId/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single driver with the specified driverId. The permission DRIVER_VIEW is required to fetch a driver
         * @summary Get a driver
         * @param {string} driverId driverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDriver(driverId: string, options: any = {}): FetchArgs {
            // verify required parameter 'driverId' is not null or undefined
            if (driverId === null || driverId === undefined) {
                throw new RequiredError('driverId','Required parameter driverId was null or undefined when calling fetchDriver.');
            }
            const localVarPath = `/company/drivers/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of drivers which are assigned to the users company. The permission DRIVER_VIEW is required to access this endpoint.
         * @summary Get all drivers
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDriverList(limit?: number, query?: string, skip?: number, sortBy?: 'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/company/drivers/all`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns one row per relevant transport order (DONE or EXECUTING) for every vehicle in the company within [sinceTimestamp, toTimestamp], enriched with the empty-kilometre gap to the previous tour, plausibility flags, hints, consolidated-shipment group label, FMS odometer values, customer (FRM key from freight additionalData) and stop coordinates.  Replaces the per-company `reportScript` based XLSX flow for the on-demand empty-kilometre dashboard. Optionally filterable by a list of vehicle number plates.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
         * @summary Get the empty-kilometres report for all vehicles in the given window
         * @param {EmptyKilometersReportRequest} EmptyKilometersReportRequest EmptyKilometersReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyKilometersReport(EmptyKilometersReportRequest: EmptyKilometersReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EmptyKilometersReportRequest' is not null or undefined
            if (EmptyKilometersReportRequest === null || EmptyKilometersReportRequest === undefined) {
                throw new RequiredError('EmptyKilometersReportRequest','Required parameter EmptyKilometersReportRequest was null or undefined when calling fetchEmptyKilometersReport.');
            }
            const localVarPath = `/company/reports/emptyKilometers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EmptyKilometersReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EmptyKilometersReportRequest || {}) : (EmptyKilometersReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Detail view behind one row of the empty-kilometre report: the GPS track between [sinceTimestamp, toTimestamp] split into driving and standing clusters (same segmentation the tour map uses), each standing cluster reverse geocoded to a city, and the DTCO activities of every driver that was on the truck in that window.  Standing clusters that sit at the last stop of the previous tour or at the first stop of the following one are flagged, so the caller can label them. When no DTCO logbook exists, `gpsDrivingSeconds` / `gpsStandingSeconds` carry the GPS approximation of driving versus everything else.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
         * @summary Get what the truck did during one empty run
         * @param {EmptyKilometersRunDetailsRequest} EmptyKilometersRunDetailsRequest EmptyKilometersRunDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyKilometersRunDetails(EmptyKilometersRunDetailsRequest: EmptyKilometersRunDetailsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EmptyKilometersRunDetailsRequest' is not null or undefined
            if (EmptyKilometersRunDetailsRequest === null || EmptyKilometersRunDetailsRequest === undefined) {
                throw new RequiredError('EmptyKilometersRunDetailsRequest','Required parameter EmptyKilometersRunDetailsRequest was null or undefined when calling fetchEmptyKilometersRunDetails.');
            }
            const localVarPath = `/company/reports/emptyKilometers/runDetails`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EmptyKilometersRunDetailsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EmptyKilometersRunDetailsRequest || {}) : (EmptyKilometersRunDetailsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * return empty tours for a vehicle
         * @summary get EmptyTours for a vehicle
         * @param {VehicleEmptyTourRequest} VehicleEmptyTourRequest VehicleEmptyTourRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyTours(VehicleEmptyTourRequest: VehicleEmptyTourRequest, options: any = {}): FetchArgs {
            // verify required parameter 'VehicleEmptyTourRequest' is not null or undefined
            if (VehicleEmptyTourRequest === null || VehicleEmptyTourRequest === undefined) {
                throw new RequiredError('VehicleEmptyTourRequest','Required parameter VehicleEmptyTourRequest was null or undefined when calling fetchEmptyTours.');
            }
            const localVarPath = `/company/vehicles/emptyTour`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleEmptyTourRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehicleEmptyTourRequest || {}) : (VehicleEmptyTourRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the filters as per user id and company specific
         * @summary Fetch filters as per user id and company id
         * @param {string} [companyId] companyId
         * @param {string} [userId] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFilters(companyId?: string, userId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/fetchFilter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all incoming partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
         * @summary invitation list
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIncomingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/company/partners/incominginvitations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the partnership invitation identified by the randomInvitation token. Everyone can access this invitation if he knows the randomInvitationToken. No further authentication is needed.
         * @summary get invitation by random token
         * @param {string} randomInvitationId randomInvitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitationByToken(randomInvitationId: string, options: any = {}): FetchArgs {
            // verify required parameter 'randomInvitationId' is not null or undefined
            if (randomInvitationId === null || randomInvitationId === undefined) {
                throw new RequiredError('randomInvitationId','Required parameter randomInvitationId was null or undefined when calling fetchInvitationByToken.');
            }
            const localVarPath = `/invitations/{randomInvitationId}`
                .replace(`{${"randomInvitationId"}}`, encodeURIComponent(String(randomInvitationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all outgoing partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
         * @summary invitation list
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOutgoingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/company/partners/outgoinginvitations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all partner companies including the externalId given for them. The permission COMPANY_VIEW_PARTNERS is required to to execute this operation
         * @summary get all partners
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/company/partners`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of users for the specified partner company.
         * @summary Get List of users for a partner company
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerUsers(partnerCompanyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'partnerCompanyId' is not null or undefined
            if (partnerCompanyId === null || partnerCompanyId === undefined) {
                throw new RequiredError('partnerCompanyId','Required parameter partnerCompanyId was null or undefined when calling fetchPartnerUsers.');
            }
            const localVarPath = `/company/partners/{partnerCompanyId}/users`
                .replace(`{${"partnerCompanyId"}}`, encodeURIComponent(String(partnerCompanyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the roles of the user of the given user id (for the availableCompany of the calling user). The permission USER_ROLES_VIEW is required to call this operation.
         * @summary Fetch roles of the user with id
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRolesForUser(userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling fetchRolesForUser.');
            }
            const localVarPath = `/company/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the user with the specified external user id.
         * @summary Find User by external user id
         * @param {string} externalId externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserByExternalUserId(externalId: string, options: any = {}): FetchArgs {
            // verify required parameter 'externalId' is not null or undefined
            if (externalId === null || externalId === undefined) {
                throw new RequiredError('externalId','Required parameter externalId was null or undefined when calling fetchUserByExternalUserId.');
            }
            const localVarPath = `/company/userByExternalId/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the user with the specified user id.
         * @summary Find User by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchUserById.');
            }
            const localVarPath = `/company/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the user role of the specified userRoleId. The permission USER_ROLES_VIEW is required to execute this operation
         * @summary Get user role by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRoleById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchUserRoleById.');
            }
            const localVarPath = `/company/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all user roles of the current company. The permission USER_ROLES_VIEW is required to execute this operation.
         * @summary Get all user roles
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'NAME' | 'PERMISSION'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRoleList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'PERMISSION', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/company/roles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the user roles of the specified userRoleIds. The permission USER_ROLES_VIEW is required to execute this operation
         * @summary Get user role by id
         * @param {Array<string>} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRolesByIds(ids: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling fetchUserRolesByIds.');
            }
            const localVarPath = `/company/roles/list/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of users which are currently member of the role with the specified id.
         * @summary Get all users which are member of a given UserRole
         * @param {string} roleId roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersWithRole(roleId: string, options: any = {}): FetchArgs {
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId','Required parameter roleId was null or undefined when calling fetchUsersWithRole.');
            }
            const localVarPath = `/company/roles/{roleId}/users`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single vehicle with the specified vehicleId. The permission VEHICLE_VIEW is required to fetch a vehicle
         * @summary Get a vehicle
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicle(vehicleId: string, options: any = {}): FetchArgs {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling fetchVehicle.');
            }
            const localVarPath = `/company/vehicles/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the distinct, non-blank values of properties.additionalData[key=\"apiGatewaySource\"] across all vehicles visible to the calling user. Used to populate the data-source filter in the fleet view. The permission VEHICLE_VIEW is required to access this endpoint.
         * @summary Get distinct apiGatewaySource values across the company's vehicles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleApiGatewaySources(options: any = {}): FetchArgs {
            const localVarPath = `/company/vehicles/apiGatewaySources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Computes empty-leg kilometres between consecutive non-overlapping transport orders that the given vehicle performed in [sinceTimestamp, toTimestamp]. Reads odometer values from each stop's `additionalData` (preferring FMS keys `vehicle.odometer.on.arrive` / `vehicle.odometer.on.depart`, with a virtual odometer fallback) — does NOT depend on the GPS position stream like the legacy /emptyTour endpoint, so it works for clients whose feeds carry odometer values in stop additionalData rather than tagged GPS samples.  Returns one segment per gap with the computed empty km, route (from-city → to-city), source flag (FMS / VIRTUAL / …), plausibility flag, Sammelladung group label when an overlap is detected, and human-readable hints. Tours with no plate or in non-relevant statuses (anything other than DONE / EXECUTING) are skipped before grouping.  The permission VEHICLE_VIEW is required.
         * @summary Get empty kilometres between consecutive transport orders for a vehicle
         * @param {VehicleEmptyKilometersRequest} VehicleEmptyKilometersRequest VehicleEmptyKilometersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleEmptyKilometers(VehicleEmptyKilometersRequest: VehicleEmptyKilometersRequest, options: any = {}): FetchArgs {
            // verify required parameter 'VehicleEmptyKilometersRequest' is not null or undefined
            if (VehicleEmptyKilometersRequest === null || VehicleEmptyKilometersRequest === undefined) {
                throw new RequiredError('VehicleEmptyKilometersRequest','Required parameter VehicleEmptyKilometersRequest was null or undefined when calling fetchVehicleEmptyKilometers.');
            }
            const localVarPath = `/company/vehicles/emptyKilometers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleEmptyKilometersRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehicleEmptyKilometersRequest || {}) : (VehicleEmptyKilometersRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of vehicles which are assigned to the users company. The permission VEHICLE_VIEW is required to access this endpoint.
         * @summary Get all vehicles
         * @param {string} [apiGatewaySource] apiGatewaySource
         * @param {number} [skip] skip
         * @param {'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleList(apiGatewaySource?: string, skip?: number, sortBy?: 'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/vehicles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (apiGatewaySource !== undefined) {
                localVarQueryParameter['apiGatewaySource'] = apiGatewaySource;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a report containing empty tour report for all company vehicles for the last month
         * @summary returns Empty tour report
         * @param {VehiclesReportRequest} VehiclesReportRequest VehiclesReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmptyTourReport(VehiclesReportRequest: VehiclesReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'VehiclesReportRequest' is not null or undefined
            if (VehiclesReportRequest === null || VehiclesReportRequest === undefined) {
                throw new RequiredError('VehiclesReportRequest','Required parameter VehiclesReportRequest was null or undefined when calling getEmptyTourReport.');
            }
            const localVarPath = `/company/vehicles/emptyTourReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehiclesReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehiclesReportRequest || {}) : (VehiclesReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns List of partners that can link to the users company
         * @summary Get List of partners that can link to the users company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkingPartners(options: any = {}): FetchArgs {
            const localVarPath = `/company/partners/linkingPartners`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all members of the company.
         * @summary Get List of users
         * @param {string} [externalUserId] externalUserId
         * @param {number} [limit] limit
         * @param {string} [q] q
         * @param {number} [skip] skip
         * @param {'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(externalUserId?: string, limit?: number, q?: string, skip?: number, sortBy?: 'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/company/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (externalUserId !== undefined) {
                localVarQueryParameter['externalUserId'] = externalUserId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a customer address mapping
         * @summary Modify single customerAddressMapping with the given id
         * @param {string} id id
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyAddressMapping(id: string, CompanyAddressMapping: CompanyAddressMapping, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyCompanyAddressMapping.');
            }
            // verify required parameter 'CompanyAddressMapping' is not null or undefined
            if (CompanyAddressMapping === null || CompanyAddressMapping === undefined) {
                throw new RequiredError('CompanyAddressMapping','Required parameter CompanyAddressMapping was null or undefined when calling modifyCompanyAddressMapping.');
            }
            const localVarPath = `/company/addressMapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyAddressMapping" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyAddressMapping || {}) : (CompanyAddressMapping || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a customer address mapping group
         * @summary Modify single customerAddressMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyAddressMappingGroup(id: string, CompanyAddressMappingGroup: CompanyAddressMappingGroup, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyCompanyAddressMappingGroup.');
            }
            // verify required parameter 'CompanyAddressMappingGroup' is not null or undefined
            if (CompanyAddressMappingGroup === null || CompanyAddressMappingGroup === undefined) {
                throw new RequiredError('CompanyAddressMappingGroup','Required parameter CompanyAddressMappingGroup was null or undefined when calling modifyCompanyAddressMappingGroup.');
            }
            const localVarPath = `/company/addressMappingGroup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyAddressMappingGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyAddressMappingGroup || {}) : (CompanyAddressMappingGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a customer freight mapping
         * @summary Modify single customerFreightMapping with the given id
         * @param {string} id id
         * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyFreightMapping(id: string, CompanyFreightMapping: CompanyFreightMapping, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyCompanyFreightMapping.');
            }
            // verify required parameter 'CompanyFreightMapping' is not null or undefined
            if (CompanyFreightMapping === null || CompanyFreightMapping === undefined) {
                throw new RequiredError('CompanyFreightMapping','Required parameter CompanyFreightMapping was null or undefined when calling modifyCompanyFreightMapping.');
            }
            const localVarPath = `/company/freightMapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyFreightMapping" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyFreightMapping || {}) : (CompanyFreightMapping || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a customer freight mapping group
         * @summary Modify single customerFreightMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyFreightMappingGroup(id: string, CompanyFreightMappingGroup: CompanyFreightMappingGroup, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyCompanyFreightMappingGroup.');
            }
            // verify required parameter 'CompanyFreightMappingGroup' is not null or undefined
            if (CompanyFreightMappingGroup === null || CompanyFreightMappingGroup === undefined) {
                throw new RequiredError('CompanyFreightMappingGroup','Required parameter CompanyFreightMappingGroup was null or undefined when calling modifyCompanyFreightMappingGroup.');
            }
            const localVarPath = `/company/freightMappingGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyFreightMappingGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyFreightMappingGroup || {}) : (CompanyFreightMappingGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify a company tag
         * @summary Modify company tag
         * @param {string} id id
         * @param {CompanyTag} CompanyTag CompanyTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTag(id: string, CompanyTag: CompanyTag, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyCompanyTag.');
            }
            // verify required parameter 'CompanyTag' is not null or undefined
            if (CompanyTag === null || CompanyTag === undefined) {
                throw new RequiredError('CompanyTag','Required parameter CompanyTag was null or undefined when calling modifyCompanyTag.');
            }
            const localVarPath = `/company/modifyCompanyTag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyTag" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyTag || {}) : (CompanyTag || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a customer TransportOrder Mapping
         * @summary Modify single customerTransportOrderMapping with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTransportOrderMapping(id: string, CompanyTransportOrderMapping: CompanyTransportOrderMapping, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyCompanyTransportOrderMapping.');
            }
            // verify required parameter 'CompanyTransportOrderMapping' is not null or undefined
            if (CompanyTransportOrderMapping === null || CompanyTransportOrderMapping === undefined) {
                throw new RequiredError('CompanyTransportOrderMapping','Required parameter CompanyTransportOrderMapping was null or undefined when calling modifyCompanyTransportOrderMapping.');
            }
            const localVarPath = `/company/transportOrderMapping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyTransportOrderMapping" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyTransportOrderMapping || {}) : (CompanyTransportOrderMapping || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies a customer TransportOrder mapping group
         * @summary Modify single customerTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyCompanyTransportOrderMappingGroup.');
            }
            // verify required parameter 'CompanyTransportOrderMappingGroup' is not null or undefined
            if (CompanyTransportOrderMappingGroup === null || CompanyTransportOrderMappingGroup === undefined) {
                throw new RequiredError('CompanyTransportOrderMappingGroup','Required parameter CompanyTransportOrderMappingGroup was null or undefined when calling modifyCompanyTransportOrderMappingGroup.');
            }
            const localVarPath = `/company/transportOrderMappingGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyTransportOrderMappingGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyTransportOrderMappingGroup || {}) : (CompanyTransportOrderMappingGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies the driver with the specified driverId. This method checks that there is no other driver with the given externalDriverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to call this endpoint.
         * @summary Modify driver by id
         * @param {string} driverId driverId
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyDriverById(driverId: string, DriverRequest: DriverRequest, options: any = {}): FetchArgs {
            // verify required parameter 'driverId' is not null or undefined
            if (driverId === null || driverId === undefined) {
                throw new RequiredError('driverId','Required parameter driverId was null or undefined when calling modifyDriverById.');
            }
            // verify required parameter 'DriverRequest' is not null or undefined
            if (DriverRequest === null || DriverRequest === undefined) {
                throw new RequiredError('DriverRequest','Required parameter DriverRequest was null or undefined when calling modifyDriverById.');
            }
            const localVarPath = `/company/drivers/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DriverRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DriverRequest || {}) : (DriverRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies the user role of the given role id. The USER_ROLES_CREATE_MODIFY_DELETE permission is required to execute this operation.
         * @summary Modify user role by id
         * @param {string} id id
         * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoleById(id: string, UserRoleRequest: UserRoleRequest, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyUserRoleById.');
            }
            // verify required parameter 'UserRoleRequest' is not null or undefined
            if (UserRoleRequest === null || UserRoleRequest === undefined) {
                throw new RequiredError('UserRoleRequest','Required parameter UserRoleRequest was null or undefined when calling modifyUserRoleById.');
            }
            const localVarPath = `/company/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserRoleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UserRoleRequest || {}) : (UserRoleRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies the vehicles with the specified vehicleId. This method checks that there is no other vehicles with the given numberPlate or externalVehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to call this endpoint.
         * @summary Modify vehicles by id
         * @param {string} vehicleId vehicleId
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyVehicleById(vehicleId: string, VehicleRequest: VehicleRequest, options: any = {}): FetchArgs {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling modifyVehicleById.');
            }
            // verify required parameter 'VehicleRequest' is not null or undefined
            if (VehicleRequest === null || VehicleRequest === undefined) {
                throw new RequiredError('VehicleRequest','Required parameter VehicleRequest was null or undefined when calling modifyVehicleById.');
            }
            const localVarPath = `/company/vehicles/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehicleRequest || {}) : (VehicleRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all companies. The superuser permission is required to execute this operation.
         * @summary List all companies
         * @param {string} term term
         * @param {boolean} [includeArchived] includeArchived
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryCompanies(term: string, includeArchived?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'term' is not null or undefined
            if (term === null || term === undefined) {
                throw new RequiredError('term','Required parameter term was null or undefined when calling queryCompanies.');
            }
            const localVarPath = `/company`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a new company with the given registration data. This endpoint sends an email to the user who sent the registration.
         * @summary register new company
         * @param {Registration} Registration Registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCompany(Registration: Registration, options: any = {}): FetchArgs {
            // verify required parameter 'Registration' is not null or undefined
            if (Registration === null || Registration === undefined) {
                throw new RequiredError('Registration','Required parameter Registration was null or undefined when calling registerCompany.');
            }
            const localVarPath = `/company/register`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Registration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Registration || {}) : (Registration || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the driver with the given driverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Delete driver by id
         * @param {string} driverId driverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDriver(driverId: string, options: any = {}): FetchArgs {
            // verify required parameter 'driverId' is not null or undefined
            if (driverId === null || driverId === undefined) {
                throw new RequiredError('driverId','Required parameter driverId was null or undefined when calling removeDriver.');
            }
            const localVarPath = `/company/drivers/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the user from the specified role
         * @summary Delete role membership of user
         * @param {string} roleId roleId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleFromUser(roleId: string, userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId','Required parameter roleId was null or undefined when calling removeRoleFromUser.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling removeRoleFromUser.');
            }
            const localVarPath = `/company/roles/{roleId}/users/{userId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the vehicles with the given vehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Delete vehicles by id
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVehicle(vehicleId: string, options: any = {}): FetchArgs {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling removeVehicle.');
            }
            const localVarPath = `/company/vehicles/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint takes a company address mapping group (parameter groupId) and a list of company address mappings.  Then, it deletes all company address mappings which are currently present in the specified group of address mappings  and it inserts the given list of address mappings into the given group of company address mappings. 
         * @summary Replace all customerAddressMappings of the given group with the given list of company address mappings
         * @param {ReplaceCompanyAddressMappingRequest} ReplaceCompanyAddressMappingRequest ReplaceCompanyAddressMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyAddressMappingList(ReplaceCompanyAddressMappingRequest: ReplaceCompanyAddressMappingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ReplaceCompanyAddressMappingRequest' is not null or undefined
            if (ReplaceCompanyAddressMappingRequest === null || ReplaceCompanyAddressMappingRequest === undefined) {
                throw new RequiredError('ReplaceCompanyAddressMappingRequest','Required parameter ReplaceCompanyAddressMappingRequest was null or undefined when calling replaceCompanyAddressMappingList.');
            }
            const localVarPath = `/company/addressMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReplaceCompanyAddressMappingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ReplaceCompanyAddressMappingRequest || {}) : (ReplaceCompanyAddressMappingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint takes a company Freight mapping group (parameter groupId) and a list of company freight mappings.  Then, it deletes all company Freight mappings which are currently present in the specified group of freight mappings  and it inserts the given list of freight mappings into the given group of company freight mappings. 
         * @summary Replace all customerFreightMappings of the given group with the given list of company Freight mappings
         * @param {ReplaceCompanyFreightMappingRequest} ReplaceCompanyFreightMappingRequest ReplaceCompanyFreightMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyFreightMappingList(ReplaceCompanyFreightMappingRequest: ReplaceCompanyFreightMappingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ReplaceCompanyFreightMappingRequest' is not null or undefined
            if (ReplaceCompanyFreightMappingRequest === null || ReplaceCompanyFreightMappingRequest === undefined) {
                throw new RequiredError('ReplaceCompanyFreightMappingRequest','Required parameter ReplaceCompanyFreightMappingRequest was null or undefined when calling replaceCompanyFreightMappingList.');
            }
            const localVarPath = `/company/freightMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReplaceCompanyFreightMappingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ReplaceCompanyFreightMappingRequest || {}) : (ReplaceCompanyFreightMappingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint takes a company transportOrder mapping group (parameter groupId) and a list of company transportOrder mappings.  Then, it deletes all company transportOrder mappings which are currently present in the specified group of transportOrder mappings  and it inserts the given list of transportOrder mappings into the given group of company transportOrder mappings. 
         * @summary Replace all customerTransportOrderMappings of the given group with the given list of company transportOrder mappings
         * @param {ReplaceCompanyTransportOrderMappingRequest} ReplaceCompanyTransportOrderMappingRequest ReplaceCompanyTransportOrderMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyTransportOrderMappingList(ReplaceCompanyTransportOrderMappingRequest: ReplaceCompanyTransportOrderMappingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ReplaceCompanyTransportOrderMappingRequest' is not null or undefined
            if (ReplaceCompanyTransportOrderMappingRequest === null || ReplaceCompanyTransportOrderMappingRequest === undefined) {
                throw new RequiredError('ReplaceCompanyTransportOrderMappingRequest','Required parameter ReplaceCompanyTransportOrderMappingRequest was null or undefined when calling replaceCompanyTransportOrderMappingList.');
            }
            const localVarPath = `/company/transportOrderMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReplaceCompanyTransportOrderMappingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ReplaceCompanyTransportOrderMappingRequest || {}) : (ReplaceCompanyTransportOrderMappingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches all rules that are used for validation of transportOrders from the sourceCompany of the given transportOrder.
         * @summary runs all status validation rules for this TransportOrder and gives back results
         * @param {RunTransportOrderStatusValidationsRequest} RunTransportOrderStatusValidationsRequest RunTransportOrderStatusValidationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTransportOrderStatusValidations(RunTransportOrderStatusValidationsRequest: RunTransportOrderStatusValidationsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'RunTransportOrderStatusValidationsRequest' is not null or undefined
            if (RunTransportOrderStatusValidationsRequest === null || RunTransportOrderStatusValidationsRequest === undefined) {
                throw new RequiredError('RunTransportOrderStatusValidationsRequest','Required parameter RunTransportOrderStatusValidationsRequest was null or undefined when calling runTransportOrderStatusValidations.');
            }
            const localVarPath = `/runTransportOrderStatusValidations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RunTransportOrderStatusValidationsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(RunTransportOrderStatusValidationsRequest || {}) : (RunTransportOrderStatusValidationsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings
         * @summary sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings 
         * @param {SendTransportOrderStatusValidationsMailsNowRequest} SendTransportOrderStatusValidationsMailsNowRequest SendTransportOrderStatusValidationsMailsNowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTransportOrderStatusValidationsMailsNow(SendTransportOrderStatusValidationsMailsNowRequest: SendTransportOrderStatusValidationsMailsNowRequest, options: any = {}): FetchArgs {
            // verify required parameter 'SendTransportOrderStatusValidationsMailsNowRequest' is not null or undefined
            if (SendTransportOrderStatusValidationsMailsNowRequest === null || SendTransportOrderStatusValidationsMailsNowRequest === undefined) {
                throw new RequiredError('SendTransportOrderStatusValidationsMailsNowRequest','Required parameter SendTransportOrderStatusValidationsMailsNowRequest was null or undefined when calling sendTransportOrderStatusValidationsMailsNow.');
            }
            const localVarPath = `/sendTransportOrderStatusValidationsMailsNow`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SendTransportOrderStatusValidationsMailsNowRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SendTransportOrderStatusValidationsMailsNowRequest || {}) : (SendTransportOrderStatusValidationsMailsNowRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assigns the role linked to the given roleId to the User of the given userId
         * @summary Set the roles of the user
         * @param {string} userId userId
         * @param {RolesOfUserRequest} RolesOfUserRequest RolesOfUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRolesOfUser(userId: string, RolesOfUserRequest: RolesOfUserRequest, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling setRolesOfUser.');
            }
            // verify required parameter 'RolesOfUserRequest' is not null or undefined
            if (RolesOfUserRequest === null || RolesOfUserRequest === undefined) {
                throw new RequiredError('RolesOfUserRequest','Required parameter RolesOfUserRequest was null or undefined when calling setRolesOfUser.');
            }
            const localVarPath = `/company/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RolesOfUserRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(RolesOfUserRequest || {}) : (RolesOfUserRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updated the acknowledged flag on warnings in transportOrders
         * @summary updates acknowledged flag on a 
         * @param {UpdateAcknowledgedOnStatusValidationRequest} UpdateAcknowledgedOnStatusValidationRequest UpdateAcknowledgedOnStatusValidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAcknowledgeOnStatusValidation(UpdateAcknowledgedOnStatusValidationRequest: UpdateAcknowledgedOnStatusValidationRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UpdateAcknowledgedOnStatusValidationRequest' is not null or undefined
            if (UpdateAcknowledgedOnStatusValidationRequest === null || UpdateAcknowledgedOnStatusValidationRequest === undefined) {
                throw new RequiredError('UpdateAcknowledgedOnStatusValidationRequest','Required parameter UpdateAcknowledgedOnStatusValidationRequest was null or undefined when calling updateAcknowledgeOnStatusValidation.');
            }
            const localVarPath = `/updateAcknowledgeOnStatusValidation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateAcknowledgedOnStatusValidationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateAcknowledgedOnStatusValidationRequest || {}) : (UpdateAcknowledgedOnStatusValidationRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the company of the given companyId using the posted data. This method can be called, if the currently authenticated user has the permission to modify the specified company. this endpoint will return the updated Company object.
         * @summary update company
         * @param {string} id id
         * @param {Company} Company Company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(id: string, Company: Company, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCompany.');
            }
            // verify required parameter 'Company' is not null or undefined
            if (Company === null || Company === undefined) {
                throw new RequiredError('Company','Required parameter Company was null or undefined when calling updateCompany.');
            }
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Company" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Company || {}) : (Company || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update company's ignore list of customer report.
         * @summary Update company's ignore list of customer report.
         * @param {UpdateIgnoreListForCustomerReportForAllCompaniesRequest} UpdateIgnoreListForCustomerReportForAllCompaniesRequest UpdateIgnoreListForCustomerReportForAllCompaniesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIgnoreListForCustomerReportForAllCompanies(UpdateIgnoreListForCustomerReportForAllCompaniesRequest: UpdateIgnoreListForCustomerReportForAllCompaniesRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UpdateIgnoreListForCustomerReportForAllCompaniesRequest' is not null or undefined
            if (UpdateIgnoreListForCustomerReportForAllCompaniesRequest === null || UpdateIgnoreListForCustomerReportForAllCompaniesRequest === undefined) {
                throw new RequiredError('UpdateIgnoreListForCustomerReportForAllCompaniesRequest','Required parameter UpdateIgnoreListForCustomerReportForAllCompaniesRequest was null or undefined when calling updateIgnoreListForCustomerReportForAllCompanies.');
            }
            const localVarPath = `/company/updateIgnoreListForCustomerReportForAllCompanies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateIgnoreListForCustomerReportForAllCompaniesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateIgnoreListForCustomerReportForAllCompaniesRequest || {}) : (UpdateIgnoreListForCustomerReportForAllCompaniesRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes the status of a pending invitation. The status of the invitation can either be changed by the inviting party or by the invited party. However, the user calling this method requires the COMPANY_MODIFY_PARTNERS permission to execute this operation.
         * @summary accept or reject invitation
         * @param {string} randomInvitationId randomInvitationId
         * @param {PartnerInvitationStatusUpdate} PartnerInvitationStatusUpdate PartnerInvitationStatusUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvitationStatus(randomInvitationId: string, PartnerInvitationStatusUpdate: PartnerInvitationStatusUpdate, options: any = {}): FetchArgs {
            // verify required parameter 'randomInvitationId' is not null or undefined
            if (randomInvitationId === null || randomInvitationId === undefined) {
                throw new RequiredError('randomInvitationId','Required parameter randomInvitationId was null or undefined when calling updateInvitationStatus.');
            }
            // verify required parameter 'PartnerInvitationStatusUpdate' is not null or undefined
            if (PartnerInvitationStatusUpdate === null || PartnerInvitationStatusUpdate === undefined) {
                throw new RequiredError('PartnerInvitationStatusUpdate','Required parameter PartnerInvitationStatusUpdate was null or undefined when calling updateInvitationStatus.');
            }
            const localVarPath = `/invitations/{randomInvitationId}`
                .replace(`{${"randomInvitationId"}}`, encodeURIComponent(String(randomInvitationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PartnerInvitationStatusUpdate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(PartnerInvitationStatusUpdate || {}) : (PartnerInvitationStatusUpdate || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the external partner id of a partner company using the posted data. This method can be called, if the currently authenticated user has the permission to modify partners.
         * @summary update external partner id
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {Partner} Partner Partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerById(partnerCompanyId: string, Partner: Partner, options: any = {}): FetchArgs {
            // verify required parameter 'partnerCompanyId' is not null or undefined
            if (partnerCompanyId === null || partnerCompanyId === undefined) {
                throw new RequiredError('partnerCompanyId','Required parameter partnerCompanyId was null or undefined when calling updatePartnerById.');
            }
            // verify required parameter 'Partner' is not null or undefined
            if (Partner === null || Partner === undefined) {
                throw new RequiredError('Partner','Required parameter Partner was null or undefined when calling updatePartnerById.');
            }
            const localVarPath = `/company/partners/{partnerCompanyId}`
                .replace(`{${"partnerCompanyId"}}`, encodeURIComponent(String(partnerCompanyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Partner" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Partner || {}) : (Partner || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the specified user by the given user id. This operation allows partial updates. If properties are left blank, the old values are preserved. The permission USERS_MODIFY is required to execute this operation and only users of the same company as the caller can be modified.
         * @summary Modify user by id
         * @param {string} id id
         * @param {UserRequest} UserRequest UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById(id: string, UserRequest: UserRequest, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateUserById.');
            }
            // verify required parameter 'UserRequest' is not null or undefined
            if (UserRequest === null || UserRequest === undefined) {
                throw new RequiredError('UserRequest','Required parameter UserRequest was null or undefined when calling updateUserById.');
            }
            const localVarPath = `/company/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UserRequest || {}) : (UserRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check whether the given external driver ID is not yet taken by an already existing driver in this company.
         * @summary Validate driver external Id
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDriverExternalId(DriverRequest: DriverRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DriverRequest' is not null or undefined
            if (DriverRequest === null || DriverRequest === undefined) {
                throw new RequiredError('DriverRequest','Required parameter DriverRequest was null or undefined when calling validateDriverExternalId.');
            }
            const localVarPath = `/company/driver/validateExternalId`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DriverRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DriverRequest || {}) : (DriverRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate user data
         * @param {EmailRequest} EmailRequest EmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUser(EmailRequest: EmailRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EmailRequest' is not null or undefined
            if (EmailRequest === null || EmailRequest === undefined) {
                throw new RequiredError('EmailRequest','Required parameter EmailRequest was null or undefined when calling validateUser.');
            }
            const localVarPath = `/company/users/validate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EmailRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EmailRequest || {}) : (EmailRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check whether the given external vehicles ID is not yet taken by an already existing vehicles in this company.
         * @summary Validate vehicles external Id
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVehicleExternalId(VehicleRequest: VehicleRequest, options: any = {}): FetchArgs {
            // verify required parameter 'VehicleRequest' is not null or undefined
            if (VehicleRequest === null || VehicleRequest === undefined) {
                throw new RequiredError('VehicleRequest','Required parameter VehicleRequest was null or undefined when calling validateVehicleExternalId.');
            }
            const localVarPath = `/company/vehicles/validateExternalId`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehicleRequest || {}) : (VehicleRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check whether the given number plate is not yet taken by an already existing vehicles in this company.
         * @summary Validate vehicles numberPlate
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVehicleNumberPlate(VehicleRequest: VehicleRequest, options: any = {}): FetchArgs {
            // verify required parameter 'VehicleRequest' is not null or undefined
            if (VehicleRequest === null || VehicleRequest === undefined) {
                throw new RequiredError('VehicleRequest','Required parameter VehicleRequest was null or undefined when calling validateVehicleNumberPlate.');
            }
            const localVarPath = `/company/vehicles/validateNumberPlate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehicleRequest || {}) : (VehicleRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * update company's customer report setting to acknowledged based on the enable flag.
         * @summary update company's customer report setting to acknowledged.
         * @param {AddAcknowledgementForCompaniesCustomerReportRequest} AddAcknowledgementForCompaniesCustomerReportRequest AddAcknowledgementForCompaniesCustomerReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeCompaniesFromCustomerReport(AddAcknowledgementForCompaniesCustomerReportRequest: AddAcknowledgementForCompaniesCustomerReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AcknowledgeCompaniesFromCustomerReportResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).acknowledgeCompaniesFromCustomerReport(AddAcknowledgementForCompaniesCustomerReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a new customer address mapping
         * @summary Add new customerAddressMapping
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyAddressMapping(CompanyAddressMapping: CompanyAddressMapping, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAddressMapping> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addCompanyAddressMapping(CompanyAddressMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a new customer address mapping group
         * @summary Add new customerAddressMappingGroup
         * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyAddressMappingGroup(CompanyAddressMappingGroup: CompanyAddressMappingGroup, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAddressMappingGroup> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addCompanyAddressMappingGroup(CompanyAddressMappingGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a new customer freight mapping
         * @summary Add new customerFreightMapping
         * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyFreightMapping(CompanyFreightMapping: CompanyFreightMapping, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyFreightMapping> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addCompanyFreightMapping(CompanyFreightMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a new customer freight mapping group
         * @summary Add new customerFreightMappingGroup
         * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyFreightMappingGroup(CompanyFreightMappingGroup: CompanyFreightMappingGroup, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyFreightMappingGroup> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addCompanyFreightMappingGroup(CompanyFreightMappingGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add a new company tag
         * @summary Add new company tag
         * @param {CompanyTag} CompanyTag CompanyTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTag(CompanyTag: CompanyTag, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTagsFetchResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addCompanyTag(CompanyTag, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a new customer TransportOrder Mapping
         * @summary Add new customerTransportOrderMapping
         * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTransportOrderMapping(CompanyTransportOrderMapping: CompanyTransportOrderMapping, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTransportOrderMapping> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addCompanyTransportOrderMapping(CompanyTransportOrderMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a new customer TransportOrder mapping group
         * @summary Add new customerCompanyTransportOrderMappingGroup
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTransportOrderMappingGroup(CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTransportOrderMappingGroup> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addCompanyTransportOrderMappingGroup(CompanyTransportOrderMappingGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch the add filter request and save it in database as per user id and company specific
         * @summary Add new filter for a user as per his company signed in
         * @param {AddFiltersRequest} AddFiltersRequest AddFiltersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFilters(AddFiltersRequest: AddFiltersRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserFilterList> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addFilters(AddFiltersRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * update company's customer report setting to ignore or unIgnore based on the enable flag.
         * @summary update company's customer report setting to ignore or unignore.
         * @param {AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest} AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemoveCompaniesFromIgnoreListForCustomerReport(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest: AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddOrRemoveCompaniesFromIgnoreListForCustomerReportResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addOrRemoveCompaniesFromIgnoreListForCustomerReport(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a user with the given userId to the role with the given userRoleId. The Permission USER_ROLES_ASSIGN is required to execute this operation.
         * @summary Add user role membership for the given role and the given user
         * @param {string} roleId roleId
         * @param {UserRoleAddRequest} UserRoleAddRequest UserRoleAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleToUser(roleId: string, UserRoleAddRequest: UserRoleAddRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserRole> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).addRoleToUser(roleId, UserRoleAddRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Archives Company
         * @summary archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompany(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).archiveCompany(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Authenticate spedion user as per php session id
         * @summary Authenticate spedion user as per php session id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateSpedionUser(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthToken> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).authenticateSpedionUser(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes multiple company address mappings
         * @summary Delete companyAddressMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyAddressMappings(ids: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).bulkDeleteCompanyAddressMappings(ids, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes multiple company freight mappings
         * @summary Delete companyFreightMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyFreightMappings(ids: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).bulkDeleteCompanyFreightMappings(ids, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes multiple company TransportOrder mappings
         * @summary Delete CompanyTransportOrderMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyTransportOrderMappings(ids: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).bulkDeleteCompanyTransportOrderMappings(ids, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check and update disable until status for customer reports based on the new report values.
         * @summary Check and update disable until status based on current customer reports.
         * @param {CheckAndUpdateDisableUntilStatusRequest} CheckAndUpdateDisableUntilStatusRequest CheckAndUpdateDisableUntilStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndUpdateDisableUntilStatus(CheckAndUpdateDisableUntilStatusRequest: CheckAndUpdateDisableUntilStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).checkAndUpdateDisableUntilStatus(CheckAndUpdateDisableUntilStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Clones an existing company TransportOrder mapping group, creating a new group with the same settings. Optionally override fields via the request body (e.g. validFrom, validTill, groupName).
         * @summary Clone a companyTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTransportOrderMappingGroup> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).cloneCompanyTransportOrderMappingGroup(id, CompanyTransportOrderMappingGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a new driver for the current company of the user. If a driver with the specified pin already exists, a BadRequest is returned to the calling user. The DRIVER_CREATE_MODIFY_DELETE permission is required to call this endpoint
         * @summary Create new driver
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriver(DriverRequest: DriverRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Driver> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).createDriver(DriverRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create an new invitation and send an invitation email to the invited party. If the invited party accepts the invitation, both companies become partner and can exchange transports.
         * @summary send invitation
         * @param {PartnerInvitation} PartnerInvitation PartnerInvitation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(PartnerInvitation: PartnerInvitation, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PartnerInvitation> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).createInvitation(PartnerInvitation, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a new user for the specified company. The permission USERS_CREATE is required to create a new user account. The newly created user is member of the same company as the currently authenticated user.
         * @summary create user
         * @param {UserCreateRequest} UserCreateRequest UserCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(UserCreateRequest: UserCreateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).createUser(UserCreateRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a new user role. The permission USER_ROLES_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Create new user role
         * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserRole(UserRoleRequest: UserRoleRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserRole> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).createUserRole(UserRoleRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a new vehicles for the current company of the user. If a vehicles with the specified numberPlate or externalVehicleId already exists, a BadRequest is returned to the calling user. The VEHICLE_CREATE_MODIFY_DELETE permission is required to call this endpoint
         * @summary Create new vehicles
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle(VehicleRequest: VehicleRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Vehicle> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).createVehicle(VehicleRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a customer address mapping
         * @summary Delete customerAddressMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyAddressMapping(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteCompanyAddressMapping(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a customer address mapping group
         * @summary Delete customerAddressMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyAddressMappingGroup(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteCompanyAddressMappingGroup(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a company freight mapping
         * @summary Delete companyFreightMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyFreightMapping(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteCompanyFreightMapping(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a company freight mapping group
         * @summary Delete companyFreightMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyFreightMappingGroup(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteCompanyFreightMappingGroup(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a company tag
         * @summary Delete companyTag with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTag(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTagsFetchResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteCompanyTag(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a company transportOrder mapping
         * @summary Delete companyTransportOrderMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTransportOrderMapping(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteCompanyTransportOrderMapping(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a company TransportOrder mapping group
         * @summary Delete companyTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTransportOrderMappingGroup(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteCompanyTransportOrderMappingGroup(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete the filter with the given filterId and userId. The permission COMPANY_MODIFY is required to execute this operation.
         * @summary Delete filter by id
         * @param {string} [filterId] filterId
         * @param {string} [userId] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilter(filterId?: string, userId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserFilterList> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteFilter(filterId, userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes a partner and cancels the partnership between two companies.
         * @summary delete
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartner(partnerCompanyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deletePartner(partnerCompanyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Use this endpoint to remove a user from the companies users list. The permission USER_DELETE is required to execute this operation
         * @summary Delete user by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteUserById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes the user role with the specified role id.
         * @summary Delete user role by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRoleById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).deleteUserRoleById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify the filter name depending upon the filter id and return the updated filter list
         * @summary Modify filter name as per the id
         * @param {ModifyFilterName} ModifyFilterName ModifyFilterName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFilterName(ModifyFilterName: ModifyFilterName, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserFilterList> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).editFilterName(ModifyFilterName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all users of all partners for the current company. In order to call this operation the permission USERS_VIEW is required
         * @summary Get List of users for all partner companies
         * @param {string} query query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPartnersUsers(query: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AllPartnersUsersResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchAllPartnersUsers(query, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns list of all partner companies with list of validationRules    
         * @summary Get List of all partner companies with list of validationRules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPartnersValidationRuleNames(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AllPartnersValidationRuleNamesResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchAllPartnersValidationRuleNames(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch address book and drivers of the user's company.
         * @summary fetch company's address book and drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressBookAndDrivers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAddressBookRequestResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyAddressBookAndDrivers(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all company address mapping groups of this company
         * @summary Get a list of all customer address mapping groups
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingGroups(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerAddressMappingGroupResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyAddressMappingGroups(skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all user defined address mappings defined for this company.
         * @summary Get a list of all customer address mappings
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerAddressMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyAddressMappingList(onlyGroupIds, skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all user defined address mappings defined for this company without authentication.
         * @summary Get a list of all customer address mappings
         * @param {string} token token
         * @param {string} [pin] pin
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingListPublic(token: string, pin?: string, onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerAddressMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyAddressMappingListPublic(token, pin, onlyGroupIds, skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the company with the specified companyId, if the currently authenticated user has the permission to view that company.
         * @summary get company by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all user definied freight mapping groups defined for this company.
         * @summary Get a list of all freight mapping groups
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyFreightMappingGroupList(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerFreightMappingGroupsResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyFreightMappingGroupList(skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all user defined freight mappings for this company.
         * @summary Get a list of all freight mapping
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyFreightMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerFreightMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyFreightMappingList(onlyGroupIds, skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the company of the currently authenticated user.
         * @summary get current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyOfUser(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyOfUser(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch Company tags as per company id
         * @summary Fetch Company tags as per company id
         * @param {FetchCompanyTagsRequest} FetchCompanyTagsRequest FetchCompanyTagsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTags(FetchCompanyTagsRequest: FetchCompanyTagsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTagsFetchResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyTags(FetchCompanyTagsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all user definied transportOrder mapping groups defined for this company.
         * @summary Get a list of all transportOrder mapping groups
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingGroupList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerTransportOrderMappingGroupsResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyTransportOrderMappingGroupList(skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all user defined transportOrder mappings for this company.
         * @summary Get a list of all transportOrder mapping
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerTransportOrderMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyTransportOrderMappingList(skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all user defined transportOrder mappings based the specific group id for this company.
         * @summary Get a list of all transportOrder mapping by group id
         * @param {string} groupId groupId
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingListByGroupId(groupId: string, skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerTransportOrderMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchCompanyTransportOrderMappingListByGroupId(groupId, skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a single driver with the specified driverId. The permission DRIVER_VIEW is required to fetch a driver
         * @summary Get a driver
         * @param {string} driverId driverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDriver(driverId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Driver> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchDriver(driverId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of drivers which are assigned to the users company. The permission DRIVER_VIEW is required to access this endpoint.
         * @summary Get all drivers
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDriverList(limit?: number, query?: string, skip?: number, sortBy?: 'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DriverListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchDriverList(limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns one row per relevant transport order (DONE or EXECUTING) for every vehicle in the company within [sinceTimestamp, toTimestamp], enriched with the empty-kilometre gap to the previous tour, plausibility flags, hints, consolidated-shipment group label, FMS odometer values, customer (FRM key from freight additionalData) and stop coordinates.  Replaces the per-company `reportScript` based XLSX flow for the on-demand empty-kilometre dashboard. Optionally filterable by a list of vehicle number plates.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
         * @summary Get the empty-kilometres report for all vehicles in the given window
         * @param {EmptyKilometersReportRequest} EmptyKilometersReportRequest EmptyKilometersReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyKilometersReport(EmptyKilometersReportRequest: EmptyKilometersReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyKilometersReportResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchEmptyKilometersReport(EmptyKilometersReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Detail view behind one row of the empty-kilometre report: the GPS track between [sinceTimestamp, toTimestamp] split into driving and standing clusters (same segmentation the tour map uses), each standing cluster reverse geocoded to a city, and the DTCO activities of every driver that was on the truck in that window.  Standing clusters that sit at the last stop of the previous tour or at the first stop of the following one are flagged, so the caller can label them. When no DTCO logbook exists, `gpsDrivingSeconds` / `gpsStandingSeconds` carry the GPS approximation of driving versus everything else.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
         * @summary Get what the truck did during one empty run
         * @param {EmptyKilometersRunDetailsRequest} EmptyKilometersRunDetailsRequest EmptyKilometersRunDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyKilometersRunDetails(EmptyKilometersRunDetailsRequest: EmptyKilometersRunDetailsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyKilometersRunDetailsResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchEmptyKilometersRunDetails(EmptyKilometersRunDetailsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * return empty tours for a vehicle
         * @summary get EmptyTours for a vehicle
         * @param {VehicleEmptyTourRequest} VehicleEmptyTourRequest VehicleEmptyTourRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyTours(VehicleEmptyTourRequest: VehicleEmptyTourRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleEmptyTourResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchEmptyTours(VehicleEmptyTourRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch the filters as per user id and company specific
         * @summary Fetch filters as per user id and company id
         * @param {string} [companyId] companyId
         * @param {string} [userId] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFilters(companyId?: string, userId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserFilterList> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchFilters(companyId, userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all incoming partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
         * @summary invitation list
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIncomingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InvitationListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchIncomingInvitationList(limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the partnership invitation identified by the randomInvitation token. Everyone can access this invitation if he knows the randomInvitationToken. No further authentication is needed.
         * @summary get invitation by random token
         * @param {string} randomInvitationId randomInvitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitationByToken(randomInvitationId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InvitationRespone> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchInvitationByToken(randomInvitationId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all outgoing partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
         * @summary invitation list
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOutgoingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InvitationListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchOutgoingInvitationList(limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all partner companies including the externalId given for them. The permission COMPANY_VIEW_PARTNERS is required to to execute this operation
         * @summary get all partners
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PartnerListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchPartnerList(limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of users for the specified partner company.
         * @summary Get List of users for a partner company
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerUsers(partnerCompanyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PartnerUsersResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchPartnerUsers(partnerCompanyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the roles of the user of the given user id (for the availableCompany of the calling user). The permission USER_ROLES_VIEW is required to call this operation.
         * @summary Fetch roles of the user with id
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRolesForUser(userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserRoleResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchRolesForUser(userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get the user with the specified external user id.
         * @summary Find User by external user id
         * @param {string} externalId externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserByExternalUserId(externalId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchUserByExternalUserId(externalId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get the user with the specified user id.
         * @summary Find User by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchUserById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the user role of the specified userRoleId. The permission USER_ROLES_VIEW is required to execute this operation
         * @summary Get user role by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRoleById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserRole> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchUserRoleById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all user roles of the current company. The permission USER_ROLES_VIEW is required to execute this operation.
         * @summary Get all user roles
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'NAME' | 'PERMISSION'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRoleList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'PERMISSION', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserRoleResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchUserRoleList(limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the user roles of the specified userRoleIds. The permission USER_ROLES_VIEW is required to execute this operation
         * @summary Get user role by id
         * @param {Array<string>} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRolesByIds(ids: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyUserRolesByIdsResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchUserRolesByIds(ids, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of users which are currently member of the role with the specified id.
         * @summary Get all users which are member of a given UserRole
         * @param {string} roleId roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersWithRole(roleId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchUsersWithRole(roleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a single vehicle with the specified vehicleId. The permission VEHICLE_VIEW is required to fetch a vehicle
         * @summary Get a vehicle
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicle(vehicleId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Vehicle> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchVehicle(vehicleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the distinct, non-blank values of properties.additionalData[key=\"apiGatewaySource\"] across all vehicles visible to the calling user. Used to populate the data-source filter in the fleet view. The permission VEHICLE_VIEW is required to access this endpoint.
         * @summary Get distinct apiGatewaySource values across the company's vehicles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleApiGatewaySources(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleApiGatewaySourcesResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchVehicleApiGatewaySources(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Computes empty-leg kilometres between consecutive non-overlapping transport orders that the given vehicle performed in [sinceTimestamp, toTimestamp]. Reads odometer values from each stop's `additionalData` (preferring FMS keys `vehicle.odometer.on.arrive` / `vehicle.odometer.on.depart`, with a virtual odometer fallback) — does NOT depend on the GPS position stream like the legacy /emptyTour endpoint, so it works for clients whose feeds carry odometer values in stop additionalData rather than tagged GPS samples.  Returns one segment per gap with the computed empty km, route (from-city → to-city), source flag (FMS / VIRTUAL / …), plausibility flag, Sammelladung group label when an overlap is detected, and human-readable hints. Tours with no plate or in non-relevant statuses (anything other than DONE / EXECUTING) are skipped before grouping.  The permission VEHICLE_VIEW is required.
         * @summary Get empty kilometres between consecutive transport orders for a vehicle
         * @param {VehicleEmptyKilometersRequest} VehicleEmptyKilometersRequest VehicleEmptyKilometersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleEmptyKilometers(VehicleEmptyKilometersRequest: VehicleEmptyKilometersRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleEmptyKilometersResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchVehicleEmptyKilometers(VehicleEmptyKilometersRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of vehicles which are assigned to the users company. The permission VEHICLE_VIEW is required to access this endpoint.
         * @summary Get all vehicles
         * @param {string} [apiGatewaySource] apiGatewaySource
         * @param {number} [skip] skip
         * @param {'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleList(apiGatewaySource?: string, skip?: number, sortBy?: 'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).fetchVehicleList(apiGatewaySource, skip, sortBy, sortDirection, take, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a report containing empty tour report for all company vehicles for the last month
         * @summary returns Empty tour report
         * @param {VehiclesReportRequest} VehiclesReportRequest VehiclesReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmptyTourReport(VehiclesReportRequest: VehiclesReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehiclesReportResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).getEmptyTourReport(VehiclesReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns List of partners that can link to the users company
         * @summary Get List of partners that can link to the users company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkingPartners(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LinkingPartnersResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).linkingPartners(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all members of the company.
         * @summary Get List of users
         * @param {string} [externalUserId] externalUserId
         * @param {number} [limit] limit
         * @param {string} [q] q
         * @param {number} [skip] skip
         * @param {'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(externalUserId?: string, limit?: number, q?: string, skip?: number, sortBy?: 'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).listUsers(externalUserId, limit, q, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies a customer address mapping
         * @summary Modify single customerAddressMapping with the given id
         * @param {string} id id
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyAddressMapping(id: string, CompanyAddressMapping: CompanyAddressMapping, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAddressMapping> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyCompanyAddressMapping(id, CompanyAddressMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies a customer address mapping group
         * @summary Modify single customerAddressMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyAddressMappingGroup(id: string, CompanyAddressMappingGroup: CompanyAddressMappingGroup, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAddressMappingGroup> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyCompanyAddressMappingGroup(id, CompanyAddressMappingGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies a customer freight mapping
         * @summary Modify single customerFreightMapping with the given id
         * @param {string} id id
         * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyFreightMapping(id: string, CompanyFreightMapping: CompanyFreightMapping, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyFreightMapping> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyCompanyFreightMapping(id, CompanyFreightMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies a customer freight mapping group
         * @summary Modify single customerFreightMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyFreightMappingGroup(id: string, CompanyFreightMappingGroup: CompanyFreightMappingGroup, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyFreightMappingGroup> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyCompanyFreightMappingGroup(id, CompanyFreightMappingGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify a company tag
         * @summary Modify company tag
         * @param {string} id id
         * @param {CompanyTag} CompanyTag CompanyTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTag(id: string, CompanyTag: CompanyTag, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTagsFetchResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyCompanyTag(id, CompanyTag, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies a customer TransportOrder Mapping
         * @summary Modify single customerTransportOrderMapping with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTransportOrderMapping(id: string, CompanyTransportOrderMapping: CompanyTransportOrderMapping, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTransportOrderMapping> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyCompanyTransportOrderMapping(id, CompanyTransportOrderMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies a customer TransportOrder mapping group
         * @summary Modify single customerTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyTransportOrderMappingGroup> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyCompanyTransportOrderMappingGroup(id, CompanyTransportOrderMappingGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies the driver with the specified driverId. This method checks that there is no other driver with the given externalDriverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to call this endpoint.
         * @summary Modify driver by id
         * @param {string} driverId driverId
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyDriverById(driverId: string, DriverRequest: DriverRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Driver> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyDriverById(driverId, DriverRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies the user role of the given role id. The USER_ROLES_CREATE_MODIFY_DELETE permission is required to execute this operation.
         * @summary Modify user role by id
         * @param {string} id id
         * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoleById(id: string, UserRoleRequest: UserRoleRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserRole> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyUserRoleById(id, UserRoleRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies the vehicles with the specified vehicleId. This method checks that there is no other vehicles with the given numberPlate or externalVehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to call this endpoint.
         * @summary Modify vehicles by id
         * @param {string} vehicleId vehicleId
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyVehicleById(vehicleId: string, VehicleRequest: VehicleRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Vehicle> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).modifyVehicleById(vehicleId, VehicleRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all companies. The superuser permission is required to execute this operation.
         * @summary List all companies
         * @param {string} term term
         * @param {boolean} [includeArchived] includeArchived
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryCompanies(term: string, includeArchived?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyListResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).queryCompanies(term, includeArchived, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Register a new company with the given registration data. This endpoint sends an email to the user who sent the registration.
         * @summary register new company
         * @param {Registration} Registration Registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCompany(Registration: Registration, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).registerCompany(Registration, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes the driver with the given driverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Delete driver by id
         * @param {string} driverId driverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDriver(driverId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).removeDriver(driverId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes the user from the specified role
         * @summary Delete role membership of user
         * @param {string} roleId roleId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleFromUser(roleId: string, userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).removeRoleFromUser(roleId, userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes the vehicles with the given vehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Delete vehicles by id
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVehicle(vehicleId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).removeVehicle(vehicleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint takes a company address mapping group (parameter groupId) and a list of company address mappings.  Then, it deletes all company address mappings which are currently present in the specified group of address mappings  and it inserts the given list of address mappings into the given group of company address mappings. 
         * @summary Replace all customerAddressMappings of the given group with the given list of company address mappings
         * @param {ReplaceCompanyAddressMappingRequest} ReplaceCompanyAddressMappingRequest ReplaceCompanyAddressMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyAddressMappingList(ReplaceCompanyAddressMappingRequest: ReplaceCompanyAddressMappingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerAddressMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).replaceCompanyAddressMappingList(ReplaceCompanyAddressMappingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint takes a company Freight mapping group (parameter groupId) and a list of company freight mappings.  Then, it deletes all company Freight mappings which are currently present in the specified group of freight mappings  and it inserts the given list of freight mappings into the given group of company freight mappings. 
         * @summary Replace all customerFreightMappings of the given group with the given list of company Freight mappings
         * @param {ReplaceCompanyFreightMappingRequest} ReplaceCompanyFreightMappingRequest ReplaceCompanyFreightMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyFreightMappingList(ReplaceCompanyFreightMappingRequest: ReplaceCompanyFreightMappingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerFreightMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).replaceCompanyFreightMappingList(ReplaceCompanyFreightMappingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint takes a company transportOrder mapping group (parameter groupId) and a list of company transportOrder mappings.  Then, it deletes all company transportOrder mappings which are currently present in the specified group of transportOrder mappings  and it inserts the given list of transportOrder mappings into the given group of company transportOrder mappings. 
         * @summary Replace all customerTransportOrderMappings of the given group with the given list of company transportOrder mappings
         * @param {ReplaceCompanyTransportOrderMappingRequest} ReplaceCompanyTransportOrderMappingRequest ReplaceCompanyTransportOrderMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyTransportOrderMappingList(ReplaceCompanyTransportOrderMappingRequest: ReplaceCompanyTransportOrderMappingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerTransportOrderMappingResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).replaceCompanyTransportOrderMappingList(ReplaceCompanyTransportOrderMappingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches all rules that are used for validation of transportOrders from the sourceCompany of the given transportOrder.
         * @summary runs all status validation rules for this TransportOrder and gives back results
         * @param {RunTransportOrderStatusValidationsRequest} RunTransportOrderStatusValidationsRequest RunTransportOrderStatusValidationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTransportOrderStatusValidations(RunTransportOrderStatusValidationsRequest: RunTransportOrderStatusValidationsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchValidationRulesResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).runTransportOrderStatusValidations(RunTransportOrderStatusValidationsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings
         * @summary sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings 
         * @param {SendTransportOrderStatusValidationsMailsNowRequest} SendTransportOrderStatusValidationsMailsNowRequest SendTransportOrderStatusValidationsMailsNowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTransportOrderStatusValidationsMailsNow(SendTransportOrderStatusValidationsMailsNowRequest: SendTransportOrderStatusValidationsMailsNowRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SendTransportOrderStatusValidationsMailsNowResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).sendTransportOrderStatusValidationsMailsNow(SendTransportOrderStatusValidationsMailsNowRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Assigns the role linked to the given roleId to the User of the given userId
         * @summary Set the roles of the user
         * @param {string} userId userId
         * @param {RolesOfUserRequest} RolesOfUserRequest RolesOfUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRolesOfUser(userId: string, RolesOfUserRequest: RolesOfUserRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RolesOfUserRequest> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).setRolesOfUser(userId, RolesOfUserRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updated the acknowledged flag on warnings in transportOrders
         * @summary updates acknowledged flag on a 
         * @param {UpdateAcknowledgedOnStatusValidationRequest} UpdateAcknowledgedOnStatusValidationRequest UpdateAcknowledgedOnStatusValidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAcknowledgeOnStatusValidation(UpdateAcknowledgedOnStatusValidationRequest: UpdateAcknowledgedOnStatusValidationRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateAcknowledgedOnStatusValidationResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).updateAcknowledgeOnStatusValidation(UpdateAcknowledgedOnStatusValidationRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update the company of the given companyId using the posted data. This method can be called, if the currently authenticated user has the permission to modify the specified company. this endpoint will return the updated Company object.
         * @summary update company
         * @param {string} id id
         * @param {Company} Company Company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(id: string, Company: Company, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).updateCompany(id, Company, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update company's ignore list of customer report.
         * @summary Update company's ignore list of customer report.
         * @param {UpdateIgnoreListForCustomerReportForAllCompaniesRequest} UpdateIgnoreListForCustomerReportForAllCompaniesRequest UpdateIgnoreListForCustomerReportForAllCompaniesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIgnoreListForCustomerReportForAllCompanies(UpdateIgnoreListForCustomerReportForAllCompaniesRequest: UpdateIgnoreListForCustomerReportForAllCompaniesRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateIgnoreListForCustomerReportForAllCompaniesResponse> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).updateIgnoreListForCustomerReportForAllCompanies(UpdateIgnoreListForCustomerReportForAllCompaniesRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Changes the status of a pending invitation. The status of the invitation can either be changed by the inviting party or by the invited party. However, the user calling this method requires the COMPANY_MODIFY_PARTNERS permission to execute this operation.
         * @summary accept or reject invitation
         * @param {string} randomInvitationId randomInvitationId
         * @param {PartnerInvitationStatusUpdate} PartnerInvitationStatusUpdate PartnerInvitationStatusUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvitationStatus(randomInvitationId: string, PartnerInvitationStatusUpdate: PartnerInvitationStatusUpdate, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PartnerInvitation> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).updateInvitationStatus(randomInvitationId, PartnerInvitationStatusUpdate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update the external partner id of a partner company using the posted data. This method can be called, if the currently authenticated user has the permission to modify partners.
         * @summary update external partner id
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {Partner} Partner Partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerById(partnerCompanyId: string, Partner: Partner, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Partner> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).updatePartnerById(partnerCompanyId, Partner, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify the specified user by the given user id. This operation allows partial updates. If properties are left blank, the old values are preserved. The permission USERS_MODIFY is required to execute this operation and only users of the same company as the caller can be modified.
         * @summary Modify user by id
         * @param {string} id id
         * @param {UserRequest} UserRequest UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById(id: string, UserRequest: UserRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).updateUserById(id, UserRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check whether the given external driver ID is not yet taken by an already existing driver in this company.
         * @summary Validate driver external Id
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDriverExternalId(DriverRequest: DriverRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResult> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).validateDriverExternalId(DriverRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Validate user data
         * @param {EmailRequest} EmailRequest EmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUser(EmailRequest: EmailRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResult> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).validateUser(EmailRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check whether the given external vehicles ID is not yet taken by an already existing vehicles in this company.
         * @summary Validate vehicles external Id
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVehicleExternalId(VehicleRequest: VehicleRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResult> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).validateVehicleExternalId(VehicleRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check whether the given number plate is not yet taken by an already existing vehicles in this company.
         * @summary Validate vehicles numberPlate
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVehicleNumberPlate(VehicleRequest: VehicleRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResult> {
            const localVarFetchArgs = CompanyApiFetchParamCreator(configuration).validateVehicleNumberPlate(VehicleRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * update company's customer report setting to acknowledged based on the enable flag.
         * @summary update company's customer report setting to acknowledged.
         * @param {AddAcknowledgementForCompaniesCustomerReportRequest} AddAcknowledgementForCompaniesCustomerReportRequest AddAcknowledgementForCompaniesCustomerReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeCompaniesFromCustomerReport(AddAcknowledgementForCompaniesCustomerReportRequest: AddAcknowledgementForCompaniesCustomerReportRequest, options?: any) {
            return CompanyApiFp(configuration).acknowledgeCompaniesFromCustomerReport(AddAcknowledgementForCompaniesCustomerReportRequest, options)(fetch, basePath);
        },
        /**
         * Adds a new customer address mapping
         * @summary Add new customerAddressMapping
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyAddressMapping(CompanyAddressMapping: CompanyAddressMapping, options?: any) {
            return CompanyApiFp(configuration).addCompanyAddressMapping(CompanyAddressMapping, options)(fetch, basePath);
        },
        /**
         * Adds a new customer address mapping group
         * @summary Add new customerAddressMappingGroup
         * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyAddressMappingGroup(CompanyAddressMappingGroup: CompanyAddressMappingGroup, options?: any) {
            return CompanyApiFp(configuration).addCompanyAddressMappingGroup(CompanyAddressMappingGroup, options)(fetch, basePath);
        },
        /**
         * Adds a new customer freight mapping
         * @summary Add new customerFreightMapping
         * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyFreightMapping(CompanyFreightMapping: CompanyFreightMapping, options?: any) {
            return CompanyApiFp(configuration).addCompanyFreightMapping(CompanyFreightMapping, options)(fetch, basePath);
        },
        /**
         * Adds a new customer freight mapping group
         * @summary Add new customerFreightMappingGroup
         * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyFreightMappingGroup(CompanyFreightMappingGroup: CompanyFreightMappingGroup, options?: any) {
            return CompanyApiFp(configuration).addCompanyFreightMappingGroup(CompanyFreightMappingGroup, options)(fetch, basePath);
        },
        /**
         * Add a new company tag
         * @summary Add new company tag
         * @param {CompanyTag} CompanyTag CompanyTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTag(CompanyTag: CompanyTag, options?: any) {
            return CompanyApiFp(configuration).addCompanyTag(CompanyTag, options)(fetch, basePath);
        },
        /**
         * Adds a new customer TransportOrder Mapping
         * @summary Add new customerTransportOrderMapping
         * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTransportOrderMapping(CompanyTransportOrderMapping: CompanyTransportOrderMapping, options?: any) {
            return CompanyApiFp(configuration).addCompanyTransportOrderMapping(CompanyTransportOrderMapping, options)(fetch, basePath);
        },
        /**
         * Adds a new customer TransportOrder mapping group
         * @summary Add new customerCompanyTransportOrderMappingGroup
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyTransportOrderMappingGroup(CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any) {
            return CompanyApiFp(configuration).addCompanyTransportOrderMappingGroup(CompanyTransportOrderMappingGroup, options)(fetch, basePath);
        },
        /**
         * Fetch the add filter request and save it in database as per user id and company specific
         * @summary Add new filter for a user as per his company signed in
         * @param {AddFiltersRequest} AddFiltersRequest AddFiltersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFilters(AddFiltersRequest: AddFiltersRequest, options?: any) {
            return CompanyApiFp(configuration).addFilters(AddFiltersRequest, options)(fetch, basePath);
        },
        /**
         * update company's customer report setting to ignore or unIgnore based on the enable flag.
         * @summary update company's customer report setting to ignore or unignore.
         * @param {AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest} AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemoveCompaniesFromIgnoreListForCustomerReport(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest: AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest, options?: any) {
            return CompanyApiFp(configuration).addOrRemoveCompaniesFromIgnoreListForCustomerReport(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest, options)(fetch, basePath);
        },
        /**
         * Adds a user with the given userId to the role with the given userRoleId. The Permission USER_ROLES_ASSIGN is required to execute this operation.
         * @summary Add user role membership for the given role and the given user
         * @param {string} roleId roleId
         * @param {UserRoleAddRequest} UserRoleAddRequest UserRoleAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleToUser(roleId: string, UserRoleAddRequest: UserRoleAddRequest, options?: any) {
            return CompanyApiFp(configuration).addRoleToUser(roleId, UserRoleAddRequest, options)(fetch, basePath);
        },
        /**
         * Archives Company
         * @summary archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompany(options?: any) {
            return CompanyApiFp(configuration).archiveCompany(options)(fetch, basePath);
        },
        /**
         * Authenticate spedion user as per php session id
         * @summary Authenticate spedion user as per php session id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateSpedionUser(options?: any) {
            return CompanyApiFp(configuration).authenticateSpedionUser(options)(fetch, basePath);
        },
        /**
         * Deletes multiple company address mappings
         * @summary Delete companyAddressMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyAddressMappings(ids: string, options?: any) {
            return CompanyApiFp(configuration).bulkDeleteCompanyAddressMappings(ids, options)(fetch, basePath);
        },
        /**
         * Deletes multiple company freight mappings
         * @summary Delete companyFreightMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyFreightMappings(ids: string, options?: any) {
            return CompanyApiFp(configuration).bulkDeleteCompanyFreightMappings(ids, options)(fetch, basePath);
        },
        /**
         * Deletes multiple company TransportOrder mappings
         * @summary Delete CompanyTransportOrderMappings with the given ids
         * @param {string} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteCompanyTransportOrderMappings(ids: string, options?: any) {
            return CompanyApiFp(configuration).bulkDeleteCompanyTransportOrderMappings(ids, options)(fetch, basePath);
        },
        /**
         * Check and update disable until status for customer reports based on the new report values.
         * @summary Check and update disable until status based on current customer reports.
         * @param {CheckAndUpdateDisableUntilStatusRequest} CheckAndUpdateDisableUntilStatusRequest CheckAndUpdateDisableUntilStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndUpdateDisableUntilStatus(CheckAndUpdateDisableUntilStatusRequest: CheckAndUpdateDisableUntilStatusRequest, options?: any) {
            return CompanyApiFp(configuration).checkAndUpdateDisableUntilStatus(CheckAndUpdateDisableUntilStatusRequest, options)(fetch, basePath);
        },
        /**
         * Clones an existing company TransportOrder mapping group, creating a new group with the same settings. Optionally override fields via the request body (e.g. validFrom, validTill, groupName).
         * @summary Clone a companyTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any) {
            return CompanyApiFp(configuration).cloneCompanyTransportOrderMappingGroup(id, CompanyTransportOrderMappingGroup, options)(fetch, basePath);
        },
        /**
         * Create a new driver for the current company of the user. If a driver with the specified pin already exists, a BadRequest is returned to the calling user. The DRIVER_CREATE_MODIFY_DELETE permission is required to call this endpoint
         * @summary Create new driver
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriver(DriverRequest: DriverRequest, options?: any) {
            return CompanyApiFp(configuration).createDriver(DriverRequest, options)(fetch, basePath);
        },
        /**
         * Create an new invitation and send an invitation email to the invited party. If the invited party accepts the invitation, both companies become partner and can exchange transports.
         * @summary send invitation
         * @param {PartnerInvitation} PartnerInvitation PartnerInvitation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(PartnerInvitation: PartnerInvitation, options?: any) {
            return CompanyApiFp(configuration).createInvitation(PartnerInvitation, options)(fetch, basePath);
        },
        /**
         * Create a new user for the specified company. The permission USERS_CREATE is required to create a new user account. The newly created user is member of the same company as the currently authenticated user.
         * @summary create user
         * @param {UserCreateRequest} UserCreateRequest UserCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(UserCreateRequest: UserCreateRequest, options?: any) {
            return CompanyApiFp(configuration).createUser(UserCreateRequest, options)(fetch, basePath);
        },
        /**
         * Create a new user role. The permission USER_ROLES_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Create new user role
         * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserRole(UserRoleRequest: UserRoleRequest, options?: any) {
            return CompanyApiFp(configuration).createUserRole(UserRoleRequest, options)(fetch, basePath);
        },
        /**
         * Create a new vehicles for the current company of the user. If a vehicles with the specified numberPlate or externalVehicleId already exists, a BadRequest is returned to the calling user. The VEHICLE_CREATE_MODIFY_DELETE permission is required to call this endpoint
         * @summary Create new vehicles
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle(VehicleRequest: VehicleRequest, options?: any) {
            return CompanyApiFp(configuration).createVehicle(VehicleRequest, options)(fetch, basePath);
        },
        /**
         * Deletes a customer address mapping
         * @summary Delete customerAddressMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyAddressMapping(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteCompanyAddressMapping(id, options)(fetch, basePath);
        },
        /**
         * Deletes a customer address mapping group
         * @summary Delete customerAddressMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyAddressMappingGroup(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteCompanyAddressMappingGroup(id, options)(fetch, basePath);
        },
        /**
         * Deletes a company freight mapping
         * @summary Delete companyFreightMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyFreightMapping(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteCompanyFreightMapping(id, options)(fetch, basePath);
        },
        /**
         * Deletes a company freight mapping group
         * @summary Delete companyFreightMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyFreightMappingGroup(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteCompanyFreightMappingGroup(id, options)(fetch, basePath);
        },
        /**
         * Deletes a company tag
         * @summary Delete companyTag with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTag(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteCompanyTag(id, options)(fetch, basePath);
        },
        /**
         * Deletes a company transportOrder mapping
         * @summary Delete companyTransportOrderMapping with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTransportOrderMapping(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteCompanyTransportOrderMapping(id, options)(fetch, basePath);
        },
        /**
         * Deletes a company TransportOrder mapping group
         * @summary Delete companyTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyTransportOrderMappingGroup(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteCompanyTransportOrderMappingGroup(id, options)(fetch, basePath);
        },
        /**
         * Delete the filter with the given filterId and userId. The permission COMPANY_MODIFY is required to execute this operation.
         * @summary Delete filter by id
         * @param {string} [filterId] filterId
         * @param {string} [userId] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilter(filterId?: string, userId?: string, options?: any) {
            return CompanyApiFp(configuration).deleteFilter(filterId, userId, options)(fetch, basePath);
        },
        /**
         * Removes a partner and cancels the partnership between two companies.
         * @summary delete
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartner(partnerCompanyId: string, options?: any) {
            return CompanyApiFp(configuration).deletePartner(partnerCompanyId, options)(fetch, basePath);
        },
        /**
         * Use this endpoint to remove a user from the companies users list. The permission USER_DELETE is required to execute this operation
         * @summary Delete user by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteUserById(id, options)(fetch, basePath);
        },
        /**
         * Removes the user role with the specified role id.
         * @summary Delete user role by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRoleById(id: string, options?: any) {
            return CompanyApiFp(configuration).deleteUserRoleById(id, options)(fetch, basePath);
        },
        /**
         * Modify the filter name depending upon the filter id and return the updated filter list
         * @summary Modify filter name as per the id
         * @param {ModifyFilterName} ModifyFilterName ModifyFilterName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFilterName(ModifyFilterName: ModifyFilterName, options?: any) {
            return CompanyApiFp(configuration).editFilterName(ModifyFilterName, options)(fetch, basePath);
        },
        /**
         * Returns all users of all partners for the current company. In order to call this operation the permission USERS_VIEW is required
         * @summary Get List of users for all partner companies
         * @param {string} query query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPartnersUsers(query: string, options?: any) {
            return CompanyApiFp(configuration).fetchAllPartnersUsers(query, options)(fetch, basePath);
        },
        /**
         * Returns list of all partner companies with list of validationRules    
         * @summary Get List of all partner companies with list of validationRules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPartnersValidationRuleNames(options?: any) {
            return CompanyApiFp(configuration).fetchAllPartnersValidationRuleNames(options)(fetch, basePath);
        },
        /**
         * Fetch address book and drivers of the user's company.
         * @summary fetch company's address book and drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressBookAndDrivers(options?: any) {
            return CompanyApiFp(configuration).fetchCompanyAddressBookAndDrivers(options)(fetch, basePath);
        },
        /**
         * Returns all company address mapping groups of this company
         * @summary Get a list of all customer address mapping groups
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingGroups(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyAddressMappingGroups(skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns all user defined address mappings defined for this company.
         * @summary Get a list of all customer address mappings
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyAddressMappingList(onlyGroupIds, skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns all user defined address mappings defined for this company without authentication.
         * @summary Get a list of all customer address mappings
         * @param {string} token token
         * @param {string} [pin] pin
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingListPublic(token: string, pin?: string, onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyAddressMappingListPublic(token, pin, onlyGroupIds, skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns the company with the specified companyId, if the currently authenticated user has the permission to view that company.
         * @summary get company by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyById(id: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyById(id, options)(fetch, basePath);
        },
        /**
         * Returns all user definied freight mapping groups defined for this company.
         * @summary Get a list of all freight mapping groups
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyFreightMappingGroupList(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyFreightMappingGroupList(skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns all user defined freight mappings for this company.
         * @summary Get a list of all freight mapping
         * @param {Array<string>} [onlyGroupIds] onlyGroupIds
         * @param {number} [skip] skip
         * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyFreightMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyFreightMappingList(onlyGroupIds, skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns the company of the currently authenticated user.
         * @summary get current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyOfUser(options?: any) {
            return CompanyApiFp(configuration).fetchCompanyOfUser(options)(fetch, basePath);
        },
        /**
         * Fetch Company tags as per company id
         * @summary Fetch Company tags as per company id
         * @param {FetchCompanyTagsRequest} FetchCompanyTagsRequest FetchCompanyTagsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTags(FetchCompanyTagsRequest: FetchCompanyTagsRequest, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyTags(FetchCompanyTagsRequest, options)(fetch, basePath);
        },
        /**
         * Returns all user definied transportOrder mapping groups defined for this company.
         * @summary Get a list of all transportOrder mapping groups
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingGroupList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyTransportOrderMappingGroupList(skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns all user defined transportOrder mappings for this company.
         * @summary Get a list of all transportOrder mapping
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyTransportOrderMappingList(skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns all user defined transportOrder mappings based the specific group id for this company.
         * @summary Get a list of all transportOrder mapping by group id
         * @param {string} groupId groupId
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyTransportOrderMappingListByGroupId(groupId: string, skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchCompanyTransportOrderMappingListByGroupId(groupId, skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns a single driver with the specified driverId. The permission DRIVER_VIEW is required to fetch a driver
         * @summary Get a driver
         * @param {string} driverId driverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDriver(driverId: string, options?: any) {
            return CompanyApiFp(configuration).fetchDriver(driverId, options)(fetch, basePath);
        },
        /**
         * Returns a list of drivers which are assigned to the users company. The permission DRIVER_VIEW is required to access this endpoint.
         * @summary Get all drivers
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDriverList(limit?: number, query?: string, skip?: number, sortBy?: 'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return CompanyApiFp(configuration).fetchDriverList(limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns one row per relevant transport order (DONE or EXECUTING) for every vehicle in the company within [sinceTimestamp, toTimestamp], enriched with the empty-kilometre gap to the previous tour, plausibility flags, hints, consolidated-shipment group label, FMS odometer values, customer (FRM key from freight additionalData) and stop coordinates.  Replaces the per-company `reportScript` based XLSX flow for the on-demand empty-kilometre dashboard. Optionally filterable by a list of vehicle number plates.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
         * @summary Get the empty-kilometres report for all vehicles in the given window
         * @param {EmptyKilometersReportRequest} EmptyKilometersReportRequest EmptyKilometersReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyKilometersReport(EmptyKilometersReportRequest: EmptyKilometersReportRequest, options?: any) {
            return CompanyApiFp(configuration).fetchEmptyKilometersReport(EmptyKilometersReportRequest, options)(fetch, basePath);
        },
        /**
         * Detail view behind one row of the empty-kilometre report: the GPS track between [sinceTimestamp, toTimestamp] split into driving and standing clusters (same segmentation the tour map uses), each standing cluster reverse geocoded to a city, and the DTCO activities of every driver that was on the truck in that window.  Standing clusters that sit at the last stop of the previous tour or at the first stop of the following one are flagged, so the caller can label them. When no DTCO logbook exists, `gpsDrivingSeconds` / `gpsStandingSeconds` carry the GPS approximation of driving versus everything else.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
         * @summary Get what the truck did during one empty run
         * @param {EmptyKilometersRunDetailsRequest} EmptyKilometersRunDetailsRequest EmptyKilometersRunDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyKilometersRunDetails(EmptyKilometersRunDetailsRequest: EmptyKilometersRunDetailsRequest, options?: any) {
            return CompanyApiFp(configuration).fetchEmptyKilometersRunDetails(EmptyKilometersRunDetailsRequest, options)(fetch, basePath);
        },
        /**
         * return empty tours for a vehicle
         * @summary get EmptyTours for a vehicle
         * @param {VehicleEmptyTourRequest} VehicleEmptyTourRequest VehicleEmptyTourRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyTours(VehicleEmptyTourRequest: VehicleEmptyTourRequest, options?: any) {
            return CompanyApiFp(configuration).fetchEmptyTours(VehicleEmptyTourRequest, options)(fetch, basePath);
        },
        /**
         * Fetch the filters as per user id and company specific
         * @summary Fetch filters as per user id and company id
         * @param {string} [companyId] companyId
         * @param {string} [userId] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFilters(companyId?: string, userId?: string, options?: any) {
            return CompanyApiFp(configuration).fetchFilters(companyId, userId, options)(fetch, basePath);
        },
        /**
         * Returns all incoming partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
         * @summary invitation list
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIncomingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return CompanyApiFp(configuration).fetchIncomingInvitationList(limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns the partnership invitation identified by the randomInvitation token. Everyone can access this invitation if he knows the randomInvitationToken. No further authentication is needed.
         * @summary get invitation by random token
         * @param {string} randomInvitationId randomInvitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitationByToken(randomInvitationId: string, options?: any) {
            return CompanyApiFp(configuration).fetchInvitationByToken(randomInvitationId, options)(fetch, basePath);
        },
        /**
         * Returns all outgoing partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
         * @summary invitation list
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOutgoingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return CompanyApiFp(configuration).fetchOutgoingInvitationList(limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns a list of all partner companies including the externalId given for them. The permission COMPANY_VIEW_PARTNERS is required to to execute this operation
         * @summary get all partners
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return CompanyApiFp(configuration).fetchPartnerList(limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns a list of users for the specified partner company.
         * @summary Get List of users for a partner company
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerUsers(partnerCompanyId: string, options?: any) {
            return CompanyApiFp(configuration).fetchPartnerUsers(partnerCompanyId, options)(fetch, basePath);
        },
        /**
         * Returns the roles of the user of the given user id (for the availableCompany of the calling user). The permission USER_ROLES_VIEW is required to call this operation.
         * @summary Fetch roles of the user with id
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRolesForUser(userId: string, options?: any) {
            return CompanyApiFp(configuration).fetchRolesForUser(userId, options)(fetch, basePath);
        },
        /**
         * Get the user with the specified external user id.
         * @summary Find User by external user id
         * @param {string} externalId externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserByExternalUserId(externalId: string, options?: any) {
            return CompanyApiFp(configuration).fetchUserByExternalUserId(externalId, options)(fetch, basePath);
        },
        /**
         * Get the user with the specified user id.
         * @summary Find User by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserById(id: string, options?: any) {
            return CompanyApiFp(configuration).fetchUserById(id, options)(fetch, basePath);
        },
        /**
         * Returns the user role of the specified userRoleId. The permission USER_ROLES_VIEW is required to execute this operation
         * @summary Get user role by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRoleById(id: string, options?: any) {
            return CompanyApiFp(configuration).fetchUserRoleById(id, options)(fetch, basePath);
        },
        /**
         * Returns a list of all user roles of the current company. The permission USER_ROLES_VIEW is required to execute this operation.
         * @summary Get all user roles
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'NAME' | 'PERMISSION'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRoleList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'PERMISSION', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return CompanyApiFp(configuration).fetchUserRoleList(limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns the user roles of the specified userRoleIds. The permission USER_ROLES_VIEW is required to execute this operation
         * @summary Get user role by id
         * @param {Array<string>} ids ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserRolesByIds(ids: Array<string>, options?: any) {
            return CompanyApiFp(configuration).fetchUserRolesByIds(ids, options)(fetch, basePath);
        },
        /**
         * Returns a list of users which are currently member of the role with the specified id.
         * @summary Get all users which are member of a given UserRole
         * @param {string} roleId roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersWithRole(roleId: string, options?: any) {
            return CompanyApiFp(configuration).fetchUsersWithRole(roleId, options)(fetch, basePath);
        },
        /**
         * Returns a single vehicle with the specified vehicleId. The permission VEHICLE_VIEW is required to fetch a vehicle
         * @summary Get a vehicle
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicle(vehicleId: string, options?: any) {
            return CompanyApiFp(configuration).fetchVehicle(vehicleId, options)(fetch, basePath);
        },
        /**
         * Returns the distinct, non-blank values of properties.additionalData[key=\"apiGatewaySource\"] across all vehicles visible to the calling user. Used to populate the data-source filter in the fleet view. The permission VEHICLE_VIEW is required to access this endpoint.
         * @summary Get distinct apiGatewaySource values across the company's vehicles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleApiGatewaySources(options?: any) {
            return CompanyApiFp(configuration).fetchVehicleApiGatewaySources(options)(fetch, basePath);
        },
        /**
         * Computes empty-leg kilometres between consecutive non-overlapping transport orders that the given vehicle performed in [sinceTimestamp, toTimestamp]. Reads odometer values from each stop's `additionalData` (preferring FMS keys `vehicle.odometer.on.arrive` / `vehicle.odometer.on.depart`, with a virtual odometer fallback) — does NOT depend on the GPS position stream like the legacy /emptyTour endpoint, so it works for clients whose feeds carry odometer values in stop additionalData rather than tagged GPS samples.  Returns one segment per gap with the computed empty km, route (from-city → to-city), source flag (FMS / VIRTUAL / …), plausibility flag, Sammelladung group label when an overlap is detected, and human-readable hints. Tours with no plate or in non-relevant statuses (anything other than DONE / EXECUTING) are skipped before grouping.  The permission VEHICLE_VIEW is required.
         * @summary Get empty kilometres between consecutive transport orders for a vehicle
         * @param {VehicleEmptyKilometersRequest} VehicleEmptyKilometersRequest VehicleEmptyKilometersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleEmptyKilometers(VehicleEmptyKilometersRequest: VehicleEmptyKilometersRequest, options?: any) {
            return CompanyApiFp(configuration).fetchVehicleEmptyKilometers(VehicleEmptyKilometersRequest, options)(fetch, basePath);
        },
        /**
         * Returns a list of vehicles which are assigned to the users company. The permission VEHICLE_VIEW is required to access this endpoint.
         * @summary Get all vehicles
         * @param {string} [apiGatewaySource] apiGatewaySource
         * @param {number} [skip] skip
         * @param {'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {number} [take] take
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleList(apiGatewaySource?: string, skip?: number, sortBy?: 'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
            return CompanyApiFp(configuration).fetchVehicleList(apiGatewaySource, skip, sortBy, sortDirection, take, term, options)(fetch, basePath);
        },
        /**
         * Returns a report containing empty tour report for all company vehicles for the last month
         * @summary returns Empty tour report
         * @param {VehiclesReportRequest} VehiclesReportRequest VehiclesReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmptyTourReport(VehiclesReportRequest: VehiclesReportRequest, options?: any) {
            return CompanyApiFp(configuration).getEmptyTourReport(VehiclesReportRequest, options)(fetch, basePath);
        },
        /**
         * Returns List of partners that can link to the users company
         * @summary Get List of partners that can link to the users company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkingPartners(options?: any) {
            return CompanyApiFp(configuration).linkingPartners(options)(fetch, basePath);
        },
        /**
         * Returns a list of all members of the company.
         * @summary Get List of users
         * @param {string} [externalUserId] externalUserId
         * @param {number} [limit] limit
         * @param {string} [q] q
         * @param {number} [skip] skip
         * @param {'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(externalUserId?: string, limit?: number, q?: string, skip?: number, sortBy?: 'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return CompanyApiFp(configuration).listUsers(externalUserId, limit, q, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Modifies a customer address mapping
         * @summary Modify single customerAddressMapping with the given id
         * @param {string} id id
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyAddressMapping(id: string, CompanyAddressMapping: CompanyAddressMapping, options?: any) {
            return CompanyApiFp(configuration).modifyCompanyAddressMapping(id, CompanyAddressMapping, options)(fetch, basePath);
        },
        /**
         * Modifies a customer address mapping group
         * @summary Modify single customerAddressMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyAddressMappingGroup(id: string, CompanyAddressMappingGroup: CompanyAddressMappingGroup, options?: any) {
            return CompanyApiFp(configuration).modifyCompanyAddressMappingGroup(id, CompanyAddressMappingGroup, options)(fetch, basePath);
        },
        /**
         * Modifies a customer freight mapping
         * @summary Modify single customerFreightMapping with the given id
         * @param {string} id id
         * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyFreightMapping(id: string, CompanyFreightMapping: CompanyFreightMapping, options?: any) {
            return CompanyApiFp(configuration).modifyCompanyFreightMapping(id, CompanyFreightMapping, options)(fetch, basePath);
        },
        /**
         * Modifies a customer freight mapping group
         * @summary Modify single customerFreightMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyFreightMappingGroup(id: string, CompanyFreightMappingGroup: CompanyFreightMappingGroup, options?: any) {
            return CompanyApiFp(configuration).modifyCompanyFreightMappingGroup(id, CompanyFreightMappingGroup, options)(fetch, basePath);
        },
        /**
         * Modify a company tag
         * @summary Modify company tag
         * @param {string} id id
         * @param {CompanyTag} CompanyTag CompanyTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTag(id: string, CompanyTag: CompanyTag, options?: any) {
            return CompanyApiFp(configuration).modifyCompanyTag(id, CompanyTag, options)(fetch, basePath);
        },
        /**
         * Modifies a customer TransportOrder Mapping
         * @summary Modify single customerTransportOrderMapping with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTransportOrderMapping(id: string, CompanyTransportOrderMapping: CompanyTransportOrderMapping, options?: any) {
            return CompanyApiFp(configuration).modifyCompanyTransportOrderMapping(id, CompanyTransportOrderMapping, options)(fetch, basePath);
        },
        /**
         * Modifies a customer TransportOrder mapping group
         * @summary Modify single customerTransportOrderMappingGroup with the given id
         * @param {string} id id
         * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any) {
            return CompanyApiFp(configuration).modifyCompanyTransportOrderMappingGroup(id, CompanyTransportOrderMappingGroup, options)(fetch, basePath);
        },
        /**
         * Modifies the driver with the specified driverId. This method checks that there is no other driver with the given externalDriverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to call this endpoint.
         * @summary Modify driver by id
         * @param {string} driverId driverId
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyDriverById(driverId: string, DriverRequest: DriverRequest, options?: any) {
            return CompanyApiFp(configuration).modifyDriverById(driverId, DriverRequest, options)(fetch, basePath);
        },
        /**
         * Modifies the user role of the given role id. The USER_ROLES_CREATE_MODIFY_DELETE permission is required to execute this operation.
         * @summary Modify user role by id
         * @param {string} id id
         * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoleById(id: string, UserRoleRequest: UserRoleRequest, options?: any) {
            return CompanyApiFp(configuration).modifyUserRoleById(id, UserRoleRequest, options)(fetch, basePath);
        },
        /**
         * Modifies the vehicles with the specified vehicleId. This method checks that there is no other vehicles with the given numberPlate or externalVehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to call this endpoint.
         * @summary Modify vehicles by id
         * @param {string} vehicleId vehicleId
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyVehicleById(vehicleId: string, VehicleRequest: VehicleRequest, options?: any) {
            return CompanyApiFp(configuration).modifyVehicleById(vehicleId, VehicleRequest, options)(fetch, basePath);
        },
        /**
         * Returns a list of all companies. The superuser permission is required to execute this operation.
         * @summary List all companies
         * @param {string} term term
         * @param {boolean} [includeArchived] includeArchived
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryCompanies(term: string, includeArchived?: boolean, options?: any) {
            return CompanyApiFp(configuration).queryCompanies(term, includeArchived, options)(fetch, basePath);
        },
        /**
         * Register a new company with the given registration data. This endpoint sends an email to the user who sent the registration.
         * @summary register new company
         * @param {Registration} Registration Registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCompany(Registration: Registration, options?: any) {
            return CompanyApiFp(configuration).registerCompany(Registration, options)(fetch, basePath);
        },
        /**
         * Removes the driver with the given driverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Delete driver by id
         * @param {string} driverId driverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDriver(driverId: string, options?: any) {
            return CompanyApiFp(configuration).removeDriver(driverId, options)(fetch, basePath);
        },
        /**
         * Removes the user from the specified role
         * @summary Delete role membership of user
         * @param {string} roleId roleId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleFromUser(roleId: string, userId: string, options?: any) {
            return CompanyApiFp(configuration).removeRoleFromUser(roleId, userId, options)(fetch, basePath);
        },
        /**
         * Removes the vehicles with the given vehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to execute this operation.
         * @summary Delete vehicles by id
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVehicle(vehicleId: string, options?: any) {
            return CompanyApiFp(configuration).removeVehicle(vehicleId, options)(fetch, basePath);
        },
        /**
         * This endpoint takes a company address mapping group (parameter groupId) and a list of company address mappings.  Then, it deletes all company address mappings which are currently present in the specified group of address mappings  and it inserts the given list of address mappings into the given group of company address mappings. 
         * @summary Replace all customerAddressMappings of the given group with the given list of company address mappings
         * @param {ReplaceCompanyAddressMappingRequest} ReplaceCompanyAddressMappingRequest ReplaceCompanyAddressMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyAddressMappingList(ReplaceCompanyAddressMappingRequest: ReplaceCompanyAddressMappingRequest, options?: any) {
            return CompanyApiFp(configuration).replaceCompanyAddressMappingList(ReplaceCompanyAddressMappingRequest, options)(fetch, basePath);
        },
        /**
         * This endpoint takes a company Freight mapping group (parameter groupId) and a list of company freight mappings.  Then, it deletes all company Freight mappings which are currently present in the specified group of freight mappings  and it inserts the given list of freight mappings into the given group of company freight mappings. 
         * @summary Replace all customerFreightMappings of the given group with the given list of company Freight mappings
         * @param {ReplaceCompanyFreightMappingRequest} ReplaceCompanyFreightMappingRequest ReplaceCompanyFreightMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyFreightMappingList(ReplaceCompanyFreightMappingRequest: ReplaceCompanyFreightMappingRequest, options?: any) {
            return CompanyApiFp(configuration).replaceCompanyFreightMappingList(ReplaceCompanyFreightMappingRequest, options)(fetch, basePath);
        },
        /**
         * This endpoint takes a company transportOrder mapping group (parameter groupId) and a list of company transportOrder mappings.  Then, it deletes all company transportOrder mappings which are currently present in the specified group of transportOrder mappings  and it inserts the given list of transportOrder mappings into the given group of company transportOrder mappings. 
         * @summary Replace all customerTransportOrderMappings of the given group with the given list of company transportOrder mappings
         * @param {ReplaceCompanyTransportOrderMappingRequest} ReplaceCompanyTransportOrderMappingRequest ReplaceCompanyTransportOrderMappingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCompanyTransportOrderMappingList(ReplaceCompanyTransportOrderMappingRequest: ReplaceCompanyTransportOrderMappingRequest, options?: any) {
            return CompanyApiFp(configuration).replaceCompanyTransportOrderMappingList(ReplaceCompanyTransportOrderMappingRequest, options)(fetch, basePath);
        },
        /**
         * Fetches all rules that are used for validation of transportOrders from the sourceCompany of the given transportOrder.
         * @summary runs all status validation rules for this TransportOrder and gives back results
         * @param {RunTransportOrderStatusValidationsRequest} RunTransportOrderStatusValidationsRequest RunTransportOrderStatusValidationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTransportOrderStatusValidations(RunTransportOrderStatusValidationsRequest: RunTransportOrderStatusValidationsRequest, options?: any) {
            return CompanyApiFp(configuration).runTransportOrderStatusValidations(RunTransportOrderStatusValidationsRequest, options)(fetch, basePath);
        },
        /**
         * sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings
         * @summary sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings 
         * @param {SendTransportOrderStatusValidationsMailsNowRequest} SendTransportOrderStatusValidationsMailsNowRequest SendTransportOrderStatusValidationsMailsNowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTransportOrderStatusValidationsMailsNow(SendTransportOrderStatusValidationsMailsNowRequest: SendTransportOrderStatusValidationsMailsNowRequest, options?: any) {
            return CompanyApiFp(configuration).sendTransportOrderStatusValidationsMailsNow(SendTransportOrderStatusValidationsMailsNowRequest, options)(fetch, basePath);
        },
        /**
         * Assigns the role linked to the given roleId to the User of the given userId
         * @summary Set the roles of the user
         * @param {string} userId userId
         * @param {RolesOfUserRequest} RolesOfUserRequest RolesOfUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRolesOfUser(userId: string, RolesOfUserRequest: RolesOfUserRequest, options?: any) {
            return CompanyApiFp(configuration).setRolesOfUser(userId, RolesOfUserRequest, options)(fetch, basePath);
        },
        /**
         * Updated the acknowledged flag on warnings in transportOrders
         * @summary updates acknowledged flag on a 
         * @param {UpdateAcknowledgedOnStatusValidationRequest} UpdateAcknowledgedOnStatusValidationRequest UpdateAcknowledgedOnStatusValidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAcknowledgeOnStatusValidation(UpdateAcknowledgedOnStatusValidationRequest: UpdateAcknowledgedOnStatusValidationRequest, options?: any) {
            return CompanyApiFp(configuration).updateAcknowledgeOnStatusValidation(UpdateAcknowledgedOnStatusValidationRequest, options)(fetch, basePath);
        },
        /**
         * Update the company of the given companyId using the posted data. This method can be called, if the currently authenticated user has the permission to modify the specified company. this endpoint will return the updated Company object.
         * @summary update company
         * @param {string} id id
         * @param {Company} Company Company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(id: string, Company: Company, options?: any) {
            return CompanyApiFp(configuration).updateCompany(id, Company, options)(fetch, basePath);
        },
        /**
         * Update company's ignore list of customer report.
         * @summary Update company's ignore list of customer report.
         * @param {UpdateIgnoreListForCustomerReportForAllCompaniesRequest} UpdateIgnoreListForCustomerReportForAllCompaniesRequest UpdateIgnoreListForCustomerReportForAllCompaniesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIgnoreListForCustomerReportForAllCompanies(UpdateIgnoreListForCustomerReportForAllCompaniesRequest: UpdateIgnoreListForCustomerReportForAllCompaniesRequest, options?: any) {
            return CompanyApiFp(configuration).updateIgnoreListForCustomerReportForAllCompanies(UpdateIgnoreListForCustomerReportForAllCompaniesRequest, options)(fetch, basePath);
        },
        /**
         * Changes the status of a pending invitation. The status of the invitation can either be changed by the inviting party or by the invited party. However, the user calling this method requires the COMPANY_MODIFY_PARTNERS permission to execute this operation.
         * @summary accept or reject invitation
         * @param {string} randomInvitationId randomInvitationId
         * @param {PartnerInvitationStatusUpdate} PartnerInvitationStatusUpdate PartnerInvitationStatusUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvitationStatus(randomInvitationId: string, PartnerInvitationStatusUpdate: PartnerInvitationStatusUpdate, options?: any) {
            return CompanyApiFp(configuration).updateInvitationStatus(randomInvitationId, PartnerInvitationStatusUpdate, options)(fetch, basePath);
        },
        /**
         * Update the external partner id of a partner company using the posted data. This method can be called, if the currently authenticated user has the permission to modify partners.
         * @summary update external partner id
         * @param {string} partnerCompanyId partnerCompanyId
         * @param {Partner} Partner Partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerById(partnerCompanyId: string, Partner: Partner, options?: any) {
            return CompanyApiFp(configuration).updatePartnerById(partnerCompanyId, Partner, options)(fetch, basePath);
        },
        /**
         * Modify the specified user by the given user id. This operation allows partial updates. If properties are left blank, the old values are preserved. The permission USERS_MODIFY is required to execute this operation and only users of the same company as the caller can be modified.
         * @summary Modify user by id
         * @param {string} id id
         * @param {UserRequest} UserRequest UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById(id: string, UserRequest: UserRequest, options?: any) {
            return CompanyApiFp(configuration).updateUserById(id, UserRequest, options)(fetch, basePath);
        },
        /**
         * Check whether the given external driver ID is not yet taken by an already existing driver in this company.
         * @summary Validate driver external Id
         * @param {DriverRequest} DriverRequest DriverRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDriverExternalId(DriverRequest: DriverRequest, options?: any) {
            return CompanyApiFp(configuration).validateDriverExternalId(DriverRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Validate user data
         * @param {EmailRequest} EmailRequest EmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUser(EmailRequest: EmailRequest, options?: any) {
            return CompanyApiFp(configuration).validateUser(EmailRequest, options)(fetch, basePath);
        },
        /**
         * Check whether the given external vehicles ID is not yet taken by an already existing vehicles in this company.
         * @summary Validate vehicles external Id
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVehicleExternalId(VehicleRequest: VehicleRequest, options?: any) {
            return CompanyApiFp(configuration).validateVehicleExternalId(VehicleRequest, options)(fetch, basePath);
        },
        /**
         * Check whether the given number plate is not yet taken by an already existing vehicles in this company.
         * @summary Validate vehicles numberPlate
         * @param {VehicleRequest} VehicleRequest VehicleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVehicleNumberPlate(VehicleRequest: VehicleRequest, options?: any) {
            return CompanyApiFp(configuration).validateVehicleNumberPlate(VehicleRequest, options)(fetch, basePath);
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * update company's customer report setting to acknowledged based on the enable flag.
     * @summary update company's customer report setting to acknowledged.
     * @param {AddAcknowledgementForCompaniesCustomerReportRequest} AddAcknowledgementForCompaniesCustomerReportRequest AddAcknowledgementForCompaniesCustomerReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public acknowledgeCompaniesFromCustomerReport(AddAcknowledgementForCompaniesCustomerReportRequest: AddAcknowledgementForCompaniesCustomerReportRequest, options?: any) {
        return CompanyApiFp(this.configuration).acknowledgeCompaniesFromCustomerReport(AddAcknowledgementForCompaniesCustomerReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a new customer address mapping
     * @summary Add new customerAddressMapping
     * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addCompanyAddressMapping(CompanyAddressMapping: CompanyAddressMapping, options?: any) {
        return CompanyApiFp(this.configuration).addCompanyAddressMapping(CompanyAddressMapping, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a new customer address mapping group
     * @summary Add new customerAddressMappingGroup
     * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addCompanyAddressMappingGroup(CompanyAddressMappingGroup: CompanyAddressMappingGroup, options?: any) {
        return CompanyApiFp(this.configuration).addCompanyAddressMappingGroup(CompanyAddressMappingGroup, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a new customer freight mapping
     * @summary Add new customerFreightMapping
     * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addCompanyFreightMapping(CompanyFreightMapping: CompanyFreightMapping, options?: any) {
        return CompanyApiFp(this.configuration).addCompanyFreightMapping(CompanyFreightMapping, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a new customer freight mapping group
     * @summary Add new customerFreightMappingGroup
     * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addCompanyFreightMappingGroup(CompanyFreightMappingGroup: CompanyFreightMappingGroup, options?: any) {
        return CompanyApiFp(this.configuration).addCompanyFreightMappingGroup(CompanyFreightMappingGroup, options)(this.fetch, this.basePath);
    }

    /**
     * Add a new company tag
     * @summary Add new company tag
     * @param {CompanyTag} CompanyTag CompanyTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addCompanyTag(CompanyTag: CompanyTag, options?: any) {
        return CompanyApiFp(this.configuration).addCompanyTag(CompanyTag, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a new customer TransportOrder Mapping
     * @summary Add new customerTransportOrderMapping
     * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addCompanyTransportOrderMapping(CompanyTransportOrderMapping: CompanyTransportOrderMapping, options?: any) {
        return CompanyApiFp(this.configuration).addCompanyTransportOrderMapping(CompanyTransportOrderMapping, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a new customer TransportOrder mapping group
     * @summary Add new customerCompanyTransportOrderMappingGroup
     * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addCompanyTransportOrderMappingGroup(CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any) {
        return CompanyApiFp(this.configuration).addCompanyTransportOrderMappingGroup(CompanyTransportOrderMappingGroup, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch the add filter request and save it in database as per user id and company specific
     * @summary Add new filter for a user as per his company signed in
     * @param {AddFiltersRequest} AddFiltersRequest AddFiltersRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addFilters(AddFiltersRequest: AddFiltersRequest, options?: any) {
        return CompanyApiFp(this.configuration).addFilters(AddFiltersRequest, options)(this.fetch, this.basePath);
    }

    /**
     * update company's customer report setting to ignore or unIgnore based on the enable flag.
     * @summary update company's customer report setting to ignore or unignore.
     * @param {AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest} AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addOrRemoveCompaniesFromIgnoreListForCustomerReport(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest: AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest, options?: any) {
        return CompanyApiFp(this.configuration).addOrRemoveCompaniesFromIgnoreListForCustomerReport(AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a user with the given userId to the role with the given userRoleId. The Permission USER_ROLES_ASSIGN is required to execute this operation.
     * @summary Add user role membership for the given role and the given user
     * @param {string} roleId roleId
     * @param {UserRoleAddRequest} UserRoleAddRequest UserRoleAddRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addRoleToUser(roleId: string, UserRoleAddRequest: UserRoleAddRequest, options?: any) {
        return CompanyApiFp(this.configuration).addRoleToUser(roleId, UserRoleAddRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Archives Company
     * @summary archive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public archiveCompany(options?: any) {
        return CompanyApiFp(this.configuration).archiveCompany(options)(this.fetch, this.basePath);
    }

    /**
     * Authenticate spedion user as per php session id
     * @summary Authenticate spedion user as per php session id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public authenticateSpedionUser(options?: any) {
        return CompanyApiFp(this.configuration).authenticateSpedionUser(options)(this.fetch, this.basePath);
    }

    /**
     * Deletes multiple company address mappings
     * @summary Delete companyAddressMappings with the given ids
     * @param {string} ids ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public bulkDeleteCompanyAddressMappings(ids: string, options?: any) {
        return CompanyApiFp(this.configuration).bulkDeleteCompanyAddressMappings(ids, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes multiple company freight mappings
     * @summary Delete companyFreightMappings with the given ids
     * @param {string} ids ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public bulkDeleteCompanyFreightMappings(ids: string, options?: any) {
        return CompanyApiFp(this.configuration).bulkDeleteCompanyFreightMappings(ids, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes multiple company TransportOrder mappings
     * @summary Delete CompanyTransportOrderMappings with the given ids
     * @param {string} ids ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public bulkDeleteCompanyTransportOrderMappings(ids: string, options?: any) {
        return CompanyApiFp(this.configuration).bulkDeleteCompanyTransportOrderMappings(ids, options)(this.fetch, this.basePath);
    }

    /**
     * Check and update disable until status for customer reports based on the new report values.
     * @summary Check and update disable until status based on current customer reports.
     * @param {CheckAndUpdateDisableUntilStatusRequest} CheckAndUpdateDisableUntilStatusRequest CheckAndUpdateDisableUntilStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public checkAndUpdateDisableUntilStatus(CheckAndUpdateDisableUntilStatusRequest: CheckAndUpdateDisableUntilStatusRequest, options?: any) {
        return CompanyApiFp(this.configuration).checkAndUpdateDisableUntilStatus(CheckAndUpdateDisableUntilStatusRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Clones an existing company TransportOrder mapping group, creating a new group with the same settings. Optionally override fields via the request body (e.g. validFrom, validTill, groupName).
     * @summary Clone a companyTransportOrderMappingGroup with the given id
     * @param {string} id id
     * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public cloneCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any) {
        return CompanyApiFp(this.configuration).cloneCompanyTransportOrderMappingGroup(id, CompanyTransportOrderMappingGroup, options)(this.fetch, this.basePath);
    }

    /**
     * Create a new driver for the current company of the user. If a driver with the specified pin already exists, a BadRequest is returned to the calling user. The DRIVER_CREATE_MODIFY_DELETE permission is required to call this endpoint
     * @summary Create new driver
     * @param {DriverRequest} DriverRequest DriverRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createDriver(DriverRequest: DriverRequest, options?: any) {
        return CompanyApiFp(this.configuration).createDriver(DriverRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Create an new invitation and send an invitation email to the invited party. If the invited party accepts the invitation, both companies become partner and can exchange transports.
     * @summary send invitation
     * @param {PartnerInvitation} PartnerInvitation PartnerInvitation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createInvitation(PartnerInvitation: PartnerInvitation, options?: any) {
        return CompanyApiFp(this.configuration).createInvitation(PartnerInvitation, options)(this.fetch, this.basePath);
    }

    /**
     * Create a new user for the specified company. The permission USERS_CREATE is required to create a new user account. The newly created user is member of the same company as the currently authenticated user.
     * @summary create user
     * @param {UserCreateRequest} UserCreateRequest UserCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createUser(UserCreateRequest: UserCreateRequest, options?: any) {
        return CompanyApiFp(this.configuration).createUser(UserCreateRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Create a new user role. The permission USER_ROLES_CREATE_MODIFY_DELETE is required to execute this operation.
     * @summary Create new user role
     * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createUserRole(UserRoleRequest: UserRoleRequest, options?: any) {
        return CompanyApiFp(this.configuration).createUserRole(UserRoleRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Create a new vehicles for the current company of the user. If a vehicles with the specified numberPlate or externalVehicleId already exists, a BadRequest is returned to the calling user. The VEHICLE_CREATE_MODIFY_DELETE permission is required to call this endpoint
     * @summary Create new vehicles
     * @param {VehicleRequest} VehicleRequest VehicleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createVehicle(VehicleRequest: VehicleRequest, options?: any) {
        return CompanyApiFp(this.configuration).createVehicle(VehicleRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a customer address mapping
     * @summary Delete customerAddressMapping with the given id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompanyAddressMapping(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteCompanyAddressMapping(id, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a customer address mapping group
     * @summary Delete customerAddressMappingGroup with the given id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompanyAddressMappingGroup(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteCompanyAddressMappingGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a company freight mapping
     * @summary Delete companyFreightMapping with the given id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompanyFreightMapping(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteCompanyFreightMapping(id, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a company freight mapping group
     * @summary Delete companyFreightMappingGroup with the given id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompanyFreightMappingGroup(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteCompanyFreightMappingGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a company tag
     * @summary Delete companyTag with the given id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompanyTag(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteCompanyTag(id, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a company transportOrder mapping
     * @summary Delete companyTransportOrderMapping with the given id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompanyTransportOrderMapping(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteCompanyTransportOrderMapping(id, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a company TransportOrder mapping group
     * @summary Delete companyTransportOrderMappingGroup with the given id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompanyTransportOrderMappingGroup(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteCompanyTransportOrderMappingGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * Delete the filter with the given filterId and userId. The permission COMPANY_MODIFY is required to execute this operation.
     * @summary Delete filter by id
     * @param {string} [filterId] filterId
     * @param {string} [userId] userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteFilter(filterId?: string, userId?: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteFilter(filterId, userId, options)(this.fetch, this.basePath);
    }

    /**
     * Removes a partner and cancels the partnership between two companies.
     * @summary delete
     * @param {string} partnerCompanyId partnerCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deletePartner(partnerCompanyId: string, options?: any) {
        return CompanyApiFp(this.configuration).deletePartner(partnerCompanyId, options)(this.fetch, this.basePath);
    }

    /**
     * Use this endpoint to remove a user from the companies users list. The permission USER_DELETE is required to execute this operation
     * @summary Delete user by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteUserById(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteUserById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Removes the user role with the specified role id.
     * @summary Delete user role by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteUserRoleById(id: string, options?: any) {
        return CompanyApiFp(this.configuration).deleteUserRoleById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Modify the filter name depending upon the filter id and return the updated filter list
     * @summary Modify filter name as per the id
     * @param {ModifyFilterName} ModifyFilterName ModifyFilterName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public editFilterName(ModifyFilterName: ModifyFilterName, options?: any) {
        return CompanyApiFp(this.configuration).editFilterName(ModifyFilterName, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all users of all partners for the current company. In order to call this operation the permission USERS_VIEW is required
     * @summary Get List of users for all partner companies
     * @param {string} query query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchAllPartnersUsers(query: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchAllPartnersUsers(query, options)(this.fetch, this.basePath);
    }

    /**
     * Returns list of all partner companies with list of validationRules    
     * @summary Get List of all partner companies with list of validationRules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchAllPartnersValidationRuleNames(options?: any) {
        return CompanyApiFp(this.configuration).fetchAllPartnersValidationRuleNames(options)(this.fetch, this.basePath);
    }

    /**
     * Fetch address book and drivers of the user's company.
     * @summary fetch company's address book and drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyAddressBookAndDrivers(options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyAddressBookAndDrivers(options)(this.fetch, this.basePath);
    }

    /**
     * Returns all company address mapping groups of this company
     * @summary Get a list of all customer address mapping groups
     * @param {number} [skip] skip
     * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyAddressMappingGroups(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyAddressMappingGroups(skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all user defined address mappings defined for this company.
     * @summary Get a list of all customer address mappings
     * @param {Array<string>} [onlyGroupIds] onlyGroupIds
     * @param {number} [skip] skip
     * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyAddressMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyAddressMappingList(onlyGroupIds, skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all user defined address mappings defined for this company without authentication.
     * @summary Get a list of all customer address mappings
     * @param {string} token token
     * @param {string} [pin] pin
     * @param {Array<string>} [onlyGroupIds] onlyGroupIds
     * @param {number} [skip] skip
     * @param {'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyAddressMappingListPublic(token: string, pin?: string, onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'NAME' | 'COUNTRY' | 'ZIPCODE' | 'STREET' | 'HOUSE_NO' | 'CITY' | 'KIND' | 'EXTERNAL_ADDRESS_NUMBER' | 'EXTERNAL_ADDRESS_NUMBER2' | 'REPLACE_WITH_NAME' | 'REPLACE_WITH_NAME2' | 'REPLACE_WITH_EXTERNAL_STOP_ID' | 'REPLACE_WITH_ZIPCODE' | 'REPLACE_WITH_STREET' | 'REPLACE_WITH_HOUSE_NO' | 'REPLACE_WITH_CITY' | 'OBSERVER', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyAddressMappingListPublic(token, pin, onlyGroupIds, skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the company with the specified companyId, if the currently authenticated user has the permission to view that company.
     * @summary get company by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyById(id: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all user definied freight mapping groups defined for this company.
     * @summary Get a list of all freight mapping groups
     * @param {number} [skip] skip
     * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyFreightMappingGroupList(skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyFreightMappingGroupList(skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all user defined freight mappings for this company.
     * @summary Get a list of all freight mapping
     * @param {Array<string>} [onlyGroupIds] onlyGroupIds
     * @param {number} [skip] skip
     * @param {'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyFreightMappingList(onlyGroupIds?: Array<string>, skip?: number, sortBy?: 'MATCH_ON_FREIGHT_ID' | 'MATCH_ON_CONTAINMENT_NAME' | 'MATCH_ON_CONTAINMENT_TYPE' | 'MATCH_ON_DELIVERY_NUMBER' | 'MATCH_ON_EXTERNAL_FREIGHT_ID' | 'MATCH_ON_VERBOSE_NAME' | 'REPLACE_WITH_FREIGHT_ID' | 'REPLACE_WITH_CONTAINMENT_NAME' | 'REPLACE_WITH_CONTAINMENT_TYPE' | 'REPLACE_WITH_DELIVERY_NUMBER' | 'REPLACE_WITH_EXTERNAL_FREIGHT_ID' | 'REPLACE_WITH_VERBOSE_NAME', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyFreightMappingList(onlyGroupIds, skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the company of the currently authenticated user.
     * @summary get current company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyOfUser(options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyOfUser(options)(this.fetch, this.basePath);
    }

    /**
     * Fetch Company tags as per company id
     * @summary Fetch Company tags as per company id
     * @param {FetchCompanyTagsRequest} FetchCompanyTagsRequest FetchCompanyTagsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyTags(FetchCompanyTagsRequest: FetchCompanyTagsRequest, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyTags(FetchCompanyTagsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all user definied transportOrder mapping groups defined for this company.
     * @summary Get a list of all transportOrder mapping groups
     * @param {number} [skip] skip
     * @param {string} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyTransportOrderMappingGroupList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyTransportOrderMappingGroupList(skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all user defined transportOrder mappings for this company.
     * @summary Get a list of all transportOrder mapping
     * @param {number} [skip] skip
     * @param {string} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyTransportOrderMappingList(skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyTransportOrderMappingList(skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all user defined transportOrder mappings based the specific group id for this company.
     * @summary Get a list of all transportOrder mapping by group id
     * @param {string} groupId groupId
     * @param {number} [skip] skip
     * @param {string} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchCompanyTransportOrderMappingListByGroupId(groupId: string, skip?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchCompanyTransportOrderMappingListByGroupId(groupId, skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a single driver with the specified driverId. The permission DRIVER_VIEW is required to fetch a driver
     * @summary Get a driver
     * @param {string} driverId driverId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchDriver(driverId: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchDriver(driverId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of drivers which are assigned to the users company. The permission DRIVER_VIEW is required to access this endpoint.
     * @summary Get all drivers
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchDriverList(limit?: number, query?: string, skip?: number, sortBy?: 'FIRST_NAME' | 'LAST_NAME' | 'LANGUAGE' | 'PHONE_NUMBER', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CompanyApiFp(this.configuration).fetchDriverList(limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns one row per relevant transport order (DONE or EXECUTING) for every vehicle in the company within [sinceTimestamp, toTimestamp], enriched with the empty-kilometre gap to the previous tour, plausibility flags, hints, consolidated-shipment group label, FMS odometer values, customer (FRM key from freight additionalData) and stop coordinates.  Replaces the per-company `reportScript` based XLSX flow for the on-demand empty-kilometre dashboard. Optionally filterable by a list of vehicle number plates.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
     * @summary Get the empty-kilometres report for all vehicles in the given window
     * @param {EmptyKilometersReportRequest} EmptyKilometersReportRequest EmptyKilometersReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchEmptyKilometersReport(EmptyKilometersReportRequest: EmptyKilometersReportRequest, options?: any) {
        return CompanyApiFp(this.configuration).fetchEmptyKilometersReport(EmptyKilometersReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Detail view behind one row of the empty-kilometre report: the GPS track between [sinceTimestamp, toTimestamp] split into driving and standing clusters (same segmentation the tour map uses), each standing cluster reverse geocoded to a city, and the DTCO activities of every driver that was on the truck in that window.  Standing clusters that sit at the last stop of the previous tour or at the first stop of the following one are flagged, so the caller can label them. When no DTCO logbook exists, `gpsDrivingSeconds` / `gpsStandingSeconds` carry the GPS approximation of driving versus everything else.  The permission VIEW_EMPTY_KM_REPORT is required. Super users bypass this check; companyAdmins do NOT — they must have the permission granted explicitly.
     * @summary Get what the truck did during one empty run
     * @param {EmptyKilometersRunDetailsRequest} EmptyKilometersRunDetailsRequest EmptyKilometersRunDetailsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchEmptyKilometersRunDetails(EmptyKilometersRunDetailsRequest: EmptyKilometersRunDetailsRequest, options?: any) {
        return CompanyApiFp(this.configuration).fetchEmptyKilometersRunDetails(EmptyKilometersRunDetailsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * return empty tours for a vehicle
     * @summary get EmptyTours for a vehicle
     * @param {VehicleEmptyTourRequest} VehicleEmptyTourRequest VehicleEmptyTourRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchEmptyTours(VehicleEmptyTourRequest: VehicleEmptyTourRequest, options?: any) {
        return CompanyApiFp(this.configuration).fetchEmptyTours(VehicleEmptyTourRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch the filters as per user id and company specific
     * @summary Fetch filters as per user id and company id
     * @param {string} [companyId] companyId
     * @param {string} [userId] userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchFilters(companyId?: string, userId?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchFilters(companyId, userId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all incoming partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
     * @summary invitation list
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchIncomingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CompanyApiFp(this.configuration).fetchIncomingInvitationList(limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the partnership invitation identified by the randomInvitation token. Everyone can access this invitation if he knows the randomInvitationToken. No further authentication is needed.
     * @summary get invitation by random token
     * @param {string} randomInvitationId randomInvitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchInvitationByToken(randomInvitationId: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchInvitationByToken(randomInvitationId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all outgoing partnership invitations for the users company. The executionResult list also indicates the status (pending, accepted, rejected) of the invitation.
     * @summary invitation list
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchOutgoingInvitationList(limit?: number, query?: string, skip?: number, sortBy?: 'INVITING_COMPANY_NAME' | 'INVITING_USER_ID' | 'INVITING_CONTACT_NAME' | 'INVITING_CONTACT_EMAIL' | 'INVITED_COMPANY_NAME' | 'INVITED_CONTACT_NAME' | 'INVITED_CONTACT_EMAIL' | 'TIMESTAMP' | 'STATUS' | 'RANDOM_ID_TOKEN', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CompanyApiFp(this.configuration).fetchOutgoingInvitationList(limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all partner companies including the externalId given for them. The permission COMPANY_VIEW_PARTNERS is required to to execute this operation
     * @summary get all partners
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchPartnerList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'TAG' | 'CITY' | 'ZIP_CODE' | 'STREET' | 'COUNTRY', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CompanyApiFp(this.configuration).fetchPartnerList(limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of users for the specified partner company.
     * @summary Get List of users for a partner company
     * @param {string} partnerCompanyId partnerCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchPartnerUsers(partnerCompanyId: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchPartnerUsers(partnerCompanyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the roles of the user of the given user id (for the availableCompany of the calling user). The permission USER_ROLES_VIEW is required to call this operation.
     * @summary Fetch roles of the user with id
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchRolesForUser(userId: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchRolesForUser(userId, options)(this.fetch, this.basePath);
    }

    /**
     * Get the user with the specified external user id.
     * @summary Find User by external user id
     * @param {string} externalId externalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchUserByExternalUserId(externalId: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchUserByExternalUserId(externalId, options)(this.fetch, this.basePath);
    }

    /**
     * Get the user with the specified user id.
     * @summary Find User by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchUserById(id: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchUserById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the user role of the specified userRoleId. The permission USER_ROLES_VIEW is required to execute this operation
     * @summary Get user role by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchUserRoleById(id: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchUserRoleById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all user roles of the current company. The permission USER_ROLES_VIEW is required to execute this operation.
     * @summary Get all user roles
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'NAME' | 'PERMISSION'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchUserRoleList(limit?: number, query?: string, skip?: number, sortBy?: 'NAME' | 'PERMISSION', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CompanyApiFp(this.configuration).fetchUserRoleList(limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the user roles of the specified userRoleIds. The permission USER_ROLES_VIEW is required to execute this operation
     * @summary Get user role by id
     * @param {Array<string>} ids ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchUserRolesByIds(ids: Array<string>, options?: any) {
        return CompanyApiFp(this.configuration).fetchUserRolesByIds(ids, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of users which are currently member of the role with the specified id.
     * @summary Get all users which are member of a given UserRole
     * @param {string} roleId roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchUsersWithRole(roleId: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchUsersWithRole(roleId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a single vehicle with the specified vehicleId. The permission VEHICLE_VIEW is required to fetch a vehicle
     * @summary Get a vehicle
     * @param {string} vehicleId vehicleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchVehicle(vehicleId: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchVehicle(vehicleId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the distinct, non-blank values of properties.additionalData[key=\"apiGatewaySource\"] across all vehicles visible to the calling user. Used to populate the data-source filter in the fleet view. The permission VEHICLE_VIEW is required to access this endpoint.
     * @summary Get distinct apiGatewaySource values across the company's vehicles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchVehicleApiGatewaySources(options?: any) {
        return CompanyApiFp(this.configuration).fetchVehicleApiGatewaySources(options)(this.fetch, this.basePath);
    }

    /**
     * Computes empty-leg kilometres between consecutive non-overlapping transport orders that the given vehicle performed in [sinceTimestamp, toTimestamp]. Reads odometer values from each stop's `additionalData` (preferring FMS keys `vehicle.odometer.on.arrive` / `vehicle.odometer.on.depart`, with a virtual odometer fallback) — does NOT depend on the GPS position stream like the legacy /emptyTour endpoint, so it works for clients whose feeds carry odometer values in stop additionalData rather than tagged GPS samples.  Returns one segment per gap with the computed empty km, route (from-city → to-city), source flag (FMS / VIRTUAL / …), plausibility flag, Sammelladung group label when an overlap is detected, and human-readable hints. Tours with no plate or in non-relevant statuses (anything other than DONE / EXECUTING) are skipped before grouping.  The permission VEHICLE_VIEW is required.
     * @summary Get empty kilometres between consecutive transport orders for a vehicle
     * @param {VehicleEmptyKilometersRequest} VehicleEmptyKilometersRequest VehicleEmptyKilometersRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchVehicleEmptyKilometers(VehicleEmptyKilometersRequest: VehicleEmptyKilometersRequest, options?: any) {
        return CompanyApiFp(this.configuration).fetchVehicleEmptyKilometers(VehicleEmptyKilometersRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of vehicles which are assigned to the users company. The permission VEHICLE_VIEW is required to access this endpoint.
     * @summary Get all vehicles
     * @param {string} [apiGatewaySource] apiGatewaySource
     * @param {number} [skip] skip
     * @param {'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {number} [take] take
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public fetchVehicleList(apiGatewaySource?: string, skip?: number, sortBy?: 'EXTERNAL_VEHICLE_ID' | 'NUMBER_PLATE' | 'TYPE' | 'OWNER' | 'ALIAS' | 'TIMESTAMP', sortDirection?: 'ASC' | 'DESC', take?: number, term?: string, options?: any) {
        return CompanyApiFp(this.configuration).fetchVehicleList(apiGatewaySource, skip, sortBy, sortDirection, take, term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a report containing empty tour report for all company vehicles for the last month
     * @summary returns Empty tour report
     * @param {VehiclesReportRequest} VehiclesReportRequest VehiclesReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getEmptyTourReport(VehiclesReportRequest: VehiclesReportRequest, options?: any) {
        return CompanyApiFp(this.configuration).getEmptyTourReport(VehiclesReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns List of partners that can link to the users company
     * @summary Get List of partners that can link to the users company 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public linkingPartners(options?: any) {
        return CompanyApiFp(this.configuration).linkingPartners(options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all members of the company.
     * @summary Get List of users
     * @param {string} [externalUserId] externalUserId
     * @param {number} [limit] limit
     * @param {string} [q] q
     * @param {number} [skip] skip
     * @param {'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public listUsers(externalUserId?: string, limit?: number, q?: string, skip?: number, sortBy?: 'EMAIL' | 'PHONE_NUMBER' | 'FIRST_NAME' | 'LAST_NAME' | 'COMPANY_ADMIN' | 'PERMISSIONS' | 'EMAIL_VERIFIED' | 'PHONE_VERIFIED' | 'STATE' | 'ROLES' | 'PREFERRED_LANGUAGE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return CompanyApiFp(this.configuration).listUsers(externalUserId, limit, q, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies a customer address mapping
     * @summary Modify single customerAddressMapping with the given id
     * @param {string} id id
     * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyCompanyAddressMapping(id: string, CompanyAddressMapping: CompanyAddressMapping, options?: any) {
        return CompanyApiFp(this.configuration).modifyCompanyAddressMapping(id, CompanyAddressMapping, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies a customer address mapping group
     * @summary Modify single customerAddressMappingGroup with the given id
     * @param {string} id id
     * @param {CompanyAddressMappingGroup} CompanyAddressMappingGroup CompanyAddressMappingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyCompanyAddressMappingGroup(id: string, CompanyAddressMappingGroup: CompanyAddressMappingGroup, options?: any) {
        return CompanyApiFp(this.configuration).modifyCompanyAddressMappingGroup(id, CompanyAddressMappingGroup, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies a customer freight mapping
     * @summary Modify single customerFreightMapping with the given id
     * @param {string} id id
     * @param {CompanyFreightMapping} CompanyFreightMapping CompanyFreightMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyCompanyFreightMapping(id: string, CompanyFreightMapping: CompanyFreightMapping, options?: any) {
        return CompanyApiFp(this.configuration).modifyCompanyFreightMapping(id, CompanyFreightMapping, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies a customer freight mapping group
     * @summary Modify single customerFreightMappingGroup with the given id
     * @param {string} id id
     * @param {CompanyFreightMappingGroup} CompanyFreightMappingGroup CompanyFreightMappingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyCompanyFreightMappingGroup(id: string, CompanyFreightMappingGroup: CompanyFreightMappingGroup, options?: any) {
        return CompanyApiFp(this.configuration).modifyCompanyFreightMappingGroup(id, CompanyFreightMappingGroup, options)(this.fetch, this.basePath);
    }

    /**
     * Modify a company tag
     * @summary Modify company tag
     * @param {string} id id
     * @param {CompanyTag} CompanyTag CompanyTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyCompanyTag(id: string, CompanyTag: CompanyTag, options?: any) {
        return CompanyApiFp(this.configuration).modifyCompanyTag(id, CompanyTag, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies a customer TransportOrder Mapping
     * @summary Modify single customerTransportOrderMapping with the given id
     * @param {string} id id
     * @param {CompanyTransportOrderMapping} CompanyTransportOrderMapping CompanyTransportOrderMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyCompanyTransportOrderMapping(id: string, CompanyTransportOrderMapping: CompanyTransportOrderMapping, options?: any) {
        return CompanyApiFp(this.configuration).modifyCompanyTransportOrderMapping(id, CompanyTransportOrderMapping, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies a customer TransportOrder mapping group
     * @summary Modify single customerTransportOrderMappingGroup with the given id
     * @param {string} id id
     * @param {CompanyTransportOrderMappingGroup} CompanyTransportOrderMappingGroup CompanyTransportOrderMappingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyCompanyTransportOrderMappingGroup(id: string, CompanyTransportOrderMappingGroup: CompanyTransportOrderMappingGroup, options?: any) {
        return CompanyApiFp(this.configuration).modifyCompanyTransportOrderMappingGroup(id, CompanyTransportOrderMappingGroup, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies the driver with the specified driverId. This method checks that there is no other driver with the given externalDriverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to call this endpoint.
     * @summary Modify driver by id
     * @param {string} driverId driverId
     * @param {DriverRequest} DriverRequest DriverRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyDriverById(driverId: string, DriverRequest: DriverRequest, options?: any) {
        return CompanyApiFp(this.configuration).modifyDriverById(driverId, DriverRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies the user role of the given role id. The USER_ROLES_CREATE_MODIFY_DELETE permission is required to execute this operation.
     * @summary Modify user role by id
     * @param {string} id id
     * @param {UserRoleRequest} UserRoleRequest UserRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyUserRoleById(id: string, UserRoleRequest: UserRoleRequest, options?: any) {
        return CompanyApiFp(this.configuration).modifyUserRoleById(id, UserRoleRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies the vehicles with the specified vehicleId. This method checks that there is no other vehicles with the given numberPlate or externalVehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to call this endpoint.
     * @summary Modify vehicles by id
     * @param {string} vehicleId vehicleId
     * @param {VehicleRequest} VehicleRequest VehicleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public modifyVehicleById(vehicleId: string, VehicleRequest: VehicleRequest, options?: any) {
        return CompanyApiFp(this.configuration).modifyVehicleById(vehicleId, VehicleRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all companies. The superuser permission is required to execute this operation.
     * @summary List all companies
     * @param {string} term term
     * @param {boolean} [includeArchived] includeArchived
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public queryCompanies(term: string, includeArchived?: boolean, options?: any) {
        return CompanyApiFp(this.configuration).queryCompanies(term, includeArchived, options)(this.fetch, this.basePath);
    }

    /**
     * Register a new company with the given registration data. This endpoint sends an email to the user who sent the registration.
     * @summary register new company
     * @param {Registration} Registration Registration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public registerCompany(Registration: Registration, options?: any) {
        return CompanyApiFp(this.configuration).registerCompany(Registration, options)(this.fetch, this.basePath);
    }

    /**
     * Removes the driver with the given driverId. The permission DRIVER_CREATE_MODIFY_DELETE is required to execute this operation.
     * @summary Delete driver by id
     * @param {string} driverId driverId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public removeDriver(driverId: string, options?: any) {
        return CompanyApiFp(this.configuration).removeDriver(driverId, options)(this.fetch, this.basePath);
    }

    /**
     * Removes the user from the specified role
     * @summary Delete role membership of user
     * @param {string} roleId roleId
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public removeRoleFromUser(roleId: string, userId: string, options?: any) {
        return CompanyApiFp(this.configuration).removeRoleFromUser(roleId, userId, options)(this.fetch, this.basePath);
    }

    /**
     * Removes the vehicles with the given vehicleId. The permission VEHICLE_CREATE_MODIFY_DELETE is required to execute this operation.
     * @summary Delete vehicles by id
     * @param {string} vehicleId vehicleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public removeVehicle(vehicleId: string, options?: any) {
        return CompanyApiFp(this.configuration).removeVehicle(vehicleId, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint takes a company address mapping group (parameter groupId) and a list of company address mappings.  Then, it deletes all company address mappings which are currently present in the specified group of address mappings  and it inserts the given list of address mappings into the given group of company address mappings. 
     * @summary Replace all customerAddressMappings of the given group with the given list of company address mappings
     * @param {ReplaceCompanyAddressMappingRequest} ReplaceCompanyAddressMappingRequest ReplaceCompanyAddressMappingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public replaceCompanyAddressMappingList(ReplaceCompanyAddressMappingRequest: ReplaceCompanyAddressMappingRequest, options?: any) {
        return CompanyApiFp(this.configuration).replaceCompanyAddressMappingList(ReplaceCompanyAddressMappingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint takes a company Freight mapping group (parameter groupId) and a list of company freight mappings.  Then, it deletes all company Freight mappings which are currently present in the specified group of freight mappings  and it inserts the given list of freight mappings into the given group of company freight mappings. 
     * @summary Replace all customerFreightMappings of the given group with the given list of company Freight mappings
     * @param {ReplaceCompanyFreightMappingRequest} ReplaceCompanyFreightMappingRequest ReplaceCompanyFreightMappingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public replaceCompanyFreightMappingList(ReplaceCompanyFreightMappingRequest: ReplaceCompanyFreightMappingRequest, options?: any) {
        return CompanyApiFp(this.configuration).replaceCompanyFreightMappingList(ReplaceCompanyFreightMappingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint takes a company transportOrder mapping group (parameter groupId) and a list of company transportOrder mappings.  Then, it deletes all company transportOrder mappings which are currently present in the specified group of transportOrder mappings  and it inserts the given list of transportOrder mappings into the given group of company transportOrder mappings. 
     * @summary Replace all customerTransportOrderMappings of the given group with the given list of company transportOrder mappings
     * @param {ReplaceCompanyTransportOrderMappingRequest} ReplaceCompanyTransportOrderMappingRequest ReplaceCompanyTransportOrderMappingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public replaceCompanyTransportOrderMappingList(ReplaceCompanyTransportOrderMappingRequest: ReplaceCompanyTransportOrderMappingRequest, options?: any) {
        return CompanyApiFp(this.configuration).replaceCompanyTransportOrderMappingList(ReplaceCompanyTransportOrderMappingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches all rules that are used for validation of transportOrders from the sourceCompany of the given transportOrder.
     * @summary runs all status validation rules for this TransportOrder and gives back results
     * @param {RunTransportOrderStatusValidationsRequest} RunTransportOrderStatusValidationsRequest RunTransportOrderStatusValidationsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public runTransportOrderStatusValidations(RunTransportOrderStatusValidationsRequest: RunTransportOrderStatusValidationsRequest, options?: any) {
        return CompanyApiFp(this.configuration).runTransportOrderStatusValidations(RunTransportOrderStatusValidationsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings
     * @summary sends the TransportOrderValidationMails for the given TransportOrders, if they have active warnings 
     * @param {SendTransportOrderStatusValidationsMailsNowRequest} SendTransportOrderStatusValidationsMailsNowRequest SendTransportOrderStatusValidationsMailsNowRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public sendTransportOrderStatusValidationsMailsNow(SendTransportOrderStatusValidationsMailsNowRequest: SendTransportOrderStatusValidationsMailsNowRequest, options?: any) {
        return CompanyApiFp(this.configuration).sendTransportOrderStatusValidationsMailsNow(SendTransportOrderStatusValidationsMailsNowRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Assigns the role linked to the given roleId to the User of the given userId
     * @summary Set the roles of the user
     * @param {string} userId userId
     * @param {RolesOfUserRequest} RolesOfUserRequest RolesOfUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public setRolesOfUser(userId: string, RolesOfUserRequest: RolesOfUserRequest, options?: any) {
        return CompanyApiFp(this.configuration).setRolesOfUser(userId, RolesOfUserRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Updated the acknowledged flag on warnings in transportOrders
     * @summary updates acknowledged flag on a 
     * @param {UpdateAcknowledgedOnStatusValidationRequest} UpdateAcknowledgedOnStatusValidationRequest UpdateAcknowledgedOnStatusValidationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateAcknowledgeOnStatusValidation(UpdateAcknowledgedOnStatusValidationRequest: UpdateAcknowledgedOnStatusValidationRequest, options?: any) {
        return CompanyApiFp(this.configuration).updateAcknowledgeOnStatusValidation(UpdateAcknowledgedOnStatusValidationRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Update the company of the given companyId using the posted data. This method can be called, if the currently authenticated user has the permission to modify the specified company. this endpoint will return the updated Company object.
     * @summary update company
     * @param {string} id id
     * @param {Company} Company Company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateCompany(id: string, Company: Company, options?: any) {
        return CompanyApiFp(this.configuration).updateCompany(id, Company, options)(this.fetch, this.basePath);
    }

    /**
     * Update company's ignore list of customer report.
     * @summary Update company's ignore list of customer report.
     * @param {UpdateIgnoreListForCustomerReportForAllCompaniesRequest} UpdateIgnoreListForCustomerReportForAllCompaniesRequest UpdateIgnoreListForCustomerReportForAllCompaniesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateIgnoreListForCustomerReportForAllCompanies(UpdateIgnoreListForCustomerReportForAllCompaniesRequest: UpdateIgnoreListForCustomerReportForAllCompaniesRequest, options?: any) {
        return CompanyApiFp(this.configuration).updateIgnoreListForCustomerReportForAllCompanies(UpdateIgnoreListForCustomerReportForAllCompaniesRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Changes the status of a pending invitation. The status of the invitation can either be changed by the inviting party or by the invited party. However, the user calling this method requires the COMPANY_MODIFY_PARTNERS permission to execute this operation.
     * @summary accept or reject invitation
     * @param {string} randomInvitationId randomInvitationId
     * @param {PartnerInvitationStatusUpdate} PartnerInvitationStatusUpdate PartnerInvitationStatusUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateInvitationStatus(randomInvitationId: string, PartnerInvitationStatusUpdate: PartnerInvitationStatusUpdate, options?: any) {
        return CompanyApiFp(this.configuration).updateInvitationStatus(randomInvitationId, PartnerInvitationStatusUpdate, options)(this.fetch, this.basePath);
    }

    /**
     * Update the external partner id of a partner company using the posted data. This method can be called, if the currently authenticated user has the permission to modify partners.
     * @summary update external partner id
     * @param {string} partnerCompanyId partnerCompanyId
     * @param {Partner} Partner Partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updatePartnerById(partnerCompanyId: string, Partner: Partner, options?: any) {
        return CompanyApiFp(this.configuration).updatePartnerById(partnerCompanyId, Partner, options)(this.fetch, this.basePath);
    }

    /**
     * Modify the specified user by the given user id. This operation allows partial updates. If properties are left blank, the old values are preserved. The permission USERS_MODIFY is required to execute this operation and only users of the same company as the caller can be modified.
     * @summary Modify user by id
     * @param {string} id id
     * @param {UserRequest} UserRequest UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateUserById(id: string, UserRequest: UserRequest, options?: any) {
        return CompanyApiFp(this.configuration).updateUserById(id, UserRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Check whether the given external driver ID is not yet taken by an already existing driver in this company.
     * @summary Validate driver external Id
     * @param {DriverRequest} DriverRequest DriverRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public validateDriverExternalId(DriverRequest: DriverRequest, options?: any) {
        return CompanyApiFp(this.configuration).validateDriverExternalId(DriverRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Validate user data
     * @param {EmailRequest} EmailRequest EmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public validateUser(EmailRequest: EmailRequest, options?: any) {
        return CompanyApiFp(this.configuration).validateUser(EmailRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Check whether the given external vehicles ID is not yet taken by an already existing vehicles in this company.
     * @summary Validate vehicles external Id
     * @param {VehicleRequest} VehicleRequest VehicleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public validateVehicleExternalId(VehicleRequest: VehicleRequest, options?: any) {
        return CompanyApiFp(this.configuration).validateVehicleExternalId(VehicleRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Check whether the given number plate is not yet taken by an already existing vehicles in this company.
     * @summary Validate vehicles numberPlate
     * @param {VehicleRequest} VehicleRequest VehicleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public validateVehicleNumberPlate(VehicleRequest: VehicleRequest, options?: any) {
        return CompanyApiFp(this.configuration).validateVehicleNumberPlate(VehicleRequest, options)(this.fetch, this.basePath);
    }

}

/**
 * EventsApi - fetch parameter creator
 * @export
 */
export const EventsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set an event as processed.
         * @summary Set event from queue processed
         * @param {string} eventId eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueuedEvent(eventId: string, options: any = {}): FetchArgs {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling deleteQueuedEvent.');
            }
            const localVarPath = `/queuedEvents/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns the last 250 events which are enqueued in any queue of type API-Sync the user's company. After processing those events, the events must be either marked as processed using the [updateQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/updateQueuedEvent) operation or completely removed from the queue using the [deleteQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/deleteQueuedEvent) method.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui.
         * @summary get all queued events
         * @param {number} [limit] limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllQueuedEvents(limit?: number, options: any = {}): FetchArgs {
            const localVarPath = `/queuedEvents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns an event identified by the event id. It must belong to the current company of the user. 
         * @summary gets a queued event by id
         * @param {string} eventId eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventById(eventId: string, options: any = {}): FetchArgs {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling fetchQueuedEventById.');
            }
            const localVarPath = `/queuedEvents/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns all events for queues of the specified queue type API_SYNC. This is the default endpoint to fetch new events.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui. Please note that this endpoint only returns events caused by other companies. If one want to get events for actions caused by the own company, please request to enable event mirroring.
         * @summary get Queued events for queue of API_SYNC.
         * @param {number} [limit] limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEvents(limit?: number, options: any = {}): FetchArgs {
            const localVarPath = `/queuedEvents/apiSync/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns a report of processed events with ERROR state for all companies (InternalMonitoring-only).
         * @summary get a report of processed events with ERROR state for all companies (InternalMonitoring-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuedEventsErrorReport(options: any = {}): FetchArgs {
            const localVarPath = `/queuedEvents/getQueuedEventsErrorReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns a report of the current queuedEvent situation of all companies (InternalMonitoring-only).
         * @summary get a report of the current queuedEvent situation of all companies (InternalMonitoring-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuedEventsHealthReport(options: any = {}): FetchArgs {
            const localVarPath = `/queuedEvents/getQueuedEventsHealthReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to modify a queued event in our message queue.
         * @summary Modify queued event
         * @param {string} eventId eventId
         * @param {QueuedEvent} QueuedEvent QueuedEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEvent(eventId: string, QueuedEvent: QueuedEvent, options: any = {}): FetchArgs {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling updateQueuedEvent.');
            }
            // verify required parameter 'QueuedEvent' is not null or undefined
            if (QueuedEvent === null || QueuedEvent === undefined) {
                throw new RequiredError('QueuedEvent','Required parameter QueuedEvent was null or undefined when calling updateQueuedEvent.');
            }
            const localVarPath = `/queuedEvents/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"QueuedEvent" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(QueuedEvent || {}) : (QueuedEvent || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint modifies the status of an queued event. It must belong to the current company of the user or the caller must be superuser. It can specifiy if the event was processed and set a processing info 
         * @summary modifies status of  a queued event by id
         * @param {string} eventId eventId
         * @param {QueuedEventStatusRequest} QueuedEventStatusRequest QueuedEventStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEventStatus(eventId: string, QueuedEventStatusRequest: QueuedEventStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling updateQueuedEventStatus.');
            }
            // verify required parameter 'QueuedEventStatusRequest' is not null or undefined
            if (QueuedEventStatusRequest === null || QueuedEventStatusRequest === undefined) {
                throw new RequiredError('QueuedEventStatusRequest','Required parameter QueuedEventStatusRequest was null or undefined when calling updateQueuedEventStatus.');
            }
            const localVarPath = `/queuedEvents/{eventId}/setStatus`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"QueuedEventStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(QueuedEventStatusRequest || {}) : (QueuedEventStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Set an event as processed.
         * @summary Set event from queue processed
         * @param {string} eventId eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueuedEvent(eventId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).deleteQueuedEvent(eventId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns the last 250 events which are enqueued in any queue of type API-Sync the user's company. After processing those events, the events must be either marked as processed using the [updateQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/updateQueuedEvent) operation or completely removed from the queue using the [deleteQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/deleteQueuedEvent) method.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui.
         * @summary get all queued events
         * @param {number} [limit] limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllQueuedEvents(limit?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventResponse> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).fetchAllQueuedEvents(limit, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns an event identified by the event id. It must belong to the current company of the user. 
         * @summary gets a queued event by id
         * @param {string} eventId eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventById(eventId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEvent> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).fetchQueuedEventById(eventId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns all events for queues of the specified queue type API_SYNC. This is the default endpoint to fetch new events.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui. Please note that this endpoint only returns events caused by other companies. If one want to get events for actions caused by the own company, please request to enable event mirroring.
         * @summary get Queued events for queue of API_SYNC.
         * @param {number} [limit] limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEvents(limit?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventResponse> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).fetchQueuedEvents(limit, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns a report of processed events with ERROR state for all companies (InternalMonitoring-only).
         * @summary get a report of processed events with ERROR state for all companies (InternalMonitoring-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuedEventsErrorReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventsErrorReports> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).getQueuedEventsErrorReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns a report of the current queuedEvent situation of all companies (InternalMonitoring-only).
         * @summary get a report of the current queuedEvent situation of all companies (InternalMonitoring-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuedEventsHealthReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventsHealthReports> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).getQueuedEventsHealthReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Use this endpoint to modify a queued event in our message queue.
         * @summary Modify queued event
         * @param {string} eventId eventId
         * @param {QueuedEvent} QueuedEvent QueuedEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEvent(eventId: string, QueuedEvent: QueuedEvent, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEvent> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).updateQueuedEvent(eventId, QueuedEvent, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint modifies the status of an queued event. It must belong to the current company of the user or the caller must be superuser. It can specifiy if the event was processed and set a processing info 
         * @summary modifies status of  a queued event by id
         * @param {string} eventId eventId
         * @param {QueuedEventStatusRequest} QueuedEventStatusRequest QueuedEventStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEventStatus(eventId: string, QueuedEventStatusRequest: QueuedEventStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEvent> {
            const localVarFetchArgs = EventsApiFetchParamCreator(configuration).updateQueuedEventStatus(eventId, QueuedEventStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Set an event as processed.
         * @summary Set event from queue processed
         * @param {string} eventId eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueuedEvent(eventId: string, options?: any) {
            return EventsApiFp(configuration).deleteQueuedEvent(eventId, options)(fetch, basePath);
        },
        /**
         * This endpoint returns the last 250 events which are enqueued in any queue of type API-Sync the user's company. After processing those events, the events must be either marked as processed using the [updateQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/updateQueuedEvent) operation or completely removed from the queue using the [deleteQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/deleteQueuedEvent) method.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui.
         * @summary get all queued events
         * @param {number} [limit] limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllQueuedEvents(limit?: number, options?: any) {
            return EventsApiFp(configuration).fetchAllQueuedEvents(limit, options)(fetch, basePath);
        },
        /**
         * This endpoint returns an event identified by the event id. It must belong to the current company of the user. 
         * @summary gets a queued event by id
         * @param {string} eventId eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventById(eventId: string, options?: any) {
            return EventsApiFp(configuration).fetchQueuedEventById(eventId, options)(fetch, basePath);
        },
        /**
         * This endpoint returns all events for queues of the specified queue type API_SYNC. This is the default endpoint to fetch new events.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui. Please note that this endpoint only returns events caused by other companies. If one want to get events for actions caused by the own company, please request to enable event mirroring.
         * @summary get Queued events for queue of API_SYNC.
         * @param {number} [limit] limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEvents(limit?: number, options?: any) {
            return EventsApiFp(configuration).fetchQueuedEvents(limit, options)(fetch, basePath);
        },
        /**
         * This endpoint returns a report of processed events with ERROR state for all companies (InternalMonitoring-only).
         * @summary get a report of processed events with ERROR state for all companies (InternalMonitoring-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuedEventsErrorReport(options?: any) {
            return EventsApiFp(configuration).getQueuedEventsErrorReport(options)(fetch, basePath);
        },
        /**
         * This endpoint returns a report of the current queuedEvent situation of all companies (InternalMonitoring-only).
         * @summary get a report of the current queuedEvent situation of all companies (InternalMonitoring-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuedEventsHealthReport(options?: any) {
            return EventsApiFp(configuration).getQueuedEventsHealthReport(options)(fetch, basePath);
        },
        /**
         * Use this endpoint to modify a queued event in our message queue.
         * @summary Modify queued event
         * @param {string} eventId eventId
         * @param {QueuedEvent} QueuedEvent QueuedEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEvent(eventId: string, QueuedEvent: QueuedEvent, options?: any) {
            return EventsApiFp(configuration).updateQueuedEvent(eventId, QueuedEvent, options)(fetch, basePath);
        },
        /**
         * This endpoint modifies the status of an queued event. It must belong to the current company of the user or the caller must be superuser. It can specifiy if the event was processed and set a processing info 
         * @summary modifies status of  a queued event by id
         * @param {string} eventId eventId
         * @param {QueuedEventStatusRequest} QueuedEventStatusRequest QueuedEventStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEventStatus(eventId: string, QueuedEventStatusRequest: QueuedEventStatusRequest, options?: any) {
            return EventsApiFp(configuration).updateQueuedEventStatus(eventId, QueuedEventStatusRequest, options)(fetch, basePath);
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * Set an event as processed.
     * @summary Set event from queue processed
     * @param {string} eventId eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteQueuedEvent(eventId: string, options?: any) {
        return EventsApiFp(this.configuration).deleteQueuedEvent(eventId, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns the last 250 events which are enqueued in any queue of type API-Sync the user's company. After processing those events, the events must be either marked as processed using the [updateQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/updateQueuedEvent) operation or completely removed from the queue using the [deleteQueuedEvent](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/deleteQueuedEvent) method.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui.
     * @summary get all queued events
     * @param {number} [limit] limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public fetchAllQueuedEvents(limit?: number, options?: any) {
        return EventsApiFp(this.configuration).fetchAllQueuedEvents(limit, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns an event identified by the event id. It must belong to the current company of the user. 
     * @summary gets a queued event by id
     * @param {string} eventId eventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public fetchQueuedEventById(eventId: string, options?: any) {
        return EventsApiFp(this.configuration).fetchQueuedEventById(eventId, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns all events for queues of the specified queue type API_SYNC. This is the default endpoint to fetch new events.  **Hint** Should this operation never provide any events, please check that the API-Queue checkbox is marked on the Company/Settings page in our Web-Ui. Please note that this endpoint only returns events caused by other companies. If one want to get events for actions caused by the own company, please request to enable event mirroring.
     * @summary get Queued events for queue of API_SYNC.
     * @param {number} [limit] limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public fetchQueuedEvents(limit?: number, options?: any) {
        return EventsApiFp(this.configuration).fetchQueuedEvents(limit, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns a report of processed events with ERROR state for all companies (InternalMonitoring-only).
     * @summary get a report of processed events with ERROR state for all companies (InternalMonitoring-only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getQueuedEventsErrorReport(options?: any) {
        return EventsApiFp(this.configuration).getQueuedEventsErrorReport(options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns a report of the current queuedEvent situation of all companies (InternalMonitoring-only).
     * @summary get a report of the current queuedEvent situation of all companies (InternalMonitoring-only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getQueuedEventsHealthReport(options?: any) {
        return EventsApiFp(this.configuration).getQueuedEventsHealthReport(options)(this.fetch, this.basePath);
    }

    /**
     * Use this endpoint to modify a queued event in our message queue.
     * @summary Modify queued event
     * @param {string} eventId eventId
     * @param {QueuedEvent} QueuedEvent QueuedEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateQueuedEvent(eventId: string, QueuedEvent: QueuedEvent, options?: any) {
        return EventsApiFp(this.configuration).updateQueuedEvent(eventId, QueuedEvent, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint modifies the status of an queued event. It must belong to the current company of the user or the caller must be superuser. It can specifiy if the event was processed and set a processing info 
     * @summary modifies status of  a queued event by id
     * @param {string} eventId eventId
     * @param {QueuedEventStatusRequest} QueuedEventStatusRequest QueuedEventStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateQueuedEventStatus(eventId: string, QueuedEventStatusRequest: QueuedEventStatusRequest, options?: any) {
        return EventsApiFp(this.configuration).updateQueuedEventStatus(eventId, QueuedEventStatusRequest, options)(this.fetch, this.basePath);
    }

}

/**
 * InternalApi - fetch parameter creator
 * @export
 */
export const InternalApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds Defaults to a given configuration. Often needed for the converter.
         * @summary getUsersCompany
         * @param {AddDefaultsToConfigRequest} AddDefaultsToConfigRequest AddDefaultsToConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDefaultsToConfig(AddDefaultsToConfigRequest: AddDefaultsToConfigRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AddDefaultsToConfigRequest' is not null or undefined
            if (AddDefaultsToConfigRequest === null || AddDefaultsToConfigRequest === undefined) {
                throw new RequiredError('AddDefaultsToConfigRequest','Required parameter AddDefaultsToConfigRequest was null or undefined when calling addDefaultsToConfig.');
            }
            const localVarPath = `/internal/addDefaultsToConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddDefaultsToConfigRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AddDefaultsToConfigRequest || {}) : (AddDefaultsToConfigRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add global geofences
         * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGlobalGeofences(GlobalGeofence: GlobalGeofence, options: any = {}): FetchArgs {
            // verify required parameter 'GlobalGeofence' is not null or undefined
            if (GlobalGeofence === null || GlobalGeofence === undefined) {
                throw new RequiredError('GlobalGeofence','Required parameter GlobalGeofence was null or undefined when calling addGlobalGeofences.');
            }
            const localVarPath = `/internal/globalGeofences`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GlobalGeofence" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GlobalGeofence || {}) : (GlobalGeofence || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new partnership
         * @param {PartnerAddRequest} PartnerAddRequest PartnerAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPartnerToCompany(PartnerAddRequest: PartnerAddRequest, options: any = {}): FetchArgs {
            // verify required parameter 'PartnerAddRequest' is not null or undefined
            if (PartnerAddRequest === null || PartnerAddRequest === undefined) {
                throw new RequiredError('PartnerAddRequest','Required parameter PartnerAddRequest was null or undefined when calling addPartnerToCompany.');
            }
            const localVarPath = `/internal/company/partners`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PartnerAddRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(PartnerAddRequest || {}) : (PartnerAddRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary scriptErrorLogger
         * @param {ScriptErrorLoggerRequest} ScriptErrorLoggerRequest ScriptErrorLoggerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScriptErrorLog(ScriptErrorLoggerRequest: ScriptErrorLoggerRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ScriptErrorLoggerRequest' is not null or undefined
            if (ScriptErrorLoggerRequest === null || ScriptErrorLoggerRequest === undefined) {
                throw new RequiredError('ScriptErrorLoggerRequest','Required parameter ScriptErrorLoggerRequest was null or undefined when calling addScriptErrorLog.');
            }
            const localVarPath = `/internal/scriptErrorLogger`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ScriptErrorLoggerRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ScriptErrorLoggerRequest || {}) : (ScriptErrorLoggerRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of prompts based on the given search criteria 
         * @summary Test creation or modification of transport order
         * @param {OaiPromptListRequest} OaiPromptListRequest OaiPromptListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiListPrompts(OaiPromptListRequest: OaiPromptListRequest, options: any = {}): FetchArgs {
            // verify required parameter 'OaiPromptListRequest' is not null or undefined
            if (OaiPromptListRequest === null || OaiPromptListRequest === undefined) {
                throw new RequiredError('OaiPromptListRequest','Required parameter OaiPromptListRequest was null or undefined when calling aiListPrompts.');
            }
            const localVarPath = `/internal/oaiListPrompts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OaiPromptListRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(OaiPromptListRequest || {}) : (OaiPromptListRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify a promt with the given criteria 
         * @summary Test creation or modification of transport order
         * @param {string} id id
         * @param {AiParseResult} AiParseResult AiParseResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiModifyPromtResult(id: string, AiParseResult: AiParseResult, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling aiModifyPromtResult.');
            }
            // verify required parameter 'AiParseResult' is not null or undefined
            if (AiParseResult === null || AiParseResult === undefined) {
                throw new RequiredError('AiParseResult','Required parameter AiParseResult was null or undefined when calling aiModifyPromtResult.');
            }
            const localVarPath = `/internal/promt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AiParseResult" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AiParseResult || {}) : (AiParseResult || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation parses a text using the given input and returns the corresponding output 
         * @summary Call ai with the given promt
         * @param {ParseTextRequest} ParseTextRequest ParseTextRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiParseText(ParseTextRequest: ParseTextRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ParseTextRequest' is not null or undefined
            if (ParseTextRequest === null || ParseTextRequest === undefined) {
                throw new RequiredError('ParseTextRequest','Required parameter ParseTextRequest was null or undefined when calling aiParseText.');
            }
            const localVarPath = `/internal/oaiParseText`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParseTextRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ParseTextRequest || {}) : (ParseTextRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation parses a text using the given input and returns the corresponding output with Authentication token 
         * @summary Call ai with the given promt
         * @param {ParseTextPublicRequest} ParseTextPublicRequest ParseTextPublicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiParseTextPublic(ParseTextPublicRequest: ParseTextPublicRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ParseTextPublicRequest' is not null or undefined
            if (ParseTextPublicRequest === null || ParseTextPublicRequest === undefined) {
                throw new RequiredError('ParseTextPublicRequest','Required parameter ParseTextPublicRequest was null or undefined when calling aiParseTextPublic.');
            }
            const localVarPath = `/internal/oaiParseTextPublic`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParseTextPublicRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ParseTextPublicRequest || {}) : (ParseTextPublicRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all transport orders exported as excel file using an endpoint with url based authentication
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {string} auth_token auth_token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTransportOrderExcelExportForPowerBi(auth_token: string, options: any = {}): FetchArgs {
            // verify required parameter 'auth_token' is not null or undefined
            if (auth_token === null || auth_token === undefined) {
                throw new RequiredError('auth_token','Required parameter auth_token was null or undefined when calling allTransportOrderExcelExportForPowerBi.');
            }
            const localVarPath = `/internal/allTransportOrderExcelExport/{auth_token}`
                .replace(`{${"auth_token"}}`, encodeURIComponent(String(auth_token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * AI analysis of ticket difficulty vs score to suggest which ticket to pick up first
         * @summary analyzeTicketForPickup
         * @param {AnalyzeTicketForPickupRequest} AnalyzeTicketForPickupRequest AnalyzeTicketForPickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeTicketForPickup(AnalyzeTicketForPickupRequest: AnalyzeTicketForPickupRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AnalyzeTicketForPickupRequest' is not null or undefined
            if (AnalyzeTicketForPickupRequest === null || AnalyzeTicketForPickupRequest === undefined) {
                throw new RequiredError('AnalyzeTicketForPickupRequest','Required parameter AnalyzeTicketForPickupRequest was null or undefined when calling analyzeTicketForPickup.');
            }
            const localVarPath = `/internal/analyzeTicketForPickup`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AnalyzeTicketForPickupRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AnalyzeTicketForPickupRequest || {}) : (AnalyzeTicketForPickupRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary archive transportOrders
         * @param {string} companyId companyId
         * @param {ArchiveTransportOrdersRequest} ArchiveTransportOrdersRequest ArchiveTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTransportOrders(companyId: string, ArchiveTransportOrdersRequest: ArchiveTransportOrdersRequest, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling archiveTransportOrders.');
            }
            // verify required parameter 'ArchiveTransportOrdersRequest' is not null or undefined
            if (ArchiveTransportOrdersRequest === null || ArchiveTransportOrdersRequest === undefined) {
                throw new RequiredError('ArchiveTransportOrdersRequest','Required parameter ArchiveTransportOrdersRequest was null or undefined when calling archiveTransportOrders.');
            }
            const localVarPath = `/internal/archiveTransportOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ArchiveTransportOrdersRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ArchiveTransportOrdersRequest || {}) : (ArchiveTransportOrdersRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call this endpoint to assign a transport order with an assigned device to the company of the currently logged in user.
         * @summary Assign transportorder with assigned device to company of logged in user
         * @param {AssignToCurrentCompanyRequestData} AssignToCurrentCompanyRequestData AssignToCurrentCompanyRequestData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTransportOrderToMyCompany(AssignToCurrentCompanyRequestData: AssignToCurrentCompanyRequestData, options: any = {}): FetchArgs {
            // verify required parameter 'AssignToCurrentCompanyRequestData' is not null or undefined
            if (AssignToCurrentCompanyRequestData === null || AssignToCurrentCompanyRequestData === undefined) {
                throw new RequiredError('AssignToCurrentCompanyRequestData','Required parameter AssignToCurrentCompanyRequestData was null or undefined when calling assignTransportOrderToMyCompany.');
            }
            const localVarPath = `/internal/assignTransportOrderToCurrentCompany`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AssignToCurrentCompanyRequestData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AssignToCurrentCompanyRequestData || {}) : (AssignToCurrentCompanyRequestData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * bill given projectWorkLogBook entries
         * @summary bill given projectWorkLogBook entries
         * @param {BillWorkLogBookEntriesRequest} BillWorkLogBookEntriesRequest BillWorkLogBookEntriesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billWorkLogBookEntries(BillWorkLogBookEntriesRequest: BillWorkLogBookEntriesRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BillWorkLogBookEntriesRequest' is not null or undefined
            if (BillWorkLogBookEntriesRequest === null || BillWorkLogBookEntriesRequest === undefined) {
                throw new RequiredError('BillWorkLogBookEntriesRequest','Required parameter BillWorkLogBookEntriesRequest was null or undefined when calling billWorkLogBookEntries.');
            }
            const localVarPath = `/internal/billWorkLogBookEntries`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillWorkLogBookEntriesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillWorkLogBookEntriesRequest || {}) : (BillWorkLogBookEntriesRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the billing detailed usage report in billed TOs
         * @summary returns the billing detailed usage report in billed TOs
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingDetailedUsageReport(month: number, year: number, options: any = {}): FetchArgs {
            // verify required parameter 'month' is not null or undefined
            if (month === null || month === undefined) {
                throw new RequiredError('month','Required parameter month was null or undefined when calling billingDetailedUsageReport.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling billingDetailedUsageReport.');
            }
            const localVarPath = `/internal/billingDetailedUsageReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {string} imei imei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderBoxTag(imei: string, options: any = {}): FetchArgs {
            // verify required parameter 'imei' is not null or undefined
            if (imei === null || imei === undefined) {
                throw new RequiredError('imei','Required parameter imei was null or undefined when calling calculateOrderBoxTag.');
            }
            const localVarPath = `/orderBox/calculateTag/{imei}`
                .replace(`{${"imei"}}`, encodeURIComponent(String(imei)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets the system log level to the given value.
         * @param {string} logLevel logLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLogLevel(logLevel: string, options: any = {}): FetchArgs {
            // verify required parameter 'logLevel' is not null or undefined
            if (logLevel === null || logLevel === undefined) {
                throw new RequiredError('logLevel','Required parameter logLevel was null or undefined when calling changeLogLevel.');
            }
            const localVarPath = `/internal/system/log/{logLevel}`
                .replace(`{${"logLevel"}}`, encodeURIComponent(String(logLevel)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compares the Zoho price and XLS price for an invoice generated from the billing request. Returns whether the prices are the same, both prices, and the invoice if they differ.
         * @summary compare Zoho and XLS prices for invoice
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareInvoicePrices(BillingRequest: BillingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BillingRequest' is not null or undefined
            if (BillingRequest === null || BillingRequest === undefined) {
                throw new RequiredError('BillingRequest','Required parameter BillingRequest was null or undefined when calling compareInvoicePrices.');
            }
            const localVarPath = `/internal/compareInvoicePrices`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillingRequest || {}) : (BillingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Compute polyline + DRIVING/STANDING segments from a raw positions list (no DB fetch)
         * @param {ComputeSegmentsFromPositionsRequest} ComputeSegmentsFromPositionsRequest ComputeSegmentsFromPositionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeSegmentsFromPositions(ComputeSegmentsFromPositionsRequest: ComputeSegmentsFromPositionsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ComputeSegmentsFromPositionsRequest' is not null or undefined
            if (ComputeSegmentsFromPositionsRequest === null || ComputeSegmentsFromPositionsRequest === undefined) {
                throw new RequiredError('ComputeSegmentsFromPositionsRequest','Required parameter ComputeSegmentsFromPositionsRequest was null or undefined when calling computeSegmentsFromPositions.');
            }
            const localVarPath = `/internal/dump/computeSegmentsFromPositions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ComputeSegmentsFromPositionsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ComputeSegmentsFromPositionsRequest || {}) : (ComputeSegmentsFromPositionsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all transport orders exported as excel file
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {TransportAllOrderToExcelConversionRequest} TransportAllOrderToExcelConversionRequest TransportAllOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertAllTransportOrderListToExcel(TransportAllOrderToExcelConversionRequest: TransportAllOrderToExcelConversionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportAllOrderToExcelConversionRequest' is not null or undefined
            if (TransportAllOrderToExcelConversionRequest === null || TransportAllOrderToExcelConversionRequest === undefined) {
                throw new RequiredError('TransportAllOrderToExcelConversionRequest','Required parameter TransportAllOrderToExcelConversionRequest was null or undefined when calling convertAllTransportOrderListToExcel.');
            }
            const localVarPath = `/internal/allTransportOrderExcelExport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportAllOrderToExcelConversionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportAllOrderToExcelConversionRequest || {}) : (TransportAllOrderToExcelConversionRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of transport orders exported as excel file
         * @summary convert list of transport orders to excel
         * @param {TransportOrderToExcelConversionRequest} TransportOrderToExcelConversionRequest TransportOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertTransportOrderListToExcel(TransportOrderToExcelConversionRequest: TransportOrderToExcelConversionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderToExcelConversionRequest' is not null or undefined
            if (TransportOrderToExcelConversionRequest === null || TransportOrderToExcelConversionRequest === undefined) {
                throw new RequiredError('TransportOrderToExcelConversionRequest','Required parameter TransportOrderToExcelConversionRequest was null or undefined when calling convertTransportOrderListToExcel.');
            }
            const localVarPath = `/internal/transportOrderExcelExport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderToExcelConversionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderToExcelConversionRequest || {}) : (TransportOrderToExcelConversionRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will copy an existing transport order and create it in a fresh state for a target company.
         * @summary create multiple transport orders
         * @param {CopyAsNewTransportOrderRequest} CopyAsNewTransportOrderRequest CopyAsNewTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyAsNewTransportOrder(CopyAsNewTransportOrderRequest: CopyAsNewTransportOrderRequest, options: any = {}): FetchArgs {
            // verify required parameter 'CopyAsNewTransportOrderRequest' is not null or undefined
            if (CopyAsNewTransportOrderRequest === null || CopyAsNewTransportOrderRequest === undefined) {
                throw new RequiredError('CopyAsNewTransportOrderRequest','Required parameter CopyAsNewTransportOrderRequest was null or undefined when calling copyAsNewTransportOrder.');
            }
            const localVarPath = `/transportOrders/copyAsNewTransportOrder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CopyAsNewTransportOrderRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CopyAsNewTransportOrderRequest || {}) : (CopyAsNewTransportOrderRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create billing and responds with Zip-File
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBilling(BillingRequest: BillingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BillingRequest' is not null or undefined
            if (BillingRequest === null || BillingRequest === undefined) {
                throw new RequiredError('BillingRequest','Required parameter BillingRequest was null or undefined when calling createBilling.');
            }
            const localVarPath = `/internal/createBilling`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillingRequest || {}) : (BillingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will create a new company with the given name and address. The user must be a super user to execute this operation. Newly created company will have the state UNDER_CONSTRUCTION and the responsibleLogeniosManager will be set to the email of the user who created the company. This operation will also create a new CompanyHistory entry with the change type CREATE and return the created company object.
         * @summary Create a new company
         * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(CompanyCreateRequest: CompanyCreateRequest, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyCreateRequest' is not null or undefined
            if (CompanyCreateRequest === null || CompanyCreateRequest === undefined) {
                throw new RequiredError('CompanyCreateRequest','Required parameter CompanyCreateRequest was null or undefined when calling createCompany.');
            }
            const localVarPath = `/internal/createCompany/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyCreateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyCreateRequest || {}) : (CompanyCreateRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new company
         * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyOldToBeDeletedSoon(CompanyCreateRequest: CompanyCreateRequest, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyCreateRequest' is not null or undefined
            if (CompanyCreateRequest === null || CompanyCreateRequest === undefined) {
                throw new RequiredError('CompanyCreateRequest','Required parameter CompanyCreateRequest was null or undefined when calling createCompanyOldToBeDeletedSoon.');
            }
            const localVarPath = `/internal//`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyCreateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyCreateRequest || {}) : (CompanyCreateRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {boolean} includeLinked includeLinked
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2Endpoint(includeLinked: boolean, transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'includeLinked' is not null or undefined
            if (includeLinked === null || includeLinked === undefined) {
                throw new RequiredError('includeLinked','Required parameter includeLinked was null or undefined when calling createDumpV2Endpoint.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling createDumpV2Endpoint.');
            }
            const localVarPath = `/internal/dumpV2/fetchDumpForTransportOrder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (includeLinked !== undefined) {
                localVarQueryParameter['includeLinked'] = includeLinked;
            }

            if (transportOrderId !== undefined) {
                localVarQueryParameter['transportOrderId'] = transportOrderId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {boolean} includeLinked includeLinked
         * @param {string} transportOrderId transportOrderId
         * @param {boolean} zipped zipped
         * @param {string} [excludeTransportOrderChangeTypes] excludeTransportOrderChangeTypes
         * @param {boolean} [includePositionEvents] includePositionEvents
         * @param {string} [includeTransportOrderChangeTypes] includeTransportOrderChangeTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FileEndpoint(includeLinked: boolean, transportOrderId: string, zipped: boolean, excludeTransportOrderChangeTypes?: string, includePositionEvents?: boolean, includeTransportOrderChangeTypes?: string, options: any = {}): FetchArgs {
            // verify required parameter 'includeLinked' is not null or undefined
            if (includeLinked === null || includeLinked === undefined) {
                throw new RequiredError('includeLinked','Required parameter includeLinked was null or undefined when calling createDumpV2FileEndpoint.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling createDumpV2FileEndpoint.');
            }
            // verify required parameter 'zipped' is not null or undefined
            if (zipped === null || zipped === undefined) {
                throw new RequiredError('zipped','Required parameter zipped was null or undefined when calling createDumpV2FileEndpoint.');
            }
            const localVarPath = `/internal/dumpV2/fetchDumpForTransportOrderFile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (excludeTransportOrderChangeTypes !== undefined) {
                localVarQueryParameter['excludeTransportOrderChangeTypes'] = excludeTransportOrderChangeTypes;
            }

            if (includeLinked !== undefined) {
                localVarQueryParameter['includeLinked'] = includeLinked;
            }

            if (includePositionEvents !== undefined) {
                localVarQueryParameter['includePositionEvents'] = includePositionEvents;
            }

            if (includeTransportOrderChangeTypes !== undefined) {
                localVarQueryParameter['includeTransportOrderChangeTypes'] = includeTransportOrderChangeTypes;
            }

            if (transportOrderId !== undefined) {
                localVarQueryParameter['transportOrderId'] = transportOrderId;
            }

            if (zipped !== undefined) {
                localVarQueryParameter['zipped'] = zipped;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns dump data for transport orders in a specific version range.
         * @summary Get all needed test data for geo status tests (In Format V2) in a specific transport order version range
         * @param {GeoStatusDumpTransportOrderVersionRangeRequest} GeoStatusDumpTransportOrderVersionRangeRequest GeoStatusDumpTransportOrderVersionRangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FilteredByVersionRangeEndpoint(GeoStatusDumpTransportOrderVersionRangeRequest: GeoStatusDumpTransportOrderVersionRangeRequest, options: any = {}): FetchArgs {
            // verify required parameter 'GeoStatusDumpTransportOrderVersionRangeRequest' is not null or undefined
            if (GeoStatusDumpTransportOrderVersionRangeRequest === null || GeoStatusDumpTransportOrderVersionRangeRequest === undefined) {
                throw new RequiredError('GeoStatusDumpTransportOrderVersionRangeRequest','Required parameter GeoStatusDumpTransportOrderVersionRangeRequest was null or undefined when calling createDumpV2FilteredByVersionRangeEndpoint.');
            }
            const localVarPath = `/internal/dumpV2/fetchDumpFilteredByVersionRange`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GeoStatusDumpTransportOrderVersionRangeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GeoStatusDumpTransportOrderVersionRangeRequest || {}) : (GeoStatusDumpTransportOrderVersionRangeRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {GeoStatusDumpTransportOrderListFilterRequest} GeoStatusDumpTransportOrderListFilterRequest GeoStatusDumpTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FilteredEndpoint(GeoStatusDumpTransportOrderListFilterRequest: GeoStatusDumpTransportOrderListFilterRequest, options: any = {}): FetchArgs {
            // verify required parameter 'GeoStatusDumpTransportOrderListFilterRequest' is not null or undefined
            if (GeoStatusDumpTransportOrderListFilterRequest === null || GeoStatusDumpTransportOrderListFilterRequest === undefined) {
                throw new RequiredError('GeoStatusDumpTransportOrderListFilterRequest','Required parameter GeoStatusDumpTransportOrderListFilterRequest was null or undefined when calling createDumpV2FilteredEndpoint.');
            }
            const localVarPath = `/internal/dumpV2/fetchDumpFiltered`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GeoStatusDumpTransportOrderListFilterRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GeoStatusDumpTransportOrderListFilterRequest || {}) : (GeoStatusDumpTransportOrderListFilterRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create invoices and store in DB
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoicesAndSaveToDB(BillingRequest: BillingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BillingRequest' is not null or undefined
            if (BillingRequest === null || BillingRequest === undefined) {
                throw new RequiredError('BillingRequest','Required parameter BillingRequest was null or undefined when calling createInvoicesAndSaveToDB.');
            }
            const localVarPath = `/internal/createInvoicesAndSaveToDB`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillingRequest || {}) : (BillingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update or insert a script error log in the AI tasks.
         * @summary updateOrInsertAiTaskToDB
         * @param {AIAgentTask} AIAgentTask AIAgentTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyAiAgentTask(AIAgentTask: AIAgentTask, options: any = {}): FetchArgs {
            // verify required parameter 'AIAgentTask' is not null or undefined
            if (AIAgentTask === null || AIAgentTask === undefined) {
                throw new RequiredError('AIAgentTask','Required parameter AIAgentTask was null or undefined when calling createOrModifyAiAgentTask.');
            }
            const localVarPath = `/internal/createOrModifyAiAgentTask`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AIAgentTask" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AIAgentTask || {}) : (AIAgentTask || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a conversion job log or updates an existing entry
         * @summary Fetch conversion job logs
         * @param {ConversionJobLog} ConversionJobLog ConversionJobLog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyConversionJobLog(ConversionJobLog: ConversionJobLog, options: any = {}): FetchArgs {
            // verify required parameter 'ConversionJobLog' is not null or undefined
            if (ConversionJobLog === null || ConversionJobLog === undefined) {
                throw new RequiredError('ConversionJobLog','Required parameter ConversionJobLog was null or undefined when calling createOrModifyConversionJobLog.');
            }
            const localVarPath = `/internal/conversionJobLogs/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ConversionJobLog" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ConversionJobLog || {}) : (ConversionJobLog || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update or insert a script Documentation in the Scripts Documentations Table.
         * @summary updateOrInsertScriptDocumentationToDB
         * @param {ScriptsDocumentationEntry} ScriptsDocumentationEntry ScriptsDocumentationEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyScriptDocumentation(ScriptsDocumentationEntry: ScriptsDocumentationEntry, options: any = {}): FetchArgs {
            // verify required parameter 'ScriptsDocumentationEntry' is not null or undefined
            if (ScriptsDocumentationEntry === null || ScriptsDocumentationEntry === undefined) {
                throw new RequiredError('ScriptsDocumentationEntry','Required parameter ScriptsDocumentationEntry was null or undefined when calling createOrModifyScriptDocumentation.');
            }
            const localVarPath = `/internal/createOrModifyScriptDocumentation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ScriptsDocumentationEntry" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ScriptsDocumentationEntry || {}) : (ScriptsDocumentationEntry || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will do the same as createOrModify, but without saving anything to the DB. 
         * @summary Test creation or modification of transport order
         * @param {CreateOrModifyTransportOrderDryRunRequest} CreateOrModifyTransportOrderDryRunRequest CreateOrModifyTransportOrderDryRunRequest
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrderDryRun(CreateOrModifyTransportOrderDryRunRequest: CreateOrModifyTransportOrderDryRunRequest, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'CreateOrModifyTransportOrderDryRunRequest' is not null or undefined
            if (CreateOrModifyTransportOrderDryRunRequest === null || CreateOrModifyTransportOrderDryRunRequest === undefined) {
                throw new RequiredError('CreateOrModifyTransportOrderDryRunRequest','Required parameter CreateOrModifyTransportOrderDryRunRequest was null or undefined when calling createOrModifyTransportOrderDryRun.');
            }
            const localVarPath = `/internal/createOrModifyDryRun`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fixStopsOfLinkedTransports !== undefined) {
                localVarQueryParameter['fixStopsOfLinkedTransports'] = fixStopsOfLinkedTransports;
            }

            if (forceOverrideDependedStatesOnModifyTransportOrder !== undefined) {
                localVarQueryParameter['forceOverrideDependedStatesOnModifyTransportOrder'] = forceOverrideDependedStatesOnModifyTransportOrder;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (resolveCompanySpecificMapping !== undefined) {
                localVarQueryParameter['resolveCompanySpecificMapping'] = resolveCompanySpecificMapping;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateOrModifyTransportOrderDryRunRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CreateOrModifyTransportOrderDryRunRequest || {}) : (CreateOrModifyTransportOrderDryRunRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId
         * @summary create transport order
         * @param {string} companyId companyId
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrderForCompany(companyId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling createOrModifyTransportOrderForCompany.');
            }
            // verify required parameter 'TransportOrder' is not null or undefined
            if (TransportOrder === null || TransportOrder === undefined) {
                throw new RequiredError('TransportOrder','Required parameter TransportOrder was null or undefined when calling createOrModifyTransportOrderForCompany.');
            }
            const localVarPath = `/internal/transportOrders/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fixStopsOfLinkedTransports !== undefined) {
                localVarQueryParameter['fixStopsOfLinkedTransports'] = fixStopsOfLinkedTransports;
            }

            if (forceOverrideDependedStatesOnModifyTransportOrder !== undefined) {
                localVarQueryParameter['forceOverrideDependedStatesOnModifyTransportOrder'] = forceOverrideDependedStatesOnModifyTransportOrder;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (resolveCompanySpecificMapping !== undefined) {
                localVarQueryParameter['resolveCompanySpecificMapping'] = resolveCompanySpecificMapping;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrder" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrder || {}) : (TransportOrder || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * creates a rule for scheduled order creation.
         * @summary create rule for scheduled Order Creation
         * @param {ScheduledOrderCreationRule} ScheduledOrderCreationRule ScheduledOrderCreationRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateScheduledOrderCreationRule(ScheduledOrderCreationRule: ScheduledOrderCreationRule, options: any = {}): FetchArgs {
            // verify required parameter 'ScheduledOrderCreationRule' is not null or undefined
            if (ScheduledOrderCreationRule === null || ScheduledOrderCreationRule === undefined) {
                throw new RequiredError('ScheduledOrderCreationRule','Required parameter ScheduledOrderCreationRule was null or undefined when calling createOrUpdateScheduledOrderCreationRule.');
            }
            const localVarPath = `/internal/scheduledOrderCreation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ScheduledOrderCreationRule" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ScheduledOrderCreationRule || {}) : (ScheduledOrderCreationRule || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create an ProjectWorkLogBookEntry
         * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectWorkLogBookEntry(ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options: any = {}): FetchArgs {
            // verify required parameter 'ProjectWorkLogBookEntry' is not null or undefined
            if (ProjectWorkLogBookEntry === null || ProjectWorkLogBookEntry === undefined) {
                throw new RequiredError('ProjectWorkLogBookEntry','Required parameter ProjectWorkLogBookEntry was null or undefined when calling createProjectWorkLogBookEntry.');
            }
            const localVarPath = `/internal/projectWorkLogBookEntry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProjectWorkLogBookEntry" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ProjectWorkLogBookEntry || {}) : (ProjectWorkLogBookEntry || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns scriptRunnerUser of given company.
         * @summary create new scriptRunnerUser for given company
         * @param {string} companyId companyId
         * @param {CreateScriptRunnerUserRequest} CreateScriptRunnerUserRequest CreateScriptRunnerUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScriptRunnerUser(companyId: string, CreateScriptRunnerUserRequest: CreateScriptRunnerUserRequest, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling createScriptRunnerUser.');
            }
            // verify required parameter 'CreateScriptRunnerUserRequest' is not null or undefined
            if (CreateScriptRunnerUserRequest === null || CreateScriptRunnerUserRequest === undefined) {
                throw new RequiredError('CreateScriptRunnerUserRequest','Required parameter CreateScriptRunnerUserRequest was null or undefined when calling createScriptRunnerUser.');
            }
            const localVarPath = `/internal/scriptRunnerUser`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateScriptRunnerUserRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CreateScriptRunnerUserRequest || {}) : (CreateScriptRunnerUserRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new shipment Form Config. The permission COMPANY_MODIFY is required to execute this operation.
         * @summary Create new shipment Form Config
         * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentFormConfig(ShipmentFormConfigRequest: ShipmentFormConfigRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ShipmentFormConfigRequest' is not null or undefined
            if (ShipmentFormConfigRequest === null || ShipmentFormConfigRequest === undefined) {
                throw new RequiredError('ShipmentFormConfigRequest','Required parameter ShipmentFormConfigRequest was null or undefined when calling createShipmentFormConfig.');
            }
            const localVarPath = `/internal/company/shipmentFormConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShipmentFormConfigRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ShipmentFormConfigRequest || {}) : (ShipmentFormConfigRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
         * @summary create transport order without authentication
         * @param {TransportOrderWithTokenPin} TransportOrderWithTokenPin TransportOrderWithTokenPin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportOrderPublic(TransportOrderWithTokenPin: TransportOrderWithTokenPin, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderWithTokenPin' is not null or undefined
            if (TransportOrderWithTokenPin === null || TransportOrderWithTokenPin === undefined) {
                throw new RequiredError('TransportOrderWithTokenPin','Required parameter TransportOrderWithTokenPin was null or undefined when calling createTransportOrderPublic.');
            }
            const localVarPath = `/internal/company/shipmentFormConfig/createTransportOrderPublic`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderWithTokenPin" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderWithTokenPin || {}) : (TransportOrderWithTokenPin || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gibt alle deferred notifications für eine bestimmte orderId zurück.  
         * @summary deferredNotifications
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferredNotifications(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling deferredNotifications.');
            }
            const localVarPath = `/internal/deferredNotifications/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the draft with the given id.  
         * @summary deleteDraftOfConfig
         * @param {string} companyId companyId
         * @param {string} draftId draftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftOfConfig(companyId: string, draftId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling deleteDraftOfConfig.');
            }
            // verify required parameter 'draftId' is not null or undefined
            if (draftId === null || draftId === undefined) {
                throw new RequiredError('draftId','Required parameter draftId was null or undefined when calling deleteDraftOfConfig.');
            }
            const localVarPath = `/internal/deleteDraftOfConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (draftId !== undefined) {
                localVarQueryParameter['draftId'] = draftId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete failed requests by ids
         * @param {string} failedRequestIds failedRequestIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFailedRequest(failedRequestIds: string, options: any = {}): FetchArgs {
            // verify required parameter 'failedRequestIds' is not null or undefined
            if (failedRequestIds === null || failedRequestIds === undefined) {
                throw new RequiredError('failedRequestIds','Required parameter failedRequestIds was null or undefined when calling deleteFailedRequest.');
            }
            const localVarPath = `/internal/failedRequest/{failedRequestIds}`
                .replace(`{${"failedRequestIds"}}`, encodeURIComponent(String(failedRequestIds)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete global geofences by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalGeofences(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteGlobalGeofences.');
            }
            const localVarPath = `/internal/globalGeofences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the older drafts (of the calling user and for the his current company) until only 5 drafts remain.  
         * @summary deleteOldestAutoSavedDraftOfConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOldestAutoSavedDraftOfConfig(options: any = {}): FetchArgs {
            const localVarPath = `/internal/deleteOldestAutoSavedDraftOfConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the ProjectWorkLogBookEntry with the given id.  
         * @summary Delete ProjectWorkLogBookEntry by id
         * @param {string} logBookEntryId logBookEntryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectWorkLogBookEntryById(logBookEntryId: string, options: any = {}): FetchArgs {
            // verify required parameter 'logBookEntryId' is not null or undefined
            if (logBookEntryId === null || logBookEntryId === undefined) {
                throw new RequiredError('logBookEntryId','Required parameter logBookEntryId was null or undefined when calling deleteProjectWorkLogBookEntryById.');
            }
            const localVarPath = `/internal/deleteProjectWorkLogBookEntryById`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (logBookEntryId !== undefined) {
                localVarQueryParameter['logBookEntryId'] = logBookEntryId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the shipment form config with the specified config id.
         * @summary Delete shipment Form Config by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentFormConfigById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteShipmentFormConfigById.');
            }
            const localVarPath = `/internal/company/shipmentFormConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deletes a TransportOrderConfigTest
         * @param {string} [testId] testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransportOrderConfigTest(testId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/company/deleteTransportOrderConfigTest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a description of the link table that belongs to a transport order.
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeLinkedOrders(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling describeLinkedOrders.');
            }
            const localVarPath = `/internal/transportOrder/{orderId}/describeLinkedOrders`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call this endpoint to get a description of the patchset. The description contains tabular data what was changed in a transport order
         * @summary Describe patchset
         * @param {DescribePatchsetRequest} DescribePatchsetRequest DescribePatchsetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describePatchset(DescribePatchsetRequest: DescribePatchsetRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DescribePatchsetRequest' is not null or undefined
            if (DescribePatchsetRequest === null || DescribePatchsetRequest === undefined) {
                throw new RequiredError('DescribePatchsetRequest','Required parameter DescribePatchsetRequest was null or undefined when calling describePatchset.');
            }
            const localVarPath = `/internal/describePatchset`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DescribePatchsetRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DescribePatchsetRequest || {}) : (DescribePatchsetRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an iteration's user input and remove subsequent iterations.
         * @summary editAiAgentTaskIteration
         * @param {EditIterationRequest} EditIterationRequest EditIterationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAiAgentTaskIteration(EditIterationRequest: EditIterationRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EditIterationRequest' is not null or undefined
            if (EditIterationRequest === null || EditIterationRequest === undefined) {
                throw new RequiredError('EditIterationRequest','Required parameter EditIterationRequest was null or undefined when calling editAiAgentTaskIteration.');
            }
            const localVarPath = `/internal/editAiAgentTaskIteration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EditIterationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EditIterationRequest || {}) : (EditIterationRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary enroll for totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollTotp(options: any = {}): FetchArgs {
            const localVarPath = `/internal/enrollTotp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * exclude Company From Unbilled TransportOrders Calculation
         * @summary exclude Company From Unbilled TransportOrders Calculation
         * @param {ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest} ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeCompanyFromUnbilledTransportOrdersCalculation(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest: ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest' is not null or undefined
            if (ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest === null || ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest === undefined) {
                throw new RequiredError('ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest','Required parameter ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest was null or undefined when calling excludeCompanyFromUnbilledTransportOrdersCalculation.');
            }
            const localVarPath = `/internal/excludeCompanyFromUnbilledTransportOrdersCalculation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest || {}) : (ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary ExtractToSpecificConfig
         * @param {ExtractToSpecificConfigRequest} ExtractToSpecificConfigRequest ExtractToSpecificConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractToSpecificConfig(ExtractToSpecificConfigRequest: ExtractToSpecificConfigRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ExtractToSpecificConfigRequest' is not null or undefined
            if (ExtractToSpecificConfigRequest === null || ExtractToSpecificConfigRequest === undefined) {
                throw new RequiredError('ExtractToSpecificConfigRequest','Required parameter ExtractToSpecificConfigRequest was null or undefined when calling extractToSpecificConfig.');
            }
            const localVarPath = `/internal/extractToSpecificConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExtractToSpecificConfigRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ExtractToSpecificConfigRequest || {}) : (ExtractToSpecificConfigRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch an AI agent task by script path and company ID
         * @summary getAIAgentTaskByPath
         * @param {string} companyId companyId
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIAgentTaskByID(companyId: string, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchAIAgentTaskByID.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchAIAgentTaskByID.');
            }
            const localVarPath = `/internal/getAIAgentTaskById`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch AI agent tasks with optional filters
         * @summary getAIAgentTasks
         * @param {string} [companyId] companyId
         * @param {Date} [fromCreateDate] fromCreateDate
         * @param {string} [inputScriptPath] inputScriptPath
         * @param {'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED'} [status] status
         * @param {Date} [toCreateDate] toCreateDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIAgentTasks(companyId?: string, fromCreateDate?: Date, inputScriptPath?: string, status?: 'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED', toCreateDate?: Date, options: any = {}): FetchArgs {
            const localVarPath = `/internal/getAIAgentTasks`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (fromCreateDate !== undefined) {
                localVarQueryParameter['fromCreateDate'] = (fromCreateDate as any).toISOString();
            }

            if (inputScriptPath !== undefined) {
                localVarQueryParameter['inputScriptPath'] = inputScriptPath;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (toCreateDate !== undefined) {
                localVarQueryParameter['toCreateDate'] = (toCreateDate as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back all drafts for this user and this companyId.  
         * @summary fetchAllConfigDrafts
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllConfigDrafts(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchAllConfigDrafts.');
            }
            const localVarPath = `/internal/fetchAllConfigDrafts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get companies with Notification Configuartion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllNotificationConfiguartions(options: any = {}): FetchArgs {
            const localVarPath = `/internal/config/companiesWithNotificationConfiguation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllQueuedEventsByQueueType(queueType: string, options: any = {}): FetchArgs {
            // verify required parameter 'queueType' is not null or undefined
            if (queueType === null || queueType === undefined) {
                throw new RequiredError('queueType','Required parameter queueType was null or undefined when calling fetchAllQueuedEventsByQueueType.');
            }
            const localVarPath = `/internal/queuedEvents/unprocessed/{queueType}`
                .replace(`{${"queueType"}}`, encodeURIComponent(String(queueType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of company id and name and responsible manager of that company
         * @summary fetch list of all companies and their responsible managers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllResponsibleManagers(options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchAllResponsibleManagers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all SchedulerReportingConfigurations. Only accessible for superusers.
         * @summary Fetch all SchedulerReportingConfigurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllSchedulerReportingConfigurations(options: any = {}): FetchArgs {
            const localVarPath = `/internal/schedulerReportingConfigurations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the state of the api gateway for the given company. If no state is present, initialize a new api gateway state
         * @summary get api gateway state
         * @param {string} companyId companyId
         * @param {string} configId configId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchApiGatewayState(companyId: string, configId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchApiGatewayState.');
            }
            // verify required parameter 'configId' is not null or undefined
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId','Required parameter configId was null or undefined when calling fetchApiGatewayState.');
            }
            const localVarPath = `/internal/api_gateway/state/{companyId}/{configId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"configId"}}`, encodeURIComponent(String(configId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call this endpoint to get the Assigned device info for a transport order using the companyTag and the external order identifier
         * @summary Query Assigned Device info by external order ref
         * @param {AccessTransportOrderViaExternalAssignedDeviceUrlRequest} AccessTransportOrderViaExternalAssignedDeviceUrlRequest AccessTransportOrderViaExternalAssignedDeviceUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAssignedDeviceInfoByExternalAccessUrl(AccessTransportOrderViaExternalAssignedDeviceUrlRequest: AccessTransportOrderViaExternalAssignedDeviceUrlRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AccessTransportOrderViaExternalAssignedDeviceUrlRequest' is not null or undefined
            if (AccessTransportOrderViaExternalAssignedDeviceUrlRequest === null || AccessTransportOrderViaExternalAssignedDeviceUrlRequest === undefined) {
                throw new RequiredError('AccessTransportOrderViaExternalAssignedDeviceUrlRequest','Required parameter AccessTransportOrderViaExternalAssignedDeviceUrlRequest was null or undefined when calling fetchAssignedDeviceInfoByExternalAccessUrl.');
            }
            const localVarPath = `/internal/accessTransportOrderViaExternalAssignedDeviceId`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccessTransportOrderViaExternalAssignedDeviceUrlRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AccessTransportOrderViaExternalAssignedDeviceUrlRequest || {}) : (AccessTransportOrderViaExternalAssignedDeviceUrlRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches all devices associated to the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasDevices(options: any = {}): FetchArgs {
            const localVarPath = `/internal/tracking/atlas/devices`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches all devices with the corresponding status and position for the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasPositions(options: any = {}): FetchArgs {
            const localVarPath = `/internal/tracking/atlas/positions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches the current atlas version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasVersion(options: any = {}): FetchArgs {
            const localVarPath = `/internal/tracking/atlas/version`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary fetchCmNavTreeTextModalList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCmNavTreeTextModalList(options: any = {}): FetchArgs {
            const localVarPath = `/internal/CmNavTreeTextModalList`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of company ids of companies with the given responsible managers
         * @summary fetch list of all companies of the given responsible managers
         * @param {string} responsibleManagers responsibleManagers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompaniesOfResponsibleManagers(responsibleManagers: string, options: any = {}): FetchArgs {
            // verify required parameter 'responsibleManagers' is not null or undefined
            if (responsibleManagers === null || responsibleManagers === undefined) {
                throw new RequiredError('responsibleManagers','Required parameter responsibleManagers was null or undefined when calling fetchCompaniesOfResponsibleManagers.');
            }
            const localVarPath = `/internal/fetchCompaniesOfResponsibleManagers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (responsibleManagers !== undefined) {
                localVarQueryParameter['responsibleManagers'] = responsibleManagers;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * return the existing address mapping found against the given transport order, transport and stop otherwise return null
         * @param {string} orderId orderId
         * @param {string} stopId stopId
         * @param {string} transportId transportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingByStop(orderId: string, stopId: string, transportId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchCompanyAddressMappingByStop.');
            }
            // verify required parameter 'stopId' is not null or undefined
            if (stopId === null || stopId === undefined) {
                throw new RequiredError('stopId','Required parameter stopId was null or undefined when calling fetchCompanyAddressMappingByStop.');
            }
            // verify required parameter 'transportId' is not null or undefined
            if (transportId === null || transportId === undefined) {
                throw new RequiredError('transportId','Required parameter transportId was null or undefined when calling fetchCompanyAddressMappingByStop.');
            }
            const localVarPath = `/internal/addressMapping/fetchCompanyAddressMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (stopId !== undefined) {
                localVarQueryParameter['stopId'] = stopId;
            }

            if (transportId !== undefined) {
                localVarQueryParameter['transportId'] = transportId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * return the existing address mappings found against the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingsForOrder(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchCompanyAddressMappingsForOrder.');
            }
            const localVarPath = `/internal/addressMapping/fetchCompanyAddressMappingsForOrder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches all configuration changes for ALL companies within a specified time period. Returns CompanyHistory entries along with their detailed CompanyConfigurationChange records. This endpoint is intended for reporting purposes and requires superuser permissions.  Parameters: - from: Start timestamp (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) - to: End timestamp (ISO 8601 format, e.g., 2024-12-31T23:59:59Z)  Returns: - List of all companies with their configuration changes in the specified period - Grouped by company for easy report generation
         * @summary Fetches company configuration changes for all companies in a given time period
         * @param {string} [from] from
         * @param {string} [to] to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigChanges(from?: string, to?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchCompanyConfigChanges`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Superusers: Returns the company config of the companyId provided. For Non-Superusers with COMPANY_FULL_VIEW permission: Returns the company config of the company of the user. If the user gives a company Id, he gets a forbidden.
         * @summary get company config
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfiguration(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchCompanyConfiguration.');
            }
            const localVarPath = `/internal/fetchCompanyConfiguration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns changes of the company with the provided id.
         * @summary get company configuration changes of company
         * @param {string} companyId companyId
         * @param {string} [historyId] historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationChanges(companyId: string, historyId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchCompanyConfigurationChanges.');
            }
            const localVarPath = `/internal/fetchCompanyConfigurationChanges`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (historyId !== undefined) {
                localVarQueryParameter['historyId'] = historyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns changes of the company with the provided id.
         * @summary get company configuration changes of company
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [path] path
         * @param {number} [skip] skip
         * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationChangesForField(companyId: string, limit?: number, path?: string, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchCompanyConfigurationChangesForField.');
            }
            const localVarPath = `/internal/fetchCompanyConfigurationChangesForField`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns history of the company with the provided id.
         * @summary get company configuration history of company
         * @param {string} companyId companyId
         * @param {string} [commentQuery] commentQuery
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [specificHistoryId] specificHistoryId
         * @param {'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY'} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationHistory(companyId: string, commentQuery?: string, limit?: number, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', specificHistoryId?: string, type?: 'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY', options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchCompanyConfigurationHistory.');
            }
            const localVarPath = `/internal/fetchCompanyConfigurationHistory`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (commentQuery !== undefined) {
                localVarQueryParameter['commentQuery'] = commentQuery;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (specificHistoryId !== undefined) {
                localVarQueryParameter['specificHistoryId'] = specificHistoryId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get company config
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyContracts(companyId: string, limit?: number, query?: string, skip?: number, sortBy?: 'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchCompanyContracts.');
            }
            const localVarPath = `/internal/fetchCompanyContracts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches the company specific view configuration
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyViewConfiguration(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchCompanyViewConfiguration.');
            }
            const localVarPath = `/internal/companyViewConfiguration/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back all current conversion logs.
         * @summary Fetch conversion job logs for transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchConversionJobLogForOrder(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchConversionJobLogForOrder.');
            }
            const localVarPath = `/internal/conversionJobLogs/forTransportOrder/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back all current conversion logs.
         * @summary Fetch conversion job logs
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [orderId] orderId
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchConversionJobLogs(companyId: string, limit?: number, orderId?: string, query?: string, skip?: number, sortBy?: 'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchConversionJobLogs.');
            }
            const localVarPath = `/internal/conversionJobLogs/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the default company config.
         * @summary get default company config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultCompanyConfiguration(options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchDefaultCompanyConfiguration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the default contract.
         * @summary get default Contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultContract(options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchDefaultContract`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the default edi configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultEdiConfiguration(options: any = {}): FetchArgs {
            const localVarPath = `/internal/converter/defaultEdiConfiguration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the default lis configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultLisConfiguration(options: any = {}): FetchArgs {
            const localVarPath = `/internal/converter/defaultLisConfiguration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of freight at the given depot. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get all freight in depot
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDepotFreight(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options: any = {}): FetchArgs {
            const localVarPath = `/company/monitor/freight/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (attachmentCategories) {
                localVarQueryParameter['attachmentCategories'] = attachmentCategories.join(COLLECTION_FORMATS["csv"]);
            }

            if (begin !== undefined) {
                localVarQueryParameter['begin'] = (begin as any).toISOString();
            }

            if (countDocuments !== undefined) {
                localVarQueryParameter['countDocuments'] = countDocuments;
            }

            if (dateTimeField !== undefined) {
                localVarQueryParameter['dateTimeField'] = dateTimeField;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any).toISOString();
            }

            if (exactSearchTermMatch !== undefined) {
                localVarQueryParameter['exactSearchTermMatch'] = exactSearchTermMatch;
            }

            if (hasAttachment !== undefined) {
                localVarQueryParameter['hasAttachment'] = hasAttachment;
            }

            if (modifiedSince !== undefined) {
                localVarQueryParameter['modifiedSince'] = (modifiedSince as any).toISOString();
            }

            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (partnerNameRegex !== undefined) {
                localVarQueryParameter['partnerNameRegex'] = partnerNameRegex;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (trailer !== undefined) {
                localVarQueryParameter['trailer'] = trailer;
            }

            if (validationStatus !== undefined) {
                localVarQueryParameter['validationStatus'] = validationStatus;
            }

            if (vehicle !== undefined) {
                localVarQueryParameter['vehicle'] = vehicle;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back the draft with the given id.  
         * @summary fetchDraftOfConfig
         * @param {string} companyId companyId
         * @param {string} draftId draftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDraftOfConfig(companyId: string, draftId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchDraftOfConfig.');
            }
            // verify required parameter 'draftId' is not null or undefined
            if (draftId === null || draftId === undefined) {
                throw new RequiredError('draftId','Required parameter draftId was null or undefined when calling fetchDraftOfConfig.');
            }
            const localVarPath = `/internal/fetchDraftOfConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (draftId !== undefined) {
                localVarQueryParameter['draftId'] = draftId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an empty ProjectWorkLogBookEntry.
         * @summary get default and empty ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyProjectWorkLogBookEntry(options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchEmptyProjectWorkLogBookEntry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current eta for the specified stop
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaAccuracyReportForCompany(transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fetchEtaAccuracyReportForCompany.');
            }
            const localVarPath = `/internal/eta/report/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning a defined BackendToEtaCalculatorEvent.
         * @summary get eta calculator events
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEvent(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchEtaCalculatorEvent.');
            }
            const localVarPath = `/internal/etaCalculatorEvents/fetchEvent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning take*etaCalculatorEvents.
         * @summary get eta calculator events
         * @param {string} [companyId] companyId
         * @param {string} [id] id
         * @param {number} [limit] limit
         * @param {boolean} [processed] processed
         * @param {number} [skip] skip
         * @param {'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [transportOrderId] transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEvents(companyId?: string, id?: string, limit?: number, processed?: boolean, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/etaCalculatorEvents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (processed !== undefined) {
                localVarQueryParameter['processed'] = processed;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (transportOrderId !== undefined) {
                localVarQueryParameter['transportOrderId'] = transportOrderId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning take*etaCalculatorEvents.
         * @summary get eta calculator events
         * @param {string} company company
         * @param {number} take take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEventsForCompany(company: string, take: number, options: any = {}): FetchArgs {
            // verify required parameter 'company' is not null or undefined
            if (company === null || company === undefined) {
                throw new RequiredError('company','Required parameter company was null or undefined when calling fetchEtaCalculatorEventsForCompany.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling fetchEtaCalculatorEventsForCompany.');
            }
            const localVarPath = `/internal/etaCalculatorEventsForCompany/{company}/{take}/`
                .replace(`{${"company"}}`, encodeURIComponent(String(company)))
                .replace(`{${"take"}}`, encodeURIComponent(String(take)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns samples that can  be used to correct the eta value displayed to the user. Super user only endpoint.
         * @summary Get all calculation errors. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCorrectionSamples(options: any = {}): FetchArgs {
            const localVarPath = `/internal/eta/correctionSample`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns the average eta calculation error for a given eta algo and a destination city and  arrival time. It removes samples from orders where the calculated ETA was not stable, e.g. because the truck was far too late and so the calculated eta values were always corrected upwards.   Values of averageCalculationErrorInMin below zero indicate that the truck was earlier at the location than the calculated eta.   If the parameter orderIdPrefix is given, the calculation is only applied for transport orders that start with the given prefix 
         * @summary Calculates the average error for a given city and planned arrival time
         * @param {EtaCorrectionSampleRequest} EtaCorrectionSampleRequest EtaCorrectionSampleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCorrectionSamplesForCityAndTime(EtaCorrectionSampleRequest: EtaCorrectionSampleRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EtaCorrectionSampleRequest' is not null or undefined
            if (EtaCorrectionSampleRequest === null || EtaCorrectionSampleRequest === undefined) {
                throw new RequiredError('EtaCorrectionSampleRequest','Required parameter EtaCorrectionSampleRequest was null or undefined when calling fetchEtaCorrectionSamplesForCityAndTime.');
            }
            const localVarPath = `/internal/eta/correctionSampleForCityAndTime`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtaCorrectionSampleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EtaCorrectionSampleRequest || {}) : (EtaCorrectionSampleRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set.    
         * @summary responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set
         * @param {EtaQualityReportRequest} EtaQualityReportRequest EtaQualityReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaQualityReport(EtaQualityReportRequest: EtaQualityReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EtaQualityReportRequest' is not null or undefined
            if (EtaQualityReportRequest === null || EtaQualityReportRequest === undefined) {
                throw new RequiredError('EtaQualityReportRequest','Required parameter EtaQualityReportRequest was null or undefined when calling fetchEtaQualityReport.');
            }
            const localVarPath = `/internal/eta/report`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtaQualityReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EtaQualityReportRequest || {}) : (EtaQualityReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches failed messageLogs for a specific company.
         * @summary fetch failed messageLogs of a company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedMessageLogsOfSpecificCompany(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchFailedMessageLogsOfSpecificCompany.');
            }
            const localVarPath = `/internal/fetchFailedMessageLogsOfSpecificCompany`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches the failedRequests of requested company
         * @param {Date} [endTime] endTime
         * @param {number} [limit] limit
         * @param {string} [queryId] queryId
         * @param {string} [queryMethod] queryMethod
         * @param {string} [queryUrl] queryUrl
         * @param {string} [queryUserMail] queryUserMail
         * @param {string} [queryXRequestId] queryXRequestId
         * @param {number} [skip] skip
         * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchFailedRequests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any).toISOString();
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (queryId !== undefined) {
                localVarQueryParameter['queryId'] = queryId;
            }

            if (queryMethod !== undefined) {
                localVarQueryParameter['queryMethod'] = queryMethod;
            }

            if (queryUrl !== undefined) {
                localVarQueryParameter['queryUrl'] = queryUrl;
            }

            if (queryUserMail !== undefined) {
                localVarQueryParameter['queryUserMail'] = queryUserMail;
            }

            if (queryXRequestId !== undefined) {
                localVarQueryParameter['queryXRequestId'] = queryXRequestId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check failed requests
         * @param {number} [minutesToCheck] minutesToCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedRequestsMonitoring(minutesToCheck?: number, options: any = {}): FetchArgs {
            const localVarPath = `/internal/monitoring/failedRequestsMonitoring`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (minutesToCheck !== undefined) {
                localVarQueryParameter['minutesToCheck'] = minutesToCheck;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the following history of the provided history id. If it was the last, it returns the current config.
         * @summary get following company configuration history
         * @param {string} companyId companyId
         * @param {string} historyId historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFollowingCompanyConfigurationHistory(companyId: string, historyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchFollowingCompanyConfigurationHistory.');
            }
            // verify required parameter 'historyId' is not null or undefined
            if (historyId === null || historyId === undefined) {
                throw new RequiredError('historyId','Required parameter historyId was null or undefined when calling fetchFollowingCompanyConfigurationHistory.');
            }
            const localVarPath = `/internal/fetchFollowingCompanyConfigurationHistory`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (historyId !== undefined) {
                localVarQueryParameter['historyId'] = historyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the following history of the provided history id. If it was the last, it returns the current contractVersion.
         * @summary get following company contract history
         * @param {string} companyId companyId
         * @param {string} contractId contractId
         * @param {string} historyId historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFollowingCompanyContractHistory(companyId: string, contractId: string, historyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchFollowingCompanyContractHistory.');
            }
            // verify required parameter 'contractId' is not null or undefined
            if (contractId === null || contractId === undefined) {
                throw new RequiredError('contractId','Required parameter contractId was null or undefined when calling fetchFollowingCompanyContractHistory.');
            }
            // verify required parameter 'historyId' is not null or undefined
            if (historyId === null || historyId === undefined) {
                throw new RequiredError('historyId','Required parameter historyId was null or undefined when calling fetchFollowingCompanyContractHistory.');
            }
            const localVarPath = `/internal/fetchFollowingCompanyContractHistory`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (historyId !== undefined) {
                localVarQueryParameter['historyId'] = historyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the geoStatus configuration of user's company.
         * @summary Get geo status config of user's company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusConfig(options: any = {}): FetchArgs {
            const localVarPath = `/internal/config/geoStatusConfig/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the geoStatus configuration of your company.
         * @summary Get geo status config by company id
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusConfigByCompanyId(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchGeoStatusConfigByCompanyId.');
            }
            const localVarPath = `/internal/config/geoStatusConfig/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the geoStatus information for requested transport order.
         * @summary Get information object describing thresholds and settings of the geoStatus for requested transport order.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusInformation(transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fetchGeoStatusInformation.');
            }
            const localVarPath = `/internal/geostatus/info/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If no vehicle is selected it will return all test data for transport orders in mongo collection geoStatusTestData. To add transportOrders to geoStatusTestData use addTransportOrderToGeoStatusTestData(). If a vehicleId is given it returns the geoStatus test data for the selected vehicle and time span. Default is last 14 days.
         * @summary Get all needed test data for geo status tests
         * @param {string} [from] from
         * @param {string} [to] to
         * @param {string} [vehicleId] vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusTestData(from?: string, to?: string, vehicleId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/dump/geoStatusTestData`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns dump data for a transport order and adds it to the default geoStatusTestData set fetched by fetchGeoStatusTestData().
         * @summary Get all needed test data for geo status tests
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusTestDataForTransportOrder(transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fetchGeoStatusTestDataForTransportOrder.');
            }
            const localVarPath = `/internal/dump/geoStatusTestData/fetchForTransportOrder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (transportOrderId !== undefined) {
                localVarQueryParameter['transportOrderId'] = transportOrderId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get global geofences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGlobalGeofences(options: any = {}): FetchArgs {
            const localVarPath = `/internal/globalGeofences`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches History objects. If a type is given, only the type specific histories will be returned. If an ID is given, only the entires with that object ID will be returned. If a query is given, only entries matching that full text search will be returned. It will not respond more entries than the limit, which default is 20. It will respond the total number of found entries.
         * @summary fetch history
         * @param {FetchHistoryRequest} FetchHistoryRequest FetchHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHistory(FetchHistoryRequest: FetchHistoryRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchHistoryRequest' is not null or undefined
            if (FetchHistoryRequest === null || FetchHistoryRequest === undefined) {
                throw new RequiredError('FetchHistoryRequest','Required parameter FetchHistoryRequest was null or undefined when calling fetchHistory.');
            }
            const localVarPath = `/internal/fetchHistory`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchHistoryRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchHistoryRequest || {}) : (FetchHistoryRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * fetching invoices from DB
         * @summary fetch invoices which where not uploaded to zoho
         * @param {FetchInvoicesRequest} FetchInvoicesRequest FetchInvoicesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoices(FetchInvoicesRequest: FetchInvoicesRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchInvoicesRequest' is not null or undefined
            if (FetchInvoicesRequest === null || FetchInvoicesRequest === undefined) {
                throw new RequiredError('FetchInvoicesRequest','Required parameter FetchInvoicesRequest was null or undefined when calling fetchInvoices.');
            }
            const localVarPath = `/internal/fetchInvoices`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchInvoicesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchInvoicesRequest || {}) : (FetchInvoicesRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the invoice data for all billed companies
         * @summary get billing data for all companies
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoicingData(month: number, year: number, options: any = {}): FetchArgs {
            // verify required parameter 'month' is not null or undefined
            if (month === null || month === undefined) {
                throw new RequiredError('month','Required parameter month was null or undefined when calling fetchInvoicingData.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling fetchInvoicingData.');
            }
            const localVarPath = `/internal/invoicing_report/{year}/{month}`
                .replace(`{${"month"}}`, encodeURIComponent(String(month)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the last GPS position to a given vehicle id.
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastPositionForVehicleId(vehicleId: string, options: any = {}): FetchArgs {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling fetchLastPositionForVehicleId.');
            }
            const localVarPath = `/internal/position/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation authenticates a user by mail address and returns the company mail gateway configuration
         * @summary Authenticate user by mail address and return 
         * @param {string} userEmailAddress userEmailAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMailGatewayConfigurationByUserEmailAddress(userEmailAddress: string, options: any = {}): FetchArgs {
            // verify required parameter 'userEmailAddress' is not null or undefined
            if (userEmailAddress === null || userEmailAddress === undefined) {
                throw new RequiredError('userEmailAddress','Required parameter userEmailAddress was null or undefined when calling fetchMailGatewayConfigurationByUserEmailAddress.');
            }
            const localVarPath = `/internal/company/mailGatewayConfiguration/{userEmailAddress}`
                .replace(`{${"userEmailAddress"}}`, encodeURIComponent(String(userEmailAddress)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the merged and sorted list of locations of this order
         * @param {string} orderId orderId
         * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMergedStopList(orderId: string, includeDepotsFromLinkedOrders?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchMergedStopList.');
            }
            const localVarPath = `/internal/transportOrder/{orderId}/stopList`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (includeDepotsFromLinkedOrders !== undefined) {
                localVarQueryParameter['includeDepotsFromLinkedOrders'] = includeDepotsFromLinkedOrders;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches MessageLog.
         * @summary fetch messageLog
         * @param {FetchMailLogRequest} FetchMailLogRequest FetchMailLogRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMessageLog(FetchMailLogRequest: FetchMailLogRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchMailLogRequest' is not null or undefined
            if (FetchMailLogRequest === null || FetchMailLogRequest === undefined) {
                throw new RequiredError('FetchMailLogRequest','Required parameter FetchMailLogRequest was null or undefined when calling fetchMessageLog.');
            }
            const localVarPath = `/internal/fetchMailLog`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchMailLogRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchMailLogRequest || {}) : (FetchMailLogRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches messageLogs of failed sendings.
         * @summary fetch messageLogs of failed sendings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMessageLogReport(options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchMessageLogReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all available database migrations known to this backend version.
         * @summary get all available db migrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMigrations(options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchMigrations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch Access Token of observer
         * @summary Fetch Access Token of Observer
         * @param {string} orderId orderId
         * @param {string} xObserverId xObserverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverAccessToken(orderId: string, xObserverId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchObserverAccessToken.');
            }
            // verify required parameter 'xObserverId' is not null or undefined
            if (xObserverId === null || xObserverId === undefined) {
                throw new RequiredError('xObserverId','Required parameter xObserverId was null or undefined when calling fetchObserverAccessToken.');
            }
            const localVarPath = `/internal/transportOrder/{orderId}/observer/{xObserverId}/accessToken`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"xObserverId"}}`, encodeURIComponent(String(xObserverId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back all Partners with externalPartnerId and externalPartnerId of them from the given company.
         * @summary fetchPartnersWithConfigAndExportAndImport
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnersWithConfigAndExportAndImport(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchPartnersWithConfigAndExportAndImport.');
            }
            const localVarPath = `/internal/fetchPartnersWithConfigAndExportAndImport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type of the company of the current user of the users company. Only usable for uses with permisison EVENTS. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type and own company
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsByQueueType(queueType: string, options: any = {}): FetchArgs {
            // verify required parameter 'queueType' is not null or undefined
            if (queueType === null || queueType === undefined) {
                throw new RequiredError('queueType','Required parameter queueType was null or undefined when calling fetchQueuedEventsByQueueType.');
            }
            const localVarPath = `/queuedEvents/unprocessed/{queueType}`
                .replace(`{${"queueType"}}`, encodeURIComponent(String(queueType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type and given company. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type with given company id
         * @param {string} companyId companyId
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsByQueueTypeAndCompanyId(companyId: string, queueType: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchQueuedEventsByQueueTypeAndCompanyId.');
            }
            // verify required parameter 'queueType' is not null or undefined
            if (queueType === null || queueType === undefined) {
                throw new RequiredError('queueType','Required parameter queueType was null or undefined when calling fetchQueuedEventsByQueueTypeAndCompanyId.');
            }
            const localVarPath = `/internal/queuedEvents/unprocessed/{queueType}/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"queueType"}}`, encodeURIComponent(String(queueType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns events according to the given parameters.
         * @summary get all queued events
         * @param {'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER'} [changeTypeFilter] changeTypeFilter
         * @param {string} [companyId] companyId
         * @param {Date} [createdAtFromFilter] createdAtFromFilter
         * @param {Date} [createdAtToFilter] createdAtToFilter
         * @param {'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT'} [eventTypeFilter] eventTypeFilter
         * @param {boolean} [hasExportedFiles] hasExportedFiles
         * @param {number} [limit] limit
         * @param {boolean} [processedFilter] processedFilter
         * @param {'OK' | 'WARN' | 'ERROR' | 'RETRY'} [processingStateFilter] processingStateFilter
         * @param {'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER'} [queueTypeFilter] queueTypeFilter
         * @param {string} [queuedEventId] queuedEventId
         * @param {number} [skip] skip
         * @param {'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [transportOrderId] transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsForCM(changeTypeFilter?: 'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER', companyId?: string, createdAtFromFilter?: Date, createdAtToFilter?: Date, eventTypeFilter?: 'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT', hasExportedFiles?: boolean, limit?: number, processedFilter?: boolean, processingStateFilter?: 'OK' | 'WARN' | 'ERROR' | 'RETRY', queueTypeFilter?: 'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER', queuedEventId?: string, skip?: number, sortBy?: 'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/queuedEvents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (changeTypeFilter !== undefined) {
                localVarQueryParameter['changeTypeFilter'] = changeTypeFilter;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (createdAtFromFilter !== undefined) {
                localVarQueryParameter['createdAtFromFilter'] = (createdAtFromFilter as any).toISOString();
            }

            if (createdAtToFilter !== undefined) {
                localVarQueryParameter['createdAtToFilter'] = (createdAtToFilter as any).toISOString();
            }

            if (eventTypeFilter !== undefined) {
                localVarQueryParameter['eventTypeFilter'] = eventTypeFilter;
            }

            if (hasExportedFiles !== undefined) {
                localVarQueryParameter['hasExportedFiles'] = hasExportedFiles;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (processedFilter !== undefined) {
                localVarQueryParameter['processedFilter'] = processedFilter;
            }

            if (processingStateFilter !== undefined) {
                localVarQueryParameter['processingStateFilter'] = processingStateFilter;
            }

            if (queueTypeFilter !== undefined) {
                localVarQueryParameter['queueTypeFilter'] = queueTypeFilter;
            }

            if (queuedEventId !== undefined) {
                localVarQueryParameter['queuedEventId'] = queuedEventId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (transportOrderId !== undefined) {
                localVarQueryParameter['transportOrderId'] = transportOrderId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning all queues of the specified queue type. It returns all queues for all companies Only usable for uses with permisison SUPERUSER. 
         * @summary get all queues of all companiew of the specified type
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuesByQueueType(queueType: string, options: any = {}): FetchArgs {
            // verify required parameter 'queueType' is not null or undefined
            if (queueType === null || queueType === undefined) {
                throw new RequiredError('queueType','Required parameter queueType was null or undefined when calling fetchQueuesByQueueType.');
            }
            const localVarPath = `/internal/queues/{queueType}`
                .replace(`{${"queueType"}}`, encodeURIComponent(String(queueType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches the rawRequests of requested company
         * @param {Date} [endTime] endTime
         * @param {number} [limit] limit
         * @param {string} [queryId] queryId
         * @param {string} [queryMethod] queryMethod
         * @param {string} [queryUrl] queryUrl
         * @param {string} [queryUserMail] queryUserMail
         * @param {string} [queryXRequestId] queryXRequestId
         * @param {number} [skip] skip
         * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRawRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options: any = {}): FetchArgs {
            const localVarPath = `/internal/fetchRawRequests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any).toISOString();
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (queryId !== undefined) {
                localVarQueryParameter['queryId'] = queryId;
            }

            if (queryMethod !== undefined) {
                localVarQueryParameter['queryMethod'] = queryMethod;
            }

            if (queryUrl !== undefined) {
                localVarQueryParameter['queryUrl'] = queryUrl;
            }

            if (queryUserMail !== undefined) {
                localVarQueryParameter['queryUserMail'] = queryUserMail;
            }

            if (queryXRequestId !== undefined) {
                localVarQueryParameter['queryXRequestId'] = queryXRequestId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Release Notes from the Gitlab Wiki for the CM, since it should authenticate via backend.
         * @summary fetch ReleaseNotes From Gitlab Wiki
         * @param {string} stage stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReleaseNotesFromGitlabWiki(stage: string, options: any = {}): FetchArgs {
            // verify required parameter 'stage' is not null or undefined
            if (stage === null || stage === undefined) {
                throw new RequiredError('stage','Required parameter stage was null or undefined when calling fetchReleaseNotesFromGitlabWiki.');
            }
            const localVarPath = `/internal/fetchReleaseNotesFromGitlabWiki/{stage}`
                .replace(`{${"stage"}}`, encodeURIComponent(String(stage)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns report generation statistics for super users. Shows which companies use reports, how often they are generated, and whether they are sent by email.
         * @summary Fetches report generation statistics
         * @param {string} [companyId] companyId
         * @param {Date} [endTime] endTime
         * @param {'MANUAL' | 'AUTO'} [generationType] generationType
         * @param {number} [limit] limit
         * @param {string} [reportName] reportName
         * @param {string} [sinceId] sinceId
         * @param {number} [skip] skip
         * @param {'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReportGenerationStats(companyId?: string, endTime?: Date, generationType?: 'MANUAL' | 'AUTO', limit?: number, reportName?: string, sinceId?: string, skip?: number, sortBy?: 'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options: any = {}): FetchArgs {
            const localVarPath = `/internal/reportGenerationStats`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any).toISOString();
            }

            if (generationType !== undefined) {
                localVarQueryParameter['generationType'] = generationType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (reportName !== undefined) {
                localVarQueryParameter['reportName'] = reportName;
            }

            if (sinceId !== undefined) {
                localVarQueryParameter['sinceId'] = sinceId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches ScheduledOrderCreationRule.
         * @summary fetch scheduled Order Creation rules
         * @param {FetchScheduledOrderCreationRulesRequest} FetchScheduledOrderCreationRulesRequest FetchScheduledOrderCreationRulesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScheduledOrderCreationRules(FetchScheduledOrderCreationRulesRequest: FetchScheduledOrderCreationRulesRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchScheduledOrderCreationRulesRequest' is not null or undefined
            if (FetchScheduledOrderCreationRulesRequest === null || FetchScheduledOrderCreationRulesRequest === undefined) {
                throw new RequiredError('FetchScheduledOrderCreationRulesRequest','Required parameter FetchScheduledOrderCreationRulesRequest was null or undefined when calling fetchScheduledOrderCreationRules.');
            }
            const localVarPath = `/internal/fetchScheduledOrderCreationRules`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchScheduledOrderCreationRulesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchScheduledOrderCreationRulesRequest || {}) : (FetchScheduledOrderCreationRulesRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning the SchedulerConfigs.
         * @summary get scheduler configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSchedulerConfigs(options: any = {}): FetchArgs {
            const localVarPath = `/internal/scheduler/config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an internal endpoint returning the SchedulerTasks.
         * @summary get scheduler tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSchedulerTasks(options: any = {}): FetchArgs {
            const localVarPath = `/internal/scheduler/task`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * fetch Script Documentation By Documentation Type
         * @summary fetchScriptDocumentationByDocumentationType
         * @param {'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION'} [documentationType] documentationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptDocumentationByDocumentationType(documentationType?: 'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION', options: any = {}): FetchArgs {
            const localVarPath = `/internal/getScriptDocumentationByDocumentationType`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (documentationType !== undefined) {
                localVarQueryParameter['documentationType'] = documentationType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns scriptRunnerUser of given company.
         * @summary get scriptRunnerUser of given company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptRunnerUser(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchScriptRunnerUser.');
            }
            const localVarPath = `/internal/scriptRunnerUser/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch Scripts Documentations
         * @summary FetchScriptsDocumentations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptsDocumentations(options: any = {}): FetchArgs {
            const localVarPath = `/internal/FetchScriptsDocumentations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the shipment Form Config of the specified id. The permission COMPANY_MODIFY is required to execute this operation
         * @summary Get shipment Form Config by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchShipmentFormConfigById.');
            }
            const localVarPath = `/internal/company/shipmentFormConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the shipment Form Config of the specified access token without authentication.
         * @summary Get shipment Form Config by access token
         * @param {string} token token
         * @param {string} [pin] pin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigByToken(token: string, pin?: string, options: any = {}): FetchArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling fetchShipmentFormConfigByToken.');
            }
            const localVarPath = `/internal/company/shipmentFormConfigPublic/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pin !== undefined) {
                localVarQueryParameter['pin'] = pin;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all configurations for the transport Order creation form for the specified company.
         * @summary Get List of configurations for the transport Order creation form
         * @param {number} [limit] limit
         * @param {string} [q] q
         * @param {number} [skip] skip
         * @param {'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigList(limit?: number, q?: string, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/internal/internal/company/shipmentFormConfigList`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call this endpoint to fetch message logs based on message type and list of transport order ids.
         * @summary Returns message logs with specific message type only based on list of transport order ids in request and message type
         * @param {FetchSpecificMessageLogsForTransportOrdersRequest} FetchSpecificMessageLogsForTransportOrdersRequest FetchSpecificMessageLogsForTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSpecificMessageLogsForTransportOrders(FetchSpecificMessageLogsForTransportOrdersRequest: FetchSpecificMessageLogsForTransportOrdersRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchSpecificMessageLogsForTransportOrdersRequest' is not null or undefined
            if (FetchSpecificMessageLogsForTransportOrdersRequest === null || FetchSpecificMessageLogsForTransportOrdersRequest === undefined) {
                throw new RequiredError('FetchSpecificMessageLogsForTransportOrdersRequest','Required parameter FetchSpecificMessageLogsForTransportOrdersRequest was null or undefined when calling fetchSpecificMessageLogsForTransportOrders.');
            }
            const localVarPath = `/internal/transportOrders/fetchSpecificMessageLogsForTransportOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchSpecificMessageLogsForTransportOrdersRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchSpecificMessageLogsForTransportOrdersRequest || {}) : (FetchSpecificMessageLogsForTransportOrdersRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns message logs with specific message type only that where send and reference the given transport order
         * @param {'REMINDER' | 'INFO' | 'WARNING'} messageType messageType
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSpecificTypeMessageLogsForSingleTransportOrder(messageType: 'REMINDER' | 'INFO' | 'WARNING', orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'messageType' is not null or undefined
            if (messageType === null || messageType === undefined) {
                throw new RequiredError('messageType','Required parameter messageType was null or undefined when calling fetchSpecificTypeMessageLogsForSingleTransportOrder.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchSpecificTypeMessageLogsForSingleTransportOrder.');
            }
            const localVarPath = `/internal/transportOrders/{orderId}/{messageType}/messageLog`
                .replace(`{${"messageType"}}`, encodeURIComponent(String(messageType)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all needed StandingTimesUi data as simple as possible for the requested time period
         * @summary get data for standingTimesUi
         * @param {Date} endTime endTime
         * @param {Date} startTime startTime
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStandingTimesUiData(endTime: Date, startTime: Date, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options: any = {}): FetchArgs {
            // verify required parameter 'endTime' is not null or undefined
            if (endTime === null || endTime === undefined) {
                throw new RequiredError('endTime','Required parameter endTime was null or undefined when calling fetchStandingTimesUiData.');
            }
            // verify required parameter 'startTime' is not null or undefined
            if (startTime === null || startTime === undefined) {
                throw new RequiredError('startTime','Required parameter startTime was null or undefined when calling fetchStandingTimesUiData.');
            }
            const localVarPath = `/internal/fetchStandingTimesUiData`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dateTimeField !== undefined) {
                localVarQueryParameter['dateTimeField'] = dateTimeField;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any).toISOString();
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any).toISOString();
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Standing times per stop as XLSX.
         * @summary fetchStandingTimesXlsx
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStandingTimesXlsx(TourCostReportRequest: TourCostReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TourCostReportRequest' is not null or undefined
            if (TourCostReportRequest === null || TourCostReportRequest === undefined) {
                throw new RequiredError('TourCostReportRequest','Required parameter TourCostReportRequest was null or undefined when calling fetchStandingTimesXlsx.');
            }
            const localVarPath = `/reports/tourCostReport/standingTimes/xlsx`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TourCostReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TourCostReportRequest || {}) : (TourCostReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back all current active SystemStatusMessages.
         * @summary Fetch SystemStatusMessages
         * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
         * @param {number} [limit] limit
         * @param {boolean} [onlyActive] onlyActive
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSystemStatusMessages(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/internal/systemStatusMessages`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (onlyActive !== undefined) {
                localVarQueryParameter['onlyActive'] = onlyActive;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all currently active SystemStatusMessages with combined affectedTransportOrders.
         * @summary Fetch SystemStatusMessages with combined affectedTransportOrders
         * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
         * @param {number} [limit] limit
         * @param {boolean} [onlyActive] onlyActive
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSystemStatusMessagesCombined(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/internal/systemStatusMessagesCombined`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (onlyActive !== undefined) {
                localVarQueryParameter['onlyActive'] = onlyActive;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ...
         * @summary fetchTourCostReport
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTourCostReport(TourCostReportRequest: TourCostReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TourCostReportRequest' is not null or undefined
            if (TourCostReportRequest === null || TourCostReportRequest === undefined) {
                throw new RequiredError('TourCostReportRequest','Required parameter TourCostReportRequest was null or undefined when calling fetchTourCostReport.');
            }
            const localVarPath = `/reports/tourCostReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TourCostReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TourCostReportRequest || {}) : (TourCostReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tour cost report as XLSX. Durations are real Excel time cells.
         * @summary fetchTourCostReportXlsx
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTourCostReportXlsx(TourCostReportRequest: TourCostReportRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TourCostReportRequest' is not null or undefined
            if (TourCostReportRequest === null || TourCostReportRequest === undefined) {
                throw new RequiredError('TourCostReportRequest','Required parameter TourCostReportRequest was null or undefined when calling fetchTourCostReportXlsx.');
            }
            const localVarPath = `/reports/tourCostReport/xlsx`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TourCostReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TourCostReportRequest || {}) : (TourCostReportRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will fetch a new Transport-Order by the externalTransportOrderId and the companyId (sourceCompanyId)
         * @summary get transport order by companyId and external transportOrderId
         * @param {string} companyId companyId
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByExternalTransportOrderIdAndCompany(companyId: string, externalTransportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchTransportOrderByExternalTransportOrderIdAndCompany.');
            }
            // verify required parameter 'externalTransportOrderId' is not null or undefined
            if (externalTransportOrderId === null || externalTransportOrderId === undefined) {
                throw new RequiredError('externalTransportOrderId','Required parameter externalTransportOrderId was null or undefined when calling fetchTransportOrderByExternalTransportOrderIdAndCompany.');
            }
            const localVarPath = `/internal/company/{companyId}/transportOrders/byExternalTransportOrderId/{externalTransportOrderId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"externalTransportOrderId"}}`, encodeURIComponent(String(externalTransportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id.
         * @summary get transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByIdSourceAndTargetView(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchTransportOrderByIdSourceAndTargetView.');
            }
            const localVarPath = `/internal/sourceAndTargetView/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will fetch a new Transport-Order by the telematicTransportOrderId and the targetCompanyId
         * @summary get transport order by companyId and GetTransportOrderByTelematicTransportOrderId
         * @param {string} targetCompanyId targetCompanyId
         * @param {string} telematicTransportOrderId telematicTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId(targetCompanyId: string, telematicTransportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'targetCompanyId' is not null or undefined
            if (targetCompanyId === null || targetCompanyId === undefined) {
                throw new RequiredError('targetCompanyId','Required parameter targetCompanyId was null or undefined when calling fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId.');
            }
            // verify required parameter 'telematicTransportOrderId' is not null or undefined
            if (telematicTransportOrderId === null || telematicTransportOrderId === undefined) {
                throw new RequiredError('telematicTransportOrderId','Required parameter telematicTransportOrderId was null or undefined when calling fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId.');
            }
            const localVarPath = `/internal/company/{targetCompanyId}/transportOrders/byTelematicTransportOrderId/{telematicTransportOrderId}`
                .replace(`{${"targetCompanyId"}}`, encodeURIComponent(String(targetCompanyId)))
                .replace(`{${"telematicTransportOrderId"}}`, encodeURIComponent(String(telematicTransportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the converter Info of this transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderConverterInfo(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchTransportOrderConverterInfo.');
            }
            const localVarPath = `/internal/transportOrders/{orderId}/converterInfo`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all messages that where send and reference the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderMessageLog(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchTransportOrderMessageLog.');
            }
            const localVarPath = `/internal/transportOrders/{orderId}/messageLog`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of partners used in the last transport orders
         * @summary extract partners from transport orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderPartnerList(options: any = {}): FetchArgs {
            const localVarPath = `/internal/transportOrders/extractPartners`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * fetch unbilled projectWorkLogBook entries
         * @summary fetch unbilled projectWorkLogBook entries
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUnbilled(BillingRequest: BillingRequest, limit?: number, skip?: number, sortBy?: 'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            // verify required parameter 'BillingRequest' is not null or undefined
            if (BillingRequest === null || BillingRequest === undefined) {
                throw new RequiredError('BillingRequest','Required parameter BillingRequest was null or undefined when calling fetchUnbilled.');
            }
            const localVarPath = `/internal/fetchUnbilled`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillingRequest || {}) : (BillingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches the user for the given company
         * @param {string} companyId companyId
         * @param {string} externalUserId externalUserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserBy(companyId: string, externalUserId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling fetchUserBy.');
            }
            // verify required parameter 'externalUserId' is not null or undefined
            if (externalUserId === null || externalUserId === undefined) {
                throw new RequiredError('externalUserId','Required parameter externalUserId was null or undefined when calling fetchUserBy.');
            }
            const localVarPath = `/internal/company/{companyId}/user/{externalUserId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"externalUserId"}}`, encodeURIComponent(String(externalUserId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all users matching a given searchterm. The superuser permission to show all users or companyAdmin to show company users is required to execute this operation.
         * @summary List all users
         * @param {string} term term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsers(term: string, options: any = {}): FetchArgs {
            // verify required parameter 'term' is not null or undefined
            if (term === null || term === undefined) {
                throw new RequiredError('term','Required parameter term was null or undefined when calling fetchUsers.');
            }
            const localVarPath = `/internal/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of users specified in the query string. The supplied argument must be a comma separated list of user ids
         * @summary List all users specified in the parameter list
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersByIdList(userIds: string, options: any = {}): FetchArgs {
            // verify required parameter 'userIds' is not null or undefined
            if (userIds === null || userIds === undefined) {
                throw new RequiredError('userIds','Required parameter userIds was null or undefined when calling fetchUsersByIdList.');
            }
            const localVarPath = `/internal/usersToNotify`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (userIds !== undefined) {
                localVarQueryParameter['userIds'] = userIds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch vehicles residence times in a area defined by position and radius. Default for last 14 days.
         * @param {VehicleGeoFilterRequest} VehicleGeoFilterRequest VehicleGeoFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleResidenceTimesInArea(VehicleGeoFilterRequest: VehicleGeoFilterRequest, options: any = {}): FetchArgs {
            // verify required parameter 'VehicleGeoFilterRequest' is not null or undefined
            if (VehicleGeoFilterRequest === null || VehicleGeoFilterRequest === undefined) {
                throw new RequiredError('VehicleGeoFilterRequest','Required parameter VehicleGeoFilterRequest was null or undefined when calling fetchVehicleResidenceTimesInArea.');
            }
            const localVarPath = `/geoLocations/vehicleResidenceTimes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleGeoFilterRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(VehicleGeoFilterRequest || {}) : (VehicleGeoFilterRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
         * @param {FixTransportOrderTimesRequest} FixTransportOrderTimesRequest FixTransportOrderTimesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixTransportOrder(FixTransportOrderTimesRequest: FixTransportOrderTimesRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FixTransportOrderTimesRequest' is not null or undefined
            if (FixTransportOrderTimesRequest === null || FixTransportOrderTimesRequest === undefined) {
                throw new RequiredError('FixTransportOrderTimesRequest','Required parameter FixTransportOrderTimesRequest was null or undefined when calling fixTransportOrder.');
            }
            const localVarPath = `/internal/fixTransportOrder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FixTransportOrderTimesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FixTransportOrderTimesRequest || {}) : (FixTransportOrderTimesRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
         * @param {string} transportOrderId transportOrderId
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {number} [mergeAndOrderKeyToStartFrom] mergeAndOrderKeyToStartFrom
         * @param {number} [offsetAfterInMinutes] offsetAfterInMinutes
         * @param {number} [offsetBeforeInMinutes] offsetBeforeInMinutes
         * @param {boolean} [partialFixAllowed] partialFixAllowed
         * @param {boolean} [replaceOriginalTransportOrder] replaceOriginalTransportOrder
         * @param {boolean} [reverse] reverse
         * @param {boolean} [shouldCreateHistoryEntry] shouldCreateHistoryEntry
         * @param {string} [stopIdToStartFrom] stopIdToStartFrom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixTransportOrderTimes(transportOrderId: string, fixStopsOfLinkedTransports?: boolean, mergeAndOrderKeyToStartFrom?: number, offsetAfterInMinutes?: number, offsetBeforeInMinutes?: number, partialFixAllowed?: boolean, replaceOriginalTransportOrder?: boolean, reverse?: boolean, shouldCreateHistoryEntry?: boolean, stopIdToStartFrom?: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fixTransportOrderTimes.');
            }
            const localVarPath = `/internal/fixTransportOrderTimes/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fixStopsOfLinkedTransports !== undefined) {
                localVarQueryParameter['fixStopsOfLinkedTransports'] = fixStopsOfLinkedTransports;
            }

            if (mergeAndOrderKeyToStartFrom !== undefined) {
                localVarQueryParameter['mergeAndOrderKeyToStartFrom'] = mergeAndOrderKeyToStartFrom;
            }

            if (offsetAfterInMinutes !== undefined) {
                localVarQueryParameter['offsetAfterInMinutes'] = offsetAfterInMinutes;
            }

            if (offsetBeforeInMinutes !== undefined) {
                localVarQueryParameter['offsetBeforeInMinutes'] = offsetBeforeInMinutes;
            }

            if (partialFixAllowed !== undefined) {
                localVarQueryParameter['partialFixAllowed'] = partialFixAllowed;
            }

            if (replaceOriginalTransportOrder !== undefined) {
                localVarQueryParameter['replaceOriginalTransportOrder'] = replaceOriginalTransportOrder;
            }

            if (reverse !== undefined) {
                localVarQueryParameter['reverse'] = reverse;
            }

            if (shouldCreateHistoryEntry !== undefined) {
                localVarQueryParameter['shouldCreateHistoryEntry'] = shouldCreateHistoryEntry;
            }

            if (stopIdToStartFrom !== undefined) {
                localVarQueryParameter['stopIdToStartFrom'] = stopIdToStartFrom;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Force the reapplication of the current customerAddressMapping for the transportOrder. This operation is useful to reapply changed customer address mappings
         * @param {boolean} justSimulate justSimulate
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceApplyCustomerAddressMapping(justSimulate: boolean, orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'justSimulate' is not null or undefined
            if (justSimulate === null || justSimulate === undefined) {
                throw new RequiredError('justSimulate','Required parameter justSimulate was null or undefined when calling forceApplyCustomerAddressMapping.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling forceApplyCustomerAddressMapping.');
            }
            const localVarPath = `/internal/transportOrder/{orderId}/forceApplyCustomerAddressMapping`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (justSimulate !== undefined) {
                localVarQueryParameter['justSimulate'] = justSimulate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parses the given JSON String into an CompanyConfiguration object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
         * @summary update current company
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatConfig(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options: any = {}): FetchArgs {
            // verify required parameter 'UpdateCompanyConfigRequestWrapper' is not null or undefined
            if (UpdateCompanyConfigRequestWrapper === null || UpdateCompanyConfigRequestWrapper === undefined) {
                throw new RequiredError('UpdateCompanyConfigRequestWrapper','Required parameter UpdateCompanyConfigRequestWrapper was null or undefined when calling formatConfig.');
            }
            const localVarPath = `/internal/formatConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCompanyConfigRequestWrapper" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateCompanyConfigRequestWrapper || {}) : (UpdateCompanyConfigRequestWrapper || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parses the given JSON String into an Contract object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
         * @summary update current company
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatContract(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options: any = {}): FetchArgs {
            // verify required parameter 'UpdateCompanyConfigRequestWrapper' is not null or undefined
            if (UpdateCompanyConfigRequestWrapper === null || UpdateCompanyConfigRequestWrapper === undefined) {
                throw new RequiredError('UpdateCompanyConfigRequestWrapper','Required parameter UpdateCompanyConfigRequestWrapper was null or undefined when calling formatContract.');
            }
            const localVarPath = `/internal/formatContract`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCompanyConfigRequestWrapper" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateCompanyConfigRequestWrapper || {}) : (UpdateCompanyConfigRequestWrapper || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get report of completed orders of company partners
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompletionReport(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/report/partnerReport/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (attachmentCategories) {
                localVarQueryParameter['attachmentCategories'] = attachmentCategories.join(COLLECTION_FORMATS["csv"]);
            }

            if (begin !== undefined) {
                localVarQueryParameter['begin'] = (begin as any).toISOString();
            }

            if (countDocuments !== undefined) {
                localVarQueryParameter['countDocuments'] = countDocuments;
            }

            if (dateTimeField !== undefined) {
                localVarQueryParameter['dateTimeField'] = dateTimeField;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any).toISOString();
            }

            if (exactSearchTermMatch !== undefined) {
                localVarQueryParameter['exactSearchTermMatch'] = exactSearchTermMatch;
            }

            if (hasAttachment !== undefined) {
                localVarQueryParameter['hasAttachment'] = hasAttachment;
            }

            if (modifiedSince !== undefined) {
                localVarQueryParameter['modifiedSince'] = (modifiedSince as any).toISOString();
            }

            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (partnerNameRegex !== undefined) {
                localVarQueryParameter['partnerNameRegex'] = partnerNameRegex;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (trailer !== undefined) {
                localVarQueryParameter['trailer'] = trailer;
            }

            if (validationStatus !== undefined) {
                localVarQueryParameter['validationStatus'] = validationStatus;
            }

            if (vehicle !== undefined) {
                localVarQueryParameter['vehicle'] = vehicle;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a xlsx of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get report of completed orders of company partners
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompletionReportAsXlsx(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/report/partnerReportAsXLSX`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (attachmentCategories) {
                localVarQueryParameter['attachmentCategories'] = attachmentCategories.join(COLLECTION_FORMATS["csv"]);
            }

            if (begin !== undefined) {
                localVarQueryParameter['begin'] = (begin as any).toISOString();
            }

            if (countDocuments !== undefined) {
                localVarQueryParameter['countDocuments'] = countDocuments;
            }

            if (dateTimeField !== undefined) {
                localVarQueryParameter['dateTimeField'] = dateTimeField;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any).toISOString();
            }

            if (exactSearchTermMatch !== undefined) {
                localVarQueryParameter['exactSearchTermMatch'] = exactSearchTermMatch;
            }

            if (hasAttachment !== undefined) {
                localVarQueryParameter['hasAttachment'] = hasAttachment;
            }

            if (modifiedSince !== undefined) {
                localVarQueryParameter['modifiedSince'] = (modifiedSince as any).toISOString();
            }

            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (partnerNameRegex !== undefined) {
                localVarQueryParameter['partnerNameRegex'] = partnerNameRegex;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (trailer !== undefined) {
                localVarQueryParameter['trailer'] = trailer;
            }

            if (validationStatus !== undefined) {
                localVarQueryParameter['validationStatus'] = validationStatus;
            }

            if (vehicle !== undefined) {
                localVarQueryParameter['vehicle'] = vehicle;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns the Elflein Error report
         * @summary returns the Elflein Error report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateElfleinVdlNetcarErrorReport(options: any = {}): FetchArgs {
            const localVarPath = `/internal/elfleinErrorReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns the Elflein report
         * @summary returns the Elflein report
         * @param {boolean} compressed compressed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateElfleinVdlNetcarReport(compressed: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'compressed' is not null or undefined
            if (compressed === null || compressed === undefined) {
                throw new RequiredError('compressed','Required parameter compressed was null or undefined when calling generateElfleinVdlNetcarReport.');
            }
            const localVarPath = `/internal/elfleinReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (compressed !== undefined) {
                localVarQueryParameter['compressed'] = compressed;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes a generic status report
         * @summary returns the generic status report
         * @param {string} statusReportName statusReportName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGenericStatusReport(statusReportName: string, options: any = {}): FetchArgs {
            // verify required parameter 'statusReportName' is not null or undefined
            if (statusReportName === null || statusReportName === undefined) {
                throw new RequiredError('statusReportName','Required parameter statusReportName was null or undefined when calling generateGenericStatusReport.');
            }
            const localVarPath = `/internal/genericStatusReport/{statusReportName}`
                .replace(`{${"statusReportName"}}`, encodeURIComponent(String(statusReportName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes a generic status report for all transport orders matching the filter asynchronously. Returns a job status URL that can be polled to check the report generation progress.
         * @summary generates a generic status report for all filtered transport orders asynchronously
         * @param {string} statusReportName statusReportName
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGenericStatusReportAsync(statusReportName: string, FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options: any = {}): FetchArgs {
            // verify required parameter 'statusReportName' is not null or undefined
            if (statusReportName === null || statusReportName === undefined) {
                throw new RequiredError('statusReportName','Required parameter statusReportName was null or undefined when calling generateGenericStatusReportAsync.');
            }
            // verify required parameter 'FetchTransportOrderListFilterRequest' is not null or undefined
            if (FetchTransportOrderListFilterRequest === null || FetchTransportOrderListFilterRequest === undefined) {
                throw new RequiredError('FetchTransportOrderListFilterRequest','Required parameter FetchTransportOrderListFilterRequest was null or undefined when calling generateGenericStatusReportAsync.');
            }
            const localVarPath = `/internal/genericStatusReportAsync/{statusReportName}`
                .replace(`{${"statusReportName"}}`, encodeURIComponent(String(statusReportName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchTransportOrderListFilterRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchTransportOrderListFilterRequest || {}) : (FetchTransportOrderListFilterRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns the GeoStatus Debug report
         * @summary returns the Debug report for the geo status system
         * @param {number} [fromDay] fromDay
         * @param {number} [fromMonth] fromMonth
         * @param {number} [fromYear] fromYear
         * @param {number} [toDay] toDay
         * @param {number} [toMonth] toMonth
         * @param {number} [toYear] toYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGeoStatusDebugReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options: any = {}): FetchArgs {
            const localVarPath = `/internal/geoStatusDebugReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fromDay !== undefined) {
                localVarQueryParameter['fromDay'] = fromDay;
            }

            if (fromMonth !== undefined) {
                localVarQueryParameter['fromMonth'] = fromMonth;
            }

            if (fromYear !== undefined) {
                localVarQueryParameter['fromYear'] = fromYear;
            }

            if (toDay !== undefined) {
                localVarQueryParameter['toDay'] = toDay;
            }

            if (toMonth !== undefined) {
                localVarQueryParameter['toMonth'] = toMonth;
            }

            if (toYear !== undefined) {
                localVarQueryParameter['toYear'] = toYear;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return CSV Report in the format  id;externalTransportOrderId;KM_START;KM_END;KM_LEER;
         * @summary returns the Paneuropa Mileage report
         * @param {Date} [modifiedSince] modifiedSince
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaneuropaMileageReport(modifiedSince?: Date, options: any = {}): FetchArgs {
            const localVarPath = `/internal/paneuropaMileageReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (modifiedSince !== undefined) {
                localVarQueryParameter['modifiedSince'] = (modifiedSince as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns the validation report
         * @summary returns the validation report
         * @param {number} [fromDay] fromDay
         * @param {number} [fromMonth] fromMonth
         * @param {number} [fromYear] fromYear
         * @param {number} [toDay] toDay
         * @param {number} [toMonth] toMonth
         * @param {number} [toYear] toYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateValidationReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options: any = {}): FetchArgs {
            const localVarPath = `/internal/validationReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fromDay !== undefined) {
                localVarQueryParameter['fromDay'] = fromDay;
            }

            if (fromMonth !== undefined) {
                localVarQueryParameter['fromMonth'] = fromMonth;
            }

            if (fromYear !== undefined) {
                localVarQueryParameter['fromYear'] = fromYear;
            }

            if (toDay !== undefined) {
                localVarQueryParameter['toDay'] = toDay;
            }

            if (toMonth !== undefined) {
                localVarQueryParameter['toMonth'] = toMonth;
            }

            if (toYear !== undefined) {
                localVarQueryParameter['toYear'] = toYear;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch AI parse result by ID
         * @summary getAiParseResultById
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiParseResultById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAiParseResultById.');
            }
            const localVarPath = `/internal/getAiParseResultById`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch AI parse results with optional filters
         * @summary getAiParseResults
         * @param {FetchAiParseResultsRequest} FetchAiParseResultsRequest FetchAiParseResultsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiParseResults(FetchAiParseResultsRequest: FetchAiParseResultsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchAiParseResultsRequest' is not null or undefined
            if (FetchAiParseResultsRequest === null || FetchAiParseResultsRequest === undefined) {
                throw new RequiredError('FetchAiParseResultsRequest','Required parameter FetchAiParseResultsRequest was null or undefined when calling getAiParseResults.');
            }
            const localVarPath = `/internal/getAiParseResults`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchAiParseResultsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchAiParseResultsRequest || {}) : (FetchAiParseResultsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * getting all companies and all billed orders
         * @summary getting all companies and all billed orders
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesAndBilledOrders(month: number, year: number, options: any = {}): FetchArgs {
            // verify required parameter 'month' is not null or undefined
            if (month === null || month === undefined) {
                throw new RequiredError('month','Required parameter month was null or undefined when calling getAllCompaniesAndBilledOrders.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling getAllCompaniesAndBilledOrders.');
            }
            const localVarPath = `/internal/getAllCompaniesAndBilledOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches all configurations that changed after the given timestamp, default is 1 day
         * @param {string} [since] since
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConfigurations(since?: string, options: any = {}): FetchArgs {
            const localVarPath = `/internal/getAllConfigurations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * getting all unbilled orders for company
         * @summary getting all unbilled orders for company
         * @param {GetAllUnbilledOrdersForCompanyRequest} GetAllUnbilledOrdersForCompanyRequest GetAllUnbilledOrdersForCompanyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnbilledOrdersForCompany(GetAllUnbilledOrdersForCompanyRequest: GetAllUnbilledOrdersForCompanyRequest, options: any = {}): FetchArgs {
            // verify required parameter 'GetAllUnbilledOrdersForCompanyRequest' is not null or undefined
            if (GetAllUnbilledOrdersForCompanyRequest === null || GetAllUnbilledOrdersForCompanyRequest === undefined) {
                throw new RequiredError('GetAllUnbilledOrdersForCompanyRequest','Required parameter GetAllUnbilledOrdersForCompanyRequest was null or undefined when calling getAllUnbilledOrdersForCompany.');
            }
            const localVarPath = `/internal/getAllUnbilledOrdersForCompany`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GetAllUnbilledOrdersForCompanyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GetAllUnbilledOrdersForCompanyRequest || {}) : (GetAllUnbilledOrdersForCompanyRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get companies with api-gateway config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiGatewayConfigs(options: any = {}): FetchArgs {
            const localVarPath = `/internal/config/companiesWithApiGatewayConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get alive of backend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendAlive(options: any = {}): FetchArgs {
            const localVarPath = `/internal/alive`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get health of backend components
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendHealth(options: any = {}): FetchArgs {
            const localVarPath = `/internal/health`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get performance of GET+POST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendPerformance(options: any = {}): FetchArgs {
            const localVarPath = `/internal/performance`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * list all Companies excluded from Unbilled TransportOrders Calculation
         * @summary list all Companies excluded from Unbilled TransportOrders Calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesExcludedFromUnbilledTransportOrdersCalculation(options: any = {}): FetchArgs {
            const localVarPath = `/internal/getCompaniesExcludedFromUnbilledTransportOrdersCalculation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get companyIds from companies which should be billed
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesToInvoice(BillingRequest: BillingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BillingRequest' is not null or undefined
            if (BillingRequest === null || BillingRequest === undefined) {
                throw new RequiredError('BillingRequest','Required parameter BillingRequest was null or undefined when calling getCompaniesToInvoice.');
            }
            const localVarPath = `/internal/getCompaniesToInvoice`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillingRequest || {}) : (BillingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches all companyNames & tags for the given companyIds
         * @param {string} companyIds companyIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyNames(companyIds: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyIds' is not null or undefined
            if (companyIds === null || companyIds === undefined) {
                throw new RequiredError('companyIds','Required parameter companyIds was null or undefined when calling getCompanyNames.');
            }
            const localVarPath = `/internal/getCompanyNames`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyIds !== undefined) {
                localVarQueryParameter['companyIds'] = companyIds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the short info of all companies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyShortInfo(options: any = {}): FetchArgs {
            const localVarPath = `/internal/monitoring/companyShortInfo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a list of all ConfigFieldDescriptions.
         * @summary getConfigFieldDescriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigFieldDescriptions(options: any = {}): FetchArgs {
            const localVarPath = `/internal/configFieldDescription`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company configuration for customer
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getConfiguration.');
            }
            const localVarPath = `/internal/company/{companyId}/configuration`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last 24 hours polyline for driver
         * @param {string} driverId driverId
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverPolyline(driverId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'driverId' is not null or undefined
            if (driverId === null || driverId === undefined) {
                throw new RequiredError('driverId','Required parameter driverId was null or undefined when calling getDriverPolyline.');
            }
            const localVarPath = `/geoLocations/driverPolyline/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (resolveAddresses !== undefined) {
                localVarQueryParameter['resolveAddresses'] = resolveAddresses;
            }

            if (segmentByEstimatedStates !== undefined) {
                localVarQueryParameter['segmentByEstimatedStates'] = segmentByEstimatedStates;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get companies with eta calculator config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtaCalculatorConfigs(options: any = {}): FetchArgs {
            const localVarPath = `/internal/config/companiesWithEtaConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {EtaTestEventRequest} EtaTestEventRequest EtaTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtaTestEvent(EtaTestEventRequest: EtaTestEventRequest, options: any = {}): FetchArgs {
            // verify required parameter 'EtaTestEventRequest' is not null or undefined
            if (EtaTestEventRequest === null || EtaTestEventRequest === undefined) {
                throw new RequiredError('EtaTestEventRequest','Required parameter EtaTestEventRequest was null or undefined when calling getEtaTestEvent.');
            }
            const localVarPath = `/internal/company/getEtaTestEvent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtaTestEventRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EtaTestEventRequest || {}) : (EtaTestEventRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a report containing the time at a location for a given time range based on the actual vehicle positions
         * @summary returns the time spent at the specified location report based on GPS data
         * @param {string} companyAddressMappingId companyAddressMappingId
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoTimeAtLocationReport(companyAddressMappingId: string, month: number, year: number, options: any = {}): FetchArgs {
            // verify required parameter 'companyAddressMappingId' is not null or undefined
            if (companyAddressMappingId === null || companyAddressMappingId === undefined) {
                throw new RequiredError('companyAddressMappingId','Required parameter companyAddressMappingId was null or undefined when calling getGeoTimeAtLocationReport.');
            }
            // verify required parameter 'month' is not null or undefined
            if (month === null || month === undefined) {
                throw new RequiredError('month','Required parameter month was null or undefined when calling getGeoTimeAtLocationReport.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling getGeoTimeAtLocationReport.');
            }
            const localVarPath = `/internal/geoBasedTimeAtLocationReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyAddressMappingId !== undefined) {
                localVarQueryParameter['companyAddressMappingId'] = companyAddressMappingId;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a gerolsteiner XML report for the given month
         * @summary returns gerolsteiner xml report
         * @param {boolean} dumpXml dumpXml
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGerolsteinerXmlReport(dumpXml: boolean, month: number, year: number, options: any = {}): FetchArgs {
            // verify required parameter 'dumpXml' is not null or undefined
            if (dumpXml === null || dumpXml === undefined) {
                throw new RequiredError('dumpXml','Required parameter dumpXml was null or undefined when calling getGerolsteinerXmlReport.');
            }
            // verify required parameter 'month' is not null or undefined
            if (month === null || month === undefined) {
                throw new RequiredError('month','Required parameter month was null or undefined when calling getGerolsteinerXmlReport.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling getGerolsteinerXmlReport.');
            }
            const localVarPath = `/internal/gerolsteinerXmlReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dumpXml !== undefined) {
                localVarQueryParameter['dumpXml'] = dumpXml;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get long running queries from mongo db from the last x seconds.
         * @param {number} [minusSeconds] minusSeconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLongRunningQueries(minusSeconds?: number, options: any = {}): FetchArgs {
            const localVarPath = `/internal/monitoring/db/longRunningQueries`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (minusSeconds !== undefined) {
                localVarQueryParameter['minusSeconds'] = minusSeconds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the company monitor configurations for customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorConfigurations(options: any = {}): FetchArgs {
            const localVarPath = `/internal/company/monitor/configuration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company notification configuration for customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationConfiguration(options: any = {}): FetchArgs {
            const localVarPath = `/internal/company/notification/configuration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {PositionTestEventRequest} PositionTestEventRequest PositionTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionTestEvent(PositionTestEventRequest: PositionTestEventRequest, options: any = {}): FetchArgs {
            // verify required parameter 'PositionTestEventRequest' is not null or undefined
            if (PositionTestEventRequest === null || PositionTestEventRequest === undefined) {
                throw new RequiredError('PositionTestEventRequest','Required parameter PositionTestEventRequest was null or undefined when calling getPositionTestEvent.');
            }
            const localVarPath = `/internal/company/getPositionTestEvent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PositionTestEventRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(PositionTestEventRequest || {}) : (PositionTestEventRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the ProjectWorkLogBookEntries.
         * @summary Gets ProjectWorkLogBookEntries from Company.
         * @param {boolean} [alreadyBilled] alreadyBilled
         * @param {Array<string>} [companyIds] companyIds
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectWorkLogBookEntries(alreadyBilled?: boolean, companyIds?: Array<string>, limit?: number, skip?: number, sortBy?: 'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/internal/projectWorkLogBookEntryByCompanyId`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (alreadyBilled !== undefined) {
                localVarQueryParameter['alreadyBilled'] = alreadyBilled;
            }

            if (companyIds) {
                localVarQueryParameter['companyIds'] = companyIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the state of the scheduler reporting task.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulerReportingTaskState(options: any = {}): FetchArgs {
            const localVarPath = `/internal/monitoring/schedulerReportingTaskState`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary scriptErrorLogger
         * @param {'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE'} sortBy sortBy
         * @param {'ASC' | 'DESC'} sortDirection sortDirection
         * @param {string} [companyId] companyId
         * @param {Date} [fromCreatedDate] fromCreatedDate
         * @param {number} [limit] limit
         * @param {string} [scriptPath] scriptPath
         * @param {number} [skip] skip
         * @param {Date} [toCreatedDate] toCreatedDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptErrorLogs(sortBy: 'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE', sortDirection: 'ASC' | 'DESC', companyId?: string, fromCreatedDate?: Date, limit?: number, scriptPath?: string, skip?: number, toCreatedDate?: Date, options: any = {}): FetchArgs {
            // verify required parameter 'sortBy' is not null or undefined
            if (sortBy === null || sortBy === undefined) {
                throw new RequiredError('sortBy','Required parameter sortBy was null or undefined when calling getScriptErrorLogs.');
            }
            // verify required parameter 'sortDirection' is not null or undefined
            if (sortDirection === null || sortDirection === undefined) {
                throw new RequiredError('sortDirection','Required parameter sortDirection was null or undefined when calling getScriptErrorLogs.');
            }
            const localVarPath = `/internal/scriptErrorLogger`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (fromCreatedDate !== undefined) {
                localVarQueryParameter['fromCreatedDate'] = (fromCreatedDate as any).toISOString();
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (scriptPath !== undefined) {
                localVarQueryParameter['scriptPath'] = scriptPath;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (toCreatedDate !== undefined) {
                localVarQueryParameter['toCreatedDate'] = (toCreatedDate as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getScriptInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptInfo(options: any = {}): FetchArgs {
            const localVarPath = `/internal/getScriptInfo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of shipmet mapping candidates for the current transport order
         * @summary Get a list of possible shipment mappings for the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentMappingProposal(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getShipmentMappingProposal.');
            }
            const localVarPath = `/internal/transportOrder/getShipmentMappingProposal`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of super users with their status of two factor authentication.
         * @summary extract super user list and check their 2 factor authentication is done.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperUserTwoFactorAuthenticationStatus(options: any = {}): FetchArgs {
            const localVarPath = `/internal/getSuperUserTwoFactorAuthenticationStatusList`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user permissions from a chosen user ID
         * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TargetUserRequest' is not null or undefined
            if (TargetUserRequest === null || TargetUserRequest === undefined) {
                throw new RequiredError('TargetUserRequest','Required parameter TargetUserRequest was null or undefined when calling getTempTargetUserPermissions.');
            }
            const localVarPath = `/internal/permissions/take`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TargetUserRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TargetUserRequest || {}) : (TargetUserRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch test failures with optional filters
         * @summary getTestFailures
         * @param {GetTestFailuresRequest} GetTestFailuresRequest GetTestFailuresRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestFailures(GetTestFailuresRequest: GetTestFailuresRequest, options: any = {}): FetchArgs {
            // verify required parameter 'GetTestFailuresRequest' is not null or undefined
            if (GetTestFailuresRequest === null || GetTestFailuresRequest === undefined) {
                throw new RequiredError('GetTestFailuresRequest','Required parameter GetTestFailuresRequest was null or undefined when calling getTestFailures.');
            }
            const localVarPath = `/internal/getTestFailures`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GetTestFailuresRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GetTestFailuresRequest || {}) : (GetTestFailuresRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a report containing the time at a location for a given time range
         * @summary returns the time spent at Gerolsteiner
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeAtGerolsteinerReport(month: number, year: number, options: any = {}): FetchArgs {
            // verify required parameter 'month' is not null or undefined
            if (month === null || month === undefined) {
                throw new RequiredError('month','Required parameter month was null or undefined when calling getTimeAtGerolsteinerReport.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling getTimeAtGerolsteinerReport.');
            }
            const localVarPath = `/internal/timeAtGerolsteinerReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a report containing the time at a location for a given time range
         * @summary returns the time spent at the specified location report
         * @param {string} locationString locationString
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeAtLocationReport(locationString: string, month: number, year: number, options: any = {}): FetchArgs {
            // verify required parameter 'locationString' is not null or undefined
            if (locationString === null || locationString === undefined) {
                throw new RequiredError('locationString','Required parameter locationString was null or undefined when calling getTimeAtLocationReport.');
            }
            // verify required parameter 'month' is not null or undefined
            if (month === null || month === undefined) {
                throw new RequiredError('month','Required parameter month was null or undefined when calling getTimeAtLocationReport.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling getTimeAtLocationReport.');
            }
            const localVarPath = `/internal/timeAtLocationReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (locationString !== undefined) {
                localVarQueryParameter['locationString'] = locationString;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a temporary test TransportOrderEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {TransportOrderTestEventRequest} TransportOrderTestEventRequest TransportOrderTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportOrderTestEvent(TransportOrderTestEventRequest: TransportOrderTestEventRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderTestEventRequest' is not null or undefined
            if (TransportOrderTestEventRequest === null || TransportOrderTestEventRequest === undefined) {
                throw new RequiredError('TransportOrderTestEventRequest','Required parameter TransportOrderTestEventRequest was null or undefined when calling getTransportOrderTestEvent.');
            }
            const localVarPath = `/internal/company/getTransportOrderTestEvent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderTestEventRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderTestEventRequest || {}) : (TransportOrderTestEventRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getType
         * @param {GetTypeRequest} GetTypeRequest GetTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getType(GetTypeRequest: GetTypeRequest, options: any = {}): FetchArgs {
            // verify required parameter 'GetTypeRequest' is not null or undefined
            if (GetTypeRequest === null || GetTypeRequest === undefined) {
                throw new RequiredError('GetTypeRequest','Required parameter GetTypeRequest was null or undefined when calling getType.');
            }
            const localVarPath = `/internal/getType`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GetTypeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GetTypeRequest || {}) : (GetTypeRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getTypes
         * @param {GetTypesRequest} GetTypesRequest GetTypesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes(GetTypesRequest: GetTypesRequest, options: any = {}): FetchArgs {
            // verify required parameter 'GetTypesRequest' is not null or undefined
            if (GetTypesRequest === null || GetTypesRequest === undefined) {
                throw new RequiredError('GetTypesRequest','Required parameter GetTypesRequest was null or undefined when calling getTypes.');
            }
            const localVarPath = `/internal/getTypes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GetTypesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GetTypesRequest || {}) : (GetTypesRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * fetch unbilled projectWorkLogBook entries
         * @summary get unbilled TransportOrders
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnbilledTransportOrders(BillingRequest: BillingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BillingRequest' is not null or undefined
            if (BillingRequest === null || BillingRequest === undefined) {
                throw new RequiredError('BillingRequest','Required parameter BillingRequest was null or undefined when calling getUnbilledTransportOrders.');
            }
            const localVarPath = `/internal/getUnbilledTransportOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillingRequest || {}) : (BillingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back userName by userId
         * @summary getUserName
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserName(userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserName.');
            }
            const localVarPath = `/internal/getUserName`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back the company of the given user.
         * @summary getUsersCompany
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCompany(options: any = {}): FetchArgs {
            const localVarPath = `/internal/getUsersCompany`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last 24 hours polyline for vehicle
         * @param {number} epsilon epsilon
         * @param {string} vehicleId vehicleId
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolyline(epsilon: number, vehicleId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'epsilon' is not null or undefined
            if (epsilon === null || epsilon === undefined) {
                throw new RequiredError('epsilon','Required parameter epsilon was null or undefined when calling getVehiclePolyline.');
            }
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehiclePolyline.');
            }
            const localVarPath = `/geoLocations/vehiclePolyline/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (epsilon !== undefined) {
                localVarQueryParameter['epsilon'] = epsilon;
            }

            if (resolveAddresses !== undefined) {
                localVarQueryParameter['resolveAddresses'] = resolveAddresses;
            }

            if (segmentByEstimatedStates !== undefined) {
                localVarQueryParameter['segmentByEstimatedStates'] = segmentByEstimatedStates;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check vehicle positions in a specific time range for irregularities. Default search window is last 7 days.
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePositionsCheck(from: string, to: string, vehicleId: string, options: any = {}): FetchArgs {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from','Required parameter from was null or undefined when calling getVehiclePositionsCheck.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to','Required parameter to was null or undefined when calling getVehiclePositionsCheck.');
            }
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehiclePositionsCheck.');
            }
            const localVarPath = `/internal/tracking/vehiclePositionsCheck/{vehicleId}/{from}/{to}`
                .replace(`{${"from"}}`, encodeURIComponent(String(from)))
                .replace(`{${"to"}}`, encodeURIComponent(String(to)))
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation applies a groovy script on the given transportOrder and returns the result.
         * @summary Applies groovy script on transportOrder and returns result
         * @param {ScriptingRequest} ScriptingRequest ScriptingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groovyScripting(ScriptingRequest: ScriptingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ScriptingRequest' is not null or undefined
            if (ScriptingRequest === null || ScriptingRequest === undefined) {
                throw new RequiredError('ScriptingRequest','Required parameter ScriptingRequest was null or undefined when calling groovyScripting.');
            }
            const localVarPath = `/internal/transportOrders/script`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ScriptingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ScriptingRequest || {}) : (ScriptingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import an excel document containing the customer address mapping. This method is intensionally  allowed for non super users
         * @summary Import address mapping from lis
         * @param {any} doc Excel document to import the addresses from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importLisCustomerAddressMapping(doc: any, options: any = {}): FetchArgs {
            // verify required parameter 'doc' is not null or undefined
            if (doc === null || doc === undefined) {
                throw new RequiredError('doc','Required parameter doc was null or undefined when calling importLisCustomerAddressMapping.');
            }
            const localVarPath = `/internal/company/customerAddressMapping/importFromLis`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (doc !== undefined) {
                localVarFormParams.set('doc', doc as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds positions from a gpx track with timestamps as fake positions to a vehicle. The startTime overrides the starting time in the gpx file.
         * @summary POST /api/internal/tracking/gpxtrack
         * @param {any} gpx Gpx file with track
         * @param {string} bodyObject Enter body object here
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertGpxTrackForVehicle(gpx: any, bodyObject: string, options: any = {}): FetchArgs {
            // verify required parameter 'gpx' is not null or undefined
            if (gpx === null || gpx === undefined) {
                throw new RequiredError('gpx','Required parameter gpx was null or undefined when calling insertGpxTrackForVehicle.');
            }
            // verify required parameter 'bodyObject' is not null or undefined
            if (bodyObject === null || bodyObject === undefined) {
                throw new RequiredError('bodyObject','Required parameter bodyObject was null or undefined when calling insertGpxTrackForVehicle.');
            }
            const localVarPath = `/internal/tracking/gpxtrack`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (gpx !== undefined) {
                localVarFormParams.set('gpx', gpx as any);
            }

            if (bodyObject !== undefined) {
                localVarFormParams.set('bodyObject', bodyObject as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSuperuser(options: any = {}): FetchArgs {
            const localVarPath = `/currentUser/isSuperuser`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links two transports with and checks if all needed configs are set.
         * @summary Links two transports
         * @param {TransportLinkingRequest} TransportLinkingRequest TransportLinkingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkTransports(TransportLinkingRequest: TransportLinkingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportLinkingRequest' is not null or undefined
            if (TransportLinkingRequest === null || TransportLinkingRequest === undefined) {
                throw new RequiredError('TransportLinkingRequest','Required parameter TransportLinkingRequest was null or undefined when calling linkTransports.');
            }
            const localVarPath = `/internal/linking/linkTransports`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportLinkingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportLinkingRequest || {}) : (TransportLinkingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists all TransportOrderConfigTests. This endpoint is needed for the integration tests of the converter
         * @param {string} [companyId] companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/internal/company/listAllTransportOrderConfigTest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists all TransportOrderConfigTests of the users company
         * @param {string} [companyId] companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options: any = {}): FetchArgs {
            const localVarPath = `/internal/company/listTransportOrderConfigTest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a generic AI test failure.
         * @summary logTestFailure
         * @param {TestFailureLogEntry} TestFailureLogEntry TestFailureLogEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logTestFailure(TestFailureLogEntry: TestFailureLogEntry, options: any = {}): FetchArgs {
            // verify required parameter 'TestFailureLogEntry' is not null or undefined
            if (TestFailureLogEntry === null || TestFailureLogEntry === undefined) {
                throw new RequiredError('TestFailureLogEntry','Required parameter TestFailureLogEntry was null or undefined when calling logTestFailure.');
            }
            const localVarPath = `/internal/logTestFailure`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TestFailureLogEntry" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TestFailureLogEntry || {}) : (TestFailureLogEntry || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will map a telematic tour to one or multiple existing transport orders. If no script is set, the default company telematicTourMappingScript is used.
         * @summary Map telematic tour to transport order by script
         * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTelematicTour(TelematicTourMapRequest: TelematicTourMapRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TelematicTourMapRequest' is not null or undefined
            if (TelematicTourMapRequest === null || TelematicTourMapRequest === undefined) {
                throw new RequiredError('TelematicTourMapRequest','Required parameter TelematicTourMapRequest was null or undefined when calling mapTelematicTour.');
            }
            const localVarPath = `/internal/transportOrders/mapTelematicTourToTransportOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TelematicTourMapRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TelematicTourMapRequest || {}) : (TelematicTourMapRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will map a telematic tour to an existing transport order. If no script is set, the default company telematicTourMappingScript is used.
         * @summary Map telematic tour to transport order by script
         * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTelematicTourDEPRECATED(TelematicTourMapRequest: TelematicTourMapRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TelematicTourMapRequest' is not null or undefined
            if (TelematicTourMapRequest === null || TelematicTourMapRequest === undefined) {
                throw new RequiredError('TelematicTourMapRequest','Required parameter TelematicTourMapRequest was null or undefined when calling mapTelematicTourDEPRECATED.');
            }
            const localVarPath = `/internal/transportOrders/mapTelematicTour`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TelematicTourMapRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TelematicTourMapRequest || {}) : (TelematicTourMapRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will map a virtual spedion single tour vehicle to an assigned device of an existing transport order.
         * @summary Map virtual SPEDION single tour vehicle to assigned device of specific transport order
         * @param {MapVehicleToAssignedDeviceRequest} MapVehicleToAssignedDeviceRequest MapVehicleToAssignedDeviceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapVehicletoAssignedDevice(MapVehicleToAssignedDeviceRequest: MapVehicleToAssignedDeviceRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MapVehicleToAssignedDeviceRequest' is not null or undefined
            if (MapVehicleToAssignedDeviceRequest === null || MapVehicleToAssignedDeviceRequest === undefined) {
                throw new RequiredError('MapVehicleToAssignedDeviceRequest','Required parameter MapVehicleToAssignedDeviceRequest was null or undefined when calling mapVehicletoAssignedDevice.');
            }
            const localVarPath = `/internal/transportOrders/mapVehicleToAssignedDevice`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MapVehicleToAssignedDeviceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MapVehicleToAssignedDeviceRequest || {}) : (MapVehicleToAssignedDeviceRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To migrate the DB to the latest version known to this version of the backend. 
         * @summary migrating the db to the latest version!
         * @param {boolean} dryRun dryRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateDb(dryRun: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'dryRun' is not null or undefined
            if (dryRun === null || dryRun === undefined) {
                throw new RequiredError('dryRun','Required parameter dryRun was null or undefined when calling migrateDb.');
            }
            const localVarPath = `/internal/migrateDb`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies the ProjectWorkLogBookEntry with the specified ProjectWorkLogBookEntryId.
         * @summary Modify ProjectWorkLogBookEntry by id
         * @param {string} logBookEntryId logBookEntryId
         * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyProjectWorkLogBookEntryById(logBookEntryId: string, ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options: any = {}): FetchArgs {
            // verify required parameter 'logBookEntryId' is not null or undefined
            if (logBookEntryId === null || logBookEntryId === undefined) {
                throw new RequiredError('logBookEntryId','Required parameter logBookEntryId was null or undefined when calling modifyProjectWorkLogBookEntryById.');
            }
            // verify required parameter 'ProjectWorkLogBookEntry' is not null or undefined
            if (ProjectWorkLogBookEntry === null || ProjectWorkLogBookEntry === undefined) {
                throw new RequiredError('ProjectWorkLogBookEntry','Required parameter ProjectWorkLogBookEntry was null or undefined when calling modifyProjectWorkLogBookEntryById.');
            }
            const localVarPath = `/internal/modifyProjectWorkLogBookEntryById`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (logBookEntryId !== undefined) {
                localVarQueryParameter['logBookEntryId'] = logBookEntryId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProjectWorkLogBookEntry" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ProjectWorkLogBookEntry || {}) : (ProjectWorkLogBookEntry || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies the shipment form config of the given config id. The COMPANY_MODIFY permission is required to execute this operation.
         * @summary Modify shipment Form Config by id
         * @param {string} id id
         * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyShipmentFormConfigById(id: string, ShipmentFormConfigRequest: ShipmentFormConfigRequest, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling modifyShipmentFormConfigById.');
            }
            // verify required parameter 'ShipmentFormConfigRequest' is not null or undefined
            if (ShipmentFormConfigRequest === null || ShipmentFormConfigRequest === undefined) {
                throw new RequiredError('ShipmentFormConfigRequest','Required parameter ShipmentFormConfigRequest was null or undefined when calling modifyShipmentFormConfigById.');
            }
            const localVarPath = `/internal/company/shipmentFormConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShipmentFormConfigRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ShipmentFormConfigRequest || {}) : (ShipmentFormConfigRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Monitor mongo db operations running longer than given seconds.
         * @param {string} [mongoDbTags] mongoDbTags
         * @param {number} [seconds] seconds
         * @param {string} [mongoDbTags2] mongoDbTags
         * @param {number} [seconds2] seconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorDbOperations(mongoDbTags?: string, seconds?: number, mongoDbTags2?: string, seconds2?: number, options: any = {}): FetchArgs {
            const localVarPath = `/internal/monitoring/db/operations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (mongoDbTags !== undefined) {
                localVarQueryParameter['mongoDbTags'] = mongoDbTags;
            }

            if (seconds !== undefined) {
                localVarQueryParameter['seconds'] = seconds;
            }

            if (mongoDbTags2 !== undefined) {
                localVarQueryParameter['mongoDbTags'] = mongoDbTags2;
            }

            if (seconds2 !== undefined) {
                localVarQueryParameter['seconds'] = seconds2;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Monitor failed sms and emails in message log in past 7 days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorFailedSmsEmail(options: any = {}): FetchArgs {
            const localVarPath = `/internal/monitoringSmsEmail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Monitor waiting events for specific queue.
         * @param {string} type type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorWaitingEvents(type: string, options: any = {}): FetchArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling monitorWaitingEvents.');
            }
            const localVarPath = `/internal/monitoring/queuedEvents/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation applies a groovy script on the given transportOrder and returns the result.
         * @summary Applies groovy script on transportOrders and returns results
         * @param {MultiOrderScriptingRequest} MultiOrderScriptingRequest MultiOrderScriptingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiOrderGroovyScripting(MultiOrderScriptingRequest: MultiOrderScriptingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MultiOrderScriptingRequest' is not null or undefined
            if (MultiOrderScriptingRequest === null || MultiOrderScriptingRequest === undefined) {
                throw new RequiredError('MultiOrderScriptingRequest','Required parameter MultiOrderScriptingRequest was null or undefined when calling multiOrderGroovyScripting.');
            }
            const localVarPath = `/internal/transportOrders/multiOrderScript`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MultiOrderScriptingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MultiOrderScriptingRequest || {}) : (MultiOrderScriptingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the configuration, to check if it can be accepted by the database.
         * @summary multiScriptExecution
         * @param {MultiScriptExecutionRequest} MultiScriptExecutionRequest MultiScriptExecutionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiScriptExecution(MultiScriptExecutionRequest: MultiScriptExecutionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MultiScriptExecutionRequest' is not null or undefined
            if (MultiScriptExecutionRequest === null || MultiScriptExecutionRequest === undefined) {
                throw new RequiredError('MultiScriptExecutionRequest','Required parameter MultiScriptExecutionRequest was null or undefined when calling multiScriptExecution.');
            }
            const localVarPath = `/internal/multiScriptExecution`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MultiScriptExecutionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MultiScriptExecutionRequest || {}) : (MultiScriptExecutionRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Drops Entries from the ai cache 
         * @summary Call ai with the given promt
         * @param {DropCacheEntryRequest} DropCacheEntryRequest DropCacheEntryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oaiDropCacheEntry(DropCacheEntryRequest: DropCacheEntryRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DropCacheEntryRequest' is not null or undefined
            if (DropCacheEntryRequest === null || DropCacheEntryRequest === undefined) {
                throw new RequiredError('DropCacheEntryRequest','Required parameter DropCacheEntryRequest was null or undefined when calling oaiDropCacheEntry.');
            }
            const localVarPath = `/internal/oaiDropCacheEntry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DropCacheEntryRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DropCacheEntryRequest || {}) : (DropCacheEntryRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Optimize the Route for given shipments
         * @summary Optimize the Route for given shipments.
         * @param {RouteOptimizerRequest} RouteOptimizerRequest RouteOptimizerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizeRoutes(RouteOptimizerRequest: RouteOptimizerRequest, options: any = {}): FetchArgs {
            // verify required parameter 'RouteOptimizerRequest' is not null or undefined
            if (RouteOptimizerRequest === null || RouteOptimizerRequest === undefined) {
                throw new RequiredError('RouteOptimizerRequest','Required parameter RouteOptimizerRequest was null or undefined when calling optimizeRoutes.');
            }
            const localVarPath = `/routeOpt/optimizeRoutes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RouteOptimizerRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(RouteOptimizerRequest || {}) : (RouteOptimizerRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary parse a transport order from a prompt
         * @param {ParseTransportOrderRequest} ParseTransportOrderRequest ParseTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseGenericAiToTransportOrder(ParseTransportOrderRequest: ParseTransportOrderRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ParseTransportOrderRequest' is not null or undefined
            if (ParseTransportOrderRequest === null || ParseTransportOrderRequest === undefined) {
                throw new RequiredError('ParseTransportOrderRequest','Required parameter ParseTransportOrderRequest was null or undefined when calling parseGenericAiToTransportOrder.');
            }
            const localVarPath = `/internal/parseGenericAiToTransportOrder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParseTransportOrderRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ParseTransportOrderRequest || {}) : (ParseTransportOrderRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary parse the next scheduled execution from a prompt
         * @param {ParseNextScheduledExecutionRequest} ParseNextScheduledExecutionRequest ParseNextScheduledExecutionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseNextScheduledExecution(ParseNextScheduledExecutionRequest: ParseNextScheduledExecutionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ParseNextScheduledExecutionRequest' is not null or undefined
            if (ParseNextScheduledExecutionRequest === null || ParseNextScheduledExecutionRequest === undefined) {
                throw new RequiredError('ParseNextScheduledExecutionRequest','Required parameter ParseNextScheduledExecutionRequest was null or undefined when calling parseNextScheduledExecution.');
            }
            const localVarPath = `/internal/parseNextScheduledExecution`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParseNextScheduledExecutionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ParseNextScheduledExecutionRequest || {}) : (ParseNextScheduledExecutionRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the times as string calculated by the given reportTimeReference and the current time.
         * @summary previewReportTimeReference
         * @param {ReportTimeReference} ReportTimeReference ReportTimeReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReportTimeReference(ReportTimeReference: ReportTimeReference, options: any = {}): FetchArgs {
            // verify required parameter 'ReportTimeReference' is not null or undefined
            if (ReportTimeReference === null || ReportTimeReference === undefined) {
                throw new RequiredError('ReportTimeReference','Required parameter ReportTimeReference was null or undefined when calling previewReportTimeReference.');
            }
            const localVarPath = `/internal/previewReportTimeReference`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportTimeReference" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ReportTimeReference || {}) : (ReportTimeReference || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * AI analyzes all tickets considering score, difficulty, and other factors to recommend top 3 to pick up
         * @summary recommendTopTicketsForPickup
         * @param {RecommendTopTicketsRequest} RecommendTopTicketsRequest RecommendTopTicketsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendTopTicketsForPickup(RecommendTopTicketsRequest: RecommendTopTicketsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'RecommendTopTicketsRequest' is not null or undefined
            if (RecommendTopTicketsRequest === null || RecommendTopTicketsRequest === undefined) {
                throw new RequiredError('RecommendTopTicketsRequest','Required parameter RecommendTopTicketsRequest was null or undefined when calling recommendTopTicketsForPickup.');
            }
            const localVarPath = `/internal/recommendTopTicketsForPickup`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RecommendTopTicketsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(RecommendTopTicketsRequest || {}) : (RecommendTopTicketsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recoveres a deleted object from history
         * @summary recover history entry
         * @param {RecoverHistoryEntryRequest} RecoverHistoryEntryRequest RecoverHistoryEntryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverHistoryEntry(RecoverHistoryEntryRequest: RecoverHistoryEntryRequest, options: any = {}): FetchArgs {
            // verify required parameter 'RecoverHistoryEntryRequest' is not null or undefined
            if (RecoverHistoryEntryRequest === null || RecoverHistoryEntryRequest === undefined) {
                throw new RequiredError('RecoverHistoryEntryRequest','Required parameter RecoverHistoryEntryRequest was null or undefined when calling recoverHistoryEntry.');
            }
            const localVarPath = `/internal/recoverHistoryEntry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RecoverHistoryEntryRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(RecoverHistoryEntryRequest || {}) : (RecoverHistoryEntryRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a path from the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary removeFromCmNavTreeTextModal
         * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options: any = {}): FetchArgs {
            // verify required parameter 'CmNavTreeTextModalListRequest' is not null or undefined
            if (CmNavTreeTextModalListRequest === null || CmNavTreeTextModalListRequest === undefined) {
                throw new RequiredError('CmNavTreeTextModalListRequest','Required parameter CmNavTreeTextModalListRequest was null or undefined when calling removeFromCmNavTreeTextModal.');
            }
            const localVarPath = `/internal/RemoveFromCmNavTreeTextModalList`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CmNavTreeTextModalListRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CmNavTreeTextModalListRequest || {}) : (CmNavTreeTextModalListRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove temp token used from a chosen user ID
         * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TargetUserRequest' is not null or undefined
            if (TargetUserRequest === null || TargetUserRequest === undefined) {
                throw new RequiredError('TargetUserRequest','Required parameter TargetUserRequest was null or undefined when calling removeTempTargetUserPermissions.');
            }
            const localVarPath = `/internal/permissions/remove`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TargetUserRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TargetUserRequest || {}) : (TargetUserRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace the company configuration with the given value
         * @param {string} companyId companyId
         * @param {CompanyConfiguration} CompanyConfiguration CompanyConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceConfiguration(companyId: string, CompanyConfiguration: CompanyConfiguration, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling replaceConfiguration.');
            }
            // verify required parameter 'CompanyConfiguration' is not null or undefined
            if (CompanyConfiguration === null || CompanyConfiguration === undefined) {
                throw new RequiredError('CompanyConfiguration','Required parameter CompanyConfiguration was null or undefined when calling replaceConfiguration.');
            }
            const localVarPath = `/internal/company/{companyId}/configuration`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyConfiguration || {}) : (CompanyConfiguration || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace the company monitor configurations with the given value
         * @param {CompanyMonitorConfigs} CompanyMonitorConfigs CompanyMonitorConfigs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceMonitorConfiguration(CompanyMonitorConfigs: CompanyMonitorConfigs, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyMonitorConfigs' is not null or undefined
            if (CompanyMonitorConfigs === null || CompanyMonitorConfigs === undefined) {
                throw new RequiredError('CompanyMonitorConfigs','Required parameter CompanyMonitorConfigs was null or undefined when calling replaceMonitorConfiguration.');
            }
            const localVarPath = `/internal/company/monitor/configuration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyMonitorConfigs" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyMonitorConfigs || {}) : (CompanyMonitorConfigs || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace the company notification configurations with the given value
         * @param {NotificationConfiguration} NotificationConfiguration NotificationConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceNotificationConfiguration(NotificationConfiguration: NotificationConfiguration, options: any = {}): FetchArgs {
            // verify required parameter 'NotificationConfiguration' is not null or undefined
            if (NotificationConfiguration === null || NotificationConfiguration === undefined) {
                throw new RequiredError('NotificationConfiguration','Required parameter NotificationConfiguration was null or undefined when calling replaceNotificationConfiguration.');
            }
            const localVarPath = `/internal/company/notification/configuration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(NotificationConfiguration || {}) : (NotificationConfiguration || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * overrides given SystemStatusMessages.
         * @summary Update SystemStatusMessage endTime
         * @param {string} id id
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceSystemStatusMessage(id: string, SystemStatusMessage: SystemStatusMessage, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling replaceSystemStatusMessage.');
            }
            // verify required parameter 'SystemStatusMessage' is not null or undefined
            if (SystemStatusMessage === null || SystemStatusMessage === undefined) {
                throw new RequiredError('SystemStatusMessage','Required parameter SystemStatusMessage was null or undefined when calling replaceSystemStatusMessage.');
            }
            const localVarPath = `/internal/systemStatusMessages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SystemStatusMessage" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SystemStatusMessage || {}) : (SystemStatusMessage || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary replays all positions of a geostatusTest dump
         * @param {ReplayGeoStatusTestDataRequest} ReplayGeoStatusTestDataRequest ReplayGeoStatusTestDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayGeoStatusTestData(ReplayGeoStatusTestDataRequest: ReplayGeoStatusTestDataRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ReplayGeoStatusTestDataRequest' is not null or undefined
            if (ReplayGeoStatusTestDataRequest === null || ReplayGeoStatusTestDataRequest === undefined) {
                throw new RequiredError('ReplayGeoStatusTestDataRequest','Required parameter ReplayGeoStatusTestDataRequest was null or undefined when calling replayGeoStatusTestData.');
            }
            const localVarPath = `/internal/dump/replayGeoStatusTestData`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReplayGeoStatusTestDataRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ReplayGeoStatusTestDataRequest || {}) : (ReplayGeoStatusTestDataRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replays the last position of a vehicle for debugging purposes.
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayLastPositionRequest(vehicleId: string, options: any = {}): FetchArgs {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling replayLastPositionRequest.');
            }
            const localVarPath = `/internal/tracking/replayLastPositionForVehicle/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Coordinates from AddressMapping
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCompanyAddressMappingToCoordinates(CompanyAddressMapping: CompanyAddressMapping, options: any = {}): FetchArgs {
            // verify required parameter 'CompanyAddressMapping' is not null or undefined
            if (CompanyAddressMapping === null || CompanyAddressMapping === undefined) {
                throw new RequiredError('CompanyAddressMapping','Required parameter CompanyAddressMapping was null or undefined when calling resolveCompanyAddressMappingToCoordinates.');
            }
            const localVarPath = `/internal/resolveCompanyAddressMappingToCoordinates`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyAddressMapping" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyAddressMapping || {}) : (CompanyAddressMapping || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-Validates the customerAddressMapping for the transportOrder
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCustomerAddressMapping(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling resolveCustomerAddressMapping.');
            }
            const localVarPath = `/internal/transportOrder/{orderId}/resolveCustomerAdressMapping`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-Validates the customerAddressMapping for multiple transportOrders in a single request. Returns detailed results for each transport order processed.
         * @param {ResolveCustomerAddressMappingBatchRequest} ResolveCustomerAddressMappingBatchRequest ResolveCustomerAddressMappingBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCustomerAddressMappingBatch(ResolveCustomerAddressMappingBatchRequest: ResolveCustomerAddressMappingBatchRequest, options: any = {}): FetchArgs {
            // verify required parameter 'ResolveCustomerAddressMappingBatchRequest' is not null or undefined
            if (ResolveCustomerAddressMappingBatchRequest === null || ResolveCustomerAddressMappingBatchRequest === undefined) {
                throw new RequiredError('ResolveCustomerAddressMappingBatchRequest','Required parameter ResolveCustomerAddressMappingBatchRequest was null or undefined when calling resolveCustomerAddressMappingBatch.');
            }
            const localVarPath = `/internal/transportOrder/batch/resolveCustomerAddressMapping`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ResolveCustomerAddressMappingBatchRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ResolveCustomerAddressMappingBatchRequest || {}) : (ResolveCustomerAddressMappingBatchRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns the reverse geocoding for a given Google plus code.
         * @summary Get the reverse geocoding for a given plus code
         * @param {string} plusCode plusCode
         * @param {boolean} [reduceAccuracyOfPlusCode] reduceAccuracyOfPlusCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseGeocodePlusCode(plusCode: string, reduceAccuracyOfPlusCode?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'plusCode' is not null or undefined
            if (plusCode === null || plusCode === undefined) {
                throw new RequiredError('plusCode','Required parameter plusCode was null or undefined when calling reverseGeocodePlusCode.');
            }
            const localVarPath = `/internal/geocoding/reverse/{plusCode}`
                .replace(`{${"plusCode"}}`, encodeURIComponent(String(plusCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (reduceAccuracyOfPlusCode !== undefined) {
                localVarQueryParameter['reduceAccuracyOfPlusCode'] = reduceAccuracyOfPlusCode;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary rollback transportOrder
         * @param {RollbackTransportOrderRequest} RollbackTransportOrderRequest RollbackTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rollbackTransportOrder(RollbackTransportOrderRequest: RollbackTransportOrderRequest, options: any = {}): FetchArgs {
            // verify required parameter 'RollbackTransportOrderRequest' is not null or undefined
            if (RollbackTransportOrderRequest === null || RollbackTransportOrderRequest === undefined) {
                throw new RequiredError('RollbackTransportOrderRequest','Required parameter RollbackTransportOrderRequest was null or undefined when calling rollbackTransportOrder.');
            }
            const localVarPath = `/internal/rollbackTransportOrder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RollbackTransportOrderRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(RollbackTransportOrderRequest || {}) : (RollbackTransportOrderRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {TaskOptions} TaskOptions TaskOptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTask(TaskOptions: TaskOptions, options: any = {}): FetchArgs {
            // verify required parameter 'TaskOptions' is not null or undefined
            if (TaskOptions === null || TaskOptions === undefined) {
                throw new RequiredError('TaskOptions','Required parameter TaskOptions was null or undefined when calling runTask.');
            }
            const localVarPath = `/internal/tasks/runManually`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TaskOptions" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TaskOptions || {}) : (TaskOptions || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves the configuration as draft, so it's saved for later usage.
         * @summary saveConfigAsDraft
         * @param {SaveConfigAsDraftRequest} SaveConfigAsDraftRequest SaveConfigAsDraftRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfigAsDraft(SaveConfigAsDraftRequest: SaveConfigAsDraftRequest, options: any = {}): FetchArgs {
            // verify required parameter 'SaveConfigAsDraftRequest' is not null or undefined
            if (SaveConfigAsDraftRequest === null || SaveConfigAsDraftRequest === undefined) {
                throw new RequiredError('SaveConfigAsDraftRequest','Required parameter SaveConfigAsDraftRequest was null or undefined when calling saveConfigAsDraft.');
            }
            const localVarPath = `/internal/saveConfigAsDraft`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SaveConfigAsDraftRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SaveConfigAsDraftRequest || {}) : (SaveConfigAsDraftRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves a description for a specific field in the CompanyConfiguration. The field is specified by a JQuary leading to the field.
         * @summary saveConfigFieldDescription
         * @param {SaveConfigFieldDescriptionRequest} SaveConfigFieldDescriptionRequest SaveConfigFieldDescriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfigFieldDescription(SaveConfigFieldDescriptionRequest: SaveConfigFieldDescriptionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'SaveConfigFieldDescriptionRequest' is not null or undefined
            if (SaveConfigFieldDescriptionRequest === null || SaveConfigFieldDescriptionRequest === undefined) {
                throw new RequiredError('SaveConfigFieldDescriptionRequest','Required parameter SaveConfigFieldDescriptionRequest was null or undefined when calling saveConfigFieldDescription.');
            }
            const localVarPath = `/internal/configFieldDescription`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SaveConfigFieldDescriptionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SaveConfigFieldDescriptionRequest || {}) : (SaveConfigFieldDescriptionRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the default contract.
         * @summary save Contract
         * @param {SaveContractRequest} SaveContractRequest SaveContractRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContract(SaveContractRequest: SaveContractRequest, options: any = {}): FetchArgs {
            // verify required parameter 'SaveContractRequest' is not null or undefined
            if (SaveContractRequest === null || SaveContractRequest === undefined) {
                throw new RequiredError('SaveContractRequest','Required parameter SaveContractRequest was null or undefined when calling saveContract.');
            }
            const localVarPath = `/internal/saveContract`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SaveContractRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SaveContractRequest || {}) : (SaveContractRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves a SystemStatusMessage and returns if it succeeded.
         * @summary Save SystemStatusMessage
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSystemStatusMessages(SystemStatusMessage: SystemStatusMessage, options: any = {}): FetchArgs {
            // verify required parameter 'SystemStatusMessage' is not null or undefined
            if (SystemStatusMessage === null || SystemStatusMessage === undefined) {
                throw new RequiredError('SystemStatusMessage','Required parameter SystemStatusMessage was null or undefined when calling saveSystemStatusMessages.');
            }
            const localVarPath = `/internal/systemStatusMessages`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SystemStatusMessage" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SystemStatusMessage || {}) : (SystemStatusMessage || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary save a new TransportOrderConfig Test
         * @param {SaveTransportOrderConfigTestRequest} SaveTransportOrderConfigTestRequest SaveTransportOrderConfigTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTransportOrderConfigTest(SaveTransportOrderConfigTestRequest: SaveTransportOrderConfigTestRequest, options: any = {}): FetchArgs {
            // verify required parameter 'SaveTransportOrderConfigTestRequest' is not null or undefined
            if (SaveTransportOrderConfigTestRequest === null || SaveTransportOrderConfigTestRequest === undefined) {
                throw new RequiredError('SaveTransportOrderConfigTestRequest','Required parameter SaveTransportOrderConfigTestRequest was null or undefined when calling saveTransportOrderConfigTest.');
            }
            const localVarPath = `/internal/company/saveTransportOrderConfigTest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SaveTransportOrderConfigTestRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SaveTransportOrderConfigTestRequest || {}) : (SaveTransportOrderConfigTestRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch unassigned tickets with Score label from GitLab, sorted by score descending
         * @summary scoredUnassignedTickets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoredUnassignedTickets(options: any = {}): FetchArgs {
            const localVarPath = `/internal/scoredUnassignedTickets`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint searches through all configurations of all companies for a given searchTerm. The searchTerm is splitted by whitespaces and will return matches for every substring. To avoid splitting the searchterm or parts of it, please surround it by quots. Example:    searchterm [hello world] will respond every config containing the term \"hello\" and every config containing the term \"world\".             searchterm [\"hello world\"] will respond every config containing the searchterm \"hello world\" 
         * @summary search Configs
         * @param {SearchConfigsRequest} SearchConfigsRequest SearchConfigsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConfigs(SearchConfigsRequest: SearchConfigsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'SearchConfigsRequest' is not null or undefined
            if (SearchConfigsRequest === null || SearchConfigsRequest === undefined) {
                throw new RequiredError('SearchConfigsRequest','Required parameter SearchConfigsRequest was null or undefined when calling searchConfigs.');
            }
            const localVarPath = `/internal/searchConfig`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SearchConfigsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SearchConfigsRequest || {}) : (SearchConfigsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary redirects query to graylog and returns found logs
         * @param {GraylogRequest} GraylogRequest GraylogRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGraylog(GraylogRequest: GraylogRequest, options: any = {}): FetchArgs {
            // verify required parameter 'GraylogRequest' is not null or undefined
            if (GraylogRequest === null || GraylogRequest === undefined) {
                throw new RequiredError('GraylogRequest','Required parameter GraylogRequest was null or undefined when calling searchGraylog.');
            }
            const localVarPath = `/internal/graylog`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraylogRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GraylogRequest || {}) : (GraylogRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all transport orders exported as excel file
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {TransportSelectedOrderToExcelConversionRequest} TransportSelectedOrderToExcelConversionRequest TransportSelectedOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectedTransportOrderExcelExport(TransportSelectedOrderToExcelConversionRequest: TransportSelectedOrderToExcelConversionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportSelectedOrderToExcelConversionRequest' is not null or undefined
            if (TransportSelectedOrderToExcelConversionRequest === null || TransportSelectedOrderToExcelConversionRequest === undefined) {
                throw new RequiredError('TransportSelectedOrderToExcelConversionRequest','Required parameter TransportSelectedOrderToExcelConversionRequest was null or undefined when calling selectedTransportOrderExcelExport.');
            }
            const localVarPath = `/internal/selectedTransportOrderExcelExport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportSelectedOrderToExcelConversionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportSelectedOrderToExcelConversionRequest || {}) : (TransportSelectedOrderToExcelConversionRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sends mail and logs it into the MailLog-collection in the DB.
         * @summary send message
         * @param {MessageLog} MessageLog MessageLog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(MessageLog: MessageLog, options: any = {}): FetchArgs {
            // verify required parameter 'MessageLog' is not null or undefined
            if (MessageLog === null || MessageLog === undefined) {
                throw new RequiredError('MessageLog','Required parameter MessageLog was null or undefined when calling sendMessage.');
            }
            const localVarPath = `/internal/sendMessage`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MessageLog" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MessageLog || {}) : (MessageLog || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a path to the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary setCmNavTreeTextModal
         * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options: any = {}): FetchArgs {
            // verify required parameter 'CmNavTreeTextModalListRequest' is not null or undefined
            if (CmNavTreeTextModalListRequest === null || CmNavTreeTextModalListRequest === undefined) {
                throw new RequiredError('CmNavTreeTextModalListRequest','Required parameter CmNavTreeTextModalListRequest was null or undefined when calling setCmNavTreeTextModal.');
            }
            const localVarPath = `/internal/CmNavTreeTextModalList`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CmNavTreeTextModalListRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CmNavTreeTextModalListRequest || {}) : (CmNavTreeTextModalListRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send shipment Form Config access details via user's Email.
         * @summary Send shipment Form Config access details via user's Email
         * @param {string} shipmentCreateFormId shipmentCreateFormId
         * @param {ShareUserAccessViaEmailRequest} ShareUserAccessViaEmailRequest ShareUserAccessViaEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareShipmentCreateFormUserAccessViaEmail(shipmentCreateFormId: string, ShareUserAccessViaEmailRequest: ShareUserAccessViaEmailRequest, options: any = {}): FetchArgs {
            // verify required parameter 'shipmentCreateFormId' is not null or undefined
            if (shipmentCreateFormId === null || shipmentCreateFormId === undefined) {
                throw new RequiredError('shipmentCreateFormId','Required parameter shipmentCreateFormId was null or undefined when calling shareShipmentCreateFormUserAccessViaEmail.');
            }
            // verify required parameter 'ShareUserAccessViaEmailRequest' is not null or undefined
            if (ShareUserAccessViaEmailRequest === null || ShareUserAccessViaEmailRequest === undefined) {
                throw new RequiredError('ShareUserAccessViaEmailRequest','Required parameter ShareUserAccessViaEmailRequest was null or undefined when calling shareShipmentCreateFormUserAccessViaEmail.');
            }
            const localVarPath = `/internal/company/shipmentFormConfig/{shipmentCreateFormId}/shareUserAccessViaEmail`
                .replace(`{${"shipmentCreateFormId"}}`, encodeURIComponent(String(shipmentCreateFormId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShareUserAccessViaEmailRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ShareUserAccessViaEmailRequest || {}) : (ShareUserAccessViaEmailRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves a SystemStatusMessage and ends all other SystemStatusMessages for the combination of companyId + groupKey.
         * @summary Save SystemStatusMessage and end others
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleSaveSystemStatusMessage(SystemStatusMessage: SystemStatusMessage, options: any = {}): FetchArgs {
            // verify required parameter 'SystemStatusMessage' is not null or undefined
            if (SystemStatusMessage === null || SystemStatusMessage === undefined) {
                throw new RequiredError('SystemStatusMessage','Required parameter SystemStatusMessage was null or undefined when calling simpleSaveSystemStatusMessage.');
            }
            const localVarPath = `/internal/systemStatusMessagesSimple`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SystemStatusMessage" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SystemStatusMessage || {}) : (SystemStatusMessage || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a xlsx the standingTimesUi.
         * @summary Get a standingTimes report of specified tours of one shipper as xlsx
         * @param {StandingTimesUiSpecificReportXlsxRequest} StandingTimesUiSpecificReportXlsxRequest StandingTimesUiSpecificReportXlsxRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standingTimesUiSpecificReportXlsx(StandingTimesUiSpecificReportXlsxRequest: StandingTimesUiSpecificReportXlsxRequest, options: any = {}): FetchArgs {
            // verify required parameter 'StandingTimesUiSpecificReportXlsxRequest' is not null or undefined
            if (StandingTimesUiSpecificReportXlsxRequest === null || StandingTimesUiSpecificReportXlsxRequest === undefined) {
                throw new RequiredError('StandingTimesUiSpecificReportXlsxRequest','Required parameter StandingTimesUiSpecificReportXlsxRequest was null or undefined when calling standingTimesUiSpecificReportXlsx.');
            }
            const localVarPath = `/internal/standingTimesUiSpecificReportXlsx`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"StandingTimesUiSpecificReportXlsxRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(StandingTimesUiSpecificReportXlsxRequest || {}) : (StandingTimesUiSpecificReportXlsxRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a xlsx the standingTimesUi.
         * @summary Get standingTimesUi table as xlsx
         * @param {Date} endTime endTime
         * @param {Date} startTime startTime
         * @param {StandingTimesUiTableAsXlsxRequest} StandingTimesUiTableAsXlsxRequest StandingTimesUiTableAsXlsxRequest
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standingTimesUiTableAsXlsx(endTime: Date, startTime: Date, StandingTimesUiTableAsXlsxRequest: StandingTimesUiTableAsXlsxRequest, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options: any = {}): FetchArgs {
            // verify required parameter 'endTime' is not null or undefined
            if (endTime === null || endTime === undefined) {
                throw new RequiredError('endTime','Required parameter endTime was null or undefined when calling standingTimesUiTableAsXlsx.');
            }
            // verify required parameter 'startTime' is not null or undefined
            if (startTime === null || startTime === undefined) {
                throw new RequiredError('startTime','Required parameter startTime was null or undefined when calling standingTimesUiTableAsXlsx.');
            }
            // verify required parameter 'StandingTimesUiTableAsXlsxRequest' is not null or undefined
            if (StandingTimesUiTableAsXlsxRequest === null || StandingTimesUiTableAsXlsxRequest === undefined) {
                throw new RequiredError('StandingTimesUiTableAsXlsxRequest','Required parameter StandingTimesUiTableAsXlsxRequest was null or undefined when calling standingTimesUiTableAsXlsx.');
            }
            const localVarPath = `/internal/standingTimesUiTableAsXlsx`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dateTimeField !== undefined) {
                localVarQueryParameter['dateTimeField'] = dateTimeField;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any).toISOString();
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any).toISOString();
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"StandingTimesUiTableAsXlsxRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(StandingTimesUiTableAsXlsxRequest || {}) : (StandingTimesUiTableAsXlsxRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upsert the full Spedion DTCO activity logbook for a driver.
         * @summary submitDriverWorkAndRestTimes
         * @param {DriverWorkAndRestTimesUpsertRequest} DriverWorkAndRestTimesUpsertRequest DriverWorkAndRestTimesUpsertRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDriverWorkAndRestTimes(DriverWorkAndRestTimesUpsertRequest: DriverWorkAndRestTimesUpsertRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DriverWorkAndRestTimesUpsertRequest' is not null or undefined
            if (DriverWorkAndRestTimesUpsertRequest === null || DriverWorkAndRestTimesUpsertRequest === undefined) {
                throw new RequiredError('DriverWorkAndRestTimesUpsertRequest','Required parameter DriverWorkAndRestTimesUpsertRequest was null or undefined when calling submitDriverWorkAndRestTimes.');
            }
            const localVarPath = `/internal/driverWorkAndRestTimes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DriverWorkAndRestTimesUpsertRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DriverWorkAndRestTimesUpsertRequest || {}) : (DriverWorkAndRestTimesUpsertRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary switches the active state
         * @param {SwitchActiveTransportOrderConfigTestsRequest} SwitchActiveTransportOrderConfigTestsRequest SwitchActiveTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchActiveTransportOrderConfigTest(SwitchActiveTransportOrderConfigTestsRequest: SwitchActiveTransportOrderConfigTestsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'SwitchActiveTransportOrderConfigTestsRequest' is not null or undefined
            if (SwitchActiveTransportOrderConfigTestsRequest === null || SwitchActiveTransportOrderConfigTestsRequest === undefined) {
                throw new RequiredError('SwitchActiveTransportOrderConfigTestsRequest','Required parameter SwitchActiveTransportOrderConfigTestsRequest was null or undefined when calling switchActiveTransportOrderConfigTest.');
            }
            const localVarPath = `/internal/company/switchActiveTransportOrderConfigTest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SwitchActiveTransportOrderConfigTestsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SwitchActiveTransportOrderConfigTestsRequest || {}) : (SwitchActiveTransportOrderConfigTestsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the default contract.
         * @summary save Contract
         * @param {number} configIndex configIndex
         * @param {CompanyWithConfig} CompanyWithConfig CompanyWithConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testApiGatewayConfig(configIndex: number, CompanyWithConfig: CompanyWithConfig, options: any = {}): FetchArgs {
            // verify required parameter 'configIndex' is not null or undefined
            if (configIndex === null || configIndex === undefined) {
                throw new RequiredError('configIndex','Required parameter configIndex was null or undefined when calling testApiGatewayConfig.');
            }
            // verify required parameter 'CompanyWithConfig' is not null or undefined
            if (CompanyWithConfig === null || CompanyWithConfig === undefined) {
                throw new RequiredError('CompanyWithConfig','Required parameter CompanyWithConfig was null or undefined when calling testApiGatewayConfig.');
            }
            const localVarPath = `/internal/testApiGatewayConfig/{configIndex}`
                .replace(`{${"configIndex"}}`, encodeURIComponent(String(configIndex)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyWithConfig" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(CompanyWithConfig || {}) : (CompanyWithConfig || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test all log levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testLogLevel(options: any = {}): FetchArgs {
            const localVarPath = `/internal/system/testLogLevel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sends a failed request again
         * @param {string} failedRequestId failedRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerFailedRequest(failedRequestId: string, options: any = {}): FetchArgs {
            // verify required parameter 'failedRequestId' is not null or undefined
            if (failedRequestId === null || failedRequestId === undefined) {
                throw new RequiredError('failedRequestId','Required parameter failedRequestId was null or undefined when calling triggerFailedRequest.');
            }
            const localVarPath = `/internal/triggerFailedRequest/{failedRequestId}`
                .replace(`{${"failedRequestId"}}`, encodeURIComponent(String(failedRequestId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary triggers a given list of tests
         * @param {TriggerTransportOrderConfigTestsRequest} TriggerTransportOrderConfigTestsRequest TriggerTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerTransportOrderTests(TriggerTransportOrderConfigTestsRequest: TriggerTransportOrderConfigTestsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TriggerTransportOrderConfigTestsRequest' is not null or undefined
            if (TriggerTransportOrderConfigTestsRequest === null || TriggerTransportOrderConfigTestsRequest === undefined) {
                throw new RequiredError('TriggerTransportOrderConfigTestsRequest','Required parameter TriggerTransportOrderConfigTestsRequest was null or undefined when calling triggerTransportOrderTests.');
            }
            const localVarPath = `/internal/company/triggerTransportOrderConfigTests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TriggerTransportOrderConfigTestsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TriggerTransportOrderConfigTestsRequest || {}) : (TriggerTransportOrderConfigTestsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adding an email address in unsubscribe list.
         * @summary send message
         * @param {UnsubscribeEmailRequest} UnsubscribeEmailRequest UnsubscribeEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeEmail(UnsubscribeEmailRequest: UnsubscribeEmailRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UnsubscribeEmailRequest' is not null or undefined
            if (UnsubscribeEmailRequest === null || UnsubscribeEmailRequest === undefined) {
                throw new RequiredError('UnsubscribeEmailRequest','Required parameter UnsubscribeEmailRequest was null or undefined when calling unsubscribeEmail.');
            }
            const localVarPath = `/internal/unsubscribeEmail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UnsubscribeEmailRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UnsubscribeEmailRequest || {}) : (UnsubscribeEmailRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the state dict of the current api gateway with the given config
         * @summary submit api gateway state
         * @param {string} companyId companyId
         * @param {string} configId configId
         * @param {ApiGatewayStateUpdateRequest} ApiGatewayStateUpdateRequest ApiGatewayStateUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiGatewayState(companyId: string, configId: string, ApiGatewayStateUpdateRequest: ApiGatewayStateUpdateRequest, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling updateApiGatewayState.');
            }
            // verify required parameter 'configId' is not null or undefined
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId','Required parameter configId was null or undefined when calling updateApiGatewayState.');
            }
            // verify required parameter 'ApiGatewayStateUpdateRequest' is not null or undefined
            if (ApiGatewayStateUpdateRequest === null || ApiGatewayStateUpdateRequest === undefined) {
                throw new RequiredError('ApiGatewayStateUpdateRequest','Required parameter ApiGatewayStateUpdateRequest was null or undefined when calling updateApiGatewayState.');
            }
            const localVarPath = `/internal/api_gateway/state/{companyId}/{configId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"configId"}}`, encodeURIComponent(String(configId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ApiGatewayStateUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ApiGatewayStateUpdateRequest || {}) : (ApiGatewayStateUpdateRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * add a company to the user, that he can then switch to
         * @summary updates all companies that a user can switch to
         * @param {UpdateAvailableCompanyToUserRequest} UpdateAvailableCompanyToUserRequest UpdateAvailableCompanyToUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableCompanyToUser(UpdateAvailableCompanyToUserRequest: UpdateAvailableCompanyToUserRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UpdateAvailableCompanyToUserRequest' is not null or undefined
            if (UpdateAvailableCompanyToUserRequest === null || UpdateAvailableCompanyToUserRequest === undefined) {
                throw new RequiredError('UpdateAvailableCompanyToUserRequest','Required parameter UpdateAvailableCompanyToUserRequest was null or undefined when calling updateAvailableCompanyToUser.');
            }
            const localVarPath = `/internal/updateAvailableCompanyToUser`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateAvailableCompanyToUserRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateAvailableCompanyToUserRequest || {}) : (UpdateAvailableCompanyToUserRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the comment on a given ConfigHistory
         * @summary update company config history comment
         * @param {string} companyId companyId
         * @param {string} historyId historyId
         * @param {UpdateCompanyConfigHistoryCommentRequest} UpdateCompanyConfigHistoryCommentRequest UpdateCompanyConfigHistoryCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfigHistoryComment(companyId: string, historyId: string, UpdateCompanyConfigHistoryCommentRequest: UpdateCompanyConfigHistoryCommentRequest, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling updateCompanyConfigHistoryComment.');
            }
            // verify required parameter 'historyId' is not null or undefined
            if (historyId === null || historyId === undefined) {
                throw new RequiredError('historyId','Required parameter historyId was null or undefined when calling updateCompanyConfigHistoryComment.');
            }
            // verify required parameter 'UpdateCompanyConfigHistoryCommentRequest' is not null or undefined
            if (UpdateCompanyConfigHistoryCommentRequest === null || UpdateCompanyConfigHistoryCommentRequest === undefined) {
                throw new RequiredError('UpdateCompanyConfigHistoryCommentRequest','Required parameter UpdateCompanyConfigHistoryCommentRequest was null or undefined when calling updateCompanyConfigHistoryComment.');
            }
            const localVarPath = `/internal/updateCompanyConfigHistoryComment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (historyId !== undefined) {
                localVarQueryParameter['historyId'] = historyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCompanyConfigHistoryCommentRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateCompanyConfigHistoryCommentRequest || {}) : (UpdateCompanyConfigHistoryCommentRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the configuration of the company of the currently authenticated user.
         * @summary update current company
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {string} [comment] comment
         * @param {string} [ticketNrs] ticketNrs
         * @param {number} [workTimeInMinutes] workTimeInMinutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, comment?: string, ticketNrs?: string, workTimeInMinutes?: number, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling updateCompanyConfiguration.');
            }
            // verify required parameter 'UpdateCompanyConfigRequestWrapper' is not null or undefined
            if (UpdateCompanyConfigRequestWrapper === null || UpdateCompanyConfigRequestWrapper === undefined) {
                throw new RequiredError('UpdateCompanyConfigRequestWrapper','Required parameter UpdateCompanyConfigRequestWrapper was null or undefined when calling updateCompanyConfiguration.');
            }
            const localVarPath = `/internal/updateCompanyConfiguration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (ticketNrs !== undefined) {
                localVarQueryParameter['ticketNrs'] = ticketNrs;
            }

            if (workTimeInMinutes !== undefined) {
                localVarQueryParameter['workTimeInMinutes'] = workTimeInMinutes;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCompanyConfigRequestWrapper" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateCompanyConfigRequestWrapper || {}) : (UpdateCompanyConfigRequestWrapper || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gives back all drafts for this user and this companyId.  
         * @summary updateConfigDraft
         * @param {string} draftId draftId
         * @param {boolean} shared shared
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigDraft(draftId: string, shared: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'draftId' is not null or undefined
            if (draftId === null || draftId === undefined) {
                throw new RequiredError('draftId','Required parameter draftId was null or undefined when calling updateConfigDraft.');
            }
            // verify required parameter 'shared' is not null or undefined
            if (shared === null || shared === undefined) {
                throw new RequiredError('shared','Required parameter shared was null or undefined when calling updateConfigDraft.');
            }
            const localVarPath = `/internal/UpdateConfigDraft`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (draftId !== undefined) {
                localVarQueryParameter['draftId'] = draftId;
            }

            if (shared !== undefined) {
                localVarQueryParameter['shared'] = shared;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is webhook from mailgun which trigger on any status change of email our system send.
         * @summary update email status text webhook from mailgun
         * @param {MailgunWebhookInputRequest} MailgunWebhookInputRequest MailgunWebhookInputRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailStatusTextWebhook(MailgunWebhookInputRequest: MailgunWebhookInputRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MailgunWebhookInputRequest' is not null or undefined
            if (MailgunWebhookInputRequest === null || MailgunWebhookInputRequest === undefined) {
                throw new RequiredError('MailgunWebhookInputRequest','Required parameter MailgunWebhookInputRequest was null or undefined when calling updateEmailStatusTextWebhook.');
            }
            const localVarPath = `/mailgun/updateEmailStatusTextWebhook`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MailgunWebhookInputRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MailgunWebhookInputRequest || {}) : (MailgunWebhookInputRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update global geofences by id
         * @param {string} id id
         * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalGeofences(id: string, GlobalGeofence: GlobalGeofence, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateGlobalGeofences.');
            }
            // verify required parameter 'GlobalGeofence' is not null or undefined
            if (GlobalGeofence === null || GlobalGeofence === undefined) {
                throw new RequiredError('GlobalGeofence','Required parameter GlobalGeofence was null or undefined when calling updateGlobalGeofences.');
            }
            const localVarPath = `/internal/globalGeofences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GlobalGeofence" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(GlobalGeofence || {}) : (GlobalGeofence || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the message log by given id and update its acknowledge status.
         * @summary update external partner id
         * @param {MessageLogAcknowledgeRequest} MessageLogAcknowledgeRequest MessageLogAcknowledgeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageLogToAcknowledgeStatus(MessageLogAcknowledgeRequest: MessageLogAcknowledgeRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MessageLogAcknowledgeRequest' is not null or undefined
            if (MessageLogAcknowledgeRequest === null || MessageLogAcknowledgeRequest === undefined) {
                throw new RequiredError('MessageLogAcknowledgeRequest','Required parameter MessageLogAcknowledgeRequest was null or undefined when calling updateMessageLogToAcknowledgeStatus.');
            }
            const localVarPath = `/internal/updateMessageLogToAcknowledgeStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MessageLogAcknowledgeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MessageLogAcknowledgeRequest || {}) : (MessageLogAcknowledgeRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will do the same as createOrModify, but without saving anything to the DB. 
         * @summary Update the missing attribute values
         * @param {MissingAttributeValuesUpdateRequest} MissingAttributeValuesUpdateRequest MissingAttributeValuesUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMissingAttributeValues(MissingAttributeValuesUpdateRequest: MissingAttributeValuesUpdateRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MissingAttributeValuesUpdateRequest' is not null or undefined
            if (MissingAttributeValuesUpdateRequest === null || MissingAttributeValuesUpdateRequest === undefined) {
                throw new RequiredError('MissingAttributeValuesUpdateRequest','Required parameter MissingAttributeValuesUpdateRequest was null or undefined when calling updateMissingAttributeValues.');
            }
            const localVarPath = `/internal/updateMissingAttributeValues`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MissingAttributeValuesUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MissingAttributeValuesUpdateRequest || {}) : (MissingAttributeValuesUpdateRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the etaCalculatorEvent's processed and errorString fields.
         * @summary set given etaCalculator event's processed to true and the given errorString
         * @param {MultipleEtaProcessedRequest} MultipleEtaProcessedRequest MultipleEtaProcessedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMultiEtaCalculatorEvents(MultipleEtaProcessedRequest: MultipleEtaProcessedRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MultipleEtaProcessedRequest' is not null or undefined
            if (MultipleEtaProcessedRequest === null || MultipleEtaProcessedRequest === undefined) {
                throw new RequiredError('MultipleEtaProcessedRequest','Required parameter MultipleEtaProcessedRequest was null or undefined when calling updateMultiEtaCalculatorEvents.');
            }
            const localVarPath = `/internal/etaCalculatorEvents/updateMany`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MultipleEtaProcessedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MultipleEtaProcessedRequest || {}) : (MultipleEtaProcessedRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update or insert schedulerTaskConfig
         * @param {SchedulerTaskConfig} SchedulerTaskConfig SchedulerTaskConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrInsertSchedulerTaskConfig(SchedulerTaskConfig: SchedulerTaskConfig, options: any = {}): FetchArgs {
            // verify required parameter 'SchedulerTaskConfig' is not null or undefined
            if (SchedulerTaskConfig === null || SchedulerTaskConfig === undefined) {
                throw new RequiredError('SchedulerTaskConfig','Required parameter SchedulerTaskConfig was null or undefined when calling updateOrInsertSchedulerTaskConfig.');
            }
            const localVarPath = `/internal/scheduler/task`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SchedulerTaskConfig" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SchedulerTaskConfig || {}) : (SchedulerTaskConfig || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * updates a list of queued events with a given processingState
         * @summary UpdateQueuedEvents
         * @param {UpdateQueuedEventsRequest} UpdateQueuedEventsRequest UpdateQueuedEventsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEvents(UpdateQueuedEventsRequest: UpdateQueuedEventsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UpdateQueuedEventsRequest' is not null or undefined
            if (UpdateQueuedEventsRequest === null || UpdateQueuedEventsRequest === undefined) {
                throw new RequiredError('UpdateQueuedEventsRequest','Required parameter UpdateQueuedEventsRequest was null or undefined when calling updateQueuedEvents.');
            }
            const localVarPath = `/internal/updateQueuedEvents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateQueuedEventsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateQueuedEventsRequest || {}) : (UpdateQueuedEventsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update Scheduler config
         * @param {SchedulerConfig} SchedulerConfig SchedulerConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerConfig(SchedulerConfig: SchedulerConfig, options: any = {}): FetchArgs {
            // verify required parameter 'SchedulerConfig' is not null or undefined
            if (SchedulerConfig === null || SchedulerConfig === undefined) {
                throw new RequiredError('SchedulerConfig','Required parameter SchedulerConfig was null or undefined when calling updateSchedulerConfig.');
            }
            const localVarPath = `/internal/scheduler/config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SchedulerConfig" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SchedulerConfig || {}) : (SchedulerConfig || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a specific SchedulerReportingConfiguration. Only accessible for superusers.
         * @summary Update SchedulerReportingConfiguration
         * @param {string} id id
         * @param {SchedulerReportingConfiguration} SchedulerReportingConfiguration SchedulerReportingConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerReportingConfiguration(id: string, SchedulerReportingConfiguration: SchedulerReportingConfiguration, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateSchedulerReportingConfiguration.');
            }
            // verify required parameter 'SchedulerReportingConfiguration' is not null or undefined
            if (SchedulerReportingConfiguration === null || SchedulerReportingConfiguration === undefined) {
                throw new RequiredError('SchedulerReportingConfiguration','Required parameter SchedulerReportingConfiguration was null or undefined when calling updateSchedulerReportingConfiguration.');
            }
            const localVarPath = `/internal/schedulerReportingConfigurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SchedulerReportingConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(SchedulerReportingConfiguration || {}) : (SchedulerReportingConfiguration || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates the test
         * @param {UpdateTransportOrderConfigTestsRequest} UpdateTransportOrderConfigTestsRequest UpdateTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportOrderConfigTests(UpdateTransportOrderConfigTestsRequest: UpdateTransportOrderConfigTestsRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UpdateTransportOrderConfigTestsRequest' is not null or undefined
            if (UpdateTransportOrderConfigTestsRequest === null || UpdateTransportOrderConfigTestsRequest === undefined) {
                throw new RequiredError('UpdateTransportOrderConfigTestsRequest','Required parameter UpdateTransportOrderConfigTestsRequest was null or undefined when calling updateTransportOrderConfigTests.');
            }
            const localVarPath = `/internal/company/updateTransportOrderConfigTests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateTransportOrderConfigTestsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateTransportOrderConfigTestsRequest || {}) : (UpdateTransportOrderConfigTestsRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * uploads credit notes to Zoho
         * @summary upload credit notes to zoho
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCreditNotesToZoho(BillingRequest: BillingRequest, options: any = {}): FetchArgs {
            // verify required parameter 'BillingRequest' is not null or undefined
            if (BillingRequest === null || BillingRequest === undefined) {
                throw new RequiredError('BillingRequest','Required parameter BillingRequest was null or undefined when calling uploadCreditNotesToZoho.');
            }
            const localVarPath = `/internal/uploadCreditNotesToZoho`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BillingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(BillingRequest || {}) : (BillingRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * uploads an Invoice from the DB to Zoho
         * @summary upload invoice to zoho
         * @param {UploadInvoiceToZohoRequest} UploadInvoiceToZohoRequest UploadInvoiceToZohoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInvoiceToZoho(UploadInvoiceToZohoRequest: UploadInvoiceToZohoRequest, options: any = {}): FetchArgs {
            // verify required parameter 'UploadInvoiceToZohoRequest' is not null or undefined
            if (UploadInvoiceToZohoRequest === null || UploadInvoiceToZohoRequest === undefined) {
                throw new RequiredError('UploadInvoiceToZohoRequest','Required parameter UploadInvoiceToZohoRequest was null or undefined when calling uploadInvoiceToZoho.');
            }
            const localVarPath = `/internal/uploadInvoiceToZoho`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UploadInvoiceToZohoRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UploadInvoiceToZohoRequest || {}) : (UploadInvoiceToZohoRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the configuration of the company of the currently authenticated user.
         * @summary update current company
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling validateCompanyConfiguration.');
            }
            // verify required parameter 'UpdateCompanyConfigRequestWrapper' is not null or undefined
            if (UpdateCompanyConfigRequestWrapper === null || UpdateCompanyConfigRequestWrapper === undefined) {
                throw new RequiredError('UpdateCompanyConfigRequestWrapper','Required parameter UpdateCompanyConfigRequestWrapper was null or undefined when calling validateCompanyConfiguration.');
            }
            const localVarPath = `/internal/validateCompanyConfiguration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCompanyConfigRequestWrapper" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateCompanyConfigRequestWrapper || {}) : (UpdateCompanyConfigRequestWrapper || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {string} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOrderBoxTag(tag: string, options: any = {}): FetchArgs {
            // verify required parameter 'tag' is not null or undefined
            if (tag === null || tag === undefined) {
                throw new RequiredError('tag','Required parameter tag was null or undefined when calling validateOrderBoxTag.');
            }
            const localVarPath = `/orderBox/validateTag/{tag}`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary checking if the given totp is currently valid
         * @param {string} totp totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTotp(totp: string, options: any = {}): FetchArgs {
            // verify required parameter 'totp' is not null or undefined
            if (totp === null || totp === undefined) {
                throw new RequiredError('totp','Required parameter totp was null or undefined when calling validateTotp.');
            }
            const localVarPath = `/internal/validateTotp/{totp}`
                .replace(`{${"totp"}}`, encodeURIComponent(String(totp)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the configuration, to check if it can be accepted by the database.
         * @summary validate company config
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling verifyCompanyConfiguration.');
            }
            // verify required parameter 'UpdateCompanyConfigRequestWrapper' is not null or undefined
            if (UpdateCompanyConfigRequestWrapper === null || UpdateCompanyConfigRequestWrapper === undefined) {
                throw new RequiredError('UpdateCompanyConfigRequestWrapper','Required parameter UpdateCompanyConfigRequestWrapper was null or undefined when calling verifyCompanyConfiguration.');
            }
            const localVarPath = `/internal/verifyCompanyConfiguration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCompanyConfigRequestWrapper" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(UpdateCompanyConfigRequestWrapper || {}) : (UpdateCompanyConfigRequestWrapper || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call this endpoint to view the transport order as immediate format. The immediate format is a list of key value pairs that describe the whole transport order. 
         * @summary Returns the Transport Order as immediate Format
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTransportOrderAsImmediateFormat(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling viewTransportOrderAsImmediateFormat.');
            }
            const localVarPath = `/internal/viewTransportOrderAsImmediateFormat/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary wait for specified duration in milliseconds
         * @param {number} timeInMs timeInMs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitForDuration(timeInMs: number, options: any = {}): FetchArgs {
            // verify required parameter 'timeInMs' is not null or undefined
            if (timeInMs === null || timeInMs === undefined) {
                throw new RequiredError('timeInMs','Required parameter timeInMs was null or undefined when calling waitForDuration.');
            }
            const localVarPath = `/internal/wait`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeInMs !== undefined) {
                localVarQueryParameter['timeInMs'] = timeInMs;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import an excel document containing the customer address mapping. This method is intentionally  allowed for non super users
         * @summary Import address mapping from lis
         * @param {any} doc Excel document to convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        xls2json(doc: any, options: any = {}): FetchArgs {
            // verify required parameter 'doc' is not null or undefined
            if (doc === null || doc === undefined) {
                throw new RequiredError('doc','Required parameter doc was null or undefined when calling xls2json.');
            }
            const localVarPath = `/internal/converter/xls2json`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (doc !== undefined) {
                localVarFormParams.set('doc', doc as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalApi - functional programming interface
 * @export
 */
export const InternalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Adds Defaults to a given configuration. Often needed for the converter.
         * @summary getUsersCompany
         * @param {AddDefaultsToConfigRequest} AddDefaultsToConfigRequest AddDefaultsToConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDefaultsToConfig(AddDefaultsToConfigRequest: AddDefaultsToConfigRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddDefaultsToConfigResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).addDefaultsToConfig(AddDefaultsToConfigRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary add global geofences
         * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGlobalGeofences(GlobalGeofence: GlobalGeofence, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddGlobalGeofencesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).addGlobalGeofences(GlobalGeofence, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create a new partnership
         * @param {PartnerAddRequest} PartnerAddRequest PartnerAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPartnerToCompany(PartnerAddRequest: PartnerAddRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Partner> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).addPartnerToCompany(PartnerAddRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary scriptErrorLogger
         * @param {ScriptErrorLoggerRequest} ScriptErrorLoggerRequest ScriptErrorLoggerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScriptErrorLog(ScriptErrorLoggerRequest: ScriptErrorLoggerRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ScriptErrorLogAddedResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).addScriptErrorLog(ScriptErrorLoggerRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of prompts based on the given search criteria 
         * @summary Test creation or modification of transport order
         * @param {OaiPromptListRequest} OaiPromptListRequest OaiPromptListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiListPrompts(OaiPromptListRequest: OaiPromptListRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OaiPromptListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).aiListPrompts(OaiPromptListRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify a promt with the given criteria 
         * @summary Test creation or modification of transport order
         * @param {string} id id
         * @param {AiParseResult} AiParseResult AiParseResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiModifyPromtResult(id: string, AiParseResult: AiParseResult, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AiParseResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).aiModifyPromtResult(id, AiParseResult, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation parses a text using the given input and returns the corresponding output 
         * @summary Call ai with the given promt
         * @param {ParseTextRequest} ParseTextRequest ParseTextRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiParseText(ParseTextRequest: ParseTextRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParseTextResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).aiParseText(ParseTextRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation parses a text using the given input and returns the corresponding output with Authentication token 
         * @summary Call ai with the given promt
         * @param {ParseTextPublicRequest} ParseTextPublicRequest ParseTextPublicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiParseTextPublic(ParseTextPublicRequest: ParseTextPublicRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParseTextResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).aiParseTextPublic(ParseTextPublicRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all transport orders exported as excel file using an endpoint with url based authentication
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {string} auth_token auth_token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTransportOrderExcelExportForPowerBi(auth_token: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).allTransportOrderExcelExportForPowerBi(auth_token, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * AI analysis of ticket difficulty vs score to suggest which ticket to pick up first
         * @summary analyzeTicketForPickup
         * @param {AnalyzeTicketForPickupRequest} AnalyzeTicketForPickupRequest AnalyzeTicketForPickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeTicketForPickup(AnalyzeTicketForPickupRequest: AnalyzeTicketForPickupRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AnalyzeTicketForPickupResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).analyzeTicketForPickup(AnalyzeTicketForPickupRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary archive transportOrders
         * @param {string} companyId companyId
         * @param {ArchiveTransportOrdersRequest} ArchiveTransportOrdersRequest ArchiveTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTransportOrders(companyId: string, ArchiveTransportOrdersRequest: ArchiveTransportOrdersRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ArchiveTransportOrdersResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).archiveTransportOrders(companyId, ArchiveTransportOrdersRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Call this endpoint to assign a transport order with an assigned device to the company of the currently logged in user.
         * @summary Assign transportorder with assigned device to company of logged in user
         * @param {AssignToCurrentCompanyRequestData} AssignToCurrentCompanyRequestData AssignToCurrentCompanyRequestData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTransportOrderToMyCompany(AssignToCurrentCompanyRequestData: AssignToCurrentCompanyRequestData, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AssignResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).assignTransportOrderToMyCompany(AssignToCurrentCompanyRequestData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * bill given projectWorkLogBook entries
         * @summary bill given projectWorkLogBook entries
         * @param {BillWorkLogBookEntriesRequest} BillWorkLogBookEntriesRequest BillWorkLogBookEntriesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billWorkLogBookEntries(BillWorkLogBookEntriesRequest: BillWorkLogBookEntriesRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BillWorkLogBookEntriesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).billWorkLogBookEntries(BillWorkLogBookEntriesRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the billing detailed usage report in billed TOs
         * @summary returns the billing detailed usage report in billed TOs
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingDetailedUsageReport(month: number, year: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).billingDetailedUsageReport(month, year, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {string} imei imei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderBoxTag(imei: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderBoxTagResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).calculateOrderBoxTag(imei, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Sets the system log level to the given value.
         * @param {string} logLevel logLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLogLevel(logLevel: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyMonitorConfigs> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).changeLogLevel(logLevel, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Compares the Zoho price and XLS price for an invoice generated from the billing request. Returns whether the prices are the same, both prices, and the invoice if they differ.
         * @summary compare Zoho and XLS prices for invoice
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareInvoicePrices(BillingRequest: BillingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ComparePricesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).compareInvoicePrices(BillingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Compute polyline + DRIVING/STANDING segments from a raw positions list (no DB fetch)
         * @param {ComputeSegmentsFromPositionsRequest} ComputeSegmentsFromPositionsRequest ComputeSegmentsFromPositionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeSegmentsFromPositions(ComputeSegmentsFromPositionsRequest: ComputeSegmentsFromPositionsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TourPolylineResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).computeSegmentsFromPositions(ComputeSegmentsFromPositionsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all transport orders exported as excel file
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {TransportAllOrderToExcelConversionRequest} TransportAllOrderToExcelConversionRequest TransportAllOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertAllTransportOrderListToExcel(TransportAllOrderToExcelConversionRequest: TransportAllOrderToExcelConversionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).convertAllTransportOrderListToExcel(TransportAllOrderToExcelConversionRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of transport orders exported as excel file
         * @summary convert list of transport orders to excel
         * @param {TransportOrderToExcelConversionRequest} TransportOrderToExcelConversionRequest TransportOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertTransportOrderListToExcel(TransportOrderToExcelConversionRequest: TransportOrderToExcelConversionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).convertTransportOrderListToExcel(TransportOrderToExcelConversionRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will copy an existing transport order and create it in a fresh state for a target company.
         * @summary create multiple transport orders
         * @param {CopyAsNewTransportOrderRequest} CopyAsNewTransportOrderRequest CopyAsNewTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyAsNewTransportOrder(CopyAsNewTransportOrderRequest: CopyAsNewTransportOrderRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).copyAsNewTransportOrder(CopyAsNewTransportOrderRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * create billing and responds with Zip-File
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBilling(BillingRequest: BillingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createBilling(BillingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will create a new company with the given name and address. The user must be a super user to execute this operation. Newly created company will have the state UNDER_CONSTRUCTION and the responsibleLogeniosManager will be set to the email of the user who created the company. This operation will also create a new CompanyHistory entry with the change type CREATE and return the created company object.
         * @summary Create a new company
         * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(CompanyCreateRequest: CompanyCreateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createCompany(CompanyCreateRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create a new company
         * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyOldToBeDeletedSoon(CompanyCreateRequest: CompanyCreateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createCompanyOldToBeDeletedSoon(CompanyCreateRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {boolean} includeLinked includeLinked
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2Endpoint(includeLinked: boolean, transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoStatusTestDataV2> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createDumpV2Endpoint(includeLinked, transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {boolean} includeLinked includeLinked
         * @param {string} transportOrderId transportOrderId
         * @param {boolean} zipped zipped
         * @param {string} [excludeTransportOrderChangeTypes] excludeTransportOrderChangeTypes
         * @param {boolean} [includePositionEvents] includePositionEvents
         * @param {string} [includeTransportOrderChangeTypes] includeTransportOrderChangeTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FileEndpoint(includeLinked: boolean, transportOrderId: string, zipped: boolean, excludeTransportOrderChangeTypes?: string, includePositionEvents?: boolean, includeTransportOrderChangeTypes?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createDumpV2FileEndpoint(includeLinked, transportOrderId, zipped, excludeTransportOrderChangeTypes, includePositionEvents, includeTransportOrderChangeTypes, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns dump data for transport orders in a specific version range.
         * @summary Get all needed test data for geo status tests (In Format V2) in a specific transport order version range
         * @param {GeoStatusDumpTransportOrderVersionRangeRequest} GeoStatusDumpTransportOrderVersionRangeRequest GeoStatusDumpTransportOrderVersionRangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FilteredByVersionRangeEndpoint(GeoStatusDumpTransportOrderVersionRangeRequest: GeoStatusDumpTransportOrderVersionRangeRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoStatusTestDataV2WithVersionRange> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createDumpV2FilteredByVersionRangeEndpoint(GeoStatusDumpTransportOrderVersionRangeRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {GeoStatusDumpTransportOrderListFilterRequest} GeoStatusDumpTransportOrderListFilterRequest GeoStatusDumpTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FilteredEndpoint(GeoStatusDumpTransportOrderListFilterRequest: GeoStatusDumpTransportOrderListFilterRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoStatusTestDataV2> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createDumpV2FilteredEndpoint(GeoStatusDumpTransportOrderListFilterRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * create invoices and store in DB
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoicesAndSaveToDB(BillingRequest: BillingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InvoiceResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createInvoicesAndSaveToDB(BillingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update or insert a script error log in the AI tasks.
         * @summary updateOrInsertAiTaskToDB
         * @param {AIAgentTask} AIAgentTask AIAgentTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyAiAgentTask(AIAgentTask: AIAgentTask, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AIAgentTask> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createOrModifyAiAgentTask(AIAgentTask, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates a conversion job log or updates an existing entry
         * @summary Fetch conversion job logs
         * @param {ConversionJobLog} ConversionJobLog ConversionJobLog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyConversionJobLog(ConversionJobLog: ConversionJobLog, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConversionJobLog> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createOrModifyConversionJobLog(ConversionJobLog, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update or insert a script Documentation in the Scripts Documentations Table.
         * @summary updateOrInsertScriptDocumentationToDB
         * @param {ScriptsDocumentationEntry} ScriptsDocumentationEntry ScriptsDocumentationEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyScriptDocumentation(ScriptsDocumentationEntry: ScriptsDocumentationEntry, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ScriptsDocumentationEntry> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createOrModifyScriptDocumentation(ScriptsDocumentationEntry, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will do the same as createOrModify, but without saving anything to the DB. 
         * @summary Test creation or modification of transport order
         * @param {CreateOrModifyTransportOrderDryRunRequest} CreateOrModifyTransportOrderDryRunRequest CreateOrModifyTransportOrderDryRunRequest
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrderDryRun(CreateOrModifyTransportOrderDryRunRequest: CreateOrModifyTransportOrderDryRunRequest, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreateOrModifyTransportOrderDryRunResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createOrModifyTransportOrderDryRun(CreateOrModifyTransportOrderDryRunRequest, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId
         * @summary create transport order
         * @param {string} companyId companyId
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrderForCompany(companyId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createOrModifyTransportOrderForCompany(companyId, TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * creates a rule for scheduled order creation.
         * @summary create rule for scheduled Order Creation
         * @param {ScheduledOrderCreationRule} ScheduledOrderCreationRule ScheduledOrderCreationRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateScheduledOrderCreationRule(ScheduledOrderCreationRule: ScheduledOrderCreationRule, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createOrUpdateScheduledOrderCreationRule(ScheduledOrderCreationRule, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary create an ProjectWorkLogBookEntry
         * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectWorkLogBookEntry(ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProjectWorkLogBookEntry> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createProjectWorkLogBookEntry(ProjectWorkLogBookEntry, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns scriptRunnerUser of given company.
         * @summary create new scriptRunnerUser for given company
         * @param {string} companyId companyId
         * @param {CreateScriptRunnerUserRequest} CreateScriptRunnerUserRequest CreateScriptRunnerUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScriptRunnerUser(companyId: string, CreateScriptRunnerUserRequest: CreateScriptRunnerUserRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreateScriptRunnerUserResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createScriptRunnerUser(companyId, CreateScriptRunnerUserRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a new shipment Form Config. The permission COMPANY_MODIFY is required to execute this operation.
         * @summary Create new shipment Form Config
         * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentFormConfig(ShipmentFormConfigRequest: ShipmentFormConfigRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShipmentFormConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createShipmentFormConfig(ShipmentFormConfigRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
         * @summary create transport order without authentication
         * @param {TransportOrderWithTokenPin} TransportOrderWithTokenPin TransportOrderWithTokenPin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportOrderPublic(TransportOrderWithTokenPin: TransportOrderWithTokenPin, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).createTransportOrderPublic(TransportOrderWithTokenPin, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gibt alle deferred notifications für eine bestimmte orderId zurück.  
         * @summary deferredNotifications
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferredNotifications(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeferredNotificationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deferredNotifications(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes the draft with the given id.  
         * @summary deleteDraftOfConfig
         * @param {string} companyId companyId
         * @param {string} draftId draftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftOfConfig(companyId: string, draftId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deleteDraftOfConfig(companyId, draftId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary delete failed requests by ids
         * @param {string} failedRequestIds failedRequestIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFailedRequest(failedRequestIds: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteFailedRequestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deleteFailedRequest(failedRequestIds, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary delete global geofences by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalGeofences(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddGlobalGeofencesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deleteGlobalGeofences(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes the older drafts (of the calling user and for the his current company) until only 5 drafts remain.  
         * @summary deleteOldestAutoSavedDraftOfConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOldestAutoSavedDraftOfConfig(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deleteOldestAutoSavedDraftOfConfig(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes the ProjectWorkLogBookEntry with the given id.  
         * @summary Delete ProjectWorkLogBookEntry by id
         * @param {string} logBookEntryId logBookEntryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectWorkLogBookEntryById(logBookEntryId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SimpleResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deleteProjectWorkLogBookEntryById(logBookEntryId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes the shipment form config with the specified config id.
         * @summary Delete shipment Form Config by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentFormConfigById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deleteShipmentFormConfigById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary deletes a TransportOrderConfigTest
         * @param {string} [testId] testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransportOrderConfigTest(testId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DeleteTransportOrderConfigTestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).deleteTransportOrderConfigTest(testId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a description of the link table that belongs to a transport order.
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeLinkedOrders(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderLinkDescriptionResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).describeLinkedOrders(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Call this endpoint to get a description of the patchset. The description contains tabular data what was changed in a transport order
         * @summary Describe patchset
         * @param {DescribePatchsetRequest} DescribePatchsetRequest DescribePatchsetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describePatchset(DescribePatchsetRequest: DescribePatchsetRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PatchsetDescription> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).describePatchset(DescribePatchsetRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Edit an iteration's user input and remove subsequent iterations.
         * @summary editAiAgentTaskIteration
         * @param {EditIterationRequest} EditIterationRequest EditIterationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAiAgentTaskIteration(EditIterationRequest: EditIterationRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AIAgentTask> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).editAiAgentTaskIteration(EditIterationRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary enroll for totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollTotp(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotpEnrollmentResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).enrollTotp(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * exclude Company From Unbilled TransportOrders Calculation
         * @summary exclude Company From Unbilled TransportOrders Calculation
         * @param {ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest} ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeCompanyFromUnbilledTransportOrdersCalculation(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest: ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ExcludeCompanyFromUnbilledTransportOrdersCalculationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).excludeCompanyFromUnbilledTransportOrdersCalculation(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary ExtractToSpecificConfig
         * @param {ExtractToSpecificConfigRequest} ExtractToSpecificConfigRequest ExtractToSpecificConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractToSpecificConfig(ExtractToSpecificConfigRequest: ExtractToSpecificConfigRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ExtractToSpecificConfigResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).extractToSpecificConfig(ExtractToSpecificConfigRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch an AI agent task by script path and company ID
         * @summary getAIAgentTaskByPath
         * @param {string} companyId companyId
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIAgentTaskByID(companyId: string, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AIAgentTask> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAIAgentTaskByID(companyId, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch AI agent tasks with optional filters
         * @summary getAIAgentTasks
         * @param {string} [companyId] companyId
         * @param {Date} [fromCreateDate] fromCreateDate
         * @param {string} [inputScriptPath] inputScriptPath
         * @param {'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED'} [status] status
         * @param {Date} [toCreateDate] toCreateDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIAgentTasks(companyId?: string, fromCreateDate?: Date, inputScriptPath?: string, status?: 'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED', toCreateDate?: Date, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchAIAgentTasksResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAIAgentTasks(companyId, fromCreateDate, inputScriptPath, status, toCreateDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back all drafts for this user and this companyId.  
         * @summary fetchAllConfigDrafts
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllConfigDrafts(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchAllConfigDraftsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAllConfigDrafts(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get companies with Notification Configuartion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllNotificationConfiguartions(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfigurationListResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAllNotificationConfiguartions(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllQueuedEventsByQueueType(queueType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAllQueuedEventsByQueueType(queueType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of company id and name and responsible manager of that company
         * @summary fetch list of all companies and their responsible managers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllResponsibleManagers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyResponsibleManagerResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAllResponsibleManagers(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all SchedulerReportingConfigurations. Only accessible for superusers.
         * @summary Fetch all SchedulerReportingConfigurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllSchedulerReportingConfigurations(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SchedulerReportingConfigurationsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAllSchedulerReportingConfigurations(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the state of the api gateway for the given company. If no state is present, initialize a new api gateway state
         * @summary get api gateway state
         * @param {string} companyId companyId
         * @param {string} configId configId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchApiGatewayState(companyId: string, configId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ApiGatewayState> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchApiGatewayState(companyId, configId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Call this endpoint to get the Assigned device info for a transport order using the companyTag and the external order identifier
         * @summary Query Assigned Device info by external order ref
         * @param {AccessTransportOrderViaExternalAssignedDeviceUrlRequest} AccessTransportOrderViaExternalAssignedDeviceUrlRequest AccessTransportOrderViaExternalAssignedDeviceUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAssignedDeviceInfoByExternalAccessUrl(AccessTransportOrderViaExternalAssignedDeviceUrlRequest: AccessTransportOrderViaExternalAssignedDeviceUrlRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderAssignedDeviceInfo> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAssignedDeviceInfoByExternalAccessUrl(AccessTransportOrderViaExternalAssignedDeviceUrlRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches all devices associated to the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasDevices(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AtlasDevicesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAtlasDevices(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches all devices with the corresponding status and position for the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasPositions(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AtlasPositionsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAtlasPositions(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches the current atlas version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasVersion(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AtlasVersionResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchAtlasVersion(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary fetchCmNavTreeTextModalList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCmNavTreeTextModalList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchCmNavTreeTextModalListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCmNavTreeTextModalList(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of company ids of companies with the given responsible managers
         * @summary fetch list of all companies of the given responsible managers
         * @param {string} responsibleManagers responsibleManagers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompaniesOfResponsibleManagers(responsibleManagers: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyShortListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompaniesOfResponsibleManagers(responsibleManagers, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * return the existing address mapping found against the given transport order, transport and stop otherwise return null
         * @param {string} orderId orderId
         * @param {string} stopId stopId
         * @param {string} transportId transportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingByStop(orderId: string, stopId: string, transportId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerAddressMappingResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyAddressMappingByStop(orderId, stopId, transportId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * return the existing address mappings found against the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingsForOrder(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerAddressMappingOfOrderResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyAddressMappingsForOrder(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches all configuration changes for ALL companies within a specified time period. Returns CompanyHistory entries along with their detailed CompanyConfigurationChange records. This endpoint is intended for reporting purposes and requires superuser permissions.  Parameters: - from: Start timestamp (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) - to: End timestamp (ISO 8601 format, e.g., 2024-12-31T23:59:59Z)  Returns: - List of all companies with their configuration changes in the specified period - Grouped by company for easy report generation
         * @summary Fetches company configuration changes for all companies in a given time period
         * @param {string} [from] from
         * @param {string} [to] to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigChanges(from?: string, to?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchCompanyConfigChangesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyConfigChanges(from, to, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * For Superusers: Returns the company config of the companyId provided. For Non-Superusers with COMPANY_FULL_VIEW permission: Returns the company config of the company of the user. If the user gives a company Id, he gets a forbidden.
         * @summary get company config
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfiguration(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyConfiguration(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns changes of the company with the provided id.
         * @summary get company configuration changes of company
         * @param {string} companyId companyId
         * @param {string} [historyId] historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationChanges(companyId: string, historyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfigurationChanges> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyConfigurationChanges(companyId, historyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns changes of the company with the provided id.
         * @summary get company configuration changes of company
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [path] path
         * @param {number} [skip] skip
         * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationChangesForField(companyId: string, limit?: number, path?: string, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchCompanyConfigurationChangesForFieldResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyConfigurationChangesForField(companyId, limit, path, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns history of the company with the provided id.
         * @summary get company configuration history of company
         * @param {string} companyId companyId
         * @param {string} [commentQuery] commentQuery
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [specificHistoryId] specificHistoryId
         * @param {'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY'} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationHistory(companyId: string, commentQuery?: string, limit?: number, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', specificHistoryId?: string, type?: 'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfigHistory> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyConfigurationHistory(companyId, commentQuery, limit, skip, sortBy, sortDirection, specificHistoryId, type, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get company config
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyContracts(companyId: string, limit?: number, query?: string, skip?: number, sortBy?: 'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ContractsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyContracts(companyId, limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches the company specific view configuration
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyViewConfiguration(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyUiViewConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchCompanyViewConfiguration(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back all current conversion logs.
         * @summary Fetch conversion job logs for transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchConversionJobLogForOrder(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConversionJobLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchConversionJobLogForOrder(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back all current conversion logs.
         * @summary Fetch conversion job logs
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [orderId] orderId
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchConversionJobLogs(companyId: string, limit?: number, orderId?: string, query?: string, skip?: number, sortBy?: 'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConversionJobLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchConversionJobLogs(companyId, limit, orderId, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the default company config.
         * @summary get default company config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultCompanyConfiguration(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchDefaultCompanyConfiguration(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the default contract.
         * @summary get default Contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultContract(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Contract> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchDefaultContract(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the default edi configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultEdiConfiguration(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EdiConverterConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchDefaultEdiConfiguration(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the default lis configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultLisConfiguration(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LisConverterConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchDefaultLisConfiguration(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of freight at the given depot. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get all freight in depot
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDepotFreight(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DepotFreightResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchDepotFreight(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back the draft with the given id.  
         * @summary fetchDraftOfConfig
         * @param {string} companyId companyId
         * @param {string} draftId draftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDraftOfConfig(companyId: string, draftId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchDraftOfConfigResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchDraftOfConfig(companyId, draftId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns an empty ProjectWorkLogBookEntry.
         * @summary get default and empty ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyProjectWorkLogBookEntry(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProjectWorkLogBookEntry> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEmptyProjectWorkLogBookEntry(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get current eta for the specified stop
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaAccuracyReportForCompany(transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderEtaReportList> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEtaAccuracyReportForCompany(transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning a defined BackendToEtaCalculatorEvent.
         * @summary get eta calculator events
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEvent(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BackendToEtaCalculatorEvent> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEtaCalculatorEvent(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning take*etaCalculatorEvents.
         * @summary get eta calculator events
         * @param {string} [companyId] companyId
         * @param {string} [id] id
         * @param {number} [limit] limit
         * @param {boolean} [processed] processed
         * @param {number} [skip] skip
         * @param {'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [transportOrderId] transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEvents(companyId?: string, id?: string, limit?: number, processed?: boolean, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtaCalculatorEventsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEtaCalculatorEvents(companyId, id, limit, processed, skip, sortBy, sortDirection, transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning take*etaCalculatorEvents.
         * @summary get eta calculator events
         * @param {string} company company
         * @param {number} take take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEventsForCompany(company: string, take: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtaCalculatorEventsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEtaCalculatorEventsForCompany(company, take, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns samples that can  be used to correct the eta value displayed to the user. Super user only endpoint.
         * @summary Get all calculation errors. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCorrectionSamples(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEtaCorrectionSamples(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns the average eta calculation error for a given eta algo and a destination city and  arrival time. It removes samples from orders where the calculated ETA was not stable, e.g. because the truck was far too late and so the calculated eta values were always corrected upwards.   Values of averageCalculationErrorInMin below zero indicate that the truck was earlier at the location than the calculated eta.   If the parameter orderIdPrefix is given, the calculation is only applied for transport orders that start with the given prefix 
         * @summary Calculates the average error for a given city and planned arrival time
         * @param {EtaCorrectionSampleRequest} EtaCorrectionSampleRequest EtaCorrectionSampleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCorrectionSamplesForCityAndTime(EtaCorrectionSampleRequest: EtaCorrectionSampleRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtaCorrectionAverageResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEtaCorrectionSamplesForCityAndTime(EtaCorrectionSampleRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set.    
         * @summary responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set
         * @param {EtaQualityReportRequest} EtaQualityReportRequest EtaQualityReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaQualityReport(EtaQualityReportRequest: EtaQualityReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtaQualityReportResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchEtaQualityReport(EtaQualityReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches failed messageLogs for a specific company.
         * @summary fetch failed messageLogs of a company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedMessageLogsOfSpecificCompany(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchMailLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchFailedMessageLogsOfSpecificCompany(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches the failedRequests of requested company
         * @param {Date} [endTime] endTime
         * @param {number} [limit] limit
         * @param {string} [queryId] queryId
         * @param {string} [queryMethod] queryMethod
         * @param {string} [queryUrl] queryUrl
         * @param {string} [queryUserMail] queryUserMail
         * @param {string} [queryXRequestId] queryXRequestId
         * @param {number} [skip] skip
         * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FailedRequestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchFailedRequests(endTime, limit, queryId, queryMethod, queryUrl, queryUserMail, queryXRequestId, skip, sortBy, sortDirection, startTime, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Check failed requests
         * @param {number} [minutesToCheck] minutesToCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedRequestsMonitoring(minutesToCheck?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FailedRequestsMonitoringResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchFailedRequestsMonitoring(minutesToCheck, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the following history of the provided history id. If it was the last, it returns the current config.
         * @summary get following company configuration history
         * @param {string} companyId companyId
         * @param {string} historyId historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFollowingCompanyConfigurationHistory(companyId: string, historyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchFollowingCompanyConfigurationHistoryResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchFollowingCompanyConfigurationHistory(companyId, historyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the following history of the provided history id. If it was the last, it returns the current contractVersion.
         * @summary get following company contract history
         * @param {string} companyId companyId
         * @param {string} contractId contractId
         * @param {string} historyId historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFollowingCompanyContractHistory(companyId: string, contractId: string, historyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchFollowingCompanyContractHistoryResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchFollowingCompanyContractHistory(companyId, contractId, historyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the geoStatus configuration of user's company.
         * @summary Get geo status config of user's company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusConfig(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StatusByVehiclePositionsConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchGeoStatusConfig(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the geoStatus configuration of your company.
         * @summary Get geo status config by company id
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusConfigByCompanyId(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StatusByVehiclePositionsConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchGeoStatusConfigByCompanyId(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the geoStatus information for requested transport order.
         * @summary Get information object describing thresholds and settings of the geoStatus for requested transport order.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusInformation(transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoStatusInfoResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchGeoStatusInformation(transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * If no vehicle is selected it will return all test data for transport orders in mongo collection geoStatusTestData. To add transportOrders to geoStatusTestData use addTransportOrderToGeoStatusTestData(). If a vehicleId is given it returns the geoStatus test data for the selected vehicle and time span. Default is last 14 days.
         * @summary Get all needed test data for geo status tests
         * @param {string} [from] from
         * @param {string} [to] to
         * @param {string} [vehicleId] vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusTestData(from?: string, to?: string, vehicleId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchGeoStatusTestData(from, to, vehicleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns dump data for a transport order and adds it to the default geoStatusTestData set fetched by fetchGeoStatusTestData().
         * @summary Get all needed test data for geo status tests
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusTestDataForTransportOrder(transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchGeoStatusTestDataForTransportOrder(transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get global geofences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGlobalGeofences(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetGlobalGeofencesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchGlobalGeofences(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches History objects. If a type is given, only the type specific histories will be returned. If an ID is given, only the entires with that object ID will be returned. If a query is given, only entries matching that full text search will be returned. It will not respond more entries than the limit, which default is 20. It will respond the total number of found entries.
         * @summary fetch history
         * @param {FetchHistoryRequest} FetchHistoryRequest FetchHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHistory(FetchHistoryRequest: FetchHistoryRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchHistoryResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchHistory(FetchHistoryRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * fetching invoices from DB
         * @summary fetch invoices which where not uploaded to zoho
         * @param {FetchInvoicesRequest} FetchInvoicesRequest FetchInvoicesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoices(FetchInvoicesRequest: FetchInvoicesRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InvoicingReportResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchInvoices(FetchInvoicesRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the invoice data for all billed companies
         * @summary get billing data for all companies
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoicingData(month: number, year: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InvoicingReportResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchInvoicingData(month, year, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches the last GPS position to a given vehicle id.
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastPositionForVehicleId(vehicleId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PositionResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchLastPositionForVehicleId(vehicleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation authenticates a user by mail address and returns the company mail gateway configuration
         * @summary Authenticate user by mail address and return 
         * @param {string} userEmailAddress userEmailAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMailGatewayConfigurationByUserEmailAddress(userEmailAddress: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MailGatewayConfigurationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchMailGatewayConfigurationByUserEmailAddress(userEmailAddress, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the merged and sorted list of locations of this order
         * @param {string} orderId orderId
         * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMergedStopList(orderId: string, includeDepotsFromLinkedOrders?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MergedStopListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchMergedStopList(orderId, includeDepotsFromLinkedOrders, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches MessageLog.
         * @summary fetch messageLog
         * @param {FetchMailLogRequest} FetchMailLogRequest FetchMailLogRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMessageLog(FetchMailLogRequest: FetchMailLogRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchMailLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchMessageLog(FetchMailLogRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches messageLogs of failed sendings.
         * @summary fetch messageLogs of failed sendings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMessageLogReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageLogReport> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchMessageLogReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all available database migrations known to this backend version.
         * @summary get all available db migrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMigrations(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchMigrationsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchMigrations(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch Access Token of observer
         * @summary Fetch Access Token of Observer
         * @param {string} orderId orderId
         * @param {string} xObserverId xObserverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverAccessToken(orderId: string, xObserverId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccessTokenResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchObserverAccessToken(orderId, xObserverId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back all Partners with externalPartnerId and externalPartnerId of them from the given company.
         * @summary fetchPartnersWithConfigAndExportAndImport
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnersWithConfigAndExportAndImport(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchPartnersWithConfigAndExportAndImportResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchPartnersWithConfigAndExportAndImport(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type of the company of the current user of the users company. Only usable for uses with permisison EVENTS. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type and own company
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsByQueueType(queueType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchQueuedEventsByQueueType(queueType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type and given company. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type with given company id
         * @param {string} companyId companyId
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsByQueueTypeAndCompanyId(companyId: string, queueType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchQueuedEventsByQueueTypeAndCompanyId(companyId, queueType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns events according to the given parameters.
         * @summary get all queued events
         * @param {'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER'} [changeTypeFilter] changeTypeFilter
         * @param {string} [companyId] companyId
         * @param {Date} [createdAtFromFilter] createdAtFromFilter
         * @param {Date} [createdAtToFilter] createdAtToFilter
         * @param {'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT'} [eventTypeFilter] eventTypeFilter
         * @param {boolean} [hasExportedFiles] hasExportedFiles
         * @param {number} [limit] limit
         * @param {boolean} [processedFilter] processedFilter
         * @param {'OK' | 'WARN' | 'ERROR' | 'RETRY'} [processingStateFilter] processingStateFilter
         * @param {'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER'} [queueTypeFilter] queueTypeFilter
         * @param {string} [queuedEventId] queuedEventId
         * @param {number} [skip] skip
         * @param {'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [transportOrderId] transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsForCM(changeTypeFilter?: 'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER', companyId?: string, createdAtFromFilter?: Date, createdAtToFilter?: Date, eventTypeFilter?: 'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT', hasExportedFiles?: boolean, limit?: number, processedFilter?: boolean, processingStateFilter?: 'OK' | 'WARN' | 'ERROR' | 'RETRY', queueTypeFilter?: 'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER', queuedEventId?: string, skip?: number, sortBy?: 'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchQueuedEventsForCM(changeTypeFilter, companyId, createdAtFromFilter, createdAtToFilter, eventTypeFilter, hasExportedFiles, limit, processedFilter, processingStateFilter, queueTypeFilter, queuedEventId, skip, sortBy, sortDirection, transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning all queues of the specified queue type. It returns all queues for all companies Only usable for uses with permisison SUPERUSER. 
         * @summary get all queues of all companiew of the specified type
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuesByQueueType(queueType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueueListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchQueuesByQueueType(queueType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches the rawRequests of requested company
         * @param {Date} [endTime] endTime
         * @param {number} [limit] limit
         * @param {string} [queryId] queryId
         * @param {string} [queryMethod] queryMethod
         * @param {string} [queryUrl] queryUrl
         * @param {string} [queryUserMail] queryUserMail
         * @param {string} [queryXRequestId] queryXRequestId
         * @param {number} [skip] skip
         * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRawRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RawRequestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchRawRequests(endTime, limit, queryId, queryMethod, queryUrl, queryUserMail, queryXRequestId, skip, sortBy, sortDirection, startTime, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the Release Notes from the Gitlab Wiki for the CM, since it should authenticate via backend.
         * @summary fetch ReleaseNotes From Gitlab Wiki
         * @param {string} stage stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReleaseNotesFromGitlabWiki(stage: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WikiPage> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchReleaseNotesFromGitlabWiki(stage, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns report generation statistics for super users. Shows which companies use reports, how often they are generated, and whether they are sent by email.
         * @summary Fetches report generation statistics
         * @param {string} [companyId] companyId
         * @param {Date} [endTime] endTime
         * @param {'MANUAL' | 'AUTO'} [generationType] generationType
         * @param {number} [limit] limit
         * @param {string} [reportName] reportName
         * @param {string} [sinceId] sinceId
         * @param {number} [skip] skip
         * @param {'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReportGenerationStats(companyId?: string, endTime?: Date, generationType?: 'MANUAL' | 'AUTO', limit?: number, reportName?: string, sinceId?: string, skip?: number, sortBy?: 'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportGenerationStatsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchReportGenerationStats(companyId, endTime, generationType, limit, reportName, sinceId, skip, sortBy, sortDirection, startTime, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches ScheduledOrderCreationRule.
         * @summary fetch scheduled Order Creation rules
         * @param {FetchScheduledOrderCreationRulesRequest} FetchScheduledOrderCreationRulesRequest FetchScheduledOrderCreationRulesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScheduledOrderCreationRules(FetchScheduledOrderCreationRulesRequest: FetchScheduledOrderCreationRulesRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchScheduledOrderCreationRulesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchScheduledOrderCreationRules(FetchScheduledOrderCreationRulesRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning the SchedulerConfigs.
         * @summary get scheduler configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSchedulerConfigs(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SchedulerConfigs> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchSchedulerConfigs(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is an internal endpoint returning the SchedulerTasks.
         * @summary get scheduler tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSchedulerTasks(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SchedulerTaskConfigs> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchSchedulerTasks(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * fetch Script Documentation By Documentation Type
         * @summary fetchScriptDocumentationByDocumentationType
         * @param {'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION'} [documentationType] documentationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptDocumentationByDocumentationType(documentationType?: 'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ScriptsDocumentationEntry> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchScriptDocumentationByDocumentationType(documentationType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns scriptRunnerUser of given company.
         * @summary get scriptRunnerUser of given company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptRunnerUser(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ScriptRunnerUserExistsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchScriptRunnerUser(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch Scripts Documentations
         * @summary FetchScriptsDocumentations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptsDocumentations(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchScriptsDocumentationsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchScriptsDocumentations(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the shipment Form Config of the specified id. The permission COMPANY_MODIFY is required to execute this operation
         * @summary Get shipment Form Config by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShipmentFormConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchShipmentFormConfigById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the shipment Form Config of the specified access token without authentication.
         * @summary Get shipment Form Config by access token
         * @param {string} token token
         * @param {string} [pin] pin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigByToken(token: string, pin?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShipmentFormConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchShipmentFormConfigByToken(token, pin, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all configurations for the transport Order creation form for the specified company.
         * @summary Get List of configurations for the transport Order creation form
         * @param {number} [limit] limit
         * @param {string} [q] q
         * @param {number} [skip] skip
         * @param {'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigList(limit?: number, q?: string, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShipmentFormConfigListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchShipmentFormConfigList(limit, q, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Call this endpoint to fetch message logs based on message type and list of transport order ids.
         * @summary Returns message logs with specific message type only based on list of transport order ids in request and message type
         * @param {FetchSpecificMessageLogsForTransportOrdersRequest} FetchSpecificMessageLogsForTransportOrdersRequest FetchSpecificMessageLogsForTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSpecificMessageLogsForTransportOrders(FetchSpecificMessageLogsForTransportOrdersRequest: FetchSpecificMessageLogsForTransportOrdersRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderMessageLogsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchSpecificMessageLogsForTransportOrders(FetchSpecificMessageLogsForTransportOrdersRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns message logs with specific message type only that where send and reference the given transport order
         * @param {'REMINDER' | 'INFO' | 'WARNING'} messageType messageType
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSpecificTypeMessageLogsForSingleTransportOrder(messageType: 'REMINDER' | 'INFO' | 'WARNING', orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchSpecificTypeMessageLogsForSingleTransportOrder(messageType, orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all needed StandingTimesUi data as simple as possible for the requested time period
         * @summary get data for standingTimesUi
         * @param {Date} endTime endTime
         * @param {Date} startTime startTime
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStandingTimesUiData(endTime: Date, startTime: Date, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StandingTimesUiDataResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchStandingTimesUiData(endTime, startTime, dateTimeField, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Standing times per stop as XLSX.
         * @summary fetchStandingTimesXlsx
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStandingTimesXlsx(TourCostReportRequest: TourCostReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchStandingTimesXlsx(TourCostReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back all current active SystemStatusMessages.
         * @summary Fetch SystemStatusMessages
         * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
         * @param {number} [limit] limit
         * @param {boolean} [onlyActive] onlyActive
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSystemStatusMessages(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SystemStatusMessagesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchSystemStatusMessages(level, limit, onlyActive, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all currently active SystemStatusMessages with combined affectedTransportOrders.
         * @summary Fetch SystemStatusMessages with combined affectedTransportOrders
         * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
         * @param {number} [limit] limit
         * @param {boolean} [onlyActive] onlyActive
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSystemStatusMessagesCombined(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SystemStatusMessagesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchSystemStatusMessagesCombined(level, limit, onlyActive, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * ...
         * @summary fetchTourCostReport
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTourCostReport(TourCostReportRequest: TourCostReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TourCostReportResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTourCostReport(TourCostReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Tour cost report as XLSX. Durations are real Excel time cells.
         * @summary fetchTourCostReportXlsx
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTourCostReportXlsx(TourCostReportRequest: TourCostReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTourCostReportXlsx(TourCostReportRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will fetch a new Transport-Order by the externalTransportOrderId and the companyId (sourceCompanyId)
         * @summary get transport order by companyId and external transportOrderId
         * @param {string} companyId companyId
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByExternalTransportOrderIdAndCompany(companyId: string, externalTransportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTransportOrderByExternalTransportOrderIdAndCompany(companyId, externalTransportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id.
         * @summary get transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByIdSourceAndTargetView(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderByIdSourceAndTargetViewResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTransportOrderByIdSourceAndTargetView(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will fetch a new Transport-Order by the telematicTransportOrderId and the targetCompanyId
         * @summary get transport order by companyId and GetTransportOrderByTelematicTransportOrderId
         * @param {string} targetCompanyId targetCompanyId
         * @param {string} telematicTransportOrderId telematicTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId(targetCompanyId: string, telematicTransportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId(targetCompanyId, telematicTransportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the converter Info of this transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderConverterInfo(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConverterInfo> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTransportOrderConverterInfo(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns all messages that where send and reference the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderMessageLog(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTransportOrderMessageLog(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of partners used in the last transport orders
         * @summary extract partners from transport orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderPartnerList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PartnerQueryResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchTransportOrderPartnerList(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * fetch unbilled projectWorkLogBook entries
         * @summary fetch unbilled projectWorkLogBook entries
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUnbilled(BillingRequest: BillingRequest, limit?: number, skip?: number, sortBy?: 'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchUnbilledResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchUnbilled(BillingRequest, limit, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches the user for the given company
         * @param {string} companyId companyId
         * @param {string} externalUserId externalUserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserBy(companyId: string, externalUserId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchUserBy(companyId, externalUserId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all users matching a given searchterm. The superuser permission to show all users or companyAdmin to show company users is required to execute this operation.
         * @summary List all users
         * @param {string} term term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsers(term: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchUsers(term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of users specified in the query string. The supplied argument must be a comma separated list of user ids
         * @summary List all users specified in the parameter list
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersByIdList(userIds: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchUsersByIdList(userIds, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetch vehicles residence times in a area defined by position and radius. Default for last 14 days.
         * @param {VehicleGeoFilterRequest} VehicleGeoFilterRequest VehicleGeoFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleResidenceTimesInArea(VehicleGeoFilterRequest: VehicleGeoFilterRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ResidenceTimesResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fetchVehicleResidenceTimesInArea(VehicleGeoFilterRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
         * @param {FixTransportOrderTimesRequest} FixTransportOrderTimesRequest FixTransportOrderTimesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixTransportOrder(FixTransportOrderTimesRequest: FixTransportOrderTimesRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fixTransportOrder(FixTransportOrderTimesRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
         * @param {string} transportOrderId transportOrderId
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {number} [mergeAndOrderKeyToStartFrom] mergeAndOrderKeyToStartFrom
         * @param {number} [offsetAfterInMinutes] offsetAfterInMinutes
         * @param {number} [offsetBeforeInMinutes] offsetBeforeInMinutes
         * @param {boolean} [partialFixAllowed] partialFixAllowed
         * @param {boolean} [replaceOriginalTransportOrder] replaceOriginalTransportOrder
         * @param {boolean} [reverse] reverse
         * @param {boolean} [shouldCreateHistoryEntry] shouldCreateHistoryEntry
         * @param {string} [stopIdToStartFrom] stopIdToStartFrom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixTransportOrderTimes(transportOrderId: string, fixStopsOfLinkedTransports?: boolean, mergeAndOrderKeyToStartFrom?: number, offsetAfterInMinutes?: number, offsetBeforeInMinutes?: number, partialFixAllowed?: boolean, replaceOriginalTransportOrder?: boolean, reverse?: boolean, shouldCreateHistoryEntry?: boolean, stopIdToStartFrom?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).fixTransportOrderTimes(transportOrderId, fixStopsOfLinkedTransports, mergeAndOrderKeyToStartFrom, offsetAfterInMinutes, offsetBeforeInMinutes, partialFixAllowed, replaceOriginalTransportOrder, reverse, shouldCreateHistoryEntry, stopIdToStartFrom, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Force the reapplication of the current customerAddressMapping for the transportOrder. This operation is useful to reapply changed customer address mappings
         * @param {boolean} justSimulate justSimulate
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceApplyCustomerAddressMapping(justSimulate: boolean, orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ApplyCustomerAddressMappingResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).forceApplyCustomerAddressMapping(justSimulate, orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Parses the given JSON String into an CompanyConfiguration object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
         * @summary update current company
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatConfig(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FormatConfigResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).formatConfig(UpdateCompanyConfigRequestWrapper, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Parses the given JSON String into an Contract object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
         * @summary update current company
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatContract(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FormatContractResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).formatContract(UpdateCompanyConfigRequestWrapper, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get report of completed orders of company partners
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompletionReport(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompletionReportResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateCompletionReport(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a xlsx of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get report of completed orders of company partners
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompletionReportAsXlsx(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateCompletionReportAsXlsx(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * returns the Elflein Error report
         * @summary returns the Elflein Error report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateElfleinVdlNetcarErrorReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateElfleinVdlNetcarErrorReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * returns the Elflein report
         * @summary returns the Elflein report
         * @param {boolean} compressed compressed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateElfleinVdlNetcarReport(compressed: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateElfleinVdlNetcarReport(compressed, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Executes a generic status report
         * @summary returns the generic status report
         * @param {string} statusReportName statusReportName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGenericStatusReport(statusReportName: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OutputReport> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateGenericStatusReport(statusReportName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Executes a generic status report for all transport orders matching the filter asynchronously. Returns a job status URL that can be polled to check the report generation progress.
         * @summary generates a generic status report for all filtered transport orders asynchronously
         * @param {string} statusReportName statusReportName
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGenericStatusReportAsync(statusReportName: string, FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AsyncJobResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateGenericStatusReportAsync(statusReportName, FetchTransportOrderListFilterRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * returns the GeoStatus Debug report
         * @summary returns the Debug report for the geo status system
         * @param {number} [fromDay] fromDay
         * @param {number} [fromMonth] fromMonth
         * @param {number} [fromYear] fromYear
         * @param {number} [toDay] toDay
         * @param {number} [toMonth] toMonth
         * @param {number} [toYear] toYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGeoStatusDebugReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateGeoStatusDebugReport(fromDay, fromMonth, fromYear, toDay, toMonth, toYear, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Return CSV Report in the format  id;externalTransportOrderId;KM_START;KM_END;KM_LEER;
         * @summary returns the Paneuropa Mileage report
         * @param {Date} [modifiedSince] modifiedSince
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaneuropaMileageReport(modifiedSince?: Date, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generatePaneuropaMileageReport(modifiedSince, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * returns the validation report
         * @summary returns the validation report
         * @param {number} [fromDay] fromDay
         * @param {number} [fromMonth] fromMonth
         * @param {number} [fromYear] fromYear
         * @param {number} [toDay] toDay
         * @param {number} [toMonth] toMonth
         * @param {number} [toYear] toYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateValidationReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).generateValidationReport(fromDay, fromMonth, fromYear, toDay, toMonth, toYear, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch AI parse result by ID
         * @summary getAiParseResultById
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiParseResultById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AiParseResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getAiParseResultById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch AI parse results with optional filters
         * @summary getAiParseResults
         * @param {FetchAiParseResultsRequest} FetchAiParseResultsRequest FetchAiParseResultsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiParseResults(FetchAiParseResultsRequest: FetchAiParseResultsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchAiParseResultsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getAiParseResults(FetchAiParseResultsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * getting all companies and all billed orders
         * @summary getting all companies and all billed orders
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesAndBilledOrders(month: number, year: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetAllCompaniesAndBilledOrdersResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getAllCompaniesAndBilledOrders(month, year, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches all configurations that changed after the given timestamp, default is 1 day
         * @param {string} [since] since
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConfigurations(since?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetAllConfigurationsThatChangedResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getAllConfigurations(since, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * getting all unbilled orders for company
         * @summary getting all unbilled orders for company
         * @param {GetAllUnbilledOrdersForCompanyRequest} GetAllUnbilledOrdersForCompanyRequest GetAllUnbilledOrdersForCompanyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnbilledOrdersForCompany(GetAllUnbilledOrdersForCompanyRequest: GetAllUnbilledOrdersForCompanyRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetAllUnbilledOrdersForCompanyResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getAllUnbilledOrdersForCompany(GetAllUnbilledOrdersForCompanyRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get companies with api-gateway config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiGatewayConfigs(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfigurationListResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getApiGatewayConfigs(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get alive of backend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendAlive(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AliveCheckResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getBackendAlive(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get health of backend components
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendHealth(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<HealthResponseBackend> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getBackendHealth(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get performance of GET+POST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendPerformance(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PerformanceResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getBackendPerformance(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * list all Companies excluded from Unbilled TransportOrders Calculation
         * @summary list all Companies excluded from Unbilled TransportOrders Calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesExcludedFromUnbilledTransportOrdersCalculation(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetCompaniesExcludedFromUnbilledTransportOrdersCalculationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getCompaniesExcludedFromUnbilledTransportOrdersCalculation(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get companyIds from companies which should be billed
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesToInvoice(BillingRequest: BillingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompaniesToInvoiceResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getCompaniesToInvoice(BillingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches all companyNames & tags for the given companyIds
         * @param {string} companyIds companyIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyNames(companyIds: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetCompanyNamesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getCompanyNames(companyIds, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get the short info of all companies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyShortInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyShortInfoResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getCompanyShortInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Return a list of all ConfigFieldDescriptions.
         * @summary getConfigFieldDescriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigFieldDescriptions(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetConfigFieldDescriptionResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getConfigFieldDescriptions(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get company configuration for customer
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getConfiguration(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get last 24 hours polyline for driver
         * @param {string} driverId driverId
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverPolyline(driverId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DriverPolyline> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getDriverPolyline(driverId, resolveAddresses, segmentByEstimatedStates, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get companies with eta calculator config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtaCalculatorConfigs(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtaCalculatorCompanys> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getEtaCalculatorConfigs(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {EtaTestEventRequest} EtaTestEventRequest EtaTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtaTestEvent(EtaTestEventRequest: EtaTestEventRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventAndConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getEtaTestEvent(EtaTestEventRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a report containing the time at a location for a given time range based on the actual vehicle positions
         * @summary returns the time spent at the specified location report based on GPS data
         * @param {string} companyAddressMappingId companyAddressMappingId
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoTimeAtLocationReport(companyAddressMappingId: string, month: number, year: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getGeoTimeAtLocationReport(companyAddressMappingId, month, year, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a gerolsteiner XML report for the given month
         * @summary returns gerolsteiner xml report
         * @param {boolean} dumpXml dumpXml
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGerolsteinerXmlReport(dumpXml: boolean, month: number, year: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GerolsteinerResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getGerolsteinerXmlReport(dumpXml, month, year, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get long running queries from mongo db from the last x seconds.
         * @param {number} [minusSeconds] minusSeconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLongRunningQueries(minusSeconds?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LongRunningQueriesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getLongRunningQueries(minusSeconds, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get the company monitor configurations for customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorConfigurations(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyMonitorConfigs> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getMonitorConfigurations(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get company notification configuration for customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationConfiguration(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NotificationConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getNotificationConfiguration(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {PositionTestEventRequest} PositionTestEventRequest PositionTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionTestEvent(PositionTestEventRequest: PositionTestEventRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventAndConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getPositionTestEvent(PositionTestEventRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the ProjectWorkLogBookEntries.
         * @summary Gets ProjectWorkLogBookEntries from Company.
         * @param {boolean} [alreadyBilled] alreadyBilled
         * @param {Array<string>} [companyIds] companyIds
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectWorkLogBookEntries(alreadyBilled?: boolean, companyIds?: Array<string>, limit?: number, skip?: number, sortBy?: 'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProjectWorkLogBookResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getProjectWorkLogBookEntries(alreadyBilled, companyIds, limit, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get the state of the scheduler reporting task.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulerReportingTaskState(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SchedulerReportingTaskStateResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getSchedulerReportingTaskState(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary scriptErrorLogger
         * @param {'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE'} sortBy sortBy
         * @param {'ASC' | 'DESC'} sortDirection sortDirection
         * @param {string} [companyId] companyId
         * @param {Date} [fromCreatedDate] fromCreatedDate
         * @param {number} [limit] limit
         * @param {string} [scriptPath] scriptPath
         * @param {number} [skip] skip
         * @param {Date} [toCreatedDate] toCreatedDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptErrorLogs(sortBy: 'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE', sortDirection: 'ASC' | 'DESC', companyId?: string, fromCreatedDate?: Date, limit?: number, scriptPath?: string, skip?: number, toCreatedDate?: Date, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ScriptErrorLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getScriptErrorLogs(sortBy, sortDirection, companyId, fromCreatedDate, limit, scriptPath, skip, toCreatedDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getScriptInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetScriptInfoResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getScriptInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of shipmet mapping candidates for the current transport order
         * @summary Get a list of possible shipment mappings for the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentMappingProposal(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShipmentMappingCandidatesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getShipmentMappingProposal(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns list of super users with their status of two factor authentication.
         * @summary extract super user list and check their 2 factor authentication is done.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperUserTwoFactorAuthenticationStatus(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SuperUserTwoFactorAuthenticationStatusResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getSuperUserTwoFactorAuthenticationStatus(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user permissions from a chosen user ID
         * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TempTargetUser> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getTempTargetUserPermissions(TargetUserRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch test failures with optional filters
         * @summary getTestFailures
         * @param {GetTestFailuresRequest} GetTestFailuresRequest GetTestFailuresRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestFailures(GetTestFailuresRequest: GetTestFailuresRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchTestFailuresResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getTestFailures(GetTestFailuresRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a report containing the time at a location for a given time range
         * @summary returns the time spent at Gerolsteiner
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeAtGerolsteinerReport(month: number, year: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getTimeAtGerolsteinerReport(month, year, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a report containing the time at a location for a given time range
         * @summary returns the time spent at the specified location report
         * @param {string} locationString locationString
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeAtLocationReport(locationString: string, month: number, year: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getTimeAtLocationReport(locationString, month, year, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a temporary test TransportOrderEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {TransportOrderTestEventRequest} TransportOrderTestEventRequest TransportOrderTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportOrderTestEvent(TransportOrderTestEventRequest: TransportOrderTestEventRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventAndConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getTransportOrderTestEvent(TransportOrderTestEventRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getType
         * @param {GetTypeRequest} GetTypeRequest GetTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getType(GetTypeRequest: GetTypeRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetTypeResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getType(GetTypeRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getTypes
         * @param {GetTypesRequest} GetTypesRequest GetTypesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes(GetTypesRequest: GetTypesRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetTypesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getTypes(GetTypesRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * fetch unbilled projectWorkLogBook entries
         * @summary get unbilled TransportOrders
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnbilledTransportOrders(BillingRequest: BillingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UnbilledTransportOrderResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getUnbilledTransportOrders(BillingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back userName by userId
         * @summary getUserName
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserName(userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetUserNameResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getUserName(userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back the company of the given user.
         * @summary getUsersCompany
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCompany(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetUsersCompanyResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getUsersCompany(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get last 24 hours polyline for vehicle
         * @param {number} epsilon epsilon
         * @param {string} vehicleId vehicleId
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolyline(epsilon: number, vehicleId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehiclePolyline> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getVehiclePolyline(epsilon, vehicleId, resolveAddresses, segmentByEstimatedStates, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Check vehicle positions in a specific time range for irregularities. Default search window is last 7 days.
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePositionsCheck(from: string, to: string, vehicleId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehiclePositionsCheckResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).getVehiclePositionsCheck(from, to, vehicleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation applies a groovy script on the given transportOrder and returns the result.
         * @summary Applies groovy script on transportOrder and returns result
         * @param {ScriptingRequest} ScriptingRequest ScriptingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groovyScripting(ScriptingRequest: ScriptingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).groovyScripting(ScriptingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Import an excel document containing the customer address mapping. This method is intensionally  allowed for non super users
         * @summary Import address mapping from lis
         * @param {any} doc Excel document to import the addresses from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importLisCustomerAddressMapping(doc: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddressImportResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).importLisCustomerAddressMapping(doc, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds positions from a gpx track with timestamps as fake positions to a vehicle. The startTime overrides the starting time in the gpx file.
         * @summary POST /api/internal/tracking/gpxtrack
         * @param {any} gpx Gpx file with track
         * @param {string} bodyObject Enter body object here
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertGpxTrackForVehicle(gpx: any, bodyObject: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TelematicDataResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).insertGpxTrackForVehicle(gpx, bodyObject, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSuperuser(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<IsSuperuserResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).isSuperuser(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Links two transports with and checks if all needed configs are set.
         * @summary Links two transports
         * @param {TransportLinkingRequest} TransportLinkingRequest TransportLinkingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkTransports(TransportLinkingRequest: TransportLinkingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportLinkingResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).linkTransports(TransportLinkingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Lists all TransportOrderConfigTests. This endpoint is needed for the integration tests of the converter
         * @param {string} [companyId] companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListTransportOrderConfigTestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).listAllTransportOrderConfigTests(companyId, limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Lists all TransportOrderConfigTests of the users company
         * @param {string} [companyId] companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListTransportOrderConfigTestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).listTransportOrderConfigTests(companyId, limit, query, skip, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Store a generic AI test failure.
         * @summary logTestFailure
         * @param {TestFailureLogEntry} TestFailureLogEntry TestFailureLogEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logTestFailure(TestFailureLogEntry: TestFailureLogEntry, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TestFailureLogEntry> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).logTestFailure(TestFailureLogEntry, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will map a telematic tour to one or multiple existing transport orders. If no script is set, the default company telematicTourMappingScript is used.
         * @summary Map telematic tour to transport order by script
         * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTelematicTour(TelematicTourMapRequest: TelematicTourMapRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TelematicTourMapResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).mapTelematicTour(TelematicTourMapRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will map a telematic tour to an existing transport order. If no script is set, the default company telematicTourMappingScript is used.
         * @summary Map telematic tour to transport order by script
         * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTelematicTourDEPRECATED(TelematicTourMapRequest: TelematicTourMapRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).mapTelematicTourDEPRECATED(TelematicTourMapRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will map a virtual spedion single tour vehicle to an assigned device of an existing transport order.
         * @summary Map virtual SPEDION single tour vehicle to assigned device of specific transport order
         * @param {MapVehicleToAssignedDeviceRequest} MapVehicleToAssignedDeviceRequest MapVehicleToAssignedDeviceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapVehicletoAssignedDevice(MapVehicleToAssignedDeviceRequest: MapVehicleToAssignedDeviceRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).mapVehicletoAssignedDevice(MapVehicleToAssignedDeviceRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * To migrate the DB to the latest version known to this version of the backend. 
         * @summary migrating the db to the latest version!
         * @param {boolean} dryRun dryRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateDb(dryRun: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MigrateDbResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).migrateDb(dryRun, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies the ProjectWorkLogBookEntry with the specified ProjectWorkLogBookEntryId.
         * @summary Modify ProjectWorkLogBookEntry by id
         * @param {string} logBookEntryId logBookEntryId
         * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyProjectWorkLogBookEntryById(logBookEntryId: string, ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProjectWorkLogBookEntry> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).modifyProjectWorkLogBookEntryById(logBookEntryId, ProjectWorkLogBookEntry, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modifies the shipment form config of the given config id. The COMPANY_MODIFY permission is required to execute this operation.
         * @summary Modify shipment Form Config by id
         * @param {string} id id
         * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyShipmentFormConfigById(id: string, ShipmentFormConfigRequest: ShipmentFormConfigRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShipmentFormConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).modifyShipmentFormConfigById(id, ShipmentFormConfigRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Monitor mongo db operations running longer than given seconds.
         * @param {string} [mongoDbTags] mongoDbTags
         * @param {number} [seconds] seconds
         * @param {string} [mongoDbTags2] mongoDbTags
         * @param {number} [seconds2] seconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorDbOperations(mongoDbTags?: string, seconds?: number, mongoDbTags2?: string, seconds2?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoringOperationsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).monitorDbOperations(mongoDbTags, seconds, mongoDbTags2, seconds2, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Monitor failed sms and emails in message log in past 7 days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorFailedSmsEmail(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FailedEmailSmsMonitoringResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).monitorFailedSmsEmail(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Monitor waiting events for specific queue.
         * @param {string} type type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorWaitingEvents(type: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoringQueueResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).monitorWaitingEvents(type, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation applies a groovy script on the given transportOrder and returns the result.
         * @summary Applies groovy script on transportOrders and returns results
         * @param {MultiOrderScriptingRequest} MultiOrderScriptingRequest MultiOrderScriptingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiOrderGroovyScripting(MultiOrderScriptingRequest: MultiOrderScriptingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MultiOrderScriptingResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).multiOrderGroovyScripting(MultiOrderScriptingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Validates the configuration, to check if it can be accepted by the database.
         * @summary multiScriptExecution
         * @param {MultiScriptExecutionRequest} MultiScriptExecutionRequest MultiScriptExecutionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiScriptExecution(MultiScriptExecutionRequest: MultiScriptExecutionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).multiScriptExecution(MultiScriptExecutionRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Drops Entries from the ai cache 
         * @summary Call ai with the given promt
         * @param {DropCacheEntryRequest} DropCacheEntryRequest DropCacheEntryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oaiDropCacheEntry(DropCacheEntryRequest: DropCacheEntryRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DropCacheResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).oaiDropCacheEntry(DropCacheEntryRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Optimize the Route for given shipments
         * @summary Optimize the Route for given shipments.
         * @param {RouteOptimizerRequest} RouteOptimizerRequest RouteOptimizerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizeRoutes(RouteOptimizerRequest: RouteOptimizerRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VrpResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).optimizeRoutes(RouteOptimizerRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary parse a transport order from a prompt
         * @param {ParseTransportOrderRequest} ParseTransportOrderRequest ParseTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseGenericAiToTransportOrder(ParseTransportOrderRequest: ParseTransportOrderRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParseTransportOrderResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).parseGenericAiToTransportOrder(ParseTransportOrderRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary parse the next scheduled execution from a prompt
         * @param {ParseNextScheduledExecutionRequest} ParseNextScheduledExecutionRequest ParseNextScheduledExecutionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseNextScheduledExecution(ParseNextScheduledExecutionRequest: ParseNextScheduledExecutionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ParseNextScheduledExecutionResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).parseNextScheduledExecution(ParseNextScheduledExecutionRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the times as string calculated by the given reportTimeReference and the current time.
         * @summary previewReportTimeReference
         * @param {ReportTimeReference} ReportTimeReference ReportTimeReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReportTimeReference(ReportTimeReference: ReportTimeReference, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PreviewReportTimeReferenceResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).previewReportTimeReference(ReportTimeReference, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * AI analyzes all tickets considering score, difficulty, and other factors to recommend top 3 to pick up
         * @summary recommendTopTicketsForPickup
         * @param {RecommendTopTicketsRequest} RecommendTopTicketsRequest RecommendTopTicketsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendTopTicketsForPickup(RecommendTopTicketsRequest: RecommendTopTicketsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RecommendTopTicketsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).recommendTopTicketsForPickup(RecommendTopTicketsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Recoveres a deleted object from history
         * @summary recover history entry
         * @param {RecoverHistoryEntryRequest} RecoverHistoryEntryRequest RecoverHistoryEntryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverHistoryEntry(RecoverHistoryEntryRequest: RecoverHistoryEntryRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RecoverHistoryEntryResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).recoverHistoryEntry(RecoverHistoryEntryRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes a path from the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary removeFromCmNavTreeTextModal
         * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SetCmNavTreeTextModalListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).removeFromCmNavTreeTextModal(CmNavTreeTextModalListRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Remove temp token used from a chosen user ID
         * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).removeTempTargetUserPermissions(TargetUserRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Replace the company configuration with the given value
         * @param {string} companyId companyId
         * @param {CompanyConfiguration} CompanyConfiguration CompanyConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceConfiguration(companyId: string, CompanyConfiguration: CompanyConfiguration, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).replaceConfiguration(companyId, CompanyConfiguration, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Replace the company monitor configurations with the given value
         * @param {CompanyMonitorConfigs} CompanyMonitorConfigs CompanyMonitorConfigs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceMonitorConfiguration(CompanyMonitorConfigs: CompanyMonitorConfigs, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyMonitorConfigs> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).replaceMonitorConfiguration(CompanyMonitorConfigs, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Replace the company notification configurations with the given value
         * @param {NotificationConfiguration} NotificationConfiguration NotificationConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceNotificationConfiguration(NotificationConfiguration: NotificationConfiguration, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NotificationConfiguration> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).replaceNotificationConfiguration(NotificationConfiguration, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * overrides given SystemStatusMessages.
         * @summary Update SystemStatusMessage endTime
         * @param {string} id id
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceSystemStatusMessage(id: string, SystemStatusMessage: SystemStatusMessage, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateSystemStatusMessagesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).replaceSystemStatusMessage(id, SystemStatusMessage, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary replays all positions of a geostatusTest dump
         * @param {ReplayGeoStatusTestDataRequest} ReplayGeoStatusTestDataRequest ReplayGeoStatusTestDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayGeoStatusTestData(ReplayGeoStatusTestDataRequest: ReplayGeoStatusTestDataRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReplayGeoStatusTestDataResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).replayGeoStatusTestData(ReplayGeoStatusTestDataRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Replays the last position of a vehicle for debugging purposes.
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayLastPositionRequest(vehicleId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).replayLastPositionRequest(vehicleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary get Coordinates from AddressMapping
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCompanyAddressMappingToCoordinates(CompanyAddressMapping: CompanyAddressMapping, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddressWithCoordinates> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).resolveCompanyAddressMappingToCoordinates(CompanyAddressMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Re-Validates the customerAddressMapping for the transportOrder
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCustomerAddressMapping(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Result> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).resolveCustomerAddressMapping(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Re-Validates the customerAddressMapping for multiple transportOrders in a single request. Returns detailed results for each transport order processed.
         * @param {ResolveCustomerAddressMappingBatchRequest} ResolveCustomerAddressMappingBatchRequest ResolveCustomerAddressMappingBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCustomerAddressMappingBatch(ResolveCustomerAddressMappingBatchRequest: ResolveCustomerAddressMappingBatchRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ResolveCustomerAddressMappingBatchResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).resolveCustomerAddressMappingBatch(ResolveCustomerAddressMappingBatchRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns the reverse geocoding for a given Google plus code.
         * @summary Get the reverse geocoding for a given plus code
         * @param {string} plusCode plusCode
         * @param {boolean} [reduceAccuracyOfPlusCode] reduceAccuracyOfPlusCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseGeocodePlusCode(plusCode: string, reduceAccuracyOfPlusCode?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Geocoding> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).reverseGeocodePlusCode(plusCode, reduceAccuracyOfPlusCode, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary rollback transportOrder
         * @param {RollbackTransportOrderRequest} RollbackTransportOrderRequest RollbackTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rollbackTransportOrder(RollbackTransportOrderRequest: RollbackTransportOrderRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RollbackTransportOrderResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).rollbackTransportOrder(RollbackTransportOrderRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {TaskOptions} TaskOptions TaskOptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTask(TaskOptions: TaskOptions, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NoContent> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).runTask(TaskOptions, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Saves the configuration as draft, so it's saved for later usage.
         * @summary saveConfigAsDraft
         * @param {SaveConfigAsDraftRequest} SaveConfigAsDraftRequest SaveConfigAsDraftRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfigAsDraft(SaveConfigAsDraftRequest: SaveConfigAsDraftRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SaveConfigAsDraftResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).saveConfigAsDraft(SaveConfigAsDraftRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Saves a description for a specific field in the CompanyConfiguration. The field is specified by a JQuary leading to the field.
         * @summary saveConfigFieldDescription
         * @param {SaveConfigFieldDescriptionRequest} SaveConfigFieldDescriptionRequest SaveConfigFieldDescriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfigFieldDescription(SaveConfigFieldDescriptionRequest: SaveConfigFieldDescriptionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SaveConfigFieldDescriptionResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).saveConfigFieldDescription(SaveConfigFieldDescriptionRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the default contract.
         * @summary save Contract
         * @param {SaveContractRequest} SaveContractRequest SaveContractRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContract(SaveContractRequest: SaveContractRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SaveContractResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).saveContract(SaveContractRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Saves a SystemStatusMessage and returns if it succeeded.
         * @summary Save SystemStatusMessage
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSystemStatusMessages(SystemStatusMessage: SystemStatusMessage, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SaveSystemStatusMessagesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).saveSystemStatusMessages(SystemStatusMessage, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary save a new TransportOrderConfig Test
         * @param {SaveTransportOrderConfigTestRequest} SaveTransportOrderConfigTestRequest SaveTransportOrderConfigTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTransportOrderConfigTest(SaveTransportOrderConfigTestRequest: SaveTransportOrderConfigTestRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueuedEventAndConfig> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).saveTransportOrderConfigTest(SaveTransportOrderConfigTestRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch unassigned tickets with Score label from GitLab, sorted by score descending
         * @summary scoredUnassignedTickets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoredUnassignedTickets(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ScoredUnassignedTicketsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).scoredUnassignedTickets(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint searches through all configurations of all companies for a given searchTerm. The searchTerm is splitted by whitespaces and will return matches for every substring. To avoid splitting the searchterm or parts of it, please surround it by quots. Example:    searchterm [hello world] will respond every config containing the term \"hello\" and every config containing the term \"world\".             searchterm [\"hello world\"] will respond every config containing the searchterm \"hello world\" 
         * @summary search Configs
         * @param {SearchConfigsRequest} SearchConfigsRequest SearchConfigsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConfigs(SearchConfigsRequest: SearchConfigsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchConfigsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).searchConfigs(SearchConfigsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary redirects query to graylog and returns found logs
         * @param {GraylogRequest} GraylogRequest GraylogRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGraylog(GraylogRequest: GraylogRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LogScraperResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).searchGraylog(GraylogRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a list of all transport orders exported as excel file
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {TransportSelectedOrderToExcelConversionRequest} TransportSelectedOrderToExcelConversionRequest TransportSelectedOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectedTransportOrderExcelExport(TransportSelectedOrderToExcelConversionRequest: TransportSelectedOrderToExcelConversionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).selectedTransportOrderExcelExport(TransportSelectedOrderToExcelConversionRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * sends mail and logs it into the MailLog-collection in the DB.
         * @summary send message
         * @param {MessageLog} MessageLog MessageLog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(MessageLog: MessageLog, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SendMailResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).sendMessage(MessageLog, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adds a path to the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary setCmNavTreeTextModal
         * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SetCmNavTreeTextModalListResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).setCmNavTreeTextModal(CmNavTreeTextModalListRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Send shipment Form Config access details via user's Email.
         * @summary Send shipment Form Config access details via user's Email
         * @param {string} shipmentCreateFormId shipmentCreateFormId
         * @param {ShareUserAccessViaEmailRequest} ShareUserAccessViaEmailRequest ShareUserAccessViaEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareShipmentCreateFormUserAccessViaEmail(shipmentCreateFormId: string, ShareUserAccessViaEmailRequest: ShareUserAccessViaEmailRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShareUserAccessViaEmailResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).shareShipmentCreateFormUserAccessViaEmail(shipmentCreateFormId, ShareUserAccessViaEmailRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Saves a SystemStatusMessage and ends all other SystemStatusMessages for the combination of companyId + groupKey.
         * @summary Save SystemStatusMessage and end others
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleSaveSystemStatusMessage(SystemStatusMessage: SystemStatusMessage, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SaveSystemStatusMessagesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).simpleSaveSystemStatusMessage(SystemStatusMessage, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a xlsx the standingTimesUi.
         * @summary Get a standingTimes report of specified tours of one shipper as xlsx
         * @param {StandingTimesUiSpecificReportXlsxRequest} StandingTimesUiSpecificReportXlsxRequest StandingTimesUiSpecificReportXlsxRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standingTimesUiSpecificReportXlsx(StandingTimesUiSpecificReportXlsxRequest: StandingTimesUiSpecificReportXlsxRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).standingTimesUiSpecificReportXlsx(StandingTimesUiSpecificReportXlsxRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a xlsx the standingTimesUi.
         * @summary Get standingTimesUi table as xlsx
         * @param {Date} endTime endTime
         * @param {Date} startTime startTime
         * @param {StandingTimesUiTableAsXlsxRequest} StandingTimesUiTableAsXlsxRequest StandingTimesUiTableAsXlsxRequest
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standingTimesUiTableAsXlsx(endTime: Date, startTime: Date, StandingTimesUiTableAsXlsxRequest: StandingTimesUiTableAsXlsxRequest, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).standingTimesUiTableAsXlsx(endTime, startTime, StandingTimesUiTableAsXlsxRequest, dateTimeField, term, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Upsert the full Spedion DTCO activity logbook for a driver.
         * @summary submitDriverWorkAndRestTimes
         * @param {DriverWorkAndRestTimesUpsertRequest} DriverWorkAndRestTimesUpsertRequest DriverWorkAndRestTimesUpsertRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDriverWorkAndRestTimes(DriverWorkAndRestTimesUpsertRequest: DriverWorkAndRestTimesUpsertRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DriverWorkAndRestTimes> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).submitDriverWorkAndRestTimes(DriverWorkAndRestTimesUpsertRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary switches the active state
         * @param {SwitchActiveTransportOrderConfigTestsRequest} SwitchActiveTransportOrderConfigTestsRequest SwitchActiveTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchActiveTransportOrderConfigTest(SwitchActiveTransportOrderConfigTestsRequest: SwitchActiveTransportOrderConfigTestsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SwitchActiveTransportOrderConfigTestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).switchActiveTransportOrderConfigTest(SwitchActiveTransportOrderConfigTestsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the default contract.
         * @summary save Contract
         * @param {number} configIndex configIndex
         * @param {CompanyWithConfig} CompanyWithConfig CompanyWithConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testApiGatewayConfig(configIndex: number, CompanyWithConfig: CompanyWithConfig, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SaveContractResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).testApiGatewayConfig(configIndex, CompanyWithConfig, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Test all log levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testLogLevel(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Void> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).testLogLevel(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary sends a failed request again
         * @param {string} failedRequestId failedRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerFailedRequest(failedRequestId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TriggerFailedRequestResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).triggerFailedRequest(failedRequestId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary triggers a given list of tests
         * @param {TriggerTransportOrderConfigTestsRequest} TriggerTransportOrderConfigTestsRequest TriggerTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerTransportOrderTests(TriggerTransportOrderConfigTestsRequest: TriggerTransportOrderConfigTestsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TriggerTransportOrderConfigTestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).triggerTransportOrderTests(TriggerTransportOrderConfigTestsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Adding an email address in unsubscribe list.
         * @summary send message
         * @param {UnsubscribeEmailRequest} UnsubscribeEmailRequest UnsubscribeEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeEmail(UnsubscribeEmailRequest: UnsubscribeEmailRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).unsubscribeEmail(UnsubscribeEmailRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify the state dict of the current api gateway with the given config
         * @summary submit api gateway state
         * @param {string} companyId companyId
         * @param {string} configId configId
         * @param {ApiGatewayStateUpdateRequest} ApiGatewayStateUpdateRequest ApiGatewayStateUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiGatewayState(companyId: string, configId: string, ApiGatewayStateUpdateRequest: ApiGatewayStateUpdateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ApiGatewayState> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateApiGatewayState(companyId, configId, ApiGatewayStateUpdateRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * add a company to the user, that he can then switch to
         * @summary updates all companies that a user can switch to
         * @param {UpdateAvailableCompanyToUserRequest} UpdateAvailableCompanyToUserRequest UpdateAvailableCompanyToUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableCompanyToUser(UpdateAvailableCompanyToUserRequest: UpdateAvailableCompanyToUserRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateAvailableCompanyToUserResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateAvailableCompanyToUser(UpdateAvailableCompanyToUserRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updates the comment on a given ConfigHistory
         * @summary update company config history comment
         * @param {string} companyId companyId
         * @param {string} historyId historyId
         * @param {UpdateCompanyConfigHistoryCommentRequest} UpdateCompanyConfigHistoryCommentRequest UpdateCompanyConfigHistoryCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfigHistoryComment(companyId: string, historyId: string, UpdateCompanyConfigHistoryCommentRequest: UpdateCompanyConfigHistoryCommentRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateCompanyConfigHistoryCommentResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateCompanyConfigHistoryComment(companyId, historyId, UpdateCompanyConfigHistoryCommentRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updates the configuration of the company of the currently authenticated user.
         * @summary update current company
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {string} [comment] comment
         * @param {string} [ticketNrs] ticketNrs
         * @param {number} [workTimeInMinutes] workTimeInMinutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, comment?: string, ticketNrs?: string, workTimeInMinutes?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConfigDbVerificationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, comment, ticketNrs, workTimeInMinutes, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gives back all drafts for this user and this companyId.  
         * @summary updateConfigDraft
         * @param {string} draftId draftId
         * @param {boolean} shared shared
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigDraft(draftId: string, shared: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateConfigDraftsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateConfigDraft(draftId, shared, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This is webhook from mailgun which trigger on any status change of email our system send.
         * @summary update email status text webhook from mailgun
         * @param {MailgunWebhookInputRequest} MailgunWebhookInputRequest MailgunWebhookInputRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailStatusTextWebhook(MailgunWebhookInputRequest: MailgunWebhookInputRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateEmailStatusTextWebhook(MailgunWebhookInputRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary update global geofences by id
         * @param {string} id id
         * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalGeofences(id: string, GlobalGeofence: GlobalGeofence, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AddGlobalGeofencesResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateGlobalGeofences(id, GlobalGeofence, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch the message log by given id and update its acknowledge status.
         * @summary update external partner id
         * @param {MessageLogAcknowledgeRequest} MessageLogAcknowledgeRequest MessageLogAcknowledgeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageLogToAcknowledgeStatus(MessageLogAcknowledgeRequest: MessageLogAcknowledgeRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FetchMailLogResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateMessageLogToAcknowledgeStatus(MessageLogAcknowledgeRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will do the same as createOrModify, but without saving anything to the DB. 
         * @summary Update the missing attribute values
         * @param {MissingAttributeValuesUpdateRequest} MissingAttributeValuesUpdateRequest MissingAttributeValuesUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMissingAttributeValues(MissingAttributeValuesUpdateRequest: MissingAttributeValuesUpdateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MissingAttributeValuesUpdateResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateMissingAttributeValues(MissingAttributeValuesUpdateRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update the etaCalculatorEvent's processed and errorString fields.
         * @summary set given etaCalculator event's processed to true and the given errorString
         * @param {MultipleEtaProcessedRequest} MultipleEtaProcessedRequest MultipleEtaProcessedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMultiEtaCalculatorEvents(MultipleEtaProcessedRequest: MultipleEtaProcessedRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NoContent> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateMultiEtaCalculatorEvents(MultipleEtaProcessedRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary update or insert schedulerTaskConfig
         * @param {SchedulerTaskConfig} SchedulerTaskConfig SchedulerTaskConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrInsertSchedulerTaskConfig(SchedulerTaskConfig: SchedulerTaskConfig, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModelBoolean> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateOrInsertSchedulerTaskConfig(SchedulerTaskConfig, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * updates a list of queued events with a given processingState
         * @summary UpdateQueuedEvents
         * @param {UpdateQueuedEventsRequest} UpdateQueuedEventsRequest UpdateQueuedEventsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEvents(UpdateQueuedEventsRequest: UpdateQueuedEventsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SaveConfigFieldDescriptionResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateQueuedEvents(UpdateQueuedEventsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary update Scheduler config
         * @param {SchedulerConfig} SchedulerConfig SchedulerConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerConfig(SchedulerConfig: SchedulerConfig, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NoContent> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateSchedulerConfig(SchedulerConfig, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updates a specific SchedulerReportingConfiguration. Only accessible for superusers.
         * @summary Update SchedulerReportingConfiguration
         * @param {string} id id
         * @param {SchedulerReportingConfiguration} SchedulerReportingConfiguration SchedulerReportingConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerReportingConfiguration(id: string, SchedulerReportingConfiguration: SchedulerReportingConfiguration, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateSchedulerReportingConfigurationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateSchedulerReportingConfiguration(id, SchedulerReportingConfiguration, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary updates the test
         * @param {UpdateTransportOrderConfigTestsRequest} UpdateTransportOrderConfigTestsRequest UpdateTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportOrderConfigTests(UpdateTransportOrderConfigTestsRequest: UpdateTransportOrderConfigTestsRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateTransportOrderConfigTestsResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).updateTransportOrderConfigTests(UpdateTransportOrderConfigTestsRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * uploads credit notes to Zoho
         * @summary upload credit notes to zoho
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCreditNotesToZoho(BillingRequest: BillingRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ZohoInvoicingResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).uploadCreditNotesToZoho(BillingRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * uploads an Invoice from the DB to Zoho
         * @summary upload invoice to zoho
         * @param {UploadInvoiceToZohoRequest} UploadInvoiceToZohoRequest UploadInvoiceToZohoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInvoiceToZoho(UploadInvoiceToZohoRequest: UploadInvoiceToZohoRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ZohoInvoicingResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).uploadInvoiceToZoho(UploadInvoiceToZohoRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updates the configuration of the company of the currently authenticated user.
         * @summary update current company
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConfigValidationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).validateCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {string} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOrderBoxTag(tag: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderBoxValidationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).validateOrderBoxTag(tag, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary checking if the given totp is currently valid
         * @param {string} totp totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTotp(totp: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidateTotpResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).validateTotp(totp, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Validates the configuration, to check if it can be accepted by the database.
         * @summary validate company config
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConfigDbVerificationResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).verifyCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Call this endpoint to view the transport order as immediate format. The immediate format is a list of key value pairs that describe the whole transport order. 
         * @summary Returns the Transport Order as immediate Format
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTransportOrderAsImmediateFormat(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImmediateFormatResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).viewTransportOrderAsImmediateFormat(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary wait for specified duration in milliseconds
         * @param {number} timeInMs timeInMs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitForDuration(timeInMs: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AliveCheckResponse> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).waitForDuration(timeInMs, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Import an excel document containing the customer address mapping. This method is intentionally  allowed for non super users
         * @summary Import address mapping from lis
         * @param {any} doc Excel document to convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        xls2json(doc: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<XlsToJsonResult> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).xls2json(doc, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InternalApi - factory interface
 * @export
 */
export const InternalApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Adds Defaults to a given configuration. Often needed for the converter.
         * @summary getUsersCompany
         * @param {AddDefaultsToConfigRequest} AddDefaultsToConfigRequest AddDefaultsToConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDefaultsToConfig(AddDefaultsToConfigRequest: AddDefaultsToConfigRequest, options?: any) {
            return InternalApiFp(configuration).addDefaultsToConfig(AddDefaultsToConfigRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary add global geofences
         * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGlobalGeofences(GlobalGeofence: GlobalGeofence, options?: any) {
            return InternalApiFp(configuration).addGlobalGeofences(GlobalGeofence, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create a new partnership
         * @param {PartnerAddRequest} PartnerAddRequest PartnerAddRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPartnerToCompany(PartnerAddRequest: PartnerAddRequest, options?: any) {
            return InternalApiFp(configuration).addPartnerToCompany(PartnerAddRequest, options)(fetch, basePath);
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary scriptErrorLogger
         * @param {ScriptErrorLoggerRequest} ScriptErrorLoggerRequest ScriptErrorLoggerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScriptErrorLog(ScriptErrorLoggerRequest: ScriptErrorLoggerRequest, options?: any) {
            return InternalApiFp(configuration).addScriptErrorLog(ScriptErrorLoggerRequest, options)(fetch, basePath);
        },
        /**
         * Returns a list of prompts based on the given search criteria 
         * @summary Test creation or modification of transport order
         * @param {OaiPromptListRequest} OaiPromptListRequest OaiPromptListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiListPrompts(OaiPromptListRequest: OaiPromptListRequest, options?: any) {
            return InternalApiFp(configuration).aiListPrompts(OaiPromptListRequest, options)(fetch, basePath);
        },
        /**
         * Modify a promt with the given criteria 
         * @summary Test creation or modification of transport order
         * @param {string} id id
         * @param {AiParseResult} AiParseResult AiParseResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiModifyPromtResult(id: string, AiParseResult: AiParseResult, options?: any) {
            return InternalApiFp(configuration).aiModifyPromtResult(id, AiParseResult, options)(fetch, basePath);
        },
        /**
         * This operation parses a text using the given input and returns the corresponding output 
         * @summary Call ai with the given promt
         * @param {ParseTextRequest} ParseTextRequest ParseTextRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiParseText(ParseTextRequest: ParseTextRequest, options?: any) {
            return InternalApiFp(configuration).aiParseText(ParseTextRequest, options)(fetch, basePath);
        },
        /**
         * This operation parses a text using the given input and returns the corresponding output with Authentication token 
         * @summary Call ai with the given promt
         * @param {ParseTextPublicRequest} ParseTextPublicRequest ParseTextPublicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiParseTextPublic(ParseTextPublicRequest: ParseTextPublicRequest, options?: any) {
            return InternalApiFp(configuration).aiParseTextPublic(ParseTextPublicRequest, options)(fetch, basePath);
        },
        /**
         * Returns a list of all transport orders exported as excel file using an endpoint with url based authentication
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {string} auth_token auth_token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allTransportOrderExcelExportForPowerBi(auth_token: string, options?: any) {
            return InternalApiFp(configuration).allTransportOrderExcelExportForPowerBi(auth_token, options)(fetch, basePath);
        },
        /**
         * AI analysis of ticket difficulty vs score to suggest which ticket to pick up first
         * @summary analyzeTicketForPickup
         * @param {AnalyzeTicketForPickupRequest} AnalyzeTicketForPickupRequest AnalyzeTicketForPickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeTicketForPickup(AnalyzeTicketForPickupRequest: AnalyzeTicketForPickupRequest, options?: any) {
            return InternalApiFp(configuration).analyzeTicketForPickup(AnalyzeTicketForPickupRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary archive transportOrders
         * @param {string} companyId companyId
         * @param {ArchiveTransportOrdersRequest} ArchiveTransportOrdersRequest ArchiveTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTransportOrders(companyId: string, ArchiveTransportOrdersRequest: ArchiveTransportOrdersRequest, options?: any) {
            return InternalApiFp(configuration).archiveTransportOrders(companyId, ArchiveTransportOrdersRequest, options)(fetch, basePath);
        },
        /**
         * Call this endpoint to assign a transport order with an assigned device to the company of the currently logged in user.
         * @summary Assign transportorder with assigned device to company of logged in user
         * @param {AssignToCurrentCompanyRequestData} AssignToCurrentCompanyRequestData AssignToCurrentCompanyRequestData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTransportOrderToMyCompany(AssignToCurrentCompanyRequestData: AssignToCurrentCompanyRequestData, options?: any) {
            return InternalApiFp(configuration).assignTransportOrderToMyCompany(AssignToCurrentCompanyRequestData, options)(fetch, basePath);
        },
        /**
         * bill given projectWorkLogBook entries
         * @summary bill given projectWorkLogBook entries
         * @param {BillWorkLogBookEntriesRequest} BillWorkLogBookEntriesRequest BillWorkLogBookEntriesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billWorkLogBookEntries(BillWorkLogBookEntriesRequest: BillWorkLogBookEntriesRequest, options?: any) {
            return InternalApiFp(configuration).billWorkLogBookEntries(BillWorkLogBookEntriesRequest, options)(fetch, basePath);
        },
        /**
         * Returns the billing detailed usage report in billed TOs
         * @summary returns the billing detailed usage report in billed TOs
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingDetailedUsageReport(month: number, year: number, options?: any) {
            return InternalApiFp(configuration).billingDetailedUsageReport(month, year, options)(fetch, basePath);
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {string} imei imei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderBoxTag(imei: string, options?: any) {
            return InternalApiFp(configuration).calculateOrderBoxTag(imei, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Sets the system log level to the given value.
         * @param {string} logLevel logLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLogLevel(logLevel: string, options?: any) {
            return InternalApiFp(configuration).changeLogLevel(logLevel, options)(fetch, basePath);
        },
        /**
         * Compares the Zoho price and XLS price for an invoice generated from the billing request. Returns whether the prices are the same, both prices, and the invoice if they differ.
         * @summary compare Zoho and XLS prices for invoice
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareInvoicePrices(BillingRequest: BillingRequest, options?: any) {
            return InternalApiFp(configuration).compareInvoicePrices(BillingRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Compute polyline + DRIVING/STANDING segments from a raw positions list (no DB fetch)
         * @param {ComputeSegmentsFromPositionsRequest} ComputeSegmentsFromPositionsRequest ComputeSegmentsFromPositionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeSegmentsFromPositions(ComputeSegmentsFromPositionsRequest: ComputeSegmentsFromPositionsRequest, options?: any) {
            return InternalApiFp(configuration).computeSegmentsFromPositions(ComputeSegmentsFromPositionsRequest, options)(fetch, basePath);
        },
        /**
         * Returns a list of all transport orders exported as excel file
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {TransportAllOrderToExcelConversionRequest} TransportAllOrderToExcelConversionRequest TransportAllOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertAllTransportOrderListToExcel(TransportAllOrderToExcelConversionRequest: TransportAllOrderToExcelConversionRequest, options?: any) {
            return InternalApiFp(configuration).convertAllTransportOrderListToExcel(TransportAllOrderToExcelConversionRequest, options)(fetch, basePath);
        },
        /**
         * Returns a list of transport orders exported as excel file
         * @summary convert list of transport orders to excel
         * @param {TransportOrderToExcelConversionRequest} TransportOrderToExcelConversionRequest TransportOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertTransportOrderListToExcel(TransportOrderToExcelConversionRequest: TransportOrderToExcelConversionRequest, options?: any) {
            return InternalApiFp(configuration).convertTransportOrderListToExcel(TransportOrderToExcelConversionRequest, options)(fetch, basePath);
        },
        /**
         * This operation will copy an existing transport order and create it in a fresh state for a target company.
         * @summary create multiple transport orders
         * @param {CopyAsNewTransportOrderRequest} CopyAsNewTransportOrderRequest CopyAsNewTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyAsNewTransportOrder(CopyAsNewTransportOrderRequest: CopyAsNewTransportOrderRequest, options?: any) {
            return InternalApiFp(configuration).copyAsNewTransportOrder(CopyAsNewTransportOrderRequest, options)(fetch, basePath);
        },
        /**
         * create billing and responds with Zip-File
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBilling(BillingRequest: BillingRequest, options?: any) {
            return InternalApiFp(configuration).createBilling(BillingRequest, options)(fetch, basePath);
        },
        /**
         * This operation will create a new company with the given name and address. The user must be a super user to execute this operation. Newly created company will have the state UNDER_CONSTRUCTION and the responsibleLogeniosManager will be set to the email of the user who created the company. This operation will also create a new CompanyHistory entry with the change type CREATE and return the created company object.
         * @summary Create a new company
         * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(CompanyCreateRequest: CompanyCreateRequest, options?: any) {
            return InternalApiFp(configuration).createCompany(CompanyCreateRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create a new company
         * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyOldToBeDeletedSoon(CompanyCreateRequest: CompanyCreateRequest, options?: any) {
            return InternalApiFp(configuration).createCompanyOldToBeDeletedSoon(CompanyCreateRequest, options)(fetch, basePath);
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {boolean} includeLinked includeLinked
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2Endpoint(includeLinked: boolean, transportOrderId: string, options?: any) {
            return InternalApiFp(configuration).createDumpV2Endpoint(includeLinked, transportOrderId, options)(fetch, basePath);
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {boolean} includeLinked includeLinked
         * @param {string} transportOrderId transportOrderId
         * @param {boolean} zipped zipped
         * @param {string} [excludeTransportOrderChangeTypes] excludeTransportOrderChangeTypes
         * @param {boolean} [includePositionEvents] includePositionEvents
         * @param {string} [includeTransportOrderChangeTypes] includeTransportOrderChangeTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FileEndpoint(includeLinked: boolean, transportOrderId: string, zipped: boolean, excludeTransportOrderChangeTypes?: string, includePositionEvents?: boolean, includeTransportOrderChangeTypes?: string, options?: any) {
            return InternalApiFp(configuration).createDumpV2FileEndpoint(includeLinked, transportOrderId, zipped, excludeTransportOrderChangeTypes, includePositionEvents, includeTransportOrderChangeTypes, options)(fetch, basePath);
        },
        /**
         * This endpoint returns dump data for transport orders in a specific version range.
         * @summary Get all needed test data for geo status tests (In Format V2) in a specific transport order version range
         * @param {GeoStatusDumpTransportOrderVersionRangeRequest} GeoStatusDumpTransportOrderVersionRangeRequest GeoStatusDumpTransportOrderVersionRangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FilteredByVersionRangeEndpoint(GeoStatusDumpTransportOrderVersionRangeRequest: GeoStatusDumpTransportOrderVersionRangeRequest, options?: any) {
            return InternalApiFp(configuration).createDumpV2FilteredByVersionRangeEndpoint(GeoStatusDumpTransportOrderVersionRangeRequest, options)(fetch, basePath);
        },
        /**
         * This endpoint returns dump data for a transport order.
         * @summary Get all needed test data for geo status tests (In Format V2)
         * @param {GeoStatusDumpTransportOrderListFilterRequest} GeoStatusDumpTransportOrderListFilterRequest GeoStatusDumpTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDumpV2FilteredEndpoint(GeoStatusDumpTransportOrderListFilterRequest: GeoStatusDumpTransportOrderListFilterRequest, options?: any) {
            return InternalApiFp(configuration).createDumpV2FilteredEndpoint(GeoStatusDumpTransportOrderListFilterRequest, options)(fetch, basePath);
        },
        /**
         * create invoices and store in DB
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoicesAndSaveToDB(BillingRequest: BillingRequest, options?: any) {
            return InternalApiFp(configuration).createInvoicesAndSaveToDB(BillingRequest, options)(fetch, basePath);
        },
        /**
         * Update or insert a script error log in the AI tasks.
         * @summary updateOrInsertAiTaskToDB
         * @param {AIAgentTask} AIAgentTask AIAgentTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyAiAgentTask(AIAgentTask: AIAgentTask, options?: any) {
            return InternalApiFp(configuration).createOrModifyAiAgentTask(AIAgentTask, options)(fetch, basePath);
        },
        /**
         * Creates a conversion job log or updates an existing entry
         * @summary Fetch conversion job logs
         * @param {ConversionJobLog} ConversionJobLog ConversionJobLog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyConversionJobLog(ConversionJobLog: ConversionJobLog, options?: any) {
            return InternalApiFp(configuration).createOrModifyConversionJobLog(ConversionJobLog, options)(fetch, basePath);
        },
        /**
         * Update or insert a script Documentation in the Scripts Documentations Table.
         * @summary updateOrInsertScriptDocumentationToDB
         * @param {ScriptsDocumentationEntry} ScriptsDocumentationEntry ScriptsDocumentationEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyScriptDocumentation(ScriptsDocumentationEntry: ScriptsDocumentationEntry, options?: any) {
            return InternalApiFp(configuration).createOrModifyScriptDocumentation(ScriptsDocumentationEntry, options)(fetch, basePath);
        },
        /**
         * This operation will do the same as createOrModify, but without saving anything to the DB. 
         * @summary Test creation or modification of transport order
         * @param {CreateOrModifyTransportOrderDryRunRequest} CreateOrModifyTransportOrderDryRunRequest CreateOrModifyTransportOrderDryRunRequest
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrderDryRun(CreateOrModifyTransportOrderDryRunRequest: CreateOrModifyTransportOrderDryRunRequest, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
            return InternalApiFp(configuration).createOrModifyTransportOrderDryRun(CreateOrModifyTransportOrderDryRunRequest, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(fetch, basePath);
        },
        /**
         * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId
         * @summary create transport order
         * @param {string} companyId companyId
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrderForCompany(companyId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
            return InternalApiFp(configuration).createOrModifyTransportOrderForCompany(companyId, TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(fetch, basePath);
        },
        /**
         * creates a rule for scheduled order creation.
         * @summary create rule for scheduled Order Creation
         * @param {ScheduledOrderCreationRule} ScheduledOrderCreationRule ScheduledOrderCreationRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateScheduledOrderCreationRule(ScheduledOrderCreationRule: ScheduledOrderCreationRule, options?: any) {
            return InternalApiFp(configuration).createOrUpdateScheduledOrderCreationRule(ScheduledOrderCreationRule, options)(fetch, basePath);
        },
        /**
         * 
         * @summary create an ProjectWorkLogBookEntry
         * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectWorkLogBookEntry(ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options?: any) {
            return InternalApiFp(configuration).createProjectWorkLogBookEntry(ProjectWorkLogBookEntry, options)(fetch, basePath);
        },
        /**
         * Returns scriptRunnerUser of given company.
         * @summary create new scriptRunnerUser for given company
         * @param {string} companyId companyId
         * @param {CreateScriptRunnerUserRequest} CreateScriptRunnerUserRequest CreateScriptRunnerUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScriptRunnerUser(companyId: string, CreateScriptRunnerUserRequest: CreateScriptRunnerUserRequest, options?: any) {
            return InternalApiFp(configuration).createScriptRunnerUser(companyId, CreateScriptRunnerUserRequest, options)(fetch, basePath);
        },
        /**
         * Create a new shipment Form Config. The permission COMPANY_MODIFY is required to execute this operation.
         * @summary Create new shipment Form Config
         * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentFormConfig(ShipmentFormConfigRequest: ShipmentFormConfigRequest, options?: any) {
            return InternalApiFp(configuration).createShipmentFormConfig(ShipmentFormConfigRequest, options)(fetch, basePath);
        },
        /**
         * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
         * @summary create transport order without authentication
         * @param {TransportOrderWithTokenPin} TransportOrderWithTokenPin TransportOrderWithTokenPin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportOrderPublic(TransportOrderWithTokenPin: TransportOrderWithTokenPin, options?: any) {
            return InternalApiFp(configuration).createTransportOrderPublic(TransportOrderWithTokenPin, options)(fetch, basePath);
        },
        /**
         * Gibt alle deferred notifications für eine bestimmte orderId zurück.  
         * @summary deferredNotifications
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferredNotifications(orderId: string, options?: any) {
            return InternalApiFp(configuration).deferredNotifications(orderId, options)(fetch, basePath);
        },
        /**
         * Deletes the draft with the given id.  
         * @summary deleteDraftOfConfig
         * @param {string} companyId companyId
         * @param {string} draftId draftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftOfConfig(companyId: string, draftId: string, options?: any) {
            return InternalApiFp(configuration).deleteDraftOfConfig(companyId, draftId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary delete failed requests by ids
         * @param {string} failedRequestIds failedRequestIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFailedRequest(failedRequestIds: string, options?: any) {
            return InternalApiFp(configuration).deleteFailedRequest(failedRequestIds, options)(fetch, basePath);
        },
        /**
         * 
         * @summary delete global geofences by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalGeofences(id: string, options?: any) {
            return InternalApiFp(configuration).deleteGlobalGeofences(id, options)(fetch, basePath);
        },
        /**
         * Deletes the older drafts (of the calling user and for the his current company) until only 5 drafts remain.  
         * @summary deleteOldestAutoSavedDraftOfConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOldestAutoSavedDraftOfConfig(options?: any) {
            return InternalApiFp(configuration).deleteOldestAutoSavedDraftOfConfig(options)(fetch, basePath);
        },
        /**
         * Deletes the ProjectWorkLogBookEntry with the given id.  
         * @summary Delete ProjectWorkLogBookEntry by id
         * @param {string} logBookEntryId logBookEntryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectWorkLogBookEntryById(logBookEntryId: string, options?: any) {
            return InternalApiFp(configuration).deleteProjectWorkLogBookEntryById(logBookEntryId, options)(fetch, basePath);
        },
        /**
         * Removes the shipment form config with the specified config id.
         * @summary Delete shipment Form Config by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentFormConfigById(id: string, options?: any) {
            return InternalApiFp(configuration).deleteShipmentFormConfigById(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary deletes a TransportOrderConfigTest
         * @param {string} [testId] testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransportOrderConfigTest(testId?: string, options?: any) {
            return InternalApiFp(configuration).deleteTransportOrderConfigTest(testId, options)(fetch, basePath);
        },
        /**
         * Returns a description of the link table that belongs to a transport order.
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describeLinkedOrders(orderId: string, options?: any) {
            return InternalApiFp(configuration).describeLinkedOrders(orderId, options)(fetch, basePath);
        },
        /**
         * Call this endpoint to get a description of the patchset. The description contains tabular data what was changed in a transport order
         * @summary Describe patchset
         * @param {DescribePatchsetRequest} DescribePatchsetRequest DescribePatchsetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        describePatchset(DescribePatchsetRequest: DescribePatchsetRequest, options?: any) {
            return InternalApiFp(configuration).describePatchset(DescribePatchsetRequest, options)(fetch, basePath);
        },
        /**
         * Edit an iteration's user input and remove subsequent iterations.
         * @summary editAiAgentTaskIteration
         * @param {EditIterationRequest} EditIterationRequest EditIterationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAiAgentTaskIteration(EditIterationRequest: EditIterationRequest, options?: any) {
            return InternalApiFp(configuration).editAiAgentTaskIteration(EditIterationRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary enroll for totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollTotp(options?: any) {
            return InternalApiFp(configuration).enrollTotp(options)(fetch, basePath);
        },
        /**
         * exclude Company From Unbilled TransportOrders Calculation
         * @summary exclude Company From Unbilled TransportOrders Calculation
         * @param {ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest} ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeCompanyFromUnbilledTransportOrdersCalculation(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest: ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest, options?: any) {
            return InternalApiFp(configuration).excludeCompanyFromUnbilledTransportOrdersCalculation(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest, options)(fetch, basePath);
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary ExtractToSpecificConfig
         * @param {ExtractToSpecificConfigRequest} ExtractToSpecificConfigRequest ExtractToSpecificConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractToSpecificConfig(ExtractToSpecificConfigRequest: ExtractToSpecificConfigRequest, options?: any) {
            return InternalApiFp(configuration).extractToSpecificConfig(ExtractToSpecificConfigRequest, options)(fetch, basePath);
        },
        /**
         * Fetch an AI agent task by script path and company ID
         * @summary getAIAgentTaskByPath
         * @param {string} companyId companyId
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIAgentTaskByID(companyId: string, id: string, options?: any) {
            return InternalApiFp(configuration).fetchAIAgentTaskByID(companyId, id, options)(fetch, basePath);
        },
        /**
         * Fetch AI agent tasks with optional filters
         * @summary getAIAgentTasks
         * @param {string} [companyId] companyId
         * @param {Date} [fromCreateDate] fromCreateDate
         * @param {string} [inputScriptPath] inputScriptPath
         * @param {'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED'} [status] status
         * @param {Date} [toCreateDate] toCreateDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIAgentTasks(companyId?: string, fromCreateDate?: Date, inputScriptPath?: string, status?: 'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED', toCreateDate?: Date, options?: any) {
            return InternalApiFp(configuration).fetchAIAgentTasks(companyId, fromCreateDate, inputScriptPath, status, toCreateDate, options)(fetch, basePath);
        },
        /**
         * Gives back all drafts for this user and this companyId.  
         * @summary fetchAllConfigDrafts
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllConfigDrafts(companyId: string, options?: any) {
            return InternalApiFp(configuration).fetchAllConfigDrafts(companyId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get companies with Notification Configuartion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllNotificationConfiguartions(options?: any) {
            return InternalApiFp(configuration).fetchAllNotificationConfiguartions(options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllQueuedEventsByQueueType(queueType: string, options?: any) {
            return InternalApiFp(configuration).fetchAllQueuedEventsByQueueType(queueType, options)(fetch, basePath);
        },
        /**
         * Returns a list of company id and name and responsible manager of that company
         * @summary fetch list of all companies and their responsible managers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllResponsibleManagers(options?: any) {
            return InternalApiFp(configuration).fetchAllResponsibleManagers(options)(fetch, basePath);
        },
        /**
         * Returns all SchedulerReportingConfigurations. Only accessible for superusers.
         * @summary Fetch all SchedulerReportingConfigurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllSchedulerReportingConfigurations(options?: any) {
            return InternalApiFp(configuration).fetchAllSchedulerReportingConfigurations(options)(fetch, basePath);
        },
        /**
         * Returns the state of the api gateway for the given company. If no state is present, initialize a new api gateway state
         * @summary get api gateway state
         * @param {string} companyId companyId
         * @param {string} configId configId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchApiGatewayState(companyId: string, configId: string, options?: any) {
            return InternalApiFp(configuration).fetchApiGatewayState(companyId, configId, options)(fetch, basePath);
        },
        /**
         * Call this endpoint to get the Assigned device info for a transport order using the companyTag and the external order identifier
         * @summary Query Assigned Device info by external order ref
         * @param {AccessTransportOrderViaExternalAssignedDeviceUrlRequest} AccessTransportOrderViaExternalAssignedDeviceUrlRequest AccessTransportOrderViaExternalAssignedDeviceUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAssignedDeviceInfoByExternalAccessUrl(AccessTransportOrderViaExternalAssignedDeviceUrlRequest: AccessTransportOrderViaExternalAssignedDeviceUrlRequest, options?: any) {
            return InternalApiFp(configuration).fetchAssignedDeviceInfoByExternalAccessUrl(AccessTransportOrderViaExternalAssignedDeviceUrlRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches all devices associated to the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasDevices(options?: any) {
            return InternalApiFp(configuration).fetchAtlasDevices(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches all devices with the corresponding status and position for the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasPositions(options?: any) {
            return InternalApiFp(configuration).fetchAtlasPositions(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches the current atlas version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAtlasVersion(options?: any) {
            return InternalApiFp(configuration).fetchAtlasVersion(options)(fetch, basePath);
        },
        /**
         * Gives back the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary fetchCmNavTreeTextModalList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCmNavTreeTextModalList(options?: any) {
            return InternalApiFp(configuration).fetchCmNavTreeTextModalList(options)(fetch, basePath);
        },
        /**
         * Returns a list of company ids of companies with the given responsible managers
         * @summary fetch list of all companies of the given responsible managers
         * @param {string} responsibleManagers responsibleManagers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompaniesOfResponsibleManagers(responsibleManagers: string, options?: any) {
            return InternalApiFp(configuration).fetchCompaniesOfResponsibleManagers(responsibleManagers, options)(fetch, basePath);
        },
        /**
         * return the existing address mapping found against the given transport order, transport and stop otherwise return null
         * @param {string} orderId orderId
         * @param {string} stopId stopId
         * @param {string} transportId transportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingByStop(orderId: string, stopId: string, transportId: string, options?: any) {
            return InternalApiFp(configuration).fetchCompanyAddressMappingByStop(orderId, stopId, transportId, options)(fetch, basePath);
        },
        /**
         * return the existing address mappings found against the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyAddressMappingsForOrder(orderId: string, options?: any) {
            return InternalApiFp(configuration).fetchCompanyAddressMappingsForOrder(orderId, options)(fetch, basePath);
        },
        /**
         * Fetches all configuration changes for ALL companies within a specified time period. Returns CompanyHistory entries along with their detailed CompanyConfigurationChange records. This endpoint is intended for reporting purposes and requires superuser permissions.  Parameters: - from: Start timestamp (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) - to: End timestamp (ISO 8601 format, e.g., 2024-12-31T23:59:59Z)  Returns: - List of all companies with their configuration changes in the specified period - Grouped by company for easy report generation
         * @summary Fetches company configuration changes for all companies in a given time period
         * @param {string} [from] from
         * @param {string} [to] to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigChanges(from?: string, to?: string, options?: any) {
            return InternalApiFp(configuration).fetchCompanyConfigChanges(from, to, options)(fetch, basePath);
        },
        /**
         * For Superusers: Returns the company config of the companyId provided. For Non-Superusers with COMPANY_FULL_VIEW permission: Returns the company config of the company of the user. If the user gives a company Id, he gets a forbidden.
         * @summary get company config
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfiguration(companyId: string, options?: any) {
            return InternalApiFp(configuration).fetchCompanyConfiguration(companyId, options)(fetch, basePath);
        },
        /**
         * Returns changes of the company with the provided id.
         * @summary get company configuration changes of company
         * @param {string} companyId companyId
         * @param {string} [historyId] historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationChanges(companyId: string, historyId?: string, options?: any) {
            return InternalApiFp(configuration).fetchCompanyConfigurationChanges(companyId, historyId, options)(fetch, basePath);
        },
        /**
         * Returns changes of the company with the provided id.
         * @summary get company configuration changes of company
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [path] path
         * @param {number} [skip] skip
         * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationChangesForField(companyId: string, limit?: number, path?: string, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).fetchCompanyConfigurationChangesForField(companyId, limit, path, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns history of the company with the provided id.
         * @summary get company configuration history of company
         * @param {string} companyId companyId
         * @param {string} [commentQuery] commentQuery
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [specificHistoryId] specificHistoryId
         * @param {'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY'} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyConfigurationHistory(companyId: string, commentQuery?: string, limit?: number, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', specificHistoryId?: string, type?: 'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY', options?: any) {
            return InternalApiFp(configuration).fetchCompanyConfigurationHistory(companyId, commentQuery, limit, skip, sortBy, sortDirection, specificHistoryId, type, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get company config
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyContracts(companyId: string, limit?: number, query?: string, skip?: number, sortBy?: 'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).fetchCompanyContracts(companyId, limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches the company specific view configuration
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCompanyViewConfiguration(companyId: string, options?: any) {
            return InternalApiFp(configuration).fetchCompanyViewConfiguration(companyId, options)(fetch, basePath);
        },
        /**
         * Gives back all current conversion logs.
         * @summary Fetch conversion job logs for transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchConversionJobLogForOrder(orderId: string, options?: any) {
            return InternalApiFp(configuration).fetchConversionJobLogForOrder(orderId, options)(fetch, basePath);
        },
        /**
         * Gives back all current conversion logs.
         * @summary Fetch conversion job logs
         * @param {string} companyId companyId
         * @param {number} [limit] limit
         * @param {string} [orderId] orderId
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchConversionJobLogs(companyId: string, limit?: number, orderId?: string, query?: string, skip?: number, sortBy?: 'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).fetchConversionJobLogs(companyId, limit, orderId, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns the default company config.
         * @summary get default company config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultCompanyConfiguration(options?: any) {
            return InternalApiFp(configuration).fetchDefaultCompanyConfiguration(options)(fetch, basePath);
        },
        /**
         * Returns the default contract.
         * @summary get default Contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultContract(options?: any) {
            return InternalApiFp(configuration).fetchDefaultContract(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the default edi configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultEdiConfiguration(options?: any) {
            return InternalApiFp(configuration).fetchDefaultEdiConfiguration(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the default lis configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultLisConfiguration(options?: any) {
            return InternalApiFp(configuration).fetchDefaultLisConfiguration(options)(fetch, basePath);
        },
        /**
         * Returns a list of freight at the given depot. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get all freight in depot
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDepotFreight(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
            return InternalApiFp(configuration).fetchDepotFreight(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(fetch, basePath);
        },
        /**
         * Gives back the draft with the given id.  
         * @summary fetchDraftOfConfig
         * @param {string} companyId companyId
         * @param {string} draftId draftId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDraftOfConfig(companyId: string, draftId: string, options?: any) {
            return InternalApiFp(configuration).fetchDraftOfConfig(companyId, draftId, options)(fetch, basePath);
        },
        /**
         * Returns an empty ProjectWorkLogBookEntry.
         * @summary get default and empty ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEmptyProjectWorkLogBookEntry(options?: any) {
            return InternalApiFp(configuration).fetchEmptyProjectWorkLogBookEntry(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get current eta for the specified stop
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaAccuracyReportForCompany(transportOrderId: string, options?: any) {
            return InternalApiFp(configuration).fetchEtaAccuracyReportForCompany(transportOrderId, options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning a defined BackendToEtaCalculatorEvent.
         * @summary get eta calculator events
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEvent(id: string, options?: any) {
            return InternalApiFp(configuration).fetchEtaCalculatorEvent(id, options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning take*etaCalculatorEvents.
         * @summary get eta calculator events
         * @param {string} [companyId] companyId
         * @param {string} [id] id
         * @param {number} [limit] limit
         * @param {boolean} [processed] processed
         * @param {number} [skip] skip
         * @param {'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [transportOrderId] transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEvents(companyId?: string, id?: string, limit?: number, processed?: boolean, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options?: any) {
            return InternalApiFp(configuration).fetchEtaCalculatorEvents(companyId, id, limit, processed, skip, sortBy, sortDirection, transportOrderId, options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning take*etaCalculatorEvents.
         * @summary get eta calculator events
         * @param {string} company company
         * @param {number} take take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCalculatorEventsForCompany(company: string, take: number, options?: any) {
            return InternalApiFp(configuration).fetchEtaCalculatorEventsForCompany(company, take, options)(fetch, basePath);
        },
        /**
         * This endpoint returns samples that can  be used to correct the eta value displayed to the user. Super user only endpoint.
         * @summary Get all calculation errors. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCorrectionSamples(options?: any) {
            return InternalApiFp(configuration).fetchEtaCorrectionSamples(options)(fetch, basePath);
        },
        /**
         * This endpoint returns the average eta calculation error for a given eta algo and a destination city and  arrival time. It removes samples from orders where the calculated ETA was not stable, e.g. because the truck was far too late and so the calculated eta values were always corrected upwards.   Values of averageCalculationErrorInMin below zero indicate that the truck was earlier at the location than the calculated eta.   If the parameter orderIdPrefix is given, the calculation is only applied for transport orders that start with the given prefix 
         * @summary Calculates the average error for a given city and planned arrival time
         * @param {EtaCorrectionSampleRequest} EtaCorrectionSampleRequest EtaCorrectionSampleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaCorrectionSamplesForCityAndTime(EtaCorrectionSampleRequest: EtaCorrectionSampleRequest, options?: any) {
            return InternalApiFp(configuration).fetchEtaCorrectionSamplesForCityAndTime(EtaCorrectionSampleRequest, options)(fetch, basePath);
        },
        /**
         * Responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set.    
         * @summary responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set
         * @param {EtaQualityReportRequest} EtaQualityReportRequest EtaQualityReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEtaQualityReport(EtaQualityReportRequest: EtaQualityReportRequest, options?: any) {
            return InternalApiFp(configuration).fetchEtaQualityReport(EtaQualityReportRequest, options)(fetch, basePath);
        },
        /**
         * Fetches failed messageLogs for a specific company.
         * @summary fetch failed messageLogs of a company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedMessageLogsOfSpecificCompany(companyId: string, options?: any) {
            return InternalApiFp(configuration).fetchFailedMessageLogsOfSpecificCompany(companyId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches the failedRequests of requested company
         * @param {Date} [endTime] endTime
         * @param {number} [limit] limit
         * @param {string} [queryId] queryId
         * @param {string} [queryMethod] queryMethod
         * @param {string} [queryUrl] queryUrl
         * @param {string} [queryUserMail] queryUserMail
         * @param {string} [queryXRequestId] queryXRequestId
         * @param {number} [skip] skip
         * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any) {
            return InternalApiFp(configuration).fetchFailedRequests(endTime, limit, queryId, queryMethod, queryUrl, queryUserMail, queryXRequestId, skip, sortBy, sortDirection, startTime, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Check failed requests
         * @param {number} [minutesToCheck] minutesToCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFailedRequestsMonitoring(minutesToCheck?: number, options?: any) {
            return InternalApiFp(configuration).fetchFailedRequestsMonitoring(minutesToCheck, options)(fetch, basePath);
        },
        /**
         * Returns the following history of the provided history id. If it was the last, it returns the current config.
         * @summary get following company configuration history
         * @param {string} companyId companyId
         * @param {string} historyId historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFollowingCompanyConfigurationHistory(companyId: string, historyId: string, options?: any) {
            return InternalApiFp(configuration).fetchFollowingCompanyConfigurationHistory(companyId, historyId, options)(fetch, basePath);
        },
        /**
         * Returns the following history of the provided history id. If it was the last, it returns the current contractVersion.
         * @summary get following company contract history
         * @param {string} companyId companyId
         * @param {string} contractId contractId
         * @param {string} historyId historyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFollowingCompanyContractHistory(companyId: string, contractId: string, historyId: string, options?: any) {
            return InternalApiFp(configuration).fetchFollowingCompanyContractHistory(companyId, contractId, historyId, options)(fetch, basePath);
        },
        /**
         * Returns the geoStatus configuration of user's company.
         * @summary Get geo status config of user's company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusConfig(options?: any) {
            return InternalApiFp(configuration).fetchGeoStatusConfig(options)(fetch, basePath);
        },
        /**
         * Returns the geoStatus configuration of your company.
         * @summary Get geo status config by company id
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusConfigByCompanyId(companyId: string, options?: any) {
            return InternalApiFp(configuration).fetchGeoStatusConfigByCompanyId(companyId, options)(fetch, basePath);
        },
        /**
         * Returns the geoStatus information for requested transport order.
         * @summary Get information object describing thresholds and settings of the geoStatus for requested transport order.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusInformation(transportOrderId: string, options?: any) {
            return InternalApiFp(configuration).fetchGeoStatusInformation(transportOrderId, options)(fetch, basePath);
        },
        /**
         * If no vehicle is selected it will return all test data for transport orders in mongo collection geoStatusTestData. To add transportOrders to geoStatusTestData use addTransportOrderToGeoStatusTestData(). If a vehicleId is given it returns the geoStatus test data for the selected vehicle and time span. Default is last 14 days.
         * @summary Get all needed test data for geo status tests
         * @param {string} [from] from
         * @param {string} [to] to
         * @param {string} [vehicleId] vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusTestData(from?: string, to?: string, vehicleId?: string, options?: any) {
            return InternalApiFp(configuration).fetchGeoStatusTestData(from, to, vehicleId, options)(fetch, basePath);
        },
        /**
         * This endpoint returns dump data for a transport order and adds it to the default geoStatusTestData set fetched by fetchGeoStatusTestData().
         * @summary Get all needed test data for geo status tests
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGeoStatusTestDataForTransportOrder(transportOrderId: string, options?: any) {
            return InternalApiFp(configuration).fetchGeoStatusTestDataForTransportOrder(transportOrderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get global geofences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGlobalGeofences(options?: any) {
            return InternalApiFp(configuration).fetchGlobalGeofences(options)(fetch, basePath);
        },
        /**
         * Fetches History objects. If a type is given, only the type specific histories will be returned. If an ID is given, only the entires with that object ID will be returned. If a query is given, only entries matching that full text search will be returned. It will not respond more entries than the limit, which default is 20. It will respond the total number of found entries.
         * @summary fetch history
         * @param {FetchHistoryRequest} FetchHistoryRequest FetchHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHistory(FetchHistoryRequest: FetchHistoryRequest, options?: any) {
            return InternalApiFp(configuration).fetchHistory(FetchHistoryRequest, options)(fetch, basePath);
        },
        /**
         * fetching invoices from DB
         * @summary fetch invoices which where not uploaded to zoho
         * @param {FetchInvoicesRequest} FetchInvoicesRequest FetchInvoicesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoices(FetchInvoicesRequest: FetchInvoicesRequest, options?: any) {
            return InternalApiFp(configuration).fetchInvoices(FetchInvoicesRequest, options)(fetch, basePath);
        },
        /**
         * Returns the invoice data for all billed companies
         * @summary get billing data for all companies
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoicingData(month: number, year: number, options?: any) {
            return InternalApiFp(configuration).fetchInvoicingData(month, year, options)(fetch, basePath);
        },
        /**
         * Fetches the last GPS position to a given vehicle id.
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastPositionForVehicleId(vehicleId: string, options?: any) {
            return InternalApiFp(configuration).fetchLastPositionForVehicleId(vehicleId, options)(fetch, basePath);
        },
        /**
         * This operation authenticates a user by mail address and returns the company mail gateway configuration
         * @summary Authenticate user by mail address and return 
         * @param {string} userEmailAddress userEmailAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMailGatewayConfigurationByUserEmailAddress(userEmailAddress: string, options?: any) {
            return InternalApiFp(configuration).fetchMailGatewayConfigurationByUserEmailAddress(userEmailAddress, options)(fetch, basePath);
        },
        /**
         * Returns the merged and sorted list of locations of this order
         * @param {string} orderId orderId
         * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMergedStopList(orderId: string, includeDepotsFromLinkedOrders?: boolean, options?: any) {
            return InternalApiFp(configuration).fetchMergedStopList(orderId, includeDepotsFromLinkedOrders, options)(fetch, basePath);
        },
        /**
         * Fetches MessageLog.
         * @summary fetch messageLog
         * @param {FetchMailLogRequest} FetchMailLogRequest FetchMailLogRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMessageLog(FetchMailLogRequest: FetchMailLogRequest, options?: any) {
            return InternalApiFp(configuration).fetchMessageLog(FetchMailLogRequest, options)(fetch, basePath);
        },
        /**
         * Fetches messageLogs of failed sendings.
         * @summary fetch messageLogs of failed sendings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMessageLogReport(options?: any) {
            return InternalApiFp(configuration).fetchMessageLogReport(options)(fetch, basePath);
        },
        /**
         * Returns all available database migrations known to this backend version.
         * @summary get all available db migrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMigrations(options?: any) {
            return InternalApiFp(configuration).fetchMigrations(options)(fetch, basePath);
        },
        /**
         * Fetch Access Token of observer
         * @summary Fetch Access Token of Observer
         * @param {string} orderId orderId
         * @param {string} xObserverId xObserverId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverAccessToken(orderId: string, xObserverId: string, options?: any) {
            return InternalApiFp(configuration).fetchObserverAccessToken(orderId, xObserverId, options)(fetch, basePath);
        },
        /**
         * Gives back all Partners with externalPartnerId and externalPartnerId of them from the given company.
         * @summary fetchPartnersWithConfigAndExportAndImport
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnersWithConfigAndExportAndImport(companyId: string, options?: any) {
            return InternalApiFp(configuration).fetchPartnersWithConfigAndExportAndImport(companyId, options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type of the company of the current user of the users company. Only usable for uses with permisison EVENTS. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type and own company
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsByQueueType(queueType: string, options?: any) {
            return InternalApiFp(configuration).fetchQueuedEventsByQueueType(queueType, options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning all events for all queues of the specified queue type and given company. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
         * @summary get Queued events for queue of type with given company id
         * @param {string} companyId companyId
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsByQueueTypeAndCompanyId(companyId: string, queueType: string, options?: any) {
            return InternalApiFp(configuration).fetchQueuedEventsByQueueTypeAndCompanyId(companyId, queueType, options)(fetch, basePath);
        },
        /**
         * This endpoint returns events according to the given parameters.
         * @summary get all queued events
         * @param {'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER'} [changeTypeFilter] changeTypeFilter
         * @param {string} [companyId] companyId
         * @param {Date} [createdAtFromFilter] createdAtFromFilter
         * @param {Date} [createdAtToFilter] createdAtToFilter
         * @param {'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT'} [eventTypeFilter] eventTypeFilter
         * @param {boolean} [hasExportedFiles] hasExportedFiles
         * @param {number} [limit] limit
         * @param {boolean} [processedFilter] processedFilter
         * @param {'OK' | 'WARN' | 'ERROR' | 'RETRY'} [processingStateFilter] processingStateFilter
         * @param {'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER'} [queueTypeFilter] queueTypeFilter
         * @param {string} [queuedEventId] queuedEventId
         * @param {number} [skip] skip
         * @param {'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {string} [transportOrderId] transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuedEventsForCM(changeTypeFilter?: 'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER', companyId?: string, createdAtFromFilter?: Date, createdAtToFilter?: Date, eventTypeFilter?: 'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT', hasExportedFiles?: boolean, limit?: number, processedFilter?: boolean, processingStateFilter?: 'OK' | 'WARN' | 'ERROR' | 'RETRY', queueTypeFilter?: 'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER', queuedEventId?: string, skip?: number, sortBy?: 'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options?: any) {
            return InternalApiFp(configuration).fetchQueuedEventsForCM(changeTypeFilter, companyId, createdAtFromFilter, createdAtToFilter, eventTypeFilter, hasExportedFiles, limit, processedFilter, processingStateFilter, queueTypeFilter, queuedEventId, skip, sortBy, sortDirection, transportOrderId, options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning all queues of the specified queue type. It returns all queues for all companies Only usable for uses with permisison SUPERUSER. 
         * @summary get all queues of all companiew of the specified type
         * @param {string} queueType queueType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueuesByQueueType(queueType: string, options?: any) {
            return InternalApiFp(configuration).fetchQueuesByQueueType(queueType, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches the rawRequests of requested company
         * @param {Date} [endTime] endTime
         * @param {number} [limit] limit
         * @param {string} [queryId] queryId
         * @param {string} [queryMethod] queryMethod
         * @param {string} [queryUrl] queryUrl
         * @param {string} [queryUserMail] queryUserMail
         * @param {string} [queryXRequestId] queryXRequestId
         * @param {number} [skip] skip
         * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRawRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any) {
            return InternalApiFp(configuration).fetchRawRequests(endTime, limit, queryId, queryMethod, queryUrl, queryUserMail, queryXRequestId, skip, sortBy, sortDirection, startTime, options)(fetch, basePath);
        },
        /**
         * Returns the Release Notes from the Gitlab Wiki for the CM, since it should authenticate via backend.
         * @summary fetch ReleaseNotes From Gitlab Wiki
         * @param {string} stage stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReleaseNotesFromGitlabWiki(stage: string, options?: any) {
            return InternalApiFp(configuration).fetchReleaseNotesFromGitlabWiki(stage, options)(fetch, basePath);
        },
        /**
         * Returns report generation statistics for super users. Shows which companies use reports, how often they are generated, and whether they are sent by email.
         * @summary Fetches report generation statistics
         * @param {string} [companyId] companyId
         * @param {Date} [endTime] endTime
         * @param {'MANUAL' | 'AUTO'} [generationType] generationType
         * @param {number} [limit] limit
         * @param {string} [reportName] reportName
         * @param {string} [sinceId] sinceId
         * @param {number} [skip] skip
         * @param {'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {Date} [startTime] startTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReportGenerationStats(companyId?: string, endTime?: Date, generationType?: 'MANUAL' | 'AUTO', limit?: number, reportName?: string, sinceId?: string, skip?: number, sortBy?: 'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any) {
            return InternalApiFp(configuration).fetchReportGenerationStats(companyId, endTime, generationType, limit, reportName, sinceId, skip, sortBy, sortDirection, startTime, options)(fetch, basePath);
        },
        /**
         * Fetches ScheduledOrderCreationRule.
         * @summary fetch scheduled Order Creation rules
         * @param {FetchScheduledOrderCreationRulesRequest} FetchScheduledOrderCreationRulesRequest FetchScheduledOrderCreationRulesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScheduledOrderCreationRules(FetchScheduledOrderCreationRulesRequest: FetchScheduledOrderCreationRulesRequest, options?: any) {
            return InternalApiFp(configuration).fetchScheduledOrderCreationRules(FetchScheduledOrderCreationRulesRequest, options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning the SchedulerConfigs.
         * @summary get scheduler configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSchedulerConfigs(options?: any) {
            return InternalApiFp(configuration).fetchSchedulerConfigs(options)(fetch, basePath);
        },
        /**
         * This is an internal endpoint returning the SchedulerTasks.
         * @summary get scheduler tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSchedulerTasks(options?: any) {
            return InternalApiFp(configuration).fetchSchedulerTasks(options)(fetch, basePath);
        },
        /**
         * fetch Script Documentation By Documentation Type
         * @summary fetchScriptDocumentationByDocumentationType
         * @param {'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION'} [documentationType] documentationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptDocumentationByDocumentationType(documentationType?: 'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION', options?: any) {
            return InternalApiFp(configuration).fetchScriptDocumentationByDocumentationType(documentationType, options)(fetch, basePath);
        },
        /**
         * Returns scriptRunnerUser of given company.
         * @summary get scriptRunnerUser of given company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptRunnerUser(companyId: string, options?: any) {
            return InternalApiFp(configuration).fetchScriptRunnerUser(companyId, options)(fetch, basePath);
        },
        /**
         * Fetch Scripts Documentations
         * @summary FetchScriptsDocumentations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScriptsDocumentations(options?: any) {
            return InternalApiFp(configuration).fetchScriptsDocumentations(options)(fetch, basePath);
        },
        /**
         * Returns the shipment Form Config of the specified id. The permission COMPANY_MODIFY is required to execute this operation
         * @summary Get shipment Form Config by id
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigById(id: string, options?: any) {
            return InternalApiFp(configuration).fetchShipmentFormConfigById(id, options)(fetch, basePath);
        },
        /**
         * Returns the shipment Form Config of the specified access token without authentication.
         * @summary Get shipment Form Config by access token
         * @param {string} token token
         * @param {string} [pin] pin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigByToken(token: string, pin?: string, options?: any) {
            return InternalApiFp(configuration).fetchShipmentFormConfigByToken(token, pin, options)(fetch, basePath);
        },
        /**
         * Returns a list of all configurations for the transport Order creation form for the specified company.
         * @summary Get List of configurations for the transport Order creation form
         * @param {number} [limit] limit
         * @param {string} [q] q
         * @param {number} [skip] skip
         * @param {'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchShipmentFormConfigList(limit?: number, q?: string, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).fetchShipmentFormConfigList(limit, q, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Call this endpoint to fetch message logs based on message type and list of transport order ids.
         * @summary Returns message logs with specific message type only based on list of transport order ids in request and message type
         * @param {FetchSpecificMessageLogsForTransportOrdersRequest} FetchSpecificMessageLogsForTransportOrdersRequest FetchSpecificMessageLogsForTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSpecificMessageLogsForTransportOrders(FetchSpecificMessageLogsForTransportOrdersRequest: FetchSpecificMessageLogsForTransportOrdersRequest, options?: any) {
            return InternalApiFp(configuration).fetchSpecificMessageLogsForTransportOrders(FetchSpecificMessageLogsForTransportOrdersRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns message logs with specific message type only that where send and reference the given transport order
         * @param {'REMINDER' | 'INFO' | 'WARNING'} messageType messageType
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSpecificTypeMessageLogsForSingleTransportOrder(messageType: 'REMINDER' | 'INFO' | 'WARNING', orderId: string, options?: any) {
            return InternalApiFp(configuration).fetchSpecificTypeMessageLogsForSingleTransportOrder(messageType, orderId, options)(fetch, basePath);
        },
        /**
         * Returns a list of all needed StandingTimesUi data as simple as possible for the requested time period
         * @summary get data for standingTimesUi
         * @param {Date} endTime endTime
         * @param {Date} startTime startTime
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStandingTimesUiData(endTime: Date, startTime: Date, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options?: any) {
            return InternalApiFp(configuration).fetchStandingTimesUiData(endTime, startTime, dateTimeField, term, options)(fetch, basePath);
        },
        /**
         * Standing times per stop as XLSX.
         * @summary fetchStandingTimesXlsx
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStandingTimesXlsx(TourCostReportRequest: TourCostReportRequest, options?: any) {
            return InternalApiFp(configuration).fetchStandingTimesXlsx(TourCostReportRequest, options)(fetch, basePath);
        },
        /**
         * Gives back all current active SystemStatusMessages.
         * @summary Fetch SystemStatusMessages
         * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
         * @param {number} [limit] limit
         * @param {boolean} [onlyActive] onlyActive
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSystemStatusMessages(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).fetchSystemStatusMessages(level, limit, onlyActive, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Returns a list of all currently active SystemStatusMessages with combined affectedTransportOrders.
         * @summary Fetch SystemStatusMessages with combined affectedTransportOrders
         * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
         * @param {number} [limit] limit
         * @param {boolean} [onlyActive] onlyActive
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSystemStatusMessagesCombined(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).fetchSystemStatusMessagesCombined(level, limit, onlyActive, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * ...
         * @summary fetchTourCostReport
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTourCostReport(TourCostReportRequest: TourCostReportRequest, options?: any) {
            return InternalApiFp(configuration).fetchTourCostReport(TourCostReportRequest, options)(fetch, basePath);
        },
        /**
         * Tour cost report as XLSX. Durations are real Excel time cells.
         * @summary fetchTourCostReportXlsx
         * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTourCostReportXlsx(TourCostReportRequest: TourCostReportRequest, options?: any) {
            return InternalApiFp(configuration).fetchTourCostReportXlsx(TourCostReportRequest, options)(fetch, basePath);
        },
        /**
         * This operation will fetch a new Transport-Order by the externalTransportOrderId and the companyId (sourceCompanyId)
         * @summary get transport order by companyId and external transportOrderId
         * @param {string} companyId companyId
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByExternalTransportOrderIdAndCompany(companyId: string, externalTransportOrderId: string, options?: any) {
            return InternalApiFp(configuration).fetchTransportOrderByExternalTransportOrderIdAndCompany(companyId, externalTransportOrderId, options)(fetch, basePath);
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id.
         * @summary get transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByIdSourceAndTargetView(orderId: string, options?: any) {
            return InternalApiFp(configuration).fetchTransportOrderByIdSourceAndTargetView(orderId, options)(fetch, basePath);
        },
        /**
         * This operation will fetch a new Transport-Order by the telematicTransportOrderId and the targetCompanyId
         * @summary get transport order by companyId and GetTransportOrderByTelematicTransportOrderId
         * @param {string} targetCompanyId targetCompanyId
         * @param {string} telematicTransportOrderId telematicTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId(targetCompanyId: string, telematicTransportOrderId: string, options?: any) {
            return InternalApiFp(configuration).fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId(targetCompanyId, telematicTransportOrderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the converter Info of this transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderConverterInfo(orderId: string, options?: any) {
            return InternalApiFp(configuration).fetchTransportOrderConverterInfo(orderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns all messages that where send and reference the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderMessageLog(orderId: string, options?: any) {
            return InternalApiFp(configuration).fetchTransportOrderMessageLog(orderId, options)(fetch, basePath);
        },
        /**
         * Returns a list of partners used in the last transport orders
         * @summary extract partners from transport orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderPartnerList(options?: any) {
            return InternalApiFp(configuration).fetchTransportOrderPartnerList(options)(fetch, basePath);
        },
        /**
         * fetch unbilled projectWorkLogBook entries
         * @summary fetch unbilled projectWorkLogBook entries
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUnbilled(BillingRequest: BillingRequest, limit?: number, skip?: number, sortBy?: 'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).fetchUnbilled(BillingRequest, limit, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches the user for the given company
         * @param {string} companyId companyId
         * @param {string} externalUserId externalUserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserBy(companyId: string, externalUserId: string, options?: any) {
            return InternalApiFp(configuration).fetchUserBy(companyId, externalUserId, options)(fetch, basePath);
        },
        /**
         * Returns a list of all users matching a given searchterm. The superuser permission to show all users or companyAdmin to show company users is required to execute this operation.
         * @summary List all users
         * @param {string} term term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsers(term: string, options?: any) {
            return InternalApiFp(configuration).fetchUsers(term, options)(fetch, basePath);
        },
        /**
         * Returns a list of users specified in the query string. The supplied argument must be a comma separated list of user ids
         * @summary List all users specified in the parameter list
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersByIdList(userIds: string, options?: any) {
            return InternalApiFp(configuration).fetchUsersByIdList(userIds, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetch vehicles residence times in a area defined by position and radius. Default for last 14 days.
         * @param {VehicleGeoFilterRequest} VehicleGeoFilterRequest VehicleGeoFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehicleResidenceTimesInArea(VehicleGeoFilterRequest: VehicleGeoFilterRequest, options?: any) {
            return InternalApiFp(configuration).fetchVehicleResidenceTimesInArea(VehicleGeoFilterRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
         * @param {FixTransportOrderTimesRequest} FixTransportOrderTimesRequest FixTransportOrderTimesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixTransportOrder(FixTransportOrderTimesRequest: FixTransportOrderTimesRequest, options?: any) {
            return InternalApiFp(configuration).fixTransportOrder(FixTransportOrderTimesRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
         * @param {string} transportOrderId transportOrderId
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {number} [mergeAndOrderKeyToStartFrom] mergeAndOrderKeyToStartFrom
         * @param {number} [offsetAfterInMinutes] offsetAfterInMinutes
         * @param {number} [offsetBeforeInMinutes] offsetBeforeInMinutes
         * @param {boolean} [partialFixAllowed] partialFixAllowed
         * @param {boolean} [replaceOriginalTransportOrder] replaceOriginalTransportOrder
         * @param {boolean} [reverse] reverse
         * @param {boolean} [shouldCreateHistoryEntry] shouldCreateHistoryEntry
         * @param {string} [stopIdToStartFrom] stopIdToStartFrom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixTransportOrderTimes(transportOrderId: string, fixStopsOfLinkedTransports?: boolean, mergeAndOrderKeyToStartFrom?: number, offsetAfterInMinutes?: number, offsetBeforeInMinutes?: number, partialFixAllowed?: boolean, replaceOriginalTransportOrder?: boolean, reverse?: boolean, shouldCreateHistoryEntry?: boolean, stopIdToStartFrom?: string, options?: any) {
            return InternalApiFp(configuration).fixTransportOrderTimes(transportOrderId, fixStopsOfLinkedTransports, mergeAndOrderKeyToStartFrom, offsetAfterInMinutes, offsetBeforeInMinutes, partialFixAllowed, replaceOriginalTransportOrder, reverse, shouldCreateHistoryEntry, stopIdToStartFrom, options)(fetch, basePath);
        },
        /**
         * Force the reapplication of the current customerAddressMapping for the transportOrder. This operation is useful to reapply changed customer address mappings
         * @param {boolean} justSimulate justSimulate
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceApplyCustomerAddressMapping(justSimulate: boolean, orderId: string, options?: any) {
            return InternalApiFp(configuration).forceApplyCustomerAddressMapping(justSimulate, orderId, options)(fetch, basePath);
        },
        /**
         * Parses the given JSON String into an CompanyConfiguration object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
         * @summary update current company
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatConfig(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
            return InternalApiFp(configuration).formatConfig(UpdateCompanyConfigRequestWrapper, options)(fetch, basePath);
        },
        /**
         * Parses the given JSON String into an Contract object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
         * @summary update current company
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatContract(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
            return InternalApiFp(configuration).formatContract(UpdateCompanyConfigRequestWrapper, options)(fetch, basePath);
        },
        /**
         * Returns a list of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get report of completed orders of company partners
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompletionReport(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
            return InternalApiFp(configuration).generateCompletionReport(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(fetch, basePath);
        },
        /**
         * Returns a xlsx of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
         * @summary Get report of completed orders of company partners
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompletionReportAsXlsx(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
            return InternalApiFp(configuration).generateCompletionReportAsXlsx(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(fetch, basePath);
        },
        /**
         * returns the Elflein Error report
         * @summary returns the Elflein Error report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateElfleinVdlNetcarErrorReport(options?: any) {
            return InternalApiFp(configuration).generateElfleinVdlNetcarErrorReport(options)(fetch, basePath);
        },
        /**
         * returns the Elflein report
         * @summary returns the Elflein report
         * @param {boolean} compressed compressed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateElfleinVdlNetcarReport(compressed: boolean, options?: any) {
            return InternalApiFp(configuration).generateElfleinVdlNetcarReport(compressed, options)(fetch, basePath);
        },
        /**
         * Executes a generic status report
         * @summary returns the generic status report
         * @param {string} statusReportName statusReportName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGenericStatusReport(statusReportName: string, options?: any) {
            return InternalApiFp(configuration).generateGenericStatusReport(statusReportName, options)(fetch, basePath);
        },
        /**
         * Executes a generic status report for all transport orders matching the filter asynchronously. Returns a job status URL that can be polled to check the report generation progress.
         * @summary generates a generic status report for all filtered transport orders asynchronously
         * @param {string} statusReportName statusReportName
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGenericStatusReportAsync(statusReportName: string, FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any) {
            return InternalApiFp(configuration).generateGenericStatusReportAsync(statusReportName, FetchTransportOrderListFilterRequest, options)(fetch, basePath);
        },
        /**
         * returns the GeoStatus Debug report
         * @summary returns the Debug report for the geo status system
         * @param {number} [fromDay] fromDay
         * @param {number} [fromMonth] fromMonth
         * @param {number} [fromYear] fromYear
         * @param {number} [toDay] toDay
         * @param {number} [toMonth] toMonth
         * @param {number} [toYear] toYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGeoStatusDebugReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options?: any) {
            return InternalApiFp(configuration).generateGeoStatusDebugReport(fromDay, fromMonth, fromYear, toDay, toMonth, toYear, options)(fetch, basePath);
        },
        /**
         * Return CSV Report in the format  id;externalTransportOrderId;KM_START;KM_END;KM_LEER;
         * @summary returns the Paneuropa Mileage report
         * @param {Date} [modifiedSince] modifiedSince
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaneuropaMileageReport(modifiedSince?: Date, options?: any) {
            return InternalApiFp(configuration).generatePaneuropaMileageReport(modifiedSince, options)(fetch, basePath);
        },
        /**
         * returns the validation report
         * @summary returns the validation report
         * @param {number} [fromDay] fromDay
         * @param {number} [fromMonth] fromMonth
         * @param {number} [fromYear] fromYear
         * @param {number} [toDay] toDay
         * @param {number} [toMonth] toMonth
         * @param {number} [toYear] toYear
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateValidationReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options?: any) {
            return InternalApiFp(configuration).generateValidationReport(fromDay, fromMonth, fromYear, toDay, toMonth, toYear, options)(fetch, basePath);
        },
        /**
         * Fetch AI parse result by ID
         * @summary getAiParseResultById
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiParseResultById(id: string, options?: any) {
            return InternalApiFp(configuration).getAiParseResultById(id, options)(fetch, basePath);
        },
        /**
         * Fetch AI parse results with optional filters
         * @summary getAiParseResults
         * @param {FetchAiParseResultsRequest} FetchAiParseResultsRequest FetchAiParseResultsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiParseResults(FetchAiParseResultsRequest: FetchAiParseResultsRequest, options?: any) {
            return InternalApiFp(configuration).getAiParseResults(FetchAiParseResultsRequest, options)(fetch, basePath);
        },
        /**
         * getting all companies and all billed orders
         * @summary getting all companies and all billed orders
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesAndBilledOrders(month: number, year: number, options?: any) {
            return InternalApiFp(configuration).getAllCompaniesAndBilledOrders(month, year, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches all configurations that changed after the given timestamp, default is 1 day
         * @param {string} [since] since
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConfigurations(since?: string, options?: any) {
            return InternalApiFp(configuration).getAllConfigurations(since, options)(fetch, basePath);
        },
        /**
         * getting all unbilled orders for company
         * @summary getting all unbilled orders for company
         * @param {GetAllUnbilledOrdersForCompanyRequest} GetAllUnbilledOrdersForCompanyRequest GetAllUnbilledOrdersForCompanyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnbilledOrdersForCompany(GetAllUnbilledOrdersForCompanyRequest: GetAllUnbilledOrdersForCompanyRequest, options?: any) {
            return InternalApiFp(configuration).getAllUnbilledOrdersForCompany(GetAllUnbilledOrdersForCompanyRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get companies with api-gateway config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiGatewayConfigs(options?: any) {
            return InternalApiFp(configuration).getApiGatewayConfigs(options)(fetch, basePath);
        },
        /**
         * 
         * @summary get alive of backend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendAlive(options?: any) {
            return InternalApiFp(configuration).getBackendAlive(options)(fetch, basePath);
        },
        /**
         * 
         * @summary get health of backend components
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendHealth(options?: any) {
            return InternalApiFp(configuration).getBackendHealth(options)(fetch, basePath);
        },
        /**
         * 
         * @summary get performance of GET+POST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackendPerformance(options?: any) {
            return InternalApiFp(configuration).getBackendPerformance(options)(fetch, basePath);
        },
        /**
         * list all Companies excluded from Unbilled TransportOrders Calculation
         * @summary list all Companies excluded from Unbilled TransportOrders Calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesExcludedFromUnbilledTransportOrdersCalculation(options?: any) {
            return InternalApiFp(configuration).getCompaniesExcludedFromUnbilledTransportOrdersCalculation(options)(fetch, basePath);
        },
        /**
         * get companyIds from companies which should be billed
         * @summary create billing
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesToInvoice(BillingRequest: BillingRequest, options?: any) {
            return InternalApiFp(configuration).getCompaniesToInvoice(BillingRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches all companyNames & tags for the given companyIds
         * @param {string} companyIds companyIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyNames(companyIds: string, options?: any) {
            return InternalApiFp(configuration).getCompanyNames(companyIds, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get the short info of all companies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyShortInfo(options?: any) {
            return InternalApiFp(configuration).getCompanyShortInfo(options)(fetch, basePath);
        },
        /**
         * Return a list of all ConfigFieldDescriptions.
         * @summary getConfigFieldDescriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigFieldDescriptions(options?: any) {
            return InternalApiFp(configuration).getConfigFieldDescriptions(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get company configuration for customer
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(companyId: string, options?: any) {
            return InternalApiFp(configuration).getConfiguration(companyId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get last 24 hours polyline for driver
         * @param {string} driverId driverId
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverPolyline(driverId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
            return InternalApiFp(configuration).getDriverPolyline(driverId, resolveAddresses, segmentByEstimatedStates, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get companies with eta calculator config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtaCalculatorConfigs(options?: any) {
            return InternalApiFp(configuration).getEtaCalculatorConfigs(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {EtaTestEventRequest} EtaTestEventRequest EtaTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtaTestEvent(EtaTestEventRequest: EtaTestEventRequest, options?: any) {
            return InternalApiFp(configuration).getEtaTestEvent(EtaTestEventRequest, options)(fetch, basePath);
        },
        /**
         * Returns a report containing the time at a location for a given time range based on the actual vehicle positions
         * @summary returns the time spent at the specified location report based on GPS data
         * @param {string} companyAddressMappingId companyAddressMappingId
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoTimeAtLocationReport(companyAddressMappingId: string, month: number, year: number, options?: any) {
            return InternalApiFp(configuration).getGeoTimeAtLocationReport(companyAddressMappingId, month, year, options)(fetch, basePath);
        },
        /**
         * Returns a gerolsteiner XML report for the given month
         * @summary returns gerolsteiner xml report
         * @param {boolean} dumpXml dumpXml
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGerolsteinerXmlReport(dumpXml: boolean, month: number, year: number, options?: any) {
            return InternalApiFp(configuration).getGerolsteinerXmlReport(dumpXml, month, year, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get long running queries from mongo db from the last x seconds.
         * @param {number} [minusSeconds] minusSeconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLongRunningQueries(minusSeconds?: number, options?: any) {
            return InternalApiFp(configuration).getLongRunningQueries(minusSeconds, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get the company monitor configurations for customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorConfigurations(options?: any) {
            return InternalApiFp(configuration).getMonitorConfigurations(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get company notification configuration for customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationConfiguration(options?: any) {
            return InternalApiFp(configuration).getNotificationConfiguration(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {PositionTestEventRequest} PositionTestEventRequest PositionTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionTestEvent(PositionTestEventRequest: PositionTestEventRequest, options?: any) {
            return InternalApiFp(configuration).getPositionTestEvent(PositionTestEventRequest, options)(fetch, basePath);
        },
        /**
         * Returns the ProjectWorkLogBookEntries.
         * @summary Gets ProjectWorkLogBookEntries from Company.
         * @param {boolean} [alreadyBilled] alreadyBilled
         * @param {Array<string>} [companyIds] companyIds
         * @param {number} [limit] limit
         * @param {number} [skip] skip
         * @param {'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectWorkLogBookEntries(alreadyBilled?: boolean, companyIds?: Array<string>, limit?: number, skip?: number, sortBy?: 'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).getProjectWorkLogBookEntries(alreadyBilled, companyIds, limit, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get the state of the scheduler reporting task.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulerReportingTaskState(options?: any) {
            return InternalApiFp(configuration).getSchedulerReportingTaskState(options)(fetch, basePath);
        },
        /**
         * sets the given converter config as specific config and returns the companyConfiguration 
         * @summary scriptErrorLogger
         * @param {'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE'} sortBy sortBy
         * @param {'ASC' | 'DESC'} sortDirection sortDirection
         * @param {string} [companyId] companyId
         * @param {Date} [fromCreatedDate] fromCreatedDate
         * @param {number} [limit] limit
         * @param {string} [scriptPath] scriptPath
         * @param {number} [skip] skip
         * @param {Date} [toCreatedDate] toCreatedDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptErrorLogs(sortBy: 'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE', sortDirection: 'ASC' | 'DESC', companyId?: string, fromCreatedDate?: Date, limit?: number, scriptPath?: string, skip?: number, toCreatedDate?: Date, options?: any) {
            return InternalApiFp(configuration).getScriptErrorLogs(sortBy, sortDirection, companyId, fromCreatedDate, limit, scriptPath, skip, toCreatedDate, options)(fetch, basePath);
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getScriptInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptInfo(options?: any) {
            return InternalApiFp(configuration).getScriptInfo(options)(fetch, basePath);
        },
        /**
         * Returns a list of shipmet mapping candidates for the current transport order
         * @summary Get a list of possible shipment mappings for the given transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentMappingProposal(orderId: string, options?: any) {
            return InternalApiFp(configuration).getShipmentMappingProposal(orderId, options)(fetch, basePath);
        },
        /**
         * Returns list of super users with their status of two factor authentication.
         * @summary extract super user list and check their 2 factor authentication is done.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperUserTwoFactorAuthenticationStatus(options?: any) {
            return InternalApiFp(configuration).getSuperUserTwoFactorAuthenticationStatus(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user permissions from a chosen user ID
         * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options?: any) {
            return InternalApiFp(configuration).getTempTargetUserPermissions(TargetUserRequest, options)(fetch, basePath);
        },
        /**
         * Fetch test failures with optional filters
         * @summary getTestFailures
         * @param {GetTestFailuresRequest} GetTestFailuresRequest GetTestFailuresRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestFailures(GetTestFailuresRequest: GetTestFailuresRequest, options?: any) {
            return InternalApiFp(configuration).getTestFailures(GetTestFailuresRequest, options)(fetch, basePath);
        },
        /**
         * Returns a report containing the time at a location for a given time range
         * @summary returns the time spent at Gerolsteiner
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeAtGerolsteinerReport(month: number, year: number, options?: any) {
            return InternalApiFp(configuration).getTimeAtGerolsteinerReport(month, year, options)(fetch, basePath);
        },
        /**
         * Returns a report containing the time at a location for a given time range
         * @summary returns the time spent at the specified location report
         * @param {string} locationString locationString
         * @param {number} month month
         * @param {number} year year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeAtLocationReport(locationString: string, month: number, year: number, options?: any) {
            return InternalApiFp(configuration).getTimeAtLocationReport(locationString, month, year, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a temporary test TransportOrderEvent of the given type, for the given TransportOrder and the config of the given company
         * @param {TransportOrderTestEventRequest} TransportOrderTestEventRequest TransportOrderTestEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportOrderTestEvent(TransportOrderTestEventRequest: TransportOrderTestEventRequest, options?: any) {
            return InternalApiFp(configuration).getTransportOrderTestEvent(TransportOrderTestEventRequest, options)(fetch, basePath);
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getType
         * @param {GetTypeRequest} GetTypeRequest GetTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getType(GetTypeRequest: GetTypeRequest, options?: any) {
            return InternalApiFp(configuration).getType(GetTypeRequest, options)(fetch, basePath);
        },
        /**
         * Gives back the type of the requested value of the CompanyConfiguration.
         * @summary getTypes
         * @param {GetTypesRequest} GetTypesRequest GetTypesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes(GetTypesRequest: GetTypesRequest, options?: any) {
            return InternalApiFp(configuration).getTypes(GetTypesRequest, options)(fetch, basePath);
        },
        /**
         * fetch unbilled projectWorkLogBook entries
         * @summary get unbilled TransportOrders
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnbilledTransportOrders(BillingRequest: BillingRequest, options?: any) {
            return InternalApiFp(configuration).getUnbilledTransportOrders(BillingRequest, options)(fetch, basePath);
        },
        /**
         * Gives back userName by userId
         * @summary getUserName
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserName(userId: string, options?: any) {
            return InternalApiFp(configuration).getUserName(userId, options)(fetch, basePath);
        },
        /**
         * Gives back the company of the given user.
         * @summary getUsersCompany
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCompany(options?: any) {
            return InternalApiFp(configuration).getUsersCompany(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get last 24 hours polyline for vehicle
         * @param {number} epsilon epsilon
         * @param {string} vehicleId vehicleId
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolyline(epsilon: number, vehicleId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
            return InternalApiFp(configuration).getVehiclePolyline(epsilon, vehicleId, resolveAddresses, segmentByEstimatedStates, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Check vehicle positions in a specific time range for irregularities. Default search window is last 7 days.
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePositionsCheck(from: string, to: string, vehicleId: string, options?: any) {
            return InternalApiFp(configuration).getVehiclePositionsCheck(from, to, vehicleId, options)(fetch, basePath);
        },
        /**
         * This operation applies a groovy script on the given transportOrder and returns the result.
         * @summary Applies groovy script on transportOrder and returns result
         * @param {ScriptingRequest} ScriptingRequest ScriptingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groovyScripting(ScriptingRequest: ScriptingRequest, options?: any) {
            return InternalApiFp(configuration).groovyScripting(ScriptingRequest, options)(fetch, basePath);
        },
        /**
         * Import an excel document containing the customer address mapping. This method is intensionally  allowed for non super users
         * @summary Import address mapping from lis
         * @param {any} doc Excel document to import the addresses from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importLisCustomerAddressMapping(doc: any, options?: any) {
            return InternalApiFp(configuration).importLisCustomerAddressMapping(doc, options)(fetch, basePath);
        },
        /**
         * Adds positions from a gpx track with timestamps as fake positions to a vehicle. The startTime overrides the starting time in the gpx file.
         * @summary POST /api/internal/tracking/gpxtrack
         * @param {any} gpx Gpx file with track
         * @param {string} bodyObject Enter body object here
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertGpxTrackForVehicle(gpx: any, bodyObject: string, options?: any) {
            return InternalApiFp(configuration).insertGpxTrackForVehicle(gpx, bodyObject, options)(fetch, basePath);
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSuperuser(options?: any) {
            return InternalApiFp(configuration).isSuperuser(options)(fetch, basePath);
        },
        /**
         * Links two transports with and checks if all needed configs are set.
         * @summary Links two transports
         * @param {TransportLinkingRequest} TransportLinkingRequest TransportLinkingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkTransports(TransportLinkingRequest: TransportLinkingRequest, options?: any) {
            return InternalApiFp(configuration).linkTransports(TransportLinkingRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Lists all TransportOrderConfigTests. This endpoint is needed for the integration tests of the converter
         * @param {string} [companyId] companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).listAllTransportOrderConfigTests(companyId, limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Lists all TransportOrderConfigTests of the users company
         * @param {string} [companyId] companyId
         * @param {number} [limit] limit
         * @param {string} [query] query
         * @param {number} [skip] skip
         * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
         * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options?: any) {
            return InternalApiFp(configuration).listTransportOrderConfigTests(companyId, limit, query, skip, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * Store a generic AI test failure.
         * @summary logTestFailure
         * @param {TestFailureLogEntry} TestFailureLogEntry TestFailureLogEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logTestFailure(TestFailureLogEntry: TestFailureLogEntry, options?: any) {
            return InternalApiFp(configuration).logTestFailure(TestFailureLogEntry, options)(fetch, basePath);
        },
        /**
         * This operation will map a telematic tour to one or multiple existing transport orders. If no script is set, the default company telematicTourMappingScript is used.
         * @summary Map telematic tour to transport order by script
         * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTelematicTour(TelematicTourMapRequest: TelematicTourMapRequest, options?: any) {
            return InternalApiFp(configuration).mapTelematicTour(TelematicTourMapRequest, options)(fetch, basePath);
        },
        /**
         * This operation will map a telematic tour to an existing transport order. If no script is set, the default company telematicTourMappingScript is used.
         * @summary Map telematic tour to transport order by script
         * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapTelematicTourDEPRECATED(TelematicTourMapRequest: TelematicTourMapRequest, options?: any) {
            return InternalApiFp(configuration).mapTelematicTourDEPRECATED(TelematicTourMapRequest, options)(fetch, basePath);
        },
        /**
         * This operation will map a virtual spedion single tour vehicle to an assigned device of an existing transport order.
         * @summary Map virtual SPEDION single tour vehicle to assigned device of specific transport order
         * @param {MapVehicleToAssignedDeviceRequest} MapVehicleToAssignedDeviceRequest MapVehicleToAssignedDeviceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapVehicletoAssignedDevice(MapVehicleToAssignedDeviceRequest: MapVehicleToAssignedDeviceRequest, options?: any) {
            return InternalApiFp(configuration).mapVehicletoAssignedDevice(MapVehicleToAssignedDeviceRequest, options)(fetch, basePath);
        },
        /**
         * To migrate the DB to the latest version known to this version of the backend. 
         * @summary migrating the db to the latest version!
         * @param {boolean} dryRun dryRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateDb(dryRun: boolean, options?: any) {
            return InternalApiFp(configuration).migrateDb(dryRun, options)(fetch, basePath);
        },
        /**
         * Modifies the ProjectWorkLogBookEntry with the specified ProjectWorkLogBookEntryId.
         * @summary Modify ProjectWorkLogBookEntry by id
         * @param {string} logBookEntryId logBookEntryId
         * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyProjectWorkLogBookEntryById(logBookEntryId: string, ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options?: any) {
            return InternalApiFp(configuration).modifyProjectWorkLogBookEntryById(logBookEntryId, ProjectWorkLogBookEntry, options)(fetch, basePath);
        },
        /**
         * Modifies the shipment form config of the given config id. The COMPANY_MODIFY permission is required to execute this operation.
         * @summary Modify shipment Form Config by id
         * @param {string} id id
         * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyShipmentFormConfigById(id: string, ShipmentFormConfigRequest: ShipmentFormConfigRequest, options?: any) {
            return InternalApiFp(configuration).modifyShipmentFormConfigById(id, ShipmentFormConfigRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Monitor mongo db operations running longer than given seconds.
         * @param {string} [mongoDbTags] mongoDbTags
         * @param {number} [seconds] seconds
         * @param {string} [mongoDbTags2] mongoDbTags
         * @param {number} [seconds2] seconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorDbOperations(mongoDbTags?: string, seconds?: number, mongoDbTags2?: string, seconds2?: number, options?: any) {
            return InternalApiFp(configuration).monitorDbOperations(mongoDbTags, seconds, mongoDbTags2, seconds2, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Monitor failed sms and emails in message log in past 7 days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorFailedSmsEmail(options?: any) {
            return InternalApiFp(configuration).monitorFailedSmsEmail(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Monitor waiting events for specific queue.
         * @param {string} type type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorWaitingEvents(type: string, options?: any) {
            return InternalApiFp(configuration).monitorWaitingEvents(type, options)(fetch, basePath);
        },
        /**
         * This operation applies a groovy script on the given transportOrder and returns the result.
         * @summary Applies groovy script on transportOrders and returns results
         * @param {MultiOrderScriptingRequest} MultiOrderScriptingRequest MultiOrderScriptingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiOrderGroovyScripting(MultiOrderScriptingRequest: MultiOrderScriptingRequest, options?: any) {
            return InternalApiFp(configuration).multiOrderGroovyScripting(MultiOrderScriptingRequest, options)(fetch, basePath);
        },
        /**
         * Validates the configuration, to check if it can be accepted by the database.
         * @summary multiScriptExecution
         * @param {MultiScriptExecutionRequest} MultiScriptExecutionRequest MultiScriptExecutionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiScriptExecution(MultiScriptExecutionRequest: MultiScriptExecutionRequest, options?: any) {
            return InternalApiFp(configuration).multiScriptExecution(MultiScriptExecutionRequest, options)(fetch, basePath);
        },
        /**
         * Drops Entries from the ai cache 
         * @summary Call ai with the given promt
         * @param {DropCacheEntryRequest} DropCacheEntryRequest DropCacheEntryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oaiDropCacheEntry(DropCacheEntryRequest: DropCacheEntryRequest, options?: any) {
            return InternalApiFp(configuration).oaiDropCacheEntry(DropCacheEntryRequest, options)(fetch, basePath);
        },
        /**
         * Optimize the Route for given shipments
         * @summary Optimize the Route for given shipments.
         * @param {RouteOptimizerRequest} RouteOptimizerRequest RouteOptimizerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizeRoutes(RouteOptimizerRequest: RouteOptimizerRequest, options?: any) {
            return InternalApiFp(configuration).optimizeRoutes(RouteOptimizerRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary parse a transport order from a prompt
         * @param {ParseTransportOrderRequest} ParseTransportOrderRequest ParseTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseGenericAiToTransportOrder(ParseTransportOrderRequest: ParseTransportOrderRequest, options?: any) {
            return InternalApiFp(configuration).parseGenericAiToTransportOrder(ParseTransportOrderRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary parse the next scheduled execution from a prompt
         * @param {ParseNextScheduledExecutionRequest} ParseNextScheduledExecutionRequest ParseNextScheduledExecutionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseNextScheduledExecution(ParseNextScheduledExecutionRequest: ParseNextScheduledExecutionRequest, options?: any) {
            return InternalApiFp(configuration).parseNextScheduledExecution(ParseNextScheduledExecutionRequest, options)(fetch, basePath);
        },
        /**
         * Returns the times as string calculated by the given reportTimeReference and the current time.
         * @summary previewReportTimeReference
         * @param {ReportTimeReference} ReportTimeReference ReportTimeReference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReportTimeReference(ReportTimeReference: ReportTimeReference, options?: any) {
            return InternalApiFp(configuration).previewReportTimeReference(ReportTimeReference, options)(fetch, basePath);
        },
        /**
         * AI analyzes all tickets considering score, difficulty, and other factors to recommend top 3 to pick up
         * @summary recommendTopTicketsForPickup
         * @param {RecommendTopTicketsRequest} RecommendTopTicketsRequest RecommendTopTicketsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendTopTicketsForPickup(RecommendTopTicketsRequest: RecommendTopTicketsRequest, options?: any) {
            return InternalApiFp(configuration).recommendTopTicketsForPickup(RecommendTopTicketsRequest, options)(fetch, basePath);
        },
        /**
         * Recoveres a deleted object from history
         * @summary recover history entry
         * @param {RecoverHistoryEntryRequest} RecoverHistoryEntryRequest RecoverHistoryEntryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverHistoryEntry(RecoverHistoryEntryRequest: RecoverHistoryEntryRequest, options?: any) {
            return InternalApiFp(configuration).recoverHistoryEntry(RecoverHistoryEntryRequest, options)(fetch, basePath);
        },
        /**
         * Removes a path from the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary removeFromCmNavTreeTextModal
         * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options?: any) {
            return InternalApiFp(configuration).removeFromCmNavTreeTextModal(CmNavTreeTextModalListRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Remove temp token used from a chosen user ID
         * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options?: any) {
            return InternalApiFp(configuration).removeTempTargetUserPermissions(TargetUserRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Replace the company configuration with the given value
         * @param {string} companyId companyId
         * @param {CompanyConfiguration} CompanyConfiguration CompanyConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceConfiguration(companyId: string, CompanyConfiguration: CompanyConfiguration, options?: any) {
            return InternalApiFp(configuration).replaceConfiguration(companyId, CompanyConfiguration, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Replace the company monitor configurations with the given value
         * @param {CompanyMonitorConfigs} CompanyMonitorConfigs CompanyMonitorConfigs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceMonitorConfiguration(CompanyMonitorConfigs: CompanyMonitorConfigs, options?: any) {
            return InternalApiFp(configuration).replaceMonitorConfiguration(CompanyMonitorConfigs, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Replace the company notification configurations with the given value
         * @param {NotificationConfiguration} NotificationConfiguration NotificationConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceNotificationConfiguration(NotificationConfiguration: NotificationConfiguration, options?: any) {
            return InternalApiFp(configuration).replaceNotificationConfiguration(NotificationConfiguration, options)(fetch, basePath);
        },
        /**
         * overrides given SystemStatusMessages.
         * @summary Update SystemStatusMessage endTime
         * @param {string} id id
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceSystemStatusMessage(id: string, SystemStatusMessage: SystemStatusMessage, options?: any) {
            return InternalApiFp(configuration).replaceSystemStatusMessage(id, SystemStatusMessage, options)(fetch, basePath);
        },
        /**
         * 
         * @summary replays all positions of a geostatusTest dump
         * @param {ReplayGeoStatusTestDataRequest} ReplayGeoStatusTestDataRequest ReplayGeoStatusTestDataRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayGeoStatusTestData(ReplayGeoStatusTestDataRequest: ReplayGeoStatusTestDataRequest, options?: any) {
            return InternalApiFp(configuration).replayGeoStatusTestData(ReplayGeoStatusTestDataRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Replays the last position of a vehicle for debugging purposes.
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayLastPositionRequest(vehicleId: string, options?: any) {
            return InternalApiFp(configuration).replayLastPositionRequest(vehicleId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary get Coordinates from AddressMapping
         * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCompanyAddressMappingToCoordinates(CompanyAddressMapping: CompanyAddressMapping, options?: any) {
            return InternalApiFp(configuration).resolveCompanyAddressMappingToCoordinates(CompanyAddressMapping, options)(fetch, basePath);
        },
        /**
         * Re-Validates the customerAddressMapping for the transportOrder
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCustomerAddressMapping(orderId: string, options?: any) {
            return InternalApiFp(configuration).resolveCustomerAddressMapping(orderId, options)(fetch, basePath);
        },
        /**
         * Re-Validates the customerAddressMapping for multiple transportOrders in a single request. Returns detailed results for each transport order processed.
         * @param {ResolveCustomerAddressMappingBatchRequest} ResolveCustomerAddressMappingBatchRequest ResolveCustomerAddressMappingBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCustomerAddressMappingBatch(ResolveCustomerAddressMappingBatchRequest: ResolveCustomerAddressMappingBatchRequest, options?: any) {
            return InternalApiFp(configuration).resolveCustomerAddressMappingBatch(ResolveCustomerAddressMappingBatchRequest, options)(fetch, basePath);
        },
        /**
         * This endpoint returns the reverse geocoding for a given Google plus code.
         * @summary Get the reverse geocoding for a given plus code
         * @param {string} plusCode plusCode
         * @param {boolean} [reduceAccuracyOfPlusCode] reduceAccuracyOfPlusCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseGeocodePlusCode(plusCode: string, reduceAccuracyOfPlusCode?: boolean, options?: any) {
            return InternalApiFp(configuration).reverseGeocodePlusCode(plusCode, reduceAccuracyOfPlusCode, options)(fetch, basePath);
        },
        /**
         * 
         * @summary rollback transportOrder
         * @param {RollbackTransportOrderRequest} RollbackTransportOrderRequest RollbackTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rollbackTransportOrder(RollbackTransportOrderRequest: RollbackTransportOrderRequest, options?: any) {
            return InternalApiFp(configuration).rollbackTransportOrder(RollbackTransportOrderRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {TaskOptions} TaskOptions TaskOptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runTask(TaskOptions: TaskOptions, options?: any) {
            return InternalApiFp(configuration).runTask(TaskOptions, options)(fetch, basePath);
        },
        /**
         * Saves the configuration as draft, so it's saved for later usage.
         * @summary saveConfigAsDraft
         * @param {SaveConfigAsDraftRequest} SaveConfigAsDraftRequest SaveConfigAsDraftRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfigAsDraft(SaveConfigAsDraftRequest: SaveConfigAsDraftRequest, options?: any) {
            return InternalApiFp(configuration).saveConfigAsDraft(SaveConfigAsDraftRequest, options)(fetch, basePath);
        },
        /**
         * Saves a description for a specific field in the CompanyConfiguration. The field is specified by a JQuary leading to the field.
         * @summary saveConfigFieldDescription
         * @param {SaveConfigFieldDescriptionRequest} SaveConfigFieldDescriptionRequest SaveConfigFieldDescriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfigFieldDescription(SaveConfigFieldDescriptionRequest: SaveConfigFieldDescriptionRequest, options?: any) {
            return InternalApiFp(configuration).saveConfigFieldDescription(SaveConfigFieldDescriptionRequest, options)(fetch, basePath);
        },
        /**
         * Returns the default contract.
         * @summary save Contract
         * @param {SaveContractRequest} SaveContractRequest SaveContractRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContract(SaveContractRequest: SaveContractRequest, options?: any) {
            return InternalApiFp(configuration).saveContract(SaveContractRequest, options)(fetch, basePath);
        },
        /**
         * Saves a SystemStatusMessage and returns if it succeeded.
         * @summary Save SystemStatusMessage
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSystemStatusMessages(SystemStatusMessage: SystemStatusMessage, options?: any) {
            return InternalApiFp(configuration).saveSystemStatusMessages(SystemStatusMessage, options)(fetch, basePath);
        },
        /**
         * 
         * @summary save a new TransportOrderConfig Test
         * @param {SaveTransportOrderConfigTestRequest} SaveTransportOrderConfigTestRequest SaveTransportOrderConfigTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTransportOrderConfigTest(SaveTransportOrderConfigTestRequest: SaveTransportOrderConfigTestRequest, options?: any) {
            return InternalApiFp(configuration).saveTransportOrderConfigTest(SaveTransportOrderConfigTestRequest, options)(fetch, basePath);
        },
        /**
         * Fetch unassigned tickets with Score label from GitLab, sorted by score descending
         * @summary scoredUnassignedTickets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoredUnassignedTickets(options?: any) {
            return InternalApiFp(configuration).scoredUnassignedTickets(options)(fetch, basePath);
        },
        /**
         * This endpoint searches through all configurations of all companies for a given searchTerm. The searchTerm is splitted by whitespaces and will return matches for every substring. To avoid splitting the searchterm or parts of it, please surround it by quots. Example:    searchterm [hello world] will respond every config containing the term \"hello\" and every config containing the term \"world\".             searchterm [\"hello world\"] will respond every config containing the searchterm \"hello world\" 
         * @summary search Configs
         * @param {SearchConfigsRequest} SearchConfigsRequest SearchConfigsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConfigs(SearchConfigsRequest: SearchConfigsRequest, options?: any) {
            return InternalApiFp(configuration).searchConfigs(SearchConfigsRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary redirects query to graylog and returns found logs
         * @param {GraylogRequest} GraylogRequest GraylogRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGraylog(GraylogRequest: GraylogRequest, options?: any) {
            return InternalApiFp(configuration).searchGraylog(GraylogRequest, options)(fetch, basePath);
        },
        /**
         * Returns a list of all transport orders exported as excel file
         * @summary convert list of all transport orders to excel without any pagination rules
         * @param {TransportSelectedOrderToExcelConversionRequest} TransportSelectedOrderToExcelConversionRequest TransportSelectedOrderToExcelConversionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectedTransportOrderExcelExport(TransportSelectedOrderToExcelConversionRequest: TransportSelectedOrderToExcelConversionRequest, options?: any) {
            return InternalApiFp(configuration).selectedTransportOrderExcelExport(TransportSelectedOrderToExcelConversionRequest, options)(fetch, basePath);
        },
        /**
         * sends mail and logs it into the MailLog-collection in the DB.
         * @summary send message
         * @param {MessageLog} MessageLog MessageLog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(MessageLog: MessageLog, options?: any) {
            return InternalApiFp(configuration).sendMessage(MessageLog, options)(fetch, basePath);
        },
        /**
         * Adds a path to the list of paths that should be opened as TextField in the CM-NavTree.
         * @summary setCmNavTreeTextModal
         * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options?: any) {
            return InternalApiFp(configuration).setCmNavTreeTextModal(CmNavTreeTextModalListRequest, options)(fetch, basePath);
        },
        /**
         * Send shipment Form Config access details via user's Email.
         * @summary Send shipment Form Config access details via user's Email
         * @param {string} shipmentCreateFormId shipmentCreateFormId
         * @param {ShareUserAccessViaEmailRequest} ShareUserAccessViaEmailRequest ShareUserAccessViaEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareShipmentCreateFormUserAccessViaEmail(shipmentCreateFormId: string, ShareUserAccessViaEmailRequest: ShareUserAccessViaEmailRequest, options?: any) {
            return InternalApiFp(configuration).shareShipmentCreateFormUserAccessViaEmail(shipmentCreateFormId, ShareUserAccessViaEmailRequest, options)(fetch, basePath);
        },
        /**
         * Saves a SystemStatusMessage and ends all other SystemStatusMessages for the combination of companyId + groupKey.
         * @summary Save SystemStatusMessage and end others
         * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleSaveSystemStatusMessage(SystemStatusMessage: SystemStatusMessage, options?: any) {
            return InternalApiFp(configuration).simpleSaveSystemStatusMessage(SystemStatusMessage, options)(fetch, basePath);
        },
        /**
         * Returns a xlsx the standingTimesUi.
         * @summary Get a standingTimes report of specified tours of one shipper as xlsx
         * @param {StandingTimesUiSpecificReportXlsxRequest} StandingTimesUiSpecificReportXlsxRequest StandingTimesUiSpecificReportXlsxRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standingTimesUiSpecificReportXlsx(StandingTimesUiSpecificReportXlsxRequest: StandingTimesUiSpecificReportXlsxRequest, options?: any) {
            return InternalApiFp(configuration).standingTimesUiSpecificReportXlsx(StandingTimesUiSpecificReportXlsxRequest, options)(fetch, basePath);
        },
        /**
         * Returns a xlsx the standingTimesUi.
         * @summary Get standingTimesUi table as xlsx
         * @param {Date} endTime endTime
         * @param {Date} startTime startTime
         * @param {StandingTimesUiTableAsXlsxRequest} StandingTimesUiTableAsXlsxRequest StandingTimesUiTableAsXlsxRequest
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {string} [term] term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        standingTimesUiTableAsXlsx(endTime: Date, startTime: Date, StandingTimesUiTableAsXlsxRequest: StandingTimesUiTableAsXlsxRequest, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options?: any) {
            return InternalApiFp(configuration).standingTimesUiTableAsXlsx(endTime, startTime, StandingTimesUiTableAsXlsxRequest, dateTimeField, term, options)(fetch, basePath);
        },
        /**
         * Upsert the full Spedion DTCO activity logbook for a driver.
         * @summary submitDriverWorkAndRestTimes
         * @param {DriverWorkAndRestTimesUpsertRequest} DriverWorkAndRestTimesUpsertRequest DriverWorkAndRestTimesUpsertRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDriverWorkAndRestTimes(DriverWorkAndRestTimesUpsertRequest: DriverWorkAndRestTimesUpsertRequest, options?: any) {
            return InternalApiFp(configuration).submitDriverWorkAndRestTimes(DriverWorkAndRestTimesUpsertRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary switches the active state
         * @param {SwitchActiveTransportOrderConfigTestsRequest} SwitchActiveTransportOrderConfigTestsRequest SwitchActiveTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchActiveTransportOrderConfigTest(SwitchActiveTransportOrderConfigTestsRequest: SwitchActiveTransportOrderConfigTestsRequest, options?: any) {
            return InternalApiFp(configuration).switchActiveTransportOrderConfigTest(SwitchActiveTransportOrderConfigTestsRequest, options)(fetch, basePath);
        },
        /**
         * Returns the default contract.
         * @summary save Contract
         * @param {number} configIndex configIndex
         * @param {CompanyWithConfig} CompanyWithConfig CompanyWithConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testApiGatewayConfig(configIndex: number, CompanyWithConfig: CompanyWithConfig, options?: any) {
            return InternalApiFp(configuration).testApiGatewayConfig(configIndex, CompanyWithConfig, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Test all log levels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testLogLevel(options?: any) {
            return InternalApiFp(configuration).testLogLevel(options)(fetch, basePath);
        },
        /**
         * 
         * @summary sends a failed request again
         * @param {string} failedRequestId failedRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerFailedRequest(failedRequestId: string, options?: any) {
            return InternalApiFp(configuration).triggerFailedRequest(failedRequestId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary triggers a given list of tests
         * @param {TriggerTransportOrderConfigTestsRequest} TriggerTransportOrderConfigTestsRequest TriggerTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerTransportOrderTests(TriggerTransportOrderConfigTestsRequest: TriggerTransportOrderConfigTestsRequest, options?: any) {
            return InternalApiFp(configuration).triggerTransportOrderTests(TriggerTransportOrderConfigTestsRequest, options)(fetch, basePath);
        },
        /**
         * Adding an email address in unsubscribe list.
         * @summary send message
         * @param {UnsubscribeEmailRequest} UnsubscribeEmailRequest UnsubscribeEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeEmail(UnsubscribeEmailRequest: UnsubscribeEmailRequest, options?: any) {
            return InternalApiFp(configuration).unsubscribeEmail(UnsubscribeEmailRequest, options)(fetch, basePath);
        },
        /**
         * Modify the state dict of the current api gateway with the given config
         * @summary submit api gateway state
         * @param {string} companyId companyId
         * @param {string} configId configId
         * @param {ApiGatewayStateUpdateRequest} ApiGatewayStateUpdateRequest ApiGatewayStateUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiGatewayState(companyId: string, configId: string, ApiGatewayStateUpdateRequest: ApiGatewayStateUpdateRequest, options?: any) {
            return InternalApiFp(configuration).updateApiGatewayState(companyId, configId, ApiGatewayStateUpdateRequest, options)(fetch, basePath);
        },
        /**
         * add a company to the user, that he can then switch to
         * @summary updates all companies that a user can switch to
         * @param {UpdateAvailableCompanyToUserRequest} UpdateAvailableCompanyToUserRequest UpdateAvailableCompanyToUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableCompanyToUser(UpdateAvailableCompanyToUserRequest: UpdateAvailableCompanyToUserRequest, options?: any) {
            return InternalApiFp(configuration).updateAvailableCompanyToUser(UpdateAvailableCompanyToUserRequest, options)(fetch, basePath);
        },
        /**
         * Updates the comment on a given ConfigHistory
         * @summary update company config history comment
         * @param {string} companyId companyId
         * @param {string} historyId historyId
         * @param {UpdateCompanyConfigHistoryCommentRequest} UpdateCompanyConfigHistoryCommentRequest UpdateCompanyConfigHistoryCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfigHistoryComment(companyId: string, historyId: string, UpdateCompanyConfigHistoryCommentRequest: UpdateCompanyConfigHistoryCommentRequest, options?: any) {
            return InternalApiFp(configuration).updateCompanyConfigHistoryComment(companyId, historyId, UpdateCompanyConfigHistoryCommentRequest, options)(fetch, basePath);
        },
        /**
         * Updates the configuration of the company of the currently authenticated user.
         * @summary update current company
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {string} [comment] comment
         * @param {string} [ticketNrs] ticketNrs
         * @param {number} [workTimeInMinutes] workTimeInMinutes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, comment?: string, ticketNrs?: string, workTimeInMinutes?: number, options?: any) {
            return InternalApiFp(configuration).updateCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, comment, ticketNrs, workTimeInMinutes, options)(fetch, basePath);
        },
        /**
         * Gives back all drafts for this user and this companyId.  
         * @summary updateConfigDraft
         * @param {string} draftId draftId
         * @param {boolean} shared shared
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigDraft(draftId: string, shared: boolean, options?: any) {
            return InternalApiFp(configuration).updateConfigDraft(draftId, shared, options)(fetch, basePath);
        },
        /**
         * This is webhook from mailgun which trigger on any status change of email our system send.
         * @summary update email status text webhook from mailgun
         * @param {MailgunWebhookInputRequest} MailgunWebhookInputRequest MailgunWebhookInputRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailStatusTextWebhook(MailgunWebhookInputRequest: MailgunWebhookInputRequest, options?: any) {
            return InternalApiFp(configuration).updateEmailStatusTextWebhook(MailgunWebhookInputRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary update global geofences by id
         * @param {string} id id
         * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalGeofences(id: string, GlobalGeofence: GlobalGeofence, options?: any) {
            return InternalApiFp(configuration).updateGlobalGeofences(id, GlobalGeofence, options)(fetch, basePath);
        },
        /**
         * Fetch the message log by given id and update its acknowledge status.
         * @summary update external partner id
         * @param {MessageLogAcknowledgeRequest} MessageLogAcknowledgeRequest MessageLogAcknowledgeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageLogToAcknowledgeStatus(MessageLogAcknowledgeRequest: MessageLogAcknowledgeRequest, options?: any) {
            return InternalApiFp(configuration).updateMessageLogToAcknowledgeStatus(MessageLogAcknowledgeRequest, options)(fetch, basePath);
        },
        /**
         * This operation will do the same as createOrModify, but without saving anything to the DB. 
         * @summary Update the missing attribute values
         * @param {MissingAttributeValuesUpdateRequest} MissingAttributeValuesUpdateRequest MissingAttributeValuesUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMissingAttributeValues(MissingAttributeValuesUpdateRequest: MissingAttributeValuesUpdateRequest, options?: any) {
            return InternalApiFp(configuration).updateMissingAttributeValues(MissingAttributeValuesUpdateRequest, options)(fetch, basePath);
        },
        /**
         * Update the etaCalculatorEvent's processed and errorString fields.
         * @summary set given etaCalculator event's processed to true and the given errorString
         * @param {MultipleEtaProcessedRequest} MultipleEtaProcessedRequest MultipleEtaProcessedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMultiEtaCalculatorEvents(MultipleEtaProcessedRequest: MultipleEtaProcessedRequest, options?: any) {
            return InternalApiFp(configuration).updateMultiEtaCalculatorEvents(MultipleEtaProcessedRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary update or insert schedulerTaskConfig
         * @param {SchedulerTaskConfig} SchedulerTaskConfig SchedulerTaskConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrInsertSchedulerTaskConfig(SchedulerTaskConfig: SchedulerTaskConfig, options?: any) {
            return InternalApiFp(configuration).updateOrInsertSchedulerTaskConfig(SchedulerTaskConfig, options)(fetch, basePath);
        },
        /**
         * updates a list of queued events with a given processingState
         * @summary UpdateQueuedEvents
         * @param {UpdateQueuedEventsRequest} UpdateQueuedEventsRequest UpdateQueuedEventsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueuedEvents(UpdateQueuedEventsRequest: UpdateQueuedEventsRequest, options?: any) {
            return InternalApiFp(configuration).updateQueuedEvents(UpdateQueuedEventsRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary update Scheduler config
         * @param {SchedulerConfig} SchedulerConfig SchedulerConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerConfig(SchedulerConfig: SchedulerConfig, options?: any) {
            return InternalApiFp(configuration).updateSchedulerConfig(SchedulerConfig, options)(fetch, basePath);
        },
        /**
         * Updates a specific SchedulerReportingConfiguration. Only accessible for superusers.
         * @summary Update SchedulerReportingConfiguration
         * @param {string} id id
         * @param {SchedulerReportingConfiguration} SchedulerReportingConfiguration SchedulerReportingConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerReportingConfiguration(id: string, SchedulerReportingConfiguration: SchedulerReportingConfiguration, options?: any) {
            return InternalApiFp(configuration).updateSchedulerReportingConfiguration(id, SchedulerReportingConfiguration, options)(fetch, basePath);
        },
        /**
         * 
         * @summary updates the test
         * @param {UpdateTransportOrderConfigTestsRequest} UpdateTransportOrderConfigTestsRequest UpdateTransportOrderConfigTestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportOrderConfigTests(UpdateTransportOrderConfigTestsRequest: UpdateTransportOrderConfigTestsRequest, options?: any) {
            return InternalApiFp(configuration).updateTransportOrderConfigTests(UpdateTransportOrderConfigTestsRequest, options)(fetch, basePath);
        },
        /**
         * uploads credit notes to Zoho
         * @summary upload credit notes to zoho
         * @param {BillingRequest} BillingRequest BillingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCreditNotesToZoho(BillingRequest: BillingRequest, options?: any) {
            return InternalApiFp(configuration).uploadCreditNotesToZoho(BillingRequest, options)(fetch, basePath);
        },
        /**
         * uploads an Invoice from the DB to Zoho
         * @summary upload invoice to zoho
         * @param {UploadInvoiceToZohoRequest} UploadInvoiceToZohoRequest UploadInvoiceToZohoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInvoiceToZoho(UploadInvoiceToZohoRequest: UploadInvoiceToZohoRequest, options?: any) {
            return InternalApiFp(configuration).uploadInvoiceToZoho(UploadInvoiceToZohoRequest, options)(fetch, basePath);
        },
        /**
         * Updates the configuration of the company of the currently authenticated user.
         * @summary update current company
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
            return InternalApiFp(configuration).validateCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, options)(fetch, basePath);
        },
        /**
         * 
         * @summary checks if the user is super user
         * @param {string} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOrderBoxTag(tag: string, options?: any) {
            return InternalApiFp(configuration).validateOrderBoxTag(tag, options)(fetch, basePath);
        },
        /**
         * 
         * @summary checking if the given totp is currently valid
         * @param {string} totp totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTotp(totp: string, options?: any) {
            return InternalApiFp(configuration).validateTotp(totp, options)(fetch, basePath);
        },
        /**
         * Validates the configuration, to check if it can be accepted by the database.
         * @summary validate company config
         * @param {string} companyId companyId
         * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
            return InternalApiFp(configuration).verifyCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, options)(fetch, basePath);
        },
        /**
         * Call this endpoint to view the transport order as immediate format. The immediate format is a list of key value pairs that describe the whole transport order. 
         * @summary Returns the Transport Order as immediate Format
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTransportOrderAsImmediateFormat(orderId: string, options?: any) {
            return InternalApiFp(configuration).viewTransportOrderAsImmediateFormat(orderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary wait for specified duration in milliseconds
         * @param {number} timeInMs timeInMs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitForDuration(timeInMs: number, options?: any) {
            return InternalApiFp(configuration).waitForDuration(timeInMs, options)(fetch, basePath);
        },
        /**
         * Import an excel document containing the customer address mapping. This method is intentionally  allowed for non super users
         * @summary Import address mapping from lis
         * @param {any} doc Excel document to convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        xls2json(doc: any, options?: any) {
            return InternalApiFp(configuration).xls2json(doc, options)(fetch, basePath);
        },
    };
};

/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
export class InternalApi extends BaseAPI {
    /**
     * Adds Defaults to a given configuration. Often needed for the converter.
     * @summary getUsersCompany
     * @param {AddDefaultsToConfigRequest} AddDefaultsToConfigRequest AddDefaultsToConfigRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public addDefaultsToConfig(AddDefaultsToConfigRequest: AddDefaultsToConfigRequest, options?: any) {
        return InternalApiFp(this.configuration).addDefaultsToConfig(AddDefaultsToConfigRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary add global geofences
     * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public addGlobalGeofences(GlobalGeofence: GlobalGeofence, options?: any) {
        return InternalApiFp(this.configuration).addGlobalGeofences(GlobalGeofence, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create a new partnership
     * @param {PartnerAddRequest} PartnerAddRequest PartnerAddRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public addPartnerToCompany(PartnerAddRequest: PartnerAddRequest, options?: any) {
        return InternalApiFp(this.configuration).addPartnerToCompany(PartnerAddRequest, options)(this.fetch, this.basePath);
    }

    /**
     * sets the given converter config as specific config and returns the companyConfiguration 
     * @summary scriptErrorLogger
     * @param {ScriptErrorLoggerRequest} ScriptErrorLoggerRequest ScriptErrorLoggerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public addScriptErrorLog(ScriptErrorLoggerRequest: ScriptErrorLoggerRequest, options?: any) {
        return InternalApiFp(this.configuration).addScriptErrorLog(ScriptErrorLoggerRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of prompts based on the given search criteria 
     * @summary Test creation or modification of transport order
     * @param {OaiPromptListRequest} OaiPromptListRequest OaiPromptListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public aiListPrompts(OaiPromptListRequest: OaiPromptListRequest, options?: any) {
        return InternalApiFp(this.configuration).aiListPrompts(OaiPromptListRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Modify a promt with the given criteria 
     * @summary Test creation or modification of transport order
     * @param {string} id id
     * @param {AiParseResult} AiParseResult AiParseResult
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public aiModifyPromtResult(id: string, AiParseResult: AiParseResult, options?: any) {
        return InternalApiFp(this.configuration).aiModifyPromtResult(id, AiParseResult, options)(this.fetch, this.basePath);
    }

    /**
     * This operation parses a text using the given input and returns the corresponding output 
     * @summary Call ai with the given promt
     * @param {ParseTextRequest} ParseTextRequest ParseTextRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public aiParseText(ParseTextRequest: ParseTextRequest, options?: any) {
        return InternalApiFp(this.configuration).aiParseText(ParseTextRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation parses a text using the given input and returns the corresponding output with Authentication token 
     * @summary Call ai with the given promt
     * @param {ParseTextPublicRequest} ParseTextPublicRequest ParseTextPublicRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public aiParseTextPublic(ParseTextPublicRequest: ParseTextPublicRequest, options?: any) {
        return InternalApiFp(this.configuration).aiParseTextPublic(ParseTextPublicRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all transport orders exported as excel file using an endpoint with url based authentication
     * @summary convert list of all transport orders to excel without any pagination rules
     * @param {string} auth_token auth_token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public allTransportOrderExcelExportForPowerBi(auth_token: string, options?: any) {
        return InternalApiFp(this.configuration).allTransportOrderExcelExportForPowerBi(auth_token, options)(this.fetch, this.basePath);
    }

    /**
     * AI analysis of ticket difficulty vs score to suggest which ticket to pick up first
     * @summary analyzeTicketForPickup
     * @param {AnalyzeTicketForPickupRequest} AnalyzeTicketForPickupRequest AnalyzeTicketForPickupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public analyzeTicketForPickup(AnalyzeTicketForPickupRequest: AnalyzeTicketForPickupRequest, options?: any) {
        return InternalApiFp(this.configuration).analyzeTicketForPickup(AnalyzeTicketForPickupRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary archive transportOrders
     * @param {string} companyId companyId
     * @param {ArchiveTransportOrdersRequest} ArchiveTransportOrdersRequest ArchiveTransportOrdersRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public archiveTransportOrders(companyId: string, ArchiveTransportOrdersRequest: ArchiveTransportOrdersRequest, options?: any) {
        return InternalApiFp(this.configuration).archiveTransportOrders(companyId, ArchiveTransportOrdersRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Call this endpoint to assign a transport order with an assigned device to the company of the currently logged in user.
     * @summary Assign transportorder with assigned device to company of logged in user
     * @param {AssignToCurrentCompanyRequestData} AssignToCurrentCompanyRequestData AssignToCurrentCompanyRequestData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public assignTransportOrderToMyCompany(AssignToCurrentCompanyRequestData: AssignToCurrentCompanyRequestData, options?: any) {
        return InternalApiFp(this.configuration).assignTransportOrderToMyCompany(AssignToCurrentCompanyRequestData, options)(this.fetch, this.basePath);
    }

    /**
     * bill given projectWorkLogBook entries
     * @summary bill given projectWorkLogBook entries
     * @param {BillWorkLogBookEntriesRequest} BillWorkLogBookEntriesRequest BillWorkLogBookEntriesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public billWorkLogBookEntries(BillWorkLogBookEntriesRequest: BillWorkLogBookEntriesRequest, options?: any) {
        return InternalApiFp(this.configuration).billWorkLogBookEntries(BillWorkLogBookEntriesRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the billing detailed usage report in billed TOs
     * @summary returns the billing detailed usage report in billed TOs
     * @param {number} month month
     * @param {number} year year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public billingDetailedUsageReport(month: number, year: number, options?: any) {
        return InternalApiFp(this.configuration).billingDetailedUsageReport(month, year, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary checks if the user is super user
     * @param {string} imei imei
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public calculateOrderBoxTag(imei: string, options?: any) {
        return InternalApiFp(this.configuration).calculateOrderBoxTag(imei, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Sets the system log level to the given value.
     * @param {string} logLevel logLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public changeLogLevel(logLevel: string, options?: any) {
        return InternalApiFp(this.configuration).changeLogLevel(logLevel, options)(this.fetch, this.basePath);
    }

    /**
     * Compares the Zoho price and XLS price for an invoice generated from the billing request. Returns whether the prices are the same, both prices, and the invoice if they differ.
     * @summary compare Zoho and XLS prices for invoice
     * @param {BillingRequest} BillingRequest BillingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public compareInvoicePrices(BillingRequest: BillingRequest, options?: any) {
        return InternalApiFp(this.configuration).compareInvoicePrices(BillingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Compute polyline + DRIVING/STANDING segments from a raw positions list (no DB fetch)
     * @param {ComputeSegmentsFromPositionsRequest} ComputeSegmentsFromPositionsRequest ComputeSegmentsFromPositionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public computeSegmentsFromPositions(ComputeSegmentsFromPositionsRequest: ComputeSegmentsFromPositionsRequest, options?: any) {
        return InternalApiFp(this.configuration).computeSegmentsFromPositions(ComputeSegmentsFromPositionsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all transport orders exported as excel file
     * @summary convert list of all transport orders to excel without any pagination rules
     * @param {TransportAllOrderToExcelConversionRequest} TransportAllOrderToExcelConversionRequest TransportAllOrderToExcelConversionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public convertAllTransportOrderListToExcel(TransportAllOrderToExcelConversionRequest: TransportAllOrderToExcelConversionRequest, options?: any) {
        return InternalApiFp(this.configuration).convertAllTransportOrderListToExcel(TransportAllOrderToExcelConversionRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of transport orders exported as excel file
     * @summary convert list of transport orders to excel
     * @param {TransportOrderToExcelConversionRequest} TransportOrderToExcelConversionRequest TransportOrderToExcelConversionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public convertTransportOrderListToExcel(TransportOrderToExcelConversionRequest: TransportOrderToExcelConversionRequest, options?: any) {
        return InternalApiFp(this.configuration).convertTransportOrderListToExcel(TransportOrderToExcelConversionRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will copy an existing transport order and create it in a fresh state for a target company.
     * @summary create multiple transport orders
     * @param {CopyAsNewTransportOrderRequest} CopyAsNewTransportOrderRequest CopyAsNewTransportOrderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public copyAsNewTransportOrder(CopyAsNewTransportOrderRequest: CopyAsNewTransportOrderRequest, options?: any) {
        return InternalApiFp(this.configuration).copyAsNewTransportOrder(CopyAsNewTransportOrderRequest, options)(this.fetch, this.basePath);
    }

    /**
     * create billing and responds with Zip-File
     * @summary create billing
     * @param {BillingRequest} BillingRequest BillingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createBilling(BillingRequest: BillingRequest, options?: any) {
        return InternalApiFp(this.configuration).createBilling(BillingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will create a new company with the given name and address. The user must be a super user to execute this operation. Newly created company will have the state UNDER_CONSTRUCTION and the responsibleLogeniosManager will be set to the email of the user who created the company. This operation will also create a new CompanyHistory entry with the change type CREATE and return the created company object.
     * @summary Create a new company
     * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createCompany(CompanyCreateRequest: CompanyCreateRequest, options?: any) {
        return InternalApiFp(this.configuration).createCompany(CompanyCreateRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create a new company
     * @param {CompanyCreateRequest} CompanyCreateRequest CompanyCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createCompanyOldToBeDeletedSoon(CompanyCreateRequest: CompanyCreateRequest, options?: any) {
        return InternalApiFp(this.configuration).createCompanyOldToBeDeletedSoon(CompanyCreateRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns dump data for a transport order.
     * @summary Get all needed test data for geo status tests (In Format V2)
     * @param {boolean} includeLinked includeLinked
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createDumpV2Endpoint(includeLinked: boolean, transportOrderId: string, options?: any) {
        return InternalApiFp(this.configuration).createDumpV2Endpoint(includeLinked, transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns dump data for a transport order.
     * @summary Get all needed test data for geo status tests (In Format V2)
     * @param {boolean} includeLinked includeLinked
     * @param {string} transportOrderId transportOrderId
     * @param {boolean} zipped zipped
     * @param {string} [excludeTransportOrderChangeTypes] excludeTransportOrderChangeTypes
     * @param {boolean} [includePositionEvents] includePositionEvents
     * @param {string} [includeTransportOrderChangeTypes] includeTransportOrderChangeTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createDumpV2FileEndpoint(includeLinked: boolean, transportOrderId: string, zipped: boolean, excludeTransportOrderChangeTypes?: string, includePositionEvents?: boolean, includeTransportOrderChangeTypes?: string, options?: any) {
        return InternalApiFp(this.configuration).createDumpV2FileEndpoint(includeLinked, transportOrderId, zipped, excludeTransportOrderChangeTypes, includePositionEvents, includeTransportOrderChangeTypes, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns dump data for transport orders in a specific version range.
     * @summary Get all needed test data for geo status tests (In Format V2) in a specific transport order version range
     * @param {GeoStatusDumpTransportOrderVersionRangeRequest} GeoStatusDumpTransportOrderVersionRangeRequest GeoStatusDumpTransportOrderVersionRangeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createDumpV2FilteredByVersionRangeEndpoint(GeoStatusDumpTransportOrderVersionRangeRequest: GeoStatusDumpTransportOrderVersionRangeRequest, options?: any) {
        return InternalApiFp(this.configuration).createDumpV2FilteredByVersionRangeEndpoint(GeoStatusDumpTransportOrderVersionRangeRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns dump data for a transport order.
     * @summary Get all needed test data for geo status tests (In Format V2)
     * @param {GeoStatusDumpTransportOrderListFilterRequest} GeoStatusDumpTransportOrderListFilterRequest GeoStatusDumpTransportOrderListFilterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createDumpV2FilteredEndpoint(GeoStatusDumpTransportOrderListFilterRequest: GeoStatusDumpTransportOrderListFilterRequest, options?: any) {
        return InternalApiFp(this.configuration).createDumpV2FilteredEndpoint(GeoStatusDumpTransportOrderListFilterRequest, options)(this.fetch, this.basePath);
    }

    /**
     * create invoices and store in DB
     * @summary create billing
     * @param {BillingRequest} BillingRequest BillingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createInvoicesAndSaveToDB(BillingRequest: BillingRequest, options?: any) {
        return InternalApiFp(this.configuration).createInvoicesAndSaveToDB(BillingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Update or insert a script error log in the AI tasks.
     * @summary updateOrInsertAiTaskToDB
     * @param {AIAgentTask} AIAgentTask AIAgentTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createOrModifyAiAgentTask(AIAgentTask: AIAgentTask, options?: any) {
        return InternalApiFp(this.configuration).createOrModifyAiAgentTask(AIAgentTask, options)(this.fetch, this.basePath);
    }

    /**
     * Creates a conversion job log or updates an existing entry
     * @summary Fetch conversion job logs
     * @param {ConversionJobLog} ConversionJobLog ConversionJobLog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createOrModifyConversionJobLog(ConversionJobLog: ConversionJobLog, options?: any) {
        return InternalApiFp(this.configuration).createOrModifyConversionJobLog(ConversionJobLog, options)(this.fetch, this.basePath);
    }

    /**
     * Update or insert a script Documentation in the Scripts Documentations Table.
     * @summary updateOrInsertScriptDocumentationToDB
     * @param {ScriptsDocumentationEntry} ScriptsDocumentationEntry ScriptsDocumentationEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createOrModifyScriptDocumentation(ScriptsDocumentationEntry: ScriptsDocumentationEntry, options?: any) {
        return InternalApiFp(this.configuration).createOrModifyScriptDocumentation(ScriptsDocumentationEntry, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will do the same as createOrModify, but without saving anything to the DB. 
     * @summary Test creation or modification of transport order
     * @param {CreateOrModifyTransportOrderDryRunRequest} CreateOrModifyTransportOrderDryRunRequest CreateOrModifyTransportOrderDryRunRequest
     * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
     * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
     * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
     * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createOrModifyTransportOrderDryRun(CreateOrModifyTransportOrderDryRunRequest: CreateOrModifyTransportOrderDryRunRequest, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
        return InternalApiFp(this.configuration).createOrModifyTransportOrderDryRun(CreateOrModifyTransportOrderDryRunRequest, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId
     * @summary create transport order
     * @param {string} companyId companyId
     * @param {TransportOrder} TransportOrder TransportOrder
     * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
     * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
     * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
     * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createOrModifyTransportOrderForCompany(companyId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
        return InternalApiFp(this.configuration).createOrModifyTransportOrderForCompany(companyId, TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(this.fetch, this.basePath);
    }

    /**
     * creates a rule for scheduled order creation.
     * @summary create rule for scheduled Order Creation
     * @param {ScheduledOrderCreationRule} ScheduledOrderCreationRule ScheduledOrderCreationRule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createOrUpdateScheduledOrderCreationRule(ScheduledOrderCreationRule: ScheduledOrderCreationRule, options?: any) {
        return InternalApiFp(this.configuration).createOrUpdateScheduledOrderCreationRule(ScheduledOrderCreationRule, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary create an ProjectWorkLogBookEntry
     * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createProjectWorkLogBookEntry(ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options?: any) {
        return InternalApiFp(this.configuration).createProjectWorkLogBookEntry(ProjectWorkLogBookEntry, options)(this.fetch, this.basePath);
    }

    /**
     * Returns scriptRunnerUser of given company.
     * @summary create new scriptRunnerUser for given company
     * @param {string} companyId companyId
     * @param {CreateScriptRunnerUserRequest} CreateScriptRunnerUserRequest CreateScriptRunnerUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createScriptRunnerUser(companyId: string, CreateScriptRunnerUserRequest: CreateScriptRunnerUserRequest, options?: any) {
        return InternalApiFp(this.configuration).createScriptRunnerUser(companyId, CreateScriptRunnerUserRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Create a new shipment Form Config. The permission COMPANY_MODIFY is required to execute this operation.
     * @summary Create new shipment Form Config
     * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createShipmentFormConfig(ShipmentFormConfigRequest: ShipmentFormConfigRequest, options?: any) {
        return InternalApiFp(this.configuration).createShipmentFormConfig(ShipmentFormConfigRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
     * @summary create transport order without authentication
     * @param {TransportOrderWithTokenPin} TransportOrderWithTokenPin TransportOrderWithTokenPin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createTransportOrderPublic(TransportOrderWithTokenPin: TransportOrderWithTokenPin, options?: any) {
        return InternalApiFp(this.configuration).createTransportOrderPublic(TransportOrderWithTokenPin, options)(this.fetch, this.basePath);
    }

    /**
     * Gibt alle deferred notifications für eine bestimmte orderId zurück.  
     * @summary deferredNotifications
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deferredNotifications(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).deferredNotifications(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes the draft with the given id.  
     * @summary deleteDraftOfConfig
     * @param {string} companyId companyId
     * @param {string} draftId draftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteDraftOfConfig(companyId: string, draftId: string, options?: any) {
        return InternalApiFp(this.configuration).deleteDraftOfConfig(companyId, draftId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary delete failed requests by ids
     * @param {string} failedRequestIds failedRequestIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteFailedRequest(failedRequestIds: string, options?: any) {
        return InternalApiFp(this.configuration).deleteFailedRequest(failedRequestIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary delete global geofences by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteGlobalGeofences(id: string, options?: any) {
        return InternalApiFp(this.configuration).deleteGlobalGeofences(id, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes the older drafts (of the calling user and for the his current company) until only 5 drafts remain.  
     * @summary deleteOldestAutoSavedDraftOfConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteOldestAutoSavedDraftOfConfig(options?: any) {
        return InternalApiFp(this.configuration).deleteOldestAutoSavedDraftOfConfig(options)(this.fetch, this.basePath);
    }

    /**
     * Deletes the ProjectWorkLogBookEntry with the given id.  
     * @summary Delete ProjectWorkLogBookEntry by id
     * @param {string} logBookEntryId logBookEntryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteProjectWorkLogBookEntryById(logBookEntryId: string, options?: any) {
        return InternalApiFp(this.configuration).deleteProjectWorkLogBookEntryById(logBookEntryId, options)(this.fetch, this.basePath);
    }

    /**
     * Removes the shipment form config with the specified config id.
     * @summary Delete shipment Form Config by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteShipmentFormConfigById(id: string, options?: any) {
        return InternalApiFp(this.configuration).deleteShipmentFormConfigById(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary deletes a TransportOrderConfigTest
     * @param {string} [testId] testId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteTransportOrderConfigTest(testId?: string, options?: any) {
        return InternalApiFp(this.configuration).deleteTransportOrderConfigTest(testId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a description of the link table that belongs to a transport order.
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public describeLinkedOrders(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).describeLinkedOrders(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Call this endpoint to get a description of the patchset. The description contains tabular data what was changed in a transport order
     * @summary Describe patchset
     * @param {DescribePatchsetRequest} DescribePatchsetRequest DescribePatchsetRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public describePatchset(DescribePatchsetRequest: DescribePatchsetRequest, options?: any) {
        return InternalApiFp(this.configuration).describePatchset(DescribePatchsetRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Edit an iteration's user input and remove subsequent iterations.
     * @summary editAiAgentTaskIteration
     * @param {EditIterationRequest} EditIterationRequest EditIterationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public editAiAgentTaskIteration(EditIterationRequest: EditIterationRequest, options?: any) {
        return InternalApiFp(this.configuration).editAiAgentTaskIteration(EditIterationRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary enroll for totp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public enrollTotp(options?: any) {
        return InternalApiFp(this.configuration).enrollTotp(options)(this.fetch, this.basePath);
    }

    /**
     * exclude Company From Unbilled TransportOrders Calculation
     * @summary exclude Company From Unbilled TransportOrders Calculation
     * @param {ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest} ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public excludeCompanyFromUnbilledTransportOrdersCalculation(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest: ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest, options?: any) {
        return InternalApiFp(this.configuration).excludeCompanyFromUnbilledTransportOrdersCalculation(ExcludeCompanyFromUnbilledTransportOrdersCalculationRequest, options)(this.fetch, this.basePath);
    }

    /**
     * sets the given converter config as specific config and returns the companyConfiguration 
     * @summary ExtractToSpecificConfig
     * @param {ExtractToSpecificConfigRequest} ExtractToSpecificConfigRequest ExtractToSpecificConfigRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public extractToSpecificConfig(ExtractToSpecificConfigRequest: ExtractToSpecificConfigRequest, options?: any) {
        return InternalApiFp(this.configuration).extractToSpecificConfig(ExtractToSpecificConfigRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch an AI agent task by script path and company ID
     * @summary getAIAgentTaskByPath
     * @param {string} companyId companyId
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAIAgentTaskByID(companyId: string, id: string, options?: any) {
        return InternalApiFp(this.configuration).fetchAIAgentTaskByID(companyId, id, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch AI agent tasks with optional filters
     * @summary getAIAgentTasks
     * @param {string} [companyId] companyId
     * @param {Date} [fromCreateDate] fromCreateDate
     * @param {string} [inputScriptPath] inputScriptPath
     * @param {'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED'} [status] status
     * @param {Date} [toCreateDate] toCreateDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAIAgentTasks(companyId?: string, fromCreateDate?: Date, inputScriptPath?: string, status?: 'RUNNING' | 'DONE' | 'USER_INPUT_REQUIRED' | 'ABORTED', toCreateDate?: Date, options?: any) {
        return InternalApiFp(this.configuration).fetchAIAgentTasks(companyId, fromCreateDate, inputScriptPath, status, toCreateDate, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back all drafts for this user and this companyId.  
     * @summary fetchAllConfigDrafts
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAllConfigDrafts(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchAllConfigDrafts(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get companies with Notification Configuartion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAllNotificationConfiguartions(options?: any) {
        return InternalApiFp(this.configuration).fetchAllNotificationConfiguartions(options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning all events for all queues of the specified queue type. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
     * @summary get Queued events for queue of type
     * @param {string} queueType queueType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAllQueuedEventsByQueueType(queueType: string, options?: any) {
        return InternalApiFp(this.configuration).fetchAllQueuedEventsByQueueType(queueType, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of company id and name and responsible manager of that company
     * @summary fetch list of all companies and their responsible managers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAllResponsibleManagers(options?: any) {
        return InternalApiFp(this.configuration).fetchAllResponsibleManagers(options)(this.fetch, this.basePath);
    }

    /**
     * Returns all SchedulerReportingConfigurations. Only accessible for superusers.
     * @summary Fetch all SchedulerReportingConfigurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAllSchedulerReportingConfigurations(options?: any) {
        return InternalApiFp(this.configuration).fetchAllSchedulerReportingConfigurations(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the state of the api gateway for the given company. If no state is present, initialize a new api gateway state
     * @summary get api gateway state
     * @param {string} companyId companyId
     * @param {string} configId configId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchApiGatewayState(companyId: string, configId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchApiGatewayState(companyId, configId, options)(this.fetch, this.basePath);
    }

    /**
     * Call this endpoint to get the Assigned device info for a transport order using the companyTag and the external order identifier
     * @summary Query Assigned Device info by external order ref
     * @param {AccessTransportOrderViaExternalAssignedDeviceUrlRequest} AccessTransportOrderViaExternalAssignedDeviceUrlRequest AccessTransportOrderViaExternalAssignedDeviceUrlRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAssignedDeviceInfoByExternalAccessUrl(AccessTransportOrderViaExternalAssignedDeviceUrlRequest: AccessTransportOrderViaExternalAssignedDeviceUrlRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchAssignedDeviceInfoByExternalAccessUrl(AccessTransportOrderViaExternalAssignedDeviceUrlRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches all devices associated to the user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAtlasDevices(options?: any) {
        return InternalApiFp(this.configuration).fetchAtlasDevices(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches all devices with the corresponding status and position for the user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAtlasPositions(options?: any) {
        return InternalApiFp(this.configuration).fetchAtlasPositions(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches the current atlas version.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchAtlasVersion(options?: any) {
        return InternalApiFp(this.configuration).fetchAtlasVersion(options)(this.fetch, this.basePath);
    }

    /**
     * Gives back the list of paths that should be opened as TextField in the CM-NavTree.
     * @summary fetchCmNavTreeTextModalList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCmNavTreeTextModalList(options?: any) {
        return InternalApiFp(this.configuration).fetchCmNavTreeTextModalList(options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of company ids of companies with the given responsible managers
     * @summary fetch list of all companies of the given responsible managers
     * @param {string} responsibleManagers responsibleManagers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompaniesOfResponsibleManagers(responsibleManagers: string, options?: any) {
        return InternalApiFp(this.configuration).fetchCompaniesOfResponsibleManagers(responsibleManagers, options)(this.fetch, this.basePath);
    }

    /**
     * return the existing address mapping found against the given transport order, transport and stop otherwise return null
     * @param {string} orderId orderId
     * @param {string} stopId stopId
     * @param {string} transportId transportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyAddressMappingByStop(orderId: string, stopId: string, transportId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyAddressMappingByStop(orderId, stopId, transportId, options)(this.fetch, this.basePath);
    }

    /**
     * return the existing address mappings found against the given transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyAddressMappingsForOrder(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyAddressMappingsForOrder(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches all configuration changes for ALL companies within a specified time period. Returns CompanyHistory entries along with their detailed CompanyConfigurationChange records. This endpoint is intended for reporting purposes and requires superuser permissions.  Parameters: - from: Start timestamp (ISO 8601 format, e.g., 2024-01-01T00:00:00Z) - to: End timestamp (ISO 8601 format, e.g., 2024-12-31T23:59:59Z)  Returns: - List of all companies with their configuration changes in the specified period - Grouped by company for easy report generation
     * @summary Fetches company configuration changes for all companies in a given time period
     * @param {string} [from] from
     * @param {string} [to] to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyConfigChanges(from?: string, to?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyConfigChanges(from, to, options)(this.fetch, this.basePath);
    }

    /**
     * For Superusers: Returns the company config of the companyId provided. For Non-Superusers with COMPANY_FULL_VIEW permission: Returns the company config of the company of the user. If the user gives a company Id, he gets a forbidden.
     * @summary get company config
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyConfiguration(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyConfiguration(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns changes of the company with the provided id.
     * @summary get company configuration changes of company
     * @param {string} companyId companyId
     * @param {string} [historyId] historyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyConfigurationChanges(companyId: string, historyId?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyConfigurationChanges(companyId, historyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns changes of the company with the provided id.
     * @summary get company configuration changes of company
     * @param {string} companyId companyId
     * @param {number} [limit] limit
     * @param {string} [path] path
     * @param {number} [skip] skip
     * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyConfigurationChangesForField(companyId: string, limit?: number, path?: string, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyConfigurationChangesForField(companyId, limit, path, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns history of the company with the provided id.
     * @summary get company configuration history of company
     * @param {string} companyId companyId
     * @param {string} [commentQuery] commentQuery
     * @param {number} [limit] limit
     * @param {number} [skip] skip
     * @param {'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {string} [specificHistoryId] specificHistoryId
     * @param {'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY'} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyConfigurationHistory(companyId: string, commentQuery?: string, limit?: number, skip?: number, sortBy?: 'TIMESTAMP' | 'CHANGED_BY' | 'COMMENT', sortDirection?: 'ASC' | 'DESC', specificHistoryId?: string, type?: 'ALL' | 'CONFIG_ONLY' | 'CONTRACT_ONLY', options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyConfigurationHistory(companyId, commentQuery, limit, skip, sortBy, sortDirection, specificHistoryId, type, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get company config
     * @param {string} companyId companyId
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyContracts(companyId: string, limit?: number, query?: string, skip?: number, sortBy?: 'BILLING_ACTIVE' | 'EXPORT_TO' | 'FIXED_BASE_PRICE' | 'GROUPING_TAG_SCRIPT' | 'IMPORT_FROM' | 'PRICE_ORDER' | 'VALID_FROM', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyContracts(companyId, limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches the company specific view configuration
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchCompanyViewConfiguration(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchCompanyViewConfiguration(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back all current conversion logs.
     * @summary Fetch conversion job logs for transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchConversionJobLogForOrder(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchConversionJobLogForOrder(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back all current conversion logs.
     * @summary Fetch conversion job logs
     * @param {string} companyId companyId
     * @param {number} [limit] limit
     * @param {string} [orderId] orderId
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchConversionJobLogs(companyId: string, limit?: number, orderId?: string, query?: string, skip?: number, sortBy?: 'CREATED' | 'INPUT_FILE_NAME' | 'RESULT' | 'ARCHIVED_FILE_NAME', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).fetchConversionJobLogs(companyId, limit, orderId, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the default company config.
     * @summary get default company config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchDefaultCompanyConfiguration(options?: any) {
        return InternalApiFp(this.configuration).fetchDefaultCompanyConfiguration(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the default contract.
     * @summary get default Contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchDefaultContract(options?: any) {
        return InternalApiFp(this.configuration).fetchDefaultContract(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the default edi configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchDefaultEdiConfiguration(options?: any) {
        return InternalApiFp(this.configuration).fetchDefaultEdiConfiguration(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the default lis configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchDefaultLisConfiguration(options?: any) {
        return InternalApiFp(this.configuration).fetchDefaultLisConfiguration(options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of freight at the given depot. The permission USE_DEPOT is required to access this endpoint.
     * @summary Get all freight in depot
     * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
     * @param {Date} [begin] begin
     * @param {boolean} [countDocuments] countDocuments
     * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
     * @param {Date} [end] end
     * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
     * @param {boolean} [hasAttachment] hasAttachment
     * @param {Date} [modifiedSince] modifiedSince
     * @param {Array<string>} [partnerIds] partnerIds
     * @param {string} [partnerNameRegex] partnerNameRegex
     * @param {string} [searchTerm] searchTerm
     * @param {number} [skip] skip
     * @param {string} [sortBy] sortBy
     * @param {string} [sortOrder] sortOrder
     * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
     * @param {number} [take] take
     * @param {string} [trailer] trailer
     * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
     * @param {string} [vehicle] vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchDepotFreight(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchDepotFreight(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back the draft with the given id.  
     * @summary fetchDraftOfConfig
     * @param {string} companyId companyId
     * @param {string} draftId draftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchDraftOfConfig(companyId: string, draftId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchDraftOfConfig(companyId, draftId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns an empty ProjectWorkLogBookEntry.
     * @summary get default and empty ProjectWorkLogBookEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEmptyProjectWorkLogBookEntry(options?: any) {
        return InternalApiFp(this.configuration).fetchEmptyProjectWorkLogBookEntry(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get current eta for the specified stop
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEtaAccuracyReportForCompany(transportOrderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchEtaAccuracyReportForCompany(transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning a defined BackendToEtaCalculatorEvent.
     * @summary get eta calculator events
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEtaCalculatorEvent(id: string, options?: any) {
        return InternalApiFp(this.configuration).fetchEtaCalculatorEvent(id, options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning take*etaCalculatorEvents.
     * @summary get eta calculator events
     * @param {string} [companyId] companyId
     * @param {string} [id] id
     * @param {number} [limit] limit
     * @param {boolean} [processed] processed
     * @param {number} [skip] skip
     * @param {'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {string} [transportOrderId] transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEtaCalculatorEvents(companyId?: string, id?: string, limit?: number, processed?: boolean, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchEtaCalculatorEvents(companyId, id, limit, processed, skip, sortBy, sortDirection, transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning take*etaCalculatorEvents.
     * @summary get eta calculator events
     * @param {string} company company
     * @param {number} take take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEtaCalculatorEventsForCompany(company: string, take: number, options?: any) {
        return InternalApiFp(this.configuration).fetchEtaCalculatorEventsForCompany(company, take, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns samples that can  be used to correct the eta value displayed to the user. Super user only endpoint.
     * @summary Get all calculation errors. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEtaCorrectionSamples(options?: any) {
        return InternalApiFp(this.configuration).fetchEtaCorrectionSamples(options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns the average eta calculation error for a given eta algo and a destination city and  arrival time. It removes samples from orders where the calculated ETA was not stable, e.g. because the truck was far too late and so the calculated eta values were always corrected upwards.   Values of averageCalculationErrorInMin below zero indicate that the truck was earlier at the location than the calculated eta.   If the parameter orderIdPrefix is given, the calculation is only applied for transport orders that start with the given prefix 
     * @summary Calculates the average error for a given city and planned arrival time
     * @param {EtaCorrectionSampleRequest} EtaCorrectionSampleRequest EtaCorrectionSampleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEtaCorrectionSamplesForCityAndTime(EtaCorrectionSampleRequest: EtaCorrectionSampleRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchEtaCorrectionSamplesForCityAndTime(EtaCorrectionSampleRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set.    
     * @summary responds aggregated data showing the quality / accuracy of the past ETAs with a given filter set
     * @param {EtaQualityReportRequest} EtaQualityReportRequest EtaQualityReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchEtaQualityReport(EtaQualityReportRequest: EtaQualityReportRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchEtaQualityReport(EtaQualityReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches failed messageLogs for a specific company.
     * @summary fetch failed messageLogs of a company
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchFailedMessageLogsOfSpecificCompany(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchFailedMessageLogsOfSpecificCompany(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches the failedRequests of requested company
     * @param {Date} [endTime] endTime
     * @param {number} [limit] limit
     * @param {string} [queryId] queryId
     * @param {string} [queryMethod] queryMethod
     * @param {string} [queryUrl] queryUrl
     * @param {string} [queryUserMail] queryUserMail
     * @param {string} [queryXRequestId] queryXRequestId
     * @param {number} [skip] skip
     * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {Date} [startTime] startTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchFailedRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any) {
        return InternalApiFp(this.configuration).fetchFailedRequests(endTime, limit, queryId, queryMethod, queryUrl, queryUserMail, queryXRequestId, skip, sortBy, sortDirection, startTime, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Check failed requests
     * @param {number} [minutesToCheck] minutesToCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchFailedRequestsMonitoring(minutesToCheck?: number, options?: any) {
        return InternalApiFp(this.configuration).fetchFailedRequestsMonitoring(minutesToCheck, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the following history of the provided history id. If it was the last, it returns the current config.
     * @summary get following company configuration history
     * @param {string} companyId companyId
     * @param {string} historyId historyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchFollowingCompanyConfigurationHistory(companyId: string, historyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchFollowingCompanyConfigurationHistory(companyId, historyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the following history of the provided history id. If it was the last, it returns the current contractVersion.
     * @summary get following company contract history
     * @param {string} companyId companyId
     * @param {string} contractId contractId
     * @param {string} historyId historyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchFollowingCompanyContractHistory(companyId: string, contractId: string, historyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchFollowingCompanyContractHistory(companyId, contractId, historyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the geoStatus configuration of user's company.
     * @summary Get geo status config of user's company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchGeoStatusConfig(options?: any) {
        return InternalApiFp(this.configuration).fetchGeoStatusConfig(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the geoStatus configuration of your company.
     * @summary Get geo status config by company id
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchGeoStatusConfigByCompanyId(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchGeoStatusConfigByCompanyId(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the geoStatus information for requested transport order.
     * @summary Get information object describing thresholds and settings of the geoStatus for requested transport order.
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchGeoStatusInformation(transportOrderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchGeoStatusInformation(transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * If no vehicle is selected it will return all test data for transport orders in mongo collection geoStatusTestData. To add transportOrders to geoStatusTestData use addTransportOrderToGeoStatusTestData(). If a vehicleId is given it returns the geoStatus test data for the selected vehicle and time span. Default is last 14 days.
     * @summary Get all needed test data for geo status tests
     * @param {string} [from] from
     * @param {string} [to] to
     * @param {string} [vehicleId] vehicleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchGeoStatusTestData(from?: string, to?: string, vehicleId?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchGeoStatusTestData(from, to, vehicleId, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns dump data for a transport order and adds it to the default geoStatusTestData set fetched by fetchGeoStatusTestData().
     * @summary Get all needed test data for geo status tests
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchGeoStatusTestDataForTransportOrder(transportOrderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchGeoStatusTestDataForTransportOrder(transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get global geofences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchGlobalGeofences(options?: any) {
        return InternalApiFp(this.configuration).fetchGlobalGeofences(options)(this.fetch, this.basePath);
    }

    /**
     * Fetches History objects. If a type is given, only the type specific histories will be returned. If an ID is given, only the entires with that object ID will be returned. If a query is given, only entries matching that full text search will be returned. It will not respond more entries than the limit, which default is 20. It will respond the total number of found entries.
     * @summary fetch history
     * @param {FetchHistoryRequest} FetchHistoryRequest FetchHistoryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchHistory(FetchHistoryRequest: FetchHistoryRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchHistory(FetchHistoryRequest, options)(this.fetch, this.basePath);
    }

    /**
     * fetching invoices from DB
     * @summary fetch invoices which where not uploaded to zoho
     * @param {FetchInvoicesRequest} FetchInvoicesRequest FetchInvoicesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchInvoices(FetchInvoicesRequest: FetchInvoicesRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchInvoices(FetchInvoicesRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the invoice data for all billed companies
     * @summary get billing data for all companies
     * @param {number} month month
     * @param {number} year year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchInvoicingData(month: number, year: number, options?: any) {
        return InternalApiFp(this.configuration).fetchInvoicingData(month, year, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches the last GPS position to a given vehicle id.
     * @param {string} vehicleId vehicleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchLastPositionForVehicleId(vehicleId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchLastPositionForVehicleId(vehicleId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation authenticates a user by mail address and returns the company mail gateway configuration
     * @summary Authenticate user by mail address and return 
     * @param {string} userEmailAddress userEmailAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchMailGatewayConfigurationByUserEmailAddress(userEmailAddress: string, options?: any) {
        return InternalApiFp(this.configuration).fetchMailGatewayConfigurationByUserEmailAddress(userEmailAddress, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the merged and sorted list of locations of this order
     * @param {string} orderId orderId
     * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchMergedStopList(orderId: string, includeDepotsFromLinkedOrders?: boolean, options?: any) {
        return InternalApiFp(this.configuration).fetchMergedStopList(orderId, includeDepotsFromLinkedOrders, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches MessageLog.
     * @summary fetch messageLog
     * @param {FetchMailLogRequest} FetchMailLogRequest FetchMailLogRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchMessageLog(FetchMailLogRequest: FetchMailLogRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchMessageLog(FetchMailLogRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches messageLogs of failed sendings.
     * @summary fetch messageLogs of failed sendings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchMessageLogReport(options?: any) {
        return InternalApiFp(this.configuration).fetchMessageLogReport(options)(this.fetch, this.basePath);
    }

    /**
     * Returns all available database migrations known to this backend version.
     * @summary get all available db migrations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchMigrations(options?: any) {
        return InternalApiFp(this.configuration).fetchMigrations(options)(this.fetch, this.basePath);
    }

    /**
     * Fetch Access Token of observer
     * @summary Fetch Access Token of Observer
     * @param {string} orderId orderId
     * @param {string} xObserverId xObserverId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchObserverAccessToken(orderId: string, xObserverId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchObserverAccessToken(orderId, xObserverId, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back all Partners with externalPartnerId and externalPartnerId of them from the given company.
     * @summary fetchPartnersWithConfigAndExportAndImport
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchPartnersWithConfigAndExportAndImport(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchPartnersWithConfigAndExportAndImport(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning all events for all queues of the specified queue type of the company of the current user of the users company. Only usable for uses with permisison EVENTS. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
     * @summary get Queued events for queue of type and own company
     * @param {string} queueType queueType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchQueuedEventsByQueueType(queueType: string, options?: any) {
        return InternalApiFp(this.configuration).fetchQueuedEventsByQueueType(queueType, options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning all events for all queues of the specified queue type and given company. Only usable for elevated users. Please use [fetchAllQueuedEvents](https://app.logenios.com/apidocs/index.html?url=swagger.json#/Events/fetchAllQueuedEvents) instead.
     * @summary get Queued events for queue of type with given company id
     * @param {string} companyId companyId
     * @param {string} queueType queueType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchQueuedEventsByQueueTypeAndCompanyId(companyId: string, queueType: string, options?: any) {
        return InternalApiFp(this.configuration).fetchQueuedEventsByQueueTypeAndCompanyId(companyId, queueType, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns events according to the given parameters.
     * @summary get all queued events
     * @param {'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER'} [changeTypeFilter] changeTypeFilter
     * @param {string} [companyId] companyId
     * @param {Date} [createdAtFromFilter] createdAtFromFilter
     * @param {Date} [createdAtToFilter] createdAtToFilter
     * @param {'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT'} [eventTypeFilter] eventTypeFilter
     * @param {boolean} [hasExportedFiles] hasExportedFiles
     * @param {number} [limit] limit
     * @param {boolean} [processedFilter] processedFilter
     * @param {'OK' | 'WARN' | 'ERROR' | 'RETRY'} [processingStateFilter] processingStateFilter
     * @param {'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER'} [queueTypeFilter] queueTypeFilter
     * @param {string} [queuedEventId] queuedEventId
     * @param {number} [skip] skip
     * @param {'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {string} [transportOrderId] transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchQueuedEventsForCM(changeTypeFilter?: 'CREATE' | 'UPDATE' | 'STORNO' | 'ATTACHMENT_ADD' | 'ATTACHMENT_DELETE' | 'ATTACHMENT_MODIFY' | 'ASSIGN_COMPANY' | 'ASSIGN_VEHICLE' | 'ASSIGN_DEVICE' | 'ASSIGN_TRAILER' | 'ASSIGN_ORDERBOX' | 'STATUS_UPDATE_TRANSPORT_ORDER' | 'STATUS_UPDATE_STOP_LOCATION' | 'STATUS_UPDATE_STOP_ACTION' | 'STATUS_UPDATE_FREIGHT' | 'STATUS_UPDATE_ATTACHMENT' | 'LINK_EVENT' | 'STATUS_UPDATE_OBSERVER', companyId?: string, createdAtFromFilter?: Date, createdAtToFilter?: Date, eventTypeFilter?: 'TRANSPORT_ORDER_EVENT' | 'POSITION_EVENT' | 'ETA_EVENT' | 'COMPANY_EVENT' | 'SYSTEM_NOTIFICATION' | 'TEXT_MESSAGE_EVENT', hasExportedFiles?: boolean, limit?: number, processedFilter?: boolean, processingStateFilter?: 'OK' | 'WARN' | 'ERROR' | 'RETRY', queueTypeFilter?: 'FTP_SYNC' | 'API_GATEWAY_SYNC' | 'API_SYNC' | 'NOTIFICATIONS' | 'ETA_CALCULATOR' | 'SCRIPT_RUNNER', queuedEventId?: string, skip?: number, sortBy?: 'ID' | 'QUEUE_ID' | 'QUEUE_TYPE' | 'EVENT_TYPE' | 'TIMESTAMP' | 'RATE_LIMITED' | 'SUPPRESSED' | 'PROCESSED' | 'PROCESSING_STATE', sortDirection?: 'ASC' | 'DESC', transportOrderId?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchQueuedEventsForCM(changeTypeFilter, companyId, createdAtFromFilter, createdAtToFilter, eventTypeFilter, hasExportedFiles, limit, processedFilter, processingStateFilter, queueTypeFilter, queuedEventId, skip, sortBy, sortDirection, transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning all queues of the specified queue type. It returns all queues for all companies Only usable for uses with permisison SUPERUSER. 
     * @summary get all queues of all companiew of the specified type
     * @param {string} queueType queueType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchQueuesByQueueType(queueType: string, options?: any) {
        return InternalApiFp(this.configuration).fetchQueuesByQueueType(queueType, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches the rawRequests of requested company
     * @param {Date} [endTime] endTime
     * @param {number} [limit] limit
     * @param {string} [queryId] queryId
     * @param {string} [queryMethod] queryMethod
     * @param {string} [queryUrl] queryUrl
     * @param {string} [queryUserMail] queryUserMail
     * @param {string} [queryXRequestId] queryXRequestId
     * @param {number} [skip] skip
     * @param {'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {Date} [startTime] startTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchRawRequests(endTime?: Date, limit?: number, queryId?: string, queryMethod?: string, queryUrl?: string, queryUserMail?: string, queryXRequestId?: string, skip?: number, sortBy?: 'ID' | 'TIMESTAMP' | 'USER_MAIL' | 'ENDPOINT' | 'X_REQUEST_ID', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any) {
        return InternalApiFp(this.configuration).fetchRawRequests(endTime, limit, queryId, queryMethod, queryUrl, queryUserMail, queryXRequestId, skip, sortBy, sortDirection, startTime, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the Release Notes from the Gitlab Wiki for the CM, since it should authenticate via backend.
     * @summary fetch ReleaseNotes From Gitlab Wiki
     * @param {string} stage stage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchReleaseNotesFromGitlabWiki(stage: string, options?: any) {
        return InternalApiFp(this.configuration).fetchReleaseNotesFromGitlabWiki(stage, options)(this.fetch, this.basePath);
    }

    /**
     * Returns report generation statistics for super users. Shows which companies use reports, how often they are generated, and whether they are sent by email.
     * @summary Fetches report generation statistics
     * @param {string} [companyId] companyId
     * @param {Date} [endTime] endTime
     * @param {'MANUAL' | 'AUTO'} [generationType] generationType
     * @param {number} [limit] limit
     * @param {string} [reportName] reportName
     * @param {string} [sinceId] sinceId
     * @param {number} [skip] skip
     * @param {'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {Date} [startTime] startTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchReportGenerationStats(companyId?: string, endTime?: Date, generationType?: 'MANUAL' | 'AUTO', limit?: number, reportName?: string, sinceId?: string, skip?: number, sortBy?: 'GENERATION_TIME' | 'REPORT_NAME' | 'COMPANY_NAME', sortDirection?: 'ASC' | 'DESC', startTime?: Date, options?: any) {
        return InternalApiFp(this.configuration).fetchReportGenerationStats(companyId, endTime, generationType, limit, reportName, sinceId, skip, sortBy, sortDirection, startTime, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches ScheduledOrderCreationRule.
     * @summary fetch scheduled Order Creation rules
     * @param {FetchScheduledOrderCreationRulesRequest} FetchScheduledOrderCreationRulesRequest FetchScheduledOrderCreationRulesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchScheduledOrderCreationRules(FetchScheduledOrderCreationRulesRequest: FetchScheduledOrderCreationRulesRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchScheduledOrderCreationRules(FetchScheduledOrderCreationRulesRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning the SchedulerConfigs.
     * @summary get scheduler configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchSchedulerConfigs(options?: any) {
        return InternalApiFp(this.configuration).fetchSchedulerConfigs(options)(this.fetch, this.basePath);
    }

    /**
     * This is an internal endpoint returning the SchedulerTasks.
     * @summary get scheduler tasks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchSchedulerTasks(options?: any) {
        return InternalApiFp(this.configuration).fetchSchedulerTasks(options)(this.fetch, this.basePath);
    }

    /**
     * fetch Script Documentation By Documentation Type
     * @summary fetchScriptDocumentationByDocumentationType
     * @param {'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION'} [documentationType] documentationType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchScriptDocumentationByDocumentationType(documentationType?: 'GET_LIS_DOCUMENTATION' | 'GET_TRANSLOGICA_DOCUMENTATION' | 'GET_LOGENIOS_ENVIRONMENT_DOCUMENTATION' | 'GET_AIENV_DOCUMENTATION' | 'GET_TRANSDATA_DOCUMENTATION' | 'GET_SOLOPLAN_DOCUMENTATION' | 'GET_EDI_DOCUMENTATION', options?: any) {
        return InternalApiFp(this.configuration).fetchScriptDocumentationByDocumentationType(documentationType, options)(this.fetch, this.basePath);
    }

    /**
     * Returns scriptRunnerUser of given company.
     * @summary get scriptRunnerUser of given company
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchScriptRunnerUser(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchScriptRunnerUser(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch Scripts Documentations
     * @summary FetchScriptsDocumentations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchScriptsDocumentations(options?: any) {
        return InternalApiFp(this.configuration).fetchScriptsDocumentations(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the shipment Form Config of the specified id. The permission COMPANY_MODIFY is required to execute this operation
     * @summary Get shipment Form Config by id
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchShipmentFormConfigById(id: string, options?: any) {
        return InternalApiFp(this.configuration).fetchShipmentFormConfigById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the shipment Form Config of the specified access token without authentication.
     * @summary Get shipment Form Config by access token
     * @param {string} token token
     * @param {string} [pin] pin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchShipmentFormConfigByToken(token: string, pin?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchShipmentFormConfigByToken(token, pin, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all configurations for the transport Order creation form for the specified company.
     * @summary Get List of configurations for the transport Order creation form
     * @param {number} [limit] limit
     * @param {string} [q] q
     * @param {number} [skip] skip
     * @param {'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchShipmentFormConfigList(limit?: number, q?: string, skip?: number, sortBy?: 'ID' | 'COMPANY_ID' | 'COMPANY_NAME' | 'VERBOSE' | 'LOADING_LOCATION' | 'UNLOADING_LOCATION' | 'SHIPPER' | 'VALID_UNTIL' | 'PIN' | 'ACCESS_TOKEN' | 'EMAIL_TO' | 'OBSERVERS' | 'USERS', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).fetchShipmentFormConfigList(limit, q, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Call this endpoint to fetch message logs based on message type and list of transport order ids.
     * @summary Returns message logs with specific message type only based on list of transport order ids in request and message type
     * @param {FetchSpecificMessageLogsForTransportOrdersRequest} FetchSpecificMessageLogsForTransportOrdersRequest FetchSpecificMessageLogsForTransportOrdersRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchSpecificMessageLogsForTransportOrders(FetchSpecificMessageLogsForTransportOrdersRequest: FetchSpecificMessageLogsForTransportOrdersRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchSpecificMessageLogsForTransportOrders(FetchSpecificMessageLogsForTransportOrdersRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns message logs with specific message type only that where send and reference the given transport order
     * @param {'REMINDER' | 'INFO' | 'WARNING'} messageType messageType
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchSpecificTypeMessageLogsForSingleTransportOrder(messageType: 'REMINDER' | 'INFO' | 'WARNING', orderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchSpecificTypeMessageLogsForSingleTransportOrder(messageType, orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all needed StandingTimesUi data as simple as possible for the requested time period
     * @summary get data for standingTimesUi
     * @param {Date} endTime endTime
     * @param {Date} startTime startTime
     * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchStandingTimesUiData(endTime: Date, startTime: Date, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options?: any) {
        return InternalApiFp(this.configuration).fetchStandingTimesUiData(endTime, startTime, dateTimeField, term, options)(this.fetch, this.basePath);
    }

    /**
     * Standing times per stop as XLSX.
     * @summary fetchStandingTimesXlsx
     * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchStandingTimesXlsx(TourCostReportRequest: TourCostReportRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchStandingTimesXlsx(TourCostReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back all current active SystemStatusMessages.
     * @summary Fetch SystemStatusMessages
     * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
     * @param {number} [limit] limit
     * @param {boolean} [onlyActive] onlyActive
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchSystemStatusMessages(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).fetchSystemStatusMessages(level, limit, onlyActive, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all currently active SystemStatusMessages with combined affectedTransportOrders.
     * @summary Fetch SystemStatusMessages with combined affectedTransportOrders
     * @param {'A_INFO' | 'B_WARNING' | 'C_ERROR'} [level] level
     * @param {number} [limit] limit
     * @param {boolean} [onlyActive] onlyActive
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchSystemStatusMessagesCombined(level?: 'A_INFO' | 'B_WARNING' | 'C_ERROR', limit?: number, onlyActive?: boolean, query?: string, skip?: number, sortBy?: 'ID' | 'FOR_CUSTOMERS_TO_SEE' | 'START_TIME' | 'END_TIME' | 'TITLE' | 'CREATED_AT' | 'CREATED_BY' | 'LEVEL' | 'MESSAGE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).fetchSystemStatusMessagesCombined(level, limit, onlyActive, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * ...
     * @summary fetchTourCostReport
     * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTourCostReport(TourCostReportRequest: TourCostReportRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchTourCostReport(TourCostReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Tour cost report as XLSX. Durations are real Excel time cells.
     * @summary fetchTourCostReportXlsx
     * @param {TourCostReportRequest} TourCostReportRequest TourCostReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTourCostReportXlsx(TourCostReportRequest: TourCostReportRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchTourCostReportXlsx(TourCostReportRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will fetch a new Transport-Order by the externalTransportOrderId and the companyId (sourceCompanyId)
     * @summary get transport order by companyId and external transportOrderId
     * @param {string} companyId companyId
     * @param {string} externalTransportOrderId externalTransportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTransportOrderByExternalTransportOrderIdAndCompany(companyId: string, externalTransportOrderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchTransportOrderByExternalTransportOrderIdAndCompany(companyId, externalTransportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return the Transport-Order referenced by the Transport-Order id.
     * @summary get transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTransportOrderByIdSourceAndTargetView(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchTransportOrderByIdSourceAndTargetView(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will fetch a new Transport-Order by the telematicTransportOrderId and the targetCompanyId
     * @summary get transport order by companyId and GetTransportOrderByTelematicTransportOrderId
     * @param {string} targetCompanyId targetCompanyId
     * @param {string} telematicTransportOrderId telematicTransportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId(targetCompanyId: string, telematicTransportOrderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchTransportOrderByTelematicTransportOrderIdAndTargetCompanyId(targetCompanyId, telematicTransportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the converter Info of this transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTransportOrderConverterInfo(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchTransportOrderConverterInfo(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns all messages that where send and reference the given transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTransportOrderMessageLog(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchTransportOrderMessageLog(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of partners used in the last transport orders
     * @summary extract partners from transport orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchTransportOrderPartnerList(options?: any) {
        return InternalApiFp(this.configuration).fetchTransportOrderPartnerList(options)(this.fetch, this.basePath);
    }

    /**
     * fetch unbilled projectWorkLogBook entries
     * @summary fetch unbilled projectWorkLogBook entries
     * @param {BillingRequest} BillingRequest BillingRequest
     * @param {number} [limit] limit
     * @param {number} [skip] skip
     * @param {'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchUnbilled(BillingRequest: BillingRequest, limit?: number, skip?: number, sortBy?: 'CREATED_DATE' | 'COMPANY_NAME' | 'SHORT_DESCRIPTION' | 'TIME_SPEND_ON_TASK' | 'BILLING_COST', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).fetchUnbilled(BillingRequest, limit, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches the user for the given company
     * @param {string} companyId companyId
     * @param {string} externalUserId externalUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchUserBy(companyId: string, externalUserId: string, options?: any) {
        return InternalApiFp(this.configuration).fetchUserBy(companyId, externalUserId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all users matching a given searchterm. The superuser permission to show all users or companyAdmin to show company users is required to execute this operation.
     * @summary List all users
     * @param {string} term term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchUsers(term: string, options?: any) {
        return InternalApiFp(this.configuration).fetchUsers(term, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of users specified in the query string. The supplied argument must be a comma separated list of user ids
     * @summary List all users specified in the parameter list
     * @param {string} userIds userIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchUsersByIdList(userIds: string, options?: any) {
        return InternalApiFp(this.configuration).fetchUsersByIdList(userIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetch vehicles residence times in a area defined by position and radius. Default for last 14 days.
     * @param {VehicleGeoFilterRequest} VehicleGeoFilterRequest VehicleGeoFilterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fetchVehicleResidenceTimesInArea(VehicleGeoFilterRequest: VehicleGeoFilterRequest, options?: any) {
        return InternalApiFp(this.configuration).fetchVehicleResidenceTimesInArea(VehicleGeoFilterRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
     * @param {FixTransportOrderTimesRequest} FixTransportOrderTimesRequest FixTransportOrderTimesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fixTransportOrder(FixTransportOrderTimesRequest: FixTransportOrderTimesRequest, options?: any) {
        return InternalApiFp(this.configuration).fixTransportOrder(FixTransportOrderTimesRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fix arrival and departure times for transport order. The algorithm will start from given location id backwards.
     * @param {string} transportOrderId transportOrderId
     * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
     * @param {number} [mergeAndOrderKeyToStartFrom] mergeAndOrderKeyToStartFrom
     * @param {number} [offsetAfterInMinutes] offsetAfterInMinutes
     * @param {number} [offsetBeforeInMinutes] offsetBeforeInMinutes
     * @param {boolean} [partialFixAllowed] partialFixAllowed
     * @param {boolean} [replaceOriginalTransportOrder] replaceOriginalTransportOrder
     * @param {boolean} [reverse] reverse
     * @param {boolean} [shouldCreateHistoryEntry] shouldCreateHistoryEntry
     * @param {string} [stopIdToStartFrom] stopIdToStartFrom
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public fixTransportOrderTimes(transportOrderId: string, fixStopsOfLinkedTransports?: boolean, mergeAndOrderKeyToStartFrom?: number, offsetAfterInMinutes?: number, offsetBeforeInMinutes?: number, partialFixAllowed?: boolean, replaceOriginalTransportOrder?: boolean, reverse?: boolean, shouldCreateHistoryEntry?: boolean, stopIdToStartFrom?: string, options?: any) {
        return InternalApiFp(this.configuration).fixTransportOrderTimes(transportOrderId, fixStopsOfLinkedTransports, mergeAndOrderKeyToStartFrom, offsetAfterInMinutes, offsetBeforeInMinutes, partialFixAllowed, replaceOriginalTransportOrder, reverse, shouldCreateHistoryEntry, stopIdToStartFrom, options)(this.fetch, this.basePath);
    }

    /**
     * Force the reapplication of the current customerAddressMapping for the transportOrder. This operation is useful to reapply changed customer address mappings
     * @param {boolean} justSimulate justSimulate
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public forceApplyCustomerAddressMapping(justSimulate: boolean, orderId: string, options?: any) {
        return InternalApiFp(this.configuration).forceApplyCustomerAddressMapping(justSimulate, orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Parses the given JSON String into an CompanyConfiguration object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
     * @summary update current company
     * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public formatConfig(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
        return InternalApiFp(this.configuration).formatConfig(UpdateCompanyConfigRequestWrapper, options)(this.fetch, this.basePath);
    }

    /**
     * Parses the given JSON String into an Contract object in order to format it. This allows the user of the ConfigManager to see what the parsed object will look like.
     * @summary update current company
     * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public formatContract(UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
        return InternalApiFp(this.configuration).formatContract(UpdateCompanyConfigRequestWrapper, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
     * @summary Get report of completed orders of company partners
     * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
     * @param {Date} [begin] begin
     * @param {boolean} [countDocuments] countDocuments
     * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
     * @param {Date} [end] end
     * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
     * @param {boolean} [hasAttachment] hasAttachment
     * @param {Date} [modifiedSince] modifiedSince
     * @param {Array<string>} [partnerIds] partnerIds
     * @param {string} [partnerNameRegex] partnerNameRegex
     * @param {string} [searchTerm] searchTerm
     * @param {number} [skip] skip
     * @param {string} [sortBy] sortBy
     * @param {string} [sortOrder] sortOrder
     * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
     * @param {number} [take] take
     * @param {string} [trailer] trailer
     * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
     * @param {string} [vehicle] vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateCompletionReport(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
        return InternalApiFp(this.configuration).generateCompletionReport(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a xlsx of partners and the amount of fulfilled orders. The permission USE_DEPOT is required to access this endpoint.
     * @summary Get report of completed orders of company partners
     * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
     * @param {Date} [begin] begin
     * @param {boolean} [countDocuments] countDocuments
     * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
     * @param {Date} [end] end
     * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
     * @param {boolean} [hasAttachment] hasAttachment
     * @param {Date} [modifiedSince] modifiedSince
     * @param {Array<string>} [partnerIds] partnerIds
     * @param {string} [partnerNameRegex] partnerNameRegex
     * @param {string} [searchTerm] searchTerm
     * @param {number} [skip] skip
     * @param {string} [sortBy] sortBy
     * @param {string} [sortOrder] sortOrder
     * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
     * @param {number} [take] take
     * @param {string} [trailer] trailer
     * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
     * @param {string} [vehicle] vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateCompletionReportAsXlsx(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
        return InternalApiFp(this.configuration).generateCompletionReportAsXlsx(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(this.fetch, this.basePath);
    }

    /**
     * returns the Elflein Error report
     * @summary returns the Elflein Error report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateElfleinVdlNetcarErrorReport(options?: any) {
        return InternalApiFp(this.configuration).generateElfleinVdlNetcarErrorReport(options)(this.fetch, this.basePath);
    }

    /**
     * returns the Elflein report
     * @summary returns the Elflein report
     * @param {boolean} compressed compressed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateElfleinVdlNetcarReport(compressed: boolean, options?: any) {
        return InternalApiFp(this.configuration).generateElfleinVdlNetcarReport(compressed, options)(this.fetch, this.basePath);
    }

    /**
     * Executes a generic status report
     * @summary returns the generic status report
     * @param {string} statusReportName statusReportName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateGenericStatusReport(statusReportName: string, options?: any) {
        return InternalApiFp(this.configuration).generateGenericStatusReport(statusReportName, options)(this.fetch, this.basePath);
    }

    /**
     * Executes a generic status report for all transport orders matching the filter asynchronously. Returns a job status URL that can be polled to check the report generation progress.
     * @summary generates a generic status report for all filtered transport orders asynchronously
     * @param {string} statusReportName statusReportName
     * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateGenericStatusReportAsync(statusReportName: string, FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any) {
        return InternalApiFp(this.configuration).generateGenericStatusReportAsync(statusReportName, FetchTransportOrderListFilterRequest, options)(this.fetch, this.basePath);
    }

    /**
     * returns the GeoStatus Debug report
     * @summary returns the Debug report for the geo status system
     * @param {number} [fromDay] fromDay
     * @param {number} [fromMonth] fromMonth
     * @param {number} [fromYear] fromYear
     * @param {number} [toDay] toDay
     * @param {number} [toMonth] toMonth
     * @param {number} [toYear] toYear
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateGeoStatusDebugReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options?: any) {
        return InternalApiFp(this.configuration).generateGeoStatusDebugReport(fromDay, fromMonth, fromYear, toDay, toMonth, toYear, options)(this.fetch, this.basePath);
    }

    /**
     * Return CSV Report in the format  id;externalTransportOrderId;KM_START;KM_END;KM_LEER;
     * @summary returns the Paneuropa Mileage report
     * @param {Date} [modifiedSince] modifiedSince
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generatePaneuropaMileageReport(modifiedSince?: Date, options?: any) {
        return InternalApiFp(this.configuration).generatePaneuropaMileageReport(modifiedSince, options)(this.fetch, this.basePath);
    }

    /**
     * returns the validation report
     * @summary returns the validation report
     * @param {number} [fromDay] fromDay
     * @param {number} [fromMonth] fromMonth
     * @param {number} [fromYear] fromYear
     * @param {number} [toDay] toDay
     * @param {number} [toMonth] toMonth
     * @param {number} [toYear] toYear
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateValidationReport(fromDay?: number, fromMonth?: number, fromYear?: number, toDay?: number, toMonth?: number, toYear?: number, options?: any) {
        return InternalApiFp(this.configuration).generateValidationReport(fromDay, fromMonth, fromYear, toDay, toMonth, toYear, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch AI parse result by ID
     * @summary getAiParseResultById
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getAiParseResultById(id: string, options?: any) {
        return InternalApiFp(this.configuration).getAiParseResultById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch AI parse results with optional filters
     * @summary getAiParseResults
     * @param {FetchAiParseResultsRequest} FetchAiParseResultsRequest FetchAiParseResultsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getAiParseResults(FetchAiParseResultsRequest: FetchAiParseResultsRequest, options?: any) {
        return InternalApiFp(this.configuration).getAiParseResults(FetchAiParseResultsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * getting all companies and all billed orders
     * @summary getting all companies and all billed orders
     * @param {number} month month
     * @param {number} year year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getAllCompaniesAndBilledOrders(month: number, year: number, options?: any) {
        return InternalApiFp(this.configuration).getAllCompaniesAndBilledOrders(month, year, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches all configurations that changed after the given timestamp, default is 1 day
     * @param {string} [since] since
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getAllConfigurations(since?: string, options?: any) {
        return InternalApiFp(this.configuration).getAllConfigurations(since, options)(this.fetch, this.basePath);
    }

    /**
     * getting all unbilled orders for company
     * @summary getting all unbilled orders for company
     * @param {GetAllUnbilledOrdersForCompanyRequest} GetAllUnbilledOrdersForCompanyRequest GetAllUnbilledOrdersForCompanyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getAllUnbilledOrdersForCompany(GetAllUnbilledOrdersForCompanyRequest: GetAllUnbilledOrdersForCompanyRequest, options?: any) {
        return InternalApiFp(this.configuration).getAllUnbilledOrdersForCompany(GetAllUnbilledOrdersForCompanyRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get companies with api-gateway config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getApiGatewayConfigs(options?: any) {
        return InternalApiFp(this.configuration).getApiGatewayConfigs(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get alive of backend
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getBackendAlive(options?: any) {
        return InternalApiFp(this.configuration).getBackendAlive(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get health of backend components
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getBackendHealth(options?: any) {
        return InternalApiFp(this.configuration).getBackendHealth(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get performance of GET+POST
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getBackendPerformance(options?: any) {
        return InternalApiFp(this.configuration).getBackendPerformance(options)(this.fetch, this.basePath);
    }

    /**
     * list all Companies excluded from Unbilled TransportOrders Calculation
     * @summary list all Companies excluded from Unbilled TransportOrders Calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getCompaniesExcludedFromUnbilledTransportOrdersCalculation(options?: any) {
        return InternalApiFp(this.configuration).getCompaniesExcludedFromUnbilledTransportOrdersCalculation(options)(this.fetch, this.basePath);
    }

    /**
     * get companyIds from companies which should be billed
     * @summary create billing
     * @param {BillingRequest} BillingRequest BillingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getCompaniesToInvoice(BillingRequest: BillingRequest, options?: any) {
        return InternalApiFp(this.configuration).getCompaniesToInvoice(BillingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches all companyNames & tags for the given companyIds
     * @param {string} companyIds companyIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getCompanyNames(companyIds: string, options?: any) {
        return InternalApiFp(this.configuration).getCompanyNames(companyIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get the short info of all companies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getCompanyShortInfo(options?: any) {
        return InternalApiFp(this.configuration).getCompanyShortInfo(options)(this.fetch, this.basePath);
    }

    /**
     * Return a list of all ConfigFieldDescriptions.
     * @summary getConfigFieldDescriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getConfigFieldDescriptions(options?: any) {
        return InternalApiFp(this.configuration).getConfigFieldDescriptions(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get company configuration for customer
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getConfiguration(companyId: string, options?: any) {
        return InternalApiFp(this.configuration).getConfiguration(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get last 24 hours polyline for driver
     * @param {string} driverId driverId
     * @param {boolean} [resolveAddresses] resolveAddresses
     * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getDriverPolyline(driverId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
        return InternalApiFp(this.configuration).getDriverPolyline(driverId, resolveAddresses, segmentByEstimatedStates, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get companies with eta calculator config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getEtaCalculatorConfigs(options?: any) {
        return InternalApiFp(this.configuration).getEtaCalculatorConfigs(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
     * @param {EtaTestEventRequest} EtaTestEventRequest EtaTestEventRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getEtaTestEvent(EtaTestEventRequest: EtaTestEventRequest, options?: any) {
        return InternalApiFp(this.configuration).getEtaTestEvent(EtaTestEventRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a report containing the time at a location for a given time range based on the actual vehicle positions
     * @summary returns the time spent at the specified location report based on GPS data
     * @param {string} companyAddressMappingId companyAddressMappingId
     * @param {number} month month
     * @param {number} year year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getGeoTimeAtLocationReport(companyAddressMappingId: string, month: number, year: number, options?: any) {
        return InternalApiFp(this.configuration).getGeoTimeAtLocationReport(companyAddressMappingId, month, year, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a gerolsteiner XML report for the given month
     * @summary returns gerolsteiner xml report
     * @param {boolean} dumpXml dumpXml
     * @param {number} month month
     * @param {number} year year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getGerolsteinerXmlReport(dumpXml: boolean, month: number, year: number, options?: any) {
        return InternalApiFp(this.configuration).getGerolsteinerXmlReport(dumpXml, month, year, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get long running queries from mongo db from the last x seconds.
     * @param {number} [minusSeconds] minusSeconds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getLongRunningQueries(minusSeconds?: number, options?: any) {
        return InternalApiFp(this.configuration).getLongRunningQueries(minusSeconds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get the company monitor configurations for customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMonitorConfigurations(options?: any) {
        return InternalApiFp(this.configuration).getMonitorConfigurations(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get company notification configuration for customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getNotificationConfiguration(options?: any) {
        return InternalApiFp(this.configuration).getNotificationConfiguration(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a temporary test PositionEvent of the given type, for the given TransportOrder and the config of the given company
     * @param {PositionTestEventRequest} PositionTestEventRequest PositionTestEventRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getPositionTestEvent(PositionTestEventRequest: PositionTestEventRequest, options?: any) {
        return InternalApiFp(this.configuration).getPositionTestEvent(PositionTestEventRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the ProjectWorkLogBookEntries.
     * @summary Gets ProjectWorkLogBookEntries from Company.
     * @param {boolean} [alreadyBilled] alreadyBilled
     * @param {Array<string>} [companyIds] companyIds
     * @param {number} [limit] limit
     * @param {number} [skip] skip
     * @param {'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getProjectWorkLogBookEntries(alreadyBilled?: boolean, companyIds?: Array<string>, limit?: number, skip?: number, sortBy?: 'ALREADY_BILLED' | 'CREATED_DATE' | 'SHORT_DESCRIPTION' | 'TIME_SPENT_ON_TASK' | 'BILLING_COST' | 'USER_NAME' | 'BILLING_MODE', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).getProjectWorkLogBookEntries(alreadyBilled, companyIds, limit, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get the state of the scheduler reporting task.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getSchedulerReportingTaskState(options?: any) {
        return InternalApiFp(this.configuration).getSchedulerReportingTaskState(options)(this.fetch, this.basePath);
    }

    /**
     * sets the given converter config as specific config and returns the companyConfiguration 
     * @summary scriptErrorLogger
     * @param {'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE'} sortBy sortBy
     * @param {'ASC' | 'DESC'} sortDirection sortDirection
     * @param {string} [companyId] companyId
     * @param {Date} [fromCreatedDate] fromCreatedDate
     * @param {number} [limit] limit
     * @param {string} [scriptPath] scriptPath
     * @param {number} [skip] skip
     * @param {Date} [toCreatedDate] toCreatedDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getScriptErrorLogs(sortBy: 'COMPANY_ID' | 'SCRIPT_PATH' | 'CREATED_DATE', sortDirection: 'ASC' | 'DESC', companyId?: string, fromCreatedDate?: Date, limit?: number, scriptPath?: string, skip?: number, toCreatedDate?: Date, options?: any) {
        return InternalApiFp(this.configuration).getScriptErrorLogs(sortBy, sortDirection, companyId, fromCreatedDate, limit, scriptPath, skip, toCreatedDate, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back the type of the requested value of the CompanyConfiguration.
     * @summary getScriptInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getScriptInfo(options?: any) {
        return InternalApiFp(this.configuration).getScriptInfo(options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of shipmet mapping candidates for the current transport order
     * @summary Get a list of possible shipment mappings for the given transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getShipmentMappingProposal(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).getShipmentMappingProposal(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns list of super users with their status of two factor authentication.
     * @summary extract super user list and check their 2 factor authentication is done.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getSuperUserTwoFactorAuthenticationStatus(options?: any) {
        return InternalApiFp(this.configuration).getSuperUserTwoFactorAuthenticationStatus(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user permissions from a chosen user ID
     * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options?: any) {
        return InternalApiFp(this.configuration).getTempTargetUserPermissions(TargetUserRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch test failures with optional filters
     * @summary getTestFailures
     * @param {GetTestFailuresRequest} GetTestFailuresRequest GetTestFailuresRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getTestFailures(GetTestFailuresRequest: GetTestFailuresRequest, options?: any) {
        return InternalApiFp(this.configuration).getTestFailures(GetTestFailuresRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a report containing the time at a location for a given time range
     * @summary returns the time spent at Gerolsteiner
     * @param {number} month month
     * @param {number} year year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getTimeAtGerolsteinerReport(month: number, year: number, options?: any) {
        return InternalApiFp(this.configuration).getTimeAtGerolsteinerReport(month, year, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a report containing the time at a location for a given time range
     * @summary returns the time spent at the specified location report
     * @param {string} locationString locationString
     * @param {number} month month
     * @param {number} year year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getTimeAtLocationReport(locationString: string, month: number, year: number, options?: any) {
        return InternalApiFp(this.configuration).getTimeAtLocationReport(locationString, month, year, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a temporary test TransportOrderEvent of the given type, for the given TransportOrder and the config of the given company
     * @param {TransportOrderTestEventRequest} TransportOrderTestEventRequest TransportOrderTestEventRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getTransportOrderTestEvent(TransportOrderTestEventRequest: TransportOrderTestEventRequest, options?: any) {
        return InternalApiFp(this.configuration).getTransportOrderTestEvent(TransportOrderTestEventRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back the type of the requested value of the CompanyConfiguration.
     * @summary getType
     * @param {GetTypeRequest} GetTypeRequest GetTypeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getType(GetTypeRequest: GetTypeRequest, options?: any) {
        return InternalApiFp(this.configuration).getType(GetTypeRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back the type of the requested value of the CompanyConfiguration.
     * @summary getTypes
     * @param {GetTypesRequest} GetTypesRequest GetTypesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getTypes(GetTypesRequest: GetTypesRequest, options?: any) {
        return InternalApiFp(this.configuration).getTypes(GetTypesRequest, options)(this.fetch, this.basePath);
    }

    /**
     * fetch unbilled projectWorkLogBook entries
     * @summary get unbilled TransportOrders
     * @param {BillingRequest} BillingRequest BillingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getUnbilledTransportOrders(BillingRequest: BillingRequest, options?: any) {
        return InternalApiFp(this.configuration).getUnbilledTransportOrders(BillingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back userName by userId
     * @summary getUserName
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getUserName(userId: string, options?: any) {
        return InternalApiFp(this.configuration).getUserName(userId, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back the company of the given user.
     * @summary getUsersCompany
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getUsersCompany(options?: any) {
        return InternalApiFp(this.configuration).getUsersCompany(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get last 24 hours polyline for vehicle
     * @param {number} epsilon epsilon
     * @param {string} vehicleId vehicleId
     * @param {boolean} [resolveAddresses] resolveAddresses
     * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getVehiclePolyline(epsilon: number, vehicleId: string, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
        return InternalApiFp(this.configuration).getVehiclePolyline(epsilon, vehicleId, resolveAddresses, segmentByEstimatedStates, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Check vehicle positions in a specific time range for irregularities. Default search window is last 7 days.
     * @param {string} from from
     * @param {string} to to
     * @param {string} vehicleId vehicleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getVehiclePositionsCheck(from: string, to: string, vehicleId: string, options?: any) {
        return InternalApiFp(this.configuration).getVehiclePositionsCheck(from, to, vehicleId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation applies a groovy script on the given transportOrder and returns the result.
     * @summary Applies groovy script on transportOrder and returns result
     * @param {ScriptingRequest} ScriptingRequest ScriptingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public groovyScripting(ScriptingRequest: ScriptingRequest, options?: any) {
        return InternalApiFp(this.configuration).groovyScripting(ScriptingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Import an excel document containing the customer address mapping. This method is intensionally  allowed for non super users
     * @summary Import address mapping from lis
     * @param {any} doc Excel document to import the addresses from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public importLisCustomerAddressMapping(doc: any, options?: any) {
        return InternalApiFp(this.configuration).importLisCustomerAddressMapping(doc, options)(this.fetch, this.basePath);
    }

    /**
     * Adds positions from a gpx track with timestamps as fake positions to a vehicle. The startTime overrides the starting time in the gpx file.
     * @summary POST /api/internal/tracking/gpxtrack
     * @param {any} gpx Gpx file with track
     * @param {string} bodyObject Enter body object here
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public insertGpxTrackForVehicle(gpx: any, bodyObject: string, options?: any) {
        return InternalApiFp(this.configuration).insertGpxTrackForVehicle(gpx, bodyObject, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary checks if the user is super user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public isSuperuser(options?: any) {
        return InternalApiFp(this.configuration).isSuperuser(options)(this.fetch, this.basePath);
    }

    /**
     * Links two transports with and checks if all needed configs are set.
     * @summary Links two transports
     * @param {TransportLinkingRequest} TransportLinkingRequest TransportLinkingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public linkTransports(TransportLinkingRequest: TransportLinkingRequest, options?: any) {
        return InternalApiFp(this.configuration).linkTransports(TransportLinkingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Lists all TransportOrderConfigTests. This endpoint is needed for the integration tests of the converter
     * @param {string} [companyId] companyId
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listAllTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).listAllTransportOrderConfigTests(companyId, limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Lists all TransportOrderConfigTests of the users company
     * @param {string} [companyId] companyId
     * @param {number} [limit] limit
     * @param {string} [query] query
     * @param {number} [skip] skip
     * @param {'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED'} [sortBy] sortBy
     * @param {'ASC' | 'DESC'} [sortDirection] sortDirection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listTransportOrderConfigTests(companyId?: string, limit?: number, query?: string, skip?: number, sortBy?: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED', sortDirection?: 'ASC' | 'DESC', options?: any) {
        return InternalApiFp(this.configuration).listTransportOrderConfigTests(companyId, limit, query, skip, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * Store a generic AI test failure.
     * @summary logTestFailure
     * @param {TestFailureLogEntry} TestFailureLogEntry TestFailureLogEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public logTestFailure(TestFailureLogEntry: TestFailureLogEntry, options?: any) {
        return InternalApiFp(this.configuration).logTestFailure(TestFailureLogEntry, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will map a telematic tour to one or multiple existing transport orders. If no script is set, the default company telematicTourMappingScript is used.
     * @summary Map telematic tour to transport order by script
     * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public mapTelematicTour(TelematicTourMapRequest: TelematicTourMapRequest, options?: any) {
        return InternalApiFp(this.configuration).mapTelematicTour(TelematicTourMapRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will map a telematic tour to an existing transport order. If no script is set, the default company telematicTourMappingScript is used.
     * @summary Map telematic tour to transport order by script
     * @param {TelematicTourMapRequest} TelematicTourMapRequest TelematicTourMapRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public mapTelematicTourDEPRECATED(TelematicTourMapRequest: TelematicTourMapRequest, options?: any) {
        return InternalApiFp(this.configuration).mapTelematicTourDEPRECATED(TelematicTourMapRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will map a virtual spedion single tour vehicle to an assigned device of an existing transport order.
     * @summary Map virtual SPEDION single tour vehicle to assigned device of specific transport order
     * @param {MapVehicleToAssignedDeviceRequest} MapVehicleToAssignedDeviceRequest MapVehicleToAssignedDeviceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public mapVehicletoAssignedDevice(MapVehicleToAssignedDeviceRequest: MapVehicleToAssignedDeviceRequest, options?: any) {
        return InternalApiFp(this.configuration).mapVehicletoAssignedDevice(MapVehicleToAssignedDeviceRequest, options)(this.fetch, this.basePath);
    }

    /**
     * To migrate the DB to the latest version known to this version of the backend. 
     * @summary migrating the db to the latest version!
     * @param {boolean} dryRun dryRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public migrateDb(dryRun: boolean, options?: any) {
        return InternalApiFp(this.configuration).migrateDb(dryRun, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies the ProjectWorkLogBookEntry with the specified ProjectWorkLogBookEntryId.
     * @summary Modify ProjectWorkLogBookEntry by id
     * @param {string} logBookEntryId logBookEntryId
     * @param {ProjectWorkLogBookEntry} ProjectWorkLogBookEntry ProjectWorkLogBookEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public modifyProjectWorkLogBookEntryById(logBookEntryId: string, ProjectWorkLogBookEntry: ProjectWorkLogBookEntry, options?: any) {
        return InternalApiFp(this.configuration).modifyProjectWorkLogBookEntryById(logBookEntryId, ProjectWorkLogBookEntry, options)(this.fetch, this.basePath);
    }

    /**
     * Modifies the shipment form config of the given config id. The COMPANY_MODIFY permission is required to execute this operation.
     * @summary Modify shipment Form Config by id
     * @param {string} id id
     * @param {ShipmentFormConfigRequest} ShipmentFormConfigRequest ShipmentFormConfigRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public modifyShipmentFormConfigById(id: string, ShipmentFormConfigRequest: ShipmentFormConfigRequest, options?: any) {
        return InternalApiFp(this.configuration).modifyShipmentFormConfigById(id, ShipmentFormConfigRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Monitor mongo db operations running longer than given seconds.
     * @param {string} [mongoDbTags] mongoDbTags
     * @param {number} [seconds] seconds
     * @param {string} [mongoDbTags2] mongoDbTags
     * @param {number} [seconds2] seconds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public monitorDbOperations(mongoDbTags?: string, seconds?: number, mongoDbTags2?: string, seconds2?: number, options?: any) {
        return InternalApiFp(this.configuration).monitorDbOperations(mongoDbTags, seconds, mongoDbTags2, seconds2, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Monitor failed sms and emails in message log in past 7 days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public monitorFailedSmsEmail(options?: any) {
        return InternalApiFp(this.configuration).monitorFailedSmsEmail(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Monitor waiting events for specific queue.
     * @param {string} type type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public monitorWaitingEvents(type: string, options?: any) {
        return InternalApiFp(this.configuration).monitorWaitingEvents(type, options)(this.fetch, this.basePath);
    }

    /**
     * This operation applies a groovy script on the given transportOrder and returns the result.
     * @summary Applies groovy script on transportOrders and returns results
     * @param {MultiOrderScriptingRequest} MultiOrderScriptingRequest MultiOrderScriptingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public multiOrderGroovyScripting(MultiOrderScriptingRequest: MultiOrderScriptingRequest, options?: any) {
        return InternalApiFp(this.configuration).multiOrderGroovyScripting(MultiOrderScriptingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Validates the configuration, to check if it can be accepted by the database.
     * @summary multiScriptExecution
     * @param {MultiScriptExecutionRequest} MultiScriptExecutionRequest MultiScriptExecutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public multiScriptExecution(MultiScriptExecutionRequest: MultiScriptExecutionRequest, options?: any) {
        return InternalApiFp(this.configuration).multiScriptExecution(MultiScriptExecutionRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Drops Entries from the ai cache 
     * @summary Call ai with the given promt
     * @param {DropCacheEntryRequest} DropCacheEntryRequest DropCacheEntryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public oaiDropCacheEntry(DropCacheEntryRequest: DropCacheEntryRequest, options?: any) {
        return InternalApiFp(this.configuration).oaiDropCacheEntry(DropCacheEntryRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Optimize the Route for given shipments
     * @summary Optimize the Route for given shipments.
     * @param {RouteOptimizerRequest} RouteOptimizerRequest RouteOptimizerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public optimizeRoutes(RouteOptimizerRequest: RouteOptimizerRequest, options?: any) {
        return InternalApiFp(this.configuration).optimizeRoutes(RouteOptimizerRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary parse a transport order from a prompt
     * @param {ParseTransportOrderRequest} ParseTransportOrderRequest ParseTransportOrderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public parseGenericAiToTransportOrder(ParseTransportOrderRequest: ParseTransportOrderRequest, options?: any) {
        return InternalApiFp(this.configuration).parseGenericAiToTransportOrder(ParseTransportOrderRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary parse the next scheduled execution from a prompt
     * @param {ParseNextScheduledExecutionRequest} ParseNextScheduledExecutionRequest ParseNextScheduledExecutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public parseNextScheduledExecution(ParseNextScheduledExecutionRequest: ParseNextScheduledExecutionRequest, options?: any) {
        return InternalApiFp(this.configuration).parseNextScheduledExecution(ParseNextScheduledExecutionRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the times as string calculated by the given reportTimeReference and the current time.
     * @summary previewReportTimeReference
     * @param {ReportTimeReference} ReportTimeReference ReportTimeReference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public previewReportTimeReference(ReportTimeReference: ReportTimeReference, options?: any) {
        return InternalApiFp(this.configuration).previewReportTimeReference(ReportTimeReference, options)(this.fetch, this.basePath);
    }

    /**
     * AI analyzes all tickets considering score, difficulty, and other factors to recommend top 3 to pick up
     * @summary recommendTopTicketsForPickup
     * @param {RecommendTopTicketsRequest} RecommendTopTicketsRequest RecommendTopTicketsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public recommendTopTicketsForPickup(RecommendTopTicketsRequest: RecommendTopTicketsRequest, options?: any) {
        return InternalApiFp(this.configuration).recommendTopTicketsForPickup(RecommendTopTicketsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Recoveres a deleted object from history
     * @summary recover history entry
     * @param {RecoverHistoryEntryRequest} RecoverHistoryEntryRequest RecoverHistoryEntryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public recoverHistoryEntry(RecoverHistoryEntryRequest: RecoverHistoryEntryRequest, options?: any) {
        return InternalApiFp(this.configuration).recoverHistoryEntry(RecoverHistoryEntryRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Removes a path from the list of paths that should be opened as TextField in the CM-NavTree.
     * @summary removeFromCmNavTreeTextModal
     * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public removeFromCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options?: any) {
        return InternalApiFp(this.configuration).removeFromCmNavTreeTextModal(CmNavTreeTextModalListRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Remove temp token used from a chosen user ID
     * @param {TargetUserRequest} TargetUserRequest TargetUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public removeTempTargetUserPermissions(TargetUserRequest: TargetUserRequest, options?: any) {
        return InternalApiFp(this.configuration).removeTempTargetUserPermissions(TargetUserRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Replace the company configuration with the given value
     * @param {string} companyId companyId
     * @param {CompanyConfiguration} CompanyConfiguration CompanyConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replaceConfiguration(companyId: string, CompanyConfiguration: CompanyConfiguration, options?: any) {
        return InternalApiFp(this.configuration).replaceConfiguration(companyId, CompanyConfiguration, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Replace the company monitor configurations with the given value
     * @param {CompanyMonitorConfigs} CompanyMonitorConfigs CompanyMonitorConfigs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replaceMonitorConfiguration(CompanyMonitorConfigs: CompanyMonitorConfigs, options?: any) {
        return InternalApiFp(this.configuration).replaceMonitorConfiguration(CompanyMonitorConfigs, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Replace the company notification configurations with the given value
     * @param {NotificationConfiguration} NotificationConfiguration NotificationConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replaceNotificationConfiguration(NotificationConfiguration: NotificationConfiguration, options?: any) {
        return InternalApiFp(this.configuration).replaceNotificationConfiguration(NotificationConfiguration, options)(this.fetch, this.basePath);
    }

    /**
     * overrides given SystemStatusMessages.
     * @summary Update SystemStatusMessage endTime
     * @param {string} id id
     * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replaceSystemStatusMessage(id: string, SystemStatusMessage: SystemStatusMessage, options?: any) {
        return InternalApiFp(this.configuration).replaceSystemStatusMessage(id, SystemStatusMessage, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary replays all positions of a geostatusTest dump
     * @param {ReplayGeoStatusTestDataRequest} ReplayGeoStatusTestDataRequest ReplayGeoStatusTestDataRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replayGeoStatusTestData(ReplayGeoStatusTestDataRequest: ReplayGeoStatusTestDataRequest, options?: any) {
        return InternalApiFp(this.configuration).replayGeoStatusTestData(ReplayGeoStatusTestDataRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Replays the last position of a vehicle for debugging purposes.
     * @param {string} vehicleId vehicleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replayLastPositionRequest(vehicleId: string, options?: any) {
        return InternalApiFp(this.configuration).replayLastPositionRequest(vehicleId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary get Coordinates from AddressMapping
     * @param {CompanyAddressMapping} CompanyAddressMapping CompanyAddressMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public resolveCompanyAddressMappingToCoordinates(CompanyAddressMapping: CompanyAddressMapping, options?: any) {
        return InternalApiFp(this.configuration).resolveCompanyAddressMappingToCoordinates(CompanyAddressMapping, options)(this.fetch, this.basePath);
    }

    /**
     * Re-Validates the customerAddressMapping for the transportOrder
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public resolveCustomerAddressMapping(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).resolveCustomerAddressMapping(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Re-Validates the customerAddressMapping for multiple transportOrders in a single request. Returns detailed results for each transport order processed.
     * @param {ResolveCustomerAddressMappingBatchRequest} ResolveCustomerAddressMappingBatchRequest ResolveCustomerAddressMappingBatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public resolveCustomerAddressMappingBatch(ResolveCustomerAddressMappingBatchRequest: ResolveCustomerAddressMappingBatchRequest, options?: any) {
        return InternalApiFp(this.configuration).resolveCustomerAddressMappingBatch(ResolveCustomerAddressMappingBatchRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns the reverse geocoding for a given Google plus code.
     * @summary Get the reverse geocoding for a given plus code
     * @param {string} plusCode plusCode
     * @param {boolean} [reduceAccuracyOfPlusCode] reduceAccuracyOfPlusCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public reverseGeocodePlusCode(plusCode: string, reduceAccuracyOfPlusCode?: boolean, options?: any) {
        return InternalApiFp(this.configuration).reverseGeocodePlusCode(plusCode, reduceAccuracyOfPlusCode, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary rollback transportOrder
     * @param {RollbackTransportOrderRequest} RollbackTransportOrderRequest RollbackTransportOrderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public rollbackTransportOrder(RollbackTransportOrderRequest: RollbackTransportOrderRequest, options?: any) {
        return InternalApiFp(this.configuration).rollbackTransportOrder(RollbackTransportOrderRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary checks if the user is super user
     * @param {TaskOptions} TaskOptions TaskOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public runTask(TaskOptions: TaskOptions, options?: any) {
        return InternalApiFp(this.configuration).runTask(TaskOptions, options)(this.fetch, this.basePath);
    }

    /**
     * Saves the configuration as draft, so it's saved for later usage.
     * @summary saveConfigAsDraft
     * @param {SaveConfigAsDraftRequest} SaveConfigAsDraftRequest SaveConfigAsDraftRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public saveConfigAsDraft(SaveConfigAsDraftRequest: SaveConfigAsDraftRequest, options?: any) {
        return InternalApiFp(this.configuration).saveConfigAsDraft(SaveConfigAsDraftRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Saves a description for a specific field in the CompanyConfiguration. The field is specified by a JQuary leading to the field.
     * @summary saveConfigFieldDescription
     * @param {SaveConfigFieldDescriptionRequest} SaveConfigFieldDescriptionRequest SaveConfigFieldDescriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public saveConfigFieldDescription(SaveConfigFieldDescriptionRequest: SaveConfigFieldDescriptionRequest, options?: any) {
        return InternalApiFp(this.configuration).saveConfigFieldDescription(SaveConfigFieldDescriptionRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the default contract.
     * @summary save Contract
     * @param {SaveContractRequest} SaveContractRequest SaveContractRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public saveContract(SaveContractRequest: SaveContractRequest, options?: any) {
        return InternalApiFp(this.configuration).saveContract(SaveContractRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Saves a SystemStatusMessage and returns if it succeeded.
     * @summary Save SystemStatusMessage
     * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public saveSystemStatusMessages(SystemStatusMessage: SystemStatusMessage, options?: any) {
        return InternalApiFp(this.configuration).saveSystemStatusMessages(SystemStatusMessage, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary save a new TransportOrderConfig Test
     * @param {SaveTransportOrderConfigTestRequest} SaveTransportOrderConfigTestRequest SaveTransportOrderConfigTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public saveTransportOrderConfigTest(SaveTransportOrderConfigTestRequest: SaveTransportOrderConfigTestRequest, options?: any) {
        return InternalApiFp(this.configuration).saveTransportOrderConfigTest(SaveTransportOrderConfigTestRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch unassigned tickets with Score label from GitLab, sorted by score descending
     * @summary scoredUnassignedTickets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public scoredUnassignedTickets(options?: any) {
        return InternalApiFp(this.configuration).scoredUnassignedTickets(options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint searches through all configurations of all companies for a given searchTerm. The searchTerm is splitted by whitespaces and will return matches for every substring. To avoid splitting the searchterm or parts of it, please surround it by quots. Example:    searchterm [hello world] will respond every config containing the term \"hello\" and every config containing the term \"world\".             searchterm [\"hello world\"] will respond every config containing the searchterm \"hello world\" 
     * @summary search Configs
     * @param {SearchConfigsRequest} SearchConfigsRequest SearchConfigsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public searchConfigs(SearchConfigsRequest: SearchConfigsRequest, options?: any) {
        return InternalApiFp(this.configuration).searchConfigs(SearchConfigsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary redirects query to graylog and returns found logs
     * @param {GraylogRequest} GraylogRequest GraylogRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public searchGraylog(GraylogRequest: GraylogRequest, options?: any) {
        return InternalApiFp(this.configuration).searchGraylog(GraylogRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a list of all transport orders exported as excel file
     * @summary convert list of all transport orders to excel without any pagination rules
     * @param {TransportSelectedOrderToExcelConversionRequest} TransportSelectedOrderToExcelConversionRequest TransportSelectedOrderToExcelConversionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public selectedTransportOrderExcelExport(TransportSelectedOrderToExcelConversionRequest: TransportSelectedOrderToExcelConversionRequest, options?: any) {
        return InternalApiFp(this.configuration).selectedTransportOrderExcelExport(TransportSelectedOrderToExcelConversionRequest, options)(this.fetch, this.basePath);
    }

    /**
     * sends mail and logs it into the MailLog-collection in the DB.
     * @summary send message
     * @param {MessageLog} MessageLog MessageLog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public sendMessage(MessageLog: MessageLog, options?: any) {
        return InternalApiFp(this.configuration).sendMessage(MessageLog, options)(this.fetch, this.basePath);
    }

    /**
     * Adds a path to the list of paths that should be opened as TextField in the CM-NavTree.
     * @summary setCmNavTreeTextModal
     * @param {CmNavTreeTextModalListRequest} CmNavTreeTextModalListRequest CmNavTreeTextModalListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public setCmNavTreeTextModal(CmNavTreeTextModalListRequest: CmNavTreeTextModalListRequest, options?: any) {
        return InternalApiFp(this.configuration).setCmNavTreeTextModal(CmNavTreeTextModalListRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Send shipment Form Config access details via user's Email.
     * @summary Send shipment Form Config access details via user's Email
     * @param {string} shipmentCreateFormId shipmentCreateFormId
     * @param {ShareUserAccessViaEmailRequest} ShareUserAccessViaEmailRequest ShareUserAccessViaEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public shareShipmentCreateFormUserAccessViaEmail(shipmentCreateFormId: string, ShareUserAccessViaEmailRequest: ShareUserAccessViaEmailRequest, options?: any) {
        return InternalApiFp(this.configuration).shareShipmentCreateFormUserAccessViaEmail(shipmentCreateFormId, ShareUserAccessViaEmailRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Saves a SystemStatusMessage and ends all other SystemStatusMessages for the combination of companyId + groupKey.
     * @summary Save SystemStatusMessage and end others
     * @param {SystemStatusMessage} SystemStatusMessage SystemStatusMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public simpleSaveSystemStatusMessage(SystemStatusMessage: SystemStatusMessage, options?: any) {
        return InternalApiFp(this.configuration).simpleSaveSystemStatusMessage(SystemStatusMessage, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a xlsx the standingTimesUi.
     * @summary Get a standingTimes report of specified tours of one shipper as xlsx
     * @param {StandingTimesUiSpecificReportXlsxRequest} StandingTimesUiSpecificReportXlsxRequest StandingTimesUiSpecificReportXlsxRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public standingTimesUiSpecificReportXlsx(StandingTimesUiSpecificReportXlsxRequest: StandingTimesUiSpecificReportXlsxRequest, options?: any) {
        return InternalApiFp(this.configuration).standingTimesUiSpecificReportXlsx(StandingTimesUiSpecificReportXlsxRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a xlsx the standingTimesUi.
     * @summary Get standingTimesUi table as xlsx
     * @param {Date} endTime endTime
     * @param {Date} startTime startTime
     * @param {StandingTimesUiTableAsXlsxRequest} StandingTimesUiTableAsXlsxRequest StandingTimesUiTableAsXlsxRequest
     * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
     * @param {string} [term] term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public standingTimesUiTableAsXlsx(endTime: Date, startTime: Date, StandingTimesUiTableAsXlsxRequest: StandingTimesUiTableAsXlsxRequest, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', term?: string, options?: any) {
        return InternalApiFp(this.configuration).standingTimesUiTableAsXlsx(endTime, startTime, StandingTimesUiTableAsXlsxRequest, dateTimeField, term, options)(this.fetch, this.basePath);
    }

    /**
     * Upsert the full Spedion DTCO activity logbook for a driver.
     * @summary submitDriverWorkAndRestTimes
     * @param {DriverWorkAndRestTimesUpsertRequest} DriverWorkAndRestTimesUpsertRequest DriverWorkAndRestTimesUpsertRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public submitDriverWorkAndRestTimes(DriverWorkAndRestTimesUpsertRequest: DriverWorkAndRestTimesUpsertRequest, options?: any) {
        return InternalApiFp(this.configuration).submitDriverWorkAndRestTimes(DriverWorkAndRestTimesUpsertRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary switches the active state
     * @param {SwitchActiveTransportOrderConfigTestsRequest} SwitchActiveTransportOrderConfigTestsRequest SwitchActiveTransportOrderConfigTestsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public switchActiveTransportOrderConfigTest(SwitchActiveTransportOrderConfigTestsRequest: SwitchActiveTransportOrderConfigTestsRequest, options?: any) {
        return InternalApiFp(this.configuration).switchActiveTransportOrderConfigTest(SwitchActiveTransportOrderConfigTestsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the default contract.
     * @summary save Contract
     * @param {number} configIndex configIndex
     * @param {CompanyWithConfig} CompanyWithConfig CompanyWithConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public testApiGatewayConfig(configIndex: number, CompanyWithConfig: CompanyWithConfig, options?: any) {
        return InternalApiFp(this.configuration).testApiGatewayConfig(configIndex, CompanyWithConfig, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Test all log levels.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public testLogLevel(options?: any) {
        return InternalApiFp(this.configuration).testLogLevel(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary sends a failed request again
     * @param {string} failedRequestId failedRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public triggerFailedRequest(failedRequestId: string, options?: any) {
        return InternalApiFp(this.configuration).triggerFailedRequest(failedRequestId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary triggers a given list of tests
     * @param {TriggerTransportOrderConfigTestsRequest} TriggerTransportOrderConfigTestsRequest TriggerTransportOrderConfigTestsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public triggerTransportOrderTests(TriggerTransportOrderConfigTestsRequest: TriggerTransportOrderConfigTestsRequest, options?: any) {
        return InternalApiFp(this.configuration).triggerTransportOrderTests(TriggerTransportOrderConfigTestsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Adding an email address in unsubscribe list.
     * @summary send message
     * @param {UnsubscribeEmailRequest} UnsubscribeEmailRequest UnsubscribeEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public unsubscribeEmail(UnsubscribeEmailRequest: UnsubscribeEmailRequest, options?: any) {
        return InternalApiFp(this.configuration).unsubscribeEmail(UnsubscribeEmailRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Modify the state dict of the current api gateway with the given config
     * @summary submit api gateway state
     * @param {string} companyId companyId
     * @param {string} configId configId
     * @param {ApiGatewayStateUpdateRequest} ApiGatewayStateUpdateRequest ApiGatewayStateUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateApiGatewayState(companyId: string, configId: string, ApiGatewayStateUpdateRequest: ApiGatewayStateUpdateRequest, options?: any) {
        return InternalApiFp(this.configuration).updateApiGatewayState(companyId, configId, ApiGatewayStateUpdateRequest, options)(this.fetch, this.basePath);
    }

    /**
     * add a company to the user, that he can then switch to
     * @summary updates all companies that a user can switch to
     * @param {UpdateAvailableCompanyToUserRequest} UpdateAvailableCompanyToUserRequest UpdateAvailableCompanyToUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateAvailableCompanyToUser(UpdateAvailableCompanyToUserRequest: UpdateAvailableCompanyToUserRequest, options?: any) {
        return InternalApiFp(this.configuration).updateAvailableCompanyToUser(UpdateAvailableCompanyToUserRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Updates the comment on a given ConfigHistory
     * @summary update company config history comment
     * @param {string} companyId companyId
     * @param {string} historyId historyId
     * @param {UpdateCompanyConfigHistoryCommentRequest} UpdateCompanyConfigHistoryCommentRequest UpdateCompanyConfigHistoryCommentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateCompanyConfigHistoryComment(companyId: string, historyId: string, UpdateCompanyConfigHistoryCommentRequest: UpdateCompanyConfigHistoryCommentRequest, options?: any) {
        return InternalApiFp(this.configuration).updateCompanyConfigHistoryComment(companyId, historyId, UpdateCompanyConfigHistoryCommentRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Updates the configuration of the company of the currently authenticated user.
     * @summary update current company
     * @param {string} companyId companyId
     * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
     * @param {string} [comment] comment
     * @param {string} [ticketNrs] ticketNrs
     * @param {number} [workTimeInMinutes] workTimeInMinutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, comment?: string, ticketNrs?: string, workTimeInMinutes?: number, options?: any) {
        return InternalApiFp(this.configuration).updateCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, comment, ticketNrs, workTimeInMinutes, options)(this.fetch, this.basePath);
    }

    /**
     * Gives back all drafts for this user and this companyId.  
     * @summary updateConfigDraft
     * @param {string} draftId draftId
     * @param {boolean} shared shared
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateConfigDraft(draftId: string, shared: boolean, options?: any) {
        return InternalApiFp(this.configuration).updateConfigDraft(draftId, shared, options)(this.fetch, this.basePath);
    }

    /**
     * This is webhook from mailgun which trigger on any status change of email our system send.
     * @summary update email status text webhook from mailgun
     * @param {MailgunWebhookInputRequest} MailgunWebhookInputRequest MailgunWebhookInputRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateEmailStatusTextWebhook(MailgunWebhookInputRequest: MailgunWebhookInputRequest, options?: any) {
        return InternalApiFp(this.configuration).updateEmailStatusTextWebhook(MailgunWebhookInputRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary update global geofences by id
     * @param {string} id id
     * @param {GlobalGeofence} GlobalGeofence GlobalGeofence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateGlobalGeofences(id: string, GlobalGeofence: GlobalGeofence, options?: any) {
        return InternalApiFp(this.configuration).updateGlobalGeofences(id, GlobalGeofence, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch the message log by given id and update its acknowledge status.
     * @summary update external partner id
     * @param {MessageLogAcknowledgeRequest} MessageLogAcknowledgeRequest MessageLogAcknowledgeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateMessageLogToAcknowledgeStatus(MessageLogAcknowledgeRequest: MessageLogAcknowledgeRequest, options?: any) {
        return InternalApiFp(this.configuration).updateMessageLogToAcknowledgeStatus(MessageLogAcknowledgeRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will do the same as createOrModify, but without saving anything to the DB. 
     * @summary Update the missing attribute values
     * @param {MissingAttributeValuesUpdateRequest} MissingAttributeValuesUpdateRequest MissingAttributeValuesUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateMissingAttributeValues(MissingAttributeValuesUpdateRequest: MissingAttributeValuesUpdateRequest, options?: any) {
        return InternalApiFp(this.configuration).updateMissingAttributeValues(MissingAttributeValuesUpdateRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Update the etaCalculatorEvent's processed and errorString fields.
     * @summary set given etaCalculator event's processed to true and the given errorString
     * @param {MultipleEtaProcessedRequest} MultipleEtaProcessedRequest MultipleEtaProcessedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateMultiEtaCalculatorEvents(MultipleEtaProcessedRequest: MultipleEtaProcessedRequest, options?: any) {
        return InternalApiFp(this.configuration).updateMultiEtaCalculatorEvents(MultipleEtaProcessedRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary update or insert schedulerTaskConfig
     * @param {SchedulerTaskConfig} SchedulerTaskConfig SchedulerTaskConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateOrInsertSchedulerTaskConfig(SchedulerTaskConfig: SchedulerTaskConfig, options?: any) {
        return InternalApiFp(this.configuration).updateOrInsertSchedulerTaskConfig(SchedulerTaskConfig, options)(this.fetch, this.basePath);
    }

    /**
     * updates a list of queued events with a given processingState
     * @summary UpdateQueuedEvents
     * @param {UpdateQueuedEventsRequest} UpdateQueuedEventsRequest UpdateQueuedEventsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateQueuedEvents(UpdateQueuedEventsRequest: UpdateQueuedEventsRequest, options?: any) {
        return InternalApiFp(this.configuration).updateQueuedEvents(UpdateQueuedEventsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary update Scheduler config
     * @param {SchedulerConfig} SchedulerConfig SchedulerConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateSchedulerConfig(SchedulerConfig: SchedulerConfig, options?: any) {
        return InternalApiFp(this.configuration).updateSchedulerConfig(SchedulerConfig, options)(this.fetch, this.basePath);
    }

    /**
     * Updates a specific SchedulerReportingConfiguration. Only accessible for superusers.
     * @summary Update SchedulerReportingConfiguration
     * @param {string} id id
     * @param {SchedulerReportingConfiguration} SchedulerReportingConfiguration SchedulerReportingConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateSchedulerReportingConfiguration(id: string, SchedulerReportingConfiguration: SchedulerReportingConfiguration, options?: any) {
        return InternalApiFp(this.configuration).updateSchedulerReportingConfiguration(id, SchedulerReportingConfiguration, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary updates the test
     * @param {UpdateTransportOrderConfigTestsRequest} UpdateTransportOrderConfigTestsRequest UpdateTransportOrderConfigTestsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateTransportOrderConfigTests(UpdateTransportOrderConfigTestsRequest: UpdateTransportOrderConfigTestsRequest, options?: any) {
        return InternalApiFp(this.configuration).updateTransportOrderConfigTests(UpdateTransportOrderConfigTestsRequest, options)(this.fetch, this.basePath);
    }

    /**
     * uploads credit notes to Zoho
     * @summary upload credit notes to zoho
     * @param {BillingRequest} BillingRequest BillingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public uploadCreditNotesToZoho(BillingRequest: BillingRequest, options?: any) {
        return InternalApiFp(this.configuration).uploadCreditNotesToZoho(BillingRequest, options)(this.fetch, this.basePath);
    }

    /**
     * uploads an Invoice from the DB to Zoho
     * @summary upload invoice to zoho
     * @param {UploadInvoiceToZohoRequest} UploadInvoiceToZohoRequest UploadInvoiceToZohoRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public uploadInvoiceToZoho(UploadInvoiceToZohoRequest: UploadInvoiceToZohoRequest, options?: any) {
        return InternalApiFp(this.configuration).uploadInvoiceToZoho(UploadInvoiceToZohoRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Updates the configuration of the company of the currently authenticated user.
     * @summary update current company
     * @param {string} companyId companyId
     * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public validateCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
        return InternalApiFp(this.configuration).validateCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary checks if the user is super user
     * @param {string} tag tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public validateOrderBoxTag(tag: string, options?: any) {
        return InternalApiFp(this.configuration).validateOrderBoxTag(tag, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary checking if the given totp is currently valid
     * @param {string} totp totp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public validateTotp(totp: string, options?: any) {
        return InternalApiFp(this.configuration).validateTotp(totp, options)(this.fetch, this.basePath);
    }

    /**
     * Validates the configuration, to check if it can be accepted by the database.
     * @summary validate company config
     * @param {string} companyId companyId
     * @param {UpdateCompanyConfigRequestWrapper} UpdateCompanyConfigRequestWrapper UpdateCompanyConfigRequestWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public verifyCompanyConfiguration(companyId: string, UpdateCompanyConfigRequestWrapper: UpdateCompanyConfigRequestWrapper, options?: any) {
        return InternalApiFp(this.configuration).verifyCompanyConfiguration(companyId, UpdateCompanyConfigRequestWrapper, options)(this.fetch, this.basePath);
    }

    /**
     * Call this endpoint to view the transport order as immediate format. The immediate format is a list of key value pairs that describe the whole transport order. 
     * @summary Returns the Transport Order as immediate Format
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public viewTransportOrderAsImmediateFormat(orderId: string, options?: any) {
        return InternalApiFp(this.configuration).viewTransportOrderAsImmediateFormat(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary wait for specified duration in milliseconds
     * @param {number} timeInMs timeInMs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public waitForDuration(timeInMs: number, options?: any) {
        return InternalApiFp(this.configuration).waitForDuration(timeInMs, options)(this.fetch, this.basePath);
    }

    /**
     * Import an excel document containing the customer address mapping. This method is intentionally  allowed for non super users
     * @summary Import address mapping from lis
     * @param {any} doc Excel document to convert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public xls2json(doc: any, options?: any) {
        return InternalApiFp(this.configuration).xls2json(doc, options)(this.fetch, this.basePath);
    }

}

/**
 * MobileApi - fetch parameter creator
 * @export
 */
export const MobileApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation will assign a Device to the TransportOrder.
         * @summary assign
         * @param {string} orderId orderId
         * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDevice(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling assignDevice.');
            }
            // verify required parameter 'TransportOrderAssignRequest' is not null or undefined
            if (TransportOrderAssignRequest === null || TransportOrderAssignRequest === undefined) {
                throw new RequiredError('TransportOrderAssignRequest','Required parameter TransportOrderAssignRequest was null or undefined when calling assignDevice.');
            }
            const localVarPath = `/mobile/transportOrders/{orderId}/assignDevice`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderAssignRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderAssignRequest || {}) : (TransportOrderAssignRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a transport order.
         * @summary Get transport order
         * @param {string} authToken authToken
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrder(authToken: string, transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'authToken' is not null or undefined
            if (authToken === null || authToken === undefined) {
                throw new RequiredError('authToken','Required parameter authToken was null or undefined when calling fetchTransportOrder.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fetchTransportOrder.');
            }
            const localVarPath = `/mobile/fetchTransportOrder/{transportOrderId}/{authToken}`
                .replace(`{${"authToken"}}`, encodeURIComponent(String(authToken)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single transport order identified by the source company tag and by the transportId.   Errors:      Not found - if no transport Order was found     Conflict - if multiple transport orders were found     Permission denied - if user has insufficient permissions
         * @summary fetch single transportorder by Company TAG and TransportId
         * @param {string} authToken authToken
         * @param {string} tag tag
         * @param {string} transportId transportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByCompanyTagAndTransportId(authToken: string, tag: string, transportId: string, options: any = {}): FetchArgs {
            // verify required parameter 'authToken' is not null or undefined
            if (authToken === null || authToken === undefined) {
                throw new RequiredError('authToken','Required parameter authToken was null or undefined when calling fetchTransportOrderByCompanyTagAndTransportId.');
            }
            // verify required parameter 'tag' is not null or undefined
            if (tag === null || tag === undefined) {
                throw new RequiredError('tag','Required parameter tag was null or undefined when calling fetchTransportOrderByCompanyTagAndTransportId.');
            }
            // verify required parameter 'transportId' is not null or undefined
            if (transportId === null || transportId === undefined) {
                throw new RequiredError('transportId','Required parameter transportId was null or undefined when calling fetchTransportOrderByCompanyTagAndTransportId.');
            }
            const localVarPath = `/mobile/fetchTransportOrderByTagAndTransportId/{tag}/{transportId}/{authToken}`
                .replace(`{${"authToken"}}`, encodeURIComponent(String(authToken)))
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)))
                .replace(`{${"transportId"}}`, encodeURIComponent(String(transportId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will assign the same Device to the TransportOrder to trigger a link resend.
         * @summary resend
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendLink(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling resendLink.');
            }
            const localVarPath = `/mobile/transportOrders/{orderId}/resend`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileApi - functional programming interface
 * @export
 */
export const MobileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation will assign a Device to the TransportOrder.
         * @summary assign
         * @param {string} orderId orderId
         * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDevice(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Token> {
            const localVarFetchArgs = MobileApiFetchParamCreator(configuration).assignDevice(orderId, TransportOrderAssignRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a transport order.
         * @summary Get transport order
         * @param {string} authToken authToken
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrder(authToken: string, transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = MobileApiFetchParamCreator(configuration).fetchTransportOrder(authToken, transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a single transport order identified by the source company tag and by the transportId.   Errors:      Not found - if no transport Order was found     Conflict - if multiple transport orders were found     Permission denied - if user has insufficient permissions
         * @summary fetch single transportorder by Company TAG and TransportId
         * @param {string} authToken authToken
         * @param {string} tag tag
         * @param {string} transportId transportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByCompanyTagAndTransportId(authToken: string, tag: string, transportId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = MobileApiFetchParamCreator(configuration).fetchTransportOrderByCompanyTagAndTransportId(authToken, tag, transportId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will assign the same Device to the TransportOrder to trigger a link resend.
         * @summary resend
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendLink(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Token> {
            const localVarFetchArgs = MobileApiFetchParamCreator(configuration).resendLink(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MobileApi - factory interface
 * @export
 */
export const MobileApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * This operation will assign a Device to the TransportOrder.
         * @summary assign
         * @param {string} orderId orderId
         * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDevice(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options?: any) {
            return MobileApiFp(configuration).assignDevice(orderId, TransportOrderAssignRequest, options)(fetch, basePath);
        },
        /**
         * Returns a transport order.
         * @summary Get transport order
         * @param {string} authToken authToken
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrder(authToken: string, transportOrderId: string, options?: any) {
            return MobileApiFp(configuration).fetchTransportOrder(authToken, transportOrderId, options)(fetch, basePath);
        },
        /**
         * Returns a single transport order identified by the source company tag and by the transportId.   Errors:      Not found - if no transport Order was found     Conflict - if multiple transport orders were found     Permission denied - if user has insufficient permissions
         * @summary fetch single transportorder by Company TAG and TransportId
         * @param {string} authToken authToken
         * @param {string} tag tag
         * @param {string} transportId transportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByCompanyTagAndTransportId(authToken: string, tag: string, transportId: string, options?: any) {
            return MobileApiFp(configuration).fetchTransportOrderByCompanyTagAndTransportId(authToken, tag, transportId, options)(fetch, basePath);
        },
        /**
         * This operation will assign the same Device to the TransportOrder to trigger a link resend.
         * @summary resend
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendLink(orderId: string, options?: any) {
            return MobileApiFp(configuration).resendLink(orderId, options)(fetch, basePath);
        },
    };
};

/**
 * MobileApi - object-oriented interface
 * @export
 * @class MobileApi
 * @extends {BaseAPI}
 */
export class MobileApi extends BaseAPI {
    /**
     * This operation will assign a Device to the TransportOrder.
     * @summary assign
     * @param {string} orderId orderId
     * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public assignDevice(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options?: any) {
        return MobileApiFp(this.configuration).assignDevice(orderId, TransportOrderAssignRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a transport order.
     * @summary Get transport order
     * @param {string} authToken authToken
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public fetchTransportOrder(authToken: string, transportOrderId: string, options?: any) {
        return MobileApiFp(this.configuration).fetchTransportOrder(authToken, transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a single transport order identified by the source company tag and by the transportId.   Errors:      Not found - if no transport Order was found     Conflict - if multiple transport orders were found     Permission denied - if user has insufficient permissions
     * @summary fetch single transportorder by Company TAG and TransportId
     * @param {string} authToken authToken
     * @param {string} tag tag
     * @param {string} transportId transportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public fetchTransportOrderByCompanyTagAndTransportId(authToken: string, tag: string, transportId: string, options?: any) {
        return MobileApiFp(this.configuration).fetchTransportOrderByCompanyTagAndTransportId(authToken, tag, transportId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will assign the same Device to the TransportOrder to trigger a link resend.
     * @summary resend
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public resendLink(orderId: string, options?: any) {
        return MobileApiFp(this.configuration).resendLink(orderId, options)(this.fetch, this.basePath);
    }

}

/**
 * MobileLogTrackApi - fetch parameter creator
 * @export
 */
export const MobileLogTrackApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Init LOGENIOS Tracking App
         * @param {LogTrackInitRequest} LogTrackInitRequest LogTrackInitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initMobileApp(LogTrackInitRequest: LogTrackInitRequest, options: any = {}): FetchArgs {
            // verify required parameter 'LogTrackInitRequest' is not null or undefined
            if (LogTrackInitRequest === null || LogTrackInitRequest === undefined) {
                throw new RequiredError('LogTrackInitRequest','Required parameter LogTrackInitRequest was null or undefined when calling initMobileApp.');
            }
            const localVarPath = `/internal/tracking/logTrackInit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"LogTrackInitRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(LogTrackInitRequest || {}) : (LogTrackInitRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post position from LOGENIOS Tracking App
         * @param {LogTrackPositionRequest} LogTrackPositionRequest LogTrackPositionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPosition(LogTrackPositionRequest: LogTrackPositionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'LogTrackPositionRequest' is not null or undefined
            if (LogTrackPositionRequest === null || LogTrackPositionRequest === undefined) {
                throw new RequiredError('LogTrackPositionRequest','Required parameter LogTrackPositionRequest was null or undefined when calling postPosition.');
            }
            const localVarPath = `/internal/tracking/logTrackPosition`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"LogTrackPositionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(LogTrackPositionRequest || {}) : (LogTrackPositionRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileLogTrackApi - functional programming interface
 * @export
 */
export const MobileLogTrackApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Init LOGENIOS Tracking App
         * @param {LogTrackInitRequest} LogTrackInitRequest LogTrackInitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initMobileApp(LogTrackInitRequest: LogTrackInitRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LogTrackInitResponse> {
            const localVarFetchArgs = MobileLogTrackApiFetchParamCreator(configuration).initMobileApp(LogTrackInitRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Post position from LOGENIOS Tracking App
         * @param {LogTrackPositionRequest} LogTrackPositionRequest LogTrackPositionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPosition(LogTrackPositionRequest: LogTrackPositionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LogTrackPositionResponse> {
            const localVarFetchArgs = MobileLogTrackApiFetchParamCreator(configuration).postPosition(LogTrackPositionRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MobileLogTrackApi - factory interface
 * @export
 */
export const MobileLogTrackApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Init LOGENIOS Tracking App
         * @param {LogTrackInitRequest} LogTrackInitRequest LogTrackInitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initMobileApp(LogTrackInitRequest: LogTrackInitRequest, options?: any) {
            return MobileLogTrackApiFp(configuration).initMobileApp(LogTrackInitRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Post position from LOGENIOS Tracking App
         * @param {LogTrackPositionRequest} LogTrackPositionRequest LogTrackPositionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPosition(LogTrackPositionRequest: LogTrackPositionRequest, options?: any) {
            return MobileLogTrackApiFp(configuration).postPosition(LogTrackPositionRequest, options)(fetch, basePath);
        },
    };
};

/**
 * MobileLogTrackApi - object-oriented interface
 * @export
 * @class MobileLogTrackApi
 * @extends {BaseAPI}
 */
export class MobileLogTrackApi extends BaseAPI {
    /**
     * 
     * @summary Init LOGENIOS Tracking App
     * @param {LogTrackInitRequest} LogTrackInitRequest LogTrackInitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileLogTrackApi
     */
    public initMobileApp(LogTrackInitRequest: LogTrackInitRequest, options?: any) {
        return MobileLogTrackApiFp(this.configuration).initMobileApp(LogTrackInitRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Post position from LOGENIOS Tracking App
     * @param {LogTrackPositionRequest} LogTrackPositionRequest LogTrackPositionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileLogTrackApi
     */
    public postPosition(LogTrackPositionRequest: LogTrackPositionRequest, options?: any) {
        return MobileLogTrackApiFp(this.configuration).postPosition(LogTrackPositionRequest, options)(this.fetch, this.basePath);
    }

}

/**
 * QueryApi - fetch parameter creator
 * @export
 */
export const QueryApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * testing the Discovery Service
         * @summary run Discovery Service
         * @param {DiscoveryServiceRequest} DiscoveryServiceRequest DiscoveryServiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDiscoveryService(DiscoveryServiceRequest: DiscoveryServiceRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DiscoveryServiceRequest' is not null or undefined
            if (DiscoveryServiceRequest === null || DiscoveryServiceRequest === undefined) {
                throw new RequiredError('DiscoveryServiceRequest','Required parameter DiscoveryServiceRequest was null or undefined when calling runDiscoveryService.');
            }
            const localVarPath = `/query/discoveryService`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DiscoveryServiceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DiscoveryServiceRequest || {}) : (DiscoveryServiceRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * testing the query engine
         * @summary run Query request
         * @param {string} collection collection
         * @param {QueryRequest} QueryRequest QueryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runQuery(collection: string, QueryRequest: QueryRequest, options: any = {}): FetchArgs {
            // verify required parameter 'collection' is not null or undefined
            if (collection === null || collection === undefined) {
                throw new RequiredError('collection','Required parameter collection was null or undefined when calling runQuery.');
            }
            // verify required parameter 'QueryRequest' is not null or undefined
            if (QueryRequest === null || QueryRequest === undefined) {
                throw new RequiredError('QueryRequest','Required parameter QueryRequest was null or undefined when calling runQuery.');
            }
            const localVarPath = `/query/engine/{collection}`
                .replace(`{${"collection"}}`, encodeURIComponent(String(collection)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"QueryRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(QueryRequest || {}) : (QueryRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryApi - functional programming interface
 * @export
 */
export const QueryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * testing the Discovery Service
         * @summary run Discovery Service
         * @param {DiscoveryServiceRequest} DiscoveryServiceRequest DiscoveryServiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDiscoveryService(DiscoveryServiceRequest: DiscoveryServiceRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DiscoveryServiceResponse> {
            const localVarFetchArgs = QueryApiFetchParamCreator(configuration).runDiscoveryService(DiscoveryServiceRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * testing the query engine
         * @summary run Query request
         * @param {string} collection collection
         * @param {QueryRequest} QueryRequest QueryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runQuery(collection: string, QueryRequest: QueryRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueryResponse> {
            const localVarFetchArgs = QueryApiFetchParamCreator(configuration).runQuery(collection, QueryRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * QueryApi - factory interface
 * @export
 */
export const QueryApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * testing the Discovery Service
         * @summary run Discovery Service
         * @param {DiscoveryServiceRequest} DiscoveryServiceRequest DiscoveryServiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDiscoveryService(DiscoveryServiceRequest: DiscoveryServiceRequest, options?: any) {
            return QueryApiFp(configuration).runDiscoveryService(DiscoveryServiceRequest, options)(fetch, basePath);
        },
        /**
         * testing the query engine
         * @summary run Query request
         * @param {string} collection collection
         * @param {QueryRequest} QueryRequest QueryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runQuery(collection: string, QueryRequest: QueryRequest, options?: any) {
            return QueryApiFp(configuration).runQuery(collection, QueryRequest, options)(fetch, basePath);
        },
    };
};

/**
 * QueryApi - object-oriented interface
 * @export
 * @class QueryApi
 * @extends {BaseAPI}
 */
export class QueryApi extends BaseAPI {
    /**
     * testing the Discovery Service
     * @summary run Discovery Service
     * @param {DiscoveryServiceRequest} DiscoveryServiceRequest DiscoveryServiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryApi
     */
    public runDiscoveryService(DiscoveryServiceRequest: DiscoveryServiceRequest, options?: any) {
        return QueryApiFp(this.configuration).runDiscoveryService(DiscoveryServiceRequest, options)(this.fetch, this.basePath);
    }

    /**
     * testing the query engine
     * @summary run Query request
     * @param {string} collection collection
     * @param {QueryRequest} QueryRequest QueryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryApi
     */
    public runQuery(collection: string, QueryRequest: QueryRequest, options?: any) {
        return QueryApiFp(this.configuration).runQuery(collection, QueryRequest, options)(this.fetch, this.basePath);
    }

}

/**
 * QueueApi - fetch parameter creator
 * @export
 */
export const QueueApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new queue for the company of the currently authenticated user. It is required to specify the queue type as well as the queue name. If the queue type is API_SYNC, all queued events are accessible via this web api. If the queue type is FTP_SYNC resulting events are exported in a destination format and provided on a FTP server. Other queue types are reserved for internal use only.
         * @summary create queue
         * @param {Queue} Queue Queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueue(Queue: Queue, options: any = {}): FetchArgs {
            // verify required parameter 'Queue' is not null or undefined
            if (Queue === null || Queue === undefined) {
                throw new RequiredError('Queue','Required parameter Queue was null or undefined when calling createQueue.');
            }
            const localVarPath = `/queues`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Queue" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Queue || {}) : (Queue || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the queue with the given queue id. The queue can only be removed if the user has permission to modify queues and the queue to delete is assigned to the same company as the calling user.
         * @summary Delete queue
         * @param {string} queueId queueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueue(queueId: string, options: any = {}): FetchArgs {
            // verify required parameter 'queueId' is not null or undefined
            if (queueId === null || queueId === undefined) {
                throw new RequiredError('queueId','Required parameter queueId was null or undefined when calling deleteQueue.');
            }
            const localVarPath = `/queues/{queueId}`
                .replace(`{${"queueId"}}`, encodeURIComponent(String(queueId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single queue identified by the given queue id.
         * @summary find queue by id
         * @param {string} queueId queueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueueById(queueId: string, options: any = {}): FetchArgs {
            // verify required parameter 'queueId' is not null or undefined
            if (queueId === null || queueId === undefined) {
                throw new RequiredError('queueId','Required parameter queueId was null or undefined when calling fetchQueueById.');
            }
            const localVarPath = `/queues/{queueId}`
                .replace(`{${"queueId"}}`, encodeURIComponent(String(queueId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all event queues assigned to the current company and their corresponding queue type.
         * @summary list queues
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueueList(companyId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/queues`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tests the suppressionScript of a given Queue on a given QueuedEvent.
         * @summary test queue suppressionScript on an event
         * @param {QueueWithEvent} QueueWithEvent QueueWithEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuppressionScriptTest(QueueWithEvent: QueueWithEvent, options: any = {}): FetchArgs {
            // verify required parameter 'QueueWithEvent' is not null or undefined
            if (QueueWithEvent === null || QueueWithEvent === undefined) {
                throw new RequiredError('QueueWithEvent','Required parameter QueueWithEvent was null or undefined when calling testSuppressionScriptTest.');
            }
            const localVarPath = `/queues/testSuppressionScriptTest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"QueueWithEvent" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(QueueWithEvent || {}) : (QueueWithEvent || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the queue with the given queue id. It is allowed to change the name as well as the queue type. The company id is read only.
         * @summary update queue
         * @param {string} queueId queueId
         * @param {Queue} Queue Queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueue(queueId: string, Queue: Queue, options: any = {}): FetchArgs {
            // verify required parameter 'queueId' is not null or undefined
            if (queueId === null || queueId === undefined) {
                throw new RequiredError('queueId','Required parameter queueId was null or undefined when calling updateQueue.');
            }
            // verify required parameter 'Queue' is not null or undefined
            if (Queue === null || Queue === undefined) {
                throw new RequiredError('Queue','Required parameter Queue was null or undefined when calling updateQueue.');
            }
            const localVarPath = `/queues/{queueId}`
                .replace(`{${"queueId"}}`, encodeURIComponent(String(queueId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Queue" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Queue || {}) : (Queue || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueueApi - functional programming interface
 * @export
 */
export const QueueApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a new queue for the company of the currently authenticated user. It is required to specify the queue type as well as the queue name. If the queue type is API_SYNC, all queued events are accessible via this web api. If the queue type is FTP_SYNC resulting events are exported in a destination format and provided on a FTP server. Other queue types are reserved for internal use only.
         * @summary create queue
         * @param {Queue} Queue Queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueue(Queue: Queue, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Queue> {
            const localVarFetchArgs = QueueApiFetchParamCreator(configuration).createQueue(Queue, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Remove the queue with the given queue id. The queue can only be removed if the user has permission to modify queues and the queue to delete is assigned to the same company as the calling user.
         * @summary Delete queue
         * @param {string} queueId queueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueue(queueId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = QueueApiFetchParamCreator(configuration).deleteQueue(queueId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetch a single queue identified by the given queue id.
         * @summary find queue by id
         * @param {string} queueId queueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueueById(queueId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Queue> {
            const localVarFetchArgs = QueueApiFetchParamCreator(configuration).fetchQueueById(queueId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all event queues assigned to the current company and their corresponding queue type.
         * @summary list queues
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueueList(companyId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<QueueListResponse> {
            const localVarFetchArgs = QueueApiFetchParamCreator(configuration).fetchQueueList(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Tests the suppressionScript of a given Queue on a given QueuedEvent.
         * @summary test queue suppressionScript on an event
         * @param {QueueWithEvent} QueueWithEvent QueueWithEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuppressionScriptTest(QueueWithEvent: QueueWithEvent, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TestSuppressionScriptResponse> {
            const localVarFetchArgs = QueueApiFetchParamCreator(configuration).testSuppressionScriptTest(QueueWithEvent, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Modify the queue with the given queue id. It is allowed to change the name as well as the queue type. The company id is read only.
         * @summary update queue
         * @param {string} queueId queueId
         * @param {Queue} Queue Queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueue(queueId: string, Queue: Queue, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Queue> {
            const localVarFetchArgs = QueueApiFetchParamCreator(configuration).updateQueue(queueId, Queue, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * QueueApi - factory interface
 * @export
 */
export const QueueApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Create a new queue for the company of the currently authenticated user. It is required to specify the queue type as well as the queue name. If the queue type is API_SYNC, all queued events are accessible via this web api. If the queue type is FTP_SYNC resulting events are exported in a destination format and provided on a FTP server. Other queue types are reserved for internal use only.
         * @summary create queue
         * @param {Queue} Queue Queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueue(Queue: Queue, options?: any) {
            return QueueApiFp(configuration).createQueue(Queue, options)(fetch, basePath);
        },
        /**
         * Remove the queue with the given queue id. The queue can only be removed if the user has permission to modify queues and the queue to delete is assigned to the same company as the calling user.
         * @summary Delete queue
         * @param {string} queueId queueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQueue(queueId: string, options?: any) {
            return QueueApiFp(configuration).deleteQueue(queueId, options)(fetch, basePath);
        },
        /**
         * Fetch a single queue identified by the given queue id.
         * @summary find queue by id
         * @param {string} queueId queueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueueById(queueId: string, options?: any) {
            return QueueApiFp(configuration).fetchQueueById(queueId, options)(fetch, basePath);
        },
        /**
         * Returns all event queues assigned to the current company and their corresponding queue type.
         * @summary list queues
         * @param {string} [companyId] companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchQueueList(companyId?: string, options?: any) {
            return QueueApiFp(configuration).fetchQueueList(companyId, options)(fetch, basePath);
        },
        /**
         * Tests the suppressionScript of a given Queue on a given QueuedEvent.
         * @summary test queue suppressionScript on an event
         * @param {QueueWithEvent} QueueWithEvent QueueWithEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuppressionScriptTest(QueueWithEvent: QueueWithEvent, options?: any) {
            return QueueApiFp(configuration).testSuppressionScriptTest(QueueWithEvent, options)(fetch, basePath);
        },
        /**
         * Modify the queue with the given queue id. It is allowed to change the name as well as the queue type. The company id is read only.
         * @summary update queue
         * @param {string} queueId queueId
         * @param {Queue} Queue Queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueue(queueId: string, Queue: Queue, options?: any) {
            return QueueApiFp(configuration).updateQueue(queueId, Queue, options)(fetch, basePath);
        },
    };
};

/**
 * QueueApi - object-oriented interface
 * @export
 * @class QueueApi
 * @extends {BaseAPI}
 */
export class QueueApi extends BaseAPI {
    /**
     * Create a new queue for the company of the currently authenticated user. It is required to specify the queue type as well as the queue name. If the queue type is API_SYNC, all queued events are accessible via this web api. If the queue type is FTP_SYNC resulting events are exported in a destination format and provided on a FTP server. Other queue types are reserved for internal use only.
     * @summary create queue
     * @param {Queue} Queue Queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    public createQueue(Queue: Queue, options?: any) {
        return QueueApiFp(this.configuration).createQueue(Queue, options)(this.fetch, this.basePath);
    }

    /**
     * Remove the queue with the given queue id. The queue can only be removed if the user has permission to modify queues and the queue to delete is assigned to the same company as the calling user.
     * @summary Delete queue
     * @param {string} queueId queueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    public deleteQueue(queueId: string, options?: any) {
        return QueueApiFp(this.configuration).deleteQueue(queueId, options)(this.fetch, this.basePath);
    }

    /**
     * Fetch a single queue identified by the given queue id.
     * @summary find queue by id
     * @param {string} queueId queueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    public fetchQueueById(queueId: string, options?: any) {
        return QueueApiFp(this.configuration).fetchQueueById(queueId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all event queues assigned to the current company and their corresponding queue type.
     * @summary list queues
     * @param {string} [companyId] companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    public fetchQueueList(companyId?: string, options?: any) {
        return QueueApiFp(this.configuration).fetchQueueList(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Tests the suppressionScript of a given Queue on a given QueuedEvent.
     * @summary test queue suppressionScript on an event
     * @param {QueueWithEvent} QueueWithEvent QueueWithEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    public testSuppressionScriptTest(QueueWithEvent: QueueWithEvent, options?: any) {
        return QueueApiFp(this.configuration).testSuppressionScriptTest(QueueWithEvent, options)(this.fetch, this.basePath);
    }

    /**
     * Modify the queue with the given queue id. It is allowed to change the name as well as the queue type. The company id is read only.
     * @summary update queue
     * @param {string} queueId queueId
     * @param {Queue} Queue Queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    public updateQueue(queueId: string, Queue: Queue, options?: any) {
        return QueueApiFp(this.configuration).updateQueue(queueId, Queue, options)(this.fetch, this.basePath);
    }

}

/**
 * ShipmentsApi - fetch parameter creator
 * @export
 */
export const ShipmentsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Convert List of TransportOrders to shipments
         * @param {TransportOrderListRequest} TransportOrderListRequest TransportOrderListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTransportOrdersAsShipments(TransportOrderListRequest: TransportOrderListRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderListRequest' is not null or undefined
            if (TransportOrderListRequest === null || TransportOrderListRequest === undefined) {
                throw new RequiredError('TransportOrderListRequest','Required parameter TransportOrderListRequest was null or undefined when calling viewTransportOrdersAsShipments.');
            }
            const localVarPath = `/shipments/viewTransportOrdersAsShipment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderListRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderListRequest || {}) : (TransportOrderListRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShipmentsApi - functional programming interface
 * @export
 */
export const ShipmentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Convert List of TransportOrders to shipments
         * @param {TransportOrderListRequest} TransportOrderListRequest TransportOrderListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTransportOrdersAsShipments(TransportOrderListRequest: TransportOrderListRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShipmentResponse> {
            const localVarFetchArgs = ShipmentsApiFetchParamCreator(configuration).viewTransportOrdersAsShipments(TransportOrderListRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ShipmentsApi - factory interface
 * @export
 */
export const ShipmentsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Convert List of TransportOrders to shipments
         * @param {TransportOrderListRequest} TransportOrderListRequest TransportOrderListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTransportOrdersAsShipments(TransportOrderListRequest: TransportOrderListRequest, options?: any) {
            return ShipmentsApiFp(configuration).viewTransportOrdersAsShipments(TransportOrderListRequest, options)(fetch, basePath);
        },
    };
};

/**
 * ShipmentsApi - object-oriented interface
 * @export
 * @class ShipmentsApi
 * @extends {BaseAPI}
 */
export class ShipmentsApi extends BaseAPI {
    /**
     * 
     * @summary Convert List of TransportOrders to shipments
     * @param {TransportOrderListRequest} TransportOrderListRequest TransportOrderListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public viewTransportOrdersAsShipments(TransportOrderListRequest: TransportOrderListRequest, options?: any) {
        return ShipmentsApiFp(this.configuration).viewTransportOrdersAsShipments(TransportOrderListRequest, options)(this.fetch, this.basePath);
    }

}

/**
 * TrackingApi - fetch parameter creator
 * @export
 */
export const TrackingApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if transport order has temperature/reefer data from positions. Used to hide temperature tab for non-food carriers.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHasTemperatureData(transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fetchHasTemperatureData.');
            }
            const localVarPath = `/tracking/hasTemperatureData/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current eta for the specified stop
         * @param {string} stopId stopId
         * @param {string} transportId transportId
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderEta(stopId: string, transportId: string, transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'stopId' is not null or undefined
            if (stopId === null || stopId === undefined) {
                throw new RequiredError('stopId','Required parameter stopId was null or undefined when calling fetchTransportOrderEta.');
            }
            // verify required parameter 'transportId' is not null or undefined
            if (transportId === null || transportId === undefined) {
                throw new RequiredError('transportId','Required parameter transportId was null or undefined when calling fetchTransportOrderEta.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fetchTransportOrderEta.');
            }
            const localVarPath = `/eta/{transportOrderId}/{transportId}/{stopId}`
                .replace(`{${"stopId"}}`, encodeURIComponent(String(stopId)))
                .replace(`{${"transportId"}}`, encodeURIComponent(String(transportId)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get temperature history from position reefer/cooler data for the transport order.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderTemperatureHistory(transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling fetchTransportOrderTemperatureHistory.');
            }
            const localVarPath = `/tracking/temperatureHistory/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches all vehicles visible for the user with last valid position. With default parameters it will only return vehicles with positions in last 90 days.
         * @param {number} [onlyWithNewPositionsInLastXDays] onlyWithNewPositionsInLastXDays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehiclesWithPosition(onlyWithNewPositionsInLastXDays?: number, options: any = {}): FetchArgs {
            const localVarPath = `/tracking/vehiclesWithPosition`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (onlyWithNewPositionsInLastXDays !== undefined) {
                localVarQueryParameter['onlyWithNewPositionsInLastXDays'] = onlyWithNewPositionsInLastXDays;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [DEPRECATED -> use fetchTransportOrderEta instead] Get current eta for stop
         * @param {number} stopNumber stopNumber
         * @param {number} transportNumber transportNumber
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourEta(stopNumber: number, transportNumber: number, transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'stopNumber' is not null or undefined
            if (stopNumber === null || stopNumber === undefined) {
                throw new RequiredError('stopNumber','Required parameter stopNumber was null or undefined when calling getTourEta.');
            }
            // verify required parameter 'transportNumber' is not null or undefined
            if (transportNumber === null || transportNumber === undefined) {
                throw new RequiredError('transportNumber','Required parameter transportNumber was null or undefined when calling getTourEta.');
            }
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling getTourEta.');
            }
            const localVarPath = `/geoLocations/tourEta/{transportOrderId}/{transportNumber}/{stopNumber}`
                .replace(`{${"stopNumber"}}`, encodeURIComponent(String(stopNumber)))
                .replace(`{${"transportNumber"}}`, encodeURIComponent(String(transportNumber)))
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get polyline for tour
         * @param {string} transportOrderId transportOrderId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourPolyline(transportOrderId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling getTourPolyline.');
            }
            const localVarPath = `/geoLocations/tourPolyline/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (epsilon !== undefined) {
                localVarQueryParameter['epsilon'] = epsilon;
            }

            if (resolveAddresses !== undefined) {
                localVarQueryParameter['resolveAddresses'] = resolveAddresses;
            }

            if (segmentByEstimatedStates !== undefined) {
                localVarQueryParameter['segmentByEstimatedStates'] = segmentByEstimatedStates;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get polyline for tour by observer access token  It shall return  - the last position if observer.hideDrivingLane == true  - all positions otherwise 
         * @param {string} accessToken accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourPolylineByPrivateAccessToken(accessToken: string, options: any = {}): FetchArgs {
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken','Required parameter accessToken was null or undefined when calling getTourPolylineByPrivateAccessToken.');
            }
            const localVarPath = `/geoLocations/tourPolyline/byAccessToken/{accessToken}`
                .replace(`{${"accessToken"}}`, encodeURIComponent(String(accessToken)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get polyline for vehicle
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from','Required parameter from was null or undefined when calling getVehiclePolylineFromTo.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to','Required parameter to was null or undefined when calling getVehiclePolylineFromTo.');
            }
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehiclePolylineFromTo.');
            }
            const localVarPath = `/geoLocations/vehiclePolyline/{vehicleId}/{from}/{to}`
                .replace(`{${"from"}}`, encodeURIComponent(String(from)))
                .replace(`{${"to"}}`, encodeURIComponent(String(to)))
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (epsilon !== undefined) {
                localVarQueryParameter['epsilon'] = epsilon;
            }

            if (resolveAddresses !== undefined) {
                localVarQueryParameter['resolveAddresses'] = resolveAddresses;
            }

            if (segmentByEstimatedStates !== undefined) {
                localVarQueryParameter['segmentByEstimatedStates'] = segmentByEstimatedStates;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get polyline for vehicle split by transport orders on this vehicle in given time slot
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineSplittedByTransportOrders(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from','Required parameter from was null or undefined when calling getVehiclePolylineSplittedByTransportOrders.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to','Required parameter to was null or undefined when calling getVehiclePolylineSplittedByTransportOrders.');
            }
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehiclePolylineSplittedByTransportOrders.');
            }
            const localVarPath = `/geoLocations/vehiclePolylineSplittedByTransportOrders/{vehicleId}/{from}/{to}`
                .replace(`{${"from"}}`, encodeURIComponent(String(from)))
                .replace(`{${"to"}}`, encodeURIComponent(String(to)))
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (epsilon !== undefined) {
                localVarQueryParameter['epsilon'] = epsilon;
            }

            if (resolveAddresses !== undefined) {
                localVarQueryParameter['resolveAddresses'] = resolveAddresses;
            }

            if (segmentByEstimatedStates !== undefined) {
                localVarQueryParameter['segmentByEstimatedStates'] = segmentByEstimatedStates;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get polyline with positions  for vehicle
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineWithPositionsFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from','Required parameter from was null or undefined when calling getVehiclePolylineWithPositionsFromTo.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to','Required parameter to was null or undefined when calling getVehiclePolylineWithPositionsFromTo.');
            }
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehiclePolylineWithPositionsFromTo.');
            }
            const localVarPath = `/geoLocations/vehiclePolylineWithPositions/{vehicleId}/{from}/{to}`
                .replace(`{${"from"}}`, encodeURIComponent(String(from)))
                .replace(`{${"to"}}`, encodeURIComponent(String(to)))
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (epsilon !== undefined) {
                localVarQueryParameter['epsilon'] = epsilon;
            }

            if (resolveAddresses !== undefined) {
                localVarQueryParameter['resolveAddresses'] = resolveAddresses;
            }

            if (segmentByEstimatedStates !== undefined) {
                localVarQueryParameter['segmentByEstimatedStates'] = segmentByEstimatedStates;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Positions of the given vehicle based on the from and to times.
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePositions(from: string, to: string, vehicleId: string, options: any = {}): FetchArgs {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from','Required parameter from was null or undefined when calling getVehiclePositions.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to','Required parameter to was null or undefined when calling getVehiclePositions.');
            }
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehiclePositions.');
            }
            const localVarPath = `/geoLocations/getVehiclePositions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post current eta for stop
         * @param {string} transportOrderId transportOrderId
         * @param {PostStopEtasRequest} PostStopEtasRequest PostStopEtasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTourEta(transportOrderId: string, PostStopEtasRequest: PostStopEtasRequest, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling postTourEta.');
            }
            // verify required parameter 'PostStopEtasRequest' is not null or undefined
            if (PostStopEtasRequest === null || PostStopEtasRequest === undefined) {
                throw new RequiredError('PostStopEtasRequest','Required parameter PostStopEtasRequest was null or undefined when calling postTourEta.');
            }
            const localVarPath = `/geoLocations/tourEta/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PostStopEtasRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(PostStopEtasRequest || {}) : (PostStopEtasRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Tracking currentPosition
         * @param {TelematicData} TelematicData TelematicData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrackingPosition(TelematicData: TelematicData, options: any = {}): FetchArgs {
            // verify required parameter 'TelematicData' is not null or undefined
            if (TelematicData === null || TelematicData === undefined) {
                throw new RequiredError('TelematicData','Required parameter TelematicData was null or undefined when calling postTrackingPosition.');
            }
            const localVarPath = `/geoLocations/positionRequests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TelematicData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TelematicData || {}) : (TelematicData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingApi - functional programming interface
 * @export
 */
export const TrackingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if transport order has temperature/reefer data from positions. Used to hide temperature tab for non-food carriers.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHasTemperatureData(transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<HasTemperatureDataResponse> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).fetchHasTemperatureData(transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get current eta for the specified stop
         * @param {string} stopId stopId
         * @param {string} transportId transportId
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderEta(stopId: string, transportId: string, transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StopEtaResult> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).fetchTransportOrderEta(stopId, transportId, transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get temperature history from position reefer/cooler data for the transport order.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderTemperatureHistory(transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TemperatureHistoryResponse> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).fetchTransportOrderTemperatureHistory(transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Fetches all vehicles visible for the user with last valid position. With default parameters it will only return vehicles with positions in last 90 days.
         * @param {number} [onlyWithNewPositionsInLastXDays] onlyWithNewPositionsInLastXDays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehiclesWithPosition(onlyWithNewPositionsInLastXDays?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehiclesWithPositionResponse> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).fetchVehiclesWithPosition(onlyWithNewPositionsInLastXDays, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary [DEPRECATED -> use fetchTransportOrderEta instead] Get current eta for stop
         * @param {number} stopNumber stopNumber
         * @param {number} transportNumber transportNumber
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourEta(stopNumber: number, transportNumber: number, transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StopEtaResult> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).getTourEta(stopNumber, transportNumber, transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get polyline for tour
         * @param {string} transportOrderId transportOrderId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourPolyline(transportOrderId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TourPolylineResponse> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).getTourPolyline(transportOrderId, epsilon, resolveAddresses, segmentByEstimatedStates, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get polyline for tour by observer access token  It shall return  - the last position if observer.hideDrivingLane == true  - all positions otherwise 
         * @param {string} accessToken accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourPolylineByPrivateAccessToken(accessToken: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TourPolylineResponse> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).getTourPolylineByPrivateAccessToken(accessToken, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get polyline for vehicle
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehiclePolyline> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).getVehiclePolylineFromTo(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get polyline for vehicle split by transport orders on this vehicle in given time slot
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineSplittedByTransportOrders(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TourPolylinesForVehicle> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).getVehiclePolylineSplittedByTransportOrders(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get polyline with positions  for vehicle
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineWithPositionsFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehiclePolylineWithPositions> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).getVehiclePolylineWithPositionsFromTo(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Positions of the given vehicle based on the from and to times.
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePositions(from: string, to: string, vehicleId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehiclePositionsResponse> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).getVehiclePositions(from, to, vehicleId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Post current eta for stop
         * @param {string} transportOrderId transportOrderId
         * @param {PostStopEtasRequest} PostStopEtasRequest PostStopEtasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTourEta(transportOrderId: string, PostStopEtasRequest: PostStopEtasRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Result> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).postTourEta(transportOrderId, PostStopEtasRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Post Tracking currentPosition
         * @param {TelematicData} TelematicData TelematicData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrackingPosition(TelematicData: TelematicData, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TelematicDataResponse> {
            const localVarFetchArgs = TrackingApiFetchParamCreator(configuration).postTrackingPosition(TelematicData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TrackingApi - factory interface
 * @export
 */
export const TrackingApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Check if transport order has temperature/reefer data from positions. Used to hide temperature tab for non-food carriers.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHasTemperatureData(transportOrderId: string, options?: any) {
            return TrackingApiFp(configuration).fetchHasTemperatureData(transportOrderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get current eta for the specified stop
         * @param {string} stopId stopId
         * @param {string} transportId transportId
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderEta(stopId: string, transportId: string, transportOrderId: string, options?: any) {
            return TrackingApiFp(configuration).fetchTransportOrderEta(stopId, transportId, transportOrderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get temperature history from position reefer/cooler data for the transport order.
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderTemperatureHistory(transportOrderId: string, options?: any) {
            return TrackingApiFp(configuration).fetchTransportOrderTemperatureHistory(transportOrderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Fetches all vehicles visible for the user with last valid position. With default parameters it will only return vehicles with positions in last 90 days.
         * @param {number} [onlyWithNewPositionsInLastXDays] onlyWithNewPositionsInLastXDays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVehiclesWithPosition(onlyWithNewPositionsInLastXDays?: number, options?: any) {
            return TrackingApiFp(configuration).fetchVehiclesWithPosition(onlyWithNewPositionsInLastXDays, options)(fetch, basePath);
        },
        /**
         * 
         * @summary [DEPRECATED -> use fetchTransportOrderEta instead] Get current eta for stop
         * @param {number} stopNumber stopNumber
         * @param {number} transportNumber transportNumber
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourEta(stopNumber: number, transportNumber: number, transportOrderId: string, options?: any) {
            return TrackingApiFp(configuration).getTourEta(stopNumber, transportNumber, transportOrderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get polyline for tour
         * @param {string} transportOrderId transportOrderId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourPolyline(transportOrderId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
            return TrackingApiFp(configuration).getTourPolyline(transportOrderId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get polyline for tour by observer access token  It shall return  - the last position if observer.hideDrivingLane == true  - all positions otherwise 
         * @param {string} accessToken accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTourPolylineByPrivateAccessToken(accessToken: string, options?: any) {
            return TrackingApiFp(configuration).getTourPolylineByPrivateAccessToken(accessToken, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get polyline for vehicle
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
            return TrackingApiFp(configuration).getVehiclePolylineFromTo(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get polyline for vehicle split by transport orders on this vehicle in given time slot
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineSplittedByTransportOrders(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
            return TrackingApiFp(configuration).getVehiclePolylineSplittedByTransportOrders(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get polyline with positions  for vehicle
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {number} [epsilon] epsilon
         * @param {boolean} [resolveAddresses] resolveAddresses
         * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePolylineWithPositionsFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
            return TrackingApiFp(configuration).getVehiclePolylineWithPositionsFromTo(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Positions of the given vehicle based on the from and to times.
         * @param {string} from from
         * @param {string} to to
         * @param {string} vehicleId vehicleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclePositions(from: string, to: string, vehicleId: string, options?: any) {
            return TrackingApiFp(configuration).getVehiclePositions(from, to, vehicleId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Post current eta for stop
         * @param {string} transportOrderId transportOrderId
         * @param {PostStopEtasRequest} PostStopEtasRequest PostStopEtasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTourEta(transportOrderId: string, PostStopEtasRequest: PostStopEtasRequest, options?: any) {
            return TrackingApiFp(configuration).postTourEta(transportOrderId, PostStopEtasRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Post Tracking currentPosition
         * @param {TelematicData} TelematicData TelematicData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrackingPosition(TelematicData: TelematicData, options?: any) {
            return TrackingApiFp(configuration).postTrackingPosition(TelematicData, options)(fetch, basePath);
        },
    };
};

/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
export class TrackingApi extends BaseAPI {
    /**
     * 
     * @summary Check if transport order has temperature/reefer data from positions. Used to hide temperature tab for non-food carriers.
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public fetchHasTemperatureData(transportOrderId: string, options?: any) {
        return TrackingApiFp(this.configuration).fetchHasTemperatureData(transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get current eta for the specified stop
     * @param {string} stopId stopId
     * @param {string} transportId transportId
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public fetchTransportOrderEta(stopId: string, transportId: string, transportOrderId: string, options?: any) {
        return TrackingApiFp(this.configuration).fetchTransportOrderEta(stopId, transportId, transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get temperature history from position reefer/cooler data for the transport order.
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public fetchTransportOrderTemperatureHistory(transportOrderId: string, options?: any) {
        return TrackingApiFp(this.configuration).fetchTransportOrderTemperatureHistory(transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Fetches all vehicles visible for the user with last valid position. With default parameters it will only return vehicles with positions in last 90 days.
     * @param {number} [onlyWithNewPositionsInLastXDays] onlyWithNewPositionsInLastXDays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public fetchVehiclesWithPosition(onlyWithNewPositionsInLastXDays?: number, options?: any) {
        return TrackingApiFp(this.configuration).fetchVehiclesWithPosition(onlyWithNewPositionsInLastXDays, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary [DEPRECATED -> use fetchTransportOrderEta instead] Get current eta for stop
     * @param {number} stopNumber stopNumber
     * @param {number} transportNumber transportNumber
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getTourEta(stopNumber: number, transportNumber: number, transportOrderId: string, options?: any) {
        return TrackingApiFp(this.configuration).getTourEta(stopNumber, transportNumber, transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get polyline for tour
     * @param {string} transportOrderId transportOrderId
     * @param {number} [epsilon] epsilon
     * @param {boolean} [resolveAddresses] resolveAddresses
     * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getTourPolyline(transportOrderId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
        return TrackingApiFp(this.configuration).getTourPolyline(transportOrderId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get polyline for tour by observer access token  It shall return  - the last position if observer.hideDrivingLane == true  - all positions otherwise 
     * @param {string} accessToken accessToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getTourPolylineByPrivateAccessToken(accessToken: string, options?: any) {
        return TrackingApiFp(this.configuration).getTourPolylineByPrivateAccessToken(accessToken, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get polyline for vehicle
     * @param {string} from from
     * @param {string} to to
     * @param {string} vehicleId vehicleId
     * @param {number} [epsilon] epsilon
     * @param {boolean} [resolveAddresses] resolveAddresses
     * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getVehiclePolylineFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
        return TrackingApiFp(this.configuration).getVehiclePolylineFromTo(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get polyline for vehicle split by transport orders on this vehicle in given time slot
     * @param {string} from from
     * @param {string} to to
     * @param {string} vehicleId vehicleId
     * @param {number} [epsilon] epsilon
     * @param {boolean} [resolveAddresses] resolveAddresses
     * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getVehiclePolylineSplittedByTransportOrders(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
        return TrackingApiFp(this.configuration).getVehiclePolylineSplittedByTransportOrders(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get polyline with positions  for vehicle
     * @param {string} from from
     * @param {string} to to
     * @param {string} vehicleId vehicleId
     * @param {number} [epsilon] epsilon
     * @param {boolean} [resolveAddresses] resolveAddresses
     * @param {boolean} [segmentByEstimatedStates] segmentByEstimatedStates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getVehiclePolylineWithPositionsFromTo(from: string, to: string, vehicleId: string, epsilon?: number, resolveAddresses?: boolean, segmentByEstimatedStates?: boolean, options?: any) {
        return TrackingApiFp(this.configuration).getVehiclePolylineWithPositionsFromTo(from, to, vehicleId, epsilon, resolveAddresses, segmentByEstimatedStates, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Positions of the given vehicle based on the from and to times.
     * @param {string} from from
     * @param {string} to to
     * @param {string} vehicleId vehicleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getVehiclePositions(from: string, to: string, vehicleId: string, options?: any) {
        return TrackingApiFp(this.configuration).getVehiclePositions(from, to, vehicleId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Post current eta for stop
     * @param {string} transportOrderId transportOrderId
     * @param {PostStopEtasRequest} PostStopEtasRequest PostStopEtasRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public postTourEta(transportOrderId: string, PostStopEtasRequest: PostStopEtasRequest, options?: any) {
        return TrackingApiFp(this.configuration).postTourEta(transportOrderId, PostStopEtasRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Post Tracking currentPosition
     * @param {TelematicData} TelematicData TelematicData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public postTrackingPosition(TelematicData: TelematicData, options?: any) {
        return TrackingApiFp(this.configuration).postTrackingPosition(TelematicData, options)(this.fetch, this.basePath);
    }

}

/**
 * TransportOrderApi - fetch parameter creator
 * @export
 */
export const TransportOrderApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
         * @summary add observer to transport order
         * @param {string} orderId orderId
         * @param {Observer} Observer Observer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObserver(orderId: string, Observer: Observer, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling addObserver.');
            }
            // verify required parameter 'Observer' is not null or undefined
            if (Observer === null || Observer === undefined) {
                throw new RequiredError('Observer','Required parameter Observer was null or undefined when calling addObserver.');
            }
            const localVarPath = `/transportOrders/{orderId}/observers`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Observer" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Observer || {}) : (Observer || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
         * @summary add observer to transport order
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {Observer} Observer Observer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObserverByExternalTransportOrderId(externalTransportOrderId: string, Observer: Observer, options: any = {}): FetchArgs {
            // verify required parameter 'externalTransportOrderId' is not null or undefined
            if (externalTransportOrderId === null || externalTransportOrderId === undefined) {
                throw new RequiredError('externalTransportOrderId','Required parameter externalTransportOrderId was null or undefined when calling addObserverByExternalTransportOrderId.');
            }
            // verify required parameter 'Observer' is not null or undefined
            if (Observer === null || Observer === undefined) {
                throw new RequiredError('Observer','Required parameter Observer was null or undefined when calling addObserverByExternalTransportOrderId.');
            }
            const localVarPath = `/transportOrders/{externalTransportOrderId}/observerAddByExternalTransportOrderId`
                .replace(`{${"externalTransportOrderId"}}`, encodeURIComponent(String(externalTransportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Observer" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(Observer || {}) : (Observer || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will assign a company and/or a vehicle to a Transport-Order. To assign a company, the field targetCompanyId or partnerId needs to be filled.  To assign a vehicle, the field vehicleId or externalVehicleId needs to be filled. The vehicle can only be assigned, if the current company is also the targetCompany of the transport-order.  Depending on the configuration of the logenios account, assigning a targetVehicle may trigger the a message to the vehicle integrated telematic system containing the transport order to be executed.  At least one of these fields need to be filled, the others can stay empty, depending on your intention.  If the transport order is in status canceled, a assign call that modifies   * the assigned vehicle   resets it's status from canceled to accepted, because it is assumed that the formerly canceled transport order  shall be done now after the new assigment has happened. 
         * @summary assign
         * @param {string} orderId orderId
         * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTransportOrder(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling assignTransportOrder.');
            }
            // verify required parameter 'TransportOrderAssignRequest' is not null or undefined
            if (TransportOrderAssignRequest === null || TransportOrderAssignRequest === undefined) {
                throw new RequiredError('TransportOrderAssignRequest','Required parameter TransportOrderAssignRequest was null or undefined when calling assignTransportOrder.');
            }
            const localVarPath = `/transportOrders/{orderId}/assign`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderAssignRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderAssignRequest || {}) : (TransportOrderAssignRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will set the status of a transport-order to CANCELED and send a message to the telematic.
         * @summary cancel transport order
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransportOrder(transportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'transportOrderId' is not null or undefined
            if (transportOrderId === null || transportOrderId === undefined) {
                throw new RequiredError('transportOrderId','Required parameter transportOrderId was null or undefined when calling cancelTransportOrder.');
            }
            const localVarPath = `/transportOrders/cancel/{transportOrderId}`
                .replace(`{${"transportOrderId"}}`, encodeURIComponent(String(transportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return a count of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Count transport orders
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchTransportOrderListFilterRequest' is not null or undefined
            if (FetchTransportOrderListFilterRequest === null || FetchTransportOrderListFilterRequest === undefined) {
                throw new RequiredError('FetchTransportOrderListFilterRequest','Required parameter FetchTransportOrderListFilterRequest was null or undefined when calling countTransportOrdersWithFilter.');
            }
            const localVarPath = `/transportOrders/countTransportOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchTransportOrderListFilterRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchTransportOrderListFilterRequest || {}) : (FetchTransportOrderListFilterRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will link one of your company's Transport-Orders to another company.
         * @summary create linked transport order
         * @param {LinkTransportOrderRequest} LinkTransportOrderRequest LinkTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkedTransportOrder(LinkTransportOrderRequest: LinkTransportOrderRequest, options: any = {}): FetchArgs {
            // verify required parameter 'LinkTransportOrderRequest' is not null or undefined
            if (LinkTransportOrderRequest === null || LinkTransportOrderRequest === undefined) {
                throw new RequiredError('LinkTransportOrderRequest','Required parameter LinkTransportOrderRequest was null or undefined when calling createLinkedTransportOrder.');
            }
            const localVarPath = `/transportOrders/link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"LinkTransportOrderRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(LinkTransportOrderRequest || {}) : (LinkTransportOrderRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will create multiple Transport-Orders at once from a WrappedTransportOrdersRequest, which should contain a list of Transport-Orders.
         * @summary create multiple transport orders
         * @param {WrappedTransportOrdersRequest} WrappedTransportOrdersRequest WrappedTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultipleTransportOrders(WrappedTransportOrdersRequest: WrappedTransportOrdersRequest, options: any = {}): FetchArgs {
            // verify required parameter 'WrappedTransportOrdersRequest' is not null or undefined
            if (WrappedTransportOrdersRequest === null || WrappedTransportOrdersRequest === undefined) {
                throw new RequiredError('WrappedTransportOrdersRequest','Required parameter WrappedTransportOrdersRequest was null or undefined when calling createMultipleTransportOrders.');
            }
            const localVarPath = `/transportOrders/wrapped`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"WrappedTransportOrdersRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(WrappedTransportOrdersRequest || {}) : (WrappedTransportOrdersRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId.  **Important Remark**: This function shall only be called on transport orders originating from the current company.  Should this method be called on transport orders where the current company is target company and not source company the backend rejects the changes with a FORBIDDEN response.   Use the optional mode parameter to specify whether the existing transport order shall be replaced or partially  modified by the provided post data.   Options for the mode parameter: - REPLACE: (default) The whole content of the transport order is replaced with the updated version - PATCH: The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is patched with the newly                    provided version. If the part is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    To determine if a new transport order shall be created or an existing transport order shall be updated, the following rules are applied:  1. if the field _id is populated, the system will lookup the transportOrder with the specified _id. 2. if _id is not present: the field externalTransportOrderId will be used to lookup all transportOrders with the externalTransportOrderId.    If none is found, an new transport order is created. If exactly one transportOrder exists, the transportOrder is updated.     If multiple transportOrders exist and the call is made by the source company and exactly one transportOrder has companyId = source company id    the transportOrder is updated. Otherwise the update operation will fail and an exception will be returned. If the target company wants to     update a transport order and the transport order can't be identified without id conflict (e.g. because multiple different source companies have    transport orders with the same externalTransportOrderId) an error will be returned.        If mode is PATCH: The field transportOrderId can be populated with an index expression to reference to a transportOrder based on the transportId, if the transportId    is unique and the expression resolves to exactly one transport order. The syntax for this index expression is ${TRANSPORT:<transportId>}.    If multiple transport orders match to that index operator, the update will fail. 
         * @summary create transport order
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrder(TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrder' is not null or undefined
            if (TransportOrder === null || TransportOrder === undefined) {
                throw new RequiredError('TransportOrder','Required parameter TransportOrder was null or undefined when calling createOrModifyTransportOrder.');
            }
            const localVarPath = `/transportOrders/createOrModify`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fixStopsOfLinkedTransports !== undefined) {
                localVarQueryParameter['fixStopsOfLinkedTransports'] = fixStopsOfLinkedTransports;
            }

            if (forceOverrideDependedStatesOnModifyTransportOrder !== undefined) {
                localVarQueryParameter['forceOverrideDependedStatesOnModifyTransportOrder'] = forceOverrideDependedStatesOnModifyTransportOrder;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (resolveCompanySpecificMapping !== undefined) {
                localVarQueryParameter['resolveCompanySpecificMapping'] = resolveCompanySpecificMapping;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrder" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrder || {}) : (TransportOrder || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
         * @summary create transport order
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportOrder(TransportOrder: TransportOrder, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrder' is not null or undefined
            if (TransportOrder === null || TransportOrder === undefined) {
                throw new RequiredError('TransportOrder','Required parameter TransportOrder was null or undefined when calling createTransportOrder.');
            }
            const localVarPath = `/transportOrders/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrder" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrder || {}) : (TransportOrder || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoints provides an information to which sub contractor the given transport order was assigned.  It returns the private access token which can be used to retrieve the transportOrder, to submit a status or to fetch and submit attachments.   Further, this endpoint returns an url to a mobile website where the transport order can be viewed without  login.  The permission TO_ASSIGN_VEHICLE is required to call this endpoint
         * @summary fetch information to whom this transport order was assigned
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAssignedDeviceInfo(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchAssignedDeviceInfo.');
            }
            const localVarPath = `/transportOrders/{orderId}/assignedDeviceInfo`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
         * @summary fetch information on the observer of an transport order
         * @param {string} observerId observerId
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverInfo(observerId: string, orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'observerId' is not null or undefined
            if (observerId === null || observerId === undefined) {
                throw new RequiredError('observerId','Required parameter observerId was null or undefined when calling fetchObserverInfo.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchObserverInfo.');
            }
            const localVarPath = `/transportOrders/{orderId}/fetchObserverInfo/{observerId}`
                .replace(`{${"observerId"}}`, encodeURIComponent(String(observerId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
         * @summary fetch information on the observer of an transport order
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {string} observerId observerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverInfoByExternalTransportOrderId(externalTransportOrderId: string, observerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'externalTransportOrderId' is not null or undefined
            if (externalTransportOrderId === null || externalTransportOrderId === undefined) {
                throw new RequiredError('externalTransportOrderId','Required parameter externalTransportOrderId was null or undefined when calling fetchObserverInfoByExternalTransportOrderId.');
            }
            // verify required parameter 'observerId' is not null or undefined
            if (observerId === null || observerId === undefined) {
                throw new RequiredError('observerId','Required parameter observerId was null or undefined when calling fetchObserverInfoByExternalTransportOrderId.');
            }
            const localVarPath = `/transportOrders/{externalTransportOrderId}/fetchObserverInfoByExternalId/{observerId}`
                .replace(`{${"externalTransportOrderId"}}`, encodeURIComponent(String(externalTransportOrderId)))
                .replace(`{${"observerId"}}`, encodeURIComponent(String(observerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return the Transport-Order of another company referenced by the external transport-order id. Appropriate permissions are needed.
         * @summary Get transport order by externalTransportOrderId
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByExternalId(externalTransportOrderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'externalTransportOrderId' is not null or undefined
            if (externalTransportOrderId === null || externalTransportOrderId === undefined) {
                throw new RequiredError('externalTransportOrderId','Required parameter externalTransportOrderId was null or undefined when calling fetchTransportOrderByExternalId.');
            }
            const localVarPath = `/transportOrders/byExternalId/{externalTransportOrderId}`
                .replace(`{${"externalTransportOrderId"}}`, encodeURIComponent(String(externalTransportOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id.
         * @summary get transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderById(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchTransportOrderById.');
            }
            const localVarPath = `/transportOrders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enter the private access token of an observer to get the TransportOrder-Object that it's observing.
         * @summary get transport order by observer access token
         * @param {string} privateAccessToken privateAccessToken
         * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByPrivateAccessToken(privateAccessToken: string, includeDepotsFromLinkedOrders?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'privateAccessToken' is not null or undefined
            if (privateAccessToken === null || privateAccessToken === undefined) {
                throw new RequiredError('privateAccessToken','Required parameter privateAccessToken was null or undefined when calling fetchTransportOrderByPrivateAccessToken.');
            }
            const localVarPath = `/transportOrders/byAccessToken/{privateAccessToken}`
                .replace(`{${"privateAccessToken"}}`, encodeURIComponent(String(privateAccessToken)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDepotsFromLinkedOrders !== undefined) {
                localVarQueryParameter['includeDepotsFromLinkedOrders'] = includeDepotsFromLinkedOrders;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return the history of a Transport-Order. It will contain all changes that have been done on this Transport-Order. Use the Transport-Order id as URL-parameter.
         * @summary get history
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderHistory(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchTransportOrderHistory.');
            }
            const localVarPath = `/transportOrders/{orderId}/history`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enter the private access token of an observer to get the TransportOrder history.
         * @summary get history by observer access token
         * @param {string} privateAccessToken privateAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderHistoryByPrivateAccessToken(privateAccessToken: string, options: any = {}): FetchArgs {
            // verify required parameter 'privateAccessToken' is not null or undefined
            if (privateAccessToken === null || privateAccessToken === undefined) {
                throw new RequiredError('privateAccessToken','Required parameter privateAccessToken was null or undefined when calling fetchTransportOrderHistoryByPrivateAccessToken.');
            }
            const localVarPath = `/transportOrders/byAccessToken/{privateAccessToken}/history`
                .replace(`{${"privateAccessToken"}}`, encodeURIComponent(String(privateAccessToken)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return all logs of a Transport-Order. Use the Transport-Order id as URL-parameter.
         * @summary get logs
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderLogs(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling fetchTransportOrderLogs.');
            }
            const localVarPath = `/transportOrders/{orderId}/log`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Get list of transport orders
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrders(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options: any = {}): FetchArgs {
            const localVarPath = `/transportOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (attachmentCategories) {
                localVarQueryParameter['attachmentCategories'] = attachmentCategories.join(COLLECTION_FORMATS["csv"]);
            }

            if (begin !== undefined) {
                localVarQueryParameter['begin'] = (begin as any).toISOString();
            }

            if (countDocuments !== undefined) {
                localVarQueryParameter['countDocuments'] = countDocuments;
            }

            if (dateTimeField !== undefined) {
                localVarQueryParameter['dateTimeField'] = dateTimeField;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any).toISOString();
            }

            if (exactSearchTermMatch !== undefined) {
                localVarQueryParameter['exactSearchTermMatch'] = exactSearchTermMatch;
            }

            if (hasAttachment !== undefined) {
                localVarQueryParameter['hasAttachment'] = hasAttachment;
            }

            if (modifiedSince !== undefined) {
                localVarQueryParameter['modifiedSince'] = (modifiedSince as any).toISOString();
            }

            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (partnerNameRegex !== undefined) {
                localVarQueryParameter['partnerNameRegex'] = partnerNameRegex;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (trailer !== undefined) {
                localVarQueryParameter['trailer'] = trailer;
            }

            if (validationStatus !== undefined) {
                localVarQueryParameter['validationStatus'] = validationStatus;
            }

            if (vehicle !== undefined) {
                localVarQueryParameter['vehicle'] = vehicle;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Get list of transport orders
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FetchTransportOrderListFilterRequest' is not null or undefined
            if (FetchTransportOrderListFilterRequest === null || FetchTransportOrderListFilterRequest === undefined) {
                throw new RequiredError('FetchTransportOrderListFilterRequest','Required parameter FetchTransportOrderListFilterRequest was null or undefined when calling fetchTransportOrdersWithFilter.');
            }
            const localVarPath = `/transportOrders/fetchTransportOrders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FetchTransportOrderListFilterRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FetchTransportOrderListFilterRequest || {}) : (FetchTransportOrderListFilterRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return a PDF of the Transport-Order referenced by the Transport-Order id.
         * @summary get pdf from transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportOrderPdfById(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getTransportOrderPdfById.');
            }
            const localVarPath = `/transportOrderPdf/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will update a Transport-Order referenced by the Transport-Order id. Depending on the  TransportOrderPutOption the behavior of this method is as follows:  When putMode is  - REPLACE:         (default) The whole content of the transport order is replaced with the updated version - PATCH:           The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is replaced with the newly                    provided version. If it is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    The put mode is an optional parameter with the default value of REPLACE  **Id Matching in Patch Mode** When patching StopLocations or Freights, a special access mode can be used to address the stop locations or the freight items. Instead of using the StopId or the FreightId, a query containing the index, the action or in case of the freight the transport can be submitted.   Syntax:  - ${INDEX:0} : Updates the element at the specified index. E.g. stop 0, freight 9,....  - ${LOADING_LOCATION} : Only valid when used in a stopId. References the first loading stop of a transport.  - ${UNLOADING_LOCATION} : Only valid when used in a stopId. References the first unloading stop of a transport.  - ${TRANSPORT:0} : Only valid when used in a freightId. References all freights referenced in any stop                                 location of the transport with the given transportId.  - ${ALL}: Only valid when used in a freight id. References all freights  Example: > modifyTransportOrder(\"AA-BB1\", { >   \"externalTransportOrderId\": \"1\",  >   transports:[{ >     \"transportId\": \"112233\", >     \"stops\": [{ >       \"stopId\": \"$INDEX:0\", >       \"comment\": \"Hello test\" >     ] >   }] >   }, \"PATCH\")  Will update the comment of the first stop of the specified transport. A direct knowledge of the stopId is not required in that case.    **ATTENTION:**  1. It depends on the status of the transport order whether an update can be applied or not. Transport Orders in State EXECUTING, DONE, and CANCELED cannot be modified.  2. Exception to the rule above: If a transport order is in status canceled, and the target company re-assigns the vehicle, then the transport order goes from status caneceld to status accepted.  3. While the targetCompany as well as the assignedVehicle of a transportOrder can be modified using this call, please consider using the assignTransportOrder operation instead.     The assignTransportOrder does not require the resubmission of the whole transportOrder and therefore avoids unintended changes.   
         * @summary Update transport order 
         * @param {string} orderId orderId
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyTransportOrder(orderId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling modifyTransportOrder.');
            }
            // verify required parameter 'TransportOrder' is not null or undefined
            if (TransportOrder === null || TransportOrder === undefined) {
                throw new RequiredError('TransportOrder','Required parameter TransportOrder was null or undefined when calling modifyTransportOrder.');
            }
            const localVarPath = `/transportOrders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fixStopsOfLinkedTransports !== undefined) {
                localVarQueryParameter['fixStopsOfLinkedTransports'] = fixStopsOfLinkedTransports;
            }

            if (forceOverrideDependedStatesOnModifyTransportOrder !== undefined) {
                localVarQueryParameter['forceOverrideDependedStatesOnModifyTransportOrder'] = forceOverrideDependedStatesOnModifyTransportOrder;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (resolveCompanySpecificMapping !== undefined) {
                localVarQueryParameter['resolveCompanySpecificMapping'] = resolveCompanySpecificMapping;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrder" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrder || {}) : (TransportOrder || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. The body of the request needs to be a StopLocation object. It will overwrite only the eta inside the stopLocation.
         * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId 
         * @param {string} orderId orderId
         * @param {EtaPatchRequest} EtaPatchRequest EtaPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEtaToStopLocation(orderId: string, EtaPatchRequest: EtaPatchRequest, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling putEtaToStopLocation.');
            }
            // verify required parameter 'EtaPatchRequest' is not null or undefined
            if (EtaPatchRequest === null || EtaPatchRequest === undefined) {
                throw new RequiredError('EtaPatchRequest','Required parameter EtaPatchRequest was null or undefined when calling putEtaToStopLocation.');
            }
            const localVarPath = `/transportOrderEtas/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtaPatchRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(EtaPatchRequest || {}) : (EtaPatchRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. It will overwrite only the eta inside the stopLocation.
         * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId or external ones
         * @param {StopEtaPatchRequest} StopEtaPatchRequest StopEtaPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putStopEta(StopEtaPatchRequest: StopEtaPatchRequest, options: any = {}): FetchArgs {
            // verify required parameter 'StopEtaPatchRequest' is not null or undefined
            if (StopEtaPatchRequest === null || StopEtaPatchRequest === undefined) {
                throw new RequiredError('StopEtaPatchRequest','Required parameter StopEtaPatchRequest was null or undefined when calling putStopEta.');
            }
            const localVarPath = `/transportOrderEtas/stopEta`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"StopEtaPatchRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(StopEtaPatchRequest || {}) : (StopEtaPatchRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id after the updated route info.
         * @summary Re-calculate the routeInfo of the transport Order against given ID.
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reCalculateRouteInfoForTour(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling reCalculateRouteInfoForTour.');
            }
            const localVarPath = `/reCalculateRouteInfoForTour/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will remove the assigned device from the specified transport order.
         * @summary Remove assigned device
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedDevice(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling removeAssignedDevice.');
            }
            const localVarPath = `/transportOrders/{orderId}/assignedDevice`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will remove the assigned trailer from the specified transport order.
         * @summary Remove assigned trailer
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedTrailer(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling removeAssignedTrailer.');
            }
            const localVarPath = `/transportOrders/{orderId}/assignedTrailer`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will remove the assigned vehicle from the specified transport order.
         * @summary Remove assigned vehicle
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedVehicle(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling removeAssignedVehicle.');
            }
            const localVarPath = `/transportOrders/{orderId}/assignedVehicle`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will remove an observer from a Transport-Order referenced by the Transport-Order and Observer id. After removing the observer, the information on the transport can no longer be viewed by the former observer. Also no further notifications are sent to the former observer.
         * @summary remove observer from transport order
         * @param {string} observerId observerId
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeObserver(observerId: string, orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'observerId' is not null or undefined
            if (observerId === null || observerId === undefined) {
                throw new RequiredError('observerId','Required parameter observerId was null or undefined when calling removeObserver.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling removeObserver.');
            }
            const localVarPath = `/transportOrders/{orderId}/observers/{observerId}`
                .replace(`{${"observerId"}}`, encodeURIComponent(String(observerId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will replace the additional data of an transport order with new ones. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
         * @summary replaces the additional data with the given list of key values
         * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderAdditionalDataModifyRequest' is not null or undefined
            if (TransportOrderAdditionalDataModifyRequest === null || TransportOrderAdditionalDataModifyRequest === undefined) {
                throw new RequiredError('TransportOrderAdditionalDataModifyRequest','Required parameter TransportOrderAdditionalDataModifyRequest was null or undefined when calling replaceAdditionalData.');
            }
            const localVarPath = `/transportOrders/additionalData`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderAdditionalDataModifyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderAdditionalDataModifyRequest || {}) : (TransportOrderAdditionalDataModifyRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will split a transport order into unloading and loading locations.
         * @summary split transport order
         * @param {string} orderId orderId
         * @param {TransportOrderSplitRequest} TransportOrderSplitRequest TransportOrderSplitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitTransportOrder(orderId: string, TransportOrderSplitRequest: TransportOrderSplitRequest, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling splitTransportOrder.');
            }
            // verify required parameter 'TransportOrderSplitRequest' is not null or undefined
            if (TransportOrderSplitRequest === null || TransportOrderSplitRequest === undefined) {
                throw new RequiredError('TransportOrderSplitRequest','Required parameter TransportOrderSplitRequest was null or undefined when calling splitTransportOrder.');
            }
            const localVarPath = `/transportOrders/{orderId}/split`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderSplitRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderSplitRequest || {}) : (TransportOrderSplitRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will change the status of the specified attachment. If no status is set in the update request, the last known status will remain.
         * @summary post attachment status
         * @param {AttachmentStatusRequest} AttachmentStatusRequest AttachmentStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAttachmentStatus(AttachmentStatusRequest: AttachmentStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'AttachmentStatusRequest' is not null or undefined
            if (AttachmentStatusRequest === null || AttachmentStatusRequest === undefined) {
                throw new RequiredError('AttachmentStatusRequest','Required parameter AttachmentStatusRequest was null or undefined when calling submitAttachmentStatus.');
            }
            const localVarPath = `/transportOrders/attachmentStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AttachmentStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(AttachmentStatusRequest || {}) : (AttachmentStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will change the status of the specified freight. If no status is set in the update request, the last known status will remain.
         * @summary post freight status
         * @param {FreightStatusRequest} FreightStatusRequest FreightStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFreightStatus(FreightStatusRequest: FreightStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'FreightStatusRequest' is not null or undefined
            if (FreightStatusRequest === null || FreightStatusRequest === undefined) {
                throw new RequiredError('FreightStatusRequest','Required parameter FreightStatusRequest was null or undefined when calling submitFreightStatus.');
            }
            const localVarPath = `/transportOrders/freightStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FreightStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(FreightStatusRequest || {}) : (FreightStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation changes multiple transportOrder status values at once.  
         * @summary post multiple transport order status updates
         * @param {MultipleTransportOrderStatusUpdateRequests} MultipleTransportOrderStatusUpdateRequests MultipleTransportOrderStatusUpdateRequests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMultipleStatusChanges(MultipleTransportOrderStatusUpdateRequests: MultipleTransportOrderStatusUpdateRequests, options: any = {}): FetchArgs {
            // verify required parameter 'MultipleTransportOrderStatusUpdateRequests' is not null or undefined
            if (MultipleTransportOrderStatusUpdateRequests === null || MultipleTransportOrderStatusUpdateRequests === undefined) {
                throw new RequiredError('MultipleTransportOrderStatusUpdateRequests','Required parameter MultipleTransportOrderStatusUpdateRequests was null or undefined when calling submitMultipleStatusChanges.');
            }
            const localVarPath = `/transportOrders/multiStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MultipleTransportOrderStatusUpdateRequests" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MultipleTransportOrderStatusUpdateRequests || {}) : (MultipleTransportOrderStatusUpdateRequests || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will change the status of the specified transport order. The status can be changed according to the status tables provided in the api documentation. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
         * @summary post transport order status
         * @param {TransportOrderStatusUpdateRequest} TransportOrderStatusUpdateRequest TransportOrderStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStatus(TransportOrderStatusUpdateRequest: TransportOrderStatusUpdateRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderStatusUpdateRequest' is not null or undefined
            if (TransportOrderStatusUpdateRequest === null || TransportOrderStatusUpdateRequest === undefined) {
                throw new RequiredError('TransportOrderStatusUpdateRequest','Required parameter TransportOrderStatusUpdateRequest was null or undefined when calling submitStatus.');
            }
            const localVarPath = `/transportOrders/status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderStatusUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderStatusUpdateRequest || {}) : (TransportOrderStatusUpdateRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will change the status of the specified stop action. If no status is set in the update request, the last known status will remain.
         * @summary post stop action status
         * @param {StopActionStatusRequest} StopActionStatusRequest StopActionStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStopActionStatus(StopActionStatusRequest: StopActionStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'StopActionStatusRequest' is not null or undefined
            if (StopActionStatusRequest === null || StopActionStatusRequest === undefined) {
                throw new RequiredError('StopActionStatusRequest','Required parameter StopActionStatusRequest was null or undefined when calling submitStopActionStatus.');
            }
            const localVarPath = `/transportOrders/stopActionStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"StopActionStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(StopActionStatusRequest || {}) : (StopActionStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will change the status of the specified stop location. If no status is set in the update request, the last known status will remain.
         * @summary post stop location status
         * @param {StopLocationStatusRequest} StopLocationStatusRequest StopLocationStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStopLocationStatus(StopLocationStatusRequest: StopLocationStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'StopLocationStatusRequest' is not null or undefined
            if (StopLocationStatusRequest === null || StopLocationStatusRequest === undefined) {
                throw new RequiredError('StopLocationStatusRequest','Required parameter StopLocationStatusRequest was null or undefined when calling submitStopLocationStatus.');
            }
            const localVarPath = `/transportOrders/stopLocationStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"StopLocationStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(StopLocationStatusRequest || {}) : (StopLocationStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will change the status of the telematic status in the specified transport order. If no status is set in the update request, the last known status will remain.
         * @summary post telematic transport order status
         * @param {TelematicTransportOrderStatusRequest} TelematicTransportOrderStatusRequest TelematicTransportOrderStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTelematicTransportOrderStatus(TelematicTransportOrderStatusRequest: TelematicTransportOrderStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TelematicTransportOrderStatusRequest' is not null or undefined
            if (TelematicTransportOrderStatusRequest === null || TelematicTransportOrderStatusRequest === undefined) {
                throw new RequiredError('TelematicTransportOrderStatusRequest','Required parameter TelematicTransportOrderStatusRequest was null or undefined when calling submitTelematicTransportOrderStatus.');
            }
            const localVarPath = `/transportOrders/telematicStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TelematicTransportOrderStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TelematicTransportOrderStatusRequest || {}) : (TelematicTransportOrderStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will change the status of the specified transport order. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
         * @summary post transport order status
         * @param {TransportOrderStatusRequest} TransportOrderStatusRequest TransportOrderStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTransportOrderStatus(TransportOrderStatusRequest: TransportOrderStatusRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderStatusRequest' is not null or undefined
            if (TransportOrderStatusRequest === null || TransportOrderStatusRequest === undefined) {
                throw new RequiredError('TransportOrderStatusRequest','Required parameter TransportOrderStatusRequest was null or undefined when calling submitTransportOrderStatus.');
            }
            const localVarPath = `/transportOrders/transportOrderStatus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderStatusRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderStatusRequest || {}) : (TransportOrderStatusRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will trigger an AssignCompanyEvent.  It is used to retrigger the pipeline if something changed for example in the configuration after the assignment was already done. 
         * @summary assign
         * @param {string} orderId orderId
         * @param {TriggerAssignCompanyRequest} TriggerAssignCompanyRequest TriggerAssignCompanyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerAssignCompanyEvent(orderId: string, TriggerAssignCompanyRequest: TriggerAssignCompanyRequest, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling triggerAssignCompanyEvent.');
            }
            // verify required parameter 'TriggerAssignCompanyRequest' is not null or undefined
            if (TriggerAssignCompanyRequest === null || TriggerAssignCompanyRequest === undefined) {
                throw new RequiredError('TriggerAssignCompanyRequest','Required parameter TriggerAssignCompanyRequest was null or undefined when calling triggerAssignCompanyEvent.');
            }
            const localVarPath = `/transportOrders/triggerAssignCompanyEvent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TriggerAssignCompanyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TriggerAssignCompanyRequest || {}) : (TriggerAssignCompanyRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation will update the additional data of an transport order. It will add the new data without deleting the old data. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
         * @summary updates the additional data with the given list of key values
         * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options: any = {}): FetchArgs {
            // verify required parameter 'TransportOrderAdditionalDataModifyRequest' is not null or undefined
            if (TransportOrderAdditionalDataModifyRequest === null || TransportOrderAdditionalDataModifyRequest === undefined) {
                throw new RequiredError('TransportOrderAdditionalDataModifyRequest','Required parameter TransportOrderAdditionalDataModifyRequest was null or undefined when calling updateAdditionalData.');
            }
            const localVarPath = `/transportOrders/additionalData`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TransportOrderAdditionalDataModifyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(TransportOrderAdditionalDataModifyRequest || {}) : (TransportOrderAdditionalDataModifyRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransportOrderApi - functional programming interface
 * @export
 */
export const TransportOrderApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
         * @summary add observer to transport order
         * @param {string} orderId orderId
         * @param {Observer} Observer Observer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObserver(orderId: string, Observer: Observer, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Observer> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).addObserver(orderId, Observer, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
         * @summary add observer to transport order
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {Observer} Observer Observer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObserverByExternalTransportOrderId(externalTransportOrderId: string, Observer: Observer, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Observer> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).addObserverByExternalTransportOrderId(externalTransportOrderId, Observer, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will assign a company and/or a vehicle to a Transport-Order. To assign a company, the field targetCompanyId or partnerId needs to be filled.  To assign a vehicle, the field vehicleId or externalVehicleId needs to be filled. The vehicle can only be assigned, if the current company is also the targetCompany of the transport-order.  Depending on the configuration of the logenios account, assigning a targetVehicle may trigger the a message to the vehicle integrated telematic system containing the transport order to be executed.  At least one of these fields need to be filled, the others can stay empty, depending on your intention.  If the transport order is in status canceled, a assign call that modifies   * the assigned vehicle   resets it's status from canceled to accepted, because it is assumed that the formerly canceled transport order  shall be done now after the new assigment has happened. 
         * @summary assign
         * @param {string} orderId orderId
         * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTransportOrder(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).assignTransportOrder(orderId, TransportOrderAssignRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will set the status of a transport-order to CANCELED and send a message to the telematic.
         * @summary cancel transport order
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransportOrder(transportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).cancelTransportOrder(transportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return a count of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Count transport orders
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderCountResponse> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).countTransportOrdersWithFilter(FetchTransportOrderListFilterRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will link one of your company's Transport-Orders to another company.
         * @summary create linked transport order
         * @param {LinkTransportOrderRequest} LinkTransportOrderRequest LinkTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkedTransportOrder(LinkTransportOrderRequest: LinkTransportOrderRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).createLinkedTransportOrder(LinkTransportOrderRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will create multiple Transport-Orders at once from a WrappedTransportOrdersRequest, which should contain a list of Transport-Orders.
         * @summary create multiple transport orders
         * @param {WrappedTransportOrdersRequest} WrappedTransportOrdersRequest WrappedTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultipleTransportOrders(WrappedTransportOrdersRequest: WrappedTransportOrdersRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WrappedTransportOrdersResponse> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).createMultipleTransportOrders(WrappedTransportOrdersRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId.  **Important Remark**: This function shall only be called on transport orders originating from the current company.  Should this method be called on transport orders where the current company is target company and not source company the backend rejects the changes with a FORBIDDEN response.   Use the optional mode parameter to specify whether the existing transport order shall be replaced or partially  modified by the provided post data.   Options for the mode parameter: - REPLACE: (default) The whole content of the transport order is replaced with the updated version - PATCH: The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is patched with the newly                    provided version. If the part is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    To determine if a new transport order shall be created or an existing transport order shall be updated, the following rules are applied:  1. if the field _id is populated, the system will lookup the transportOrder with the specified _id. 2. if _id is not present: the field externalTransportOrderId will be used to lookup all transportOrders with the externalTransportOrderId.    If none is found, an new transport order is created. If exactly one transportOrder exists, the transportOrder is updated.     If multiple transportOrders exist and the call is made by the source company and exactly one transportOrder has companyId = source company id    the transportOrder is updated. Otherwise the update operation will fail and an exception will be returned. If the target company wants to     update a transport order and the transport order can't be identified without id conflict (e.g. because multiple different source companies have    transport orders with the same externalTransportOrderId) an error will be returned.        If mode is PATCH: The field transportOrderId can be populated with an index expression to reference to a transportOrder based on the transportId, if the transportId    is unique and the expression resolves to exactly one transport order. The syntax for this index expression is ${TRANSPORT:<transportId>}.    If multiple transport orders match to that index operator, the update will fail. 
         * @summary create transport order
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrder(TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).createOrModifyTransportOrder(TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
         * @summary create transport order
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportOrder(TransportOrder: TransportOrder, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).createTransportOrder(TransportOrder, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoints provides an information to which sub contractor the given transport order was assigned.  It returns the private access token which can be used to retrieve the transportOrder, to submit a status or to fetch and submit attachments.   Further, this endpoint returns an url to a mobile website where the transport order can be viewed without  login.  The permission TO_ASSIGN_VEHICLE is required to call this endpoint
         * @summary fetch information to whom this transport order was assigned
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAssignedDeviceInfo(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderAssignedDeviceInfo> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchAssignedDeviceInfo(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
         * @summary fetch information on the observer of an transport order
         * @param {string} observerId observerId
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverInfo(observerId: string, orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderObserverInfo> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchObserverInfo(observerId, orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
         * @summary fetch information on the observer of an transport order
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {string} observerId observerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverInfoByExternalTransportOrderId(externalTransportOrderId: string, observerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderObserverInfo> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchObserverInfoByExternalTransportOrderId(externalTransportOrderId, observerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return the Transport-Order of another company referenced by the external transport-order id. Appropriate permissions are needed.
         * @summary Get transport order by externalTransportOrderId
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByExternalId(externalTransportOrderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrderByExternalId(externalTransportOrderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id.
         * @summary get transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderById(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrderById(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Enter the private access token of an observer to get the TransportOrder-Object that it's observing.
         * @summary get transport order by observer access token
         * @param {string} privateAccessToken privateAccessToken
         * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByPrivateAccessToken(privateAccessToken: string, includeDepotsFromLinkedOrders?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrderByPrivateAccessToken(privateAccessToken, includeDepotsFromLinkedOrders, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return the history of a Transport-Order. It will contain all changes that have been done on this Transport-Order. Use the Transport-Order id as URL-parameter.
         * @summary get history
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderHistory(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderHistory> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrderHistory(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Enter the private access token of an observer to get the TransportOrder history.
         * @summary get history by observer access token
         * @param {string} privateAccessToken privateAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderHistoryByPrivateAccessToken(privateAccessToken: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderHistory> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrderHistoryByPrivateAccessToken(privateAccessToken, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return all logs of a Transport-Order. Use the Transport-Order id as URL-parameter.
         * @summary get logs
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderLogs(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderLog> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrderLogs(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Get list of transport orders
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrders(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderListResponse> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrders(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Get list of transport orders
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderListResponse> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).fetchTransportOrdersWithFilter(FetchTransportOrderListFilterRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return a PDF of the Transport-Order referenced by the Transport-Order id.
         * @summary get pdf from transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportOrderPdfById(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderPdfResponse> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).getTransportOrderPdfById(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will update a Transport-Order referenced by the Transport-Order id. Depending on the  TransportOrderPutOption the behavior of this method is as follows:  When putMode is  - REPLACE:         (default) The whole content of the transport order is replaced with the updated version - PATCH:           The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is replaced with the newly                    provided version. If it is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    The put mode is an optional parameter with the default value of REPLACE  **Id Matching in Patch Mode** When patching StopLocations or Freights, a special access mode can be used to address the stop locations or the freight items. Instead of using the StopId or the FreightId, a query containing the index, the action or in case of the freight the transport can be submitted.   Syntax:  - ${INDEX:0} : Updates the element at the specified index. E.g. stop 0, freight 9,....  - ${LOADING_LOCATION} : Only valid when used in a stopId. References the first loading stop of a transport.  - ${UNLOADING_LOCATION} : Only valid when used in a stopId. References the first unloading stop of a transport.  - ${TRANSPORT:0} : Only valid when used in a freightId. References all freights referenced in any stop                                 location of the transport with the given transportId.  - ${ALL}: Only valid when used in a freight id. References all freights  Example: > modifyTransportOrder(\"AA-BB1\", { >   \"externalTransportOrderId\": \"1\",  >   transports:[{ >     \"transportId\": \"112233\", >     \"stops\": [{ >       \"stopId\": \"$INDEX:0\", >       \"comment\": \"Hello test\" >     ] >   }] >   }, \"PATCH\")  Will update the comment of the first stop of the specified transport. A direct knowledge of the stopId is not required in that case.    **ATTENTION:**  1. It depends on the status of the transport order whether an update can be applied or not. Transport Orders in State EXECUTING, DONE, and CANCELED cannot be modified.  2. Exception to the rule above: If a transport order is in status canceled, and the target company re-assigns the vehicle, then the transport order goes from status caneceld to status accepted.  3. While the targetCompany as well as the assignedVehicle of a transportOrder can be modified using this call, please consider using the assignTransportOrder operation instead.     The assignTransportOrder does not require the resubmission of the whole transportOrder and therefore avoids unintended changes.   
         * @summary Update transport order 
         * @param {string} orderId orderId
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyTransportOrder(orderId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).modifyTransportOrder(orderId, TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. The body of the request needs to be a StopLocation object. It will overwrite only the eta inside the stopLocation.
         * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId 
         * @param {string} orderId orderId
         * @param {EtaPatchRequest} EtaPatchRequest EtaPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEtaToStopLocation(orderId: string, EtaPatchRequest: EtaPatchRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderEtaPutResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).putEtaToStopLocation(orderId, EtaPatchRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. It will overwrite only the eta inside the stopLocation.
         * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId or external ones
         * @param {StopEtaPatchRequest} StopEtaPatchRequest StopEtaPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putStopEta(StopEtaPatchRequest: StopEtaPatchRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderEtaPutResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).putStopEta(StopEtaPatchRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id after the updated route info.
         * @summary Re-calculate the routeInfo of the transport Order against given ID.
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reCalculateRouteInfoForTour(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).reCalculateRouteInfoForTour(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will remove the assigned device from the specified transport order.
         * @summary Remove assigned device
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedDevice(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).removeAssignedDevice(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will remove the assigned trailer from the specified transport order.
         * @summary Remove assigned trailer
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedTrailer(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).removeAssignedTrailer(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will remove the assigned vehicle from the specified transport order.
         * @summary Remove assigned vehicle
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedVehicle(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).removeAssignedVehicle(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will remove an observer from a Transport-Order referenced by the Transport-Order and Observer id. After removing the observer, the information on the transport can no longer be viewed by the former observer. Also no further notifications are sent to the former observer.
         * @summary remove observer from transport order
         * @param {string} observerId observerId
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeObserver(observerId: string, orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).removeObserver(observerId, orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will replace the additional data of an transport order with new ones. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
         * @summary replaces the additional data with the given list of key values
         * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).replaceAdditionalData(TransportOrderAdditionalDataModifyRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will split a transport order into unloading and loading locations.
         * @summary split transport order
         * @param {string} orderId orderId
         * @param {TransportOrderSplitRequest} TransportOrderSplitRequest TransportOrderSplitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitTransportOrder(orderId: string, TransportOrderSplitRequest: TransportOrderSplitRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderSplitResponse> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).splitTransportOrder(orderId, TransportOrderSplitRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will change the status of the specified attachment. If no status is set in the update request, the last known status will remain.
         * @summary post attachment status
         * @param {AttachmentStatusRequest} AttachmentStatusRequest AttachmentStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAttachmentStatus(AttachmentStatusRequest: AttachmentStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitAttachmentStatus(AttachmentStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will change the status of the specified freight. If no status is set in the update request, the last known status will remain.
         * @summary post freight status
         * @param {FreightStatusRequest} FreightStatusRequest FreightStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFreightStatus(FreightStatusRequest: FreightStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitFreightStatus(FreightStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation changes multiple transportOrder status values at once.  
         * @summary post multiple transport order status updates
         * @param {MultipleTransportOrderStatusUpdateRequests} MultipleTransportOrderStatusUpdateRequests MultipleTransportOrderStatusUpdateRequests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMultipleStatusChanges(MultipleTransportOrderStatusUpdateRequests: MultipleTransportOrderStatusUpdateRequests, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitMultipleStatusChanges(MultipleTransportOrderStatusUpdateRequests, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will change the status of the specified transport order. The status can be changed according to the status tables provided in the api documentation. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
         * @summary post transport order status
         * @param {TransportOrderStatusUpdateRequest} TransportOrderStatusUpdateRequest TransportOrderStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStatus(TransportOrderStatusUpdateRequest: TransportOrderStatusUpdateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitStatus(TransportOrderStatusUpdateRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will change the status of the specified stop action. If no status is set in the update request, the last known status will remain.
         * @summary post stop action status
         * @param {StopActionStatusRequest} StopActionStatusRequest StopActionStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStopActionStatus(StopActionStatusRequest: StopActionStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitStopActionStatus(StopActionStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will change the status of the specified stop location. If no status is set in the update request, the last known status will remain.
         * @summary post stop location status
         * @param {StopLocationStatusRequest} StopLocationStatusRequest StopLocationStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStopLocationStatus(StopLocationStatusRequest: StopLocationStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitStopLocationStatus(StopLocationStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will change the status of the telematic status in the specified transport order. If no status is set in the update request, the last known status will remain.
         * @summary post telematic transport order status
         * @param {TelematicTransportOrderStatusRequest} TelematicTransportOrderStatusRequest TelematicTransportOrderStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTelematicTransportOrderStatus(TelematicTransportOrderStatusRequest: TelematicTransportOrderStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitTelematicTransportOrderStatus(TelematicTransportOrderStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will change the status of the specified transport order. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
         * @summary post transport order status
         * @param {TransportOrderStatusRequest} TransportOrderStatusRequest TransportOrderStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTransportOrderStatus(TransportOrderStatusRequest: TransportOrderStatusRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrderStatusChangeResult> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).submitTransportOrderStatus(TransportOrderStatusRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will trigger an AssignCompanyEvent.  It is used to retrigger the pipeline if something changed for example in the configuration after the assignment was already done. 
         * @summary assign
         * @param {string} orderId orderId
         * @param {TriggerAssignCompanyRequest} TriggerAssignCompanyRequest TriggerAssignCompanyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerAssignCompanyEvent(orderId: string, TriggerAssignCompanyRequest: TriggerAssignCompanyRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TriggerAssignCompanyResponse> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).triggerAssignCompanyEvent(orderId, TriggerAssignCompanyRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This operation will update the additional data of an transport order. It will add the new data without deleting the old data. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
         * @summary updates the additional data with the given list of key values
         * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TransportOrder> {
            const localVarFetchArgs = TransportOrderApiFetchParamCreator(configuration).updateAdditionalData(TransportOrderAdditionalDataModifyRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TransportOrderApi - factory interface
 * @export
 */
export const TransportOrderApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
         * @summary add observer to transport order
         * @param {string} orderId orderId
         * @param {Observer} Observer Observer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObserver(orderId: string, Observer: Observer, options?: any) {
            return TransportOrderApiFp(configuration).addObserver(orderId, Observer, options)(fetch, basePath);
        },
        /**
         * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
         * @summary add observer to transport order
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {Observer} Observer Observer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObserverByExternalTransportOrderId(externalTransportOrderId: string, Observer: Observer, options?: any) {
            return TransportOrderApiFp(configuration).addObserverByExternalTransportOrderId(externalTransportOrderId, Observer, options)(fetch, basePath);
        },
        /**
         * This operation will assign a company and/or a vehicle to a Transport-Order. To assign a company, the field targetCompanyId or partnerId needs to be filled.  To assign a vehicle, the field vehicleId or externalVehicleId needs to be filled. The vehicle can only be assigned, if the current company is also the targetCompany of the transport-order.  Depending on the configuration of the logenios account, assigning a targetVehicle may trigger the a message to the vehicle integrated telematic system containing the transport order to be executed.  At least one of these fields need to be filled, the others can stay empty, depending on your intention.  If the transport order is in status canceled, a assign call that modifies   * the assigned vehicle   resets it's status from canceled to accepted, because it is assumed that the formerly canceled transport order  shall be done now after the new assigment has happened. 
         * @summary assign
         * @param {string} orderId orderId
         * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTransportOrder(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options?: any) {
            return TransportOrderApiFp(configuration).assignTransportOrder(orderId, TransportOrderAssignRequest, options)(fetch, basePath);
        },
        /**
         * This operation will set the status of a transport-order to CANCELED and send a message to the telematic.
         * @summary cancel transport order
         * @param {string} transportOrderId transportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransportOrder(transportOrderId: string, options?: any) {
            return TransportOrderApiFp(configuration).cancelTransportOrder(transportOrderId, options)(fetch, basePath);
        },
        /**
         * This operation will return a count of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Count transport orders
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any) {
            return TransportOrderApiFp(configuration).countTransportOrdersWithFilter(FetchTransportOrderListFilterRequest, options)(fetch, basePath);
        },
        /**
         * This operation will link one of your company's Transport-Orders to another company.
         * @summary create linked transport order
         * @param {LinkTransportOrderRequest} LinkTransportOrderRequest LinkTransportOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkedTransportOrder(LinkTransportOrderRequest: LinkTransportOrderRequest, options?: any) {
            return TransportOrderApiFp(configuration).createLinkedTransportOrder(LinkTransportOrderRequest, options)(fetch, basePath);
        },
        /**
         * This operation will create multiple Transport-Orders at once from a WrappedTransportOrdersRequest, which should contain a list of Transport-Orders.
         * @summary create multiple transport orders
         * @param {WrappedTransportOrdersRequest} WrappedTransportOrdersRequest WrappedTransportOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultipleTransportOrders(WrappedTransportOrdersRequest: WrappedTransportOrdersRequest, options?: any) {
            return TransportOrderApiFp(configuration).createMultipleTransportOrders(WrappedTransportOrdersRequest, options)(fetch, basePath);
        },
        /**
         * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId.  **Important Remark**: This function shall only be called on transport orders originating from the current company.  Should this method be called on transport orders where the current company is target company and not source company the backend rejects the changes with a FORBIDDEN response.   Use the optional mode parameter to specify whether the existing transport order shall be replaced or partially  modified by the provided post data.   Options for the mode parameter: - REPLACE: (default) The whole content of the transport order is replaced with the updated version - PATCH: The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is patched with the newly                    provided version. If the part is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    To determine if a new transport order shall be created or an existing transport order shall be updated, the following rules are applied:  1. if the field _id is populated, the system will lookup the transportOrder with the specified _id. 2. if _id is not present: the field externalTransportOrderId will be used to lookup all transportOrders with the externalTransportOrderId.    If none is found, an new transport order is created. If exactly one transportOrder exists, the transportOrder is updated.     If multiple transportOrders exist and the call is made by the source company and exactly one transportOrder has companyId = source company id    the transportOrder is updated. Otherwise the update operation will fail and an exception will be returned. If the target company wants to     update a transport order and the transport order can't be identified without id conflict (e.g. because multiple different source companies have    transport orders with the same externalTransportOrderId) an error will be returned.        If mode is PATCH: The field transportOrderId can be populated with an index expression to reference to a transportOrder based on the transportId, if the transportId    is unique and the expression resolves to exactly one transport order. The syntax for this index expression is ${TRANSPORT:<transportId>}.    If multiple transport orders match to that index operator, the update will fail. 
         * @summary create transport order
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrModifyTransportOrder(TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
            return TransportOrderApiFp(configuration).createOrModifyTransportOrder(TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(fetch, basePath);
        },
        /**
         * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
         * @summary create transport order
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransportOrder(TransportOrder: TransportOrder, options?: any) {
            return TransportOrderApiFp(configuration).createTransportOrder(TransportOrder, options)(fetch, basePath);
        },
        /**
         * This endpoints provides an information to which sub contractor the given transport order was assigned.  It returns the private access token which can be used to retrieve the transportOrder, to submit a status or to fetch and submit attachments.   Further, this endpoint returns an url to a mobile website where the transport order can be viewed without  login.  The permission TO_ASSIGN_VEHICLE is required to call this endpoint
         * @summary fetch information to whom this transport order was assigned
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAssignedDeviceInfo(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchAssignedDeviceInfo(orderId, options)(fetch, basePath);
        },
        /**
         * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
         * @summary fetch information on the observer of an transport order
         * @param {string} observerId observerId
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverInfo(observerId: string, orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchObserverInfo(observerId, orderId, options)(fetch, basePath);
        },
        /**
         * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
         * @summary fetch information on the observer of an transport order
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {string} observerId observerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchObserverInfoByExternalTransportOrderId(externalTransportOrderId: string, observerId: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchObserverInfoByExternalTransportOrderId(externalTransportOrderId, observerId, options)(fetch, basePath);
        },
        /**
         * This operation will return the Transport-Order of another company referenced by the external transport-order id. Appropriate permissions are needed.
         * @summary Get transport order by externalTransportOrderId
         * @param {string} externalTransportOrderId externalTransportOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByExternalId(externalTransportOrderId: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrderByExternalId(externalTransportOrderId, options)(fetch, basePath);
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id.
         * @summary get transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderById(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrderById(orderId, options)(fetch, basePath);
        },
        /**
         * Enter the private access token of an observer to get the TransportOrder-Object that it's observing.
         * @summary get transport order by observer access token
         * @param {string} privateAccessToken privateAccessToken
         * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderByPrivateAccessToken(privateAccessToken: string, includeDepotsFromLinkedOrders?: boolean, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrderByPrivateAccessToken(privateAccessToken, includeDepotsFromLinkedOrders, options)(fetch, basePath);
        },
        /**
         * This operation will return the history of a Transport-Order. It will contain all changes that have been done on this Transport-Order. Use the Transport-Order id as URL-parameter.
         * @summary get history
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderHistory(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrderHistory(orderId, options)(fetch, basePath);
        },
        /**
         * Enter the private access token of an observer to get the TransportOrder history.
         * @summary get history by observer access token
         * @param {string} privateAccessToken privateAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderHistoryByPrivateAccessToken(privateAccessToken: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrderHistoryByPrivateAccessToken(privateAccessToken, options)(fetch, basePath);
        },
        /**
         * This operation will return all logs of a Transport-Order. Use the Transport-Order id as URL-parameter.
         * @summary get logs
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrderLogs(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrderLogs(orderId, options)(fetch, basePath);
        },
        /**
         * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Get list of transport orders
         * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
         * @param {Date} [begin] begin
         * @param {boolean} [countDocuments] countDocuments
         * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
         * @param {Date} [end] end
         * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
         * @param {boolean} [hasAttachment] hasAttachment
         * @param {Date} [modifiedSince] modifiedSince
         * @param {Array<string>} [partnerIds] partnerIds
         * @param {string} [partnerNameRegex] partnerNameRegex
         * @param {string} [searchTerm] searchTerm
         * @param {number} [skip] skip
         * @param {string} [sortBy] sortBy
         * @param {string} [sortOrder] sortOrder
         * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
         * @param {number} [take] take
         * @param {string} [trailer] trailer
         * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
         * @param {string} [vehicle] vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrders(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrders(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(fetch, basePath);
        },
        /**
         * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
         * @summary Get list of transport orders
         * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any) {
            return TransportOrderApiFp(configuration).fetchTransportOrdersWithFilter(FetchTransportOrderListFilterRequest, options)(fetch, basePath);
        },
        /**
         * This operation will return a PDF of the Transport-Order referenced by the Transport-Order id.
         * @summary get pdf from transport order
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportOrderPdfById(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).getTransportOrderPdfById(orderId, options)(fetch, basePath);
        },
        /**
         * This operation will update a Transport-Order referenced by the Transport-Order id. Depending on the  TransportOrderPutOption the behavior of this method is as follows:  When putMode is  - REPLACE:         (default) The whole content of the transport order is replaced with the updated version - PATCH:           The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is replaced with the newly                    provided version. If it is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    The put mode is an optional parameter with the default value of REPLACE  **Id Matching in Patch Mode** When patching StopLocations or Freights, a special access mode can be used to address the stop locations or the freight items. Instead of using the StopId or the FreightId, a query containing the index, the action or in case of the freight the transport can be submitted.   Syntax:  - ${INDEX:0} : Updates the element at the specified index. E.g. stop 0, freight 9,....  - ${LOADING_LOCATION} : Only valid when used in a stopId. References the first loading stop of a transport.  - ${UNLOADING_LOCATION} : Only valid when used in a stopId. References the first unloading stop of a transport.  - ${TRANSPORT:0} : Only valid when used in a freightId. References all freights referenced in any stop                                 location of the transport with the given transportId.  - ${ALL}: Only valid when used in a freight id. References all freights  Example: > modifyTransportOrder(\"AA-BB1\", { >   \"externalTransportOrderId\": \"1\",  >   transports:[{ >     \"transportId\": \"112233\", >     \"stops\": [{ >       \"stopId\": \"$INDEX:0\", >       \"comment\": \"Hello test\" >     ] >   }] >   }, \"PATCH\")  Will update the comment of the first stop of the specified transport. A direct knowledge of the stopId is not required in that case.    **ATTENTION:**  1. It depends on the status of the transport order whether an update can be applied or not. Transport Orders in State EXECUTING, DONE, and CANCELED cannot be modified.  2. Exception to the rule above: If a transport order is in status canceled, and the target company re-assigns the vehicle, then the transport order goes from status caneceld to status accepted.  3. While the targetCompany as well as the assignedVehicle of a transportOrder can be modified using this call, please consider using the assignTransportOrder operation instead.     The assignTransportOrder does not require the resubmission of the whole transportOrder and therefore avoids unintended changes.   
         * @summary Update transport order 
         * @param {string} orderId orderId
         * @param {TransportOrder} TransportOrder TransportOrder
         * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
         * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
         * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
         * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyTransportOrder(orderId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
            return TransportOrderApiFp(configuration).modifyTransportOrder(orderId, TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(fetch, basePath);
        },
        /**
         * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. The body of the request needs to be a StopLocation object. It will overwrite only the eta inside the stopLocation.
         * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId 
         * @param {string} orderId orderId
         * @param {EtaPatchRequest} EtaPatchRequest EtaPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEtaToStopLocation(orderId: string, EtaPatchRequest: EtaPatchRequest, options?: any) {
            return TransportOrderApiFp(configuration).putEtaToStopLocation(orderId, EtaPatchRequest, options)(fetch, basePath);
        },
        /**
         * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. It will overwrite only the eta inside the stopLocation.
         * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId or external ones
         * @param {StopEtaPatchRequest} StopEtaPatchRequest StopEtaPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putStopEta(StopEtaPatchRequest: StopEtaPatchRequest, options?: any) {
            return TransportOrderApiFp(configuration).putStopEta(StopEtaPatchRequest, options)(fetch, basePath);
        },
        /**
         * This operation will return the Transport-Order referenced by the Transport-Order id after the updated route info.
         * @summary Re-calculate the routeInfo of the transport Order against given ID.
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reCalculateRouteInfoForTour(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).reCalculateRouteInfoForTour(orderId, options)(fetch, basePath);
        },
        /**
         * This operation will remove the assigned device from the specified transport order.
         * @summary Remove assigned device
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedDevice(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).removeAssignedDevice(orderId, options)(fetch, basePath);
        },
        /**
         * This operation will remove the assigned trailer from the specified transport order.
         * @summary Remove assigned trailer
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedTrailer(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).removeAssignedTrailer(orderId, options)(fetch, basePath);
        },
        /**
         * This operation will remove the assigned vehicle from the specified transport order.
         * @summary Remove assigned vehicle
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignedVehicle(orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).removeAssignedVehicle(orderId, options)(fetch, basePath);
        },
        /**
         * This operation will remove an observer from a Transport-Order referenced by the Transport-Order and Observer id. After removing the observer, the information on the transport can no longer be viewed by the former observer. Also no further notifications are sent to the former observer.
         * @summary remove observer from transport order
         * @param {string} observerId observerId
         * @param {string} orderId orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeObserver(observerId: string, orderId: string, options?: any) {
            return TransportOrderApiFp(configuration).removeObserver(observerId, orderId, options)(fetch, basePath);
        },
        /**
         * This operation will replace the additional data of an transport order with new ones. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
         * @summary replaces the additional data with the given list of key values
         * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options?: any) {
            return TransportOrderApiFp(configuration).replaceAdditionalData(TransportOrderAdditionalDataModifyRequest, options)(fetch, basePath);
        },
        /**
         * This operation will split a transport order into unloading and loading locations.
         * @summary split transport order
         * @param {string} orderId orderId
         * @param {TransportOrderSplitRequest} TransportOrderSplitRequest TransportOrderSplitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitTransportOrder(orderId: string, TransportOrderSplitRequest: TransportOrderSplitRequest, options?: any) {
            return TransportOrderApiFp(configuration).splitTransportOrder(orderId, TransportOrderSplitRequest, options)(fetch, basePath);
        },
        /**
         * This operation will change the status of the specified attachment. If no status is set in the update request, the last known status will remain.
         * @summary post attachment status
         * @param {AttachmentStatusRequest} AttachmentStatusRequest AttachmentStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAttachmentStatus(AttachmentStatusRequest: AttachmentStatusRequest, options?: any) {
            return TransportOrderApiFp(configuration).submitAttachmentStatus(AttachmentStatusRequest, options)(fetch, basePath);
        },
        /**
         * This operation will change the status of the specified freight. If no status is set in the update request, the last known status will remain.
         * @summary post freight status
         * @param {FreightStatusRequest} FreightStatusRequest FreightStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFreightStatus(FreightStatusRequest: FreightStatusRequest, options?: any) {
            return TransportOrderApiFp(configuration).submitFreightStatus(FreightStatusRequest, options)(fetch, basePath);
        },
        /**
         * This operation changes multiple transportOrder status values at once.  
         * @summary post multiple transport order status updates
         * @param {MultipleTransportOrderStatusUpdateRequests} MultipleTransportOrderStatusUpdateRequests MultipleTransportOrderStatusUpdateRequests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMultipleStatusChanges(MultipleTransportOrderStatusUpdateRequests: MultipleTransportOrderStatusUpdateRequests, options?: any) {
            return TransportOrderApiFp(configuration).submitMultipleStatusChanges(MultipleTransportOrderStatusUpdateRequests, options)(fetch, basePath);
        },
        /**
         * This operation will change the status of the specified transport order. The status can be changed according to the status tables provided in the api documentation. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
         * @summary post transport order status
         * @param {TransportOrderStatusUpdateRequest} TransportOrderStatusUpdateRequest TransportOrderStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStatus(TransportOrderStatusUpdateRequest: TransportOrderStatusUpdateRequest, options?: any) {
            return TransportOrderApiFp(configuration).submitStatus(TransportOrderStatusUpdateRequest, options)(fetch, basePath);
        },
        /**
         * This operation will change the status of the specified stop action. If no status is set in the update request, the last known status will remain.
         * @summary post stop action status
         * @param {StopActionStatusRequest} StopActionStatusRequest StopActionStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStopActionStatus(StopActionStatusRequest: StopActionStatusRequest, options?: any) {
            return TransportOrderApiFp(configuration).submitStopActionStatus(StopActionStatusRequest, options)(fetch, basePath);
        },
        /**
         * This operation will change the status of the specified stop location. If no status is set in the update request, the last known status will remain.
         * @summary post stop location status
         * @param {StopLocationStatusRequest} StopLocationStatusRequest StopLocationStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStopLocationStatus(StopLocationStatusRequest: StopLocationStatusRequest, options?: any) {
            return TransportOrderApiFp(configuration).submitStopLocationStatus(StopLocationStatusRequest, options)(fetch, basePath);
        },
        /**
         * This operation will change the status of the telematic status in the specified transport order. If no status is set in the update request, the last known status will remain.
         * @summary post telematic transport order status
         * @param {TelematicTransportOrderStatusRequest} TelematicTransportOrderStatusRequest TelematicTransportOrderStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTelematicTransportOrderStatus(TelematicTransportOrderStatusRequest: TelematicTransportOrderStatusRequest, options?: any) {
            return TransportOrderApiFp(configuration).submitTelematicTransportOrderStatus(TelematicTransportOrderStatusRequest, options)(fetch, basePath);
        },
        /**
         * This operation will change the status of the specified transport order. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
         * @summary post transport order status
         * @param {TransportOrderStatusRequest} TransportOrderStatusRequest TransportOrderStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTransportOrderStatus(TransportOrderStatusRequest: TransportOrderStatusRequest, options?: any) {
            return TransportOrderApiFp(configuration).submitTransportOrderStatus(TransportOrderStatusRequest, options)(fetch, basePath);
        },
        /**
         * This operation will trigger an AssignCompanyEvent.  It is used to retrigger the pipeline if something changed for example in the configuration after the assignment was already done. 
         * @summary assign
         * @param {string} orderId orderId
         * @param {TriggerAssignCompanyRequest} TriggerAssignCompanyRequest TriggerAssignCompanyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerAssignCompanyEvent(orderId: string, TriggerAssignCompanyRequest: TriggerAssignCompanyRequest, options?: any) {
            return TransportOrderApiFp(configuration).triggerAssignCompanyEvent(orderId, TriggerAssignCompanyRequest, options)(fetch, basePath);
        },
        /**
         * This operation will update the additional data of an transport order. It will add the new data without deleting the old data. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
         * @summary updates the additional data with the given list of key values
         * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options?: any) {
            return TransportOrderApiFp(configuration).updateAdditionalData(TransportOrderAdditionalDataModifyRequest, options)(fetch, basePath);
        },
    };
};

/**
 * TransportOrderApi - object-oriented interface
 * @export
 * @class TransportOrderApi
 * @extends {BaseAPI}
 */
export class TransportOrderApi extends BaseAPI {
    /**
     * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
     * @summary add observer to transport order
     * @param {string} orderId orderId
     * @param {Observer} Observer Observer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public addObserver(orderId: string, Observer: Observer, options?: any) {
        return TransportOrderApiFp(this.configuration).addObserver(orderId, Observer, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will add an observer to a Transport-Order referenced by the Transport-Order id. The body of the request needs to be the Observer object. It will return the added Observer.  Observers are allowed to view a full or partial transport order and receive notifications based on state changes. However, only SMS or e-mail based observers are capable of receiving state changes.
     * @summary add observer to transport order
     * @param {string} externalTransportOrderId externalTransportOrderId
     * @param {Observer} Observer Observer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public addObserverByExternalTransportOrderId(externalTransportOrderId: string, Observer: Observer, options?: any) {
        return TransportOrderApiFp(this.configuration).addObserverByExternalTransportOrderId(externalTransportOrderId, Observer, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will assign a company and/or a vehicle to a Transport-Order. To assign a company, the field targetCompanyId or partnerId needs to be filled.  To assign a vehicle, the field vehicleId or externalVehicleId needs to be filled. The vehicle can only be assigned, if the current company is also the targetCompany of the transport-order.  Depending on the configuration of the logenios account, assigning a targetVehicle may trigger the a message to the vehicle integrated telematic system containing the transport order to be executed.  At least one of these fields need to be filled, the others can stay empty, depending on your intention.  If the transport order is in status canceled, a assign call that modifies   * the assigned vehicle   resets it's status from canceled to accepted, because it is assumed that the formerly canceled transport order  shall be done now after the new assigment has happened. 
     * @summary assign
     * @param {string} orderId orderId
     * @param {TransportOrderAssignRequest} TransportOrderAssignRequest TransportOrderAssignRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public assignTransportOrder(orderId: string, TransportOrderAssignRequest: TransportOrderAssignRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).assignTransportOrder(orderId, TransportOrderAssignRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will set the status of a transport-order to CANCELED and send a message to the telematic.
     * @summary cancel transport order
     * @param {string} transportOrderId transportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public cancelTransportOrder(transportOrderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).cancelTransportOrder(transportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return a count of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
     * @summary Count transport orders
     * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public countTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).countTransportOrdersWithFilter(FetchTransportOrderListFilterRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will link one of your company's Transport-Orders to another company.
     * @summary create linked transport order
     * @param {LinkTransportOrderRequest} LinkTransportOrderRequest LinkTransportOrderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public createLinkedTransportOrder(LinkTransportOrderRequest: LinkTransportOrderRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).createLinkedTransportOrder(LinkTransportOrderRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will create multiple Transport-Orders at once from a WrappedTransportOrdersRequest, which should contain a list of Transport-Orders.
     * @summary create multiple transport orders
     * @param {WrappedTransportOrdersRequest} WrappedTransportOrdersRequest WrappedTransportOrdersRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public createMultipleTransportOrders(WrappedTransportOrdersRequest: WrappedTransportOrdersRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).createMultipleTransportOrders(WrappedTransportOrdersRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will create a new Transport-Order or modify an existing one identified by externalTransportOrderId.  **Important Remark**: This function shall only be called on transport orders originating from the current company.  Should this method be called on transport orders where the current company is target company and not source company the backend rejects the changes with a FORBIDDEN response.   Use the optional mode parameter to specify whether the existing transport order shall be replaced or partially  modified by the provided post data.   Options for the mode parameter: - REPLACE: (default) The whole content of the transport order is replaced with the updated version - PATCH: The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is patched with the newly                    provided version. If the part is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    To determine if a new transport order shall be created or an existing transport order shall be updated, the following rules are applied:  1. if the field _id is populated, the system will lookup the transportOrder with the specified _id. 2. if _id is not present: the field externalTransportOrderId will be used to lookup all transportOrders with the externalTransportOrderId.    If none is found, an new transport order is created. If exactly one transportOrder exists, the transportOrder is updated.     If multiple transportOrders exist and the call is made by the source company and exactly one transportOrder has companyId = source company id    the transportOrder is updated. Otherwise the update operation will fail and an exception will be returned. If the target company wants to     update a transport order and the transport order can't be identified without id conflict (e.g. because multiple different source companies have    transport orders with the same externalTransportOrderId) an error will be returned.        If mode is PATCH: The field transportOrderId can be populated with an index expression to reference to a transportOrder based on the transportId, if the transportId    is unique and the expression resolves to exactly one transport order. The syntax for this index expression is ${TRANSPORT:<transportId>}.    If multiple transport orders match to that index operator, the update will fail. 
     * @summary create transport order
     * @param {TransportOrder} TransportOrder TransportOrder
     * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
     * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
     * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
     * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public createOrModifyTransportOrder(TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
        return TransportOrderApiFp(this.configuration).createOrModifyTransportOrder(TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will create a new Transport-Order. An appropriate orderId is automatically assigned. If you set a targetCompanyId, the status will be CREATED, if you leave the field empty, the status will be DISPATCHING.
     * @summary create transport order
     * @param {TransportOrder} TransportOrder TransportOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public createTransportOrder(TransportOrder: TransportOrder, options?: any) {
        return TransportOrderApiFp(this.configuration).createTransportOrder(TransportOrder, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoints provides an information to which sub contractor the given transport order was assigned.  It returns the private access token which can be used to retrieve the transportOrder, to submit a status or to fetch and submit attachments.   Further, this endpoint returns an url to a mobile website where the transport order can be viewed without  login.  The permission TO_ASSIGN_VEHICLE is required to call this endpoint
     * @summary fetch information to whom this transport order was assigned
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchAssignedDeviceInfo(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchAssignedDeviceInfo(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
     * @summary fetch information on the observer of an transport order
     * @param {string} observerId observerId
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchObserverInfo(observerId: string, orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchObserverInfo(observerId, orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Fetches information on the observer linked to an transport order. The information contains the access url to a tracking page where the observer can see the status of the transport order
     * @summary fetch information on the observer of an transport order
     * @param {string} externalTransportOrderId externalTransportOrderId
     * @param {string} observerId observerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchObserverInfoByExternalTransportOrderId(externalTransportOrderId: string, observerId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchObserverInfoByExternalTransportOrderId(externalTransportOrderId, observerId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return the Transport-Order of another company referenced by the external transport-order id. Appropriate permissions are needed.
     * @summary Get transport order by externalTransportOrderId
     * @param {string} externalTransportOrderId externalTransportOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrderByExternalId(externalTransportOrderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrderByExternalId(externalTransportOrderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return the Transport-Order referenced by the Transport-Order id.
     * @summary get transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrderById(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrderById(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Enter the private access token of an observer to get the TransportOrder-Object that it's observing.
     * @summary get transport order by observer access token
     * @param {string} privateAccessToken privateAccessToken
     * @param {boolean} [includeDepotsFromLinkedOrders] includeDepotsFromLinkedOrders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrderByPrivateAccessToken(privateAccessToken: string, includeDepotsFromLinkedOrders?: boolean, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrderByPrivateAccessToken(privateAccessToken, includeDepotsFromLinkedOrders, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return the history of a Transport-Order. It will contain all changes that have been done on this Transport-Order. Use the Transport-Order id as URL-parameter.
     * @summary get history
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrderHistory(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrderHistory(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Enter the private access token of an observer to get the TransportOrder history.
     * @summary get history by observer access token
     * @param {string} privateAccessToken privateAccessToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrderHistoryByPrivateAccessToken(privateAccessToken: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrderHistoryByPrivateAccessToken(privateAccessToken, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return all logs of a Transport-Order. Use the Transport-Order id as URL-parameter.
     * @summary get logs
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrderLogs(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrderLogs(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
     * @summary Get list of transport orders
     * @param {Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>} [attachmentCategories] attachmentCategories
     * @param {Date} [begin] begin
     * @param {boolean} [countDocuments] countDocuments
     * @param {'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN'} [dateTimeField] dateTimeField
     * @param {Date} [end] end
     * @param {boolean} [exactSearchTermMatch] exactSearchTermMatch
     * @param {boolean} [hasAttachment] hasAttachment
     * @param {Date} [modifiedSince] modifiedSince
     * @param {Array<string>} [partnerIds] partnerIds
     * @param {string} [partnerNameRegex] partnerNameRegex
     * @param {string} [searchTerm] searchTerm
     * @param {number} [skip] skip
     * @param {string} [sortBy] sortBy
     * @param {string} [sortOrder] sortOrder
     * @param {'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING'} [status] status
     * @param {number} [take] take
     * @param {string} [trailer] trailer
     * @param {'ONLY_VALID' | 'ONLY_INVALID'} [validationStatus] validationStatus
     * @param {string} [vehicle] vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrders(attachmentCategories?: Array<'DeliveryNote' | 'CartageNote' | 'ProofOfDelivery' | 'ProofOfDeliveryTemplate' | 'Bordereau' | 'CmrDocument' | 'PhotoOfDamage' | 'PhotoOfDeliveryLocation' | 'ReturnNote' | 'WeightNote' | 'CustomsDocuments' | 'Signature' | 'Other' | 'Bill' | 'PhotoOfLoadSecuring' | 'RejectedAttachment' | 'FreightOrder' | 'PickupNote' | 'PalletNote' | 'ShipmentNote'>, begin?: Date, countDocuments?: boolean, dateTimeField?: 'CREATED' | 'PLAN_BEGIN' | 'PLAN_END' | 'WITHIN' | 'PLANSTART_OR_ADVISEDFROM' | 'ACTUAL_BEGIN' | 'ACTUAL_END' | 'ACTUAL_WITHIN', end?: Date, exactSearchTermMatch?: boolean, hasAttachment?: boolean, modifiedSince?: Date, partnerIds?: Array<string>, partnerNameRegex?: string, searchTerm?: string, skip?: number, sortBy?: string, sortOrder?: string, status?: 'CREATED' | 'DISPATCHING' | 'ACKNOWLEDGING' | 'ACCEPTED' | 'REJECTED' | 'EXECUTING' | 'DELIVERED' | 'DONE' | 'CANCELED' | 'INPUT_MISSING', take?: number, trailer?: string, validationStatus?: 'ONLY_VALID' | 'ONLY_INVALID', vehicle?: string, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrders(attachmentCategories, begin, countDocuments, dateTimeField, end, exactSearchTermMatch, hasAttachment, modifiedSince, partnerIds, partnerNameRegex, searchTerm, skip, sortBy, sortOrder, status, take, trailer, validationStatus, vehicle, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return a list of all Transport-Orders, that the user is allowed to see. The list of returned transport orders can be filtered using the transportOrderFilterParameterObject.
     * @summary Get list of transport orders
     * @param {FetchTransportOrderListFilterRequest} FetchTransportOrderListFilterRequest FetchTransportOrderListFilterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public fetchTransportOrdersWithFilter(FetchTransportOrderListFilterRequest: FetchTransportOrderListFilterRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).fetchTransportOrdersWithFilter(FetchTransportOrderListFilterRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return a PDF of the Transport-Order referenced by the Transport-Order id.
     * @summary get pdf from transport order
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public getTransportOrderPdfById(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).getTransportOrderPdfById(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will update a Transport-Order referenced by the Transport-Order id. Depending on the  TransportOrderPutOption the behavior of this method is as follows:  When putMode is  - REPLACE:         (default) The whole content of the transport order is replaced with the updated version - PATCH:           The transport oder is merged with updated version based on the transportId, stopId, freightId, ...                    If a stop location, a transport, a freight already exists, it is replaced with the newly                    provided version. If it is not found in the old version, it is appended. If it is in the                    old version but not in the new version, it is preserved. Each layer (Transport, StopLocation,                    Action, Freight, ...) is merged independently, thus it is impossible to implicitly remove                    parts of the transport order that are outdated.    The put mode is an optional parameter with the default value of REPLACE  **Id Matching in Patch Mode** When patching StopLocations or Freights, a special access mode can be used to address the stop locations or the freight items. Instead of using the StopId or the FreightId, a query containing the index, the action or in case of the freight the transport can be submitted.   Syntax:  - ${INDEX:0} : Updates the element at the specified index. E.g. stop 0, freight 9,....  - ${LOADING_LOCATION} : Only valid when used in a stopId. References the first loading stop of a transport.  - ${UNLOADING_LOCATION} : Only valid when used in a stopId. References the first unloading stop of a transport.  - ${TRANSPORT:0} : Only valid when used in a freightId. References all freights referenced in any stop                                 location of the transport with the given transportId.  - ${ALL}: Only valid when used in a freight id. References all freights  Example: > modifyTransportOrder(\"AA-BB1\", { >   \"externalTransportOrderId\": \"1\",  >   transports:[{ >     \"transportId\": \"112233\", >     \"stops\": [{ >       \"stopId\": \"$INDEX:0\", >       \"comment\": \"Hello test\" >     ] >   }] >   }, \"PATCH\")  Will update the comment of the first stop of the specified transport. A direct knowledge of the stopId is not required in that case.    **ATTENTION:**  1. It depends on the status of the transport order whether an update can be applied or not. Transport Orders in State EXECUTING, DONE, and CANCELED cannot be modified.  2. Exception to the rule above: If a transport order is in status canceled, and the target company re-assigns the vehicle, then the transport order goes from status caneceld to status accepted.  3. While the targetCompany as well as the assignedVehicle of a transportOrder can be modified using this call, please consider using the assignTransportOrder operation instead.     The assignTransportOrder does not require the resubmission of the whole transportOrder and therefore avoids unintended changes.   
     * @summary Update transport order 
     * @param {string} orderId orderId
     * @param {TransportOrder} TransportOrder TransportOrder
     * @param {boolean} [fixStopsOfLinkedTransports] fixStopsOfLinkedTransports
     * @param {boolean} [forceOverrideDependedStatesOnModifyTransportOrder] forceOverrideDependedStatesOnModifyTransportOrder
     * @param {'FULL_REPLACE' | 'REPLACE' | 'PATCH'} [mode] mode
     * @param {boolean} [resolveCompanySpecificMapping] resolveCompanySpecificMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public modifyTransportOrder(orderId: string, TransportOrder: TransportOrder, fixStopsOfLinkedTransports?: boolean, forceOverrideDependedStatesOnModifyTransportOrder?: boolean, mode?: 'FULL_REPLACE' | 'REPLACE' | 'PATCH', resolveCompanySpecificMapping?: boolean, options?: any) {
        return TransportOrderApiFp(this.configuration).modifyTransportOrder(orderId, TransportOrder, fixStopsOfLinkedTransports, forceOverrideDependedStatesOnModifyTransportOrder, mode, resolveCompanySpecificMapping, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. The body of the request needs to be a StopLocation object. It will overwrite only the eta inside the stopLocation.
     * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId 
     * @param {string} orderId orderId
     * @param {EtaPatchRequest} EtaPatchRequest EtaPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public putEtaToStopLocation(orderId: string, EtaPatchRequest: EtaPatchRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).putEtaToStopLocation(orderId, EtaPatchRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will patch an ETA into a StopLocation inside a Transport inside a Transport-Order referenced by the respective ids. It will overwrite only the eta inside the stopLocation.
     * @summary Patch ETA into StopLocation by transportOrderId, transportId and stopId or external ones
     * @param {StopEtaPatchRequest} StopEtaPatchRequest StopEtaPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public putStopEta(StopEtaPatchRequest: StopEtaPatchRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).putStopEta(StopEtaPatchRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will return the Transport-Order referenced by the Transport-Order id after the updated route info.
     * @summary Re-calculate the routeInfo of the transport Order against given ID.
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public reCalculateRouteInfoForTour(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).reCalculateRouteInfoForTour(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will remove the assigned device from the specified transport order.
     * @summary Remove assigned device
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public removeAssignedDevice(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).removeAssignedDevice(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will remove the assigned trailer from the specified transport order.
     * @summary Remove assigned trailer
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public removeAssignedTrailer(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).removeAssignedTrailer(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will remove the assigned vehicle from the specified transport order.
     * @summary Remove assigned vehicle
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public removeAssignedVehicle(orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).removeAssignedVehicle(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will remove an observer from a Transport-Order referenced by the Transport-Order and Observer id. After removing the observer, the information on the transport can no longer be viewed by the former observer. Also no further notifications are sent to the former observer.
     * @summary remove observer from transport order
     * @param {string} observerId observerId
     * @param {string} orderId orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public removeObserver(observerId: string, orderId: string, options?: any) {
        return TransportOrderApiFp(this.configuration).removeObserver(observerId, orderId, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will replace the additional data of an transport order with new ones. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
     * @summary replaces the additional data with the given list of key values
     * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public replaceAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).replaceAdditionalData(TransportOrderAdditionalDataModifyRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will split a transport order into unloading and loading locations.
     * @summary split transport order
     * @param {string} orderId orderId
     * @param {TransportOrderSplitRequest} TransportOrderSplitRequest TransportOrderSplitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public splitTransportOrder(orderId: string, TransportOrderSplitRequest: TransportOrderSplitRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).splitTransportOrder(orderId, TransportOrderSplitRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will change the status of the specified attachment. If no status is set in the update request, the last known status will remain.
     * @summary post attachment status
     * @param {AttachmentStatusRequest} AttachmentStatusRequest AttachmentStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitAttachmentStatus(AttachmentStatusRequest: AttachmentStatusRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).submitAttachmentStatus(AttachmentStatusRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will change the status of the specified freight. If no status is set in the update request, the last known status will remain.
     * @summary post freight status
     * @param {FreightStatusRequest} FreightStatusRequest FreightStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitFreightStatus(FreightStatusRequest: FreightStatusRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).submitFreightStatus(FreightStatusRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation changes multiple transportOrder status values at once.  
     * @summary post multiple transport order status updates
     * @param {MultipleTransportOrderStatusUpdateRequests} MultipleTransportOrderStatusUpdateRequests MultipleTransportOrderStatusUpdateRequests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitMultipleStatusChanges(MultipleTransportOrderStatusUpdateRequests: MultipleTransportOrderStatusUpdateRequests, options?: any) {
        return TransportOrderApiFp(this.configuration).submitMultipleStatusChanges(MultipleTransportOrderStatusUpdateRequests, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will change the status of the specified transport order. The status can be changed according to the status tables provided in the api documentation. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
     * @summary post transport order status
     * @param {TransportOrderStatusUpdateRequest} TransportOrderStatusUpdateRequest TransportOrderStatusUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitStatus(TransportOrderStatusUpdateRequest: TransportOrderStatusUpdateRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).submitStatus(TransportOrderStatusUpdateRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will change the status of the specified stop action. If no status is set in the update request, the last known status will remain.
     * @summary post stop action status
     * @param {StopActionStatusRequest} StopActionStatusRequest StopActionStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitStopActionStatus(StopActionStatusRequest: StopActionStatusRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).submitStopActionStatus(StopActionStatusRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will change the status of the specified stop location. If no status is set in the update request, the last known status will remain.
     * @summary post stop location status
     * @param {StopLocationStatusRequest} StopLocationStatusRequest StopLocationStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitStopLocationStatus(StopLocationStatusRequest: StopLocationStatusRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).submitStopLocationStatus(StopLocationStatusRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will change the status of the telematic status in the specified transport order. If no status is set in the update request, the last known status will remain.
     * @summary post telematic transport order status
     * @param {TelematicTransportOrderStatusRequest} TelematicTransportOrderStatusRequest TelematicTransportOrderStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitTelematicTransportOrderStatus(TelematicTransportOrderStatusRequest: TelematicTransportOrderStatusRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).submitTelematicTransportOrderStatus(TelematicTransportOrderStatusRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will change the status of the specified transport order. If no status is set in the update request, the last known status will remain. As LOGENIOS is typically not the leading system, all valid status changes are accepted except TransportOrder-, StopLocation- and StopAction.CANCELED. There is no check to prevent status downgrades.
     * @summary post transport order status
     * @param {TransportOrderStatusRequest} TransportOrderStatusRequest TransportOrderStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public submitTransportOrderStatus(TransportOrderStatusRequest: TransportOrderStatusRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).submitTransportOrderStatus(TransportOrderStatusRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will trigger an AssignCompanyEvent.  It is used to retrigger the pipeline if something changed for example in the configuration after the assignment was already done. 
     * @summary assign
     * @param {string} orderId orderId
     * @param {TriggerAssignCompanyRequest} TriggerAssignCompanyRequest TriggerAssignCompanyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public triggerAssignCompanyEvent(orderId: string, TriggerAssignCompanyRequest: TriggerAssignCompanyRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).triggerAssignCompanyEvent(orderId, TriggerAssignCompanyRequest, options)(this.fetch, this.basePath);
    }

    /**
     * This operation will update the additional data of an transport order. It will add the new data without deleting the old data. The new additional data is a TransportOrderAdditionalDataModifyRequest object.
     * @summary updates the additional data with the given list of key values
     * @param {TransportOrderAdditionalDataModifyRequest} TransportOrderAdditionalDataModifyRequest TransportOrderAdditionalDataModifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportOrderApi
     */
    public updateAdditionalData(TransportOrderAdditionalDataModifyRequest: TransportOrderAdditionalDataModifyRequest, options?: any) {
        return TransportOrderApiFp(this.configuration).updateAdditionalData(TransportOrderAdditionalDataModifyRequest, options)(this.fetch, this.basePath);
    }

}

